(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["FV"] = factory();
	else
		root["FV"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Set up the necessary wiring to load the FV library.
	* */
	
	
	/*
	* Set webpack config's publicpath on run time.
	* At time of the html parse, this will always be the last script on the page.
	* the path with the assets is now always the same as the one containing the js file
	* (barring dynamic insertion of the library on page b/f other script tags).
	* Note: cannot set publicpath on runtime if using the extract text plugin !!!
	* This would break the links to resources like 'icons' linked to in external css files.
	* here, working since we assume all assets are in the viewer.js directory and
	* Webpack's public path is set to this directory on build.
	* */
	var scripts = document.getElementsByTagName("script");
	var src = scripts[scripts.length - 1].getAttribute("src");
	__webpack_require__.p = src.substr(0, src.lastIndexOf("/") + 1);
	
	/*
	 * Base styling.
	 *  Require once -- wrap loader will require by ref in less to resolve variables.
	 * */
	__webpack_require__(39);
	
	var util = __webpack_require__(48);
	
	/*
	 * Establish some polyfills for IE8.
	 * Note: if testing IE8 must test in browser and document mode in the VM.
	* */
	if (util.isIE8()) {
	    __webpack_require__(54); /* error will occur if the development tools are not open */
	    __webpack_require__(55);
	    __webpack_require__(56);
	    __webpack_require__(57); // TODO: should be on Raphael import ... is it?*/
	}
	
	
	/*
	* Marionette Shim -- this will get it working in Webpack.
	* Must require in order.
	* */
	var _ = __webpack_require__(49),
	    Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59);
	
	Backbone.$ = $; //must be here for webpack
	Backbone.Radio = __webpack_require__(60);
	var Marionette = __webpack_require__(61); // (must be var)
	
	
	__webpack_require__(64); // ensure its exports applied to jquery
	__webpack_require__(66);
	
	/**
	 * TODO
	 * - require backbone.mousetrap once (or need a view to inherit all others from ( it gets run again and again )
	 * - require mousetrap first (and once here)
	 * - still?
	 * Really Bootstrapping the Mousetrap.prototype.stopCallback
	 */
	__webpack_require__(67);
	
	/* jquery-extension called where used */
	
	__webpack_require__(69);
	__webpack_require__(71);
	
	
	/* Extend Backbone.Radio */
	Backbone.Radio.Channel.prototype.triggerMethod = Marionette.triggerMethod;
	
	
	Marionette.Renderer = {
	    render: function(template, data) {
	        return _.isFunction(template) ? template(data) : template;
	    }
	};
	
	
	var FV = __webpack_require__(73);
	FV.prototype._src = util.getFileNameFromPath(src); /* store the name of the file on FV prototype: this is used in isolating error messages only from the script */
	
	
	module.exports = new FV();


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var SanitizeFileName = __webpack_require__(50);
	
	
	module.exports = {
	
	    urlEndSlash: function(url) {
	        var lastChar = url.charAt(url.length-1);
	        url = (lastChar !== '/') ? url  + '/' : url;
	        return url;
	    },
	    formatNumber: function (n, decPlaces, thouSeparator, decSeparator) {
	        var decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
	            decSeparator = decSeparator === undefined ? "." : decSeparator,
	            thouSeparator = thouSeparator === undefined ? "," : thouSeparator,
	            sign = n < 0 ? "-" : "",
	            i = parseInt(n = Math.abs(+n || 0).toFixed(decPlaces)) + "",
	            j = (j = i.length) > 3 ? j % 3 : 0;
	        return sign + (j ? i.substr(0, j) + thouSeparator : "") +
	            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thouSeparator) + (decPlaces ? decSeparator + Math.abs(n - i).toFixed(decPlaces).slice(2) : "");
	    },
	    getFileNameFromPath: function(path) {
	       return path.split('/').pop();
	    },
	    rotatePt: function(pt, deg, sx, sy) {  //deg -- give radian
	        var a = this.degreeToRadian(deg);
	        return {
	            x:  sx + Math.cos(a) * (pt.x - sx) - Math.sin(a) * (pt.y - sy),
	            y:  sy + Math.sin(a) * (pt.x - sx) + Math.cos(a) * (pt.y - sy)
	        };
	    },
	    degreeToRadian: function(deg) {
	        return deg * (Math.PI / 180);
	    },
	    stripFileExtension: function(filename) { //return filename without ext
	        return filename.substr(0, filename.lastIndexOf('.'));
	    },
	    getFileExtension: function(filePath) {
	        return filePath.split('.').pop();
	    },
	    createClass: function(name, rules) { //works with legacy IEs
	        var style = document.createElement('style');
	        style.type = 'text/css';
	        document.getElementsByTagName('head')[0].appendChild(style);
	        if(!(style.sheet||{}).insertRule)
	            (style.styleSheet || style.sheet).addRule(name, rules);
	        else
	            style.sheet.insertRule(name+"{"+rules+"}",0);
	    },
	    getStyleSheetPropertyValue: function(selectorText, propertyName) {
	        // search backwards because the last match is more likely the right one
	        for (var s= document.styleSheets.length - 1; s >= 0; s--) {
	            var cssRules;
	
	            try { /* Prevent cross domain errors from occuring in Mozilla -- just skip */
	                cssRules = document.styleSheets[s].cssRules ||
	                    document.styleSheets[s].rules || []; // IE support
	            } catch(e) {
	                continue;
	            }
	
	            for (var c=0; c < cssRules.length; c++) {
	                if (cssRules[c].selectorText === selectorText) 
	                    return cssRules[c].style[propertyName];
	            }
	        }
	        return null;
	    },
	    /* Derives Initials from a Name from the first letter of each word, space separated, defaults to lowercase -- if no words, return empty str*/
	    deriveInitials: function(fullName, toUpper) { //*todo extend underscore
	        var inits =_.reduce(fullName.split(' '), function(memo, word) {
	            return memo += word.charAt(0);
	        }, '');
	       return inits.length > 0 ? inits['to' + (!toUpper ? 'Lower' : 'Upper') + 'Case']()  : '';
	
	    },
	    /* NOTE: !!! IF TESTING IN COMPATIBILITY MODE, MUST CHANGE THE BROWSER MODE AS WELL AS THE COMPATIBILITY MODE */
	    isIE7: function() {
	        return (navigator.appVersion.indexOf("MSIE 7.") > -1);
	    },
	    isIE8: function() {
	        return (navigator.appVersion.indexOf("MSIE 8.") > -1);
	    },
	    isIE9:  function() {
	        return (navigator.appVersion.indexOf("MSIE 9.") > -1);
	    },
	    isIE8orIE9: function() {
	        return this.isIE8() || this.isIE9();
	    },
	    isIE: function () {
	        return (/trident/i).test(navigator.userAgent); /* as of IE11, no longer contains MSIE); http://msdn.microsoft.com/en-us/library/ie/bg182625%28v=vs.85%29.aspx */
	    },
	    isChrome: function () {
	        return ( /chrome/.test(navigator.userAgent.toLowerCase()) );
	    },
	    isIntegerGreaterThanZero: function(pgNum) {
	        // could optimize this when get time:
	
	        if ( !isInteger(pgNum) ) return false; //could round if string and not numeric ...
	        if ( pgNum < 1 ) return false;
	
	        return true;
	        //discussion here: http://2ality.com/2014/05/is-integer.html
	
	        function isInteger(x) {
	            return (typeof x === 'number') && (x % 1 === 0);
	        }
	    },
	    // see https://24ways.org/2010/calculating-color-contrast
	    // for given hexcolor background (assumes all 6 characters), return either dark or light color for overlay text
	    // provides dark or light parameters to overide the default dark & light return colors
	    getContrastYIQ: function(hexcolor, dark, light){
	
	        hexcolor[0] === '#' && ( hexcolor = hexcolor.substr(1) );
	
	        var r = parseInt(hexcolor.substr(0,2),16);
	        var g = parseInt(hexcolor.substr(2,2),16);
	        var b = parseInt(hexcolor.substr(4,2),16);
	
	        var yiq = ((r*299)+(g*587)+(b*114))/1000;
	
	        return (yiq >= 128)
	            ? dark ? dark : '#000'
	            : light ? light : '#fff';
	    },
	
	    /**
	     * Adapted from // https://stackoverflow.com/questions/21646738/convert-hex-to-rgba
	     *
	     */
	    hexToRgba: function( hex, alpha ) {
	
	        hex   = hex.replace('#', '');
	        var r = parseInt(hex.length == 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
	        var g = parseInt(hex.length == 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
	        var b = parseInt(hex.length == 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
	
	        if ( alpha !== undefined ) {
	            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	        }
	        else {
	            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
	        }
	
	    },
	
	    // Return unique string to apply to the name attribute of form input fields to prevent browsers' auto-complete.
	    // According to https://github.com/terrylinooo/jquery.disableAutoFill, randomizeInputName,
	    // ' preventing auto completion for all browsers (includes third-party auto-completeion extensions) not just for Google Chrome'
	    // seems to work
	    getUniqueStrToDisableFormAutoComplete: function() {
	        return Math.random().toString(36).replace(/[^a-z]+/g, '');
	    },
	    /*
	    * Wrapper around SanitizeFileName providing default options across the application.
	    * Sanitize the name of file to be downloaded for the file system (vs URL escaping).
	    * Left option to 'eliminateDupes' but this isn't the default -- the idea is if there
	    * are consecutive invalid characters replaced, consolidate them with one replacement character.
	    * FDD does this; I'm not doing it now b/c not it's that big a deal and the library I'm utilizing would need to be forked
	    * to do this only for characters that were replaced.  The below would consolidate valid replacement characters (that
	    * existed prior to replacing anything) and is not necessarily the desired functionality.
	    * I could always do this later if requested.
	    * */
	    sanitizeFileNameForFileSystem: function(name, replacement, eliminateDupes) {
	
	        var replaceWithChar = replacement ? replacement : '-';
	
	        var sanitizedName = SanitizeFileName( name, {
	            replacement: replaceWithChar
	        } );
	
	        if ( eliminateDupes ) {
	            var regEx = new RegExp(replaceWithChar + '{2,}', 'g');
	            sanitizedName = sanitizedName.replace(regEx, replaceWithChar);
	        }
	
	
	        return sanitizedName;
	    },
	    /*
	    * Capitalize the first letter of each word in str.
	    * */
	    toTitleCase: function(str) {
	        return str.replace( /\w\S*/g, function(txt) {
	                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	            }
	        );
	    },
	    /**
	     * This returns a Javascript object that is JSON-like but isn't JSON -- it includes functions.
	     * Use instead of JSON.stringify to keeps function values as JS objects.
	     * Can't just use .toString on functions in JSON.stringify's replacer,
	     * because that will surround the function with quotations.
	     */
	    jsonStringyWithFunctions: function(obj) {
	
	        // Holds functions we encounter.
	        var functions = [];
	        var placeholder = ">>FN_PLACEHOLDER<<";
	
	        // This handler just records a function object in `functions` and returns the
	        // placeholder as the value to insert into the JSON structure.
	        function replacer(key, value) {
	            if (value instanceof Function) {
	                functions.push(value);
	                return placeholder;
	            }
	
	            return value;
	        }
	
	        // Stringify using the customer replacer.
	        var pre = JSON.stringify(obj, replacer, 4);
	
	        // Replace the placeholders in order they were encountered, with
	        // the functions we've recorded.
	        var post = pre.replace( new RegExp('"' + placeholder + '"', 'g'), function() {
	            return functions.shift();
	        });
	
	        return post;
	
	    },
	
	    /* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping */
	    escapeRegExp: function(string) {
	        return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	    },
	
	    // Could also use localeCompare IE11+ ( or more limited here )
	    // but just use this now for better browser compatibility
	    caseInsensitiveCompare: function( a, b ) {
	
	        a = a.toLowerCase();
	        b = b.toLowerCase();
	
	        if ( a == b )
	            return 0;
	
	        if ( a > b )
	            return 1;
	
	        return -1;
	
	    },
	
	    /* Short-cut around mediation of events -- b/c a fn, could also be used for requests */
	    blindForward: function( target, fnName ) {
	
	        if ( !target || !target[fnName] || typeof target[fnName] !== 'function' ) {
	            return;
	        }
	
	        return target[fnName].apply( target,  Array.prototype.slice.call(arguments, 2) );
	
	    },
	
	    /**
	     * Normalize line breaks across OS as \n.
	     * On Unix machines, a single newline character �n� does the job. On Macs, a carriage return �r� is used. DOS and Windows use both: �rn�.
	     * Cold ( all stored as \n' ).
	     * Raphael SVG export plugin expects \n .
	     */
	    normalizeNewLineCharacters: function( text ) {
	        return text.replace(/(\r\n|\n|\r)/g,"\n");
	    }
	
	
	};
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	//     Underscore.js 1.4.4
	//     http://underscorejs.org
	//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `global` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Establish the object that gets returned to break out of a loop iteration.
	  var breaker = {};
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push             = ArrayProto.push,
	      slice            = ArrayProto.slice,
	      concat           = ArrayProto.concat,
	      toString         = ObjProto.toString,
	      hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeForEach      = ArrayProto.forEach,
	    nativeMap          = ArrayProto.map,
	    nativeReduce       = ArrayProto.reduce,
	    nativeReduceRight  = ArrayProto.reduceRight,
	    nativeFilter       = ArrayProto.filter,
	    nativeEvery        = ArrayProto.every,
	    nativeSome         = ArrayProto.some,
	    nativeIndexOf      = ArrayProto.indexOf,
	    nativeLastIndexOf  = ArrayProto.lastIndexOf,
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind;
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object via a string identifier,
	  // for Closure Compiler "advanced" mode.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.4.4';
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles objects with the built-in `forEach`, arrays, and raw objects.
	  // Delegates to **ECMAScript 5**'s native `forEach` if available.
	  var each = _.each = _.forEach = function(obj, iterator, context) {
	    if (obj == null) return;
	    if (nativeForEach && obj.forEach === nativeForEach) {
	      obj.forEach(iterator, context);
	    } else if (obj.length === +obj.length) {
	      for (var i = 0, l = obj.length; i < l; i++) {
	        if (iterator.call(context, obj[i], i, obj) === breaker) return;
	      }
	    } else {
	      for (var key in obj) {
	        if (_.has(obj, key)) {
	          if (iterator.call(context, obj[key], key, obj) === breaker) return;
	        }
	      }
	    }
	  };
	
	  // Return the results of applying the iterator to each element.
	  // Delegates to **ECMAScript 5**'s native `map` if available.
	  _.map = _.collect = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	    each(obj, function(value, index, list) {
	      results[results.length] = iterator.call(context, value, index, list);
	    });
	    return results;
	  };
	
	  var reduceError = 'Reduce of empty array with no initial value';
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
	  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduce && obj.reduce === nativeReduce) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
	    }
	    each(obj, function(value, index, list) {
	      if (!initial) {
	        memo = value;
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, value, index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // The right-associative version of reduce, also known as `foldr`.
	  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
	  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
	    var initial = arguments.length > 2;
	    if (obj == null) obj = [];
	    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
	      if (context) iterator = _.bind(iterator, context);
	      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
	    }
	    var length = obj.length;
	    if (length !== +length) {
	      var keys = _.keys(obj);
	      length = keys.length;
	    }
	    each(obj, function(value, index, list) {
	      index = keys ? keys[--length] : --length;
	      if (!initial) {
	        memo = obj[index];
	        initial = true;
	      } else {
	        memo = iterator.call(context, memo, obj[index], index, list);
	      }
	    });
	    if (!initial) throw new TypeError(reduceError);
	    return memo;
	  };
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, iterator, context) {
	    var result;
	    any(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) {
	        result = value;
	        return true;
	      }
	    });
	    return result;
	  };
	
	  // Return all the elements that pass a truth test.
	  // Delegates to **ECMAScript 5**'s native `filter` if available.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, iterator, context) {
	    var results = [];
	    if (obj == null) return results;
	    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
	    each(obj, function(value, index, list) {
	      if (iterator.call(context, value, index, list)) results[results.length] = value;
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, iterator, context) {
	    return _.filter(obj, function(value, index, list) {
	      return !iterator.call(context, value, index, list);
	    }, context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Delegates to **ECMAScript 5**'s native `every` if available.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = true;
	    if (obj == null) return result;
	    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
	    each(obj, function(value, index, list) {
	      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Delegates to **ECMAScript 5**'s native `some` if available.
	  // Aliased as `any`.
	  var any = _.some = _.any = function(obj, iterator, context) {
	    iterator || (iterator = _.identity);
	    var result = false;
	    if (obj == null) return result;
	    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
	    each(obj, function(value, index, list) {
	      if (result || (result = iterator.call(context, value, index, list))) return breaker;
	    });
	    return !!result;
	  };
	
	  // Determine if the array or object contains a given value (using `===`).
	  // Aliased as `include`.
	  _.contains = _.include = function(obj, target) {
	    if (obj == null) return false;
	    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
	    return any(obj, function(value) {
	      return value === target;
	    });
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      return (isFunc ? method : value[method]).apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, function(value){ return value[key]; });
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs, first) {
	    if (_.isEmpty(attrs)) return first ? null : [];
	    return _[first ? 'find' : 'filter'](obj, function(value) {
	      for (var key in attrs) {
	        if (attrs[key] !== value[key]) return false;
	      }
	      return true;
	    });
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.where(obj, attrs, true);
	  };
	
	  // Return the maximum element or (element-based computation).
	  // Can't optimize arrays of integers longer than 65,535 elements.
	  // See: https://bugs.webkit.org/show_bug.cgi?id=80797
	  _.max = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.max.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return -Infinity;
	    var result = {computed : -Infinity, value: -Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed >= result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iterator, context) {
	    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
	      return Math.min.apply(Math, obj);
	    }
	    if (!iterator && _.isEmpty(obj)) return Infinity;
	    var result = {computed : Infinity, value: Infinity};
	    each(obj, function(value, index, list) {
	      var computed = iterator ? iterator.call(context, value, index, list) : value;
	      computed < result.computed && (result = {value : value, computed : computed});
	    });
	    return result.value;
	  };
	
	  // Shuffle an array.
	  _.shuffle = function(obj) {
	    var rand;
	    var index = 0;
	    var shuffled = [];
	    each(obj, function(value) {
	      rand = _.random(index++);
	      shuffled[index - 1] = shuffled[rand];
	      shuffled[rand] = value;
	    });
	    return shuffled;
	  };
	
	  // An internal function to generate lookup iterators.
	  var lookupIterator = function(value) {
	    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
	  };
	
	  // Sort the object's values by a criterion produced by an iterator.
	  _.sortBy = function(obj, value, context) {
	    var iterator = lookupIterator(value);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value : value,
	        index : index,
	        criteria : iterator.call(context, value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index < right.index ? -1 : 1;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(obj, value, context, behavior) {
	    var result = {};
	    var iterator = lookupIterator(value || _.identity);
	    each(obj, function(value, index) {
	      var key = iterator.call(context, value, index, obj);
	      behavior(result, key, value);
	    });
	    return result;
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key, value) {
	      (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
	    });
	  };
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = function(obj, value, context) {
	    return group(obj, value, context, function(result, key) {
	      if (!_.has(result, key)) result[key] = 0;
	      result[key]++;
	    });
	  };
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iterator, context) {
	    iterator = iterator == null ? _.identity : lookupIterator(iterator);
	    var value = iterator.call(context, obj);
	    var low = 0, high = array.length;
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
	    }
	    return low;
	  };
	
	  // Safely convert anything iterable into a real, live array.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (obj.length === +obj.length) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    return (n != null) && !guard ? slice.call(array, 0, n) : array[0];
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N. The **guard** check allows it to work with
	  // `_.map`.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array. The **guard** check allows it to work with `_.map`.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if ((n != null) && !guard) {
	      return slice.call(array, Math.max(array.length - n, 0));
	    } else {
	      return array[array.length - 1];
	    }
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array. The **guard**
	  // check allows it to work with `_.map`.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, (n == null) || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, output) {
	    each(input, function(value) {
	      if (_.isArray(value)) {
	        shallow ? push.apply(output, value) : flatten(value, shallow, output);
	      } else {
	        output.push(value);
	      }
	    });
	    return output;
	  };
	
	  // Return a completely flattened version of an array.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, []);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iterator, context) {
	    if (_.isFunction(isSorted)) {
	      context = iterator;
	      iterator = isSorted;
	      isSorted = false;
	    }
	    var initial = iterator ? _.map(array, iterator, context) : array;
	    var results = [];
	    var seen = [];
	    each(initial, function(value, index) {
	      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
	        seen.push(value);
	        results.push(array[index]);
	      }
	    });
	    return results;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(concat.apply(ArrayProto, arguments));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var rest = slice.call(arguments, 1);
	    return _.filter(_.uniq(array), function(item) {
	      return _.every(rest, function(other) {
	        return _.indexOf(other, item) >= 0;
	      });
	    });
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
	    return _.filter(array, function(value){ return !_.contains(rest, value); });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    var args = slice.call(arguments);
	    var length = _.max(_.pluck(args, 'length'));
	    var results = new Array(length);
	    for (var i = 0; i < length; i++) {
	      results[i] = _.pluck(args, "" + i);
	    }
	    return results;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    if (list == null) return {};
	    var result = {};
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
	  // we need this function. Return the position of the first occurrence of an
	  // item in an array, or -1 if the item is not included in the array.
	  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = function(array, item, isSorted) {
	    if (array == null) return -1;
	    var i = 0, l = array.length;
	    if (isSorted) {
	      if (typeof isSorted == 'number') {
	        i = (isSorted < 0 ? Math.max(0, l + isSorted) : isSorted);
	      } else {
	        i = _.sortedIndex(array, item);
	        return array[i] === item ? i : -1;
	      }
	    }
	    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
	    for (; i < l; i++) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
	  _.lastIndexOf = function(array, item, from) {
	    if (array == null) return -1;
	    var hasIndex = from != null;
	    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
	      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
	    }
	    var i = (hasIndex ? from : array.length);
	    while (i--) if (array[i] === item) return i;
	    return -1;
	  };
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (arguments.length <= 1) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = arguments[2] || 1;
	
	    var len = Math.max(Math.ceil((stop - start) / step), 0);
	    var idx = 0;
	    var range = new Array(len);
	
	    while(idx < len) {
	      range[idx++] = start;
	      start += step;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (func.bind === nativeBind && nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    var args = slice.call(arguments, 2);
	    return function() {
	      return func.apply(context, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context.
	  _.partial = function(func) {
	    var args = slice.call(arguments, 1);
	    return function() {
	      return func.apply(this, args.concat(slice.call(arguments)));
	    };
	  };
	
	  // Bind all of an object's methods to that object. Useful for ensuring that
	  // all callbacks defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var funcs = slice.call(arguments, 1);
	    if (funcs.length === 0) funcs = _.functions(obj);
	    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memo = {};
	    hasher || (hasher = _.identity);
	    return function() {
	      var key = hasher.apply(this, arguments);
	      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
	    };
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){ return func.apply(null, args); }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = function(func) {
	    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
	  };
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time.
	  _.throttle = function(func, wait) {
	    var context, args, timeout, result;
	    var previous = 0;
	    var later = function() {
	      previous = new Date;
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function() {
	      var now = new Date;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, result;
	    return function() {
	      var context = this, args = arguments;
	      var later = function() {
	        timeout = null;
	        if (!immediate) result = func.apply(context, args);
	      };
	      var callNow = immediate && !timeout;
	      clearTimeout(timeout);
	      timeout = setTimeout(later, wait);
	      if (callNow) result = func.apply(context, args);
	      return result;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = function(func) {
	    var ran = false, memo;
	    return function() {
	      if (ran) return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return function() {
	      var args = [func];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments;
	      for (var i = funcs.length - 1; i >= 0; i--) {
	        args = [funcs[i].apply(this, args)];
	      }
	      return args[0];
	    };
	  };
	
	  // Returns a function that will only be executed after being called N times.
	  _.after = function(times, func) {
	    if (times <= 0) return func();
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Object Functions
	  // ----------------
	
	  // Retrieve the names of an object's properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = nativeKeys || function(obj) {
	    if (obj !== Object(obj)) throw new TypeError('Invalid object');
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys[keys.length] = key;
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var values = [];
	    for (var key in obj) if (_.has(obj, key)) values.push(obj[key]);
	    return values;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var pairs = [];
	    for (var key in obj) if (_.has(obj, key)) pairs.push([key, obj[key]]);
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    for (var key in obj) if (_.has(obj, key)) result[obj[key]] = key;
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    each(keys, function(key) {
	      if (key in obj) copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj) {
	    var copy = {};
	    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!_.contains(keys, key)) copy[key] = obj[key];
	    }
	    return copy;
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = function(obj) {
	    each(slice.call(arguments, 1), function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] == null) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the Harmony `egal` proposal: http://wiki.ecmascript.org/doku.php?id=harmony:egal.
	    if (a === b) return a !== 0 || 1 / a == 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className != toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, dates, and booleans are compared by value.
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return a == String(b);
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
	        // other numeric values.
	        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a == +b;
	      // RegExps are compared by their source patterns and flags.
	      case '[object RegExp]':
	        return a.source == b.source &&
	               a.global == b.global &&
	               a.multiline == b.multiline &&
	               a.ignoreCase == b.ignoreCase;
	    }
	    if (typeof a != 'object' || typeof b != 'object') return false;
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] == a) return bStack[length] == b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    var size = 0, result = true;
	    // Recursively compare objects and arrays.
	    if (className == '[object Array]') {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      size = a.length;
	      result = size == b.length;
	      if (result) {
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (size--) {
	          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
	        }
	      }
	    } else {
	      // Objects with different constructors are not equivalent, but `Object`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
	                               _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
	        return false;
	      }
	      // Deep compare objects.
	      for (var key in a) {
	        if (_.has(a, key)) {
	          // Count the expected number of properties.
	          size++;
	          // Deep compare each member.
	          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
	        }
	      }
	      // Ensure that both objects contain the same number of properties.
	      if (result) {
	        for (key in b) {
	          if (_.has(b, key) && !(size--)) break;
	        }
	        result = !size;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return result;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b, [], []);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
	    for (var key in obj) if (_.has(obj, key)) return false;
	    return true;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    return obj === Object(obj);
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
	  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) == '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return !!(obj && _.has(obj, 'callee'));
	    };
	  }
	
	  // Optimize `isFunction` if appropriate.
	  if (true) {
	    _.isFunction = function(obj) {
	      return typeof obj === 'function';
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj != +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iterators.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iterator, context) {
	    var accum = Array(n);
	    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // List of HTML entities for escaping.
	  var entityMap = {
	    escape: {
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      "'": '&#x27;',
	      '/': '&#x2F;'
	    }
	  };
	  entityMap.unescape = _.invert(entityMap.escape);
	
	  // Regexes containing the keys and values listed immediately above.
	  var entityRegexes = {
	    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
	    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
	  };
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  _.each(['escape', 'unescape'], function(method) {
	    _[method] = function(string) {
	      if (string == null) return '';
	      return ('' + string).replace(entityRegexes[method], function(match) {
	        return entityMap[method][match];
	      });
	    };
	  });
	
	  // If the value of the named property is a function then invoke it;
	  // otherwise, return it.
	  _.result = function(object, property) {
	    if (object == null) return null;
	    var value = object[property];
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    each(_.functions(obj), function(name){
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result.call(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\t':     't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  _.template = function(text, data, settings) {
	    var render;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = new RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset)
	        .replace(escaper, function(match) { return '\\' + escapes[match]; });
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      }
	      if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      }
	      if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	      index = offset + match.length;
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + "return __p;\n";
	
	    try {
	      render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    if (data) return render(data, _);
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled function source as a convenience for precompilation.
	    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function, which will delegate to the wrapper.
	  _.chain = function(obj) {
	    return _(obj).chain();
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(obj) {
	    return this._chain ? _(obj).chain() : obj;
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
	      return result.call(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result.call(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  _.extend(_.prototype, {
	
	    // Start chaining a wrapped Underscore object.
	    chain: function() {
	      this._chain = true;
	      return this;
	    },
	
	    // Extracts the result from a wrapped and chained object.
	    value: function() {
	      return this._wrapped;
	    }
	
	  });
	
	}).call(this);


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/*jshint node:true*/
	'use strict';
	
	/**
	 * Replaces characters in strings that are illegal/unsafe for filenames.
	 * Unsafe characters are either removed or replaced by a substitute set
	 * in the optional `options` object.
	 *
	 * Illegal Characters on Various Operating Systems
	 * / ? < > \ : * | "
	 * https://kb.acronis.com/content/39790
	 *
	 * Unicode Control codes
	 * C0 0x00-0x1f & C1 (0x80-0x9f)
	 * http://en.wikipedia.org/wiki/C0_and_C1_control_codes
	 *
	 * Reserved filenames on Unix-based systems (".", "..")
	 * Reserved filenames in Windows ("CON", "PRN", "AUX", "NUL", "COM1",
	 * "COM2", "COM3", "COM4", "COM5", "COM6", "COM7", "COM8", "COM9",
	 * "LPT1", "LPT2", "LPT3", "LPT4", "LPT5", "LPT6", "LPT7", "LPT8", and
	 * "LPT9") case-insesitively and with or without filename extensions.
	 *
	 * Capped at 255 characters in length.
	 * http://unix.stackexchange.com/questions/32795/what-is-the-maximum-allowed-filename-and-folder-size-with-ecryptfs
	 *
	 * @param  {String} input   Original filename
	 * @param  {Object} options {replacement: String}
	 * @return {String}         Sanitized filename
	 */
	
	var truncate = __webpack_require__(51);
	
	var illegalRe = /[\/\?<>\\:\*\|":]/g;
	var controlRe = /[\x00-\x1f\x80-\x9f]/g;
	var reservedRe = /^\.+$/;
	var windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
	var windowsTrailingRe = /[\. ]+$/;
	
	function sanitize(input, replacement) {
	  var sanitized = input
	    .replace(illegalRe, replacement)
	    .replace(controlRe, replacement)
	    .replace(reservedRe, replacement)
	    .replace(windowsReservedRe, replacement)
	    .replace(windowsTrailingRe, replacement);
	  return truncate(sanitized, 255);
	}
	
	module.exports = function (input, options) {
	  var replacement = (options && options.replacement) || '';
	  var output = sanitize(input, replacement);
	  if (replacement === '') {
	    return output;
	  }
	  return sanitize(output, '');
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var truncate = __webpack_require__(52);
	var getLength = __webpack_require__(53);
	module.exports = truncate.bind(null, getLength);


/***/ },
/* 52 */
/***/ function(module, exports) {

	'use strict';
	
	function isHighSurrogate(codePoint) {
	  return codePoint >= 0xd800 && codePoint <= 0xdbff;
	}
	
	function isLowSurrogate(codePoint) {
	  return codePoint >= 0xdc00 && codePoint <= 0xdfff;
	}
	
	// Truncate string by size in bytes
	module.exports = function truncate(getLength, string, byteLength) {
	  if (typeof string !== "string") {
	    throw new Error("Input must be string");
	  }
	
	  var charLength = string.length;
	  var curByteLength = 0;
	  var codePoint;
	  var segment;
	
	  for (var i = 0; i < charLength; i += 1) {
	    codePoint = string.charCodeAt(i);
	    segment = string[i];
	
	    if (isHighSurrogate(codePoint) && isLowSurrogate(string.charCodeAt(i + 1))) {
	      i += 1;
	      segment += string[i];
	    }
	
	    curByteLength += getLength(segment);
	
	    if (curByteLength === byteLength) {
	      return string.slice(0, i + 1);
	    }
	    else if (curByteLength > byteLength) {
	      return string.slice(0, i - segment.length + 1);
	    }
	  }
	
	  return string;
	};
	


/***/ },
/* 53 */
/***/ function(module, exports) {

	'use strict';
	
	function isHighSurrogate(codePoint) {
	  return codePoint >= 0xd800 && codePoint <= 0xdbff;
	}
	
	function isLowSurrogate(codePoint) {
	  return codePoint >= 0xdc00 && codePoint <= 0xdfff;
	}
	
	// Truncate string by size in bytes
	module.exports = function getByteLength(string) {
	  if (typeof string !== "string") {
	    throw new Error("Input must be string");
	  }
	
	  var charLength = string.length;
	  var byteLength = 0;
	  var codePoint = null;
	  var prevCodePoint = null;
	  for (var i = 0; i < charLength; i++) {
	    codePoint = string.charCodeAt(i);
	    // handle 4-byte non-BMP chars
	    // low surrogate
	    if (isLowSurrogate(codePoint)) {
	      // when parsing previous hi-surrogate, 3 is added to byteLength
	      if (prevCodePoint != null && isHighSurrogate(prevCodePoint)) {
	        byteLength += 1;
	      }
	      else {
	        byteLength += 3;
	      }
	    }
	    else if (codePoint <= 0x7f ) {
	      byteLength += 1;
	    }
	    else if (codePoint >= 0x80 && codePoint <= 0x7ff) {
	      byteLength += 2;
	    }
	    else if (codePoint >= 0x800 && codePoint <= 0xffff) {
	      byteLength += 3;
	    }
	    prevCodePoint = codePoint;
	  }
	
	  return byteLength;
	};


/***/ },
/* 54 */
/***/ function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function (con) {
	    'use strict';
	    var prop, method;
	    var empty = {};
	    var dummy = function() {};
	    var properties = 'memory'.split(',');
	    var methods = ('assert,count,debug,dir,dirxml,error,exception,group,' +
	        'groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,' +
	        'time,timeEnd,trace,warn').split(',');
	    while (prop = properties.pop()) con[prop] = con[prop] || empty;
	    while (method = methods.pop()) con[method] = con[method] || dummy;
	})(window.console = window.console || {});

/***/ },
/* 55 */
/***/ function(module, exports) {

	/* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
	    Used here for webpack style-loader
	 * */
	
	if (!Function.prototype.bind) {
	    Function.prototype.bind = function(oThis) {
	        if (typeof this !== 'function') {
	            // closest thing possible to the ECMAScript 5
	            // internal IsCallable function
	            throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	        }
	
	        var aArgs   = Array.prototype.slice.call(arguments, 1),
	            fToBind = this,
	            fNOP    = function() {},
	            fBound  = function() {
	                return fToBind.apply(this instanceof fNOP && oThis
	                        ? this
	                        : oThis,
	                    aArgs.concat(Array.prototype.slice.call(arguments)));
	            };
	
	        fNOP.prototype = this.prototype;
	        fBound.prototype = new fNOP();
	
	        return fBound;
	    };
	}

/***/ },
/* 56 */
/***/ function(module, exports) {

	/*
	* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
	* Used now in style-loader (needed for IE8)
	* */
	
	if (!Array.prototype.filter) {
	    Array.prototype.filter = function(fun/*, thisArg*/) {
	        'use strict';
	
	        if (this === void 0 || this === null) {
	            throw new TypeError();
	        }
	
	        var t = Object(this);
	        var len = t.length >>> 0;
	        if (typeof fun !== 'function') {
	            throw new TypeError();
	        }
	
	        var res = [];
	        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	        for (var i = 0; i < len; i++) {
	            if (i in t) {
	                var val = t[i];
	
	                // NOTE: Technically this should Object.defineProperty at
	                //       the next index, as push can be affected by
	                //       properties on Object.prototype and Array.prototype.
	                //       But that method's new, and collisions should be
	                //       rare, so use the more-compatible alternative.
	                if (fun.call(thisArg, val, i, t)) {
	                    res.push(val);
	                }
	            }
	        }
	
	        return res;
	    };
	}

/***/ },
/* 57 */
/***/ function(module, exports) {

	/*
	    https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
	    For Now, import plugin requires map polyfill
	*/
	if (!Array.prototype.map)
	{
	    Array.prototype.map = function(fun /*, thisArg */)
	    {
	        "use strict";
	
	        if (this === void 0 || this === null)
	            throw new TypeError();
	
	        var t = Object(this);
	        var len = t.length >>> 0;
	        if (typeof fun !== "function")
	            throw new TypeError();
	
	        var res = new Array(len);
	        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	        for (var i = 0; i < len; i++)
	        {
	            // NOTE: Absolute correctness would demand Object.defineProperty
	            //       be used.  But this method is fairly new, and failure is
	            //       possible only if Object.prototype or Array.prototype
	            //       has a property |i| (very unlikely), so use a less-correct
	            //       but more portable alternative.
	            if (i in t)
	                res[i] = fun.call(thisArg, t[i], i, t);
	        }
	
	        return res;
	    };
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	//     Backbone.js 1.0.0
	
	//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(){
	
	  // Initial Setup
	  // -------------
	
	  // Save a reference to the global object (`window` in the browser, `exports`
	  // on the server).
	  var root = this;
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create local references to array methods we'll want to use later.
	  var array = [];
	  var push = array.push;
	  var slice = array.slice;
	  var splice = array.splice;
	
	  // The top-level namespace. All public Backbone classes and modules will
	  // be attached to this. Exported for both the browser and the server.
	  var Backbone;
	  if (true) {
	    Backbone = exports;
	  } else {
	    Backbone = root.Backbone = {};
	  }
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.0.0';
	
	  // Require Underscore, if we're on the server, and it's not already present.
	  var _ = root._;
	  if (!_ && ("function" !== 'undefined')) _ = __webpack_require__(49);
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // custom events. You may bind with `on` or remove with `off` callback
	  // functions to an event; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {
	
	    // Bind an event to a `callback` function. Passing `"all"` will bind
	    // the callback to all events fired.
	    on: function(name, callback, context) {
	      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
	      this._events || (this._events = {});
	      var events = this._events[name] || (this._events[name] = []);
	      events.push({callback: callback, context: context, ctx: context || this});
	      return this;
	    },
	
	    // Bind an event to only be triggered a single time. After the first time
	    // the callback is invoked, it will be removed.
	    once: function(name, callback, context) {
	      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
	      var self = this;
	      var once = _.once(function() {
	        self.off(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	      return this.on(name, once, context);
	    },
	
	    // Remove one or many callbacks. If `context` is null, removes all
	    // callbacks with that function. If `callback` is null, removes all
	    // callbacks for the event. If `name` is null, removes all bound
	    // callbacks for all events.
	    off: function(name, callback, context) {
	      var retain, ev, events, names, i, l, j, k;
	      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
	      if (!name && !callback && !context) {
	        this._events = {};
	        return this;
	      }
	
	      names = name ? [name] : _.keys(this._events);
	      for (i = 0, l = names.length; i < l; i++) {
	        name = names[i];
	        if (events = this._events[name]) {
	          this._events[name] = retain = [];
	          if (callback || context) {
	            for (j = 0, k = events.length; j < k; j++) {
	              ev = events[j];
	              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
	                  (context && context !== ev.context)) {
	                retain.push(ev);
	              }
	            }
	          }
	          if (!retain.length) delete this._events[name];
	        }
	      }
	
	      return this;
	    },
	
	    // Trigger one or many events, firing all bound callbacks. Callbacks are
	    // passed the same arguments as `trigger` is, apart from the event name
	    // (unless you're listening on `"all"`, which will cause your callback to
	    // receive the true name of the event as the first argument).
	    trigger: function(name) {
	      if (!this._events) return this;
	      var args = slice.call(arguments, 1);
	      if (!eventsApi(this, 'trigger', name, args)) return this;
	      var events = this._events[name];
	      var allEvents = this._events.all;
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, arguments);
	      return this;
	    },
	
	    // Tell this object to stop listening to either specific events ... or
	    // to every object it's currently listening to.
	    stopListening: function(obj, name, callback) {
	      var listeners = this._listeners;
	      if (!listeners) return this;
	      var deleteListener = !name && !callback;
	      if (typeof name === 'object') callback = this;
	      if (obj) (listeners = {})[obj._listenerId] = obj;
	      for (var id in listeners) {
	        listeners[id].off(name, callback, this);
	        if (deleteListener) delete this._listeners[id];
	      }
	      return this;
	    }
	
	  };
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Implement fancy features of the Events API such as multiple event
	  // names `"change blur"` and jQuery-style event maps `{change: action}`
	  // in terms of the existing API.
	  var eventsApi = function(obj, action, name, rest) {
	    if (!name) return true;
	
	    // Handle event maps.
	    if (typeof name === 'object') {
	      for (var key in name) {
	        obj[action].apply(obj, [key, name[key]].concat(rest));
	      }
	      return false;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return false;
	    }
	
	    return true;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
	    }
	  };
	
	  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};
	
	  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
	  // listen to an event in another object ... keeping track of what it's
	  // listening to.
	  _.each(listenMethods, function(implementation, method) {
	    Events[method] = function(obj, name, callback) {
	      var listeners = this._listeners || (this._listeners = {});
	      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
	      listeners[id] = obj;
	      if (typeof name === 'object') callback = this;
	      obj[implementation](name, callback, this);
	      return this;
	    };
	  });
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var defaults;
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId('c');
	    this.attributes = {};
	    _.extend(this, _.pick(options, modelOptions));
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    if (defaults = _.result(this, 'defaults')) {
	      attrs = _.defaults({}, attrs, defaults);
	    }
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // A list of options to be attached directly to the model, if provided.
	  var modelOptions = ['url', 'urlRoot', 'collection'];
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      var attr, attrs, unset, changes, silent, changing, prev, current;
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      unset           = options.unset;
	      silent          = options.silent;
	      changes         = [];
	      changing        = this._changing;
	      this._changing  = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	      current = this.attributes, prev = this._previousAttributes;
	
	      // Check for changes of `id`.
	      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];
	
	      // For each `set` attribute, update or delete the current value.
	      for (attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          this.changed[attr] = val;
	        } else {
	          delete this.changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = true;
	        for (var i = 0, l = changes.length; i < l; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var val, changed = false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      for (var attr in diff) {
	        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
	        (changed || (changed = {}))[attr] = val;
	      }
	      return changed;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server. If the server's representation of the
	    // model differs from its current attributes, they will be overridden,
	    // triggering a `"change"` event.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (!model.set(model.parse(resp, options), options)) return false;
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      var attrs, method, xhr, attributes = this.attributes;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
	      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;
	
	      options = _.extend({validate: true}, options);
	
	      // Do not persist invalid models.
	      if (!this._validate(attrs, options)) return false;
	
	      // Set temporary attributes if `{wait: true}`.
	      if (attrs && options.wait) {
	        this.attributes = _.extend({}, attributes, attrs);
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      if (options.parse === void 0) options.parse = true;
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = model.parse(resp, options);
	        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
	        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
	          return false;
	        }
	        if (success) success(model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch') options.attrs = attrs;
	      xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      if (attrs && options.wait) this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	
	      var destroy = function() {
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (options.wait || model.isNew()) destroy();
	        if (success) success(model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      if (this.isNew()) {
	        options.success();
	        return false;
	      }
	      wrapError(this, options);
	
	      var xhr = this.sync('delete', this, options);
	      if (!options.wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
	      if (this.isNew()) return base;
	      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return this.id == null;
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend(options || {}, { validate: true }));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model.
	  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  _.each(modelMethods, function(method) {
	    Model.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.attributes);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analagous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.url) this.url = options.url;
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, merge: false, remove: false};
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model){ return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set.
	    add: function(models, options) {
	      return this.set(models, _.defaults(options || {}, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      models = _.isArray(models) ? models.slice() : [models];
	      options || (options = {});
	      var i, l, index, model;
	      for (i = 0, l = models.length; i < l; i++) {
	        model = this.get(models[i]);
	        if (!model) continue;
	        delete this._byId[model.id];
	        delete this._byId[model.cid];
	        index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	        this._removeReference(model);
	      }
	      return this;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      options = _.defaults(options || {}, setOptions);
	      if (options.parse) models = this.parse(models, options);
	      if (!_.isArray(models)) models = models ? [models] : [];
	      var i, l, model, attrs, existing, sort;
	      var at = options.at;
	      var sortable = this.comparator && (at == null) && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	      var toAdd = [], toRemove = [], modelMap = {};
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      for (i = 0, l = models.length; i < l; i++) {
	        if (!(model = this._prepareModel(models[i], options))) continue;
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        if (existing = this.get(model)) {
	          if (options.remove) modelMap[existing.cid] = true;
	          if (options.merge) {
	            existing.set(model.attributes, options);
	            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
	          }
	
	        // This is a new model, push it to the `toAdd` list.
	        } else if (options.add) {
	          toAdd.push(model);
	
	          // Listen to added models' events, and index models for lookup by
	          // `id` and by `cid`.
	          model.on('all', this._onModelEvent, this);
	          this._byId[model.cid] = model;
	          if (model.id != null) this._byId[model.id] = model;
	        }
	      }
	
	      // Remove nonexistent models if appropriate.
	      if (options.remove) {
	        for (i = 0, l = this.length; i < l; ++i) {
	          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this.remove(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      if (toAdd.length) {
	        if (sortable) sort = true;
	        this.length += toAdd.length;
	        if (at != null) {
	          splice.apply(this.models, [at, 0].concat(toAdd));
	        } else {
	          push.apply(this.models, toAdd);
	        }
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      if (options.silent) return this;
	
	      // Trigger `add` events.
	      for (i = 0, l = toAdd.length; i < l; i++) {
	        (model = toAdd[i]).trigger('add', model, this, options);
	      }
	
	      // Trigger `sort` if the collection was sorted.
	      if (sort) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options || (options = {});
	      for (var i = 0, l = this.models.length; i < l; i++) {
	        this._removeReference(this.models[i]);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return this;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      model = this._prepareModel(model, options);
	      this.add(model, _.extend({at: this.length}, options));
	      return model;
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      model = this._prepareModel(model, options);
	      this.add(model, _.extend({at: 0}, options));
	      return model;
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      this.remove(model, options);
	      return model;
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function(begin, end) {
	      return this.models.slice(begin, end);
	    },
	
	    // Get a model from the set by id.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      if (_.isEmpty(attrs)) return first ? void 0 : [];
	      return this[first ? 'find' : 'filter'](function(model) {
	        for (var key in attrs) {
	          if (attrs[key] !== model.get(key)) return false;
	        }
	        return true;
	      });
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      // Run sort based on type of `comparator`.
	      if (_.isString(this.comparator) || this.comparator.length === 1) {
	        this.models = this.sortBy(this.comparator, this);
	      } else {
	        this.models.sort(_.bind(this.comparator, this));
	      }
	
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Figure out the smallest index at which a model should be inserted so as
	    // to maintain order.
	    sortedIndex: function(model, value, context) {
	      value || (value = this.comparator);
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _.sortedIndex(this.models, model, iterator, context);
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return _.invoke(this.models, 'get', attr);
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = options ? _.clone(options) : {};
	      if (options.parse === void 0) options.parse = true;
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success(collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      if (!(model = this._prepareModel(model, options))) return false;
	      if (!options.wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(resp) {
	        if (options.wait) collection.add(model, options);
	        if (success) success(model, resp, options);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models);
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (attrs instanceof Model) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options || (options = {});
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model._validate(attrs, options)) {
	        this.trigger('invalid', this, attrs, options);
	        return false;
	      }
	      return model;
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model) {
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if ((event === 'add' || event === 'remove') && collection !== this) return;
	      if (event === 'destroy') this.remove(model, options);
	      if (model && event === 'change:' + model.idAttribute) {
	        delete this._byId[model.previous(model.idAttribute)];
	        if (model.id != null) this._byId[model.id] = model;
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
	    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
	    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
	    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
	    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
	    'isEmpty', 'chain'];
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  _.each(methods, function(method) {
	    Collection.prototype[method] = function() {
	      var args = slice.call(arguments);
	      args.unshift(this.models);
	      return _[method].apply(_, args);
	    };
	  });
	
	  // Underscore methods that take a property name as an argument.
	  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];
	
	  // Use attributes instead of properties.
	  _.each(attributeMethods, function(method) {
	    Collection.prototype[method] = function(value, context) {
	      var iterator = _.isFunction(value) ? value : function(model) {
	        return model.get(value);
	      };
	      return _[method](this.models, iterator, context);
	    };
	  });
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    this._configure(options || {});
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	    this.delegateEvents();
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be merged as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be prefered to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this.$el.remove();
	      this.stopListening();
	      return this;
	    },
	
	    // Change the view's element (`this.el` property), including event
	    // re-delegation.
	    setElement: function(element, delegate) {
	      if (this.$el) this.undelegateEvents();
	      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
	      this.el = this.$el[0];
	      if (delegate !== false) this.delegateEvents();
	      return this;
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save'
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    // This only works for delegate-able events: not `focus`, `blur`, and
	    // not `change`, `submit`, and `reset` in Internet Explorer.
	    delegateEvents: function(events) {
	      if (!(events || (events = _.result(this, 'events')))) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[events[key]];
	        if (!method) continue;
	
	        var match = key.match(delegateEventSplitter);
	        var eventName = match[1], selector = match[2];
	        method = _.bind(method, this);
	        eventName += '.delegateEvents' + this.cid;
	        if (selector === '') {
	          this.$el.on(eventName, method);
	        } else {
	          this.$el.on(eventName, selector, method);
	        }
	      }
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view with `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // Performs the initial configuration of a View with a set of options.
	    // Keys with special meaning *(e.g. model, collection, id, className)* are
	    // attached directly to the view.  See `viewOptions` for an exhaustive
	    // list.
	    _configure: function(options) {
	      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
	      _.extend(this, _.pick(options, viewOptions));
	      this.options = options;
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
	        this.setElement($el, false);
	      } else {
	        this.setElement(_.result(this, 'el'), false);
	      }
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
	    // that still has ActiveX enabled by default, override jQuery to use that
	    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
	    if (params.type === 'PATCH' && window.ActiveXObject &&
	          !(window.external && window.external.msActiveXFilteringEnabled)) {
	      params.xhr = function() {
	        return new ActiveXObject("Microsoft.XMLHTTP");
	      };
	    }
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch':  'PATCH',
	    'delete': 'DELETE',
	    'read':   'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        callback && callback.apply(router, args);
	        router.trigger.apply(router, ['route:' + name].concat(args));
	        router.trigger('route', name, args);
	        Backbone.history.trigger('route', router, name, args);
	      });
	      return this;
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional){
	                     return optional ? match : '([^\/]+)';
	                   })
	                   .replace(splatParam, '(.*?)');
	      return new RegExp('^' + route + '$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param) {
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    _.bindAll(this, 'checkUrl');
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for detecting MSIE.
	  var isExplorer = /msie [\w.]+/;
	
	  // Cached regex for removing a trailing slash.
	  var trailingSlash = /\/$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the cross-browser normalized URL fragment, either from the URL,
	    // the hash, or the override.
	    getFragment: function(fragment, forcePushState) {
	      if (fragment == null) {
	        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
	          fragment = this.location.pathname;
	          var root = this.root.replace(trailingSlash, '');
	          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error("Backbone.history has already been started");
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({}, {root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
	      var fragment          = this.getFragment();
	      var docMode           = document.documentMode;
	      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      if (oldIE && this._wantsHashChange) {
	        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
	        this.navigate(fragment);
	      }
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._hasPushState) {
	        Backbone.$(window).on('popstate', this.checkUrl);
	      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
	        Backbone.$(window).on('hashchange', this.checkUrl);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      // Determine if we need to change the base url, for a pushState link
	      // opened by a non-pushState browser.
	      this.fragment = fragment;
	      var loc = this.location;
	      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;
	
	      // If we've started off with a route from a `pushState`-enabled browser,
	      // but we're currently in a browser that doesn't support it...
	      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
	        this.fragment = this.getFragment(null, true);
	        this.location.replace(this.root + this.location.search + '#' + this.fragment);
	        // Return immediately as browser will do redirect to new url
	        return true;
	
	      // Or if we've started out with a hash-based route, but we're currently
	      // in a browser where it could be `pushState`-based instead...
	      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
	        this.fragment = this.getHash().replace(routeStripper, '');
	        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
	      clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	      if (current === this.fragment && this.iframe) {
	        current = this.getFragment(this.getHash(this.iframe));
	      }
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl() || this.loadUrl(this.getHash());
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragmentOverride) {
	      var fragment = this.fragment = this.getFragment(fragmentOverride);
	      var matched = _.any(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	      return matched;
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: options};
	      fragment = this.getFragment(fragment || '');
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	      var url = this.root + fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._hasPushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if(!options.replace) this.iframe.document.open().close();
	          this._updateHash(this.iframe.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain, for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent's constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function.
	    var Surrogate = function(){ this.constructor = child; };
	    Surrogate.prototype = parent.prototype;
	    child.prototype = new Surrogate;
	
	    // Add prototype properties (instance properties) to the subclass,
	    // if supplied.
	    if (protoProps) _.extend(child.prototype, protoProps);
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function (model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error(model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	}).call(this);


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.11.1
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-05-01T17:42Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper window is present,
			// execute the factory and get jQuery
			// For environments that do not inherently posses a window with a document
			// (such as Node.js), expose a jQuery-making factory as module.exports
			// This accentuates the need for the creation of a real window
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Can't do this because several apps including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	// Support: Firefox 18+
	//
	
	var deletedIds = [];
	
	var slice = deletedIds.slice;
	
	var concat = deletedIds.concat;
	
	var push = deletedIds.push;
	
	var indexOf = deletedIds.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "1.11.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1, IE<9
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		// (You can seed the arguments with an array of args, but this is
		// only used internally.)
		each: function( callback, args ) {
			return jQuery.each( this, callback, args );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map(this, function( elem, i ) {
				return callback.call( elem, i, elem );
			}));
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor(null);
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: deletedIds.sort,
		splice: deletedIds.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
			target = arguments[0] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
			target = {};
		}
	
		// extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
			// Only deal with non-null/undefined values
			if ( (options = arguments[ i ]) != null ) {
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray(src) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend({
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		// See test/unit/core.js for details concerning isFunction.
		// Since version 1.3, DOM methods and functions like alert
		// aren't supported. They return false on IE (#2968).
		isFunction: function( obj ) {
			return jQuery.type(obj) === "function";
		},
	
		isArray: Array.isArray || function( obj ) {
			return jQuery.type(obj) === "array";
		},
	
		isWindow: function( obj ) {
			/* jshint eqeqeq: false */
			return obj != null && obj == obj.window;
		},
	
		isNumeric: function( obj ) {
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			return !jQuery.isArray( obj ) && obj - parseFloat( obj ) >= 0;
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Must be an Object.
			// Because of IE, we also have to check the presence of the constructor property.
			// Make sure that DOM nodes and window objects don't pass through, as well
			if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			try {
				// Not own constructor property must be Object
				if ( obj.constructor &&
					!hasOwn.call(obj, "constructor") &&
					!hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
					return false;
				}
			} catch ( e ) {
				// IE8,9 Will throw exceptions on certain host objects #9897
				return false;
			}
	
			// Support: IE<9
			// Handle iteration over inherited properties before own properties.
			if ( support.ownLast ) {
				for ( key in obj ) {
					return hasOwn.call( obj, key );
				}
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own.
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call(obj) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		// Workarounds based on findings by Jim Driscoll
		// http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
		globalEval: function( data ) {
			if ( data && jQuery.trim( data ) ) {
				// We use execScript on Internet Explorer
				// We use an anonymous function so that context is window
				// rather than jQuery in Firefox
				( window.execScript || function( data ) {
					window[ "eval" ].call( window, data );
				} )( data );
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		// args is for internal usage only
		each: function( obj, callback, args ) {
			var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike( obj );
	
			if ( args ) {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.apply( obj[ i ], args );
	
						if ( value === false ) {
							break;
						}
					}
				}
	
			// A special, fast, case for the most common use of each
			} else {
				if ( isArray ) {
					for ( ; i < length; i++ ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				} else {
					for ( i in obj ) {
						value = callback.call( obj[ i ], i, obj[ i ] );
	
						if ( value === false ) {
							break;
						}
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1, IE<9
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArraylike( Object(arr) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			var len;
	
			if ( arr ) {
				if ( indexOf ) {
					return indexOf.call( arr, elem, i );
				}
	
				len = arr.length;
				i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
				for ( ; i < len; i++ ) {
					// Skip accessing in sparse arrays
					if ( i in arr && arr[ i ] === elem ) {
						return i;
					}
				}
			}
	
			return -1;
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			while ( j < len ) {
				first[ i++ ] = second[ j++ ];
			}
	
			// Support: IE<9
			// Workaround casting of .length to NaN on otherwise arraylike objects (e.g., NodeLists)
			if ( len !== len ) {
				while ( second[j] !== undefined ) {
					first[ i++ ] = second[ j++ ];
				}
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var value,
				i = 0,
				length = elems.length,
				isArray = isArraylike( elems ),
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var args, proxy, tmp;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: function() {
			return +( new Date() );
		},
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	function isArraylike( obj ) {
		var length = obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		if ( obj.nodeType === 1 && length ) {
			return true;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v1.10.19
	 * http://sizzlejs.com/
	 *
	 * Copyright 2013 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2014-04-18
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + -(new Date()),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		strundefined = typeof undefined,
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf if we can't use a native one
		indexOf = arr.indexOf || function( elem ) {
			var i = 0,
				len = this.length;
			for ( ; i < len; i++ ) {
				if ( this[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
		// http://www.w3.org/TR/css3-syntax/#characters
		characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Loosely modeled on CSS identifier characters
		// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
		// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = characterEncoding.replace( "w", "w#" ),
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + characterEncoding + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + characterEncoding + ")" ),
			"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
			"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var match, elem, m, nodeType,
			// QSA vars
			i, groups, old, nid, newContext, newSelector;
	
		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
	
		context = context || document;
		results = results || [];
	
		if ( !selector || typeof selector !== "string" ) {
			return results;
		}
	
		if ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {
			return [];
		}
	
		if ( documentIsHTML && !seed ) {
	
			// Shortcuts
			if ( (match = rquickExpr.exec( selector )) ) {
				// Speed-up: Sizzle("#ID")
				if ( (m = match[1]) ) {
					if ( nodeType === 9 ) {
						elem = context.getElementById( m );
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document (jQuery #6963)
						if ( elem && elem.parentNode ) {
							// Handle the case where IE, Opera, and Webkit return items
							// by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}
					} else {
						// Context is not a document
						if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
							contains( context, elem ) && elem.id === m ) {
							results.push( elem );
							return results;
						}
					}
	
				// Speed-up: Sizzle("TAG")
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;
	
				// Speed-up: Sizzle(".CLASS")
				} else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}
	
			// QSA path
			if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
				nid = old = expando;
				newContext = context;
				newSelector = nodeType === 9 && selector;
	
				// qSA works strangely on Element-rooted queries
				// We can work around this by specifying an extra ID on the root
				// and working up from there (Thanks to Andrew Dupont for the technique)
				// IE 8 doesn't work on object elements
				if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
					groups = tokenize( selector );
	
					if ( (old = context.getAttribute("id")) ) {
						nid = old.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", nid );
					}
					nid = "[id='" + nid + "'] ";
	
					i = groups.length;
					while ( i-- ) {
						groups[i] = nid + toSelector( groups[i] );
					}
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
					newSelector = groups.join(",");
				}
	
				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch(qsaError) {
					} finally {
						if ( !old ) {
							context.removeAttribute("id");
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = attrs.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== strundefined && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare,
			doc = node ? node.ownerDocument || node : preferredDoc,
			parent = doc.defaultView;
	
		// If no document and documentElement is available, return
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Set our document
		document = doc;
		docElem = doc.documentElement;
	
		// Support tests
		documentIsHTML = !isXML( doc );
	
		// Support: IE>8
		// If iframe document is assigned to "document" variable and if iframe has been reloaded,
		// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
		// IE6-8 do not support the defaultView property so parent will be undefined
		if ( parent && parent !== parent.top ) {
			// IE11 does not have attachEvent, so all must suffer
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", function() {
					setDocument();
				}, false );
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", function() {
					setDocument();
				});
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( doc.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Check if getElementsByClassName can be trusted
		support.getElementsByClassName = rnative.test( doc.getElementsByClassName ) && assert(function( div ) {
			div.innerHTML = "<div class='a'></div><div class='a i'></div>";
	
			// Support: Safari<4
			// Catch class over-caching
			div.firstChild.className = "i";
			// Support: Opera<10
			// Catch gEBCN failure to find non-leading classes
			return div.getElementsByClassName("i").length === 2;
		});
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== strundefined && documentIsHTML ) {
					var m = context.getElementById( id );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document #6963
					return m && m.parentNode ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== strundefined ) {
					return context.getElementsByTagName( tag );
				}
			} :
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				div.innerHTML = "<select msallowclip=''><option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowclip^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = doc.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully does not implement inclusive descendent
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === doc ? -1 :
					b === doc ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return doc;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch(e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, outerCache, node, diff, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || (parent[ expando ] = {});
								cache = outerCache[ type ] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = cache[0] === dirruns && cache[2];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							// Use previously-cached element index if available
							} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
								diff = cache[1];
	
							// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
							} else {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
										// Cache the index of each encountered element
										if ( useCache ) {
											(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
										}
	
										if ( node === elem ) {
											break;
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
							if ( (oldCache = outerCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context !== document && context;
				}
	
				// Add elements passing elementMatchers directly to results
				// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// Apply set filters to unmatched elements
				matchedCount += i;
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is no seed and only one group
		if ( match.length === 1 ) {
	
			// Take a shortcut and set the context if the root selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome<14
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			});
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			});
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( jQuery.inArray( elem, qualifier ) >= 0 ) !== not;
		});
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			}));
	};
	
	jQuery.fn.extend({
		find: function( selector ) {
			var i,
				ret = [],
				self = this,
				len = self.length;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter(function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				}) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow(this, selector || [], false) );
		},
		not: function( selector ) {
			return this.pushStack( winnow(this, selector || [], true) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	});
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// Use the correct document accordingly with window argument (sandbox)
		document = window.document,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && (match[1] || !context) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[1] ) {
						context = context instanceof jQuery ? context[0] : context;
	
						// scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[1],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[2] );
	
						// Check parentNode to catch when Blackberry 4.6 returns
						// nodes that are no longer in the document #6963
						if ( elem && elem.parentNode ) {
							// Handle the case where IE and Opera return items
							// by name instead of ID
							if ( elem.id !== match[2] ) {
								return rootjQuery.find( selector );
							}
	
							// Otherwise, we inject the element directly into the jQuery object
							this.length = 1;
							this[0] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || rootjQuery ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[0] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return typeof rootjQuery.ready !== "undefined" ?
					rootjQuery.ready( selector ) :
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
		// methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.extend({
		dir: function( elem, dir, until ) {
			var matched = [],
				cur = elem[ dir ];
	
			while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
				if ( cur.nodeType === 1 ) {
					matched.push( cur );
				}
				cur = cur[dir];
			}
			return matched;
		},
	
		sibling: function( n, elem ) {
			var r = [];
	
			for ( ; n; n = n.nextSibling ) {
				if ( n.nodeType === 1 && n !== elem ) {
					r.push( n );
				}
			}
	
			return r;
		}
	});
	
	jQuery.fn.extend({
		has: function( target ) {
			var i,
				targets = jQuery( target, this ),
				len = targets.length;
	
			return this.filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( this, targets[i] ) ) {
						return true;
					}
				}
			});
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
					// Always skip document fragments
					if ( cur.nodeType < 11 && (pos ?
						pos.index(cur) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector(cur, selectors)) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
		},
	
		// Determine the position of an element within
		// the matched set of elements
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[0] && this[0].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// index in selector
			if ( typeof elem === "string" ) {
				return jQuery.inArray( this[0], jQuery( elem ) );
			}
	
			// Locate the position of the desired element
			return jQuery.inArray(
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem, this );
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.unique(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter(selector)
			);
		}
	});
	
	function sibling( cur, dir ) {
		do {
			cur = cur[ dir ];
		} while ( cur && cur.nodeType !== 1 );
	
		return cur;
	}
	
	jQuery.each({
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return jQuery.dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return jQuery.dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return jQuery.dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return jQuery.dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return jQuery.sibling( elem.firstChild );
		},
		contents: function( elem ) {
			return jQuery.nodeName( elem, "iframe" ) ?
				elem.contentDocument || elem.contentWindow.document :
				jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var ret = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				ret = jQuery.filter( selector, ret );
			}
	
			if ( this.length > 1 ) {
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					ret = jQuery.unique( ret );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					ret = ret.reverse();
				}
			}
	
			return this.pushStack( ret );
		};
	});
	var rnotwhite = (/\S+/g);
	
	
	
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
		var object = optionsCache[ options ] = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		});
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			( optionsCache[ options ] || createOptions( options ) ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
			// Last fire value (for non-forgettable lists)
			memory,
			// Flag to know if list was already fired
			fired,
			// End of the loop when firing
			firingLength,
			// Index of currently firing callback (modified by remove if needed)
			firingIndex,
			// First callback to fire (used internally by add and fireWith)
			firingStart,
			// Actual callback list
			list = [],
			// Stack of fire calls for repeatable lists
			stack = !options.once && [],
			// Fire callbacks
			fire = function( data ) {
				memory = options.memory && data;
				fired = true;
				firingIndex = firingStart || 0;
				firingStart = 0;
				firingLength = list.length;
				firing = true;
				for ( ; list && firingIndex < firingLength; firingIndex++ ) {
					if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
						memory = false; // To prevent further calls using add
						break;
					}
				}
				firing = false;
				if ( list ) {
					if ( stack ) {
						if ( stack.length ) {
							fire( stack.shift() );
						}
					} else if ( memory ) {
						list = [];
					} else {
						self.disable();
					}
				}
			},
			// Actual Callbacks object
			self = {
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
						// First, we save the current length
						var start = list.length;
						(function add( args ) {
							jQuery.each( args, function( _, arg ) {
								var type = jQuery.type( arg );
								if ( type === "function" ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && type !== "string" ) {
									// Inspect recursively
									add( arg );
								}
							});
						})( arguments );
						// Do we need to add the callbacks to the
						// current firing batch?
						if ( firing ) {
							firingLength = list.length;
						// With memory, if we're not firing then
						// we should call right away
						} else if ( memory ) {
							firingStart = start;
							fire( memory );
						}
					}
					return this;
				},
				// Remove a callback from the list
				remove: function() {
					if ( list ) {
						jQuery.each( arguments, function( _, arg ) {
							var index;
							while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
								list.splice( index, 1 );
								// Handle firing indexes
								if ( firing ) {
									if ( index <= firingLength ) {
										firingLength--;
									}
									if ( index <= firingIndex ) {
										firingIndex--;
									}
								}
							}
						});
					}
					return this;
				},
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
				},
				// Remove all callbacks from the list
				empty: function() {
					list = [];
					firingLength = 0;
					return this;
				},
				// Have the list do nothing anymore
				disable: function() {
					list = stack = memory = undefined;
					return this;
				},
				// Is it disabled?
				disabled: function() {
					return !list;
				},
				// Lock the list in its current state
				lock: function() {
					stack = undefined;
					if ( !memory ) {
						self.disable();
					}
					return this;
				},
				// Is it locked?
				locked: function() {
					return !stack;
				},
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( list && ( !fired || stack ) ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						if ( firing ) {
							stack.push( args );
						} else {
							fire( args );
						}
					}
					return this;
				},
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend({
	
		Deferred: function( func ) {
			var tuples = [
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks("memory") ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred(function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[1] ](function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.done( newDefer.resolve )
											.fail( newDefer.reject )
											.progress( newDefer.notify );
									} else {
										newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
									}
								});
							});
							fns = null;
						}).promise();
					},
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[1] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(function() {
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[0] ] = function() {
					deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[0] + "With" ] = list.fireWith;
			});
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
	
						} else if ( !(--remaining) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject )
							.progress( updateFunc( i, progressContexts, progressValues ) );
					} else {
						--remaining;
					}
				}
			}
	
			// if we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	});
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend({
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
			if ( !document.body ) {
				return setTimeout( jQuery.ready );
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	});
	
	/**
	 * Clean-up method for dom ready events
	 */
	function detach() {
		if ( document.addEventListener ) {
			document.removeEventListener( "DOMContentLoaded", completed, false );
			window.removeEventListener( "load", completed, false );
	
		} else {
			document.detachEvent( "onreadystatechange", completed );
			window.detachEvent( "onload", completed );
		}
	}
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		// readyState === "complete" is good enough for us to call the dom ready in oldIE
		if ( document.addEventListener || event.type === "load" || document.readyState === "complete" ) {
			detach();
			jQuery.ready();
		}
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called after the browser event has already occurred.
			// we once tried to use readyState "interactive" here, but it caused issues like the one
			// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
			if ( document.readyState === "complete" ) {
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				setTimeout( jQuery.ready );
	
			// Standards-based browsers support DOMContentLoaded
			} else if ( document.addEventListener ) {
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed, false );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed, false );
	
			// If IE event model is used
			} else {
				// Ensure firing before onload, maybe late but safe also for iframes
				document.attachEvent( "onreadystatechange", completed );
	
				// A fallback to window.onload, that will always work
				window.attachEvent( "onload", completed );
	
				// If IE and not a frame
				// continually check to see if the document is ready
				var top = false;
	
				try {
					top = window.frameElement == null && document.documentElement;
				} catch(e) {}
	
				if ( top && top.doScroll ) {
					(function doScrollCheck() {
						if ( !jQuery.isReady ) {
	
							try {
								// Use the trick by Diego Perini
								// http://javascript.nwbox.com/IEContentLoaded/
								top.doScroll("left");
							} catch(e) {
								return setTimeout( doScrollCheck, 50 );
							}
	
							// detach all dom ready events
							detach();
	
							// and execute any waiting functions
							jQuery.ready();
						}
					})();
				}
			}
		}
		return readyList.promise( obj );
	};
	
	
	var strundefined = typeof undefined;
	
	
	
	// Support: IE<9
	// Iteration over object's inherited properties before its own
	var i;
	for ( i in jQuery( support ) ) {
		break;
	}
	support.ownLast = i !== "0";
	
	// Note: most support tests are defined in their respective modules.
	// false until the test is run
	support.inlineBlockNeedsLayout = false;
	
	// Execute ASAP in case we need to set body.style.zoom
	jQuery(function() {
		// Minified: var a,b,c,d
		var val, div, body, container;
	
		body = document.getElementsByTagName( "body" )[ 0 ];
		if ( !body || !body.style ) {
			// Return for frameset docs that don't have a body
			return;
		}
	
		// Setup
		div = document.createElement( "div" );
		container = document.createElement( "div" );
		container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
		body.appendChild( container ).appendChild( div );
	
		if ( typeof div.style.zoom !== strundefined ) {
			// Support: IE<8
			// Check if natively block-level elements act like inline-block
			// elements when setting their display to 'inline' and giving
			// them layout
			div.style.cssText = "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1";
	
			support.inlineBlockNeedsLayout = val = div.offsetWidth === 3;
			if ( val ) {
				// Prevent IE 6 from affecting layout for positioned elements #11048
				// Prevent IE from shrinking the body in IE 7 mode #12869
				// Support: IE<8
				body.style.zoom = 1;
			}
		}
	
		body.removeChild( container );
	});
	
	
	
	
	(function() {
		var div = document.createElement( "div" );
	
		// Execute the test only if not already executed in another module.
		if (support.deleteExpando == null) {
			// Support: IE<9
			support.deleteExpando = true;
			try {
				delete div.test;
			} catch( e ) {
				support.deleteExpando = false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	})();
	
	
	/**
	 * Determines whether an object can have data
	 */
	jQuery.acceptData = function( elem ) {
		var noData = jQuery.noData[ (elem.nodeName + " ").toLowerCase() ],
			nodeType = +elem.nodeType || 1;
	
		// Do not set data on non-element DOM nodes because it will not be cleared (#8335).
		return nodeType !== 1 && nodeType !== 9 ?
			false :
	
			// Nodes accept data unless otherwise specified; rejection can be conditional
			!noData || noData !== true && elem.getAttribute("classid") === noData;
	};
	
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /([A-Z])/g;
	
	function dataAttr( elem, key, data ) {
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
	
			var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch( e ) {}
	
				// Make sure we set the data so it isn't changed later
				jQuery.data( elem, key, data );
	
			} else {
				data = undefined;
			}
		}
	
		return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
		var name;
		for ( name in obj ) {
	
			// if the public data object is empty, the private is still empty
			if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
				continue;
			}
			if ( name !== "toJSON" ) {
				return false;
			}
		}
	
		return true;
	}
	
	function internalData( elem, name, data, pvt /* Internal Use Only */ ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}
	
		var ret, thisCache,
			internalKey = jQuery.expando,
	
			// We have to handle DOM nodes and JS objects differently because IE6-7
			// can't GC object references properly across the DOM-JS boundary
			isNode = elem.nodeType,
	
			// Only DOM nodes need the global jQuery cache; JS object data is
			// attached directly to the object so GC can occur automatically
			cache = isNode ? jQuery.cache : elem,
	
			// Only defining an ID for JS objects if its cache already exists allows
			// the code to shortcut on the same path as a DOM node with no cache
			id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
		// Avoid doing any more work than we need to when trying to get data on an
		// object that has no data at all
		if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && data === undefined && typeof name === "string" ) {
			return;
		}
	
		if ( !id ) {
			// Only DOM nodes need a new unique ID for each element since their data
			// ends up in the global cache
			if ( isNode ) {
				id = elem[ internalKey ] = deletedIds.pop() || jQuery.guid++;
			} else {
				id = internalKey;
			}
		}
	
		if ( !cache[ id ] ) {
			// Avoid exposing jQuery metadata on plain JS objects when the object
			// is serialized using JSON.stringify
			cache[ id ] = isNode ? {} : { toJSON: jQuery.noop };
		}
	
		// An object can be passed to jQuery.data instead of a key/value pair; this gets
		// shallow copied over onto the existing cache
		if ( typeof name === "object" || typeof name === "function" ) {
			if ( pvt ) {
				cache[ id ] = jQuery.extend( cache[ id ], name );
			} else {
				cache[ id ].data = jQuery.extend( cache[ id ].data, name );
			}
		}
	
		thisCache = cache[ id ];
	
		// jQuery data() is stored in a separate object inside the object's internal data
		// cache in order to avoid key collisions between internal data and user-defined
		// data.
		if ( !pvt ) {
			if ( !thisCache.data ) {
				thisCache.data = {};
			}
	
			thisCache = thisCache.data;
		}
	
		if ( data !== undefined ) {
			thisCache[ jQuery.camelCase( name ) ] = data;
		}
	
		// Check for both converted-to-camel and non-converted data property names
		// If a data property was specified
		if ( typeof name === "string" ) {
	
			// First Try to find as-is property data
			ret = thisCache[ name ];
	
			// Test for null|undefined property data
			if ( ret == null ) {
	
				// Try to find the camelCased property
				ret = thisCache[ jQuery.camelCase( name ) ];
			}
		} else {
			ret = thisCache;
		}
	
		return ret;
	}
	
	function internalRemoveData( elem, name, pvt ) {
		if ( !jQuery.acceptData( elem ) ) {
			return;
		}
	
		var thisCache, i,
			isNode = elem.nodeType,
	
			// See jQuery.data for more information
			cache = isNode ? jQuery.cache : elem,
			id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
		// If there is already no cache entry for this object, there is no
		// purpose in continuing
		if ( !cache[ id ] ) {
			return;
		}
	
		if ( name ) {
	
			thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
			if ( thisCache ) {
	
				// Support array or space separated string names for data keys
				if ( !jQuery.isArray( name ) ) {
	
					// try the string as a key before any manipulation
					if ( name in thisCache ) {
						name = [ name ];
					} else {
	
						// split the camel cased version by spaces unless a key with the spaces exists
						name = jQuery.camelCase( name );
						if ( name in thisCache ) {
							name = [ name ];
						} else {
							name = name.split(" ");
						}
					}
				} else {
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = name.concat( jQuery.map( name, jQuery.camelCase ) );
				}
	
				i = name.length;
				while ( i-- ) {
					delete thisCache[ name[i] ];
				}
	
				// If there is no data left in the cache, we want to continue
				// and let the cache object itself get destroyed
				if ( pvt ? !isEmptyDataObject(thisCache) : !jQuery.isEmptyObject(thisCache) ) {
					return;
				}
			}
		}
	
		// See jQuery.data for more information
		if ( !pvt ) {
			delete cache[ id ].data;
	
			// Don't destroy the parent cache unless the internal data object
			// had been the only thing left in it
			if ( !isEmptyDataObject( cache[ id ] ) ) {
				return;
			}
		}
	
		// Destroy the cache
		if ( isNode ) {
			jQuery.cleanData( [ elem ], true );
	
		// Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
		/* jshint eqeqeq: false */
		} else if ( support.deleteExpando || cache != cache.window ) {
			/* jshint eqeqeq: true */
			delete cache[ id ];
	
		// When all else fails, null
		} else {
			cache[ id ] = null;
		}
	}
	
	jQuery.extend({
		cache: {},
	
		// The following elements (space-suffixed to avoid Object.prototype collisions)
		// throw uncatchable exceptions if you attempt to set expando properties
		noData: {
			"applet ": true,
			"embed ": true,
			// ...but Flash objects (which have this classid) *can* handle expandos
			"object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"
		},
	
		hasData: function( elem ) {
			elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
			return !!elem && !isEmptyDataObject( elem );
		},
	
		data: function( elem, name, data ) {
			return internalData( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			return internalRemoveData( elem, name );
		},
	
		// For internal use only.
		_data: function( elem, name, data ) {
			return internalData( elem, name, data, true );
		},
	
		_removeData: function( elem, name ) {
			return internalRemoveData( elem, name, true );
		}
	});
	
	jQuery.fn.extend({
		data: function( key, value ) {
			var i, name, data,
				elem = this[0],
				attrs = elem && elem.attributes;
	
			// Special expections of .data basically thwart jQuery.access,
			// so implement the relevant behavior ourselves
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = jQuery.data( elem );
	
					if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice(5) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						jQuery._data( elem, "parsedAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each(function() {
					jQuery.data( this, key );
				});
			}
	
			return arguments.length > 1 ?
	
				// Sets one value
				this.each(function() {
					jQuery.data( this, key, value );
				}) :
	
				// Gets one value
				// Try to fetch any internally stored data first
				elem ? dataAttr( elem, key, jQuery.data( elem, key ) ) : undefined;
		},
	
		removeData: function( key ) {
			return this.each(function() {
				jQuery.removeData( this, key );
			});
		}
	});
	
	
	jQuery.extend({
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = jQuery._data( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray(data) ) {
						queue = jQuery._data( elem, type, jQuery.makeArray(data) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// not intended for public consumption - generates a queueHooks object, or returns the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return jQuery._data( elem, key ) || jQuery._data( elem, key, {
				empty: jQuery.Callbacks("once memory").add(function() {
					jQuery._removeData( elem, type + "queue" );
					jQuery._removeData( elem, key );
				})
			});
		}
	});
	
	jQuery.fn.extend({
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[0], type );
			}
	
			return data === undefined ?
				this :
				this.each(function() {
					var queue = jQuery.queue( this, type, data );
	
					// ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[0] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				});
		},
		dequeue: function( type ) {
			return this.each(function() {
				jQuery.dequeue( this, type );
			});
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = jQuery._data( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	});
	var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			length = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < length; i++ ) {
					fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				length ? fn( elems[0], key ) : emptyGet;
	};
	var rcheckableType = (/^(?:checkbox|radio)$/i);
	
	
	
	(function() {
		// Minified: var a,b,c
		var input = document.createElement( "input" ),
			div = document.createElement( "div" ),
			fragment = document.createDocumentFragment();
	
		// Setup
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
		// IE strips leading whitespace when .innerHTML is used
		support.leadingWhitespace = div.firstChild.nodeType === 3;
	
		// Make sure that tbody elements aren't automatically inserted
		// IE will insert them into empty tables
		support.tbody = !div.getElementsByTagName( "tbody" ).length;
	
		// Make sure that link elements get serialized correctly by innerHTML
		// This requires a wrapper element in IE
		support.htmlSerialize = !!div.getElementsByTagName( "link" ).length;
	
		// Makes sure cloning an html5 element does not cause problems
		// Where outerHTML is undefined, this still works
		support.html5Clone =
			document.createElement( "nav" ).cloneNode( true ).outerHTML !== "<:nav></:nav>";
	
		// Check if a disconnected checkbox will retain its checked
		// value of true after appended to the DOM (IE6/7)
		input.type = "checkbox";
		input.checked = true;
		fragment.appendChild( input );
		support.appendChecked = input.checked;
	
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		// Support: IE6-IE11+
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// #11217 - WebKit loses check when the name is after the checked attribute
		fragment.appendChild( div );
		div.innerHTML = "<input type='radio' checked='checked' name='t'/>";
	
		// Support: Safari 5.1, iOS 5.1, Android 4.x, Android 2.3
		// old WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<9
		// Opera does not clone events (and typeof div.attachEvent === undefined).
		// IE9-10 clones events bound via attachEvent, but they don't trigger with .click()
		support.noCloneEvent = true;
		if ( div.attachEvent ) {
			div.attachEvent( "onclick", function() {
				support.noCloneEvent = false;
			});
	
			div.cloneNode( true ).click();
		}
	
		// Execute the test only if not already executed in another module.
		if (support.deleteExpando == null) {
			// Support: IE<9
			support.deleteExpando = true;
			try {
				delete div.test;
			} catch( e ) {
				support.deleteExpando = false;
			}
		}
	})();
	
	
	(function() {
		var i, eventName,
			div = document.createElement( "div" );
	
		// Support: IE<9 (lack submit/change bubble), Firefox 23+ (lack focusin event)
		for ( i in { submit: true, change: true, focusin: true }) {
			eventName = "on" + i;
	
			if ( !(support[ i + "Bubbles" ] = eventName in window) ) {
				// Beware of CSP restrictions (https://developer.mozilla.org/en/Security/CSP)
				div.setAttribute( eventName, "t" );
				support[ i + "Bubbles" ] = div.attributes[ eventName ].expando === false;
			}
		}
	
		// Null elements to avoid leaks in IE.
		div = null;
	})();
	
	
	var rformElems = /^(?:input|select|textarea)$/i,
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
		rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
			var tmp, events, t, handleObjIn,
				special, eventHandle, handleObj,
				handlers, type, namespaces, origType,
				elemData = jQuery._data( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !(events = elemData.events) ) {
				events = elemData.events = {};
			}
			if ( !(eventHandle = elemData.handle) ) {
				eventHandle = elemData.handle = function( e ) {
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== strundefined && (!e || jQuery.event.triggered !== e.type) ?
						jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
						undefined;
				};
				// Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
				eventHandle.elem = elem;
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join(".")
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !(handlers = events[ type ]) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener/attachEvent if the special events handler returns false
					if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
						// Bind the global event handler to the element
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle, false );
	
						} else if ( elem.attachEvent ) {
							elem.attachEvent( "on" + type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
			// Nullify elem to prevent memory leaks in IE
			elem = null;
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
			var j, handleObj, tmp,
				origCount, t, events,
				special, handlers, type,
				namespaces, origType,
				elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
			if ( !elemData || !(events = elemData.events) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[t] ) || [];
				type = origType = tmp[1];
				namespaces = ( tmp[2] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				delete elemData.handle;
	
				// removeData also checks for emptiness and clears the expando if empty
				// so use it instead of delete
				jQuery._removeData( elem, "events" );
			}
		},
	
		trigger: function( event, data, elem, onlyHandlers ) {
			var handle, ontype, cur,
				bubbleType, special, tmp, i,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf(".") >= 0 ) {
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.namespace_re = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === (elem.ownerDocument || document) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
					jQuery.acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Can't use an .isFunction() check here because IE6/7 fails that test.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && elem[ type ] && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						try {
							elem[ type ]();
						} catch ( e ) {
							// IE<9 dies on focus/blur to hidden element (#1486,#12518)
							// only reproducible on winXP IE8 native, not IE9 in IE8 mode
						}
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, ret, handleObj, matched, j,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( jQuery._data( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or
					// 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
								.apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( (event.result = ret) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var sel, handleObj, matches, i,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			// Avoid non-left-click bubbling in Firefox (#3861)
			if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {
	
				/* jshint eqeqeq: false */
				for ( ; cur != this; cur = cur.parentNode || this ) {
					/* jshint eqeqeq: true */
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && (cur.disabled !== true || event.type !== "click") ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) >= 0 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push({ elem: cur, handlers: matches });
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
			}
	
			return handlerQueue;
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: IE<9
			// Fix target property (#1925)
			if ( !event.target ) {
				event.target = originalEvent.srcElement || document;
			}
	
			// Support: Chrome 23+, Safari?
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			// Support: IE<9
			// For mouse/key events, metaKey==false if it's undefined (#3368, #11328)
			event.metaKey = !!event.metaKey;
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split(" "),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
			filter: function( event, original ) {
				var body, eventDoc, doc,
					button = original.button,
					fromElement = original.fromElement;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add relatedTarget, if necessary
				if ( !event.relatedTarget && fromElement ) {
					event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		special: {
			load: {
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						try {
							this.focus();
							return false;
						} catch ( e ) {
							// Support: IE<9
							// If we error on focus to hidden element (#1486, #12518),
							// let .trigger() run the handlers
						}
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( jQuery.nodeName( this, "input" ) && this.type === "checkbox" && this.click ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		},
	
		simulate: function( type, elem, event, bubble ) {
			// Piggyback on a donor event to simulate a different one.
			// Fake originalEvent to avoid donor's stopPropagation, but if the
			// simulated event prevents default then we do the same on the donor.
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true,
					originalEvent: {}
				}
			);
			if ( bubble ) {
				jQuery.event.trigger( e, null, elem );
			} else {
				jQuery.event.dispatch.call( elem, e );
			}
			if ( e.isDefaultPrevented() ) {
				event.preventDefault();
			}
		}
	};
	
	jQuery.removeEvent = document.removeEventListener ?
		function( elem, type, handle ) {
			if ( elem.removeEventListener ) {
				elem.removeEventListener( type, handle, false );
			}
		} :
		function( elem, type, handle ) {
			var name = "on" + type;
	
			if ( elem.detachEvent ) {
	
				// #8545, #7054, preventing memory leaks for custom events in IE6-8
				// detachEvent needed property on element, by name of that event, to properly expose it to GC
				if ( typeof elem[ name ] === strundefined ) {
					elem[ name ] = null;
				}
	
				elem.detachEvent( name, handle );
			}
		};
	
	jQuery.Event = function( src, props ) {
		// Allow instantiation without the 'new' keyword
		if ( !(this instanceof jQuery.Event) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
					// Support: IE < 9, Android < 4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
			if ( !e ) {
				return;
			}
	
			// If preventDefault exists, run it on the original event
			if ( e.preventDefault ) {
				e.preventDefault();
	
			// Support: IE
			// Otherwise set the returnValue property of the original event to false
			} else {
				e.returnValue = false;
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
			if ( !e ) {
				return;
			}
			// If stopPropagation exists, run it on the original event
			if ( e.stopPropagation ) {
				e.stopPropagation();
			}
	
			// Support: IE
			// Set the cancelBubble property of the original event to true
			e.cancelBubble = true;
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && e.stopImmediatePropagation ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mousenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	});
	
	// IE submit delegation
	if ( !support.submitBubbles ) {
	
		jQuery.event.special.submit = {
			setup: function() {
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Lazy-add a submit handler when a descendant form may potentially be submitted
				jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
					// Node name check avoids a VML-related crash in IE (#9807)
					var elem = e.target,
						form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
					if ( form && !jQuery._data( form, "submitBubbles" ) ) {
						jQuery.event.add( form, "submit._submit", function( event ) {
							event._submit_bubble = true;
						});
						jQuery._data( form, "submitBubbles", true );
					}
				});
				// return undefined since we don't need an event listener
			},
	
			postDispatch: function( event ) {
				// If form was submitted by the user, bubble the event up the tree
				if ( event._submit_bubble ) {
					delete event._submit_bubble;
					if ( this.parentNode && !event.isTrigger ) {
						jQuery.event.simulate( "submit", this.parentNode, event, true );
					}
				}
			},
	
			teardown: function() {
				// Only need this for delegated form submit events
				if ( jQuery.nodeName( this, "form" ) ) {
					return false;
				}
	
				// Remove delegated handlers; cleanData eventually reaps submit handlers attached above
				jQuery.event.remove( this, "._submit" );
			}
		};
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !support.changeBubbles ) {
	
		jQuery.event.special.change = {
	
			setup: function() {
	
				if ( rformElems.test( this.nodeName ) ) {
					// IE doesn't fire change on a check/radio until blur; trigger it on click
					// after a propertychange. Eat the blur-change in special.change.handle.
					// This still fires onchange a second time for check/radio after blur.
					if ( this.type === "checkbox" || this.type === "radio" ) {
						jQuery.event.add( this, "propertychange._change", function( event ) {
							if ( event.originalEvent.propertyName === "checked" ) {
								this._just_changed = true;
							}
						});
						jQuery.event.add( this, "click._change", function( event ) {
							if ( this._just_changed && !event.isTrigger ) {
								this._just_changed = false;
							}
							// Allow triggered, simulated change events (#11500)
							jQuery.event.simulate( "change", this, event, true );
						});
					}
					return false;
				}
				// Delegated event; lazy-add a change handler on descendant inputs
				jQuery.event.add( this, "beforeactivate._change", function( e ) {
					var elem = e.target;
	
					if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "changeBubbles" ) ) {
						jQuery.event.add( elem, "change._change", function( event ) {
							if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
								jQuery.event.simulate( "change", this.parentNode, event, true );
							}
						});
						jQuery._data( elem, "changeBubbles", true );
					}
				});
			},
	
			handle: function( event ) {
				var elem = event.target;
	
				// Swallow native change events from checkbox/radio, we already triggered them above
				if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
					return event.handleObj.handler.apply( this, arguments );
				}
			},
	
			teardown: function() {
				jQuery.event.remove( this, "._change" );
	
				return !rformElems.test( this.nodeName );
			}
		};
	}
	
	// Create "bubbling" focus and blur events
	if ( !support.focusinBubbles ) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
					jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
				};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					jQuery._data( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = jQuery._data( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						jQuery._removeData( doc, fix );
					} else {
						jQuery._data( doc, fix, attaches );
					}
				}
			};
		});
	}
	
	jQuery.fn.extend({
	
		on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
			var type, origFn;
	
			// Types can be a map of types/handlers
			if ( typeof types === "object" ) {
				// ( types-Object, selector, data )
				if ( typeof selector !== "string" ) {
					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for ( type in types ) {
					this.on( type, selector, data, types[ type ], one );
				}
				return this;
			}
	
			if ( data == null && fn == null ) {
				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if ( fn == null ) {
				if ( typeof selector === "string" ) {
					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {
					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if ( fn === false ) {
				fn = returnFalse;
			} else if ( !fn ) {
				return this;
			}
	
			if ( one === 1 ) {
				origFn = fn;
				fn = function( event ) {
					// Can use an empty set, since event contains the info
					jQuery().off( event );
					return origFn.apply( this, arguments );
				};
				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
			}
			return this.each( function() {
				jQuery.event.add( this, types, fn, data, selector );
			});
		},
		one: function( types, selector, data, fn ) {
			return this.on( types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each(function() {
				jQuery.event.remove( this, types, fn, selector );
			});
		},
	
		trigger: function( type, data ) {
			return this.each(function() {
				jQuery.event.trigger( type, data, this );
			});
		},
		triggerHandler: function( type, data ) {
			var elem = this[0];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	});
	
	
	function createSafeFragment( document ) {
		var list = nodeNames.split( "|" ),
			safeFrag = document.createDocumentFragment();
	
		if ( safeFrag.createElement ) {
			while ( list.length ) {
				safeFrag.createElement(
					list.pop()
				);
			}
		}
		return safeFrag;
	}
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
			"header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
		rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
		rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
		rleadingWhitespace = /^\s+/,
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
		rtagName = /<([\w:]+)/,
		rtbody = /<tbody/i,
		rhtml = /<|&#?\w+;/,
		rnoInnerhtml = /<(?:script|style|link)/i,
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptType = /^$|\/(?:java|ecma)script/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	
		// We have to close these tags to support XHTML (#13200)
		wrapMap = {
			option: [ 1, "<select multiple='multiple'>", "</select>" ],
			legend: [ 1, "<fieldset>", "</fieldset>" ],
			area: [ 1, "<map>", "</map>" ],
			param: [ 1, "<object>", "</object>" ],
			thead: [ 1, "<table>", "</table>" ],
			tr: [ 2, "<table><tbody>", "</tbody></table>" ],
			col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
			td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
			// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
			// unless wrapped in a div with non-breaking characters in front of it.
			_default: support.htmlSerialize ? [ 0, "", "" ] : [ 1, "X<div>", "</div>"  ]
		},
		safeFragment = createSafeFragment( document ),
		fragmentDiv = safeFragment.appendChild( document.createElement("div") );
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	function getAll( context, tag ) {
		var elems, elem,
			i = 0,
			found = typeof context.getElementsByTagName !== strundefined ? context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== strundefined ? context.querySelectorAll( tag || "*" ) :
				undefined;
	
		if ( !found ) {
			for ( found = [], elems = context.childNodes || context; (elem = elems[i]) != null; i++ ) {
				if ( !tag || jQuery.nodeName( elem, tag ) ) {
					found.push( elem );
				} else {
					jQuery.merge( found, getAll( elem, tag ) );
				}
			}
		}
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], found ) :
			found;
	}
	
	// Used in buildFragment, fixes the defaultChecked property
	function fixDefaultChecked( elem ) {
		if ( rcheckableType.test( elem.type ) ) {
			elem.defaultChecked = elem.checked;
		}
	}
	
	// Support: IE<8
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName("tbody")[0] ||
				elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = (jQuery.find.attr( elem, "type" ) !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
		if ( match ) {
			elem.type = match[1];
		} else {
			elem.removeAttribute("type");
		}
		return elem;
	}
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var elem,
			i = 0;
		for ( ; (elem = elems[i]) != null; i++ ) {
			jQuery._data( elem, "globalEval", !refElements || jQuery._data( refElements[i], "globalEval" ) );
		}
	}
	
	function cloneCopyEvent( src, dest ) {
	
		if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
			return;
		}
	
		var type, i, l,
			oldData = jQuery._data( src ),
			curData = jQuery._data( dest, oldData ),
			events = oldData.events;
	
		if ( events ) {
			delete curData.handle;
			curData.events = {};
	
			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	
		// make the cloned public data object a copy from the original
		if ( curData.data ) {
			curData.data = jQuery.extend( {}, curData.data );
		}
	}
	
	function fixCloneNodeIssues( src, dest ) {
		var nodeName, e, data;
	
		// We do not need to do anything for non-Elements
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		nodeName = dest.nodeName.toLowerCase();
	
		// IE6-8 copies events bound via attachEvent when using cloneNode.
		if ( !support.noCloneEvent && dest[ jQuery.expando ] ) {
			data = jQuery._data( dest );
	
			for ( e in data.events ) {
				jQuery.removeEvent( dest, e, data.handle );
			}
	
			// Event data gets referenced instead of copied if the expando gets copied too
			dest.removeAttribute( jQuery.expando );
		}
	
		// IE blanks contents when cloning scripts, and tries to evaluate newly-set text
		if ( nodeName === "script" && dest.text !== src.text ) {
			disableScript( dest ).text = src.text;
			restoreScript( dest );
	
		// IE6-10 improperly clones children of object elements using classid.
		// IE10 throws NoModificationAllowedError if parent is null, #12132.
		} else if ( nodeName === "object" ) {
			if ( dest.parentNode ) {
				dest.outerHTML = src.outerHTML;
			}
	
			// This path appears unavoidable for IE9. When cloning an object
			// element in IE9, the outerHTML strategy above is not sufficient.
			// If the src has innerHTML and the destination does not,
			// copy the src.innerHTML into the dest.innerHTML. #10324
			if ( support.html5Clone && ( src.innerHTML && !jQuery.trim(dest.innerHTML) ) ) {
				dest.innerHTML = src.innerHTML;
			}
	
		} else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			// IE6-8 fails to persist the checked state of a cloned checkbox
			// or radio button. Worse, IE6-7 fail to give the cloned element
			// a checked appearance if the defaultChecked value isn't also set
	
			dest.defaultChecked = dest.checked = src.checked;
	
			// IE6-7 get confused and end up setting the value of a cloned
			// checkbox/radio button to an empty string instead of "on"
			if ( dest.value !== src.value ) {
				dest.value = src.value;
			}
	
		// IE6-8 fails to return the selected option to the default selected
		// state when cloning options
		} else if ( nodeName === "option" ) {
			dest.defaultSelected = dest.selected = src.defaultSelected;
	
		// IE6-8 fails to set the defaultValue to the correct value when
		// cloning other types of input fields
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	jQuery.extend({
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var destElements, node, clone, i, srcElements,
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			if ( support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
				clone = elem.cloneNode( true );
	
			// IE<=8 does not properly clone detached, unknown element nodes
			} else {
				fragmentDiv.innerHTML = elem.outerHTML;
				fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
			}
	
			if ( (!support.noCloneEvent || !support.noCloneChecked) &&
					(elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				// Fix all IE cloning issues
				for ( i = 0; (node = srcElements[i]) != null; ++i ) {
					// Ensure that the destination node is not null; Fixes #9587
					if ( destElements[i] ) {
						fixCloneNodeIssues( node, destElements[i] );
					}
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0; (node = srcElements[i]) != null; i++ ) {
						cloneCopyEvent( node, destElements[i] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			destElements = srcElements = node = null;
	
			// Return the cloned set
			return clone;
		},
	
		buildFragment: function( elems, context, scripts, selection ) {
			var j, elem, contains,
				tmp, tag, tbody, wrap,
				l = elems.length,
	
				// Ensure a safe fragment
				safe = createSafeFragment( context ),
	
				nodes = [],
				i = 0;
	
			for ( ; i < l; i++ ) {
				elem = elems[ i ];
	
				if ( elem || elem === 0 ) {
	
					// Add nodes directly
					if ( jQuery.type( elem ) === "object" ) {
						jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
					// Convert non-html into a text node
					} else if ( !rhtml.test( elem ) ) {
						nodes.push( context.createTextNode( elem ) );
	
					// Convert html into DOM nodes
					} else {
						tmp = tmp || safe.appendChild( context.createElement("div") );
	
						// Deserialize a standard representation
						tag = (rtagName.exec( elem ) || [ "", "" ])[ 1 ].toLowerCase();
						wrap = wrapMap[ tag ] || wrapMap._default;
	
						tmp.innerHTML = wrap[1] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[2];
	
						// Descend through wrappers to the right content
						j = wrap[0];
						while ( j-- ) {
							tmp = tmp.lastChild;
						}
	
						// Manually add leading whitespace removed by IE
						if ( !support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
							nodes.push( context.createTextNode( rleadingWhitespace.exec( elem )[0] ) );
						}
	
						// Remove IE's autoinserted <tbody> from table fragments
						if ( !support.tbody ) {
	
							// String was a <table>, *may* have spurious <tbody>
							elem = tag === "table" && !rtbody.test( elem ) ?
								tmp.firstChild :
	
								// String was a bare <thead> or <tfoot>
								wrap[1] === "<table>" && !rtbody.test( elem ) ?
									tmp :
									0;
	
							j = elem && elem.childNodes.length;
							while ( j-- ) {
								if ( jQuery.nodeName( (tbody = elem.childNodes[j]), "tbody" ) && !tbody.childNodes.length ) {
									elem.removeChild( tbody );
								}
							}
						}
	
						jQuery.merge( nodes, tmp.childNodes );
	
						// Fix #12392 for WebKit and IE > 9
						tmp.textContent = "";
	
						// Fix #12392 for oldIE
						while ( tmp.firstChild ) {
							tmp.removeChild( tmp.firstChild );
						}
	
						// Remember the top-level container for proper cleanup
						tmp = safe.lastChild;
					}
				}
			}
	
			// Fix #11356: Clear elements from fragment
			if ( tmp ) {
				safe.removeChild( tmp );
			}
	
			// Reset defaultChecked for any radios and checkboxes
			// about to be appended to the DOM in IE 6/7 (#8060)
			if ( !support.appendChecked ) {
				jQuery.grep( getAll( nodes, "input" ), fixDefaultChecked );
			}
	
			i = 0;
			while ( (elem = nodes[ i++ ]) ) {
	
				// #4087 - If origin and destination elements are the same, and this is
				// that element, do not do anything
				if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
					continue;
				}
	
				contains = jQuery.contains( elem.ownerDocument, elem );
	
				// Append to fragment
				tmp = getAll( safe.appendChild( elem ), "script" );
	
				// Preserve script evaluation history
				if ( contains ) {
					setGlobalEval( tmp );
				}
	
				// Capture executables
				if ( scripts ) {
					j = 0;
					while ( (elem = tmp[ j++ ]) ) {
						if ( rscriptType.test( elem.type || "" ) ) {
							scripts.push( elem );
						}
					}
				}
			}
	
			tmp = null;
	
			return safe;
		},
	
		cleanData: function( elems, /* internal */ acceptData ) {
			var elem, type, id, data,
				i = 0,
				internalKey = jQuery.expando,
				cache = jQuery.cache,
				deleteExpando = support.deleteExpando,
				special = jQuery.event.special;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
				if ( acceptData || jQuery.acceptData( elem ) ) {
	
					id = elem[ internalKey ];
					data = id && cache[ id ];
	
					if ( data ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Remove cache only if it was not already removed by jQuery.event.remove
						if ( cache[ id ] ) {
	
							delete cache[ id ];
	
							// IE does not allow us to delete expando properties from nodes,
							// nor does it have a removeAttribute function on Document nodes;
							// we must handle all of these cases
							if ( deleteExpando ) {
								delete elem[ internalKey ];
	
							} else if ( typeof elem.removeAttribute !== strundefined ) {
								elem.removeAttribute( internalKey );
	
							} else {
								elem[ internalKey ] = null;
							}
	
							deletedIds.push( id );
						}
					}
				}
			}
		}
	});
	
	jQuery.fn.extend({
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			});
		},
	
		prepend: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			});
		},
	
		before: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			});
		},
	
		after: function() {
			return this.domManip( arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			});
		},
	
		remove: function( selector, keepData /* Internal Use Only */ ) {
			var elem,
				elems = selector ? jQuery.filter( selector, this ) : this,
				i = 0;
	
			for ( ; (elem = elems[i]) != null; i++ ) {
	
				if ( !keepData && elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem ) );
				}
	
				if ( elem.parentNode ) {
					if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
						setGlobalEval( getAll( elem, "script" ) );
					}
					elem.parentNode.removeChild( elem );
				}
			}
	
			return this;
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; (elem = this[i]) != null; i++ ) {
				// Remove element nodes and prevent memory leaks
				if ( elem.nodeType === 1 ) {
					jQuery.cleanData( getAll( elem, false ) );
				}
	
				// Remove any remaining nodes
				while ( elem.firstChild ) {
					elem.removeChild( elem.firstChild );
				}
	
				// If this is a select, ensure that it displays empty (#12336)
				// Support: IE<9
				if ( elem.options && jQuery.nodeName( elem, "select" ) ) {
					elem.options.length = 0;
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map(function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			});
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined ) {
					return elem.nodeType === 1 ?
						elem.innerHTML.replace( rinlinejQuery, "" ) :
						undefined;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					( support.htmlSerialize || !rnoshimcache.test( value )  ) &&
					( support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
					!wrapMap[ (rtagName.exec( value ) || [ "", "" ])[ 1 ].toLowerCase() ] ) {
	
					value = value.replace( rxhtmlTag, "<$1></$2>" );
	
					try {
						for (; i < l; i++ ) {
							// Remove element nodes and prevent memory leaks
							elem = this[i] || {};
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch(e) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var arg = arguments[ 0 ];
	
			// Make the changes, replacing each context element with the new content
			this.domManip( arguments, function( elem ) {
				arg = this.parentNode;
	
				jQuery.cleanData( getAll( this ) );
	
				if ( arg ) {
					arg.replaceChild( elem, this );
				}
			});
	
			// Force removal if there was no new content (e.g., from empty arguments)
			return arg && (arg.length || arg.nodeType) ? this : this.remove();
		},
	
		detach: function( selector ) {
			return this.remove( selector, true );
		},
	
		domManip: function( args, callback ) {
	
			// Flatten any nested arrays
			args = concat.apply( [], args );
	
			var first, node, hasScripts,
				scripts, doc, fragment,
				i = 0,
				l = this.length,
				set = this,
				iNoClone = l - 1,
				value = args[0],
				isFunction = jQuery.isFunction( value );
	
			// We can't cloneNode fragments that contain checked, in WebKit
			if ( isFunction ||
					( l > 1 && typeof value === "string" &&
						!support.checkClone && rchecked.test( value ) ) ) {
				return this.each(function( index ) {
					var self = set.eq( index );
					if ( isFunction ) {
						args[0] = value.call( this, index, self.html() );
					}
					self.domManip( args, callback );
				});
			}
	
			if ( l ) {
				fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
				first = fragment.firstChild;
	
				if ( fragment.childNodes.length === 1 ) {
					fragment = first;
				}
	
				if ( first ) {
					scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
					hasScripts = scripts.length;
	
					// Use the original fragment for the last item instead of the first because it can end up
					// being emptied incorrectly in certain situations (#8070).
					for ( ; i < l; i++ ) {
						node = fragment;
	
						if ( i !== iNoClone ) {
							node = jQuery.clone( node, true, true );
	
							// Keep references to cloned scripts for later restoration
							if ( hasScripts ) {
								jQuery.merge( scripts, getAll( node, "script" ) );
							}
						}
	
						callback.call( this[i], node, i );
					}
	
					if ( hasScripts ) {
						doc = scripts[ scripts.length - 1 ].ownerDocument;
	
						// Reenable scripts
						jQuery.map( scripts, restoreScript );
	
						// Evaluate executable scripts on first document insertion
						for ( i = 0; i < hasScripts; i++ ) {
							node = scripts[ i ];
							if ( rscriptType.test( node.type || "" ) &&
								!jQuery._data( node, "globalEval" ) && jQuery.contains( doc, node ) ) {
	
								if ( node.src ) {
									// Optional AJAX dependency, but won't run scripts if not present
									if ( jQuery._evalUrl ) {
										jQuery._evalUrl( node.src );
									}
								} else {
									jQuery.globalEval( ( node.text || node.textContent || node.innerHTML || "" ).replace( rcleanScript, "" ) );
								}
							}
						}
					}
	
					// Fix #11809: Avoid leaking memory
					fragment = first = null;
				}
			}
	
			return this;
		}
	});
	
	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				i = 0,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone(true);
				jQuery( insert[i] )[ original ]( elems );
	
				// Modern browsers can apply jQuery collections as arrays, but oldIE needs a .get()
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	});
	
	
	var iframe,
		elemdisplay = {};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var style,
			elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			// getDefaultComputedStyle might be reliably used only on attached element
			display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?
	
				// Use of this method is a temporary fix (more like optmization) until something better comes along,
				// since it was removed from specification and supported only in FF
				style.display : jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = ( iframe[ 0 ].contentWindow || iframe[ 0 ].contentDocument ).document;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	
	
	(function() {
		var shrinkWrapBlocksVal;
	
		support.shrinkWrapBlocks = function() {
			if ( shrinkWrapBlocksVal != null ) {
				return shrinkWrapBlocksVal;
			}
	
			// Will be changed later if needed.
			shrinkWrapBlocksVal = false;
	
			// Minified: var b,c,d
			var div, body, container;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			// Support: IE6
			// Check if elements with layout shrink-wrap their children
			if ( typeof div.style.zoom !== strundefined ) {
				// Reset CSS: box-sizing; display; margin; border
				div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;" +
					"padding:1px;width:1px;zoom:1";
				div.appendChild( document.createElement( "div" ) ).style.width = "5px";
				shrinkWrapBlocksVal = div.offsetWidth !== 3;
			}
	
			body.removeChild( container );
	
			return shrinkWrapBlocksVal;
		};
	
	})();
	var rmargin = (/^margin/);
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	
	
	var getStyles, curCSS,
		rposition = /^(top|right|bottom|left)$/;
	
	if ( window.getComputedStyle ) {
		getStyles = function( elem ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		};
	
		curCSS = function( elem, name, computed ) {
			var width, minWidth, maxWidth, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
	
			// getPropertyValue is only needed for .css('filter') in IE9, see #12537
			ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
			if ( computed ) {
	
				if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
					ret = jQuery.style( elem, name );
				}
	
				// A tribute to the "awesome hack by Dean Edwards"
				// Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
				// Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
				// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
				if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;
	
					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;
	
					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "";
		};
	} else if ( document.documentElement.currentStyle ) {
		getStyles = function( elem ) {
			return elem.currentStyle;
		};
	
		curCSS = function( elem, name, computed ) {
			var left, rs, rsLeft, ret,
				style = elem.style;
	
			computed = computed || getStyles( elem );
			ret = computed ? computed[ name ] : undefined;
	
			// Avoid setting ret to empty string here
			// so we don't default to auto
			if ( ret == null && style && style[ name ] ) {
				ret = style[ name ];
			}
	
			// From the awesome hack by Dean Edwards
			// http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
			// If we're not dealing with a regular pixel number
			// but a number that has a weird ending, we need to convert it to pixels
			// but not position css attributes, as those are proportional to the parent element instead
			// and we can't measure the parent instead because it might trigger a "stacking dolls" problem
			if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
				// Remember the original values
				left = style.left;
				rs = elem.runtimeStyle;
				rsLeft = rs && rs.left;
	
				// Put in the new values to get a computed value out
				if ( rsLeft ) {
					rs.left = elem.currentStyle.left;
				}
				style.left = name === "fontSize" ? "1em" : ret;
				ret = style.pixelLeft + "px";
	
				// Revert the changed values
				style.left = left;
				if ( rsLeft ) {
					rs.left = rsLeft;
				}
			}
	
			// Support: IE
			// IE returns zIndex value as an integer.
			return ret === undefined ?
				ret :
				ret + "" || "auto";
		};
	}
	
	
	
	
	function addGetHookIf( conditionFn, hookFn ) {
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				var condition = conditionFn();
	
				if ( condition == null ) {
					// The test was not ready at this point; screw the hook this time
					// but check again when needed next time.
					return;
				}
	
				if ( condition ) {
					// Hook not needed (or it's not possible to use it due to missing dependency),
					// remove it.
					// Since there are no other hooks for marginRight, remove the whole object.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
	
				return (this.get = hookFn).apply( this, arguments );
			}
		};
	}
	
	
	(function() {
		// Minified: var b,c,d,e,f,g, h,i
		var div, style, a, pixelPositionVal, boxSizingReliableVal,
			reliableHiddenOffsetsVal, reliableMarginRightVal;
	
		// Setup
		div = document.createElement( "div" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName( "a" )[ 0 ];
		style = a && a.style;
	
		// Finish early in limited (non-browser) environments
		if ( !style ) {
			return;
		}
	
		style.cssText = "float:left;opacity:.5";
	
		// Support: IE<9
		// Make sure that element opacity exists (as opposed to filter)
		support.opacity = style.opacity === "0.5";
	
		// Verify style float existence
		// (IE uses styleFloat instead of cssFloat)
		support.cssFloat = !!style.cssFloat;
	
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		// Support: Firefox<29, Android 2.3
		// Vendor-prefix box-sizing
		support.boxSizing = style.boxSizing === "" || style.MozBoxSizing === "" ||
			style.WebkitBoxSizing === "";
	
		jQuery.extend(support, {
			reliableHiddenOffsets: function() {
				if ( reliableHiddenOffsetsVal == null ) {
					computeStyleTests();
				}
				return reliableHiddenOffsetsVal;
			},
	
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
	
			pixelPosition: function() {
				if ( pixelPositionVal == null ) {
					computeStyleTests();
				}
				return pixelPositionVal;
			},
	
			// Support: Android 2.3
			reliableMarginRight: function() {
				if ( reliableMarginRightVal == null ) {
					computeStyleTests();
				}
				return reliableMarginRightVal;
			}
		});
	
		function computeStyleTests() {
			// Minified: var b,c,d,j
			var div, body, container, contents;
	
			body = document.getElementsByTagName( "body" )[ 0 ];
			if ( !body || !body.style ) {
				// Test fired too early or in an unsupported environment, exit.
				return;
			}
	
			// Setup
			div = document.createElement( "div" );
			container = document.createElement( "div" );
			container.style.cssText = "position:absolute;border:0;width:0;height:0;top:0;left:-9999px";
			body.appendChild( container ).appendChild( div );
	
			div.style.cssText =
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
				"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
				"border:1px;padding:1px;width:4px;position:absolute";
	
			// Support: IE<9
			// Assume reasonable values in the absence of getComputedStyle
			pixelPositionVal = boxSizingReliableVal = false;
			reliableMarginRightVal = true;
	
			// Check for getComputedStyle so that this code is not run in IE<9.
			if ( window.getComputedStyle ) {
				pixelPositionVal = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
				boxSizingReliableVal =
					( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";
	
				// Support: Android 2.3
				// Div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				contents = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				contents.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				contents.style.marginRight = contents.style.width = "0";
				div.style.width = "1px";
	
				reliableMarginRightVal =
					!parseFloat( ( window.getComputedStyle( contents, null ) || {} ).marginRight );
			}
	
			// Support: IE8
			// Check if table cells still have offsetWidth/Height when they are set
			// to display:none and there are still other visible table cells in a
			// table row; if so, offsetWidth/Height are not reliable for use when
			// determining if an element has been hidden directly using
			// display:none (it is still safe to use offsets if a parent element is
			// hidden; don safety goggles and see bug #4512 for more information).
			div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
			contents = div.getElementsByTagName( "td" );
			contents[ 0 ].style.cssText = "margin:0;border:0;padding:0;display:none";
			reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			if ( reliableHiddenOffsetsVal ) {
				contents[ 0 ].style.display = "";
				contents[ 1 ].style.display = "none";
				reliableHiddenOffsetsVal = contents[ 0 ].offsetHeight === 0;
			}
	
			body.removeChild( container );
		}
	
	})();
	
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	jQuery.swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var
			ralpha = /alpha\([^)]*\)/i,
		ropacity = /opacity\s*=\s*([^)]*)/,
	
		// swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
		// see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
		rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];
	
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
		// shortcut for names that are not vendor prefixed
		if ( name in style ) {
			return name;
		}
	
		// check for vendor prefixed names
		var capName = name.charAt(0).toUpperCase() + name.slice(1),
			origName = name,
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in style ) {
				return name;
			}
		}
	
		return origName;
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = jQuery._data( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = jQuery._data( elem, "olddisplay", defaultDisplay(elem.nodeName) );
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display && display !== "none" || !hidden ) {
					jQuery._data( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
		var matches = rnumsplit.exec( value );
		return matches ?
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
			// If we already have the right measurement, avoid augmentation
			4 :
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
			// both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// at this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
				// at this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// at this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test(val) ) {
				return val;
			}
	
			// we need the check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox && ( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend({
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			// normalize float css property
			"float": support.cssFloat ? "cssFloat" : "styleFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// convert relative number strings (+= or -=) to relative numbers. #7345
				if ( type === "string" && (ret = rrelNum.exec( value )) ) {
					value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set. See: #7116
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add 'px' to the (except for certain CSS properties)
				if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
					value += "px";
				}
	
				// Fixes #8908, it can be done more correctly by specifing setters in cssHooks,
				// but it would mean to define eight (for every problematic property) identical functions
				if ( !support.clearCloneStyle && value === "" && name.indexOf("background") === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
	
					// Support: IE
					// Swallow errors from 'invalid' CSS values (#5509)
					try {
						style[ name ] = value;
					} catch(e) {}
				}
	
			} else {
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var num, val, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
			// gets hook for the prefixed version
			// followed by the unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			//convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Return, converting to number if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
			}
			return val;
		}
	});
	
	jQuery.each([ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
					// certain elements can have dimension info if we invisibly show them
					// however, it must have a current display style that would benefit from this
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
						jQuery.swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						}) :
						getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var styles = extra && getStyles( elem );
				return setPositiveNumber( elem, value, extra ?
					augmentWidthOrHeight(
						elem,
						name,
						extra,
						support.boxSizing && jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					) : 0
				);
			}
		};
	});
	
	if ( !support.opacity ) {
		jQuery.cssHooks.opacity = {
			get: function( elem, computed ) {
				// IE uses filters for opacity
				return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
					( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
					computed ? "1" : "";
			},
	
			set: function( elem, value ) {
				var style = elem.style,
					currentStyle = elem.currentStyle,
					opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
					filter = currentStyle && currentStyle.filter || style.filter || "";
	
				// IE has trouble with opacity if it does not have layout
				// Force it by setting the zoom level
				style.zoom = 1;
	
				// if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
				// if value === "", then remove inline opacity #12685
				if ( ( value >= 1 || value === "" ) &&
						jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
						style.removeAttribute ) {
	
					// Setting style.filter to null, "" & " " still leave "filter:" in the cssText
					// if "filter:" is present at all, clearType is disabled, we want to avoid this
					// style.removeAttribute is IE Only, but so apparently is this code path...
					style.removeAttribute( "filter" );
	
					// if there is no filter style applied in a css rule or unset inline opacity, we are done
					if ( value === "" || currentStyle && !currentStyle.filter ) {
						return;
					}
				}
	
				// otherwise, set new filter values
				style.filter = ralpha.test( filter ) ?
					filter.replace( ralpha, opacity ) :
					filter + " " + opacity;
			}
		};
	}
	
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// Work around by temporarily setting element display to inline-block
				return jQuery.swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	});
	
	jQuery.fn.extend({
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each(function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			});
		}
	});
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || "swing";
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				if ( tween.elem[ tween.prop ] != null &&
					(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
					return tween.elem[ tween.prop ];
				}
	
				// passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails
				// so, simple values such as "10px" are parsed to Float.
				// complex values such as "rotate(1rad)" are returned as is.
				result = jQuery.css( tween.elem, tween.prop, "" );
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
				// use step hook for back compat - use cssHook if its there - use .style if its
				// available and use plain properties where available
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9
	// Panic based approach to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		}
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
		rrun = /queueHooks$/,
		animationPrefilters = [ defaultPrefilter ],
		tweeners = {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value ),
					target = tween.cur(),
					parts = rfxnum.exec( value ),
					unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
					// Starting value computation is required for potential unit mismatches
					start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
						rfxnum.exec( jQuery.css( tween.elem, prop ) ),
					scale = 1,
					maxIterations = 20;
	
				if ( start && start[ 3 ] !== unit ) {
					// Trust units reported by jQuery.css
					unit = unit || start[ 3 ];
	
					// Make sure we update the tween properties later on
					parts = parts || [];
	
					// Iteratively approximate from a nonzero starting point
					start = +target || 1;
	
					do {
						// If previous iteration zeroed out, double until we get *something*
						// Use a string for doubling factor so we don't accidentally see scale as unchanged below
						scale = scale || ".5";
	
						// Adjust and apply
						start = start / scale;
						jQuery.style( tween.elem, prop, start + unit );
	
					// Update scale, tolerating zero or NaN from tween.cur()
					// And breaking the loop if scale is unchanged or perfect, or if we've just had enough
					} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
				}
	
				// Update tween properties
				if ( parts ) {
					start = tween.start = +start || +target || 0;
					tween.unit = unit;
					// If a +=/-= token was provided, we're doing a relative animation
					tween.end = parts[ 1 ] ?
						start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
						+parts[ 2 ];
				}
	
				return tween;
			} ]
		};
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		setTimeout(function() {
			fxNow = undefined;
		});
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			attrs = { height: type },
			i = 0;
	
		// if we include width, step value is 1 to do all cssExpand values,
		// if we don't include width, step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( (tween = collection[ index ].call( animation, prop, value )) ) {
	
				// we're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = jQuery._data( elem, "fxshow" );
	
		// handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always(function() {
				// doing this makes sure that the complete handler will be called
				// before this completes
				anim.always(function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				});
			});
		}
	
		// height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE does not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				jQuery._data( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
	
				// inline-level elements accept inline-block;
				// block-level elements need to be inline with layout
				if ( !support.inlineBlockNeedsLayout || defaultDisplay( elem.nodeName ) === "inline" ) {
					style.display = "inline-block";
				} else {
					style.zoom = 1;
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			if ( !support.shrinkWrapBlocks() ) {
				anim.always(function() {
					style.overflow = opts.overflow[ 0 ];
					style.overflowX = opts.overflow[ 1 ];
					style.overflowY = opts.overflow[ 2 ];
				});
			}
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = jQuery._data( elem, "fxshow", {} );
			}
	
			// store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done(function() {
					jQuery( elem ).hide();
				});
			}
			anim.done(function() {
				var prop;
				jQuery._removeData( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			});
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// not quite $.extend, this wont overwrite keys already present.
				// also - reusing 'index' from above because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = animationPrefilters.length,
			deferred = jQuery.Deferred().always( function() {
				// don't match elem in the :animated selector
				delete tick.elem;
			}),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
					// archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise({
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, { specialEasing: {} }, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
						// if we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// resolve when we played the last frame
					// otherwise, reject
					if ( gotoEnd ) {
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			}),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			})
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.split(" ");
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				tweeners[ prop ] = tweeners[ prop ] || [];
				tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				animationPrefilters.unshift( callback );
			} else {
				animationPrefilters.push( callback );
			}
		}
	});
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
			opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend({
		fadeTo: function( speed, to, easing, callback ) {
	
			// show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || jQuery._data( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each(function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = jQuery._data( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// start the next in the queue if the last step wasn't forced
				// timers currently will call their complete callbacks, which will dequeue
				// but only if they were gotoEnd
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			});
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each(function() {
				var index,
					data = jQuery._data( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// enable finishing flag on private data
				data.finish = true;
	
				// empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// turn off finishing flag
				delete data.finish;
			});
		}
	});
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	});
	
	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	});
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			timers = jQuery.timers,
			i = 0;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		clearInterval( timerId );
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = setTimeout( next, time );
			hooks.stop = function() {
				clearTimeout( timeout );
			};
		});
	};
	
	
	(function() {
		// Minified: var a,b,c,d,e
		var input, div, select, a, opt;
	
		// Setup
		div = document.createElement( "div" );
		div.setAttribute( "className", "t" );
		div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
		a = div.getElementsByTagName("a")[ 0 ];
	
		// First batch of tests.
		select = document.createElement("select");
		opt = select.appendChild( document.createElement("option") );
		input = div.getElementsByTagName("input")[ 0 ];
	
		a.style.cssText = "top:1px";
	
		// Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
		support.getSetAttribute = div.className !== "t";
	
		// Get the style information from getAttribute
		// (IE uses .cssText instead)
		support.style = /top/.test( a.getAttribute("style") );
	
		// Make sure that URLs aren't manipulated
		// (IE normalizes it by default)
		support.hrefNormalized = a.getAttribute("href") === "/a";
	
		// Check the default checkbox/radio value ("" on WebKit; "on" elsewhere)
		support.checkOn = !!input.value;
	
		// Make sure that a selected-by-default option has a working selected property.
		// (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
		support.optSelected = opt.selected;
	
		// Tests for enctype support on a form (#6743)
		support.enctype = !!document.createElement("form").enctype;
	
		// Make sure that the options inside disabled selects aren't marked as disabled
		// (WebKit marks them as disabled)
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE8 only
		// Check if we can trust getAttribute("value")
		input = document.createElement( "input" );
		input.setAttribute( "value", "" );
		support.input = input.getAttribute( "value" ) === "";
	
		// Check if an input maintains its value after becoming a radio
		input.value = "t";
		input.setAttribute( "type", "radio" );
		support.radioValue = input.value === "t";
	})();
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend({
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[0];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
						// handle most common string cases
						ret.replace(rreturn, "") :
						// handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each(function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
				} else if ( typeof val === "number" ) {
					val += "";
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					});
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			});
		}
	});
	
	jQuery.extend({
		valHooks: {
			option: {
				get: function( elem ) {
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						jQuery.trim( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// oldIE doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
								( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						if ( jQuery.inArray( jQuery.valHooks.option.get( option ), values ) >= 0 ) {
	
							// Support: IE6
							// When new option element is added to select box we need to
							// force reflow of newly added node in order to workaround delay
							// of initialization properties
							try {
								option.selected = optionSet = true;
	
							} catch ( _ ) {
	
								// Will be executed only in IE6
								option.scrollHeight;
							}
	
						} else {
							option.selected = false;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
	
					return options;
				}
			}
		}
	});
	
	// Radios and checkboxes getter/setter
	jQuery.each([ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				// Support: Webkit
				// "" is returned instead of "on" if a value isn't specified
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});
	
	
	
	
	var nodeHook, boolHook,
		attrHandle = jQuery.expr.attrHandle,
		ruseDefault = /^(?:checked|selected)$/i,
		getSetAttribute = support.getSetAttribute,
		getSetInput = support.input;
	
	jQuery.fn.extend({
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each(function() {
				jQuery.removeAttr( this, name );
			});
		}
	});
	
	jQuery.extend({
		attr: function( elem, name, value ) {
			var hooks, ret,
				nType = elem.nodeType;
	
			// don't get/set attributes on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === strundefined ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
			}
	
			if ( value !== undefined ) {
	
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
	
				} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
					return ret;
	
				} else {
					elem.setAttribute( name, value + "" );
					return value;
				}
	
			} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
				return ret;
	
			} else {
				ret = jQuery.find.attr( elem, name );
	
				// Non-existent attributes return null, we normalize to undefined
				return ret == null ?
					undefined :
					ret;
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( (name = attrNames[i++]) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
						// Set corresponding property to false
						if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
							elem[ propName ] = false;
						// Support: IE<9
						// Also clear defaultChecked/defaultSelected (if appropriate)
						} else {
							elem[ jQuery.camelCase( "default-" + name ) ] =
								elem[ propName ] = false;
						}
	
					// See #9699 for explanation of this approach (setting first, then removal)
					} else {
						jQuery.attr( elem, name, "" );
					}
	
					elem.removeAttribute( getSetAttribute ? name : propName );
				}
			}
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
						// Setting the type on a radio button after the value resets the value in IE6-9
						// Reset value to default in case type is set after value during creation
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		}
	});
	
	// Hook for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else if ( getSetInput && getSetAttribute || !ruseDefault.test( name ) ) {
				// IE<8 needs the *property* name
				elem.setAttribute( !getSetAttribute && jQuery.propFix[ name ] || name, name );
	
			// Use defaultChecked and defaultSelected for oldIE
			} else {
				elem[ jQuery.camelCase( "default-" + name ) ] = elem[ name ] = true;
			}
	
			return name;
		}
	};
	
	// Retrieve booleans specially
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = getSetInput && getSetAttribute || !ruseDefault.test( name ) ?
			function( elem, name, isXML ) {
				var ret, handle;
				if ( !isXML ) {
					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[ name ];
					attrHandle[ name ] = ret;
					ret = getter( elem, name, isXML ) != null ?
						name.toLowerCase() :
						null;
					attrHandle[ name ] = handle;
				}
				return ret;
			} :
			function( elem, name, isXML ) {
				if ( !isXML ) {
					return elem[ jQuery.camelCase( "default-" + name ) ] ?
						name.toLowerCase() :
						null;
				}
			};
	});
	
	// fix oldIE attroperties
	if ( !getSetInput || !getSetAttribute ) {
		jQuery.attrHooks.value = {
			set: function( elem, value, name ) {
				if ( jQuery.nodeName( elem, "input" ) ) {
					// Does not return so that setAttribute is also used
					elem.defaultValue = value;
				} else {
					// Use nodeHook if defined (#1954); otherwise setAttribute is fine
					return nodeHook && nodeHook.set( elem, value, name );
				}
			}
		};
	}
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
		// Use this for any attribute in IE6/7
		// This fixes almost every IE6/7 issue
		nodeHook = {
			set: function( elem, value, name ) {
				// Set the existing or create a new attribute node
				var ret = elem.getAttributeNode( name );
				if ( !ret ) {
					elem.setAttributeNode(
						(ret = elem.ownerDocument.createAttribute( name ))
					);
				}
	
				ret.value = value += "";
	
				// Break association with cloned elements by also using setAttribute (#9646)
				if ( name === "value" || value === elem.getAttribute( name ) ) {
					return value;
				}
			}
		};
	
		// Some attributes are constructed with empty-string values when not defined
		attrHandle.id = attrHandle.name = attrHandle.coords =
			function( elem, name, isXML ) {
				var ret;
				if ( !isXML ) {
					return (ret = elem.getAttributeNode( name )) && ret.value !== "" ?
						ret.value :
						null;
				}
			};
	
		// Fixing value retrieval on a button requires this module
		jQuery.valHooks.button = {
			get: function( elem, name ) {
				var ret = elem.getAttributeNode( name );
				if ( ret && ret.specified ) {
					return ret.value;
				}
			},
			set: nodeHook.set
		};
	
		// Set contenteditable to false on removals(#10429)
		// Setting to empty string throws an error as an invalid value
		jQuery.attrHooks.contenteditable = {
			set: function( elem, value, name ) {
				nodeHook.set( elem, value === "" ? false : value, name );
			}
		};
	
		// Set width and height to auto instead of 0 on empty string( Bug #8150 )
		// This is for removals
		jQuery.each([ "width", "height" ], function( i, name ) {
			jQuery.attrHooks[ name ] = {
				set: function( elem, value ) {
					if ( value === "" ) {
						elem.setAttribute( name, "auto" );
						return value;
					}
				}
			};
		});
	}
	
	if ( !support.style ) {
		jQuery.attrHooks.style = {
			get: function( elem ) {
				// Return undefined in the case of empty string
				// Note: IE uppercases css property names, but if we were to .toLowerCase()
				// .cssText, that would destroy case senstitivity in URL's, like in "background"
				return elem.style.cssText || undefined;
			},
			set: function( elem, value ) {
				return ( elem.style.cssText = value + "" );
			}
		};
	}
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button|object)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend({
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			name = jQuery.propFix[ name ] || name;
			return this.each(function() {
				// try/catch handles cases where IE balks (such as removing a property on window)
				try {
					this[ name ] = undefined;
					delete this[ name ];
				} catch( e ) {}
			});
		}
	});
	
	jQuery.extend({
		propFix: {
			"for": "htmlFor",
			"class": "className"
		},
	
		prop: function( elem, name, value ) {
			var ret, hooks, notxml,
				nType = elem.nodeType;
	
			// don't get/set properties on text, comment and attribute nodes
			if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
			if ( notxml ) {
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
					ret :
					( elem[ name ] = value );
	
			} else {
				return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
					ret :
					elem[ name ];
			}
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
					// elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
				}
			}
		}
	});
	
	// Some attributes require a special call on IE
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !support.hrefNormalized ) {
		// href/src property should get the full normalized URL (#10299/#12915)
		jQuery.each([ "href", "src" ], function( i, name ) {
			jQuery.propHooks[ name ] = {
				get: function( elem ) {
					return elem.getAttribute( name, 4 );
				}
			};
		});
	}
	
	// Support: Safari, IE9+
	// mis-reports the default selected property of an option
	// Accessing the parent's selectedIndex property fixes it
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
	
				if ( parent ) {
					parent.selectedIndex;
	
					// Make sure that it also works with optgroups, see #5701
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
				return null;
			}
		};
	}
	
	jQuery.each([
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	});
	
	// IE6/7 call enctype encoding
	if ( !support.enctype ) {
		jQuery.propFix.enctype = "encoding";
	}
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	jQuery.fn.extend({
		addClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				i = 0,
				len = this.length,
				proceed = typeof value === "string" && value;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).addClass( value.call( this, j, this.className ) );
				});
			}
	
			if ( proceed ) {
				// The disjunction here is for better compressibility (see removeClass)
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						" "
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, clazz, j, finalValue,
				i = 0,
				len = this.length,
				proceed = arguments.length === 0 || typeof value === "string" && value;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( j ) {
					jQuery( this ).removeClass( value.call( this, j, this.className ) );
				});
			}
			if ( proceed ) {
				classes = ( value || "" ).match( rnotwhite ) || [];
	
				for ( ; i < len; i++ ) {
					elem = this[ i ];
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( elem.className ?
						( " " + elem.className + " " ).replace( rclass, " " ) :
						""
					);
	
					if ( cur ) {
						j = 0;
						while ( (clazz = classes[j++]) ) {
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// only assign if different to avoid unneeded rendering.
						finalValue = value ? jQuery.trim( cur ) : "";
						if ( elem.className !== finalValue ) {
							elem.className = finalValue;
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each(function( i ) {
					jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
				});
			}
	
			return this.each(function() {
				if ( type === "string" ) {
					// toggle individual class names
					var className,
						i = 0,
						self = jQuery( this ),
						classNames = value.match( rnotwhite ) || [];
	
					while ( (className = classNames[ i++ ]) ) {
						// check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( type === strundefined || type === "boolean" ) {
					if ( this.className ) {
						// store className if set
						jQuery._data( this, "__className__", this.className );
					}
	
					// If the element has a class name or if we're passed "false",
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
				}
			});
		},
	
		hasClass: function( selector ) {
			var className = " " + selector + " ",
				i = 0,
				l = this.length;
			for ( ; i < l; i++ ) {
				if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
					return true;
				}
			}
	
			return false;
		}
	});
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	});
	
	jQuery.fn.extend({
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		},
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
		}
	});
	
	
	var nonce = jQuery.now();
	
	var rquery = (/\?/);
	
	
	
	var rvalidtokens = /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
	
	jQuery.parseJSON = function( data ) {
		// Attempt to parse using the native JSON parser first
		if ( window.JSON && window.JSON.parse ) {
			// Support: Android 2.3
			// Workaround failure to string-cast null input
			return window.JSON.parse( data + "" );
		}
	
		var requireNonComma,
			depth = null,
			str = jQuery.trim( data + "" );
	
		// Guard against invalid (and possibly dangerous) input by ensuring that nothing remains
		// after removing valid tokens
		return str && !jQuery.trim( str.replace( rvalidtokens, function( token, comma, open, close ) {
	
			// Force termination if we see a misplaced comma
			if ( requireNonComma && comma ) {
				depth = 0;
			}
	
			// Perform no more replacements after returning to outermost depth
			if ( depth === 0 ) {
				return token;
			}
	
			// Commas must not follow "[", "{", or ","
			requireNonComma = open || comma;
	
			// Determine new depth
			// array/object open ("[" or "{"): depth += true - false (increment)
			// array/object close ("]" or "}"): depth += false - true (decrement)
			// other cases ("," or primitive): depth += true - true (numeric cast)
			depth += !close - !open;
	
			// Remove this token
			return "";
		}) ) ?
			( Function( "return " + str ) )() :
			jQuery.error( "Invalid JSON: " + data );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, tmp;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		try {
			if ( window.DOMParser ) { // Standard
				tmp = new DOMParser();
				xml = tmp.parseFromString( data, "text/xml" );
			} else { // IE
				xml = new ActiveXObject( "Microsoft.XMLDOM" );
				xml.async = "false";
				xml.loadXML( data );
			}
		} catch( e ) {
			xml = undefined;
		}
		if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		// Document location
		ajaxLocParts,
		ajaxLocation,
	
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
		rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat("*");
	
	// #8138, IE may throw an exception when accessing
	// a field from window.location if document.domain has been set
	try {
		ajaxLocation = location.href;
	} catch( e ) {
		// Use the href attribute of an A element
		// since IE will modify it given document.location
		ajaxLocation = document.createElement( "a" );
		ajaxLocation.href = "";
		ajaxLocation = ajaxLocation.href;
	}
	
	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
				// For each dataType in the dataTypeExpression
				while ( (dataType = dataTypes[i++]) ) {
					// Prepend if requested
					if ( dataType.charAt( 0 ) === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						(structure[ dataType ] = structure[ dataType ] || []).unshift( func );
	
					// Otherwise append
					} else {
						(structure[ dataType ] = structure[ dataType ] || []).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			});
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var deep, key,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
		var firstDataType, ct, finalDataType, type,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s[ "throws" ] ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend({
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: ajaxLocation,
			type: "GET",
			isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /xml/,
				html: /html/,
				json: /json/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var // Cross-domain detection vars
				parts,
				// Loop variable
				i,
				// URL without anti-cache param
				cacheURL,
				// Response headers as string
				responseHeadersString,
				// timeout handle
				timeoutTimer,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				transport,
				// Response headers
				responseHeaders,
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
				// Callbacks context
				callbackContext = s.context || s,
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks("once memory"),
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
				// The jqXHR state
				state = 0,
				// Default abort message
				strAbort = "canceled",
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( (match = rheaders.exec( responseHeadersString )) ) {
									responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when we have a protocol:host:port mismatch
			if ( s.crossDomain == null ) {
				parts = rurl.exec( s.url.toLowerCase() );
				s.crossDomain = !!( parts &&
					( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
						( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
							( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
				);
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			fireGlobals = s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger("ajaxStart");
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
					s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = setTimeout(function() {
						jqXHR.abort("timeout");
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
					// We extract error from statusText
					// then normalize statusText and status for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
			// shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			return jQuery.ajax({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			});
		};
	});
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	});
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax({
			url: url,
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		});
	};
	
	
	jQuery.fn.extend({
		wrapAll: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function(i) {
					jQuery(this).wrapAll( html.call(this, i) );
				});
			}
	
			if ( this[0] ) {
				// The elements to wrap the target around
				var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);
	
				if ( this[0].parentNode ) {
					wrap.insertBefore( this[0] );
				}
	
				wrap.map(function() {
					var elem = this;
	
					while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
						elem = elem.firstChild;
					}
	
					return elem;
				}).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each(function(i) {
					jQuery(this).wrapInner( html.call(this, i) );
				});
			}
	
			return this.each(function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			});
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each(function(i) {
				jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
			});
		},
	
		unwrap: function() {
			return this.parent().each(function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			}).end();
		}
	});
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		return elem.offsetWidth <= 0 && elem.offsetHeight <= 0 ||
			(!support.reliableHiddenOffsets() &&
				((elem.style && elem.style.display) || jQuery.css( elem, "display" )) === "none");
	};
	
	jQuery.expr.filters.visible = function( elem ) {
		return !jQuery.expr.filters.hidden( elem );
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
				}
			});
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			});
	
		} else {
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend({
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map(function() {
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			})
			.filter(function() {
				var type = this.type;
				// Use .is(":disabled") so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			})
			.map(function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						}) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			}).get();
		}
	});
	
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject !== undefined ?
		// Support: IE6+
		function() {
	
			// XHR cannot access local files, always use ActiveX for that case
			return !this.isLocal &&
	
				// Support: IE7-8
				// oldIE XHR does not support non-RFC2616 methods (#13240)
				// See http://msdn.microsoft.com/en-us/library/ie/ms536648(v=vs.85).aspx
				// and http://www.w3.org/Protocols/rfc2616/rfc2616-sec9.html#sec9
				// Although this check for six methods instead of eight
				// since IE also does not support "trace" and "connect"
				/^(get|post|head|put|delete|options)$/i.test( this.type ) &&
	
				createStandardXHR() || createActiveXHR();
		} :
		// For all other browsers, use the standard XMLHttpRequest object
		createStandardXHR;
	
	var xhrId = 0,
		xhrCallbacks = {},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	// Support: IE<10
	// Open requests must be manually aborted on unload (#5280)
	if ( window.ActiveXObject ) {
		jQuery( window ).on( "unload", function() {
			for ( var key in xhrCallbacks ) {
				xhrCallbacks[ key ]( undefined, true );
			}
		});
	}
	
	// Determine support properties
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	xhrSupported = support.ajax = !!xhrSupported;
	
	// Create transport if the browser can provide an xhr
	if ( xhrSupported ) {
	
		jQuery.ajaxTransport(function( options ) {
			// Cross domain only allowed if supported through XMLHttpRequest
			if ( !options.crossDomain || support.cors ) {
	
				var callback;
	
				return {
					send: function( headers, complete ) {
						var i,
							xhr = options.xhr(),
							id = ++xhrId;
	
						// Open the socket
						xhr.open( options.type, options.url, options.async, options.username, options.password );
	
						// Apply custom fields if provided
						if ( options.xhrFields ) {
							for ( i in options.xhrFields ) {
								xhr[ i ] = options.xhrFields[ i ];
							}
						}
	
						// Override mime type if needed
						if ( options.mimeType && xhr.overrideMimeType ) {
							xhr.overrideMimeType( options.mimeType );
						}
	
						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if ( !options.crossDomain && !headers["X-Requested-With"] ) {
							headers["X-Requested-With"] = "XMLHttpRequest";
						}
	
						// Set headers
						for ( i in headers ) {
							// Support: IE<9
							// IE's ActiveXObject throws a 'Type Mismatch' exception when setting
							// request header to a null-value.
							//
							// To keep consistent with other XHR implementations, cast the value
							// to string and ignore `undefined`.
							if ( headers[ i ] !== undefined ) {
								xhr.setRequestHeader( i, headers[ i ] + "" );
							}
						}
	
						// Do send the request
						// This may raise an exception which is actually
						// handled in jQuery.ajax (so no try/catch here)
						xhr.send( ( options.hasContent && options.data ) || null );
	
						// Listener
						callback = function( _, isAbort ) {
							var status, statusText, responses;
	
							// Was never called and is aborted or complete
							if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
								// Clean up
								delete xhrCallbacks[ id ];
								callback = undefined;
								xhr.onreadystatechange = jQuery.noop;
	
								// Abort manually if needed
								if ( isAbort ) {
									if ( xhr.readyState !== 4 ) {
										xhr.abort();
									}
								} else {
									responses = {};
									status = xhr.status;
	
									// Support: IE<10
									// Accessing binary-data responseText throws an exception
									// (#11426)
									if ( typeof xhr.responseText === "string" ) {
										responses.text = xhr.responseText;
									}
	
									// Firefox throws an exception when accessing
									// statusText for faulty cross-domain requests
									try {
										statusText = xhr.statusText;
									} catch( e ) {
										// We normalize with Webkit giving an empty statusText
										statusText = "";
									}
	
									// Filter status for non standard behaviors
	
									// If the request is local and we have data: assume a success
									// (success with no data won't get notified, that's the best we
									// can do given current implementations)
									if ( !status && options.isLocal && !options.crossDomain ) {
										status = responses.text ? 200 : 404;
									// IE - #1450: sometimes returns 1223 when it should be 204
									} else if ( status === 1223 ) {
										status = 204;
									}
								}
							}
	
							// Call complete if needed
							if ( responses ) {
								complete( status, statusText, responses, xhr.getAllResponseHeaders() );
							}
						};
	
						if ( !options.async ) {
							// if we're in sync mode we fire the callback
							callback();
						} else if ( xhr.readyState === 4 ) {
							// (IE6 & IE7) if it's in cache and has been
							// retrieved directly we need to fire the callback
							setTimeout( callback );
						} else {
							// Add to the list of active xhr callbacks
							xhr.onreadystatechange = xhrCallbacks[ id ] = callback;
						}
					},
	
					abort: function() {
						if ( callback ) {
							callback( undefined, true );
						}
					}
				};
			}
		});
	}
	
	// Functions to create xhrs
	function createStandardXHR() {
		try {
			return new window.XMLHttpRequest();
		} catch( e ) {}
	}
	
	function createActiveXHR() {
		try {
			return new window.ActiveXObject( "Microsoft.XMLHTTP" );
		} catch( e ) {}
	}
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /(?:java|ecma)script/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	});
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
			s.global = false;
		}
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function(s) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
	
			var script,
				head = document.head || jQuery("head")[0] || document.documentElement;
	
			return {
	
				send: function( _, callback ) {
	
					script = document.createElement("script");
	
					script.async = true;
	
					if ( s.scriptCharset ) {
						script.charset = s.scriptCharset;
					}
	
					script.src = s.url;
	
					// Attach handlers for all browsers
					script.onload = script.onreadystatechange = function( _, isAbort ) {
	
						if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
							// Handle memory leak in IE
							script.onload = script.onreadystatechange = null;
	
							// Remove the script
							if ( script.parentNode ) {
								script.parentNode.removeChild( script );
							}
	
							// Dereference the script
							script = null;
	
							// Callback if not abort
							if ( !isAbort ) {
								callback( 200, "success" );
							}
						}
					};
	
					// Circumvent IE6 bugs with base elements (#2709 and #4378) by prepending
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					head.insertBefore( script, head.firstChild );
				},
	
				abort: function() {
					if ( script ) {
						script.onload( undefined, true );
					}
				}
			};
		}
	});
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always(function() {
				// Restore preexisting value
				window[ callbackName ] = overwritten;
	
				// Save back as free
				if ( s[ callbackName ] ) {
					// make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			});
	
			// Delegate to script
			return "script";
		}
	});
	
	
	
	
	// data: string of html
	// context (optional): If specified, the fragment will be created in this context, defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[1] ) ];
		}
	
		parsed = jQuery.buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, response, type,
			self = this,
			off = url.indexOf(" ");
	
		if ( off >= 0 ) {
			selector = jQuery.trim( url.slice( off, url.length ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax({
				url: url,
	
				// if "type" variable is undefined, then "GET" method will be used
				type: type,
				dataType: "html",
				data: params
			}).done(function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			}).complete( callback && function( jqXHR, status ) {
				self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
			});
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep(jQuery.timers, function( fn ) {
			return elem === fn.elem;
		}).length;
	};
	
	
	
	
	
	var docElem = window.document.documentElement;
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ?
			elem :
			elem.nodeType === 9 ?
				elem.defaultView || elem.parentWindow :
				false;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				jQuery.inArray("auto", [ curCSSTop, curCSSLeft ] ) > -1;
	
			// need to be able to calculate position if either top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
				options = options.call( elem, i, curOffset );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend({
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each(function( i ) {
						jQuery.offset.setOffset( this, options, i );
					});
			}
	
			var docElem, win,
				box = { top: 0, left: 0 },
				elem = this[ 0 ],
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			// If we don't have gBCR, just use 0,0 rather than error
			// BlackBerry 5, iOS 3 (original iPhone)
			if ( typeof elem.getBoundingClientRect !== strundefined ) {
				box = elem.getBoundingClientRect();
			}
			win = getWindow( doc );
			return {
				top: box.top  + ( win.pageYOffset || docElem.scrollTop )  - ( docElem.clientTop  || 0 ),
				left: box.left + ( win.pageXOffset || docElem.scrollLeft ) - ( docElem.clientLeft || 0 )
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				parentOffset = { top: 0, left: 0 },
				elem = this[ 0 ];
	
			// fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
				// we assume that getBoundingClientRect is available when computed position is fixed
				offset = elem.getBoundingClientRect();
			} else {
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top  += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			// note: when an element has margin: auto the offsetLeft and marginLeft
			// are the same in Safari causing offset.left to incorrectly be 0
			return {
				top:  offset.top  - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true)
			};
		},
	
		offsetParent: function() {
			return this.map(function() {
				var offsetParent = this.offsetParent || docElem;
	
				while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
					offsetParent = offsetParent.offsetParent;
				}
				return offsetParent || docElem;
			});
		}
	});
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = /Y/.test( prop );
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? (prop in win) ? win[ prop ] :
						win.document.documentElement[ method ] :
						elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : jQuery( win ).scrollLeft(),
						top ? val : jQuery( win ).scrollTop()
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length, null );
		};
	});
	
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// getComputedStyle returns percent when specified for top/left/bottom/right
	// rather than make the css module depend on the offset module, we just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
					// if curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	});
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
			// margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
						// unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		});
	});
	
	
	// The number of elements contained in the matched element set
	jQuery.fn.size = function() {
		return this.length;
	};
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in
	// AMD (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === strundefined ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	
	}));


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// Backbone.Radio v0.9.1
	(function (global, factory) {
	   true ? module.exports = factory(__webpack_require__(49), __webpack_require__(58)) : typeof define === "function" && define.amd ? define(["underscore", "backbone"], factory) : global.Backbone.Radio = factory(global._, global.Backbone);
	})(this, function (_, Backbone) {
	  "use strict";
	
	  var previousRadio = Backbone.Radio;
	
	  var Radio = Backbone.Radio = {};
	
	  Radio.VERSION = "0.9.1";
	
	  // This allows you to run multiple instances of Radio on the same
	  // webapp. After loading the new version, call `noConflict()` to
	  // get a reference to it. At the same time the old version will be
	  // returned to Backbone.Radio.
	  Radio.noConflict = function () {
	    Backbone.Radio = previousRadio;
	    return this;
	  };
	
	  // Whether or not we're in DEBUG mode or not. DEBUG mode helps you
	  // get around the issues of lack of warnings when events are mis-typed.
	  Radio.DEBUG = false;
	
	  // Format debug text.
	  Radio._debugText = function (warning, eventName, channelName) {
	    return warning + (channelName ? " on the " + channelName + " channel" : "") + ": \"" + eventName + "\"";
	  };
	
	  // This is the method that's called when an unregistered event was called.
	  // By default, it logs warning to the console. By overriding this you could
	  // make it throw an Error, for instance. This would make firing a nonexistent event
	  // have the same consequence as firing a nonexistent method on an Object.
	  Radio.debugLog = function (warning, eventName, channelName) {
	    if (Radio.DEBUG && console && console.warn) {
	      console.warn(Radio._debugText(warning, eventName, channelName));
	    }
	  };
	
	  var eventSplitter = /\s+/;
	
	  // An internal method used to handle Radio's method overloading for Requests and
	  // Commands. It's borrowed from Backbone.Events. It differs from Backbone's overload
	  // API (which is used in Backbone.Events) in that it doesn't support space-separated
	  // event names.
	  Radio._eventsApi = function (obj, action, name, rest) {
	    if (!name) {
	      return false;
	    }
	
	    var results = {};
	
	    // Handle event maps.
	    if (typeof name === "object") {
	      for (var key in name) {
	        var result = obj[action].apply(obj, [key, name[key]].concat(rest));
	        eventSplitter.test(key) ? _.extend(results, result) : results[key] = result;
	      }
	      return results;
	    }
	
	    // Handle space separated event names.
	    if (eventSplitter.test(name)) {
	      var names = name.split(eventSplitter);
	      for (var i = 0, l = names.length; i < l; i++) {
	        results[names[i]] = obj[action].apply(obj, [names[i]].concat(rest));
	      }
	      return results;
	    }
	
	    return false;
	  };
	
	  // An optimized way to execute callbacks.
	  Radio._callHandler = function (callback, context, args) {
	    var a1 = args[0],
	        a2 = args[1],
	        a3 = args[2];
	    switch (args.length) {
	      case 0:
	        return callback.call(context);
	      case 1:
	        return callback.call(context, a1);
	      case 2:
	        return callback.call(context, a1, a2);
	      case 3:
	        return callback.call(context, a1, a2, a3);
	      default:
	        return callback.apply(context, args);
	    }
	  };
	
	  // A helper used by `off` methods to the handler from the store
	  function removeHandler(store, name, callback, context) {
	    var event = store[name];
	    if ((!callback || (callback === event.callback || callback === event.callback._callback)) && (!context || context === event.context)) {
	      delete store[name];
	      return true;
	    }
	  }
	
	  function removeHandlers(store, name, callback, context) {
	    store || (store = {});
	    var names = name ? [name] : _.keys(store);
	    var matched = false;
	
	    for (var i = 0, length = names.length; i < length; i++) {
	      name = names[i];
	
	      // If there's no event by this name, log it and continue
	      // with the loop
	      if (!store[name]) {
	        continue;
	      }
	
	      if (removeHandler(store, name, callback, context)) {
	        matched = true;
	      }
	    }
	
	    return matched;
	  }
	
	  /*
	   * tune-in
	   * -------
	   * Get console logs of a channel's activity
	   *
	   */
	
	  var _logs = {};
	
	  // This is to produce an identical function in both tuneIn and tuneOut,
	  // so that Backbone.Events unregisters it.
	  function _partial(channelName) {
	    return _logs[channelName] || (_logs[channelName] = _.partial(Radio.log, channelName));
	  }
	
	  _.extend(Radio, {
	
	    // Log information about the channel and event
	    log: function log(channelName, eventName) {
	      var args = _.rest(arguments, 2);
	
	    },
	
	    // Logs all events on this channel to the console. It sets an
	    // internal value on the channel telling it we're listening,
	    // then sets a listener on the Backbone.Events
	    tuneIn: function tuneIn(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = true;
	      channel.on("all", _partial(channelName));
	      return this;
	    },
	
	    // Stop logging all of the activities on this channel to the console
	    tuneOut: function tuneOut(channelName) {
	      var channel = Radio.channel(channelName);
	      channel._tunedIn = false;
	      channel.off("all", _partial(channelName));
	      delete _logs[channelName];
	      return this;
	    }
	  });
	
	  /*
	   * Backbone.Radio.Commands
	   * -----------------------
	   * A messaging system for sending orders.
	   *
	   */
	
	  Radio.Commands = {
	
	    // Issue a command
	    command: function command(name) {
	      var args = _.rest(arguments);
	      if (Radio._eventsApi(this, "command", name, args)) {
	        return this;
	      }
	      var channelName = this.channelName;
	      var commands = this._commands;
	
	      // Check if we should log the command, and if so, do it
	      if (channelName && this._tunedIn) {
	        Radio.log.apply(this, [channelName, name].concat(args));
	      }
	
	      // If the command isn't handled, log it in DEBUG mode and exit
	      if (commands && (commands[name] || commands["default"])) {
	        var handler = commands[name] || commands["default"];
	        args = commands[name] ? args : arguments;
	        Radio._callHandler(handler.callback, handler.context, args);
	      } else {
	        Radio.debugLog("An unhandled command was fired", name, channelName);
	      }
	
	      return this;
	    },
	
	    // Register a handler for a command.
	    comply: function comply(name, callback, context) {
	      if (Radio._eventsApi(this, "comply", name, [callback, context])) {
	        return this;
	      }
	      this._commands || (this._commands = {});
	
	      if (this._commands[name]) {
	        Radio.debugLog("A command was overwritten", name, this.channelName);
	      }
	
	      this._commands[name] = {
	        callback: callback,
	        context: context || this
	      };
	
	      return this;
	    },
	
	    // Register a handler for a command that happens just once.
	    complyOnce: function complyOnce(name, callback, context) {
	      if (Radio._eventsApi(this, "complyOnce", name, [callback, context])) {
	        return this;
	      }
	      var self = this;
	
	      var once = _.once(function () {
	        self.stopComplying(name);
	        return callback.apply(this, arguments);
	      });
	
	      return this.comply(name, once, context);
	    },
	
	    // Remove handler(s)
	    stopComplying: function stopComplying(name, callback, context) {
	      if (Radio._eventsApi(this, "stopComplying", name)) {
	        return this;
	      }
	
	      // Remove everything if there are no arguments passed
	      if (!name && !callback && !context) {
	        delete this._commands;
	      } else if (!removeHandlers(this._commands, name, callback, context)) {
	        Radio.debugLog("Attempted to remove the unregistered command", name, this.channelName);
	      }
	
	      return this;
	    }
	  };
	
	  /*
	   * Backbone.Radio.Requests
	   * -----------------------
	   * A messaging system for requesting data.
	   *
	   */
	
	  function makeCallback(callback) {
	    return _.isFunction(callback) ? callback : function () {
	      return callback;
	    };
	  }
	
	  Radio.Requests = {
	
	    // Make a request
	    request: function request(name) {
	      var args = _.rest(arguments);
	      var results = Radio._eventsApi(this, "request", name, args);
	      if (results) {
	        return results;
	      }
	      var channelName = this.channelName;
	      var requests = this._requests;
	
	      // Check if we should log the request, and if so, do it
	      if (channelName && this._tunedIn) {
	        Radio.log.apply(this, [channelName, name].concat(args));
	      }
	
	      // If the request isn't handled, log it in DEBUG mode and exit
	      if (requests && (requests[name] || requests["default"])) {
	        var handler = requests[name] || requests["default"];
	        args = requests[name] ? args : arguments;
	        return Radio._callHandler(handler.callback, handler.context, args);
	      } else {
	        Radio.debugLog("An unhandled request was fired", name, channelName);
	      }
	    },
	
	    // Set up a handler for a request
	    reply: function reply(name, callback, context) {
	      if (Radio._eventsApi(this, "reply", name, [callback, context])) {
	        return this;
	      }
	
	      this._requests || (this._requests = {});
	
	      if (this._requests[name]) {
	        Radio.debugLog("A request was overwritten", name, this.channelName);
	      }
	
	      this._requests[name] = {
	        callback: makeCallback(callback),
	        context: context || this
	      };
	
	      return this;
	    },
	
	    // Set up a handler that can only be requested once
	    replyOnce: function replyOnce(name, callback, context) {
	      if (Radio._eventsApi(this, "replyOnce", name, [callback, context])) {
	        return this;
	      }
	
	      var self = this;
	
	      var once = _.once(function () {
	        self.stopReplying(name);
	        return makeCallback(callback).apply(this, arguments);
	      });
	
	      return this.reply(name, once, context);
	    },
	
	    // Remove handler(s)
	    stopReplying: function stopReplying(name, callback, context) {
	      if (Radio._eventsApi(this, "stopReplying", name)) {
	        return this;
	      }
	
	      // Remove everything if there are no arguments passed
	      if (!name && !callback && !context) {
	        delete this._requests;
	      } else if (!removeHandlers(this._requests, name, callback, context)) {
	        Radio.debugLog("Attempted to remove the unregistered request", name, this.channelName);
	      }
	
	      return this;
	    }
	  };
	
	  /*
	   * Backbone.Radio.channel
	   * ----------------------
	   * Get a reference to a channel by name.
	   *
	   */
	
	  Radio._channels = {};
	
	  Radio.channel = function (channelName) {
	    if (!channelName) {
	      throw new Error("You must provide a name for the channel.");
	    }
	
	    if (Radio._channels[channelName]) {
	      return Radio._channels[channelName];
	    } else {
	      return Radio._channels[channelName] = new Radio.Channel(channelName);
	    }
	  };
	
	  /*
	   * Backbone.Radio.Channel
	   * ----------------------
	   * A Channel is an object that extends from Backbone.Events,
	   * Radio.Commands, and Radio.Requests.
	   *
	   */
	
	  Radio.Channel = function (channelName) {
	    this.channelName = channelName;
	  };
	
	  _.extend(Radio.Channel.prototype, Backbone.Events, Radio.Commands, Radio.Requests, {
	
	    // Remove all handlers from the messaging systems of this channel
	    reset: function reset() {
	      this.off();
	      this.stopListening();
	      this.stopComplying();
	      this.stopReplying();
	      return this;
	    }
	  });
	
	  /*
	   * Top-level API
	   * -------------
	   * Supplies the 'top-level API' for working with Channels directly
	   * from Backbone.Radio.
	   *
	   */
	
	  var channel,
	      args,
	      systems = [Backbone.Events, Radio.Commands, Radio.Requests];
	
	  _.each(systems, function (system) {
	    _.each(system, function (method, methodName) {
	      Radio[methodName] = function (channelName) {
	        args = _.rest(arguments);
	        channel = this.channel(channelName);
	        return channel[methodName].apply(channel, args);
	      };
	    });
	  });
	
	  Radio.reset = function (channelName) {
	    var channels = !channelName ? this._channels : [this._channels[channelName]];
	    _.invoke(channels, "reset");
	  };
	
	  var backbone_radio = Radio;
	
	  return backbone_radio;
	});
	//# sourceMappingURL=./backbone.radio.js.map

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// MarionetteJS (Backbone.Marionette)
	// ----------------------------------
	// v2.3.2
	//
	// Copyright (c)2015 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://marionettejs.com
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58), __webpack_require__(49), __webpack_require__(62), __webpack_require__(63)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return (root.Marionette = root.Mn = factory(root, Backbone, _));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    var Wreqr = require('backbone.wreqr');
	    var BabySitter = require('backbone.babysitter');
	    module.exports = factory(root, Backbone, _);
	  } else {
	    root.Marionette = root.Mn = factory(root, root.Backbone, root._);
	  }
	
	}(this, function(root, Backbone, _) {
	  'use strict';
	
	  var previousMarionette = root.Marionette;
	  var previousMn = root.Mn;
	
	  var Marionette = Backbone.Marionette = {};
	
	  Marionette.VERSION = '2.3.2';
	
	  Marionette.noConflict = function() {
	    root.Marionette = previousMarionette;
	    root.Mn = previousMn;
	    return this;
	  };
	
	  // Get the Deferred creator for later use
	  Marionette.Deferred = Backbone.$.Deferred;
	
	  /* jshint unused: false *//* global console */
	  
	  // Helpers
	  // -------
	  
	  // Marionette.extend
	  // -----------------
	  
	  // Borrow the Backbone `extend` method so we can use it as needed
	  Marionette.extend = Backbone.Model.extend;
	  
	  // Marionette.isNodeAttached
	  // -------------------------
	  
	  // Determine if `el` is a child of the document
	  Marionette.isNodeAttached = function(el) {
	    return Backbone.$.contains(document.documentElement, el);
	  };
	  
	  
	  // Marionette.getOption
	  // --------------------
	  
	  // Retrieve an object, function or other value from a target
	  // object or its `options`, with `options` taking precedence.
	  Marionette.getOption = function(target, optionName) {
	    if (!target || !optionName) { return; }
	    if (target.options && (target.options[optionName] !== undefined)) {
	      return target.options[optionName];
	    } else {
	      return target[optionName];
	    }
	  };
	  
	  // Proxy `Marionette.getOption`
	  Marionette.proxyGetOption = function(optionName) {
	    return Marionette.getOption(this, optionName);
	  };
	  
	  // Similar to `_.result`, this is a simple helper
	  // If a function is provided we call it with context
	  // otherwise just return the value. If the value is
	  // undefined return a default value
	  Marionette._getValue = function(value, context, params) {
	    if (_.isFunction(value)) {
	      // We need to ensure that params is not undefined
	      // to prevent `apply` from failing in ie8
	      params = params || [];
	  
	      value = value.apply(context, params);
	    }
	    return value;
	  };
	  
	  // Marionette.normalizeMethods
	  // ----------------------
	  
	  // Pass in a mapping of events => functions or function names
	  // and return a mapping of events => functions
	  Marionette.normalizeMethods = function(hash) {
	    return _.reduce(hash, function(normalizedHash, method, name) {
	      if (!_.isFunction(method)) {
	        method = this[method];
	      }
	      if (method) {
	        normalizedHash[name] = method;
	      }
	      return normalizedHash;
	    }, {}, this);
	  };
	  
	  // utility method for parsing @ui. syntax strings
	  // into associated selector
	  Marionette.normalizeUIString = function(uiString, ui) {
	    return uiString.replace(/@ui\.[a-zA-Z_$0-9]*/g, function(r) {
	      return ui[r.slice(4)];
	    });
	  };
	  
	  // allows for the use of the @ui. syntax within
	  // a given key for triggers and events
	  // swaps the @ui with the associated selector.
	  // Returns a new, non-mutated, parsed events hash.
	  Marionette.normalizeUIKeys = function(hash, ui) {
	    return _.reduce(hash, function(memo, val, key) {
	      var normalizedKey = Marionette.normalizeUIString(key, ui);
	      memo[normalizedKey] = val;
	      return memo;
	    }, {});
	  };
	  
	  // allows for the use of the @ui. syntax within
	  // a given value for regions
	  // swaps the @ui with the associated selector
	  Marionette.normalizeUIValues = function(hash, ui) {
	    _.each(hash, function(val, key) {
	      if (_.isString(val)) {
	        hash[key] = Marionette.normalizeUIString(val, ui);
	      }
	    });
	    return hash;
	  };
	  
	  // Mix in methods from Underscore, for iteration, and other
	  // collection related features.
	  // Borrowing this code from Backbone.Collection:
	  // http://backbonejs.org/docs/backbone.html#section-121
	  Marionette.actAsCollection = function(object, listProperty) {
	    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
	      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
	      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
	      'last', 'without', 'isEmpty', 'pluck'];
	  
	    _.each(methods, function(method) {
	      object[method] = function() {
	        var list = _.values(_.result(this, listProperty));
	        var args = [list].concat(_.toArray(arguments));
	        return _[method].apply(_, args);
	      };
	    });
	  };
	  
	  var deprecate = Marionette.deprecate = function(message, test) {
	    if (_.isObject(message)) {
	      message = (
	        message.prev + ' is going to be removed in the future. ' +
	        'Please use ' + message.next + ' instead.' +
	        (message.url ? ' See: ' + message.url : '')
	      );
	    }
	  
	    if ((test === undefined || !test) && !deprecate._cache[message]) {
	      deprecate._warn('Deprecation warning: ' + message);
	      deprecate._cache[message] = true;
	    }
	  };
	  
	  deprecate._warn = typeof console !== 'undefined' && (console.warn || console.log) || function() {};
	  deprecate._cache = {};
	  
	  /* jshint maxstatements: 14, maxcomplexity: 7 */
	  
	  // Trigger Method
	  // --------------
	  
	  
	  Marionette._triggerMethod = (function() {
	    // split the event name on the ":"
	    var splitter = /(^|:)(\w)/gi;
	  
	    // take the event section ("section1:section2:section3")
	    // and turn it in to uppercase name
	    function getEventName(match, prefix, eventName) {
	      return eventName.toUpperCase();
	    }
	  
	    return function(context, event, args) {
	      var noEventArg = arguments.length < 3;
	      if (noEventArg) {
	        args = event;
	        event = args[0];
	      }
	  
	      // get the method name from the event name
	      var methodName = 'on' + event.replace(splitter, getEventName);
	      var method = context[methodName];
	      var result;
	  
	      // call the onMethodName if it exists
	      if (_.isFunction(method)) {
	        // pass all args, except the event name
	        result = method.apply(context, noEventArg ? _.rest(args) : args);
	      }
	  
	      // trigger the event, if a trigger method exists
	      if (_.isFunction(context.trigger)) {
	        if (noEventArg + args.length > 1) {
	          context.trigger.apply(context, noEventArg ? args : [event].concat(_.rest(args, 0)));
	        } else {
	          context.trigger(event);
	        }
	      }
	  
	      return result;
	    };
	  })();
	  
	  // Trigger an event and/or a corresponding method name. Examples:
	  //
	  // `this.triggerMethod("foo")` will trigger the "foo" event and
	  // call the "onFoo" method.
	  //
	  // `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
	  // call the "onFooBar" method.
	  Marionette.triggerMethod = function(event) {
	    return Marionette._triggerMethod(this, arguments);
	  };
	  
	  // triggerMethodOn invokes triggerMethod on a specific context
	  //
	  // e.g. `Marionette.triggerMethodOn(view, 'show')`
	  // will trigger a "show" event or invoke onShow the view.
	  Marionette.triggerMethodOn = function(context) {
	    var fnc = _.isFunction(context.triggerMethod) ?
	                  context.triggerMethod :
	                  Marionette.triggerMethod;
	  
	    return fnc.apply(context, _.rest(arguments));
	  };
	  
	  // DOM Refresh
	  // -----------
	  
	  // Monitor a view's state, and after it has been rendered and shown
	  // in the DOM, trigger a "dom:refresh" event every time it is
	  // re-rendered.
	  
	  Marionette.MonitorDOMRefresh = function(view) {
	  
	    // track when the view has been shown in the DOM,
	    // using a Marionette.Region (or by other means of triggering "show")
	    function handleShow() {
	      view._isShown = true;
	      triggerDOMRefresh();
	    }
	  
	    // track when the view has been rendered
	    function handleRender() {
	      view._isRendered = true;
	      triggerDOMRefresh();
	    }
	  
	    // Trigger the "dom:refresh" event and corresponding "onDomRefresh" method
	    function triggerDOMRefresh() {
	      if (view._isShown && view._isRendered && Marionette.isNodeAttached(view.el)) {
	        if (_.isFunction(view.triggerMethod)) {
	          view.triggerMethod('dom:refresh');
	        }
	      }
	    }
	  
	    view.on({
	      show: handleShow,
	      render: handleRender
	    });
	  };
	  
	  /* jshint maxparams: 5 */
	  
	  // Bind Entity Events & Unbind Entity Events
	  // -----------------------------------------
	  //
	  // These methods are used to bind/unbind a backbone "entity" (e.g. collection/model)
	  // to methods on a target object.
	  //
	  // The first parameter, `target`, must have the Backbone.Events module mixed in.
	  //
	  // The second parameter is the `entity` (Backbone.Model, Backbone.Collection or
	  // any object that has Backbone.Events mixed in) to bind the events from.
	  //
	  // The third parameter is a hash of { "event:name": "eventHandler" }
	  // configuration. Multiple handlers can be separated by a space. A
	  // function can be supplied instead of a string handler name.
	  
	  (function(Marionette) {
	    'use strict';
	  
	    // Bind the event to handlers specified as a string of
	    // handler names on the target object
	    function bindFromStrings(target, entity, evt, methods) {
	      var methodNames = methods.split(/\s+/);
	  
	      _.each(methodNames, function(methodName) {
	  
	        var method = target[methodName];
	        if (!method) {
	          throw new Marionette.Error('Method "' + methodName +
	            '" was configured as an event handler, but does not exist.');
	        }
	  
	        target.listenTo(entity, evt, method);
	      });
	    }
	  
	    // Bind the event to a supplied callback function
	    function bindToFunction(target, entity, evt, method) {
	      target.listenTo(entity, evt, method);
	    }
	  
	    // Bind the event to handlers specified as a string of
	    // handler names on the target object
	    function unbindFromStrings(target, entity, evt, methods) {
	      var methodNames = methods.split(/\s+/);
	  
	      _.each(methodNames, function(methodName) {
	        var method = target[methodName];
	        target.stopListening(entity, evt, method);
	      });
	    }
	  
	    // Bind the event to a supplied callback function
	    function unbindToFunction(target, entity, evt, method) {
	      target.stopListening(entity, evt, method);
	    }
	  
	  
	    // generic looping function
	    function iterateEvents(target, entity, bindings, functionCallback, stringCallback) {
	      if (!entity || !bindings) { return; }
	  
	      // type-check bindings
	      if (!_.isObject(bindings)) {
	        throw new Marionette.Error({
	          message: 'Bindings must be an object or function.',
	          url: 'marionette.functions.html#marionettebindentityevents'
	        });
	      }
	  
	      // allow the bindings to be a function
	      bindings = Marionette._getValue(bindings, target);
	  
	      // iterate the bindings and bind them
	      _.each(bindings, function(methods, evt) {
	  
	        // allow for a function as the handler,
	        // or a list of event names as a string
	        if (_.isFunction(methods)) {
	          functionCallback(target, entity, evt, methods);
	        } else {
	          stringCallback(target, entity, evt, methods);
	        }
	  
	      });
	    }
	  
	    // Export Public API
	    Marionette.bindEntityEvents = function(target, entity, bindings) {
	      iterateEvents(target, entity, bindings, bindToFunction, bindFromStrings);
	    };
	  
	    Marionette.unbindEntityEvents = function(target, entity, bindings) {
	      iterateEvents(target, entity, bindings, unbindToFunction, unbindFromStrings);
	    };
	  
	    // Proxy `bindEntityEvents`
	    Marionette.proxyBindEntityEvents = function(entity, bindings) {
	      return Marionette.bindEntityEvents(this, entity, bindings);
	    };
	  
	    // Proxy `unbindEntityEvents`
	    Marionette.proxyUnbindEntityEvents = function(entity, bindings) {
	      return Marionette.unbindEntityEvents(this, entity, bindings);
	    };
	  })(Marionette);
	  
	
	  // Error
	  // -----
	  
	  var errorProps = ['description', 'fileName', 'lineNumber', 'name', 'message', 'number'];
	  
	  Marionette.Error = Marionette.extend.call(Error, {
	    urlRoot: 'http://marionettejs.com/docs/v' + Marionette.VERSION + '/',
	  
	    constructor: function(message, options) {
	      if (_.isObject(message)) {
	        options = message;
	        message = options.message;
	      } else if (!options) {
	        options = {};
	      }
	  
	      var error = Error.call(this, message);
	      _.extend(this, _.pick(error, errorProps), _.pick(options, errorProps));
	  
	      this.captureStackTrace();
	  
	      if (options.url) {
	        this.url = this.urlRoot + options.url;
	      }
	    },
	  
	    captureStackTrace: function() {
	      if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, Marionette.Error);
	      }
	    },
	  
	    toString: function() {
	      return this.name + ': ' + this.message + (this.url ? ' See: ' + this.url : '');
	    }
	  });
	  
	  Marionette.Error.extend = Marionette.extend;
	  
	  // Callbacks
	  // ---------
	  
	  // A simple way of managing a collection of callbacks
	  // and executing them at a later point in time, using jQuery's
	  // `Deferred` object.
	  Marionette.Callbacks = function() {
	    this._deferred = Marionette.Deferred();
	    this._callbacks = [];
	  };
	  
	  _.extend(Marionette.Callbacks.prototype, {
	  
	    // Add a callback to be executed. Callbacks added here are
	    // guaranteed to execute, even if they are added after the
	    // `run` method is called.
	    add: function(callback, contextOverride) {
	      var promise = _.result(this._deferred, 'promise');
	  
	      this._callbacks.push({cb: callback, ctx: contextOverride});
	  
	      promise.then(function(args) {
	        if (contextOverride){ args.context = contextOverride; }
	        callback.call(args.context, args.options);
	      });
	    },
	  
	    // Run all registered callbacks with the context specified.
	    // Additional callbacks can be added after this has been run
	    // and they will still be executed.
	    run: function(options, context) {
	      this._deferred.resolve({
	        options: options,
	        context: context
	      });
	    },
	  
	    // Resets the list of callbacks to be run, allowing the same list
	    // to be run multiple times - whenever the `run` method is called.
	    reset: function() {
	      var callbacks = this._callbacks;
	      this._deferred = Marionette.Deferred();
	      this._callbacks = [];
	  
	      _.each(callbacks, function(cb) {
	        this.add(cb.cb, cb.ctx);
	      }, this);
	    }
	  });
	  
	  // Controller
	  // ----------
	  
	  // A multi-purpose object to use as a controller for
	  // modules and routers, and as a mediator for workflow
	  // and coordination of other objects, views, and more.
	  Marionette.Controller = function(options) {
	    this.options = options || {};
	  
	    if (_.isFunction(this.initialize)) {
	      this.initialize(this.options);
	    }
	  };
	  
	  Marionette.Controller.extend = Marionette.extend;
	  
	  // Controller Methods
	  // --------------
	  
	  // Ensure it can trigger events with Backbone.Events
	  _.extend(Marionette.Controller.prototype, Backbone.Events, {
	    destroy: function() {
	      Marionette._triggerMethod(this, 'before:destroy', arguments);
	      Marionette._triggerMethod(this, 'destroy', arguments);
	  
	      this.stopListening();
	      this.off();
	      return this;
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption
	  
	  });
	  
	  // Object
	  // ------
	  
	  // A Base Class that other Classes should descend from.
	  // Object borrows many conventions and utilities from Backbone.
	  Marionette.Object = function(options) {
	    this.options = _.extend({}, _.result(this, 'options'), options);
	  
	    this.initialize.apply(this, arguments);
	  };
	  
	  Marionette.Object.extend = Marionette.extend;
	  
	  // Object Methods
	  // --------------
	  
	  // Ensure it can trigger events with Backbone.Events
	  _.extend(Marionette.Object.prototype, Backbone.Events, {
	  
	    //this is a noop method intended to be overridden by classes that extend from this base
	    initialize: function() {},
	  
	    destroy: function() {
	      this.triggerMethod('before:destroy');
	      this.triggerMethod('destroy');
	      this.stopListening();
	    },
	  
	    // Import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  /* jshint maxcomplexity: 16, maxstatements: 45, maxlen: 120 */
	  
	  // Region
	  // ------
	  
	  // Manage the visual regions of your composite application. See
	  // http://lostechies.com/derickbailey/2011/12/12/composite-js-apps-regions-and-region-managers/
	  
	  Marionette.Region = Marionette.Object.extend({
	    constructor: function (options) {
	  
	      // set options temporarily so that we can get `el`.
	      // options will be overriden by Object.constructor
	      this.options = options || {};
	      this.el = this.getOption('el');
	  
	      // Handle when this.el is passed in as a $ wrapped element.
	      this.el = this.el instanceof Backbone.$ ? this.el[0] : this.el;
	  
	      if (!this.el) {
	        throw new Marionette.Error({
	          name: 'NoElError',
	          message: 'An "el" must be specified for a region.'
	        });
	      }
	  
	      this.$el = this.getEl(this.el);
	      Marionette.Object.call(this, options);
	    },
	  
	    // Displays a backbone view instance inside of the region.
	    // Handles calling the `render` method for you. Reads content
	    // directly from the `el` attribute. Also calls an optional
	    // `onShow` and `onDestroy` method on your view, just after showing
	    // or just before destroying the view, respectively.
	    // The `preventDestroy` option can be used to prevent a view from
	    // the old view being destroyed on show.
	    // The `forceShow` option can be used to force a view to be
	    // re-rendered if it's already shown in the region.
	    show: function(view, options){
	      if (!this._ensureElement()) {
	        return;
	      }
	  
	      this._ensureViewIsIntact(view);
	  
	      var showOptions     = options || {};
	      var isDifferentView = view !== this.currentView;
	      var preventDestroy  = !!showOptions.preventDestroy;
	      var forceShow       = !!showOptions.forceShow;
	  
	      // We are only changing the view if there is a current view to change to begin with
	      var isChangingView = !!this.currentView;
	  
	      // Only destroy the current view if we don't want to `preventDestroy` and if
	      // the view given in the first argument is different than `currentView`
	      var _shouldDestroyView = isDifferentView && !preventDestroy;
	  
	      // Only show the view given in the first argument if it is different than
	      // the current view or if we want to re-show the view. Note that if
	      // `_shouldDestroyView` is true, then `_shouldShowView` is also necessarily true.
	      var _shouldShowView = isDifferentView || forceShow;
	  
	      if (isChangingView) {
	        this.triggerMethod('before:swapOut', this.currentView, this, options);
	      }
	  
	      if (this.currentView) {
	        delete this.currentView._parent;
	      }
	  
	      if (_shouldDestroyView) {
	        this.empty();
	  
	      // A `destroy` event is attached to the clean up manually removed views.
	      // We need to detach this event when a new view is going to be shown as it
	      // is no longer relevant.
	      } else if (isChangingView && _shouldShowView) {
	        this.currentView.off('destroy', this.empty, this);
	      }
	  
	      if (_shouldShowView) {
	  
	        // We need to listen for if a view is destroyed
	        // in a way other than through the region.
	        // If this happens we need to remove the reference
	        // to the currentView since once a view has been destroyed
	        // we can not reuse it.
	        view.once('destroy', this.empty, this);
	        view.render();
	  
	        view._parent = this;
	  
	        if (isChangingView) {
	          this.triggerMethod('before:swap', view, this, options);
	        }
	  
	        this.triggerMethod('before:show', view, this, options);
	        Marionette.triggerMethodOn(view, 'before:show', view, this, options);
	  
	        if (isChangingView) {
	          this.triggerMethod('swapOut', this.currentView, this, options);
	        }
	  
	        // An array of views that we're about to display
	        var attachedRegion = Marionette.isNodeAttached(this.el);
	  
	        // The views that we're about to attach to the document
	        // It's important that we prevent _getNestedViews from being executed unnecessarily
	        // as it's a potentially-slow method
	        var displayedViews = [];
	  
	        var triggerBeforeAttach = showOptions.triggerBeforeAttach || this.triggerBeforeAttach;
	        var triggerAttach = showOptions.triggerAttach || this.triggerAttach;
	  
	        if (attachedRegion && triggerBeforeAttach) {
	          displayedViews = this._displayedViews(view);
	          this._triggerAttach(displayedViews, 'before:');
	        }
	  
	        this.attachHtml(view);
	        this.currentView = view;
	  
	        if (attachedRegion && triggerAttach) {
	          displayedViews = this._displayedViews(view);
	          this._triggerAttach(displayedViews);
	        }
	  
	        if (isChangingView) {
	          this.triggerMethod('swap', view, this, options);
	        }
	  
	        this.triggerMethod('show', view, this, options);
	        Marionette.triggerMethodOn(view, 'show', view, this, options);
	  
	        return this;
	      }
	  
	      return this;
	    },
	  
	    triggerBeforeAttach: true,
	    triggerAttach: true,
	  
	    _triggerAttach: function(views, prefix) {
	      var eventName = (prefix || '') + 'attach';
	      _.each(views, function(view) {
	        Marionette.triggerMethodOn(view, eventName, view, this);
	      }, this);
	    },
	  
	    _displayedViews: function(view) {
	      return _.union([view], _.result(view, '_getNestedViews') || []);
	    },
	  
	    _ensureElement: function(){
	      if (!_.isObject(this.el)) {
	        this.$el = this.getEl(this.el);
	        this.el = this.$el[0];
	      }
	  
	      if (!this.$el || this.$el.length === 0) {
	        if (this.getOption('allowMissingEl')) {
	          return false;
	        } else {
	          throw new Marionette.Error('An "el" ' + this.$el.selector + ' must exist in DOM');
	        }
	      }
	      return true;
	    },
	  
	    _ensureViewIsIntact: function(view) {
	      if (!view) {
	        throw new Marionette.Error({
	          name: 'ViewNotValid',
	          message: 'The view passed is undefined and therefore invalid. You must pass a view instance to show.'
	        });
	      }
	  
	      if (view.isDestroyed) {
	        throw new Marionette.Error({
	          name: 'ViewDestroyedError',
	          message: 'View (cid: "' + view.cid + '") has already been destroyed and cannot be used.'
	        });
	      }
	    },
	  
	    // Override this method to change how the region finds the DOM
	    // element that it manages. Return a jQuery selector object scoped
	    // to a provided parent el or the document if none exists.
	    getEl: function(el) {
	      return Backbone.$(el, Marionette._getValue(this.options.parentEl, this));
	    },
	  
	    // Override this method to change how the new view is
	    // appended to the `$el` that the region is managing
	    attachHtml: function(view) {
	      this.$el.contents().detach();
	  
	      this.el.appendChild(view.el);
	    },
	  
	    // Destroy the current view, if there is one. If there is no
	    // current view, it does nothing and returns immediately.
	    empty: function() {
	      var view = this.currentView;
	  
	      // If there is no view in the region
	      // we should not remove anything
	      if (!view) { return; }
	  
	      view.off('destroy', this.empty, this);
	      this.triggerMethod('before:empty', view);
	      this._destroyView();
	      this.triggerMethod('empty', view);
	  
	      // Remove region pointer to the currentView
	      delete this.currentView;
	      return this;
	    },
	  
	    // call 'destroy' or 'remove', depending on which is found
	    // on the view (if showing a raw Backbone view or a Marionette View)
	    _destroyView: function() {
	      var view = this.currentView;
	  
	      if (view.destroy && !view.isDestroyed) {
	        view.destroy();
	      } else if (view.remove) {
	        view.remove();
	  
	        // appending isDestroyed to raw Backbone View allows regions
	        // to throw a ViewDestroyedError for this view
	        view.isDestroyed = true;
	      }
	    },
	  
	    // Attach an existing view to the region. This
	    // will not call `render` or `onShow` for the new view,
	    // and will not replace the current HTML for the `el`
	    // of the region.
	    attachView: function(view) {
	      this.currentView = view;
	      return this;
	    },
	  
	    // Checks whether a view is currently present within
	    // the region. Returns `true` if there is and `false` if
	    // no view is present.
	    hasView: function() {
	      return !!this.currentView;
	    },
	  
	    // Reset the region by destroying any existing view and
	    // clearing out the cached `$el`. The next time a view
	    // is shown via this region, the region will re-query the
	    // DOM for the region's `el`.
	    reset: function() {
	      this.empty();
	  
	      if (this.$el) {
	        this.el = this.$el.selector;
	      }
	  
	      delete this.$el;
	      return this;
	    }
	  
	  },
	  
	  // Static Methods
	  {
	  
	    // Build an instance of a region by passing in a configuration object
	    // and a default region class to use if none is specified in the config.
	    //
	    // The config object should either be a string as a jQuery DOM selector,
	    // a Region class directly, or an object literal that specifies a selector,
	    // a custom regionClass, and any options to be supplied to the region:
	    //
	    // ```js
	    // {
	    //   selector: "#foo",
	    //   regionClass: MyCustomRegion,
	    //   allowMissingEl: false
	    // }
	    // ```
	    //
	    buildRegion: function(regionConfig, DefaultRegionClass) {
	      if (_.isString(regionConfig)) {
	        return this._buildRegionFromSelector(regionConfig, DefaultRegionClass);
	      }
	  
	      if (regionConfig.selector || regionConfig.el || regionConfig.regionClass) {
	        return this._buildRegionFromObject(regionConfig, DefaultRegionClass);
	      }
	  
	      if (_.isFunction(regionConfig)) {
	        return this._buildRegionFromRegionClass(regionConfig);
	      }
	  
	      throw new Marionette.Error({
	        message: 'Improper region configuration type.',
	        url: 'marionette.region.html#region-configuration-types'
	      });
	    },
	  
	    // Build the region from a string selector like '#foo-region'
	    _buildRegionFromSelector: function(selector, DefaultRegionClass) {
	      return new DefaultRegionClass({ el: selector });
	    },
	  
	    // Build the region from a configuration object
	    // ```js
	    // { selector: '#foo', regionClass: FooRegion, allowMissingEl: false }
	    // ```
	    _buildRegionFromObject: function(regionConfig, DefaultRegionClass) {
	      var RegionClass = regionConfig.regionClass || DefaultRegionClass;
	      var options = _.omit(regionConfig, 'selector', 'regionClass');
	  
	      if (regionConfig.selector && !options.el) {
	        options.el = regionConfig.selector;
	      }
	  
	      return new RegionClass(options);
	    },
	  
	    // Build the region directly from a given `RegionClass`
	    _buildRegionFromRegionClass: function(RegionClass) {
	      return new RegionClass();
	    }
	  });
	  
	  // Region Manager
	  // --------------
	  
	  // Manage one or more related `Marionette.Region` objects.
	  Marionette.RegionManager = Marionette.Controller.extend({
	    constructor: function(options) {
	      this._regions = {};
	  
	      Marionette.Controller.call(this, options);
	  
	      this.addRegions(this.getOption('regions'));
	    },
	  
	    // Add multiple regions using an object literal or a
	    // function that returns an object literal, where
	    // each key becomes the region name, and each value is
	    // the region definition.
	    addRegions: function(regionDefinitions, defaults) {
	      regionDefinitions = Marionette._getValue(regionDefinitions, this, arguments);
	  
	      return _.reduce(regionDefinitions, function(regions, definition, name) {
	        if (_.isString(definition)) {
	          definition = {selector: definition};
	        }
	        if (definition.selector) {
	          definition = _.defaults({}, definition, defaults);
	        }
	  
	        regions[name] = this.addRegion(name, definition);
	        return regions;
	      }, {}, this);
	    },
	  
	    // Add an individual region to the region manager,
	    // and return the region instance
	    addRegion: function(name, definition) {
	      var region;
	  
	      if (definition instanceof Marionette.Region) {
	        region = definition;
	      } else {
	        region = Marionette.Region.buildRegion(definition, Marionette.Region);
	      }
	  
	      this.triggerMethod('before:add:region', name, region);
	  
	      region._parent = this;
	      this._store(name, region);
	  
	      this.triggerMethod('add:region', name, region);
	      return region;
	    },
	  
	    // Get a region by name
	    get: function(name) {
	      return this._regions[name];
	    },
	  
	    // Gets all the regions contained within
	    // the `regionManager` instance.
	    getRegions: function(){
	      return _.clone(this._regions);
	    },
	  
	    // Remove a region by name
	    removeRegion: function(name) {
	      var region = this._regions[name];
	      this._remove(name, region);
	  
	      return region;
	    },
	  
	    // Empty all regions in the region manager, and
	    // remove them
	    removeRegions: function() {
	      var regions = this.getRegions();
	      _.each(this._regions, function(region, name) {
	        this._remove(name, region);
	      }, this);
	  
	      return regions;
	    },
	  
	    // Empty all regions in the region manager, but
	    // leave them attached
	    emptyRegions: function() {
	      var regions = this.getRegions();
	      _.invoke(regions, 'empty');
	      return regions;
	    },
	  
	    // Destroy all regions and shut down the region
	    // manager entirely
	    destroy: function() {
	      this.removeRegions();
	      return Marionette.Controller.prototype.destroy.apply(this, arguments);
	    },
	  
	    // internal method to store regions
	    _store: function(name, region) {
	      this._regions[name] = region;
	      this._setLength();
	    },
	  
	    // internal method to remove a region
	    _remove: function(name, region) {
	      this.triggerMethod('before:remove:region', name, region);
	      region.empty();
	      region.stopListening();
	  
	      delete region._parent;
	      delete this._regions[name];
	      this._setLength();
	      this.triggerMethod('remove:region', name, region);
	    },
	  
	    // set the number of regions current held
	    _setLength: function() {
	      this.length = _.size(this._regions);
	    }
	  });
	  
	  Marionette.actAsCollection(Marionette.RegionManager.prototype, '_regions');
	  
	
	  // Template Cache
	  // --------------
	  
	  // Manage templates stored in `<script>` blocks,
	  // caching them for faster access.
	  Marionette.TemplateCache = function(templateId) {
	    this.templateId = templateId;
	  };
	  
	  // TemplateCache object-level methods. Manage the template
	  // caches from these method calls instead of creating
	  // your own TemplateCache instances
	  _.extend(Marionette.TemplateCache, {
	    templateCaches: {},
	  
	    // Get the specified template by id. Either
	    // retrieves the cached version, or loads it
	    // from the DOM.
	    get: function(templateId) {
	      var cachedTemplate = this.templateCaches[templateId];
	  
	      if (!cachedTemplate) {
	        cachedTemplate = new Marionette.TemplateCache(templateId);
	        this.templateCaches[templateId] = cachedTemplate;
	      }
	  
	      return cachedTemplate.load();
	    },
	  
	    // Clear templates from the cache. If no arguments
	    // are specified, clears all templates:
	    // `clear()`
	    //
	    // If arguments are specified, clears each of the
	    // specified templates from the cache:
	    // `clear("#t1", "#t2", "...")`
	    clear: function() {
	      var i;
	      var args = _.toArray(arguments);
	      var length = args.length;
	  
	      if (length > 0) {
	        for (i = 0; i < length; i++) {
	          delete this.templateCaches[args[i]];
	        }
	      } else {
	        this.templateCaches = {};
	      }
	    }
	  });
	  
	  // TemplateCache instance methods, allowing each
	  // template cache object to manage its own state
	  // and know whether or not it has been loaded
	  _.extend(Marionette.TemplateCache.prototype, {
	  
	    // Internal method to load the template
	    load: function() {
	      // Guard clause to prevent loading this template more than once
	      if (this.compiledTemplate) {
	        return this.compiledTemplate;
	      }
	  
	      // Load the template and compile it
	      var template = this.loadTemplate(this.templateId);
	      this.compiledTemplate = this.compileTemplate(template);
	  
	      return this.compiledTemplate;
	    },
	  
	    // Load a template from the DOM, by default. Override
	    // this method to provide your own template retrieval
	    // For asynchronous loading with AMD/RequireJS, consider
	    // using a template-loader plugin as described here:
	    // https://github.com/marionettejs/backbone.marionette/wiki/Using-marionette-with-requirejs
	    loadTemplate: function(templateId) {
	      var template = Backbone.$(templateId).html();
	  
	      if (!template || template.length === 0) {
	        throw new Marionette.Error({
	          name: 'NoTemplateError',
	          message: 'Could not find template: "' + templateId + '"'
	        });
	      }
	  
	      return template;
	    },
	  
	    // Pre-compile the template before caching it. Override
	    // this method if you do not need to pre-compile a template
	    // (JST / RequireJS for example) or if you want to change
	    // the template engine used (Handebars, etc).
	    compileTemplate: function(rawTemplate) {
	      return _.template(rawTemplate);
	    }
	  });
	  
	  // Renderer
	  // --------
	  
	  // Render a template with data by passing in the template
	  // selector and the data to render.
	  Marionette.Renderer = {
	  
	    // Render a template with data. The `template` parameter is
	    // passed to the `TemplateCache` object to retrieve the
	    // template function. Override this method to provide your own
	    // custom rendering and template handling for all of Marionette.
	    render: function(template, data) {
	      if (!template) {
	        throw new Marionette.Error({
	          name: 'TemplateNotFoundError',
	          message: 'Cannot render the template since its false, null or undefined.'
	        });
	      }
	  
	      var templateFunc = _.isFunction(template) ? template : Marionette.TemplateCache.get(template);
	  
	      return templateFunc(data);
	    }
	  };
	  
	
	  /* jshint maxlen: 114, nonew: false */
	  // View
	  // ----
	  
	  // The core view class that other Marionette views extend from.
	  Marionette.View = Backbone.View.extend({
	    isDestroyed: false,
	  
	    constructor: function(options) {
	      _.bindAll(this, 'render');
	  
	      options = Marionette._getValue(options, this);
	  
	      // this exposes view options to the view initializer
	      // this is a backfill since backbone removed the assignment
	      // of this.options
	      // at some point however this may be removed
	      this.options = _.extend({}, _.result(this, 'options'), options);
	  
	      this._behaviors = Marionette.Behaviors(this);
	  
	      Backbone.View.apply(this, arguments);
	  
	      Marionette.MonitorDOMRefresh(this);
	      this.on('show', this.onShowCalled);
	    },
	  
	    // Get the template for this view
	    // instance. You can set a `template` attribute in the view
	    // definition or pass a `template: "whatever"` parameter in
	    // to the constructor options.
	    getTemplate: function() {
	      return this.getOption('template');
	    },
	  
	    // Serialize a model by returning its attributes. Clones
	    // the attributes to allow modification.
	    serializeModel: function(model){
	      return model.toJSON.apply(model, _.rest(arguments));
	    },
	  
	    // Mix in template helper methods. Looks for a
	    // `templateHelpers` attribute, which can either be an
	    // object literal, or a function that returns an object
	    // literal. All methods and attributes from this object
	    // are copies to the object passed in.
	    mixinTemplateHelpers: function(target) {
	      target = target || {};
	      var templateHelpers = this.getOption('templateHelpers');
	      templateHelpers = Marionette._getValue(templateHelpers, this);
	      return _.extend(target, templateHelpers);
	    },
	  
	    // normalize the keys of passed hash with the views `ui` selectors.
	    // `{"@ui.foo": "bar"}`
	    normalizeUIKeys: function(hash) {
	      var uiBindings = _.result(this, '_uiBindings');
	      return Marionette.normalizeUIKeys(hash, uiBindings || _.result(this, 'ui'));
	    },
	  
	    // normalize the values of passed hash with the views `ui` selectors.
	    // `{foo: "@ui.bar"}`
	    normalizeUIValues: function(hash) {
	      var ui = _.result(this, 'ui');
	      var uiBindings = _.result(this, '_uiBindings');
	      return Marionette.normalizeUIValues(hash, uiBindings || ui);
	    },
	  
	    // Configure `triggers` to forward DOM events to view
	    // events. `triggers: {"click .foo": "do:foo"}`
	    configureTriggers: function() {
	      if (!this.triggers) { return; }
	  
	      // Allow `triggers` to be configured as a function
	      var triggers = this.normalizeUIKeys(_.result(this, 'triggers'));
	  
	      // Configure the triggers, prevent default
	      // action and stop propagation of DOM events
	      return _.reduce(triggers, function(events, value, key) {
	        events[key] = this._buildViewTrigger(value);
	        return events;
	      }, {}, this);
	    },
	  
	    // Overriding Backbone.View's delegateEvents to handle
	    // the `triggers`, `modelEvents`, and `collectionEvents` configuration
	    delegateEvents: function(events) {
	      this._delegateDOMEvents(events);
	      this.bindEntityEvents(this.model, this.getOption('modelEvents'));
	      this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));
	  
	      _.each(this._behaviors, function(behavior) {
	        behavior.bindEntityEvents(this.model, behavior.getOption('modelEvents'));
	        behavior.bindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	      }, this);
	  
	      return this;
	    },
	  
	    // internal method to delegate DOM events and triggers
	    _delegateDOMEvents: function(eventsArg) {
	      var events = Marionette._getValue(eventsArg || this.events, this);
	  
	      // normalize ui keys
	      events = this.normalizeUIKeys(events);
	      if(_.isUndefined(eventsArg)) {this.events = events;}
	  
	      var combinedEvents = {};
	  
	      // look up if this view has behavior events
	      var behaviorEvents = _.result(this, 'behaviorEvents') || {};
	      var triggers = this.configureTriggers();
	      var behaviorTriggers = _.result(this, 'behaviorTriggers') || {};
	  
	      // behavior events will be overriden by view events and or triggers
	      _.extend(combinedEvents, behaviorEvents, events, triggers, behaviorTriggers);
	  
	      Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
	    },
	  
	    // Overriding Backbone.View's undelegateEvents to handle unbinding
	    // the `triggers`, `modelEvents`, and `collectionEvents` config
	    undelegateEvents: function() {
	      Backbone.View.prototype.undelegateEvents.apply(this, arguments);
	  
	      this.unbindEntityEvents(this.model, this.getOption('modelEvents'));
	      this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));
	  
	      _.each(this._behaviors, function(behavior) {
	        behavior.unbindEntityEvents(this.model, behavior.getOption('modelEvents'));
	        behavior.unbindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	      }, this);
	  
	      return this;
	    },
	  
	    // Internal method, handles the `show` event.
	    onShowCalled: function() {},
	  
	    // Internal helper method to verify whether the view hasn't been destroyed
	    _ensureViewIsIntact: function() {
	      if (this.isDestroyed) {
	        throw new Marionette.Error({
	          name: 'ViewDestroyedError',
	          message: 'View (cid: "' + this.cid + '") has already been destroyed and cannot be used.'
	        });
	      }
	    },
	  
	    // Default `destroy` implementation, for removing a view from the
	    // DOM and unbinding it. Regions will call this method
	    // for you. You can specify an `onDestroy` method in your view to
	    // add custom code that is called after the view is destroyed.
	    destroy: function() {
	      if (this.isDestroyed) { return; }
	  
	      var args = _.toArray(arguments);
	  
	      this.triggerMethod.apply(this, ['before:destroy'].concat(args));
	  
	      // mark as destroyed before doing the actual destroy, to
	      // prevent infinite loops within "destroy" event handlers
	      // that are trying to destroy other views
	      this.isDestroyed = true;
	      this.triggerMethod.apply(this, ['destroy'].concat(args));
	  
	      // unbind UI elements
	      this.unbindUIElements();
	  
	      // remove the view from the DOM
	      this.remove();
	  
	      // Call destroy on each behavior after
	      // destroying the view.
	      // This unbinds event listeners
	      // that behaviors have registered for.
	      _.invoke(this._behaviors, 'destroy', args);
	  
	      return this;
	    },
	  
	    bindUIElements: function() {
	      this._bindUIElements();
	      _.invoke(this._behaviors, this._bindUIElements);
	    },
	  
	    // This method binds the elements specified in the "ui" hash inside the view's code with
	    // the associated jQuery selectors.
	    _bindUIElements: function() {
	      if (!this.ui) { return; }
	  
	      // store the ui hash in _uiBindings so they can be reset later
	      // and so re-rendering the view will be able to find the bindings
	      if (!this._uiBindings) {
	        this._uiBindings = this.ui;
	      }
	  
	      // get the bindings result, as a function or otherwise
	      var bindings = _.result(this, '_uiBindings');
	  
	      // empty the ui so we don't have anything to start with
	      this.ui = {};
	  
	      // bind each of the selectors
	      _.each(bindings, function(selector, key) {
	        this.ui[key] = this.$(selector);
	      }, this);
	    },
	  
	    // This method unbinds the elements specified in the "ui" hash
	    unbindUIElements: function() {
	      this._unbindUIElements();
	      _.invoke(this._behaviors, this._unbindUIElements);
	    },
	  
	    _unbindUIElements: function() {
	      if (!this.ui || !this._uiBindings) { return; }
	  
	      // delete all of the existing ui bindings
	      _.each(this.ui, function($el, name) {
	        delete this.ui[name];
	      }, this);
	  
	      // reset the ui element to the original bindings configuration
	      this.ui = this._uiBindings;
	      delete this._uiBindings;
	    },
	  
	    // Internal method to create an event handler for a given `triggerDef` like
	    // 'click:foo'
	    _buildViewTrigger: function(triggerDef) {
	      var hasOptions = _.isObject(triggerDef);
	  
	      var options = _.defaults({}, (hasOptions ? triggerDef : {}), {
	        preventDefault: true,
	        stopPropagation: true
	      });
	  
	      var eventName = hasOptions ? options.event : triggerDef;
	  
	      return function(e) {
	        if (e) {
	          if (e.preventDefault && options.preventDefault) {
	            e.preventDefault();
	          }
	  
	          if (e.stopPropagation && options.stopPropagation) {
	            e.stopPropagation();
	          }
	        }
	  
	        var args = {
	          view: this,
	          model: this.model,
	          collection: this.collection
	        };
	  
	        this.triggerMethod(eventName, args);
	      };
	    },
	  
	    setElement: function() {
	      var ret = Backbone.View.prototype.setElement.apply(this, arguments);
	  
	      // proxy behavior $el to the view's $el.
	      // This is needed because a view's $el proxy
	      // is not set until after setElement is called.
	      _.invoke(this._behaviors, 'proxyViewProperties', this);
	  
	      return ret;
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: function() {
	      var triggerMethod = Marionette._triggerMethod;
	      var ret = triggerMethod(this, arguments);
	      var behaviors = this._behaviors;
	      // Use good ol' for as this is a very hot function
	      for (var i = 0, length = behaviors && behaviors.length; i < length; i++) {
	        triggerMethod(behaviors[i], arguments);
	      }
	  
	      return ret;
	    },
	  
	    // This method returns any views that are immediate
	    // children of this view
	    _getImmediateChildren: function() {
	      return [];
	    },
	  
	    // Returns an array of every nested view within this view
	    _getNestedViews: function() {
	      var children = this._getImmediateChildren();
	  
	      if (!children.length) { return children; }
	  
	      return _.reduce(children, function(memo, view) {
	        if (!view._getNestedViews) { return memo; }
	        return memo.concat(view._getNestedViews());
	      }, children);
	    },
	  
	    // Imports the "normalizeMethods" to transform hashes of
	    // events=>function references/names to a hash of events=>function references
	    normalizeMethods: Marionette.normalizeMethods,
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    // Proxy `bindEntityEvents` to enable binding view's events from another entity.
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    // Proxy `unbindEntityEvents` to enable unbinding view's events from another entity.
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  // Item View
	  // ---------
	  
	  // A single item view implementation that contains code for rendering
	  // with underscore.js templates, serializing the view's model or collection,
	  // and calling several methods on extended views, such as `onRender`.
	  Marionette.ItemView = Marionette.View.extend({
	  
	    // Setting up the inheritance chain which allows changes to
	    // Marionette.View.prototype.constructor which allows overriding
	    constructor: function() {
	      Marionette.View.apply(this, arguments);
	    },
	  
	    // Serialize the model or collection for the view. If a model is
	    // found, the view's `serializeModel` is called. If a collection is found,
	    // each model in the collection is serialized by calling
	    // the view's `serializeCollection` and put into an `items` array in
	    // the resulting data. If both are found, defaults to the model.
	    // You can override the `serializeData` method in your own view definition,
	    // to provide custom serialization for your view's data.
	    serializeData: function(){
	      if (!this.model && !this.collection) {
	        return {};
	      }
	  
	      var args = [this.model || this.collection];
	      if (arguments.length) {
	        args.push.apply(args, arguments);
	      }
	  
	      if (this.model) {
	        return this.serializeModel.apply(this, args);
	      } else {
	        return {
	          items: this.serializeCollection.apply(this, args)
	        };
	      }
	    },
	  
	    // Serialize a collection by serializing each of its models.
	    serializeCollection: function(collection){
	      return collection.toJSON.apply(collection, _.rest(arguments));
	    },
	  
	    // Render the view, defaulting to underscore.js templates.
	    // You can override this in your view definition to provide
	    // a very specific rendering for your view. In general, though,
	    // you should override the `Marionette.Renderer` object to
	    // change how Marionette renders views.
	    render: function() {
	      this._ensureViewIsIntact();
	  
	      this.triggerMethod('before:render', this);
	  
	      this._renderTemplate();
	      this.bindUIElements();
	  
	      this.triggerMethod('render', this);
	  
	      return this;
	    },
	  
	    // Internal method to render the template with the serialized data
	    // and template helpers via the `Marionette.Renderer` object.
	    // Throws an `UndefinedTemplateError` error if the template is
	    // any falsely value but literal `false`.
	    _renderTemplate: function() {
	      var template = this.getTemplate();
	  
	      // Allow template-less item views
	      if (template === false) {
	        return;
	      }
	  
	      if (!template) {
	        throw new Marionette.Error({
	          name: 'UndefinedTemplateError',
	          message: 'Cannot render the template since it is null or undefined.'
	        });
	      }
	  
	      // Add in entity data and template helpers
	      var data = this.serializeData();
	      data = this.mixinTemplateHelpers(data);
	  
	      // Render and add to el
	      var html = Marionette.Renderer.render(template, data, this);
	      this.attachElContent(html);
	  
	      return this;
	    },
	  
	    // Attaches the content of a given view.
	    // This method can be overridden to optimize rendering,
	    // or to render in a non standard way.
	    //
	    // For example, using `innerHTML` instead of `$el.html`
	    //
	    // ```js
	    // attachElContent: function(html) {
	    //   this.el.innerHTML = html;
	    //   return this;
	    // }
	    // ```
	    attachElContent: function(html) {
	      this.$el.html(html);
	  
	      return this;
	    }
	  });
	  
	  /* jshint maxstatements: 14 */
	  
	  // Collection View
	  // ---------------
	  
	  // A view that iterates over a Backbone.Collection
	  // and renders an individual child view for each model.
	  Marionette.CollectionView = Marionette.View.extend({
	  
	    // used as the prefix for child view events
	    // that are forwarded through the collectionview
	    childViewEventPrefix: 'childview',
	  
	    // constructor
	    // option to pass `{sort: false}` to prevent the `CollectionView` from
	    // maintaining the sorted order of the collection.
	    // This will fallback onto appending childView's to the end.
	    constructor: function(options){
	      var initOptions = options || {};
	      if (_.isUndefined(this.sort)){
	        this.sort = _.isUndefined(initOptions.sort) ? true : initOptions.sort;
	      }
	  
	      this.once('render', this._initialEvents);
	      this._initChildViewStorage();
	  
	      Marionette.View.apply(this, arguments);
	  
	      this.initRenderBuffer();
	    },
	  
	    // Instead of inserting elements one by one into the page,
	    // it's much more performant to insert elements into a document
	    // fragment and then insert that document fragment into the page
	    initRenderBuffer: function() {
	      this.elBuffer = document.createDocumentFragment();
	      this._bufferedChildren = [];
	    },
	  
	    startBuffering: function() {
	      this.initRenderBuffer();
	      this.isBuffering = true;
	    },
	  
	    endBuffering: function() {
	      this.isBuffering = false;
	      this._triggerBeforeShowBufferedChildren();
	      this.attachBuffer(this, this.elBuffer);
	      this._triggerShowBufferedChildren();
	      this.initRenderBuffer();
	    },
	  
	    _triggerBeforeShowBufferedChildren: function() {
	      if (this._isShown) {
	        _.each(this._bufferedChildren, _.partial(this._triggerMethodOnChild, 'before:show'));
	      }
	    },
	  
	    _triggerShowBufferedChildren: function() {
	      if (this._isShown) {
	        _.each(this._bufferedChildren, _.partial(this._triggerMethodOnChild, 'show'));
	  
	        this._bufferedChildren = [];
	      }
	    },
	  
	    // Internal method for _.each loops to call `Marionette.triggerMethodOn` on
	    // a child view
	    _triggerMethodOnChild: function(event, childView) {
	      Marionette.triggerMethodOn(childView, event);
	    },
	  
	    // Configured the initial events that the collection view
	    // binds to.
	    _initialEvents: function() {
	      if (this.collection) {
	        this.listenTo(this.collection, 'add', this._onCollectionAdd);
	        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
	        this.listenTo(this.collection, 'reset', this.render);
	  
	        if (this.sort) {
	          this.listenTo(this.collection, 'sort', this._sortViews);
	        }
	      }
	    },
	  
	    // Handle a child added to the collection
	    _onCollectionAdd: function(child) {
	      this.destroyEmptyView();
	      var ChildView = this.getChildView(child);
	      var index = this.collection.indexOf(child);
	      this.addChild(child, ChildView, index);
	    },
	  
	    // get the child view by model it holds, and remove it
	    _onCollectionRemove: function(model) {
	      var view = this.children.findByModel(model);
	      this.removeChildView(view);
	      this.checkEmpty();
	    },
	  
	    // Override from `Marionette.View` to trigger show on child views
	    onShowCalled: function() {
	      this.children.each(_.partial(this._triggerMethodOnChild, 'show'));
	    },
	  
	    // Render children views. Override this method to
	    // provide your own implementation of a render function for
	    // the collection view.
	    render: function() {
	      this._ensureViewIsIntact();
	      this.triggerMethod('before:render', this);
	      this._renderChildren();
	      this.triggerMethod('render', this);
	      return this;
	    },
	  
	    // Render view after sorting. Override this method to
	    // change how the view renders after a `sort` on the collection.
	    // An example of this would be to only `renderChildren` in a `CompositeView`
	    // rather than the full view.
	    resortView: function() {
	      this.render();
	    },
	  
	    // Internal method. This checks for any changes in the order of the collection.
	    // If the index of any view doesn't match, it will render.
	    _sortViews: function() {
	      // check for any changes in sort order of views
	      var orderChanged = this.collection.find(function(item, index){
	        var view = this.children.findByModel(item);
	        return !view || view._index !== index;
	      }, this);
	  
	      if (orderChanged) {
	        this.resortView();
	      }
	    },
	  
	    // Internal reference to what index a `emptyView` is.
	    _emptyViewIndex: -1,
	  
	    // Internal method. Separated so that CompositeView can have
	    // more control over events being triggered, around the rendering
	    // process
	    _renderChildren: function() {
	      this.destroyEmptyView();
	      this.destroyChildren();
	  
	      if (this.isEmpty(this.collection)) {
	        this.showEmptyView();
	      } else {
	        this.triggerMethod('before:render:collection', this);
	        this.startBuffering();
	        this.showCollection();
	        this.endBuffering();
	        this.triggerMethod('render:collection', this);
	      }
	    },
	  
	    // Internal method to loop through collection and show each child view.
	    showCollection: function() {
	      var ChildView;
	      this.collection.each(function(child, index) {
	        ChildView = this.getChildView(child);
	        this.addChild(child, ChildView, index);
	      }, this);
	    },
	  
	    // Internal method to show an empty view in place of
	    // a collection of child views, when the collection is empty
	    showEmptyView: function() {
	      var EmptyView = this.getEmptyView();
	  
	      if (EmptyView && !this._showingEmptyView) {
	        this.triggerMethod('before:render:empty');
	  
	        this._showingEmptyView = true;
	        var model = new Backbone.Model();
	        this.addEmptyView(model, EmptyView);
	  
	        this.triggerMethod('render:empty');
	      }
	    },
	  
	    // Internal method to destroy an existing emptyView instance
	    // if one exists. Called when a collection view has been
	    // rendered empty, and then a child is added to the collection.
	    destroyEmptyView: function() {
	      if (this._showingEmptyView) {
	        this.triggerMethod('before:remove:empty');
	  
	        this.destroyChildren();
	        delete this._showingEmptyView;
	  
	        this.triggerMethod('remove:empty');
	      }
	    },
	  
	    // Retrieve the empty view class
	    getEmptyView: function() {
	      return this.getOption('emptyView');
	    },
	  
	    // Render and show the emptyView. Similar to addChild method
	    // but "add:child" events are not fired, and the event from
	    // emptyView are not forwarded
	    addEmptyView: function(child, EmptyView) {
	  
	      // get the emptyViewOptions, falling back to childViewOptions
	      var emptyViewOptions = this.getOption('emptyViewOptions') ||
	                            this.getOption('childViewOptions');
	  
	      if (_.isFunction(emptyViewOptions)){
	        emptyViewOptions = emptyViewOptions.call(this, child, this._emptyViewIndex);
	      }
	  
	      // build the empty view
	      var view = this.buildChildView(child, EmptyView, emptyViewOptions);
	  
	      view._parent = this;
	  
	      // Proxy emptyView events
	      this.proxyChildEvents(view);
	  
	      // trigger the 'before:show' event on `view` if the collection view
	      // has already been shown
	      if (this._isShown) {
	        Marionette.triggerMethodOn(view, 'before:show');
	      }
	  
	      // Store the `emptyView` like a `childView` so we can properly
	      // remove and/or close it later
	      this.children.add(view);
	  
	      // Render it and show it
	      this.renderChildView(view, this._emptyViewIndex);
	  
	      // call the 'show' method if the collection view
	      // has already been shown
	      if (this._isShown) {
	        Marionette.triggerMethodOn(view, 'show');
	      }
	    },
	  
	    // Retrieve the `childView` class, either from `this.options.childView`
	    // or from the `childView` in the object definition. The "options"
	    // takes precedence.
	    // This method receives the model that will be passed to the instance
	    // created from this `childView`. Overriding methods may use the child
	    // to determine what `childView` class to return.
	    getChildView: function(child) {
	      var childView = this.getOption('childView');
	  
	      if (!childView) {
	        throw new Marionette.Error({
	          name: 'NoChildViewError',
	          message: 'A "childView" must be specified'
	        });
	      }
	  
	      return childView;
	    },
	  
	    // Render the child's view and add it to the
	    // HTML for the collection view at a given index.
	    // This will also update the indices of later views in the collection
	    // in order to keep the children in sync with the collection.
	    addChild: function(child, ChildView, index) {
	      var childViewOptions = this.getOption('childViewOptions');
	      childViewOptions = Marionette._getValue(childViewOptions, this, [child, index]);
	  
	      var view = this.buildChildView(child, ChildView, childViewOptions);
	  
	      // increment indices of views after this one
	      this._updateIndices(view, true, index);
	  
	      this._addChildView(view, index);
	  
	      view._parent = this;
	  
	      return view;
	    },
	  
	    // Internal method. This decrements or increments the indices of views after the
	    // added/removed view to keep in sync with the collection.
	    _updateIndices: function(view, increment, index) {
	      if (!this.sort) {
	        return;
	      }
	  
	      if (increment) {
	        // assign the index to the view
	        view._index = index;
	      }
	  
	      // update the indexes of views after this one
	      this.children.each(function (laterView) {
	        if (laterView._index >= view._index) {
	          laterView._index += increment ? 1 : -1;
	        }
	      });
	    },
	  
	  
	    // Internal Method. Add the view to children and render it at
	    // the given index.
	    _addChildView: function(view, index) {
	      // set up the child view event forwarding
	      this.proxyChildEvents(view);
	  
	      this.triggerMethod('before:add:child', view);
	  
	      // Store the child view itself so we can properly
	      // remove and/or destroy it later
	      this.children.add(view);
	      this.renderChildView(view, index);
	  
	      if (this._isShown && !this.isBuffering) {
	        Marionette.triggerMethodOn(view, 'show');
	      }
	  
	      this.triggerMethod('add:child', view);
	    },
	  
	    // render the child view
	    renderChildView: function(view, index) {
	      view.render();
	      this.attachHtml(this, view, index);
	      return view;
	    },
	  
	    // Build a `childView` for a model in the collection.
	    buildChildView: function(child, ChildViewClass, childViewOptions) {
	      var options = _.extend({model: child}, childViewOptions);
	      return new ChildViewClass(options);
	    },
	  
	    // Remove the child view and destroy it.
	    // This function also updates the indices of
	    // later views in the collection in order to keep
	    // the children in sync with the collection.
	    removeChildView: function(view) {
	  
	      if (view) {
	        this.triggerMethod('before:remove:child', view);
	        // call 'destroy' or 'remove', depending on which is found
	        if (view.destroy) { view.destroy(); }
	        else if (view.remove) { view.remove(); }
	  
	        delete view._parent;
	        this.stopListening(view);
	        this.children.remove(view);
	        this.triggerMethod('remove:child', view);
	  
	        // decrement the index of views after this one
	        this._updateIndices(view, false);
	      }
	  
	      return view;
	    },
	  
	    // check if the collection is empty
	    isEmpty: function() {
	      return !this.collection || this.collection.length === 0;
	    },
	  
	    // If empty, show the empty view
	    checkEmpty: function() {
	      if (this.isEmpty(this.collection)) {
	        this.showEmptyView();
	      }
	    },
	  
	    // You might need to override this if you've overridden attachHtml
	    attachBuffer: function(collectionView, buffer) {
	      collectionView.$el.append(buffer);
	    },
	  
	    // Append the HTML to the collection's `el`.
	    // Override this method to do something other
	    // than `.append`.
	    attachHtml: function(collectionView, childView, index) {
	      if (collectionView.isBuffering) {
	        // buffering happens on reset events and initial renders
	        // in order to reduce the number of inserts into the
	        // document, which are expensive.
	        collectionView.elBuffer.appendChild(childView.el);
	        collectionView._bufferedChildren.push(childView);
	      }
	      else {
	        // If we've already rendered the main collection, append
	        // the new child into the correct order if we need to. Otherwise
	        // append to the end.
	        if (!collectionView._insertBefore(childView, index)){
	          collectionView._insertAfter(childView);
	        }
	      }
	    },
	  
	    // Internal method. Check whether we need to insert the view into
	    // the correct position.
	    _insertBefore: function(childView, index) {
	      var currentView;
	      var findPosition = this.sort && (index < this.children.length - 1);
	      if (findPosition) {
	        // Find the view after this one
	        currentView = this.children.find(function (view) {
	          return view._index === index + 1;
	        });
	      }
	  
	      if (currentView) {
	        currentView.$el.before(childView.el);
	        return true;
	      }
	  
	      return false;
	    },
	  
	    // Internal method. Append a view to the end of the $el
	    _insertAfter: function(childView) {
	      this.$el.append(childView.el);
	    },
	  
	    // Internal method to set up the `children` object for
	    // storing all of the child views
	    _initChildViewStorage: function() {
	      this.children = new Backbone.ChildViewContainer();
	    },
	  
	    // Handle cleanup and other destroying needs for the collection of views
	    destroy: function() {
	      if (this.isDestroyed) { return; }
	  
	      this.triggerMethod('before:destroy:collection');
	      this.destroyChildren();
	      this.triggerMethod('destroy:collection');
	  
	      return Marionette.View.prototype.destroy.apply(this, arguments);
	    },
	  
	    // Destroy the child views that this collection view
	    // is holding on to, if any
	    destroyChildren: function() {
	      var childViews = this.children.map(_.identity);
	      this.children.each(this.removeChildView, this);
	      this.checkEmpty();
	      return childViews;
	    },
	  
	    // Set up the child view event forwarding. Uses a "childview:"
	    // prefix in front of all forwarded events.
	    proxyChildEvents: function(view) {
	      var prefix = this.getOption('childViewEventPrefix');
	  
	      // Forward all child view events through the parent,
	      // prepending "childview:" to the event name
	      this.listenTo(view, 'all', function() {
	        var args = _.toArray(arguments);
	        var rootEvent = args[0];
	        var childEvents = this.normalizeMethods(_.result(this, 'childEvents'));
	  
	        args[0] = prefix + ':' + rootEvent;
	        args.splice(1, 0, view);
	  
	        // call collectionView childEvent if defined
	        if (typeof childEvents !== 'undefined' && _.isFunction(childEvents[rootEvent])) {
	          childEvents[rootEvent].apply(this, args.slice(1));
	        }
	  
	        this.triggerMethod.apply(this, args);
	      }, this);
	    },
	  
	    _getImmediateChildren: function() {
	      return _.values(this.children._views);
	    }
	  });
	  
	  /* jshint maxstatements: 17, maxlen: 117 */
	  
	  // Composite View
	  // --------------
	  
	  // Used for rendering a branch-leaf, hierarchical structure.
	  // Extends directly from CollectionView and also renders an
	  // a child view as `modelView`, for the top leaf
	  Marionette.CompositeView = Marionette.CollectionView.extend({
	  
	    // Setting up the inheritance chain which allows changes to
	    // Marionette.CollectionView.prototype.constructor which allows overriding
	    // option to pass '{sort: false}' to prevent the CompositeView from
	    // maintaining the sorted order of the collection.
	    // This will fallback onto appending childView's to the end.
	    constructor: function() {
	      Marionette.CollectionView.apply(this, arguments);
	    },
	  
	    // Configured the initial events that the composite view
	    // binds to. Override this method to prevent the initial
	    // events, or to add your own initial events.
	    _initialEvents: function() {
	  
	      // Bind only after composite view is rendered to avoid adding child views
	      // to nonexistent childViewContainer
	  
	      if (this.collection) {
	        this.listenTo(this.collection, 'add', this._onCollectionAdd);
	        this.listenTo(this.collection, 'remove', this._onCollectionRemove);
	        this.listenTo(this.collection, 'reset', this._renderChildren);
	  
	        if (this.sort) {
	          this.listenTo(this.collection, 'sort', this._sortViews);
	        }
	      }
	    },
	  
	    // Retrieve the `childView` to be used when rendering each of
	    // the items in the collection. The default is to return
	    // `this.childView` or Marionette.CompositeView if no `childView`
	    // has been defined
	    getChildView: function(child) {
	      var childView = this.getOption('childView') || this.constructor;
	  
	      return childView;
	    },
	  
	    // Serialize the model for the view.
	    // You can override the `serializeData` method in your own view
	    // definition, to provide custom serialization for your view's data.
	    serializeData: function() {
	      var data = {};
	  
	      if (this.model){
	        data = _.partial(this.serializeModel, this.model).apply(this, arguments);
	      }
	  
	      return data;
	    },
	  
	    // Renders the model and the collection.
	    render: function() {
	      this._ensureViewIsIntact();
	      this.isRendered = true;
	      this.resetChildViewContainer();
	  
	      this.triggerMethod('before:render', this);
	  
	      this._renderTemplate();
	      this._renderChildren();
	  
	      this.triggerMethod('render', this);
	      return this;
	    },
	  
	    _renderChildren: function() {
	      if (this.isRendered) {
	        Marionette.CollectionView.prototype._renderChildren.call(this);
	      }
	    },
	  
	    // Render the root template that the children
	    // views are appended to
	    _renderTemplate: function() {
	      var data = {};
	      data = this.serializeData();
	      data = this.mixinTemplateHelpers(data);
	  
	      this.triggerMethod('before:render:template');
	  
	      var template = this.getTemplate();
	      var html = Marionette.Renderer.render(template, data, this);
	      this.attachElContent(html);
	  
	      // the ui bindings is done here and not at the end of render since they
	      // will not be available until after the model is rendered, but should be
	      // available before the collection is rendered.
	      this.bindUIElements();
	      this.triggerMethod('render:template');
	    },
	  
	    // Attaches the content of the root.
	    // This method can be overridden to optimize rendering,
	    // or to render in a non standard way.
	    //
	    // For example, using `innerHTML` instead of `$el.html`
	    //
	    // ```js
	    // attachElContent: function(html) {
	    //   this.el.innerHTML = html;
	    //   return this;
	    // }
	    // ```
	    attachElContent: function(html) {
	      this.$el.html(html);
	  
	      return this;
	    },
	  
	    // You might need to override this if you've overridden attachHtml
	    attachBuffer: function(compositeView, buffer) {
	      var $container = this.getChildViewContainer(compositeView);
	      $container.append(buffer);
	    },
	  
	    // Internal method. Append a view to the end of the $el.
	    // Overidden from CollectionView to ensure view is appended to
	    // childViewContainer
	    _insertAfter: function (childView) {
	      var $container = this.getChildViewContainer(this, childView);
	      $container.append(childView.el);
	    },
	  
	    // Internal method to ensure an `$childViewContainer` exists, for the
	    // `attachHtml` method to use.
	    getChildViewContainer: function(containerView, childView) {
	      if ('$childViewContainer' in containerView) {
	        return containerView.$childViewContainer;
	      }
	  
	      var container;
	      var childViewContainer = Marionette.getOption(containerView, 'childViewContainer');
	      if (childViewContainer) {
	  
	        var selector = Marionette._getValue(childViewContainer, containerView);
	  
	        if (selector.charAt(0) === '@' && containerView.ui) {
	          container = containerView.ui[selector.substr(4)];
	        } else {
	          container = containerView.$(selector);
	        }
	  
	        if (container.length <= 0) {
	          throw new Marionette.Error({
	            name: 'ChildViewContainerMissingError',
	            message: 'The specified "childViewContainer" was not found: ' + containerView.childViewContainer
	          });
	        }
	  
	      } else {
	        container = containerView.$el;
	      }
	  
	      containerView.$childViewContainer = container;
	      return container;
	    },
	  
	    // Internal method to reset the `$childViewContainer` on render
	    resetChildViewContainer: function() {
	      if (this.$childViewContainer) {
	        delete this.$childViewContainer;
	      }
	    }
	  });
	  
	  // Layout View
	  // -----------
	  
	  // Used for managing application layoutViews, nested layoutViews and
	  // multiple regions within an application or sub-application.
	  //
	  // A specialized view class that renders an area of HTML and then
	  // attaches `Region` instances to the specified `regions`.
	  // Used for composite view management and sub-application areas.
	  Marionette.LayoutView = Marionette.ItemView.extend({
	    regionClass: Marionette.Region,
	  
	    // Ensure the regions are available when the `initialize` method
	    // is called.
	    constructor: function(options) {
	      options = options || {};
	  
	      this._firstRender = true;
	      this._initializeRegions(options);
	  
	      Marionette.ItemView.call(this, options);
	    },
	  
	    // LayoutView's render will use the existing region objects the
	    // first time it is called. Subsequent calls will destroy the
	    // views that the regions are showing and then reset the `el`
	    // for the regions to the newly rendered DOM elements.
	    render: function() {
	      this._ensureViewIsIntact();
	  
	      if (this._firstRender) {
	        // if this is the first render, don't do anything to
	        // reset the regions
	        this._firstRender = false;
	      } else {
	        // If this is not the first render call, then we need to
	        // re-initialize the `el` for each region
	        this._reInitializeRegions();
	      }
	  
	      return Marionette.ItemView.prototype.render.apply(this, arguments);
	    },
	  
	    // Handle destroying regions, and then destroy the view itself.
	    destroy: function() {
	      if (this.isDestroyed) { return this; }
	  
	      this.regionManager.destroy();
	      return Marionette.ItemView.prototype.destroy.apply(this, arguments);
	    },
	  
	    // Add a single region, by name, to the layoutView
	    addRegion: function(name, definition) {
	      var regions = {};
	      regions[name] = definition;
	      return this._buildRegions(regions)[name];
	    },
	  
	    // Add multiple regions as a {name: definition, name2: def2} object literal
	    addRegions: function(regions) {
	      this.regions = _.extend({}, this.regions, regions);
	      return this._buildRegions(regions);
	    },
	  
	    // Remove a single region from the LayoutView, by name
	    removeRegion: function(name) {
	      delete this.regions[name];
	      return this.regionManager.removeRegion(name);
	    },
	  
	    // Provides alternative access to regions
	    // Accepts the region name
	    // getRegion('main')
	    getRegion: function(region) {
	      return this.regionManager.get(region);
	    },
	  
	    // Get all regions
	    getRegions: function(){
	      return this.regionManager.getRegions();
	    },
	  
	    // internal method to build regions
	    _buildRegions: function(regions) {
	      var defaults = {
	        regionClass: this.getOption('regionClass'),
	        parentEl: _.partial(_.result, this, 'el')
	      };
	  
	      return this.regionManager.addRegions(regions, defaults);
	    },
	  
	    // Internal method to initialize the regions that have been defined in a
	    // `regions` attribute on this layoutView.
	    _initializeRegions: function(options) {
	      var regions;
	      this._initRegionManager();
	  
	      regions = Marionette._getValue(this.regions, this, [options]) || {};
	  
	      // Enable users to define `regions` as instance options.
	      var regionOptions = this.getOption.call(options, 'regions');
	  
	      // enable region options to be a function
	      regionOptions = Marionette._getValue(regionOptions, this, [options]);
	  
	      _.extend(regions, regionOptions);
	  
	      // Normalize region selectors hash to allow
	      // a user to use the @ui. syntax.
	      regions = this.normalizeUIValues(regions);
	  
	      this.addRegions(regions);
	    },
	  
	    // Internal method to re-initialize all of the regions by updating the `el` that
	    // they point to
	    _reInitializeRegions: function() {
	      this.regionManager.invoke('reset');
	    },
	  
	    // Enable easy overriding of the default `RegionManager`
	    // for customized region interactions and business specific
	    // view logic for better control over single regions.
	    getRegionManager: function() {
	      return new Marionette.RegionManager();
	    },
	  
	    // Internal method to initialize the region manager
	    // and all regions in it
	    _initRegionManager: function() {
	      this.regionManager = this.getRegionManager();
	      this.regionManager._parent = this;
	  
	      this.listenTo(this.regionManager, 'before:add:region', function(name) {
	        this.triggerMethod('before:add:region', name);
	      });
	  
	      this.listenTo(this.regionManager, 'add:region', function(name, region) {
	        this[name] = region;
	        this.triggerMethod('add:region', name, region);
	      });
	  
	      this.listenTo(this.regionManager, 'before:remove:region', function(name) {
	        this.triggerMethod('before:remove:region', name);
	      });
	  
	      this.listenTo(this.regionManager, 'remove:region', function(name, region) {
	        delete this[name];
	        this.triggerMethod('remove:region', name, region);
	      });
	    },
	  
	    _getImmediateChildren: function() {
	      return _.chain(this.regionManager.getRegions())
	        .pluck('currentView')
	        .compact()
	        .value();
	    }
	  });
	  
	
	  // Behavior
	  // --------
	  
	  // A Behavior is an isolated set of DOM /
	  // user interactions that can be mixed into any View.
	  // Behaviors allow you to blackbox View specific interactions
	  // into portable logical chunks, keeping your views simple and your code DRY.
	  
	  Marionette.Behavior = Marionette.Object.extend({
	    constructor: function(options, view) {
	      // Setup reference to the view.
	      // this comes in handle when a behavior
	      // wants to directly talk up the chain
	      // to the view.
	      this.view = view;
	      this.defaults = _.result(this, 'defaults') || {};
	      this.options  = _.extend({}, this.defaults, options);
	  
	      Marionette.Object.apply(this, arguments);
	    },
	  
	    // proxy behavior $ method to the view
	    // this is useful for doing jquery DOM lookups
	    // scoped to behaviors view.
	    $: function() {
	      return this.view.$.apply(this.view, arguments);
	    },
	  
	    // Stops the behavior from listening to events.
	    // Overrides Object#destroy to prevent additional events from being triggered.
	    destroy: function() {
	      this.stopListening();
	    },
	  
	    proxyViewProperties: function (view) {
	      this.$el = view.$el;
	      this.el = view.el;
	    }
	  });
	  
	  /* jshint maxlen: 143 */
	  // Behaviors
	  // ---------
	  
	  // Behaviors is a utility class that takes care of
	  // gluing your behavior instances to their given View.
	  // The most important part of this class is that you
	  // **MUST** override the class level behaviorsLookup
	  // method for things to work properly.
	  
	  Marionette.Behaviors = (function(Marionette, _) {
	    // Borrow event splitter from Backbone
	    var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	  
	    function Behaviors(view, behaviors) {
	  
	      if (!_.isObject(view.behaviors)) {
	        return {};
	      }
	  
	      // Behaviors defined on a view can be a flat object literal
	      // or it can be a function that returns an object.
	      behaviors = Behaviors.parseBehaviors(view, behaviors || _.result(view, 'behaviors'));
	  
	      // Wraps several of the view's methods
	      // calling the methods first on each behavior
	      // and then eventually calling the method on the view.
	      Behaviors.wrap(view, behaviors, _.keys(methods));
	      return behaviors;
	    }
	  
	    var methods = {
	      behaviorTriggers: function(behaviorTriggers, behaviors) {
	        var triggerBuilder = new BehaviorTriggersBuilder(this, behaviors);
	        return triggerBuilder.buildBehaviorTriggers();
	      },
	  
	      behaviorEvents: function(behaviorEvents, behaviors) {
	        var _behaviorsEvents = {};
	        var viewUI = this._uiBindings || _.result(this, 'ui');
	  
	        _.each(behaviors, function(b, i) {
	          var _events = {};
	          var behaviorEvents = _.clone(_.result(b, 'events')) || {};
	          var behaviorUI = b._uiBindings || _.result(b, 'ui');
	  
	          // Construct an internal UI hash first using
	          // the views UI hash and then the behaviors UI hash.
	          // This allows the user to use UI hash elements
	          // defined in the parent view as well as those
	          // defined in the given behavior.
	          var ui = _.extend({}, viewUI, behaviorUI);
	  
	          // Normalize behavior events hash to allow
	          // a user to use the @ui. syntax.
	          behaviorEvents = Marionette.normalizeUIKeys(behaviorEvents, ui);
	  
	          var j = 0;
	          _.each(behaviorEvents, function(behaviour, key) {
	            var match     = key.match(delegateEventSplitter);
	  
	            // Set event name to be namespaced using the view cid,
	            // the behavior index, and the behavior event index
	            // to generate a non colliding event namespace
	            // http://api.jquery.com/event.namespace/
	            var eventName = match[1] + '.' + [this.cid, i, j++, ' '].join(''),
	                selector  = match[2];
	  
	            var eventKey  = eventName + selector;
	            var handler   = _.isFunction(behaviour) ? behaviour : b[behaviour];
	  
	            _events[eventKey] = _.bind(handler, b);
	          }, this);
	  
	          _behaviorsEvents = _.extend(_behaviorsEvents, _events);
	        }, this);
	  
	        return _behaviorsEvents;
	      }
	    };
	  
	    _.extend(Behaviors, {
	  
	      // Placeholder method to be extended by the user.
	      // The method should define the object that stores the behaviors.
	      // i.e.
	      //
	      // ```js
	      // Marionette.Behaviors.behaviorsLookup: function() {
	      //   return App.Behaviors
	      // }
	      // ```
	      behaviorsLookup: function() {
	        throw new Marionette.Error({
	          message: 'You must define where your behaviors are stored.',
	          url: 'marionette.behaviors.html#behaviorslookup'
	        });
	      },
	  
	      // Takes care of getting the behavior class
	      // given options and a key.
	      // If a user passes in options.behaviorClass
	      // default to using that. Otherwise delegate
	      // the lookup to the users `behaviorsLookup` implementation.
	      getBehaviorClass: function(options, key) {
	        if (options.behaviorClass) {
	          return options.behaviorClass;
	        }
	  
	        // Get behavior class can be either a flat object or a method
	        return Marionette._getValue(Behaviors.behaviorsLookup, this, [options, key])[key];
	      },
	  
	      // Iterate over the behaviors object, for each behavior
	      // instantiate it and get its grouped behaviors.
	      parseBehaviors: function(view, behaviors) {
	        return _.chain(behaviors).map(function(options, key) {
	          var BehaviorClass = Behaviors.getBehaviorClass(options, key);
	  
	          var behavior = new BehaviorClass(options, view);
	          var nestedBehaviors = Behaviors.parseBehaviors(view, _.result(behavior, 'behaviors'));
	  
	          return [behavior].concat(nestedBehaviors);
	        }).flatten().value();
	      },
	  
	      // Wrap view internal methods so that they delegate to behaviors. For example,
	      // `onDestroy` should trigger destroy on all of the behaviors and then destroy itself.
	      // i.e.
	      //
	      // `view.delegateEvents = _.partial(methods.delegateEvents, view.delegateEvents, behaviors);`
	      wrap: function(view, behaviors, methodNames) {
	        _.each(methodNames, function(methodName) {
	          view[methodName] = _.partial(methods[methodName], view[methodName], behaviors);
	        });
	      }
	    });
	  
	    // Class to build handlers for `triggers` on behaviors
	    // for views
	    function BehaviorTriggersBuilder(view, behaviors) {
	      this._view      = view;
	      this._viewUI    = _.result(view, 'ui');
	      this._behaviors = behaviors;
	      this._triggers  = {};
	    }
	  
	    _.extend(BehaviorTriggersBuilder.prototype, {
	      // Main method to build the triggers hash with event keys and handlers
	      buildBehaviorTriggers: function() {
	        _.each(this._behaviors, this._buildTriggerHandlersForBehavior, this);
	        return this._triggers;
	      },
	  
	      // Internal method to build all trigger handlers for a given behavior
	      _buildTriggerHandlersForBehavior: function(behavior, i) {
	        var ui = _.extend({}, this._viewUI, _.result(behavior, 'ui'));
	        var triggersHash = _.clone(_.result(behavior, 'triggers')) || {};
	  
	        triggersHash = Marionette.normalizeUIKeys(triggersHash, ui);
	  
	        _.each(triggersHash, _.bind(this._setHandlerForBehavior, this, behavior, i));
	      },
	  
	      // Internal method to create and assign the trigger handler for a given
	      // behavior
	      _setHandlerForBehavior: function(behavior, i, eventName, trigger) {
	        // Unique identifier for the `this._triggers` hash
	        var triggerKey = trigger.replace(/^\S+/, function(triggerName) {
	          return triggerName + '.' + 'behaviortriggers' + i;
	        });
	  
	        this._triggers[triggerKey] = this._view._buildViewTrigger(eventName);
	      }
	    });
	  
	    return Behaviors;
	  
	  })(Marionette, _);
	  
	
	  // App Router
	  // ----------
	  
	  // Reduce the boilerplate code of handling route events
	  // and then calling a single method on another object.
	  // Have your routers configured to call the method on
	  // your object, directly.
	  //
	  // Configure an AppRouter with `appRoutes`.
	  //
	  // App routers can only take one `controller` object.
	  // It is recommended that you divide your controller
	  // objects in to smaller pieces of related functionality
	  // and have multiple routers / controllers, instead of
	  // just one giant router and controller.
	  //
	  // You can also add standard routes to an AppRouter.
	  
	  Marionette.AppRouter = Backbone.Router.extend({
	  
	    constructor: function(options) {
	      this.options = options || {};
	  
	      Backbone.Router.apply(this, arguments);
	  
	      var appRoutes = this.getOption('appRoutes');
	      var controller = this._getController();
	      this.processAppRoutes(controller, appRoutes);
	      this.on('route', this._processOnRoute, this);
	    },
	  
	    // Similar to route method on a Backbone Router but
	    // method is called on the controller
	    appRoute: function(route, methodName) {
	      var controller = this._getController();
	      this._addAppRoute(controller, route, methodName);
	    },
	  
	    // process the route event and trigger the onRoute
	    // method call, if it exists
	    _processOnRoute: function(routeName, routeArgs) {
	      // make sure an onRoute before trying to call it
	      if (_.isFunction(this.onRoute)) {
	        // find the path that matches the current route
	        var routePath = _.invert(this.getOption('appRoutes'))[routeName];
	        this.onRoute(routeName, routePath, routeArgs);
	      }
	    },
	  
	    // Internal method to process the `appRoutes` for the
	    // router, and turn them in to routes that trigger the
	    // specified method on the specified `controller`.
	    processAppRoutes: function(controller, appRoutes) {
	      if (!appRoutes) { return; }
	  
	      var routeNames = _.keys(appRoutes).reverse(); // Backbone requires reverted order of routes
	  
	      _.each(routeNames, function(route) {
	        this._addAppRoute(controller, route, appRoutes[route]);
	      }, this);
	    },
	  
	    _getController: function() {
	      return this.getOption('controller');
	    },
	  
	    _addAppRoute: function(controller, route, methodName) {
	      var method = controller[methodName];
	  
	      if (!method) {
	        throw new Marionette.Error('Method "' + methodName + '" was not found on the controller');
	      }
	  
	      this.route(route, methodName, _.bind(method, controller));
	    },
	  
	    // Proxy `getOption` to enable getting options from this or this.options by name.
	    getOption: Marionette.proxyGetOption,
	  
	    triggerMethod: Marionette.triggerMethod,
	  
	    bindEntityEvents: Marionette.proxyBindEntityEvents,
	  
	    unbindEntityEvents: Marionette.proxyUnbindEntityEvents
	  });
	  
	  // Application
	  // -----------
	  
	  // Contain and manage the composite application as a whole.
	  // Stores and starts up `Region` objects, includes an
	  // event aggregator as `app.vent`
	  Marionette.Application = Marionette.Object.extend({
	    constructor: function(options) {
	      this._initializeRegions(options);
	      this._initCallbacks = new Marionette.Callbacks();
	      this.submodules = {};
	      _.extend(this, options);
	      this._initChannel();
	      Marionette.Object.call(this, options);
	    },
	  
	    // Command execution, facilitated by Backbone.Wreqr.Commands
	    execute: function() {
	      this.commands.execute.apply(this.commands, arguments);
	    },
	  
	    // Request/response, facilitated by Backbone.Wreqr.RequestResponse
	    request: function() {
	      return this.reqres.request.apply(this.reqres, arguments);
	    },
	  
	    // Add an initializer that is either run at when the `start`
	    // method is called, or run immediately if added after `start`
	    // has already been called.
	    addInitializer: function(initializer) {
	      this._initCallbacks.add(initializer);
	    },
	  
	    // kick off all of the application's processes.
	    // initializes all of the regions that have been added
	    // to the app, and runs all of the initializer functions
	    start: function(options) {
	      this.triggerMethod('before:start', options);
	      this._initCallbacks.run(options, this);
	      this.triggerMethod('start', options);
	    },
	  
	    // Add regions to your app.
	    // Accepts a hash of named strings or Region objects
	    // addRegions({something: "#someRegion"})
	    // addRegions({something: Region.extend({el: "#someRegion"}) });
	    addRegions: function(regions) {
	      return this._regionManager.addRegions(regions);
	    },
	  
	    // Empty all regions in the app, without removing them
	    emptyRegions: function() {
	      return this._regionManager.emptyRegions();
	    },
	  
	    // Removes a region from your app, by name
	    // Accepts the regions name
	    // removeRegion('myRegion')
	    removeRegion: function(region) {
	      return this._regionManager.removeRegion(region);
	    },
	  
	    // Provides alternative access to regions
	    // Accepts the region name
	    // getRegion('main')
	    getRegion: function(region) {
	      return this._regionManager.get(region);
	    },
	  
	    // Get all the regions from the region manager
	    getRegions: function(){
	      return this._regionManager.getRegions();
	    },
	  
	    // Create a module, attached to the application
	    module: function(moduleNames, moduleDefinition) {
	  
	      // Overwrite the module class if the user specifies one
	      var ModuleClass = Marionette.Module.getClass(moduleDefinition);
	  
	      var args = _.toArray(arguments);
	      args.unshift(this);
	  
	      // see the Marionette.Module object for more information
	      return ModuleClass.create.apply(ModuleClass, args);
	    },
	  
	    // Enable easy overriding of the default `RegionManager`
	    // for customized region interactions and business-specific
	    // view logic for better control over single regions.
	    getRegionManager: function() {
	      return new Marionette.RegionManager();
	    },
	  
	    // Internal method to initialize the regions that have been defined in a
	    // `regions` attribute on the application instance
	    _initializeRegions: function(options) {
	      var regions = _.isFunction(this.regions) ? this.regions(options) : this.regions || {};
	  
	      this._initRegionManager();
	  
	      // Enable users to define `regions` in instance options.
	      var optionRegions = Marionette.getOption(options, 'regions');
	  
	      // Enable region options to be a function
	      if (_.isFunction(optionRegions)) {
	        optionRegions = optionRegions.call(this, options);
	      }
	  
	      // Overwrite current regions with those passed in options
	      _.extend(regions, optionRegions);
	  
	      this.addRegions(regions);
	  
	      return this;
	    },
	  
	    // Internal method to set up the region manager
	    _initRegionManager: function() {
	      this._regionManager = this.getRegionManager();
	      this._regionManager._parent = this;
	  
	      this.listenTo(this._regionManager, 'before:add:region', function() {
	        Marionette._triggerMethod(this, 'before:add:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'add:region', function(name, region) {
	        this[name] = region;
	        Marionette._triggerMethod(this, 'add:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'before:remove:region', function() {
	        Marionette._triggerMethod(this, 'before:remove:region', arguments);
	      });
	  
	      this.listenTo(this._regionManager, 'remove:region', function(name) {
	        delete this[name];
	        Marionette._triggerMethod(this, 'remove:region', arguments);
	      });
	    },
	  
	    // Internal method to setup the Wreqr.radio channel
	    _initChannel: function() {
	      this.channelName = _.result(this, 'channelName') || 'global';
	      this.channel = _.result(this, 'channel') || Backbone.Wreqr.radio.channel(this.channelName);
	      this.vent = _.result(this, 'vent') || this.channel.vent;
	      this.commands = _.result(this, 'commands') || this.channel.commands;
	      this.reqres = _.result(this, 'reqres') || this.channel.reqres;
	    }
	  });
	  
	  /* jshint maxparams: 9 */
	  
	  // Module
	  // ------
	  
	  // A simple module system, used to create privacy and encapsulation in
	  // Marionette applications
	  Marionette.Module = function(moduleName, app, options) {
	    this.moduleName = moduleName;
	    this.options = _.extend({}, this.options, options);
	    // Allow for a user to overide the initialize
	    // for a given module instance.
	    this.initialize = options.initialize || this.initialize;
	  
	    // Set up an internal store for sub-modules.
	    this.submodules = {};
	  
	    this._setupInitializersAndFinalizers();
	  
	    // Set an internal reference to the app
	    // within a module.
	    this.app = app;
	  
	    if (_.isFunction(this.initialize)) {
	      this.initialize(moduleName, app, this.options);
	    }
	  };
	  
	  Marionette.Module.extend = Marionette.extend;
	  
	  // Extend the Module prototype with events / listenTo, so that the module
	  // can be used as an event aggregator or pub/sub.
	  _.extend(Marionette.Module.prototype, Backbone.Events, {
	  
	    // By default modules start with their parents.
	    startWithParent: true,
	  
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic when extending Marionette.Module.
	    initialize: function() {},
	  
	    // Initializer for a specific module. Initializers are run when the
	    // module's `start` method is called.
	    addInitializer: function(callback) {
	      this._initializerCallbacks.add(callback);
	    },
	  
	    // Finalizers are run when a module is stopped. They are used to teardown
	    // and finalize any variables, references, events and other code that the
	    // module had set up.
	    addFinalizer: function(callback) {
	      this._finalizerCallbacks.add(callback);
	    },
	  
	    // Start the module, and run all of its initializers
	    start: function(options) {
	      // Prevent re-starting a module that is already started
	      if (this._isInitialized) { return; }
	  
	      // start the sub-modules (depth-first hierarchy)
	      _.each(this.submodules, function(mod) {
	        // check to see if we should start the sub-module with this parent
	        if (mod.startWithParent) {
	          mod.start(options);
	        }
	      });
	  
	      // run the callbacks to "start" the current module
	      this.triggerMethod('before:start', options);
	  
	      this._initializerCallbacks.run(options, this);
	      this._isInitialized = true;
	  
	      this.triggerMethod('start', options);
	    },
	  
	    // Stop this module by running its finalizers and then stop all of
	    // the sub-modules for this module
	    stop: function() {
	      // if we are not initialized, don't bother finalizing
	      if (!this._isInitialized) { return; }
	      this._isInitialized = false;
	  
	      this.triggerMethod('before:stop');
	  
	      // stop the sub-modules; depth-first, to make sure the
	      // sub-modules are stopped / finalized before parents
	      _.invoke(this.submodules, 'stop');
	  
	      // run the finalizers
	      this._finalizerCallbacks.run(undefined, this);
	  
	      // reset the initializers and finalizers
	      this._initializerCallbacks.reset();
	      this._finalizerCallbacks.reset();
	  
	      this.triggerMethod('stop');
	    },
	  
	    // Configure the module with a definition function and any custom args
	    // that are to be passed in to the definition function
	    addDefinition: function(moduleDefinition, customArgs) {
	      this._runModuleDefinition(moduleDefinition, customArgs);
	    },
	  
	    // Internal method: run the module definition function with the correct
	    // arguments
	    _runModuleDefinition: function(definition, customArgs) {
	      // If there is no definition short circut the method.
	      if (!definition) { return; }
	  
	      // build the correct list of arguments for the module definition
	      var args = _.flatten([
	        this,
	        this.app,
	        Backbone,
	        Marionette,
	        Backbone.$, _,
	        customArgs
	      ]);
	  
	      definition.apply(this, args);
	    },
	  
	    // Internal method: set up new copies of initializers and finalizers.
	    // Calling this method will wipe out all existing initializers and
	    // finalizers.
	    _setupInitializersAndFinalizers: function() {
	      this._initializerCallbacks = new Marionette.Callbacks();
	      this._finalizerCallbacks = new Marionette.Callbacks();
	    },
	  
	    // import the `triggerMethod` to trigger events with corresponding
	    // methods if the method exists
	    triggerMethod: Marionette.triggerMethod
	  });
	  
	  // Class methods to create modules
	  _.extend(Marionette.Module, {
	  
	    // Create a module, hanging off the app parameter as the parent object.
	    create: function(app, moduleNames, moduleDefinition) {
	      var module = app;
	  
	      // get the custom args passed in after the module definition and
	      // get rid of the module name and definition function
	      var customArgs = _.rest(arguments, 3);
	  
	      // Split the module names and get the number of submodules.
	      // i.e. an example module name of `Doge.Wow.Amaze` would
	      // then have the potential for 3 module definitions.
	      moduleNames = moduleNames.split('.');
	      var length = moduleNames.length;
	  
	      // store the module definition for the last module in the chain
	      var moduleDefinitions = [];
	      moduleDefinitions[length - 1] = moduleDefinition;
	  
	      // Loop through all the parts of the module definition
	      _.each(moduleNames, function(moduleName, i) {
	        var parentModule = module;
	        module = this._getModule(parentModule, moduleName, app, moduleDefinition);
	        this._addModuleDefinition(parentModule, module, moduleDefinitions[i], customArgs);
	      }, this);
	  
	      // Return the last module in the definition chain
	      return module;
	    },
	  
	    _getModule: function(parentModule, moduleName, app, def, args) {
	      var options = _.extend({}, def);
	      var ModuleClass = this.getClass(def);
	  
	      // Get an existing module of this name if we have one
	      var module = parentModule[moduleName];
	  
	      if (!module) {
	        // Create a new module if we don't have one
	        module = new ModuleClass(moduleName, app, options);
	        parentModule[moduleName] = module;
	        // store the module on the parent
	        parentModule.submodules[moduleName] = module;
	      }
	  
	      return module;
	    },
	  
	    // ## Module Classes
	    //
	    // Module classes can be used as an alternative to the define pattern.
	    // The extend function of a Module is identical to the extend functions
	    // on other Backbone and Marionette classes.
	    // This allows module lifecyle events like `onStart` and `onStop` to be called directly.
	    getClass: function(moduleDefinition) {
	      var ModuleClass = Marionette.Module;
	  
	      if (!moduleDefinition) {
	        return ModuleClass;
	      }
	  
	      // If all of the module's functionality is defined inside its class,
	      // then the class can be passed in directly. `MyApp.module("Foo", FooModule)`.
	      if (moduleDefinition.prototype instanceof ModuleClass) {
	        return moduleDefinition;
	      }
	  
	      return moduleDefinition.moduleClass || ModuleClass;
	    },
	  
	    // Add the module definition and add a startWithParent initializer function.
	    // This is complicated because module definitions are heavily overloaded
	    // and support an anonymous function, module class, or options object
	    _addModuleDefinition: function(parentModule, module, def, args) {
	      var fn = this._getDefine(def);
	      var startWithParent = this._getStartWithParent(def, module);
	  
	      if (fn) {
	        module.addDefinition(fn, args);
	      }
	  
	      this._addStartWithParent(parentModule, module, startWithParent);
	    },
	  
	    _getStartWithParent: function(def, module) {
	      var swp;
	  
	      if (_.isFunction(def) && (def.prototype instanceof Marionette.Module)) {
	        swp = module.constructor.prototype.startWithParent;
	        return _.isUndefined(swp) ? true : swp;
	      }
	  
	      if (_.isObject(def)) {
	        swp = def.startWithParent;
	        return _.isUndefined(swp) ? true : swp;
	      }
	  
	      return true;
	    },
	  
	    _getDefine: function(def) {
	      if (_.isFunction(def) && !(def.prototype instanceof Marionette.Module)) {
	        return def;
	      }
	  
	      if (_.isObject(def)) {
	        return def.define;
	      }
	  
	      return null;
	    },
	  
	    _addStartWithParent: function(parentModule, module, startWithParent) {
	      module.startWithParent = module.startWithParent && startWithParent;
	  
	      if (!module.startWithParent || !!module.startWithParentIsConfigured) {
	        return;
	      }
	  
	      module.startWithParentIsConfigured = true;
	  
	      parentModule.addInitializer(function(options) {
	        if (module.startWithParent) {
	          module.start(options);
	        }
	      });
	    }
	  });
	  
	
	  return Marionette;
	}));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.Wreqr (Backbone.Marionette)
	// ----------------------------------
	// v1.4.0
	//
	// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://github.com/marionettejs/backbone.wreqr
	
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return factory(Backbone, _);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    module.exports = factory(Backbone, _);
	  } else {
	    factory(root.Backbone, root._);
	  }
	
	}(this, function(Backbone, _) {
	  "use strict";
	
	  var previousWreqr = Backbone.Wreqr;
	
	  var Wreqr = Backbone.Wreqr = {};
	
	  Backbone.Wreqr.VERSION = '1.4.0';
	
	  Backbone.Wreqr.noConflict = function () {
	    Backbone.Wreqr = previousWreqr;
	    return this;
	  };
	
	  // Handlers
	  // --------
	  // A registry of functions to call, given a name
	  
	  Wreqr.Handlers = (function(Backbone, _){
	    "use strict";
	    
	    // Constructor
	    // -----------
	  
	    var Handlers = function(options){
	      this.options = options;
	      this._wreqrHandlers = {};
	      
	      if (_.isFunction(this.initialize)){
	        this.initialize(options);
	      }
	    };
	  
	    Handlers.extend = Backbone.Model.extend;
	  
	    // Instance Members
	    // ----------------
	  
	    _.extend(Handlers.prototype, Backbone.Events, {
	  
	      // Add multiple handlers using an object literal configuration
	      setHandlers: function(handlers){
	        _.each(handlers, _.bind(function(handler, name){
	          var context = null;
	  
	          if (_.isObject(handler) && !_.isFunction(handler)){
	            context = handler.context;
	            handler = handler.callback;
	          }
	  
	          this.setHandler(name, handler, context);
	        }, this));
	      },
	  
	      // Add a handler for the given name, with an
	      // optional context to run the handler within
	      setHandler: function(name, handler, context){
	        var config = {
	          callback: handler,
	          context: context
	        };
	  
	        this._wreqrHandlers[name] = config;
	  
	        this.trigger("handler:add", name, handler, context);
	      },
	  
	      // Determine whether or not a handler is registered
	      hasHandler: function(name){
	        return !! this._wreqrHandlers[name];
	      },
	  
	      // Get the currently registered handler for
	      // the specified name. Throws an exception if
	      // no handler is found.
	      getHandler: function(name){
	        var config = this._wreqrHandlers[name];
	  
	        if (!config){
	          return;
	        }
	  
	        return function(){
	          return config.callback.apply(config.context, arguments);
	        };
	      },
	  
	      // Remove a handler for the specified name
	      removeHandler: function(name){
	        delete this._wreqrHandlers[name];
	      },
	  
	      // Remove all handlers from this registry
	      removeAllHandlers: function(){
	        this._wreqrHandlers = {};
	      }
	    });
	  
	    return Handlers;
	  })(Backbone, _);
	  
	  // Wreqr.CommandStorage
	  // --------------------
	  //
	  // Store and retrieve commands for execution.
	  Wreqr.CommandStorage = (function(){
	    "use strict";
	  
	    // Constructor function
	    var CommandStorage = function(options){
	      this.options = options;
	      this._commands = {};
	  
	      if (_.isFunction(this.initialize)){
	        this.initialize(options);
	      }
	    };
	  
	    // Instance methods
	    _.extend(CommandStorage.prototype, Backbone.Events, {
	  
	      // Get an object literal by command name, that contains
	      // the `commandName` and the `instances` of all commands
	      // represented as an array of arguments to process
	      getCommands: function(commandName){
	        var commands = this._commands[commandName];
	  
	        // we don't have it, so add it
	        if (!commands){
	  
	          // build the configuration
	          commands = {
	            command: commandName, 
	            instances: []
	          };
	  
	          // store it
	          this._commands[commandName] = commands;
	        }
	  
	        return commands;
	      },
	  
	      // Add a command by name, to the storage and store the
	      // args for the command
	      addCommand: function(commandName, args){
	        var command = this.getCommands(commandName);
	        command.instances.push(args);
	      },
	  
	      // Clear all commands for the given `commandName`
	      clearCommands: function(commandName){
	        var command = this.getCommands(commandName);
	        command.instances = [];
	      }
	    });
	  
	    return CommandStorage;
	  })();
	  
	  // Wreqr.Commands
	  // --------------
	  //
	  // A simple command pattern implementation. Register a command
	  // handler and execute it.
	  Wreqr.Commands = (function(Wreqr, _){
	    "use strict";
	  
	    return Wreqr.Handlers.extend({
	      // default storage type
	      storageType: Wreqr.CommandStorage,
	  
	      constructor: function(options){
	        this.options = options || {};
	  
	        this._initializeStorage(this.options);
	        this.on("handler:add", this._executeCommands, this);
	  
	        Wreqr.Handlers.prototype.constructor.apply(this, arguments);
	      },
	  
	      // Execute a named command with the supplied args
	      execute: function(name){
	        name = arguments[0];
	        var args = _.rest(arguments);
	  
	        if (this.hasHandler(name)){
	          this.getHandler(name).apply(this, args);
	        } else {
	          this.storage.addCommand(name, args);
	        }
	  
	      },
	  
	      // Internal method to handle bulk execution of stored commands
	      _executeCommands: function(name, handler, context){
	        var command = this.storage.getCommands(name);
	  
	        // loop through and execute all the stored command instances
	        _.each(command.instances, function(args){
	          handler.apply(context, args);
	        });
	  
	        this.storage.clearCommands(name);
	      },
	  
	      // Internal method to initialize storage either from the type's
	      // `storageType` or the instance `options.storageType`.
	      _initializeStorage: function(options){
	        var storage;
	  
	        var StorageType = options.storageType || this.storageType;
	        if (_.isFunction(StorageType)){
	          storage = new StorageType();
	        } else {
	          storage = StorageType;
	        }
	  
	        this.storage = storage;
	      }
	    });
	  
	  })(Wreqr, _);
	  
	  // Wreqr.RequestResponse
	  // ---------------------
	  //
	  // A simple request/response implementation. Register a
	  // request handler, and return a response from it
	  Wreqr.RequestResponse = (function(Wreqr, _){
	    "use strict";
	  
	    return Wreqr.Handlers.extend({
	      request: function(name){
	        if (this.hasHandler(name)) {
	          return this.getHandler(name).apply(this, _.rest(arguments));
	        }
	      }
	    });
	  
	  })(Wreqr, _);
	  
	  // Event Aggregator
	  // ----------------
	  // A pub-sub object that can be used to decouple various parts
	  // of an application through event-driven architecture.
	  
	  Wreqr.EventAggregator = (function(Backbone, _){
	    "use strict";
	    var EA = function(){};
	  
	    // Copy the `extend` function used by Backbone's classes
	    EA.extend = Backbone.Model.extend;
	  
	    // Copy the basic Backbone.Events on to the event aggregator
	    _.extend(EA.prototype, Backbone.Events);
	  
	    return EA;
	  })(Backbone, _);
	  
	  // Wreqr.Channel
	  // --------------
	  //
	  // An object that wraps the three messaging systems:
	  // EventAggregator, RequestResponse, Commands
	  Wreqr.Channel = (function(Wreqr){
	    "use strict";
	  
	    var Channel = function(channelName) {
	      this.vent        = new Backbone.Wreqr.EventAggregator();
	      this.reqres      = new Backbone.Wreqr.RequestResponse();
	      this.commands    = new Backbone.Wreqr.Commands();
	      this.channelName = channelName;
	    };
	  
	    _.extend(Channel.prototype, {
	  
	      // Remove all handlers from the messaging systems of this channel
	      reset: function() {
	        this.vent.off();
	        this.vent.stopListening();
	        this.reqres.removeAllHandlers();
	        this.commands.removeAllHandlers();
	        return this;
	      },
	  
	      // Connect a hash of events; one for each messaging system
	      connectEvents: function(hash, context) {
	        this._connect('vent', hash, context);
	        return this;
	      },
	  
	      connectCommands: function(hash, context) {
	        this._connect('commands', hash, context);
	        return this;
	      },
	  
	      connectRequests: function(hash, context) {
	        this._connect('reqres', hash, context);
	        return this;
	      },
	  
	      // Attach the handlers to a given message system `type`
	      _connect: function(type, hash, context) {
	        if (!hash) {
	          return;
	        }
	  
	        context = context || this;
	        var method = (type === 'vent') ? 'on' : 'setHandler';
	  
	        _.each(hash, _.bind(function(fn, eventName) {
	          this[type][method](eventName, _.bind(fn, context));
	        }, this));
	      }
	    });
	  
	  
	    return Channel;
	  })(Wreqr);
	  
	  // Wreqr.Radio
	  // --------------
	  //
	  // An object that lets you communicate with many channels.
	  Wreqr.radio = (function(Wreqr, _){
	    "use strict";
	  
	    var Radio = function() {
	      this._channels = {};
	      this.vent = {};
	      this.commands = {};
	      this.reqres = {};
	      this._proxyMethods();
	    };
	  
	    _.extend(Radio.prototype, {
	  
	      channel: function(channelName) {
	        if (!channelName) {
	          throw new Error('Channel must receive a name');
	        }
	  
	        return this._getChannel( channelName );
	      },
	  
	      _getChannel: function(channelName) {
	        var channel = this._channels[channelName];
	  
	        if(!channel) {
	          channel = new Wreqr.Channel(channelName);
	          this._channels[channelName] = channel;
	        }
	  
	        return channel;
	      },
	  
	      _proxyMethods: function() {
	        _.each(['vent', 'commands', 'reqres'], _.bind(function(system) {
	          _.each( messageSystems[system], _.bind(function(method) {
	            this[system][method] = proxyMethod(this, system, method);
	          }, this));
	        }, this));
	      }
	    });
	  
	  
	    var messageSystems = {
	      vent: [
	        'on',
	        'off',
	        'trigger',
	        'once',
	        'stopListening',
	        'listenTo',
	        'listenToOnce'
	      ],
	  
	      commands: [
	        'execute',
	        'setHandler',
	        'setHandlers',
	        'removeHandler',
	        'removeAllHandlers'
	      ],
	  
	      reqres: [
	        'request',
	        'setHandler',
	        'setHandlers',
	        'removeHandler',
	        'removeAllHandlers'
	      ]
	    };
	  
	    var proxyMethod = function(radio, system, method) {
	      return function(channelName) {
	        var messageSystem = radio._getChannel(channelName)[system];
	  
	        return messageSystem[method].apply(messageSystem, _.rest(arguments));
	      };
	    };
	  
	    return new Radio();
	  
	  })(Wreqr, _);
	  
	
	  return Backbone.Wreqr;
	
	}));


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.BabySitter
	// -------------------
	// v0.1.11
	//
	// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
	// Distributed under MIT license
	//
	// http://github.com/marionettejs/backbone.babysitter
	
	(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(58), __webpack_require__(49)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
	      return factory(Backbone, _);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined') {
	    var Backbone = require('backbone');
	    var _ = require('underscore');
	    module.exports = factory(Backbone, _);
	  } else {
	    factory(root.Backbone, root._);
	  }
	
	}(this, function(Backbone, _) {
	  'use strict';
	
	  var previousChildViewContainer = Backbone.ChildViewContainer;
	
	  // BabySitter.ChildViewContainer
	  // -----------------------------
	  //
	  // Provide a container to store, retrieve and
	  // shut down child views.
	  
	  Backbone.ChildViewContainer = (function (Backbone, _) {
	  
	    // Container Constructor
	    // ---------------------
	  
	    var Container = function(views){
	      this._views = {};
	      this._indexByModel = {};
	      this._indexByCustom = {};
	      this._updateLength();
	  
	      _.each(views, this.add, this);
	    };
	  
	    // Container Methods
	    // -----------------
	  
	    _.extend(Container.prototype, {
	  
	      // Add a view to this container. Stores the view
	      // by `cid` and makes it searchable by the model
	      // cid (and model itself). Optionally specify
	      // a custom key to store an retrieve the view.
	      add: function(view, customIndex){
	        var viewCid = view.cid;
	  
	        // store the view
	        this._views[viewCid] = view;
	  
	        // index it by model
	        if (view.model){
	          this._indexByModel[view.model.cid] = viewCid;
	        }
	  
	        // index by custom
	        if (customIndex){
	          this._indexByCustom[customIndex] = viewCid;
	        }
	  
	        this._updateLength();
	        return this;
	      },
	  
	      // Find a view by the model that was attached to
	      // it. Uses the model's `cid` to find it.
	      findByModel: function(model){
	        return this.findByModelCid(model.cid);
	      },
	  
	      // Find a view by the `cid` of the model that was attached to
	      // it. Uses the model's `cid` to find the view `cid` and
	      // retrieve the view using it.
	      findByModelCid: function(modelCid){
	        var viewCid = this._indexByModel[modelCid];
	        return this.findByCid(viewCid);
	      },
	  
	      // Find a view by a custom indexer.
	      findByCustom: function(index){
	        var viewCid = this._indexByCustom[index];
	        return this.findByCid(viewCid);
	      },
	  
	      // Find by index. This is not guaranteed to be a
	      // stable index.
	      findByIndex: function(index){
	        return _.values(this._views)[index];
	      },
	  
	      // retrieve a view by its `cid` directly
	      findByCid: function(cid){
	        return this._views[cid];
	      },
	  
	      // Remove a view
	      remove: function(view){
	        var viewCid = view.cid;
	  
	        // delete model index
	        if (view.model){
	          delete this._indexByModel[view.model.cid];
	        }
	  
	        // delete custom index
	        _.any(this._indexByCustom, function(cid, key) {
	          if (cid === viewCid) {
	            delete this._indexByCustom[key];
	            return true;
	          }
	        }, this);
	  
	        // remove the view from the container
	        delete this._views[viewCid];
	  
	        // update the length
	        this._updateLength();
	        return this;
	      },
	  
	      // Call a method on every view in the container,
	      // passing parameters to the call method one at a
	      // time, like `function.call`.
	      call: function(method){
	        this.apply(method, _.tail(arguments));
	      },
	  
	      // Apply a method on every view in the container,
	      // passing parameters to the call method one at a
	      // time, like `function.apply`.
	      apply: function(method, args){
	        _.each(this._views, function(view){
	          if (_.isFunction(view[method])){
	            view[method].apply(view, args || []);
	          }
	        });
	      },
	  
	      // Update the `.length` attribute on this container
	      _updateLength: function(){
	        this.length = _.size(this._views);
	      }
	    });
	  
	    // Borrowing this code from Backbone.Collection:
	    // http://backbonejs.org/docs/backbone.html#section-106
	    //
	    // Mix in methods from Underscore, for iteration, and other
	    // collection related features.
	    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
	      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
	      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
	      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
	  
	    _.each(methods, function(method) {
	      Container.prototype[method] = function() {
	        var views = _.values(this._views);
	        var args = [views].concat(_.toArray(arguments));
	        return _[method].apply(_, args);
	      };
	    });
	  
	    // return the public API
	    return Container;
	  })(Backbone, _);
	  
	
	  Backbone.ChildViewContainer.VERSION = '0.1.11';
	
	  Backbone.ChildViewContainer.noConflict = function () {
	    Backbone.ChildViewContainer = previousChildViewContainer;
	    return this;
	  };
	
	  return Backbone.ChildViewContainer;
	
	}));


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Effects 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Effects Core
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Extends the internal jQuery effects. Includes morphing and easing. Required by all other effects.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/category/effects-core/
	//>>demos: http://jqueryui.com/effect/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var dataSpace = "ui-effects-",
		dataSpaceStyle = "ui-effects-style",
		dataSpaceAnimated = "ui-effects-animated",
	
		// Create a local jQuery because jQuery Color relies on it and the
		// global may not exist with AMD and a custom build (#10199)
		jQuery = $;
	
	$.effects = {
		effect: {}
	};
	
	/*!
	 * jQuery Color Animations v2.1.2
	 * https://github.com/jquery/jquery-color
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * Date: Wed Jan 16 08:47:09 2013 -0600
	 */
	( function( jQuery, undefined ) {
	
		var stepHooks = "backgroundColor borderBottomColor borderLeftColor borderRightColor " +
			"borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
	
		// Plusequals test for += 100 -= 100
		rplusequals = /^([\-+])=\s*(\d+\.?\d*)/,
	
		// A set of RE's that can match strings and generate color tuples.
		stringParsers = [ {
				re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ],
						execResult[ 3 ],
						execResult[ 4 ]
					];
				}
			}, {
				re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ] * 2.55,
						execResult[ 2 ] * 2.55,
						execResult[ 3 ] * 2.55,
						execResult[ 4 ]
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ], 16 )
					];
				}
			}, {
	
				// This regex ignores A-F because it's compared against an already lowercased string
				re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
				space: "hsla",
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ] / 100,
						execResult[ 3 ] / 100,
						execResult[ 4 ]
					];
				}
			} ],
	
		// JQuery.Color( )
		color = jQuery.Color = function( color, green, blue, alpha ) {
			return new jQuery.Color.fn.parse( color, green, blue, alpha );
		},
		spaces = {
			rgba: {
				props: {
					red: {
						idx: 0,
						type: "byte"
					},
					green: {
						idx: 1,
						type: "byte"
					},
					blue: {
						idx: 2,
						type: "byte"
					}
				}
			},
	
			hsla: {
				props: {
					hue: {
						idx: 0,
						type: "degrees"
					},
					saturation: {
						idx: 1,
						type: "percent"
					},
					lightness: {
						idx: 2,
						type: "percent"
					}
				}
			}
		},
		propTypes = {
			"byte": {
				floor: true,
				max: 255
			},
			"percent": {
				max: 1
			},
			"degrees": {
				mod: 360,
				floor: true
			}
		},
		support = color.support = {},
	
		// Element for support tests
		supportElem = jQuery( "<p>" )[ 0 ],
	
		// Colors = jQuery.Color.names
		colors,
	
		// Local aliases of functions called often
		each = jQuery.each;
	
	// Determine rgba support immediately
	supportElem.style.cssText = "background-color:rgba(1,1,1,.5)";
	support.rgba = supportElem.style.backgroundColor.indexOf( "rgba" ) > -1;
	
	// Define cache name and alpha properties
	// for rgba and hsla spaces
	each( spaces, function( spaceName, space ) {
		space.cache = "_" + spaceName;
		space.props.alpha = {
			idx: 3,
			type: "percent",
			def: 1
		};
	} );
	
	function clamp( value, prop, allowEmpty ) {
		var type = propTypes[ prop.type ] || {};
	
		if ( value == null ) {
			return ( allowEmpty || !prop.def ) ? null : prop.def;
		}
	
		// ~~ is an short way of doing floor for positive numbers
		value = type.floor ? ~~value : parseFloat( value );
	
		// IE will pass in empty strings as value for alpha,
		// which will hit this case
		if ( isNaN( value ) ) {
			return prop.def;
		}
	
		if ( type.mod ) {
	
			// We add mod before modding to make sure that negatives values
			// get converted properly: -10 -> 350
			return ( value + type.mod ) % type.mod;
		}
	
		// For now all property types without mod have min and max
		return 0 > value ? 0 : type.max < value ? type.max : value;
	}
	
	function stringParse( string ) {
		var inst = color(),
			rgba = inst._rgba = [];
	
		string = string.toLowerCase();
	
		each( stringParsers, function( i, parser ) {
			var parsed,
				match = parser.re.exec( string ),
				values = match && parser.parse( match ),
				spaceName = parser.space || "rgba";
	
			if ( values ) {
				parsed = inst[ spaceName ]( values );
	
				// If this was an rgba parse the assignment might happen twice
				// oh well....
				inst[ spaces[ spaceName ].cache ] = parsed[ spaces[ spaceName ].cache ];
				rgba = inst._rgba = parsed._rgba;
	
				// Exit each( stringParsers ) here because we matched
				return false;
			}
		} );
	
		// Found a stringParser that handled it
		if ( rgba.length ) {
	
			// If this came from a parsed string, force "transparent" when alpha is 0
			// chrome, (and maybe others) return "transparent" as rgba(0,0,0,0)
			if ( rgba.join() === "0,0,0,0" ) {
				jQuery.extend( rgba, colors.transparent );
			}
			return inst;
		}
	
		// Named colors
		return colors[ string ];
	}
	
	color.fn = jQuery.extend( color.prototype, {
		parse: function( red, green, blue, alpha ) {
			if ( red === undefined ) {
				this._rgba = [ null, null, null, null ];
				return this;
			}
			if ( red.jquery || red.nodeType ) {
				red = jQuery( red ).css( green );
				green = undefined;
			}
	
			var inst = this,
				type = jQuery.type( red ),
				rgba = this._rgba = [];
	
			// More than 1 argument specified - assume ( red, green, blue, alpha )
			if ( green !== undefined ) {
				red = [ red, green, blue, alpha ];
				type = "array";
			}
	
			if ( type === "string" ) {
				return this.parse( stringParse( red ) || colors._default );
			}
	
			if ( type === "array" ) {
				each( spaces.rgba.props, function( key, prop ) {
					rgba[ prop.idx ] = clamp( red[ prop.idx ], prop );
				} );
				return this;
			}
	
			if ( type === "object" ) {
				if ( red instanceof color ) {
					each( spaces, function( spaceName, space ) {
						if ( red[ space.cache ] ) {
							inst[ space.cache ] = red[ space.cache ].slice();
						}
					} );
				} else {
					each( spaces, function( spaceName, space ) {
						var cache = space.cache;
						each( space.props, function( key, prop ) {
	
							// If the cache doesn't exist, and we know how to convert
							if ( !inst[ cache ] && space.to ) {
	
								// If the value was null, we don't need to copy it
								// if the key was alpha, we don't need to copy it either
								if ( key === "alpha" || red[ key ] == null ) {
									return;
								}
								inst[ cache ] = space.to( inst._rgba );
							}
	
							// This is the only case where we allow nulls for ALL properties.
							// call clamp with alwaysAllowEmpty
							inst[ cache ][ prop.idx ] = clamp( red[ key ], prop, true );
						} );
	
						// Everything defined but alpha?
						if ( inst[ cache ] &&
								jQuery.inArray( null, inst[ cache ].slice( 0, 3 ) ) < 0 ) {
	
							// Use the default of 1
							inst[ cache ][ 3 ] = 1;
							if ( space.from ) {
								inst._rgba = space.from( inst[ cache ] );
							}
						}
					} );
				}
				return this;
			}
		},
		is: function( compare ) {
			var is = color( compare ),
				same = true,
				inst = this;
	
			each( spaces, function( _, space ) {
				var localCache,
					isCache = is[ space.cache ];
				if ( isCache ) {
					localCache = inst[ space.cache ] || space.to && space.to( inst._rgba ) || [];
					each( space.props, function( _, prop ) {
						if ( isCache[ prop.idx ] != null ) {
							same = ( isCache[ prop.idx ] === localCache[ prop.idx ] );
							return same;
						}
					} );
				}
				return same;
			} );
			return same;
		},
		_space: function() {
			var used = [],
				inst = this;
			each( spaces, function( spaceName, space ) {
				if ( inst[ space.cache ] ) {
					used.push( spaceName );
				}
			} );
			return used.pop();
		},
		transition: function( other, distance ) {
			var end = color( other ),
				spaceName = end._space(),
				space = spaces[ spaceName ],
				startColor = this.alpha() === 0 ? color( "transparent" ) : this,
				start = startColor[ space.cache ] || space.to( startColor._rgba ),
				result = start.slice();
	
			end = end[ space.cache ];
			each( space.props, function( key, prop ) {
				var index = prop.idx,
					startValue = start[ index ],
					endValue = end[ index ],
					type = propTypes[ prop.type ] || {};
	
				// If null, don't override start value
				if ( endValue === null ) {
					return;
				}
	
				// If null - use end
				if ( startValue === null ) {
					result[ index ] = endValue;
				} else {
					if ( type.mod ) {
						if ( endValue - startValue > type.mod / 2 ) {
							startValue += type.mod;
						} else if ( startValue - endValue > type.mod / 2 ) {
							startValue -= type.mod;
						}
					}
					result[ index ] = clamp( ( endValue - startValue ) * distance + startValue, prop );
				}
			} );
			return this[ spaceName ]( result );
		},
		blend: function( opaque ) {
	
			// If we are already opaque - return ourself
			if ( this._rgba[ 3 ] === 1 ) {
				return this;
			}
	
			var rgb = this._rgba.slice(),
				a = rgb.pop(),
				blend = color( opaque )._rgba;
	
			return color( jQuery.map( rgb, function( v, i ) {
				return ( 1 - a ) * blend[ i ] + a * v;
			} ) );
		},
		toRgbaString: function() {
			var prefix = "rgba(",
				rgba = jQuery.map( this._rgba, function( v, i ) {
					return v == null ? ( i > 2 ? 1 : 0 ) : v;
				} );
	
			if ( rgba[ 3 ] === 1 ) {
				rgba.pop();
				prefix = "rgb(";
			}
	
			return prefix + rgba.join() + ")";
		},
		toHslaString: function() {
			var prefix = "hsla(",
				hsla = jQuery.map( this.hsla(), function( v, i ) {
					if ( v == null ) {
						v = i > 2 ? 1 : 0;
					}
	
					// Catch 1 and 2
					if ( i && i < 3 ) {
						v = Math.round( v * 100 ) + "%";
					}
					return v;
				} );
	
			if ( hsla[ 3 ] === 1 ) {
				hsla.pop();
				prefix = "hsl(";
			}
			return prefix + hsla.join() + ")";
		},
		toHexString: function( includeAlpha ) {
			var rgba = this._rgba.slice(),
				alpha = rgba.pop();
	
			if ( includeAlpha ) {
				rgba.push( ~~( alpha * 255 ) );
			}
	
			return "#" + jQuery.map( rgba, function( v ) {
	
				// Default to 0 when nulls exist
				v = ( v || 0 ).toString( 16 );
				return v.length === 1 ? "0" + v : v;
			} ).join( "" );
		},
		toString: function() {
			return this._rgba[ 3 ] === 0 ? "transparent" : this.toRgbaString();
		}
	} );
	color.fn.parse.prototype = color.fn;
	
	// Hsla conversions adapted from:
	// https://code.google.com/p/maashaack/source/browse/packages/graphics/trunk/src/graphics/colors/HUE2RGB.as?r=5021
	
	function hue2rgb( p, q, h ) {
		h = ( h + 1 ) % 1;
		if ( h * 6 < 1 ) {
			return p + ( q - p ) * h * 6;
		}
		if ( h * 2 < 1 ) {
			return q;
		}
		if ( h * 3 < 2 ) {
			return p + ( q - p ) * ( ( 2 / 3 ) - h ) * 6;
		}
		return p;
	}
	
	spaces.hsla.to = function( rgba ) {
		if ( rgba[ 0 ] == null || rgba[ 1 ] == null || rgba[ 2 ] == null ) {
			return [ null, null, null, rgba[ 3 ] ];
		}
		var r = rgba[ 0 ] / 255,
			g = rgba[ 1 ] / 255,
			b = rgba[ 2 ] / 255,
			a = rgba[ 3 ],
			max = Math.max( r, g, b ),
			min = Math.min( r, g, b ),
			diff = max - min,
			add = max + min,
			l = add * 0.5,
			h, s;
	
		if ( min === max ) {
			h = 0;
		} else if ( r === max ) {
			h = ( 60 * ( g - b ) / diff ) + 360;
		} else if ( g === max ) {
			h = ( 60 * ( b - r ) / diff ) + 120;
		} else {
			h = ( 60 * ( r - g ) / diff ) + 240;
		}
	
		// Chroma (diff) == 0 means greyscale which, by definition, saturation = 0%
		// otherwise, saturation is based on the ratio of chroma (diff) to lightness (add)
		if ( diff === 0 ) {
			s = 0;
		} else if ( l <= 0.5 ) {
			s = diff / add;
		} else {
			s = diff / ( 2 - add );
		}
		return [ Math.round( h ) % 360, s, l, a == null ? 1 : a ];
	};
	
	spaces.hsla.from = function( hsla ) {
		if ( hsla[ 0 ] == null || hsla[ 1 ] == null || hsla[ 2 ] == null ) {
			return [ null, null, null, hsla[ 3 ] ];
		}
		var h = hsla[ 0 ] / 360,
			s = hsla[ 1 ],
			l = hsla[ 2 ],
			a = hsla[ 3 ],
			q = l <= 0.5 ? l * ( 1 + s ) : l + s - l * s,
			p = 2 * l - q;
	
		return [
			Math.round( hue2rgb( p, q, h + ( 1 / 3 ) ) * 255 ),
			Math.round( hue2rgb( p, q, h ) * 255 ),
			Math.round( hue2rgb( p, q, h - ( 1 / 3 ) ) * 255 ),
			a
		];
	};
	
	each( spaces, function( spaceName, space ) {
		var props = space.props,
			cache = space.cache,
			to = space.to,
			from = space.from;
	
		// Makes rgba() and hsla()
		color.fn[ spaceName ] = function( value ) {
	
			// Generate a cache for this space if it doesn't exist
			if ( to && !this[ cache ] ) {
				this[ cache ] = to( this._rgba );
			}
			if ( value === undefined ) {
				return this[ cache ].slice();
			}
	
			var ret,
				type = jQuery.type( value ),
				arr = ( type === "array" || type === "object" ) ? value : arguments,
				local = this[ cache ].slice();
	
			each( props, function( key, prop ) {
				var val = arr[ type === "object" ? key : prop.idx ];
				if ( val == null ) {
					val = local[ prop.idx ];
				}
				local[ prop.idx ] = clamp( val, prop );
			} );
	
			if ( from ) {
				ret = color( from( local ) );
				ret[ cache ] = local;
				return ret;
			} else {
				return color( local );
			}
		};
	
		// Makes red() green() blue() alpha() hue() saturation() lightness()
		each( props, function( key, prop ) {
	
			// Alpha is included in more than one space
			if ( color.fn[ key ] ) {
				return;
			}
			color.fn[ key ] = function( value ) {
				var vtype = jQuery.type( value ),
					fn = ( key === "alpha" ? ( this._hsla ? "hsla" : "rgba" ) : spaceName ),
					local = this[ fn ](),
					cur = local[ prop.idx ],
					match;
	
				if ( vtype === "undefined" ) {
					return cur;
				}
	
				if ( vtype === "function" ) {
					value = value.call( this, cur );
					vtype = jQuery.type( value );
				}
				if ( value == null && prop.empty ) {
					return this;
				}
				if ( vtype === "string" ) {
					match = rplusequals.exec( value );
					if ( match ) {
						value = cur + parseFloat( match[ 2 ] ) * ( match[ 1 ] === "+" ? 1 : -1 );
					}
				}
				local[ prop.idx ] = value;
				return this[ fn ]( local );
			};
		} );
	} );
	
	// Add cssHook and .fx.step function for each named hook.
	// accept a space separated string of properties
	color.hook = function( hook ) {
		var hooks = hook.split( " " );
		each( hooks, function( i, hook ) {
			jQuery.cssHooks[ hook ] = {
				set: function( elem, value ) {
					var parsed, curElem,
						backgroundColor = "";
	
					if ( value !== "transparent" && ( jQuery.type( value ) !== "string" ||
							( parsed = stringParse( value ) ) ) ) {
						value = color( parsed || value );
						if ( !support.rgba && value._rgba[ 3 ] !== 1 ) {
							curElem = hook === "backgroundColor" ? elem.parentNode : elem;
							while (
								( backgroundColor === "" || backgroundColor === "transparent" ) &&
								curElem && curElem.style
							) {
								try {
									backgroundColor = jQuery.css( curElem, "backgroundColor" );
									curElem = curElem.parentNode;
								} catch ( e ) {
								}
							}
	
							value = value.blend( backgroundColor && backgroundColor !== "transparent" ?
								backgroundColor :
								"_default" );
						}
	
						value = value.toRgbaString();
					}
					try {
						elem.style[ hook ] = value;
					} catch ( e ) {
	
						// Wrapped to prevent IE from throwing errors on "invalid" values like
						// 'auto' or 'inherit'
					}
				}
			};
			jQuery.fx.step[ hook ] = function( fx ) {
				if ( !fx.colorInit ) {
					fx.start = color( fx.elem, hook );
					fx.end = color( fx.end );
					fx.colorInit = true;
				}
				jQuery.cssHooks[ hook ].set( fx.elem, fx.start.transition( fx.end, fx.pos ) );
			};
		} );
	
	};
	
	color.hook( stepHooks );
	
	jQuery.cssHooks.borderColor = {
		expand: function( value ) {
			var expanded = {};
	
			each( [ "Top", "Right", "Bottom", "Left" ], function( i, part ) {
				expanded[ "border" + part + "Color" ] = value;
			} );
			return expanded;
		}
	};
	
	// Basic color names only.
	// Usage of any of the other color names requires adding yourself or including
	// jquery.color.svg-names.js.
	colors = jQuery.Color.names = {
	
		// 4.1. Basic color keywords
		aqua: "#00ffff",
		black: "#000000",
		blue: "#0000ff",
		fuchsia: "#ff00ff",
		gray: "#808080",
		green: "#008000",
		lime: "#00ff00",
		maroon: "#800000",
		navy: "#000080",
		olive: "#808000",
		purple: "#800080",
		red: "#ff0000",
		silver: "#c0c0c0",
		teal: "#008080",
		white: "#ffffff",
		yellow: "#ffff00",
	
		// 4.2.3. "transparent" color keyword
		transparent: [ null, null, null, 0 ],
	
		_default: "#ffffff"
	};
	
	} )( jQuery );
	
	/******************************************************************************/
	/****************************** CLASS ANIMATIONS ******************************/
	/******************************************************************************/
	( function() {
	
	var classAnimationActions = [ "add", "remove", "toggle" ],
		shorthandStyles = {
			border: 1,
			borderBottom: 1,
			borderColor: 1,
			borderLeft: 1,
			borderRight: 1,
			borderTop: 1,
			borderWidth: 1,
			margin: 1,
			padding: 1
		};
	
	$.each(
		[ "borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle" ],
		function( _, prop ) {
			$.fx.step[ prop ] = function( fx ) {
				if ( fx.end !== "none" && !fx.setAttr || fx.pos === 1 && !fx.setAttr ) {
					jQuery.style( fx.elem, prop, fx.end );
					fx.setAttr = true;
				}
			};
		}
	);
	
	function getElementStyles( elem ) {
		var key, len,
			style = elem.ownerDocument.defaultView ?
				elem.ownerDocument.defaultView.getComputedStyle( elem, null ) :
				elem.currentStyle,
			styles = {};
	
		if ( style && style.length && style[ 0 ] && style[ style[ 0 ] ] ) {
			len = style.length;
			while ( len-- ) {
				key = style[ len ];
				if ( typeof style[ key ] === "string" ) {
					styles[ $.camelCase( key ) ] = style[ key ];
				}
			}
	
		// Support: Opera, IE <9
		} else {
			for ( key in style ) {
				if ( typeof style[ key ] === "string" ) {
					styles[ key ] = style[ key ];
				}
			}
		}
	
		return styles;
	}
	
	function styleDifference( oldStyle, newStyle ) {
		var diff = {},
			name, value;
	
		for ( name in newStyle ) {
			value = newStyle[ name ];
			if ( oldStyle[ name ] !== value ) {
				if ( !shorthandStyles[ name ] ) {
					if ( $.fx.step[ name ] || !isNaN( parseFloat( value ) ) ) {
						diff[ name ] = value;
					}
				}
			}
		}
	
		return diff;
	}
	
	// Support: jQuery <1.8
	if ( !$.fn.addBack ) {
		$.fn.addBack = function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		};
	}
	
	$.effects.animateClass = function( value, duration, easing, callback ) {
		var o = $.speed( duration, easing, callback );
	
		return this.queue( function() {
			var animated = $( this ),
				baseClass = animated.attr( "class" ) || "",
				applyClassChange,
				allAnimations = o.children ? animated.find( "*" ).addBack() : animated;
	
			// Map the animated objects to store the original styles.
			allAnimations = allAnimations.map( function() {
				var el = $( this );
				return {
					el: el,
					start: getElementStyles( this )
				};
			} );
	
			// Apply class change
			applyClassChange = function() {
				$.each( classAnimationActions, function( i, action ) {
					if ( value[ action ] ) {
						animated[ action + "Class" ]( value[ action ] );
					}
				} );
			};
			applyClassChange();
	
			// Map all animated objects again - calculate new styles and diff
			allAnimations = allAnimations.map( function() {
				this.end = getElementStyles( this.el[ 0 ] );
				this.diff = styleDifference( this.start, this.end );
				return this;
			} );
	
			// Apply original class
			animated.attr( "class", baseClass );
	
			// Map all animated objects again - this time collecting a promise
			allAnimations = allAnimations.map( function() {
				var styleInfo = this,
					dfd = $.Deferred(),
					opts = $.extend( {}, o, {
						queue: false,
						complete: function() {
							dfd.resolve( styleInfo );
						}
					} );
	
				this.el.animate( this.diff, opts );
				return dfd.promise();
			} );
	
			// Once all animations have completed:
			$.when.apply( $, allAnimations.get() ).done( function() {
	
				// Set the final class
				applyClassChange();
	
				// For each animated element,
				// clear all css properties that were animated
				$.each( arguments, function() {
					var el = this.el;
					$.each( this.diff, function( key ) {
						el.css( key, "" );
					} );
				} );
	
				// This is guarnteed to be there if you use jQuery.speed()
				// it also handles dequeuing the next anim...
				o.complete.call( animated[ 0 ] );
			} );
		} );
	};
	
	$.fn.extend( {
		addClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return speed ?
					$.effects.animateClass.call( this,
						{ add: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.addClass ),
	
		removeClass: ( function( orig ) {
			return function( classNames, speed, easing, callback ) {
				return arguments.length > 1 ?
					$.effects.animateClass.call( this,
						{ remove: classNames }, speed, easing, callback ) :
					orig.apply( this, arguments );
			};
		} )( $.fn.removeClass ),
	
		toggleClass: ( function( orig ) {
			return function( classNames, force, speed, easing, callback ) {
				if ( typeof force === "boolean" || force === undefined ) {
					if ( !speed ) {
	
						// Without speed parameter
						return orig.apply( this, arguments );
					} else {
						return $.effects.animateClass.call( this,
							( force ? { add: classNames } : { remove: classNames } ),
							speed, easing, callback );
					}
				} else {
	
					// Without force parameter
					return $.effects.animateClass.call( this,
						{ toggle: classNames }, force, speed, easing );
				}
			};
		} )( $.fn.toggleClass ),
	
		switchClass: function( remove, add, speed, easing, callback ) {
			return $.effects.animateClass.call( this, {
				add: add,
				remove: remove
			}, speed, easing, callback );
		}
	} );
	
	} )();
	
	/******************************************************************************/
	/*********************************** EFFECTS **********************************/
	/******************************************************************************/
	
	( function() {
	
	if ( $.expr && $.expr.filters && $.expr.filters.animated ) {
		$.expr.filters.animated = ( function( orig ) {
			return function( elem ) {
				return !!$( elem ).data( dataSpaceAnimated ) || orig( elem );
			};
		} )( $.expr.filters.animated );
	}
	
	if ( $.uiBackCompat !== false ) {
		$.extend( $.effects, {
	
			// Saves a set of properties in a data storage
			save: function( element, set ) {
				var i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						element.data( dataSpace + set[ i ], element[ 0 ].style[ set[ i ] ] );
					}
				}
			},
	
			// Restores a set of previously saved properties from a data storage
			restore: function( element, set ) {
				var val, i = 0, length = set.length;
				for ( ; i < length; i++ ) {
					if ( set[ i ] !== null ) {
						val = element.data( dataSpace + set[ i ] );
						element.css( set[ i ], val );
					}
				}
			},
	
			setMode: function( el, mode ) {
				if ( mode === "toggle" ) {
					mode = el.is( ":hidden" ) ? "show" : "hide";
				}
				return mode;
			},
	
			// Wraps the element around a wrapper that copies position properties
			createWrapper: function( element ) {
	
				// If the element is already wrapped, return it
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					return element.parent();
				}
	
				// Wrap the element
				var props = {
						width: element.outerWidth( true ),
						height: element.outerHeight( true ),
						"float": element.css( "float" )
					},
					wrapper = $( "<div></div>" )
						.addClass( "ui-effects-wrapper" )
						.css( {
							fontSize: "100%",
							background: "transparent",
							border: "none",
							margin: 0,
							padding: 0
						} ),
	
					// Store the size in case width/height are defined in % - Fixes #5245
					size = {
						width: element.width(),
						height: element.height()
					},
					active = document.activeElement;
	
				// Support: Firefox
				// Firefox incorrectly exposes anonymous content
				// https://bugzilla.mozilla.org/show_bug.cgi?id=561664
				try {
					active.id;
				} catch ( e ) {
					active = document.body;
				}
	
				element.wrap( wrapper );
	
				// Fixes #7595 - Elements lose focus when wrapped.
				if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
					$( active ).trigger( "focus" );
				}
	
				// Hotfix for jQuery 1.4 since some change in wrap() seems to actually
				// lose the reference to the wrapped element
				wrapper = element.parent();
	
				// Transfer positioning properties to the wrapper
				if ( element.css( "position" ) === "static" ) {
					wrapper.css( { position: "relative" } );
					element.css( { position: "relative" } );
				} else {
					$.extend( props, {
						position: element.css( "position" ),
						zIndex: element.css( "z-index" )
					} );
					$.each( [ "top", "left", "bottom", "right" ], function( i, pos ) {
						props[ pos ] = element.css( pos );
						if ( isNaN( parseInt( props[ pos ], 10 ) ) ) {
							props[ pos ] = "auto";
						}
					} );
					element.css( {
						position: "relative",
						top: 0,
						left: 0,
						right: "auto",
						bottom: "auto"
					} );
				}
				element.css( size );
	
				return wrapper.css( props ).show();
			},
	
			removeWrapper: function( element ) {
				var active = document.activeElement;
	
				if ( element.parent().is( ".ui-effects-wrapper" ) ) {
					element.parent().replaceWith( element );
	
					// Fixes #7595 - Elements lose focus when wrapped.
					if ( element[ 0 ] === active || $.contains( element[ 0 ], active ) ) {
						$( active ).trigger( "focus" );
					}
				}
	
				return element;
			}
		} );
	}
	
	$.extend( $.effects, {
		version: "1.12.0",
	
		define: function( name, mode, effect ) {
			if ( !effect ) {
				effect = mode;
				mode = "effect";
			}
	
			$.effects.effect[ name ] = effect;
			$.effects.effect[ name ].mode = mode;
	
			return effect;
		},
	
		scaledDimensions: function( element, percent, direction ) {
			if ( percent === 0 ) {
				return {
					height: 0,
					width: 0,
					outerHeight: 0,
					outerWidth: 0
				};
			}
	
			var x = direction !== "horizontal" ? ( ( percent || 100 ) / 100 ) : 1,
				y = direction !== "vertical" ? ( ( percent || 100 ) / 100 ) : 1;
	
			return {
				height: element.height() * y,
				width: element.width() * x,
				outerHeight: element.outerHeight() * y,
				outerWidth: element.outerWidth() * x
			};
	
		},
	
		clipToBox: function( animation ) {
			return {
				width: animation.clip.right - animation.clip.left,
				height: animation.clip.bottom - animation.clip.top,
				left: animation.clip.left,
				top: animation.clip.top
			};
		},
	
		// Injects recently queued functions to be first in line (after "inprogress")
		unshift: function( element, queueLength, count ) {
			var queue = element.queue();
	
			if ( queueLength > 1 ) {
				queue.splice.apply( queue,
					[ 1, 0 ].concat( queue.splice( queueLength, count ) ) );
			}
			element.dequeue();
		},
	
		saveStyle: function( element ) {
			element.data( dataSpaceStyle, element[ 0 ].style.cssText );
		},
	
		restoreStyle: function( element ) {
			element[ 0 ].style.cssText = element.data( dataSpaceStyle ) || "";
			element.removeData( dataSpaceStyle );
		},
	
		mode: function( element, mode ) {
			var hidden = element.is( ":hidden" );
	
			if ( mode === "toggle" ) {
				mode = hidden ? "show" : "hide";
			}
			if ( hidden ? mode === "hide" : mode === "show" ) {
				mode = "none";
			}
			return mode;
		},
	
		// Translates a [top,left] array into a baseline value
		getBaseline: function( origin, original ) {
			var y, x;
	
			switch ( origin[ 0 ] ) {
			case "top":
				y = 0;
				break;
			case "middle":
				y = 0.5;
				break;
			case "bottom":
				y = 1;
				break;
			default:
				y = origin[ 0 ] / original.height;
			}
	
			switch ( origin[ 1 ] ) {
			case "left":
				x = 0;
				break;
			case "center":
				x = 0.5;
				break;
			case "right":
				x = 1;
				break;
			default:
				x = origin[ 1 ] / original.width;
			}
	
			return {
				x: x,
				y: y
			};
		},
	
		// Creates a placeholder element so that the original element can be made absolute
		createPlaceholder: function( element ) {
			var placeholder,
				cssPosition = element.css( "position" ),
				position = element.position();
	
			// Lock in margins first to account for form elements, which
			// will change margin if you explicitly set height
			// see: http://jsfiddle.net/JZSMt/3/ https://bugs.webkit.org/show_bug.cgi?id=107380
			// Support: Safari
			element.css( {
				marginTop: element.css( "marginTop" ),
				marginBottom: element.css( "marginBottom" ),
				marginLeft: element.css( "marginLeft" ),
				marginRight: element.css( "marginRight" )
			} )
			.outerWidth( element.outerWidth() )
			.outerHeight( element.outerHeight() );
	
			if ( /^(static|relative)/.test( cssPosition ) ) {
				cssPosition = "absolute";
	
				placeholder = $( "<" + element[ 0 ].nodeName + ">" ).insertAfter( element ).css( {
	
					// Convert inline to inline block to account for inline elements
					// that turn to inline block based on content (like img)
					display: /^(inline|ruby)/.test( element.css( "display" ) ) ?
						"inline-block" :
						"block",
					visibility: "hidden",
	
					// Margins need to be set to account for margin collapse
					marginTop: element.css( "marginTop" ),
					marginBottom: element.css( "marginBottom" ),
					marginLeft: element.css( "marginLeft" ),
					marginRight: element.css( "marginRight" ),
					"float": element.css( "float" )
				} )
				.outerWidth( element.outerWidth() )
				.outerHeight( element.outerHeight() )
				.addClass( "ui-effects-placeholder" );
	
				element.data( dataSpace + "placeholder", placeholder );
			}
	
			element.css( {
				position: cssPosition,
				left: position.left,
				top: position.top
			} );
	
			return placeholder;
		},
	
		removePlaceholder: function( element ) {
			var dataKey = dataSpace + "placeholder",
					placeholder = element.data( dataKey );
	
			if ( placeholder ) {
				placeholder.remove();
				element.removeData( dataKey );
			}
		},
	
		// Removes a placeholder if it exists and restores
		// properties that were modified during placeholder creation
		cleanUp: function( element ) {
			$.effects.restoreStyle( element );
			$.effects.removePlaceholder( element );
		},
	
		setTransition: function( element, list, factor, value ) {
			value = value || {};
			$.each( list, function( i, x ) {
				var unit = element.cssUnit( x );
				if ( unit[ 0 ] > 0 ) {
					value[ x ] = unit[ 0 ] * factor + unit[ 1 ];
				}
			} );
			return value;
		}
	} );
	
	// Return an effect options object for the given parameters:
	function _normalizeArguments( effect, options, speed, callback ) {
	
		// Allow passing all options as the first parameter
		if ( $.isPlainObject( effect ) ) {
			options = effect;
			effect = effect.effect;
		}
	
		// Convert to an object
		effect = { effect: effect };
	
		// Catch (effect, null, ...)
		if ( options == null ) {
			options = {};
		}
	
		// Catch (effect, callback)
		if ( $.isFunction( options ) ) {
			callback = options;
			speed = null;
			options = {};
		}
	
		// Catch (effect, speed, ?)
		if ( typeof options === "number" || $.fx.speeds[ options ] ) {
			callback = speed;
			speed = options;
			options = {};
		}
	
		// Catch (effect, options, callback)
		if ( $.isFunction( speed ) ) {
			callback = speed;
			speed = null;
		}
	
		// Add options to effect
		if ( options ) {
			$.extend( effect, options );
		}
	
		speed = speed || options.duration;
		effect.duration = $.fx.off ? 0 :
			typeof speed === "number" ? speed :
			speed in $.fx.speeds ? $.fx.speeds[ speed ] :
			$.fx.speeds._default;
	
		effect.complete = callback || options.complete;
	
		return effect;
	}
	
	function standardAnimationOption( option ) {
	
		// Valid standard speeds (nothing, number, named speed)
		if ( !option || typeof option === "number" || $.fx.speeds[ option ] ) {
			return true;
		}
	
		// Invalid strings - treat as "normal" speed
		if ( typeof option === "string" && !$.effects.effect[ option ] ) {
			return true;
		}
	
		// Complete callback
		if ( $.isFunction( option ) ) {
			return true;
		}
	
		// Options hash (but not naming an effect)
		if ( typeof option === "object" && !option.effect ) {
			return true;
		}
	
		// Didn't match any standard API
		return false;
	}
	
	$.fn.extend( {
		effect: function( /* effect, options, speed, callback */ ) {
			var args = _normalizeArguments.apply( this, arguments ),
				effectMethod = $.effects.effect[ args.effect ],
				defaultMode = effectMethod.mode,
				queue = args.queue,
				queueName = queue || "fx",
				complete = args.complete,
				mode = args.mode,
				modes = [],
				prefilter = function( next ) {
					var el = $( this ),
						normalizedMode = $.effects.mode( el, mode ) || defaultMode;
	
					// Sentinel for duck-punching the :animated psuedo-selector
					el.data( dataSpaceAnimated, true );
	
					// Save effect mode for later use,
					// we can't just call $.effects.mode again later,
					// as the .show() below destroys the initial state
					modes.push( normalizedMode );
	
					// See $.uiBackCompat inside of run() for removal of defaultMode in 1.13
					if ( defaultMode && ( normalizedMode === "show" ||
							( normalizedMode === defaultMode && normalizedMode === "hide" ) ) ) {
						el.show();
					}
	
					if ( !defaultMode || normalizedMode !== "none" ) {
						$.effects.saveStyle( el );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				};
	
			if ( $.fx.off || !effectMethod ) {
	
				// Delegate to the original method (e.g., .show()) if possible
				if ( mode ) {
					return this[ mode ]( args.duration, complete );
				} else {
					return this.each( function() {
						if ( complete ) {
							complete.call( this );
						}
					} );
				}
			}
	
			function run( next ) {
				var elem = $( this );
	
				function cleanup() {
					elem.removeData( dataSpaceAnimated );
	
					$.effects.cleanUp( elem );
	
					if ( args.mode === "hide" ) {
						elem.hide();
					}
	
					done();
				}
	
				function done() {
					if ( $.isFunction( complete ) ) {
						complete.call( elem[ 0 ] );
					}
	
					if ( $.isFunction( next ) ) {
						next();
					}
				}
	
				// Override mode option on a per element basis,
				// as toggle can be either show or hide depending on element state
				args.mode = modes.shift();
	
				if ( $.uiBackCompat !== false && !defaultMode ) {
					if ( elem.is( ":hidden" ) ? mode === "hide" : mode === "show" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, done );
					}
				} else {
					if ( args.mode === "none" ) {
	
						// Call the core method to track "olddisplay" properly
						elem[ mode ]();
						done();
					} else {
						effectMethod.call( elem[ 0 ], args, cleanup );
					}
				}
			}
	
			// Run prefilter on all elements first to ensure that
			// any showing or hiding happens before placeholder creation,
			// which ensures that any layout changes are correctly captured.
			return queue === false ?
				this.each( prefilter ).each( run ) :
				this.queue( queueName, prefilter ).queue( queueName, run );
		},
	
		show: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "show";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.show ),
	
		hide: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "hide";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.hide ),
	
		toggle: ( function( orig ) {
			return function( option ) {
				if ( standardAnimationOption( option ) || typeof option === "boolean" ) {
					return orig.apply( this, arguments );
				} else {
					var args = _normalizeArguments.apply( this, arguments );
					args.mode = "toggle";
					return this.effect.call( this, args );
				}
			};
		} )( $.fn.toggle ),
	
		cssUnit: function( key ) {
			var style = this.css( key ),
				val = [];
	
			$.each( [ "em", "px", "%", "pt" ], function( i, unit ) {
				if ( style.indexOf( unit ) > 0 ) {
					val = [ parseFloat( style ), unit ];
				}
			} );
			return val;
		},
	
		cssClip: function( clipObj ) {
			if ( clipObj ) {
				return this.css( "clip", "rect(" + clipObj.top + "px " + clipObj.right + "px " +
					clipObj.bottom + "px " + clipObj.left + "px)" );
			}
			return parseClip( this.css( "clip" ), this );
		},
	
		transfer: function( options, done ) {
			var element = $( this ),
				target = $( options.to ),
				targetFixed = target.css( "position" ) === "fixed",
				body = $( "body" ),
				fixTop = targetFixed ? body.scrollTop() : 0,
				fixLeft = targetFixed ? body.scrollLeft() : 0,
				endPosition = target.offset(),
				animation = {
					top: endPosition.top - fixTop,
					left: endPosition.left - fixLeft,
					height: target.innerHeight(),
					width: target.innerWidth()
				},
				startPosition = element.offset(),
				transfer = $( "<div class='ui-effects-transfer'></div>" )
					.appendTo( "body" )
					.addClass( options.className )
					.css( {
						top: startPosition.top - fixTop,
						left: startPosition.left - fixLeft,
						height: element.innerHeight(),
						width: element.innerWidth(),
						position: targetFixed ? "fixed" : "absolute"
					} )
					.animate( animation, options.duration, options.easing, function() {
						transfer.remove();
						if ( $.isFunction( done ) ) {
							done();
						}
					} );
		}
	} );
	
	function parseClip( str, element ) {
			var outerWidth = element.outerWidth(),
				outerHeight = element.outerHeight(),
				clipRegex = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
				values = clipRegex.exec( str ) || [ "", 0, outerWidth, outerHeight, 0 ];
	
			return {
				top: parseFloat( values[ 1 ] ) || 0,
				right: values[ 2 ] === "auto" ? outerWidth : parseFloat( values[ 2 ] ),
				bottom: values[ 3 ] === "auto" ? outerHeight : parseFloat( values[ 3 ] ),
				left: parseFloat( values[ 4 ] ) || 0
			};
	}
	
	$.fx.step.clip = function( fx ) {
		if ( !fx.clipInit ) {
			fx.start = $( fx.elem ).cssClip();
			if ( typeof fx.end === "string" ) {
				fx.end = parseClip( fx.end, fx.elem );
			}
			fx.clipInit = true;
		}
	
		$( fx.elem ).cssClip( {
			top: fx.pos * ( fx.end.top - fx.start.top ) + fx.start.top,
			right: fx.pos * ( fx.end.right - fx.start.right ) + fx.start.right,
			bottom: fx.pos * ( fx.end.bottom - fx.start.bottom ) + fx.start.bottom,
			left: fx.pos * ( fx.end.left - fx.start.left ) + fx.start.left
		} );
	};
	
	} )();
	
	/******************************************************************************/
	/*********************************** EASING ***********************************/
	/******************************************************************************/
	
	( function() {
	
	// Based on easing equations from Robert Penner (http://www.robertpenner.com/easing)
	
	var baseEasings = {};
	
	$.each( [ "Quad", "Cubic", "Quart", "Quint", "Expo" ], function( i, name ) {
		baseEasings[ name ] = function( p ) {
			return Math.pow( p, i + 2 );
		};
	} );
	
	$.extend( baseEasings, {
		Sine: function( p ) {
			return 1 - Math.cos( p * Math.PI / 2 );
		},
		Circ: function( p ) {
			return 1 - Math.sqrt( 1 - p * p );
		},
		Elastic: function( p ) {
			return p === 0 || p === 1 ? p :
				-Math.pow( 2, 8 * ( p - 1 ) ) * Math.sin( ( ( p - 1 ) * 80 - 7.5 ) * Math.PI / 15 );
		},
		Back: function( p ) {
			return p * p * ( 3 * p - 2 );
		},
		Bounce: function( p ) {
			var pow2,
				bounce = 4;
	
			while ( p < ( ( pow2 = Math.pow( 2, --bounce ) ) - 1 ) / 11 ) {}
			return 1 / Math.pow( 4, 3 - bounce ) - 7.5625 * Math.pow( ( pow2 * 3 - 2 ) / 22 - p, 2 );
		}
	} );
	
	$.each( baseEasings, function( name, easeIn ) {
		$.easing[ "easeIn" + name ] = easeIn;
		$.easing[ "easeOut" + name ] = function( p ) {
			return 1 - easeIn( 1 - p );
		};
		$.easing[ "easeInOut" + name ] = function( p ) {
			return p < 0.5 ?
				easeIn( p * 2 ) / 2 :
				1 - easeIn( p * -2 + 2 ) / 2;
		};
	} );
	
	} )();
	
	return $.effects;
	
	} ) );


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.0";
	
	} ) );


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	/**
	 * 'Extensions' of Marionette and Backbone.
	 * TODO: break apart separately into Marionette and Backbone.
	 */
	
	var Backbone = __webpack_require__(58),
	    Marionette = __webpack_require__(61);
	
	/**
	 * Note: requests target to have triggerMethod Method mixed in to receive
	 * -- really 'triggerMethod'.
	 */
	Marionette.blindTriggerOn = function(target, name) {
	
	    if (!target)
	        return;
	
	    var args =  Array.prototype.slice.call(arguments, 1); // includes name and any arguments passed
	
	    if (target instanceof Array) {
	        _.each(target, function(t) {
	            t && t.triggerMethod && t.triggerMethod.apply(t, args);
	        });
	    } else {
	        target.triggerMethod && target.triggerMethod.apply(target, args);
	    }
	
	};
	
	
	/**
	 * Note: temp until get rid of the last legacy ones
	 */
	_.extend( Backbone.View.prototype, {
	
	    /**
	     * Remove a view's childViews and then itself.
	     * Will call at top level of hierarchy to remove all.
	     * use justEmpty if you want to empty the div, rather than remove it
	     */
	    destroy: function(justEmpty) {
	
	        if (this.childViews) {
	
	            _.each(this.childViews, function(cv) {
	                if (cv && cv.destroy) {
	                    cv.destroy();
	                    cv = null;
	                }
	            });
	
	            this.childViews = null;
	        }
	
	        if (justEmpty) {
	
	            this.$el.empty();
	            this.stopListening();
	
	        } else {
	
	            this.remove();
	        }
	
	    },
	    /*
	    *  Helper to allow using of wrapper div in template without 'doubling' it.
	    *  Used when top left el left in template and not mentioned in bb view -- done post render.
	    *  Events undelegated, then delegated.
	    * */
	    unwrap: function() { //
	        this.setElement( this.$el.children().first().end() );
	    },
	
	    /**
	     * Literally all code from Backbone.View.remove replacing this.$el.remove(), with this.$el.empty().
	     * Override remove on view instances to call this method.
	     */
	    emptyRemove: function() {
	        this.$el.empty();
	        this.stopListening();
	        return this;
	    }
	
	});
	
	
	
	/**
	 * Extend Model Prototype
	 */
	
	_.extend( Backbone.Model.prototype, {
	
	    triggerMethod: Marionette.triggerMethod,
	
	    /**
	     * Must use trigger method.
	     * For naming, make clear this isn't the typical destroy
	     */
	    onDestroy: function() {
	        this.erase();
	    },
	
	    erase: function() {
	
	        this.clear({silent: true});
	        this.stopListening();
	        this.off();
	
	        /* delete instance props */
	        _.each( _.keys(this), function(key) {
	            delete this[key];
	        }, this);
	
	    },
	    /* toggle boolean attribute */
	    toggle: function(attr, options) {
	        this.set( attr, !this.get(attr), options ? options : {} );
	    },
	
	    // Allow for options to be passed to the constructor, like parse
	    clone: function( options ) {
	        return new this.constructor( this.attributes, options );
	    }
	
	});
	
	
	_.extend( Backbone.Collection.prototype, {
	
	    triggerMethod: Marionette.triggerMethod,
	
	    onDestroy: function() {
	        this.erase(); //for naming, make clear this isn't the typical destroy
	    },
	    /**
	     * Reset collection with no models/out triggering event.
	     * Could patch with destroy the model destroy above.
	     */
	    erase: function() {
	        Backbone.Collection.prototype.reset.call(this, [], {silent: true});
	        this.off();
	        this.stopListening();
	    }
	
	});
	
	
	
	/**
	 * Forward array of fn names to be called off target object with same arguments
	 * -- add to the addToObject if exists.
	 * Just trying to reduce some boilerplate.
	 * Allows the functions to be defined on the other object  -- they must exist to be invoked correctly.
	 * Works coming from, not to ...
	 */
	Backbone.fwdFnsOnObjAsFn = function(target, callFn, fnNames, fnHolder) {
	
	    fnHolder = fnHolder || this;
	    callFn = callFn || 'trigger';
	    _.each(fnNames, function(c) {
	        fnHolder[c] = function() {
	            target[callFn].apply(target, [c].concat(_.toArray(arguments)));
	        };
	    }, this);
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var Mousetrap = __webpack_require__(68);
	
	/**
	 * Mousetrap.stopCallback is a method that is called to see if the keyboard event
	 * should fire based on if you are inside a form input field.
	 * If true is returned then it stops the callback from firing, if false it fires it.
	 * As of version 1.5+, must put on the prototype:
	 * https://stackoverflow.com/questions/21013866/mousetrap-bind-is-not-working-when-field-is-in-focus
	 */
	
	Mousetrap.prototype.stopCallback = function(e, element, combo) {
	
	    var elementsNotAllowed =
	            (element.tagName === 'INPUT' || element.tagName === 'SELECT' ||
	                element.tagName === 'TEXTAREA' || (element.contentEditable && element.contentEditable === 'true')),
	
	        keysAllowed = (combo !== 'esc')
	            && (combo !=='shift+enter')
	            && (combo !=='up')
	            && (combo !=='down')
	            && (combo !=='right')
	            && (combo !=='left')
	        ;
	
	    return elementsNotAllowed && keysAllowed;
	
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
	/**
	 * Copyright 2012-2017 Craig Campbell
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * Mousetrap is a simple keyboard shortcut library for Javascript with
	 * no external dependencies
	 *
	 * @version 1.6.5
	 * @url craig.is/killing/mice
	 */
	(function(window, document, undefined) {
	
	    // Check if mousetrap is used inside browser, if not, return
	    if (!window) {
	        return;
	    }
	
	    /**
	     * mapping of special keycodes to their corresponding keys
	     *
	     * everything in this dictionary cannot use keypress events
	     * so it has to be here to map to the correct keycodes for
	     * keyup/keydown events
	     *
	     * @type {Object}
	     */
	    var _MAP = {
	        8: 'backspace',
	        9: 'tab',
	        13: 'enter',
	        16: 'shift',
	        17: 'ctrl',
	        18: 'alt',
	        20: 'capslock',
	        27: 'esc',
	        32: 'space',
	        33: 'pageup',
	        34: 'pagedown',
	        35: 'end',
	        36: 'home',
	        37: 'left',
	        38: 'up',
	        39: 'right',
	        40: 'down',
	        45: 'ins',
	        46: 'del',
	        91: 'meta',
	        93: 'meta',
	        224: 'meta'
	    };
	
	    /**
	     * mapping for special characters so they can support
	     *
	     * this dictionary is only used incase you want to bind a
	     * keyup or keydown event to one of these keys
	     *
	     * @type {Object}
	     */
	    var _KEYCODE_MAP = {
	        106: '*',
	        107: '+',
	        109: '-',
	        110: '.',
	        111 : '/',
	        186: ';',
	        187: '=',
	        188: ',',
	        189: '-',
	        190: '.',
	        191: '/',
	        192: '`',
	        219: '[',
	        220: '\\',
	        221: ']',
	        222: '\''
	    };
	
	    /**
	     * this is a mapping of keys that require shift on a US keypad
	     * back to the non shift equivelents
	     *
	     * this is so you can use keyup events with these keys
	     *
	     * note that this will only work reliably on US keyboards
	     *
	     * @type {Object}
	     */
	    var _SHIFT_MAP = {
	        '~': '`',
	        '!': '1',
	        '@': '2',
	        '#': '3',
	        '$': '4',
	        '%': '5',
	        '^': '6',
	        '&': '7',
	        '*': '8',
	        '(': '9',
	        ')': '0',
	        '_': '-',
	        '+': '=',
	        ':': ';',
	        '\"': '\'',
	        '<': ',',
	        '>': '.',
	        '?': '/',
	        '|': '\\'
	    };
	
	    /**
	     * this is a list of special strings you can use to map
	     * to modifier keys when you specify your keyboard shortcuts
	     *
	     * @type {Object}
	     */
	    var _SPECIAL_ALIASES = {
	        'option': 'alt',
	        'command': 'meta',
	        'return': 'enter',
	        'escape': 'esc',
	        'plus': '+',
	        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
	    };
	
	    /**
	     * variable to store the flipped version of _MAP from above
	     * needed to check if we should use keypress or not when no action
	     * is specified
	     *
	     * @type {Object|undefined}
	     */
	    var _REVERSE_MAP;
	
	    /**
	     * loop through the f keys, f1 to f19 and add them to the map
	     * programatically
	     */
	    for (var i = 1; i < 20; ++i) {
	        _MAP[111 + i] = 'f' + i;
	    }
	
	    /**
	     * loop through to map numbers on the numeric keypad
	     */
	    for (i = 0; i <= 9; ++i) {
	
	        // This needs to use a string cause otherwise since 0 is falsey
	        // mousetrap will never fire for numpad 0 pressed as part of a keydown
	        // event.
	        //
	        // @see https://github.com/ccampbell/mousetrap/pull/258
	        _MAP[i + 96] = i.toString();
	    }
	
	    /**
	     * cross browser add event method
	     *
	     * @param {Element|HTMLDocument} object
	     * @param {string} type
	     * @param {Function} callback
	     * @returns void
	     */
	    function _addEvent(object, type, callback) {
	        if (object.addEventListener) {
	            object.addEventListener(type, callback, false);
	            return;
	        }
	
	        object.attachEvent('on' + type, callback);
	    }
	
	    /**
	     * takes the event and returns the key character
	     *
	     * @param {Event} e
	     * @return {string}
	     */
	    function _characterFromEvent(e) {
	
	        // for keypress events we should return the character as is
	        if (e.type == 'keypress') {
	            var character = String.fromCharCode(e.which);
	
	            // if the shift key is not pressed then it is safe to assume
	            // that we want the character to be lowercase.  this means if
	            // you accidentally have caps lock on then your key bindings
	            // will continue to work
	            //
	            // the only side effect that might not be desired is if you
	            // bind something like 'A' cause you want to trigger an
	            // event when capital A is pressed caps lock will no longer
	            // trigger the event.  shift+a will though.
	            if (!e.shiftKey) {
	                character = character.toLowerCase();
	            }
	
	            return character;
	        }
	
	        // for non keypress events the special maps are needed
	        if (_MAP[e.which]) {
	            return _MAP[e.which];
	        }
	
	        if (_KEYCODE_MAP[e.which]) {
	            return _KEYCODE_MAP[e.which];
	        }
	
	        // if it is not in the special map
	
	        // with keydown and keyup events the character seems to always
	        // come in as an uppercase character whether you are pressing shift
	        // or not.  we should make sure it is always lowercase for comparisons
	        return String.fromCharCode(e.which).toLowerCase();
	    }
	
	    /**
	     * checks if two arrays are equal
	     *
	     * @param {Array} modifiers1
	     * @param {Array} modifiers2
	     * @returns {boolean}
	     */
	    function _modifiersMatch(modifiers1, modifiers2) {
	        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
	    }
	
	    /**
	     * takes a key event and figures out what the modifiers are
	     *
	     * @param {Event} e
	     * @returns {Array}
	     */
	    function _eventModifiers(e) {
	        var modifiers = [];
	
	        if (e.shiftKey) {
	            modifiers.push('shift');
	        }
	
	        if (e.altKey) {
	            modifiers.push('alt');
	        }
	
	        if (e.ctrlKey) {
	            modifiers.push('ctrl');
	        }
	
	        if (e.metaKey) {
	            modifiers.push('meta');
	        }
	
	        return modifiers;
	    }
	
	    /**
	     * prevents default for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _preventDefault(e) {
	        if (e.preventDefault) {
	            e.preventDefault();
	            return;
	        }
	
	        e.returnValue = false;
	    }
	
	    /**
	     * stops propogation for this event
	     *
	     * @param {Event} e
	     * @returns void
	     */
	    function _stopPropagation(e) {
	        if (e.stopPropagation) {
	            e.stopPropagation();
	            return;
	        }
	
	        e.cancelBubble = true;
	    }
	
	    /**
	     * determines if the keycode specified is a modifier key or not
	     *
	     * @param {string} key
	     * @returns {boolean}
	     */
	    function _isModifier(key) {
	        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
	    }
	
	    /**
	     * reverses the map lookup so that we can look for specific keys
	     * to see what can and can't use keypress
	     *
	     * @return {Object}
	     */
	    function _getReverseMap() {
	        if (!_REVERSE_MAP) {
	            _REVERSE_MAP = {};
	            for (var key in _MAP) {
	
	                // pull out the numeric keypad from here cause keypress should
	                // be able to detect the keys from the character
	                if (key > 95 && key < 112) {
	                    continue;
	                }
	
	                if (_MAP.hasOwnProperty(key)) {
	                    _REVERSE_MAP[_MAP[key]] = key;
	                }
	            }
	        }
	        return _REVERSE_MAP;
	    }
	
	    /**
	     * picks the best action based on the key combination
	     *
	     * @param {string} key - character for key
	     * @param {Array} modifiers
	     * @param {string=} action passed in
	     */
	    function _pickBestAction(key, modifiers, action) {
	
	        // if no action was picked in we should try to pick the one
	        // that we think would work best for this key
	        if (!action) {
	            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
	        }
	
	        // modifier keys don't work as expected with keypress,
	        // switch to keydown
	        if (action == 'keypress' && modifiers.length) {
	            action = 'keydown';
	        }
	
	        return action;
	    }
	
	    /**
	     * Converts from a string key combination to an array
	     *
	     * @param  {string} combination like "command+shift+l"
	     * @return {Array}
	     */
	    function _keysFromString(combination) {
	        if (combination === '+') {
	            return ['+'];
	        }
	
	        combination = combination.replace(/\+{2}/g, '+plus');
	        return combination.split('+');
	    }
	
	    /**
	     * Gets info for a specific key combination
	     *
	     * @param  {string} combination key combination ("command+s" or "a" or "*")
	     * @param  {string=} action
	     * @returns {Object}
	     */
	    function _getKeyInfo(combination, action) {
	        var keys;
	        var key;
	        var i;
	        var modifiers = [];
	
	        // take the keys from this pattern and figure out what the actual
	        // pattern is all about
	        keys = _keysFromString(combination);
	
	        for (i = 0; i < keys.length; ++i) {
	            key = keys[i];
	
	            // normalize key names
	            if (_SPECIAL_ALIASES[key]) {
	                key = _SPECIAL_ALIASES[key];
	            }
	
	            // if this is not a keypress event then we should
	            // be smart about using shift keys
	            // this will only work for US keyboards however
	            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
	                key = _SHIFT_MAP[key];
	                modifiers.push('shift');
	            }
	
	            // if this key is a modifier then add it to the list of modifiers
	            if (_isModifier(key)) {
	                modifiers.push(key);
	            }
	        }
	
	        // depending on what the key combination is
	        // we will try to pick the best event for it
	        action = _pickBestAction(key, modifiers, action);
	
	        return {
	            key: key,
	            modifiers: modifiers,
	            action: action
	        };
	    }
	
	    function _belongsTo(element, ancestor) {
	        if (element === null || element === document) {
	            return false;
	        }
	
	        if (element === ancestor) {
	            return true;
	        }
	
	        return _belongsTo(element.parentNode, ancestor);
	    }
	
	    function Mousetrap(targetElement) {
	        var self = this;
	
	        targetElement = targetElement || document;
	
	        if (!(self instanceof Mousetrap)) {
	            return new Mousetrap(targetElement);
	        }
	
	        /**
	         * element to attach key events to
	         *
	         * @type {Element}
	         */
	        self.target = targetElement;
	
	        /**
	         * a list of all the callbacks setup via Mousetrap.bind()
	         *
	         * @type {Object}
	         */
	        self._callbacks = {};
	
	        /**
	         * direct map of string combinations to callbacks used for trigger()
	         *
	         * @type {Object}
	         */
	        self._directMap = {};
	
	        /**
	         * keeps track of what level each sequence is at since multiple
	         * sequences can start out with the same sequence
	         *
	         * @type {Object}
	         */
	        var _sequenceLevels = {};
	
	        /**
	         * variable to store the setTimeout call
	         *
	         * @type {null|number}
	         */
	        var _resetTimer;
	
	        /**
	         * temporary state where we will ignore the next keyup
	         *
	         * @type {boolean|string}
	         */
	        var _ignoreNextKeyup = false;
	
	        /**
	         * temporary state where we will ignore the next keypress
	         *
	         * @type {boolean}
	         */
	        var _ignoreNextKeypress = false;
	
	        /**
	         * are we currently inside of a sequence?
	         * type of action ("keyup" or "keydown" or "keypress") or false
	         *
	         * @type {boolean|string}
	         */
	        var _nextExpectedAction = false;
	
	        /**
	         * resets all sequence counters except for the ones passed in
	         *
	         * @param {Object} doNotReset
	         * @returns void
	         */
	        function _resetSequences(doNotReset) {
	            doNotReset = doNotReset || {};
	
	            var activeSequences = false,
	                key;
	
	            for (key in _sequenceLevels) {
	                if (doNotReset[key]) {
	                    activeSequences = true;
	                    continue;
	                }
	                _sequenceLevels[key] = 0;
	            }
	
	            if (!activeSequences) {
	                _nextExpectedAction = false;
	            }
	        }
	
	        /**
	         * finds all callbacks that match based on the keycode, modifiers,
	         * and action
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event|Object} e
	         * @param {string=} sequenceName - name of the sequence we are looking for
	         * @param {string=} combination
	         * @param {number=} level
	         * @returns {Array}
	         */
	        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
	            var i;
	            var callback;
	            var matches = [];
	            var action = e.type;
	
	            // if there are no events related to this keycode
	            if (!self._callbacks[character]) {
	                return [];
	            }
	
	            // if a modifier key is coming up on its own we should allow it
	            if (action == 'keyup' && _isModifier(character)) {
	                modifiers = [character];
	            }
	
	            // loop through all callbacks for the key that was pressed
	            // and see if any of them match
	            for (i = 0; i < self._callbacks[character].length; ++i) {
	                callback = self._callbacks[character][i];
	
	                // if a sequence name is not specified, but this is a sequence at
	                // the wrong level then move onto the next match
	                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
	                    continue;
	                }
	
	                // if the action we are looking for doesn't match the action we got
	                // then we should keep going
	                if (action != callback.action) {
	                    continue;
	                }
	
	                // if this is a keypress event and the meta key and control key
	                // are not pressed that means that we need to only look at the
	                // character, otherwise check the modifiers as well
	                //
	                // chrome will not fire a keypress if meta or control is down
	                // safari will fire a keypress if meta or meta+shift is down
	                // firefox will fire a keypress if meta or control is down
	                if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {
	
	                    // when you bind a combination or sequence a second time it
	                    // should overwrite the first one.  if a sequenceName or
	                    // combination is specified in this call it does just that
	                    //
	                    // @todo make deleting its own method?
	                    var deleteCombo = !sequenceName && callback.combo == combination;
	                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
	                    if (deleteCombo || deleteSequence) {
	                        self._callbacks[character].splice(i, 1);
	                    }
	
	                    matches.push(callback);
	                }
	            }
	
	            return matches;
	        }
	
	        /**
	         * actually calls the callback function
	         *
	         * if your callback function returns false this will use the jquery
	         * convention - prevent default and stop propogation on the event
	         *
	         * @param {Function} callback
	         * @param {Event} e
	         * @returns void
	         */
	        function _fireCallback(callback, e, combo, sequence) {
	
	            // if this event should not happen stop here
	            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
	                return;
	            }
	
	            if (callback(e, combo) === false) {
	                _preventDefault(e);
	                _stopPropagation(e);
	            }
	        }
	
	        /**
	         * handles a character key event
	         *
	         * @param {string} character
	         * @param {Array} modifiers
	         * @param {Event} e
	         * @returns void
	         */
	        self._handleKey = function(character, modifiers, e) {
	            var callbacks = _getMatches(character, modifiers, e);
	            var i;
	            var doNotReset = {};
	            var maxLevel = 0;
	            var processedSequenceCallback = false;
	
	            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
	            for (i = 0; i < callbacks.length; ++i) {
	                if (callbacks[i].seq) {
	                    maxLevel = Math.max(maxLevel, callbacks[i].level);
	                }
	            }
	
	            // loop through matching callbacks for this key event
	            for (i = 0; i < callbacks.length; ++i) {
	
	                // fire for all sequence callbacks
	                // this is because if for example you have multiple sequences
	                // bound such as "g i" and "g t" they both need to fire the
	                // callback for matching g cause otherwise you can only ever
	                // match the first one
	                if (callbacks[i].seq) {
	
	                    // only fire callbacks for the maxLevel to prevent
	                    // subsequences from also firing
	                    //
	                    // for example 'a option b' should not cause 'option b' to fire
	                    // even though 'option b' is part of the other sequence
	                    //
	                    // any sequences that do not match here will be discarded
	                    // below by the _resetSequences call
	                    if (callbacks[i].level != maxLevel) {
	                        continue;
	                    }
	
	                    processedSequenceCallback = true;
	
	                    // keep a list of which sequences were matches for later
	                    doNotReset[callbacks[i].seq] = 1;
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
	                    continue;
	                }
	
	                // if there were no sequence matches but we are still here
	                // that means this is a regular match so we should fire that
	                if (!processedSequenceCallback) {
	                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
	                }
	            }
	
	            // if the key you pressed matches the type of sequence without
	            // being a modifier (ie "keyup" or "keypress") then we should
	            // reset all sequences that were not matched by this event
	            //
	            // this is so, for example, if you have the sequence "h a t" and you
	            // type "h e a r t" it does not match.  in this case the "e" will
	            // cause the sequence to reset
	            //
	            // modifier keys are ignored because you can have a sequence
	            // that contains modifiers such as "enter ctrl+space" and in most
	            // cases the modifier key will be pressed before the next key
	            //
	            // also if you have a sequence such as "ctrl+b a" then pressing the
	            // "b" key will trigger a "keypress" and a "keydown"
	            //
	            // the "keydown" is expected when there is a modifier, but the
	            // "keypress" ends up matching the _nextExpectedAction since it occurs
	            // after and that causes the sequence to reset
	            //
	            // we ignore keypresses in a sequence that directly follow a keydown
	            // for the same character
	            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
	            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
	                _resetSequences(doNotReset);
	            }
	
	            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
	        };
	
	        /**
	         * handles a keydown event
	         *
	         * @param {Event} e
	         * @returns void
	         */
	        function _handleKeyEvent(e) {
	
	            // normalize e.which for key events
	            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
	            if (typeof e.which !== 'number') {
	                e.which = e.keyCode;
	            }
	
	            var character = _characterFromEvent(e);
	
	            // no character found then stop
	            if (!character) {
	                return;
	            }
	
	            // need to use === for the character check because the character can be 0
	            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
	                _ignoreNextKeyup = false;
	                return;
	            }
	
	            self.handleKey(character, _eventModifiers(e), e);
	        }
	
	        /**
	         * called to set a 1 second timeout on the specified sequence
	         *
	         * this is so after each key press in the sequence you have 1 second
	         * to press the next key before you have to start over
	         *
	         * @returns void
	         */
	        function _resetSequenceTimer() {
	            clearTimeout(_resetTimer);
	            _resetTimer = setTimeout(_resetSequences, 1000);
	        }
	
	        /**
	         * binds a key sequence to an event
	         *
	         * @param {string} combo - combo specified in bind call
	         * @param {Array} keys
	         * @param {Function} callback
	         * @param {string=} action
	         * @returns void
	         */
	        function _bindSequence(combo, keys, callback, action) {
	
	            // start off by adding a sequence level record for this combination
	            // and setting the level to 0
	            _sequenceLevels[combo] = 0;
	
	            /**
	             * callback to increase the sequence level for this sequence and reset
	             * all other sequences that were active
	             *
	             * @param {string} nextAction
	             * @returns {Function}
	             */
	            function _increaseSequence(nextAction) {
	                return function() {
	                    _nextExpectedAction = nextAction;
	                    ++_sequenceLevels[combo];
	                    _resetSequenceTimer();
	                };
	            }
	
	            /**
	             * wraps the specified callback inside of another function in order
	             * to reset all sequence counters as soon as this sequence is done
	             *
	             * @param {Event} e
	             * @returns void
	             */
	            function _callbackAndReset(e) {
	                _fireCallback(callback, e, combo);
	
	                // we should ignore the next key up if the action is key down
	                // or keypress.  this is so if you finish a sequence and
	                // release the key the final key will not trigger a keyup
	                if (action !== 'keyup') {
	                    _ignoreNextKeyup = _characterFromEvent(e);
	                }
	
	                // weird race condition if a sequence ends with the key
	                // another sequence begins with
	                setTimeout(_resetSequences, 10);
	            }
	
	            // loop through keys one at a time and bind the appropriate callback
	            // function.  for any key leading up to the final one it should
	            // increase the sequence. after the final, it should reset all sequences
	            //
	            // if an action is specified in the original bind call then that will
	            // be used throughout.  otherwise we will pass the action that the
	            // next key in the sequence should match.  this allows a sequence
	            // to mix and match keypress and keydown events depending on which
	            // ones are better suited to the key provided
	            for (var i = 0; i < keys.length; ++i) {
	                var isFinal = i + 1 === keys.length;
	                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
	                _bindSingle(keys[i], wrappedCallback, action, combo, i);
	            }
	        }
	
	        /**
	         * binds a single keyboard combination
	         *
	         * @param {string} combination
	         * @param {Function} callback
	         * @param {string=} action
	         * @param {string=} sequenceName - name of sequence if part of sequence
	         * @param {number=} level - what part of the sequence the command is
	         * @returns void
	         */
	        function _bindSingle(combination, callback, action, sequenceName, level) {
	
	            // store a direct mapped reference for use with Mousetrap.trigger
	            self._directMap[combination + ':' + action] = callback;
	
	            // make sure multiple spaces in a row become a single space
	            combination = combination.replace(/\s+/g, ' ');
	
	            var sequence = combination.split(' ');
	            var info;
	
	            // if this pattern is a sequence of keys then run through this method
	            // to reprocess each pattern one key at a time
	            if (sequence.length > 1) {
	                _bindSequence(combination, sequence, callback, action);
	                return;
	            }
	
	            info = _getKeyInfo(combination, action);
	
	            // make sure to initialize array if this is the first time
	            // a callback is added for this key
	            self._callbacks[info.key] = self._callbacks[info.key] || [];
	
	            // remove an existing match if there is one
	            _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);
	
	            // add this call back to the array
	            // if it is a sequence put it at the beginning
	            // if not put it at the end
	            //
	            // this is important because the way these are processed expects
	            // the sequence ones to come first
	            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
	                callback: callback,
	                modifiers: info.modifiers,
	                action: info.action,
	                seq: sequenceName,
	                level: level,
	                combo: combination
	            });
	        }
	
	        /**
	         * binds multiple combinations to the same callback
	         *
	         * @param {Array} combinations
	         * @param {Function} callback
	         * @param {string|undefined} action
	         * @returns void
	         */
	        self._bindMultiple = function(combinations, callback, action) {
	            for (var i = 0; i < combinations.length; ++i) {
	                _bindSingle(combinations[i], callback, action);
	            }
	        };
	
	        // start!
	        _addEvent(targetElement, 'keypress', _handleKeyEvent);
	        _addEvent(targetElement, 'keydown', _handleKeyEvent);
	        _addEvent(targetElement, 'keyup', _handleKeyEvent);
	    }
	
	    /**
	     * binds an event to mousetrap
	     *
	     * can be a single key, a combination of keys separated with +,
	     * an array of keys, or a sequence of keys separated by spaces
	     *
	     * be sure to list the modifier keys first to make sure that the
	     * correct key ends up getting bound (the last key in the pattern)
	     *
	     * @param {string|Array} keys
	     * @param {Function} callback
	     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
	     * @returns void
	     */
	    Mousetrap.prototype.bind = function(keys, callback, action) {
	        var self = this;
	        keys = keys instanceof Array ? keys : [keys];
	        self._bindMultiple.call(self, keys, callback, action);
	        return self;
	    };
	
	    /**
	     * unbinds an event to mousetrap
	     *
	     * the unbinding sets the callback function of the specified key combo
	     * to an empty function and deletes the corresponding key in the
	     * _directMap dict.
	     *
	     * TODO: actually remove this from the _callbacks dictionary instead
	     * of binding an empty function
	     *
	     * the keycombo+action has to be exactly the same as
	     * it was defined in the bind method
	     *
	     * @param {string|Array} keys
	     * @param {string} action
	     * @returns void
	     */
	    Mousetrap.prototype.unbind = function(keys, action) {
	        var self = this;
	        return self.bind.call(self, keys, function() {}, action);
	    };
	
	    /**
	     * triggers an event that has already been bound
	     *
	     * @param {string} keys
	     * @param {string=} action
	     * @returns void
	     */
	    Mousetrap.prototype.trigger = function(keys, action) {
	        var self = this;
	        if (self._directMap[keys + ':' + action]) {
	            self._directMap[keys + ':' + action]({}, keys);
	        }
	        return self;
	    };
	
	    /**
	     * resets the library back to its initial state.  this is useful
	     * if you want to clear out the current keyboard shortcuts and bind
	     * new ones - for example if you switch to another page
	     *
	     * @returns void
	     */
	    Mousetrap.prototype.reset = function() {
	        var self = this;
	        self._callbacks = {};
	        self._directMap = {};
	        return self;
	    };
	
	    /**
	     * should we stop this event before firing off callbacks
	     *
	     * @param {Event} e
	     * @param {Element} element
	     * @return {boolean}
	     */
	    Mousetrap.prototype.stopCallback = function(e, element) {
	        var self = this;
	
	        // if the element has the class "mousetrap" then no need to stop
	        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
	            return false;
	        }
	
	        if (_belongsTo(element, self.target)) {
	            return false;
	        }
	
	        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
	        // not the initial event target in the shadow tree. Note that not all events cross the
	        // shadow boundary.
	        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
	        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
	        // target cannot be obtained.
	        if ('composedPath' in e && typeof e.composedPath === 'function') {
	            // For open shadow trees, update `element` so that the following check works.
	            var initialEventTarget = e.composedPath()[0];
	            if (initialEventTarget !== e.target) {
	                element = initialEventTarget;
	            }
	        }
	
	        // stop for input, select, and textarea
	        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
	    };
	
	    /**
	     * exposes _handleKey publicly so it can be overwritten by extensions
	     */
	    Mousetrap.prototype.handleKey = function() {
	        var self = this;
	        return self._handleKey.apply(self, arguments);
	    };
	
	    /**
	     * allow custom key mappings
	     */
	    Mousetrap.addKeycodes = function(object) {
	        for (var key in object) {
	            if (object.hasOwnProperty(key)) {
	                _MAP[key] = object[key];
	            }
	        }
	        _REVERSE_MAP = null;
	    };
	
	    /**
	     * Init the global mousetrap functions
	     *
	     * This method is needed to allow the global mousetrap functions to work
	     * now that mousetrap is a constructor function.
	     */
	    Mousetrap.init = function() {
	        var documentMousetrap = Mousetrap(document);
	        for (var method in documentMousetrap) {
	            if (method.charAt(0) !== '_') {
	                Mousetrap[method] = (function(method) {
	                    return function() {
	                        return documentMousetrap[method].apply(documentMousetrap, arguments);
	                    };
	                } (method));
	            }
	        }
	    };
	
	    Mousetrap.init();
	
	    // expose mousetrap to the global object
	    window.Mousetrap = Mousetrap;
	
	    // expose as a common js module
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Mousetrap;
	    }
	
	    // expose mousetrap as an AMD module
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return Mousetrap;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}) (typeof window !== 'undefined' ? window : null, typeof  window !== 'undefined' ? document : null);


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {//! moment.js
	//! version : 2.9.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (undefined) {
	    /************************************
	        Constants
	    ************************************/
	
	    var moment,
	        VERSION = '2.9.0',
	        // the global-scope this is NOT the global object in Node.js
	        globalScope = (typeof global !== 'undefined' && (typeof window === 'undefined' || window === global.window)) ? global : this,
	        oldGlobalMoment,
	        round = Math.round,
	        hasOwnProperty = Object.prototype.hasOwnProperty,
	        i,
	
	        YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	
	        // internal storage for locale config files
	        locales = {},
	
	        // extra moment internal properties (plugins register props here)
	        momentProperties = [],
	
	        // check for nodeJS
	        hasModule = (typeof module !== 'undefined' && module && module.exports),
	
	        // ASP.NET json date format regex
	        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
	        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,
	
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,
	
	        // format tokens
	        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	
	        // parsing token regexes
	        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
	        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
	        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
	        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
	        parseTokenDigits = /\d+/, // nonzero number of digits
	        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
	        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        parseTokenT = /T/i, // T (ISO separator)
	        parseTokenOffsetMs = /[\+\-]?\d+/, // 1234567890123
	        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	
	        //strict parsing regexes
	        parseTokenOneDigit = /\d/, // 0 - 9
	        parseTokenTwoDigits = /\d\d/, // 00 - 99
	        parseTokenThreeDigits = /\d{3}/, // 000 - 999
	        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
	        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
	        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf
	
	        // iso 8601 regex
	        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	
	        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',
	
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	            ['YYYY-DDD', /\d{4}-\d{3}/]
	        ],
	
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	            ['HH:mm', /(T| )\d\d:\d\d/],
	            ['HH', /(T| )\d\d/]
	        ],
	
	        // timezone chunker '+10:00' > ['10', '00'] or '-1530' > ['-', '15', '30']
	        parseTimezoneChunker = /([\+\-]|\d\d)/gi,
	
	        // getter and setter names
	        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
	        unitMillisecondFactors = {
	            'Milliseconds' : 1,
	            'Seconds' : 1e3,
	            'Minutes' : 6e4,
	            'Hours' : 36e5,
	            'Days' : 864e5,
	            'Months' : 2592e6,
	            'Years' : 31536e6
	        },
	
	        unitAliases = {
	            ms : 'millisecond',
	            s : 'second',
	            m : 'minute',
	            h : 'hour',
	            d : 'day',
	            D : 'date',
	            w : 'week',
	            W : 'isoWeek',
	            M : 'month',
	            Q : 'quarter',
	            y : 'year',
	            DDD : 'dayOfYear',
	            e : 'weekday',
	            E : 'isoWeekday',
	            gg: 'weekYear',
	            GG: 'isoWeekYear'
	        },
	
	        camelFunctions = {
	            dayofyear : 'dayOfYear',
	            isoweekday : 'isoWeekday',
	            isoweek : 'isoWeek',
	            weekyear : 'weekYear',
	            isoweekyear : 'isoWeekYear'
	        },
	
	        // format function strings
	        formatFunctions = {},
	
	        // default relative time thresholds
	        relativeTimeThresholds = {
	            s: 45,  // seconds to minute
	            m: 45,  // minutes to hour
	            h: 22,  // hours to day
	            d: 26,  // days to month
	            M: 11   // months to year
	        },
	
	        // tokens to ordinalize and pad
	        ordinalizeTokens = 'DDD w W M D d'.split(' '),
	        paddedTokens = 'M D H h m s w W'.split(' '),
	
	        formatTokenFunctions = {
	            M    : function () {
	                return this.month() + 1;
	            },
	            MMM  : function (format) {
	                return this.localeData().monthsShort(this, format);
	            },
	            MMMM : function (format) {
	                return this.localeData().months(this, format);
	            },
	            D    : function () {
	                return this.date();
	            },
	            DDD  : function () {
	                return this.dayOfYear();
	            },
	            d    : function () {
	                return this.day();
	            },
	            dd   : function (format) {
	                return this.localeData().weekdaysMin(this, format);
	            },
	            ddd  : function (format) {
	                return this.localeData().weekdaysShort(this, format);
	            },
	            dddd : function (format) {
	                return this.localeData().weekdays(this, format);
	            },
	            w    : function () {
	                return this.week();
	            },
	            W    : function () {
	                return this.isoWeek();
	            },
	            YY   : function () {
	                return leftZeroFill(this.year() % 100, 2);
	            },
	            YYYY : function () {
	                return leftZeroFill(this.year(), 4);
	            },
	            YYYYY : function () {
	                return leftZeroFill(this.year(), 5);
	            },
	            YYYYYY : function () {
	                var y = this.year(), sign = y >= 0 ? '+' : '-';
	                return sign + leftZeroFill(Math.abs(y), 6);
	            },
	            gg   : function () {
	                return leftZeroFill(this.weekYear() % 100, 2);
	            },
	            gggg : function () {
	                return leftZeroFill(this.weekYear(), 4);
	            },
	            ggggg : function () {
	                return leftZeroFill(this.weekYear(), 5);
	            },
	            GG   : function () {
	                return leftZeroFill(this.isoWeekYear() % 100, 2);
	            },
	            GGGG : function () {
	                return leftZeroFill(this.isoWeekYear(), 4);
	            },
	            GGGGG : function () {
	                return leftZeroFill(this.isoWeekYear(), 5);
	            },
	            e : function () {
	                return this.weekday();
	            },
	            E : function () {
	                return this.isoWeekday();
	            },
	            a    : function () {
	                return this.localeData().meridiem(this.hours(), this.minutes(), true);
	            },
	            A    : function () {
	                return this.localeData().meridiem(this.hours(), this.minutes(), false);
	            },
	            H    : function () {
	                return this.hours();
	            },
	            h    : function () {
	                return this.hours() % 12 || 12;
	            },
	            m    : function () {
	                return this.minutes();
	            },
	            s    : function () {
	                return this.seconds();
	            },
	            S    : function () {
	                return toInt(this.milliseconds() / 100);
	            },
	            SS   : function () {
	                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
	            },
	            SSS  : function () {
	                return leftZeroFill(this.milliseconds(), 3);
	            },
	            SSSS : function () {
	                return leftZeroFill(this.milliseconds(), 3);
	            },
	            Z    : function () {
	                var a = this.utcOffset(),
	                    b = '+';
	                if (a < 0) {
	                    a = -a;
	                    b = '-';
	                }
	                return b + leftZeroFill(toInt(a / 60), 2) + ':' + leftZeroFill(toInt(a) % 60, 2);
	            },
	            ZZ   : function () {
	                var a = this.utcOffset(),
	                    b = '+';
	                if (a < 0) {
	                    a = -a;
	                    b = '-';
	                }
	                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
	            },
	            z : function () {
	                return this.zoneAbbr();
	            },
	            zz : function () {
	                return this.zoneName();
	            },
	            x    : function () {
	                return this.valueOf();
	            },
	            X    : function () {
	                return this.unix();
	            },
	            Q : function () {
	                return this.quarter();
	            }
	        },
	
	        deprecations = {},
	
	        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'],
	
	        updateInProgress = false;
	
	    // Pick the first defined of two or three arguments. dfl comes from
	    // default.
	    function dfl(a, b, c) {
	        switch (arguments.length) {
	            case 2: return a != null ? a : b;
	            case 3: return a != null ? a : b != null ? b : c;
	            default: throw new Error('Implement me');
	        }
	    }
	
	    function hasOwnProp(a, b) {
	        return hasOwnProperty.call(a, b);
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object, and es5 standard is not very
	        // helpful.
	        return {
	            empty : false,
	            unusedTokens : [],
	            unusedInput : [],
	            overflow : -2,
	            charsLeftOver : 0,
	            nullInput : false,
	            invalidMonth : null,
	            invalidFormat : false,
	            userInvalidated : false,
	            iso: false
	        };
	    }
	
	    function printMsg(msg) {
	        if (moment.suppressDeprecationWarnings === false &&
	                typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	        return extend(function () {
	            if (firstTime) {
	                printMsg(msg);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            printMsg(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    function padToken(func, count) {
	        return function (a) {
	            return leftZeroFill(func.call(this, a), count);
	        };
	    }
	    function ordinalizeToken(func, period) {
	        return function (a) {
	            return this.localeData().ordinal(func.call(this, a), period);
	        };
	    }
	
	    function monthDiff(a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    while (ordinalizeTokens.length) {
	        i = ordinalizeTokens.pop();
	        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
	    }
	    while (paddedTokens.length) {
	        i = paddedTokens.pop();
	        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
	    }
	    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);
	
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // thie is not supposed to happen
	            return hour;
	        }
	    }
	
	    /************************************
	        Constructors
	    ************************************/
	
	    function Locale() {
	    }
	
	    // Moment prototype object
	    function Moment(config, skipOverflow) {
	        if (skipOverflow !== false) {
	            checkOverflow(config);
	        }
	        copyConfig(this, config);
	        this._d = new Date(+config._d);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            moment.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    // Duration Constructor
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = moment.localeData();
	
	        this._bubble();
	    }
	
	    /************************************
	        Helpers
	    ************************************/
	
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = from._pf;
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    // left zero fill a number
	    // see http://jsperf.com/left-zero-filling for performance comparison
	    function leftZeroFill(number, targetLength, forceSign) {
	        var output = '' + Math.abs(number),
	            sign = number >= 0;
	
	        while (output.length < targetLength) {
	            output = '0' + output;
	        }
	        return (sign ? (forceSign ? '+' : '') : '-') + output;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = makeAs(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = moment.duration(val, period);
	            addOrSubtractDurationFromMoment(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            moment.updateOffset(mom, days || months);
	        }
	    }
	
	    // check if is an array
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return Object.prototype.toString.call(input) === '[object Date]' ||
	            input instanceof Date;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function normalizeUnits(units) {
	        if (units) {
	            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
	            units = unitAliases[units] || camelFunctions[lowered] || lowered;
	        }
	        return units;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeList(field) {
	        var count, setter;
	
	        if (field.indexOf('week') === 0) {
	            count = 7;
	            setter = 'day';
	        }
	        else if (field.indexOf('month') === 0) {
	            count = 12;
	            setter = 'month';
	        }
	        else {
	            return;
	        }
	
	        moment[field] = function (format, index) {
	            var i, getter,
	                method = moment._locale[field],
	                results = [];
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            getter = function (i) {
	                var m = moment().utc().set(setter, i);
	                return method.call(moment._locale, m, format || '');
	            };
	
	            if (index != null) {
	                return getter(index);
	            }
	            else {
	                for (i = 0; i < count; i++) {
	                    results.push(getter(i));
	                }
	                return results;
	            }
	        };
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            if (coercedNumber >= 0) {
	                value = Math.floor(coercedNumber);
	            } else {
	                value = Math.ceil(coercedNumber);
	            }
	        }
	
	        return value;
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function checkOverflow(m) {
	        var overflow;
	        if (m._a && m._pf.overflow === -2) {
	            overflow =
	                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
	                m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
	                m._a[HOUR] < 0 || m._a[HOUR] > 24 ||
	                    (m._a[HOUR] === 24 && (m._a[MINUTE] !== 0 ||
	                                           m._a[SECOND] !== 0 ||
	                                           m._a[MILLISECOND] !== 0)) ? HOUR :
	                m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
	                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
	                m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            m._pf.overflow = overflow;
	        }
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            m._isValid = !isNaN(m._d.getTime()) &&
	                m._pf.overflow < 0 &&
	                !m._pf.empty &&
	                !m._pf.invalidMonth &&
	                !m._pf.nullInput &&
	                !m._pf.invalidFormat &&
	                !m._pf.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    m._pf.charsLeftOver === 0 &&
	                    m._pf.unusedTokens.length === 0 &&
	                    m._pf.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        if (!locales[name] && hasModule) {
	            try {
	                oldLocale = moment.locale();
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                // because defineLocale currently also sets the global locale, we want to undo that for lazy loaded locales
	                moment.locale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // Return a moment from input, that is local/utc/utcOffset equivalent to
	    // model.
	    function makeAs(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (moment.isMoment(input) || isDate(input) ?
	                    +input : +moment(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            moment.updateOffset(res, false);
	            return res;
	        } else {
	            return moment(input).local();
	        }
	    }
	
	    /************************************
	        Locale
	    ************************************/
	
	
	    extend(Locale.prototype, {
	
	        set : function (config) {
	            var prop, i;
	            for (i in config) {
	                prop = config[i];
	                if (typeof prop === 'function') {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	            // Lenient ordinal parsing accepts just a number in addition to
	            // number + (possibly) stuff coming from _ordinalParseLenient.
	            this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + /\d{1,2}/.source);
	        },
	
	        _months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        months : function (m) {
	            return this._months[m.month()];
	        },
	
	        _monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        monthsShort : function (m) {
	            return this._monthsShort[m.month()];
	        },
	
	        monthsParse : function (monthName, format, strict) {
	            var i, mom, regex;
	
	            if (!this._monthsParse) {
	                this._monthsParse = [];
	                this._longMonthsParse = [];
	                this._shortMonthsParse = [];
	            }
	
	            for (i = 0; i < 12; i++) {
	                // make the regex if we don't have it already
	                mom = moment.utc([2000, i]);
	                if (strict && !this._longMonthsParse[i]) {
	                    this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                    this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	                }
	                if (!strict && !this._monthsParse[i]) {
	                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	                }
	                // test the regex
	                if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                    return i;
	                } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                    return i;
	                } else if (!strict && this._monthsParse[i].test(monthName)) {
	                    return i;
	                }
	            }
	        },
	
	        _weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdays : function (m) {
	            return this._weekdays[m.day()];
	        },
	
	        _weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysShort : function (m) {
	            return this._weekdaysShort[m.day()];
	        },
	
	        _weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        weekdaysMin : function (m) {
	            return this._weekdaysMin[m.day()];
	        },
	
	        weekdaysParse : function (weekdayName) {
	            var i, mom, regex;
	
	            if (!this._weekdaysParse) {
	                this._weekdaysParse = [];
	            }
	
	            for (i = 0; i < 7; i++) {
	                // make the regex if we don't have it already
	                if (!this._weekdaysParse[i]) {
	                    mom = moment([2000, 1]).day(i);
	                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	                }
	                // test the regex
	                if (this._weekdaysParse[i].test(weekdayName)) {
	                    return i;
	                }
	            }
	        },
	
	        _longDateFormat : {
	            LTS : 'h:mm:ss A',
	            LT : 'h:mm A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY LT',
	            LLLL : 'dddd, MMMM D, YYYY LT'
	        },
	        longDateFormat : function (key) {
	            var output = this._longDateFormat[key];
	            if (!output && this._longDateFormat[key.toUpperCase()]) {
	                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function (val) {
	                    return val.slice(1);
	                });
	                this._longDateFormat[key] = output;
	            }
	            return output;
	        },
	
	        isPM : function (input) {
	            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	            // Using charAt should be more compatible.
	            return ((input + '').toLowerCase().charAt(0) === 'p');
	        },
	
	        _meridiemParse : /[ap]\.?m?\.?/i,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'pm' : 'PM';
	            } else {
	                return isLower ? 'am' : 'AM';
	            }
	        },
	
	
	        _calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        calendar : function (key, mom, now) {
	            var output = this._calendar[key];
	            return typeof output === 'function' ? output.apply(mom, [now]) : output;
	        },
	
	        _relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	
	        relativeTime : function (number, withoutSuffix, string, isFuture) {
	            var output = this._relativeTime[string];
	            return (typeof output === 'function') ?
	                output(number, withoutSuffix, string, isFuture) :
	                output.replace(/%d/i, number);
	        },
	
	        pastFuture : function (diff, output) {
	            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	        },
	
	        ordinal : function (number) {
	            return this._ordinal.replace('%d', number);
	        },
	        _ordinal : '%d',
	        _ordinalParse : /\d{1,2}/,
	
	        preparse : function (string) {
	            return string;
	        },
	
	        postformat : function (string) {
	            return string;
	        },
	
	        week : function (mom) {
	            return weekOfYear(mom, this._week.dow, this._week.doy).week;
	        },
	
	        _week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        },
	
	        firstDayOfWeek : function () {
	            return this._week.dow;
	        },
	
	        firstDayOfYear : function () {
	            return this._week.doy;
	        },
	
	        _invalidDate: 'Invalid date',
	        invalidDate: function () {
	            return this._invalidDate;
	        }
	    });
	
	    /************************************
	        Formatting
	    ************************************/
	
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	
	        if (!formatFunctions[format]) {
	            formatFunctions[format] = makeFormatFunction(format);
	        }
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	
	    /************************************
	        Parsing
	    ************************************/
	
	
	    // get the regex to find the next token
	    function getParseRegexForToken(token, config) {
	        var a, strict = config._strict;
	        switch (token) {
	        case 'Q':
	            return parseTokenOneDigit;
	        case 'DDDD':
	            return parseTokenThreeDigits;
	        case 'YYYY':
	        case 'GGGG':
	        case 'gggg':
	            return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
	        case 'Y':
	        case 'G':
	        case 'g':
	            return parseTokenSignedNumber;
	        case 'YYYYYY':
	        case 'YYYYY':
	        case 'GGGGG':
	        case 'ggggg':
	            return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
	        case 'S':
	            if (strict) {
	                return parseTokenOneDigit;
	            }
	            /* falls through */
	        case 'SS':
	            if (strict) {
	                return parseTokenTwoDigits;
	            }
	            /* falls through */
	        case 'SSS':
	            if (strict) {
	                return parseTokenThreeDigits;
	            }
	            /* falls through */
	        case 'DDD':
	            return parseTokenOneToThreeDigits;
	        case 'MMM':
	        case 'MMMM':
	        case 'dd':
	        case 'ddd':
	        case 'dddd':
	            return parseTokenWord;
	        case 'a':
	        case 'A':
	            return config._locale._meridiemParse;
	        case 'x':
	            return parseTokenOffsetMs;
	        case 'X':
	            return parseTokenTimestampMs;
	        case 'Z':
	        case 'ZZ':
	            return parseTokenTimezone;
	        case 'T':
	            return parseTokenT;
	        case 'SSSS':
	            return parseTokenDigits;
	        case 'MM':
	        case 'DD':
	        case 'YY':
	        case 'GG':
	        case 'gg':
	        case 'HH':
	        case 'hh':
	        case 'mm':
	        case 'ss':
	        case 'ww':
	        case 'WW':
	            return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
	        case 'M':
	        case 'D':
	        case 'd':
	        case 'H':
	        case 'h':
	        case 'm':
	        case 's':
	        case 'w':
	        case 'W':
	        case 'e':
	        case 'E':
	            return parseTokenOneOrTwoDigits;
	        case 'Do':
	            return strict ? config._locale._ordinalParse : config._locale._ordinalParseLenient;
	        default :
	            a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), 'i'));
	            return a;
	        }
	    }
	
	    function utcOffsetFromString(string) {
	        string = string || '';
	        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
	            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
	            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
	            minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // function to convert string input to date
	    function addTimeToArrayFromToken(token, input, config) {
	        var a, datePartArray = config._a;
	
	        switch (token) {
	        // QUARTER
	        case 'Q':
	            if (input != null) {
	                datePartArray[MONTH] = (toInt(input) - 1) * 3;
	            }
	            break;
	        // MONTH
	        case 'M' : // fall through to MM
	        case 'MM' :
	            if (input != null) {
	                datePartArray[MONTH] = toInt(input) - 1;
	            }
	            break;
	        case 'MMM' : // fall through to MMMM
	        case 'MMMM' :
	            a = config._locale.monthsParse(input, token, config._strict);
	            // if we didn't find a month name, mark the date as invalid.
	            if (a != null) {
	                datePartArray[MONTH] = a;
	            } else {
	                config._pf.invalidMonth = input;
	            }
	            break;
	        // DAY OF MONTH
	        case 'D' : // fall through to DD
	        case 'DD' :
	            if (input != null) {
	                datePartArray[DATE] = toInt(input);
	            }
	            break;
	        case 'Do' :
	            if (input != null) {
	                datePartArray[DATE] = toInt(parseInt(
	                            input.match(/\d{1,2}/)[0], 10));
	            }
	            break;
	        // DAY OF YEAR
	        case 'DDD' : // fall through to DDDD
	        case 'DDDD' :
	            if (input != null) {
	                config._dayOfYear = toInt(input);
	            }
	
	            break;
	        // YEAR
	        case 'YY' :
	            datePartArray[YEAR] = moment.parseTwoDigitYear(input);
	            break;
	        case 'YYYY' :
	        case 'YYYYY' :
	        case 'YYYYYY' :
	            datePartArray[YEAR] = toInt(input);
	            break;
	        // AM / PM
	        case 'a' : // fall through to A
	        case 'A' :
	            config._meridiem = input;
	            // config._isPm = config._locale.isPM(input);
	            break;
	        // HOUR
	        case 'h' : // fall through to hh
	        case 'hh' :
	            config._pf.bigHour = true;
	            /* falls through */
	        case 'H' : // fall through to HH
	        case 'HH' :
	            datePartArray[HOUR] = toInt(input);
	            break;
	        // MINUTE
	        case 'm' : // fall through to mm
	        case 'mm' :
	            datePartArray[MINUTE] = toInt(input);
	            break;
	        // SECOND
	        case 's' : // fall through to ss
	        case 'ss' :
	            datePartArray[SECOND] = toInt(input);
	            break;
	        // MILLISECOND
	        case 'S' :
	        case 'SS' :
	        case 'SSS' :
	        case 'SSSS' :
	            datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
	            break;
	        // UNIX OFFSET (MILLISECONDS)
	        case 'x':
	            config._d = new Date(toInt(input));
	            break;
	        // UNIX TIMESTAMP WITH MS
	        case 'X':
	            config._d = new Date(parseFloat(input) * 1000);
	            break;
	        // TIMEZONE
	        case 'Z' : // fall through to ZZ
	        case 'ZZ' :
	            config._useUTC = true;
	            config._tzm = utcOffsetFromString(input);
	            break;
	        // WEEKDAY - human
	        case 'dd':
	        case 'ddd':
	        case 'dddd':
	            a = config._locale.weekdaysParse(input);
	            // if we didn't get a weekday name, mark the date as invalid
	            if (a != null) {
	                config._w = config._w || {};
	                config._w['d'] = a;
	            } else {
	                config._pf.invalidWeekday = input;
	            }
	            break;
	        // WEEK, WEEK DAY - numeric
	        case 'w':
	        case 'ww':
	        case 'W':
	        case 'WW':
	        case 'd':
	        case 'e':
	        case 'E':
	            token = token.substr(0, 1);
	            /* falls through */
	        case 'gggg':
	        case 'GGGG':
	        case 'GGGGG':
	            token = token.substr(0, 2);
	            if (input) {
	                config._w = config._w || {};
	                config._w[token] = toInt(input);
	            }
	            break;
	        case 'gg':
	        case 'GG':
	            config._w = config._w || {};
	            config._w[token] = moment.parseTwoDigitYear(input);
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = dfl(w.GG, config._a[YEAR], weekOfYear(moment(), 1, 4).year);
	            week = dfl(w.W, 1);
	            weekday = dfl(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = dfl(w.gg, config._a[YEAR], weekOfYear(moment(), dow, doy).year);
	            week = dfl(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function dateFromConfig(config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = dfl(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                config._pf._overflowDayOfYear = true;
	            }
	
	            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dateFromObject(config) {
	        var normalizedInput;
	
	        if (config._d) {
	            return;
	        }
	
	        normalizedInput = normalizeObjectUnits(config._i);
	        config._a = [
	            normalizedInput.year,
	            normalizedInput.month,
	            normalizedInput.day || normalizedInput.date,
	            normalizedInput.hour,
	            normalizedInput.minute,
	            normalizedInput.second,
	            normalizedInput.millisecond
	        ];
	
	        dateFromConfig(config);
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [
	                now.getUTCFullYear(),
	                now.getUTCMonth(),
	                now.getUTCDate()
	            ];
	        } else {
	            return [now.getFullYear(), now.getMonth(), now.getDate()];
	        }
	    }
	
	    // date from string and format string
	    function makeDateFromStringAndFormat(config) {
	        if (config._f === moment.ISO_8601) {
	            parseISO(config);
	            return;
	        }
	
	        config._a = [];
	        config._pf.empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    config._pf.unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    config._pf.empty = false;
	                }
	                else {
	                    config._pf.unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                config._pf.unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            config._pf.unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._pf.bigHour === true && config._a[HOUR] <= 12) {
	            config._pf.bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR],
	                config._meridiem);
	        dateFromConfig(config);
	        checkOverflow(config);
	    }
	
	    function unescapeFormat(s) {
	        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        });
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function regexpEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    // date from string and array of format strings
	    function makeDateFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            config._pf.invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._pf = defaultParsingFlags();
	            tempConfig._f = config._f[i];
	            makeDateFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += tempConfig._pf.charsLeftOver;
	
	            //or tokens
	            currentScore += tempConfig._pf.unusedTokens.length * 10;
	
	            tempConfig._pf.score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    // date from iso format
	    function parseISO(config) {
	        var i, l,
	            string = config._i,
	            match = isoRegex.exec(string);
	
	        if (match) {
	            config._pf.iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    // match[5] should be 'T' or undefined
	                    config._f = isoDates[i][0] + (match[6] || ' ');
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    config._f += isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(parseTokenTimezone)) {
	                config._f += 'Z';
	            }
	            makeDateFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function makeDateFromString(config) {
	        parseISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            moment.createFromInputFallback(config);
	        }
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function makeDateFromInput(config) {
	        var input = config._i, matched;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if ((matched = aspNetJsonRegex.exec(input)) !== null) {
	            config._d = new Date(+matched[1]);
	        } else if (typeof input === 'string') {
	            makeDateFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            dateFromConfig(config);
	        } else if (typeof(input) === 'object') {
	            dateFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            moment.createFromInputFallback(config);
	        }
	    }
	
	    function makeDate(y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function makeUTCDate(y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    function parseWeekday(input, locale) {
	        if (typeof input === 'string') {
	            if (!isNaN(input)) {
	                input = parseInt(input, 10);
	            }
	            else {
	                input = locale.weekdaysParse(input);
	                if (typeof input !== 'number') {
	                    return null;
	                }
	            }
	        }
	        return input;
	    }
	
	    /************************************
	        Relative Time
	    ************************************/
	
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime(posNegDuration, withoutSuffix, locale) {
	        var duration = moment.duration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            years = round(duration.as('y')),
	
	            args = seconds < relativeTimeThresholds.s && ['s', seconds] ||
	                minutes === 1 && ['m'] ||
	                minutes < relativeTimeThresholds.m && ['mm', minutes] ||
	                hours === 1 && ['h'] ||
	                hours < relativeTimeThresholds.h && ['hh', hours] ||
	                days === 1 && ['d'] ||
	                days < relativeTimeThresholds.d && ['dd', days] ||
	                months === 1 && ['M'] ||
	                months < relativeTimeThresholds.M && ['MM', months] ||
	                years === 1 && ['y'] || ['yy', years];
	
	        args[2] = withoutSuffix;
	        args[3] = +posNegDuration > 0;
	        args[4] = locale;
	        return substituteTimeAgo.apply({}, args);
	    }
	
	
	    /************************************
	        Week of Year
	    ************************************/
	
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = moment(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;
	
	        d = d === 0 ? 7 : d;
	        weekday = weekday != null ? weekday : firstDayOfWeek;
	        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
	        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    function makeMoment(config) {
	        var input = config._i,
	            format = config._f,
	            res;
	
	        config._locale = config._locale || moment.localeData(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return moment.invalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (moment.isMoment(input)) {
	            return new Moment(input, true);
	        } else if (format) {
	            if (isArray(format)) {
	                makeDateFromStringAndArray(config);
	            } else {
	                makeDateFromStringAndFormat(config);
	            }
	        } else {
	            makeDateFromInput(config);
	        }
	
	        res = new Moment(config);
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    moment = function (input, format, locale, strict) {
	        var c;
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c = {};
	        c._isAMomentObject = true;
	        c._i = input;
	        c._f = format;
	        c._l = locale;
	        c._strict = strict;
	        c._isUTC = false;
	        c._pf = defaultParsingFlags();
	
	        return makeMoment(c);
	    };
	
	    moment.suppressDeprecationWarnings = false;
	
	    moment.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return moment();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    moment.min = function () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    };
	
	    moment.max = function () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    };
	
	    // creating with utc
	    moment.utc = function (input, format, locale, strict) {
	        var c;
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c = {};
	        c._isAMomentObject = true;
	        c._useUTC = true;
	        c._isUTC = true;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	        c._pf = defaultParsingFlags();
	
	        return makeMoment(c).utc();
	    };
	
	    // creating with unix timestamp (in seconds)
	    moment.unix = function (input) {
	        return moment(input * 1000);
	    };
	
	    // duration
	    moment.duration = function (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            parseIso,
	            diffRes;
	
	        if (moment.isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoDurationRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            parseIso = function (inp) {
	                // We'd normally use ~~inp for this, but unfortunately it also
	                // converts floats to ints.
	                // inp may be undefined, so careful calling replace on it.
	                var res = inp && parseFloat(inp.replace(',', '.'));
	                // apply sign while we're at it
	                return (isNaN(res) ? 0 : res) * sign;
	            };
	            duration = {
	                y: parseIso(match[2]),
	                M: parseIso(match[3]),
	                d: parseIso(match[4]),
	                h: parseIso(match[5]),
	                m: parseIso(match[6]),
	                s: parseIso(match[7]),
	                w: parseIso(match[8])
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' &&
	                ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(moment(duration.from), moment(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (moment.isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    };
	
	    // version number
	    moment.version = VERSION;
	
	    // default format
	    moment.defaultFormat = isoFormat;
	
	    // constant that refers to the ISO standard
	    moment.ISO_8601 = function () {};
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    moment.momentProperties = momentProperties;
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    moment.updateOffset = function () {};
	
	    // This function allows you to set a threshold for relative time strings
	    moment.relativeTimeThreshold = function (threshold, limit) {
	        if (relativeTimeThresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return relativeTimeThresholds[threshold];
	        }
	        relativeTimeThresholds[threshold] = limit;
	        return true;
	    };
	
	    moment.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        function (key, value) {
	            return moment.locale(key, value);
	        }
	    );
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    moment.locale = function (key, values) {
	        var data;
	        if (key) {
	            if (typeof(values) !== 'undefined') {
	                data = moment.defineLocale(key, values);
	            }
	            else {
	                data = moment.localeData(key);
	            }
	
	            if (data) {
	                moment.duration._locale = moment._locale = data;
	            }
	        }
	
	        return moment._locale._abbr;
	    };
	
	    moment.defineLocale = function (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            if (!locales[name]) {
	                locales[name] = new Locale();
	            }
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            moment.locale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    };
	
	    moment.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        function (key) {
	            return moment.localeData(key);
	        }
	    );
	
	    // returns locale data
	    moment.localeData = function (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return moment._locale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    };
	
	    // compare moment object
	    moment.isMoment = function (obj) {
	        return obj instanceof Moment ||
	            (obj != null && hasOwnProp(obj, '_isAMomentObject'));
	    };
	
	    // for typechecking Duration objects
	    moment.isDuration = function (obj) {
	        return obj instanceof Duration;
	    };
	
	    for (i = lists.length - 1; i >= 0; --i) {
	        makeList(lists[i]);
	    }
	
	    moment.normalizeUnits = function (units) {
	        return normalizeUnits(units);
	    };
	
	    moment.invalid = function (flags) {
	        var m = moment.utc(NaN);
	        if (flags != null) {
	            extend(m._pf, flags);
	        }
	        else {
	            m._pf.userInvalidated = true;
	        }
	
	        return m;
	    };
	
	    moment.parseZone = function () {
	        return moment.apply(null, arguments).parseZone();
	    };
	
	    moment.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    moment.isDate = isDate;
	
	    /************************************
	        Moment Prototype
	    ************************************/
	
	
	    extend(moment.fn = Moment.prototype, {
	
	        clone : function () {
	            return moment(this);
	        },
	
	        valueOf : function () {
	            return +this._d - ((this._offset || 0) * 60000);
	        },
	
	        unix : function () {
	            return Math.floor(+this / 1000);
	        },
	
	        toString : function () {
	            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	        },
	
	        toDate : function () {
	            return this._offset ? new Date(+this) : this._d;
	        },
	
	        toISOString : function () {
	            var m = moment(this).utc();
	            if (0 < m.year() && m.year() <= 9999) {
	                if ('function' === typeof Date.prototype.toISOString) {
	                    // native implementation is ~50x faster, use it when we can
	                    return this.toDate().toISOString();
	                } else {
	                    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	                }
	            } else {
	                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        },
	
	        toArray : function () {
	            var m = this;
	            return [
	                m.year(),
	                m.month(),
	                m.date(),
	                m.hours(),
	                m.minutes(),
	                m.seconds(),
	                m.milliseconds()
	            ];
	        },
	
	        isValid : function () {
	            return isValid(this);
	        },
	
	        isDSTShifted : function () {
	            if (this._a) {
	                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
	            }
	
	            return false;
	        },
	
	        parsingFlags : function () {
	            return extend({}, this._pf);
	        },
	
	        invalidAt: function () {
	            return this._pf.overflow;
	        },
	
	        utc : function (keepLocalTime) {
	            return this.utcOffset(0, keepLocalTime);
	        },
	
	        local : function (keepLocalTime) {
	            if (this._isUTC) {
	                this.utcOffset(0, keepLocalTime);
	                this._isUTC = false;
	
	                if (keepLocalTime) {
	                    this.subtract(this._dateUtcOffset(), 'm');
	                }
	            }
	            return this;
	        },
	
	        format : function (inputString) {
	            var output = formatMoment(this, inputString || moment.defaultFormat);
	            return this.localeData().postformat(output);
	        },
	
	        add : createAdder(1, 'add'),
	
	        subtract : createAdder(-1, 'subtract'),
	
	        diff : function (input, units, asFloat) {
	            var that = makeAs(input, this),
	                zoneDiff = (that.utcOffset() - this.utcOffset()) * 6e4,
	                anchor, diff, output, daysAdjust;
	
	            units = normalizeUnits(units);
	
	            if (units === 'year' || units === 'month' || units === 'quarter') {
	                output = monthDiff(this, that);
	                if (units === 'quarter') {
	                    output = output / 3;
	                } else if (units === 'year') {
	                    output = output / 12;
	                }
	            } else {
	                diff = this - that;
	                output = units === 'second' ? diff / 1e3 : // 1000
	                    units === 'minute' ? diff / 6e4 : // 1000 * 60
	                    units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
	                    units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                    units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                    diff;
	            }
	            return asFloat ? output : absRound(output);
	        },
	
	        from : function (time, withoutSuffix) {
	            return moment.duration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        },
	
	        fromNow : function (withoutSuffix) {
	            return this.from(moment(), withoutSuffix);
	        },
	
	        calendar : function (time) {
	            // We want to compare the start of today, vs this.
	            // Getting start-of-today depends on whether we're locat/utc/offset
	            // or not.
	            var now = time || moment(),
	                sod = makeAs(now, this).startOf('day'),
	                diff = this.diff(sod, 'days', true),
	                format = diff < -6 ? 'sameElse' :
	                    diff < -1 ? 'lastWeek' :
	                    diff < 0 ? 'lastDay' :
	                    diff < 1 ? 'sameDay' :
	                    diff < 2 ? 'nextDay' :
	                    diff < 7 ? 'nextWeek' : 'sameElse';
	            return this.format(this.localeData().calendar(format, this, moment(now)));
	        },
	
	        isLeapYear : function () {
	            return isLeapYear(this.year());
	        },
	
	        isDST : function () {
	            return (this.utcOffset() > this.clone().month(0).utcOffset() ||
	                this.utcOffset() > this.clone().month(5).utcOffset());
	        },
	
	        day : function (input) {
	            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	            if (input != null) {
	                input = parseWeekday(input, this.localeData());
	                return this.add(input - day, 'd');
	            } else {
	                return day;
	            }
	        },
	
	        month : makeAccessor('Month', true),
	
	        startOf : function (units) {
	            units = normalizeUnits(units);
	            // the following switch intentionally omits break keywords
	            // to utilize falling through the cases.
	            switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	                /* falls through */
	            }
	
	            // weeks are a special case
	            if (units === 'week') {
	                this.weekday(0);
	            } else if (units === 'isoWeek') {
	                this.isoWeekday(1);
	            }
	
	            // quarters are also special
	            if (units === 'quarter') {
	                this.month(Math.floor(this.month() / 3) * 3);
	            }
	
	            return this;
	        },
	
	        endOf: function (units) {
	            units = normalizeUnits(units);
	            if (units === undefined || units === 'millisecond') {
	                return this;
	            }
	            return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	        },
	
	        isAfter: function (input, units) {
	            var inputMs;
	            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	            if (units === 'millisecond') {
	                input = moment.isMoment(input) ? input : moment(input);
	                return +this > +input;
	            } else {
	                inputMs = moment.isMoment(input) ? +input : +moment(input);
	                return inputMs < +this.clone().startOf(units);
	            }
	        },
	
	        isBefore: function (input, units) {
	            var inputMs;
	            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	            if (units === 'millisecond') {
	                input = moment.isMoment(input) ? input : moment(input);
	                return +this < +input;
	            } else {
	                inputMs = moment.isMoment(input) ? +input : +moment(input);
	                return +this.clone().endOf(units) < inputMs;
	            }
	        },
	
	        isBetween: function (from, to, units) {
	            return this.isAfter(from, units) && this.isBefore(to, units);
	        },
	
	        isSame: function (input, units) {
	            var inputMs;
	            units = normalizeUnits(units || 'millisecond');
	            if (units === 'millisecond') {
	                input = moment.isMoment(input) ? input : moment(input);
	                return +this === +input;
	            } else {
	                inputMs = +moment(input);
	                return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	            }
	        },
	
	        min: deprecate(
	                 'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	                 function (other) {
	                     other = moment.apply(null, arguments);
	                     return other < this ? this : other;
	                 }
	         ),
	
	        max: deprecate(
	                'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	                function (other) {
	                    other = moment.apply(null, arguments);
	                    return other > this ? this : other;
	                }
	        ),
	
	        zone : deprecate(
	                'moment().zone is deprecated, use moment().utcOffset instead. ' +
	                'https://github.com/moment/moment/issues/1779',
	                function (input, keepLocalTime) {
	                    if (input != null) {
	                        if (typeof input !== 'string') {
	                            input = -input;
	                        }
	
	                        this.utcOffset(input, keepLocalTime);
	
	                        return this;
	                    } else {
	                        return -this.utcOffset();
	                    }
	                }
	        ),
	
	        // keepLocalTime = true means only change the timezone, without
	        // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	        // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	        // +0200, so we adjust the time as needed, to be valid.
	        //
	        // Keeping the time actually adds/subtracts (one hour)
	        // from the actual represented time. That is why we call updateOffset
	        // a second time. In case it wants us to change the offset again
	        // _changeInProgress == true case, then we have to adjust, because
	        // there is no such time in the given timezone.
	        utcOffset : function (input, keepLocalTime) {
	            var offset = this._offset || 0,
	                localAdjust;
	            if (input != null) {
	                if (typeof input === 'string') {
	                    input = utcOffsetFromString(input);
	                }
	                if (Math.abs(input) < 16) {
	                    input = input * 60;
	                }
	                if (!this._isUTC && keepLocalTime) {
	                    localAdjust = this._dateUtcOffset();
	                }
	                this._offset = input;
	                this._isUTC = true;
	                if (localAdjust != null) {
	                    this.add(localAdjust, 'm');
	                }
	                if (offset !== input) {
	                    if (!keepLocalTime || this._changeInProgress) {
	                        addOrSubtractDurationFromMoment(this,
	                                moment.duration(input - offset, 'm'), 1, false);
	                    } else if (!this._changeInProgress) {
	                        this._changeInProgress = true;
	                        moment.updateOffset(this, true);
	                        this._changeInProgress = null;
	                    }
	                }
	
	                return this;
	            } else {
	                return this._isUTC ? offset : this._dateUtcOffset();
	            }
	        },
	
	        isLocal : function () {
	            return !this._isUTC;
	        },
	
	        isUtcOffset : function () {
	            return this._isUTC;
	        },
	
	        isUtc : function () {
	            return this._isUTC && this._offset === 0;
	        },
	
	        zoneAbbr : function () {
	            return this._isUTC ? 'UTC' : '';
	        },
	
	        zoneName : function () {
	            return this._isUTC ? 'Coordinated Universal Time' : '';
	        },
	
	        parseZone : function () {
	            if (this._tzm) {
	                this.utcOffset(this._tzm);
	            } else if (typeof this._i === 'string') {
	                this.utcOffset(utcOffsetFromString(this._i));
	            }
	            return this;
	        },
	
	        hasAlignedHourOffset : function (input) {
	            if (!input) {
	                input = 0;
	            }
	            else {
	                input = moment(input).utcOffset();
	            }
	
	            return (this.utcOffset() - input) % 60 === 0;
	        },
	
	        daysInMonth : function () {
	            return daysInMonth(this.year(), this.month());
	        },
	
	        dayOfYear : function (input) {
	            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
	            return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	        },
	
	        quarter : function (input) {
	            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	        },
	
	        weekYear : function (input) {
	            var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	            return input == null ? year : this.add((input - year), 'y');
	        },
	
	        isoWeekYear : function (input) {
	            var year = weekOfYear(this, 1, 4).year;
	            return input == null ? year : this.add((input - year), 'y');
	        },
	
	        week : function (input) {
	            var week = this.localeData().week(this);
	            return input == null ? week : this.add((input - week) * 7, 'd');
	        },
	
	        isoWeek : function (input) {
	            var week = weekOfYear(this, 1, 4).week;
	            return input == null ? week : this.add((input - week) * 7, 'd');
	        },
	
	        weekday : function (input) {
	            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	            return input == null ? weekday : this.add(input - weekday, 'd');
	        },
	
	        isoWeekday : function (input) {
	            // behaves the same as moment#day except
	            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	            // as a setter, sunday should belong to the previous week.
	            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	        },
	
	        isoWeeksInYear : function () {
	            return weeksInYear(this.year(), 1, 4);
	        },
	
	        weeksInYear : function () {
	            var weekInfo = this.localeData()._week;
	            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	        },
	
	        get : function (units) {
	            units = normalizeUnits(units);
	            return this[units]();
	        },
	
	        set : function (units, value) {
	            var unit;
	            if (typeof units === 'object') {
	                for (unit in units) {
	                    this.set(unit, units[unit]);
	                }
	            }
	            else {
	                units = normalizeUnits(units);
	                if (typeof this[units] === 'function') {
	                    this[units](value);
	                }
	            }
	            return this;
	        },
	
	        // If passed a locale key, it will set the locale for this
	        // instance.  Otherwise, it will return the locale configuration
	        // variables for this instance.
	        locale : function (key) {
	            var newLocaleData;
	
	            if (key === undefined) {
	                return this._locale._abbr;
	            } else {
	                newLocaleData = moment.localeData(key);
	                if (newLocaleData != null) {
	                    this._locale = newLocaleData;
	                }
	                return this;
	            }
	        },
	
	        lang : deprecate(
	            'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	            function (key) {
	                if (key === undefined) {
	                    return this.localeData();
	                } else {
	                    return this.locale(key);
	                }
	            }
	        ),
	
	        localeData : function () {
	            return this._locale;
	        },
	
	        _dateUtcOffset : function () {
	            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	            // https://github.com/moment/moment/pull/1871
	            return -Math.round(this._d.getTimezoneOffset() / 15) * 15;
	        }
	
	    });
	
	    function rawMonthSetter(mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(),
	                daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function rawGetter(mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function rawSetter(mom, unit, value) {
	        if (unit === 'Month') {
	            return rawMonthSetter(mom, value);
	        } else {
	            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    function makeAccessor(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                rawSetter(this, unit, value);
	                moment.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return rawGetter(this, unit);
	            }
	        };
	    }
	
	    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
	    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
	    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
	    // moment.fn.month is defined separately
	    moment.fn.date = makeAccessor('Date', true);
	    moment.fn.dates = deprecate('dates accessor is deprecated. Use date instead.', makeAccessor('Date', true));
	    moment.fn.year = makeAccessor('FullYear', true);
	    moment.fn.years = deprecate('years accessor is deprecated. Use year instead.', makeAccessor('FullYear', true));
	
	    // add plural methods
	    moment.fn.days = moment.fn.day;
	    moment.fn.months = moment.fn.month;
	    moment.fn.weeks = moment.fn.week;
	    moment.fn.isoWeeks = moment.fn.isoWeek;
	    moment.fn.quarters = moment.fn.quarter;
	
	    // add aliased format methods
	    moment.fn.toJSON = moment.fn.toISOString;
	
	    // alias isUtc for dev-friendliness
	    moment.fn.isUTC = moment.fn.isUtc;
	
	    /************************************
	        Duration Prototype
	    ************************************/
	
	
	    function daysToYears (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        return days * 400 / 146097;
	    }
	
	    function yearsToDays (years) {
	        // years * 365 + absRound(years / 4) -
	        //     absRound(years / 100) + absRound(years / 400);
	        return years * 146097 / 400;
	    }
	
	    extend(moment.duration.fn = Duration.prototype, {
	
	        _bubble : function () {
	            var milliseconds = this._milliseconds,
	                days = this._days,
	                months = this._months,
	                data = this._data,
	                seconds, minutes, hours, years = 0;
	
	            // The following code bubbles up values, see the tests for
	            // examples of what that means.
	            data.milliseconds = milliseconds % 1000;
	
	            seconds = absRound(milliseconds / 1000);
	            data.seconds = seconds % 60;
	
	            minutes = absRound(seconds / 60);
	            data.minutes = minutes % 60;
	
	            hours = absRound(minutes / 60);
	            data.hours = hours % 24;
	
	            days += absRound(hours / 24);
	
	            // Accurately convert days to years, assume start from year 0.
	            years = absRound(daysToYears(days));
	            days -= absRound(yearsToDays(years));
	
	            // 30 days to a month
	            // TODO (iskren): Use anchor date (like 1st Jan) to compute this.
	            months += absRound(days / 30);
	            days %= 30;
	
	            // 12 months -> 1 year
	            years += absRound(months / 12);
	            months %= 12;
	
	            data.days = days;
	            data.months = months;
	            data.years = years;
	        },
	
	        abs : function () {
	            this._milliseconds = Math.abs(this._milliseconds);
	            this._days = Math.abs(this._days);
	            this._months = Math.abs(this._months);
	
	            this._data.milliseconds = Math.abs(this._data.milliseconds);
	            this._data.seconds = Math.abs(this._data.seconds);
	            this._data.minutes = Math.abs(this._data.minutes);
	            this._data.hours = Math.abs(this._data.hours);
	            this._data.months = Math.abs(this._data.months);
	            this._data.years = Math.abs(this._data.years);
	
	            return this;
	        },
	
	        weeks : function () {
	            return absRound(this.days() / 7);
	        },
	
	        valueOf : function () {
	            return this._milliseconds +
	              this._days * 864e5 +
	              (this._months % 12) * 2592e6 +
	              toInt(this._months / 12) * 31536e6;
	        },
	
	        humanize : function (withSuffix) {
	            var output = relativeTime(this, !withSuffix, this.localeData());
	
	            if (withSuffix) {
	                output = this.localeData().pastFuture(+this, output);
	            }
	
	            return this.localeData().postformat(output);
	        },
	
	        add : function (input, val) {
	            // supports only 2.0-style add(1, 's') or add(moment)
	            var dur = moment.duration(input, val);
	
	            this._milliseconds += dur._milliseconds;
	            this._days += dur._days;
	            this._months += dur._months;
	
	            this._bubble();
	
	            return this;
	        },
	
	        subtract : function (input, val) {
	            var dur = moment.duration(input, val);
	
	            this._milliseconds -= dur._milliseconds;
	            this._days -= dur._days;
	            this._months -= dur._months;
	
	            this._bubble();
	
	            return this;
	        },
	
	        get : function (units) {
	            units = normalizeUnits(units);
	            return this[units.toLowerCase() + 's']();
	        },
	
	        as : function (units) {
	            var days, months;
	            units = normalizeUnits(units);
	
	            if (units === 'month' || units === 'year') {
	                days = this._days + this._milliseconds / 864e5;
	                months = this._months + daysToYears(days) * 12;
	                return units === 'month' ? months : months / 12;
	            } else {
	                // handle milliseconds separately because of floating point math errors (issue #1867)
	                days = this._days + Math.round(yearsToDays(this._months / 12));
	                switch (units) {
	                    case 'week': return days / 7 + this._milliseconds / 6048e5;
	                    case 'day': return days + this._milliseconds / 864e5;
	                    case 'hour': return days * 24 + this._milliseconds / 36e5;
	                    case 'minute': return days * 24 * 60 + this._milliseconds / 6e4;
	                    case 'second': return days * 24 * 60 * 60 + this._milliseconds / 1000;
	                    // Math.floor prevents floating point math errors here
	                    case 'millisecond': return Math.floor(days * 24 * 60 * 60 * 1000) + this._milliseconds;
	                    default: throw new Error('Unknown unit ' + units);
	                }
	            }
	        },
	
	        lang : moment.fn.lang,
	        locale : moment.fn.locale,
	
	        toIsoString : deprecate(
	            'toIsoString() is deprecated. Please use toISOString() instead ' +
	            '(notice the capitals)',
	            function () {
	                return this.toISOString();
	            }
	        ),
	
	        toISOString : function () {
	            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	            var years = Math.abs(this.years()),
	                months = Math.abs(this.months()),
	                days = Math.abs(this.days()),
	                hours = Math.abs(this.hours()),
	                minutes = Math.abs(this.minutes()),
	                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);
	
	            if (!this.asSeconds()) {
	                // this is the same as C#'s (Noda) and python (isodate)...
	                // but not other JS (goog.date)
	                return 'P0D';
	            }
	
	            return (this.asSeconds() < 0 ? '-' : '') +
	                'P' +
	                (years ? years + 'Y' : '') +
	                (months ? months + 'M' : '') +
	                (days ? days + 'D' : '') +
	                ((hours || minutes || seconds) ? 'T' : '') +
	                (hours ? hours + 'H' : '') +
	                (minutes ? minutes + 'M' : '') +
	                (seconds ? seconds + 'S' : '');
	        },
	
	        localeData : function () {
	            return this._locale;
	        },
	
	        toJSON : function () {
	            return this.toISOString();
	        }
	    });
	
	    moment.duration.fn.toString = moment.duration.fn.toISOString;
	
	    function makeDurationGetter(name) {
	        moment.duration.fn[name] = function () {
	            return this._data[name];
	        };
	    }
	
	    for (i in unitMillisecondFactors) {
	        if (hasOwnProp(unitMillisecondFactors, i)) {
	            makeDurationGetter(i.toLowerCase());
	        }
	    }
	
	    moment.duration.fn.asMilliseconds = function () {
	        return this.as('ms');
	    };
	    moment.duration.fn.asSeconds = function () {
	        return this.as('s');
	    };
	    moment.duration.fn.asMinutes = function () {
	        return this.as('m');
	    };
	    moment.duration.fn.asHours = function () {
	        return this.as('h');
	    };
	    moment.duration.fn.asDays = function () {
	        return this.as('d');
	    };
	    moment.duration.fn.asWeeks = function () {
	        return this.as('weeks');
	    };
	    moment.duration.fn.asMonths = function () {
	        return this.as('M');
	    };
	    moment.duration.fn.asYears = function () {
	        return this.as('y');
	    };
	
	    /************************************
	        Default Locale
	    ************************************/
	
	
	    // Set default locale, other locale will inherit from English.
	    moment.locale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    /* EMBED_LOCALES */
	
	    /************************************
	        Exposing Moment
	    ************************************/
	
	    function makeGlobal(shouldDeprecate) {
	        /*global ender:false */
	        if (typeof ender !== 'undefined') {
	            return;
	        }
	        oldGlobalMoment = globalScope.moment;
	        if (shouldDeprecate) {
	            globalScope.moment = deprecate(
	                    'Accessing Moment through the global scope is ' +
	                    'deprecated, and will be removed in an upcoming ' +
	                    'release.',
	                    moment);
	        } else {
	            globalScope.moment = moment;
	        }
	    }
	
	    // CommonJS module is defined
	    if (hasModule) {
	        module.exports = moment;
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	            if (module.config && module.config() && module.config().noGlobal === true) {
	                // release the global variable
	                globalScope.moment = oldGlobalMoment;
	            }
	
	            return moment;
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        makeGlobal(true);
	    } else {
	        makeGlobal();
	    }
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(70)(module)))

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var fvChannel = __webpack_require__(72).channel('FV');
	var moment = __webpack_require__(69);
	var _ = __webpack_require__(49);
	
	
	_.extend(moment, {
	
	    /*
	     *
	     * Convert dtString to local time and return it formatted in Doc Viewer's default date-time format string.
	     * If dtString is null (typically provided directly from server), return an empty string to prevent error.
	     * dtString is passed using a standard ISO format -- yyyy-MM-dd'T'HH:mm:ssXXX (in Java SimpleDateFormat )
	     * eg: 2019-04-30T16:20:46-04:00
	     * Intended use is for date-time fields stored in the database and the passed to the client.
	     * Dates are mostly stored in the local time of the database server.
	     * Certain dates -- like doc_note_info.ctime are stored as UTC time.  Though when passed through to Doc Viewer,
	     * underlying JDBC libraries convert them to local time of the server first, if a time zone annotation is provided (on the 'db objects' -- see FddFieldProcessor).
	     * For these cases, we need to convert the server time to the browser time.
	     * ( We probably should stop doing this in the central libraries and just return the UTC time as seen in the database ).
	     * However, most dates are not persisted in UTC time. They are written in local time and not stored with a timezone (the db fields don't support them).
	     * While not stored with a timezone, the server with returns these times with timezone of the Java server.  This is problematic and incorrect.
	     * ( Java date adds a timezone to the Date object; when retrieved via JDBC, so does java.sql.Types.TIMESTAMP ).
	     * So always convert to UTC from the local time provided (even if the time is UTC) and then convert back to local, even if it's not necessary.
	     * The toUtc and toLocal functions should always work because times passed from the Java API contain timestamps -- even if these timestamps are not correct.
	     * Date-times may not always come from the database -- eg: that cleaned from the version file.
	     * More collaborative work is needed across Engineering to determine how to handle the display of times across different time zones.
	     *
	     * */
	
	    convertDBTimeToLocalTime: function (dtString) {
	
	        if (dtString === null)
	            return '';
	
	        var utcTime = moment.utc(dtString),
	            localTime = utcTime.local();
	
	        return localTime.format(fvChannel.request('settings').DT_TIME_FMT_STR);
	
	    },
	
	    /**
	     * Still using moment to 'format' the date-time string.
	     * This is an intermediate refactor.
	     * Initially just used for times, but now can have dates too -- depends how you send moment_format_str --
	     * this will just take the output generated by the format of the current date/time with moment_format_str
	     * and append the timezone abbr to the end.
	     *
	     */
	    getCurrentTimestampWithTimezoneAbbreviation: function( moment_format_str ) {
	
	        moment_format_str = moment_format_str || fvChannel.request('settings').DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR ;
	
	        var dtNow = new Date();
	
	        var mNow = moment(dtNow);
	        var timeStamp = mNow.format( moment_format_str); // ( this is the format used by FDD ) -- ('HH:mm:ss')
	
	        timeStamp = timeStamp + ' ' + this.getTimeZoneAbbrevation(dtNow);
	
	        // For UTC: use moment.utc( dtNow )
	        // or --> dtNow.getTime( 1641596655951 ) --> this would be saving it ; then would read back in
	        //  dtNow.getTimezoneOffset() -- raw doesn't return without daylight savings -300 ( correct )
	        //  mNow.utcOffset() -- also give -300 ( but is this correct with daylight savings ? )
	        // mNow.format('Z') -- this works -- provides '-05:00'
	        // if we aren't using ... maybe just store on output -- but we have the string ... not sure if that is enough -- would probably want at least the date stored
	
	        return timeStamp;
	
	
	    },
	
	    /**
	     * Use to just append to other moment formats
	     * TODO: update to Luxon -- this is a hack, especially for IE
	     */
	    getTimeZoneAbbrevation: function( dateNow ) {
	
	        dateNow = dateNow || new Date();
	
	        var browserSupportsTimeZones = Intl.DateTimeFormat().resolvedOptions().timeZone;
	
	        var timeZoneAbbr;
	
	        if (browserSupportsTimeZones) {
	
	            /** Use this before library -- change when update to IE */
	
	                // https://stackoverflow.com/questions/67827985/is-there-a-way-to-get-time-zone-abbreviations-in-browser-javascript
	            timeZoneAbbr = Intl.DateTimeFormat('en-us', {timeZoneName: 'short'}).formatToParts( dateNow ).find(function (p) {
	                return p.type === 'timeZoneName';
	            }).value;
	
	            // vs full timezone name: Intl.DateTimeFormat().resolvedOptions().timeZone
	
	        } else {
	
	            // Not perfect, but do an attempt for IE
	            // https://stackoverflow.com/questions/1954397/detect-timezone-abbreviation-using-javascript/18346354
	            timeZoneAbbr = dateNow.toTimeString().match(new RegExp("[A-Z](?!.*[\(])", "g")).join('');
	        }
	
	        return timeZoneAbbr;
	
	    }
	
	});

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *
	 * Separate file --> good for debug
	 */
	
	var radio = __webpack_require__(60);
	radio.DEBUG = true;
	
	
	module.exports = radio;
	


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    FVSettings = __webpack_require__(74),
	    LocalStorageSettings = __webpack_require__(78),
	    User = __webpack_require__(82),
	    Viewer = __webpack_require__(97),
	    ReasonCodes = __webpack_require__(758),
	
	    Auth = __webpack_require__(759),
	    UnauthorizedDataModel = __webpack_require__(761),
	    ApiUrl = __webpack_require__(762),
	    Version = __webpack_require__(763),
	    ChannelFns = __webpack_require__(765),
	    eqSelectors = __webpack_require__(766),
	    SystemPrefs = __webpack_require__(767),
	    Util = __webpack_require__(48),
	    DocumentCollection = __webpack_require__(391), // put the models at the FV level since required here ?
	    FVConstants = __webpack_require__(768);
	
	
	__webpack_require__(764);
	
	
	/*
	* FV.createViewer is the entry point for end-user circumstances
	* Note: required as new so this is an instance of a 'library
	* */
	
	var FV = function() {
	
	    if (true) {
	        this._$dfdStylesLoaded = $.Deferred();
	        addStyleSheet.call(this);
	    }
	
	    /*
	     * Note: could just use the window -- export would also put on window too and in IE8 can't delete the window prop
	     * Need to require when pull selectors (script run order)
	     * Would like to put on here, not window ... need to fix shim ?
	     * */
	
	    this.constants = FVConstants;
	
	    this.EQ = __webpack_require__(769);
	    this.EQ.elementQuery(eqSelectors);
	
	    this._setWindowUnloadHandler();
	
	    this.viewers = {};
	    this.numberViewers = 0;
	    this.options = null; // store the original fvOptions passed to docViewer ( necessarry to apply for viewer.openInNewWindow )
	    this.settings = FVSettings;  // Note: createViewer requires some defaults set (eg, isIE8); post call, merge with plugin options
	    this.localStorageSettings = LocalStorageSettings; // ( For now this class requires no instantiation )
	
	    this.unauthorizedData = null;
	    this.auth = null;   // settings must be set first for url
	    this.apiURL = null;
	    this.user = null; // created after get remote data
	    this.systemPolicies = null;
	
	    this.cssConstants = this._getStyleConstants(); /* Necessary for Scale Calculations (applied to all viewers) */
	
	
	    /* adhoc & cache */
	    this.version = null; // from file
	    this.reasonCodes = null; // Note: stored here (same for all viewers), though fetched and set in Viewer Page Canvas Module
	
	    /* Channel stored on here, can still be referenced via Radio with the name */
	    var ch = this.channel = __webpack_require__(72).channel('FV');
	    ch.reply(ChannelFns.requests, this);
	    ch.comply(ChannelFns.commands, this);
	
	};
	
	
	function addStyleSheet() {
	    // TODO: warning if not in window
	     $('<link rel="stylesheet" type="text/css" href="' + __webpack_require__.p + 'viewer.css">')
	         .on('load', this._$dfdStylesLoaded.resolve).appendTo( $('head') );
	}
	
	
	/* Mode - States : IMPLEMENT ...
	    loadingDataPlaceholder: .... for now no, 'the region will always have a background color -- '
	    resetting -- no longer bkg color -- but would always have loading view '
	    loggedIn, 
	    loggedOut, -- can also come from auth/keep alive err -- loginView (<--viewer._exitLoggedIn)
	    viewingDocument, 
	    unableToLoadViewerError: 
	        * create viewer: parameter validation (required, options)
	        * failed db fetch
	        * failed get required user data
	        * failed docInfo fetch
	            * failed components -- leave indicators for WF ... 
	        * note: not failed login -- goes back to login view with errors
	*/
	
	
	 _.extend( FV.prototype, {
	
	     docViewer: function() {
	
	         if (false)
	             return this._addViewer.apply(this, arguments);
	
	         /* with css file applied async, only create the viewer when the styles are in the dom */
	         var self = this,
	             args = arguments,
	             timer = setInterval( function() {
	
	                 if ( self._$dfdStylesLoaded.state() === 'resolved' ) {
	                     clearTimeout(timer);
	                     return self._addViewer.apply(self, args);
	                 }
	
	             }, 100);
	
	     },
	
	     /*
	     * Essentially the entry point for the end-user -- lib is exposed.
	     * FV options kept separate as a convenience for when creating more viewers.
	     * fvOptions: optional -- if passed, will override defaults; otherwise defaults or previously stored options used ( just merge instead... ) ?
	     * */
	     _addViewer: function(aDocReq, instanceOptions, fvOptions) {
	
	
	         // Order dependent here: -- global settings on radio has path to API.
	         if (fvOptions) {
	
	             this.options = fvOptions;
	
	             //  Really means override with defaults -- could be model and call via set.
	             this.settings.initialize(fvOptions);
	         }
	
	         // Always
	         this.apiURL = ApiUrl.call( ApiUrl, this.settings.PATH_TO_API );
	
	         /*
	         *  Note: viewer instances have region used for login, loading, messages, etc ... of FV namespace ( here is some coupling )
	         *  Create region for db error message holder) -- note, viewer req's settings, use fn
	         * */
	         var viewer = new Viewer( aDocReq, instanceOptions, undefined, this.numberViewers + 1 );
	
	         if ( !viewer.validationErr ) {
	             this.numberViewers++;
	             this.viewers[this.numberViewers] = viewer;
	         }
	
	         /*
	         * Note: only done first time through -- also flag that the objects exist.
	         * Auth model relies on gl settings.
	         * */
	         !this.auth && ( this.auth = new Auth() );
	
	         !this.unauthorizedData && ( this.unauthorizedData = new UnauthorizedDataModel() ) ;
	
	         /* Call prior to any ajax calls */
	         !this.settings.$ajax.ajaxSetup && this._postValidationInit();
	
	
	         !this.version && ( this.version = new Version() ); // Note: fetched on demand
	         !this.reasonCodes && ( this.reasonCodes = new ReasonCodes() );
	
	         /*     ????????????? -- need to update/clean this !!!
	         *
	         * TODO: on subsequent requests (not the first viewer),
	         * wait to check to see if the first viewer completed before checking if .isAuthenticated
	         * (that all FV data fetched -- databasesFetched, _getRemoteData).
	         * unauthorizedData may not have been requested by creation of second viewer -- need to wait for next to return ( ( this.auth.isAuthenticated )
	         * Alternatively hook into now existing viewer.onLoadEvent ... there's a cb function for it.
	         * But actually the simple line ( isFirstViewerToLoad ) seems to work and allow for asynchronicity w/ multiple viewers --
	         * what we're really looking for is whether a viewer has already been created.
	         * Update --- this really needs to be looked into and cleaned up ...
	         * */
	
	         var isFirstViewerToLoad = (this.numberViewers == 1);
	
	         var auth = this.auth,
	             self = this;
	
	         /*
	          * If the first viewer, always fetch the 'unauthorizedData' -- databases are necessary to login.
	          * If Not Authenticated, 401 fn will be called putting into logged out state
	          * */
	
	         if (isFirstViewerToLoad) {
	
	             this.unauthorizedData.fetch()
	                 .done( function() {
	
	                     if ( auth.didFirstAuthenticationOccur() ) {
	
	                         // TODO: logged in state
	                         self._enterLoggedinMode();
	
	                     } else {
	
	                         auth.loginViaKeepAlive( self )
	                             .done( self._enterLoggedinMode )
	                             .fail( self._enterLoggedOutMode );  // cb should override 401 handler ...
	                     }
	
	                 })
	                 .fail( function(jqXHR) {
	
	                     // TODO: 'unableToLoadViewerError' state
	                     _.invoke( self.viewers, 'triggerMethod', 'loadError',
	                         'Error Fetching System Databases. Cannot Authenticate.\n' + $.fn.ajaxErrorMessage(jqXHR)
	                     );
	
	                 });
	         }
	
	         return viewer;
	     },
	
	     /*
	     * Sources (4):
	     * - fvChannel.userLoggedOut
	     * - createViewer: if firstAuthOccured cb of successful db fetch, or cb of db fetch, then cb isAuthenticated (keepAlive)
	     * - onUserLogin -- successful fetch of auth model (from login form)
	     *      - improvement: call this on the channel now .... ???
	     *      - first sets user auth to true, and creates a new user model
	     *      - fetches user data; on success --> 'create' viewer, on fail put them in 'load error mode'
	     *  call this getRequiredUserData() /  requiredAuthData() for clarity ???
	     * */
	     _enterLoggedinMode: function() {
	
	        this.auth.setUserAuth(true); // ...put this in successful callback of the auth fetch
	
	        this.systemPolicies = new SystemPrefs();
	
	        this.systemPolicies.fetch().always( _.bind( function() {
	
	            this.user = new User([], {
	                fetchReferralGroups: this.systemPolicies.allowConsults()
	            });
	
	            this.user.fetchWithGroupsAndTaskPerms(this).done( function() {
	
	                // Now fetch the reasonCodes; perhaps we combine with systemPolicies unauthdata/user,
	                // but for now do after successful user info check.
	                // We never had a fail check before when fetch from canvas module so just log a warning.
	                // Plus, this will be combined later with other webservices.
	                this.reasonCodes.fetch().fail( function( jqXHR ) {
	
	                    console.warn(  $.fn.ajaxErrorMessage(jqXHR) );
	
	                }).always( _.bind( function() {
	
	                    _.invoke( this.viewers, 'triggerMethod', 'create' );
	
	                }, this) );
	
	
	            }).fail( function( failedRequest, jqXHR ) {
	
	                // ...errorLoadingMode
	
	                // if any fetch fails, fail all!
	                _.invoke( this.viewers, 'triggerMethod', 'loadError',
	                    'Unable to retrieve necessary user data --\nFailed ' + failedRequest + ' Request \n' + $.fn.ajaxErrorMessage(jqXHR)
	                );
	
	            });
	
	        }, this ));
	
	     },
	     /*
	     * Set user auth to false, then calls --> showLoginView.
	     * Sources:
	     * - 401 logout from session timeout
	     * - createViewer: failed auth.isAuthenticated
	     * - Failed login (fail of auth model fetch) -- this would have its own states
	     * - userLoggedOut
	     * - unauthorizedLogout
	     * ... this also would be called during 'greedy' reset
	     * TODO: abort all requests queue and stop the subsequent reqs or abort all ajax requests
	     * */
	     _enterLoggedOutMode: function(options) {
	
	        var fromAuthErr = !options || (options && options.authErr);
	
	         // Don't re-render login view if already exists (subs calls to 401)
	        if (this.auth.loggedOutFromSessionTimeout() && fromAuthErr)
	            return;
	
	
	        this.auth.setUserAuth(false, options);
	
	         // TODO: destroy systemPolicies?
	
	         /*
	         *  this.user.destroy(); -- note: user destroyed -- do here instead ????
	         *  TODO:
	         *  - destruction of modules not related to 'logged in mode'
	         *  - a logout state would make clearer ( along with states for many other things here )
	         * */
	
	
	         // Quick hack to ensure that the resize sensor employed on the viewer's view,
	         // doesn't result in a run time error when viewport is resized in logged out mode.
	         // ( See viewer.channel.updateAfterViewerResize which checks for this flag ).
	         // Don't disable the event on showing the loginView, may want responsive design here in the future.
	         // Obvioulsy much more work required here ( tearing down modules, etc ) -- just change the is loaded flag on them for this specific error
	         // Perhaps could put in the showLoginView routine ... but here is probably the place you'd want a cleanup first.
	         // DVBC-1454, 172
	         // Note: will need to set back to loaded on reauth, but we are already getting errors here
	         if ( this.viewers['1'].state.get('viewerLoaded') ) {
	
	             _.each( this.viewers, function(v) {
	                 v.state.set('viewerLoaded', false);
	             });
	         }
	
	        _.invoke( this.viewers, 'triggerMethod', 'showLoginView', this.unauthorizedData, this.auth.getLogInError() );
	
	
	     },
	
	     /**
	      * From the Login Form View.
	      * formData: object of key value pairs.
	      */
	     onUserLogin: function( formData ) {
	
	         /*  WF easier doing this than overriding $ & BB.sync -- if using promises, the 401 CB runs with .always */
	         /*  if use statusCode: {} in BB sync options, the global still gets called */
	         var origStatusCode = $.ajaxSettings.statusCode;
	         $.ajaxSettings.statusCode = {};
	
	         this.auth.fetch( {
	             data: formData,
	             context: this
	         } ).done( this._enterLoggedinMode )
	
	            .fail( _.partial( this._enterLoggedOutMode, {authErr: true} ))
	
	            .always( function() {
	                 $.ajaxSettings.statusCode = origStatusCode;
	                 this.localStorageSettings.setLastDb( formData.database );
	            });
	
	     },
	
	     _postValidationInit: function() {
	         $.support.cors = true;  // Necessary FOR IE < 10
	         $.ajaxSetup( this.settings.$ajax );
	     },
	
	     /*
	     * Note: will also read rules in inline tags.
	     * TODO:
	 *      - others: sidePane: .FV-side-{side}, width;
	 *      - start using inline styles from js
	     * */
	     _getStyleConstants: function() {
	         var cssConstants = {};
	         cssConstants.V_PADDING = 10;
	         cssConstants.H_PADDING = 20;
	         cssConstants.THUMB_WIDTH = 110;
	         return cssConstants;
	
	     },
	
	    /*
	    * Don't need to listen to window.top if embedded: 'unload'/beforeunload' of current window seems
	    * to cascade down from the parent.
	    * Use unload to send ajax requests -- not beforeunload !!!
	    * */
	    _setWindowUnloadHandler: function() {
	        $(window).on( 'unload', _.bind( this._onWindowUnload, this) );
	    },
	     /*
	      * Exit if not authenticated ( Can't make webservice call if there's no session ).
	      * Former checks whether viewer has been created (auth wouldn't exist in this case).
	      * Should make private but left here to faciliate testing ( a lot of this should be made private -- DVBC-133 ).
	      * May later want to expand functionality to end the user's session.
	      * */
	
	     _onWindowUnload: function(e) {
	
	         if ( !this.auth || !this.auth.isAuthenticated() )
	             return;
	         _.invoke( this.viewers, 'command', 'unlockActiveDocumentBeforeUnload' );
	
	     },
	
	     /*
	     * API: logout
	     * */
	     endSession: function() {
	         this.auth.logOut();
	     },
	     /*
	     * Convience method -- now used in glErrHandler
	     * */
	     firstViewerInstance: function() {
	         return this.viewers.length < 1
	            ? undefined
	            :  this.viewers[_.keys(this.viewers)[0]];
	     },
	
	     /*
	      * Deprecated in API in favor of createViewer.
	      * */
	     createViewer: function(instanceOptions, fvOptions) {
	         return this.docViewer.call(this, instanceOptions.docRequest,  _.omit(instanceOptions, 'docRequest'), fvOptions);
	     },
	
	     /*
	     * Scaffold: not implemented -- see DVBC-1077
	     * Potentially make 'dummy viewer' to utilize the existing fn? -- need to see where auth comes into play
	     * */
	     comboPDF: function(aDocReq, popWindow) {
	        var docs = new DocumentCollection(aDocReq);
	
	
	     },
	     /*
	      * Probably just for test --- make 'reset' -- b/c would give clean slate.
	      * More could be destroyed / reset to default state here; need to compare FV with just
	      * script tag loaded vs after FV.docViewer vs FV.destory.
	      * */
	     destroy: function() {
	
	         _.invoke( this.viewers, 'destroy');
	
	         this.numberViewers = 0;
	         this.options = null;
	
	         var props = _.toArray( _.pick(this, 'settings', 'user', 'auth', 'reasonCodes', 'systemPolicies', 'unauthorizedData' ) );
	
	         Marionette.blindTriggerOn( props, 'destroy' );
	         this.channel.reset();
	
	     }
	
	 });
	
	
	_.extend( FV.prototype, _.pick( Marionette, 'triggerMethod', 'triggerMethodOn') );
	
	
	 module.exports = FV;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {
	/*
	* Settings that apply to the FV namespace.
	* TODO: contains viewer specific defaults settings -- move those as necessary to the viewer settings defaults itself -- only want 'global settings here'
	* */
	
	
	var M = __webpack_require__(69);
	var Util = __webpack_require__(48);
	var fvChannel = __webpack_require__(72).channel('FV');
	var ErrorModule = __webpack_require__(75);
	
	
	__webpack_require__(76);
	__webpack_require__(77);
	
	
	module.exports = {
	
	    /* cached settings */
	
	    isRunningNode: window.location.port === "3000",
	
	    isIE7: Util.isIE7(),
	    isIE8: Util.isIE8(),
	    isIE: Util.isIE(),
	    isChrome: Util.isChrome(),
	    scrollBarWidth: $.scrollbarWidth(), // note: measured from HTML tag in case script appears before the end of document body
	
	    DPI: $.fn.getDPI(),
	
	    $ajax: {
	        dataType: 'json',
	        contentType: 'application/json', // at one point just used 'json' which stopped working; I believe this may have been set at one point to trigger setting pre-flight options for the full text widget
	        crossDomain: true,   // allows, for example, server-side redirection to another domain ( over-ride only for spec req's ? ); I believe this was used at one point for JSONP requests with the full text widget
	        statusCode: {
	            401: function() {
	                fvChannel.command('unauthorizedLogout'); // could pass in to rid dependency
	            },
	            //  DVBC-1709: in some environments, this is returned instead of 401 if X-Requested-With Header is present
	            403: function() {
	                fvChannel.command('unauthorizedLogout');
	            }
	        },
	        // DVBC-1709: appears newer versions of jQuery send this automatically
	        headers: {
	            'X-Requested-With': 'XMLHttpRequest'
	        }
	
	    },
	    crePollInterval: 250,
	    PATH_TO_API: null, //note: node, tomcat, or overwritten
	    CRE_ROOT: null, /* Must be set on init -- derived from path to API */
	    /* note: the default also defined in the plugin -- TODO: get from require */
	    getCRERoot: function() {
	        return this.CRE_ROOT;
	    },
	
	    absolutePathToES: null, //set in init (options.absolutePathToES / default); fn to retrieve in channel -- this gets set on the ES model
	
	    fromUrlInterface: 0, // passed as true if called from URL interface
	    onClick: null,
	
	    // Return the path the the client version file.
	    // Note: for node environment, run grunt copy:versionNode to copy the dummy versionDEV file into the build dir 
	    // (with the same name used in PROD) ... why not using isNode here / better build setup ?
	    pathToVersionFile: function() {
	        return __webpack_require__.p + this.VERSION_FILE;
	    },
	
	    /* Date-Time */
	    DATE_FMT_STR: 'M/D/YYYY',
	    DT_TIME_FMT_STR: 'M/D/YYYY h:mma', // 4/25/2019 5:03pm -- main format used in app (eg used for ctime in notes panel)
	    DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR: 'M/D/YYYY h:mm A', // 4/25/2019 5:03 PM
	
	    /* file system ...*/
	    VERSION_FILE: 'version.json',
	
	    NEW_WINDOW_NAMESPACE: 'FV-NEW-WINDOW', // variable name of the namespace stored on the created window when the viewer is launched through 'New Window' feature
	
	    initialize: function( options ) { /* note: 'configurationOptions' -- if provided override the defaults (would be of install) */
	
	        var isRunningNode = this.isRunningNode; // need to detect at runtime if want to use local file with 'prod' build pointing to the same script
	
	        //note: logic here is a bit dicey -- can be running local files and node, external files and node; etc, ...
	        /* if given, set it and the urls that derive from it (based on DEV, NODE, ... -- some now called from fn's */
	
	        if ( options.pathToAPI ) {
	            this.PATH_TO_API = Util.urlEndSlash( options.pathToAPI );
	        } else {
	            //defaults
	            this.PATH_TO_API = isRunningNode ? (("/api/")) : (("/docview/viewer/api/"));
	        }
	
	        this.absolutePathToES = options && options.absolutePathToES ? options.absolutePathToES : this.PATH_TO_API + 'servers/elasticsearch';
	
	        //TODO: have a generic extend for overrides
	        options.crePollInterval && (this.crePollInterval = options.crePollInterval);
	        options.fromUrlInterface && (this.fromUrlInterface = options.fromUrlInterface);
	        options.onClick && (this.onClick = options.onClick);
	
	        if (true)
	            window.onerror = ErrorModule.onerror;
	
	        //( api route in from of express calls )
	
	        //TODO: put in API module (?) -- no (dependent on server running -- different format) ... could pass that too
	        this.CRE_ROOT = isRunningNode
	            ? this.PATH_TO_API
	            : this.PATH_TO_API.replace('/api', ''); //TODO: ABOVE ...
	
	
	    }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var fvChannel = __webpack_require__(72).channel('FV');
	
	
	/*
	* Store original for PRODUCTION to call if source not from script file (and to not override any existing
	* */
	
	var existingWindowOnError = window.onerror;
	
	module.exports = {
	
	    ajaxError: function( jqXHR, shortMessage ) {
	
	        var dialogOptions = {
	            type: 'error',
	            shortMessage: shortMessage,   //eg: 404 Not Found: Cannot DELETE /document/FILECABINET/1188/2643334/notes/1
	            detailedMsg: fvChannel.request( 'ajaxErrorMessage', jqXHR )
	        };
	
	        this.trigger( 'alert:show', dialogOptions );
	
	    },
	
	    /*
	    * Note: if running in dev mode (webpack eval), url can be empty in Chrome and malformed in Firefox -- should work in PROD.
	    * -- eg: ["http:", "", "localhost:8080", "docview", "public", "dv", "viewer.js line 1201 > eval"]
	    * Note: new html spec, now in Chrome, FF: message, source, lineno, colno, error.
	    * Detail is optional : link ajax errors to the alert view.
	    * Note: now applied from viewer channel.
	    * TODO: send ajax messages to log file / the back end ...
	    * */
	    onerror: function(msg, url, line) {
	
	        var aUrl = url.split('/'),
	            script = _.find(aUrl, function(i) {
	                return i === FV._src;
	            });
	
	        /*
	        * Don't handle uncaught errors not from the viewer.
	        * Also: won't get picked up in webpack dev mode (script will be ''), so
	        * */
	
	        if ((true) && !script) {
	            existingWindowOnError && existingWindowOnError();  // if not defined will be null
	            return;
	        }
	
	        /*
	        * TODO: ( ... still ... ? )
	        * - diff method to handle errors if the first instance isn't yet created -- if not now will go to console.
	        * - combo above in the function logic
	        * */
	        fvChannel.command('updatePostRunTimeError', msg, url, line);
	
	
	        // If you return true, then error alerts (like in older versions of Internet Explorer) will be suppressed.
	        var suppressErrorAlert = true;
	        return suppressErrorAlert;
	    }
	
	};
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(59),
	    Util = __webpack_require__(48); /* just for isIE in unselectable */
	
	
	$.fn.ajaxErrorMessage = function( jqXHR ) {
	    return jqXHR.status + ' ' + jqXHR.statusText + ': ' + jqXHR.responseText;
	};
	
	/* Note: like with scrollbar plugin, append to html, not body, in case not yet loaded */
	$.fn.getDPI = function () {
	    var $inchDiv = $('<div class="inch" style="width: 1in;"></div>').appendTo($('html')),
	        px = $inchDiv.width();
	    $inchDiv.remove();
	    return px;
	};
	
	
	$.fn.getHiddenElementDimensions = function(options) {
	
	    var defaults = {
	        $container: $('body'),
	        removeClass: 'hide', /* note: could be list, space delimited */
	        addClass: 'offScreen',
	        useOuter: true
	    },
	    s = $.extend({}, defaults, options),
	    $clone = this.clone()
	        .removeClass(s.removeClass)
	        .addClass(s.addClass)
	        .appendTo(s.$container);
	
	    if (options && options.removeInlineDimensions) {
	        $clone.css({
	            height: '',
	            width: ''
	        });
	    }
	
	    var w = $clone[s.useOuter ? 'outerWidth' : 'width'](),
	        h = $clone[s.useOuter ? 'outerHeight' : 'height']();
	
	    $clone.remove();
	
	    return {
	        width: w,
	        height: h
	    };
	};
	
	$.fn.getMouseCoordinate = function (event) {
	    return {x: event.pageX, y: event.pageY};
	};
	
	$.fn.setCursorEndOfText = function () {
	    var origVal = this.val();
	    this.focus().val('').val(origVal); //this deletes the txt
	    return this;
	};
	
	/* keep the element in view of a container if scrollPos changes
	 - assumes the container element dimensions can change
	 */
	
	$.fn.keepInView = function ($container, initPos) {
	    //todo: think out and fix
	    var $el = this,
	        fnOriginalPosition = function () {
	            $el.css({
	                position: 'absolute',
	                top: initPos.y,
	                left: initPos.x
	            });
	        };
	
	    fnOriginalPosition(); //the default is to set to initPos -- positioned absolutely on screen
	    return this;
	};
	
	
	/* When Iframes Are Moved in the DOM they Reload -- run this b/f to put the contents in post move */
	$.fn.persistIframeChildrenOnMove = function () {
	    var $el = this;
	    $el.find('iframe').each(function (i, el) {
	
	        var $f = $(el),
	         iframeDocument = $f[0].contentWindow.document;
	         markup = $f.getMarkupOfIframe();
	
	        /* Store the html markup on data element of the iframe, when it loads, set the html of the iframe to the markup */
	        $f.one('load', function () { //load triggered post DOM move
	            iframeDocument.write( markup ); //put back before append
	            iframeDocument.close();
	        });
	
	    });
	    return this;
	};
	
	
	//Note: DVBC-955 - $.contents BREAKS if invalid markup ( really .contentDocument ) -- eg with Adobe PDF plugin, now not all in HTML tag (the PDF is in an object tag outside
	$.fn.getMarkupOfIframe = function() {
	    var iframeDocument = this[0].contentWindow.document,
	        iframeElements = iframeDocument.getElementsByTagName('*'),
	        curElement = iframeElements[0],
	        markup = '';
	    while (curElement !== null) {
	        markup += curElement.outerHTML;
	        curElement = curElement.nextSibling;
	    }
	    return markup;
	};
	
	
	/* Return whether or not the cursor is position over element with given selector*/
	$.fn.isMouseOver = function (uniqueSelector) {
	    return $(uniqueSelector + ':hover').length > 0;
	};
	
	/* Takes el and all ancestors but input and select and make unselectable */
	$.fn.unselectable = function() {
	    var $els = this.add(this.find('*').not('input, select'));
	    Util.isIE() //todo: rid dependency
	        ? $els.attr('unselectable', 'on') //IE<10
	        : $els.addClass('unselectable'); //(less mixin)
	    return this;
	};
	
	/* cross browser selection of the text in an element */
	$.fn.selectAll = function() {
	    var doc = document,
	        range,
	        selection;
	    if (doc.body.createTextRange) {
	        range = document.body.createTextRange();
	        range.moveToElementText(this[0]);
	        range.select();
	    } else if (window.getSelection) {
	        selection = window.getSelection();
	        range = document.createRange();
	        range.selectNodeContents(this[0]);
	        selection.removeAllRanges();
	        selection.addRange(range);
	    }
	    return this;
	};
	
	
	/* Check the style attribute of an elem for a cssProperty, if it exists, return the value, otherwise return null */
	$.fn.getInlineStyle = function(cssProp) {
	    var styleAttr = this.attr('style');
	    if (!styleAttr) return null;
	    var cssProperties = styleAttr.split(';');
	    for (var i=0; i<cssProperties.length; i++) {
	        var style = cssProperties[i].split(':'),
	            prop = $.trim(style[0]),
	            val = $.trim(style[1]);
	        if (cssProp === prop) {
	            return val;
	        }
	    }
	    return null;
	};
	
	/* used in inView and lazyLoad plugins -- note: assuming element isn't window */
	$.fn.getOffsets = function() {
	    var $this = this,
	        offset = this.offset();
	    return {
	        top: offset.top,
	        height: $this.height(),
	        left: offset.left,
	        width: $this.width()
	    };
	};
	
	/*
	* Returns a string of wrapped text to fit a given width, fontSize, & fontFamily
	* */
	$.fn.textWrap = function(txt, width, fontSize, fontFamily, $container, padding) {
	
	    var $spacer = $('<span class="spacer"></span>').appendTo($container).css({
	            'font-size': fontSize,
	            'font-family': fontFamily,
	            visibility: 'hidden',
	            padding: padding ? padding : 0 //not worrying about now
	        }),
	        spaceWt = $spacer.html('&nbsp').width(),
	        wrTxt = '',
	        words = txt.split(' '),
	        nWords = words.length,
	        curLineWt = 0,
	        curWordWt = 0,
	        curWord;
	
	    for (var i = 0; i < nWords; i++) {
	        curWord = words[i];
	        curWordWt = $spacer.text(curWord).width();
	        if (curLineWt + spaceWt + curWordWt >= width) {
	            wrTxt = wrTxt + '\n' + curWord;
	            curLineWt = curWordWt;
	        } else {
	            wrTxt = (i === 0) ? curWord : wrTxt + ' ' + curWord;
	            curLineWt = curLineWt + curWordWt + spaceWt;
	        }
	    }
	    $spacer.remove();
	    return wrTxt;
	
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* Fork -- append to html instead of body to ensure scrollbar width is calculated if script runs before body tag parsed
	*  better for unpredictable third party environment
	* */
	
	/*!
	 * jQuery scrollbarWidth - v0.2 - 2/11/2009
	 * http://benalman.com/projects/jquery-misc-plugins/
	 *
	 * Copyright (c) 2010 "Cowboy" Ben Alman
	 * Dual licensed under the MIT and GPL licenses.
	 * http://benalman.com/about/license/
	 */
	
	// Calculate the scrollbar width dynamically!
	
	(function($,undefined,width){
	    '$:nomunge'; // Used by YUI compressor.
	
	    $.scrollbarWidth = function() {
	        var parent,
	            child;
	
	        if ( width === undefined ) {
	            parent = $('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('html');
	            child = parent.children();
	            width = child.innerWidth() - child.height( 99 ).innerWidth();
	            parent.remove();
	        }
	      
	        return width;
	    };
	
	})(jQuery);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/*
	* Point-of-entry for getting & setting values from local storage.
	* Most of these values retrieved act like FV level 'settings'.
	* Initially I thought we might want to to cache the actual values on here as well,
	* but with all current use cases that's unnecessary at this time.
	* ( Rather than store them on FV.settings, the thought was that keeping logic separate would facilitate
	* an easier refactor and provide clarity by keeping the properties in the same location).
	* Perhaps future use cases may have me rethink this.
	* Writing cached properties make it easier to discern defaults and possible values --
	* but for now this is accomplished this through comments.
	* Unset items are treated with 'default' values.
	* Setting defaults here may prove clearer than having them set throughout the codebase -- see below comments.
	* Note that getters may not return exactly what exists in localStorage but the value expected by the app --
	* essentially what would be the proposed instance variables values on here.
	* For now not an instantiable class to mimic old FV.settings & for simplicity of initial refactor.
	* Everything now persisted in browser localStorage; with all properties now referenced inside here,
	* could switch to another method or persistence.
	* */
	
	var MostUsedReasonCodesComparator =
	    __webpack_require__(79).prototype.mostUsedCodeCountComparator;
	
	
	module.exports = {
	
	    LEFT_PANE_WIDTH: 'FV_LEFT_W', // defaults set is sidePanel models from css -- may want to set here via an initialize.
	    RIGHT_PANE_WIDTH: 'FV_RIGHT_W',
	    LAST_DB: 'FV_DB',
	    SHOW_OVERLAYS: 'FV_SHOW_OVERLAY', // 0/1: default is 1 ( DVBC-1754)
	    SHOW_GREENBAR: 'FV_SHOW_GREENBAR', // 0/1: default is 0
	    LAST_REDACTION_FILL: 'lastRedactionFill', // default defined redaction model -- WHITE_BLACK_BORDER
	    LAST_REASON_CODES: 'lastReasonCodes', // default: unset; equivalent to 'null' (value applied when user sets to none)
	    PG_MODE_APPLY_ALL_REDACTIONS: 'pgModeApplyAllRedactions', // 0/1: default is 0
	
	    LAST_GRAPHIC_NOTE_SHAPE_COLOR: 'FV-lastGraphicNoteShapeColor', // hex color string, eg: '#a2cdb3'
	    LAST_GRAPHIC_NOTE_SHAPE_LINE_WIDTH: 'FV-lastGraphicNoteShapeLineWidth', // 1, 2, 3, 4, or 5 -- see dropdown for available values
	    LAST_GRAPHIC_NOTE_SHAPE: 'FV-lastGraphicNoteShape', // default is free from graphic note model's default shape type
	
	    LAST_NOTE_SORT_TYPE: 'FV-lastNoteSort', // see notes.models.comparators: ctime, cusr, type, pageNumber; default: ctime
	    LAST_NOTE_SORT_DIRECTION: 'FV-lastNoteSortDirection',  // 'asc' or 'desc'; default: 'sortDir'; see notes.state.sortState
	
	    APPLIED_REASON_CODE_COUNTS: 'FV-appliedReasonCodeCounts',
	
	
	    /* Now not storing any cached property default values on here -- if that changes,
	     * would want to re-implement and set them here based on the values initially in local storage,
	     * perhaps through an initialize function like this.
	     * */
	    //initialize: function() {},
	
	    /*
	    * Generic function: proxy window.setItem to local storage
	    * Update provided key with given value.
	    * */
	    setItem: function(key, value) {
	        localStorage.setItem(key, value);
	    },
	    /*
	    * Note: spec returns null if item doesn't exist.
	    * */
	    getItem: function( key ) {
	        return localStorage.getItem(key);
	    },
	
	    getLastDb: function() {
	        return this.getItem( this.LAST_DB );
	    },
	    setLastDb: function( value ) {
	        return this.setItem( this.LAST_DB, value );
	    },
	
	    /* Note --  Handle conversion between string (in storage) and expected numeric value */
	    getShowOverlays: function() {
	
	        var showOverlaysLocalStorageValue = this.getItem( this.SHOW_OVERLAYS );
	
	        if (!showOverlaysLocalStorageValue)
	            return 1;
	
	        return parseInt(showOverlaysLocalStorageValue);
	
	    },
	    // Could potentially utilize a toggle fn -- see toggleApplyAllRedactionsInPageMode ...
	    // though now not necessary
	    setShowOverlays: function( value ) {
	        return this.setItem( this.SHOW_OVERLAYS, value );
	    },
	
	    getShowGreenbar: function() {
	        var showGreenbar = this.getItem( this.SHOW_GREENBAR );
	        return showGreenbar && parseInt(showGreenbar) ? 1 : 0;
	    },
	    setShowGreenbar: function( value ) {
	        return this.setItem( this.SHOW_GREENBAR, value );
	    },
	
	    getLastRedactionFill: function() {
	        return this.getItem( this.LAST_REDACTION_FILL );
	    },
	    setLastRedactionFill: function( value ) {
	        this.setItem( this.LAST_REDACTION_FILL, value );
	    },
	
	    // Note: string to array.
	    getLastReasonCodes: function() {
	        return JSON.parse( this.getItem( this.LAST_REASON_CODES ) );
	    },
	
	    /*
	     * Store stringified array of codes if any provided,
	     * otherwise store null instead of an empty array (for clarity)
	     * */
	    setLastReasonCodes: function( aCodes ) {
	
	        var codesToStore = aCodes && aCodes.length > 0
	            ? JSON.stringify( aCodes )
	            : null;
	
	        this.setItem( this.LAST_REASON_CODES, codesToStore );
	    },
	
	
	    getAppliedReasonCodeCounts: function() {
	
	        return JSON.parse( this.getItem( this.APPLIED_REASON_CODE_COUNTS ) );
	
	    },
	
	    /**
	     *  Stores array of { code: count } sorted by count.
	     *  Avoiding use of object with keys: technically it would have not no order
	     *  Could be more performent to store an array in index order of most used,
	     *  but this leaves more flexibility in case we ever want to know the counts.
	     *  Can't impose a max number to store in the array -- say max of 5 and a new code added,
	     *  the new code would only have a count of 1 would be cut off prior to saving;
	     *  the next time added it would then have a count of 1 ... it would never make the cut.
	     *  -- could now move to keys/greater if not sorting.
	     */
	    setAppliedReasonCodeCounts: function( aCodes ) {
	
	        if ( !aCodes || aCodes.length < 1 )
	            return;
	
	        var aReasonCodeCounts = this.getAppliedReasonCodeCounts();
	
	        if ( aReasonCodeCounts === null ) {
	            aReasonCodeCounts = [];
	        }
	
	        for (var c=0; c<aCodes.length; c++ ) {
	
	            var code = aCodes[c];
	
	            var existingCodeCount = _.findWhere( aReasonCodeCounts, { code: code });
	
	            if ( existingCodeCount ) {
	
	                existingCodeCount.count += 1;
	
	            } else {
	
	                aReasonCodeCounts.push( {
	                    code: code,
	                    count: 1
	                } );
	
	            }
	        }
	
	        // Sort for ease in debug and so we don't need to call multiple times in comparator fn's to get the top amount.
	        // Also gives consistency in knowing which come first if the have the same count in the top.
	        // Sorting on way in means no need to do so multiple times on the way out.
	        aReasonCodeCounts.sort( MostUsedReasonCodesComparator );
	
	        this.setItem( this.APPLIED_REASON_CODE_COUNTS, JSON.stringify(aReasonCodeCounts) );
	
	    },
	
	    getPgModeApplyAllRedactions: function() {
	        var applyRedactions = this.getItem( this.PG_MODE_APPLY_ALL_REDACTIONS );
	        return applyRedactions && parseInt(applyRedactions) ? 1 : 0;
	    },
	    setPgModeApplyAllRedactions: function( value ) {
	        this.setItem( this.PG_MODE_APPLY_ALL_REDACTIONS, value );
	    },
	    toggleApplyAllRedactionsInPageMode: function() {
	        this.setPgModeApplyAllRedactions( this.getPgModeApplyAllRedactions() ? 0 : 1 );
	    },
	
	    getLastGraphicNoteShapeColor: function() {
	        return this.getItem( this.LAST_GRAPHIC_NOTE_SHAPE_COLOR );
	    },
	    setLastGraphicNoteShapeColor: function(hexValue) {
	        this.setItem( this.LAST_GRAPHIC_NOTE_SHAPE_COLOR, hexValue );
	    },
	
	    getLastGraphicNoteShapeLineWidth: function() {
	        return this.getItem( this.LAST_GRAPHIC_NOTE_SHAPE_LINE_WIDTH );
	    },
	
	    setLastGraphicNoteShapeLineWidth: function( width ) {
	        this.setItem( this.LAST_GRAPHIC_NOTE_SHAPE_LINE_WIDTH, width );
	    },
	
	    getLastGraphicNoteShape: function() {
	        return this.getItem( this.LAST_GRAPHIC_NOTE_SHAPE );
	    },
	
	    setLastGraphicNoteShape: function( shapeType ) {
	        this.setItem( this.LAST_GRAPHIC_NOTE_SHAPE, shapeType );
	    },
	
	    getLastNoteSortType: function() {
	        return this.getItem( this.LAST_NOTE_SORT_TYPE );
	    },
	    setLastNoteSortType: function(comparator) {
	        this.setItem( this.LAST_NOTE_SORT_TYPE, comparator );
	    },
	
	    getLastNoteSortDirection: function() {
	        return this.getItem( this.LAST_NOTE_SORT_DIRECTION );
	    },
	
	    setLastNoteSortDirection: function(direction) {
	        this.setItem( this.LAST_NOTE_SORT_DIRECTION, direction );
	    }
	
	};
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var ReasonCodeCollection = __webpack_require__(80),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    _ = __webpack_require__(49),
	    CaseInsensitiveCompare = __webpack_require__(48).caseInsensitiveCompare;
	
	
	
	/**
	 * Collection used to populate the list or reason codes available to select.
	 * Want a different comparator than shape ( which needs to be in order to derives unique key )
	 * Now only used for the sort/comparator -- could optimize, change, below.
	 */
	
	
	var MAX_REMEMBERED_REASON_CODES_COUNTS = 5;
	
	
	module.exports = ReasonCodeCollection.extend({
	
	    /**
	     * Perhaps could make more efficient but this seems ok for now:
	     * - we only never add to these and don't need comparator -- so there's a faster way
	     * - only called on open of dialogs and initial print of find and redact ones ( we don't destroy on re-open )
	     * - could call sort from the views
	     * - could leave comparator and create a constructor caching getAppliedReasonCodeCounts()
	     * - perhaps a getSortedModels/function for printing
	     * - on insertion of the models could freq-used codes alpha-numerically, then just add the other models to them on init
	     * - now it's only used for the comparator, which we don't need
	     * Now done on here since used in multiple views -- *** when consolidate, could just sort in the view ( no codes are added ) ***
	     * Could put Non-Responsive at the top for full page redactions, though I don't think necessary ( esp when combo with Chosen )
	     */
	
	    comparator: function( a, b ) {
	
	        // Perf boost would be caching for one sort trip -- but it's not very slow
	        var appliedReasonCodeCounts =
	            fvChannel.request('localStorage').getAppliedReasonCodeCounts();
	
	        var aCode = a.get('code');
	        var bCode = b.get('code');
	
	        if ( !appliedReasonCodeCounts ) {
	            return CaseInsensitiveCompare( aCode, bCode );
	        }
	
	        // area for caching ... TAKING THE TOP 5 HERE WE NEED TO SORT ON THE WAY IN TO MAKE CONSISTENT ( alpha too ) or each time here
	        appliedReasonCodeCounts = appliedReasonCodeCounts.slice( 0, MAX_REMEMBERED_REASON_CODES_COUNTS );
	
	        // Potential area for optimization; could store locally if store locally in array ( but this is minimal )
	        var aInMostUsed = _.findWhere( appliedReasonCodeCounts, { code: aCode } );
	        var bInMostUsed =  _.findWhere( appliedReasonCodeCounts, { code: bCode } );
	
	        if ( !aInMostUsed && !bInMostUsed ) {
	
	           return CaseInsensitiveCompare( aCode, bCode );
	
	        }
	
	        else if ( aInMostUsed && ! bInMostUsed ) {
	            return -1;
	        }
	
	        else if ( bInMostUsed && !aInMostUsed ) {
	            return 1;
	        }
	
	        else if ( aInMostUsed && bInMostUsed ) {
	
	            return this.mostUsedCodeCountComparator( aInMostUsed, bInMostUsed );
	
	        }
	
	
	    },
	
	    /**
	     * Sorts {code:counts} used in local storage,
	     * as well as when comparing those in the comparator above to populate dropdown.
	     * See above notes -- not the most efficient;  look at better method when consolidate
	     * redactionProperty dialogs.
	     * Sort by count, then alpha-numeric.
	     * Storing on here now for convenience.
	     */
	    mostUsedCodeCountComparator: function( aCodeCount, bCodeCount ) {
	
	        var aCount = aCodeCount.count,
	            bCount = bCodeCount.count;
	
	        if ( aCount > bCount ) {
	
	            return -1;
	
	        } else if ( aCount < bCount ) {
	
	            return 1;
	
	        } else {
	
	            return CaseInsensitiveCompare( aCodeCount.code, bCodeCount.code );
	
	        }
	
	
	    }
	
	
	});

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var ReasonCodeModel = __webpack_require__(81),
	    Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/** Now this is like an abstract class */
	
	
	module.exports = Backbone.Collection.extend({
	
	    model: ReasonCodeModel,
	
	    /* Return the codes of models containing text in code or description, case-insensitive */
	    /* ( Currently just used on the sytem collection */
	    getCodesofModelsWithText: function(text) {
	        return this.chain()
	            .filter( function(c) {
	                return c.codeOrDescriptionContainsText(text);
	            })
	            .map( function(c) {
	                return c.get('code');
	            })
	            .value();
	    },
	
	    // Only called from Shape, but generic enough to leave here
	    // Could put this from the model now
	    getNonResponsiveCodeModel: function() {
	
	        var nonResponseReasonCodeCode = fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE;
	
	        return this.findWhere({
	            code: nonResponseReasonCodeCode
	        });
	    },
	
	    containsNonResponsiveReasonCode: function() {
	        return this.getNonResponsiveCodeModel() !== undefined;
	    },
	
	    getInactiveCodes: function() {
	        return this.where({ active:false });
	    }
	
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	    idAttribute: 'code', // define to prevent dupes in collection; in reality would only ever occur from fixtures/node server
	
	    defaults: {
	
	        code: null,
	        description: null,
	
	        /* introduced in schema 9.3.5 -- will all be null and considered active in older schemas */
	        active: null, /* convenience; not a DB field */
	        startDate: null,
	        endDate: null,
	        creationUser: null,
	        creationTime: null,
	        modifiedUser: null,
	        modifiedTime: null
	
	    },
	
	    /**
	     * Used in SAT filter.
	     * Note: case insensitive by default -- could put in param for this is desired
	     * If perf is ever an issue, could cache the combo'd text value and set on model parse
	     */
	    codeOrDescriptionContainsText: function(text) {
	        return ( (this.get('code') + this.get('description') ).toLowerCase() )
	                .indexOf( text.toLowerCase() ) > -1;
	    }
	
	});


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {var _ = __webpack_require__(49),
	    TaskPerms = __webpack_require__(83),
	    UserGroups = __webpack_require__(84),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    PrivateGroups = __webpack_require__(88),
	    ReferralGroups = __webpack_require__(89),
	    Stamps = __webpack_require__(90);
	
	
	/* Top Level Module: also contains groups, user groups, task permissions, referral groups, private groups, stamps */
	
	module.exports = Backbone.Model.extend({
	
	    initialize: function( attrs, options ) {
	
	        this.taskPermissions = new TaskPerms(); //just an array stored in model attributes
	        this.groups = new UserGroups();
	        this.privateGroups = null;
	
	        // ReferralGroups will be empty if error occurs fetching, and, in currently workflow, we won't be able to enter viewer
	        // TODO: may want to handle this situation better ... eg: log an error handle as referralGroups don't exist
	        this.referralGroups = options.fetchReferralGroups
	            ? new ReferralGroups()
	            : null; // serves as flag that system doesn't support (could be used instead of channel request)
	
	        this.stamps = new Stamps();
	
	
	    },
	
	    url: function() {
	       return fvChannel.request('apiUrl').user;
	    },
	
	    /* Get this model, taskPermissions, groups, referralGroups, -- done to allow entry -- disallow if all fails */
	    fetchWithGroupsAndTaskPerms: function(cxt) {
	
	        cxt = cxt ? cxt : this;
	
	        var fetchReferralGroups = this.referralGroups !== null,
	            $dfdUser = this.fetch(),
	            $dfdTaskPerms = this.taskPermissions.fetch(),
	            $dfdGroups = this.groups.fetch(),
	            $dfdStamps = this.stamps.fetch(),
	            $dfdReferralGroups = fetchReferralGroups
	                ? this.referralGroups.fetch()
	                : null,
	            dfds = [$dfdUser, $dfdTaskPerms, $dfdGroups, $dfdStamps];
	
	        fetchReferralGroups && ( dfds.push($dfdReferralGroups) );
	
	        return $.Deferred(function($dfd) {
	
	            $.when.apply($, dfds).done (function( user, taskPerms, groups, stamps, referralGroups ) { // jqXHRs are the args
	
	                $dfd.resolveWith(cxt);
	
	            }).fail(function(failJQXHR) { //called if any fail
	
	                _.invoke(dfds, 'abort');
	
	                var dfdFail = _.find(dfds, function($dfd) {
	                   return $dfd === failJQXHR;
	                });
	
	                switch(dfdFail) {
	                    case $dfdUser:
	                        $dfd.rejectWith(cxt, ['User', failJQXHR]); break;
	                    case $dfdTaskPerms:
	                        $dfd.rejectWith(cxt, ['Task Permissions', failJQXHR]);  break;
	                    case $dfdGroups:
	                        $dfd.rejectWith(cxt, ['Groups', failJQXHR]);  break;
	                    case $dfdReferralGroups:
	                        $dfd.rejectWith(cxt, ['Referral Groups', failJQXHR]); break;
	                    case $dfdStamps:
	                        $dfd.rejectWith(cxt, ['Stamps', failJQXHR]); break;
	                }
	            });
	
	        }).promise();
	
	    },
	    getUserDescription: function() {
	        return this.get('description');
	    },
	    getUserID: function() {
	        return this.get('userId');
	    },
	    /*
	    * Note: note fetched on demand with flash notes and cached
	    * Private groups should be a 'system resource ???
	    * */
	    gettingPrivateGroups: function() {
	
	        var self = this;
	
	        return $.Deferred(function($dfd) {
	
	             if ( self.privateGroups )  { //(cached)
	
	                $dfd.resolve(self.privateGroups);
	            } else {
	
	                self.privateGroups = new PrivateGroups();
	                self.privateGroups.fetch().done( function(groups) {
	                    $dfd.resolve(groups);
	                }).fail(function(jqXHR) {
	                    $dfd.reject(jqXHR);
	                });
	            }
	
	        }).promise();
	
	    },
	    /* former: false if error */
	    groupStatus: function() {
	
	        return this.groups && this.groups.findWhere({ groupId: this.getUserID() }) &&
	            this.groups.findWhere({ groupId: this.getUserID() }).get('status');
	
	    },
	    privateGroupsFetched: function() {
	        return this.privateGroups !== null;
	    },
	
	    /* return the users private group model in the priv. grps collection */
	    getPrivateGroup: function() {
	
	        if ( !this.privateGroups ) {
	            return false;
	        }
	
	        return this.privateGroups.findWhere( {groupId: this.get('privateGrpId') });
	
	    },
	    defaultNoteAccessGroup: function(isFlashNote) {
	        /* other user id or private group */
	        return {
	            id: !isFlashNote ? 1 : 4, /* groups: groupId, name */
	            name: !isFlashNote ? 'public' : 'fdd'
	        };
	    },
	
	    /* -- Stamps Proxy -- */
	
	    getStamps: function() {
	        return this.stamps;
	    },
	
	    getGraphicStamps: function() {
	        return this.getStamps().getGraphicStamps();
	    },
	
	    getTextStamps: function() {
	        return this.getStamps().getTextStamps();
	    },
	
	    /* Note -- doesn't determine if stamps exist in the system -- just if the user does --
	     * Potentially problematic if populating stamp note dropdown -- TODO: test if we add the preview from the note source here
	     */
	    hasGraphicStamps: function() {
	        return this.getGraphicStamps().userHasStamps;
	    },
	
	    hasTextStamps: function() {
	        return this.getTextStamps().userHasStamps;
	    },
	
	
	    /* -- End Stamps -- */
	
	
	    getReferralGroups: function() {
	        return this.referralGroups; // can be null if system doesn't support
	    },
	
	    getUserName: function() {
	        return this.get('username');
	    },
	
	    getGroupOfDerivedUserColor: function() {
	        return this.groups.getGroupOfDerivedUserColor();
	    },
	
	    getDerivedUserGroupColor: function() {
	        return this.groups.getDerivedUserGroupColor();
	    },
	
	    /**
	     * DVBC-1718 - reversing DVBC-1711 no longer used.
	     */
	    canViewPdfs: function() {
	        return this.taskPermissions.canViewPdfs();
	    },
	
	    canExport: function() {
	        return this.taskPermissions.canExport();
	    },
	
	    canPrint: function() {
	        return this.taskPermissions.canPrint();
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(59)))

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {/**
	 * Leave as model: its just a hash of index, string.
	 * Can fetch independently of user.
	 */
	
	var fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = Backbone.Model.extend({
	
	    url: function() {
	        return fvChannel.request('apiUrl').taskPerms;
	    },
	
	
	
	    // Export implies ability to download document/pages.
	    canExport: function() {
	        return _.contains(this.toJSON(), 'EXPORT');
	    },
	    canDeletePages: function() {
	        return _.contains(this.toJSON(), 'DELETE_PAGES');
	    },
	    // DVBC-1718 -- no longer used
	    canViewPdfs: function() {
	        return _.contains(this.toJSON(), 'VIEW_PDF');
	    },
	    canPrint: function() {
	        return _.contains(this.toJSON(), 'PRINT');
	    },
	    /**
	     * Determines if the user can 'save' a page rotation;
	     * without, user's can rotate pages but it won't be saved.
	     * Note: not using -- see allowSaveRotation on document which is now returned
	     * in contextual permissions.
	     */
	    canSavePageRotation: function() {
	        return _.contains( this.toJSON(), 'ROTATE' );
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(49)))

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var fvChannel = __webpack_require__(72).channel('FV'),
	    GroupCollection = __webpack_require__(85),
	    PublicGroupModel = __webpack_require__(87);
	
	/**
	 * The user's groups - myGroups
	 */
	
	module.exports = GroupCollection.extend({
	
	    url: function() {
	        return fvChannel.request('apiUrl').userGroups;
	    },
	
	    /**
	     * Ensure the public group is in the collection.
	     * For now we care about for populating access groups from this.
	     * May later refactor.
	     */
	    parse: function( resp ) {
	
	        resp = GroupCollection.prototype.parse.apply( this, arguments );
	
	        var publicGroupAttrs = new PublicGroupModel().toJSON();
	
	        if ( !resp || resp.length < 1 ) {
	
	            resp = publicGroupAttrs;
	
	        } else {
	
	            var publicGrpInResponse = _.contains( _.pluck(resp, 'groupId'), publicGroupAttrs.groupId );
	
	            !publicGrpInResponse &&
	                resp.push( publicGroupAttrs );
	        }
	
	        return resp;
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var fvChannel = __webpack_require__(72).channel('FV'),
	    Group = __webpack_require__(86),
	    Backbone = __webpack_require__(58);
	
	/**
	 * Base Group Model -- no url.
	 */
	
	module.exports = Backbone.Collection.extend({
	
	    model: Group,
	
	    initialize: function() {
	
	        this.aModelAttrsSortedByName = null; // set at first request ( if utilized )
	
	        this.groupOfDerivedUserColor = null; // set at first request ( if utilized; could be null if there are no groups )
	        this.groupOfDerviedUserColorSet = false; // ( b/c above can be null )
	
	    },
	
	    // returns array of objects containing model attributes by name
	    // used to populate the accessible select box in the note view
	    getArrayOfModelAttrsSortedByName: function() {
	
	        if (this.aModelAttrsSortedByName)
	            return this.aModelAttrsSortedByName;
	
	        this.aModelAttrsSortedByName = this.chain()
	            .map( function(g) {
	                return g.toJSON();
	            })
	            .sortBy( function(i) {
	                return i.name.toLowerCase();
	            } )
	            .value();
	
	        return this.aModelAttrsSortedByName;
	
	    },
	
	    getUserInfoGroupIds: function() {
	        return this.pluck('groupId');
	    },
	
	
	    /* also sets with caching on first request: but it could be null, *F* */
	    getGroupOfDerivedUserColor: function() {
	
	        if ( this.groupOfDerviedUserColorSet && this.groupOfDerivedUserColor ) {
	            return this.groupOfDerivedUserColor;
	        }
	
	        this.groupOfDerivedUserColor = this._generateGroupOfDerivedUserColor();
	
	        return this.groupOfDerivedUserColor;
	
	    },
	
	    _generateGroupOfDerivedUserColor: function() {
	
	
	        this.groupOfDerviedUserColorSet = true; // ( only called once )
	
	        if ( this.length < 1 )
	            return null;
	
	        var groupsWithColorsAssigned = this.filter( function( group ) {
	            var color = group.get('color');
	            return color && color !== null;
	        });
	
	        if ( groupsWithColorsAssigned.length !== 1 )
	            return null;
	
	        return groupsWithColorsAssigned[0];
	
	    },
	
	    getDerivedUserGroupColor: function() {
	
	        return this.getGroupOfDerivedUserColor().getColor();
	
	    }
	
	});

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        "groupId": null,
	        "groupType": null,
	        "name": null,
	        "description": null,
	        "status": null,
	        "creationTime": null,
	        "creationUser": null,
	        "email": null,
	        "color": null
	    },
	
	    getName: function() {
	        return this.get('name');
	    },
	
	    getColor: function() {
	        return this.get('color');
	    }
	
	
	});

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var GroupModel = __webpack_require__(86);
	
	/**
	 * Set as the user's group collection none returned (ensure it exists).
	 * Note: certain attributes here are arbitrary and if used, would be inaccurate,
	 * but they aren't used.
	 * If this becomes a probably, you want to fetch the user groups.
	 * But with my group refactor -- could now add on server -- further refactor
	 * would consolidate this on a 'user' compound endpoint.
	 */
	
	
	module.exports = GroupModel.extend({
	
	    defaults: {
	        groupId: 1,
	        groupType: "NORMAL",
	        name: "public",
	        description: "all users",
	        status: "PRESENT",
	        creationTime: 1225080000000, // this would be arbitrary but not used
	        creationUser: 1,
	        email: null, // this would be arbitrary but not used
	        color: null // this could be misleading ... but not used ( for actually would need to fetch ); refactor later
	    }
	
	});

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/***
	 * Currently only used for FlashNotes.
	 */
	
	var GroupCollection = __webpack_require__(85),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = GroupCollection.extend({
	
	    url: function() {
	
	        return fvChannel.request('apiUrl').allPrivateGroups;
	
	    },
	
	    /**
	     * Filter out null 'description' -- value must be present in dd
	     * If use for other purposes, the logic should be moved elsewhere.
	     */
	    parse: function( resp ) {
	
	        resp = GroupCollection.prototype.parse.apply( this, arguments );
	
	        return _.filter( resp, function( g ) {
	            return g.description !== null && g.description !== '';
	        });
	
	    },
	
	    /**
	     * Fetch or provide cached result -- what is fed to the select box in the note view.
	     * Again: logic belongs elsewhere if we ever use for other purposes ....
	     * We also don't include the private group of the user -- but:
	     *  dds the current user back as the first value (and as 'me').
	     */
	    getIdDescs: function() {
	
	        if ( this.groupIDNames ) {
	
	            return this.groupIDNames;
	
	        } else {
	
	            /* Note: Also sets the current user as 'me' and sorts atop others */
	            var groupOfUser = fvChannel.request('user').getPrivateGroup();
	
	            this.groupIDNames =  this.chain()
	                .map( function(g) {
	                    return _.pick( g.toJSON(), 'groupId', 'description');
	                })
	                .reject( function(i) {
	                    return i.groupId === groupOfUser.get('groupId');
	                })
	                .sortBy( function(i) {
	                    return i.description.toLowerCase();
	                } )
	                .unshift(
	                     _.chain( groupOfUser.attributes ).pick('groupId', 'description' ).extend( {'description': 'Me'} ).value()
	                )
	                .value();
	
	            return this.groupIDNames;
	
	        }
	
	    },
	
	    getGroupIds: function() {
	        return this.pluck('groupId');
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Note: these are now referred to as 'consultation groups' in the user interface,
	 * but leaving them as referrals in the code base (don't want to break things and could change again)
	 * TODO: ultimately refactor in DV server and only client referral groups sent on Page Note to use this object ... thanks ...
	 */
	
	var GroupCollection = __webpack_require__(85),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = GroupCollection.extend({
	
	    url: function() {
	        return fvChannel.request('apiUrl').referralGroups;
	    }
	
	});

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    GraphicStamps = __webpack_require__(91),
	    TextStamps = __webpack_require__(95),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = Backbone.Model.extend({
	
	    /* -- don't need and not set but commented out for clarity of response
	    defaults: {
	        graphicStamps: [],
	        textStamps: []
	    },
	    */
	
	    constructor: function() {
	
	        this.graphicStamps = new GraphicStamps();
	        this.textStamps = new TextStamps();
	
	        Backbone.Model.apply( this, arguments );
	
	    },
	
	    url: function() {
	        return fvChannel.request('apiUrl').myStamps;
	    },
	
	    parse: function( data ) {
	
	        this.graphicStamps.reset( data.graphicStamps,  { parse: true } );
	        this.textStamps.reset( data.textStamps, { parse: true } );
	
	        return;
	
	    },
	
	    getGraphicStamps: function() {
	        return this.graphicStamps;
	    },
	
	    getTextStamps: function() {
	        return this.textStamps;
	    }
	
	
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var Stamps = __webpack_require__(92),
	    GraphicStamp = __webpack_require__(94);
	
	
	module.exports = Stamps.extend({
	
	    model: GraphicStamp
	
	});

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    Stamp = __webpack_require__(93);
	
	
	/* Base Abstract Class */
	
	module.exports = Backbone.Collection.extend({
	
	    model: Stamp,
	
	    initialize: function() {
	
	        this.userHasStamps = false;
	    },
	    // Apply a case sensitive sort of the subject; this is so the first will be the default stamp for new stamp notes
	    comparator: function(s) {
	        return s.get('subject').toLowerCase();
	    },
	
	    parse: function(resp) {
	
	        this.userHasStamps = resp && resp.length > 0;
	        return resp;
	
	
	    },
	    userHasStamps: function() {
	
	        return this.userHasStamps;
	
	    },
	
	    /* Cache data to populate the dropdown text context */
	    getDataToPopulateCreateStampDropDown: function() {
	
	        if ( this.dataToPopulateCreateStampDropdown )
	            return this.dataToPopulateCreateStampDropdown;
	
	        this.dataToPopulateCreateStampDropdown = this.toJSON(); // ( just extraneous model attributes ok -- I think already sorted )
	
	        return this.dataToPopulateCreateStampDropdown;
	
	    },
	
	    getDefaultStampForNewNote: function() {
	
	        if ( !this.userHasStamps )
	            return null;
	
	        return this.at(0);
	
	    },
	
	    // note: won't be able to use for pageNotes that don't have a stamp id associated with them
	    getStampModelFromId: function(id) {
	
	        return this.findWhere({id: id});
	
	    }
	
	});

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        "id": null,
	        "subject": null,
	        "stampOptions": null,
	        "creationUser": null,
	        "creationTime": null,
	        "accessGroup": null,
	        "blobId": null,
	        "type": null,
	
	        "src": null, // base64 image for graphic; text for text
	        "imageHeader": null // ( only for graphic stamps )
	
	    }
	
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var Stamp = __webpack_require__(93);
	
	
	module.exports = Stamp.extend({
	
	
	    getImgSrc: function() {
	        return this.get('src');
	    },
	
	    getWidth: function() {
	        return this.get('imageHeader').width;
	    },
	
	    getHeight: function() {
	        return this.get('imageHeader').length;
	    }
	
	
	});


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var Stamps = __webpack_require__(91),
	    TextStamp = __webpack_require__(96);
	
	
	module.exports = Stamps.extend({
	
	    model: TextStamp
	
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var Stamp = __webpack_require__(93),
	    _ = __webpack_require__(49),
	    NormalizeNewLineCharacters = __webpack_require__(48).normalizeNewLineCharacters;
	
	
	
	module.exports = Stamp.extend({
	
	    SUPPORTED_TOKENS: [ '$date', '$time' ],
	
	    constructor: function( attrs, options ) {
	
	        /* Normalize EOL white space on way in -- Raphael relies on '\n' -- printing text */
	        attrs.src = NormalizeNewLineCharacters( attrs.src );
	
	        Stamp.apply( this, arguments );
	
	        // Note: unique ( dupes are populated with the same value )
	        this.aVariables = this.setVariables();
	
	        // Also unique -- any that are the same would have the same value
	        this.aTokens = this.setTokens();
	
	    },
	
	    getText: function() {
	        return this.get('src');
	    },
	
	    setVariables: function() {
	
	        var txt = this.getText();
	
	        // Check when called from constructor and attributes haven't been sent
	        if ( !txt  )
	            return [];
	
	        // Get words starting with % but don't catch % in words starting with % -- eg: %before%after should be one match
	        // Rule is that all variables must be separated by white space
	        var variables = this.getText().match( /%[\w|%]+/g ); // old:  /\$\w+/g -- this would provide %before%after
	
	        return variables !== null
	            ? _.uniq(variables)
	            : [];
	
	    },
	
	    setTokens: function() {
	
	        var txt = this.getText();
	
	        // Check when called from constructor and attributes haven't been sent
	        if ( !txt  )
	            return [];
	
	        // No rule they must be separated by white-space
	        // Unlike variables, the names are pre-defined and you wouldn't run into the same issues
	        var tokens = this.getText().match( /\$\w+/g );
	
	        return tokens !== null
	            ? _.intersection( this.SUPPORTED_TOKENS, _.uniq(tokens) )
	            : [];
	
	    },
	
	    getVariables: function() {
	
	        return this.aVariables;
	    },
	
	    getTokens: function() {
	
	        return this.aTokens;
	
	    },
	
	    hasVariables: function() {
	
	        return this.aVariables.length > 0;
	
	    },
	
	    hasTokens: function() {
	
	        return this.getTokens().length > 0;
	
	    },
	
	    isDerivedFromPageNote: function() {
	
	        return this.get('id') === 0;
	
	
	    }
	
	
	
	});


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	
	    fvChannel = __webpack_require__(72).channel('FV'),
	    SubApp = __webpack_require__(98),
	
	    ViewerSettings = __webpack_require__(99),
	    ViewerState = __webpack_require__(100),
	    ViewerChannelActions = __webpack_require__(104),
	
	    Documents = __webpack_require__(391),
	    ViewModesContainer = __webpack_require__(412),
	    NotesModule = __webpack_require__(484),
	    FullTextModule = __webpack_require__(523),
	    ThumbnailsView = __webpack_require__(560),
	    IndexesModule = __webpack_require__(572),
	    FindAndRedactModule = __webpack_require__(580),
	
	    ViewerLayoutView = __webpack_require__(682),
	    Layout = __webpack_require__(710);
	
	__webpack_require__(76);
	
	
	
	var instVars = {
	
	    id: null,
	    channel: null, /* subApp */
	    channelName: 'viewer', /* don't store on prototype -- otherwise will inc in length on each reset (eg: viewer:1:1) */
	
	    // all above are destroyed on reset  ...
	    view: null,
	
	    state: null, // put below in state?
	    activeDocIndex: 0, // default is the first requested
	    activeDocument: null,
	    documents: null,
	
	    aDocReq: null, /* the user requested documents) */
	    vOptions: null, /* the 'instance options' from the initial request, can be changed by reset; not those from a doc vOptions */
	    settings: null, /* created from vOptions or a docVOptions -- the display of the current opts -- derived each time from vOptions or combo of those with the active document */
	
	    validationErr: null
	
	};
	
	
	/*
	* Note: with recent support for multi docs, layout really refers to 'docLayout* --
	* the entire layout should be in what is now 'view'
	* */
	
	module.exports = SubApp.extend({
	    /*
	    * Prevent lookups from going to base prototype.
	    * Add Channel Element to Prototype For SubApp Constructor.
	    * fromReset implies invoked from viewer.reset (also implies fromDocChange).
	    * fromDocChange: initially meant invoked from reset when active document changed in multi-doc mode,
	    * now really implies called from an 'internal reset' ( eg page operations too ) ... should be named appropriately ...
	    * All needs major cleanup/refactor (DVBC-1649)
	    * */
	    constructor: function(aDocReq, vOptions, options, id) {
	
	        var fromReset = options && options.fromReset,
	            fromDocChange = options && options.fromDocChange,
	            props = _.omit( instVars, 'aDocReq' );
	
	        /*
	        * If/when have time, the below is superfluous when coming from reset,
	        * where this is done in the delete ... there is a better way to accomplish this ...
	        * */
	        fromReset && ( props = _.omit( props, 'view', 'vOptions') );
	        fromDocChange && ( props = _.omit( props, 'activeDocIndex', 'documents', 'activeDocument', 'settings', 'state' ) );
	
	        _.extend( this, props, {id: id} );
	
	        if ( !fromReset ) {
	            this.aDocReq = aDocReq;
	            this.vOptions = vOptions;
	        }
	
	        /*
	        * Creation of State:
	        * Must create  before channel and layout, which reference it's values.
	        * Create b/f channel --> or context null --- other option wold be function but would hurt performance.
	        * */
	        if ( !fromDocChange ) {
	            this.state = new ViewerState( {}, {
	                id: this.id,
	                vChannel: this.channel
	            });
	        }
	
	        _.extend( this.constructor.prototype, { state: this.state }, /* need to set cxt for forwarded state fns */
	            _.pick( new ViewerChannelActions( this.state), 'requests', 'commands', 'subscriptions' )
	        );
	
	        SubApp.prototype.constructor.call( this, {aInitParams: arguments}, this.id );
	
	        _.bindAll( this, 'destroy' );
	    },
	    /*
	    * Create empty region first to show error message && validate settings while validating necessary options.
	    * Create view prior validation of settings for place to show errors if necessary.
	    * Note: container never over-writable by doc option -- el only set once and always by vOptions
	    * Get container for the view b/f rendering
	    * ('start')
	    * */
	    initialize: function(aDocReq, vOptions, options) {
	
	        /*
	        * DVBC-1647, DVBC-1648: quick fix to prevent errors if vOptions is not provided on create or reset.
	        * Class really needs a refactor: DVBC-1649.
	        * Use this.vOptions here???
	        * */
	       vOptions = vOptions || {};
	
	        var isFullScreen = !vOptions.el,
	            container = isFullScreen ? $('body')[0] : vOptions.el;
	
	        isFullScreen && _.extend( vOptions, { el: container } ) ;
	
	        if ( !this.view ) {
	
	            this.view = new ViewerLayoutView({
	                el: container,
	                vChannel: this.channel
	            }).render();
	
	
	        } else {
	
	            // TODO: - is this now obsolete ???
	            /* was cleared */
	            this.view.resetWiring();
	        }
	
	        /* Always show while data loading after create or change/reset */
	        this.channel.command('showLoading');
	
	        var fromDocChange = options && options.fromDocChange;
	
	        var vErr;
	
	        /*
	        * Currently only validate for the initial doc request, not if doc changes.
	        * TODO: all first if multi doc -- and allow navigation to those that pass -- problem is server req is for all
	        * */
	        if ( !fromDocChange ) {
	            vErr = this._validateDocRequest();
	            if (vErr) {
	                this.validationErr = vErr;
	                this.triggerMethod('loadError', vErr);
	                return this;
	            }
	        }
	
	        /*
	         * Ensure container is ignored -- always use the base.
	         * Don't create settings from its el EVER -- DVBC-926.
	         * Do after validation of aDocReq (it's referenced here and could be ignored ).
	         * */
	        var activeDocVOptions = aDocReq[this.activeDocIndex].vOptions;
	        if ( activeDocVOptions )
	            activeDocVOptions = _.omit( activeDocVOptions, 'el' );
	
	        /*
	        * Create settings object from this
	        * Cascade of rules in overrides ...
	        * Prob want to put cascade into the constructor on the settings obj ...
	        * */
	        var o = _.extend( {},
	
	            vOptions, /* (base options -- all docs ) */
	
	            /*  - prior settings if from doc change
	                - have settings changed by user preferences (eg opening thumbnails, closing the notes panel) will carry over to the next document, unless
	                - overwritten by activeDocVOptions, not the base options
	             */
	
	             ( fromDocChange ? this.settings.attributes : {} ),
	
	            /* docInstance options */
	             ( activeDocVOptions ?
	                 _.omit( activeDocVOptions, 'openToPageNumber' ) // temp workaround: in current WF, this setting only refers to the viewer instance one, not a doc-specific one
	                 : {}
	             )
	         );
	
	        this.settings = new ViewerSettings(o);
	
	        vErr = this.settings.checkOptionalParams();
	        if (vErr) {
	            this.validationErr = vErr;
	            this.triggerMethod( 'loadError', vErr );
	        }
	
	        return this;
	
	    },
	    /**
	     * TODO:
	     * - all requested documents / the individual? -- currently checking all but request at 'activeDoc' level (DVBC-1706)
	     * - *** really need to add an object for the doc slice *** ( do after renditions ) !!!
	     *      ( this logic would be contained in there ... maybe just try with aDoqRequest )
	     * - at some point this diverged from being full validation; it's now mostly looking at the container type
	     * - could also loop and validate the types of all docs provided ... lot of options here
	     * - this is a mess that needs refactor
	     */
	    _validateDocRequest: function () {
	
	        // First generic validation that of the existence of the docRequest.
	        if (!this.aDocReq)
	            return 'Document Request Not Provided';
	
	
	        // TODO: could be nice here and see if only one is requested, change it to an array ( like with pages, below )
	        if ( !(this.aDocReq instanceof Array ) ) {
	            return 'Document Request Must Be Provided as an Array.';
	        }
	
	        if ( this.aDocReq.length < 1 ) {
	            return 'No Documents Requested';
	        }
	
	        /**
	         * Now things get messier -- as currently we're only validating the active document ( currentDocRequest ).
	         * Container: -- just check for existence and valid type: invalid values returned in the server response.
	         * Note: no longer accepting 'WORKFLOW_TASK'.  People now are requesting the base filecabinet of the workflow.
	         * TODO: for any of these errors, say which doc request they failed from; initially
	         * ... this was only written for one document
	         */
	        var currentDocRequest = this.aDocReq[this.activeDocIndex];
	
	        if ( !(currentDocRequest instanceof Object) )
	            return 'Invalid Doc Request';
	
	        var container = currentDocRequest.container;
	
	        // container
	        if (!container)
	            return 'No Data Container Provided';
	
	        if ( !(container instanceof Object) )
	            return 'Invalid Container Provided';
	
	        var containerType = container.type;
	
	        if (!containerType)
	            return 'No Container Type Provided';
	
	        var validContainerTypes = ['FILECABINET', 'BIN'];
	        if ( !( _.contains(validContainerTypes, containerType.toUpperCase())) ) {
	            return 'Invalid Container Type "' + containerType + '"';
	        }
	
	        if (!container.id)
	            return 'No Container ID Provided';  // message for which document ( do with DVBC-1706 )
	
	        // Could validate numeric doc id ...
	
	        var docId = currentDocRequest.docId; // Do we want to be case-sensitive here ... would be across the board ?
	
	        if (!docId)
	            return 'No Document ID Provided';
	
	        // Could check if numeric ..
	
	        // Skipping to pageIds for now ( which are optional ) ....
	        var pageIds = currentDocRequest.pageIds;
	
	        if (pageIds) {
	
	            var arrayProvided = pageIds instanceof Array;
	
	            // Be nice and allow to specific a non array to specify a single page id
	            if ( !arrayProvided) {
	                currentDocRequest['pageIds'] = [pageIds]; // (object and array are assigned by reference, so can assign to the local)
	            }
	
	            // ... could check is numeric for the items in the array, as with the other numbers
	        }
	
	    },
	
	    /*
	    * Only called from FV_enterLoggedOutMode.
	    * TODO: tear down approp data on loggedOut ...
	    * */
	    onShowLoginView: function( unauthorizedDataModel, loginError ) {
	        this.command('showLogin', unauthorizedDataModel, loginError );
	    },
	    /* Note: for FV level errors, validation errors, docInfo Req error */
	    onLoadError: function(errMsg) {
	        this.command('showLoadError', errMsg);
	    },
	    /*
	    * Source: successful user dataFetch and reset (reset passes the options param).
	    * Fetch docInfo & get necessary data from it for setting the layout (also req'd by views).
	    * ( No options if from create -- would only come from reset ).
	    * */
	    onCreate: function(options) {
	
	        if ( !this.documents || (options && options.refetchDocInfo) ) { // (for former could also derive from (options && options.fromDocChange) -- would be null on initial load (not reset)
	            /* don't init with models, will be overwritten by fetch which will create new models */
	            this.documents = new Documents();
	
	            this.documents.fetch({
	                /* fetch all -- though the active only fully 'parsed' when PARSE DATA called on the active doc */
	                docReq: this.aDocReq,
	                context: this,
	                imageFileType: this.settings.imageFileType(),
	                docModeImageWidthFn: _.bind(this.channel._requests.getDocModeImgWidth.callback, this), //Note: dynamic the width of settings.$el (max 1000)
	                allowFlashNotes: fvChannel.request('allowFlashNotes'),
	                includePageNotes: !this.settings.excludePageNotes()
	            })
	            .fail(function (jqXHR) {
	
	                // Note: not using ajaxError command -- this assumes the main layout viewer was created and it isn't
	                // TODO: unableToLoadViewerError state
	                this.triggerMethod( 'loadError', $.fn.ajaxErrorMessage(jqXHR) );
	
	            })
	            .done(
	                _.bind( this._postDocInfoFetch, this, options )
	
	            );
	        } else {
	            this._postDocInfoFetch(options);
	        }
	    },
	    /*
	    * Set activeDocument from documents, state attributes from settings, wire communication with state, fetch activeDoc data.
	    * Post docInfo fetch or onChange of document.
	    * */
	    _postDocInfoFetch: function( options ) {
	
	        var state = this.state,
	            s = this.settings;
	
	        /* was using the non active doc on change b/c this.active doc returned truthy */
	        var ad = this.activeDocument = this.documents.at(this.activeDocIndex);
	
	        this.documents.invoke( 'setPropertiesPostParse', {
	            /*
	            * Note: this never comes from docLevel vOptions -- otherwise major issues:
	            * when the settings are created, they are a mixture of the doc level and instance level ones (now with this exception).
	            * Outlines need to differentiate between instance and viewer level settings --
	            * it could change if from docReset -- we never want it to change in that case from what it was set to in the beginning.
	            * Prob want a more clear outline on setting this stuff going forward !
	            * Also note: if the # isn't within the page range, it is validated to go to the last page
	            * */
	            viewerLevelOpenToPageNumber: s.openToPageNumber()
	        });
	
	        /**
	         * Reset rotation value of pages if document was reset or if launch from 'New Window' feature (or both).
	         * ( if docInfo was re-fetched, page rotation values unsaved by the user will diverge from the db ).
	         * May only want if !options.refetchDocInfo -- but doesn't hurt to do anyway.
	         * Yes, very messy -- desperate need of a top-down a re-write
	         */
	        if ( options && options.priorDocumentCollection ) {
	
	            // First update from all documents for document mode and thumbnails
	            // Don't need to update full mode page in current workflow as it's rotation will always be set
	            // ( Always it may not yet exist yet )
	            this.documents.updatePageRotationsPostViewerReset( options.priorDocumentCollection );
	
	        } else {
	
	            var newWindowNameSpace = window[ fvChannel.request('settings').NEW_WINDOW_NAMESPACE ];
	
	            if ( newWindowNameSpace ) {
	                this.documents.updatePageRotationsPostViewerReset(  newWindowNameSpace.priorDocumentCollection );
	            }
	
	        }
	
	
	        if (this.documents.length > 1)
	            this.command('renderDocNav');
	
	
	        /* Set state defaults dependent of the settings ( note, settings may now have been overwritten depending on user perms (above; onCreate  */
	        state.set({
	            viewMode: s.viewMode(),
	            loadImages: !s.fullTextQuickView()
	            //TODO .. fullscreen, etc, as many defaults as can here as passed from state to settings
	        }, {silent: true});
	
	        /* do post setting the above attrs from settings, which will call req -- and result in err */
	        state.triggerMethod('listenToViewerChannel', this.channel);
	
	        // When may be able to get rid of this with the additional of the full text layer
	        ad.fetchData({
	            fullTextQuery: this.request('fullTextQuery')
	        }, this)
	
	        .done( function() {
	
	            /*
	            * Must set current page after pageNote collections set on individual pages.
	            * Dependency: page needs to be set for width calcs.
	            * Also sets fullpageModel (no page change) -- need to do after page notes fetched (drawing shapes)
	            * */
	            if ( ad.hasPages() ) {
	              
	                // options.pgNumberToOpenTo refers to the number to open to after a page operation
	                var pageToOpenTo = ad.getPageToOpenTo( {
	                    pgNumberToOpenTo: options && options.pgNumberToOpenTo ? options.pgNumberToOpenTo : null
	                });
	
	
	                state.goToPage( pageToOpenTo, {initialLoad: true} );
	
	                /*
	                * Necessary b/c model broken with setting being configured after setting the settings --
	                * settings would already have been merged with these
	                * */
	                var firstInstOpts = options && this.options['0'].vOptions;
	
	                /* Override page mode view setting based on page type only for the first document & if not overwritten by viewer/first viewer instance settings */
	                pageToOpenTo.isImageType()
	                    && (options && !options.fromDocChange)
	                    && (this.vOptions && !this.vOptions.pageModeScale) // ( former: this.vOptions may be undefined if called from reset ... want better handling of this.vOptions / class / workflow in general (DVBC-1649) )
	                    && (firstInstOpts && !firstInstOpts.pageModeScale)
	                    && s.set('pageModeScale', 'Best Fit');
	            
	            }
	
	            /*
	            *  Set visibility of the notes before creation of layout.
	            *  Necessary for knowing the # visible notes prior to creation of the layout.
	            *  (Notes can be filtered out from options prior to user interaction).
	            * */
	            ad.allNotes.setIsFiltered( null, {
	                fromViewerLoad: true,
	                hideActivityNotes: s.hideActivityNotes()
	            });
	
	            this._createLayout({
	                renderSubAppsCB: _.bind(this._renderComponentModules, this),
	                fromDocChange: options && options.fromDocChange,
	                prDocLayoutState: options && options.prDocLayoutState, /* (always present if fromDocChange */
	                prFullTextState: options && options.prFullTextState
	            });
	
	        })
	        .fail(function() {
	            /*
	            * TODO: indicate any failure -- and if so, don't include pieces if they should be included
	            * dealbreakers
	            * fail to load entirely if this fails
	            * */
	        });
	    },
	
	
	    /*
	    * Creation of Layout (Doc-Level) From Settings & Doc Data (and if from doc change)
	    * TODO: now put as sub view in 'view  -- old layout view really refers now to 'doc layout' ...
	    * */
	    _createLayout: function(options) {
	
	        var pages = this.activeDocument.pageCollection,
	            cssConstants = fvChannel.request('cssConstants'),
	            ad = this.activeDocument,
	            documentHasPages = ad.hasPages(),
	            state = this.state,
	            vChannel = this.channel,
	            layout = this.addSubApp('layout', {
	                subAppClass: Layout,
	                vChannel: vChannel
	            }, this.id),
	
	            includeDocumentMode = this.request('includeDocumentMode'),
	
	            viewModesView = this.addSubApp('viewModes', {  // for now just a view
	                subAppClass: ViewModesContainer,
	                vChannel: vChannel,
	                initialViewMode: this.state.viewMode(),
	                documentHasNoPages: !documentHasPages
	            }, this.id),
	
	            s = this.settings,
	            self = this,
	            ftQuery = s.fullTextQuery();
	
	            /*
	            * Some Mediation between Layout, ModeContainer, and Viewer Model --
	            * (initial render layout ensured base layout down) -- order important
	            * */
	            layout.request( 'renderLayout', this.view.getRegion('content'), {
	                notes: ad.allNotes,
	                fullTextQuery: ftQuery,
	                numberFTHits: ftQuery ? ad.fullTextModel.getNumberOfHits() : 0 //TODO: derive in layout from above ...
	            })
	            .then( function(centerRegion) {
	
	                /* ensure the viewModeView is down (content of the center panel */
	                return $.Deferred (function($dfd) {
	
	                    viewModesView.onShow = _.partial( $dfd.resolve, viewModesView );
	                    centerRegion.show( viewModesView );
	
	                });
	            })
	            .then( function() {
	
	                if ( includeDocumentMode ) {
	                    return viewModesView.request( 'renderDocContainer', pages );
	                }
	
	            })
	            .then( function( docModeView ) {
	
	                if ( !includeDocumentMode ) {
	                    return;
	                }
	
	                /* Set Doc Mode Scale (in state; from settings, cssConstans, and els rendered in docMode container view */
	                // Perhaps this could be made async now if always pass the el on the call to scale ... could do this via the API entry point
	                var docMdScale = state.setInitialScale( 'document', s.docModeScale(), cssConstants, docModeView.getElsForScaleCalc() );
	
	                /* Set Pg vOffsets from the docMode scale value */
	                // Probably want to update vOffsets whenever scale changes -- see notes 'vOffset Refactor'
	                pages.setVOffsets( docMdScale.getScaleValue() );
	
	                /** Render the Doc Mode Pages In the Container */
	                docModeView.triggerMethod('renderPages', docMdScale);
	
	                layout.command( 'renderZoomView' , docMdScale);
	
	                /*
	                * Have state listen to scale events.
	                * Note: this will cause scrolling to the current page if the page isn't the first in the document
	                * */
	                state.triggerMethod( 'listenToScaleEvents', docMdScale );
	
	            })
	            .then( function() {
	
	                return viewModesView.request('initialPgModeViewRender', {
	                    vChannel: vChannel,
	                    model: state.fullPageModel(), /* note: not yet needed until the page view within rendered */
	                    initialRender: true //(flag to not yet render image)
	                });
	
	            }).then( function( pgMdView ) {
	
	                if ( documentHasPages ) {
	
	                    var pgModeScale = state.setInitialScale( 'page', s.pageModeScale(), cssConstants, pgMdView.getElsForScaleCalc() );
	                    pgMdView.triggerMethod('setScaleModel', pgModeScale);  // if not in this mode don't bother, div's will be visible ... though doesn't hurt
	                    layout.command('renderZoomView', pgModeScale);
	                    state.triggerMethod('listenToScaleEvents', pgModeScale);
	
	
	                } else {
	                    viewModesView.command('renderNoPagesView');
	                }
	
	                viewModesView.command( 'renderPDFMode', ad.docHasNoPDFRenderablePgs() );
	
	                options.renderSubAppsCB( layout, options.prFullTextState );
	
	                /*
	                * 'Start' the layout -- what panels are showing --
	                *  Could overlap options with render (combo in layout -- could also prevent having to reset scale on viewer )
	                *  Load in document mode (eg calculations for first scale depend on panels being open / not ... (?)
	                * */
	                layout.command( 'setInitialLayout', {
	
	                    fromDocChange: options.fromDocChange,
	                    prDocLayoutState: options.prDocLayoutState,
	
	                    fullTextQuery: ftQuery,
	                    fullTextQuickView: s.fullTextQuickView(),
	
	                    docHasNotes: ad.allNotes && ad.allNotes.length > 0,
	                    docHasVisibleNotes: ad.allNotes && ad.allNotes.getNumberOfVisibleNotes() > 0,
	                    forceOpenToNotes: s.forceOpenToNotes(),
	
	                    autoDisplayIndexes: s.autoDisplayIndexes()
	
	                });
	
	
	                state.command('setViewerLoaded');
	
	            });
	    },
	    _renderComponentModules: function(layout, prFullTextState) {
	
	        this._createNotesModule(layout);  // Notes: always created even if no notes -- perhaps config option to exclude notes module
	
	        var ftModel = this.activeDocument.fullTextModel;
	        ftModel && this._createFullTextModule(layout, ftModel, prFullTextState);
	
	        // if thumbs disabled and indexesIncluded -- don't even create stuff for left panel (?)
	
	        if ( this.request('includeThumbnailsModule') ) {
	            this._createThumbnails(layout, this.activeDocument.thumbCollection);
	        }
	
	        this.request('includeIndexesModule') && this._createIndexModule(layout);
	
	        /**
	         * Note: for now requires creation of Notes Module first which establishes the Creatable Note Types.
	         * We could 'lift' the creatableNoteTypes to the viewer level and pass in to both the notes and
	         * find and redact modules --
	         * Doing so would also allow for disabling/not including the find and redact module both here and in the header.
	         * But now, regardless of the perms defining the notes users can created, you will get the module, which I think makes more sense.
	         */
	
	        this.request('includeFindAndRedactModule') && this._createFindAndRedactModule(layout);
	
	    },
	    _createNotesModule: function(layout) {
	
	        var notes = this.addSubApp('notes', {
	            subAppClass: NotesModule,
	            vChannel: this.channel,
	            notesCollection: this.activeDocument.allNotes,
	            $container: layout.request('notesEl'), //could also pass region
	            hideActivityNotes: this.settings.hideActivityNotes()
	        }, this.id);
	
	        notes.triggerMethod('render');
	
	    },
	    /* last param may be undefined (only on reset/doc change) */
	    _createFullTextModule: function (layout, fullTextModel, prFullTextState) {
	
	        var ft = this.addSubApp('fullText', _.extend( {}, {
	            subAppClass: FullTextModule,
	            fullTextModel: fullTextModel,
	            $container: layout.request('fullTextEl'),
	            currentPgNumber: this.request('currentPageNumber'),
	            vChannel: this.channel
	        }, prFullTextState) , this.id);
	
	        ft.command('render');
	    },
	    _createThumbnails: function( layout, thumbs ) {
	
	        thumbs.setVOffsets();
	
	        var thumbsContainer = this.addSubApp('thumbNails', {
	            subAppClass: ThumbnailsView,
	            collection: thumbs,
	            vChannel: this.channel
	        }, this.id);
	
	        layout.request('thumbsEl').append( thumbsContainer.render().el );
	
	        /*
	         * DVBC-1245 -- quick fix to scroll to current thumb (if its not the first page).
	         * Do here as the view must first be in the DOM.
	         * Ideally should be called in the class/view itself.
	         * Only other place I believe this is called if from goToPage.
	         * For page mode, answer is onRenderPages -> scrollToCurrentPageTop ( ultimately should do the same way ... )
	         * */
	
	        var currentPg =  this.request('currentPage');
	        if ( currentPg.get('number') > 1) {
	            this.command( 'goToThumbnail', currentPg );
	        }
	
	    },
	    _createIndexModule: function (layout) {
	
	        this.addSubApp('indexes', {
	            subAppClass: IndexesModule,
	            indexes: this.activeDocument.docIndexes(),
	            $container: layout.request('indexesEl'),
	            vChannel: this.channel
	        }, this.id);
	
	    },
	
	
	    _createFindAndRedactModule: function( layout ) {
	
	        // May want the state module on viewer.state -- then we pass it in here
	        var module = this.addSubApp('findAndRedact', {
	            subAppClass: FindAndRedactModule,
	            vChannel: this.channel,
	            el: layout.request('findAndRedactEl'),
	            creatableNoteTypesHelper: this.request('getCreatableNotesHelper'),
	            userProvidedSearches: this.request('settings').findAndRedact()
	        }, this.id);
	
	        module.render();
	
	    },
	
	    /*
	    * Distinguish from the API reset call --
	    * aDocReq and vOptions remain the same; certain setting are persisted on re-load
	    * */
	    _internalReset: function( options ) {
	        this.reset( null, null, options );
	    },
	
	    /*
	    * Reset with different docRequest and optional instanceOptions.
	    * If none passed -- the existing are used, which is always the case when internalOptions is defined.
	    * TODO:
	    *  - trigger event that makes all creation processes stop .. (or wait to created)
	    *  - when get set up, call 'fromDocChange' something more descriptive (like internalReset?)
	    *    ... reset with certain settings persisted
	    * */
	    reset: function( aDocReq, newVOptions, internalOptions ) {
	
	        // First dissallow reset if not authenticated.
	        // Besides not making sense, prevents run time errors.
	        if ( !fvChannel.request('isAuthenticated'))
	            return;
	
	
	        // TODO: name 'fromDocChange' appropriately now that there are more sources -- eg: 'fromInternalReset'
	        var DOC_CHANGE_SRCS = ['activeDocChange', 'pageDeleted', 'pageAdded', 'pageReordered'],
	            fromDocChange = internalOptions && _.contains( DOC_CHANGE_SRCS, internalOptions.src );
	
	        /* Note: el can never be overwritten for a viewer */
	        var activeDoc = this.activeDocument,
	            requestedDocMdsPgs = activeDoc.pageCollection.where({isLoaded: false, wasRequested: true}),
	            requestedThumbs = activeDoc.thumbCollection.where({isLoaded: false, wasRequested: true}),
	            fullPageModel = this.state.fullPageModel();
	
	
	        /* Cancel any impending image load requests */
	        if (requestedDocMdsPgs.length > 0)
	            _.each(requestedDocMdsPgs, function(p) { p.trigger('page:cancelLoad'); });
	
	        if (requestedThumbs.length > 0)
	            _.each(requestedThumbs, function(p) { p.trigger('page:cancelLoad'); });
	
	        fullPageModel && fullPageModel.trigger('page:cancelLoad'); //TODO: triggerOn
	
	
	        //TODO: cancel loading of PDF in PDF mode ...
	        //TODO: if note being created, warn user prior to reset
	
	        /* Store state info prior to destruction  */
	
	        var prDocLayoutState = !fromDocChange
	                ? undefined
	                : this.requestOn('layout', 'state'),
	            /*  note: none of these now configurable with vOptions, just want the last ones opened into */
	             prFullTextState = this.requestOn('fullText', 'getStateAttributesToPersistOnReset');
	
	        // Used in case coming from a page action (eg delete)
	        // Open to the current page # (add, delete) or if pgNumberToOpenTo provided, that #(reset)
	        var pgNumberToOpenTo = internalOptions && internalOptions.pgNumberToOpenTo
	            ? internalOptions.pgNumberToOpenTo
	            : this.request('currentPageNumber');
	
	
	        /**
	         * Use to reset the rotation of any pages, which can be lost on fetch ( for users who lack permission to save rotation )
	         * This is compound objects with listeners, though it shouldn't cause memory leaks since we don't store it anywhere --
	         * Potential improvement is just getting the data needed from it ( mainly the documents and their pages ) -- could put a fn on the
	         * object itself ( also used in open new window functionality ).
	         */
	        var priorDocumentCollection = this.documents;
	
	        // Do the destroy
	        // Need to reset from FV namespace, this will be gone .. (reset param or event ..)
	        this.destroy( true, fromDocChange );
	
	        /* Post - destroy */
	        if (fromDocChange) {
	
	            /*
	            * aDocReq and vOptions remain the same -- they aren't destroyed
	            * reset some state
	            * */
	            this.state.triggerMethod( 'resetFromDocChange' );
	
	            /*
	            * Set some settings to persist from the current state that may have changed since load --
	            * this should have better organization
	            * */
	            this.settings.set({
	                viewMode: this.state.viewMode()
	            }, {silent: true});
	
	            // this.activeDocument = this.documents.at(this.activeDocIndex); -- PROB WAY TO GO , BUT NOT FIXING DVBC-926
	            this.activeDocument.resetLoadStateOfAllPgs();
	        }
	        else {
	            /* from reset api call */
	            this.aDocReq = aDocReq;
	            this.vOptions = newVOptions;
	        }
	
	        var fromInteralPgOperation = internalOptions &&
	            ( internalOptions.src === 'pageDeleted' || internalOptions.src === 'pageAdded' || internalOptions.src === 'pageReordered' );
	
	        // if this gets large enough may want to make on class ( ... relooking at the process anyway)
	        var resetWfOptions = {
	            fromReset: true, //TODO: separate from fromDocChange -- just have a doc change w/out all the settings ... eg don't need to re-request the docs and settings ( ... STILL?)
	            fromDocChange: fromDocChange,
	            prDocLayoutState: prDocLayoutState,
	            prFullTextState: prFullTextState,
	            refetchDocInfo: fromInteralPgOperation,
	            pgNumberToOpenTo: fromInteralPgOperation ? pgNumberToOpenTo : null,
	            priorDocumentCollection: priorDocumentCollection
	        };
	
	
	        this.constructor.call( this, this.aDocReq, this.vOptions, resetWfOptions, this.id );
	        this.triggerMethod('create', resetWfOptions);
	    },
	
	    /*
	    *  fromReset implies called from viewer.reset
	    *  fromDocChange means called from viewer.reset called internally when changing docs in multi-doc mode
	    *  ( overriding subapp )
	    *  Note: DVBC-1581 -- want to unlock the document here if a note is being edited, but that will make the
	    *  calling fn's of this synchronous; an endeavor for another time
	    * */
	    destroy: function( fromReset, fromDocChange ) {
	
	        SubApp.prototype.destroy.call(this);
	
	        this.subApps = null; //TODO: leak here ...
	
	        // If from 'reset', don't destroy the main layout view
	        // eg: resetView always shown after region creation
	        !fromReset && this.view.destroy();
	
	        var staticsToDelete = _.keys( _.omit(instVars, 'id', 'channel') );
	
	        fromReset &&
	            ( staticsToDelete = _.omit(staticsToDelete, 'view') );
	
	        fromDocChange &&
	            (staticsToDelete = _.omit( fromDocChange, 'vOptions', 'activeDocIndex', 'aDocReq', 'documents', 'activeDocument', 'state', 'settings') );
	
	        /* Note: keys will return own properties ) */
	        _.each(staticsToDelete, function (p) {
	            Marionette.blindTriggerOn(this[p], 'destroy');
	            this[p] = null;
	        }, this);
	
	        // Only remove from the viewers array if not from reset
	        !fromReset && fvChannel.command('viewerDestroyed', this);
	
	    },
	
	
	    /**
	     * My 'public API'.
	     * Should organize this in separate file.
	     */
	    requestedEl: function() {
	        return this.vOptions.el;
	    },
	    isFullScreen: function() {
	        return this.request('fullScreen');
	    },
	    isAttached: function() {
	        var el = this.settings.el();
	        if (!el)
	            return false;
	        return Marionette.isNodeAttached(el);
	    }
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Module with channel (requests, commands, 'subscriptions' to event)
	* Initialize acts as 'start'
	* Could store on the Marionette namespace -- 'a plugin'
	* */
	
	
	var Marionette = __webpack_require__(61),
		Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49);
	
	__webpack_require__(60);
	
	
	var slice = Array.prototype.slice;
	var BR = Backbone.Radio; // Great increase in performance
	
	
	var SubApp = Marionette.Object.extend({
	    constructor: function( options, id ) { /* Name must always be unique, even if not an instance */
	
	        var options = options || {},
	            channelName =       _.result(this, 'channelName') || options.channelName || 'channel',
	            requests =          _.result(this, 'requests') || options.requests, // what to do if none ... ?
	            commands =          _.result(this, 'commands') || options.commands,
	            subscriptions =     _.result(this, 'subscriptions') || options.subscriptions, /* note: these are the 'outer' */
	            aInitParams =       options.aInitParams ? options.aInitParams : arguments; // workaround if called from or-constructor and init param different than those expected here
	
	        this.id = id;
	        this.channelName = channelName + ':' + id;
	        this.subApps = {};
	
	        /*
	        * This would be INNER -- subscriptions / publishers; NOT NECESSARY FOR OUTER B/C NEED TO PASS IN VIEW INSTANCE ANYWAY ( could fwd )
	        * Note: ability to pass in existing channel
	        * */
	        var ch = this.channel = ( options.channel ? options.channel : new Backbone.Radio.channel(this.channelName) );
	
	        /* Wiring */
	        requests && ch.reply(requests, this);
	        commands && ch.comply(commands, this);
	        Marionette.bindEntityEvents(this, ch, subscriptions);
	
	        /*
	        * This just calls init on the subject, so *** init acts like 'start' ***
	        * Do on the instance, not the prototype
	        * */
	        Marionette.Object.prototype.constructor.apply( this, aInitParams );
	
	    },
	
	    /* name same as this subApp if subapp or param id if provided */
	    addSubApp: function(name, options, id) {
	
	        var subAppOptions = _.chain(options).omit('subAppClass').extend({
	                channelName: name /* ignored if not subapp */
	            }).value(),
	            isSubApp = options.subAppClass.prototype instanceof SubApp,
	            id = id ? id : this.id, //
	            saName = name + ':' + id,
	            subApp = new options.subAppClass(subAppOptions, id); //(latter for consistent channel name; ignored for non subapp types)
	
	        //TODO: disallow 2 non sub-app instances with same id
	
	        !isSubApp && _.extend( subApp, {subAppName: saName} ); //for latter id in get w/abstraction
	
	        this.subApps[saName] = subApp; //(name no longer has id for lookup)
	
	        // For now put on Radio as channel -- this allows to use top level api -- see 'command on'
	        // Really need to call constructor to use top level radio
	        if (!(subApp instanceof SubApp)) {
	            Backbone.Radio._channels[saName] = subApp;
	        }
	        return subApp;
	
	    },
	    /**
	     * Currently  unused -- (only destroy is called).
	     * TODO: doesn't appear entirely functional -- this/equivalent could be used to determine the
	     * order in which subApps are destroyed instead of just the destroy method -- see DVBC-1790.
	     */
	    removeSubApp: function(name) {
	        var sa = this.subApps[name];
	        sa.destroy();
	        delete sa;
	    },
	    getSubApp: function(name) { /* really the 'base name' */
	
	          var sa = this.subApps[name + ':' + this.id ]; // ahh wont work ? name + ':' + this.id : name
	          if (sa)
	              return sa;
	
	         var id = _.chain(this.subapps)
	            .filter(function(a) { return a.saName !== undefined;})
	            .find(function(a) { return a.saName.indexOf(name + ':') > -1; }).value();
	   
	         return this.subApps[name + ':' + id]; // TODO: cache
	
	    },
	    /*
	    * Makes is so modules don't need to exist
	    * TODO: what if call off same subapp ?
	    * */
	    command: function() {
	        var ch = this.channel;
	        return ch.command.apply(ch, arguments);
	    },
	    request: function() {
	        var ch = this.channel;
	         return ch.request.apply(ch, arguments);
	    },
	    /* trigger off the channel */
	    trigger: function() {
	        var ch = this.channel;
	        return ch.trigger.apply(ch, arguments);
	    },
	    /*
	    * Blind trigger but turn the targets into subApp shortcuts -- for showing intent.
	    * TODO: wanted? not currently used (only Marionette.blindTriggerOn currently called): -- needs testing ...
	    * */
	    blindTriggerOn: function(target, name) {
	
	        if (!target)
	            return;
	
	        var args = Array.prototype.slice.call(arguments, 1); /* includes name and any arguments passed */
	        if (target instanceof Array) {
	            _.each(target, function(t) {
	                t && t.triggerMethod && t.triggerMethod.apply(t, args);
	            });
	        } else {
	            target.triggerMethod && target.triggerMethod.apply(target, args);
	        }
	    },
	    /*
	    * Like Backbone.Radio top level API applied to the app --
	    * a command from the app to one of its subapps forward.
	    * allows for calling on subapp like event and not getting error, if the subapp doesn't exist.
	    * If subAppName is array, it will call on all the subapps.
	    * Good for showing which subapps it's applied so don't have to debug all the listeners -- shows the intent w/out error.
	    * */
	    commandOn: function(subAppName, method) {
	        var args;
	        if (subAppName instanceof Array) {
	           args = slice.call(arguments, 1);
	            _.each(subAppName, function(saName) {
	                if (this._subAppExists(saName))  /* if doesn't exist, don't want added to BB radio top level API */
	                    BR.command.apply(BR, [].concat(saName + ':' + this.id, args));
	            }, this);
	            return;
	        }
	        if (!this._subAppExists(subAppName)) return false;
	        args = slice.call(arguments, 2);
	        args.unshift(subAppName + ':' + this.id, method);
	        return BR.command.apply(BR, args); //lowers performance
	    },
	    requestOn: function(subAppName, method) {
	
	        if (!this._subAppExists(subAppName))
	            return false;
	
	        var args;
	
	        if (subAppName instanceof Array) {
	            args = slice.call(arguments, 1);
	            _.each(subAppName, function(saName) {
	                if (this._subAppExists(saName))
	                    BR.request.apply(BR, [].concat(saName + ':' + this.id, args));
	            }, this);
	            return;
	        }
	
	        if (!this._subAppExists(subAppName))
	            return false;
	
	        args = slice.call(arguments, 2);
	        args.unshift(subAppName + ':' + this.id, method);
	        return BR.request.apply(BR, args); //lowers performance
	
	    },
	    _subAppExists: function(subAppName) {
	        return _.contains( _.keys(this.subApps), subAppName + ':' + this.id);
	    },
	    destroy: function() {
	
	        this.triggerMethod('beforeDestroy');
	        this.channel.reset();
	        _.invoke(this.subApps, 'destroy'); //trigger in case not a subapp with destroy
	
	    }
	
	    // TODO: destroy all its subapps/modules ...
	});
	
	
	
	module.exports = SubApp;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Util = __webpack_require__(48),
	    _ = __webpack_require__(49);
	
	/*
	* Store for settings and validation of user parameters.
	* Not a Server Model
	* */
	
	module.exports = Backbone.Model.extend({
	
	    validImgFileTypes: ['JPG', 'JPEG', 'GIF', 'PNG', 'BMP'], /* note: those that can be rendered in the browser; also used to derived if page is 'imageType' */
	
	    /* those presented to the user */
	    docModeScaleValues: { /* label, scale value */
	        Auto: 'Auto',
	        'Fit Width': 'Fit Width',
	        'Fit Height': 'Fit Height'
	    },
	    pageModeScaleValues: { /* label, scale value */
	        'Best Fit': 'Best Fit',
	        'Fit Width': 'Fit Width',
	        'Fit Height': 'Fit Height',
	        '50%': 0.50,
	        '75%': 0.75,
	        '100%': 1.00,
	        '125%': 1.25,
	        '150%': 1.50,
	        '200%': 2.00,
	        'Dot For Dot': 1.00
	    },
	
	    maxDocWidth: 1000, /* note: only applicable to document */
	
	    zoomIncrement: 0.10, /* for zoom in / zoom out -- for now, not able to be over written -- not an attr */
	    minScale: 0.25, //note: now only applicable to zoom in / zoom out
	    MIN_IMG_SCALE: 0.02, //(not work the user can set, but the smallest a resize can set the image to) -- TODO: combo with minScale ...(zoom increment)?
	
	    viewModes: ['document', 'page', 'pdf'], //array possible modes
	    minimumWidth: '300px', //(for layout resize purposes)
	
	    MAX_NUM_IMAGES_TO_LOAD: 3,
	    IMAGE_LD_FAIL_CHECK_TIME: 5000, // note: currently unused
	
	    /*
	    * See: http://git.feith.com/projects/ENG-CRE/repos/central-rendering-engine/browse/central-rendering-engine-service/src/main/resources/META-INF/cre-file-extensions.xml
	    * Note: accessed from the prototype, not vChannel
	    * */
	    renderableFileExts: [ 'PDF', 'JPG', 'JPEG', 'GIF', 'TIF', 'TIFF', 'PNG', 'BMP',
	        'DOC', 'DOCX', 'XLS', 'XLSX', 'XLSB', 'XLSM', 'PPT', 'PPTX', 'PPTM',
	        'TXT', 'RTF', 'EML', 'XPS', 'MSG', 'MPP', 'VSD', 'HTML', 'HTM', 'XHTML' ],
	
	    // TODO: facades for the prototype 'default' settings
	
	    defaults: {
	
	        el: null, /* the element holding the viewer -- NOTE: necessary for setting the derived height of pages, if not provided it's set to 'body' */
	        fullScreen: false, /* true if no el provided, (also case when opened popup -- TODO: logical separate w/ attr in viewer model ( note: this now stored on there */
	
	        viewMode: 'document', //the mode to start the viewer in (if none provided, defaultViewMode of globalSettings)
	        imageFileType: 'jpg',
	
	        docModeScale: 'Auto',
	        pageModeScale: 'Fit Width', /* Note: this is the default overall but is dependant on the page type (if isImageType -- best fit) */
	
	        /* eventHooks */
	        onLoad: null,
	
	        fromReset: false, //TODO: rid?
	
	        hideIndexes: false,
	        autoDisplayIndexes: true,
	        forceOpenToNotes: null,
	
	        excludePageNotes: false,
	        hideActivityNotes: true,
	
	        fullTextQuery: null,
	        fullTextQuickView: false,
	        createNewRedactionOnEntry: false,
	
	        disableDocMode: false,
	        pdfOnly: false,
	        singlePageOnly: false,
	        disableThumbs: false, //don't include thumbnails
	
	        openToPageNumber: 1,
	
	        findAndRedact: null,
	
	        singularViewMode: false //TODO: not yet used but use to replace pdf only
	    },
	
	    /**
	     * Options are user provided -- note -- they are required (only called from viewer)
	     * These should really be referred to as attributes as this is a Backbone model
	     * ( and are already set in the contructor )
	     */
	    initialize: function(options) {
	
	
	
	
	        /**
	         * Store a copy of the original, 'non overwritten' options.
	         * Will come into play with updatePostUserFetch ( DVBC-1718 - update, this is no longer used )
	         * DVBC-1718 - no longer user but leave in place in case necessary in the future,
	         * where implemented for DVBC-1711
	         */
	        this.originalOptions = _.clone(options);
	
	        var o = options;
	
	        /**
	         * Setting Dependent -- Can Be Over-Written
	         * Over-Writing Defaults if logic not directly based on the option property,
	         * also set other settings based on the params
	         */
	        this.set( _.extend( o, {
	            fullScreen: !o.el || o.el.nodeName === "BODY" /* latter necessary because el set prior to this init call */
	        }));
	
	        /**
	         * Silent validations: when invalid, set it to the defaults, allowing viewer to load without failure
	         * Do more organization when tackle DVBC-1246 ... eg this is verbose -- could do in first extend, etc
	         *  Another check done prior to docInfo fetch to see if the number exists.
	         */
	
	        this.set({ openToPageNumber: this.getValidatedOpenToPageNumber( o.openToPageNumber ) });
	
	        /* Overriders */
	
	        o.pdfOnly && this.set({
	            viewMode: 'pdf',
	            excludePageNotes: true,
	            pdfOnly: true,
	            disableThumbs: true
	        });
	
	        o.singlePageOnly && this.set({
	            singlePageOnly: true,
	            viewMode: 'page',
	            pdfOnly: false
	        });
	
	        o.disableDocMode && this.set({
	            disableThumbs: true,
	            viewMode: (this.viewMode() === 'document') ? 'page' : this.viewMode()
	        });
	
	        // Disallow fullTextQuickView if fullTextQuery is not provided as an option (use string to allow empty search search, if not provided will be undefined)
	        (o.fullTextQuickView  && typeof o.fullTextQuery !== 'string') && this.set({
	            fullTextQuickView: false
	        });
	
	        this.get('fullTextQuickView') && this.set({ //(builds off above)
	            fullTextQuickView: true,
	            autoDisplayIndexes: false,
	            forceOpenToNotes: false
	        });
	
	        o.createNewRedactionOnEntry && this.set({
	            viewMode: 'page',
	            excludePageNotes: false,
	            pdfOnly: false,
	            forceOpenToNotes: true,
	            fullTextQuickView: false
	        });
	
	
	        if ( o.findAndRedact ) {
	
	            this.set({
	                viewMode: 'page',
	                excludePageNotes: false,
	                autoDisplayIndexes: false,
	                pdfOnly: false,
	                fullTextQuickView: false
	            });
	        }
	
	
	        //TODO: implement this -- not now due to breaking existing API(?)
	        /*
	         - singularViewMode (optional)
	         - default: false
	         - if true, hides entry points to enter view modes other than the given (or default) viewMode (still created for time being)
	         - if viewMode is 'pdf', excludePageNotes set to true
	         - fvs.singluarViewMode
	         * */
	    },
	
	
	    /* returns array of err messages or empty array */
	    checkOptionalParams: function() { 
	
	        //TODO: ACTIVE DOC INDEX (?)...
	        var aErrors = [],
	            s = this.attributes;
	
	        /* NOTE: THIS CHECKED AFTER SET -- IF NOT PROVIDED IS THAT OF FV BUT CAN BE SET TO AN INVALID ONE */
	        if ( s.imageFileType && !_.contains( this.validImgFileTypes, s.imageFileType.toUpperCase() ) ) { 
	            aErrors.push( s.imageFileType.toUpperCase() + ' is not a valid image file type.');
	        }
	
	        //leave room for more...
	        return aErrors.join('x').replace('x', '<br>');  //put a linebreak in html format
	    },
	
	    hideIndexes: function() {
	        return this.get('hideIndexes');
	    },
	    fullTextQuery: function() {
	        return this.get('fullTextQuery');
	    },
	    fullTextQuickView: function() {
	        return this.get('fullTextQuickView');
	    },
	    forceOpenToNotes: function() {
	        return this.get('forceOpenToNotes');
	    },
	    autoDisplayIndexes: function() {
	        return this.get('autoDisplayIndexes');
	    },
	    disableThumbs: function() {
	        return this.get('disableThumbs');
	    },
	    excludePageNotes: function() {
	        return this.get('excludePageNotes');
	    },
	    fullScreen: function() {
	        return this.get('fullScreen');
	    },
	    viewMode: function() {
	        return this.get('viewMode');
	    },
	    createNewRedactionOnEntry: function() {
	        return this.get('createNewRedactionOnEntry');
	    },
	    el: function() { //translates to container (in channel)
	        return this.get('el');
	    },
	    imageFileType: function() {
	        return this.get('imageFileType');
	    },
	    docModeScale: function() {
	        return this.get('docModeScale');
	    },
	    pageModeScale: function() {
	        return this.get('pageModeScale');
	    },
	    hideActivityNotes: function() {
	        return this.get('hideActivityNotes');
	    },
	    pdfOnly: function() {
	        return this.get('pdfOnly');
	    },
	    singlePageOnly: function() {
	        return this.get('singlePageOnly');
	    },
	    disableDocMode: function() {
	        return this.get('disableDocMode');
	    },
	    openToPageNumber: function() {
	        return this.get('openToPageNumber');
	    },
	
	    findAndRedact: function() {
	      return this.get('findAndRedact');
	    },
	
	    getValidatedOpenToPageNumber: function(pgNum) {
	
	        var defaultNum = this.defaults.openToPageNumber;
	
	        //check undefined in case 0 provided
	        if (pgNum === undefined)
	            return defaultNum;
	
	        //this is valid: once pages are known, it will be set to the last page number
	
	        if (pgNum === 'last')
	            return pgNum;
	
	        if (Util.isIntegerGreaterThanZero(pgNum))
	            return pgNum;
	
	        return Util.isIntegerGreaterThanZero(pgNum) ? pgNum : defaultNum;
	    }
	});
	
	
	


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    API = __webpack_require__(101),
	    Marionette = __webpack_require__(61),
	    DocLockState = __webpack_require__(103);
	
	__webpack_require__(60);
	
	
	/**
	 * Mixing in API.function allows forwarding of fns from API requests, responses to here
	 * Left-Over from Main Point of functionality in older version, incorporated here
	 */
	
	var API = new API();
	
	module.exports = Backbone.Model.extend( _.extend({
	
	    defaults: {
	
	        currentPage: null, // start null in case no pages in document
	        fullPageModel: null, //aways created on page change from currentPage (docMode) change
	
	        activeNote: null,  // trigger's 'edit' mode for pgNotes
	        activeNoteSubType: null,  // eg 'rect' or 'poly' --> could be taken off here
	
	        documentLockState: new DocLockState(), // flag indicating the Document was locked by this application and the source(s) of the lock
	
	        expandedNote: null,    //in page mode: when changing page on an edit -- only fire when this is true
	        viewMode: '',
	
	        /* note: not reset on doc change*/
	        documentViewScale: null, // not may not always exist: eg if we don't include doc mode from setting/series of them
	        pageViewScale:  null,  //  a reference to the pgModel in page mode -- needed for reloading images on loading in: also: a change sets the model for the View
	
	        numberImagesLoadingInDocMode: 0, //NOTE: NOW JUST flag so that not more than a certain number of images can load at a time (settings) checked in prefetch
	            //todo: set on init from actual settings
	            //todo: not preventing on load not being set
	
	        /* triggers */
	        fullScreenMode: false,  //TODO: layout
	        loadImages: true, //flat: if set to false (eg from fullTextQuickView setting), will disallow loading of images (toggle again when no longer 'covering')
	
	        paneIsCoveringLayout: false, //would really only apply on entry -- todo: put on layout?, note: changed w/toggle load images
	        panelIsResizing: false, /* true if user is resizing the panels -- toggles allowing note view hovers (and thus shape highlights */
	
	        viewerLoaded: false, /* needs to be reset on doc change; here, really implies viewerLoaded for active document; UPDATE: really mains 'LAYOUT' loaded in the main WF( vs logged out mode ); should change name accordingly */
	        pdfRendered: false, //store whether the PDF has already been rendered; set to false if want to reload pdf on reentry into mode (eg: rotation)
	
	        showPageTextMode: 0,
	
	        textOnlyMode: false,
	
	        findAndRedactSearchModel: null
	
	    },
	    /* applied to channel events */
	    events: {
	        'change:viewerLoaded':          'viewerLoaded',
	
	        'change:activeNote':            'changeActiveNote',
	        'change:activeNoteSubType':     'changeActiveNoteSubType',
	        'change:currentPage':           'changeCurrentPage',
	        'change:expandedNote':          'changeExpandedNote',
	        'change:viewMode':              'changeViewMode',
	
	
	        'change:loadImages':            'toggleLoadImages',
	
	        //TODO: to layout
	        'change:fullScreenMode':        'toggleFullScreenMode',
	        'change:panelIsResizing':       'panelResizingChange',
	
	        'change:showPageTextMode':      'togglePageTextMode',
	        'change:textOnlyMode':          'toggleTextOnlyMode'
	
	    }, /* applied to channel events */
	    scaleEvents: {
	        'change:scale':         'scaleChange',
	        'change:scaleType':     'scaleTypeChange'
	    },
	    initialize: function() {
	        _.bindAll(this, 'setScale');
	    },
	    /* now must be done post init */
	    onListenToViewerChannel: function(vCh) {
	        this.vChannel = vCh; //(need ref for now b/c 'api' cxt is state)
	        /* forward to channel -- already stored on channel file pre load of state model */
	        this.on('all', function() {
	            vCh.trigger.apply(vCh, arguments); //though cxt overwritten to the viewer (see subap)
	        });
	        /* forward radio methods to channel */      //TODO: mixin
	        _.each(['trigger', 'command', 'request', 'commandOn', 'requestOn'], function(action) {
	            this[action] = function() {
	                return vCh[action].apply(vCh, arguments);
	            };
	        }, this);
	    },
	
	    /**
	     * (Scale models must first be initialized)
	     * change:scale change:scaleType -- don't really need scale events
	     * trigger cxt could be overwritten to the viewer (see subap)
	     */
	    onListenToScaleEvents: function(scaleModel) {
	
	        var vCh = this.vChannel;
	        this.listenTo(scaleModel, 'all', function() {
	            vCh.trigger.apply( vCh, arguments );
	        });
	
	    },
	
	    onResetFromDocChange: function() {
	
	        this.set({
	            viewerLoaded: false,
	            pdfRendered: false,
	            activeNote: null, //in case not prevented on change
	            expandedNote: null
	        }, {silent: true});
	
	
	    },
	
	    // TODO: get all bbprops in helper ...
	    onDestroy: function() {
	
	        var attrs = _.toArray(
	
	            _.pick( this.attributes, 'documentViewScale', 'pageViewScale', 'currentPage', 'fullPageModel',
	                'activeNote', 'expandedNote', 'findAndRedactSearchModel'
	            )
	        );
	
	        Marionette.blindTriggerOn(attrs, 'destroy');
	
	        this.clear({silent: true});
	        this.stopListening(); //scale model
	        this.off();
	    }
	
	}, API.commands, API.requests));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var _ = __webpack_require__(49),
	    ScaleModel = __webpack_require__(102),
	    Util = __webpack_require__(48);
	
	/*
	* Pre-Making of the state change
	* Context is state -- added to the commands of the vChannel, 'autofowarded from channel'
	* need instance -- use constructor
	* */
	
	module.exports = function() {
	
	    _.extend( this, { commands: {
	        /*
	        * Entry point for activeNote change --
	        * Will spur mode and/or page change logic after when appropriate.
	        * Handles document locking/unlocking.
	        * */
	        setActiveNote: function( note, options ) {
	
	            var entering = note;
	
	            if ( entering ) {
	
	                if ( !note.isPageNote() ) {
	                    setActiveActiveNote.call(this);
	                    return;
	                }
	
	                // Page Note
	                if ( options.createNote || options.isEdit ) { // wouldn't this always be true?
	
	                    /*
	                     * LockSuccessCB: Set a flag that the document is locked for entering page note editing.
	                     * Facilitates checking the need to clear the lock on exit of edit mode, and clearer than checking
	                     * various options that would lead to need to unlock the document. ( eg: options.noteSaved )
	                     * Can also be picked up on to clear the locks on actions like window unload and session timeout.
	                     * Note: doesn't hurt to call lock again if in find and redact mode ...
	                     * */
	                    this.command( 'lockActiveDocument', 'PG_NOTE_EDITING', options.createNote ? 'Create Note' : 'Edit Note', _.bind(function() {
	
	                        if ( note.isDrawable() ) {
	
	                            // Here is where we need to 'wait' ....
	                            // Could create pageMode view twice ...
	                            if ( this.viewMode() !== 'page') {
	                                this.setViewMode('page'); // maybe with option not to do the canvas?
	                            }
	
	                            if ( !note.isNew() && note.pageNumber !== this.currentPageNumber() ) {
	                                this.goToPageOfNote(note); // maybe just make setting rendering the currentPageMode page empty here ... or put in a callback as an option to set the activeNote
	                            }
	
	                        }
	
	                        setActiveActiveNote.call(this);
	
	                    }, this));
	                }
	
	
	            } else {
	
	
	                // Exiting: note param will be undefined so get from state before we set it back.
	                // Only unlock the document if the note being edited came from a note that was locked; easier than checking conditions to get in here --
	                // latter I don't understand anymore
	                var exitingNote = this.request('activeNote');
	
	                if ( !exitingNote.isPageNote() || !this.getDocumentLockState().isLockedByPageNoteEditing() ) {
	                    setActiveActiveNote.call( this );
	                    return;
	                }
	
	
	                // For status messages/errors, the below will show warnings, not alerts until multiple alert dialogs supported (DVBC-1572).
	
	                this.command( 'unlockActiveDocument', 'PG_NOTE_EDITING', 0, this, function() {
	
	                    setActiveActiveNote.call(this);
	
	                });
	
	            }
	
	
	
	            // The active note part:
	            // - currently not using a callback/deferred to run after page &/or mode change
	            // - in those scenarios, the canvas (and page) will always be rendered in active/expanded 'mode' on
	            // - page image load, so if this called before the canvas/page is ready, we don't have a problem.
	            function setActiveActiveNote() {
	
	                if (entering) {
	
	                    if ( note.isDrawable() ) {
	
	                        // Don't trigger activeNoteSubType; more cleanup necessary see graphicNoteShape toolbar code ( could be set twice in this workflow)
	                        // Perhaps store on the noteUI model and listen from there
	                        this.set( 'activeNoteSubType', note.getDefaultShapeSubType(), {silent: true} );
	
	                    }
	
	                    this.set({ activeNote: note } , options );
	
	                } else {
	
	                    this.set( {activeNoteSubType: null}, {silent: true} );
	
	                    this.set( {activeNote: null }, options );
	
	                }
	
	            }
	
	
	        },
	
	        /**
	         * API calls of mode, page called here before the expanded note
	         * If drawable and entering, go to approp. mode and pg before triggering canvas.
	         * Note: if changing mode / page the expanded note event may not yet be ready --
	         * when those are called the canvas may not yet be ready to pick up the change event ... however,
	         * onRender on the canvas the expanded note is incorporated, so we don't need to worry about race conditions.
	         * An alternative would be setting a canvasOnLoad event 'flag' from the bottom up -- it's an async process,
	         * and then setting the notes as a callback.
	         */
	        setExpandedNote: function(note) {
	
	            // ( Only drawable notes allow expanding )
	            var enteringAndDrawable = note && note.isDrawable(),
	                notInPgMode = this.viewMode() !== 'page';
	
	            enteringAndDrawable && notInPgMode && this.setViewMode('page');
	
	            enteringAndDrawable && ( note.pageNumber !== this.currentPageNumber() ) &&
	                this.goToPageOfNote(note);
	
	            this.set('expandedNote', note);
	
	        },
	
	        setViewMode: function(mode) {
	
	            var activeNote = this.activeNote();
	
	            if ( !activeNote || !activeNote.isDrawable() ) {
	                this.set('viewMode', mode);
	                return;
	            }
	
	
	            this.trigger('modal:open', {
	                confirmType: 'warning',
	                title: 'Confirm',
	                content: 'Change view mode without saving note?',
	                okCB: _.bind(function () {
	
	                    // Clean up the active note prior to changing the mode -- give same options as cancelling from the note module
	                    // Nothing sync about exiting
	                    this.setActiveNote( null, {
	                        userCancelled: true,
	                        isEdit: !activeNote.isNew()
	                    });
	
	                    this.set({
	                        viewMode: mode
	                    });
	
	                }, this)
	
	            });
	
	
	        },
	        goToPage: function(page, options) {
	
	            var activeNote = this.activeNote();
	
	            if ( !activeNote || !activeNote.isDrawable() ) {
	                this.set({currentPage: page}, options);
	                return;
	            }
	
	              //if in drawing mode, alert user prior to changing page that notes will be deleted
	            this.trigger('modal:open', {
	                confirmType: 'warning',
	                title: 'Confirm',
	                content: 'Change page without saving note?',
	                okCB: _.bind( function() {
	
	                    // Destroying the canvas first should be sync and fine
	                    // ( Same as mode change with an active note open )
	                    this.setActiveNote( null, {
	                        userCancelled: true,
	                        isEdit: !activeNote.isNew()
	                    });
	
	                    this.set({
	                        currentPage: page
	                    }, {
	                        isEdit: activeNote && !activeNote.isNew() // can probably rid this
	                    });
	
	                }, this),
	                actionBtn: 'Yes',
	                cancelBtn:  'No'
	            });
	
	        },
	        goNextPage: function () { //nav command and api
	            var nextPage = this.nextPage();
	            nextPage && this.goToPage(nextPage);
	        },
	        goPrevPage: function () {
	            var prevPage = this.prevPage();
	            prevPage && this.goToPage(prevPage);
	        },
	        goToFirstPage: function () {
	            var firstPage = this.vChannel.request('activeDocPages').first(); //todo: first page fn
	            firstPage && this.goToPage(firstPage);
	        },
	        goToLastPage: function () {
	            var lastPage = this.vChannel.request('activeDocPages').last();
	            lastPage && this.goToPage(lastPage);
	        },
	        goToPageOfNote: function(note) {
	            this.goToPage( note.getPageModel() );
	        },
	        goToPageId: function(pageId) {
	
	            var page =
	                this.vChannel.request('activeDocPages').findWhere({ pageId: pageId });
	
	            page && this.goToPage(page);
	
	        },
	
	
	        /**
	         * * SCALE: the first time, must set scale to calc the value immediately after scale created
	         *  -- call must go through here, not scale model
	         *  All see listenToScaleEvents -- want ignored initially
	         */
	
	        setInitialScale: function( which, defaultScale, cssConstants, viewModeEls ) {
	
	            var scaleModel = new ScaleModel({
	                scale: defaultScale,
	                DEFAULT_SCALE: defaultScale,
	                mode: which,
	                V_PADDING: cssConstants.V_PADDING || 0, // temp until read css from markup
	                H_PADDING: cssConstants.H_PADDING || 0,
	                outerDiv: viewModeEls.outerDiv
	            });
	
	            this.set( which + 'ViewScale', scaleModel );
	
	            var pageForScale = which === 'document'
	                ? this.currentPage()
	                : this.fullPageModel();
	
	            scaleModel.setScale( pageForScale );
	
	            return scaleModel;
	
	        },
	
	        /**
	         * Set the scale of the current mode (CENTRAL ENTRY POINT)
	         * TODO: except in above, FS MODE TOGGLE CB, reset of size of gos renderable, and layout pane open/close)
	         * above old comment similar to issue is DVBC-1408
	         * In many ways acts like an 'update viewport' now for doc and page mode containers
	         */
	        setScale: function() {
	
	            var scaleModel = this.getCurrentScaleModel(),
	                viewMode = this.viewMode(),
	                pdfMode = !scaleModel;
	
	            if ( pdfMode || this.vChannel.request('activeDocPages').length < 1 ) //TODO: cache/optimize has pages
	                return false;
	
	            var pg = viewMode === 'document' ? this.currentPage() : this.fullPageModel(),
	                args = Array.prototype.slice.apply(arguments); // TODO: cache
	
	            args.unshift(pg);
	            scaleModel.setScale.apply(scaleModel, args); //slowest if custom args, could optimize
	
	
	        },
	
	        zoomIn: function () {
	            if  (this.get('paneIsCoveringLayout'))
	                return false;
	            var newScale = parseFloat(this.getCurrentScaleValue() + this.vChannel.request('zoomIncrement')).toFixed(2);
	            newScale = Math.ceil(newScale * 10) / 10; //make it pretty
	            this.setScale(newScale, 'custom');
	        },
	        zoomOut: function () {
	            var MIN_SCALE = this.vChannel.request('minScale');
	            if  (this.get('paneIsCoveringLayout'))
	                return false;
	            var newScale = parseFloat(this.getCurrentScaleValue() - this.vChannel.request('zoomIncrement')).toFixed(2);
	            newScale = Math.floor(newScale * 10) / 10; //make it pretty
	            if (newScale < MIN_SCALE)  newScale = MIN_SCALE; //don't allow below 25%
	            this.setScale(newScale, 'custom');
	        },
	        /* decrease by one after image loads -- todo: queue */
	        updateImgsLoadingDocMode: function(options) {
	            var d = options.increase ? 1 : -1;
	            this.set('numberImagesLoadingInDocMode', this.numberImagesLoadingInDocMode()+ d );
	        },
	        toggleFullScreenMode: function() {
	            this.toggle('fullScreenMode');
	        },
	        setPDFisLoaded: function() {
	            this.set('pdfRendered', true);
	        },
	        setViewerLoaded: function() {
	            this.set('viewerLoaded', true);
	        },
	        setPanelIsResizing: function(val) {
	            this.set('panelIsResizing', val);
	        },
	
	
	        /*
	         * *** Central point to lock the document -- all calls must come through here ***
	         * Same WF as vChannel.checkActiveDocLockStatus, though obtain the lock without checking first.
	         * If unsuccessful the document was already locked by another user.
	         * lockSource ( required ):
	         * - docLockState.lockSource ( use to resolve 'conflicts' locking and unlocking
	         *      -- eg if locked by PG_NOTE_EDITING and then FIND_AND_REDACT )
	         * - added to docLockState.lockSource after successful web service call
	         * - also added if document is already locked by another source; here we don't we to call the web-service again
	         * action: required -- Action name used in error dialogs
	         * lockSuccessCB: required -- fn to proceed if document successfully locked in db call
	         * docLockedByOtherUserCB: optional -- fn to call if the document was locked by another user. Default is showing an alert (prevent the action).
	         * errorCB: optional -- function to call if error occurs hitting the endpoint.  Default is showing an alert (prevent the action).
	         * */
	        lockActiveDocument: function( lockSource, action, lockSuccessCB, docLockedByOtherUserCB, errorCB ) {
	
	            // First check any cases where we wouldn't want call the webservice:
	            // exit with a lockSuccessCB to continue without a docLockResponse parameter.
	            var docLockState = this.request('getDocumentLockState');
	
	            // If for some reason, we're locked by lockSource, don't lock again
	            // ( eg, 're-search from Find and Redact' )
	            if ( docLockState.isLockedBySource( lockSource ) ) {
	                lockSuccessCB.call( this );
	                return;
	
	            }
	
	            // Add lockSource without calling the webservice if document is already locked by another source
	            if ( docLockState.isLockedByOtherSource( lockSource )  ) {
	                docLockState.addLockSource( lockSource );
	                lockSuccessCB.call( this );
	                return;
	            }
	
	            // Document is unlocked: make the call and if successful, add the lockSource to docLockState
	
	            var shortErrMsg = 'Cannot ' + Util.toTitleCase(action);
	
	            this.request('activeDocument').lock( this )
	                .done( function( docLockResponse ) {
	
	                    // Successful lock -- proceed
	                    if ( docLockResponse.getSuccess() ) {
	
	                        docLockState.addLockSource( lockSource );
	
	                        lockSuccessCB.call( this, docLockResponse );
	
	                    }
	                    // Failure: someone else has the document locked
	                    else {
	                        docLockedByOtherUserCB
	                            ? docLockedByOtherUserCB.call(this, docLockResponse)
	                            : this.command( 'showDocumentLockedErrorAlert', shortErrMsg, docLockResponse );
	                    }
	
	                })
	                .fail( function( jqXHR ) {
	                    errorCB
	                        ? errorCB.call(this, jqXHR)
	                        : this.command('ajaxError', jqXHR, shortErrMsg );
	                });
	
	        },
	
	
	        /*
	         * *** Central point to unlock the document -- ** all calls must come through here ***
	         * Wrapper around unlocking the document with common defaults to perform,
	         * assuming we don't want to really show success/failure messages prominently to the user:
	         * write msg's via console.info on success and console.warn msg's on unsuccessful/failure.
	         * All parameters optional expect lockSource ( docLockState.lockSource ) and alwaysCB
	         * - like lockDocument, if there are any conflicts, exit with the alwaysCB callback ( maybe change to success to match lock command )
	         * - if performed, the state's lockSource is unset on a successful call
	         * Utilize the alwaysCB for an action to take place afterwards on success/error ( jqXHR callbacks are run in the order they are defined ).
	         * Now called from exit active note change, was to be called on viewer.destroy (DVBC-1581).
	         * */
	        unlockActiveDocument: function( lockSource, force, cxt, alwaysCB, unlockSuccessCB, docLockedByOtherUserCB, errorCB ) {
	
	            // First check any cases where we wouldn't want to call the web service to unlock the document;
	            // If so, exit with an alwaysCB to continue ( without a docLockResponse parameter ).
	
	            var docLockState = this.request('getDocumentLockState');
	
	            // Don't unlock if already unlocked -- just in case -- it's not necessary ( no src's would be set )
	            if ( docLockState.isNotLocked() ) {
	                alwaysCB.call( cxt );
	                return;
	            }
	
	            // If locked by another source, remove this source without unlocking the document.
	            if ( docLockState.isLockedByOtherSource( lockSource ) ) {
	
	                docLockState.removeLockSource( lockSource );
	                alwaysCB.call(cxt);
	                return;
	            }
	
	            // Make the call and if successful, set lockSource to docLockState ( can change isLocked ).
	
	            force = force || 0;
	            cxt = cxt || this;
	
	            this.request('activeDocument').unlock( force, cxt )
	                .done( function( docLockResp ) {
	
	                    if ( docLockResp.getSuccess() ) {
	
	                        docLockState.removeLockSource( lockSource );
	
	                        unlockSuccessCB
	                            ? unlockSuccessCB.call( cxt, docLockResp )
	                            : console.info( 'Document ' + docLockResp.getDocId() + ' unlocked.' );
	
	                    } else {
	
	                        docLockedByOtherUserCB
	                            ? docLockedByOtherUserCB.call( cxt, docLockResp )
	                            : console.warn( 'Unable to unlock document. ' + docLockResp.getDefaultErrorMessage() );
	
	                    }
	
	                })
	                .fail( function( jqXHR ) {
	                    errorCB
	                        ? errorCB
	                        : console.warn( 'Unable to unlock document. ' +  $.fn.ajaxErrorMessage(jqXHR) );
	
	                })
	                .always( function( docLockResp ) {
	                    if (alwaysCB)
	                        alwaysCB.call( cxt, docLockResp );
	
	                });
	
	        },
	
	
	        // TODO: now disabled, not in use ...
	        toggleShowPageTextMode: function() {
	            this.toggle( 'showPageTextMode' );
	        },
	
	        toggleTextOnlyMode: function() {
	
	            //console.log( 'toggleTextOnlyMode' );
	
	            // must show the text, do this first here; do first and by force
	            //this.set( 'showPageTextMode', null, {silent: true} );
	            //this.set( 'showPageTextMode', true );
	
	            this.toggle( 'showPageTextMode' );
	
	            this.toggle( 'textOnlyMode' );
	        }
	
	    }});
	
	    /* single point of access for the prop's -- note: sometimes properties them */
	    _.extend(this, { requests: {
	        currentPage: function () {
	            return this.get('currentPage');
	        },
	        currentPageNumber: function () {     //return the current page or null if no pages in document
	            var curPg = this.currentPage(); //here in case no pgs in doc
	            return curPg ? curPg.get('number') : null;
	        },
	        nextPage: function(pg) {
	            var currentPg = pg || this.currentPage(),
	                pages = this.vChannel.request('activeDocPages'),
	                currengPgIndex = pages.indexOf(currentPg);
	            return (currengPgIndex < pages.length) ? pages.at(currengPgIndex + 1) : null; //return null if last page
	        },
	        prevPage: function(pg) {
	            var currentPg = pg || this.currentPage(),
	                pages = this.vChannel.request('activeDocPages'),
	                currengPgIndex = pages.indexOf(currentPg);
	            return (currengPgIndex > 0 ) ? pages.at(currengPgIndex - 1) : null; //return null if first page
	        },
	        isFirstPage: function () {
	            return this.currentPage() === this.vChannel.request('activeDocPages').first();
	        },
	        isLastPage: function () {
	            return this.currentPage() === this.vChannel.request('activeDocPages').last();
	        },
	        /**
	         * Returns wether the current page support annotation.
	         * For safety, check to see if document has pages -- if not return false.
	         * (Bonus is this avoid another call to check for invoker).
	         */
	        currentPageSupportsAnnotation: function() {
	            var curPg = this.currentPage();
	            return curPg ? curPg.supportsAnnotation() : false;
	        },
	
	        noteIsActiveOrExpanded: function () {
	            var isEditing = this.activeNote(),
	                noteExpanded = this.expandedNote(),
	                isActiveOrExpanded = isEditing || noteExpanded; //(don't want to return null)
	            return isActiveOrExpanded ? true : false;
	        },
	        noteIsActiveNote: function(note) {
	            return note === this.activeNote();
	        },
	        pgNoteIsOfActivePage: function(note) {
	            return note && note.pageNumber === this.currentPageNumber();
	        },
	        expandedNote: function () {
	            return this.get('expandedNote');
	        },
	        numberImagesLoadingInDocMode: function () {
	            return this.get('numberImagesLoadingInDocMode');
	        },
	        viewMode: function () {
	            return this.get('viewMode');
	        },
	
	        // TODO: refactor other ref's
	        viewModeIsPdf: function() {
	            return this.get('viewMode') === 'pdf';
	        },
	
	        //added (were accessed directly)
	        activeNote: function() {
	            return this.get('activeNote');
	        },
	        activeNoteSubType: function() {
	            return this.get('activeNoteSubType');
	        },
	        viewerLoaded: function() {
	            return this.get('viewerLoaded');
	        },
	        loadImages: function() {
	            return this.get('loadImages');
	        },
	        //wasn't in requests -- should be ???
	        fullPageModel: function () {
	            return this.get('fullPageModel');
	        },
	        getCurrentScaleValue: function () {
	
	            if (this.viewMode() === 'pdf')
	                return null;
	
	            return this.getCurrentScaleModel().get('scale');
	
	        },
	        /* Note: now Doc Mode Scale may not exist -- but shouldn't be in Doc Mode if that's the case */
	        getCurrentScaleModel: function () {
	
	            var viewMode = this.viewMode();
	
	            // ( Never call from PDF mode )
	            if (viewMode === 'pdf')
	                return null;
	
	            return this.get( (viewMode === 'document' ? 'document' : 'page') + 'ViewScale' );
	        },
	
	        pageViewScale: function() {
	            return this.get('pageViewScale');
	        },
	
	        /** -- Doc Lock ---- */
	        getDocumentLockState: function() {
	            return this.get( 'documentLockState' );
	        },
	
	        isDocumentLockedByApplication: function() {
	            return this.getDocumentLockState().isLocked();
	        },
	
	
	        /** -- Doc Lock */
	
	        paneIsCoveringLayout: function() {
	            return this.get('paneIsCoveringLayout');
	        },
	
	        /*
	         *  Return whether to disable page rotation in the UI given the current state of the UI.
	         *  Left on here (rather than vChannel like other page operations b/c of state implications & legacy code).
	         * */
	        disableRotation: function () {
	
	            var allowRotate = this.request('activeDocument').allowRotatePages() &&
	                this.request('currentPage').isRotatable() &&
	                !this.paneIsCoveringLayout() &&
	                !this.noteIsActiveOrExpanded();
	
	            return !allowRotate;
	        },
	
	        // (auto-forward from vChannel request )
	        findAndRedactSearchModel: function() {
	
	            return this.get('findAndRedactSearchModel');
	
	        },
	
	        showPageTextMode: function() {
	            return this.get('showPageTextMode');
	        },
	
	        textOnlyMode: function() {
	            return this.get('textOnlyMode');
	        },
	
	        previousActiveNote: function() {
	            return this.previous('activeNote');
	
	        }
	
	    }});
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = Backbone.Model.extend({
	
	    doubleHorPadding: 0,
	    doubleVertPadding: 0,
	    SB_W: 0,
	
	    // don't need attributes / model
	    defaults: {
	        mode: '', //marker for which mode we it belongs to -- pg or doc ... set on into -- determine is use currentPage / fullpg model for the page var
	        scale: '', //set on init
	        scaleType: '', //predefined, custom, page-fit, page-width, auto,
	        DEFAULT_SCALE: '', /*set from settings on init; also dependent on pgModel isImageType*/
	        H_PADDING: 0,
	        V_PADDING: 0,
	        outerDiv: {}
	
	    },
	
	    initialize: function() {
	
	        this.set({
	            scaleType: this._getScaleType()
	        });
	
	        /* cache some values*/
	        this.doubleHorPadding = this.get('H_PADDING') * 2;
	        this.doubleVertPadding = this.get('V_PADDING') * 2;
	
	        this.SB_W = fvChannel.request('settings').scrollBarWidth;
	       
	    },
	
	    /**
	     * Now all required -- pass through controller ( which is now the state -- no, not all required , init?
	     * Note: for correct page calc fn's, need the page object
	     * TODO: most of this just do in mediator caller (better clarity anyway)
	     */
	
	    setScale: function(page, newScale, newScaleType, options) {
	
	        var scale = newScale ? newScale : this.get('scale'),
	            scaleType = newScaleType ? newScaleType : this.get('scaleType'),
	
	            rotatedPgDimensions = page.getRotatedDimensions(),
	            pageW = rotatedPgDimensions.width,
	            pageH = rotatedPgDimensions.height,
	
	            outerWt = this.get('outerDiv').offsetWidth,
	            outerHt = this.get('outerDiv').offsetHeight,
	
	            fitWidthScale =  this.getFitWidthScale( outerWt, pageW ),
	            fitHeightScale =  this.getFitHeightScale( outerHt, outerWt, pageH, pageW ),
	            autoScale =  Math.min( 1.0, fitWidthScale ),
	            bestFitScale =  Math.min( fitHeightScale, fitWidthScale ),
	
	            scaleOpts = {};
	
	            switch(scaleType) {  //the predefined types are now the actual values to print
	                case 'Auto':   //the minimum of 100% scale or page width
	                    scaleOpts = {
	                        scale: autoScale,
	                        scaleType: scaleType
	                    };                  /* first 3 must match the value as defined on the HTML zoom template */
	                    break;
	                case 'Best Fit':
	                    scaleOpts = {
	                        scale: bestFitScale,
	                        scaleType: scaleType
	                    };
	                    break;
	                case 'Fit Width':
	                    scaleOpts = {
	                        scale: fitWidthScale,
	                        scaleType: scaleType
	                    };
	                    break;
	                case 'Fit Height':
	                    scaleOpts = {
	                        scale: fitHeightScale,
	                        scaleType: scaleType
	                    };
	                    break;
	                case 'Dot For Dot':
	                    scaleOpts =  {
	                        scale: 1.0,
	                        scaleType: scaleType
	                    };
	                    break;
	                case 'custom': //numeric and not predefined ('custom') -- from custom zoom buttons  : //ensure a number
	                    scaleOpts =  {
	                        scale: parseFloat(scale),
	                        scaleType: 'custom'
	                    };
	                break;
	            default:  // 'predefined' number : ensure number
	                scaleOpts = {
	                    scale: parseFloat(scale),
	                    scaleType: scaleType
	                }; //i think extra param 'scale' was typo
	                break;
	        }
	
	
	        if ( options && options.byForce ) {
	
	            // Don't set to null silently, then you mess up the the previous value;
	            // Instead, set the actual values silently and trigger the associated
	            // event calls in the order of Backbone's dispatcher.
	            // Could make this standardized given still heavy usage of Backbone ...
	            // Also good to know -- maybe implement something similar for other state
	            // attributes with change events that we encounter issues with firing events twice. --
	            // Eg: maybe intercept in 'api', set selectly, then fire events as needed ..
	
	            this.set( scaleOpts, _.extend( {}, options, {
	                silent: true
	            }));
	
	            this.trigger('change:scale', this, scaleOpts.scale, options );
	            this.trigger('change:scaleType', this, scaleOpts.scaleType, options );
	
	        } else {
	
	            this.set(scaleOpts, options);
	
	        }
	
	    },
	
	    // Old comment in here said to not round!
	    getFitWidthScale: function(outerWt, pageW) {
	        
	        var availableWidth = outerWt - this.doubleHorPadding,
	            scale = availableWidth / pageW;
	
	         //Account for horizontal scroll if it would exceed the amount
	        var projectedWidth = pageW * scale;
	        if ( projectedWidth >= availableWidth - this.SB_W ) {
	            availableWidth -= this.SB_W;
	            scale = availableWidth / pageW;
	        }
	
	        return scale;
	
	    },
	
	    getFitHeightScale: function(outerHt, outerWt, pageH, pageW ) {
	        
	        var availableHt = outerHt - this.doubleVertPadding,
	            availableWidthScale = availableHt / pageH, // need to see if scale change would cause the img wt to be > container causing horizontal overflow ( don't round! )
	            projectedWidth = ( pageW * availableWidthScale ) + this.doubleHorPadding;
	
	        return projectedWidth >= outerWt
	            ? (availableHt - this.SB_W) / pageH
	            : availableWidthScale;
	    },
	
	    getFriendlyScaleValue: function() { /* the value that is printed in the zoom input (and also that is selected in the drop down) */
	
	        var type = this.get('scaleType');
	        if (type === 'predefined' || type === 'custom') { //numeric
	            return (this.get('scale') * 100).toFixed(0) + '%';
	        } else { //non-numeric
	            return type;  //the printed value is the scale type now, no need to XREF
	        }
	
	    },
	
	    // only use internally
	    _getScaleType: function() {
	        var scale = this.get('scale');
	        return isNaN(scale) ? scale : 'predefined';
	    },
	
	    getScaleValue: function() {
	        return this.get('scale');
	    },
	
	    // Return in order most likely to be set in Document Mode, for performance
	    scaledTypeIsDerived: function() {
	
	        var scaleType = this.get('scaleType');
	
	        return scaleType === 'Auto' ||
	            scaleType === 'Fit Width' ||
	            scaleType === 'Fit Height' ||
	            scaleType === 'Best Fit';
	
	    },
	
	    isBestFit: function() {
	        return this.get('scaleType') === 'Best Fit';
	    },
	
	    onDestroy: function() {
	
	        this.off();
	
	        // Could already have been removed if destroyed prior --
	        var outerDiv = this.get('outerDiv');
	        outerDiv && ( outerDiv = null );
	
	        //this.clear({silent: true}); // would already have been deleted in doc mode view
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58);
	
	/**
	 * Flag Stored on Viewer State to remember if the document was locked by the application, and from what source.
	 * lockSource:
	 * - now really the source of truth ( we no longer need 'isLocked' )
	 * - array of actions that resulted in a successful document lock web service call, or
	 *   if the document was already locked, added to keep state without another superfluous call
	 * - if empty, the document is not locked by DV action
	 * - process completely intertwined with api.lockActiveDocument, api.unlockActiveDocument
	 * - Possible lock sources:
	 *  - 'PG_NOTE_EDITING'
	 *  - 'FIND_AND_REDACT'
	 * - Note on needing to handle multiple source using an array:
	 *  - we can't just set locked/isLocked; need to list the sources
	 *  - isLocked is now really just a convenience; if an item is in the lockSource array, it must be locked
	 *  - Example: if locked by find and redact search, then user hits create new page note, then he exits find and redact,
	 *  ( but is still editing the note ), we need the document to remain locked by 'PG_NOTE_EDITING'
	 */
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        isLocked: false,  // Flag indicating that the document was locked by this application (actually now now necessary but doesn't hurt)
	        lockSource: []
	
	    },
	
	    /**
	     * Don't lock or unlock directly due to nature of > 1 lock being able to be applied
	     * Called after successful lock web-service call, or
	     * if the document already locked, added to the array without a call to lock again.
	     */
	    addLockSource: function( source ) {
	
	        var newLockSource = _.unique( this.get('lockSource').concat( [source] ) );
	
	        this.set({
	            lockSource: newLockSource,
	            isLocked: newLockSource.length > 0
	        });
	
	    },
	
	    removeLockSource: function( source ) {
	
	        var newLockSource = _.without( this.get('lockSource'), source );
	
	        this.set({
	            lockSource: newLockSource,
	            isLocked: newLockSource.length > 0
	        });
	
	    },
	
	    isLocked: function() {
	        return this.get('isLocked');
	    },
	
	    isNotLocked: function() {
	        return !this.get('isLocked');
	    },
	
	    lockSource: function() {
	        return this.get('lockSource');
	    },
	
	    isLockedBySource: function( source ) {
	        return this.isLocked() && this.lockSource().indexOf( source ) > -1;
	    },
	
	    isLockedByOtherSource: function( lockSource ) {
	        return this.isLocked() && _.without( this.lockSource(), lockSource).length > 0;
	    },
	
	    isLockedByPageNoteEditing: function() {
	        return this.isLockedBySource( 'PG_NOTE_EDITING' );
	    },
	
	    isLockedByFindAndRedact: function() {
	        return this.isLockedBySource( 'FIND_AND_REDACT' );
	    },
	
	    printForDebug: function() {
	        return JSON.stringify( this.get('isLocked') ) + '|' + JSON.stringify( this.get('lockSource') );
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {/**
	 * Viewer Instance Intra Module Communication
	 * Commands, Requests, Events -- act with viewer context
	 * State API -- commands, requests, subscriptions conduit -- forwarded through here
	 * Outer Module Events forwarded through here
	 */
	
	
	var  _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    OuterEventCallbacksByModule = __webpack_require__(105),
	    StateApi = __webpack_require__(101),
	    StateCBs = __webpack_require__(106),
	    StateModel = __webpack_require__(100),
	    CRE_Defaults = __webpack_require__(107),
	    DownloadView = __webpack_require__(108),
	    AjaxError = __webpack_require__(75).ajaxError,
	    Util = __webpack_require__(48),
	
	    DeletePagesModal = __webpack_require__(109),
	    AddPagesModal = __webpack_require__(139),
	    ReorderPagesModal = __webpack_require__(142),
	    PageInfoModal = __webpack_require__(145),
	    DocInfoModal = __webpack_require__(261),
	    AboutModal = __webpack_require__(264),
	
	    PageFullSize = __webpack_require__(268),
	    HiddenCanvasView = __webpack_require__(355),
	
	    Backbone = __webpack_require__(58);
	
	__webpack_require__(389);
	
	
	//TODO: wrap in fn for caching
	//TODO: all this.getSubApp -- replace with requestOn, commandOn
	
	var requests = {
	
	    // Document
	    documents: function () {
	        return this.documents;
	    },
	    activeDocument: function () {
	        return this.activeDocument;
	    },
	    activeDocPages: function () { //nav /note -- these should be passed from local to gl
	        return this.activeDocument.pageCollection;
	    },
	    activeDocHasNoPages: function () {
	        return this.activeDocument.get('docHasNoPages');
	    },
	    activeDocumentTextModel: function() {
	      return this.activeDocument.getDocumentTextModel();
	    },
	
	    //TODO: combo and clean ...
	
	    //----------
	    docHasSomeUnrenderablePgs: function () {
	        return this.activeDocument.docHasSomeUnrenderablePgs();
	    },
	    docHasNoRenderablePgs: function () {
	        return this.activeDocument.docHasNoRenderablePgs();
	    },
	    docHasRenderablePgs: function () {
	        return this.activeDocument.hasRenderablePgs();
	    },
	    docHasNoPDFRenderablePgs: function() {
	        return this.activeDocument.docHasNoPDFRenderablePgs();
	    },
	    docHasSomeUnrenderablePDFModePgs: function() {
	        return this.activeDocument.docHasSomePDFRenderablePgs();
	    },
	    unrenderablePages: function () {
	        return this.activeDocument.pageCollection.getUnrenderablePages();
	    },
	    unrenderablePDFModePgs: function () {
	        return this.activeDocument.pageCollection.urlOrUnrenderablePages();
	    },
	
	    //------------
	
	    allNotes: function () {
	        return this.activeDocument.allNotes;
	    },
	    pageNotes: function () {
	        return this.activeDocument.pgNotes;
	    },
	    docNotes: function () {
	        return this.activeDocument.docNotes;
	    },
	
	    docIndexes: function () {
	        return this.activeDocument.docIndexes();
	    },
	    fullTextModel: function () {
	        return this.activeDocument.fullTextModel;
	    },
	
	    //settings ....
	    settings: function () {  //TODO: only used in centerHeader, nav
	        return this.settings;
	    },
	    imageFileType: function () {
	        return this.settings.imageFileType();
	    },
	    excludePageNotes: function () { //only req'd in allNotes -- can rid after -- TODO: using?
	        return this.settings.excludePageNotes();
	    },
	    fullTextQuery: function () {
	        return this.settings.fullTextQuery();
	    },
	    //TODO: state?
	    fullScreen: function () {
	        return this.settings.fullScreen();
	    },
	    /* layout*/ //TODO: should never have to go through?
	    getLayout: function () {
	        return this.getSubApp('layout');
	    },
	    getWrapper: function () { //not the same as the container
	        return this.requestOn('layout', 'wrapper');
	    },
	    modalView: function () {
	        return this.requestOn('layout', 'modalView');
	    },
	
	    /* Note: this may not exist */
	    docModeContainer: function () {
	        return this.getSubApp('viewModes').getRegion('docModeContainer').currentView;
	    },
	    pgModeContainer: function () {
	        return this.getSubApp('viewModes').getRegion('pgModeContainer').currentView;
	    },
	    pdfModeContainer: function () {
	        return this.getSubApp('viewModes').getRegion('pdfContainer').currentView;
	    },
	    pdfWrapper: function () {
	        return this.requestOn('viewModes', 'pdfWrapper');
	    },
	    //todo: really center header -- own module?
	    getHeader: function () {
	        return this.requestOn('layout', 'centerHeaderView');
	    },
	    //todo: rid -- access via channel
	    rotateView: function () {
	        return this.requestOn('layout', 'rotateView');
	    },
	
	    /*
	     * Dynamic because container width can change ..
	     * TODO: We may want to remove now.
	     *  */
	    getDocModeImgWidth: function () {
	
	        var containerWidth = $(this.settings.el()).outerWidth(),
	            MAX_DOC_WT = this.settings.maxDocWidth;
	
	        return containerWidth < MAX_DOC_WT + 1
	            ? containerWidth
	            : MAX_DOC_WT;
	
	    },
	
	    /* note: could be doc or pg mode, now only supporting page */
	    getAttributesToPersistOfNoteOnCanvas: function(note) {
	        return this.requestOn( 'viewModes', 'getCanvasShapeAttrs', note, this.state.getCurrentScaleValue(), this.request('viewMode') );
	    },
	    //notes / canvas
	    getCurrentDrawingAttributes: function () {
	        return this.requestOn('notes', 'drawingAttributes');
	    },
	
	    //mediated here
	    pageIsActivePage: function (page) { /* works page / thumb b/c relies on page number */
	        return page.get('number') === this.state.currentPageNumber();
	    },
	    getPageFromThumbModel: function(thumb) {
	        return this.activeDocument.pageCollection.at(thumb.collection.indexOf(thumb));
	    },
	    getPageModelFromNumber: function(pgNum) {
	        return this.activeDocument.pageCollection.findWhere({
	            number: pgNum
	        });
	    },
	
	    /* Use to reference for page mode page models from that store on Doc Mode pages */
	    getPagePositionalTextModel: function( pageNumber ) {
	        return this.activeDocument.pageCollection.getPositionalTextModelOfPage( pageNumber );
	    },
	
	    pageHasPositionTextModel: function( pageNumber ) {
	        var page = this.request('getPageModelFromNumber', pageNumber);
	        return page.hasPositionalTextData();
	    },
	
	    // TODO: also check if instance of pgModel -- can determine in viewModes
	    getThumbFromPageModel: function(page) {
	        return this.activeDocument.thumbCollection.at( page.collection.indexOf(page) );
	    },
	
	    rotatePgRequest: function(deg) {
	
	        var pg = this.state.currentPage(),
	            doc =  this.request('activeDocument');
	
	        if ( !doc.allowSaveRotation() ) {
	
	            var newRotation = ( deg +  pg.get('rotation') ) % 360;
	
	            /** Rotation always must be positive! ( -90 not allowed ); reflect logic used to store in page_info **/
	            if ( newRotation < 0 ) {
	                newRotation = newRotation + 360;
	            }
	
	            rotatePage.call( this, newRotation );
	
	            return;
	        }
	
	        $.ajax({
	            url: fvChannel.request('apiUrl').rotatePage( doc, pg.get('pageId'), deg ),
	            type: 'PUT',
	            context: this
	        }).done( function(page) {
	
	            rotatePage.call( this, page.rotation );
	
	        }).fail(function (jqXHR) {
	
	            this.command('ajaxError', jqXHR, 'Error rotating page');
	
	        });
	
	        function rotatePage( newPageRotation ) {
	
	            /**
	             * Document Mode --
	             * A scale change event calls everything we need here ( updateViewPort, setVOffsets, checkPagesInview )
	             * Ideally in future we have some sort of 'updateViewport' mechanism here (larger refactor)
	             * TODO: update vOffsets on every scale change first
	             * This is the only place scale is called on documentView not through the central fn,
	             * so we need to ensure it exits.
	             */
	            pg.setRotation( newPageRotation );
	
	            Util.blindForward(  this.state.get('documentViewScale'), 'setScale', pg, undefined , undefined, {
	                byForce: 1,
	                fromRotation: 1
	            });
	
	            /**
	             * Thumbnails --
	             * These don't currently have an 'updateViewport'ish equilent to set scale; should implement ...
	             * Currently won't produce error if thumbnails module doesn't exist; but need to call if it doesn't.
	             */
	
	            if ( this.request('includeThumbnailsModule') ) {
	
	                var thumb = this.request( 'getThumbFromPageModel', pg );
	                thumb.setRotation( newPageRotation );
	                doc.thumbCollection.setVOffsets();
	                thumb.trigger('pageView:rotate');
	                this.commandOn( 'thumbNails', 'checkInView' );
	            }
	
	
	            /**
	             * Page Mode --
	             * Scale change also updates rotation now, want an update viewport ....
	             */
	            var pageModePg = this.request('fullPageModel');
	            pageModePg.setRotation( newPageRotation );
	            this.state.get('pageViewScale').setScale( pageModePg , undefined , undefined , {
	                byForce: 1,
	                fromRotation: 1
	            });
	
	            /**
	             * PDF MODE - can't call from in this mode --
	             * set a flag so that when we re-enter, we make a new render request for the document
	             */
	            this.state.set( 'pdfRendered', false );
	
	        }
	
	    },
	    // combo of doc and state props: use before calling load pdf
	    allowPdfToLoad: function () {
	        return this.activeDocument.shouldLoadPDF() && this.state.loadImages();
	    },
	    docModeScaleValues: function () {
	        return this.settings.docModeScaleValues;
	    },
	    pageModeScaleValues: function () {
	        return this.settings.pageModeScaleValues;
	    },
	    zoomIncrement: function () {
	        return this.settings.zoomIncrement;
	    },
	    minScale: function () {
	        return this.settings.minScale;
	    },
	    minImageScale: function () {
	        return this.settings.MIN_IMG_SCALE;
	    },
	    minimumWidth: function () { //for layout resize ... combo with scale?
	        return this.settings.minimumWidth;
	    },
	    maxNumberImgsToLoad: function () {
	        return this.settings.MAX_NUM_IMAGES_TO_LOAD;
	    },
	    docModeImagesLoadingExceedsThreshold: function () {
	        return this.request('numberImagesLoadingInDocMode') > this.request('maxNumberImgsToLoad') - 1;
	        //todo: latter should come from the current viewer setting
	    },
	    getViewer: function () {
	        return this;
	    },
	    /*
	    * This doesn't mean scaling will not be applied to page views, just that the UI entry points will be blocked.
	    * Applies to headerCenter (zoom views; hidden) and overflowHeader menu (zoom in/out; disabled).
	    * */
	    disableScaling: function () {
	
	        var isPageMode = this.request('viewMode') === 'page',
	            currentPage = this.request('currentPage');
	
	        return  !this.state.loadImages() ||
	                this.request('activeDocHasNoPages') ||
	                ( isPageMode && !currentPage.isRenderable() ) ||
	                ( isPageMode && currentPage.isGOS() && !currentPage.isGosHtmlFile() );
	
	    },
	
	    docOrPgModeCurrentPgEl: function () {
	        return this.request('viewMode') === 'page'
	            ? this.request('pgModeContainer').pageView.currentView.$el
	            : this.getSubApp('viewModes').request('docModeViewOfPg', this.request('currentPage')).$el;
	    },
	    getDocRequest: function() {
	        return this.aDocReq;
	    },
	    activeDocIndex: function() {
	        return this.activeDocIndex;
	    },
	
	    getNewNoteModel: function( isDocNote, noteType ) {
	        return this.requestOn('notes', 'getNewNoteModel', isDocNote, noteType );
	    },
	
	    /**
	     * Create a new full page model ( from a clone of the document mode page ).
	     * Always set wasRequested, isLoaded to false ( these can be requested multi-times ).
	     */
	    getNewFullPageModelFromDocModePage: function( page ) {
	
	        return new PageFullSize( _.extend( _.clone(page.attributes), {
	            wasRequested: false,
	            isLoaded: false
	        }), {
	            parse: true,
	            parentDocument: _.clone( page.get('parentDocument') ),
	            imageFileType: page.get('imageFileType')
	        });
	
	    },
	
	    // This is a hack for find and redact and floating codes, which need to be rendered to get their data to save ...
	    // leave here for testing from console -- can prob remove later ...
	    createHiddenPageCanvas: function( pageNumber, shapes ) {
	
	        if ( this.dummyCanvasView )
	            this.command( 'destroyHiddenCanvas' );
	
	        this.dummyCanvasView = new HiddenCanvasView();
	        this.dummyCanvasView.render( this.channel, pageNumber, shapes  );
	
	        return this.dummyCanvasView;
	
	    },
	
	    /**
	     * Now exists in the notes module; eventually we should 'lift' to the viewer level since shared
	     * by notes and find and redact modules; it also makes things order dependent -- eg if want to disable
	     * the F&R module in the layout header, this would need to be done prior to creation of this object
	     * in the notes module. Could also give a centralized place for 'can redact'
	     * as opposed to checking create page note task perm in createNewRedaction on entry.
	     */
	    getCreatableNotesHelper: function() {
	        return this.getSubApp('notes').creatableNoteTypesHelper;
	    },
	
	    // --- perms ---
	    allowDeletePages: function() {
	        return this.request('activeDocument').allowDeletePages();
	    },
	    allowAddPages: function() {
	        return this.request('activeDocument').allowAddPages();
	    },
	    allowReorderPages: function() {
	        return this.request('activeDocument').allowReorderPages();
	    },
	
	    allowCreatePgNote: function() {
	        return this.request('activeDocument').allowCreatePgNote();
	    },
	    allowCreateDocNote: function() {
	        return this.request('activeDocument').allowCreateDocNote();
	    },
	    /*  same for document & page notes */
	    allowModifyOrDeleteNote: function() {
	        return this.request('activeDocument').allowModifyOrDeleteNote();
	    },
	
	    /* DVBC-1781 -- separate perm for highlight notes ( logic now: either user has it or create_page_note ) */
	    allowCreateHighlight: function() {
	        return this.request('activeDocument').allowCreateHighlight();
	    },
	    /* DVBC-1781 -- separate perm for highlight notes ( logic now: either user has it or delete_note ) */
	    allowModifyOrDeleteHighlight: function() {
	        return this.request('activeDocument').allowModifyOrDeleteHighlight();
	    },
	
	    /**
	     * Determine the url required to load a PDF inside a iframe/window,
	     * depending on the setting to use PDF.js.
	     * Also takes into account whether to disable download buttons in PDF.js,
	     * and potentially some other future settings.
	     * Note: download & print permission now only required for test server.
	     */
	    getPdfUrlToLoadInFrame: function( creResponse ) {
	
	        return this.request('usePdfJs')
	            ? fvChannel.request('apiUrl').pdfJsViewer(
	                    creResponse.inlineUrl,
	                    this.request('allowDownload'),
	                    fvChannel.request('user').canPrint(),
	                    fvChannel.request('settings').isRunningNode
	                )
	            : creResponse.inlineUrl;
	
	    },
	
	    // Downloads / 'Exports'
	
	    // Here implies ability to download/export the document
	    allowDownload: function() {
	        return fvChannel.request('user').canExport();
	    },
	
	    // Document part could be cached on parse ...
	    allowDocumentDownload: function(isPDF) {
	        return this.request('allowDownload') && this.request('activeDocument').isDownloadable(isPDF);
	    },
	
	    // May later combine setting to disable downloads (DVBC-1480).
	    // Page is the page model; provide isPDF if want to download as PDF, otherwise raw.
	    allowPageDownload: function(page, isPDF) {
	        return this.request('allowDownload') && page.isDownloadable(isPDF);
	    },
	
	    allowPDFCombo: function() {
	        return this.request('allowDownload') && this.request('documents').allowPDFCombo();
	    },
	
	    allowNewWindow: function() {
	        return fvChannel.request('user').canExport();
	    },
	
	    // Not including permissions here -- that's handled in the notes module.
	    // We should lift that logic atop here, especially since we don't need to make the note module standalone anymore
	    allowCreationOfFullPageRedaction: function() {
	
	        return !this.request('activeDocument').get('docHasNoPages') &&
	            this.request('currentPage').allowCreationOfFullPageRedaction();
	    },
	
	    /**
	     * No perms checks including in displaying the module ( create-pg-note, create-highlight ).
	     * If user lacks ability to create any notes supported by F&R -- still show the module,
	     * but disable the search.
	     */
	    includeFindAndRedactModule: function() {
	
	        var settings = this.request('settings');
	        var userProvidedSearches = settings.findAndRedact();
	        var include = !settings.pdfOnly() && !settings.excludePageNotes();
	
	        if ( userProvidedSearches ) {
	
	            return include && this.request('activeDocument').hasPagesWithPositionalData();
	
	        } else {
	
	            return include && this.request('activeDocument').fddImagePagesExistAndAllHavePositionalData();
	        }
	
	    },
	
	    /* Whether to include the module at all -- could cache for performance gains */
	    includeThumbnailsModule: function() {
	        return !this.request('settings').disableThumbs() && !this.request('activeDocHasNoPages');
	    },
	
	    /**
	     * We never allow thumbnails in PDF mode ( DVBC-1817 ).
	     * See callback.changeViewMode where the panel is closed if open on entry to pdf mode,
	     * and headerLeft.toggleHeaderViewModeState.
	     * DVBC-1823: separate from the inclusion of the module since it is no longer always created.
	     */
	    allowThumbnails: function() {
	        return this.request( 'includeThumbnailsModule' ) && this.state.viewMode() !=='pdf';
	    },
	
	    /* View is still created if none exist, though it doesn't open automatically */
	    includeIndexesModule: function () {
	        return !this.settings.hideIndexes() && this.activeDocument.hasIndexes();
	    },
	
	    /**
	     * DVBC-1823: for performance reasons, there are times we don't want to render the page views.
	     * forShowingHeaderButton: we don't want to take whether the document has pages into account
	     * ( only hide the button if the settings say so ).
	     */
	    includeDocumentMode: function( forShowingHeaderButton ) {
	
	        var s = this.request('settings'),
	            settingsAllow = !s.pdfOnly() && !s.singlePageOnly() && !s.disableDocMode();
	
	        if ( !forShowingHeaderButton ) {
	            return settingsAllow && !this.request('activeDocHasNoPages');
	        }
	
	        return settingsAllow;
	
	    },
	
	    // ALLOW: For time being a temporary flag until we decide how to handle these --
	    allowDocumentLevelFullTextOverlayFunctionality: function() {
	
	        var ALLOW = 0;
	
	        if (true) {
	            ALLOW = 0;
	        }
	
	        var settings = this.request('settings');
	
	        // Note: excludePageNotes -- ocrNotes are not part of this collection; they are returned as pages.
	        return ALLOW && this.request('activeDocument').hasPagesWithPositionalData() && !settings.pdfOnly();
	
	    },
	
	    allowDocumentLevelShowPageText: function() {
	        return this.request('allowDocumentLevelFullTextOverlayFunctionality');
	    },
	
	    allowDocumentLevelTextOnlyMode: function() {
	        return this.request('allowDocumentLevelFullTextOverlayFunctionality');
	    },
	
	
	    /* Really 'block access': page mode is always created */
	    hidePageMode: function() {
	        return this.request('settings').pdfOnly();
	    },
	
	    /* Really 'block access': pdf mode is always created */
	    hidePdfMode: function() {
	        return this.request('settings').singlePageOnly();
	    },
	
	    // Now only checking original download permission
	    disableImageDownloads: function() {
	        return !this.request('allowDownload');
	    },
	
	    // For now use PDF.js viewer is user lacks download or print permission
	    usePdfJs: function() {
	
	        var user = fvChannel.request('user');
	        return !user.canExport() || !user.canPrint();
	
	    }
	
	
	
	
	};
	
	
	var commands = {
	
	    /* docIndex is the id from the documents collection or the direction of the doc nav btn click */
	    changeActiveDoc: function(docIndex) {
	
	        //var doc = this.documents.at(docIndex);
	        //for now map the docReq array to the docIndexes -- todo: should the options be the same -- would be api change ... ?
	        //var docReq = this.request('docRequest')[docIndex];
	
	        if (typeof docIndex !== 'string') {
	
	            this.activeDocIndex = docIndex;
	
	        } else {
	
	            var nDocs = this.documents.length - 1,
	                isNext = docIndex === 'Next',
	                isPrev = docIndex === 'Previous',
	                isFirst = docIndex === 'First',
	                isLast = docIndex === 'Last',
	                isFirstDoc = this.activeDocIndex === 0,
	                isLastDoc = this.activeDocIndex === nDocs;
	
	            if ((isNext && isLastDoc) || (isPrev && isFirstDoc) || (isFirst && isFirstDoc) || (isLast && isLastDoc))
	                return false;
	
	            isNext && (this.activeDocIndex++);
	            isPrev && (this.activeDocIndex--);
	            isFirst && (this.activeDocIndex = 0);
	            isLast && (this.activeDocIndex = nDocs);
	        }
	
	        // If an alert if open, close it before proceeding to the next document
	        this.trigger('alert:hide');
	
	        this._internalReset( {
	            src: 'activeDocChange'
	        });
	
	
	    },
	
	    /**
	     * Renders a new page mode view (marionette region show) --
	     * old lower level mediation applied here.
	     * ... could clean this up further ...
	     */
	    createPageModeView: function(options) {
	
	        if ( !this.activeDocument.hasPages() || !this.state.loadImages() )
	            return;
	
	        var fullPgModel = this.state.fullPageModel(),
	            isPageMode = this.state.viewMode() ==='page',
	            renderPgModeView = _.bind( function() {
	                this.commandOn('viewModes', 'renderPgModePgView', fullPgModel);
	            }, this);
	
	
	        switch(options.src) {
	
	            case 'pageChange':
	                if (isPageMode) {
	                    this.command('setScale');  // Still necessary?
	                    renderPgModeView();
	                }
	                break;
	
	            case 'viewerRendered':
	                this.command('setScale'); // Ensure overflow settings applied
	                isPageMode && renderPgModeView();
	                break;
	
	            // Note: could be triggered by active note change
	            case 'modeChangeEntry':
	
	                if (!isPageMode)
	                    return;
	
	                /**
	                 * If loaded in other mode, would be hidden and scale wouldn't have been set
	                 * (calculations of invisible dom item's -- do here.
	                 * Also, set in case the layout updated and scale is fit height, fit width, auto ... (had loaded)
	                 */
	                this.command('setScale');
	
	               // If wasn't loaded, create the new page view
	               if ( !fullPgModel.get('isLoaded') )
	                   renderPgModeView();
	
	                break;
	
	
	            case 'toggleLoadImages':
	                isPageMode && renderPgModeView();
	                break;
	            }
	
	
	    },
	
	    ajaxError: AjaxError,
	
	    /* Open in New Window Full Screen, Default Settings */
	    openInNewWindow: function() {
	
	        var template = __webpack_require__(390)({
	                docRequest:  JSON.stringify(  this.request('getDocRequest') ),
	                instanceOptions:  Util.jsonStringyWithFunctions( _.omit(this.vOptions, 'el') ),
	                fvOptions: Util.jsonStringyWithFunctions( fvChannel.request('options') ),
	                js: __webpack_require__.p + FV._src
	            }),
	            fvSettings = fvChannel.request('settings'),
	            win = window.open('');
	
	        /**
	         * Since always a new window holding only the viewer,
	         * utilize it's global namespace for action to hook into.
	         * Currently used to set page rotation values that may be different if user lack save-rotation permission.
	         * Ties into same hook as that set in viewer.reset
	         * Could stringify/clone -- but fine since storing on the namespace (also see comments in reset if memory leaks become an issue)
	         * */
	        win[ fvSettings.NEW_WINDOW_NAMESPACE ] = {
	            priorDocumentCollection: this.documents
	        };
	
	        win.document.open();
	        win.document.write( template );
	        win.document.close( fvSettings.PATH_TO_API );
	
	
	    },
	
	    /*
	     * Open the active document as a PDF in a new browser tab.
	     * May want to combo logic with download document or exportAllDocumentsAsPDF,
	     * but don't want to mess w/and potentially break that code now ...
	     */
	    openDocAsPdfInNewWindow: function() {
	
	        var activeDocument = this.request('activeDocument');
	
	        /*
	         * Functionality should be disabled in UI, but extra check here.
	         * Note: implies document has pages and ones that renderable by CRE ( eg not multipart GOS )
	         */
	        if ( !activeDocument.hasRenderablePgs() )
	            return;
	
	        var creDefaultOpts = {
	            isPDF: 1,
	            inlinePDF: 1,
	            vChannel: this.channel,
	            completeCB: _.bind(function( creResponse ) {
	                 window.open( this.request('getPdfUrlToLoadInFrame', creResponse) );
	            }, this)
	        };
	
	        /*
	         * ( file name escape so user can download from the PDF window )
	         * also avoid current error if '/' for example in name; should revisit this
	         */
	        var creRequestOptions = _.extend( {},
	            activeDocument.docRenderRequest( 'pdf', 'pdf' ), {
	                fileName: activeDocument.documentName( activeDocument.getFileExtension(1), 1 )
	            },
	            new CRE_Defaults(creDefaultOpts)
	        );
	
	        $.fn.creRequest( creRequestOptions );
	    },
	
	    /*
	    * Show the doc info dialog for the active document.
	    * Re-request updated info mimicking a fetch of the active document
	    * to ensure user lock and modified time are up-to-date.
	    * Simpler than combining data from the existing activeDocument and another
	    * web-service request to check the lock and mtime of the document (or anything else that could change).
	    * Also -- note we're not updating the active document attributes whenever they are changed;
	    * that would be a whole project that's currently unnecessary.
	    * Note: no endpoint exists for a single document so utilize the endpoint for the collection.
	    * */
	    showDocInfo: function () {
	
	        var docCollection = new this.documents.constructor();
	
	        docCollection.fetch({
	            docReq: [ this.request('activeDocument').getDocSlice() ],
	            parse: false,
	            context: this
	        })
	        .done( function() {
	
	            this.trigger( 'modal:open', {
	                modalView: new DocInfoModal({
	                    docModel: docCollection.at(0)
	                })
	            });
	
	        })
	        .fail( function( jqXHR ) {
	            this.command( 'ajaxError', jqXHR, 'Cannot Retrieve Data to Show Doc Info Dialog' );
	        });
	
	    },
	    showPgInfo: function(page) {
	
	        var isPDFMode = this.request('viewMode') === 'pdf';
	
	        var modal = new PageInfoModal( _.extend( {}, {
	            pages:
	                !isPDFMode
	                    ? ( page && page instanceof Backbone.Model ? page : this.request('currentPage') ) //former condition (a jq event could be sent)
	                    : this.request('activeDocPages'),
	            activeDocId: this.request('activeDocument').getId(),
	            isPDFMode: isPDFMode
	
	        }));
	
	        this.trigger('modal:open', {
	            modalView: modal
	        });
	
	    },
	    showAbout: function () {
	
	        var versionModel = fvChannel.request('versionModel');
	
	        if ( !versionModel.wasFetched ) {
	
	            versionModel.fetch( this )
	                .done( showModal )
	                .fail( function(errMsg) {
	                    this.trigger('alert:show', {
	                        type: 'error',
	                        shortMessage: 'Unable To Load Version Data',
	                        detailedMsg: errMsg
	                    });
	                });
	
	            return;
	        }
	
	        showModal.call( this );
	
	        function showModal() {
	
	            this.trigger( 'modal:open', {
	                modalView: new AboutModal({
	                    versionModel: versionModel,
	                    userModel: fvChannel.request('user'),
	                    authModel: fvChannel.request('auth')
	                })
	            });
	        }
	
	    },
	    /*
	    * Called after viewer is loaded is  config option 'createNewRedactionOnEntry' true.
	    * */
	    createNewRedaction: function() {
	
	        // First fail silently if the page is not annotatable
	        if ( !this.request('currentPage').supportsAnnotation() )
	            return;
	
	        /**
	         * Note: would like to centralize 'allowCreatePgNote' in notes.creatableNoteTypes helper.
	         * But lifting it up to the viewer level would be a refactor that we can do later, if needed.  Here,
	         * we could have a function on there allowRedactions, for this purpose.
	         */
	        if ( !this.request('allowCreatePgNote') ) {
	
	            this.trigger('alert:show', {
	                type: 'error',
	                shortMessage: 'Unable To Create New Redaction',
	                detailedMsg: 'User does not have necessary permissions to create a redaction.'
	            });
	            return;
	        }
	
	        this.commandOn('notes', 'createRedactionOnViewerLoad');
	
	    },
	
	
	   /**
	    * Download Dispatcher
	    *  Note: if document, pdf, and some pages aren't renderable, they won't be included
	    *  pgNum is optional: if not provided, will be the current page
	    */
	    download: function(pageOrDoc, pdfOrRaw, pgNum) {
	
	        var ad = this.activeDocument,
	            isPDF = pdfOrRaw.toUpperCase() === 'PDF';
	
	        pageOrDoc === 'document'
	            ? downloadDocument.call( this, ad, isPDF )
	            : downloadPage.call( this, pgNum ? this.request( 'getPageModelFromNumber', pgNum) : this.request('currentPage'), isPDF );
	
	
	       // Note - for original downloads: if > 1 pages, CRE will return a zip of the individual pages.
	       // If 1 page, will return just that page (we're setting this with the containerType param, set below).
	       // However, for consistency with FDD, if downloading only one page, use the document name, not the page name (they can differ).
	        function downloadDocument(doc, isPDF) {
	
	            // Handle Document Downloads for For 1 Page Multi-Page-Gos Documents as
	            // a page download of this type. ( Would never be PDF ).
	            if ( ad.isOnePageMultiPartGosSkeleton() && !isPDF ) {
	                downloadPage.call(this, ad.pageCollection.at(0) );
	                return;
	            }
	
	            var nPages = doc.pageCollection.length,
	                contType,
	                pgType,
	                options = {};
	
	                if (!isPDF) {
	                    // container type is 'zip' if > 1 page or 'raw' if just one page
	                    contType = nPages === 1 ? 'raw' : 'zip';
	                    pgType = 'raw';
	                } else {
	                    contType = 'pdf';
	                    pgType = 'pdf';
	                }
	
	                // should name nonImageRenderReq / downloadRender req for clarity ...
	                _.extend( options, doc.docRenderRequest( contType, pgType ), new CRE_Defaults({
	                        isPDF: isPDF,
	                        vChannel: this.channel
	                    }),
	                    { fileName: doc.documentName( doc.getFileExtension(isPDF), 1 ) }
	                );
	
	                $.fn.creRequest(options);
	        }
	
	        function downloadPage(pg, isPDF) {
	
	            if ( ( pg.isGOS() || pg.isMultipartGosSkeleton() ) && !isPDF ) {
	
	                // Browser file download
	                // Note: currently no cookie to detect completion in the implementation (DVBC-1367)
	
	                var dlView = new DownloadView({
	                    src: pg.getRawDownloadUrl(),
	                    container: this.request('getWrapper')
	                }).render();
	
	            } else {
	
	                // Regular CRE render
	                var type = isPDF ? 'pdf' : 'raw',
	                    options = _.extend( {}, pg.nonImgRenderRequest(type, type), new CRE_Defaults({
	                        isPDF: isPDF,
	                        vChannel: this.channel
	                    }), { fileName: pg.getPageName( isPDF ? 'pdf': undefined, 1 ) });
	
	                $.fn.creRequest(options);
	            }
	        }
	
	    },
	
	    openPageInNewWindowAsPDF: function(page) {
	
	        var opts =  _.extend( {}, page.nonImgRenderRequest('pdf', 'pdf'), new CRE_Defaults({
	            isPDF: true,
	            vChannel: this.channel,
	            inlinePDF: 1,
	            completeCB: _.bind( function(creResponse) {
	                window.open( this.request('getPdfUrlToLoadInFrame', creResponse) );
	            }, this )
	        }), { fileName: page.getPageName( 'pdf', 1 ) });
	
	        $.fn.creRequest(opts);
	
	    },
	
	    /* if popWindow, opens in new window, otherwise, downloads */
	    exportAllDocumentsAsPDF: function(popWindow) {
	
	        var creDefaultOpts = {
	            isPDF: true,
	            vChannel: this.channel
	        };
	
	        popWindow && _.extend( creDefaultOpts, {
	            inlinePDF: 1,
	            completeCB: _.bind(function(creResponse) {
	                window.open( this.request('getPdfUrlToLoadInFrame', creResponse) ); // loading in the new window / block ui?
	            }, this)
	        });
	
	        var opts = _.extend( {},
	            this.documents.pdfRenderRequest(), {
	                fileName: this.documents.pdfFileName()
	            }, new CRE_Defaults(creDefaultOpts)
	         );
	
	        $.fn.creRequest(opts);
	    },
	
	    postToggleLeftSubPanel: function( pane ) {
	
	        if ( pane.get('currentSubPane') === 'thumbs' ) {
	            this.commandOn( 'thumbNails', 'checkInView' );
	        }
	
	    },
	
	    /** Note: the module may not exist -- so commandOn */
	    goToThumbnail: function( page ) {
	        page = page || this.request('currentPage');
	        this.commandOn( 'thumbNails', 'goToThumb', this.request('getThumbFromPageModel', page) );
	    },
	
	    //TODO: an outer event while still there
	    togglePaneIsCoveringLayout: function(isCovering) { /*note: is reaction to change of state in layout */
	        this.state.set({
	            paneIsCoveringLayout: isCovering, /* need to fire so if opp panel is opened, the initial covering one is closed */
	            loadImages: !isCovering
	        });
	    },
	
	    pageImgLoadError: function(page) {
	
	        if (page.typeIdentifier === 'THUMB')
	            return;
	
	        this.commandOn(['layout', 'notes'], 'pageImgLoadError', page);
	    },
	
	    // Quick fix until loading queue
	    checkForDocModeImagesInView: function() {
	        Util.blindForward(  this.request('docModeContainer'), 'checkForPagesInView' );
	    },
	
	    /**
	     * TODO:
	     * - should only be one entry point to requesting imgs
	     * - later queue
	     * Comes from page change and viewer load
	     * Get current page, if prev, load prev, if next; also load next.
	     * When goes to zero: the plugin will catch the current images on screen.
	     */
	
	    handleDocModeImgPrefetching: function(pg) {
	
	        if ( !this.state.loadImages() || !this.request('includeDocumentMode') ) {
	            return;
	        }
	
	        var prev = this.request('prevPage', pg),
	            next = this.request('nextPage', pg);
	
	        !pg.get('isLoaded') && pg.trigger('creRequest');
	
	        next && !next.get('isLoaded') && next.trigger('creRequest'); // should create facade here
	        prev && !prev.get('isLoaded') && prev.trigger('creRequest');
	
	
	    },
	    toggleMultiDocInterfaces: function(show) {
	        this.command('mainView.toggleMultiDocInterfaces', show);
	    },
	    updatePostRunTimeError: function() {
	        this.commandOn('layout', 'stopLoadingIndicator');
	    },
	
	    /**
	     * Force close any dropdowns using jq plugin event.
	     * Needed  propagation of a click event not allowed to reached the body level for some reason.
	     * Could also put on $.fn.dropdown.closeAll
	     */
	    forceClosePageActionDropdownMenus: function() {
	        this.view.$el.find('.dd-page-action-content').trigger('close');
	    },
	
	
	    //--- TODO: break apart into a pageOperations module/file ----
	
	    // page is either a single page model or an array of them;
	    // (want to move away from Backbone Collections towards ES6)
	    deletePages: function(page) {
	
	        this.activeDocument.deletePages( page instanceof Array ? page : [page] , this ).done( function( result ) {
	
	            var pagesDeleted = result.successfulPages,
	                errorPages = result.errorPages,
	                nFailures = errorPages.length,
	                nSuccesses = pagesDeleted.length,
	                bAllSucceeded = nFailures < 1,
	                bAllFailed = nSuccesses < 1,
	                bAnySucceeded = nSuccesses > 0;
	
	            //Note: alert is now at the top level view -- will remain shown throughout reloading of the document
	            this.trigger('alert:show', {
	                type: getMessageType(),
	                shortMessage: getShortMessage(),
	                detailedMsg: getDetailedMessage()
	            } );
	
	            // Don't reset document if all failed
	            if ( bAnySucceeded ) {
	
	                this._internalReset( {
	                    src: 'pageDeleted'
	                });
	            }
	
	            function getMessageType() {
	                if (bAllSucceeded) return 'success';
	                if (bAllFailed) return 'error';
	                return 'info';
	            }
	
	            function getShortMessage() {
	                if (bAllSucceeded) return (nSuccesses > 1 ? nSuccesses + ' ' : '') + 'Page' + (nSuccesses > 1 ? 's' : '') + ' Deleted';
	                if (bAllFailed) return 'Error Deleting ' + (nFailures > 1 ? nFailures : '') + ' Page' + (nFailures > 1 ? 's' : '');
	                return nSuccesses + ' Page' + (nSuccesses > 1 ? 's' : '') + ' Deleted. ' + 'Error Deleting ' + nFailures + ' Page' + (nFailures > 1 ? 's' : '');
	            }
	
	            function getDetailedMessage() {
	                // decision made not to print the error messages, and to show page #'s, not id's or sequences
	
	                if (bAllSucceeded)
	                    return null;
	
	               // Return the failed page numbers (of the current document at time of request) if all or some failed.
	               // If all failed, the viewer won't reset and this will be good.
	               // Potential improvement: if some failed include the old AND new pages # of the document;
	               // This is such a fringe case that not doing now, given priorities
	
	                return 'Failed to delete page' + (nFailures > 1 ? 's' : '') + ': ' + _.map(errorPages, function (p) {
	                        return p.pageNumber;
	                    }).join();
	
	            }
	
	        }).fail( function (jqXHR) {
	            this.command('ajaxError', jqXHR, 'Error Deleting Pages');
	        });
	
	    },
	
	    // If pgModel provided, show confirm to delete a single page.
	    // Otherwise, show the Delete Pages Dialog.
	    showDeletePageDialog: function( pgModel ) {
	
	        if ( pgModel ) {
	
	            this.trigger('modal:open', {
	                confirmType: 'warning',
	                title: 'Confirm',
	                content: 'Delete Page ' + pgModel.get('number') + '?',
	                okCB: _.bind( function() {
	                    this.command( 'deletePages', pgModel);
	                }, this )
	            });
	
	        } else {
	
	            var pgs = this.request('activeDocPages');
	            this.trigger('modal:open', {
	                modalView: new DeletePagesModal({
	                    numberPagesInDocument: pgs.length,
	                    okCB: _.bind( function(aPgsNumbers) {
	
	                        this.command( 'deletePages', typeof aPgsNumbers === 'string' && aPgsNumbers === 'currentPage'
	                                ? this.request('currentPage')
	                                : pgs.filter( function(p) {
	                                return _.contains( aPgsNumbers, p.get('number') );
	                            })
	                        );
	
	                    }, this)
	                })
	            });
	        }
	
	    },
	
	    showAddPagesDialog: function() {
	
	        var self = this;
	        this.trigger('modal:open', {
	            modalView: new AddPagesModal({
	
	                    okCB: function(fileList, insertAtPgNum) {
	
	                        self.activeDocument.addPages(fileList, insertAtPgNum).done( function(aPages) {
	
	                            // Unlike delete page, entire transaction will either succeed/fail
	                            var nPages = aPages.length;
	
	                            self.trigger('alert:show', {
	                                type: 'success',
	                                shortMessage: nPages + (nPages > 1 ? ' Pages' : ' Page') + ' Added',
	                            });
	
	                            self._internalReset( {
	                                src: 'pageAdded'
	                            });
	
	                        }).fail( function(jqXHR) {
	                            self.command('ajaxError', jqXHR, 'Error Adding Pages.');
	                        });
	
	                    }
	                })
	        });
	    },
	
	    showReorderPagesDialog: function() {
	
	        var self = this;
	
	        this.trigger('modal:open', {
	            modalView: new ReorderPagesModal({
	                currentPgNumber: this.request('currentPageNumber'),
	                numberPagesInDocument:  this.request('activeDocPages').length,
	
	                okCB: function(pgsToMove, destinationPg, insertAfter) {
	
	                    self.activeDocument.reorderPages.apply(self.activeDocument, arguments).done(function(aPages) {
	
	                        // aPages:  array of pg objects already in order of their new sequence (slightly than obj's than pg model)
	
	                        var nPages = pgsToMove.length;
	                        self.trigger('alert:show', {
	                            type: 'success',
	                            shortMessage: nPages + (nPages > 1 ? ' Pages' : ' Page') + ' Reordered'
	                        });
	
	                        // Determine the page # to re-open to on reset -- it's what would be the new page number of the
	                        // current page we're looking at (determined by page id).
	                        // ( The viewer API expects page #, not id )
	                        var currentPgId = self.request('currentPage').get('pageId'),
	                            pgToOpenTo = _.findWhere( aPages, { pageId: currentPgId }),
	                            pgNumToOpenTo = _.indexOf( aPages, pgToOpenTo ) + 1;  //(base 0 so add 1 -- like parse of page model collection)
	
	                        self._internalReset( {
	                            src: 'pageReordered',
	                            pgNumberToOpenTo: pgNumToOpenTo
	                        });
	
	                    }).fail( function(jqXHR) {
	                        self.command('ajaxError', jqXHR, 'Error Reordering Pages.');
	                    });
	
	                }
	            })
	        });
	
	    },
	
	    /*
	    * Toggle the value in local storage.
	    * Then re-render the shapes on the canvas, which will take updated value into account
	    * (if the page has redactions).
	    * */
	    toggleApplyAllRedactionsInPageMode: function() {
	
	        fvChannel.request('localStorage').toggleApplyAllRedactionsInPageMode();
	
	        var currentPage = this.request('currentPage');
	
	        // DVBC-1745 - former is a check in case document has no pages; the button
	        // and hotkey will not be disabled.
	        if ( currentPage && currentPage.hasRedactionNotes() )
	            this.commandOn('viewModes', 'applyAllRedactionsToggled');
	
	
	    },
	
	    /*
	     *  Central function that combines checking if the active document is locked,
	     *  with actions to perform afterwards in the possible scenarios: locked, unlocked, error checking.
	     *  ( So it's technically synchronous ).
	     *  Action: required -- the name of the action to be performed to be displayed in dialogs -- eg: 'Create Note'
	     *  unlockCB: required -- function to call if the document isn't locked.
	     *  lockCB: optional -- function to call if the document is locked. Default is showing an alert (prevent the action).
	     *  errorCB: optional -- function to call if error occurs hitting the endpoint.  Default is showing an alert (prevent the action).
	     *  checkIfLockedByOtherUser -- default false: if provided return that the doc if locked, only if by another user.
	     * */
	    checkActiveDocLockStatus: function( action, unlockCB, lockCB, errorCB, checkIfLockedByOtherUser ) {
	
	        var shortErrMsg = 'Cannot ' + Util.toTitleCase(action);
	
	        this.request('activeDocument').checkLockStatus( this )
	            .done( function( docLockResponse ) {
	
	                var checkLockedFn = checkIfLockedByOtherUser
	                    ? docLockResponse.isLockedByOtherUser
	                    : docLockResponse.isLocked;
	
	                if ( !checkLockedFn.call(docLockResponse) ) {
	                    unlockCB.call(this, docLockResponse);
	
	                } else {
	                    lockCB
	                        ? lockCB.call( this, docLockResponse )
	                        : this.command( 'showDocumentLockedErrorAlert', shortErrMsg, docLockResponse ); // could combo with this.vChannel.command('ajaxError', jqXHR, 'Error deleting note') and have logic in there
	                }
	
	            })
	            .fail( function( jqXHR ) {
	                errorCB
	                    ? errorCB.call(this, jqXHR )
	                    : this.command( 'ajaxError', jqXHR, shortErrMsg );
	            });
	    },
	    /*
	    * Unlock the document if it was locked by this application.
	    * No need to reset state.documentLockState ( viewer will not exist )
	    * */
	    unlockActiveDocumentBeforeUnload: function() {
	
	        if ( this.state.isDocumentLockedByApplication() )
	            this.request('activeDocument').unlockWithBeacon();
	
	    },
	
	
	    /*
	    * Wrapper around alert dialog to show document locked by other user messages.
	    * -- could combo with FV error 409 ???
	    * */
	    showDocumentLockedErrorAlert: function( shortErrMsg, docLockResponse ) {
	
	        this.trigger( 'alert:show', {
	            type: 'error',
	            shortMessage: shortErrMsg,
	            detailedMsg: docLockResponse.getDefaultErrorMessage()
	        });
	    },
	    /**
	     * Update layout after an 'element query resize event'
	     * Should make this an event: but first should make the main view a subApp
	     */
	    updateAfterViewerResize: function() {
	
	        if ( !this.request('viewerLoaded') )
	            return;
	
	        fvChannel.command('updateElementQuery');
	
	        // better mediation ... ( if thumbs active, the module would need to exist )
	        if (  this.getSubApp('layout').request('leftSideModel').isActivePane('thumbs') ) {
	            this.commandOn( 'thumbNails', 'checkInView' );
	        }
	
	        this.trigger('vChannel:resizeSidesIfOverlap');
	        this.command('setScale');
	
	    },
	
	    // This should be an event ... but I think I only have them as callback nows
	    repositionShapeDialog: function() {
	        this.commandOn( 'viewModes', 'repositionShapeDialog' );
	    },
	
	    /**
	     * Called when user hits click or clears the F&R search.
	     * Basically calls re-render of the canvas, which on render will reflect shapes from the f&r model.
	     * For consistency, could put this in part of the state API / callback architecture but would like to move away from that.
	     * Could reorganize and not have not store the model on the module and viewer state, but for now see now conflict requiring a refactor here
	     * - not a big deal, share the same memory reference
	     * - perhaps start it empty in the FT module and pass a new one for the viewer module
	     * - though it could be the case the module doesn't exist
	     * - * could also only ever reference from the full text module and not store on viewer state *
	     * TODO: may want to lock/unlock the document if entering ...
	     */
	    setFindAndRedactSearchModel: function( searchModel ) {
	
	        /* Update state with the model */
	        this.state.set( 'findAndRedactSearchModel', searchModel );
	
	        /* This would be the callback in the old state API arch */
	
	        // -- Exiting: a 'clear' OR search with no results --
	        if ( !searchModel.searchHasResults() ) {
	
	            // Always clear the lock initially obtained when hit enter on search form --
	            // If there are no results, immediately unlock ( user can't hit clear to unlock )
	            // Also, this will unlock on a regular clear.
	            this.command( 'unlockActiveDocument', 'FIND_AND_REDACT', 0, this, this.commands.updateToReflectFindAndRedactSearch );
	
	        } else {
	
	            /*  Entering: a search with results -*/
	            this.trigger( 'vChannel:openToSubPane', this.request('getLayout').rightSideModel, 'notes' );
	            this.command( 'updateToReflectFindAndRedactSearch' );
	
	        }
	
	    },
	
	    /**
	     * Can't just re-render -- need to call the wrapper on view modes ( see code ).
	     */
	    updateToReflectFindAndRedactSearch: function() {
	
	        this.commandOn( 'viewModes', 'redrawCanvasForFindAndRedact', this.state.get( 'findAndRedactSearchModel') );
	
	        /* Perhaps we want to highlight hits on a text layer in Doc Mode -- currently not doing ... maybe a phase II */
	        /* -- using text overlay: createFindAndRedactHitViews  ---
	         this.request('activeDocPages').each( function(page) {
	         page.trigger('pageView:showFindAndRedactHits', hitsCollection)
	         });
	         // If not in the mode, it may not be created if haven't entered yet ... will need to be higher up to show on render of all pages
	         this.request('fullPageModel').trigger('pageView:showFindAndRedactHits', hitsCollection);
	         */
	
	    },
	
	
	    destroyHiddenCanvas: function() {
	
	        this.dummyCanvasView && this.dummyCanvasView.destroy();
	        this.dummyCanvasView = null;
	
	    },
	
	    /* Called on load and viewModeChange */
	    setPageNavigationHotkeys: function( mode ) {
	
	        mode = mode || this.request('viewMode');
	
	        var docModeContainer = this.request('docModeContainer'),
	            pgModeContainer = this.request('pgModeContainer');
	
	        Util.blindForward( docModeContainer, 'unbindKeyboardEvents' );
	        pgModeContainer.unbindKeyboardEvents();
	
	        if ( mode === 'document' ) {
	            Util.blindForward( docModeContainer, 'bindKeyboardEvents' );
	        }
	
	        else if ( mode === 'page' ) {
	            pgModeContainer.bindKeyboardEvents();
	        }
	
	    }
	
	
	};
	
	/* ViewerState needed to set context of forward state callbacks */
	var ViewerChannelElements = function(viewerState) {
	    this.requests = requests;
	    this.commands = commands;
	    this.stateApi = new StateApi();
	    /* AUTO-FORWARD STATE FNS TO CHANNEL (also puts them on the channel */
	    extendAndforwardFunctions(this.requests, this.stateApi.requests, viewerState); /* merge API requests with channel requests, and make context of each the viewer state) */
	    extendAndforwardFunctions(this.commands, this.stateApi.commands, viewerState);
	    /* done for outer module, events, state model events (including scaleModel) */
	    /* generate subscriptions from the outerEvents and corresponding outerEvents callbacks that the channel will listen to*/
	    this.subscriptions = generateSubscriptions();
	    //todo: destroy
	};
	
	/* target: where to forward the fn, fnHash: 'key-value' of 'fnName': fn, context : that to call the fn */
	function extendAndforwardFunctions(target, fnHash, cxt) { //todo: util
	    _.each( _.pairs(fnHash), function(fn) {
	        var fnName = fn[0];
	        target[fnName] = function() {
	            return fn[1].apply(cxt, arguments);
	        };
	    });
	}
	
	
	/* the hash of event-cb */
	
	//todo: if getting rid of the cb hash -- the events listened for outside subs aren't prefaced by the event name -- tha is why had hash
	// could use naming scheme
	//these are then added to the viewer channel subscriptions
	function generateSubscriptions() {
	    var hookCBs = function (eventHash, callbacks) {
	            var hooks = {};
	            for (var k in eventHash) { //careful w/fns
	                hooks[k] = callbacks[eventHash[k]];
	            }
	            return hooks;
	        },
	
	        categoriedCBHash = OuterEventCallbacksByModule,
	        categories = _.keys(categoriedCBHash),
	        allHooks = {};
	
	
	    /* outer subscription cbs -- fmt: evt 'alert:show' --> alertShow -- the actual used */
	    _.each(categories, function(c) {
	        var catCBs = categoriedCBHash[c];
	        _.each(catCBs, function(cbFn, cbName) {
	            var h = {};
	            h[cbName] = cbFn;
	            _.extend(allHooks, h);
	        });
	
	    });
	
	    /* state: just put in same file? */
	    _.extend(allHooks,
	        hookCBs(StateModel.prototype.events, StateCBs),
	        hookCBs(StateModel.prototype.scaleEvents, StateCBs)); //actually bind events to callbacks of vm
	
	    return allHooks; //want obj
	}
	
	
	module.exports = ViewerChannelElements;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var fvChannel = __webpack_require__(72).channel('FV');
	
	/*
	* Context is viewer.
	* Many of these have links to this.state
	* Note: events triggered from external modules -- forward to inner
	* TODO: clean -- state now forwarded through channel and channel via viewer;
	* vChannelEvents -->  channel
	* NOTE: the function name MUST be the event that triggers it -- no longer secoNdary XREF !
	* the fn NAMES are the EVENT names
	* Here to be backwards compatible with the old events triggered off 'viewerModel' (state)
	* TODO: now some actions pre state api call set here -- just forward and do the actions in the api
	* */
	
	
	module.exports = {
	
	    common: {
	
	        // Main View is now not a sub app, perhaps it should be
	        'alert:show': function(options) {
	            this.command('mainView.showAlert', options);
	        },
	        'alert:hide': function() {
	            this.command('mainView.hideAlert');
	        },
	        'modal:open': function(options, isLoading) {
	            this.commandOn( 'viewModes', 'closeCanvasDialogs' );
	            this.commandOn( 'layout', 'showModal', options, isLoading );
	
	        },
	        'modal:close': function() {
	            this.commandOn('layout', 'closeModal');
	        }
	
	    },
	
	    notes: {
	        'notes:goToPage': function (note) {
	            this.state.goToPageOfNote(note);
	        },
	
	        'notes:setActiveNote': function (note, options) {
	            this.state.setActiveNote(note, options);
	        },
	
	        'notes:setExpandedNote': function (note) {
	            this.state.setExpandedNote(note);
	        },
	
	        'notes:noteSaved': function (note) { //(really post save)
	
	            if ( note.isPageNote() ) {
	
	                // The note was already added to the allNotes collection.
	                // Also add it to the pageNotes collection.
	                this.request('pageNotes').add( note );
	
	                // Also and the collection's of the page models in each 'mode'.
	                // And because multiple copies of the same page can be in the same document,
	                // we need to add the note for each page of the note (not just the current page).
	                // Note: the pageCollection is the 'doc mode' page model.
	
	                var pgsWithNote = this.request('activeDocPages').filter(function(p) {
	                    return note.get('pageId') === p.get('pageId');
	                });
	
	                _.each( pgsWithNote, function(page) {
	                    var docModePg = page,
	                        thumb = this.request('getThumbFromPageModel', page);
	                    _.invoke([docModePg, thumb], 'addNewPageNote', note);
	                }, this);
	
	                // For the full page model, use just the current page.
	                // Only one model ever exists -- whenever a page is changed a new model is created and ,
	                // it's notesCollection will be updated from the docMode page model.
	                // TODO: Find and Redact: only add to the full page model if its on the current page --- may want to refactor all this to reflect ...
	                if ( note.get('pageId') == this.request('currentPage').get('pageId') ) {
	                    this.request('fullPageModel').addNewPageNote(note);
	                }
	
	
	            } else {
	
	                this.request('docNotes').add(note, {sort: false});
	
	            }
	
	            //* always use the allNotes collection (flashBack notes are not tied to the collection so referencing from will err )
	            this.commandOn('layout', 'updateNoteCount', this.request('allNotes').length);
	
	
	            // Re-render canvas for drawable notes
	
	            if ( note.isDrawable() ) {
	
	                // And: trigger a re-render on the canvas of if the note is on the current page -- FIND AND REDACT
	                if (note.get('pageId') == this.request('currentPage').get('pageId')) {
	                    this.commandOn('viewModes', 'noteSaved', note);
	                }
	            }
	
	        },
	
	        /*
	         * Note: Backbone's internals will remove the model from any of its collections on destroy --
	         * ( Backbone's model.destroy triggers an event listened to by the collections: see Collection's modelEvents );
	         * So we don't need to remove from page/doc notes collections, as well as all of the page model's collections.
	         */
	        'notes:noteDeleted': function (note) {
	
	            this.commandOn('layout', 'updateNoteCount', this.request('allNotes').length);
	            this.commandOn('viewModes', 'noteDeleted', note);
	
	        },
	        /*
	         * Note: called twice from canvas (... still ? )
	         */
	        'notes:setNoteSubType': function () {
	            this.state.set.apply(this.state, ['activeNoteSubType'].concat(_.toArray(arguments)));
	        },
	
	        'notes:newNoteMenuRendered': function () {
	
	            this.commandOn.apply( this, ['layout', 'createNewNoteMenu'].concat(
	                _.toArray(arguments)).concat([this.request('getWrapper')])
	            );
	        },
	
	        'notes:setDrawColor': function (color) {
	            this.commandOn('viewModes', 'setDrawColor', color);
	        },
	        'notes:setDrawStrokeWidth': function (width) {
	            this.commandOn('viewModes', 'setStrokeWidth', width);
	        },
	        'notes:toggleShapeHighlight': function (note, options) {
	
	            if (this.state.noteIsActiveOrExpanded()) {
	                return false;
	            }
	
	            this.commandOn('viewModes', 'toggleHighlightedNote', note, options);
	
	        },
	        'notes:graphicStampChanged': function () {
	
	            this.commandOn.apply(this, ['viewModes', 'graphicStampChanged'].concat(_.toArray(arguments)));
	
	        },
	
	        'notes:consultGroupChange': function( note ) {
	
	            this.commandOn( 'viewModes', 'consultGroupChange', note );
	
	        }
	    },
	
	    //NOTE: FIRE OFF THE PAGE MODEL PUT A CHANNEL ON IT? ... ????
	    /* NOTE: NOW REALLY PAGE CANVAS -- there is a one to many relationship, but for the below all events would be one to one */
	    /* Not making major change in the architecture so don't break -- see other branch ...*/
	
	    canvas: {
	        /* only one note can be hovered at a time, even with multi canvas' */
	        'canvas:hoveredNoteChange': function () {
	
	            if (this.state.noteIsActiveOrExpanded())  //TODO: also if panel is open
	                return false;
	
	            this.commandOn.apply(this, ['notes', 'hoveredCanvasNoteChange'].concat(_.toArray(arguments)));
	
	        },
	        /* because only one note can be edited at a time, can leave as 'many to many' */
	        'canvas:drawingToggled': function () {
	            this.commandOn.apply(this, ['notes', 'canvasDrawingToggled'].concat(_.toArray(arguments)));
	        },
	
	        /**
	         * Because only one note can be edited at a time, can leave as 'many to many'.
	         * Mediate state call
	         * Note: called twice from canvas
	         */
	        'canvas:changeActiveNoteSubtype': function () {
	
	            this.state.set.apply(this.state, ['activeNoteSubType'].concat(_.toArray(arguments)));
	        },
	
	        /**
	         * Because only one note can be edited at a time, can leave as 'many to many'
	         * Here because can cancel from button -- unlike other types.
	         */
	        'canvas:cancelSignature': function (noteModel) {
	            this.commandOn.apply(this, ['notes', 'cancelSignature'].concat(_.toArray(arguments)));
	        }
	
	    },
	    fullText: {
	
	        'fullText:changePage': function (pgNum) {
	            var pg = this.request('activeDocPages').getModelFromPgNumber(pgNum);
	            // (eg page may not exist if a dummy 'meta data' page from ES module (<1) or with dummy data
	            if (!pg) return;
	            this.state.goToPage(pg);
	        },
	
	        'fullText:updateNoteCountAndCaption': function () {
	            this.commandOn.apply(this, ['layout', 'updateFullTextNoteCountAndCaption'].concat(_.toArray(arguments)));
	        }
	
	    },
	
	    findAndRedact: {
	
	
	        /**
	         * Set findAndRedactSearchModel.userClickedHitId which is picked up on canvas re-render process to select the shape.
	         * userClickedHitId is cleared immediately after the reRenderShapes, so its not persisted ( this is unlike toggleExpanded )
	         * So we set 'isSelected' on it and incorporate into the render process in the canvas,
	         * which is also called when page/mode is causing a canvas re-render.
	         */
	
	        'findAndRedact:goToHit': function( hitModel ) {
	
	            this.state.get('findAndRedactSearchModel').set(
	                { userClickedHitId: hitModel.get('id') }, { silent: true }
	            );
	
	            // First same logic as in expanded note/active note change if could be on diff mode/page
	            // Mode: still unsure if we will allow going back and forth when find and redact open ...
	            var inPageMode = this.state.viewMode() === 'page';
	            var onSamePage = hitModel.get('pageNumber') === this.state.currentPageNumber();
	
	            // Re-render the shapes on the canvas; selected shapes of the hit will be picked up and
	            // selected accordingly in the process
	            if ( inPageMode && onSamePage ) {
	
	                // Here could by-pass userClicked hitId and re-render process -- could use
	                // var shapeOfHit = hitModel.get('shape')
	                // and set it to the select shape but using the same process is cleaner.
	                this.commandOn('viewModes', 'reRenderShapes');
	                return;
	            }
	
	            // Workflow from expanded/active note which will ultimately result in a canvas re-render,
	            // so no need to kick off the 're-render' manually.
	            if ( !inPageMode ) {
	                this.state.setViewMode('page');
	            }
	
	            // Last would take over the render of the canvas
	            if ( !onSamePage ) {
	                this.state.goToPageId( hitModel.get('pageId') );
	            }
	
	            // Old comments -- I don't think still an issue:
	
	            // If change viewMode and page mode, createPageModeView will be kicked off twice (fast) which will call createPageModeView, which then
	            // calls, renderPgModePgView --> starting the request process, which when successful, results in creating a canvas and calling 're-renderShapes'
	            // this this happens so fast, re-render shapes likely cannot be called twice -- maybe we have a setViewMode which doesn't create a new page model if both will
	            // be changed, or do won't about this?
	
	            // if create and render canvas is called twice --> onBeforeDestroy will be called on the 2nd, so could 'clear' then;
	            // probably safe to do after shapes have been re-rendered in the canvas module
	
	            // Could put in logic to not create the viewMode on viewMode change callback -- but that part will go so fast I don't think we will run into issue.
	
	        },
	
	        'findAndReact:revertShapePosition': function(hitModel) {
	
	            var shape = hitModel.get('shape');
	
	            shape.set({
	                points: shape.get('originalPointsInTenthsMM')
	            }, {silent: true});
	
	            // Note: floating code redaction shape models 'persisted' here --
	            // in the call 'points' are set to 'points', not taking from the DOM, so this now works
	            this.commandOn('viewModes', 'reRenderShapes');
	
	            // Trigger back on the hit view
	            shape.uiModel.set('isDirty', false);
	
	        },
	
	        'findAndRedact:hitShapeReasonCodesChange': function( shape, aCodes, fromSelectAllOrClear ) {
	
	            if ( !shape.parentNote.isFloatingRedaction() ) {
	                updateShapeModelsReasonCodeCollection();
	                return;
	            }
	
	            // Floating Redaction:
	            // Set for page change and mode change ( when canvas has loaded )
	            // -- want to draw from 'default position' to get new size of box.
	
	            shape.setBoxIsDirty(true);
	
	            // 'Show' the page mode view so size of the box can be calculated (it can't is hidden via css)
	            // Only do if page had already loaded, where a re-render wouldn't have been called
	            // ( If not yet rendered, they will be put at default position in that mode )
	            var toggleVisibilityOfPageMode =
	                this.request('viewMode') !== 'page' && this.request('fullPageModel').get('isLoaded');
	
	            if (toggleVisibilityOfPageMode) {
	                this.commandOn('viewModes', 'toggleForceDerivisionOfPageModeDomElements', 1);
	            }
	
	            updateShapeModelsReasonCodeCollection();
	
	            // Set back page mode css / visibility
	            if (toggleVisibilityOfPageMode) {
	                this.commandOn('viewModes', 'toggleForceDerivisionOfPageModeDomElements', 0);
	            }
	
	
	            function updateShapeModelsReasonCodeCollection() {
	
	                if ( !fromSelectAllOrClear ) {
	                    shape.colRedactionCodes.set( aCodes, {sourceNotFromChosen: 1 });
	                } else {
	                    shape.colRedactionCodes.reset( aCodes, {sourceNotFromChosen: 1 });
	                }
	
	            }
	
	        },
	        /* Without changes to Canvas:HoverEdit Dialog -- make sure find and redact and zone dialgos aren't open at the same time */
	        /* This will prevent our having to keep them in sync if any 2 are open */
	        /* Workaround for the hover edit dialog not being a regular dropdown */
	        /* Will also need to implement the other way around ( canvas to find and redact ) -- now called directly on the shape model
	         * -- we could do that here too but instead utilizing existing closeCanvasDialogs */
	        'findAndRedact:openHitShapeDialog': function( shape ) {
	            this.commandOn( 'viewModes', 'closeCanvasDialogs' );
	
	        }
	
	    }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    Util = __webpack_require__(48),
	    $ = __webpack_require__(59),
	    blindForward = Util.blindForward;
	
	
	/*
	 *
	 * Post making the state change
	 * Really on same level as channel -- though deals directly with state changes
	 * request, reply to channel
	 * Context is the viewer instance (subapp)
	 *
	 * */
	
	
	module.exports = {
	
	    //note: doesn't imply is 'visible' -- different event for that
	    viewerLoaded: function(state) {
	
	        var viewMode = state.viewMode();
	
	        this.command( 'setPageNavigationHotkeys', viewMode );
	
	        if (state.viewMode() === 'pdf') {
	
	            this.request('allowPdfToLoad') && this.request('pdfModeContainer').loadPDFDocument();
	
	        } else if (viewMode === 'page') {
	
	            this.command('createPageModeView', {src: 'viewerRendered'});  // this could be a deferred ..
	
	            // Note: view mode will always be set to page first if create new redaction on entry,
	            // and the command must be called after the canvas has already been created.
	
	            this.settings.createNewRedactionOnEntry() && this.command('createNewRedaction');
	
	        } else if (viewMode === 'document') {
	
	            /**
	             * Do this before when 'setInitialScale is called, the subPanels aren't yet open so the calculation if off --
	             * temp workaround; years later needs inspection.
	             * TODO: overlap with entry on viewModechange, others?
	             */
	            state.setScale();
	            this.command('checkForDocModeImagesInView');
	            this.command('handleDocModeImgPrefetching', this.request('currentPage')); // Quick fix on load -- otherwise only called on pg change
	
	            // Would want thumbs here too, but now there are never open on load -- this may change
	        }
	
	        if ( this.request('docHasNoRenderablePgs') ) {
	            this.commandOn('layout', 'toggleRotateEnabled', true); //disable -- don't check fn (current Page will be null)
	        }
	
	        // Really want after show of layoutView but this should cache it -- want a resizeEvent to update the layout
	        this.command('updateAfterViewerResize');
	
	        var onLoad = this.request('settings').get('onLoad'); //TODO: better mediate (radio on settings?)
	        onLoad && onLoad.call(this, this);
	
	
	    },
	    /* note: for now options is for fromFullScreenToggle, and now maybe fromRotation */
	    scaleChange: function(sm, scale, options) {
	
	        this.commandOn( ['viewModes', 'layout'], 'changeScale', sm.get('mode'), scale, sm.previous('scale'), sm, options );
	
	    },
	    scaleTypeChange: function() {
	
	        this.state.viewMode() === 'page' &&
	            this.commandOn('viewModes', 'scaleTypeChange');
	
	    },
	    changeActiveNote: function(state, note, options) {
	
	        // Always ensure open -- eg won't be if called from header bar (it's closed by default)
	        this.trigger( 'vChannel:openToSubPane', this.request('getLayout').rightSideModel, 'notes' );
	
	        var isMultiDoc = this.request('documents').length > 1;
	        isMultiDoc && this.command('toggleMultiDocInterfaces', !note);
	
	        var prNote = state.previous('activeNote');
	
	        var commandOptions =  _.extend( options, {
	            prNote: prNote,
	            viewMode: state.get('viewMode'),
	            disableRotation: state.disableRotation()
	        });
	
	        // Toggle 'Edit Mode' on the Canvas -- only do if drawable note
	        // With find and redact -- maybe we call toggleDrawing mode ..
	        // Logic could but set prior in API
	        if ( note && note.isDrawable() ) {
	
	            this.commandOn( 'viewModes', 'activeNoteChange', note, commandOptions );
	
	        } else {
	
	            if ( prNote && prNote.isDrawable() ) {
	                this.commandOn( 'viewModes', 'activeNoteChange', note, commandOptions );
	            }
	        }
	
	        this.commandOn( ['notes', 'layout'] , 'activeNoteChange', note, commandOptions );
	
	    },
	    changeExpandedNote: function( state, note ) {
	
	        this.commandOn(['viewModes', 'notes', 'layout'], 'expandedNoteChange', note, {
	            prNote: state.previous('expandedNote'),
	            disableRotation: state.disableRotation()
	        });
	
	    },
	    changeActiveNoteSubType: function(state, noteType, options) {
	
	        this.commandOn(['viewModes', 'notes'], 'activeNoteSubTypeChange', noteType, _.extend( options, {
	            activeNote: state.activeNote()
	        }));
	
	    },
	
	    changeCurrentPage: function(state, page, options) {
	
	        state.set({ fullPageModel: this.request('getNewFullPageModelFromDocModePage', page) });
	
	        // Want this always called on doc mode even if not loaded --
	        // so max image loaded can't exceed threshold (though may not yet exist)
	        // Will only call on docModeView if it exists
	        this.commandOn( 'viewModes', 'docModeChangePage', {
	            loadImages: state.loadImages()
	        });
	
	
	        if (options.initialLoad)  //at first, just set the models
	            return;
	
	
	        // Should have these results of the trigger below ... would be things clearer maybe
	        this.command('createPageModeView', {
	            src: 'pageChange'
	        });
	
	        this.command( 'goToThumbnail', page );
	
	        this.commandOn(['fullText', 'notes', 'layout', 'findAndRedact'], 'changePage', {
	            pageNum: page.get('number'),
	            page: page,
	            activeNote: state.activeNote(),
	            isFirstPg: state.isFirstPage(),
	            isLastPg: state.isLastPage(),
	            disableScaling: this.request('disableScaling'),
	            disableRotation: state.disableRotation()
	        });
	
	    },
	    /*  Doc Mode Container may now not exists; they other modes should always be present for now */
	    changeViewMode: function (state, mode, options) {
	
	        var prevMode = state.previous('viewMode'),
	            docModeContainer = this.request('docModeContainer'),
	            pgModeContainer = this.request('pgModeContainer'),
	            pdfModeContainer = this.request('pdfModeContainer');
	
	        this.commandOn( 'layout', 'toggleHeaderViewMode', mode, prevMode );
	        this.commandOn( 'viewModes', 'setViewMode', mode, prevMode );
	
	        this.command( 'setPageNavigationHotkeys', mode );
	
	        switch (mode) {
	            case 'document':
	
	                // perhaps we want a layout 'refresh' ( see onLoad )
	                setTimeout( state.setScale, 0 );
	                blindForward( docModeContainer, 'scrollToCurrentPageTop' );
	                this.command('checkForDocModeImagesInView');
	                break;
	
	            case 'page':
	
	                /* Note: could already be created */
	                this.command('createPageModeView', {src: 'modeChangeEntry'});
	                break;
	
	            case 'pdf':
	
	                // Don't ever allow thumbnail pane to show in this mode
	                var leftSideModel = this.request('getLayout').leftSideModel;
	                leftSideModel.isSubPanelOpen('thumbs') && leftSideModel.close();
	
	                if (!state.get('pdfRendered')) {
	                    // should write enter/exit fn for the mode containers
	                    //(if rotated and re-entering, hide the pdf that is currently showing while the other loads) -- starts invisible anyway on load
	                    pdfModeContainer.ui.pdfWrapper.addClass('invisible');
	                    this.request('allowPdfToLoad') && pdfModeContainer.loadPDFDocument();  //don't want to reload, just do this
	                }
	                break;
	        }
	
	        this.commandOn( 'notes', 'viewModeChange', mode, _.extend( options, {
	            pagesExist: this.activeDocument.pageCollection.length > 0,
	            currentPage: state.currentPage(),
	            activeNote: state.activeNote(),
	            previousMode: prevMode
	        }));
	
	    },
	    toggleLoadImages: function(state, loadImages) {
	
	        if (!loadImages)
	            return;
	
	        /* Note, thumbnails sidepane, on open checkInView triggered
	            -- but the individual thumbs aren't listening if loadImages was false -- so here, make them no listen */
	        this.commandOn( 'thumbNails', 'listenForThumbsToBeInView' );
	
	        // Trigger image loading in the current mode -- don't do across all modes
	        switch ( state.viewMode() ) {
	
	            case 'pdf':
	                this.request('allowPdfToLoad') && this.request('pdfModeContainer').loadPDFDocument();
	                break;
	
	            case 'page':
	                this.command('createPageModeView', {src: 'toggleLoadImages'});
	                break;
	
	            case 'document':
	
	                // Should combo logic for loading inview as well as the page queue
	                this.command('checkForDocModeImagesInView');
	
	                // DVBC-1010 -- FIXES, but then breaks toggle full screen (may break others)
	                // this.command('handleDocModeImgPrefetching', this.request('currentPage'));
	                break;
	        }
	
	    },
	    /**
	     *  Note: intertwined with set scale
	     *  DOM element changes will trigger window resize event, causing recursion with setScale
	     **/
	    toggleFullScreenMode: function (state, isFullScreen) {
	
	        /**
	         * el is detached, then retached ...
	         * When detached from dom, scrollTop will be set to the top
	         * Should incorporate method for all div's with overflow -- now just this one.
	         */
	        var esScrollRatio = this.requestOn('fullText', 'vChannel:scrollTopRatio');
	
	        this.command('mainView.toggleFullScreen');
	
	
	        this.commandOn('layout', 'toggleFullScreen', isFullScreen);
	
	        // Note: a sync re-appending to the DOM
	        this.commandOn('fullText', 'vChannel:setScrollPosition', esScrollRatio);
	
	        // fromFullScreenToggle: indicator that we're coming from full screen mode: page, newScale, newScaleType (s/b object)
	        // ( I don't believe used anymore )
	        this.command( 'setScale', undefined, undefined, {
	            fromFullScreenToggle: true
	        });
	
	        // Note: ( could be superflous if the scale changed but no large performance hit )
	        this.command( 'repositionShapeDialog' );
	
	    },
	
	    panelResizingChange: function (st, val) {
	        this.command('forceClosePageActionDropdownMenus');
	        this.commandOn('notes', 'togglePanelResize', val);
	    },
	
	
	
	    // TODO: for now we don't want this ... get feedback; I think maybe only text only mode
	
	    togglePageTextMode: function( state, showPageTextMode ) {
	
	        // Always trigger on Doc Mode --- views are created but may not yet be loaded.
	        // TODO: actually, maybe only if loaded or on entry into the mode?  Could be processing intensive
	
	        if ( this.request('includeDocumentMode') ) {
	
	            var docModePages = this.request('activeDocPages');
	            docModePages.each( function(page) {
	                page.trigger('pageView:toggleTextLayer', showPageTextMode );
	            });
	
	        }
	
	
	        // Even if not in mode or page mode's view hasn't been loaded, full page model should exist
	        // Always trigger ( eg user toggles in Doc/PDF mode, we want it updated upon re-entry
	        state.fullPageModel().trigger('pageView:toggleTextLayer', showPageTextMode);
	
	    },
	
	    // See comments from togglePageTextMode: mostly same strategy ...
	    toggleTextOnlyMode: function( state, textOnlyMode ) {
	
	        if ( this.request('includeDocumentMode') ) {
	
	            var docModePages = this.request('activeDocPages');
	            docModePages.each( function(page) {
	                page.trigger('pageView:toggleTextOnlyMode', textOnlyMode );
	            });
	
	        }
	
	        state.fullPageModel().trigger('pageView:toggleTextOnlyMode', textOnlyMode );
	
	    }
	
	
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/*
	 * Default Callback Fn's For the CRE plugin interfacing with a Progress Modal View .
	 * ( used whenever progress/abort is desired ).
	 * Used For Document and Page Downloads, As Well As Inline PDF.
	 * TODO:
	 * - make this part of the main view (layout)?
	 * - could set the context to the viewer model
	 * - a CRE module? ... looking like this
	*/
	
	
	var fvChannel = __webpack_require__(72).channel('FV'),
	    DownloadView = __webpack_require__(108),
	    $ = __webpack_require__(59);
	
	
	module.exports = function(options) {
	
	    var vCh = options.vChannel;
	
	    return {
	
	        onStart: function() {
	
	            vCh.trigger('modal:open',  {
	                heading: (options.inlinePDF ? 'Loading ' : 'Downloading ') + (options.isPDF ? 'PDF' : 'Original'),
	                cancelTitle: 'Cancel Download',
	                onCancel: _.partial($.fn.creRequest.cancel, {byForce: true}) /* note .cancel will exist because a request must have been made -- see DVBC-807 -- should change arch or plugin */
	            }, true);
	
	            options.startCB && options.startCB();
	
	        },
	
	        onComplete: function(data) {
	
	            vCh.trigger('modal:close');
	
	            /*
	             * Download in hidden frame view.
	             * TODO: ( still? )
	             * - change name to 'noAutoDownload
	             * - could have frame in region
	             */
	            if ( !options.inlinePDF ) {
	
	                var downloadView = new DownloadView({
	                    src: data.downloadUrl,
	                    container: $( vCh.request('getWrapper') )
	                }).render();
	            }
	
	            options.completeCB && options.completeCB(data);
	        },
	
	        onError: function(errMsg) {
	
	            vCh.trigger('modal:close');
	
	            /*
	             * May not want to show -- eg for pdf inline -- an auth check is made afterwards, then show then err message shown.
	             * All of these could have the auth'd check
	             */
	            if ( !options.dontShowErrMsg ) {
	
	                vCh.trigger('alert:show', {
	                    type: 'error',
	                    shortMessage: 'Download Error',
	                    detailedMsg: errMsg,
	                    closeTimeout: 3000
	                });
	
	            }
	
	            options.errorCB && options.errorCB(errMsg);
	        },
	
	        onCheckState: function(renderStatus) {
	
	            var rs = renderStatus;
	            this.loadingView = this.loadingView || vCh.request('modalView'); //(new obj req'd each time)
	            this.loadingView.triggerMethod('updateStatus', rs.completedPages, rs.totalPages, rs.stateDesc);
	
	        },
	
	        onCancel: function(renderStatus, cancelOpts) { //(when the cancel is complete -- user or force)
	
	            var byForce = cancelOpts && cancelOpts.byForce; //(now from reset -- byForce implies uses hit cancel)
	            vCh.trigger('modal:close') ;
	
	            /* User Cancelled */
	            if (!byForce) {
	                vCh.trigger('alert:show', {
	                    type: 'info',
	                    shortMessage: 'Download Cancelled',
	                    closeTimeout: 3000
	                });
	            }
	
	            options.cancelCB && options.cancelCB(options);
	
	        },
	        /*
	         * When request to cancel fails
	         */
	        onCancelError: function(errMsg) {
	
	            vCh.trigger('modal:close');
	
	            vCh.trigger('alert:show', {
	                type: 'error',
	                shortMessage: 'Cancel Error',
	                detailedMsg: errMsg,
	                closeTimeout: 3000
	            });
	
	            options.cancelErrCB && options.cancelErrCB();
	
	        },
	
	        CRE_ROOT: fvChannel.request('settings').getCRERoot(), // put in in api_url ?
	        POLL_FREQ:  fvChannel.request('settings').crePollInterval
	
	    };
	
	};
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59);
	
	module.exports = Marionette.ItemView.extend({
	    tagName: 'iframe',
	    className: 'hide',
	    CLOSE_TIMEOUT: 30000, /* closing prior to download will cancel request*/
	    //CHECK_INTERVAL: 100,
	    //COOKIE_NAME: 'FSESSIONID', //may be good to reimplement cookie: could then closing dialog on queue
	    render: function() {
	        var self = this;
	        //setTimeout(function() {
	           // self.checkForDLCompletion();
	        //}, this.CHECK_INTERVAL);
	        this.options.container.append(this.$el.attr('src', this.options.src));
	
	        setTimeout(function() {
	            self.destroy();
	        }, this.CLOSE_TIMEOUT); //todo: try this to safe memory: the download is complete once the source is set?
	        return this;
	    }
	    /*,
	    checkForDLCompletion: function() {
	        var doc = this.el.contentWindow.document,
	            self = this;
	
	        //todo: nevermind -- not getting cookie --- just try removal of frame
	        if (doc.cookie.indexOf( this.COOKIE_NAME) > -1 ){
	
	            this.dlCompleted();
	            return;
	        }
	
	        //check for 'FSESSIONID'
	        //FSESSIONID
	
	        //setTimeout( self.checkForDLCompletion.call(self), self.CHECK_INTERVAL);
	    },
	    dlCompleted: function() {
	
	    }
	    //todo: still checking for completion?*/
	
	
	});

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {// TODO: may need to give modal the ability to have a sub-view / views
	// ... current uses have it overridable or have content that doesn't require interaction
	// this is extending the existing modal dialog directly
	
	// TODO: when modal is open, disable document keyboard events -- currently used in mousetrap
	
	var Modal = __webpack_require__(110),
	    _ = __webpack_require__(49),
	    Util = __webpack_require__(48);
	
	__webpack_require__(137);
	
	module.exports = Modal.extend({
	    baseModalDefaults: {
	        title: 'Delete Page'
	    },
	    contentTemplate: __webpack_require__(138),
	    initialize: function(options) {
	
	        // what is used to validate entered page numbers
	        this.numberPagesInDocument = options.numberPagesInDocument;
	
	        this.settings = _.extend( {}, {
	            content: this.contentTemplate( this.serializeContentTemplateData() )
	        }, options );
	
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );
	
	        return this;
	    },
	
	    serializeContentTemplateData: function() {
	        return {
	            randomInputName: Util.getUniqueStrToDisableFormAutoComplete()
	        };
	    },
	
	    ui: _.extend( {}, Modal.prototype.ui, {
	        form:                   '#delete-pgs-form',
	        currentPgCheckbox:      '#delete-current-pg-cb',
	        pageRangeCheckbox:      '#delete-pg-range-cb',
	        radioButtons:           '.delete-pgs-radio',
	        pageRangeInput:         '#delete-pg-range-input',
	
	        // may want to make validation and these common ...
	        errorMessageWr:         '#delete-pgs-err-msg-wr',
	        errorMessageTxt:        '#delete-pgs-err-msg-txt'
	    }),
	
	    events: _.extend( {} , Modal.prototype.events, {
	        'submit @ui.form':                  'onFormSubmit',
	        'change @ui.radioButtons':          'onRadioBtnChange'
	    }),
	
	    onFormSubmit: function(e) {
	        // simulate 'ok' -- not optimal or most symantic (buttons are outside it)
	        // but at least will capture the enter key when the selection range input is focused
	        /// ... in the future ...
	        e.preventDefault();
	        this.ok();
	    },
	
	    onRadioBtnChange: function(e) {
	        var pageRangeSelected = $(e.target)[0] === this.ui.pageRangeCheckbox[0];
	        this.ui.pageRangeInput.attr( 'disabled', !pageRangeSelected );
	        pageRangeSelected &&  this.ui.pageRangeInput.select();
	    },
	
	    ok: function() {
	
	        if (  this.ui.currentPgCheckbox.is(':checked') ) {
	            this.destroy();
	            this.settings.okCB( 'currentPage' );
	            return;
	        }
	
	        var pgsToDelete = this.getPagesToDelete( this.ui.pageRangeInput.val() );
	
	        if (typeof pgsToDelete === 'string') {
	            this._showValidationErrorMsg(pgsToDelete);
	        } else {
	            this.destroy();
	            this.settings.okCB( pgsToDelete );
	        }
	
	    },
	    _showValidationErrorMsg: function(msg) {
	        this.ui.errorMessageWr.removeClass('hide'); // could make top level in css
	        this.ui.errorMessageTxt.html(msg);
	    },
	
	    // If the range is invalid, return an error message.
	    // Otherwise, return an array of page numbers to delete.
	    getPagesToDelete: function(range) {
	
	        if (!range)
	            return 'Page Range Required';
	
	        // remove any spaces -- expression below allows for spaces in the middle of reg ex but not at beg or end
	        range = range.replace(/\s/g, '');
	
	        // https://stackoverflow.com/questions/25931053/validate-page-numbers-ranges-for-printing
	        // https://regex101.com/r/lS8vP9/3
	
	        var re = /^(?!([ \d]*-){2})\d+(?: *[-,] *\d+)*$/gm;  // If use actual #'s, could make the expression a variable and put those in there ...
	        if (!re.test(range))
	            return 'Invalid Page Range';
	
	        // Handle Duplicate Page Numbers -- just add to the dupes
	        // Handle Page Numbers Exist (including 0) -- show error ...
	        // Handle range if its of the same page (1-1), should be 1 ...
	        // Handle leading 0s in numbers (parseInt should get this)
	
	        var aPgs = [], // array of pages to return, (all are valid -- exist in the document)
	            invalidPgs = [];
	
	        _.each( range.split(','), function(section) {
	
	            if ( section.indexOf('-') < 1 ) {
	
	                //single page
	                var pgNum = parseInt(section);  // handles leading zeroes and make an integer
	
	                validatePageNumber(pgNum, this.numberPagesInDocument)
	                    ? aPgs.push( pgNum )
	                    : invalidPgs.push( pgNum );
	
	            } else {
	
	                //range
	                var pgs = section.split('-'),
	                    pg1 = parseInt( pgs[0] ),
	                    pg2 = parseInt( pgs[1] ),
	                    pg1IsValid = validatePageNumber(pg1, this.numberPagesInDocument),
	                    pg2IsValid = validatePageNumber(pg2, this.numberPagesInDocument);
	
	                if (pg1IsValid && pg2IsValid) {
	
	                    // both pages are valid: push the range of numbers between them
	                    var pgMin = Math.min( pg1, pg2 ),
	                        pgMax = Math.max( pg1, pg2 ),
	                        pagesInRange = _.range( pgMin,  pgMax );
	
	                    // underscore range 'start' is inclusive, 'stop' is exclusive, so always add the last one to the end
	                    aPgs.push.apply( aPgs, pagesInRange.concat(pgMax) );
	
	                    // maybe want to add pages that were in the range if some weren't .... now hard failing on there
	                    // should those valid and in between be pushed in as valid???
	
	                } else {
	
	                    pg1IsValid ? aPgs.push( pg1 ) : invalidPgs.push( pg1 );
	                    pg2IsValid ? aPgs.push( pg2 ) : invalidPgs.push( pg2 );
	
	                }
	
	            }
	
	        }, this );
	
	        aPgs = _.uniq(aPgs);   // remove any dupes
	        aPgs = _.sortBy(aPgs, function(n) { return n; });
	
	        invalidPgs = _.uniq(invalidPgs);
	        invalidPgs = _.sortBy(invalidPgs, function(n) { return n; });
	
	        // could make friendlier error message -- pages from x-y, --- make another string, example:
	        var nInvalidPgs = invalidPgs.length;
	        if (nInvalidPgs > 0)
	            return 'The following page' + (nInvalidPgs > 1 ? 's do' : ' does') + ' not exist in the document: ' + invalidPgs.join(', ');
	
	        return aPgs;
	
	        function validatePageNumber(n, nPagesInDoc) {
	            return n > 0 && n <= nPagesInDoc;
	        }
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/*
	*  This is a simple modal for displaying content (markup or jquery) with hooks (OK, cancel).
	*  ... currently extend to create a modal view (see 'modalLoading') ... now more examples ...
	* TODO:
	*   - draggable ( though that may break other things that are content dependent inside -- eg chosen dropdowns )
	*   - accessibility: disable tab-able content outside the modal; when available 'new' dialog element or maybe a polyfill
	*   - with implementation of subviews (DVBC-1586) refactor dialogs extending this prototype
	*   - would also want to change markup to be a form and use onSubmit
	* */
	
	__webpack_require__(111);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    ResizeSensor = __webpack_require__(112);
	
	
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	
	
	var confirmTypes = {
	    warning: {
	        icon: 'icon-attention-circled',
	        color: '#9D261D'
	    },
	    info: {
	        icon: 'icon-info-circled',
	        color: '#9D261D'
	    }
	};
	
	var defaults = {
	    actionBtn: 'OK',
	    cancelBtn: 'Cancel',
	    hideFooter: false,  // need to override this one,
	    showCancelBtn: false, //need to override this one,
	    showDismissBtn: true,
	    overlay: true,
	
	    confirmIcon: '',
	    confirmColor: '',
	
	    content: '', // html or jquery obj -- and now BackboneView
	    contentIsJquery: false,
	    contentIsBackboneView: false,
	
	    $container: null, // required if creating overlay
	    title: null, // The header of the title -- if provided, header is shown
	
	    width: null, // Set a custom width ( pixels ),
	    height: null, // Set a custom height ( pixels )
	    omitBodyPadding: false,
	    omitBodyOverflow: false,
	
	
	    onClose: null,
	    okCB: null
	
	    /* derived */
	
	
	};
	
	
	// Note: content can be jquery object or text -- sometimes template passed in -- use partial?
	
	module.exports = Marionette.LayoutView.extend({
	
	    template: __webpack_require__(117),
	    className: "FV-modal",
	
	    //TODO: what required & err if not provided: ($container: if overlay)
	    initialize: function(options) {
	
	        var o = options,
	            confType = o.confirmType,
	
	            content = o.content,
	
	            s = this.settings = _.extend( {}, defaults, o, { /* don't override proto! */
	
	                confirmIcon: confType ? confirmTypes[confType].icon : '',
	                confirmColor: confType ? confirmTypes[confType].color : '',
	
	                contentIsJquery: content && content.jquery,
	                contentIsBackboneView: content && content instanceof Backbone.View
	
	            });
	
	        this.resizeSensor = null;  // (set onShow)
	
	        /* Plugin Relies on Container Having Position */
	        var $cont = s.$container;
	        $cont && $cont.css('position') === 'static' &&
	            $cont.css('position', 'relative').data('positionApplied', true);
	
	        return this;
	
	    },
	
	
	    serializeData: function() {
	
	        var s = this.settings;
	
	        return {
	
	            showHeader:  s.title && s.title.length > 0,
	            showDismissBtn: s.showDismissBtn,
	            title:  s.title, //will be shown if header is shown
	            confirmIcon: s.confirmIcon,
	            showConfirmIcon: s.confirmIcon && s.confirmIcon.length > 0,
	            confirmColor: s.confirmColor && s.confirmColor,
	
	            rawHTMLContent: !s.contentIsJquery && !s.contentIsBackboneView // could check if string
	                ? s.content
	                : '',
	
	            contentIsBackboneView: s.contentIsBackboneView,
	
	            //i think when pass in subtemplate
	            showFooter:  !(s.hideFooter),
	            showCancelBtn:  s.showCancelBtn,
	
	            cancelBtn: s.cancelBtn,
	            actionBtn: s.actionBtn,
	
	            customWidth: s.width !== null,
	            width: s.width,
	
	            customHeight: s.height !== null,
	            height: s.height,
	
	            leftMargin: s.width ? ( parseFloat(s.width) / 2 * -1 ) + 'px' : '-200px', //latter is the default css
	            omitBodyPadding: s.omitBodyPadding,
	
	            omitBodyOverflow: s.omitBodyOverflow //eg if want to use own scrolling (w/top nav bar)
	
	
	        };
	
	    },
	
	    onRender: function() {
	
	        this.unwrap(); // (unwrap called in proto)
	
	        if ( this.settings.contentIsJquery ) {
	            this.ui.content.append( this.settings.content );
	        }
	
	    },
	
	    onBeforeShow: function() {
	
	        if ( this.settings.contentIsBackboneView ) {
	            this.contentRegion.show( this.settings.content );
	        }
	    },
	
	    onShow: function() {
	
	        this.settings.overlay && this.settings.$container.overlay();
	
	        this.$el.iframeShim();
	
	        this.$el.focus();
	
	        /*
	        * DVBC-1599: change the size of the shim when the size of the modal changes.
	        * Later may want to incorporate the code directly into the shim plugin, but for
	        * now this modal dialog is the only use case.
	        * Potentially make optional -- only apply the sensor for dialog's we know who's size dynamic.
	        * Also -- across - the board -- may only want to apply the shim conditionally (eg if using IE).
	        * */
	
	
	        this.resizeSensor = new ResizeSensor( this.el, _.bind( function() {
	            this.$el.iframeShim('sizeAndPosition');
	        }, this));
	
	
	    },
	    ui: {
	        content:        '.FV-modal-content',
	        okBtn:          '#okBtn',
	        cancelBtn:      '#cancelBtn',
	        closeBtn:       '.close'
	    },
	    regions: {
	        contentRegion:  '.FV-modal-region'
	    },
	    events: {
	        'click @ui.okBtn'      : 'ok',
	        'click @ui.cancelBtn'  : 'destroy',
	        'click @ui.closeBtn'   : 'destroy'
	    },
	    keyboardEvents: {
	        'enter' : 'ok',
	        'esc'   : 'destroy'
	    },
	    ok: function() {
	        this.destroy();
	        this.settings.okCB && this.settings.okCB();
	    },
	    unfocusBtn: function() {
	
	        this.ui.okBtn.toggleClass('btn-focus-primary'); //TODO: fix this : have it focus in the box (..still?)
	        this.ui.cancelBtn.toggleClass('btn-focus');
	
	    },
	    destroy: function() {
	
	        this.resizeSensor && this.resizeSensor.detach();
	
	        /* DVBC-1151 -- must remove the iframe shim prior to remove el from the DOM */
	        this.$el.iframeShim('destroy');
	
	        Marionette.LayoutView.prototype.destroy.apply( this, arguments ); // ( Will destroy region if exists )
	
	        var s = this.settings;
	        if (s.$container) {
	            s.$container.data('positionApplied') && s.$container.css('position', '');
	            s.$container.trigger('overlay:close');
	        }
	
	        this.$('*').remove();
	
	        s.onClose && s.onClose();
	        
	        this.remove();
	        this.$el = null;
	        this.el = null;
	    }
	
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 111 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var RS = __webpack_require__(113);
	
	/* Don't allow it to be added to window -- note: this is not working */
	// delete window.ResizeSensor;
	
	module.exports = RS;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {//NOTE: THIS VERSION IS 0.2 FOR IE8 */
	
	/**
	 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
	 * directory of this distribution and at
	 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
	 */
	;
	(function() {
	
	    /**
	     * Class for dimension change detection.
	     *
	     * @param {Element|Element[]|Elements|jQuery} element
	     * @param {Function} callback
	     *
	     * @constructor
	     */
	    this.ResizeSensor = function(element, callback) {
	        /**
	         *
	         * @constructor
	         */
	        function EventQueue() {
	            this.q = [];
	            this.add = function(ev) {
	                this.q.push(ev);
	            };
	
	            var i, j;
	            this.call = function() {
	                for (i = 0, j = this.q.length; i < j; i++) {
	                    this.q[i].call();
	                }
	            };
	        }
	
	        /**
	         * @param {HTMLElement} element
	         * @param {String}      prop
	         * @returns {String|Number}
	         */
	        function getComputedStyle(element, prop) {
	            if (element.currentStyle) {
	                return element.currentStyle[prop];
	            } else if (window.getComputedStyle) {
	                return window.getComputedStyle(element, null).getPropertyValue(prop);
	            } else {
	                return element.style[prop];
	            }
	        }
	
	        /**
	         *
	         * @param {HTMLElement} element
	         * @param {Function}    resized
	         */
	        function attachResizeEvent(element, resized) {
	            if (!element.resizedAttached) {
	                element.resizedAttached = new EventQueue();
	                element.resizedAttached.add(resized);
	            } else if (element.resizedAttached) {
	                element.resizedAttached.add(resized);
	                return;
	            }
	
	            element.resizeSensor = document.createElement('div');
	            element.resizeSensor.className = 'resize-sensor';
	            var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: scroll; z-index: -1; visibility: hidden;';
	            var styleChild = 'position: absolute; left: 0; top: 0;';
	
	            element.resizeSensor.style.cssText = style;
	            element.resizeSensor.innerHTML =
	                '<div class="resize-sensor-expand" style="' + style + '">' +
	                '<div style="' + styleChild + '"></div>' +
	                '</div>' +
	                '<div class="resize-sensor-shrink" style="' + style + '">' +
	                '<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
	                '</div>';
	            element.appendChild(element.resizeSensor);
	
	            if (!{fixed: 1, absolute: 1}[getComputedStyle(element, 'position')]) {
	                element.style.position = 'relative';
	            }
	
	            var expand = element.resizeSensor.childNodes[0];
	            var expandChild = expand.childNodes[0];
	            var shrink = element.resizeSensor.childNodes[1];
	            var shrinkChild = shrink.childNodes[0];
	
	            var lastWidth, lastHeight;
	
	            var reset = function() {
	                expandChild.style.width = expand.offsetWidth + 10 + 'px';
	                expandChild.style.height = expand.offsetHeight + 10 + 'px';
	                expand.scrollLeft = expand.scrollWidth;
	                expand.scrollTop = expand.scrollHeight;
	                shrink.scrollLeft = shrink.scrollWidth;
	                shrink.scrollTop = shrink.scrollHeight;
	                lastWidth = element.offsetWidth;
	                lastHeight = element.offsetHeight;
	            };
	
	            reset();
	
	            var changed = function() {
	                if (element.resizedAttached) {
	                    element.resizedAttached.call();
	                }
	            };
	
	            var addEvent = function(el, name, cb) {
	                if (el.attachEvent) {
	                    el.attachEvent('on' + name, cb);
	                } else {
	                    el.addEventListener(name, cb);
	                }
	            };
	
	            addEvent(expand, 'scroll', function() {
	                if (element.offsetWidth > lastWidth || element.offsetHeight > lastHeight) {
	                    changed();
	                }
	                reset();
	            });
	
	            addEvent(shrink, 'scroll',function() {
	                if (element.offsetWidth < lastWidth || element.offsetHeight < lastHeight) {
	                    changed();
	                }
	                reset();
	            });
	        }
	
	        if ("[object Array]" === Object.prototype.toString.call(element)
	            || ('undefined' !== typeof jQuery && element instanceof jQuery) //jquery
	            || ('undefined' !== typeof Elements && element instanceof Elements) //mootools
	        ) {
	            var i = 0, j = element.length;
	            for (; i < j; i++) {
	                attachResizeEvent(element[i], callback);
	            }
	        } else {
	            attachResizeEvent(element, callback);
	        }
	
	        this.detach = function() {
	            ResizeSensor.detach(element);
	        };
	    };
	
	    this.ResizeSensor.detach = function(element) {
	
	        if (element.resizeSensor) {
	            element.removeChild(element.resizeSensor);
	            delete element.resizeSensor;
	            delete element.resizedAttached;
	        }
	    };
	
	})();
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = ResizeSensor;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone, Mousetrap) {(function(_, Backbone, Mousetrap) {
	    'use strict';
	
	    var oldDelegateEvents = Backbone.View.prototype.delegateEvents;
	    var oldUndelegateEvents = Backbone.View.prototype.undelegateEvents;
	    var oldRemove = Backbone.View.prototype.remove;
	
	    // Map from keyboard commands to the View instance that most recently bound each one.
	    // so we can avoid accidentally unbinding keys when a view replaced a previous view's keybinding.
	    var lastBound = {};
	
	    _.extend(Backbone.View.prototype, {
	
	        keyboardEvents: {},
	
	        bindKeyboardEvents: function(events) {
	            if (!(events || (events = _.result(this, 'keyboardEvents')))) return;
	            for (var key in events) {
	                var method = events[key];
	                if (!_.isFunction(method)) method = this[events[key]];
	                if (!method) throw new Error('Method "' + events[key] + '" does not exist');
	                method = _.bind(method, this);
	
	                // Use global-bind plugin when appropriate
	                // https://github.com/ccampbell/mousetrap/tree/master/plugins/global-bind
	                if ('bindGlobal' in Mousetrap && (key.indexOf('mod') !== -1 || key.indexOf('command') !== -1 || key.indexOf('ctrl') !== -1)) {
	                    Mousetrap.bindGlobal(key, method);
	                } else {
	                    Mousetrap.bind(key, method);
	                }
	                lastBound[key] = this;
	            }
	            return this;
	        },
	
	        unbindKeyboardEvents: function() {
	            for (var keys in this.keyboardEvents) {
	                if (lastBound[keys] === this) {
	                    Mousetrap.unbind(keys);
	                    delete lastBound[keys];
	                }
	            }
	            return this;
	        },
	
	        delegateEvents: function() {
	            var ret = oldDelegateEvents.apply(this, arguments);
	            this.bindKeyboardEvents();
	            return ret;
	        },
	
	        undelegateEvents: function() {
	            var ret = oldUndelegateEvents.apply(this, arguments);
	            if (this.unbindKeyboardEvents) this.unbindKeyboardEvents();
	            return ret;
	        },
	
	        remove: function() {
	            var ret = oldRemove.apply(this, arguments);
	            if (this.unbindKeyboardEvents) this.unbindKeyboardEvents();
	            return ret;
	        }
	
	    });
	})(_, Backbone, Mousetrap);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(58), __webpack_require__(68)))

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	 * Creates opaque iframe underneath element --- typically used to show content atop a browser plugin (eg Adobe Reader in Internet Explorer
	 * To address memory leak: maybe apply resize library directly to the shim; currently only use case was for modal dialog,
	 * where it's implemented directly.
	*/
	
	
	(function($) {
	
	    $.fn.iframeShim = function(method) {
	       
	        var self = this;
	
	        var methods = {
	            init: function() {
	                this.data('$shim', $('<iframe class="iframeShim hide" scrolling="no" frameborder="0"></iframe>').insertBefore(this));
	                sizeAndPosition();
	                this.data('$shim').removeClass('hide');
	                $(window).on('resize scroll', sizeAndPosition); //TODO: this is causing a leak -- self referenced in the fn
	                return this;
	            },
	            destroy: function () {
	                $(window).off('resize scroll', sizeAndPosition);
	                if (this.data('$shim')) {
	                    this.data('$shim').remove();
	                    this.data('$shim', null);
	                }
	                return this;
	            },
	            sizeAndPosition: function() { // do externally if needed
	                sizeAndPosition();
	            }
	        };
	
	        if (methods[method]) {
	            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
	        } else if (typeof method === 'object' || !method) {
	            return methods.init.apply(this, arguments);
	        } else {
	            $.error('Method ' + method + ' does not exist');
	        }
	
	
	        function sizeAndPosition() {
	
	            var $shim = self.data('$shim');
	
	            //TODO: prevent occurrence
	            if (!$shim)
	                return;
	
	            /*
	            * 8/26/19 -- change to getBoundingClientRect:
	            * Use instead of jQuery, at least for outerWidth, outerHeight to avoid rounding issues (DVBC-1615)
	            * Works IE9+
	            * Note: unline jQuery.offset(), scrolling its taken into account for top, left
	            * */
	
	            var rect = self[0].getBoundingClientRect();
	
	            $shim.css({
	                width: rect.width,
	                height: rect.height,
	                top: rect.top,
	                left: rect.left,
	                'z-index': self.css('z-index') - 1, // make one less than layer of current
	                position: 'fixed' //(getting rel to document)
	            });
	
	        }
	
	    };
	
	})(jQuery);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/*
	* Give the container to add an overlay to -- by default call to append, then call to destroy.
	* Note: assumes overlay z-index and background defined in class -- could make option to override
	* Note: now has dependency on iframeShim -- if left as individual library would want to bundle the 2;
	*
	* */
	
	__webpack_require__(115);
	
	(function($) {
	
	    $.fn.overlay = function(options) {
	
	        var settings = {
	                delay: 100,
	                overlayClass: 'FV-overlay',
	                opacity: 0.7,
	                'z-index': 1
	            },
	            $win = $(window), //TODO: really want container size change -- could move to resize plugin
	            $el = this;
	
	        $.extend(settings, options);
	
	        var $o = $('<div class="' + settings.overlayClass + '"></div>').css({
	            position: 'relative', //necessary to derive z-index from class (also must append)
	            display: 'none' //start hidden
	        });
	
	        this.append($o);
	
	
	       $.extend( settings, {'z-index': parseFloat( $o.css('z-index') ) });
	
	        sizeAndPosition();
	
	        $o.fadeTo( settings.delay, settings.opacity );
	
	        $win.on('resize scroll', sizeAndPosition); //TODO: for scroll really want the parent container if overflow --- other option is using css and ensuring has position
	        this.on('overlay:close', close);
	
	        function sizeAndPosition() {
	            $o.css( cssForOverlay( $o, settings['z-index']) );
	        }
	
	        function close(e, delay) {
	
	
	            $o.fadeOut( delay ? delay : 0, function() {
	
	                $win.off( 'resize scroll', sizeAndPosition );
	                $o.iframeShim('destroy');
	                $o.remove(); // TODO: small memory leak here -- the ref in the size and position closure -- putting in own fn not helping
	
	                //$o = null; -- doesn't fix mem leak
	            });
	
	        }
	
	        /* Note: relative to window */
	        function cssForOverlay(zIndex) {
	            return {
	                position: 'fixed', //(getting rel to document)
	                'z-index': zIndex ? zIndex : parseFloat($el.css('z-index')),
	                top: $el.offset().top - $(window).scrollTop(),
	                left: $el.offset().left - $(window).scrollLeft(),
	                width: $el.outerWidth(),
	                height: $el.outerHeight()
	            };
	        }
	
	        return this;
	
	    };
	
	
	})(jQuery);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "width:"
	    + container.escapeExpression(((helper = (helper = helpers.width || (depth0 != null ? depth0.width : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"width","hash":{},"data":data}) : helper)))
	    + ";";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "height:"
	    + container.escapeExpression(((helper = (helper = helpers.height || (depth0 != null ? depth0.height : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"height","hash":{},"data":data}) : helper)))
	    + "; overflow: hidden;";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "            <button type=\"button\" class=\"close\" title=\"Close\">&times;</button>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <div class=\"FV-modal-header\">"
	    + container.escapeExpression(((helper = (helper = helpers.title || (depth0 != null ? depth0.title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"title","hash":{},"data":data}) : helper)))
	    + "</div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "padding:0px;";
	},"11":function(container,depth0,helpers,partials,data) {
	    return "overflow:hidden;";
	},"13":function(container,depth0,helpers,partials,data) {
	    return "max-height: none; height: 100%;";
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                <span class=\"confirm-icon-wr\">\n                    <i class=\""
	    + alias4(((helper = (helper = helpers.confirmIcon || (depth0 != null ? depth0.confirmIcon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"confirmIcon","hash":{},"data":data}) : helper)))
	    + "\" style=\"color:"
	    + alias4(((helper = (helper = helpers.confirmColor || (depth0 != null ? depth0.confirmColor : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"confirmColor","hash":{},"data":data}) : helper)))
	    + ";\"></i>\n                </span>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "style=\"height: "
	    + container.escapeExpression(((helper = (helper = helpers.height || (depth0 != null ? depth0.height : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"height","hash":{},"data":data}) : helper)))
	    + ";\"";
	},"19":function(container,depth0,helpers,partials,data) {
	    return "                        <div class=\"FV-modal-region\"></div>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n            <div class=\"FV-modal-footer\">\n                <input id=\"okBtn\" type=\"submit\" class=\"btn btn-primary btn-small\" value=\""
	    + container.escapeExpression(((helper = (helper = helpers.actionBtn || (depth0 != null ? depth0.actionBtn : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"actionBtn","hash":{},"data":data}) : helper)))
	    + "\"></button>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showCancelBtn : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            </div>\n\n";
	},"22":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                    <button id=\"cancelBtn\" class=\"btn btn-small\">"
	    + container.escapeExpression(((helper = (helper = helpers.cancelButtonLabel || (depth0 != null ? depth0.cancelButtonLabel : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cancelButtonLabel","hash":{},"data":data}) : helper)))
	    + "</button>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<div class=\"FV-modal\"\n     style=\"margin-left:"
	    + container.escapeExpression(((helper = (helper = helpers.leftMargin || (depth0 != null ? depth0.leftMargin : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"leftMargin","hash":{},"data":data}) : helper)))
	    + "; "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.customWidth : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.customHeight : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\"\n     tabindex=\"-1\">\n\n    <div class=\"FV-modal-wr\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showDismissBtn : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showHeader : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        <div class=\"FV-modal-body\" style=\""
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.omitBodyPadding : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.omitBodyOverflow : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.customHeight : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\"\n        >"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showConfirmIcon : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "<div class=\"FV-modal-content\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.customHeight : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.contentIsBackboneView : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                "
	    + ((stack1 = ((helper = (helper = helpers.rawHTMLContent || (depth0 != null ? depth0.rawHTMLContent : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"rawHTMLContent","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n\n            </div>\n\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showFooter : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n\n\n</div>";
	},"useData":true});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// Create a simple path alias to allow browserify to resolve
	// the runtime on a supported path.
	module.exports = __webpack_require__(119)['default'];


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _handlebarsBase = __webpack_require__(120);
	
	var base = _interopRequireWildcard(_handlebarsBase);
	
	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)
	
	var _handlebarsSafeString = __webpack_require__(134);
	
	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);
	
	var _handlebarsException = __webpack_require__(122);
	
	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);
	
	var _handlebarsUtils = __webpack_require__(121);
	
	var Utils = _interopRequireWildcard(_handlebarsUtils);
	
	var _handlebarsRuntime = __webpack_require__(135);
	
	var runtime = _interopRequireWildcard(_handlebarsRuntime);
	
	var _handlebarsNoConflict = __webpack_require__(136);
	
	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);
	
	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();
	
	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;
	
	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };
	
	  return hb;
	}
	
	var inst = create();
	inst.create = create;
	
	_handlebarsNoConflict2['default'](inst);
	
	inst['default'] = inst;
	
	exports['default'] = inst;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(121);
	
	var _exception = __webpack_require__(122);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _helpers = __webpack_require__(123);
	
	var _decorators = __webpack_require__(131);
	
	var _logger = __webpack_require__(133);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var VERSION = '4.1.0';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;
	
	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};
	
	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';
	
	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};
	
	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}
	
	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,
	
	  logger: _logger2['default'],
	  log: _logger2['default'].log,
	
	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },
	
	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },
	
	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};
	
	var log = _logger2['default'].log;
	
	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2Jhc2UuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7cUJBQTRDLFNBQVM7O3lCQUMvQixhQUFhOzs7O3VCQUNFLFdBQVc7OzBCQUNSLGNBQWM7O3NCQUNuQyxVQUFVOzs7O0FBRXRCLElBQU0sT0FBTyxHQUFHLE9BQU8sQ0FBQzs7QUFDeEIsSUFBTSxpQkFBaUIsR0FBRyxDQUFDLENBQUM7OztBQUU1QixJQUFNLGdCQUFnQixHQUFHO0FBQzlCLEdBQUMsRUFBRSxhQUFhO0FBQ2hCLEdBQUMsRUFBRSxlQUFlO0FBQ2xCLEdBQUMsRUFBRSxlQUFlO0FBQ2xCLEdBQUMsRUFBRSxVQUFVO0FBQ2IsR0FBQyxFQUFFLGtCQUFrQjtBQUNyQixHQUFDLEVBQUUsaUJBQWlCO0FBQ3BCLEdBQUMsRUFBRSxVQUFVO0NBQ2QsQ0FBQzs7O0FBRUYsSUFBTSxVQUFVLEdBQUcsaUJBQWlCLENBQUM7O0FBRTlCLFNBQVMscUJBQXFCLENBQUMsT0FBTyxFQUFFLFFBQVEsRUFBRSxVQUFVLEVBQUU7QUFDbkUsTUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLElBQUksRUFBRSxDQUFDO0FBQzdCLE1BQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxJQUFJLEVBQUUsQ0FBQztBQUMvQixNQUFJLENBQUMsVUFBVSxHQUFHLFVBQVUsSUFBSSxFQUFFLENBQUM7O0FBRW5DLGtDQUF1QixJQUFJLENBQUMsQ0FBQztBQUM3Qix3Q0FBMEIsSUFBSSxDQUFDLENBQUM7Q0FDakM7O0FBRUQscUJBQXFCLENBQUMsU0FBUyxHQUFHO0FBQ2hDLGFBQVcsRUFBRSxxQkFBcUI7O0FBRWxDLFFBQU0scUJBQVE7QUFDZCxLQUFHLEVBQUUsb0JBQU8sR0FBRzs7QUFFZixnQkFBYyxFQUFFLHdCQUFTLElBQUksRUFBRSxFQUFFLEVBQUU7QUFDakMsUUFBSSxnQkFBUyxJQUFJLENBQUMsSUFBSSxDQUFDLEtBQUssVUFBVSxFQUFFO0FBQ3RDLFVBQUksRUFBRSxFQUFFO0FBQUUsY0FBTSwyQkFBYyx5Q0FBeUMsQ0FBQyxDQUFDO09BQUU7QUFDM0Usb0JBQU8sSUFBSSxDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsQ0FBQztLQUM1QixNQUFNO0FBQ0wsVUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLENBQUM7S0FDekI7R0FDRjtBQUNELGtCQUFnQixFQUFFLDBCQUFTLElBQUksRUFBRTtBQUMvQixXQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7R0FDM0I7O0FBRUQsaUJBQWUsRUFBRSx5QkFBUyxJQUFJLEVBQUUsT0FBTyxFQUFFO0FBQ3ZDLFFBQUksZ0JBQVMsSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLFVBQVUsRUFBRTtBQUN0QyxvQkFBTyxJQUFJLENBQUMsUUFBUSxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQzdCLE1BQU07QUFDTCxVQUFJLE9BQU8sT0FBTyxLQUFLLFdBQVcsRUFBRTtBQUNsQyxjQUFNLHlFQUEwRCxJQUFJLG9CQUFpQixDQUFDO09BQ3ZGO0FBQ0QsVUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsR0FBRyxPQUFPLENBQUM7S0FDL0I7R0FDRjtBQUNELG1CQUFpQixFQUFFLDJCQUFTLElBQUksRUFBRTtBQUNoQyxXQUFPLElBQUksQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7R0FDNUI7O0FBRUQsbUJBQWlCLEVBQUUsMkJBQVMsSUFBSSxFQUFFLEVBQUUsRUFBRTtBQUNwQyxRQUFJLGdCQUFTLElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxVQUFVLEVBQUU7QUFDdEMsVUFBSSxFQUFFLEVBQUU7QUFBRSxjQUFNLDJCQUFjLDRDQUE0QyxDQUFDLENBQUM7T0FBRTtBQUM5RSxvQkFBTyxJQUFJLENBQUMsVUFBVSxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQy9CLE1BQU07QUFDTCxVQUFJLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztLQUM1QjtHQUNGO0FBQ0QscUJBQW1CLEVBQUUsNkJBQVMsSUFBSSxFQUFFO0FBQ2xDLFdBQU8sSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQztHQUM5QjtDQUNGLENBQUM7O0FBRUssSUFBSSxHQUFHLEdBQUcsb0JBQU8sR0FBRyxDQUFDOzs7UUFFcEIsV0FBVztRQUFFLE1BQU0iLCJmaWxlIjoiYmFzZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7Y3JlYXRlRnJhbWUsIGV4dGVuZCwgdG9TdHJpbmd9IGZyb20gJy4vdXRpbHMnO1xuaW1wb3J0IEV4Y2VwdGlvbiBmcm9tICcuL2V4Y2VwdGlvbic7XG5pbXBvcnQge3JlZ2lzdGVyRGVmYXVsdEhlbHBlcnN9IGZyb20gJy4vaGVscGVycyc7XG5pbXBvcnQge3JlZ2lzdGVyRGVmYXVsdERlY29yYXRvcnN9IGZyb20gJy4vZGVjb3JhdG9ycyc7XG5pbXBvcnQgbG9nZ2VyIGZyb20gJy4vbG9nZ2VyJztcblxuZXhwb3J0IGNvbnN0IFZFUlNJT04gPSAnNC4xLjAnO1xuZXhwb3J0IGNvbnN0IENPTVBJTEVSX1JFVklTSU9OID0gNztcblxuZXhwb3J0IGNvbnN0IFJFVklTSU9OX0NIQU5HRVMgPSB7XG4gIDE6ICc8PSAxLjAucmMuMicsIC8vIDEuMC5yYy4yIGlzIGFjdHVhbGx5IHJldjIgYnV0IGRvZXNuJ3QgcmVwb3J0IGl0XG4gIDI6ICc9PSAxLjAuMC1yYy4zJyxcbiAgMzogJz09IDEuMC4wLXJjLjQnLFxuICA0OiAnPT0gMS54LngnLFxuICA1OiAnPT0gMi4wLjAtYWxwaGEueCcsXG4gIDY6ICc+PSAyLjAuMC1iZXRhLjEnLFxuICA3OiAnPj0gNC4wLjAnXG59O1xuXG5jb25zdCBvYmplY3RUeXBlID0gJ1tvYmplY3QgT2JqZWN0XSc7XG5cbmV4cG9ydCBmdW5jdGlvbiBIYW5kbGViYXJzRW52aXJvbm1lbnQoaGVscGVycywgcGFydGlhbHMsIGRlY29yYXRvcnMpIHtcbiAgdGhpcy5oZWxwZXJzID0gaGVscGVycyB8fCB7fTtcbiAgdGhpcy5wYXJ0aWFscyA9IHBhcnRpYWxzIHx8IHt9O1xuICB0aGlzLmRlY29yYXRvcnMgPSBkZWNvcmF0b3JzIHx8IHt9O1xuXG4gIHJlZ2lzdGVyRGVmYXVsdEhlbHBlcnModGhpcyk7XG4gIHJlZ2lzdGVyRGVmYXVsdERlY29yYXRvcnModGhpcyk7XG59XG5cbkhhbmRsZWJhcnNFbnZpcm9ubWVudC5wcm90b3R5cGUgPSB7XG4gIGNvbnN0cnVjdG9yOiBIYW5kbGViYXJzRW52aXJvbm1lbnQsXG5cbiAgbG9nZ2VyOiBsb2dnZXIsXG4gIGxvZzogbG9nZ2VyLmxvZyxcblxuICByZWdpc3RlckhlbHBlcjogZnVuY3Rpb24obmFtZSwgZm4pIHtcbiAgICBpZiAodG9TdHJpbmcuY2FsbChuYW1lKSA9PT0gb2JqZWN0VHlwZSkge1xuICAgICAgaWYgKGZuKSB7IHRocm93IG5ldyBFeGNlcHRpb24oJ0FyZyBub3Qgc3VwcG9ydGVkIHdpdGggbXVsdGlwbGUgaGVscGVycycpOyB9XG4gICAgICBleHRlbmQodGhpcy5oZWxwZXJzLCBuYW1lKTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5oZWxwZXJzW25hbWVdID0gZm47XG4gICAgfVxuICB9LFxuICB1bnJlZ2lzdGVySGVscGVyOiBmdW5jdGlvbihuYW1lKSB7XG4gICAgZGVsZXRlIHRoaXMuaGVscGVyc1tuYW1lXTtcbiAgfSxcblxuICByZWdpc3RlclBhcnRpYWw6IGZ1bmN0aW9uKG5hbWUsIHBhcnRpYWwpIHtcbiAgICBpZiAodG9TdHJpbmcuY2FsbChuYW1lKSA9PT0gb2JqZWN0VHlwZSkge1xuICAgICAgZXh0ZW5kKHRoaXMucGFydGlhbHMsIG5hbWUpO1xuICAgIH0gZWxzZSB7XG4gICAgICBpZiAodHlwZW9mIHBhcnRpYWwgPT09ICd1bmRlZmluZWQnKSB7XG4gICAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oYEF0dGVtcHRpbmcgdG8gcmVnaXN0ZXIgYSBwYXJ0aWFsIGNhbGxlZCBcIiR7bmFtZX1cIiBhcyB1bmRlZmluZWRgKTtcbiAgICAgIH1cbiAgICAgIHRoaXMucGFydGlhbHNbbmFtZV0gPSBwYXJ0aWFsO1xuICAgIH1cbiAgfSxcbiAgdW5yZWdpc3RlclBhcnRpYWw6IGZ1bmN0aW9uKG5hbWUpIHtcbiAgICBkZWxldGUgdGhpcy5wYXJ0aWFsc1tuYW1lXTtcbiAgfSxcblxuICByZWdpc3RlckRlY29yYXRvcjogZnVuY3Rpb24obmFtZSwgZm4pIHtcbiAgICBpZiAodG9TdHJpbmcuY2FsbChuYW1lKSA9PT0gb2JqZWN0VHlwZSkge1xuICAgICAgaWYgKGZuKSB7IHRocm93IG5ldyBFeGNlcHRpb24oJ0FyZyBub3Qgc3VwcG9ydGVkIHdpdGggbXVsdGlwbGUgZGVjb3JhdG9ycycpOyB9XG4gICAgICBleHRlbmQodGhpcy5kZWNvcmF0b3JzLCBuYW1lKTtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhpcy5kZWNvcmF0b3JzW25hbWVdID0gZm47XG4gICAgfVxuICB9LFxuICB1bnJlZ2lzdGVyRGVjb3JhdG9yOiBmdW5jdGlvbihuYW1lKSB7XG4gICAgZGVsZXRlIHRoaXMuZGVjb3JhdG9yc1tuYW1lXTtcbiAgfVxufTtcblxuZXhwb3J0IGxldCBsb2cgPSBsb2dnZXIubG9nO1xuXG5leHBvcnQge2NyZWF0ZUZyYW1lLCBsb2dnZXJ9O1xuIl19


/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};
	
	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;
	
	function escapeChar(chr) {
	  return escape[chr];
	}
	
	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }
	
	  return obj;
	}
	
	var toString = Object.prototype.toString;
	
	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;
	
	/* eslint-enable func-style */
	
	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};
	
	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.
	
	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }
	
	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }
	
	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}
	
	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}
	
	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}
	
	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 122 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
	
	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;
	
	    message += ' - ' + line + ':' + column;
	  }
	
	  var tmp = Error.prototype.constructor.call(this, message);
	
	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }
	
	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }
	
	  try {
	    if (loc) {
	      this.lineNumber = line;
	
	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (Object.defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}
	
	Exception.prototype = new Error();
	
	exports['default'] = Exception;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _helpersBlockHelperMissing = __webpack_require__(124);
	
	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);
	
	var _helpersEach = __webpack_require__(125);
	
	var _helpersEach2 = _interopRequireDefault(_helpersEach);
	
	var _helpersHelperMissing = __webpack_require__(126);
	
	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);
	
	var _helpersIf = __webpack_require__(127);
	
	var _helpersIf2 = _interopRequireDefault(_helpersIf);
	
	var _helpersLog = __webpack_require__(128);
	
	var _helpersLog2 = _interopRequireDefault(_helpersLog);
	
	var _helpersLookup = __webpack_require__(129);
	
	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);
	
	var _helpersWith = __webpack_require__(130);
	
	var _helpersWith2 = _interopRequireDefault(_helpersWith);
	
	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(121);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;
	
	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }
	
	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }
	
	      return fn(context, options);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utils = __webpack_require__(121);
	
	var _exception = __webpack_require__(122);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }
	
	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;
	
	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }
	
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }
	
	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;
	
	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }
	
	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }
	
	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;
	
	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }
	
	    if (i === 0) {
	      ret = inverse(this);
	    }
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvZWFjaC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O3FCQUErRSxVQUFVOzt5QkFDbkUsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxNQUFNLEVBQUUsVUFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3pELFFBQUksQ0FBQyxPQUFPLEVBQUU7QUFDWixZQUFNLDJCQUFjLDZCQUE2QixDQUFDLENBQUM7S0FDcEQ7O0FBRUQsUUFBSSxFQUFFLEdBQUcsT0FBTyxDQUFDLEVBQUU7UUFDZixPQUFPLEdBQUcsT0FBTyxDQUFDLE9BQU87UUFDekIsQ0FBQyxHQUFHLENBQUM7UUFDTCxHQUFHLEdBQUcsRUFBRTtRQUNSLElBQUksWUFBQTtRQUNKLFdBQVcsWUFBQSxDQUFDOztBQUVoQixRQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUMvQixpQkFBVyxHQUFHLHlCQUFrQixPQUFPLENBQUMsSUFBSSxDQUFDLFdBQVcsRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsR0FBRyxDQUFDO0tBQ2pGOztBQUVELFFBQUksa0JBQVcsT0FBTyxDQUFDLEVBQUU7QUFBRSxhQUFPLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUFFOztBQUUxRCxRQUFJLE9BQU8sQ0FBQyxJQUFJLEVBQUU7QUFDaEIsVUFBSSxHQUFHLG1CQUFZLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUNsQzs7QUFFRCxhQUFTLGFBQWEsQ0FBQyxLQUFLLEVBQUUsS0FBSyxFQUFFLElBQUksRUFBRTtBQUN6QyxVQUFJLElBQUksRUFBRTtBQUNSLFlBQUksQ0FBQyxHQUFHLEdBQUcsS0FBSyxDQUFDO0FBQ2pCLFlBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO0FBQ25CLFlBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxLQUFLLENBQUMsQ0FBQztBQUN6QixZQUFJLENBQUMsSUFBSSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUM7O0FBRW5CLFlBQUksV0FBVyxFQUFFO0FBQ2YsY0FBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLEdBQUcsS0FBSyxDQUFDO1NBQ3hDO09BQ0Y7O0FBRUQsU0FBRyxHQUFHLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxFQUFFO0FBQzdCLFlBQUksRUFBRSxJQUFJO0FBQ1YsbUJBQVcsRUFBRSxtQkFBWSxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFBRSxLQUFLLENBQUMsRUFBRSxDQUFDLFdBQVcsR0FBRyxLQUFLLEVBQUUsSUFBSSxDQUFDLENBQUM7T0FDL0UsQ0FBQyxDQUFDO0tBQ0o7O0FBRUQsUUFBSSxPQUFPLElBQUksT0FBTyxPQUFPLEtBQUssUUFBUSxFQUFFO0FBQzFDLFVBQUksZUFBUSxPQUFPLENBQUMsRUFBRTtBQUNwQixhQUFLLElBQUksQ0FBQyxHQUFHLE9BQU8sQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRTtBQUN2QyxjQUFJLENBQUMsSUFBSSxPQUFPLEVBQUU7QUFDaEIseUJBQWEsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxFQUFFLENBQUMsS0FBSyxPQUFPLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQyxDQUFDO1dBQy9DO1NBQ0Y7T0FDRixNQUFNO0FBQ0wsWUFBSSxRQUFRLFlBQUEsQ0FBQzs7QUFFYixhQUFLLElBQUksR0FBRyxJQUFJLE9BQU8sRUFBRTtBQUN2QixjQUFJLE9BQU8sQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLEVBQUU7Ozs7QUFJL0IsZ0JBQUksUUFBUSxLQUFLLFNBQVMsRUFBRTtBQUMxQiwyQkFBYSxDQUFDLFFBQVEsRUFBRSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7YUFDaEM7QUFDRCxvQkFBUSxHQUFHLEdBQUcsQ0FBQztBQUNmLGFBQUMsRUFBRSxDQUFDO1dBQ0w7U0FDRjtBQUNELFlBQUksUUFBUSxLQUFLLFNBQVMsRUFBRTtBQUMxQix1QkFBYSxDQUFDLFFBQVEsRUFBRSxDQUFDLEdBQUcsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO1NBQ3RDO09BQ0Y7S0FDRjs7QUFFRCxRQUFJLENBQUMsS0FBSyxDQUFDLEVBQUU7QUFDWCxTQUFHLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ3JCOztBQUVELFdBQU8sR0FBRyxDQUFDO0dBQ1osQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoiZWFjaC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7YXBwZW5kQ29udGV4dFBhdGgsIGJsb2NrUGFyYW1zLCBjcmVhdGVGcmFtZSwgaXNBcnJheSwgaXNGdW5jdGlvbn0gZnJvbSAnLi4vdXRpbHMnO1xuaW1wb3J0IEV4Y2VwdGlvbiBmcm9tICcuLi9leGNlcHRpb24nO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignZWFjaCcsIGZ1bmN0aW9uKGNvbnRleHQsIG9wdGlvbnMpIHtcbiAgICBpZiAoIW9wdGlvbnMpIHtcbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ011c3QgcGFzcyBpdGVyYXRvciB0byAjZWFjaCcpO1xuICAgIH1cblxuICAgIGxldCBmbiA9IG9wdGlvbnMuZm4sXG4gICAgICAgIGludmVyc2UgPSBvcHRpb25zLmludmVyc2UsXG4gICAgICAgIGkgPSAwLFxuICAgICAgICByZXQgPSAnJyxcbiAgICAgICAgZGF0YSxcbiAgICAgICAgY29udGV4dFBhdGg7XG5cbiAgICBpZiAob3B0aW9ucy5kYXRhICYmIG9wdGlvbnMuaWRzKSB7XG4gICAgICBjb250ZXh0UGF0aCA9IGFwcGVuZENvbnRleHRQYXRoKG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCwgb3B0aW9ucy5pZHNbMF0pICsgJy4nO1xuICAgIH1cblxuICAgIGlmIChpc0Z1bmN0aW9uKGNvbnRleHQpKSB7IGNvbnRleHQgPSBjb250ZXh0LmNhbGwodGhpcyk7IH1cblxuICAgIGlmIChvcHRpb25zLmRhdGEpIHtcbiAgICAgIGRhdGEgPSBjcmVhdGVGcmFtZShvcHRpb25zLmRhdGEpO1xuICAgIH1cblxuICAgIGZ1bmN0aW9uIGV4ZWNJdGVyYXRpb24oZmllbGQsIGluZGV4LCBsYXN0KSB7XG4gICAgICBpZiAoZGF0YSkge1xuICAgICAgICBkYXRhLmtleSA9IGZpZWxkO1xuICAgICAgICBkYXRhLmluZGV4ID0gaW5kZXg7XG4gICAgICAgIGRhdGEuZmlyc3QgPSBpbmRleCA9PT0gMDtcbiAgICAgICAgZGF0YS5sYXN0ID0gISFsYXN0O1xuXG4gICAgICAgIGlmIChjb250ZXh0UGF0aCkge1xuICAgICAgICAgIGRhdGEuY29udGV4dFBhdGggPSBjb250ZXh0UGF0aCArIGZpZWxkO1xuICAgICAgICB9XG4gICAgICB9XG5cbiAgICAgIHJldCA9IHJldCArIGZuKGNvbnRleHRbZmllbGRdLCB7XG4gICAgICAgIGRhdGE6IGRhdGEsXG4gICAgICAgIGJsb2NrUGFyYW1zOiBibG9ja1BhcmFtcyhbY29udGV4dFtmaWVsZF0sIGZpZWxkXSwgW2NvbnRleHRQYXRoICsgZmllbGQsIG51bGxdKVxuICAgICAgfSk7XG4gICAgfVxuXG4gICAgaWYgKGNvbnRleHQgJiYgdHlwZW9mIGNvbnRleHQgPT09ICdvYmplY3QnKSB7XG4gICAgICBpZiAoaXNBcnJheShjb250ZXh0KSkge1xuICAgICAgICBmb3IgKGxldCBqID0gY29udGV4dC5sZW5ndGg7IGkgPCBqOyBpKyspIHtcbiAgICAgICAgICBpZiAoaSBpbiBjb250ZXh0KSB7XG4gICAgICAgICAgICBleGVjSXRlcmF0aW9uKGksIGksIGkgPT09IGNvbnRleHQubGVuZ3RoIC0gMSk7XG4gICAgICAgICAgfVxuICAgICAgICB9XG4gICAgICB9IGVsc2Uge1xuICAgICAgICBsZXQgcHJpb3JLZXk7XG5cbiAgICAgICAgZm9yIChsZXQga2V5IGluIGNvbnRleHQpIHtcbiAgICAgICAgICBpZiAoY29udGV4dC5oYXNPd25Qcm9wZXJ0eShrZXkpKSB7XG4gICAgICAgICAgICAvLyBXZSdyZSBydW5uaW5nIHRoZSBpdGVyYXRpb25zIG9uZSBzdGVwIG91dCBvZiBzeW5jIHNvIHdlIGNhbiBkZXRlY3RcbiAgICAgICAgICAgIC8vIHRoZSBsYXN0IGl0ZXJhdGlvbiB3aXRob3V0IGhhdmUgdG8gc2NhbiB0aGUgb2JqZWN0IHR3aWNlIGFuZCBjcmVhdGVcbiAgICAgICAgICAgIC8vIGFuIGl0ZXJtZWRpYXRlIGtleXMgYXJyYXkuXG4gICAgICAgICAgICBpZiAocHJpb3JLZXkgIT09IHVuZGVmaW5lZCkge1xuICAgICAgICAgICAgICBleGVjSXRlcmF0aW9uKHByaW9yS2V5LCBpIC0gMSk7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICBwcmlvcktleSA9IGtleTtcbiAgICAgICAgICAgIGkrKztcbiAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgaWYgKHByaW9yS2V5ICE9PSB1bmRlZmluZWQpIHtcbiAgICAgICAgICBleGVjSXRlcmF0aW9uKHByaW9yS2V5LCBpIC0gMSwgdHJ1ZSk7XG4gICAgICAgIH1cbiAgICAgIH1cbiAgICB9XG5cbiAgICBpZiAoaSA9PT0gMCkge1xuICAgICAgcmV0ID0gaW52ZXJzZSh0aGlzKTtcbiAgICB9XG5cbiAgICByZXR1cm4gcmV0O1xuICB9KTtcbn1cbiJdfQ==


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _exception = __webpack_require__(122);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(121);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }
	
	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });
	
	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 128 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }
	
	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;
	
	    instance.log.apply(instance, args);
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ },
/* 129 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFdBQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJsb29rdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignbG9va3VwJywgZnVuY3Rpb24ob2JqLCBmaWVsZCkge1xuICAgIHJldHVybiBvYmogJiYgb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(121);
	
	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }
	
	    var fn = options.fn;
	
	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }
	
	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _decoratorsInline = __webpack_require__(132);
	
	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);
	
	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(121);
	
	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }
	
	    props.partials[options.args[0]] = options.fn;
	
	    return ret;
	  });
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(121);
	
	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',
	
	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }
	
	    return level;
	  },
	
	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);
	
	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }
	
	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }
	
	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};
	
	exports['default'] = logger;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2xvZ2dlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O3FCQUFzQixTQUFTOztBQUUvQixJQUFJLE1BQU0sR0FBRztBQUNYLFdBQVMsRUFBRSxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFFLE9BQU8sQ0FBQztBQUM3QyxPQUFLLEVBQUUsTUFBTTs7O0FBR2IsYUFBVyxFQUFFLHFCQUFTLEtBQUssRUFBRTtBQUMzQixRQUFJLE9BQU8sS0FBSyxLQUFLLFFBQVEsRUFBRTtBQUM3QixVQUFJLFFBQVEsR0FBRyxlQUFRLE1BQU0sQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUM7QUFDOUQsVUFBSSxRQUFRLElBQUksQ0FBQyxFQUFFO0FBQ2pCLGFBQUssR0FBRyxRQUFRLENBQUM7T0FDbEIsTUFBTTtBQUNMLGFBQUssR0FBRyxRQUFRLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDO09BQzdCO0tBQ0Y7O0FBRUQsV0FBTyxLQUFLLENBQUM7R0FDZDs7O0FBR0QsS0FBRyxFQUFFLGFBQVMsS0FBSyxFQUFjO0FBQy9CLFNBQUssR0FBRyxNQUFNLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQyxDQUFDOztBQUVsQyxRQUFJLE9BQU8sT0FBTyxLQUFLLFdBQVcsSUFBSSxNQUFNLENBQUMsV0FBVyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxLQUFLLEVBQUU7QUFDL0UsVUFBSSxNQUFNLEdBQUcsTUFBTSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUNyQyxVQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxFQUFFOztBQUNwQixjQUFNLEdBQUcsS0FBSyxDQUFDO09BQ2hCOzt3Q0FQbUIsT0FBTztBQUFQLGVBQU87OztBQVEzQixhQUFPLENBQUMsTUFBTSxPQUFDLENBQWYsT0FBTyxFQUFZLE9BQU8sQ0FBQyxDQUFDO0tBQzdCO0dBQ0Y7Q0FDRixDQUFDOztxQkFFYSxNQUFNIiwiZmlsZSI6ImxvZ2dlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7aW5kZXhPZn0gZnJvbSAnLi91dGlscyc7XG5cbmxldCBsb2dnZXIgPSB7XG4gIG1ldGhvZE1hcDogWydkZWJ1ZycsICdpbmZvJywgJ3dhcm4nLCAnZXJyb3InXSxcbiAgbGV2ZWw6ICdpbmZvJyxcblxuICAvLyBNYXBzIGEgZ2l2ZW4gbGV2ZWwgdmFsdWUgdG8gdGhlIGBtZXRob2RNYXBgIGluZGV4ZXMgYWJvdmUuXG4gIGxvb2t1cExldmVsOiBmdW5jdGlvbihsZXZlbCkge1xuICAgIGlmICh0eXBlb2YgbGV2ZWwgPT09ICdzdHJpbmcnKSB7XG4gICAgICBsZXQgbGV2ZWxNYXAgPSBpbmRleE9mKGxvZ2dlci5tZXRob2RNYXAsIGxldmVsLnRvTG93ZXJDYXNlKCkpO1xuICAgICAgaWYgKGxldmVsTWFwID49IDApIHtcbiAgICAgICAgbGV2ZWwgPSBsZXZlbE1hcDtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIGxldmVsID0gcGFyc2VJbnQobGV2ZWwsIDEwKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICByZXR1cm4gbGV2ZWw7XG4gIH0sXG5cbiAgLy8gQ2FuIGJlIG92ZXJyaWRkZW4gaW4gdGhlIGhvc3QgZW52aXJvbm1lbnRcbiAgbG9nOiBmdW5jdGlvbihsZXZlbCwgLi4ubWVzc2FnZSkge1xuICAgIGxldmVsID0gbG9nZ2VyLmxvb2t1cExldmVsKGxldmVsKTtcblxuICAgIGlmICh0eXBlb2YgY29uc29sZSAhPT0gJ3VuZGVmaW5lZCcgJiYgbG9nZ2VyLmxvb2t1cExldmVsKGxvZ2dlci5sZXZlbCkgPD0gbGV2ZWwpIHtcbiAgICAgIGxldCBtZXRob2QgPSBsb2dnZXIubWV0aG9kTWFwW2xldmVsXTtcbiAgICAgIGlmICghY29uc29sZVttZXRob2RdKSB7IC8vIGVzbGludC1kaXNhYmxlLWxpbmUgbm8tY29uc29sZVxuICAgICAgICBtZXRob2QgPSAnbG9nJztcbiAgICAgIH1cbiAgICAgIGNvbnNvbGVbbWV0aG9kXSguLi5tZXNzYWdlKTsgLy8gZXNsaW50LWRpc2FibGUtbGluZSBuby1jb25zb2xlXG4gICAgfVxuICB9XG59O1xuXG5leHBvcnQgZGVmYXVsdCBsb2dnZXI7XG4iXX0=


/***/ },
/* 134 */
/***/ function(module, exports) {

	// Build out our basic SafeString type
	'use strict';
	
	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}
	
	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};
	
	exports['default'] = SafeString;
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;
	// istanbul ignore next
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// istanbul ignore next
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(121);
	
	var Utils = _interopRequireWildcard(_utils);
	
	var _exception = __webpack_require__(122);
	
	var _exception2 = _interopRequireDefault(_exception);
	
	var _base = __webpack_require__(120);
	
	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;
	
	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}
	
	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }
	
	  templateSpec.main.decorator = templateSpec.main_d;
	
	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);
	
	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }
	
	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);
	
	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }
	
	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }
	
	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },
	
	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,
	
	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },
	
	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },
	
	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;
	
	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }
	
	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: Object.seal({}),
	
	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };
	
	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var data = options.data;
	
	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }
	
	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;
	
	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);
	
	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };
	
	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }
	
	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}
	
	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }
	
	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }
	
	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);
	
	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}
	
	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}
	
	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }
	
	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }
	
	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }
	
	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}
	
	function noop() {
	  return '';
	}
	
	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}
	
	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ },
/* 136 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 137 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div id=\"delete-pgs-wr\">\n\n    <form id=\"delete-pgs-form\">\n\n        <div>\n            <div class=\"delete-pgs-row\">\n                <input id=\"delete-current-pg-cb\" class=\"delete-pgs-radio\" name=\"delete-pg-type\" type=\"radio\" checked>\n                <label for=\"delete-current-pg-cb\">Current Page</label>\n            </div>\n            <div class=\"delete-pgs-row\">\n                <input id=\"delete-pg-range-cb\" class=\"delete-pgs-radio\" name=\"delete-pg-type\" type=\"radio\">\n                <label for=\"delete-pg-range-cb\">Pages: <input name=\""
	    + container.escapeExpression(((helper = (helper = helpers.randomInputName || (depth0 != null ? depth0.randomInputName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"randomInputName","hash":{},"data":data}) : helper)))
	    + "\" id=\"delete-pg-range-input\" type=\"search\" autocomplete=\"nope\" disabled></label>\n                <div id=\"delete-pg-range-caption\">Enter page numbers and/or page ranges separated by commas.  For example, 1,3,5-12</div>\n            </div>\n\n        </div>\n\n    </form>\n\n\n    <!-- TODO: same as add page; consolidate -->\n    <div id=\"delete-pgs-err-msg-wr\" class=\"hide\">\n        <i class=\"icon-attention-circled\"></i>\n        <div id=\"delete-pgs-err-msg-txt\"></div>\n    </div>\n\n\n</div>";
	},"useData":true});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  TODO:
	 *   - give modal the ability to have a sub-view / views
	 *   - make base modal a form
	 *  Current uses have it overridable or have content that doesn't require interaction.
	 *  This is extending the existing modal dialog directly.
	 * */
	
	var Modal = __webpack_require__(110),
	    _ = __webpack_require__(49);
	
	__webpack_require__(140);
	
	
	module.exports = Modal.extend({
	    baseModalDefaults: {
	        title: 'Add Page'
	    },
	    contentTemplate: __webpack_require__(141),
	    initialize: function(options) {
	
	        this.settings = _.extend( {}, {
	            content: this.contentTemplate()
	        }, options );
	
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );
	
	        return this;
	    },
	
	    ui: _.extend( {}, Modal.prototype.ui, {
	        form:               '#add-pg-form',
	        fileInput:          '#file-upload-input',
	        uploadList:         '#file-upload-list', // This may wind up a seperate view
	        uploadLbl:          '#upload-label',
	        insertLastRadio:    '#insert-last',
	        insertFirstRadio:   '#insert-first',
	        numFiles:           '#n-files-selected'
	    }),
	    onShow: function() {
	        Modal.prototype.onShow.apply(this, arguments);
	        setTimeout( _.bind( function() {
	            this.ui.fileInput.focus();
	        }, this), 1);
	    },
	    events: _.extend( {} , Modal.prototype.events, {
	        'submit @ui.form':          'onFormSubmit',
	        'change @ui.fileInput':     'onFileChange'
	    }),
	    onFileChange: function() {
	
	        this.ui.uploadList
	            .html('')
	            .removeClass('showOutline');
	
	        this.ui.numFiles.html('');
	
	        var files = this.ui.fileInput[0].files, //('FileList' of 'File' objects) -- name, size, type
	            nFiles = files.length;
	
	        if (nFiles < 1)
	            return;
	
	        this.ui.numFiles.html( '(' + nFiles + ' selected)' );
	
	        _.each(files, function (f) {
	                this.ui.uploadList.append('<li>' + f.name + '</li>');
	            }, this);
	
	        if ( this.ui.uploadList[0].offsetHeight  < this.ui.uploadList[0].scrollHeight )
	            this.ui.uploadList.addClass('showOutline');
	
	    },
	    ok: function() {
	        var fileList = this.ui.fileInput[0].files;
	        if (fileList.length < 1) {
	            this.destroy();
	            return;
	        }
	
	        this.settings.okCB( fileList, this._getInsertPgNumber() );
	        this.destroy();
	    },
	    _getInsertPgNumber: function() {
	        if ( this.ui.insertFirstRadio.is(':checked') ) {
	            return 1; // the first page
	        } else if ( this.ui.insertLastRadio.is(':checked') ) {
	            // default
	            return null;
	        }
	        // may later put select box with range ...
	    }
	
	});

/***/ },
/* 140 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<form id=\"add-pg-form\">\n\n    <div id=\"add-pg-insert-section\">\n        <input id=\"insert-last\" type=\"radio\" name=\"insert-page-position\" checked>\n        <label for=\"insert-last\">After Last Page</label>\n        <input id=\"insert-first\" type=\"radio\" name=\"insert-page-position\">\n        <label for=\"insert-first\">Before First Page</label>\n    </div>\n\n    <!-- link label with for id -->\n    <input type=\"file\" id=\"file-upload-input\" multiple>\n    <label id=\"upload-label\" for=\"file-upload-input\" class=\"btn\">\n        <i class=\"icon-upload-1\" style=\"margin-right: 2px;\"></i>\n        Choose Files...\n    </label>\n\n    <div id=\"n-files-selected\"></div>\n\n    <ul id=\"file-upload-list\"></ul>\n\n</form>";
	},"useData":true});

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: may need to give modal the ability to have a sub-view / views
	// ... current uses have it overridable or have content that doesn't require interaction
	// this is extending the existing modal dialog directly
	
	// TODO: when modal is open, disable document keyboard events -- currently used in mousetrap
	
	var Modal = __webpack_require__(110),
	    _ = __webpack_require__(49),
	    Util = __webpack_require__(48);
	
	__webpack_require__(143);
	
	module.exports = Modal.extend({
	    baseModalDefaults: {
	        title: 'Reorder Pages'
	    },
	    contentTemplate: __webpack_require__(144),
	    initialize: function(options) {
	
	        this.numberPagesInDocument = options.numberPagesInDocument;
	
	        this.settings = _.extend( {}, {
	            content: this.contentTemplate( this.serializeContentTemplateData() )
	        }, options );
	
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );
	
	        return this;
	    },
	
	    onShow: function() {
	        Modal.prototype.onShow.apply(this, arguments);
	        setTimeout( _.bind( function() {
	            this.ui.movePgInput.select();
	        }, this), 1 );
	    },
	    serializeContentTemplateData: function() {
	        return {
	            currentPgNumber: this.options.currentPgNumber,
	            movePgsInputName: Util.getUniqueStrToDisableFormAutoComplete(),
	            moveToInputName: Util.getUniqueStrToDisableFormAutoComplete()
	        };
	    },
	
	    ui: _.extend( {}, Modal.prototype.ui, {
	        movePgInput:    '#rp-move-input',
	        moveToPgInput:  '#rp-move-to-pg',
	        afterCheckbox:  '#rp-after-cb',
	        radioBtns:      '.rp-pos-radio',
	        moveToLbl:      '#rp-move-to-lbl',
	
	        // may want to make validation and these common ... at least use same classes, etc ...
	        errorMessageWr:         '.dialog-err-msg-wr',
	        errorMessageTxt:        '.dialog-err-msg-txt'
	    }),
	
	    events: _.extend( {} , Modal.prototype.events, {
	        'change @ui.radioBtns':  'onRadioBtnChange'
	    }),
	
	    ok: function() {
	
	        // TODO: util for err msg
	        this.ui.errorMessageWr.addClass('hide');
	        this.ui.errorMessageTxt.text('');
	
	
	        // 1) Fail if first input is not valid
	        var pgsToMove = this.getPgsToMove( this.ui.movePgInput.val() );
	        if ( typeof pgsToMove === 'string' ) {
	            this._showValidationErrorMsg(pgsToMove);
	            return;
	        }
	
	        // 2) Fail if second not valid
	        var destinationPg = this.getDestinationPg( this.ui.moveToPgInput.val() );
	        if (typeof destinationPg === 'string') {
	            this._showValidationErrorMsg(destinationPg);
	            return;
	        }
	
	        // 3) Fail if combo of each is not valid
	
	        // 3a) Fail if the destination page is in the list of pages to be moved
	        if ( _.contains(pgsToMove, destinationPg) ) {
	            this._showValidationErrorMsg('Destination page is in the list of pages to be moved.');
	            return;
	        }
	
	        //3b) Fail if operation would not result in change of pages -- could be a fn itself ... all these necessary?
	        var insertAfter = this.isAfterChecked();
	
	        var begPg = pgsToMove[0],
	            endPg = pgsToMove.length > 1 ? _.last(pgsToMove) : pgsToMove[0];
	
	        //  (need =)???
	        if ( begPg <= destinationPg && destinationPg <= endPg ) {
	            this._showValidationErrorMsg('Operation would cause no change in page order.');
	            return;
	        }
	
	        // eg: don't insert 4 before 5; 2-4 before 5
	        if ( !insertAfter && endPg + 1 === destinationPg ) {
	            this._showValidationErrorMsg('Operation would cause no change in page order.');
	            return;
	        }
	
	        // eg: don't insert 5 after 4; insert 4-5 after 3
	        if ( insertAfter && begPg - 1 === destinationPg ) {
	            this._showValidationErrorMsg('Operation would cause no change in page order.');
	            return;
	        }
	
	        this.destroy();
	        this.settings.okCB( pgsToMove, destinationPg, insertAfter );
	
	
	    },
	
	    // return err msg if invalid or array of pages numbers to move
	    getPgsToMove: function( input ) {
	
	        var errPrefix = 'Pages to be moved is invalid: ';
	
	        if (!input)
	            return errPrefix + 'none specified.';
	
	        // remove any spaces -- expression below allows for spaces in the middle of reg ex but not at beg or end
	        input = input.replace(/\s/g, '');
	
	        var re = /^\d+(?:-\d+)?$/gm;
	        if (!re.test(input))
	            return errPrefix + 'provide a single integer or two integers separated by a dash (-).';
	
	
	        if ( input.indexOf('-') < 1 ) {
	
	            // Single Page
	            var pgNum = parseInt(input); //handle leading zeros
	
	            return this.pgNumExistsInDocument(pgNum)
	                ? [pgNum]
	                : errPrefix + 'page ' + pgNum + ' does not exist in the document.';
	
	        } else {
	
	            // Range
	            var pgs = input.split('-'),
	                pg1 = parseInt( pgs[0] ),
	                pg2 = parseInt( pgs[1] ),
	                pg1IsValid = this.pgNumExistsInDocument(pg1),
	                pg2IsValid = this.pgNumExistsInDocument(pg2);
	
	            if ( pg1IsValid && pg2IsValid ) {
	
	                // both pages are valid -- return sorted array of the page range
	
	                var pgMin = Math.min( pg1, pg2 ),
	                    pgMax = Math.max( pg1, pg2 ),
	                    aPgs = _.range( pgMin,  pgMax );
	                    aPgs.push(pgMax);
	                    aPgs = _.sortBy(aPgs, function(n) { return n; });
	
	                return aPgs;
	
	
	            } else {
	
	                var invalidPgs = [];
	                !pg1IsValid && invalidPgs.push( pg1 );
	                !pg2IsValid && invalidPgs.push( pg2 );
	
	                return errPrefix + 'page' + (invalidPgs.length > 1 ? 's ' : ' ') +
	                     invalidPgs.join(', ') + (invalidPgs.length > 1 ? ' do' : ' does') +
	                    ' not exist in the document.';
	
	            }
	        }
	
	    },
	
	    // return err msg if invalid of the destination page number
	    getDestinationPg: function( input ) {
	
	        var errPrefix = 'Invalid destination page: ';
	
	        if (!input)
	            return errPrefix + 'none specified.';
	
	        input = input.replace(/\s/g, '');
	
	        if (!/^\d+$/gm.test(input))
	            return errPrefix + 'provide a single page number.';
	
	        var pgNum = parseInt(input); //handle leading zeros
	        return this.pgNumExistsInDocument(pgNum)
	            ? pgNum
	            : errPrefix + 'page ' + pgNum + ' does not exist in the document.';
	
	    },
	
	    pgNumExistsInDocument: function(n) {
	        return n > 0 && n <= this.numberPagesInDocument;
	    },
	
	    onRadioBtnChange: function() {
	        var txt = this.ui.moveToLbl.text();
	        this.ui.moveToLbl.text( txt.replace( /before|after/gi , this.isAfterChecked() ? 'After' : 'Before') );
	    },
	
	    isAfterChecked: function() {
	        return this.ui.afterCheckbox.is(':checked');
	    },
	
	    // TODO: common w delete pg ... should make part of modal ...
	    _showValidationErrorMsg: function(msg) {
	        this.ui.errorMessageWr.removeClass('hide'); // could make top level in css
	        this.ui.errorMessageTxt.html(msg);
	    }
	
	
	});

/***/ },
/* 143 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<form id=\"reorder-pgs-form\">\n\n    <div id=\"rp-grp-div\" class=\"rp-row\">\n        <label id=\"rp-move-lbl\" class=\"rp-input-lbl\" for=\"rp-move-input\">Move page number:<br>(or range: # - #)</label>\n        <input name=\""
	    + alias4(((helper = (helper = helpers.movePgsInputName || (depth0 != null ? depth0.movePgsInputName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"movePgsInputName","hash":{},"data":data}) : helper)))
	    + "\" id=\"rp-move-input\" class=\"rp-text-input\" type=\"text\" value=\""
	    + alias4(((helper = (helper = helpers.currentPgNumber || (depth0 != null ? depth0.currentPgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currentPgNumber","hash":{},"data":data}) : helper)))
	    + "\" autocomplete=\"nope\">\n    </div>\n\n    <div id=\"rp-radio-wr\" class=\"rp-row\">\n        <label>\n            <input id=\"rp-before-cb\" class=\"rp-pos-radio\" type=\"radio\" name=\"rp-position\"> before\n        </label>\n        <label>\n            <input id=\"rp-after-cb\" class=\"rp-pos-radio\" type=\"radio\" name=\"rp-position\" checked> after\n        </label>\n    </div>\n\n    <div id=\"rp-move-to-div\" class=\"rp-row\">\n        <label id=\"rp-move-to-lbl\" class=\"rp-input-lbl\" for=\"rp-move-to-pg\">After page number:</label>\n        <input name=\""
	    + alias4(((helper = (helper = helpers.moveToInputName || (depth0 != null ? depth0.moveToInputName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"moveToInputName","hash":{},"data":data}) : helper)))
	    + "\" id=\"rp-move-to-pg\" class=\"rp-text-input\" type=\"text\" autocomplete=\"nope\">\n    </div>\n\n</form>\n\n<!-- TODO: same as add page; consolidate -->\n<div class=\"dialog-err-msg-wr hide\">\n    <i class=\"icon-attention-circled\"></i>\n    <div class=\"dialog-err-msg-txt\"></div>\n</div>\n\n\n";
	},"useData":true});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {__webpack_require__(146);
	
	var Modal = __webpack_require__(110),
	    _ = __webpack_require__(49),
	    ChildPgInfoView = __webpack_require__(147);
	
	//TODO: incorp concept of child template in the main class (and apply to other uses)
	
	
	var defaults =  {
	    hideFooter: true,
	    omitBodyOverflow: true,
	    // Note: for now setting height to a fixed value that would fix the height of content column one & one row of redactions for 1 page;
	    // This could/should be made more dynamic in the future to fit the height of the contents (DVBC-1508)
	    height: '350px', // was 325: added more spacing with addition of another line for full page reason codes; not making dynamic for now; looks ok
	    omitBodyPadding: true,
	    width: '600px' //TODO: autosize, etc
	};
	
	
	module.exports = Modal.extend({
	    compositeTemplate: __webpack_require__(260),
	    initialize: function(options) {
	
	        var pgs = this.options.pages,
	            isSinglePg = pgs instanceof Backbone.Model,
	            $compositeMarkup = $( this.compositeTemplate() ),
	            childPgs =  isSinglePg ? [this.options.pages] : this.options.pages.models;
	
	        _.each(childPgs, function(pg) {
	            $compositeMarkup.find('.pg-info-tbl-wr').append(  new ChildPgInfoView({
	                model: pg,
	                activeDocId: this.options.activeDocId
	            }).render().el );
	        }, this);
	
	        this.settings = _.extend( {} , {
	            content: $compositeMarkup[0].outerHTML
	        }, defaults, options );
	
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.defaults ) );
	        return this;
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(59)))

/***/ },
/* 146 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, moment) {__webpack_require__(148);
	
	var Marionette = __webpack_require__(61),
	    RedactionNoteModel = __webpack_require__(149);
	
	__webpack_require__(71);
	
	module.exports = Marionette.ItemView.extend({
	
	    tagName: 'li',
	    className: 'pgInfoListItem',
	    template: __webpack_require__(259),
	
	
	    /**
	     * Note: docId refers to the docId we are viewing; but the page can be of a dynamic folder in which case it will be a different doc id.
	     * DVBC-1382: unsure how we want to show reason codes metrics
	     * for now showing by page and in this dialog
	     * make change in the future after feedback
	     * may want to put in a subview for flexibility (once we decide how to display them)
	     * If leave in here and a single page, may want to make modal height larger to avoid vertical overflow.
	     * RedactionNoteModel.prototype.getReasonCodeString:
	     * (function lives on redaction note model for code re-use)
	     * should be organized better but waiting until we decide how this feature should be implemented
	     * a helper fn or similar may be a better way to go
	     *  TODO: now that descriptions are passed in with the codes in the shapes object -- could more easily include them in a report
	     *  ... if so, would probably want to use HTML, not a string ... I guess could use a title attribute for hower at the least ...
	     *  DVBC-1730 -- now reporting regular reason codes and full page reason codes separately
	     */
	
	    serializeData: function() {
	
	        var pg = this.model,
	            pgAttributes = pg.attributes,
	            parentDynamicFolderDoc = pgAttributes.parentDynamicFolderDoc; //will be undefined for non dynamic folder pages
	
	
	        var nonFullPageReasonCodesCxt = getTemplateCxtForReasonCodes('nonFullPage'),
	            fullPageReasonCodesCxt = getTemplateCxtForReasonCodes('fullPage');
	
	
	        return _.extend( {}, pgAttributes, {
	
	            pageType: pg.getFriendlyName(),
	
	            docId: parentDynamicFolderDoc
	               ? parentDynamicFolderDoc.info.documentId
	               : this.options.activeDocId,
	
	            showOriginalImageInfo: pg.isFddImage(),
	            showGOSInfo: pg.hasGosInfo(),
	            showOverlayInfo: pg.isCold(), //show if cold, even though an overlay may not be applied, -- the overlay font info is really pertaining to the text (the overlay is prob an image)
	            createdOn: pg.get('createdOn') ? moment.convertDBTimeToLocalTime( pg.get('createdOn') ) : '', // handle in case not passed by server
	
	            hasNonFullPageReasonCodes: nonFullPageReasonCodesCxt.hasReasonCodes,
	            nonFullPgReasonCodeStr: nonFullPageReasonCodesCxt.reasonCodeStr,
	
	            hasFullPageReasonCodes: fullPageReasonCodesCxt.hasReasonCodes,
	            fullPageReasonCodesStr: fullPageReasonCodesCxt.reasonCodeStr
	
	        });
	
	
	        function getTemplateCxtForReasonCodes(type) {
	
	            var reasonCodesByCounts = pg.getReasonCodesCounts(type),
	                hasReasonCodes = reasonCodesByCounts !== null,
	                reasonCodeStr = hasReasonCodes
	                    ? RedactionNoteModel.prototype.getReasonCodeString(reasonCodesByCounts)
	                    : null;
	
	            return {
	                hasReasonCodes: hasReasonCodes,
	                reasonCodeStr: reasonCodeStr
	            };
	        }
	
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(69)))

/***/ },
/* 148 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    CoordinateNote = __webpack_require__(150),
	    RedactionNoteView = __webpack_require__(231),// for now using one: would need to refactor ViewConstructor to accept function (and know diff btn constructor)
	    RedactionShapeView = __webpack_require__(233),
	    FloatingRedactionShapeView = __webpack_require__(244),
	    CoordinateRedactionShapeModel = __webpack_require__(252),
	    FloatingCodesShapeModel = __webpack_require__(258);
	
	/*
	* For ease in facilitating conversion from floating to non-floating codes,
	* only use one model and switch track for the shape views and models.
	* ( Encountered reference (to other objects) & other issue when trying to create new note models instead of just switch tracking
	* off the noteType and isConvertingToFloatingCodes.  The different shape models and views do work well however --
	* it's a cleaner process or reRendering the shapes on the canvas, from which the constructor fn are called ).
	* */
	
	module.exports = CoordinateNote.extend({
	
	    SUPPORTS_FIND_AND_REDACT: true,
	
	    ViewConstructor: RedactionNoteView,
	    init: 'D', // Floating is 'B'
	    desc: 'Redaction',
	    createHotKey: 'r',
	    actionTitle: 'Redact',
	    iconClass: 'icon-doc-text-inv',
	    autoDisplayApplies: false,
	    subTypes: ['rect', 'poly'],
	    defaultShapeColor: '#ff0000',
	
	    initialize: function( attrs, options ) {
	
	        // Here for explicity so we can see this variable explicitly exists on here
	        this.isConvertingToFloatingCodes = false;
	
	        /*
	        * Flag to prevent creating floating codes on Cold Pages.
	        * Only set in model parse when creating a new note (below -- passed from options).
	        * Not necessary to define here but left for clarity.
	        * The default is really 'false' (it starts undefined).
	        * Necessary to persist between note model creation and save ( after which parse calls init, so don't set back to false in here );
	        * No notes read from the database should ever be floating if created on cold pages.
	        * Defining this on the constructor is a better way but would require a refactor the note model.
	        * Clearer options to accomplish this include utilizing the model's collection post save or,
	        * injecting vChannel to determine if the page is cold from the pageId attribute.
	        * */
	        this.parentPageIsCold = this.parentPageIsCold;
	
	        CoordinateNote.prototype.initialize.apply( this, arguments );
	
	    },
	
	    parse: function(attrs, options) {
	
	
	        // cache some values as inst variables on the model
	        // must reset them first (not clearing on modify, so do here)
	        this.listOfReasonCodesForNoteView = null;
	        this.uniqueStringOfReasonCodes = null; // (what is searched in the SAT filter)
	
	        this.listOfReasonCodesForNoteView = this.getUniqueListOfSavedReasonCodesForNoteView(attrs.shapes);
	        this.uniqueStringOfReasonCodes = this._getUniqueStringOfSavedReasonCodes(attrs.shapes);
	
	        this.systemIsSetToFloatingCodes = fvChannel.request('applyFloatingReasonCodes'); // cache
	        this.parentPageIsCold = this.parentPageIsCold || options.isColdPage;
	
	        /*
	        * This only applies to when creating
	        * A result of only having the 'REDACTION_NOTE' type in the create note drop down menu
	        * (and only having one model for both floating and non floating codes).
	        * Floating redactions are not permitted on COLD pages. ... would be clearer to put on constructor (init called after parse)
	        * FULL_PAGE_REDACTION clause: prevent the switch to floating for this note type ( may want clearer flag here )
	        * */
	        if ( options && options.isNew && this.systemIsSetToFloatingCodes && !this.parentPageIsCold && attrs.noteType !== 'FULL_PAGE_REDACTION' )
	            attrs.noteType = 'FLOATING_REDACTION_NOTE';
	
	        // set back isConverting flag post successful floating redaction note
	        // ( pre-save it's note type is set to floating )
	        if ( this.isConvertingToFloatingCodes && attrs.noteType === 'FLOATING_REDACTION_NOTE' ) {
	            this.isConvertingToFloatingCodes = false;
	        }
	
	        return CoordinateNote.prototype.parse.apply(this, arguments);
	
	    },
	    /*
	    * Note: this seems the place to returns either a rect or poly shape view when subclass the module.
	    * Though now it's working and doing so may prove more complex.
	    *  May make sense to move these constructor references off the model and into a factory in the application.
	    * */
	    shapeView: function(options) {
	
	        var useFloating = this.isConvertingToFloatingCodes || ( this.get('noteType') === 'FLOATING_REDACTION_NOTE' && this.systemIsSetToFloatingCodes );
	        return useFloating
	            ? new FloatingRedactionShapeView(options)
	            : new RedactionShapeView(options);
	
	    },
	    getShapeModel: function() {
	
	        var useFloating = this.isConvertingToFloatingCodes || ( this.get('noteType') === 'FLOATING_REDACTION_NOTE' && this.systemIsSetToFloatingCodes );
	        return useFloating
	            ? FloatingCodesShapeModel
	            : CoordinateRedactionShapeModel;
	    },
	
	    resetOnCancelChanges: function() {
	
	        CoordinateNote.prototype.resetOnCancelChanges.apply( this, arguments );
	
	        // reset this so when the canvas is redrawn, the other note type will be used
	        this.isConvertingToFloatingCodes && ( this.isConvertingToFloatingCodes = false );
	
	    },
	    /*
	    * Return a unique sorted, unique list of saved reason codes from all shapes to display on the note view.
	    * If none exist, return null.
	    * If shapes provided, use that instead of the shapes property on the model ( could come from parse ).
	    * code here could be optimized but shouldn't impact performance, especially now caching on parse
	    * */
	    getUniqueListOfSavedReasonCodesForNoteView: function(shapes) {
	        
	        if (this.listOfReasonCodesForNoteView)
	            return this.listOfReasonCodesForNoteView;
	
	        // note: this top line can be gotten rid of ...
	        shapes = shapes || this.get('shapes');
	        if (!shapes || shapes.length < 1)
	            return null;
	
	        // Get obj of unique codes by their counts
	        // DVBC-1382: depending on direction, may want diff obj / helper for this.
	        // For time being this fn is a quick fix to avoid code duplication.
	        var codesByCounts = this.getReasonCodeCounts(shapes);
	        if (codesByCounts === null)
	            return null;
	
	        // Note: may want to make this html if need to get rid of parentheses (that are often used in codes)
	        return this.getReasonCodeString(codesByCounts);
	
	    },
	    // Return obj of unique codes X count from the note's shapes
	    // If none exist, return null
	    getReasonCodeCounts: function(shapes) {
	
	        var shapes = shapes || this.get('shapes');
	        if (!shapes || shapes.length < 1)
	            return null;
	
	        // get non unique array of codes from all shapes
	        var allCodes = _.chain( shapes )
	            .map( function(s) {
	                return _.pluck( s.reasonCodes, 'code' );
	            })
	            .flatten()
	            .value();
	
	        // create obj of unique codes X count
	        // (maybe make this a diff obj ... for code reuse; later used in page/doc metrics for sorting, etc
	        var codesByCounts = {};
	        _.each( allCodes, function(c) {
	            codesByCounts[c] = !_.contains( _.keys(codesByCounts), c )
	                ? 1
	                : codesByCounts[c] += 1;
	        });
	
	        return  _.keys(codesByCounts).length < 1
	            ? null
	            : codesByCounts;
	
	    },
	    // Take obj of codes by counts and return a string of them sorted by count (show in parenthesis), then by code
	    getReasonCodeString: function(codesByCounts) {
	
	        // Transform codesByCounts into format that facilitates sorting
	        var arrayOfCodesObjsToSort = [];
	
	        for (var code in codesByCounts) {
	            arrayOfCodesObjsToSort.push( {
	                code: code,
	                count: codesByCounts[code]
	            });
	        }
	        // Sort by both code and count
	        var aSortedObjs = _.chain( arrayOfCodesObjsToSort )
	            .sortBy( function(o ) {
	                return o.code;
	            })
	            .sortBy( function(o) {
	                return o.count * -1; //(descending)
	            }).value();
	
	        return _.map( aSortedObjs, function(o) {
	            return o.code + ( o.count > 1 ? '(' + o.count + ')' : '' ) ;
	        }).join(', ').trim();
	
	    },
	
	    // Add string of unique reason codes to search for in the SAT filter
	    textToFilter: function() {
	        return CoordinateNote.prototype.textToFilter.apply(this, arguments) + this._getUniqueStringOfSavedReasonCodes();
	    },
	
	    /*
	    * Now used for text to filter -- if none, return empty string.
	    * If shapes provided, use that instead of the shapes property on the model ( could come from parse ).
	    * May want to search exactly what is printed in listOfReasonCodesForNoteView ....
	    * */
	    _getUniqueStringOfSavedReasonCodes: function(shapes) {
	
	        if (this.uniqueStringOfReasonCodes)
	            return this.uniqueStringOfReasonCodes;
	
	        var shapes = shapes || this.get('shapes');
	        if (!shapes || shapes.length < 1) return '';
	
	        // return munged string of unique reason codes
	        return _.chain( shapes )
	            .map( function(s) {
	                return _.pluck( s.reasonCodes, 'code' );
	            })
	            .flatten()
	            .uniq()
	            .value().join('');
	    }
	
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DrawableNote = __webpack_require__(151),
	    BaseShapeView = __webpack_require__(181);
	
	/*
	* Coordinate refers to page notes stored in FDD Graphic Object Files in Edstor: highlights, redactions, strikethroughs
	* */
	
	module.exports = DrawableNote.extend({
	
	    defaultSubType: 'rect',
	
	    defaultFillOpacity: 0.25, // TODO: move to shape models ?
	
	    shapeModelsToRender: function(page) {
	
	        var ShapeModelConstructor = this.getShapeModel();
	
	        return _.map( this.get('shapes'), function(attrs, i) {
	
	            return new ShapeModelConstructor( attrs, {
	                parentNote: this,
	                pageModel: page,
	                shapeIndexOfNote: i,
	                isConvertingToFloatingCodes: this.isConvertingToFloatingCodes // this should just be on redaction shape ( but wont hurt highlights ) ...
	            });
	
	        }, this);
	
	    },
	    shapeView: function(options) {
	        return new BaseShapeView(options);
	    },
	    hasShapes: function() {
	        return this.get('shapes').length > 0; //shape will be empty array w/out
	    },
	
	    // --- Would want to move these to shape models ( but kinda difficult since newly drawn shapes don't have a model ) ---
	
	    /**
	     * Central point for getting the 'default' Raphael attributes to apply to notes' shapes.
	     * Now called centrally from canvas.getAttributesToApplyToShapeEl,
	     * which calls canvas.getColorToApplyToShape, which is the color parameter passed here.
	     */
	    defaultSVGAttrs: function( color ) {
	
	        color = color ? color : this.getDefaultShapeColor();
	
	        var opacity = this.getDefaultFillOpacity();
	
	        return {
	            stroke: color,
	            fill: color,
	            'stroke-width': 0,
	            'fill-opacity': opacity
	        };
	
	    },
	
	
	    defaultSVGAttrsEdit: function( color ) {
	
	        return _.extend(
	            {},
	            this.defaultSVGAttrs( color ),
	            { 'stroke-width': 2 }
	        );
	
	    },
	
	    getDefaultFillOpacity: function() {
	        return this.defaultFillOpacity;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    PageNote = __webpack_require__(152),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    GroupCollection = __webpack_require__(85);
	
	
	module.exports = PageNote.extend({
	
	    SUPPORTS_FIND_AND_REDACT: 0,
	
	    STORES_COLOR: 1, // flag if drawable note type stores color
	
	    SUPPORTS_COLOR_PICKER: 0, // whether the note type supports a color picker in DV
	
	    /**
	     * Store an array of shape models that can be set on parse.
	     * Currently only used by full page redaction, but may later apply to other note types;
	     */
	    constructor: function( attrs, options ) {
	
	        this.shapes = [];
	
	        this.creationUserGroups = null; // keep around in case ever wanted ( eg to provide more specificity on where color's coming from )
	        this.groupOfDerivedCreationUserGroupColor = null; // use to get the color, also more info like the name
	
	        // Set on parse -- on cancel will revert to this in case set otherwise; could be different attributes (eg text)
	        this.originalShapeAttrs = null;
	
	        return PageNote.prototype.constructor.apply( this, arguments );
	
	    },
	
	
	    parse: function( attrs, options ) {
	
	        var isNew = !attrs.sequence;
	
	        attrs = PageNote.prototype.parse.apply( this, arguments );
	
	        this.setOriginalShapeAttrsOnParse( attrs );
	
	        /**
	         * For all that store color ( everyone except GRAPHIC stamps -- set creationUserGroups & groupOfDerivedCreationUserGroupColor )
	         * - potential area for perf improvement, it saved note cusr if current user, use current user's creationGroups
	         */
	        if ( this.STORES_COLOR ) {
	
	
	            if ( !isNew ) {
	
	                // Check for backwards compatibility ( eg fixture without the attribute )
	                if ( attrs.creationUserGroups ) {
	                    // Yeah more Backbone overhead but keeps this more organized with fn to get off the groups collection
	                    this.creationUserGroups = new GroupCollection( attrs.creationUserGroups );
	                }
	
	
	            } else {
	
	                // New - unsaved:
	                var currentUserGroups = fvChannel.request('user').groups;
	
	                // Set the 'cached' creation user groups
	                this.creationUserGroups = currentUserGroups;
	
	                // For node server, put creationUserGroupColor on the attributes so they
	                // are returned on save ( the real server will always recalculate and return ).
	                // Could move to save, but seems reasonable here to keep with other logic for now.
	                if ( fvChannel.request('settings').isRunningNode ) {
	
	                    attrs.creationUserGroups = currentUserGroups.toJSON(); // no need to cache ( just DEV and not much perf hit )
	                }
	
	            }
	
	            // Check: in place for old pageNote fixtures lacking attrs.creationUserGroups
	            if ( this.creationUserGroups ) {
	
	                this.groupOfDerivedCreationUserGroupColor =
	                    this.creationUserGroups.getGroupOfDerivedUserColor();
	
	            }
	
	        }
	
	        return attrs;
	
	    },
	
	    getGroupOfDerivedCreationUserGroupColor: function() {
	
	        return this.groupOfDerivedCreationUserGroupColor;
	
	    },
	
	    getCreationUserGroupColor: function() {
	
	        if ( !this.getGroupOfDerivedCreationUserGroupColor() )
	            return null;
	
	        return this.groupOfDerivedCreationUserGroupColor.getColor();
	
	    },
	
	    /**
	     * testing -- on re-render of canvas the shapes attribute can be updated
	     * will need to change on diff note types for diff attributes used
	     * shapes is what is used to create the shape models -- maybe on parse get the attributes required and make the shapes out of that ?
	     */
	    resetOnCancelChanges: function() {
	
	        PageNote.prototype.resetOnCancelChanges.apply( this, arguments );
	
	        this.resetShapeAttrsOnCancelChanges();
	
	    },
	
	    /* Overwride if not using the shapes object to read in */
	    /* Typically attrs is 'shapes' */
	    setOriginalShapeAttrsOnParse: function( response ) {
	
	        this.originalShapeAttrs = response.shapes;
	
	    },
	
	    /* Can override, like, eg for 'text' */
	    resetShapeAttrsOnCancelChanges: function() {
	
	        this.set( 'shapes', this.originalShapeAttrs );
	
	    },
	
	    draw: true,
	    autoDisplayApplies: true, // all but redaction, graphicStamp, textStamp
	    ViewConstructor: __webpack_require__(179),
	
	    getDefaultShapeColor: function() {
	        return this.defaultShapeColor;
	    },
	
	    /*
	    * Override if a factory: eg redaction -- to return a different constructor.
	    * Otherwise: returns the constructor on the prototype
	    * */
	    getShapeModel: function() {
	        return this.ShapeModel;
	    },
	
	    getDefaultShapeSubType: function() {
	        return this.defaultSubType;
	    },
	
	    /**
	     * Update the note model attributes from the shapes on the canvas so we can
	     * use the attributes to getNewShapeModels.
	     * Called on canvas re-render for the active note, since for now, shape models are
	     * not peristed on the note and will be lost in the re-render call.
	     * shapeAttributesOfNote: what would be used to persist the notes a save call --
	     * Note: this would be enough for saved shapes that had been modified, but not
	     * any 'newlyDrawn' shapes -- these are then added to the shapes array in the re-render function,
	     * since they wouldn't yet exist on the note model.
	     * see the canvas shape code -- an interim refactor
	     */
	    updateAttributesToCreateShapeModelsOnCanvasReRender: function( shapeAttributesOfNote ) {
	
	        this.set( shapeAttributesOfNote );
	
	    },
	
	    /*
	     * Return whether the shapes of 'drawable notes' should be hidden or shown.
	     * Note: page text notes also have a noteStatus but it is meaningless to Doc Viewer --
	     * it determines whether FDD client will pop open the window for these notes on load.
	     * */
	    applyAutoDisplayToShapes: function () {
	        return ( (this.autoDisplayApplies && this.get('noteStatus') !== 'V') );
	    },
	
	    supportsColorPicker: function() {
	
	        return this.SUPPORTS_COLOR_PICKER;
	
	    },
	
	    supportsFindAndRedact: function() {
	
	        return this.SUPPORTS_FIND_AND_REDACT;
	
	    },
	
	    /**
	     * Must disallow picking the 'actual color' if there are any overrides, which now include
	     * the current 'derived' consult color and group cusr creation color.
	     * Return null if should not disable or an error message for a tooltip explanation to disable it.
	     */
	    disableColorPickerDueToColorRules: function( ) {
	
	        if ( !this.supportsColorPicker )
	            return;
	
	        var disableReasons = [];
	
	        var consultGroupColor = this.getCurrentConsultColorForShapes();
	        if ( consultGroupColor )
	            disableReasons.push( 'One consult group with a color is assigned to the note.' );
	
	
	        var noteCreationUserGroupColor = this.getCreationUserGroupColor();
	        if ( noteCreationUserGroupColor )
	            disableReasons.push( 'Note creation user belongs to one group with a color assigned.' );
	
	
	        if ( disableReasons.length === 0 )
	            return null;
	
	        return disableReasons.join('\n');
	
	
	    }
	
	
	});


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var NoteModel = __webpack_require__(153),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = NoteModel.extend({
	
	    consultsApplicable: true, // allow consults for all page note types
	    ViewConstructor:  __webpack_require__(178),
	
	    // See comment on document note parse from creating a compound id.
	    // A unique key here is slightly different.
	    parse: function(response) {
	
	        var resp = NoteModel.prototype.parse.apply( this, arguments );
	
	        if ( resp.sequence ) {
	            resp.id = 'P_' +  resp.pageId + '_' + resp.sequence;
	        }
	
	        return resp;
	
	    },
	
	    /*
	    * Note: not for get ( these are retrieved in bulk)
	    * URL here is only for CRUD operations.
	    * Note: from save, can't provide a documentModel parameter unless override Backbone.sync
	    * ( eg notes from find and redact don't have this.document set )
	    * */
	    url: function( ) {
	
	        var seq = this.get('sequence'),
	            pageId = this.get('pageId'),
	            creating = !pageId || seq === undefined;
	
	        var url = fvChannel.request('apiUrl').pageNote(
	            this.collection.document,
	            pageId,
	            creating ? undefined : seq
	        );
	
	        return url;
	
	    },
	
	    /*
	    * TODO: mediate at the viewer level -- different page models based on mode ... this is the document mode page
	    * */
	    getPageModel: function() {
	        return this.collection.document.pageCollection.findWhere({
	            pageId: this.get('pageId')
	        });
	    }
	
	
	
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    NoteUIModel = __webpack_require__(154),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	var instVars = {
	    uiModel: null, //for the note view
	    parentFlashBackNote: null //ew: there for FB notes being created ... THESE MUST GET EXTENDED .... that was hack
	
	    /* noteTypeGroup:
	        - don't make attribute: java jackson parser will throw exception for unknown attributes, so make instance var
	        - but don't put in this -- parse called b/f init so it will be overwritten
	        - I'm sure there's a better pattern here to see for clarity of the instance vars
	    */
	    // noteTypeGroup: null
	
	    // those used as flags ....
	    //isText: undefined //--> isText()
	    //isDocument
	};
	
	
	module.exports = Backbone.Model.extend({
	
	    ViewConstructor: __webpack_require__(155),
	
	    NoteUIModel: NoteUIModel,
	
	    // put this in constructor ???
	    initialize: function( attrs, options ) {
	
	        /**
	         * TODO: issue -- since parse is called from constructor 1st, UI model may not be new yet if we need to update the properties
	         * put in constructor?
	         * see textStamp.parse
	         */
	        // ( see textStamp )
	        _.extend( this, instVars, {
	           uiModel: new this.NoteUIModel({ parent: this} )
	        });
	
	        // Allow to set the page number if provided
	        if ( options.pageNumber ) {
	            this.pageNumber = options.pageNumber;
	        }
	
	    },
	
	    parse: function(resp, options) {
	        // add noteTypeGroup to the attributes
	        // this better handled server-side but then need to do with that arch: doing note logic like this in other places on client anyway ...
	
	        // put logic on base note and avoid putting on prototypes:  _.result(this, 'noteTypeGroup')
	        // .. this is b/c if save, for instance, a keyed text note, the text note model wont have a noteTypeGroup defined
	        // .. though if 'ifs' get out of control, could put function on the parent type -- eg the text note
	        var noteType = resp.noteType,
	            noteTypeGroup = noteType;
	
	        if (noteType === 'HTML_NOTE') noteTypeGroup = 'TEXT_NOTE';
	        if (noteType === 'KEYED_TEXT_NOTE') noteTypeGroup = 'TEXT';
	        if (noteType === 'SVG_GRAPHIC_NOTE') noteTypeGroup = 'GRAPHIC_NOTE';
	        if (noteType === 'FLOATING_REDACTION_NOTE') noteTypeGroup = 'REDACTION_NOTE';
	
	        this.noteTypeGroup = noteTypeGroup;
	
	        return resp;
	    },
	
	    getNoteTypeGroup: function() {
	        return this.noteTypeGroup;
	    },
	
	     //the text to search from the model data in note view for the SAT filter
	    textToFilter: function() { 
	
	        var ctime =  this.get('creationTime'),
	            cuser =  this.get('creationUserDesc'),
	            pgNum =  'p.'+ this.pageNumber,
	            title = this.get('title'),
	            text = this.get('text'),
	            //accessGroup = this.get('accessGroupName'),
	            consultGroupNames = this.getConsultGroupNames();
	
	        return (ctime ? ctime : '') + (cuser ? cuser : '') +
	            (pgNum ? pgNum: '') + (title ? title : '') + (text ? text: '') +
	            //(accessGroup ? accessGroup: '') // for now NOT doing may not be shown
	            (consultGroupNames ? consultGroupNames: '');
	
	
	    },
	
	    /**
	     * TODO:
	     * - subclass into different models
	     * - ability to return multiple validation error messages
	     * - perhaps subclass into F&R
	     * - doesn't look like we use the numer any more
	     */
	    validate: function( attrs, options ) {
	
	        var errObj = {
	            num: null, //'enum' causes error ie8 -- ENUM IS RESERVED WORD IE8 AND LOWER -- TODO: still used?
	            message: null
	        };
	
	        /*
	        * Validate 'title' for page notes -- it exists on all note types but it's only exposed in the UI for drawable page notes.
	        * Document text notes and flash notes don't send on create, only on modify.
	        * Page text notes send to the server but don't expose the interface.
	        * For page notes, the default is the note type description, which doesn't exceed the threshold.
	        * Threshold for Doc Notes is 2000; for Page Notes it's 32.
	        * */
	        if ( this.isPageNote() ) {
	
	            var maxTitleCharacters = fvChannel.request('getPageNoteTitleMaxLength');
	
	            if ( attrs.title && attrs.title.length > maxTitleCharacters ) {
	                errObj.message = "Subject cannot exceed " + maxTitleCharacters + " characters.";
	                return errObj;
	            }
	
	        }
	
	        // Full Page Redaction -- If Denied In Full at Least One Reason Code Must Be Selected
	        // Note: for this type, there will only ever be one shape
	        if ( this.isFullPageRedactionNote() ) {
	
	            var reasonCodes = _.pluck( attrs.shapes[0].reasonCodes, 'code' ),
	                isDeniedInFull = !_.contains( reasonCodes, fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE );
	
	            if ( isDeniedInFull && reasonCodes.length < 1 ) {
	                errObj.message = 'Denied in Full redactions must have at least one reason code applied.';
	                return errObj;
	            }
	
	        }
	
	        if  ( this.isDrawable() ) {
	
	            // Don't allow if there are no shapes
	            var shapesAttr;
	
	            if ( this.isSvgNoteType() ) {
	
	                shapesAttr = attrs.text;
	
	            } else if ( this.isGraphicStamp() ) {
	                /**
	                 * For this type, there is x, y, width, height.
	                 * Just look at x, if there is none, the shape was new and the user never placed it down
	                 * Note: there should also be a shape (validation should not fail)
	                 */
	                shapesAttr = attrs.x;
	            } else {
	
	                // Original coordinate notes
	                shapesAttr = attrs.shapes;
	            }
	
	            if (!shapesAttr || shapesAttr.length < 1) {
	                errObj.message = 'Cannot save ' + this.desc + ' note without any shapes.';
	                return errObj;
	            }
	
	
	            if ( this.isTextStamp() && this.uiModel.hasVariableInputs() ) {
	
	                if ( !this.uiModel.getVariableInputs().allInputsAreValid() ) {
	                    errObj.message = 'Cannot save stamp: not all variable inputs entered.';
	                    return errObj;
	                }
	
	            }
	
	
	        }  else {
	
	            if (!attrs.text || attrs.text.length < 1) {
	
	                errObj.message = 'No message entered.';
	
	                /**
	                 * Server will return null text, which would result for flash notes by design, resulting in 'false' validation error.
	                 * ( When opened, the text will be fetched on demand ).
	                 * Only deem invalid if the text is empty before it's sent to the server.
	                 * options.xhr will not exist on entry
	                 */
	                if ( this.isFlashNote() ) {
	
	                    if (!(options.xhr && options.xhr.status === 200))
	                        return errObj;
	                }
	                else {
	                    return errObj;
	                }
	            }
	
	
	
	        }
	
	    },
	
	    /*
	    *  Wraps BB model changedAttributes function.
	    *  If note hasn't changed return false (like Backbone's changedAttributes), otherwise returns the changed attributes.
	    *  Called for edited notes on save/cancel; new (by default) haven't changed --
	    *  Update: also called for new notes ( central notes:changedNoteAttributes request )
	    *  Merges note attrs and shape attrs.
	    * */
	    hasNoteChanged: function( noteAttrs, shapeAttrs ) {
	
	        // title NA for document
	        if (this.isDocument)
	            delete noteAttrs.title;
	
	        /*
	        * TODO: do this on parse of shapes
	        * never needed (but sent in resp) -- could also fill in shape val
	        *  forget what was going on here ...
	        * */
	        if ( this.get('shapes') ) {
	            _.each( this.get('shapes'), function(s) {
	                delete s.unitType;
	            });
	        }
	
	        return this.changedAttributes(
	            shapeAttrs
	                ? _.extend( {}, noteAttrs, shapeAttrs )
	                : noteAttrs
	        );
	
	    },
	    /*
	    * TODO: mediate, put back on view -- and if not at least break up into diff models for the conditionals.
	    * Sanitize input from the note view -- somewhat like computed/derived properties.
	    * This has evolved to generate the appropriate JSON to save the notes ... refactor necessary.
	    * We now have new interfaces for find and redact necessary to see if edit required ... REFACTOR necessary or make model driven.
	    * */
	    sanitizeUserInput: function(inputs, user) {
	
	        /*
	        * Note: for now privateGroups are stored on user ... should be moved.
	        * Shouldn't need to send back ids AND names for access / consult groups --
	        * should be handled by server ... actually, server should handle a lot of this
	        * */
	        var isNew = this.isNew(),
	            isFlashNote = this.isFlashNote(),
	            isFlashBack = this.parentFlashBackNote, /* only stored as flag on model -- if so, don't take from ui but the parent note itself */
	
	            // access groups:
	            defaultAccessGroup = user.defaultNoteAccessGroup(isFlashNote),
	            accessGroup = (!this.isDocument || isFlashNote)
	                ? isFlashBack /* its assumed to be the parent flashback, so not in the ui */
	                    ? this.parentFlashBackNote.get('creationUserPrivateGroup')
	                    : parseInt(inputs.accessibleByVal) //must be page -- it is printed (doesn't matter new/modified)
	                : isNew
	                    ? defaultAccessGroup.id //if not saved, used the default (public)
	                    : this.get('accessGroup'),/* it's modified and not shown -- it didn't change -- leave it */
	            accessGroupName = (!this.isDocument || isFlashNote)
	                ? isFlashBack
	                    ? this.parentFlashBackNote.get('accessGroupName')
	                    : inputs.accessibleByName
	                : isNew
	                    ? defaultAccessGroup.name //if not saved, used the default
	                    : this.get('accessGroupName'); /* it's modified and not shown -- it didn't change -- leave it */
	
	        var sanitizedAttrs = {
	            title: inputs.noteSubject === '' ? this.desc : inputs.noteSubject,
	            text: inputs.text === '' ? null : inputs.text,
	            accessGroup: accessGroup,
	            accessGroupName: (accessGroup === user.get('privateGrpId'))
	                ? user.get('description')
	                : accessGroupName,  // if the access group is the current user, it's displayed as 'Me', replace with the actual description of the user
	            noteStatus: inputs.autoDisplayChecked ? 'V' : 'I'
	        };
	
	        if ( this.isGraphicStamp() ) {
	            // graphic stamps should always have auto-display applied, but FDD save them with a value of 'I'
	            // quick hack here to ensure it's always saved as 'I'
	            sanitizedAttrs.noteStatus = 'I';
	        }
	
	        // for flash note -- this wasn't validated and the keys above have diff names, can't extend
	        // TODO: should have diff model class
	        _.has( inputs, 'sendEmail') && _.extend( sanitizedAttrs, {sendEmail: inputs.sendEmail} );
	
	        /*
	        * Note: consults groups are already sanitized, here putting them on the object to persist.
	        * TODO: ifReviewGroups apply and then consultGroups apply for each --- refactor
	        * TODO: need to see if  fvChannel.request('supportConsults') -- if it doesn't, none should be sent so prob not an issue
	        * */
	        if ( this.consultGroupsApply() ) {
	
	            // Note clean, but this will work instead of sending a null value if none of the potential review types are there.
	            // Send a null if there are none for each would also work, but would require more logic.
	            sanitizedAttrs['reviewGroups'] = {
	                'consultation': inputs.consultGroups
	            };
	        }
	
	        return sanitizedAttrs;
	
	    },
	    isDrawable: function() {
	        return this.draw; //from the xref -- can return null
	    },
	    /* derived from flags ... */
	    isTextNote: function() { //doc text or pg text note
	        return this.isText;  //flag present on text note xrefs
	    },
	    isPageNote: function() {
	        return !this.isDocument;
	    },
	    getNoteClass: function() {
	        return 'pn-' + this.init;
	    },
	    getIconHoverLbl: function() {
	        var desc = this.desc,
	            aDesc = desc.split(' ');
	        return aDesc.length > 1 ? desc : desc + ' Note';
	    },
	    /* derived (from server attrs) ... */
	    getSubject: function(includeQuotes) { //used in rendering subject field in notes
	        var title = this.get('title');
	        if (includeQuotes) {
	            return (title ? '"' + title + '"' : this.desc + ' Note');
	        } else {
	            return (title ?  title : this.desc + ' Note');
	        }
	    },
	    getNoteType: function() {
	        return this.get('noteType');
	    },
	    isPageTextNote: function() {
	        return this.get('noteType') === 'TEXT' || this.get('noteType') === 'KEYED_TEXT_NOTE';
	    },
	    autoDisplayNote: function() {
	        return this.get('noteStatus') === 'V';
	    },
	    isFlashNote: function() {
	        return this.get('noteType') === 'FLASH_NOTE';
	    },
	    isSignature: function() {
	        return this.get('noteType') === 'SVG_SIGNATURE';
	    },
	    isSVGGraphicNote: function () {
	        return this.get('noteType') === 'SVG_GRAPHIC_NOTE';
	    },
	    isFDDGraphicNote: function() {
	        return this.get('noteType') === 'GRAPHIC_NOTE';
	    },
	    isActivityNote: function() {
	        return this.get('noteType') === 'ACTIVITY_NOTE';
	    },
	    isGraphicStamp: function() {
	        return this.get('noteType') === 'GRAPHIC_STAMP';
	    },
	    isTextStamp: function() {
	        return this.get('noteType') === 'GRAPHIC_TEXT_STAMP';
	    },
	    isHighlightNote: function() {
	        return this.get('noteType') === 'HIGHLIGHT_NOTE';
	    },
	    /* -- Redaction -- */
	    isRedactionNote: function() {
	        return this.isNonFullpageRedactionNote() || this.isFullPageRedactionNote();
	    },
	
	    // 'Regular' Redaction Notes
	    isNonFullpageRedactionNote: function() {
	        return this.get('noteType') === 'REDACTION_NOTE' || this.get('noteType') === 'FLOATING_REDACTION_NOTE';
	    },
	
	    // Note: this assumes no conversion
	    isFloatingRedaction: function() {
	        return this.get('noteType') === 'FLOATING_REDACTION_NOTE';
	    },
	
	    isFullPageRedactionNote: function() {
	        return this.get('noteType') === 'FULL_PAGE_REDACTION';
	    },
	
	    isRedactionNoteConvertingToFloatingCodes: function() {
	        // (latter is only ever a property of redaction notes)
	        return this.get('noteType') === 'REDACTION_NOTE' && this.isConvertingToFloatingCodes;
	    },
	
	    isFloatingRedactionAndSystemNotSetForFloatingCodes: function() {
	        return this.get('noteType') === 'FLOATING_REDACTION_NOTE' && !this.systemIsSetToFloatingCodes;
	    },
	
	    isSvgNoteType: function() {
	        return this.isSVGGraphicNote() || this.isSignature() || this.isTextStamp();
	    },
	
	
	    /* -- End Redaction --*/
	
	
	    supportsHoverShape: function() {
	        return this.isGraphicStamp() || this.isSignature() || this.isTextStamp();
	    },
	
	
	    /* --- consult groups --- */
	    // make a sub-object?
	
	    getReviewGroups: function() {
	        return this.get('reviewGroups');
	    },
	    hasReviewGroups: function() {
	        var grps = this.getReviewGroups();
	        return grps && _.keys(grps).length > 0;
	    },
	
	
	    /* may not be applicable to the base type, but will be called on for note types where it doesn't apply -- may want to change this */
	
	    consultGroupsApply: function() {
	        return this.consultsApplicable;
	    },
	
	    // store on model now that we have different type of note views (eg find and redact)
	    showConsultGroupSelectorOnNoteViews: function() {
	        return fvChannel.request('supportConsults') && this.consultGroupsApply();
	    },
	
	    // return the consult groups array directly from the object or null if none exist
	    // TODO: may want to parse these and put on child obj ??? ... get going and see later
	
	    getConsultGroups: function() {
	
	        if ( !this.hasReviewGroups() )
	            return null;
	
	        var consultGrps = this.getReviewGroups().consultation; // now superfluous; and this needs to be in another object ...
	
	        return consultGrps && consultGrps.length > 0
	            ? consultGrps
	            : null;
	
	    },
	
	    // TODO: introduces stronger need for separate objects as this should be CACHED (done on keydown ... also another fn)
	    // return string of all consult group names for filtering or null if none are assigned
	    getConsultGroupNames: function() {
	        var consultGrps = this.getConsultGroups();
	        return consultGrps
	            ? _.pluck(consultGrps, 'name').join('')
	            : null;
	    },
	
	    consultGroupsAssigned: function() {
	        return this.getConsultGroups() !== null;
	    },
	
	    /*
	    * Return the color to apply to note shape derived from note's consultGroups.
	    * This is what's currently in the db -- it's unaffected by user changes between saving the note.
	    * Derived: if there is 1 assigned, return the color of that assignment; if there are > 1, return null (so the default color will apply)
	    * If there are no groups or none is assigned, will return null.
	    * If consultGroups provided, uses those groups to derive the color, instead of that stored on the note.
	    * TODO: put on drawable note only?
	    * */
	    getConsultColorForShapes: function( consultGroups ) {
	
	        consultGroups = consultGroups ? consultGroups : this.getConsultGroups();
	
	        if (!consultGroups)
	            return null;
	
	        return consultGroups.length === 1
	            ? consultGroups[0].color
	            : null;
	
	    },
	    /*
	    * Return the not necessarily saved, derived consult group color as it's currently set in the UI
	    * */
	    getCurrentConsultColorForShapes: function() {
	        return this.uiModel.getCurrentConsultColorForShapes();
	    },
	    /*
	    * Now necessary because we're displaying the 'current' color from that stored on on the UI model.
	    * when changed in the UI, it is changed directly.
	    * If not changed back on cancel, the note's color (and it's shapes on the canvas) won't be reset.
	    * Now only used for this purpose; other persisted attributes are stored on the note model,
	    * and aren't changed immediately with changes to the UI ( values are retrieved from the UI on save )
	    * potential opportunity for refactor if more properties like this are introduced in the future.
	    * */
	    resetOnCancelChanges: function() {
	
	        this.uiModel.resetOnCancelChanges( this.getConsultColorForShapes() );
	
	    }
	
	});
	
	


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = Backbone.Model.extend({
	    defaults: {
	        editMode: false,
	        expanded: false,
	        navigationEnabled: null, //( can click on link) -- start empty
	        viewerPgNumber: 0, // */ this really for new page text notes, updates on change)
	        isEditable: true, // (hide/show mod btns)
	        replyMode: false, /* note: now only for flash note */
	        currentConsultColorForShapes: null, // the derived color to apply from the currently selected consult groups ( TODO: should change the the selected groups and derive the color )
	        isUserDrawingShape: false, // only for drawable notes but not subclassing for simplicity
	        isFiltered: false
	    },
	    initialize: function(options) {
	        this.parent = options.parent; //(the actual note model)
	        this.set('currentConsultColorForShapes', this.parent.getConsultColorForShapes() );
	    },
	    setEditMode: function(val, options) {   //true or false
	        this.set({ editMode: val }, options);
	    },
	    toggleEditMode: function() {
	        this.set({ editMode: !this.get('editMode') });
	    },
	    setNavigationEnabled: function(enable) {  //force change in the model
	        this.set('navigationEnabled', null, {silent: true});
	        this.set('navigationEnabled', enable);
	    },
	    getCurrentConsultColorForShapes: function() {
	        return this.get('currentConsultColorForShapes');
	    },
	    resetOnCancelChanges: function(originalConsultColorForShapes) {
	
	        this.set('currentConsultColorForShapes', originalConsultColorForShapes, {silent: true});
	
	    },
	
	    setIsFiltered: function( isFiltered ) {
	        this.set( 'isFiltered', isFiltered );
	    },
	
	    isFiltered: function() {
	        return this.get('isFiltered');
	    }
	
	});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {
	
	/**
	 * TODO:
	 * - this should be a form
	 * - really need to refactor to be a LayoutView at least ( may not be huge refactor; would have to test all note types )
	 * - move referral stuff to drawable note (or page note); leaving in here for now as likely will be added to all note types
	 *    and would be more appropriate when create views for all the diff note types, which is a larger project
	 *
	 */
	
	__webpack_require__(156);
	__webpack_require__(157); //TODO: separate when own class; some classing already in progress
	__webpack_require__(158);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    SpinView = __webpack_require__(159),
	    Util = __webpack_require__(48),
	    ConsultGroupSelector = __webpack_require__(161),
	    AccessGroupSelector = __webpack_require__(173),
	    getContrastYIQ = Util.getContrastYIQ; // inc perf somewhat
	
	
	__webpack_require__(71);
	__webpack_require__(76); // (setCursorEndOfText)
	__webpack_require__(114);
	__webpack_require__(175);
	__webpack_require__(176);
	
	
	
	module.exports = Marionette.ItemView.extend({
	    className: 'note',
	    template: __webpack_require__(177),
	    initialize: function(options) {
	
	        _.extend( this, _.pick(options, 'model', 'channel'), {
	            uiModel: options.model.uiModel,
	            consultSelectorView: null,
	            accessGroupSelectorView: null
	        });
	
	         _.bindAll(this,'_getRawUserInput');
	    },
	
	    onRender: function() {
	
	        this.unwrap();
	
	        // showNoteOperations: isPageNote or newFlashNote (that's not a flashback note) ... TODO: can have different condition on FlashNote View
	        if ( this.ui.accessGrpPlaceHolder.length > 0 )
	            this._createAccessGroupSelectorView();
	
	        if ( this.model.showConsultGroupSelectorOnNoteViews() )
	            this._createConsultSelectorView();
	
	
	    },
	
	    _createConsultSelectorView: function() {
	
	        this.consultSelectorView = new ConsultGroupSelector({
	
	            userConsultGroups: fvChannel.request('user').getReferralGroups(),
	            note: this.model,
	            onChange: function() {
	                this.channel.trigger( 'consultSelectView:groupsChanged', this.model );
	            }.bind( this )
	
	        });
	
	        this.ui.consultSelectPlaceholder.replaceWith( this.consultSelectorView.render().el );
	
	    },
	
	    // TODO: reorg the whole flashback process when have time; it's not understandable
	    // -- this was combined with the 'recipient of flash notes'
	    // -- split up but not it's tied on the save process ... maybe create a subview
	    // Note: it's no longer written for flash back notes
	    _createAccessGroupSelectorView: function() {
	
	        var user = fvChannel.request('user'),
	            note = this.model;
	
	        var groups = note.isFlashNote() && note.isNew()
	            ? user.privateGroups.getIdDescs() // don't print for flash-back notes -- no need
	            : user.groups.getArrayOfModelAttrsSortedByName();
	
	        // TODO: temp fix for FLASH NOTE printing desc's instead of names --> gotta be clearer way
	        // perhaps just create another view for the flashnote select ...
	
	        if ( note.isFlashNote() ) {
	            groups = _.map( groups, function(g) {
	                return {
	                    groupId: g.groupId,
	                    name: g.description // print description as name
	                };
	            });
	        }
	
	        this.accessGroupSelectorView = new AccessGroupSelector({
	            groups: groups,
	            onChange: _.bind( this.onAccessGroupChange, this) , // picked up by the flashNoteView
	            selectedGroupId: this.model.get('accessGroup') // Must have been the same for flash notes
	        });
	
	        this.ui.accessGrpPlaceHolder.replaceWith( this.accessGroupSelectorView.render().el );
	
	    },
	
	    onAccessGroupChange: $.noop,
	
	    // Hack: pass down the on show method to the child view;
	    // See notes for refactor here in graphic stamp selector:
	    // Should really make this view a Marionette region / Babysitter View
	    onShow: function() {
	
	        this.consultSelectorView &&
	            this.consultSelectorView.triggerMethod('show');
	
	        this.accessGroupSelectorView &&
	            this.accessGroupSelectorView.triggerMethod('show');
	
	    },
	    /**
	     * request, notes:noteSaveFailure -- essentially act the same as $.ajax success and error callbacks/events,
	     * used to show/hide the loading spinner during ajax calls.
	     * request: Backbone.Model.save invokes when $.ajax request made to server
	     * notes:noteSaveFailure: differentiate from Backbone.sync's 'error' event to more clearly accomodate current note save workflow
	     * ( captureed top-down in options.error cb )
	     * Eventually we should change the note saving workflow to utilize a deferred from the call to model.save.
	     * Note: post a successful save all note views are re-rendered (so the spinner is inherently destroyed )
	     * invalid: will trigger for both invalid attributes prior to a request and on those returned from the server.
	     */
	    modelEvents: {
	        'request':                  'showSpinIndicator',
	        'notes:noteSaveFailure':    'destroySpinner',
	        'invalid':                  'validationError',
	        'showSavedIndicator':       'showSavedIndicator'
	    },
	    uiModelEvents: {
	        'change:editMode':      'toggleEditMode',
	        'change:expanded':      'toggleExpandMode',
	        'change:isEditable':    'toggleModButtons'
	    },
	    ui: {
	        bodyField:                  '.noteBody',
	        textArea:                   '.taNoteBody',
	        noteSubject:                '.subj-input',
	        subjectDiv:                 '.subj-div',
	        autoDisplay:                '.autoDisplay',
	        okBtn:                      '.ok',
	        cancelBtn:                  '.cancel',
	        editBtn:                    '.edit',
	        moreBtn:                    '.ellipsis-wr',
	        deleteBtn:                  '.delete',
	        noteHeader:                 '.noteHead',
	        submitRow:                  '.submit-row',
	        validationErr:              '.validation-err',
	        iconWrapper:                '.note-icon-wr',
	        accessGrpPlaceHolder:       '[data-access-grp-select-holder]',
	        consultSelectPlaceholder:   '[data-consult-select-holder]',
	        consultGrpLbls:             '.consult-grp-label'
	    },
	    /* note: these forwarded to notes local channel */
	    triggers: {
	        'click @ui.okBtn'       :   'enterSave',
	        'click @ui.cancelBtn'   :   'enterCancel',
	        'click @ui.editBtn'     :   'enterEdit',
	        'click @ui.moreBtn'     :   'enterExpand',
	        'click @ui.deleteBtn'   :   'enterDelete',
	        'mouseenter'            :   'enterMouseHover',
	        'mouseleave'            :   'exitMouseHover'
	    },
	    keyboardEvents: {
	        'shift+enter':  function(e) {
	
	            e.preventDefault();  //necessary to prevent dupe post from keydown
	            e.stopImmediatePropagation();  //for the return key (can be called twice)
	            this.trigger('enterSave');
	
	        },
	        'esc': 'escapeKey'
	    },
	    escapeKey: function() {
	
	        //filter b/f trigger : latter is for openedFlashNotes
	        if (  !this.options.channel.request('noteIsActiveNote', this.model) || this.model.FN_WAS_OPENED )
	            return false;
	
	        this.trigger('enterCancel');
	
	    },
	
	    //TODO: keep fixing up
	    serializeData: function() {
	
	        var m = this.model,
	            vc = this.options.channel.request('vChannel'),
	            user = fvChannel.request('user'),
	            creating = m.isNew(),
	            noteType = m.get('noteType'),
	            ctime  = m.get('creationTime')
	                ? m.get('creationTime')
	                : moment(),
	            isFlashNote = noteType === 'FLASH_NOTE',
	            isPageNote = !m.isDocument,
	            isTextNote = m.isTextNote(), //(doc / pg)
	
	            isFDDGraphicNote = m.isFDDGraphicNote(),
	            supportConsults = m.showConsultGroupSelectorOnNoteViews();
	
	            return {
	                viewerChannel: vc, // pass in case needed used in template helpers
	                note: m,
	                user: user,
	                noteType: noteType,
	                iconClass: m.iconClass ? m.iconClass : '',
	                pgNum: m.pageNumber,
	                newNoteTextAreaPlaceHolder: 'Enter text note',
	                iconHoverLabel: m.getIconHoverLbl(),
	                isTextNote: isTextNote,
	                ctime: creating
	                    ? ''
	                    : moment.convertDBTimeToLocalTime(ctime),
	                cuser: m.get('creationUserDesc'),
	                textNoteValue: m.isDocument || m.isPageTextNote()
	                    ? m.get('text') 
	                    : '', 
	                pgNavigationDisabled: vc ? false : true, //(exists with viewer)
	
	                hideAutoDisplay: !m.autoDisplayApplies, // Note: only applies to page notes; hide the auto-display row from the UI -- fix when subclass
	                display: m.autoDisplayNote(), //sets the checkbox for whether to apply auto-display (if it applies)
	
	                isPageNote: isPageNote,
	                isNew: creating,
	                isFlashNote: isFlashNote,
	                noteClass: m.getNoteClass(),
	                isActivityNote: m.isActivityNote(),
	                filterOut: this.uiModel.isFiltered(),
	                isFDDGraphicNote: isFDDGraphicNote,
	                showConsultInput: supportConsults,
	                showConsultRow: supportConsults && m.consultGroupsAssigned(),
	                userCanModifyOrDeleteNotes: vc.request('allowModifyOrDeleteNote')
	
	            };
	    },
	
	
	    //could use state here to say render this / that (eg new, eg editing )
	    templateHelpers: { //context is the serializedData if literal
	
	        subject: function() {
	            return this.isNew ? '' : this.note.getSubject();
	        },
	        subjectPH: function() {
	            return this.note.desc;
	        },
	        includeActionBtns: function() {
	            return !this.isActivityNote ;
	        },
	        includeModBtns: function() {
	            return !this.isActivityNote;
	        },
	        includeSubjectLabel: function() {
	            return !this.note.isTextNote() && !this.isFlashNote && !this.isActivityNote;
	        },
	        noteInputFieldIsTextArea: function() {
	            //DVBC-1321 -- now show text, not subject for activity notes
	            return this.note.isTextNote() || this.isFlashNote || this.isActivityNote;
	        },
	        includePgNumber: function() {
	            return !this.note.isDocument;
	        },
	        showMoreBtn: function() {
	           return this.note.isDrawable();
	        },
	        includeEditBtn: function() {
	
	            // First check perm ( apply to doc and page notes )
	            if ( !this.userCanModifyOrDeleteNotes )
	                return false;
	
	            if ( this.note.isDocument )
	                return true;
	
	            // Page: if drawable, can't be creatable on undrawable pages, no check needed
	            if ( this.note.isSignature() || this.isFDDGraphicNote )
	                return false;
	
	            return true;
	
	        },
	        includeDeleteBtn: function() {
	
	            return this.userCanModifyOrDeleteNotes;
	
	        },
	        showNoteOperations: function() {
	            return this.isPageNote || (this.isFlashNote && this.isNew);
	        },
	        consultGroups: function() {
	
	            return _.map( this.note.getConsultGroups(), function(cg) {
	
	                var colorDefined = cg.color !== null,
	                    labelColor = colorDefined ? cg.color : 'transparent';
	
	                return  {
	                    name: cg.name,
	                    labelColor: labelColor,
	                    textColor:  colorDefined ? getContrastYIQ(labelColor, '#333') : 'inherit'
	                };
	
	            });
	        }
	
	    },
	
	    showSpinIndicator: function() {
	
	        this.ui.okBtn.find('i').addClass('invisible');
	
	        this.spinner = new SpinView({
	            color: 'white',
	            length: 3,
	            radius: 3
	        });
	
	        this.ui.okBtn.append( this.spinner.render().el );
	
	        this.spinner.$el.css('top', '-6px');
	
	    },
	    toggleEditMode: function(uiModel, editMode, options) { // '(opens it up)
	
	        this.setElement(this.el); //unsure what this was for ... prob calling delegate events; not changing in case breaks
	
	        if ( editMode )  {//opening
	            this.$el.addClass('edit-mode');
	            this._postBaseToggleEditMode( true );
	            this.bindKeyboardEvents(); //(in delegate, turned off by default)
	        }  else {    //closing -- looks same in edit/new --- *** POST SAVE ACTIONS */
	            this.unbindKeyboardEvents();
	            this.ui.textArea.addClass('hide').blur().trigger('autosize.destroy'); //destroy plugins on close, not on view destruction: (needs to be called again anyway upon reopen)
	
	            //( TODO: move up -- post toggle edit mode call)
	            // Now trigger an event from the model to facilitate this in find and redact,
	            // rather than a function call, vs called fn directly on the view.
	            (options && options.noteSaved) &&
	                this.model.trigger('showSavedIndicator');
	
	            this._postBaseToggleEditMode( false );
	        }
	
	    },
	    // Apply plugin after visible (also whenever text content changes)
	    _postBaseToggleEditMode: function(isEntering) {
	        isEntering && this.ui.textArea.removeClass('hide').setCursorEndOfText().autosize();
	    },
	
	    /* state: expanded */
	    toggleExpandMode: function(uiModel, expanded) {
	
	        //TODO: clean up -- combo's style with edit-mode css as well
	        //TODO: this should also be a re-render for clarity
	
	        var $inputs = this.$('input, select');
	
	        if (expanded) {
	            this.ui.moreBtn.attr('title', 'Less');
	            $inputs.attr('disabled', 'disabled').trigger('chosen:updated');
	            this.$el.addClass('expanded');
	        } else {
	            this.ui.moreBtn.attr('title', 'More');
	            $inputs.removeAttr('disabled').trigger('chosen:updated');
	            this.$el.removeClass('expanded');
	        }
	    },
	
	    toggleModButtons: function(uiModel, allowEdit) {
	        this.$el.toggleClass('notEditable', !allowEdit);
	    },
	
	
	    toggleFiltered: function(noteFilterModel) {
	
	        if ( noteFilterModel.isSourceSAT() )
	            this._highlightDomForSATFilterToggle( noteFilterModel.getSatTxt() );
	
	        this.$el.toggleClass( 'hide', this.uiModel.isFiltered() );
	
	    },
	    _highlightDomForSATFilterToggle: function(satFilterTxt) {
	
	        this.$el.unhighlight(); //put data attr / class on what is filterable?
	        this.$el.highlight(satFilterTxt);
	        /*
	            - sat is only done when not in expanded/edit mode, so if want to highlight
	              anything visible in that mode, would need to filter down the selectors to only those used (eg not labels)
	            - could switch to diff plugin that allows to skips elements (marked) / fork jq highlight
	            - below is quick hack to not highlight the referred to label ... if have more like this in future impl more robust solution
	         */
	        this.ui.consultGrpLbls.unhighlight();
	
	    },
	
	    showSavedIndicator: function() {
	
	        var $el = this.$el.addClass('postSave'),
	           self = this;
	
	        setTimeout( function() {
	            $el.removeClass('postSave');
	            self.triggerMethod('saveIndicatorComplete'); // I think for flashnote only ...
	        }, 3000);
	
	    },
	    // get the attributes in the ui that were changed by the user necessary for persistence (for use in model fn)
	    // later sanitized by a fn in the note model, and, in some cases, altered into a different obj expected by save webservice
	    // TODO: stop this and store on model on change already ...
	    _getRawUserInput: function() {
	
	        var accessibleByPrinted = this.accessGroupSelectorView;
	
	        var input = {
	            noteSubject: this.ui.noteSubject.val(),  //looks like always captured
	            text: this.ui.textArea.val(),  //looks like always captured
	
	            autoDisplayChecked: this.ui.autoDisplay.is(':checked'), //looks like always captured
	
	            // note: accessible by not printed for doc ( but it's a part of the data structure)
	            // -- will not have changed
	            // TODO:
	            // - ever need to pass the name????
	            // - test saving
	            // - need to pass for doc notes ( not flash notes )
	
	            // i guess its the parent for flashbacks
	            accessibleByName: accessibleByPrinted
	                ?  this.accessGroupSelectorView.getSelectedGroup().groupName // was:  this.ui.accessibleBy.find(':selected').text() // flash note could be group description ...
	                :  this.model.get('accessGroupName'),   // (not printed for doc) -- not really necessary b/c of sanitize fn
	
	            accessibleByVal: accessibleByPrinted
	                ?  this.accessGroupSelectorView.getSelectedGroup().groupId // i guess the parent for flash back
	                :  this.model.get('accessGroup')  //(not printed for doc)
	        };
	
	
	        if (this.consultSelectorView) {
	            // store on consult groups obj in WF to pass on b/f saving -- will be put on compound obj
	            input['consultGroups'] = this.consultSelectorView.getSelectedGroups(); // (an array of attributes to save)
	        }
	
	        return input;
	
	    },
	
	    validationError: function(note, errObj) {
	        this.ui.validationErr.text( errObj.message );
	    },
	    //TODO: clean and combo with show/create
	    destroySpinner: function() {
	        this.spinner.destroy();
	        this.ui.okBtn.find('i').removeClass('invisible');
	    },
	
	    //TODO: THOUGH W/OUT, MEM LEAK -- but with events not set on render
	    undelegateEvents: function() {
	        Marionette.View.prototype.undelegateEvents.call(this);
	        this.unbindEntityEvents(this.uiModel, this.uiModelEvents); //-- undelegating stops workflow from working, um model no longer listened to?
	        this.unbindUIElements();
	        this.stopListening();
	        return this;
	    },
	    delegateEvents: function() {
	        Marionette.View.prototype.delegateEvents.call(this);  //clears uimodel events if comes after -- MUST DO BEFORE
	        this.bindEntityEvents(this.uiModel, this.uiModelEvents);
	        this.bindUIElements();
	        //(*Only want to listen if the active note -- the default is off)
	        this.unbindKeyboardEvents();
	        return this;
	    },
	    onBeforeDestroy: function() {
	
	        this.ui.textArea.trigger('autosize.destroy');
	
	        // child views ...
	        this.consultSelectorView && this.consultSelectorView.destroy();
	        this.accessGroupSelectorView && this.accessGroupSelectorView.destroy();
	
	    },
	    destroy: function() {
	
	        Marionette.ItemView.prototype.destroy.apply(this, arguments);
	        /* ensure clear of jq cache */
	        this.$('*').remove();
	        this.unbindUIElements();
	        this.$el.remove();
	        // pretty good but still tiny mem leak
	
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ },
/* 156 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 157 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 158 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/* Wrap spin.js in Backbone View
	
	    Example Use: 
	        this.spinner = new Spinner();
	        this.ui.spinHolder.append( this.spinner.render().el );
	*/
	
	var Marionette = __webpack_require__(61),
	    Spinner = __webpack_require__(160);
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'FV-spinner',
	
	    // Settings for spin.js
	    settings: {
	        hwaccel: true,
	        length: 4,
	        radius: 4,
	        width: 2
	    },
	
	    startHidden: false, // If extend can overwrite on extended classes' prototype
	
	    spinner: {},
	
	    initialize: function( options, startHidden ) {
	
	        this.settings = _.extend({}, this.settings, options); //don't override the proto!
	
	        if ( startHidden )
	            this.startHidden = true;
	
	    },
	
	    render: function() {
	
	        this.$el.css('position', 'relative');
	
	        this.spinner = new Spinner(this.settings).spin( this.el );
	
	        this.startHidden && this.triggerMethod('stop'); //way to work with, with immediate rendering
	
	        this.triggerMethod('afterRender');
	
	        return this;
	
	    },
	    /* hooks to stop and start without render then destroy */
	    onStart: function() {
	        this.spinner.spin( this.el );
	    },
	    onStop: function() {
	        this.spinner.stop();
	    },
	    onBeforeDestroy: function() {
	        this.spinner.stop();
	    },
	    isSpinning: function() {
	        return this.spinner.el !== undefined;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(162);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	__webpack_require__(163);
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(172),
	
	    initialize: function(options) {
	
	        _.extend( this, {
	            userConsultGroups: options.userConsultGroups,
	            note: options.note, // maybe break apart apart and just pass the consult groups of the note (though this doesn't hurt)
	            onChange: options.onChange,
	            renderDisabled: options.renderDisabled
	        });
	
	    },
	
	    serializeData: function() {
	        return {
	            consultGroups: this._getConsultsForSelect(),
	            renderDisabled: this.renderDisabled
	        };
	    },
	    onRender: function() {
	
	        // Leave the select element attributes defined in the template,
	        // as opposed to using Backbone view attributes which would override others, eg:
	        // tagName: 'select' className: 'consult-grp-select'.
	        // But in doing so -- remove the empty div and ensure the selectbox is set as the view's el.
	        this.unwrap();
	
	        // Set the value of the dropdown from any note consult groups.
	        var noteConsultGrps = this.note.getConsultGroups();
	
	        if (noteConsultGrps ) {
	
	            var grpIds = _.map( noteConsultGrps, function(g) {
	                return parseInt(g.groupId);
	            });
	
	            this.$el.val( grpIds );
	        }
	
	        // Disable from DOM info if:
	        // * user has no groups to assign,
	        // * or: the note is referred but doesn't the user doesn't have access assign any of its referrals
	
	        if (  this.$('option:enabled').length < 2 ) // (there's always an empty one)
	            this.$el.attr('disabled', 'disabled');
	
	    },
	
	    // The chosen plugin with image addon must first be called when it's in the the DOM.
	    // When called from the noteView, this is triggered in it's onShow function as a hack.
	    // A better long-term solution is to use Region's for the NoteView itself.
	    onShow: function() {
	
	        this.$el.chosen({
	            search_contains: 1,
	            width: '100%',
	            placeholder_text_multiple: 'Select Groups...',
	
	            /**
	             * HACK!: Use image-select chosen add-on template and it's {url} to but a box with the group's color next to it's name
	             * Note: this template gets wrapped inside a span.
	             * Note: this template won't be applied by the plugin if the url is null (in this case if the color is null),
	             * so it's set to transparent inside template logic
	             */
	            html_template: '<i class="chose-image-group-color-lbl" style="background-color:{url};"></i><span class="chose-note-group-text">{text}</span>'
	
	        }).on('change', _.bind(this.onSelectionChange, this) );
	
	
	    },
	    _getConsultsForSelect: function() {
	
	        // First get all the groups the user can assign (plus an empty one)
	        var EMPTY_CONSULT_GRP = {
	            groupId: -1,
	            name: '',
	            color: '',
	            userCanAssign: true
	        };
	
	        var userConsultGroups = this.userConsultGroups.getArrayOfModelAttrsSortedByName();
	        _.each( userConsultGroups, function(g) {
	           g['userCanAssign'] = true;
	        });
	
	        var groups = [EMPTY_CONSULT_GRP].concat( userConsultGroups );
	
	        // Now deal with any that are assigned to the note but not in the users groups (they can't assign them).
	        // Add any that aren't in the user's groups, with a value of userCanAssign = false.
	
	        var noteReferralGroups = this.note.getConsultGroups();
	
	        _.each( noteReferralGroups , function(ng) {
	
	            if ( !_.findWhere( userConsultGroups, {groupId: ng.groupId} ) ) {
	                var grpToAdd = _.pick(ng, 'groupId', 'name', 'color');
	                grpToAdd['userCanAssign'] = false;
	                groups.push( grpToAdd );
	            }
	
	        });
	
	        // Hack: already using data-img-src as a hack insert colored 'rectangles' in the image-select template.
	        // If this is not defined, the image-select template won't be applied, so make it transparent.
	        _.each(groups, function(g) {
	            (!g.color) && (g.color ='transparent');
	        });
	
	        // TODO: could re-sort by name at end of adding them
	        return groups;
	
	    },
	
	    /**
	     * Update the 'derived' shape color on the notes UI model ( central point to for a note model ),
	     * then call onChange.
	     * In the future, if there's a need, probably better to store the selected groups note/noteUI model.
	     * Also see overlap when used in F&R when we want to set the note attributes live ...
	     */
	    onSelectionChange: function() {
	
	        var selectedGroups = this.getSelectedGroups();
	
	        var derivedShapeColor = selectedGroups
	            ? this.note.getConsultColorForShapes( selectedGroups )
	            : null;
	
	        this.note.uiModel.set( 'currentConsultColorForShapes', derivedShapeColor, {silent: true} );
	
	        this.onChange( selectedGroups, derivedShapeColor );
	
	    },
	    // Return array of the group attribute values or null if none are selected
	    // Should probably change to use models.
	    getSelectedGroups: function() {
	
	        var groups = [];
	
	        // Value on multi-selects doesn't return disabled options ,so use this:
	        var aSelectedGrpIds = this.$('option:selected').map( function(i, el) {
	           return parseInt(el.value);
	        }).get();
	
	        // Pass the selected data from this.consultGroups or noteReferralGroups.
	        // Could make easier by using data-attributes on initial output ...
	
	        var noteReferralGroups = this.note.getConsultGroups();
	
	        _.each(aSelectedGrpIds, function(id) {
	
	            var myConsultGroup = this.userConsultGroups.findWhere( {groupId: id});
	
	            if (myConsultGroup) {
	
	                var attrs =  myConsultGroup.toJSON();
	                // TODO: temp until group objects are unified on the server or this is accomplished another way
	                attrs = _.omit(attrs, 'type', 'groupType', 'description', 'status', 'creationTime', 'email');
	                groups.push( attrs );
	
	            } else {
	                // get from the noteReferralGroups
	                var noteGrp = _.findWhere( noteReferralGroups, {groupId: id} );
	                groups.push( noteGrp );
	            }
	
	        }, this);
	
	        return groups.length > 0 ? groups : null;
	
	    },
	    onBeforeDestroy: function() {
	        this.$el
	            .off()
	            .chosen('destroy');
	    }
	
	});

/***/ },
/* 162 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Bundle wrapping Chosen plus its Image-Select extension (and both style sheets).
	 * Update 8/5/2020 -- monkey match to prevent propagation on key events in search field.
	 */
	
	
	var $ = __webpack_require__(59); // ( provide plugin already exports jQuery to the chosen module)
	
	__webpack_require__(164);
	__webpack_require__(168);
	
	// Note this module doesn't anything -- it exports chosen to global $.fn --> $.fn.chosen
	__webpack_require__(170);
	
	
	/**
	 *  DVBC-1328 - monkey patch solution to stop propagation of key events to avoid problems
	 *  associated with forking library and implementing hotkey solution.
	 *  Stop keydown propagation in search_field.
	 *  Note: confirmed event will be taken off the node.
	 *  console.log($._data(c.search_field[0],'events'));
	 *  Could make this an option if we need to allow.
	 *  Update: now also prevents forms submission if the enter key is pressed in case the widget's inside a form.
	 */
	
	
	var fn_original_chosen = $.fn.chosen;
	
	$.fn.extend({
	
	   chosen: function( options ) {
	
	       // May not be necessary but ensure turn we off our key event handler,
	       // before its destroyed by chosen.
	       if (options === 'destroy') {
	
	           this.each( function() {
	
	               var chosen = $(this).data('chosen');
	
	               // Ensure there is a chosen to prevent run time errors --
	               // Encountered issing calling viewer.destroy which this removed the layout subapp first,
	               // this to be undefined.
	               // Should research that further -- potential for memory leaks (see DVBC-1790)
	               if ( chosen ) {
	                   chosen.search_field.off();
	                   // Maybe put $(this).off here ... ?
	               }
	
	           });
	
	       }
	
	       fn_original_chosen.apply( this, arguments );
	
	       // Don't reapply if destroyed.
	       if ( options === 'destroy' ) {
	            return;
	       }
	
	       // Apply the patch
	       this.each( function() {
	
	            var chosen = $(this).data('chosen');
	            chosen.search_field
	                .off('keydown.chosen') //don't need keyup as well, this should do
	                .on('keydown.chosen', function(e) {
	
	                    e.stopPropagation();
	
	                    if ( e.keyCode === 13 ) {
	                        e.preventDefault();
	                    }
	
	                    return chosen.keydown_checker(e);
	
	                });
	
	       });
	
	       return $(this);
	   }
	
	});
	
	
	// Now bundle the extension library
	__webpack_require__(171);
	
	
	
	// Don't really need the export is this project, but export something anyway
	module.exports = $.fn.chosen;

/***/ },
/* 164 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 169 */,
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function() {
	  var $, AbstractChosen, Chosen, SelectParser,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  SelectParser = (function() {
	    function SelectParser() {
	      this.options_index = 0;
	      this.parsed = [];
	    }
	
	    SelectParser.prototype.add_node = function(child) {
	      if (child.nodeName.toUpperCase() === "OPTGROUP") {
	        return this.add_group(child);
	      } else {
	        return this.add_option(child);
	      }
	    };
	
	    SelectParser.prototype.add_group = function(group) {
	      var group_position, i, len, option, ref, results1;
	      group_position = this.parsed.length;
	      this.parsed.push({
	        array_index: group_position,
	        group: true,
	        label: group.label,
	        title: group.title ? group.title : void 0,
	        children: 0,
	        disabled: group.disabled,
	        classes: group.className
	      });
	      ref = group.childNodes;
	      results1 = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        results1.push(this.add_option(option, group_position, group.disabled));
	      }
	      return results1;
	    };
	
	    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
	      if (option.nodeName.toUpperCase() === "OPTION") {
	        if (option.text !== "") {
	          if (group_position != null) {
	            this.parsed[group_position].children += 1;
	          }
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            value: option.value,
	            text: option.text,
	            html: option.innerHTML,
	            title: option.title ? option.title : void 0,
	            selected: option.selected,
	            disabled: group_disabled === true ? group_disabled : option.disabled,
	            group_array_index: group_position,
	            group_label: group_position != null ? this.parsed[group_position].label : null,
	            classes: option.className,
	            style: option.style.cssText
	          });
	        } else {
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            empty: true
	          });
	        }
	        return this.options_index += 1;
	      }
	    };
	
	    return SelectParser;
	
	  })();
	
	  SelectParser.select_to_array = function(select) {
	    var child, i, len, parser, ref;
	    parser = new SelectParser();
	    ref = select.childNodes;
	    for (i = 0, len = ref.length; i < len; i++) {
	      child = ref[i];
	      parser.add_node(child);
	    }
	    return parser.parsed;
	  };
	
	  AbstractChosen = (function() {
	    function AbstractChosen(form_field, options1) {
	      this.form_field = form_field;
	      this.options = options1 != null ? options1 : {};
	      this.label_click_handler = bind(this.label_click_handler, this);
	      if (!AbstractChosen.browser_is_supported()) {
	        return;
	      }
	      this.is_multiple = this.form_field.multiple;
	      this.set_default_text();
	      this.set_default_values();
	      this.setup();
	      this.set_up_html();
	      this.register_observers();
	      this.on_ready();
	    }
	
	    AbstractChosen.prototype.set_default_values = function() {
	      this.click_test_action = (function(_this) {
	        return function(evt) {
	          return _this.test_active_click(evt);
	        };
	      })(this);
	      this.activate_action = (function(_this) {
	        return function(evt) {
	          return _this.activate_field(evt);
	        };
	      })(this);
	      this.active_field = false;
	      this.mouse_on_container = false;
	      this.results_showing = false;
	      this.result_highlighted = null;
	      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
	      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
	      this.disable_search_threshold = this.options.disable_search_threshold || 0;
	      this.disable_search = this.options.disable_search || false;
	      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
	      this.group_search = this.options.group_search != null ? this.options.group_search : true;
	      this.search_contains = this.options.search_contains || false;
	      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
	      this.max_selected_options = this.options.max_selected_options || Infinity;
	      this.inherit_select_classes = this.options.inherit_select_classes || false;
	      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
	      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
	      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
	      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
	      this.case_sensitive_search = this.options.case_sensitive_search || false;
	      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
	    };
	
	    AbstractChosen.prototype.set_default_text = function() {
	      if (this.form_field.getAttribute("data-placeholder")) {
	        this.default_text = this.form_field.getAttribute("data-placeholder");
	      } else if (this.is_multiple) {
	        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
	      } else {
	        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
	      }
	      this.default_text = this.escape_html(this.default_text);
	      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
	    };
	
	    AbstractChosen.prototype.choice_label = function(item) {
	      if (this.include_group_label_in_selected && (item.group_label != null)) {
	        return "<b class='group-name'>" + (this.escape_html(item.group_label)) + "</b>" + item.html;
	      } else {
	        return item.html;
	      }
	    };
	
	    AbstractChosen.prototype.mouse_enter = function() {
	      return this.mouse_on_container = true;
	    };
	
	    AbstractChosen.prototype.mouse_leave = function() {
	      return this.mouse_on_container = false;
	    };
	
	    AbstractChosen.prototype.input_focus = function(evt) {
	      if (this.is_multiple) {
	        if (!this.active_field) {
	          return setTimeout(((function(_this) {
	            return function() {
	              return _this.container_mousedown();
	            };
	          })(this)), 50);
	        }
	      } else {
	        if (!this.active_field) {
	          return this.activate_field();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.input_blur = function(evt) {
	      if (!this.mouse_on_container) {
	        this.active_field = false;
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this.blur_test();
	          };
	        })(this)), 100);
	      }
	    };
	
	    AbstractChosen.prototype.label_click_handler = function(evt) {
	      if (this.is_multiple) {
	        return this.container_mousedown(evt);
	      } else {
	        return this.activate_field();
	      }
	    };
	
	    AbstractChosen.prototype.results_option_build = function(options) {
	      var content, data, data_content, i, len, ref, shown_results;
	      content = '';
	      shown_results = 0;
	      ref = this.results_data;
	      for (i = 0, len = ref.length; i < len; i++) {
	        data = ref[i];
	        data_content = '';
	        if (data.group) {
	          data_content = this.result_add_group(data);
	        } else {
	          data_content = this.result_add_option(data);
	        }
	        if (data_content !== '') {
	          shown_results++;
	          content += data_content;
	        }
	        if (options != null ? options.first : void 0) {
	          if (data.selected && this.is_multiple) {
	            this.choice_build(data);
	          } else if (data.selected && !this.is_multiple) {
	            this.single_set_selected_text(this.choice_label(data));
	          }
	        }
	        if (shown_results >= this.max_shown_results) {
	          break;
	        }
	      }
	      return content;
	    };
	
	    AbstractChosen.prototype.result_add_option = function(option) {
	      var classes, option_el;
	      if (!option.search_match) {
	        return '';
	      }
	      if (!this.include_option_in_results(option)) {
	        return '';
	      }
	      classes = [];
	      if (!option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("active-result");
	      }
	      if (option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("disabled-result");
	      }
	      if (option.selected) {
	        classes.push("result-selected");
	      }
	      if (option.group_array_index != null) {
	        classes.push("group-option");
	      }
	      if (option.classes !== "") {
	        classes.push(option.classes);
	      }
	      option_el = document.createElement("li");
	      option_el.className = classes.join(" ");
	      if (option.style) {
	        option_el.style.cssText = option.style;
	      }
	      option_el.setAttribute("data-option-array-index", option.array_index);
	      option_el.innerHTML = option.highlighted_html || option.html;
	      if (option.title) {
	        option_el.title = option.title;
	      }
	      return this.outerHTML(option_el);
	    };
	
	    AbstractChosen.prototype.result_add_group = function(group) {
	      var classes, group_el;
	      if (!(group.search_match || group.group_match)) {
	        return '';
	      }
	      if (!(group.active_options > 0)) {
	        return '';
	      }
	      classes = [];
	      classes.push("group-result");
	      if (group.classes) {
	        classes.push(group.classes);
	      }
	      group_el = document.createElement("li");
	      group_el.className = classes.join(" ");
	      group_el.innerHTML = group.highlighted_html || this.escape_html(group.label);
	      if (group.title) {
	        group_el.title = group.title;
	      }
	      return this.outerHTML(group_el);
	    };
	
	    AbstractChosen.prototype.results_update_field = function() {
	      this.set_default_text();
	      if (!this.is_multiple) {
	        this.results_reset_cleanup();
	      }
	      this.result_clear_highlight();
	      this.results_build();
	      if (this.results_showing) {
	        return this.winnow_results();
	      }
	    };
	
	    AbstractChosen.prototype.reset_single_select_options = function() {
	      var i, len, ref, result, results1;
	      ref = this.results_data;
	      results1 = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        result = ref[i];
	        if (result.selected) {
	          results1.push(result.selected = false);
	        } else {
	          results1.push(void 0);
	        }
	      }
	      return results1;
	    };
	
	    AbstractChosen.prototype.results_toggle = function() {
	      if (this.results_showing) {
	        return this.results_hide();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.results_search = function(evt) {
	      if (this.results_showing) {
	        return this.winnow_results();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.winnow_results = function(options) {
	      var escapedQuery, fix, i, len, option, prefix, query, ref, regex, results, results_group, search_match, startpos, suffix, text;
	      this.no_results_clear();
	      results = 0;
	      query = this.get_search_text();
	      escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	      regex = this.get_search_regex(escapedQuery);
	      ref = this.results_data;
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        option.search_match = false;
	        results_group = null;
	        search_match = null;
	        option.highlighted_html = '';
	        if (this.include_option_in_results(option)) {
	          if (option.group) {
	            option.group_match = false;
	            option.active_options = 0;
	          }
	          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
	            results_group = this.results_data[option.group_array_index];
	            if (results_group.active_options === 0 && results_group.search_match) {
	              results += 1;
	            }
	            results_group.active_options += 1;
	          }
	          text = option.group ? option.label : option.text;
	          if (!(option.group && !this.group_search)) {
	            search_match = this.search_string_match(text, regex);
	            option.search_match = search_match != null;
	            if (option.search_match && !option.group) {
	              results += 1;
	            }
	            if (option.search_match) {
	              if (query.length) {
	                startpos = search_match.index;
	                prefix = text.slice(0, startpos);
	                fix = text.slice(startpos, startpos + query.length);
	                suffix = text.slice(startpos + query.length);
	                option.highlighted_html = (this.escape_html(prefix)) + "<em>" + (this.escape_html(fix)) + "</em>" + (this.escape_html(suffix));
	              }
	              if (results_group != null) {
	                results_group.group_match = true;
	              }
	            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
	              option.search_match = true;
	            }
	          }
	        }
	      }
	      this.result_clear_highlight();
	      if (results < 1 && query.length) {
	        this.update_results_content("");
	        return this.no_results(query);
	      } else {
	        this.update_results_content(this.results_option_build());
	        if (!(options != null ? options.skip_highlight : void 0)) {
	          return this.winnow_results_set_highlight();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
	      var regex_flag, regex_string;
	      regex_string = this.search_contains ? escaped_search_string : "(^|\\s|\\b)" + escaped_search_string + "[^\\s]*";
	      if (!(this.enable_split_word_search || this.search_contains)) {
	        regex_string = "^" + regex_string;
	      }
	      regex_flag = this.case_sensitive_search ? "" : "i";
	      return new RegExp(regex_string, regex_flag);
	    };
	
	    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
	      var match;
	      match = regex.exec(search_string);
	      if (!this.search_contains && (match != null ? match[1] : void 0)) {
	        match.index += 1;
	      }
	      return match;
	    };
	
	    AbstractChosen.prototype.choices_count = function() {
	      var i, len, option, ref;
	      if (this.selected_option_count != null) {
	        return this.selected_option_count;
	      }
	      this.selected_option_count = 0;
	      ref = this.form_field.options;
	      for (i = 0, len = ref.length; i < len; i++) {
	        option = ref[i];
	        if (option.selected) {
	          this.selected_option_count += 1;
	        }
	      }
	      return this.selected_option_count;
	    };
	
	    AbstractChosen.prototype.choices_click = function(evt) {
	      evt.preventDefault();
	      this.activate_field();
	      if (!(this.results_showing || this.is_disabled)) {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.keydown_checker = function(evt) {
	      var ref, stroke;
	      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
	      this.search_field_scale();
	      if (stroke !== 8 && this.pending_backstroke) {
	        this.clear_backstroke();
	      }
	      switch (stroke) {
	        case 8:
	          this.backstroke_length = this.get_search_field_value().length;
	          break;
	        case 9:
	          if (this.results_showing && !this.is_multiple) {
	            this.result_select(evt);
	          }
	          this.mouse_on_container = false;
	          break;
	        case 13:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 32:
	          if (this.disable_search) {
	            evt.preventDefault();
	          }
	          break;
	        case 38:
	          evt.preventDefault();
	          this.keyup_arrow();
	          break;
	        case 40:
	          evt.preventDefault();
	          this.keydown_arrow();
	          break;
	      }
	    };
	
	    AbstractChosen.prototype.keyup_checker = function(evt) {
	      var ref, stroke;
	      stroke = (ref = evt.which) != null ? ref : evt.keyCode;
	      this.search_field_scale();
	      switch (stroke) {
	        case 8:
	          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
	            this.keydown_backstroke();
	          } else if (!this.pending_backstroke) {
	            this.result_clear_highlight();
	            this.results_search();
	          }
	          break;
	        case 13:
	          evt.preventDefault();
	          if (this.results_showing) {
	            this.result_select(evt);
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            this.results_hide();
	          }
	          break;
	        case 9:
	        case 16:
	        case 17:
	        case 18:
	        case 38:
	        case 40:
	        case 91:
	          break;
	        default:
	          this.results_search();
	          break;
	      }
	    };
	
	    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
	      if (this.is_disabled) {
	        return;
	      }
	      return setTimeout(((function(_this) {
	        return function() {
	          return _this.results_search();
	        };
	      })(this)), 50);
	    };
	
	    AbstractChosen.prototype.container_width = function() {
	      if (this.options.width != null) {
	        return this.options.width;
	      } else {
	        return this.form_field.offsetWidth + "px";
	      }
	    };
	
	    AbstractChosen.prototype.include_option_in_results = function(option) {
	      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
	        return false;
	      }
	      if (!this.display_disabled_options && option.disabled) {
	        return false;
	      }
	      if (option.empty) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.prototype.search_results_touchstart = function(evt) {
	      this.touch_started = true;
	      return this.search_results_mouseover(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchmove = function(evt) {
	      this.touch_started = false;
	      return this.search_results_mouseout(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchend = function(evt) {
	      if (this.touch_started) {
	        return this.search_results_mouseup(evt);
	      }
	    };
	
	    AbstractChosen.prototype.outerHTML = function(element) {
	      var tmp;
	      if (element.outerHTML) {
	        return element.outerHTML;
	      }
	      tmp = document.createElement("div");
	      tmp.appendChild(element);
	      return tmp.innerHTML;
	    };
	
	    AbstractChosen.prototype.get_single_html = function() {
	      return "<a class=\"chosen-single chosen-default\">\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
	    };
	
	    AbstractChosen.prototype.get_multi_html = function() {
	      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
	    };
	
	    AbstractChosen.prototype.get_no_results_html = function(terms) {
	      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + (this.escape_html(terms)) + "</span>\n</li>";
	    };
	
	    AbstractChosen.browser_is_supported = function() {
	      if ("Microsoft Internet Explorer" === window.navigator.appName) {
	        return document.documentMode >= 8;
	      }
	      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.default_multiple_text = "Select Some Options";
	
	    AbstractChosen.default_single_text = "Select an Option";
	
	    AbstractChosen.default_no_result_text = "No results match";
	
	    return AbstractChosen;
	
	  })();
	
	  $ = jQuery;
	
	  $.fn.extend({
	    chosen: function(options) {
	      if (!AbstractChosen.browser_is_supported()) {
	        return this;
	      }
	      return this.each(function(input_field) {
	        var $this, chosen;
	        $this = $(this);
	        chosen = $this.data('chosen');
	        if (options === 'destroy') {
	          if (chosen instanceof Chosen) {
	            chosen.destroy();
	          }
	          return;
	        }
	        if (!(chosen instanceof Chosen)) {
	          $this.data('chosen', new Chosen(this, options));
	        }
	      });
	    }
	  });
	
	  Chosen = (function(superClass) {
	    extend(Chosen, superClass);
	
	    function Chosen() {
	      return Chosen.__super__.constructor.apply(this, arguments);
	    }
	
	    Chosen.prototype.setup = function() {
	      this.form_field_jq = $(this.form_field);
	      return this.current_selectedIndex = this.form_field.selectedIndex;
	    };
	
	    Chosen.prototype.set_up_html = function() {
	      var container_classes, container_props;
	      container_classes = ["chosen-container"];
	      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
	      if (this.inherit_select_classes && this.form_field.className) {
	        container_classes.push(this.form_field.className);
	      }
	      if (this.is_rtl) {
	        container_classes.push("chosen-rtl");
	      }
	      container_props = {
	        'class': container_classes.join(' '),
	        'title': this.form_field.title
	      };
	      if (this.form_field.id.length) {
	        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
	      }
	      this.container = $("<div />", container_props);
	      this.container.width(this.container_width());
	      if (this.is_multiple) {
	        this.container.html(this.get_multi_html());
	      } else {
	        this.container.html(this.get_single_html());
	      }
	      this.form_field_jq.hide().after(this.container);
	      this.dropdown = this.container.find('div.chosen-drop').first();
	      this.search_field = this.container.find('input').first();
	      this.search_results = this.container.find('ul.chosen-results').first();
	      this.search_field_scale();
	      this.search_no_results = this.container.find('li.no-results').first();
	      if (this.is_multiple) {
	        this.search_choices = this.container.find('ul.chosen-choices').first();
	        this.search_container = this.container.find('li.search-field').first();
	      } else {
	        this.search_container = this.container.find('div.chosen-search').first();
	        this.selected_item = this.container.find('.chosen-single').first();
	      }
	      this.results_build();
	      this.set_tab_index();
	      return this.set_label_behavior();
	    };
	
	    Chosen.prototype.on_ready = function() {
	      return this.form_field_jq.trigger("chosen:ready", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.register_observers = function() {
	      this.container.on('touchstart.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.container.on('touchend.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mouseup(evt);
	        };
	      })(this));
	      this.container.on('mousedown.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.container.on('mouseup.chosen', (function(_this) {
	        return function(evt) {
	          _this.container_mouseup(evt);
	        };
	      })(this));
	      this.container.on('mouseenter.chosen', (function(_this) {
	        return function(evt) {
	          _this.mouse_enter(evt);
	        };
	      })(this));
	      this.container.on('mouseleave.chosen', (function(_this) {
	        return function(evt) {
	          _this.mouse_leave(evt);
	        };
	      })(this));
	      this.search_results.on('mouseup.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseup(evt);
	        };
	      })(this));
	      this.search_results.on('mouseover.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseover(evt);
	        };
	      })(this));
	      this.search_results.on('mouseout.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mouseout(evt);
	        };
	      })(this));
	      this.search_results.on('mousewheel.chosen DOMMouseScroll.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_mousewheel(evt);
	        };
	      })(this));
	      this.search_results.on('touchstart.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchstart(evt);
	        };
	      })(this));
	      this.search_results.on('touchmove.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchmove(evt);
	        };
	      })(this));
	      this.search_results.on('touchend.chosen', (function(_this) {
	        return function(evt) {
	          _this.search_results_touchend(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:updated.chosen", (function(_this) {
	        return function(evt) {
	          _this.results_update_field(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:activate.chosen", (function(_this) {
	        return function(evt) {
	          _this.activate_field(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:open.chosen", (function(_this) {
	        return function(evt) {
	          _this.container_mousedown(evt);
	        };
	      })(this));
	      this.form_field_jq.on("chosen:close.chosen", (function(_this) {
	        return function(evt) {
	          _this.close_field(evt);
	        };
	      })(this));
	      this.search_field.on('blur.chosen', (function(_this) {
	        return function(evt) {
	          _this.input_blur(evt);
	        };
	      })(this));
	      this.search_field.on('keyup.chosen', (function(_this) {
	        return function(evt) {
	          _this.keyup_checker(evt);
	        };
	      })(this));
	      this.search_field.on('keydown.chosen', (function(_this) {
	        return function(evt) {
	          _this.keydown_checker(evt);
	        };
	      })(this));
	      this.search_field.on('focus.chosen', (function(_this) {
	        return function(evt) {
	          _this.input_focus(evt);
	        };
	      })(this));
	      this.search_field.on('cut.chosen', (function(_this) {
	        return function(evt) {
	          _this.clipboard_event_checker(evt);
	        };
	      })(this));
	      this.search_field.on('paste.chosen', (function(_this) {
	        return function(evt) {
	          _this.clipboard_event_checker(evt);
	        };
	      })(this));
	      if (this.is_multiple) {
	        return this.search_choices.on('click.chosen', (function(_this) {
	          return function(evt) {
	            _this.choices_click(evt);
	          };
	        })(this));
	      } else {
	        return this.container.on('click.chosen', function(evt) {
	          evt.preventDefault();
	        });
	      }
	    };
	
	    Chosen.prototype.destroy = function() {
	      $(this.container[0].ownerDocument).off('click.chosen', this.click_test_action);
	      if (this.form_field_label.length > 0) {
	        this.form_field_label.off('click.chosen');
	      }
	      if (this.search_field[0].tabIndex) {
	        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
	      }
	      this.container.remove();
	      this.form_field_jq.removeData('chosen');
	      return this.form_field_jq.show();
	    };
	
	    Chosen.prototype.search_field_disabled = function() {
	      this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
	      this.container.toggleClass('chosen-disabled', this.is_disabled);
	      this.search_field[0].disabled = this.is_disabled;
	      if (!this.is_multiple) {
	        this.selected_item.off('focus.chosen', this.activate_field);
	      }
	      if (this.is_disabled) {
	        return this.close_field();
	      } else if (!this.is_multiple) {
	        return this.selected_item.on('focus.chosen', this.activate_field);
	      }
	    };
	
	    Chosen.prototype.container_mousedown = function(evt) {
	      var ref;
	      if (this.is_disabled) {
	        return;
	      }
	      if (evt && ((ref = evt.type) === 'mousedown' || ref === 'touchstart') && !this.results_showing) {
	        evt.preventDefault();
	      }
	      if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
	        if (!this.active_field) {
	          if (this.is_multiple) {
	            this.search_field.val("");
	          }
	          $(this.container[0].ownerDocument).on('click.chosen', this.click_test_action);
	          this.results_show();
	        } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
	          evt.preventDefault();
	          this.results_toggle();
	        }
	        return this.activate_field();
	      }
	    };
	
	    Chosen.prototype.container_mouseup = function(evt) {
	      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
	        return this.results_reset(evt);
	      }
	    };
	
	    Chosen.prototype.search_results_mousewheel = function(evt) {
	      var delta;
	      if (evt.originalEvent) {
	        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
	      }
	      if (delta != null) {
	        evt.preventDefault();
	        if (evt.type === 'DOMMouseScroll') {
	          delta = delta * 40;
	        }
	        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
	      }
	    };
	
	    Chosen.prototype.blur_test = function(evt) {
	      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.close_field = function() {
	      $(this.container[0].ownerDocument).off("click.chosen", this.click_test_action);
	      this.active_field = false;
	      this.results_hide();
	      this.container.removeClass("chosen-container-active");
	      this.clear_backstroke();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.search_field.blur();
	    };
	
	    Chosen.prototype.activate_field = function() {
	      if (this.is_disabled) {
	        return;
	      }
	      this.container.addClass("chosen-container-active");
	      this.active_field = true;
	      this.search_field.val(this.search_field.val());
	      return this.search_field.focus();
	    };
	
	    Chosen.prototype.test_active_click = function(evt) {
	      var active_container;
	      active_container = $(evt.target).closest('.chosen-container');
	      if (active_container.length && this.container[0] === active_container[0]) {
	        return this.active_field = true;
	      } else {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.results_build = function() {
	      this.parsing = true;
	      this.selected_option_count = null;
	      this.results_data = SelectParser.select_to_array(this.form_field);
	      if (this.is_multiple) {
	        this.search_choices.find("li.search-choice").remove();
	      } else {
	        this.single_set_selected_text();
	        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
	          this.search_field[0].readOnly = true;
	          this.container.addClass("chosen-container-single-nosearch");
	        } else {
	          this.search_field[0].readOnly = false;
	          this.container.removeClass("chosen-container-single-nosearch");
	        }
	      }
	      this.update_results_content(this.results_option_build({
	        first: true
	      }));
	      this.search_field_disabled();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.parsing = false;
	    };
	
	    Chosen.prototype.result_do_highlight = function(el) {
	      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
	      if (el.length) {
	        this.result_clear_highlight();
	        this.result_highlight = el;
	        this.result_highlight.addClass("highlighted");
	        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
	        visible_top = this.search_results.scrollTop();
	        visible_bottom = maxHeight + visible_top;
	        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
	        high_bottom = high_top + this.result_highlight.outerHeight();
	        if (high_bottom >= visible_bottom) {
	          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
	        } else if (high_top < visible_top) {
	          return this.search_results.scrollTop(high_top);
	        }
	      }
	    };
	
	    Chosen.prototype.result_clear_highlight = function() {
	      if (this.result_highlight) {
	        this.result_highlight.removeClass("highlighted");
	      }
	      return this.result_highlight = null;
	    };
	
	    Chosen.prototype.results_show = function() {
	      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	        this.form_field_jq.trigger("chosen:maxselected", {
	          chosen: this
	        });
	        return false;
	      }
	      this.container.addClass("chosen-with-drop");
	      this.results_showing = true;
	      this.search_field.focus();
	      this.search_field.val(this.get_search_field_value());
	      this.winnow_results();
	      return this.form_field_jq.trigger("chosen:showing_dropdown", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.update_results_content = function(content) {
	      return this.search_results.html(content);
	    };
	
	    Chosen.prototype.results_hide = function() {
	      if (this.results_showing) {
	        this.result_clear_highlight();
	        this.container.removeClass("chosen-with-drop");
	        this.form_field_jq.trigger("chosen:hiding_dropdown", {
	          chosen: this
	        });
	      }
	      return this.results_showing = false;
	    };
	
	    Chosen.prototype.set_tab_index = function(el) {
	      var ti;
	      if (this.form_field.tabIndex) {
	        ti = this.form_field.tabIndex;
	        this.form_field.tabIndex = -1;
	        return this.search_field[0].tabIndex = ti;
	      }
	    };
	
	    Chosen.prototype.set_label_behavior = function() {
	      this.form_field_label = this.form_field_jq.parents("label");
	      if (!this.form_field_label.length && this.form_field.id.length) {
	        this.form_field_label = $("label[for='" + this.form_field.id + "']");
	      }
	      if (this.form_field_label.length > 0) {
	        return this.form_field_label.on('click.chosen', this.label_click_handler);
	      }
	    };
	
	    Chosen.prototype.show_search_field_default = function() {
	      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
	        this.search_field.val(this.default_text);
	        return this.search_field.addClass("default");
	      } else {
	        this.search_field.val("");
	        return this.search_field.removeClass("default");
	      }
	    };
	
	    Chosen.prototype.search_results_mouseup = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target.length) {
	        this.result_highlight = target;
	        this.result_select(evt);
	        return this.search_field.focus();
	      }
	    };
	
	    Chosen.prototype.search_results_mouseover = function(evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target) {
	        return this.result_do_highlight(target);
	      }
	    };
	
	    Chosen.prototype.search_results_mouseout = function(evt) {
	      if ($(evt.target).hasClass("active-result") || $(evt.target).parents('.active-result').first()) {
	        return this.result_clear_highlight();
	      }
	    };
	
	    Chosen.prototype.choice_build = function(item) {
	      var choice, close_link;
	      choice = $('<li />', {
	        "class": "search-choice"
	      }).html("<span>" + (this.choice_label(item)) + "</span>");
	      if (item.disabled) {
	        choice.addClass('search-choice-disabled');
	      } else {
	        close_link = $('<a />', {
	          "class": 'search-choice-close',
	          'data-option-array-index': item.array_index
	        });
	        close_link.on('click.chosen', (function(_this) {
	          return function(evt) {
	            return _this.choice_destroy_link_click(evt);
	          };
	        })(this));
	        choice.append(close_link);
	      }
	      return this.search_container.before(choice);
	    };
	
	    Chosen.prototype.choice_destroy_link_click = function(evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      if (!this.is_disabled) {
	        return this.choice_destroy($(evt.target));
	      }
	    };
	
	    Chosen.prototype.choice_destroy = function(link) {
	      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
	        if (this.active_field) {
	          this.search_field.focus();
	        } else {
	          this.show_search_field_default();
	        }
	        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
	          this.results_hide();
	        }
	        link.parents('li').first().remove();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.results_reset = function() {
	      this.reset_single_select_options();
	      this.form_field.options[0].selected = true;
	      this.single_set_selected_text();
	      this.show_search_field_default();
	      this.results_reset_cleanup();
	      this.trigger_form_field_change();
	      if (this.active_field) {
	        return this.results_hide();
	      }
	    };
	
	    Chosen.prototype.results_reset_cleanup = function() {
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.selected_item.find("abbr").remove();
	    };
	
	    Chosen.prototype.result_select = function(evt) {
	      var high, item;
	      if (this.result_highlight) {
	        high = this.result_highlight;
	        this.result_clear_highlight();
	        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	          this.form_field_jq.trigger("chosen:maxselected", {
	            chosen: this
	          });
	          return false;
	        }
	        if (this.is_multiple) {
	          high.removeClass("active-result");
	        } else {
	          this.reset_single_select_options();
	        }
	        high.addClass("result-selected");
	        item = this.results_data[high[0].getAttribute("data-option-array-index")];
	        item.selected = true;
	        this.form_field.options[item.options_index].selected = true;
	        this.selected_option_count = null;
	        if (this.is_multiple) {
	          this.choice_build(item);
	        } else {
	          this.single_set_selected_text(this.choice_label(item));
	        }
	        if (this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey))) {
	          if (evt.metaKey || evt.ctrlKey) {
	            this.winnow_results({
	              skip_highlight: true
	            });
	          } else {
	            this.search_field.val("");
	            this.winnow_results();
	          }
	        } else {
	          this.results_hide();
	          this.show_search_field_default();
	        }
	        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
	          this.trigger_form_field_change({
	            selected: this.form_field.options[item.options_index].value
	          });
	        }
	        this.current_selectedIndex = this.form_field.selectedIndex;
	        evt.preventDefault();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.single_set_selected_text = function(text) {
	      if (text == null) {
	        text = this.default_text;
	      }
	      if (text === this.default_text) {
	        this.selected_item.addClass("chosen-default");
	      } else {
	        this.single_deselect_control_build();
	        this.selected_item.removeClass("chosen-default");
	      }
	      return this.selected_item.find("span").html(text);
	    };
	
	    Chosen.prototype.result_deselect = function(pos) {
	      var result_data;
	      result_data = this.results_data[pos];
	      if (!this.form_field.options[result_data.options_index].disabled) {
	        result_data.selected = false;
	        this.form_field.options[result_data.options_index].selected = false;
	        this.selected_option_count = null;
	        this.result_clear_highlight();
	        if (this.results_showing) {
	          this.winnow_results();
	        }
	        this.trigger_form_field_change({
	          deselected: this.form_field.options[result_data.options_index].value
	        });
	        this.search_field_scale();
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    Chosen.prototype.single_deselect_control_build = function() {
	      if (!this.allow_single_deselect) {
	        return;
	      }
	      if (!this.selected_item.find("abbr").length) {
	        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
	      }
	      return this.selected_item.addClass("chosen-single-with-deselect");
	    };
	
	    Chosen.prototype.get_search_field_value = function() {
	      return this.search_field.val();
	    };
	
	    Chosen.prototype.get_search_text = function() {
	      return $.trim(this.get_search_field_value());
	    };
	
	    Chosen.prototype.escape_html = function(text) {
	      return $('<div/>').text(text).html();
	    };
	
	    Chosen.prototype.winnow_results_set_highlight = function() {
	      var do_high, selected_results;
	      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
	      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
	      if (do_high != null) {
	        return this.result_do_highlight(do_high);
	      }
	    };
	
	    Chosen.prototype.no_results = function(terms) {
	      var no_results_html;
	      no_results_html = this.get_no_results_html(terms);
	      this.search_results.append(no_results_html);
	      return this.form_field_jq.trigger("chosen:no_results", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.no_results_clear = function() {
	      return this.search_results.find(".no-results").remove();
	    };
	
	    Chosen.prototype.keydown_arrow = function() {
	      var next_sib;
	      if (this.results_showing && this.result_highlight) {
	        next_sib = this.result_highlight.nextAll("li.active-result").first();
	        if (next_sib) {
	          return this.result_do_highlight(next_sib);
	        }
	      } else {
	        return this.results_show();
	      }
	    };
	
	    Chosen.prototype.keyup_arrow = function() {
	      var prev_sibs;
	      if (!this.results_showing && !this.is_multiple) {
	        return this.results_show();
	      } else if (this.result_highlight) {
	        prev_sibs = this.result_highlight.prevAll("li.active-result");
	        if (prev_sibs.length) {
	          return this.result_do_highlight(prev_sibs.first());
	        } else {
	          if (this.choices_count() > 0) {
	            this.results_hide();
	          }
	          return this.result_clear_highlight();
	        }
	      }
	    };
	
	    Chosen.prototype.keydown_backstroke = function() {
	      var next_available_destroy;
	      if (this.pending_backstroke) {
	        this.choice_destroy(this.pending_backstroke.find("a").first());
	        return this.clear_backstroke();
	      } else {
	        next_available_destroy = this.search_container.siblings("li.search-choice").last();
	        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
	          this.pending_backstroke = next_available_destroy;
	          if (this.single_backstroke_delete) {
	            return this.keydown_backstroke();
	          } else {
	            return this.pending_backstroke.addClass("search-choice-focus");
	          }
	        }
	      }
	    };
	
	    Chosen.prototype.clear_backstroke = function() {
	      if (this.pending_backstroke) {
	        this.pending_backstroke.removeClass("search-choice-focus");
	      }
	      return this.pending_backstroke = null;
	    };
	
	    Chosen.prototype.search_field_scale = function() {
	      var div, i, len, style, style_block, styles, width;
	      if (!this.is_multiple) {
	        return;
	      }
	      style_block = {
	        position: 'absolute',
	        left: '-1000px',
	        top: '-1000px',
	        display: 'none',
	        whiteSpace: 'pre'
	      };
	      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];
	      for (i = 0, len = styles.length; i < len; i++) {
	        style = styles[i];
	        style_block[style] = this.search_field.css(style);
	      }
	      div = $('<div />').css(style_block);
	      div.text(this.get_search_field_value());
	      $('body').append(div);
	      width = div.width() + 25;
	      div.remove();
	      if (this.container.is(':visible')) {
	        width = Math.min(this.container.outerWidth() - 10, width);
	      }
	      return this.search_field.width(width);
	    };
	
	    Chosen.prototype.trigger_form_field_change = function(extra) {
	      this.form_field_jq.trigger("input", extra);
	      return this.form_field_jq.trigger("change", extra);
	    };
	
	    return Chosen;
	
	  })(AbstractChosen);
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * Image Select (Version 1.8)
	 *
	 * Image Select is an extention to the Chosen, a Select Box Enhancer for
	 * jQuery and Prototype, full source at https://github.com/harvesthq/chosen
	 *
	 * This plugin extension was designed as a humanized UI element for social networking
	 * sites that need to faciliate relations between people. Research shows that people
	 * are extremely sensitvie to photos of others, so we needed to revamp the traditional
	 * UI elements to make them more intuitive and human.
	 *
	 * Hope you find it helpful, and get back if you have any feedback/improvements.
	 *
	 * @author    Adnan M.Sagar, PhD <adnan@websemantics.ca>
	 * @copyright 2002-2015 Web Semantics, Inc. (http://websemantics.ca) & AlterSpark Corp. (http://www.alterspark.com)
	 * @license   http://www.opensource.org/licenses/mit-license.php MIT
	 * @link      http://websemantics.ca
	 * @package   websemantics/image-select
	 */
	
	(function($) {
	
	// Image template, this can be overridden from the constructor (options.template),
	// must contains {src} placeholder. Ther eare two class names
	// 'chose-image' or 'chose-image-small', modifiy in CSS
	var fn_template = '<img class="{class_name}" src="{url}" />'
	
	function prependTemplate(element, option, template, rtl, multiple, cls){
	    // summery:
	    // This will fill-in the provided template with image source and css class
	    // then add it to the element.
	    //
	    // element: Dom
	    //          This is the span node
	    // object: Object,
	    //          The select option to get image url
	    // template: String
	    //          Html content
	    // rtl: Boolean,
	    //          Right to Left
	    // multiple: Boolean
	    //          Used to select the approperiate css class, default to 'true'
	    // cls*: String (optional)
	    //          Css styles class
	
	    var src = $(option).data('img-src')
	
	    if(src != undefined && src > ''){
	
	        element = $(element)
	
	        text     = $(option).text()
	        multiple = (multiple != undefined) ? multiple : true
	        cls      = cls || (multiple ? 'chose-image' : 'chose-image-small')
	        cls      = rtl ? cls + ' rtl' : cls
	        template = template.replace('{url}',src)
	                           .replace('{class_name}',cls)
	                           .replace('{text}',text)
	
	        // Empty the element
	        element.empty()
	
	        // Insert after if ltr or multiple select, otherwise, insert before
	        if(rtl && multiple){
	            element.append(template)
	        }
	        else {
	            element.prepend(template)
	        }
	    }
	}
	
	function getSelectedOptions(chosen){
	    // summery:
	    //      Return a list of selected items/options with the selected 'option' elements
	    //      and chosen 'span' elements.
	    //
	    // chosen: Chosen
	    //          The Chosen object
	
	    var items    = []
	    var options  = $(chosen.form_field).find('option:selected') || []
	    var spans    = (chosen.is_multiple) ? $(chosen.container).find('.chosen-choices span'):
	                                          $(chosen.container).find('.chosen-single span')
	
	    for(var i = 0; i < options.length; i++)
	        for(var j = 0; j < spans.length; j++)
	            if($(spans[j]).text() == $(options[i]).text())
	                items.push({span:spans[j],option:options[i]})
	
	    return items
	}
	
	// Store the original 'chosen' method
	var fn_chosen = $.fn.chosen
	
	$.fn.extend({
	 // summery:
	 //  Extend the original 'chosen' method to support images
	 chosen: function(params) {
	
	    params = params || {}
	
	    // Original behavior - use function.apply to preserve context
	    var ret = fn_chosen.apply(this, arguments)
	
	    // Process all select elements to attach event handlers
	    // (change, hiding_dropdown and showing_dropdown)
	
	    this.each(function() {
	
	        var $this = $(this), chosen = $this.data('chosen')
	
	        $this.on("chosen:hiding_dropdown", function(e, chosen){
	            // summery
	            //  Triggers when hidding dropdown, explain why:TODO.
	            //
	            // evt: Event
	            //      The event object
	            // _chosen: Object {chosen:Chosen}
	            //      Contains the current instance of Chosen class
	
	            var options       = getSelectedOptions(chosen.chosen)
	            var rtl           = chosen.chosen.is_rtl
	            var multiple      = chosen.chosen.is_multiple
	            var html_template = params.html_template ||
	                                (rtl && multiple ? '{text}' + fn_template : fn_template + '{text}')
	
	            for(var i = 0; i < options.length; i++){
	                prependTemplate(options[i].span, options[i].option, html_template, rtl, multiple)
	            }
	        })
	
	        $this.on("chosen:showing_dropdown", function showing_dropdown(evt, chosen){
	            // summery
	            //    This function is triggered when the chosen instance dropdown list
	            //    becomes visible. http://forwebonly.com/jquery-chosen-custom-events-and-how-to-use-them/
	            //
	            // evt: Event
	            //      The event object
	            // chosen: Object {chosen:Chosen}
	            //      Contains the current instance of Chosen class
	
	            var chosen        = chosen.chosen
	            var options       = chosen.form_field.options || []
	            var rtl           = chosen.is_rtl
	            var html_template = params.html_template ||
	                                (rtl ? '{text}'+fn_template : fn_template+'{text}')
	
	            var lis = $(chosen.container).find('.chosen-drop ul li:not(:has(img))')
	
	            for(var i = 0; i < lis.length; i++){
	                var li      = lis[i]
	                var option  = $(options[i])
	                var idx     = $(li).attr('data-option-array-index')
	
	                /* correct option index */
	
	                if (idx){
	                  option = options[chosen.results_data[idx].options_index]
	                  prependTemplate(li, option, html_template, rtl, true, 'chose-image-list')
	                }
	
	            }
	        })
	
	        $this.on("chosen:ready", function change(e, chosen){
	            // summery:
	            //  Trigger hide dropdown when ready.
	            //  TODO: remove as it is never triggered!
	            $this.trigger('chosen:hiding_dropdown',chosen)
	        })
	
	        $this.on("chosen:updated", function change(e){
	            // summery
	            //  Update after `chosen:updated` event is triggered
	          $this.trigger('chosen:hiding_dropdown',{chosen:chosen})
	        })
	
	        $this.on('chosen:filter', function(evt, chosen){
	            // summery
	            //  Support search, pending: https://github.com/harvesthq/chosen/pull/2373
	          $this.trigger('chosen:showing_dropdown',{chosen:chosen.chosen})
	        })
	
	        // Finally, trigger hiding_dropdown on all select elements
	        if(typeof chosen != 'undefined') {
	          $this.trigger('chosen:hiding_dropdown',{chosen:chosen})
	        }
	    })
	    return $(this);
	 }
	})
	
	
	})(jQuery)
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "            <option data-img-src=\""
	    + alias2(alias1((depth0 != null ? depth0.color : depth0), depth0))
	    + "\" value=\""
	    + alias2(alias1((depth0 != null ? depth0.groupId : depth0), depth0))
	    + "\" "
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.userCanAssign : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">"
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "</option>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<select class=\"consult-grp-select\" multiple "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.renderDisabled : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.consultGroups : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</select>\n\n";
	},"useData":true});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	
	__webpack_require__(163);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function(options) {
	
	        this.onChange = options.onChange;
	        this.groups = options.groups; // can be diff for flash notes ....
	        this.renderDisabled = options.renderDisabled;
	
	    },
	
	    template: __webpack_require__(174),
	
	    onRender: function() {
	
	        this.unwrap(); // required for plugin markup -- see note in consultGroupSelector
	
	        // I don't think ever had to handle situation where note access group didn't exist ...
	        this.options.selectedGroupId &&
	            this.$el.val( this.options.selectedGroupId );
	
	    },
	
	    serializeData: function() {
	
	        //if (this.options.useDescription) {
	        //
	        //}
	
	        return {
	            groups: this.groups,
	            renderDisabled: this.renderDisabled
	        };
	
	    },
	
	    // ( Chosen must be in DOM )
	    onShow: function() {
	
	        this.$el.chosen({
	            width: '100%'
	        }).on('change', _.bind( function() {
	
	            this.onChange( this.getSelectedGroup() );
	
	        }, this) );
	    },
	
	    getSelectedGroup: function() {
	
	        var selectedGroupId = parseInt( this.$el.val() ),
	            selectedGroup =  _.findWhere( this.groups,{ groupId:selectedGroupId } );
	
	        return selectedGroup;
	
	    },
	
	    onBeforeDestroy: function() {
	
	        this.$el
	            .off()
	            .chosen('destroy');
	
	    }
	
	
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <option value=\""
	    + alias2(alias1((depth0 != null ? depth0.groupId : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "</option>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<select class=\"accessibleBy\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.renderDisabled : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.groups : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</select>";
	},"useData":true});

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*ben: note -- for no conflict -- wrap in jQuery closure (not $), this guy extend jQuery, not $*/
	
	(function(jQuery) {
	
	/*
	 * jQuery Highlight plugin
	 *
	 * Based on highlight v3 by Johann Burkard
	 * http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html
	 *
	 * Code a little bit refactored and cleaned (in my humble opinion).
	 * Most important changes:
	 *  - has an option to highlight only entire words (wordsOnly - false by default),
	 *  - has an option to be case sensitive (caseSensitive - false by default)
	 *  - highlight element tag and class names can be specified in options
	 *
	 * Usage:
	 *   // wrap every occurrance of text 'lorem' in content
	 *   // with <span class='highlight'> (default options)
	 *   $('#content').highlight('lorem');
	 *
	 *   // search for and highlight more terms at once
	 *   // so you can save some time on traversing DOM
	 *   $('#content').highlight(['lorem', 'ipsum']);
	 *   $('#content').highlight('lorem ipsum');
	 *
	 *   // search only for entire word 'lorem'
	 *   $('#content').highlight('lorem', { wordsOnly: true });
	 *
	 *   // don't ignore case during search of term 'lorem'
	 *   $('#content').highlight('lorem', { caseSensitive: true });
	 *
	 *   // wrap every occurrance of term 'ipsum' in content
	 *   // with <em class='important'>
	 *   $('#content').highlight('ipsum', { element: 'em', className: 'important' });
	 *
	 *   // remove default highlight
	 *   $('#content').unhighlight();
	 *
	 *   // remove custom highlight
	 *   $('#content').unhighlight({ element: 'em', className: 'important' });
	 *
	 *
	 * Copyright (c) 2009 Bartek Szopka
	 *
	 * Licensed under MIT license.
	 *
	 */
	
	jQuery.extend({
	    highlight: function (node, re, nodeName, className) {
	        if (node.nodeType === 3) {
	            var match = node.data.match(re);
	            if (match) {
	                var highlight = document.createElement(nodeName || 'span');
	                highlight.className = className || 'highlight';
	                var wordNode = node.splitText(match.index);
	                wordNode.splitText(match[0].length);
	                var wordClone = wordNode.cloneNode(true);
	                highlight.appendChild(wordClone);
	                wordNode.parentNode.replaceChild(highlight, wordNode);
	                return 1; //skip added node in parent
	            }
	        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
	                !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
	                !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
	            for (var i = 0; i < node.childNodes.length; i++) {
	                i += jQuery.highlight(node.childNodes[i], re, nodeName, className);
	            }
	        }
	        return 0;
	    }
	});
	
	jQuery.fn.unhighlight = function (options) {
	    var settings = { className: 'highlight', element: 'span' };
	    jQuery.extend(settings, options);
	
	    return this.find(settings.element + "." + settings.className).each(function () {
	        var parent = this.parentNode;
	        parent.replaceChild(this.firstChild, this);
	        parent.normalize();
	    }).end();
	};
	
	jQuery.fn.highlight = function (words, options) {
	    var settings = { className: 'highlight', element: 'span', caseSensitive: false, wordsOnly: false };
	    jQuery.extend(settings, options);
	
	    if (words.constructor === String) {
	        words = [words];
	    }
	    words = jQuery.grep(words, function(word, i){
	      return word != '';
	    });
	    words = jQuery.map(words, function(word, i) {
	      return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	    });
	    if (words.length == 0) { return this; };
	
	    var flag = settings.caseSensitive ? "" : "i";
	    var pattern = "(" + words.join("|") + ")";
	    if (settings.wordsOnly) {
	        pattern = "\\b" + pattern + "\\b";
	    }
	    var re = new RegExp(pattern, flag);
	
	    return this.each(function () {
	        jQuery.highlight(this, re, settings.element, settings.className);
	    });
	};
	
	
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {/*!
		Autosize 1.18.13
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function ($) {
		var
		defaults = {
			className: 'autosizejs',
			id: 'autosizejs',
			append: '\n',
			callback: false,
			resizeDelay: 10,
			placeholder: true
		},
	
		// border:0 is unnecessary, but avoids a bug in Firefox on OSX
		copy = '<textarea tabindex="-1" style="position:absolute; top:-999px; left:0; right:auto; bottom:auto; border:0; padding: 0; -moz-box-sizing:content-box; -webkit-box-sizing:content-box; box-sizing:content-box; word-wrap:break-word; height:0 !important; min-height:0 !important; overflow:hidden; transition:none; -webkit-transition:none; -moz-transition:none;"/>',
	
		// line-height is conditionally included because IE7/IE8/old Opera do not return the correct value.
		typographyStyles = [
			'fontFamily',
			'fontSize',
			'fontWeight',
			'fontStyle',
			'letterSpacing',
			'textTransform',
			'wordSpacing',
			'textIndent',
			'whiteSpace'
		],
	
		// to keep track which textarea is being mirrored when adjust() is called.
		mirrored,
	
		// the mirror element, which is used to calculate what size the mirrored element should be.
		mirror = $(copy).data('autosize', true)[0];
	
		// test that line-height can be accurately copied.
		mirror.style.lineHeight = '99px';
		if ($(mirror).css('lineHeight') === '99px') {
			typographyStyles.push('lineHeight');
		}
		mirror.style.lineHeight = '';
	
		$.fn.autosize = function (options) {
			if (!this.length) {
				return this;
			}
	
			options = $.extend({}, defaults, options || {});
	
			if (mirror.parentNode !== document.body) {
				$(document.body).append(mirror);
			}
	
			return this.each(function () {
				var
				ta = this,
				$ta = $(ta),
				maxHeight,
				minHeight,
				boxOffset = 0,
				callback = $.isFunction(options.callback),
				originalStyles = {
					height: ta.style.height,
					overflow: ta.style.overflow,
					overflowY: ta.style.overflowY,
					wordWrap: ta.style.wordWrap,
					resize: ta.style.resize
				},
				timeout,
				width = $ta.width(),
				taResize = $ta.css('resize');
	
				if ($ta.data('autosize')) {
					// exit if autosize has already been applied, or if the textarea is the mirror element.
					return;
				}
				$ta.data('autosize', true);
	
				if ($ta.css('box-sizing') === 'border-box' || $ta.css('-moz-box-sizing') === 'border-box' || $ta.css('-webkit-box-sizing') === 'border-box'){
					boxOffset = $ta.outerHeight() - $ta.height();
				}
	
				// IE8 and lower return 'auto', which parses to NaN, if no min-height is set.
				minHeight = Math.max(parseInt($ta.css('minHeight'), 10) - boxOffset || 0, $ta.height());
	
				$ta.css({
					overflow: 'hidden',
					overflowY: 'hidden',
					wordWrap: 'break-word' // horizontal overflow is hidden, so break-word is necessary for handling words longer than the textarea width
				});
	
				if (taResize === 'vertical') {
					$ta.css('resize','none');
				} else if (taResize === 'both') {
					$ta.css('resize', 'horizontal');
				}
	
				// The mirror width must exactly match the textarea width, so using getBoundingClientRect because it doesn't round the sub-pixel value.
				// window.getComputedStyle, getBoundingClientRect returning a width are unsupported, but also unneeded in IE8 and lower.
				function setWidth() {
					var width;
					var style = window.getComputedStyle ? window.getComputedStyle(ta, null) : false;
					
					if (style) {
	
						width = ta.getBoundingClientRect().width;
	
						if (width === 0 || typeof width !== 'number') {
							width = parseInt(style.width,10);
						}
	
						$.each(['paddingLeft', 'paddingRight', 'borderLeftWidth', 'borderRightWidth'], function(i,val){
							width -= parseInt(style[val],10);
						});
					} else {
						width = $ta.width();
					}
	
					mirror.style.width = Math.max(width,0) + 'px';
				}
	
				function initMirror() {
					var styles = {};
	
					mirrored = ta;
					mirror.className = options.className;
					mirror.id = options.id;
					maxHeight = parseInt($ta.css('maxHeight'), 10);
	
					// mirror is a duplicate textarea located off-screen that
					// is automatically updated to contain the same text as the
					// original textarea.  mirror always has a height of 0.
					// This gives a cross-browser supported way getting the actual
					// height of the text, through the scrollTop property.
					$.each(typographyStyles, function(i,val){
						styles[val] = $ta.css(val);
					});
					
					$(mirror).css(styles).attr('wrap', $ta.attr('wrap'));
	
					setWidth();
	
					// Chrome-specific fix:
					// When the textarea y-overflow is hidden, Chrome doesn't reflow the text to account for the space
					// made available by removing the scrollbar. This workaround triggers the reflow for Chrome.
					if (window.chrome) {
						var width = ta.style.width;
						ta.style.width = '0px';
						var ignore = ta.offsetWidth;
						ta.style.width = width;
					}
				}
	
				// Using mainly bare JS in this function because it is going
				// to fire very often while typing, and needs to very efficient.
				function adjust() {
					var height, original;
	
					if (mirrored !== ta) {
						initMirror();
					} else {
						setWidth();
					}
	
					if (!ta.value && options.placeholder) {
						// If the textarea is empty, copy the placeholder text into 
						// the mirror control and use that for sizing so that we 
						// don't end up with placeholder getting trimmed.
						mirror.value = ($ta.attr("placeholder") || '');
					} else {
						mirror.value = ta.value;
					}
	
					mirror.value += options.append || '';
					mirror.style.overflowY = ta.style.overflowY;
					original = parseInt(ta.style.height,10);
	
					// Setting scrollTop to zero is needed in IE8 and lower for the next step to be accurately applied
					mirror.scrollTop = 0;
	
					mirror.scrollTop = 9e4;
	
					// Using scrollTop rather than scrollHeight because scrollHeight is non-standard and includes padding.
					height = mirror.scrollTop;
	
					if (maxHeight && height > maxHeight) {
						ta.style.overflowY = 'scroll';
						height = maxHeight;
					} else {
						ta.style.overflowY = 'hidden';
						if (height < minHeight) {
							height = minHeight;
						}
					}
	
					height += boxOffset;
	
					if (original !== height) {
						ta.style.height = height + 'px';
						if (callback) {
							options.callback.call(ta,ta);
						}
						$ta.trigger('autosize.resized');
					}
				}
	
				function resize () {
					clearTimeout(timeout);
					timeout = setTimeout(function(){
						var newWidth = $ta.width();
	
						if (newWidth !== width) {
							width = newWidth;
							adjust();
						}
					}, parseInt(options.resizeDelay,10));
				}
	
				if ('onpropertychange' in ta) {
					if ('oninput' in ta) {
						// Detects IE9.  IE9 does not fire onpropertychange or oninput for deletions,
						// so binding to onkeyup to catch most of those occasions.  There is no way that I
						// know of to detect something like 'cut' in IE9.
						$ta.on('input.autosize keyup.autosize', adjust);
					} else {
						// IE7 / IE8
						$ta.on('propertychange.autosize', function(){
							if(event.propertyName === 'value'){
								adjust();
							}
						});
					}
				} else {
					// Modern Browsers
					$ta.on('input.autosize', adjust);
				}
	
				// Set options.resizeDelay to false if using fixed-width textarea elements.
				// Uses a timeout and width check to reduce the amount of times adjust needs to be called after window resize.
	
				if (options.resizeDelay !== false) {
					$(window).on('resize.autosize', resize);
				}
	
				// Event for manual triggering if needed.
				// Should only be needed when the value of the textarea is changed through JavaScript rather than user input.
				$ta.on('autosize.resize', adjust);
	
				// Event for manual triggering that also forces the styles to update as well.
				// Should only be needed if one of typography styles of the textarea change, and the textarea is already the target of the adjust method.
				$ta.on('autosize.resizeIncludeStyle', function() {
					mirrored = null;
					adjust();
				});
	
				$ta.on('autosize.destroy', function(){
					mirrored = null;
					clearTimeout(timeout);
					$(window).off('resize', resize);
					$ta
						.off('autosize')
						.off('.autosize')
						.css(originalStyles)
						.removeData('autosize');
				});
	
				// Call adjust in case the textarea already contains text.
				adjust();
			});
		};
	}(jQuery || $)); // jQuery or jQuery-like library, such as Zepto
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(59)))

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return " new-note";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<span class=\"note-icon-derived-group\" style=\"background:"
	    + alias4(((helper = (helper = helpers.userColor || (depth0 != null ? depth0.userColor : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userColor","hash":{},"data":data}) : helper)))
	    + ";\">\n                        <i class=\"icon-users\" style=\"color:"
	    + alias4(((helper = (helper = helpers.userColorContrast || (depth0 != null ? depth0.userColorContrast : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userColorContrast","hash":{},"data":data}) : helper)))
	    + ";\" title=\""
	    + alias4(((helper = (helper = helpers.userColorIndicatorTitle || (depth0 != null ? depth0.userColorIndicatorTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userColorIndicatorTitle","hash":{},"data":data}) : helper)))
	    + "\"></i>\n                    </span>";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "                <span class=\"new\">New</span>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "        <div class=\"subject-rw hide\">\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showConversionToFloatingCodes : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <label>Subject:</label>\n        </div>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "                <div class=\"redaction-convert-indicator hide\" title=\"Converting to Floating Reason Codes...\">\n                    <i class=\"icon-exchange\"></i>\n                </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"pgNumWr\">\n                <a class=\"pgNum "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.pgNavigationDisabled : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Page "
	    + alias4(((helper = (helper = helpers.pgNum || (depth0 != null ? depth0.pgNum : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNum","hash":{},"data":data}) : helper)))
	    + "\" role=\"button\">p."
	    + alias4(((helper = (helper = helpers.pgNum || (depth0 != null ? depth0.pgNum : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNum","hash":{},"data":data}) : helper)))
	    + "</a>\n            </div>    \n";
	},"13":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"noteBody\">"
	    + alias4(((helper = (helper = helpers.textNoteValue || (depth0 != null ? depth0.textNoteValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textNoteValue","hash":{},"data":data}) : helper)))
	    + "</div>\n            <textarea class=\"taNoteBody hide\" placeholder=\""
	    + alias4(((helper = (helper = helpers.newNoteTextAreaPlaceHolder || (depth0 != null ? depth0.newNoteTextAreaPlaceHolder : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"newNoteTextAreaPlaceHolder","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.textNoteValue || (depth0 != null ? depth0.textNoteValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"textNoteValue","hash":{},"data":data}) : helper)))
	    + "</textarea>\n            <input type=\"text\" class=\"noteSubject subj-input hide\" title=\"Subject\" value=\""
	    + alias4(((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subject","hash":{},"data":data}) : helper)))
	    + "\"> <!-- don't exclude, want values printed for has changed fn -->\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"noteSubject subj-div\">"
	    + alias4(((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subject","hash":{},"data":data}) : helper)))
	    + "</div>\n            <input type=\"text\" class=\"subj-input hide\" title=\"Subject\" placeholder=\""
	    + alias4(((helper = (helper = helpers.subjectPH || (depth0 != null ? depth0.subjectPH : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subjectPH","hash":{},"data":data}) : helper)))
	    + "\" value=\""
	    + alias4(((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subject","hash":{},"data":data}) : helper)))
	    + "\">\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "            <div class=\"modBtns hide\">\n                \n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showMoreBtn : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeEditBtn : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showConversionToFloatingCodes : depth0),{"name":"if","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeDeleteBtn : depth0),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            </div>\n";
	},"20":function(container,depth0,helpers,partials,data) {
	    return "                    <div class=\"ellipsis-wr\" title=\"More\">\n                        <i class=\"icon-dot-3\"></i>\n                    </div>\n";
	},"22":function(container,depth0,helpers,partials,data) {
	    return "                    <div class=\"mod-btn edit\" title=\"Edit\">\n                        <span class=\"icon-edit-2\"></span>\n                    </div>\n";
	},"24":function(container,depth0,helpers,partials,data) {
	    return "                    <div class=\"mod-btn btn-convert-to-floating\" title=\"Covert To Floating Reason Codes...\">\n                        <span class=\"icon-exchange\"></span>\n                    </div>\n";
	},"26":function(container,depth0,helpers,partials,data) {
	    return "                    <div class=\"mod-btn delete\" title=\"Delete\">\n                        <span class=\"icon-trash\"></span>\n                    </div>\n";
	},"28":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "            <div class=\"note-sat-info-row consult-row\">\n                <span class=\"note-sat-info-lbl consult-grp-label\">Consulted With:</span>\n                <div class=\"consult-group-lbl-wr\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.consultGroups : depth0),{"name":"each","hash":{},"fn":container.program(29, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                </div>\n            </div>\n";
	},"29":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                        <span class=\"consult-lbl label\" style=\"background-color:"
	    + alias2(alias1((depth0 != null ? depth0.labelColor : depth0), depth0))
	    + ";color:"
	    + alias2(alias1((depth0 != null ? depth0.textColor : depth0), depth0))
	    + ";\">\n                            "
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "\n                        </span>\n";
	},"31":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.reasonCodes : depth0),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"32":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                 <div class=\"note-sat-info-row note-reason-code-row\">\n                     <span class=\"note-sat-info-lbl\" title=\"Reason Codes\">Reason Codes:</span>\n                     <span class=\"note-reason-codes\" title=\""
	    + alias4(((helper = (helper = helpers.reasonCodes || (depth0 != null ? depth0.reasonCodes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reasonCodes","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.reasonCodes || (depth0 != null ? depth0.reasonCodes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reasonCodes","hash":{},"data":data}) : helper)))
	    + "</span>\n                </div>\n";
	},"34":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "        <div class=\"note-ops-wr collapsible\">\n\n            <div class=\"note-select-wr\"> <!-- prob better to have diff rows then put all in here, but now working, entire view needs refactor badly -->\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isGraphicStamp : depth0),{"name":"if","hash":{},"fn":container.program(35, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isTextStamp : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isPageNote : depth0),{"name":"if","hash":{},"fn":container.program(43, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isFlashNote : depth0),{"name":"if","hash":{},"fn":container.program(50, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            </div>\n        </div>\n\n";
	},"35":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n"
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isNew : depth0),{"name":"unless","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Select Stamp: </label>\n                        <div class=\"note-chosen-wr\">\n                            <div data-stamp-select-holder=\"true\" class=\"ad-wr note-opts-row\"></div>\n                        </div>\n                    </div>\n\n";
	},"36":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                        <div class=\"note-opts-row\">\n                            <label class=\"note-opts-lbl-left\">Image Preview: </label>\n                            <img class=\"savedStampImgPreview\" src=\""
	    + container.escapeExpression(((helper = (helper = helpers.stampNoteSrc || (depth0 != null ? depth0.stampNoteSrc : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"stampNoteSrc","hash":{},"data":data}) : helper)))
	    + "\">\n                        </div>\n";
	},"38":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n                    <div class=\"note-opts-row\">\n                        <span class=\"ts-stamp-ready-ind\" title=\"Stamp Is Ready to Be Placed Atop the Page\">\n                            <i class=\"icon-ok-circled-1\"></i>\n                        </span>\n                        <label class=\"note-opts-lbl-left lbl-select-txt-stamp\">Select Stamp:</label>\n                        <div class=\"note-chosen-wr note-chosen-wr-stamp-select\">\n                            <div data-stamp-select-holder=\"true\" class=\"ad-wr note-opts-row\"></div>\n                        </div>\n                        <div class=\"text-stamp-note-template-selected-indicator\"></div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <div class=\"text-stamp-template\"></div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <div class=\"note-opts-row-header\">Preview:</div>\n                        <div class=\"text-stamp-preview-wr\"></div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <div class=\"existing-tokens-wr\"></div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <div class=\"text-stamp-variables-wr\"></div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Font:</label>\n                        <div class=\"note-chosen-wr ts-font-select-wr\">\n                            <select class=\"text-stamp-font-select\">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.fonts : depth0),{"name":"each","hash":{},"fn":container.program(39, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                            </select>\n                        </div>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Font Size:</label>\n                        <select class=\"text-stamp-font-size-select\">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.fontSizes : depth0),{"name":"each","hash":{},"fn":container.program(41, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                        </select>\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Color:</label>\n                        <a href=\"#\" class=\"ts-cp-parent\"></a>\n\n                    </div>\n\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Opacity:</label>\n                        <div class=\"ts-opacity-slider-wr\">\n                            <input class=\"ts-opacity-slider\" type=\"range\" min=\"0\" max=\"100\" step=\"1\" title=\"Font Opacity\">\n                        </div>\n                    </div>\n\n";
	},"39":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                                    <option value=\""
	    + alias2(alias1(depth0, depth0))
	    + "\" style=\"font-family: "
	    + alias2(alias1(depth0, depth0))
	    + ";\">"
	    + alias2(alias1(depth0, depth0))
	    + "</option>\n";
	},"41":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                                <option value=\""
	    + alias2(alias1(depth0, depth0))
	    + "\">"
	    + alias2(alias1(depth0, depth0))
	    + "</option>\n";
	},"43":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n                    <div class=\"note-opts-row\">\n                        <label class=\"note-opts-lbl-left\">Accessible By: </label>\n                        <div class=\"note-chosen-wr chosen-access-grp-wr\">\n                            <div data-access-grp-select-holder=\"true\"></div>\n                        </div>\n                    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showConsultInput : depth0),{"name":"if","hash":{},"fn":container.program(44, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isFullPageRedaction : depth0),{"name":"if","hash":{},"fn":container.program(46, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                    <div class=\"ad-wr note-opts-row "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideAutoDisplay : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n                        <label class=\"note-opts-lbl-left\">Auto Display: </label>\n                        <input type=\"checkbox\" class=\"autoDisplay\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.display : depth0),{"name":"if","hash":{},"fn":container.program(48, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " >\n                    </div>\n\n";
	},"44":function(container,depth0,helpers,partials,data) {
	    return "                        <div class=\"note-opts-row\">\n                            <label class=\"note-opts-lbl-left\">Consult Groups: </label>\n                            <div class=\"note-chosen-wr chosen-consult-grp-wr\">\n                                <div data-consult-select-holder=\"true\"></div>\n                            </div>\n                        </div>\n";
	},"46":function(container,depth0,helpers,partials,data) {
	    return "                        <div class=\"note-opts-row\">\n                            <div class=\"note-fpr-zone-props-wr\"></div>\n                        </div>\n";
	},"48":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"50":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n"
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isFlashBackNote : depth0),{"name":"unless","hash":{},"fn":container.program(51, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                    <div class=\"fn-email-wr note-opts-row hide\"> <!-- starts hidden b/c by default is set to the user -->\n                        <label class=\"note-opts-lbl-left\">Email: </label>\n                        <input type=\"checkbox\" class=\"fn-email\" checked=\"true\">\n                    </div>\n\n";
	},"51":function(container,depth0,helpers,partials,data) {
	    return "                        <div class=\"note-opts-row\">\n                            <div class=\"note-chosen-wr\">\n                                <label class=\"note-opts-lbl-left\">To:</label>\n                                <div class=\"note-chosen-wr chosen-access-grp-wr\">\n                                    <div data-access-grp-select-holder=\"true\"></div>\n                                </div>\n                            </div>\n                         </div>\n";
	},"53":function(container,depth0,helpers,partials,data) {
	    return "\n        <div class=\"submit-row collapsible\">\n\n            <div class=\"validation-err pull-left\"></div>\n\n            <div class=\"submit-btns pull-right\">\n                <button class=\"btn btn-mini btn-primary ok\" title=\"Save\"> <!-- todo: make partial -->\n                    <i class=\"icon-ok\"></i>\n                </button>\n                <button class=\"btn btn-mini btn-danger cancel\" title=\"Cancel\">\n                    <i class=\"icon-cancel-1\"></i>\n                </button>\n            </div>\n\n        </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"note "
	    + alias4(((helper = (helper = helpers.noteClass || (depth0 != null ? depth0.noteClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"noteClass","hash":{},"data":data}) : helper)))
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isNew : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.filterOut : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n\n    <div class=\"noteHead\">\n\n        <div class=\"headLeft\">\n\n            <div class=\"note-icon-wr\" title=\""
	    + alias4(((helper = (helper = helpers.iconHoverLabel || (depth0 != null ? depth0.iconHoverLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"iconHoverLabel","hash":{},"data":data}) : helper)))
	    + "\">\n                <i class=\"note-icon "
	    + alias4(((helper = (helper = helpers.iconClass || (depth0 != null ? depth0.iconClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"iconClass","hash":{},"data":data}) : helper)))
	    + "\"></i>\n            </div>\n\n            <div class=\"note-user-name-wr\">\n\n                 <span class=\"userName\" title=\""
	    + alias4(((helper = (helper = helpers.cuser || (depth0 != null ? depth0.cuser : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cuser","hash":{},"data":data}) : helper)))
	    + "\">\n                     <span>"
	    + alias4(((helper = (helper = helpers.cuser || (depth0 != null ? depth0.cuser : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cuser","hash":{},"data":data}) : helper)))
	    + "</span>\n                 </span>"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showUserColorIndicator : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n\n        </div>\n\n        <div class=\"headRight\">\n            <span class=\"cTime\">\n                "
	    + alias4(((helper = (helper = helpers.ctime || (depth0 != null ? depth0.ctime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ctime","hash":{},"data":data}) : helper)))
	    + "\n            </span>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isNew : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </div>\n\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeSubjectLabel : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <div class=\"r2\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includePgNumber : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.noteInputFieldIsTextArea : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.program(17, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeModBtns : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </div>\n\n    <div class=\"note-sat-filterable-info\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showConsultRow : depth0),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isRedactionNote : depth0),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showNoteOperations : depth0),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeActionBtns : depth0),{"name":"if","hash":{},"fn":container.program(53, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>";
	},"useData":true});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	var NoteView = __webpack_require__(155),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49);
	
	module.exports = NoteView.extend({
	
	    uiModelEvents: _.extend( {}, NoteView.prototype.uiModelEvents, {
	
	        'change:viewerPgNumber'     : 'updatePgNumber', // ( from set note views navigability -- only applicable to page text notes)
	        'change:navigationEnabled'  : 'togglePgNavigationAbility'
	
	    }),
	
	
	    ui: _.extend( NoteView.prototype.ui, {
	        pgNumLink: '.pgNum'
	    }),
	
	    onRender: function() {
	
	        NoteView.prototype.onRender.call(this);
	
	        var vc = this.channel.request('vChannel');
	
	        this.uiModel.setNavigationEnabled(
	            !vc.request('getViewer') || vc.request('viewMode') === 'pdf'
	                ? false
	                : !vc.request('pgNoteIsOfActivePage', this.model)
	        );
	
	    },
	
	    updatePgNumber: function(uiModel, pgNumber) {
	
	        this.ui.pgNumLink.text( 'p.' + pgNumber );
	
	    },
	
	    togglePgNavigationAbility: function(uiModel, enable) {
	
	        var goToNotePage = function() {
	            this.channel.trigger('notes:goToPage', this.model);
	        };
	
	        enable
	            ? this.ui.pgNumLink.removeClass('disabled').on('click', _.bind(goToNotePage, this))
	            : this.ui.pgNumLink.addClass('disabled').off();  //taking off all handlers fixed the problem of the handler not disabling
	
	    }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(180);
	
	var PageNoteView = __webpack_require__(178),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    Util = __webpack_require__(48),
	    getContrastYIQ = Util.getContrastYIQ; // inc perf somewhat
	
	/*
	* Should further subclass ....
	* 'User Icon': used to indicate if 'the derived user color from its groups' would apply,
	* Only put an only on drawable note because for the other note types, we don't return groupOfDerivedCreationGroupUser.
	* For the same reason, also don't:
	* - give the user name a 'label' like background color
	* - and don't have a user icon in front of each of the cusr labels
	* Added background square -- can't show very light colors atop a white background.
	* */
	
	
	module.exports = PageNoteView.extend({
	
	
	    ui: _.extend( {}, PageNoteView.prototype.ui, {
	
	        bodyField:    '.noteSubject' // Note: I don't believe referenced, but left to indicate it's different on these noteTypes
	
	    }),
	
	    serializeData: function() {
	
	        var context = PageNoteView.prototype.serializeData.apply( this, arguments );
	        context.groupOfDerivedCreationGroupUser = context.note.getGroupOfDerivedCreationUserGroupColor();
	        return context;
	
	    },
	
	    templateHelpers: _.extend( {}, PageNoteView.prototype.templateHelpers, {
	
	        showUserColorIndicator: function() {
	
	            return this.groupOfDerivedCreationGroupUser;
	
	        },
	
	        userColor: function() {
	
	            if ( !this.groupOfDerivedCreationGroupUser )
	                return null;
	
	            return this.groupOfDerivedCreationGroupUser.getColor();
	
	        },
	
	        userColorContrast: function() {
	
	            if ( !this.groupOfDerivedCreationGroupUser )
	                return null;
	
	            return getContrastYIQ( this.groupOfDerivedCreationGroupUser.getColor(), '#333') ; // (#555 same as csur color; a little darker b/c we make a bit opaque )
	
	        },
	
	        userColorIndicatorTitle: function() {
	
	            if ( !this.groupOfDerivedCreationGroupUser )
	                return null;
	
	            return 'Shape color derived from ' + this.cuser + "'s membership in group " +
	                this.groupOfDerivedCreationGroupUser.getName() + '.';
	
	        }
	
	    }),
	
	
	    toggleKeyEvents: function( isUserDrawing ) {
	
	        this[isUserDrawing ? 'unbindKeyboardEvents' : 'bindKeyboardEvents']();
	
	    },
	
	    /*
	    * Note: the hover creating the event mediated could come from multi shapes, resulting in race conditions
	    * (is entering/not is entering) --> don't use $.fn.toggleClass
	    * */
	    toggleNoteHighlight: function( isEntering ) {
	
	        this.$el[isEntering ? 'addClass' : 'removeClass']('highlighted');
	
	    },
	
	    _postBaseToggleEditMode: function( isEntering ) {
	
	        if ( isEntering ) {
	
	            this.ui.noteSubject.setCursorEndOfText().removeClass('hide');
	            // Swap the subject div and input
	            // TODO: make class & state
	            this.ui.subjectDiv.addClass('hide');
	
	        }
	
	    }
	
	});
	
	
	


/***/ },
/* 180 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	/*For now Implies Highlight -- Really the Base */
	// really a wrapper around a raphael element -- that could be it's own view (events delegated/undelegated)
	
	
	 var Raphael = __webpack_require__(182),
	     RaphaelView = __webpack_require__(187),
	     $ = __webpack_require__(59),
	     _ = __webpack_require__(49),
	     ShapeMoveFns = __webpack_require__(189),
	     ShapeResizeFnsFactory = __webpack_require__(192),
	     SelectHandles = __webpack_require__(195),
	     SelectBoxView = __webpack_require__(206),
	     BtnSet = __webpack_require__(207);
	
	
	var instVars = {
	
	    parent: null, // TODO: rid  ... used for mouseInBounds fn
	    shapeModel: null,
	    shapeUI: null,
	    pgNoteModel: null, //TODO: can now get via resresp
	    paper: null, // TODO: necessary? -- getting the dragHandle on drawStart -- rid and renderFromModel -- this.paper.path()
	    channel: null,
	
	    /* later added */
	    dragHandle: null,
	    glow: null, // R.set from glow
	    handleSet: null,
	    borderView: null //depends on subShapeType
	
	    // ShapeResizeFns: resizeStart, resizeMove, resizeEnd
	    // MoveFns: moveStart, moveMove, moveEnd
	    // bounds
	        // this.obox = this.el.getBBox();
	        // this.obx = this.obox.x; //use as origin!
	        // this.oby = this.obox.y;
	
	    // borderView -- optional
	};
	
	
	/* Note: base in the 'coordinate */
	var ShapeView = RaphaelView.extend({  /* init from set or r element */
	
	    initialize: function(options) {
	
	        _.extend( this, instVars, _.pick(options, 'shapeModel', 'pgNoteModel', 'parent', 'channel'), {
	            shapeUI: options.shapeModel.uiModel, /*cache*/
	            paper: options.parent.paper
	        });
	
	        this.bindEntityEvents(this.shapeUI,     this.shapeUIEvents);
	        this.bindEntityEvents(this,             this.shapeSubs); /* events triggered off self ... legacy ...*/
	
	        _.bindAll(this, '_selectClickedShape');
	
	    },
	    shapeUIEvents: {
	        'change:isActive':              'toggleActive',     /* Indicates the note of the shape is active -- activate/deactivate -- TODO: could move to on render */
	        'change:isExpanded':            'toggleExpanded',   /* Indicates the note of the shape is expanded -- setExpanded/unsetExpanded -- TODO: could move to onRender */
	        'change:isSelected':            'toggleSelected',   /* select/unSelect */
	        'change:isHighlighted':         'toggleGlow',        /* highlight/unHighlight */
	        'shape:consultGroupChange':     'noteConsultGroupChange', // not an attribute on shapeUI; trigger off here for convenience with listener already set
	
	        // TODO: F&R : now using same view
	        'change:isMouseOverFindAndRedactHitView': 'toggleGlow', // utilizing for toggle from hit view
	        'change:isHitApplied':                    'toggleApplied'
	
	    },
	    /*
	    * Shape events fired off themselves
	    * Note: there are more, not all listened to off the base here -- eg: shape.move shape.resizeRect ... should inventory
	    * */
	    shapeSubs: {
	
	        'shape.scaleWithPaper':          '_scaleWithPaper',
	
	        // TODO: F&R - though now may want to update all shapes live ( canvas-re-render)
	        'shape.moveEnd shape.resizeEnd': 'persistPosition'
	
	    },
	    events: {
	        'mouseover': 'onEnterMouseHover',
	        'mouseout':  'onExitMouseHover'
	    },
	
	    /**
	     * TODO:
	     * - now passing in sm for fns that ref the proto change to options
	     * - for non graphic, still need paper first -- must draw; way around this ?
	     * - (could now get fromModel from shapeUI.isNewlyDrawn)
	     * - _renderFromModel: this was working but incorrect -- for signatures, s/b be calling the overwritten method on graphic notes, not this
	     * - this.shapeUI.set({raphaelEl: rEl}): should be stored first in parse for graphic ... but actually doesn't exist until render -- can move to parse
	     */
	    render: function(sm, scale, channel, fromModel) {
	
	        if (fromModel) {
	            var rEl = this._renderFromModel.apply(this, arguments);
	            this.shapeUI.set({raphaelEl: rEl}); // stored (just created now)
	        }
	
	        this.setElement( this.shapeUI.raphaelEl() );
	        this._hideIfAutoDisplay();
	        this.triggerMethod('afterRender'); // Don't need to ref proto
	
	
	        // TODO: temp for find and redact -- need to move logic to render: -- quick hack due to re-render of canvas mouse if over and you 'goToHit')
	        if ( this.shapeUI.get('isMouseOverFindAndRedactHitView') )
	            this.toggleGlow();
	
	        return this;
	
	    },
	    /*
	    * ( Alternative is shape drawn on canvas -- then created into shape view) )
	    * */
	    _renderFromModel: function( shapeModel, scale ) {
	
	        return this.paper
	            .path( shapeModel.getPathToRenderFromModel(scale) )
	            .attr( shapeModel.getNonPathInactiveSVGAttrs( this.channel) );
	
	
	    },
	    onEnterMouseHover: function(e) {
	
	        if ( this.shapeModel.isFindAndRedactShape ) {
	            this.toggleIsMouseOverFindAndRedactShape( e, true );
	            return;
	        }
	
	        /**
	         * DVBC-1740 -- don't stop propagation if edit mode
	         * - toggleMouseOver functionality doesn't apply here anyway
	         * - need to allow mouseenter event to be captured by the page canvas to show hovershapes
	         */
	        if ( this.channel.request('editMode') )
	            return;
	
	
	        e.preventDefault();
	        e.stopImmediatePropagation(); /* NOTE: will take the lowest -- event not prop'ing up through layers -- solves overlap problem */
	
	        this.channel.trigger('shapeView:toggleMouseOver', this.pgNoteModel, {isEntering: true });
	
	
	    },
	    onExitMouseHover: function(e) {
	
	        if ( this.shapeModel.isFindAndRedactShape ) {
	            this.toggleIsMouseOverFindAndRedactShape( e, false );
	            return;
	        }
	
	        // DVBC-1740 -- see comment in onEnterMouseHover ( don't stop propagation in edit mode )
	        if ( this.channel.request('editMode') )
	            return;
	
	        e.preventDefault();
	        e.stopImmediatePropagation(); /* NOTE: will take the lowest -- event not prop'ing up through layers -- solves overlap problem */
	
	        this.channel.trigger('shapeView:toggleMouseOver', this.pgNoteModel, {isEntering: false });
	
	    },
	
	    /**
	     * Area for F&R subclass / refactor.
	     * Also wouldn't want to allow if not one of these shapes, a note view wouldn't exist and RTE would occur.
	     * Here we also want to trigger the shape, not the model
	     * Note: F&R also allowed with edit mode -- see DVBC-1740
	     * See overlap with DVBC AND EDIT MODE -- you could be in 'both modes'
	     * Should also: /mediate/cache/reuse hitsCollection
	     */
	    toggleIsMouseOverFindAndRedactShape: function( e, isMouseOverShape ) {
	
	        e.preventDefault();
	        e.stopImmediatePropagation();
	
	        var hitModelOfShape =
	            this.channel.request('vChannel')
	                .request('findAndRedactSearchModel')
	                .get('searchResults').getHitById( this.shapeModel.get('hitId') );
	
	        // For now send event with a direct ref
	        hitModelOfShape.set( 'isMouseOverCanvasShape', isMouseOverShape );
	
	    },
	
	
	    // Now only enter: canvas-re-rendered prior and exit wouldn't exist --> could just move to render
	    toggleActive: function() {
	
	        /*
	         * TODO:
	         * - subclass on graphic note shape model
	         * - Diff shape models will rid need for this ...
	         *   I think subtype only applicable at note level with graphic notes ( but move to shapeModels anyway )
	         * */
	        var isNotGraphicNote = !this.pgNoteModel.isSVGGraphicNote();
	
	        isNotGraphicNote &&
	            this.el.attr( this.shapeModel.getNonPathActiveSVGAttrs( this.channel )  );
	
	        /* note: cursor must come after or the other props will override it) */
	        this.el.attr('cursor', 'pointer');
	        this._enableSelect();
	
	
	        /* must put front of other shapes so that their cursor doesn't go in front of this one */
	        this.el.toFront();
	        this._showIfAutoDisplay();
	        
	    },
	
	    toggleSelected: function(ui, isSelected) {
	
	        if (isSelected) {
	            this._enableMove();  //!order of events matters -- need to move
	            this.setResizeFns();
	            this._disableSelect();
	            // *DOING THIS LAST FIXES ISSUE WITH INABILITY TO DRAW UPON ENTER EDIT/CREATE WITHOUT HACK -- TODO: put b/f would speed up */
	            this._createSelectSet();  /* PROB B/C IT MUST BE SET AFTER DISABLE SELECT */
	
	        } else {
	            this._destroySelectSet();
	            this.el.attr('cursor', 'pointer');  //active, but not selected ( or allow to draw on it ...)
	            this._disableMove();
	            this._enableSelect();
	        }
	
	    },
	
	    toggleApplied: function() {
	
	        this.el.attr( this.shapeModel.getNonPathActiveSVGAttrs( this.channel ) );
	        //this.resetGlow();
	    },
	
	    // Now would only ever enter ...
	    toggleExpanded: function(ui, isExpanded) {
	
	        this.makeExpandedVisibleIndicator( ui, isExpanded );
	        this.bringToFront();
	        this._showIfAutoDisplay();
	
	    },
	
	    // The visual change/indicator called as part of toggleExpanded routine.
	    // Can differ depending on the shape type.
	    // Now only entering
	    makeExpandedVisibleIndicator: function( ui, isExpanded ) {
	
	        var attrs = isExpanded
	            ? this.shapeModel.getNonPathActiveSVGAttrs( this.channel )
	            : this.shapeModel.getNonPathInactiveSVGAttrs( this.channel );
	
	        this.el.attr(attrs);
	
	    },
	
	    bringToFront: function() {
	        this.el.toFront();
	
	    },
	
	    /*
	    * Set the mousedown handler that allows for selection of the shape.
	    * */
	    _enableSelect: function () { 
	        this.el.mousedown( this._selectClickedShape ) ;
	    },
	    _disableSelect: function() {
	        this.el.unmousedown( this._selectClickedShape );
	    },
	    _selectClickedShape: function(e) {
	
	        // Note: a jq click
	        if (e) {
	            e.preventDefault();
	            e.stopPropagation(); // ( disallows drag )
	        }
	
	        var ch = this.channel;
	
	        /**
	         * Trigger how shape dealt with and set if the note has toolbar,
	         * set it's selected shape to this type.
	         * This will trigger this callback noteSubType changed.
	         */
	        ch.trigger('changeActiveNoteSubtype',  this.shapeModel.deriveShapeSubType(), {
	            changeOrigin: 'shapeSelected'
	        } );
	
	        // Must set the above before the selected shape
	        ch.command('setSelectedShape', this.shapeModel);
	
	    },
	    _enableMove: function() { //move from select and unselect
	        this.el
	            .attr('cursor', 'move')
	            .drag(this.moveMove, this.moveStart, this.moveEnd, this, this, this);
	    },
	    _disableMove: function() {
	        this.el
	            .attr('cursor', 'pointer')
	            .undrag();
	    },
	    _showIfAutoDisplay: function() {
	        this.pgNoteModel.applyAutoDisplayToShapes() && this.el.show();
	    },
	    _hideIfAutoDisplay: function() {
	
	        // Never hide if the shape is active (DVBC-1608)
	        if ( this.shapeUI.get('isActive') )
	            return;
	
	        this.pgNoteModel.applyAutoDisplayToShapes() && this.el.hide();
	
	    },
	    toggleGlow: function() {
	
	        !this.glow
	            ? this._createGlow()
	            : this._deleteGlow();
	
	    },
	    setResizeFns: function() {
	
	        // TODO: get from note, not global
	        var noteSubType = this.channel.request('activeNoteSubType');
	
	        if (noteSubType) {
	
	            _.extend( this, ShapeResizeFnsFactory(noteSubType) );
	
	            // TODO: can now put the if on the subclass ...
	            // TODO: others, IE8?
	            if (noteSubType === 'free') {
	                this.resizeMove = _.throttle(this.resizeMove, 100);
	                this.moveMove = _.throttle(this.moveMove, 50);
	            }
	
	            _.bindAll(this, 'resizeStart', 'resizeMove', 'resizeEnd');
	        }
	    },
	
	    /*
	    *  TODO ... put on model/view ... is the shape subtype stored on there (?) ... need to model subtype to shape  --- if not do it?
	    *  Refactor when can subclass the shape views and models
	    * */
	    _employBorderViewOnSelect: function() {
	
	        // Commented out -- was exploring utilizing this as compound shape to signify selected shape,
	        // but now that F&R shapes can be moved, N/A
	        // if (this.shapeModel.isFindAndRedactShape)
	        //    return true;
	
	        var subType = this.channel.request('activeNoteSubType');
	
	        return ( subType === 'free' || subType === 'text' || subType === 'signature' ||
	            subType === 'graphic_stamp' || subType ==='text_stamp' );
	
	    },
	
	    _createSelectSet: function () {
	
	        var employBorderView = this._employBorderViewOnSelect();
	
	        // TODO: subclass -- breakup creation of select from the dialog buttons )
	
	        if ( ! this.DONT_CREATE_SELECT_HANDLES ) {
	
	            this.handleSet = new SelectHandles({
	                parent: this,
	                _pathIsRect: this.el.pathIsRect(),
	                _hasBorderView: employBorderView,
	                _paper: this.el.paper,
	                _pgRotation: this.shapeModel.pageModel.get('rotation') % 360 //TODO: put on shape obj, and also on page model doing % 360
	            }).render( this.el.paper.set() );
	
	        }
	
	
	        /* this is the border connecting the drag points */
	
	        // If f&r -- would need slightly different shape -- if we didn't employe the handleset, but now that's not an issue
	        if ( employBorderView ) {
	
	            this.borderView = new SelectBoxView({
	                parent: this
	            }).render(this.el);
	        }
	
	        if ( !this.dontCreateButtonSet ) {
	
	            this.btnSet = new BtnSet({
	                parent: this,
	                channel: this.channel
	            });
	
	            // Appears originally used to add new buttons to the set,
	            // though b/c its the last element created, can use like an 'afterSelectSelectCreation',
	            // (for shapes that create the buttonset).
	            // If use case arises where need one but not the other, refactor ...
	            this.triggerMethod('after:buttonSetCreation', true);
	
	            // flip if created on fringe of canvas
	            this.btnSet.move( this.el.getBBox() );
	        }
	
	    },
	
	    _scaleWithPaper: function(scale, lastScale) {
	
	        var args = Array.prototype.slice.call(arguments);
	        this._scaleShapeEl(scale, lastScale);
	
	        // Should listen for this event at the the shape level, then pass down to children ...
	        this.trigger.apply( this, ['shape.onAfterBaseScale', this.el.getBBox()].concat(args) );
	    },
	
	    /* Scales This Shape -- can be over-written in different implementations */
	    _scaleShapeEl: function(scale, lastScale) {
	        this.el.scalePathWithCurves(scale, lastScale);
	    },
	
	    //TODO: use blind destroy's...
	    _destroySelectSet: function () {
	
	        if (this.handleSet) {
	            this.handleSet.destroy();
	            this.handleSet = null;
	        }
	
	        if (this.btnSet) {
	            this.btnSet.destroy();
	            this.btnSet = null;
	        }
	
	        if (this.borderView) {
	            this.borderView.destroy();
	            this.borderView = null;
	        }
	
	
	    },
	    onAfterButtonSetCreation: $.noop,
	
	    noteConsultGroupChange: function( ) {
	
	        this.el.attr(
	            this.shapeModel.getNonPathActiveSVGAttrs( this.channel )
	        );
	
	    },
	
	    /*
	     * This is a quick patch for DVBC-1673.
	     * It will not be very performant, especially if the page is scaled on drag.
	     * Tried other workaround using R.st.scaleWithPaper with this.glow but that is producing a run time error.
	     * Leaving in unoptimized for the time-being, given that the whole drawing part of this app needs to be rewritten.
	     * Note: placed on baseShape, though only listened to for types that indicate
	     * they are expanded by a glow: graphic notes, signatures, graphic stamps, full page redactions.
	     * In the future the 'onAfterBaseScale' should be listened to on here and then passed down to children.
	     * May also want to may the glow it's own 'subShape.'
	     * Update: now also call if change stroke color we glow may exist.
	     */
	    resetGlow: function() {
	
	        if ( this.glow ) {
	            this._deleteGlow();
	            this._createGlow();
	        }
	    },
	
	    _createGlow: function() {
	
	
	        if ( !this.shapeModel.isFindAndRedactShape )  {
	
	            var fill = this.el.attr('fill'),
	                stroke = this.el.attr('stroke'),
	                shapeDefinedGlowColor = this.shapeModel.glowColor,
	                glowColor = shapeDefinedGlowColor
	                    ? shapeDefinedGlowColor
	                    : stroke && stroke !== 'none' ? stroke : fill;
	
	            // Quick fix for redaction shape with white fill in 'apply all redactions mode'.
	            // If going this route, should define the constants in a central file ...
	            // Another option is to make glow color a fn on the redaction shape model and check for the result instead of the property ...
	            // But wait until merge with reason codes module which breaks out the shape models for that.
	            // Note: this would work over a non-white background ... so perhaps a more complex color function is warranted
	            glowColor === '#ffffff'
	                && (glowColor = '#000000');
	
	
	            // Note: bring glow to front
	            // Solves: - full page redactions in apply all redactions mode; on both it's own shape and for others, the glow will be behind the full page,
	            // when you hover over the notes; to see notes underneath, using can hit toggle expanded, where they are brought to the forefront ( so you don't just see
	            // the glow
	
	            this.glow = this.el.glow({
	                color: glowColor
	            }).toFront();
	        }
	
	        else {
	
	            // Testing alternative -- if use can rid reset glow
	
	            this.glow = this.el.glow({
	                color: this.el.attr('fill')//, -- daron didn't like 'orange' -- i'm agreeing; i kinda like fill (then also don't need to resetGlow)
	                //fill: true,
	                //width: 2,
	                //offsetx: 2,
	                //offsety: 2
	            }).toFront();
	
	        }
	
	    },
	
	    _deleteGlow: function() {
	
	        if (!this.glow)
	            return;
	
	        this.glow.remove();
	        this.glow = null;
	
	    },
	
	    /**
	     * Now only done if find and redact -- allows to move/resize and ability to revert to original position.
	     * TODO:
	     * - a temp POC
	     * - now only allowing for coordinate shapes
	     * - perhaps put on the model
	     */
	    persistPosition: function() {
	
	        if ( this.shapeModel.isFindAndRedactShape ) {
	
	            var currentPts =
	                this.shapeModel._getPointsFromEl( this.channel.request('currentScaleValue') );
	
	            this.shapeModel.set( 'points', currentPts );
	
	            this.shapeUI.set('isDirty', true); // ( triggers event )
	
	        }
	
	    },
	
	    /* Proxy through channel for use on multiple views */
	    getColorToApply: function() {
	        return this.channel.request( 'getColorToApplyToShape', this.pgNoteModel, this.shapeModel );
	    },
	
	
	    onBeforeDestroy: function( manualUserDelete ) {
	
	        this._deleteGlow(); // (in case -- eg when called from delete all shapes and converting to floating code on re-render)
	
	
	        this._destroySelectSet();  //removes all child views (ALSO)
	        this.undelegateEvents(); //(uses custom unbind all)
	        this.unbindEntityEvents(this.shapeUI, this.shapeUIEvents); //TODO: want the bind entity events on r view composite ...
	        this.unbindEntityEvents(this,         this.shapeSubs); /* events triggered off self ... legacy ...*/
	
	        this.stopListening(); // ( in case not covered by Raphael Item View ) -- TODO: check
	
	    }
	});
	
	
	_.extend( ShapeView.prototype, ShapeMoveFns );
	
	
	module.exports = ShapeView;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(183), __webpack_require__(185), __webpack_require__(186)], __WEBPACK_AMD_DEFINE_RESULT__ = function(R) {
	
	    return R;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Raphael) {!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(184)], __WEBPACK_AMD_DEFINE_RESULT__ = function(eve) {
	
	    /*\
	     * Raphael
	     [ method ]
	     **
	     * Creates a canvas object on which to draw.
	     * You must do this first, as all future calls to drawing methods
	     * from this instance will be bound to this canvas.
	     > Parameters
	     **
	     - container (HTMLElement|string) DOM element or its ID which is going to be a parent for drawing surface
	     - width (number)
	     - height (number)
	     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
	     * or
	     - x (number)
	     - y (number)
	     - width (number)
	     - height (number)
	     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
	     * or
	     - all (array) (first 3 or 4 elements in the array are equal to [containerID, width, height] or [x, y, width, height]. The rest are element descriptions in format {type: type, <attributes>}). See @Paper.add.
	     - callback (function) #optional callback function which is going to be executed in the context of newly created paper
	     * or
	     - onReadyCallback (function) function that is going to be called on DOM ready event. You can also subscribe to this event via Eve’s “DOMLoad” event. In this case method returns `undefined`.
	     = (object) @Paper
	     > Usage
	     | // Each of the following examples create a canvas
	     | // that is 320px wide by 200px high.
	     | // Canvas is created at the viewport’s 10,50 coordinate.
	     | var paper = Raphael(10, 50, 320, 200);
	     | // Canvas is created at the top left corner of the #notepad element
	     | // (or its top right corner in dir="rtl" elements)
	     | var paper = Raphael(document.getElementById("notepad"), 320, 200);
	     | // Same as above
	     | var paper = Raphael("notepad", 320, 200);
	     | // Image dump
	     | var set = Raphael(["notepad", 320, 200, {
	     |     type: "rect",
	     |     x: 10,
	     |     y: 10,
	     |     width: 25,
	     |     height: 25,
	     |     stroke: "#f00"
	     | }, {
	     |     type: "text",
	     |     x: 30,
	     |     y: 40,
	     |     text: "Dump"
	     | }]);
	    \*/
	    function R(first) {
	        if (R.is(first, "function")) {
	            return loaded ? first() : eve.on("raphael.DOMload", first);
	        } else if (R.is(first, array)) {
	            return R._engine.create[apply](R, first.splice(0, 3 + R.is(first[0], nu))).add(first);
	        } else {
	            var args = Array.prototype.slice.call(arguments, 0);
	            if (R.is(args[args.length - 1], "function")) {
	                var f = args.pop();
	                return loaded ? f.call(R._engine.create[apply](R, args)) : eve.on("raphael.DOMload", function () {
	                    f.call(R._engine.create[apply](R, args));
	                });
	            } else {
	                return R._engine.create[apply](R, arguments);
	            }
	        }
	    }
	    R.version = "2.2.8";
	    R.eve = eve;
	    var loaded,
	        separator = /[, ]+/,
	        elements = {circle: 1, rect: 1, path: 1, ellipse: 1, text: 1, image: 1},
	        formatrg = /\{(\d+)\}/g,
	        proto = "prototype",
	        has = "hasOwnProperty",
	        g = {
	            doc: document,
	            win: window
	        },
	        oldRaphael = {
	            was: Object.prototype[has].call(g.win, "Raphael"),
	            is: g.win.Raphael
	        },
	        Paper = function () {
	            /*\
	             * Paper.ca
	             [ property (object) ]
	             **
	             * Shortcut for @Paper.customAttributes
	            \*/
	            /*\
	             * Paper.customAttributes
	             [ property (object) ]
	             **
	             * If you have a set of attributes that you would like to represent
	             * as a function of some number you can do it easily with custom attributes:
	             > Usage
	             | paper.customAttributes.hue = function (num) {
	             |     num = num % 1;
	             |     return {fill: "hsb(" + num + ", 0.75, 1)"};
	             | };
	             | // Custom attribute “hue” will change fill
	             | // to be given hue with fixed saturation and brightness.
	             | // Now you can use it like this:
	             | var c = paper.circle(10, 10, 10).attr({hue: .45});
	             | // or even like this:
	             | c.animate({hue: 1}, 1e3);
	             |
	             | // You could also create custom attribute
	             | // with multiple parameters:
	             | paper.customAttributes.hsb = function (h, s, b) {
	             |     return {fill: "hsb(" + [h, s, b].join(",") + ")"};
	             | };
	             | c.attr({hsb: "0.5 .8 1"});
	             | c.animate({hsb: [1, 0, 0.5]}, 1e3);
	            \*/
	            this.ca = this.customAttributes = {};
	        },
	        paperproto,
	        appendChild = "appendChild",
	        apply = "apply",
	        concat = "concat",
	        //taken from Modernizr touch test: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js#L40
	        supportsTouch = ('ontouchstart' in window) || window.TouchEvent || window.DocumentTouch && document instanceof DocumentTouch,
	        E = "",
	        S = " ",
	        Str = String,
	        split = "split",
	        events = "click dblclick mousedown mousemove mouseout mouseover mouseup touchstart touchmove touchend touchcancel"[split](S),
	        touchMap = {
	            mousedown: "touchstart",
	            mousemove: "touchmove",
	            mouseup: "touchend"
	        },
	        lowerCase = Str.prototype.toLowerCase,
	        math = Math,
	        mmax = math.max,
	        mmin = math.min,
	        abs = math.abs,
	        pow = math.pow,
	        PI = math.PI,
	        nu = "number",
	        string = "string",
	        array = "array",
	        toString = "toString",
	        fillString = "fill",
	        objectToString = Object.prototype.toString,
	        paper = {},
	        push = "push",
	        ISURL = R._ISURL = /^url\(['"]?(.+?)['"]?\)$/i,
	        colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i,
	        isnan = {"NaN": 1, "Infinity": 1, "-Infinity": 1},
	        bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
	        round = math.round,
	        setAttribute = "setAttribute",
	        toFloat = parseFloat,
	        toInt = parseInt,
	        upperCase = Str.prototype.toUpperCase,
	        availableAttrs = R._availableAttrs = {
	            "arrow-end": "none",
	            "arrow-start": "none",
	            blur: 0,
	            "clip-rect": "0 0 1e9 1e9",
	            cursor: "default",
	            cx: 0,
	            cy: 0,
	            fill: "#fff",
	            "fill-opacity": 1,
	            font: '10px "Arial"',
	            "font-family": '"Arial"',
	            "font-size": "10",
	            "font-style": "normal",
	            "font-weight": 400,
	            gradient: 0,
	            height: 0,
	            href: "http://raphaeljs.com/",
	            "letter-spacing": 0,
	            opacity: 1,
	            path: "M0,0",
	            r: 0,
	            rx: 0,
	            ry: 0,
	            src: "",
	            stroke: "#000",
	            "stroke-dasharray": "",
	            "stroke-linecap": "butt",
	            "stroke-linejoin": "butt",
	            "stroke-miterlimit": 0,
	            "stroke-opacity": 1,
	            "stroke-width": 1,
	            target: "_blank",
	            "text-anchor": "middle",
	            title: "Raphael",
	            transform: "",
	            width: 0,
	            x: 0,
	            y: 0,
	            "class": ""
	        },
	        availableAnimAttrs = R._availableAnimAttrs = {
	            blur: nu,
	            "clip-rect": "csv",
	            cx: nu,
	            cy: nu,
	            fill: "colour",
	            "fill-opacity": nu,
	            "font-size": nu,
	            height: nu,
	            opacity: nu,
	            path: "path",
	            r: nu,
	            rx: nu,
	            ry: nu,
	            stroke: "colour",
	            "stroke-opacity": nu,
	            "stroke-width": nu,
	            transform: "transform",
	            width: nu,
	            x: nu,
	            y: nu
	        },
	        whitespace = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]/g,
	        commaSpaces = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/,
	        hsrg = {hs: 1, rg: 1},
	        p2s = /,?([achlmqrstvxz]),?/gi,
	        pathCommand = /([achlmrqstvz])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
	        tCommand = /([rstm])[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*)+)/ig,
	        pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,?[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/ig,
	        radial_gradient = R._radial_gradient = /^r(?:\(([^,]+?)[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*([^\)]+?)\))?/,
	        eldata = {},
	        sortByKey = function (a, b) {
	            return a.key - b.key;
	        },
	        sortByNumber = function (a, b) {
	            return toFloat(a) - toFloat(b);
	        },
	        fun = function () {},
	        pipe = function (x) {
	            return x;
	        },
	        rectPath = R._rectPath = function (x, y, w, h, r) {
	            if (r) {
	                return [["M", x + r, y], ["l", w - r * 2, 0], ["a", r, r, 0, 0, 1, r, r], ["l", 0, h - r * 2], ["a", r, r, 0, 0, 1, -r, r], ["l", r * 2 - w, 0], ["a", r, r, 0, 0, 1, -r, -r], ["l", 0, r * 2 - h], ["a", r, r, 0, 0, 1, r, -r], ["z"]];
	            }
	            return [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
	        },
	        ellipsePath = function (x, y, rx, ry) {
	            if (ry == null) {
	                ry = rx;
	            }
	            return [["M", x, y], ["m", 0, -ry], ["a", rx, ry, 0, 1, 1, 0, 2 * ry], ["a", rx, ry, 0, 1, 1, 0, -2 * ry], ["z"]];
	        },
	        getPath = R._getPath = {
	            path: function (el) {
	                return el.attr("path");
	            },
	            circle: function (el) {
	                var a = el.attrs;
	                return ellipsePath(a.cx, a.cy, a.r);
	            },
	            ellipse: function (el) {
	                var a = el.attrs;
	                return ellipsePath(a.cx, a.cy, a.rx, a.ry);
	            },
	            rect: function (el) {
	                var a = el.attrs;
	                return rectPath(a.x, a.y, a.width, a.height, a.r);
	            },
	            image: function (el) {
	                var a = el.attrs;
	                return rectPath(a.x, a.y, a.width, a.height);
	            },
	            text: function (el) {
	                var bbox = el._getBBox();
	                return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	            },
	            set : function(el) {
	                var bbox = el._getBBox();
	                return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
	            }
	        },
	        /*\
	         * Raphael.mapPath
	         [ method ]
	         **
	         * Transform the path string with given matrix.
	         > Parameters
	         - path (string) path string
	         - matrix (object) see @Matrix
	         = (string) transformed path string
	        \*/
	        mapPath = R.mapPath = function (path, matrix) {
	            if (!matrix) {
	                return path;
	            }
	            var x, y, i, j, ii, jj, pathi;
	            path = path2curve(path);
	            for (i = 0, ii = path.length; i < ii; i++) {
	                pathi = path[i];
	                for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                    x = matrix.x(pathi[j], pathi[j + 1]);
	                    y = matrix.y(pathi[j], pathi[j + 1]);
	                    pathi[j] = x;
	                    pathi[j + 1] = y;
	                }
	            }
	            return path;
	        };
	
	    R._g = g;
	    /*\
	     * Raphael.type
	     [ property (string) ]
	     **
	     * Can be “SVG”, “VML” or empty, depending on browser support.
	    \*/
	    R.type = (g.win.SVGAngle || g.doc.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") ? "SVG" : "VML");
	    if (R.type == "VML") {
	        var d = g.doc.createElement("div"),
	            b;
	        d.innerHTML = '<v:shape adj="1"/>';
	        b = d.firstChild;
	        b.style.behavior = "url(#default#VML)";
	        if (!(b && typeof b.adj == "object")) {
	            return (R.type = E);
	        }
	        d = null;
	    }
	    /*\
	     * Raphael.svg
	     [ property (boolean) ]
	     **
	     * `true` if browser supports SVG.
	    \*/
	    /*\
	     * Raphael.vml
	     [ property (boolean) ]
	     **
	     * `true` if browser supports VML.
	    \*/
	    R.svg = !(R.vml = R.type == "VML");
	    R._Paper = Paper;
	    /*\
	     * Raphael.fn
	     [ property (object) ]
	     **
	     * You can add your own method to the canvas. For example if you want to draw a pie chart,
	     * you can create your own pie chart function and ship it as a Raphaël plugin. To do this
	     * you need to extend the `Raphael.fn` object. You should modify the `fn` object before a
	     * Raphaël instance is created, otherwise it will take no effect. Please note that the
	     * ability for namespaced plugins was removed in Raphael 2.0. It is up to the plugin to
	     * ensure any namespacing ensures proper context.
	     > Usage
	     | Raphael.fn.arrow = function (x1, y1, x2, y2, size) {
	     |     return this.path( ... );
	     | };
	     | // or create namespace
	     | Raphael.fn.mystuff = {
	     |     arrow: function () {…},
	     |     star: function () {…},
	     |     // etc…
	     | };
	     | var paper = Raphael(10, 10, 630, 480);
	     | // then use it
	     | paper.arrow(10, 10, 30, 30, 5).attr({fill: "#f00"});
	     | paper.mystuff.arrow();
	     | paper.mystuff.star();
	    \*/
	    R.fn = paperproto = Paper.prototype = R.prototype;
	    R._id = 0;
	    /*\
	     * Raphael.is
	     [ method ]
	     **
	     * Handful of replacements for `typeof` operator.
	     > Parameters
	     - o (…) any object or primitive
	     - type (string) name of the type, i.e. “string”, “function”, “number”, etc.
	     = (boolean) is given value is of given type
	    \*/
	    R.is = function (o, type) {
	        type = lowerCase.call(type);
	        if (type == "finite") {
	            return !isnan[has](+o);
	        }
	        if (type == "array") {
	            return o instanceof Array;
	        }
	        return  (type == "null" && o === null) ||
	                (type == typeof o && o !== null) ||
	                (type == "object" && o === Object(o)) ||
	                (type == "array" && Array.isArray && Array.isArray(o)) ||
	                objectToString.call(o).slice(8, -1).toLowerCase() == type;
	    };
	
	    function clone(obj) {
	        if (typeof obj == "function" || Object(obj) !== obj) {
	            return obj;
	        }
	        var res = new obj.constructor;
	        for (var key in obj) if (obj[has](key)) {
	            res[key] = clone(obj[key]);
	        }
	        return res;
	    }
	
	    /*\
	     * Raphael.angle
	     [ method ]
	     **
	     * Returns angle between two or three points
	     > Parameters
	     - x1 (number) x coord of first point
	     - y1 (number) y coord of first point
	     - x2 (number) x coord of second point
	     - y2 (number) y coord of second point
	     - x3 (number) #optional x coord of third point
	     - y3 (number) #optional y coord of third point
	     = (number) angle in degrees.
	    \*/
	    R.angle = function (x1, y1, x2, y2, x3, y3) {
	        if (x3 == null) {
	            var x = x1 - x2,
	                y = y1 - y2;
	            if (!x && !y) {
	                return 0;
	            }
	            return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
	        } else {
	            return R.angle(x1, y1, x3, y3) - R.angle(x2, y2, x3, y3);
	        }
	    };
	    /*\
	     * Raphael.rad
	     [ method ]
	     **
	     * Transform angle to radians
	     > Parameters
	     - deg (number) angle in degrees
	     = (number) angle in radians.
	    \*/
	    R.rad = function (deg) {
	        return deg % 360 * PI / 180;
	    };
	    /*\
	     * Raphael.deg
	     [ method ]
	     **
	     * Transform angle to degrees
	     > Parameters
	     - rad (number) angle in radians
	     = (number) angle in degrees.
	    \*/
	    R.deg = function (rad) {
	        return Math.round ((rad * 180 / PI% 360)* 1000) / 1000;
	    };
	    /*\
	     * Raphael.snapTo
	     [ method ]
	     **
	     * Snaps given value to given grid.
	     > Parameters
	     - values (array|number) given array of values or step of the grid
	     - value (number) value to adjust
	     - tolerance (number) #optional tolerance for snapping. Default is `10`.
	     = (number) adjusted value.
	    \*/
	    R.snapTo = function (values, value, tolerance) {
	        tolerance = R.is(tolerance, "finite") ? tolerance : 10;
	        if (R.is(values, array)) {
	            var i = values.length;
	            while (i--) if (abs(values[i] - value) <= tolerance) {
	                return values[i];
	            }
	        } else {
	            values = +values;
	            var rem = value % values;
	            if (rem < tolerance) {
	                return value - rem;
	            }
	            if (rem > values - tolerance) {
	                return value - rem + values;
	            }
	        }
	        return value;
	    };
	
	    /*\
	     * Raphael.createUUID
	     [ method ]
	     **
	     * Returns RFC4122, version 4 ID
	    \*/
	    var createUUID = R.createUUID = (function (uuidRegEx, uuidReplacer) {
	        return function () {
	            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(uuidRegEx, uuidReplacer).toUpperCase();
	        };
	    })(/[xy]/g, function (c) {
	        var r = math.random() * 16 | 0,
	            v = c == "x" ? r : (r & 3 | 8);
	        return v.toString(16);
	    });
	
	    /*\
	     * Raphael.setWindow
	     [ method ]
	     **
	     * Used when you need to draw in `&lt;iframe>`. Switched window to the iframe one.
	     > Parameters
	     - newwin (window) new window object
	    \*/
	    R.setWindow = function (newwin) {
	        eve("raphael.setWindow", R, g.win, newwin);
	        g.win = newwin;
	        g.doc = g.win.document;
	        if (R._engine.initWin) {
	            R._engine.initWin(g.win);
	        }
	    };
	    var toHex = function (color) {
	        if (R.vml) {
	            // http://dean.edwards.name/weblog/2009/10/convert-any-colour-value-to-hex-in-msie/
	            var trim = /^\s+|\s+$/g;
	            var bod;
	            try {
	                var docum = new ActiveXObject("htmlfile");
	                docum.write("<body>");
	                docum.close();
	                bod = docum.body;
	            } catch(e) {
	                bod = createPopup().document.body;
	            }
	            var range = bod.createTextRange();
	            toHex = cacher(function (color) {
	                try {
	                    bod.style.color = Str(color).replace(trim, E);
	                    var value = range.queryCommandValue("ForeColor");
	                    value = ((value & 255) << 16) | (value & 65280) | ((value & 16711680) >>> 16);
	                    return "#" + ("000000" + value.toString(16)).slice(-6);
	                } catch(e) {
	                    return "none";
	                }
	            });
	        } else {
	            var i = g.doc.createElement("i");
	            i.title = "Rapha\xebl Colour Picker";
	            i.style.display = "none";
	            g.doc.body.appendChild(i);
	            toHex = cacher(function (color) {
	                i.style.color = color;
	                return g.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
	            });
	        }
	        return toHex(color);
	    },
	    hsbtoString = function () {
	        return "hsb(" + [this.h, this.s, this.b] + ")";
	    },
	    hsltoString = function () {
	        return "hsl(" + [this.h, this.s, this.l] + ")";
	    },
	    rgbtoString = function () {
	        return this.hex;
	    },
	    prepareRGB = function (r, g, b) {
	        if (g == null && R.is(r, "object") && "r" in r && "g" in r && "b" in r) {
	            b = r.b;
	            g = r.g;
	            r = r.r;
	        }
	        if (g == null && R.is(r, string)) {
	            var clr = R.getRGB(r);
	            r = clr.r;
	            g = clr.g;
	            b = clr.b;
	        }
	        if (r > 1 || g > 1 || b > 1) {
	            r /= 255;
	            g /= 255;
	            b /= 255;
	        }
	
	        return [r, g, b];
	    },
	    packageRGB = function (r, g, b, o) {
	        r *= 255;
	        g *= 255;
	        b *= 255;
	        var rgb = {
	            r: r,
	            g: g,
	            b: b,
	            hex: R.rgb(r, g, b),
	            toString: rgbtoString
	        };
	        R.is(o, "finite") && (rgb.opacity = o);
	        return rgb;
	    };
	
	    /*\
	     * Raphael.color
	     [ method ]
	     **
	     * Parses the color string and returns object with all values for the given color.
	     > Parameters
	     - clr (string) color string in one of the supported formats (see @Raphael.getRGB)
	     = (object) Combined RGB & HSB object in format:
	     o {
	     o     r (number) red,
	     o     g (number) green,
	     o     b (number) blue,
	     o     hex (string) color in HTML/CSS format: #••••••,
	     o     error (boolean) `true` if string can’t be parsed,
	     o     h (number) hue,
	     o     s (number) saturation,
	     o     v (number) value (brightness),
	     o     l (number) lightness
	     o }
	    \*/
	    R.color = function (clr) {
	        var rgb;
	        if (R.is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
	            rgb = R.hsb2rgb(clr);
	            clr.r = rgb.r;
	            clr.g = rgb.g;
	            clr.b = rgb.b;
	            clr.hex = rgb.hex;
	        } else if (R.is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
	            rgb = R.hsl2rgb(clr);
	            clr.r = rgb.r;
	            clr.g = rgb.g;
	            clr.b = rgb.b;
	            clr.hex = rgb.hex;
	        } else {
	            if (R.is(clr, "string")) {
	                clr = R.getRGB(clr);
	            }
	            if (R.is(clr, "object") && "r" in clr && "g" in clr && "b" in clr) {
	                rgb = R.rgb2hsl(clr);
	                clr.h = rgb.h;
	                clr.s = rgb.s;
	                clr.l = rgb.l;
	                rgb = R.rgb2hsb(clr);
	                clr.v = rgb.b;
	            } else {
	                clr = {hex: "none"};
	                clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
	            }
	        }
	        clr.toString = rgbtoString;
	        return clr;
	    };
	    /*\
	     * Raphael.hsb2rgb
	     [ method ]
	     **
	     * Converts HSB values to RGB object.
	     > Parameters
	     - h (number) hue
	     - s (number) saturation
	     - v (number) value or brightness
	     = (object) RGB object in format:
	     o {
	     o     r (number) red,
	     o     g (number) green,
	     o     b (number) blue,
	     o     hex (string) color in HTML/CSS format: #••••••
	     o }
	    \*/
	    R.hsb2rgb = function (h, s, v, o) {
	        if (this.is(h, "object") && "h" in h && "s" in h && "b" in h) {
	            v = h.b;
	            s = h.s;
	            o = h.o;
	            h = h.h;
	        }
	        h *= 360;
	        var R, G, B, X, C;
	        h = (h % 360) / 60;
	        C = v * s;
	        X = C * (1 - abs(h % 2 - 1));
	        R = G = B = v - C;
	
	        h = ~~h;
	        R += [C, X, 0, 0, X, C][h];
	        G += [X, C, C, X, 0, 0][h];
	        B += [0, 0, X, C, C, X][h];
	        return packageRGB(R, G, B, o);
	    };
	    /*\
	     * Raphael.hsl2rgb
	     [ method ]
	     **
	     * Converts HSL values to RGB object.
	     > Parameters
	     - h (number) hue
	     - s (number) saturation
	     - l (number) luminosity
	     = (object) RGB object in format:
	     o {
	     o     r (number) red,
	     o     g (number) green,
	     o     b (number) blue,
	     o     hex (string) color in HTML/CSS format: #••••••
	     o }
	    \*/
	    R.hsl2rgb = function (h, s, l, o) {
	        if (this.is(h, "object") && "h" in h && "s" in h && "l" in h) {
	            l = h.l;
	            s = h.s;
	            h = h.h;
	        }
	        if (h > 1 || s > 1 || l > 1) {
	            h /= 360;
	            s /= 100;
	            l /= 100;
	        }
	        h *= 360;
	        var R, G, B, X, C;
	        h = (h % 360) / 60;
	        C = 2 * s * (l < .5 ? l : 1 - l);
	        X = C * (1 - abs(h % 2 - 1));
	        R = G = B = l - C / 2;
	
	        h = ~~h;
	        R += [C, X, 0, 0, X, C][h];
	        G += [X, C, C, X, 0, 0][h];
	        B += [0, 0, X, C, C, X][h];
	        return packageRGB(R, G, B, o);
	    };
	    /*\
	     * Raphael.rgb2hsb
	     [ method ]
	     **
	     * Converts RGB values to HSB object.
	     > Parameters
	     - r (number) red
	     - g (number) green
	     - b (number) blue
	     = (object) HSB object in format:
	     o {
	     o     h (number) hue
	     o     s (number) saturation
	     o     b (number) brightness
	     o }
	    \*/
	    R.rgb2hsb = function (r, g, b) {
	        b = prepareRGB(r, g, b);
	        r = b[0];
	        g = b[1];
	        b = b[2];
	
	        var H, S, V, C;
	        V = mmax(r, g, b);
	        C = V - mmin(r, g, b);
	        H = (C == 0 ? null :
	             V == r ? (g - b) / C :
	             V == g ? (b - r) / C + 2 :
	                      (r - g) / C + 4
	            );
	        H = ((H + 360) % 6) * 60 / 360;
	        S = C == 0 ? 0 : C / V;
	        return {h: H, s: S, b: V, toString: hsbtoString};
	    };
	    /*\
	     * Raphael.rgb2hsl
	     [ method ]
	     **
	     * Converts RGB values to HSL object.
	     > Parameters
	     - r (number) red
	     - g (number) green
	     - b (number) blue
	     = (object) HSL object in format:
	     o {
	     o     h (number) hue
	     o     s (number) saturation
	     o     l (number) luminosity
	     o }
	    \*/
	    R.rgb2hsl = function (r, g, b) {
	        b = prepareRGB(r, g, b);
	        r = b[0];
	        g = b[1];
	        b = b[2];
	
	        var H, S, L, M, m, C;
	        M = mmax(r, g, b);
	        m = mmin(r, g, b);
	        C = M - m;
	        H = (C == 0 ? null :
	             M == r ? (g - b) / C :
	             M == g ? (b - r) / C + 2 :
	                      (r - g) / C + 4);
	        H = ((H + 360) % 6) * 60 / 360;
	        L = (M + m) / 2;
	        S = (C == 0 ? 0 :
	             L < .5 ? C / (2 * L) :
	                      C / (2 - 2 * L));
	        return {h: H, s: S, l: L, toString: hsltoString};
	    };
	    R._path2string = function () {
	        return this.join(",").replace(p2s, "$1");
	    };
	    function repush(array, item) {
	        for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
	            return array.push(array.splice(i, 1)[0]);
	        }
	    }
	    function cacher(f, scope, postprocessor) {
	        function newf() {
	            var arg = Array.prototype.slice.call(arguments, 0),
	                args = arg.join("\u2400"),
	                cache = newf.cache = newf.cache || {},
	                count = newf.count = newf.count || [];
	            if (cache[has](args)) {
	                repush(count, args);
	                return postprocessor ? postprocessor(cache[args]) : cache[args];
	            }
	            count.length >= 1e3 && delete cache[count.shift()];
	            count.push(args);
	            cache[args] = f[apply](scope, arg);
	            return postprocessor ? postprocessor(cache[args]) : cache[args];
	        }
	        return newf;
	    }
	
	    var preload = R._preload = function (src, f) {
	        var img = g.doc.createElement("img");
	        img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
	        img.onload = function () {
	            f.call(this);
	            this.onload = null;
	            g.doc.body.removeChild(this);
	        };
	        img.onerror = function () {
	            g.doc.body.removeChild(this);
	        };
	        g.doc.body.appendChild(img);
	        img.src = src;
	    };
	
	    function clrToString() {
	        return this.hex;
	    }
	
	    /*\
	     * Raphael.getRGB
	     [ method ]
	     **
	     * Parses colour string as RGB object
	     > Parameters
	     - colour (string) colour string in one of formats:
	     # <ul>
	     #     <li>Colour name (“<code>red</code>”, “<code>green</code>”, “<code>cornflowerblue</code>”, etc)</li>
	     #     <li>#••• — shortened HTML colour: (“<code>#000</code>”, “<code>#fc0</code>”, etc)</li>
	     #     <li>#•••••• — full length HTML colour: (“<code>#000000</code>”, “<code>#bd2300</code>”)</li>
	     #     <li>rgb(•••, •••, •••) — red, green and blue channels’ values: (“<code>rgb(200,&nbsp;100,&nbsp;0)</code>”)</li>
	     #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (“<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>”)</li>
	     #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (“<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>”)</li>
	     #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	     #     <li>hsl(•••, •••, •••) — same as hsb</li>
	     #     <li>hsl(•••%, •••%, •••%) — same as hsb</li>
	     # </ul>
	     = (object) RGB object in format:
	     o {
	     o     r (number) red,
	     o     g (number) green,
	     o     b (number) blue
	     o     hex (string) color in HTML/CSS format: #••••••,
	     o     error (boolean) true if string can’t be parsed
	     o }
	    \*/
	    R.getRGB = cacher(function (colour) {
	        if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
	            return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: clrToString};
	        }
	        if (colour == "none") {
	            return {r: -1, g: -1, b: -1, hex: "none", toString: clrToString};
	        }
	        !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
	        var res,
	            red,
	            green,
	            blue,
	            opacity,
	            t,
	            values,
	            rgb = colour.match(colourRegExp);
	        if (rgb) {
	            if (rgb[2]) {
	                blue = toInt(rgb[2].substring(5), 16);
	                green = toInt(rgb[2].substring(3, 5), 16);
	                red = toInt(rgb[2].substring(1, 3), 16);
	            }
	            if (rgb[3]) {
	                blue = toInt((t = rgb[3].charAt(3)) + t, 16);
	                green = toInt((t = rgb[3].charAt(2)) + t, 16);
	                red = toInt((t = rgb[3].charAt(1)) + t, 16);
	            }
	            if (rgb[4]) {
	                values = rgb[4][split](commaSpaces);
	                red = toFloat(values[0]);
	                values[0].slice(-1) == "%" && (red *= 2.55);
	                green = toFloat(values[1]);
	                values[1].slice(-1) == "%" && (green *= 2.55);
	                blue = toFloat(values[2]);
	                values[2].slice(-1) == "%" && (blue *= 2.55);
	                rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
	                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	            }
	            if (rgb[5]) {
	                values = rgb[5][split](commaSpaces);
	                red = toFloat(values[0]);
	                values[0].slice(-1) == "%" && (red *= 2.55);
	                green = toFloat(values[1]);
	                values[1].slice(-1) == "%" && (green *= 2.55);
	                blue = toFloat(values[2]);
	                values[2].slice(-1) == "%" && (blue *= 2.55);
	                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	                rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
	                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	                return R.hsb2rgb(red, green, blue, opacity);
	            }
	            if (rgb[6]) {
	                values = rgb[6][split](commaSpaces);
	                red = toFloat(values[0]);
	                values[0].slice(-1) == "%" && (red *= 2.55);
	                green = toFloat(values[1]);
	                values[1].slice(-1) == "%" && (green *= 2.55);
	                blue = toFloat(values[2]);
	                values[2].slice(-1) == "%" && (blue *= 2.55);
	                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
	                rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
	                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
	                return R.hsl2rgb(red, green, blue, opacity);
	            }
	            rgb = {r: red, g: green, b: blue, toString: clrToString};
	            rgb.hex = "#" + (16777216 | blue | (green << 8) | (red << 16)).toString(16).slice(1);
	            R.is(opacity, "finite") && (rgb.opacity = opacity);
	            return rgb;
	        }
	        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: clrToString};
	    }, R);
	    /*\
	     * Raphael.hsb
	     [ method ]
	     **
	     * Converts HSB values to hex representation of the colour.
	     > Parameters
	     - h (number) hue
	     - s (number) saturation
	     - b (number) value or brightness
	     = (string) hex representation of the colour.
	    \*/
	    R.hsb = cacher(function (h, s, b) {
	        return R.hsb2rgb(h, s, b).hex;
	    });
	    /*\
	     * Raphael.hsl
	     [ method ]
	     **
	     * Converts HSL values to hex representation of the colour.
	     > Parameters
	     - h (number) hue
	     - s (number) saturation
	     - l (number) luminosity
	     = (string) hex representation of the colour.
	    \*/
	    R.hsl = cacher(function (h, s, l) {
	        return R.hsl2rgb(h, s, l).hex;
	    });
	    /*\
	     * Raphael.rgb
	     [ method ]
	     **
	     * Converts RGB values to hex representation of the colour.
	     > Parameters
	     - r (number) red
	     - g (number) green
	     - b (number) blue
	     = (string) hex representation of the colour.
	    \*/
	    R.rgb = cacher(function (r, g, b) {
	        function round(x) { return (x + 0.5) | 0; }
	        return "#" + (16777216 | round(b) | (round(g) << 8) | (round(r) << 16)).toString(16).slice(1);
	    });
	    /*\
	     * Raphael.getColor
	     [ method ]
	     **
	     * On each call returns next colour in the spectrum. To reset it back to red call @Raphael.getColor.reset
	     > Parameters
	     - value (number) #optional brightness, default is `0.75`
	     = (string) hex representation of the colour.
	    \*/
	    R.getColor = function (value) {
	        var start = this.getColor.start = this.getColor.start || {h: 0, s: 1, b: value || .75},
	            rgb = this.hsb2rgb(start.h, start.s, start.b);
	        start.h += .075;
	        if (start.h > 1) {
	            start.h = 0;
	            start.s -= .2;
	            start.s <= 0 && (this.getColor.start = {h: 0, s: 1, b: start.b});
	        }
	        return rgb.hex;
	    };
	    /*\
	     * Raphael.getColor.reset
	     [ method ]
	     **
	     * Resets spectrum position for @Raphael.getColor back to red.
	    \*/
	    R.getColor.reset = function () {
	        delete this.start;
	    };
	
	    // http://schepers.cc/getting-to-the-point
	    function catmullRom2bezier(crp, z) {
	        var d = [];
	        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
	            var p = [
	                        {x: +crp[i - 2], y: +crp[i - 1]},
	                        {x: +crp[i],     y: +crp[i + 1]},
	                        {x: +crp[i + 2], y: +crp[i + 3]},
	                        {x: +crp[i + 4], y: +crp[i + 5]}
	                    ];
	            if (z) {
	                if (!i) {
	                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
	                } else if (iLen - 4 == i) {
	                    p[3] = {x: +crp[0], y: +crp[1]};
	                } else if (iLen - 2 == i) {
	                    p[2] = {x: +crp[0], y: +crp[1]};
	                    p[3] = {x: +crp[2], y: +crp[3]};
	                }
	            } else {
	                if (iLen - 4 == i) {
	                    p[3] = p[2];
	                } else if (!i) {
	                    p[0] = {x: +crp[i], y: +crp[i + 1]};
	                }
	            }
	            d.push(["C",
	                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
	                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
	                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
	                  (p[1].y + 6*p[2].y - p[3].y) / 6,
	                  p[2].x,
	                  p[2].y
	            ]);
	        }
	
	        return d;
	    }
	    /*\
	     * Raphael.parsePathString
	     [ method ]
	     **
	     * Utility method
	     **
	     * Parses given path string into an array of arrays of path segments.
	     > Parameters
	     - pathString (string|array) path string or array of segments (in the last case it will be returned straight away)
	     = (array) array of segments.
	    \*/
	    R.parsePathString = function (pathString) {
	        if (!pathString) {
	            return null;
	        }
	        var pth = paths(pathString);
	        if (pth.arr) {
	            return pathClone(pth.arr);
	        }
	
	        var paramCounts = {a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0},
	            data = [];
	        if (R.is(pathString, array) && R.is(pathString[0], array)) { // rough assumption
	            data = pathClone(pathString);
	        }
	        if (!data.length) {
	            Str(pathString).replace(pathCommand, function (a, b, c) {
	                var params = [],
	                    name = b.toLowerCase();
	                c.replace(pathValues, function (a, b) {
	                    b && params.push(+b);
	                });
	                if (name == "m" && params.length > 2) {
	                    data.push([b][concat](params.splice(0, 2)));
	                    name = "l";
	                    b = b == "m" ? "l" : "L";
	                }
	                if (name == "r") {
	                    data.push([b][concat](params));
	                } else while (params.length >= paramCounts[name]) {
	                    data.push([b][concat](params.splice(0, paramCounts[name])));
	                    if (!paramCounts[name]) {
	                        break;
	                    }
	                }
	            });
	        }
	        data.toString = R._path2string;
	        pth.arr = pathClone(data);
	        return data;
	    };
	    /*\
	     * Raphael.parseTransformString
	     [ method ]
	     **
	     * Utility method
	     **
	     * Parses given path string into an array of transformations.
	     > Parameters
	     - TString (string|array) transform string or array of transformations (in the last case it will be returned straight away)
	     = (array) array of transformations.
	    \*/
	    R.parseTransformString = cacher(function (TString) {
	        if (!TString) {
	            return null;
	        }
	        var paramCounts = {r: 3, s: 4, t: 2, m: 6},
	            data = [];
	        if (R.is(TString, array) && R.is(TString[0], array)) { // rough assumption
	            data = pathClone(TString);
	        }
	        if (!data.length) {
	            Str(TString).replace(tCommand, function (a, b, c) {
	                var params = [],
	                    name = lowerCase.call(b);
	                c.replace(pathValues, function (a, b) {
	                    b && params.push(+b);
	                });
	                data.push([b][concat](params));
	            });
	        }
	        data.toString = R._path2string;
	        return data;
	    }, this, function(elem) {
	        if (!elem) return elem;
	        var newData = [];
	        for (var i = 0; i < elem.length; i++) {
	            var newLevel = [];
	            for (var j = 0; j < elem[i].length; j++) {
	                newLevel.push(elem[i][j]);
	            }
	            newData.push(newLevel);
	        }
	      return newData; } );
	    // PATHS
	    var paths = function (ps) {
	        var p = paths.ps = paths.ps || {};
	        if (p[ps]) {
	            p[ps].sleep = 100;
	        } else {
	            p[ps] = {
	                sleep: 100
	            };
	        }
	        setTimeout(function () {
	            for (var key in p) if (p[has](key) && key != ps) {
	                p[key].sleep--;
	                !p[key].sleep && delete p[key];
	            }
	        });
	        return p[ps];
	    };
	    /*\
	     * Raphael.findDotsAtSegment
	     [ method ]
	     **
	     * Utility method
	     **
	     * Find dot coordinates on the given cubic bezier curve at the given t.
	     > Parameters
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     - t (number) position on the curve (0..1)
	     = (object) point information in format:
	     o {
	     o     x: (number) x coordinate of the point
	     o     y: (number) y coordinate of the point
	     o     m: {
	     o         x: (number) x coordinate of the left anchor
	     o         y: (number) y coordinate of the left anchor
	     o     }
	     o     n: {
	     o         x: (number) x coordinate of the right anchor
	     o         y: (number) y coordinate of the right anchor
	     o     }
	     o     start: {
	     o         x: (number) x coordinate of the start of the curve
	     o         y: (number) y coordinate of the start of the curve
	     o     }
	     o     end: {
	     o         x: (number) x coordinate of the end of the curve
	     o         y: (number) y coordinate of the end of the curve
	     o     }
	     o     alpha: (number) angle of the curve derivative at the point
	     o }
	    \*/
	    R.findDotsAtSegment = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	        var t1 = 1 - t,
	            t13 = pow(t1, 3),
	            t12 = pow(t1, 2),
	            t2 = t * t,
	            t3 = t2 * t,
	            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
	            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
	            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
	            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
	            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
	            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
	            ax = t1 * p1x + t * c1x,
	            ay = t1 * p1y + t * c1y,
	            cx = t1 * c2x + t * p2x,
	            cy = t1 * c2y + t * p2y,
	            alpha = (90 - math.atan2(mx - nx, my - ny) * 180 / PI);
	        (mx > nx || my < ny) && (alpha += 180);
	        return {
	            x: x,
	            y: y,
	            m: {x: mx, y: my},
	            n: {x: nx, y: ny},
	            start: {x: ax, y: ay},
	            end: {x: cx, y: cy},
	            alpha: alpha
	        };
	    };
	    /*\
	     * Raphael.bezierBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Return bounding box of a given cubic bezier curve
	     > Parameters
	     - p1x (number) x of the first point of the curve
	     - p1y (number) y of the first point of the curve
	     - c1x (number) x of the first anchor of the curve
	     - c1y (number) y of the first anchor of the curve
	     - c2x (number) x of the second anchor of the curve
	     - c2y (number) y of the second anchor of the curve
	     - p2x (number) x of the second point of the curve
	     - p2y (number) y of the second point of the curve
	     * or
	     - bez (array) array of six points for bezier curve
	     = (object) point information in format:
	     o {
	     o     min: {
	     o         x: (number) x coordinate of the left point
	     o         y: (number) y coordinate of the top point
	     o     }
	     o     max: {
	     o         x: (number) x coordinate of the right point
	     o         y: (number) y coordinate of the bottom point
	     o     }
	     o }
	    \*/
	    R.bezierBBox = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	        if (!R.is(p1x, "array")) {
	            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
	        }
	        var bbox = curveDim.apply(null, p1x);
	        return {
	            x: bbox.min.x,
	            y: bbox.min.y,
	            x2: bbox.max.x,
	            y2: bbox.max.y,
	            width: bbox.max.x - bbox.min.x,
	            height: bbox.max.y - bbox.min.y
	        };
	    };
	    /*\
	     * Raphael.isPointInsideBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside bounding boxes.
	     > Parameters
	     - bbox (string) bounding box
	     - x (string) x coordinate of the point
	     - y (string) y coordinate of the point
	     = (boolean) `true` if point inside
	    \*/
	    R.isPointInsideBBox = function (bbox, x, y) {
	        return x >= bbox.x && x <= bbox.x2 && y >= bbox.y && y <= bbox.y2;
	    };
	    /*\
	     * Raphael.isBBoxIntersect
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if two bounding boxes intersect
	     > Parameters
	     - bbox1 (string) first bounding box
	     - bbox2 (string) second bounding box
	     = (boolean) `true` if they intersect
	    \*/
	    R.isBBoxIntersect = function (bbox1, bbox2) {
	        var i = R.isPointInsideBBox;
	        return i(bbox2, bbox1.x, bbox1.y)
	            || i(bbox2, bbox1.x2, bbox1.y)
	            || i(bbox2, bbox1.x, bbox1.y2)
	            || i(bbox2, bbox1.x2, bbox1.y2)
	            || i(bbox1, bbox2.x, bbox2.y)
	            || i(bbox1, bbox2.x2, bbox2.y)
	            || i(bbox1, bbox2.x, bbox2.y2)
	            || i(bbox1, bbox2.x2, bbox2.y2)
	            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
	            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
	    };
	    function base3(t, p1, p2, p3, p4) {
	        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
	            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
	        return t * t2 - 3 * p1 + 3 * p2;
	    }
	    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
	        if (z == null) {
	            z = 1;
	        }
	        z = z > 1 ? 1 : z < 0 ? 0 : z;
	        var z2 = z / 2,
	            n = 12,
	            Tvalues = [-0.1252,0.1252,-0.3678,0.3678,-0.5873,0.5873,-0.7699,0.7699,-0.9041,0.9041,-0.9816,0.9816],
	            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
	            sum = 0;
	        for (var i = 0; i < n; i++) {
	            var ct = z2 * Tvalues[i] + z2,
	                xbase = base3(ct, x1, x2, x3, x4),
	                ybase = base3(ct, y1, y2, y3, y4),
	                comb = xbase * xbase + ybase * ybase;
	            sum += Cvalues[i] * math.sqrt(comb);
	        }
	        return z2 * sum;
	    }
	    function getTatLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
	        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
	            return;
	        }
	        var t = 1,
	            step = t / 2,
	            t2 = t - step,
	            l,
	            e = .01;
	        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        while (abs(l - ll) > e) {
	            step /= 2;
	            t2 += (l < ll ? 1 : -1) * step;
	            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
	        }
	        return t2;
	    }
	    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
	        if (
	            mmax(x1, x2) < mmin(x3, x4) ||
	            mmin(x1, x2) > mmax(x3, x4) ||
	            mmax(y1, y2) < mmin(y3, y4) ||
	            mmin(y1, y2) > mmax(y3, y4)
	        ) {
	            return;
	        }
	        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	
	        if (!denominator) {
	            return;
	        }
	        var px = nx / denominator,
	            py = ny / denominator,
	            px2 = +px.toFixed(2),
	            py2 = +py.toFixed(2);
	        if (
	            px2 < +mmin(x1, x2).toFixed(2) ||
	            px2 > +mmax(x1, x2).toFixed(2) ||
	            px2 < +mmin(x3, x4).toFixed(2) ||
	            px2 > +mmax(x3, x4).toFixed(2) ||
	            py2 < +mmin(y1, y2).toFixed(2) ||
	            py2 > +mmax(y1, y2).toFixed(2) ||
	            py2 < +mmin(y3, y4).toFixed(2) ||
	            py2 > +mmax(y3, y4).toFixed(2)
	        ) {
	            return;
	        }
	        return {x: px, y: py};
	    }
	    function inter(bez1, bez2) {
	        return interHelper(bez1, bez2);
	    }
	    function interCount(bez1, bez2) {
	        return interHelper(bez1, bez2, 1);
	    }
	    function interHelper(bez1, bez2, justCount) {
	        var bbox1 = R.bezierBBox(bez1),
	            bbox2 = R.bezierBBox(bez2);
	        if (!R.isBBoxIntersect(bbox1, bbox2)) {
	            return justCount ? 0 : [];
	        }
	        var l1 = bezlen.apply(0, bez1),
	            l2 = bezlen.apply(0, bez2),
	            n1 = mmax(~~(l1 / 5), 1),
	            n2 = mmax(~~(l2 / 5), 1),
	            dots1 = [],
	            dots2 = [],
	            xy = {},
	            res = justCount ? 0 : [];
	        for (var i = 0; i < n1 + 1; i++) {
	            var p = R.findDotsAtSegment.apply(R, bez1.concat(i / n1));
	            dots1.push({x: p.x, y: p.y, t: i / n1});
	        }
	        for (i = 0; i < n2 + 1; i++) {
	            p = R.findDotsAtSegment.apply(R, bez2.concat(i / n2));
	            dots2.push({x: p.x, y: p.y, t: i / n2});
	        }
	        for (i = 0; i < n1; i++) {
	            for (var j = 0; j < n2; j++) {
	                var di = dots1[i],
	                    di1 = dots1[i + 1],
	                    dj = dots2[j],
	                    dj1 = dots2[j + 1],
	                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
	                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
	                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
	                if (is) {
	                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
	                        continue;
	                    }
	                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
	                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
	                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
	                    if (t1 >= 0 && t1 <= 1.001 && t2 >= 0 && t2 <= 1.001) {
	                        if (justCount) {
	                            res++;
	                        } else {
	                            res.push({
	                                x: is.x,
	                                y: is.y,
	                                t1: mmin(t1, 1),
	                                t2: mmin(t2, 1)
	                            });
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    /*\
	     * Raphael.pathIntersection
	     [ method ]
	     **
	     * Utility method
	     **
	     * Finds intersections of two paths
	     > Parameters
	     - path1 (string) path string
	     - path2 (string) path string
	     = (array) dots of intersection
	     o [
	     o     {
	     o         x: (number) x coordinate of the point
	     o         y: (number) y coordinate of the point
	     o         t1: (number) t value for segment of path1
	     o         t2: (number) t value for segment of path2
	     o         segment1: (number) order number for segment of path1
	     o         segment2: (number) order number for segment of path2
	     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1
	     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
	     o     }
	     o ]
	    \*/
	    R.pathIntersection = function (path1, path2) {
	        return interPathHelper(path1, path2);
	    };
	    R.pathIntersectionNumber = function (path1, path2) {
	        return interPathHelper(path1, path2, 1);
	    };
	    function interPathHelper(path1, path2, justCount) {
	        path1 = R._path2curve(path1);
	        path2 = R._path2curve(path2);
	        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
	            res = justCount ? 0 : [];
	        for (var i = 0, ii = path1.length; i < ii; i++) {
	            var pi = path1[i];
	            if (pi[0] == "M") {
	                x1 = x1m = pi[1];
	                y1 = y1m = pi[2];
	            } else {
	                if (pi[0] == "C") {
	                    bez1 = [x1, y1].concat(pi.slice(1));
	                    x1 = bez1[6];
	                    y1 = bez1[7];
	                } else {
	                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
	                    x1 = x1m;
	                    y1 = y1m;
	                }
	                for (var j = 0, jj = path2.length; j < jj; j++) {
	                    var pj = path2[j];
	                    if (pj[0] == "M") {
	                        x2 = x2m = pj[1];
	                        y2 = y2m = pj[2];
	                    } else {
	                        if (pj[0] == "C") {
	                            bez2 = [x2, y2].concat(pj.slice(1));
	                            x2 = bez2[6];
	                            y2 = bez2[7];
	                        } else {
	                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
	                            x2 = x2m;
	                            y2 = y2m;
	                        }
	                        var intr = interHelper(bez1, bez2, justCount);
	                        if (justCount) {
	                            res += intr;
	                        } else {
	                            for (var k = 0, kk = intr.length; k < kk; k++) {
	                                intr[k].segment1 = i;
	                                intr[k].segment2 = j;
	                                intr[k].bez1 = bez1;
	                                intr[k].bez2 = bez2;
	                            }
	                            res = res.concat(intr);
	                        }
	                    }
	                }
	            }
	        }
	        return res;
	    }
	    /*\
	     * Raphael.isPointInsidePath
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns `true` if given point is inside a given closed path.
	     > Parameters
	     - path (string) path string
	     - x (number) x of the point
	     - y (number) y of the point
	     = (boolean) true, if point is inside the path
	    \*/
	    R.isPointInsidePath = function (path, x, y) {
	        var bbox = R.pathBBox(path);
	        return R.isPointInsideBBox(bbox, x, y) &&
	               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
	    };
	    R._removedFactory = function (methodname) {
	        return function () {
	            eve("raphael.log", null, "Rapha\xebl: you are calling to method \u201c" + methodname + "\u201d of removed object", methodname);
	        };
	    };
	    /*\
	     * Raphael.pathBBox
	     [ method ]
	     **
	     * Utility method
	     **
	     * Return bounding box of a given path
	     > Parameters
	     - path (string) path string
	     = (object) bounding box
	     o {
	     o     x: (number) x coordinate of the left top point of the box
	     o     y: (number) y coordinate of the left top point of the box
	     o     x2: (number) x coordinate of the right bottom point of the box
	     o     y2: (number) y coordinate of the right bottom point of the box
	     o     width: (number) width of the box
	     o     height: (number) height of the box
	     o     cx: (number) x coordinate of the center of the box
	     o     cy: (number) y coordinate of the center of the box
	     o }
	    \*/
	    var pathDimensions = R.pathBBox = function (path) {
	        var pth = paths(path);
	        if (pth.bbox) {
	            return clone(pth.bbox);
	        }
	        if (!path) {
	            return {x: 0, y: 0, width: 0, height: 0, x2: 0, y2: 0};
	        }
	        path = path2curve(path);
	        var x = 0,
	            y = 0,
	            X = [],
	            Y = [],
	            p;
	        for (var i = 0, ii = path.length; i < ii; i++) {
	            p = path[i];
	            if (p[0] == "M") {
	                x = p[1];
	                y = p[2];
	                X.push(x);
	                Y.push(y);
	            } else {
	                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                X = X[concat](dim.min.x, dim.max.x);
	                Y = Y[concat](dim.min.y, dim.max.y);
	                x = p[5];
	                y = p[6];
	            }
	        }
	        var xmin = mmin[apply](0, X),
	            ymin = mmin[apply](0, Y),
	            xmax = mmax[apply](0, X),
	            ymax = mmax[apply](0, Y),
	            width = xmax - xmin,
	            height = ymax - ymin,
	                bb = {
	                x: xmin,
	                y: ymin,
	                x2: xmax,
	                y2: ymax,
	                width: width,
	                height: height,
	                cx: xmin + width / 2,
	                cy: ymin + height / 2
	            };
	        pth.bbox = clone(bb);
	        return bb;
	    },
	        pathClone = function (pathArray) {
	            var res = clone(pathArray);
	            res.toString = R._path2string;
	            return res;
	        },
	        pathToRelative = R._pathToRelative = function (pathArray) {
	            var pth = paths(pathArray);
	            if (pth.rel) {
	                return pathClone(pth.rel);
	            }
	            if (!R.is(pathArray, array) || !R.is(pathArray && pathArray[0], array)) { // rough assumption
	                pathArray = R.parsePathString(pathArray);
	            }
	            var res = [],
	                x = 0,
	                y = 0,
	                mx = 0,
	                my = 0,
	                start = 0;
	            if (pathArray[0][0] == "M") {
	                x = pathArray[0][1];
	                y = pathArray[0][2];
	                mx = x;
	                my = y;
	                start++;
	                res.push(["M", x, y]);
	            }
	            for (var i = start, ii = pathArray.length; i < ii; i++) {
	                var r = res[i] = [],
	                    pa = pathArray[i];
	                if (pa[0] != lowerCase.call(pa[0])) {
	                    r[0] = lowerCase.call(pa[0]);
	                    switch (r[0]) {
	                        case "a":
	                            r[1] = pa[1];
	                            r[2] = pa[2];
	                            r[3] = pa[3];
	                            r[4] = pa[4];
	                            r[5] = pa[5];
	                            r[6] = +(pa[6] - x).toFixed(3);
	                            r[7] = +(pa[7] - y).toFixed(3);
	                            break;
	                        case "v":
	                            r[1] = +(pa[1] - y).toFixed(3);
	                            break;
	                        case "m":
	                            mx = pa[1];
	                            my = pa[2];
	                        default:
	                            for (var j = 1, jj = pa.length; j < jj; j++) {
	                                r[j] = +(pa[j] - ((j % 2) ? x : y)).toFixed(3);
	                            }
	                    }
	                } else {
	                    r = res[i] = [];
	                    if (pa[0] == "m") {
	                        mx = pa[1] + x;
	                        my = pa[2] + y;
	                    }
	                    for (var k = 0, kk = pa.length; k < kk; k++) {
	                        res[i][k] = pa[k];
	                    }
	                }
	                var len = res[i].length;
	                switch (res[i][0]) {
	                    case "z":
	                        x = mx;
	                        y = my;
	                        break;
	                    case "h":
	                        x += +res[i][len - 1];
	                        break;
	                    case "v":
	                        y += +res[i][len - 1];
	                        break;
	                    default:
	                        x += +res[i][len - 2];
	                        y += +res[i][len - 1];
	                }
	            }
	            res.toString = R._path2string;
	            pth.rel = pathClone(res);
	            return res;
	        },
	        pathToAbsolute = R._pathToAbsolute = function (pathArray) {
	            var pth = paths(pathArray);
	            if (pth.abs) {
	                return pathClone(pth.abs);
	            }
	            if (!R.is(pathArray, array) || !R.is(pathArray && pathArray[0], array)) { // rough assumption
	                pathArray = R.parsePathString(pathArray);
	            }
	            if (!pathArray || !pathArray.length) {
	                return [["M", 0, 0]];
	            }
	            var res = [],
	                x = 0,
	                y = 0,
	                mx = 0,
	                my = 0,
	                start = 0;
	            if (pathArray[0][0] == "M") {
	                x = +pathArray[0][1];
	                y = +pathArray[0][2];
	                mx = x;
	                my = y;
	                start++;
	                res[0] = ["M", x, y];
	            }
	            var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
	            for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
	                res.push(r = []);
	                pa = pathArray[i];
	                if (pa[0] != upperCase.call(pa[0])) {
	                    r[0] = upperCase.call(pa[0]);
	                    switch (r[0]) {
	                        case "A":
	                            r[1] = pa[1];
	                            r[2] = pa[2];
	                            r[3] = pa[3];
	                            r[4] = pa[4];
	                            r[5] = pa[5];
	                            r[6] = +(pa[6] + x);
	                            r[7] = +(pa[7] + y);
	                            break;
	                        case "V":
	                            r[1] = +pa[1] + y;
	                            break;
	                        case "H":
	                            r[1] = +pa[1] + x;
	                            break;
	                        case "R":
	                            var dots = [x, y][concat](pa.slice(1));
	                            for (var j = 2, jj = dots.length; j < jj; j++) {
	                                dots[j] = +dots[j] + x;
	                                dots[++j] = +dots[j] + y;
	                            }
	                            res.pop();
	                            res = res[concat](catmullRom2bezier(dots, crz));
	                            break;
	                        case "M":
	                            mx = +pa[1] + x;
	                            my = +pa[2] + y;
	                        default:
	                            for (j = 1, jj = pa.length; j < jj; j++) {
	                                r[j] = +pa[j] + ((j % 2) ? x : y);
	                            }
	                    }
	                } else if (pa[0] == "R") {
	                    dots = [x, y][concat](pa.slice(1));
	                    res.pop();
	                    res = res[concat](catmullRom2bezier(dots, crz));
	                    r = ["R"][concat](pa.slice(-2));
	                } else {
	                    for (var k = 0, kk = pa.length; k < kk; k++) {
	                        r[k] = pa[k];
	                    }
	                }
	                switch (r[0]) {
	                    case "Z":
	                        x = mx;
	                        y = my;
	                        break;
	                    case "H":
	                        x = r[1];
	                        break;
	                    case "V":
	                        y = r[1];
	                        break;
	                    case "M":
	                        mx = r[r.length - 2];
	                        my = r[r.length - 1];
	                    default:
	                        x = r[r.length - 2];
	                        y = r[r.length - 1];
	                }
	            }
	            res.toString = R._path2string;
	            pth.abs = pathClone(res);
	            return res;
	        },
	        l2c = function (x1, y1, x2, y2) {
	            return [x1, y1, x2, y2, x2, y2];
	        },
	        q2c = function (x1, y1, ax, ay, x2, y2) {
	            var _13 = 1 / 3,
	                _23 = 2 / 3;
	            return [
	                    _13 * x1 + _23 * ax,
	                    _13 * y1 + _23 * ay,
	                    _13 * x2 + _23 * ax,
	                    _13 * y2 + _23 * ay,
	                    x2,
	                    y2
	                ];
	        },
	        a2c = function (x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
	            // for more information of where this math came from visit:
	            // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
	            var _120 = PI * 120 / 180,
	                rad = PI / 180 * (+angle || 0),
	                res = [],
	                xy,
	                rotate = cacher(function (x, y, rad) {
	                    var X = x * math.cos(rad) - y * math.sin(rad),
	                        Y = x * math.sin(rad) + y * math.cos(rad);
	                    return {x: X, y: Y};
	                });
	            if (!recursive) {
	                xy = rotate(x1, y1, -rad);
	                x1 = xy.x;
	                y1 = xy.y;
	                xy = rotate(x2, y2, -rad);
	                x2 = xy.x;
	                y2 = xy.y;
	                var cos = math.cos(PI / 180 * angle),
	                    sin = math.sin(PI / 180 * angle),
	                    x = (x1 - x2) / 2,
	                    y = (y1 - y2) / 2;
	                var h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
	                if (h > 1) {
	                    h = math.sqrt(h);
	                    rx = h * rx;
	                    ry = h * ry;
	                }
	                var rx2 = rx * rx,
	                    ry2 = ry * ry,
	                    k = (large_arc_flag == sweep_flag ? -1 : 1) *
	                        math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
	                    cx = k * rx * y / ry + (x1 + x2) / 2,
	                    cy = k * -ry * x / rx + (y1 + y2) / 2,
	                    f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
	                    f2 = math.asin(((y2 - cy) / ry).toFixed(9));
	
	                f1 = x1 < cx ? PI - f1 : f1;
	                f2 = x2 < cx ? PI - f2 : f2;
	                f1 < 0 && (f1 = PI * 2 + f1);
	                f2 < 0 && (f2 = PI * 2 + f2);
	                if (sweep_flag && f1 > f2) {
	                    f1 = f1 - PI * 2;
	                }
	                if (!sweep_flag && f2 > f1) {
	                    f2 = f2 - PI * 2;
	                }
	            } else {
	                f1 = recursive[0];
	                f2 = recursive[1];
	                cx = recursive[2];
	                cy = recursive[3];
	            }
	            var df = f2 - f1;
	            if (abs(df) > _120) {
	                var f2old = f2,
	                    x2old = x2,
	                    y2old = y2;
	                f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
	                x2 = cx + rx * math.cos(f2);
	                y2 = cy + ry * math.sin(f2);
	                res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
	            }
	            df = f2 - f1;
	            var c1 = math.cos(f1),
	                s1 = math.sin(f1),
	                c2 = math.cos(f2),
	                s2 = math.sin(f2),
	                t = math.tan(df / 4),
	                hx = 4 / 3 * rx * t,
	                hy = 4 / 3 * ry * t,
	                m1 = [x1, y1],
	                m2 = [x1 + hx * s1, y1 - hy * c1],
	                m3 = [x2 + hx * s2, y2 - hy * c2],
	                m4 = [x2, y2];
	            m2[0] = 2 * m1[0] - m2[0];
	            m2[1] = 2 * m1[1] - m2[1];
	            if (recursive) {
	                return [m2, m3, m4][concat](res);
	            } else {
	                res = [m2, m3, m4][concat](res).join()[split](",");
	                var newres = [];
	                for (var i = 0, ii = res.length; i < ii; i++) {
	                    newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
	                }
	                return newres;
	            }
	        },
	        findDotAtSegment = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
	            var t1 = 1 - t;
	            return {
	                x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
	                y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
	            };
	        },
	        curveDim = cacher(function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
	            var a = (c2x - 2 * c1x + p1x) - (p2x - 2 * c2x + c1x),
	                b = 2 * (c1x - p1x) - 2 * (c2x - c1x),
	                c = p1x - c1x,
	                t1 = (-b + math.sqrt(b * b - 4 * a * c)) / 2 / a,
	                t2 = (-b - math.sqrt(b * b - 4 * a * c)) / 2 / a,
	                y = [p1y, p2y],
	                x = [p1x, p2x],
	                dot;
	            abs(t1) > "1e12" && (t1 = .5);
	            abs(t2) > "1e12" && (t2 = .5);
	            if (t1 > 0 && t1 < 1) {
	                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
	                x.push(dot.x);
	                y.push(dot.y);
	            }
	            if (t2 > 0 && t2 < 1) {
	                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
	                x.push(dot.x);
	                y.push(dot.y);
	            }
	            a = (c2y - 2 * c1y + p1y) - (p2y - 2 * c2y + c1y);
	            b = 2 * (c1y - p1y) - 2 * (c2y - c1y);
	            c = p1y - c1y;
	            t1 = (-b + math.sqrt(b * b - 4 * a * c)) / 2 / a;
	            t2 = (-b - math.sqrt(b * b - 4 * a * c)) / 2 / a;
	            abs(t1) > "1e12" && (t1 = .5);
	            abs(t2) > "1e12" && (t2 = .5);
	            if (t1 > 0 && t1 < 1) {
	                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t1);
	                x.push(dot.x);
	                y.push(dot.y);
	            }
	            if (t2 > 0 && t2 < 1) {
	                dot = findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2);
	                x.push(dot.x);
	                y.push(dot.y);
	            }
	            return {
	                min: {x: mmin[apply](0, x), y: mmin[apply](0, y)},
	                max: {x: mmax[apply](0, x), y: mmax[apply](0, y)}
	            };
	        }),
	        path2curve = R._path2curve = cacher(function (path, path2) {
	            var pth = !path2 && paths(path);
	            if (!path2 && pth.curve) {
	                return pathClone(pth.curve);
	            }
	            var p = pathToAbsolute(path),
	                p2 = path2 && pathToAbsolute(path2),
	                attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	                attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
	                processPath = function (path, d, pcom) {
	                    var nx, ny, tq = {T:1, Q:1};
	                    if (!path) {
	                        return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
	                    }
	                    !(path[0] in tq) && (d.qx = d.qy = null);
	                    switch (path[0]) {
	                        case "M":
	                            d.X = path[1];
	                            d.Y = path[2];
	                            break;
	                        case "A":
	                            path = ["C"][concat](a2c[apply](0, [d.x, d.y][concat](path.slice(1))));
	                            break;
	                        case "S":
	                            if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
	                                nx = d.x * 2 - d.bx;          // And reflect the previous
	                                ny = d.y * 2 - d.by;          // command's control point relative to the current point.
	                            }
	                            else {                            // or some else or nothing
	                                nx = d.x;
	                                ny = d.y;
	                            }
	                            path = ["C", nx, ny][concat](path.slice(1));
	                            break;
	                        case "T":
	                            if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
	                                d.qx = d.x * 2 - d.qx;        // And make a reflection similar
	                                d.qy = d.y * 2 - d.qy;        // to case "S".
	                            }
	                            else {                            // or something else or nothing
	                                d.qx = d.x;
	                                d.qy = d.y;
	                            }
	                            path = ["C"][concat](q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
	                            break;
	                        case "Q":
	                            d.qx = path[1];
	                            d.qy = path[2];
	                            path = ["C"][concat](q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
	                            break;
	                        case "L":
	                            path = ["C"][concat](l2c(d.x, d.y, path[1], path[2]));
	                            break;
	                        case "H":
	                            path = ["C"][concat](l2c(d.x, d.y, path[1], d.y));
	                            break;
	                        case "V":
	                            path = ["C"][concat](l2c(d.x, d.y, d.x, path[1]));
	                            break;
	                        case "Z":
	                            path = ["C"][concat](l2c(d.x, d.y, d.X, d.Y));
	                            break;
	                    }
	                    return path;
	                },
	                fixArc = function (pp, i) {
	                    if (pp[i].length > 7) {
	                        pp[i].shift();
	                        var pi = pp[i];
	                        while (pi.length) {
	                            pcoms1[i]="A"; // if created multiple C:s, their original seg is saved
	                            p2 && (pcoms2[i]="A"); // the same as above
	                            pp.splice(i++, 0, ["C"][concat](pi.splice(0, 6)));
	                        }
	                        pp.splice(i, 1);
	                        ii = mmax(p.length, p2 && p2.length || 0);
	                    }
	                },
	                fixM = function (path1, path2, a1, a2, i) {
	                    if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
	                        path2.splice(i, 0, ["M", a2.x, a2.y]);
	                        a1.bx = 0;
	                        a1.by = 0;
	                        a1.x = path1[i][1];
	                        a1.y = path1[i][2];
	                        ii = mmax(p.length, p2 && p2.length || 0);
	                    }
	                },
	                pcoms1 = [], // path commands of original path p
	                pcoms2 = [], // path commands of original path p2
	                pfirst = "", // temporary holder for original path command
	                pcom = ""; // holder for previous path command of original path
	            for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
	                p[i] && (pfirst = p[i][0]); // save current path command
	
	                if (pfirst != "C") // C is not saved yet, because it may be result of conversion
	                {
	                    pcoms1[i] = pfirst; // Save current path command
	                    i && ( pcom = pcoms1[i-1]); // Get previous path command pcom
	                }
	                p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
	
	                if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
	                // which may produce multiple C:s
	                // so we have to make sure that C is also C in original path
	
	                fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
	
	                if (p2) { // the same procedures is done to p2
	                    p2[i] && (pfirst = p2[i][0]);
	                    if (pfirst != "C")
	                    {
	                        pcoms2[i] = pfirst;
	                        i && (pcom = pcoms2[i-1]);
	                    }
	                    p2[i] = processPath(p2[i], attrs2, pcom);
	
	                    if (pcoms2[i]!="A" && pfirst=="C") pcoms2[i]="C";
	
	                    fixArc(p2, i);
	                }
	                fixM(p, p2, attrs, attrs2, i);
	                fixM(p2, p, attrs2, attrs, i);
	                var seg = p[i],
	                    seg2 = p2 && p2[i],
	                    seglen = seg.length,
	                    seg2len = p2 && seg2.length;
	                attrs.x = seg[seglen - 2];
	                attrs.y = seg[seglen - 1];
	                attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
	                attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
	                attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
	                attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
	                attrs2.x = p2 && seg2[seg2len - 2];
	                attrs2.y = p2 && seg2[seg2len - 1];
	            }
	            if (!p2) {
	                pth.curve = pathClone(p);
	            }
	            return p2 ? [p, p2] : p;
	        }, null, pathClone),
	        parseDots = R._parseDots = cacher(function (gradient) {
	            var dots = [];
	            for (var i = 0, ii = gradient.length; i < ii; i++) {
	                var dot = {},
	                    par = gradient[i].match(/^([^:]*):?([\d\.]*)/);
	                dot.color = R.getRGB(par[1]);
	                if (dot.color.error) {
	                    return null;
	                }
	                dot.opacity = dot.color.opacity;
	                dot.color = dot.color.hex;
	                par[2] && (dot.offset = par[2] + "%");
	                dots.push(dot);
	            }
	            for (i = 1, ii = dots.length - 1; i < ii; i++) {
	                if (!dots[i].offset) {
	                    var start = toFloat(dots[i - 1].offset || 0),
	                        end = 0;
	                    for (var j = i + 1; j < ii; j++) {
	                        if (dots[j].offset) {
	                            end = dots[j].offset;
	                            break;
	                        }
	                    }
	                    if (!end) {
	                        end = 100;
	                        j = ii;
	                    }
	                    end = toFloat(end);
	                    var d = (end - start) / (j - i + 1);
	                    for (; i < j; i++) {
	                        start += d;
	                        dots[i].offset = start + "%";
	                    }
	                }
	            }
	            return dots;
	        }),
	        tear = R._tear = function (el, paper) {
	            el == paper.top && (paper.top = el.prev);
	            el == paper.bottom && (paper.bottom = el.next);
	            el.next && (el.next.prev = el.prev);
	            el.prev && (el.prev.next = el.next);
	        },
	        tofront = R._tofront = function (el, paper) {
	            if (paper.top === el) {
	                return;
	            }
	            tear(el, paper);
	            el.next = null;
	            el.prev = paper.top;
	            paper.top.next = el;
	            paper.top = el;
	        },
	        toback = R._toback = function (el, paper) {
	            if (paper.bottom === el) {
	                return;
	            }
	            tear(el, paper);
	            el.next = paper.bottom;
	            el.prev = null;
	            paper.bottom.prev = el;
	            paper.bottom = el;
	        },
	        insertafter = R._insertafter = function (el, el2, paper) {
	            tear(el, paper);
	            el2 == paper.top && (paper.top = el);
	            el2.next && (el2.next.prev = el);
	            el.next = el2.next;
	            el.prev = el2;
	            el2.next = el;
	        },
	        insertbefore = R._insertbefore = function (el, el2, paper) {
	            tear(el, paper);
	            el2 == paper.bottom && (paper.bottom = el);
	            el2.prev && (el2.prev.next = el);
	            el.prev = el2.prev;
	            el2.prev = el;
	            el.next = el2;
	        },
	        /*\
	         * Raphael.toMatrix
	         [ method ]
	         **
	         * Utility method
	         **
	         * Returns matrix of transformations applied to a given path
	         > Parameters
	         - path (string) path string
	         - transform (string|array) transformation string
	         = (object) @Matrix
	        \*/
	        toMatrix = R.toMatrix = function (path, transform) {
	            var bb = pathDimensions(path),
	                el = {
	                    _: {
	                        transform: E
	                    },
	                    getBBox: function () {
	                        return bb;
	                    }
	                };
	            extractTransform(el, transform);
	            return el.matrix;
	        },
	        /*\
	         * Raphael.transformPath
	         [ method ]
	         **
	         * Utility method
	         **
	         * Returns path transformed by a given transformation
	         > Parameters
	         - path (string) path string
	         - transform (string|array) transformation string
	         = (string) path
	        \*/
	        transformPath = R.transformPath = function (path, transform) {
	            return mapPath(path, toMatrix(path, transform));
	        },
	        extractTransform = R._extractTransform = function (el, tstr) {
	            if (tstr == null) {
	                return el._.transform;
	            }
	            tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || E);
	            var tdata = R.parseTransformString(tstr),
	                deg = 0,
	                dx = 0,
	                dy = 0,
	                sx = 1,
	                sy = 1,
	                _ = el._,
	                m = new Matrix;
	            _.transform = tdata || [];
	            if (tdata) {
	                for (var i = 0, ii = tdata.length; i < ii; i++) {
	                    var t = tdata[i],
	                        tlen = t.length,
	                        command = Str(t[0]).toLowerCase(),
	                        absolute = t[0] != command,
	                        inver = absolute ? m.invert() : 0,
	                        x1,
	                        y1,
	                        x2,
	                        y2,
	                        bb;
	                    if (command == "t" && tlen == 3) {
	                        if (absolute) {
	                            x1 = inver.x(0, 0);
	                            y1 = inver.y(0, 0);
	                            x2 = inver.x(t[1], t[2]);
	                            y2 = inver.y(t[1], t[2]);
	                            m.translate(x2 - x1, y2 - y1);
	                        } else {
	                            m.translate(t[1], t[2]);
	                        }
	                    } else if (command == "r") {
	                        if (tlen == 2) {
	                            bb = bb || el.getBBox(1);
	                            m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                            deg += t[1];
	                        } else if (tlen == 4) {
	                            if (absolute) {
	                                x2 = inver.x(t[2], t[3]);
	                                y2 = inver.y(t[2], t[3]);
	                                m.rotate(t[1], x2, y2);
	                            } else {
	                                m.rotate(t[1], t[2], t[3]);
	                            }
	                            deg += t[1];
	                        }
	                    } else if (command == "s") {
	                        if (tlen == 2 || tlen == 3) {
	                            bb = bb || el.getBBox(1);
	                            m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
	                            sx *= t[1];
	                            sy *= t[tlen - 1];
	                        } else if (tlen == 5) {
	                            if (absolute) {
	                                x2 = inver.x(t[3], t[4]);
	                                y2 = inver.y(t[3], t[4]);
	                                m.scale(t[1], t[2], x2, y2);
	                            } else {
	                                m.scale(t[1], t[2], t[3], t[4]);
	                            }
	                            sx *= t[1];
	                            sy *= t[2];
	                        }
	                    } else if (command == "m" && tlen == 7) {
	                        m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
	                    }
	                    _.dirtyT = 1;
	                    el.matrix = m;
	                }
	            }
	
	            /*\
	             * Element.matrix
	             [ property (object) ]
	             **
	             * Keeps @Matrix object, which represents element transformation
	            \*/
	            el.matrix = m;
	
	            _.sx = sx;
	            _.sy = sy;
	            _.deg = deg;
	            _.dx = dx = m.e;
	            _.dy = dy = m.f;
	
	            if (sx == 1 && sy == 1 && !deg && _.bbox) {
	                _.bbox.x += +dx;
	                _.bbox.y += +dy;
	            } else {
	                _.dirtyT = 1;
	            }
	        },
	        getEmpty = function (item) {
	            var l = item[0];
	            switch (l.toLowerCase()) {
	                case "t": return [l, 0, 0];
	                case "m": return [l, 1, 0, 0, 1, 0, 0];
	                case "r": if (item.length == 4) {
	                    return [l, 0, item[2], item[3]];
	                } else {
	                    return [l, 0];
	                }
	                case "s": if (item.length == 5) {
	                    return [l, 1, 1, item[3], item[4]];
	                } else if (item.length == 3) {
	                    return [l, 1, 1];
	                } else {
	                    return [l, 1];
	                }
	            }
	        },
	        equaliseTransform = R._equaliseTransform = function (t1, t2) {
	            t2 = Str(t2).replace(/\.{3}|\u2026/g, t1);
	            t1 = R.parseTransformString(t1) || [];
	            t2 = R.parseTransformString(t2) || [];
	            var maxlength = mmax(t1.length, t2.length),
	                from = [],
	                to = [],
	                i = 0, j, jj,
	                tt1, tt2;
	            for (; i < maxlength; i++) {
	                tt1 = t1[i] || getEmpty(t2[i]);
	                tt2 = t2[i] || getEmpty(tt1);
	                if ((tt1[0] != tt2[0]) ||
	                    (tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3])) ||
	                    (tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4]))
	                    ) {
	                    return;
	                }
	                from[i] = [];
	                to[i] = [];
	                for (j = 0, jj = mmax(tt1.length, tt2.length); j < jj; j++) {
	                    j in tt1 && (from[i][j] = tt1[j]);
	                    j in tt2 && (to[i][j] = tt2[j]);
	                }
	            }
	            return {
	                from: from,
	                to: to
	            };
	        };
	    R._getContainer = function (x, y, w, h) {
	        var container;
	        container = h == null && !R.is(x, "object") ? g.doc.getElementById(x) : x;
	        if (container == null) {
	            return;
	        }
	        if (container.tagName) {
	            if (y == null) {
	                return {
	                    container: container,
	                    width: container.style.pixelWidth || container.offsetWidth,
	                    height: container.style.pixelHeight || container.offsetHeight
	                };
	            } else {
	                return {
	                    container: container,
	                    width: y,
	                    height: w
	                };
	            }
	        }
	        return {
	            container: 1,
	            x: x,
	            y: y,
	            width: w,
	            height: h
	        };
	    };
	    /*\
	     * Raphael.pathToRelative
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to relative form
	     > Parameters
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments.
	    \*/
	    R.pathToRelative = pathToRelative;
	    R._engine = {};
	    /*\
	     * Raphael.path2curve
	     [ method ]
	     **
	     * Utility method
	     **
	     * Converts path to a new path where all segments are cubic bezier curves.
	     > Parameters
	     - pathString (string|array) path string or array of segments
	     = (array) array of segments.
	    \*/
	    R.path2curve = path2curve;
	    /*\
	     * Raphael.matrix
	     [ method ]
	     **
	     * Utility method
	     **
	     * Returns matrix based on given parameters.
	     > Parameters
	     - a (number)
	     - b (number)
	     - c (number)
	     - d (number)
	     - e (number)
	     - f (number)
	     = (object) @Matrix
	    \*/
	    R.matrix = function (a, b, c, d, e, f) {
	        return new Matrix(a, b, c, d, e, f);
	    };
	    function Matrix(a, b, c, d, e, f) {
	        if (a != null) {
	            this.a = +a;
	            this.b = +b;
	            this.c = +c;
	            this.d = +d;
	            this.e = +e;
	            this.f = +f;
	        } else {
	            this.a = 1;
	            this.b = 0;
	            this.c = 0;
	            this.d = 1;
	            this.e = 0;
	            this.f = 0;
	        }
	    }
	    (function (matrixproto) {
	        /*\
	         * Matrix.add
	         [ method ]
	         **
	         * Adds given matrix to existing one.
	         > Parameters
	         - a (number)
	         - b (number)
	         - c (number)
	         - d (number)
	         - e (number)
	         - f (number)
	         or
	         - matrix (object) @Matrix
	        \*/
	        matrixproto.add = function (a, b, c, d, e, f) {
	            var out = [[], [], []],
	                m = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
	                matrix = [[a, c, e], [b, d, f], [0, 0, 1]],
	                x, y, z, res;
	
	            if (a && a instanceof Matrix) {
	                matrix = [[a.a, a.c, a.e], [a.b, a.d, a.f], [0, 0, 1]];
	            }
	
	            for (x = 0; x < 3; x++) {
	                for (y = 0; y < 3; y++) {
	                    res = 0;
	                    for (z = 0; z < 3; z++) {
	                        res += m[x][z] * matrix[z][y];
	                    }
	                    out[x][y] = res;
	                }
	            }
	            this.a = out[0][0];
	            this.b = out[1][0];
	            this.c = out[0][1];
	            this.d = out[1][1];
	            this.e = out[0][2];
	            this.f = out[1][2];
	        };
	        /*\
	         * Matrix.invert
	         [ method ]
	         **
	         * Returns inverted version of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.invert = function () {
	            var me = this,
	                x = me.a * me.d - me.b * me.c;
	            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
	        };
	        /*\
	         * Matrix.clone
	         [ method ]
	         **
	         * Returns copy of the matrix
	         = (object) @Matrix
	        \*/
	        matrixproto.clone = function () {
	            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
	        };
	        /*\
	         * Matrix.translate
	         [ method ]
	         **
	         * Translate the matrix
	         > Parameters
	         - x (number)
	         - y (number)
	        \*/
	        matrixproto.translate = function (x, y) {
	            this.add(1, 0, 0, 1, x, y);
	        };
	        /*\
	         * Matrix.scale
	         [ method ]
	         **
	         * Scales the matrix
	         > Parameters
	         - x (number)
	         - y (number) #optional
	         - cx (number) #optional
	         - cy (number) #optional
	        \*/
	        matrixproto.scale = function (x, y, cx, cy) {
	            y == null && (y = x);
	            (cx || cy) && this.add(1, 0, 0, 1, cx, cy);
	            this.add(x, 0, 0, y, 0, 0);
	            (cx || cy) && this.add(1, 0, 0, 1, -cx, -cy);
	        };
	        /*\
	         * Matrix.rotate
	         [ method ]
	         **
	         * Rotates the matrix
	         > Parameters
	         - a (number)
	         - x (number)
	         - y (number)
	        \*/
	        matrixproto.rotate = function (a, x, y) {
	            a = R.rad(a);
	            x = x || 0;
	            y = y || 0;
	            var cos = +math.cos(a).toFixed(9),
	                sin = +math.sin(a).toFixed(9);
	            this.add(cos, sin, -sin, cos, x, y);
	            this.add(1, 0, 0, 1, -x, -y);
	        };
	        /*\
	         * Matrix.x
	         [ method ]
	         **
	         * Return x coordinate for given point after transformation described by the matrix. See also @Matrix.y
	         > Parameters
	         - x (number)
	         - y (number)
	         = (number) x
	        \*/
	        matrixproto.x = function (x, y) {
	            return x * this.a + y * this.c + this.e;
	        };
	        /*\
	         * Matrix.y
	         [ method ]
	         **
	         * Return y coordinate for given point after transformation described by the matrix. See also @Matrix.x
	         > Parameters
	         - x (number)
	         - y (number)
	         = (number) y
	        \*/
	        matrixproto.y = function (x, y) {
	            return x * this.b + y * this.d + this.f;
	        };
	        matrixproto.get = function (i) {
	            return +this[Str.fromCharCode(97 + i)].toFixed(4);
	        };
	        matrixproto.toString = function () {
	            return R.svg ?
	                "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")" :
	                [this.get(0), this.get(2), this.get(1), this.get(3), 0, 0].join();
	        };
	        matrixproto.toFilter = function () {
	            return "progid:DXImageTransform.Microsoft.Matrix(M11=" + this.get(0) +
	                ", M12=" + this.get(2) + ", M21=" + this.get(1) + ", M22=" + this.get(3) +
	                ", Dx=" + this.get(4) + ", Dy=" + this.get(5) + ", sizingmethod='auto expand')";
	        };
	        matrixproto.offset = function () {
	            return [this.e.toFixed(4), this.f.toFixed(4)];
	        };
	        function norm(a) {
	            return a[0] * a[0] + a[1] * a[1];
	        }
	        function normalize(a) {
	            var mag = math.sqrt(norm(a));
	            a[0] && (a[0] /= mag);
	            a[1] && (a[1] /= mag);
	        }
	        /*\
	         * Matrix.split
	         [ method ]
	         **
	         * Splits matrix into primitive transformations
	         = (object) in format:
	         o dx (number) translation by x
	         o dy (number) translation by y
	         o scalex (number) scale by x
	         o scaley (number) scale by y
	         o shear (number) shear
	         o rotate (number) rotation in deg
	         o isSimple (boolean) could it be represented via simple transformations
	        \*/
	        matrixproto.split = function () {
	            var out = {};
	            // translation
	            out.dx = this.e;
	            out.dy = this.f;
	
	            // scale and shear
	            var row = [[this.a, this.c], [this.b, this.d]];
	            out.scalex = math.sqrt(norm(row[0]));
	            normalize(row[0]);
	
	            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
	            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
	
	            out.scaley = math.sqrt(norm(row[1]));
	            normalize(row[1]);
	            out.shear /= out.scaley;
	
	            // rotation
	            var sin = -row[0][1],
	                cos = row[1][1];
	            if (cos < 0) {
	                out.rotate = R.deg(math.acos(cos));
	                if (sin < 0) {
	                    out.rotate = 360 - out.rotate;
	                }
	            } else {
	                out.rotate = R.deg(math.asin(sin));
	            }
	
	            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
	            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
	            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
	            return out;
	        };
	        /*\
	         * Matrix.toTransformString
	         [ method ]
	         **
	         * Return transform string that represents given matrix
	         = (string) transform string
	        \*/
	        matrixproto.toTransformString = function (shorter) {
	            var s = shorter || this[split]();
	            if (s.isSimple) {
	                s.scalex = +s.scalex.toFixed(4);
	                s.scaley = +s.scaley.toFixed(4);
	                s.rotate = +s.rotate.toFixed(4);
	                return  (s.dx || s.dy ? "t" + [s.dx, s.dy] : E) +
	                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E) +
	                        (s.rotate ? "r" + [s.rotate, 0, 0] : E);
	            } else {
	                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
	            }
	        };
	    })(Matrix.prototype);
	
	    var preventDefault = function () {
	        this.returnValue = false;
	    },
	    preventTouch = function () {
	        return this.originalEvent.preventDefault();
	    },
	    stopPropagation = function () {
	        this.cancelBubble = true;
	    },
	    stopTouch = function () {
	        return this.originalEvent.stopPropagation();
	    },
	    getEventPosition = function (e) {
	        var scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
	            scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft;
	
	        return {
	            x: e.clientX + scrollX,
	            y: e.clientY + scrollY
	        };
	    },
	    addEvent = (function () {
	        if (g.doc.addEventListener) {
	            return function (obj, type, fn, element) {
	                var f = function (e) {
	                    var pos = getEventPosition(e);
	                    return fn.call(element, e, pos.x, pos.y);
	                };
	                obj.addEventListener(type, f, false);
	
	                if (supportsTouch && touchMap[type]) {
	                    var _f = function (e) {
	                        var pos = getEventPosition(e),
	                            olde = e;
	
	                        for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
	                            if (e.targetTouches[i].target == obj) {
	                                e = e.targetTouches[i];
	                                e.originalEvent = olde;
	                                e.preventDefault = preventTouch;
	                                e.stopPropagation = stopTouch;
	                                break;
	                            }
	                        }
	
	                        return fn.call(element, e, pos.x, pos.y);
	                    };
	                    obj.addEventListener(touchMap[type], _f, false);
	                }
	
	                return function () {
	                    obj.removeEventListener(type, f, false);
	
	                    if (supportsTouch && touchMap[type])
	                        obj.removeEventListener(touchMap[type], _f, false);
	
	                    return true;
	                };
	            };
	        } else if (g.doc.attachEvent) {
	            return function (obj, type, fn, element) {
	                var f = function (e) {
	                    e = e || g.win.event;
	                    var scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
	                        scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
	                        x = e.clientX + scrollX,
	                        y = e.clientY + scrollY;
	                    e.preventDefault = e.preventDefault || preventDefault;
	                    e.stopPropagation = e.stopPropagation || stopPropagation;
	                    return fn.call(element, e, x, y);
	                };
	                obj.attachEvent("on" + type, f);
	                var detacher = function () {
	                    obj.detachEvent("on" + type, f);
	                    return true;
	                };
	                return detacher;
	            };
	        }
	    })(),
	    drag = [],
	    dragMove = function (e) {
	        var x = e.clientX,
	            y = e.clientY,
	            scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
	            scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft,
	            dragi,
	            j = drag.length;
	        while (j--) {
	            dragi = drag[j];
	            if (supportsTouch && e.touches) {
	                var i = e.touches.length,
	                    touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    if (touch.identifier == dragi.el._drag.id) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        (e.originalEvent ? e.originalEvent : e).preventDefault();
	                        break;
	                    }
	                }
	            } else {
	                e.preventDefault();
	            }
	            var node = dragi.el.node,
	                o,
	                next = node.nextSibling,
	                parent = node.parentNode,
	                display = node.style.display;
	            g.win.opera && parent.removeChild(node);
	            node.style.display = "none";
	            o = dragi.el.paper.getElementByPoint(x, y);
	            node.style.display = display;
	            g.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
	            o && eve("raphael.drag.over." + dragi.el.id, dragi.el, o);
	            x += scrollX;
	            y += scrollY;
	            eve("raphael.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
	        }
	    },
	    dragUp = function (e) {
	        R.unmousemove(dragMove).unmouseup(dragUp);
	        var i = drag.length,
	            dragi;
	        while (i--) {
	            dragi = drag[i];
	            dragi.el._drag = {};
	            eve("raphael.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
	        }
	        drag = [];
	    },
	    /*\
	     * Raphael.el
	     [ property (object) ]
	     **
	     * You can add your own method to elements. This is useful when you want to hack default functionality or
	     * want to wrap some common transformation or attributes in one method. In difference to canvas methods,
	     * you can redefine element method at any time. Expending element methods wouldn’t affect set.
	     > Usage
	     | Raphael.el.red = function () {
	     |     this.attr({fill: "#f00"});
	     | };
	     | // then use it
	     | paper.circle(100, 100, 20).red();
	    \*/
	    elproto = R.el = {};
	    /*\
	     * Element.click
	     [ method ]
	     **
	     * Adds event handler for click for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unclick
	     [ method ]
	     **
	     * Removes event handler for click for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.dblclick
	     [ method ]
	     **
	     * Adds event handler for double click for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.undblclick
	     [ method ]
	     **
	     * Removes event handler for double click for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.mousedown
	     [ method ]
	     **
	     * Adds event handler for mousedown for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousedown
	     [ method ]
	     **
	     * Removes event handler for mousedown for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.mousemove
	     [ method ]
	     **
	     * Adds event handler for mousemove for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmousemove
	     [ method ]
	     **
	     * Removes event handler for mousemove for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.mouseout
	     [ method ]
	     **
	     * Adds event handler for mouseout for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseout
	     [ method ]
	     **
	     * Removes event handler for mouseout for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.mouseover
	     [ method ]
	     **
	     * Adds event handler for mouseover for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseover
	     [ method ]
	     **
	     * Removes event handler for mouseover for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.mouseup
	     [ method ]
	     **
	     * Adds event handler for mouseup for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.unmouseup
	     [ method ]
	     **
	     * Removes event handler for mouseup for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.touchstart
	     [ method ]
	     **
	     * Adds event handler for touchstart for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchstart
	     [ method ]
	     **
	     * Removes event handler for touchstart for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.touchmove
	     [ method ]
	     **
	     * Adds event handler for touchmove for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchmove
	     [ method ]
	     **
	     * Removes event handler for touchmove for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.touchend
	     [ method ]
	     **
	     * Adds event handler for touchend for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchend
	     [ method ]
	     **
	     * Removes event handler for touchend for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	
	    /*\
	     * Element.touchcancel
	     [ method ]
	     **
	     * Adds event handler for touchcancel for the element.
	     > Parameters
	     - handler (function) handler for the event
	     = (object) @Element
	    \*/
	    /*\
	     * Element.untouchcancel
	     [ method ]
	     **
	     * Removes event handler for touchcancel for the element.
	     > Parameters
	     - handler (function) #optional handler for the event
	     = (object) @Element
	    \*/
	    for (var i = events.length; i--;) {
	        (function (eventName) {
	            R[eventName] = elproto[eventName] = function (fn, scope) {
	                if (R.is(fn, "function")) {
	                    this.events = this.events || [];
	                    this.events.push({name: eventName, f: fn, unbind: addEvent(this.shape || this.node || g.doc, eventName, fn, scope || this)});
	                }
	                return this;
	            };
	            R["un" + eventName] = elproto["un" + eventName] = function (fn) {
	                var events = this.events || [],
	                    l = events.length;
	                while (l--){
	                    if (events[l].name == eventName && (R.is(fn, "undefined") || events[l].f == fn)) {
	                        events[l].unbind();
	                        events.splice(l, 1);
	                        !events.length && delete this.events;
	                    }
	                }
	                return this;
	            };
	        })(events[i]);
	    }
	
	    /*\
	     * Element.data
	     [ method ]
	     **
	     * Adds or retrieves given value associated with given key.
	     **
	     * See also @Element.removeData
	     > Parameters
	     - key (string) key to store data
	     - value (any) #optional value to store
	     = (object) @Element
	     * or, if value is not specified:
	     = (any) value
	     * or, if key and value are not specified:
	     = (object) Key/value pairs for all the data associated with the element.
	     > Usage
	     | for (var i = 0, i < 5, i++) {
	     |     paper.circle(10 + 15 * i, 10, 10)
	     |          .attr({fill: "#000"})
	     |          .data("i", i)
	     |          .click(function () {
	     |             alert(this.data("i"));
	     |          });
	     | }
	    \*/
	    elproto.data = function (key, value) {
	        var data = eldata[this.id] = eldata[this.id] || {};
	        if (arguments.length == 0) {
	            return data;
	        }
	        if (arguments.length == 1) {
	            if (R.is(key, "object")) {
	                for (var i in key) if (key[has](i)) {
	                    this.data(i, key[i]);
	                }
	                return this;
	            }
	            eve("raphael.data.get." + this.id, this, data[key], key);
	            return data[key];
	        }
	        data[key] = value;
	        eve("raphael.data.set." + this.id, this, value, key);
	        return this;
	    };
	    /*\
	     * Element.removeData
	     [ method ]
	     **
	     * Removes value associated with an element by given key.
	     * If key is not provided, removes all the data of the element.
	     > Parameters
	     - key (string) #optional key
	     = (object) @Element
	    \*/
	    elproto.removeData = function (key) {
	        if (key == null) {
	            delete eldata[this.id];
	        } else {
	            eldata[this.id] && delete eldata[this.id][key];
	        }
	        return this;
	    };
	     /*\
	     * Element.getData
	     [ method ]
	     **
	     * Retrieves the element data
	     = (object) data
	    \*/
	    elproto.getData = function () {
	        return clone(eldata[this.id] || {});
	    };
	    /*\
	     * Element.hover
	     [ method ]
	     **
	     * Adds event handlers for hover for the element.
	     > Parameters
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     - icontext (object) #optional context for hover in handler
	     - ocontext (object) #optional context for hover out handler
	     = (object) @Element
	    \*/
	    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
	        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
	    };
	    /*\
	     * Element.unhover
	     [ method ]
	     **
	     * Removes event handlers for hover for the element.
	     > Parameters
	     - f_in (function) handler for hover in
	     - f_out (function) handler for hover out
	     = (object) @Element
	    \*/
	    elproto.unhover = function (f_in, f_out) {
	        return this.unmouseover(f_in).unmouseout(f_out);
	    };
	    var draggable = [];
	    /*\
	     * Element.drag
	     [ method ]
	     **
	     * Adds event handlers for drag of the element.
	     > Parameters
	     - onmove (function) handler for moving
	     - onstart (function) handler for drag start
	     - onend (function) handler for drag end
	     - mcontext (object) #optional context for moving handler
	     - scontext (object) #optional context for drag start handler
	     - econtext (object) #optional context for drag end handler
	     * Additionally following `drag` events will be triggered: `drag.start.<id>` on start,
	     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element will be dragged over another element
	     * `drag.over.<id>` will be fired as well.
	     *
	     * Start event and start handler will be called in specified context or in context of the element with following parameters:
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * Move event and move handler will be called in specified context or in context of the element with following parameters:
	     o dx (number) shift by x from the start point
	     o dy (number) shift by y from the start point
	     o x (number) x position of the mouse
	     o y (number) y position of the mouse
	     o event (object) DOM event object
	     * End event and end handler will be called in specified context or in context of the element with following parameters:
	     o event (object) DOM event object
	     = (object) @Element
	    \*/
	    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
	        function start(e) {
	            (e.originalEvent || e).preventDefault();
	            var x = e.clientX,
	                y = e.clientY,
	                scrollY = g.doc.documentElement.scrollTop || g.doc.body.scrollTop,
	                scrollX = g.doc.documentElement.scrollLeft || g.doc.body.scrollLeft;
	            this._drag.id = e.identifier;
	            if (supportsTouch && e.touches) {
	                var i = e.touches.length, touch;
	                while (i--) {
	                    touch = e.touches[i];
	                    this._drag.id = touch.identifier;
	                    if (touch.identifier == this._drag.id) {
	                        x = touch.clientX;
	                        y = touch.clientY;
	                        break;
	                    }
	                }
	            }
	            this._drag.x = x + scrollX;
	            this._drag.y = y + scrollY;
	            !drag.length && R.mousemove(dragMove).mouseup(dragUp);
	            drag.push({el: this, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
	            onstart && eve.on("raphael.drag.start." + this.id, onstart);
	            onmove && eve.on("raphael.drag.move." + this.id, onmove);
	            onend && eve.on("raphael.drag.end." + this.id, onend);
	            eve("raphael.drag.start." + this.id, start_scope || move_scope || this, this._drag.x, this._drag.y, e);
	        }
	        this._drag = {};
	        draggable.push({el: this, start: start});
	        this.mousedown(start);
	        return this;
	    };
	    /*\
	     * Element.onDragOver
	     [ method ]
	     **
	     * Shortcut for assigning event handler for `drag.over.<id>` event, where id is id of the element (see @Element.id).
	     > Parameters
	     - f (function) handler for event, first argument would be the element you are dragging over
	    \*/
	    elproto.onDragOver = function (f) {
	        f ? eve.on("raphael.drag.over." + this.id, f) : eve.unbind("raphael.drag.over." + this.id);
	    };
	    /*\
	     * Element.undrag
	     [ method ]
	     **
	     * Removes all drag event handlers from given element.
	    \*/
	    elproto.undrag = function () {
	        var i = draggable.length;
	        while (i--) if (draggable[i].el == this) {
	            this.unmousedown(draggable[i].start);
	            draggable.splice(i, 1);
	            eve.unbind("raphael.drag.*." + this.id);
	        }
	        !draggable.length && R.unmousemove(dragMove).unmouseup(dragUp);
	        drag = [];
	    };
	    /*\
	     * Paper.circle
	     [ method ]
	     **
	     * Draws a circle.
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - r (number) radius
	     = (object) Raphaël element object with type “circle”
	     **
	     > Usage
	     | var c = paper.circle(50, 50, 40);
	    \*/
	    paperproto.circle = function (x, y, r) {
	        var out = R._engine.circle(this, x || 0, y || 0, r || 0);
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.rect
	     [ method ]
	     *
	     * Draws a rectangle.
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the top left corner
	     - y (number) y coordinate of the top left corner
	     - width (number) width
	     - height (number) height
	     - r (number) #optional radius for rounded corners, default is 0
	     = (object) Raphaël element object with type “rect”
	     **
	     > Usage
	     | // regular rectangle
	     | var c = paper.rect(10, 10, 50, 50);
	     | // rectangle with rounded corners
	     | var c = paper.rect(40, 40, 50, 50, 10);
	    \*/
	    paperproto.rect = function (x, y, w, h, r) {
	        var out = R._engine.rect(this, x || 0, y || 0, w || 0, h || 0, r || 0);
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.ellipse
	     [ method ]
	     **
	     * Draws an ellipse.
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the centre
	     - y (number) y coordinate of the centre
	     - rx (number) horizontal radius
	     - ry (number) vertical radius
	     = (object) Raphaël element object with type “ellipse”
	     **
	     > Usage
	     | var c = paper.ellipse(50, 50, 40, 20);
	    \*/
	    paperproto.ellipse = function (x, y, rx, ry) {
	        var out = R._engine.ellipse(this, x || 0, y || 0, rx || 0, ry || 0);
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.path
	     [ method ]
	     **
	     * Creates a path element by given path data string.
	     > Parameters
	     - pathString (string) #optional path string in SVG format.
	     * Path string consists of one-letter commands, followed by comma seprarated arguments in numercal form. Example:
	     | "M10,20L30,40"
	     * Here we can see two commands: “M”, with arguments `(10, 20)` and “L” with arguments `(30, 40)`. Upper case letter mean command is absolute, lower case—relative.
	     *
	     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a>.</p>
	     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
	     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
	     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
	     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
	     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
	     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
	     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
	     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
	     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
	     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
	     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
	     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
	     * * “Catmull-Rom curveto” is a not standard SVG command and added in 2.0 to make life easier.
	     * Note: there is a special case when path consist of just three commands: “M10,10R…z”. In this case path will smoothly connects to its beginning.
	     > Usage
	     | var c = paper.path("M10 10L90 90");
	     | // draw a diagonal line:
	     | // move to 10,10, line to 90,90
	     * For example of path strings, check out these icons: http://raphaeljs.com/icons/
	    \*/
	    paperproto.path = function (pathString) {
	        pathString && !R.is(pathString, string) && !R.is(pathString[0], array) && (pathString += E);
	        var out = R._engine.path(R.format[apply](R, arguments), this);
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.image
	     [ method ]
	     **
	     * Embeds an image into the surface.
	     **
	     > Parameters
	     **
	     - src (string) URI of the source image
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - width (number) width of the image
	     - height (number) height of the image
	     = (object) Raphaël element object with type “image”
	     **
	     > Usage
	     | var c = paper.image("apple.png", 10, 10, 80, 80);
	    \*/
	    paperproto.image = function (src, x, y, w, h) {
	        var out = R._engine.image(this, src || "about:blank", x || 0, y || 0, w || 0, h || 0);
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.text
	     [ method ]
	     **
	     * Draws a text string. If you need line breaks, put “\n” in the string.
	     **
	     > Parameters
	     **
	     - x (number) x coordinate position
	     - y (number) y coordinate position
	     - text (string) The text string to draw
	     = (object) Raphaël element object with type “text”
	     **
	     > Usage
	     | var t = paper.text(50, 50, "Raphaël\nkicks\nbutt!");
	    \*/
	    paperproto.text = function (x, y, text) {
	        var out = R._engine.text(this, x || 0, y || 0, Str(text));
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Paper.set
	     [ method ]
	     **
	     * Creates array-like object to keep and operate several elements at once.
	     * Warning: it doesn’t create any elements for itself in the page, it just groups existing elements.
	     * Sets act as pseudo elements — all methods available to an element can be used on a set.
	     = (object) array-like object that represents set of elements
	     **
	     > Usage
	     | var st = paper.set();
	     | st.push(
	     |     paper.circle(10, 10, 5),
	     |     paper.circle(30, 10, 5)
	     | );
	     | st.attr({fill: "red"}); // changes the fill of both circles
	    \*/
	    paperproto.set = function (itemsArray) {
	        !R.is(itemsArray, "array") && (itemsArray = Array.prototype.splice.call(arguments, 0, arguments.length));
	        var out = new Set(itemsArray);
	        this.__set__ && this.__set__.push(out);
	        out["paper"] = this;
	        out["type"] = "set";
	        return out;
	    };
	    /*\
	     * Paper.setStart
	     [ method ]
	     **
	     * Creates @Paper.set. All elements that will be created after calling this method and before calling
	     * @Paper.setFinish will be added to the set.
	     **
	     > Usage
	     | paper.setStart();
	     | paper.circle(10, 10, 5),
	     | paper.circle(30, 10, 5)
	     | var st = paper.setFinish();
	     | st.attr({fill: "red"}); // changes the fill of both circles
	    \*/
	    paperproto.setStart = function (set) {
	        this.__set__ = set || this.set();
	    };
	    /*\
	     * Paper.setFinish
	     [ method ]
	     **
	     * See @Paper.setStart. This method finishes catching and returns resulting set.
	     **
	     = (object) set
	    \*/
	    paperproto.setFinish = function (set) {
	        var out = this.__set__;
	        delete this.__set__;
	        return out;
	    };
	    /*\
	     * Paper.getSize
	     [ method ]
	     **
	     * Obtains current paper actual size.
	     **
	     = (object)
	     \*/
	    paperproto.getSize = function () {
	        var container = this.canvas.parentNode;
	        return {
	            width: container.offsetWidth,
	            height: container.offsetHeight
	                };
	        };
	    /*\
	     * Paper.setSize
	     [ method ]
	     **
	     * If you need to change dimensions of the canvas call this method
	     **
	     > Parameters
	     **
	     - width (number) new width of the canvas
	     - height (number) new height of the canvas
	    \*/
	    paperproto.setSize = function (width, height) {
	        return R._engine.setSize.call(this, width, height);
	    };
	    /*\
	     * Paper.setViewBox
	     [ method ]
	     **
	     * Sets the view box of the paper. Practically it gives you ability to zoom and pan whole paper surface by
	     * specifying new boundaries.
	     **
	     > Parameters
	     **
	     - x (number) new x position, default is `0`
	     - y (number) new y position, default is `0`
	     - w (number) new width of the canvas
	     - h (number) new height of the canvas
	     - fit (boolean) `true` if you want graphics to fit into new boundary box
	    \*/
	    paperproto.setViewBox = function (x, y, w, h, fit) {
	        return R._engine.setViewBox.call(this, x, y, w, h, fit);
	    };
	    /*\
	     * Paper.top
	     [ property ]
	     **
	     * Points to the topmost element on the paper
	    \*/
	    /*\
	     * Paper.bottom
	     [ property ]
	     **
	     * Points to the bottom element on the paper
	    \*/
	    paperproto.top = paperproto.bottom = null;
	    /*\
	     * Paper.raphael
	     [ property ]
	     **
	     * Points to the @Raphael object/function
	    \*/
	    paperproto.raphael = R;
	    var getOffset = function (elem) {
	        var box = elem.getBoundingClientRect(),
	            doc = elem.ownerDocument,
	            body = doc.body,
	            docElem = doc.documentElement,
	            clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
	            top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
	            left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
	        return {
	            y: top,
	            x: left
	        };
	    };
	    /*\
	     * Paper.getElementByPoint
	     [ method ]
	     **
	     * Returns you topmost element under given point.
	     **
	     = (object) Raphaël element object
	     > Parameters
	     **
	     - x (number) x coordinate from the top left corner of the window
	     - y (number) y coordinate from the top left corner of the window
	     > Usage
	     | paper.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
	    \*/
	    paperproto.getElementByPoint = function (x, y) {
	        var paper = this,
	            svg = paper.canvas,
	            target = g.doc.elementFromPoint(x, y);
	        if (g.win.opera && target.tagName == "svg") {
	            var so = getOffset(svg),
	                sr = svg.createSVGRect();
	            sr.x = x - so.x;
	            sr.y = y - so.y;
	            sr.width = sr.height = 1;
	            var hits = svg.getIntersectionList(sr, null);
	            if (hits.length) {
	                target = hits[hits.length - 1];
	            }
	        }
	        if (!target) {
	            return null;
	        }
	        while (target.parentNode && target != svg.parentNode && !target.raphael) {
	            target = target.parentNode;
	        }
	        target == paper.canvas.parentNode && (target = svg);
	        target = target && target.raphael ? paper.getById(target.raphaelid) : null;
	        return target;
	    };
	
	    /*\
	     * Paper.getElementsByBBox
	     [ method ]
	     **
	     * Returns set of elements that have an intersecting bounding box
	     **
	     > Parameters
	     **
	     - bbox (object) bbox to check with
	     = (object) @Set
	     \*/
	    paperproto.getElementsByBBox = function (bbox) {
	        var set = this.set();
	        this.forEach(function (el) {
	            if (R.isBBoxIntersect(el.getBBox(), bbox)) {
	                set.push(el);
	            }
	        });
	        return set;
	    };
	
	    /*\
	     * Paper.getById
	     [ method ]
	     **
	     * Returns you element by its internal ID.
	     **
	     > Parameters
	     **
	     - id (number) id
	     = (object) Raphaël element object
	    \*/
	    paperproto.getById = function (id) {
	        var bot = this.bottom;
	        while (bot) {
	            if (bot.id == id) {
	                return bot;
	            }
	            bot = bot.next;
	        }
	        return null;
	    };
	    /*\
	     * Paper.forEach
	     [ method ]
	     **
	     * Executes given function for each element on the paper
	     *
	     * If callback function returns `false` it will stop loop running.
	     **
	     > Parameters
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Paper object
	     > Usage
	     | paper.forEach(function (el) {
	     |     el.attr({ stroke: "blue" });
	     | });
	    \*/
	    paperproto.forEach = function (callback, thisArg) {
	        var bot = this.bottom;
	        while (bot) {
	            if (callback.call(thisArg, bot) === false) {
	                return this;
	            }
	            bot = bot.next;
	        }
	        return this;
	    };
	    /*\
	     * Paper.getElementsByPoint
	     [ method ]
	     **
	     * Returns set of elements that have common point inside
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the point
	     - y (number) y coordinate of the point
	     = (object) @Set
	    \*/
	    paperproto.getElementsByPoint = function (x, y) {
	        var set = this.set();
	        this.forEach(function (el) {
	            if (el.isPointInside(x, y)) {
	                set.push(el);
	            }
	        });
	        return set;
	    };
	    function x_y() {
	        return this.x + S + this.y;
	    }
	    function x_y_w_h() {
	        return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
	    }
	    /*\
	     * Element.isPointInside
	     [ method ]
	     **
	     * Determine if given point is inside this element’s shape
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the point
	     - y (number) y coordinate of the point
	     = (boolean) `true` if point inside the shape
	    \*/
	    elproto.isPointInside = function (x, y) {
	        var rp = this.realPath = getPath[this.type](this);
	        if (this.attr('transform') && this.attr('transform').length) {
	            rp = R.transformPath(rp, this.attr('transform'));
	        }
	        return R.isPointInsidePath(rp, x, y);
	    };
	    /*\
	     * Element.getBBox
	     [ method ]
	     **
	     * Return bounding box for a given element
	     **
	     > Parameters
	     **
	     - isWithoutTransform (boolean) flag, `true` if you want to have bounding box before transformations. Default is `false`.
	     = (object) Bounding box object:
	     o {
	     o     x: (number) top left corner x
	     o     y: (number) top left corner y
	     o     x2: (number) bottom right corner x
	     o     y2: (number) bottom right corner y
	     o     width: (number) width
	     o     height: (number) height
	     o }
	    \*/
	    elproto.getBBox = function (isWithoutTransform) {
	        if (this.removed) {
	            return {};
	        }
	        var _ = this._;
	        if (isWithoutTransform) {
	            if (_.dirty || !_.bboxwt) {
	                this.realPath = getPath[this.type](this);
	                _.bboxwt = pathDimensions(this.realPath);
	                _.bboxwt.toString = x_y_w_h;
	                _.dirty = 0;
	            }
	            return _.bboxwt;
	        }
	        if (_.dirty || _.dirtyT || !_.bbox) {
	            if (_.dirty || !this.realPath) {
	                _.bboxwt = 0;
	                this.realPath = getPath[this.type](this);
	            }
	            _.bbox = pathDimensions(mapPath(this.realPath, this.matrix));
	            _.bbox.toString = x_y_w_h;
	            _.dirty = _.dirtyT = 0;
	        }
	        return _.bbox;
	    };
	    /*\
	     * Element.clone
	     [ method ]
	     **
	     = (object) clone of a given element
	     **
	    \*/
	    elproto.clone = function () {
	        if (this.removed) {
	            return null;
	        }
	        var out = this.paper[this.type]().attr(this.attr());
	        this.__set__ && this.__set__.push(out);
	        return out;
	    };
	    /*\
	     * Element.glow
	     [ method ]
	     **
	     * Return set of elements that create glow-like effect around given element. See @Paper.set.
	     *
	     * Note: Glow is not connected to the element. If you change element attributes it won’t adjust itself.
	     **
	     > Parameters
	     **
	     - glow (object) #optional parameters object with all properties optional:
	     o {
	     o     width (number) size of the glow, default is `10`
	     o     fill (boolean) will it be filled, default is `false`
	     o     opacity (number) opacity, default is `0.5`
	     o     offsetx (number) horizontal offset, default is `0`
	     o     offsety (number) vertical offset, default is `0`
	     o     color (string) glow colour, default is `black`
	     o }
	     = (object) @Paper.set of elements that represents glow
	    \*/
	    elproto.glow = function (glow) {
	        if (this.type == "text") {
	            return null;
	        }
	        glow = glow || {};
	        var s = {
	            width: (glow.width || 10) + (+this.attr("stroke-width") || 1),
	            fill: glow.fill || false,
	            opacity: glow.opacity == null ? .5 : glow.opacity,
	            offsetx: glow.offsetx || 0,
	            offsety: glow.offsety || 0,
	            color: glow.color || "#000"
	        },
	            c = s.width / 2,
	            r = this.paper,
	            out = r.set(),
	            path = this.realPath || getPath[this.type](this);
	        path = this.matrix ? mapPath(path, this.matrix) : path;
	        for (var i = 1; i < c + 1; i++) {
	            out.push(r.path(path).attr({
	                stroke: s.color,
	                fill: s.fill ? s.color : "none",
	                "stroke-linejoin": "round",
	                "stroke-linecap": "round",
	                "stroke-width": +(s.width / c * i).toFixed(3),
	                opacity: +(s.opacity / c).toFixed(3)
	            }));
	        }
	        return out.insertBefore(this).translate(s.offsetx, s.offsety);
	    };
	    var curveslengths = {},
	    getPointAtSegmentLength = function (p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
	        if (length == null) {
	            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
	        } else {
	            return R.findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, getTatLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
	        }
	    },
	    getLengthFactory = function (istotal, subpath) {
	        return function (path, length, onlystart) {
	            path = path2curve(path);
	            var x, y, p, l, sp = "", subpaths = {}, point,
	                len = 0;
	            for (var i = 0, ii = path.length; i < ii; i++) {
	                p = path[i];
	                if (p[0] == "M") {
	                    x = +p[1];
	                    y = +p[2];
	                } else {
	                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
	                    if (len + l > length) {
	                        if (subpath && !subpaths.start) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            sp += ["C" + point.start.x, point.start.y, point.m.x, point.m.y, point.x, point.y];
	                            if (onlystart) {return sp;}
	                            subpaths.start = sp;
	                            sp = ["M" + point.x, point.y + "C" + point.n.x, point.n.y, point.end.x, point.end.y, p[5], p[6]].join();
	                            len += l;
	                            x = +p[5];
	                            y = +p[6];
	                            continue;
	                        }
	                        if (!istotal && !subpath) {
	                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
	                            return {x: point.x, y: point.y, alpha: point.alpha};
	                        }
	                    }
	                    len += l;
	                    x = +p[5];
	                    y = +p[6];
	                }
	                sp += p.shift() + p;
	            }
	            subpaths.end = sp;
	            point = istotal ? len : subpath ? subpaths : R.findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
	            point.alpha && (point = {x: point.x, y: point.y, alpha: point.alpha});
	            return point;
	        };
	    };
	    var getTotalLength = getLengthFactory(1),
	        getPointAtLength = getLengthFactory(),
	        getSubpathsAtLength = getLengthFactory(0, 1);
	    /*\
	     * Raphael.getTotalLength
	     [ method ]
	     **
	     * Returns length of the given path in pixels.
	     **
	     > Parameters
	     **
	     - path (string) SVG path string.
	     **
	     = (number) length.
	    \*/
	    R.getTotalLength = getTotalLength;
	    /*\
	     * Raphael.getPointAtLength
	     [ method ]
	     **
	     * Return coordinates of the point located at the given length on the given path.
	     **
	     > Parameters
	     **
	     - path (string) SVG path string
	     - length (number)
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate
	     o     y: (number) y coordinate
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    R.getPointAtLength = getPointAtLength;
	    /*\
	     * Raphael.getSubpath
	     [ method ]
	     **
	     * Return subpath of a given path from given length to given length.
	     **
	     > Parameters
	     **
	     - path (string) SVG path string
	     - from (number) position of the start of the segment
	     - to (number) position of the end of the segment
	     **
	     = (string) pathstring for the segment
	    \*/
	    R.getSubpath = function (path, from, to) {
	        if (this.getTotalLength(path) - to < 1e-6) {
	            return getSubpathsAtLength(path, from).end;
	        }
	        var a = getSubpathsAtLength(path, to, 1);
	        return from ? getSubpathsAtLength(a, from).end : a;
	    };
	    /*\
	     * Element.getTotalLength
	     [ method ]
	     **
	     * Returns length of the path in pixels. Only works for element of “path” type.
	     = (number) length.
	    \*/
	    elproto.getTotalLength = function () {
	        var path = this.getPath();
	        if (!path) {
	            return;
	        }
	
	        if (this.node.getTotalLength) {
	            return this.node.getTotalLength();
	        }
	
	        return getTotalLength(path);
	    };
	    /*\
	     * Element.getPointAtLength
	     [ method ]
	     **
	     * Return coordinates of the point located at the given length on the given path. Only works for element of “path” type.
	     **
	     > Parameters
	     **
	     - length (number)
	     **
	     = (object) representation of the point:
	     o {
	     o     x: (number) x coordinate
	     o     y: (number) y coordinate
	     o     alpha: (number) angle of derivative
	     o }
	    \*/
	    elproto.getPointAtLength = function (length) {
	        var path = this.getPath();
	        if (!path) {
	            return;
	        }
	
	        return getPointAtLength(path, length);
	    };
	    /*\
	     * Element.getPath
	     [ method ]
	     **
	     * Returns path of the element. Only works for elements of “path” type and simple elements like circle.
	     = (object) path
	     **
	    \*/
	    elproto.getPath = function () {
	        var path,
	            getPath = R._getPath[this.type];
	
	        if (this.type == "text" || this.type == "set") {
	            return;
	        }
	
	        if (getPath) {
	            path = getPath(this);
	        }
	
	        return path;
	    };
	    /*\
	     * Element.getSubpath
	     [ method ]
	     **
	     * Return subpath of a given element from given length to given length. Only works for element of “path” type.
	     **
	     > Parameters
	     **
	     - from (number) position of the start of the segment
	     - to (number) position of the end of the segment
	     **
	     = (string) pathstring for the segment
	    \*/
	    elproto.getSubpath = function (from, to) {
	        var path = this.getPath();
	        if (!path) {
	            return;
	        }
	
	        return R.getSubpath(path, from, to);
	    };
	    /*\
	     * Raphael.easing_formulas
	     [ property ]
	     **
	     * Object that contains easing formulas for animation. You could extend it with your own. By default it has following list of easing:
	     # <ul>
	     #     <li>“linear”</li>
	     #     <li>“&lt;” or “easeIn” or “ease-in”</li>
	     #     <li>“>” or “easeOut” or “ease-out”</li>
	     #     <li>“&lt;>” or “easeInOut” or “ease-in-out”</li>
	     #     <li>“backIn” or “back-in”</li>
	     #     <li>“backOut” or “back-out”</li>
	     #     <li>“elastic”</li>
	     #     <li>“bounce”</li>
	     # </ul>
	     # <p>See also <a href="http://raphaeljs.com/easing.html">Easing demo</a>.</p>
	    \*/
	    var ef = R.easing_formulas = {
	        linear: function (n) {
	            return n;
	        },
	        "<": function (n) {
	            return pow(n, 1.7);
	        },
	        ">": function (n) {
	            return pow(n, .48);
	        },
	        "<>": function (n) {
	            var q = .48 - n / 1.04,
	                Q = math.sqrt(.1734 + q * q),
	                x = Q - q,
	                X = pow(abs(x), 1 / 3) * (x < 0 ? -1 : 1),
	                y = -Q - q,
	                Y = pow(abs(y), 1 / 3) * (y < 0 ? -1 : 1),
	                t = X + Y + .5;
	            return (1 - t) * 3 * t * t + t * t * t;
	        },
	        backIn: function (n) {
	            var s = 1.70158;
	            return n * n * ((s + 1) * n - s);
	        },
	        backOut: function (n) {
	            n = n - 1;
	            var s = 1.70158;
	            return n * n * ((s + 1) * n + s) + 1;
	        },
	        elastic: function (n) {
	            if (n == !!n) {
	                return n;
	            }
	            return pow(2, -10 * n) * math.sin((n - .075) * (2 * PI) / .3) + 1;
	        },
	        bounce: function (n) {
	            var s = 7.5625,
	                p = 2.75,
	                l;
	            if (n < (1 / p)) {
	                l = s * n * n;
	            } else {
	                if (n < (2 / p)) {
	                    n -= (1.5 / p);
	                    l = s * n * n + .75;
	                } else {
	                    if (n < (2.5 / p)) {
	                        n -= (2.25 / p);
	                        l = s * n * n + .9375;
	                    } else {
	                        n -= (2.625 / p);
	                        l = s * n * n + .984375;
	                    }
	                }
	            }
	            return l;
	        }
	    };
	    ef.easeIn = ef["ease-in"] = ef["<"];
	    ef.easeOut = ef["ease-out"] = ef[">"];
	    ef.easeInOut = ef["ease-in-out"] = ef["<>"];
	    ef["back-in"] = ef.backIn;
	    ef["back-out"] = ef.backOut;
	
	    var animationElements = [],
	        requestAnimFrame = window.requestAnimationFrame       ||
	                           window.webkitRequestAnimationFrame ||
	                           window.mozRequestAnimationFrame    ||
	                           window.oRequestAnimationFrame      ||
	                           window.msRequestAnimationFrame     ||
	                           function (callback) {
	                               setTimeout(callback, 16);
	                           },
	        animation = function () {
	            var Now = +new Date,
	                l = 0;
	            for (; l < animationElements.length; l++) {
	                var e = animationElements[l];
	                if (e.el.removed || e.paused) {
	                    continue;
	                }
	                var time = Now - e.start,
	                    ms = e.ms,
	                    easing = e.easing,
	                    from = e.from,
	                    diff = e.diff,
	                    to = e.to,
	                    t = e.t,
	                    that = e.el,
	                    set = {},
	                    now,
	                    init = {},
	                    key;
	                if (e.initstatus) {
	                    time = (e.initstatus * e.anim.top - e.prev) / (e.percent - e.prev) * ms;
	                    e.status = e.initstatus;
	                    delete e.initstatus;
	                    e.stop && animationElements.splice(l--, 1);
	                } else {
	                    e.status = (e.prev + (e.percent - e.prev) * (time / ms)) / e.anim.top;
	                }
	                if (time < 0) {
	                    continue;
	                }
	                if (time < ms) {
	                    var pos = easing(time / ms);
	                    for (var attr in from) if (from[has](attr)) {
	                        switch (availableAnimAttrs[attr]) {
	                            case nu:
	                                now = +from[attr] + pos * ms * diff[attr];
	                                break;
	                            case "colour":
	                                now = "rgb(" + [
	                                    upto255(round(from[attr].r + pos * ms * diff[attr].r)),
	                                    upto255(round(from[attr].g + pos * ms * diff[attr].g)),
	                                    upto255(round(from[attr].b + pos * ms * diff[attr].b))
	                                ].join(",") + ")";
	                                break;
	                            case "path":
	                                now = [];
	                                for (var i = 0, ii = from[attr].length; i < ii; i++) {
	                                    now[i] = [from[attr][i][0]];
	                                    for (var j = 1, jj = from[attr][i].length; j < jj; j++) {
	                                        now[i][j] = +from[attr][i][j] + pos * ms * diff[attr][i][j];
	                                    }
	                                    now[i] = now[i].join(S);
	                                }
	                                now = now.join(S);
	                                break;
	                            case "transform":
	                                if (diff[attr].real) {
	                                    now = [];
	                                    for (i = 0, ii = from[attr].length; i < ii; i++) {
	                                        now[i] = [from[attr][i][0]];
	                                        for (j = 1, jj = from[attr][i].length; j < jj; j++) {
	                                            now[i][j] = from[attr][i][j] + pos * ms * diff[attr][i][j];
	                                        }
	                                    }
	                                } else {
	                                    var get = function (i) {
	                                        return +from[attr][i] + pos * ms * diff[attr][i];
	                                    };
	                                    // now = [["r", get(2), 0, 0], ["t", get(3), get(4)], ["s", get(0), get(1), 0, 0]];
	                                    now = [["m", get(0), get(1), get(2), get(3), get(4), get(5)]];
	                                }
	                                break;
	                            case "csv":
	                                if (attr == "clip-rect") {
	                                    now = [];
	                                    i = 4;
	                                    while (i--) {
	                                        now[i] = +from[attr][i] + pos * ms * diff[attr][i];
	                                    }
	                                }
	                                break;
	                            default:
	                                var from2 = [][concat](from[attr]);
	                                now = [];
	                                i = that.paper.customAttributes[attr].length;
	                                while (i--) {
	                                    now[i] = +from2[i] + pos * ms * diff[attr][i];
	                                }
	                                break;
	                        }
	                        set[attr] = now;
	                    }
	                    that.attr(set);
	                    (function (id, that, anim) {
	                        setTimeout(function () {
	                            eve("raphael.anim.frame." + id, that, anim);
	                        });
	                    })(that.id, that, e.anim);
	                } else {
	                    (function(f, el, a) {
	                        setTimeout(function() {
	                            eve("raphael.anim.frame." + el.id, el, a);
	                            eve("raphael.anim.finish." + el.id, el, a);
	                            R.is(f, "function") && f.call(el);
	                        });
	                    })(e.callback, that, e.anim);
	                    that.attr(to);
	                    animationElements.splice(l--, 1);
	                    if (e.repeat > 1 && !e.next) {
	                        for (key in to) if (to[has](key)) {
	                            init[key] = e.totalOrigin[key];
	                        }
	                        e.el.attr(init);
	                        runAnimation(e.anim, e.el, e.anim.percents[0], null, e.totalOrigin, e.repeat - 1);
	                    }
	                    if (e.next && !e.stop) {
	                        runAnimation(e.anim, e.el, e.next, null, e.totalOrigin, e.repeat);
	                    }
	                }
	            }
	            animationElements.length && requestAnimFrame(animation);
	        },
	        upto255 = function (color) {
	            return color > 255 ? 255 : color < 0 ? 0 : color;
	        };
	    /*\
	     * Element.animateWith
	     [ method ]
	     **
	     * Acts similar to @Element.animate, but ensure that given animation runs in sync with another given element.
	     **
	     > Parameters
	     **
	     - el (object) element to sync with
	     - anim (object) animation to sync with
	     - params (object) #optional final attributes for the element, see also @Element.attr
	     - ms (number) #optional number of milliseconds for animation to run
	     - easing (string) #optional easing type. Accept on of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
	     - callback (function) #optional callback function. Will be called at the end of animation.
	     * or
	     - element (object) element to sync with
	     - anim (object) animation to sync with
	     - animation (object) #optional animation object, see @Raphael.animation
	     **
	     = (object) original element
	    \*/
	    elproto.animateWith = function (el, anim, params, ms, easing, callback) {
	        var element = this;
	        if (element.removed) {
	            callback && callback.call(element);
	            return element;
	        }
	        var a = params instanceof Animation ? params : R.animation(params, ms, easing, callback),
	            x, y;
	        runAnimation(a, element, a.percents[0], null, element.attr());
	        for (var i = 0, ii = animationElements.length; i < ii; i++) {
	            if (animationElements[i].anim == anim && animationElements[i].el == el) {
	                animationElements[ii - 1].start = animationElements[i].start;
	                break;
	            }
	        }
	        return element;
	        //
	        //
	        // var a = params ? R.animation(params, ms, easing, callback) : anim,
	        //     status = element.status(anim);
	        // return this.animate(a).status(a, status * anim.ms / a.ms);
	    };
	    function CubicBezierAtTime(t, p1x, p1y, p2x, p2y, duration) {
	        var cx = 3 * p1x,
	            bx = 3 * (p2x - p1x) - cx,
	            ax = 1 - cx - bx,
	            cy = 3 * p1y,
	            by = 3 * (p2y - p1y) - cy,
	            ay = 1 - cy - by;
	        function sampleCurveX(t) {
	            return ((ax * t + bx) * t + cx) * t;
	        }
	        function solve(x, epsilon) {
	            var t = solveCurveX(x, epsilon);
	            return ((ay * t + by) * t + cy) * t;
	        }
	        function solveCurveX(x, epsilon) {
	            var t0, t1, t2, x2, d2, i;
	            for(t2 = x, i = 0; i < 8; i++) {
	                x2 = sampleCurveX(t2) - x;
	                if (abs(x2) < epsilon) {
	                    return t2;
	                }
	                d2 = (3 * ax * t2 + 2 * bx) * t2 + cx;
	                if (abs(d2) < 1e-6) {
	                    break;
	                }
	                t2 = t2 - x2 / d2;
	            }
	            t0 = 0;
	            t1 = 1;
	            t2 = x;
	            if (t2 < t0) {
	                return t0;
	            }
	            if (t2 > t1) {
	                return t1;
	            }
	            while (t0 < t1) {
	                x2 = sampleCurveX(t2);
	                if (abs(x2 - x) < epsilon) {
	                    return t2;
	                }
	                if (x > x2) {
	                    t0 = t2;
	                } else {
	                    t1 = t2;
	                }
	                t2 = (t1 - t0) / 2 + t0;
	            }
	            return t2;
	        }
	        return solve(t, 1 / (200 * duration));
	    }
	    elproto.onAnimation = function (f) {
	        f ? eve.on("raphael.anim.frame." + this.id, f) : eve.unbind("raphael.anim.frame." + this.id);
	        return this;
	    };
	    function Animation(anim, ms) {
	        var percents = [],
	            newAnim = {};
	        this.ms = ms;
	        this.times = 1;
	        if (anim) {
	            for (var attr in anim) if (anim[has](attr)) {
	                newAnim[toFloat(attr)] = anim[attr];
	                percents.push(toFloat(attr));
	            }
	            percents.sort(sortByNumber);
	        }
	        this.anim = newAnim;
	        this.top = percents[percents.length - 1];
	        this.percents = percents;
	    }
	    /*\
	     * Animation.delay
	     [ method ]
	     **
	     * Creates a copy of existing animation object with given delay.
	     **
	     > Parameters
	     **
	     - delay (number) number of ms to pass between animation start and actual animation
	     **
	     = (object) new altered Animation object
	     | var anim = Raphael.animation({cx: 10, cy: 20}, 2e3);
	     | circle1.animate(anim); // run the given animation immediately
	     | circle2.animate(anim.delay(500)); // run the given animation after 500 ms
	    \*/
	    Animation.prototype.delay = function (delay) {
	        var a = new Animation(this.anim, this.ms);
	        a.times = this.times;
	        a.del = +delay || 0;
	        return a;
	    };
	    /*\
	     * Animation.repeat
	     [ method ]
	     **
	     * Creates a copy of existing animation object with given repetition.
	     **
	     > Parameters
	     **
	     - repeat (number) number iterations of animation. For infinite animation pass `Infinity`
	     **
	     = (object) new altered Animation object
	    \*/
	    Animation.prototype.repeat = function (times) {
	        var a = new Animation(this.anim, this.ms);
	        a.del = this.del;
	        a.times = math.floor(mmax(times, 0)) || 1;
	        return a;
	    };
	    function runAnimation(anim, element, percent, status, totalOrigin, times) {
	        percent = toFloat(percent);
	        var params,
	            isInAnim,
	            isInAnimSet,
	            percents = [],
	            next,
	            prev,
	            timestamp,
	            ms = anim.ms,
	            from = {},
	            to = {},
	            diff = {};
	        if (status) {
	            for (i = 0, ii = animationElements.length; i < ii; i++) {
	                var e = animationElements[i];
	                if (e.el.id == element.id && e.anim == anim) {
	                    if (e.percent != percent) {
	                        animationElements.splice(i, 1);
	                        isInAnimSet = 1;
	                    } else {
	                        isInAnim = e;
	                    }
	                    element.attr(e.totalOrigin);
	                    break;
	                }
	            }
	        } else {
	            status = +to; // NaN
	        }
	        for (var i = 0, ii = anim.percents.length; i < ii; i++) {
	            if (anim.percents[i] == percent || anim.percents[i] > status * anim.top) {
	                percent = anim.percents[i];
	                prev = anim.percents[i - 1] || 0;
	                ms = ms / anim.top * (percent - prev);
	                next = anim.percents[i + 1];
	                params = anim.anim[percent];
	                break;
	            } else if (status) {
	                element.attr(anim.anim[anim.percents[i]]);
	            }
	        }
	        if (!params) {
	            return;
	        }
	        if (!isInAnim) {
	            for (var attr in params) if (params[has](attr)) {
	                if (availableAnimAttrs[has](attr) || element.paper.customAttributes[has](attr)) {
	                    from[attr] = element.attr(attr);
	                    (from[attr] == null) && (from[attr] = availableAttrs[attr]);
	                    to[attr] = params[attr];
	                    switch (availableAnimAttrs[attr]) {
	                        case nu:
	                            diff[attr] = (to[attr] - from[attr]) / ms;
	                            break;
	                        case "colour":
	                            from[attr] = R.getRGB(from[attr]);
	                            var toColour = R.getRGB(to[attr]);
	                            diff[attr] = {
	                                r: (toColour.r - from[attr].r) / ms,
	                                g: (toColour.g - from[attr].g) / ms,
	                                b: (toColour.b - from[attr].b) / ms
	                            };
	                            break;
	                        case "path":
	                            var pathes = path2curve(from[attr], to[attr]),
	                                toPath = pathes[1];
	                            from[attr] = pathes[0];
	                            diff[attr] = [];
	                            for (i = 0, ii = from[attr].length; i < ii; i++) {
	                                diff[attr][i] = [0];
	                                for (var j = 1, jj = from[attr][i].length; j < jj; j++) {
	                                    diff[attr][i][j] = (toPath[i][j] - from[attr][i][j]) / ms;
	                                }
	                            }
	                            break;
	                        case "transform":
	                            var _ = element._,
	                                eq = equaliseTransform(_[attr], to[attr]);
	                            if (eq) {
	                                from[attr] = eq.from;
	                                to[attr] = eq.to;
	                                diff[attr] = [];
	                                diff[attr].real = true;
	                                for (i = 0, ii = from[attr].length; i < ii; i++) {
	                                    diff[attr][i] = [from[attr][i][0]];
	                                    for (j = 1, jj = from[attr][i].length; j < jj; j++) {
	                                        diff[attr][i][j] = (to[attr][i][j] - from[attr][i][j]) / ms;
	                                    }
	                                }
	                            } else {
	                                var m = (element.matrix || new Matrix),
	                                    to2 = {
	                                        _: {transform: _.transform},
	                                        getBBox: function () {
	                                            return element.getBBox(1);
	                                        }
	                                    };
	                                from[attr] = [
	                                    m.a,
	                                    m.b,
	                                    m.c,
	                                    m.d,
	                                    m.e,
	                                    m.f
	                                ];
	                                extractTransform(to2, to[attr]);
	                                to[attr] = to2._.transform;
	                                diff[attr] = [
	                                    (to2.matrix.a - m.a) / ms,
	                                    (to2.matrix.b - m.b) / ms,
	                                    (to2.matrix.c - m.c) / ms,
	                                    (to2.matrix.d - m.d) / ms,
	                                    (to2.matrix.e - m.e) / ms,
	                                    (to2.matrix.f - m.f) / ms
	                                ];
	                                // from[attr] = [_.sx, _.sy, _.deg, _.dx, _.dy];
	                                // var to2 = {_:{}, getBBox: function () { return element.getBBox(); }};
	                                // extractTransform(to2, to[attr]);
	                                // diff[attr] = [
	                                //     (to2._.sx - _.sx) / ms,
	                                //     (to2._.sy - _.sy) / ms,
	                                //     (to2._.deg - _.deg) / ms,
	                                //     (to2._.dx - _.dx) / ms,
	                                //     (to2._.dy - _.dy) / ms
	                                // ];
	                            }
	                            break;
	                        case "csv":
	                            var values = Str(params[attr])[split](separator),
	                                from2 = Str(from[attr])[split](separator);
	                            if (attr == "clip-rect") {
	                                from[attr] = from2;
	                                diff[attr] = [];
	                                i = from2.length;
	                                while (i--) {
	                                    diff[attr][i] = (values[i] - from[attr][i]) / ms;
	                                }
	                            }
	                            to[attr] = values;
	                            break;
	                        default:
	                            values = [][concat](params[attr]);
	                            from2 = [][concat](from[attr]);
	                            diff[attr] = [];
	                            i = element.paper.customAttributes[attr].length;
	                            while (i--) {
	                                diff[attr][i] = ((values[i] || 0) - (from2[i] || 0)) / ms;
	                            }
	                            break;
	                    }
	                }
	            }
	            var easing = params.easing,
	                easyeasy = R.easing_formulas[easing];
	            if (!easyeasy) {
	                easyeasy = Str(easing).match(bezierrg);
	                if (easyeasy && easyeasy.length == 5) {
	                    var curve = easyeasy;
	                    easyeasy = function (t) {
	                        return CubicBezierAtTime(t, +curve[1], +curve[2], +curve[3], +curve[4], ms);
	                    };
	                } else {
	                    easyeasy = pipe;
	                }
	            }
	            timestamp = params.start || anim.start || +new Date;
	            e = {
	                anim: anim,
	                percent: percent,
	                timestamp: timestamp,
	                start: timestamp + (anim.del || 0),
	                status: 0,
	                initstatus: status || 0,
	                stop: false,
	                ms: ms,
	                easing: easyeasy,
	                from: from,
	                diff: diff,
	                to: to,
	                el: element,
	                callback: params.callback,
	                prev: prev,
	                next: next,
	                repeat: times || anim.times,
	                origin: element.attr(),
	                totalOrigin: totalOrigin
	            };
	            animationElements.push(e);
	            if (status && !isInAnim && !isInAnimSet) {
	                e.stop = true;
	                e.start = new Date - ms * status;
	                if (animationElements.length == 1) {
	                    return animation();
	                }
	            }
	            if (isInAnimSet) {
	                e.start = new Date - e.ms * status;
	            }
	            animationElements.length == 1 && requestAnimFrame(animation);
	        } else {
	            isInAnim.initstatus = status;
	            isInAnim.start = new Date - isInAnim.ms * status;
	        }
	        eve("raphael.anim.start." + element.id, element, anim);
	    }
	    /*\
	     * Raphael.animation
	     [ method ]
	     **
	     * Creates an animation object that can be passed to the @Element.animate or @Element.animateWith methods.
	     * See also @Animation.delay and @Animation.repeat methods.
	     **
	     > Parameters
	     **
	     - params (object) final attributes for the element, see also @Element.attr
	     - ms (number) number of milliseconds for animation to run
	     - easing (string) #optional easing type. Accept one of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
	     - callback (function) #optional callback function. Will be called at the end of animation.
	     **
	     = (object) @Animation
	    \*/
	    R.animation = function (params, ms, easing, callback) {
	        if (params instanceof Animation) {
	            return params;
	        }
	        if (R.is(easing, "function") || !easing) {
	            callback = callback || easing || null;
	            easing = null;
	        }
	        params = Object(params);
	        ms = +ms || 0;
	        var p = {},
	            json,
	            attr;
	        for (attr in params) if (params[has](attr) && toFloat(attr) != attr && toFloat(attr) + "%" != attr) {
	            json = true;
	            p[attr] = params[attr];
	        }
	        if (!json) {
	            // if percent-like syntax is used and end-of-all animation callback used
	            if(callback){
	                // find the last one
	                var lastKey = 0;
	                for(var i in params){
	                    var percent = toInt(i);
	                    if(params[has](i) && percent > lastKey){
	                        lastKey = percent;
	                    }
	                }
	                lastKey += '%';
	                // if already defined callback in the last keyframe, skip
	                !params[lastKey].callback && (params[lastKey].callback = callback);
	            }
	          return new Animation(params, ms);
	        } else {
	            easing && (p.easing = easing);
	            callback && (p.callback = callback);
	            return new Animation({100: p}, ms);
	        }
	    };
	    /*\
	     * Element.animate
	     [ method ]
	     **
	     * Creates and starts animation for given element.
	     **
	     > Parameters
	     **
	     - params (object) final attributes for the element, see also @Element.attr
	     - ms (number) number of milliseconds for animation to run
	     - easing (string) #optional easing type. Accept one of @Raphael.easing_formulas or CSS format: `cubic&#x2010;bezier(XX,&#160;XX,&#160;XX,&#160;XX)`
	     - callback (function) #optional callback function. Will be called at the end of animation.
	     * or
	     - animation (object) animation object, see @Raphael.animation
	     **
	     = (object) original element
	    \*/
	    elproto.animate = function (params, ms, easing, callback) {
	        var element = this;
	        if (element.removed) {
	            callback && callback.call(element);
	            return element;
	        }
	        var anim = params instanceof Animation ? params : R.animation(params, ms, easing, callback);
	        runAnimation(anim, element, anim.percents[0], null, element.attr());
	        return element;
	    };
	    /*\
	     * Element.setTime
	     [ method ]
	     **
	     * Sets the status of animation of the element in milliseconds. Similar to @Element.status method.
	     **
	     > Parameters
	     **
	     - anim (object) animation object
	     - value (number) number of milliseconds from the beginning of the animation
	     **
	     = (object) original element if `value` is specified
	     * Note, that during animation following events are triggered:
	     *
	     * On each animation frame event `anim.frame.<id>`, on start `anim.start.<id>` and on end `anim.finish.<id>`.
	    \*/
	    elproto.setTime = function (anim, value) {
	        if (anim && value != null) {
	            this.status(anim, mmin(value, anim.ms) / anim.ms);
	        }
	        return this;
	    };
	    /*\
	     * Element.status
	     [ method ]
	     **
	     * Gets or sets the status of animation of the element.
	     **
	     > Parameters
	     **
	     - anim (object) #optional animation object
	     - value (number) #optional 0 – 1. If specified, method works like a setter and sets the status of a given animation to the value. This will cause animation to jump to the given position.
	     **
	     = (number) status
	     * or
	     = (array) status if `anim` is not specified. Array of objects in format:
	     o {
	     o     anim: (object) animation object
	     o     status: (number) status
	     o }
	     * or
	     = (object) original element if `value` is specified
	    \*/
	    elproto.status = function (anim, value) {
	        var out = [],
	            i = 0,
	            len,
	            e;
	        if (value != null) {
	            runAnimation(anim, this, -1, mmin(value, 1));
	            return this;
	        } else {
	            len = animationElements.length;
	            for (; i < len; i++) {
	                e = animationElements[i];
	                if (e.el.id == this.id && (!anim || e.anim == anim)) {
	                    if (anim) {
	                        return e.status;
	                    }
	                    out.push({
	                        anim: e.anim,
	                        status: e.status
	                    });
	                }
	            }
	            if (anim) {
	                return 0;
	            }
	            return out;
	        }
	    };
	    /*\
	     * Element.pause
	     [ method ]
	     **
	     * Stops animation of the element with ability to resume it later on.
	     **
	     > Parameters
	     **
	     - anim (object) #optional animation object
	     **
	     = (object) original element
	    \*/
	    elproto.pause = function (anim) {
	        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
	            if (eve("raphael.anim.pause." + this.id, this, animationElements[i].anim) !== false) {
	                animationElements[i].paused = true;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.resume
	     [ method ]
	     **
	     * Resumes animation if it was paused with @Element.pause method.
	     **
	     > Parameters
	     **
	     - anim (object) #optional animation object
	     **
	     = (object) original element
	    \*/
	    elproto.resume = function (anim) {
	        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
	            var e = animationElements[i];
	            if (eve("raphael.anim.resume." + this.id, this, e.anim) !== false) {
	                delete e.paused;
	                this.status(e.anim, e.status);
	            }
	        }
	        return this;
	    };
	    /*\
	     * Element.stop
	     [ method ]
	     **
	     * Stops animation of the element.
	     **
	     > Parameters
	     **
	     - anim (object) #optional animation object
	     **
	     = (object) original element
	    \*/
	    elproto.stop = function (anim) {
	        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.id == this.id && (!anim || animationElements[i].anim == anim)) {
	            if (eve("raphael.anim.stop." + this.id, this, animationElements[i].anim) !== false) {
	                animationElements.splice(i--, 1);
	            }
	        }
	        return this;
	    };
	    function stopAnimation(paper) {
	        for (var i = 0; i < animationElements.length; i++) if (animationElements[i].el.paper == paper) {
	            animationElements.splice(i--, 1);
	        }
	    }
	    eve.on("raphael.remove", stopAnimation);
	    eve.on("raphael.clear", stopAnimation);
	    elproto.toString = function () {
	        return "Rapha\xebl\u2019s object";
	    };
	
	    // Set
	    var Set = function (items) {
	        this.items = [];
	        this.length = 0;
	        this.type = "set";
	        if (items) {
	            for (var i = 0, ii = items.length; i < ii; i++) {
	                if (items[i] && (items[i].constructor == elproto.constructor || items[i].constructor == Set)) {
	                    this[this.items.length] = this.items[this.items.length] = items[i];
	                    this.length++;
	                }
	            }
	        }
	    },
	    setproto = Set.prototype;
	    /*\
	     * Set.push
	     [ method ]
	     **
	     * Adds each argument to the current set.
	     = (object) original element
	    \*/
	    setproto.push = function () {
	        var item,
	            len;
	        for (var i = 0, ii = arguments.length; i < ii; i++) {
	            item = arguments[i];
	            if (item && (item.constructor == elproto.constructor || item.constructor == Set)) {
	                len = this.items.length;
	                this[len] = this.items[len] = item;
	                this.length++;
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.pop
	     [ method ]
	     **
	     * Removes last element and returns it.
	     = (object) element
	    \*/
	    setproto.pop = function () {
	        this.length && delete this[this.length--];
	        return this.items.pop();
	    };
	    /*\
	     * Set.forEach
	     [ method ]
	     **
	     * Executes given function for each element in the set.
	     *
	     * If function returns `false` it will stop loop running.
	     **
	     > Parameters
	     **
	     - callback (function) function to run
	     - thisArg (object) context object for the callback
	     = (object) Set object
	    \*/
	    setproto.forEach = function (callback, thisArg) {
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            if (callback.call(thisArg, this.items[i], i) === false) {
	                return this;
	            }
	        }
	        return this;
	    };
	    for (var method in elproto) if (elproto[has](method)) {
	        setproto[method] = (function (methodname) {
	            return function () {
	                var arg = arguments;
	                return this.forEach(function (el) {
	                    el[methodname][apply](el, arg);
	                });
	            };
	        })(method);
	    }
	    setproto.attr = function (name, value) {
	        if (name && R.is(name, array) && R.is(name[0], "object")) {
	            for (var j = 0, jj = name.length; j < jj; j++) {
	                this.items[j].attr(name[j]);
	            }
	        } else {
	            for (var i = 0, ii = this.items.length; i < ii; i++) {
	                this.items[i].attr(name, value);
	            }
	        }
	        return this;
	    };
	    /*\
	     * Set.clear
	     [ method ]
	     **
	     * Removes all elements from the set
	    \*/
	    setproto.clear = function () {
	        while (this.length) {
	            this.pop();
	        }
	    };
	    /*\
	     * Set.splice
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     > Parameters
	     **
	     - index (number) position of the deletion
	     - count (number) number of element to remove
	     - insertion… (object) #optional elements to insert
	     = (object) set elements that were deleted
	    \*/
	    setproto.splice = function (index, count, insertion) {
	        index = index < 0 ? mmax(this.length + index, 0) : index;
	        count = mmax(0, mmin(this.length - index, count));
	        var tail = [],
	            todel = [],
	            args = [],
	            i;
	        for (i = 2; i < arguments.length; i++) {
	            args.push(arguments[i]);
	        }
	        for (i = 0; i < count; i++) {
	            todel.push(this[index + i]);
	        }
	        for (; i < this.length - index; i++) {
	            tail.push(this[index + i]);
	        }
	        var arglen = args.length;
	        for (i = 0; i < arglen + tail.length; i++) {
	            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
	        }
	        i = this.items.length = this.length -= count - arglen;
	        while (this[i]) {
	            delete this[i++];
	        }
	        return new Set(todel);
	    };
	    /*\
	     * Set.exclude
	     [ method ]
	     **
	     * Removes given element from the set
	     **
	     > Parameters
	     **
	     - element (object) element to remove
	     = (boolean) `true` if object was found & removed from the set
	    \*/
	    setproto.exclude = function (el) {
	        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
	            this.splice(i, 1);
	            return true;
	        }
	    };
	    setproto.animate = function (params, ms, easing, callback) {
	        (R.is(easing, "function") || !easing) && (callback = easing || null);
	        var len = this.items.length,
	            i = len,
	            item,
	            set = this,
	            collector;
	        if (!len) {
	            return this;
	        }
	        callback && (collector = function () {
	            !--len && callback.call(set);
	        });
	        easing = R.is(easing, string) ? easing : collector;
	        var anim = R.animation(params, ms, easing, collector);
	        item = this.items[--i].animate(anim);
	        while (i--) {
	            this.items[i] && !this.items[i].removed && this.items[i].animateWith(item, anim, anim);
	            (this.items[i] && !this.items[i].removed) || len--;
	        }
	        return this;
	    };
	    setproto.insertAfter = function (el) {
	        var i = this.items.length;
	        while (i--) {
	            this.items[i].insertAfter(el);
	        }
	        return this;
	    };
	    setproto.getBBox = function () {
	        var x = [],
	            y = [],
	            x2 = [],
	            y2 = [];
	        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
	            var box = this.items[i].getBBox();
	            x.push(box.x);
	            y.push(box.y);
	            x2.push(box.x + box.width);
	            y2.push(box.y + box.height);
	        }
	        x = mmin[apply](0, x);
	        y = mmin[apply](0, y);
	        x2 = mmax[apply](0, x2);
	        y2 = mmax[apply](0, y2);
	        return {
	            x: x,
	            y: y,
	            x2: x2,
	            y2: y2,
	            width: x2 - x,
	            height: y2 - y
	        };
	    };
	    setproto.clone = function (s) {
	        s = this.paper.set();
	        for (var i = 0, ii = this.items.length; i < ii; i++) {
	            s.push(this.items[i].clone());
	        }
	        return s;
	    };
	    setproto.toString = function () {
	        return "Rapha\xebl\u2018s set";
	    };
	
	    setproto.glow = function(glowConfig) {
	        var ret = this.paper.set();
	        this.forEach(function(shape, index){
	            var g = shape.glow(glowConfig);
	            if(g != null){
	                g.forEach(function(shape2, index2){
	                    ret.push(shape2);
	                });
	            }
	        });
	        return ret;
	    };
	
	
	    /*\
	     * Set.isPointInside
	     [ method ]
	     **
	     * Determine if given point is inside this set’s elements
	     **
	     > Parameters
	     **
	     - x (number) x coordinate of the point
	     - y (number) y coordinate of the point
	     = (boolean) `true` if point is inside any of the set's elements
	     \*/
	    setproto.isPointInside = function (x, y) {
	        var isPointInside = false;
	        this.forEach(function (el) {
	            if (el.isPointInside(x, y)) {
	                isPointInside = true;
	                return false; // stop loop
	            }
	        });
	        return isPointInside;
	    };
	
	    /*\
	     * Raphael.registerFont
	     [ method ]
	     **
	     * Adds given font to the registered set of fonts for Raphaël. Should be used as an internal call from within Cufón’s font file.
	     * Returns original parameter, so it could be used with chaining.
	     # <a href="http://wiki.github.com/sorccu/cufon/about">More about Cufón and how to convert your font form TTF, OTF, etc to JavaScript file.</a>
	     **
	     > Parameters
	     **
	     - font (object) the font to register
	     = (object) the font you passed in
	     > Usage
	     | Cufon.registerFont(Raphael.registerFont({…}));
	    \*/
	    R.registerFont = function (font) {
	        if (!font.face) {
	            return font;
	        }
	        this.fonts = this.fonts || {};
	        var fontcopy = {
	                w: font.w,
	                face: {},
	                glyphs: {}
	            },
	            family = font.face["font-family"];
	        for (var prop in font.face) if (font.face[has](prop)) {
	            fontcopy.face[prop] = font.face[prop];
	        }
	        if (this.fonts[family]) {
	            this.fonts[family].push(fontcopy);
	        } else {
	            this.fonts[family] = [fontcopy];
	        }
	        if (!font.svg) {
	            fontcopy.face["units-per-em"] = toInt(font.face["units-per-em"], 10);
	            for (var glyph in font.glyphs) if (font.glyphs[has](glyph)) {
	                var path = font.glyphs[glyph];
	                fontcopy.glyphs[glyph] = {
	                    w: path.w,
	                    k: {},
	                    d: path.d && "M" + path.d.replace(/[mlcxtrv]/g, function (command) {
	                            return {l: "L", c: "C", x: "z", t: "m", r: "l", v: "c"}[command] || "M";
	                        }) + "z"
	                };
	                if (path.k) {
	                    for (var k in path.k) if (path[has](k)) {
	                        fontcopy.glyphs[glyph].k[k] = path.k[k];
	                    }
	                }
	            }
	        }
	        return font;
	    };
	    /*\
	     * Paper.getFont
	     [ method ]
	     **
	     * Finds font object in the registered fonts by given parameters. You could specify only one word from the font name, like “Myriad” for “Myriad Pro”.
	     **
	     > Parameters
	     **
	     - family (string) font family name or any word from it
	     - weight (string) #optional font weight
	     - style (string) #optional font style
	     - stretch (string) #optional font stretch
	     = (object) the font object
	     > Usage
	     | paper.print(100, 100, "Test string", paper.getFont("Times", 800), 30);
	    \*/
	    paperproto.getFont = function (family, weight, style, stretch) {
	        stretch = stretch || "normal";
	        style = style || "normal";
	        weight = +weight || {normal: 400, bold: 700, lighter: 300, bolder: 800}[weight] || 400;
	        if (!R.fonts) {
	            return;
	        }
	        var font = R.fonts[family];
	        if (!font) {
	            var name = new RegExp("(^|\\s)" + family.replace(/[^\w\d\s+!~.:_-]/g, E) + "(\\s|$)", "i");
	            for (var fontName in R.fonts) if (R.fonts[has](fontName)) {
	                if (name.test(fontName)) {
	                    font = R.fonts[fontName];
	                    break;
	                }
	            }
	        }
	        var thefont;
	        if (font) {
	            for (var i = 0, ii = font.length; i < ii; i++) {
	                thefont = font[i];
	                if (thefont.face["font-weight"] == weight && (thefont.face["font-style"] == style || !thefont.face["font-style"]) && thefont.face["font-stretch"] == stretch) {
	                    break;
	                }
	            }
	        }
	        return thefont;
	    };
	    /*\
	     * Paper.print
	     [ method ]
	     **
	     * Creates path that represent given text written using given font at given position with given size.
	     * Result of the method is path element that contains whole text as a separate path.
	     **
	     > Parameters
	     **
	     - x (number) x position of the text
	     - y (number) y position of the text
	     - string (string) text to print
	     - font (object) font object, see @Paper.getFont
	     - size (number) #optional size of the font, default is `16`
	     - origin (string) #optional could be `"baseline"` or `"middle"`, default is `"middle"`
	     - letter_spacing (number) #optional number in range `-1..1`, default is `0`
	     - line_spacing (number) #optional number in range `1..3`, default is `1`
	     = (object) resulting path element, which consist of all letters
	     > Usage
	     | var txt = r.print(10, 50, "print", r.getFont("Museo"), 30).attr({fill: "#fff"});
	    \*/
	    paperproto.print = function (x, y, string, font, size, origin, letter_spacing, line_spacing) {
	        origin = origin || "middle"; // baseline|middle
	        letter_spacing = mmax(mmin(letter_spacing || 0, 1), -1);
	        line_spacing = mmax(mmin(line_spacing || 1, 3), 1);
	        var letters = Str(string)[split](E),
	            shift = 0,
	            notfirst = 0,
	            path = E,
	            scale;
	        R.is(font, "string") && (font = this.getFont(font));
	        if (font) {
	            scale = (size || 16) / font.face["units-per-em"];
	            var bb = font.face.bbox[split](separator),
	                top = +bb[0],
	                lineHeight = bb[3] - bb[1],
	                shifty = 0,
	                height = +bb[1] + (origin == "baseline" ? lineHeight + (+font.face.descent) : lineHeight / 2);
	            for (var i = 0, ii = letters.length; i < ii; i++) {
	                if (letters[i] == "\n") {
	                    shift = 0;
	                    curr = 0;
	                    notfirst = 0;
	                    shifty += lineHeight * line_spacing;
	                } else {
	                    var prev = notfirst && font.glyphs[letters[i - 1]] || {},
	                        curr = font.glyphs[letters[i]];
	                    shift += notfirst ? (prev.w || font.w) + (prev.k && prev.k[letters[i]] || 0) + (font.w * letter_spacing) : 0;
	                    notfirst = 1;
	                }
	                if (curr && curr.d) {
	                    path += R.transformPath(curr.d, ["t", shift * scale, shifty * scale, "s", scale, scale, top, height, "t", (x - top) / scale, (y - height) / scale]);
	                }
	            }
	        }
	        return this.path(path).attr({
	            fill: "#000",
	            stroke: "none"
	        });
	    };
	
	    /*\
	     * Paper.add
	     [ method ]
	     **
	     * Imports elements in JSON array in format `{type: type, <attributes>}`
	     **
	     > Parameters
	     **
	     - json (array)
	     = (object) resulting set of imported elements
	     > Usage
	     | paper.add([
	     |     {
	     |         type: "circle",
	     |         cx: 10,
	     |         cy: 10,
	     |         r: 5
	     |     },
	     |     {
	     |         type: "rect",
	     |         x: 10,
	     |         y: 10,
	     |         width: 10,
	     |         height: 10,
	     |         fill: "#fc0"
	     |     }
	     | ]);
	    \*/
	    paperproto.add = function (json) {
	        if (R.is(json, "array")) {
	            var res = this.set(),
	                i = 0,
	                ii = json.length,
	                j;
	            for (; i < ii; i++) {
	                j = json[i] || {};
	                elements[has](j.type) && res.push(this[j.type]().attr(j));
	            }
	        }
	        return res;
	    };
	
	    /*\
	     * Raphael.format
	     [ method ]
	     **
	     * Simple format function. Replaces construction of type “`{<number>}`” to the corresponding argument.
	     **
	     > Parameters
	     **
	     - token (string) string to format
	     - … (string) rest of arguments will be treated as parameters for replacement
	     = (string) formated string
	     > Usage
	     | var x = 10,
	     |     y = 20,
	     |     width = 40,
	     |     height = 50;
	     | // this will draw a rectangular shape equivalent to "M10,20h40v50h-40z"
	     | paper.path(Raphael.format("M{0},{1}h{2}v{3}h{4}z", x, y, width, height, -width));
	    \*/
	    R.format = function (token, params) {
	        var args = R.is(params, array) ? [0][concat](params) : arguments;
	        token && R.is(token, string) && args.length - 1 && (token = token.replace(formatrg, function (str, i) {
	            return args[++i] == null ? E : args[i];
	        }));
	        return token || E;
	    };
	    /*\
	     * Raphael.fullfill
	     [ method ]
	     **
	     * A little bit more advanced format function than @Raphael.format. Replaces construction of type “`{<name>}`” to the corresponding argument.
	     **
	     > Parameters
	     **
	     - token (string) string to format
	     - json (object) object which properties will be used as a replacement
	     = (string) formated string
	     > Usage
	     | // this will draw a rectangular shape equivalent to "M10,20h40v50h-40z"
	     | paper.path(Raphael.fullfill("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
	     |     x: 10,
	     |     y: 20,
	     |     dim: {
	     |         width: 40,
	     |         height: 50,
	     |         "negative width": -40
	     |     }
	     | }));
	    \*/
	    R.fullfill = (function () {
	        var tokenRegex = /\{([^\}]+)\}/g,
	            objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
	            replacer = function (all, key, obj) {
	                var res = obj;
	                key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
	                    name = name || quotedName;
	                    if (res) {
	                        if (name in res) {
	                            res = res[name];
	                        }
	                        typeof res == "function" && isFunc && (res = res());
	                    }
	                });
	                res = (res == null || res == obj ? all : res) + "";
	                return res;
	            };
	        return function (str, obj) {
	            return String(str).replace(tokenRegex, function (all, key) {
	                return replacer(all, key, obj);
	            });
	        };
	    })();
	    /*\
	     * Raphael.ninja
	     [ method ]
	     **
	     * If you want to leave no trace of Raphaël (Well, Raphaël creates only one global variable `Raphael`, but anyway.) You can use `ninja` method.
	     * Beware, that in this case plugins could stop working, because they are depending on global variable existence.
	     **
	     = (object) Raphael object
	     > Usage
	     | (function (local_raphael) {
	     |     var paper = local_raphael(10, 10, 320, 200);
	     |     …
	     | })(Raphael.ninja());
	    \*/
	    R.ninja = function () {
	        if (oldRaphael.was) {
	            g.win.Raphael = oldRaphael.is;
	        } else {
	            // IE8 raises an error when deleting window property
	            __webpack_provided_window_dot_Raphael = undefined;
	            try {
	                delete __webpack_provided_window_dot_Raphael;
	            } catch(e) {}
	        }
	        return R;
	    };
	    /*\
	     * Raphael.st
	     [ property (object) ]
	     **
	     * You can add your own method to elements and sets. It is wise to add a set method for each element method
	     * you added, so you will be able to call the same method on sets too.
	     **
	     * See also @Raphael.el.
	     > Usage
	     | Raphael.el.red = function () {
	     |     this.attr({fill: "#f00"});
	     | };
	     | Raphael.st.red = function () {
	     |     this.forEach(function (el) {
	     |         el.red();
	     |     });
	     | };
	     | // then use it
	     | paper.set(paper.circle(100, 100, 20), paper.circle(110, 100, 20)).red();
	    \*/
	    R.st = setproto;
	
	    eve.on("raphael.DOMload", function () {
	        loaded = true;
	    });
	
	    // Firefox <3.6 fix: http://webreflection.blogspot.com/2009/11/195-chars-to-help-lazy-loading.html
	    (function (doc, loaded, f) {
	        if (doc.readyState == null && doc.addEventListener){
	            doc.addEventListener(loaded, f = function () {
	                doc.removeEventListener(loaded, f, false);
	                doc.readyState = "complete";
	            }, false);
	            doc.readyState = "loading";
	        }
	        function isLoaded() {
	            (/in/).test(doc.readyState) ? setTimeout(isLoaded, 9) : R.eve("raphael.DOMload");
	        }
	        isLoaded();
	    })(document, "DOMContentLoaded");
	
	    return R;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
	// 
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	// 
	// http://www.apache.org/licenses/LICENSE-2.0
	// 
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	// ┌────────────────────────────────────────────────────────────┐ \\
	// │ Eve 0.5.0 - JavaScript Events Library                      │ \\
	// ├────────────────────────────────────────────────────────────┤ \\
	// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
	// └────────────────────────────────────────────────────────────┘ \\
	
	(function (glob) {
	    var version = "0.5.0",
	        has = "hasOwnProperty",
	        separator = /[\.\/]/,
	        comaseparator = /\s*,\s*/,
	        wildcard = "*",
	        fun = function () {},
	        numsort = function (a, b) {
	            return a - b;
	        },
	        current_event,
	        stop,
	        events = {n: {}},
	        firstDefined = function () {
	            for (var i = 0, ii = this.length; i < ii; i++) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        lastDefined = function () {
	            var i = this.length;
	            while (--i) {
	                if (typeof this[i] != "undefined") {
	                    return this[i];
	                }
	            }
	        },
	        objtos = Object.prototype.toString,
	        Str = String,
	        isArray = Array.isArray || function (ar) {
	            return ar instanceof Array || objtos.call(ar) == "[object Array]";
	        };
	    /*\
	     * eve
	     [ method ]
	
	     * Fires event with given `name`, given scope and other parameters.
	
	     > Arguments
	
	     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
	     - scope (object) context for the event handlers
	     - varargs (...) the rest of arguments will be sent to event handlers
	
	     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
	    \*/
	        var eve = function (name, scope) {
	            var e = events,
	                oldstop = stop,
	                args = Array.prototype.slice.call(arguments, 2),
	                listeners = eve.listeners(name),
	                z = 0,
	                f = false,
	                l,
	                indexed = [],
	                queue = {},
	                out = [],
	                ce = current_event,
	                errors = [];
	            out.firstDefined = firstDefined;
	            out.lastDefined = lastDefined;
	            current_event = name;
	            stop = 0;
	            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
	                indexed.push(listeners[i].zIndex);
	                if (listeners[i].zIndex < 0) {
	                    queue[listeners[i].zIndex] = listeners[i];
	                }
	            }
	            indexed.sort(numsort);
	            while (indexed[z] < 0) {
	                l = queue[indexed[z++]];
	                out.push(l.apply(scope, args));
	                if (stop) {
	                    stop = oldstop;
	                    return out;
	                }
	            }
	            for (i = 0; i < ii; i++) {
	                l = listeners[i];
	                if ("zIndex" in l) {
	                    if (l.zIndex == indexed[z]) {
	                        out.push(l.apply(scope, args));
	                        if (stop) {
	                            break;
	                        }
	                        do {
	                            z++;
	                            l = queue[indexed[z]];
	                            l && out.push(l.apply(scope, args));
	                            if (stop) {
	                                break;
	                            }
	                        } while (l)
	                    } else {
	                        queue[l.zIndex] = l;
	                    }
	                } else {
	                    out.push(l.apply(scope, args));
	                    if (stop) {
	                        break;
	                    }
	                }
	            }
	            stop = oldstop;
	            current_event = ce;
	            return out;
	        };
	        // Undocumented. Debug only.
	        eve._events = events;
	    /*\
	     * eve.listeners
	     [ method ]
	
	     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.
	
	     > Arguments
	
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated
	
	     = (array) array of event handlers
	    \*/
	    eve.listeners = function (name) {
	        var names = isArray(name) ? name : name.split(separator),
	            e = events,
	            item,
	            items,
	            k,
	            i,
	            ii,
	            j,
	            jj,
	            nes,
	            es = [e],
	            out = [];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            nes = [];
	            for (j = 0, jj = es.length; j < jj; j++) {
	                e = es[j].n;
	                items = [e[names[i]], e[wildcard]];
	                k = 2;
	                while (k--) {
	                    item = items[k];
	                    if (item) {
	                        nes.push(item);
	                        out = out.concat(item.f || []);
	                    }
	                }
	            }
	            es = nes;
	        }
	        return out;
	    };
	    /*\
	     * eve.separator
	     [ method ]
	
	     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
	     * here. Be aware that if you pass a string longer than one character it will be treated as
	     * a list of characters.
	
	     - separator (string) new separator. Empty string resets to default: `.` or `/`.
	    \*/
	    eve.separator = function (sep) {
	        if (sep) {
	            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
	            sep = "[" + sep + "]";
	            separator = new RegExp(sep);
	        } else {
	            separator = /[\.\/]/;
	        }
	    };
	    /*\
	     * eve.on
	     [ method ]
	     **
	     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
	     | eve.on("*.under.*", f);
	     | eve("mouse.under.floor"); // triggers f
	     * Use @eve to trigger the listener.
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     - name (array) if you don’t want to use separators, you can use array of strings
	     - f (function) event handler function
	     **
	     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
	     > Example:
	     | eve.on("mouse", eatIt)(2);
	     | eve.on("mouse", scream);
	     | eve.on("mouse", catchIt)(1);
	     * This will ensure that `catchIt` function will be called before `eatIt`.
	     *
	     * If you want to put your handler before non-indexed handlers, specify a negative value.
	     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
	    \*/
	    eve.on = function (name, f) {
	        if (typeof f != "function") {
	            return function () {};
	        }
	        var names = isArray(name) ? (isArray(name[0]) ? name : [name]) : Str(name).split(comaseparator);
	        for (var i = 0, ii = names.length; i < ii; i++) {
	            (function (name) {
	                var names = isArray(name) ? name : Str(name).split(separator),
	                    e = events,
	                    exist;
	                for (var i = 0, ii = names.length; i < ii; i++) {
	                    e = e.n;
	                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
	                }
	                e.f = e.f || [];
	                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
	                    exist = true;
	                    break;
	                }
	                !exist && e.f.push(f);
	            }(names[i]));
	        }
	        return function (zIndex) {
	            if (+zIndex == +zIndex) {
	                f.zIndex = +zIndex;
	            }
	        };
	    };
	    /*\
	     * eve.f
	     [ method ]
	     **
	     * Returns function that will fire given event with optional arguments.
	     * Arguments that will be passed to the result function will be also
	     * concated to the list of final arguments.
	     | el.onclick = eve.f("click", 1, 2);
	     | eve.on("click", function (a, b, c) {
	     |     console.log(a, b, c); // 1, 2, [event object]
	     | });
	     > Arguments
	     - event (string) event name
	     - varargs (…) and any other arguments
	     = (function) possible event handler function
	    \*/
	    eve.f = function (event) {
	        var attrs = [].slice.call(arguments, 1);
	        return function () {
	            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
	        };
	    };
	    /*\
	     * eve.stop
	     [ method ]
	     **
	     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
	    \*/
	    eve.stop = function () {
	        stop = 1;
	    };
	    /*\
	     * eve.nt
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     > Arguments
	     **
	     - subname (string) #optional subname of the event
	     **
	     = (string) name of the event, if `subname` is not specified
	     * or
	     = (boolean) `true`, if current event’s name contains `subname`
	    \*/
	    eve.nt = function (subname) {
	        var cur = isArray(current_event) ? current_event.join(".") : current_event;
	        if (subname) {
	            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
	        }
	        return cur;
	    };
	    /*\
	     * eve.nts
	     [ method ]
	     **
	     * Could be used inside event handler to figure out actual name of the event.
	     **
	     **
	     = (array) names of the event
	    \*/
	    eve.nts = function () {
	        return isArray(current_event) ? current_event : current_event.split(separator);
	    };
	    /*\
	     * eve.off
	     [ method ]
	     **
	     * Removes given function from the list of event listeners assigned to given name.
	     * If no arguments specified all the events will be cleared.
	     **
	     > Arguments
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	    \*/
	    /*\
	     * eve.unbind
	     [ method ]
	     **
	     * See @eve.off
	    \*/
	    eve.off = eve.unbind = function (name, f) {
	        if (!name) {
	            eve._events = events = {n: {}};
	            return;
	        }
	        var names = isArray(name) ? (isArray(name[0]) ? name : [name]) : Str(name).split(comaseparator);
	        if (names.length > 1) {
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                eve.off(names[i], f);
	            }
	            return;
	        }
	        names = isArray(name) ? name : Str(name).split(separator);
	        var e,
	            key,
	            splice,
	            i, ii, j, jj,
	            cur = [events];
	        for (i = 0, ii = names.length; i < ii; i++) {
	            for (j = 0; j < cur.length; j += splice.length - 2) {
	                splice = [j, 1];
	                e = cur[j].n;
	                if (names[i] != wildcard) {
	                    if (e[names[i]]) {
	                        splice.push(e[names[i]]);
	                    }
	                } else {
	                    for (key in e) if (e[has](key)) {
	                        splice.push(e[key]);
	                    }
	                }
	                cur.splice.apply(cur, splice);
	            }
	        }
	        for (i = 0, ii = cur.length; i < ii; i++) {
	            e = cur[i];
	            while (e.n) {
	                if (f) {
	                    if (e.f) {
	                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
	                            e.f.splice(j, 1);
	                            break;
	                        }
	                        !e.f.length && delete e.f;
	                    }
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        var funcs = e.n[key].f;
	                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
	                            funcs.splice(j, 1);
	                            break;
	                        }
	                        !funcs.length && delete e.n[key].f;
	                    }
	                } else {
	                    delete e.f;
	                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
	                        delete e.n[key].f;
	                    }
	                }
	                e = e.n;
	            }
	        }
	    };
	    /*\
	     * eve.once
	     [ method ]
	     **
	     * Binds given event handler with a given name to only run once then unbind itself.
	     | eve.once("login", f);
	     | eve("login"); // triggers f
	     | eve("login"); // no listeners
	     * Use @eve to trigger the listener.
	     **
	     > Arguments
	     **
	     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
	     - f (function) event handler function
	     **
	     = (function) same return function as @eve.on
	    \*/
	    eve.once = function (name, f) {
	        var f2 = function () {
	            eve.off(name, f2);
	            return f.apply(this, arguments);
	        };
	        return eve.on(name, f2);
	    };
	    /*\
	     * eve.version
	     [ property (string) ]
	     **
	     * Current version of the library.
	    \*/
	    eve.version = version;
	    eve.toString = function () {
	        return "You are running Eve " + version;
	    };
	    (typeof module != "undefined" && module.exports) ? (module.exports = eve) : ( true ? (!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))) : (glob.eve = eve));
	})(this);


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(183)], __WEBPACK_AMD_DEFINE_RESULT__ = function(R) {
	    if (R && !R.svg) {
	        return;
	    }
	
	    var has = "hasOwnProperty",
	        Str = String,
	        toFloat = parseFloat,
	        toInt = parseInt,
	        math = Math,
	        mmax = math.max,
	        abs = math.abs,
	        pow = math.pow,
	        separator = /[, ]+/,
	        eve = R.eve,
	        E = "",
	        S = " ";
	    var xlink = "http://www.w3.org/1999/xlink",
	        markers = {
	            block: "M5,0 0,2.5 5,5z",
	            classic: "M5,0 0,2.5 5,5 3.5,3 3.5,2z",
	            diamond: "M2.5,0 5,2.5 2.5,5 0,2.5z",
	            open: "M6,1 1,3.5 6,6",
	            oval: "M2.5,0A2.5,2.5,0,0,1,2.5,5 2.5,2.5,0,0,1,2.5,0z"
	        },
	        markerCounter = {};
	    R.toString = function () {
	        return  "Your browser supports SVG.\nYou are running Rapha\xebl " + this.version;
	    };
	    var $ = function (el, attr) {
	        if (attr) {
	            if (typeof el == "string") {
	                el = $(el);
	            }
	            for (var key in attr) if (attr[has](key)) {
	                if (key.substring(0, 6) == "xlink:") {
	                    el.setAttributeNS(xlink, key.substring(6), Str(attr[key]));
	                } else {
	                    el.setAttribute(key, Str(attr[key]));
	                }
	            }
	        } else {
	            el = R._g.doc.createElementNS("http://www.w3.org/2000/svg", el);
	            el.style && (el.style.webkitTapHighlightColor = "rgba(0,0,0,0)");
	        }
	        return el;
	    },
	    addGradientFill = function (element, gradient) {
	        var type = "linear",
	            id = element.id + gradient,
	            fx = .5, fy = .5,
	            o = element.node,
	            SVG = element.paper,
	            s = o.style,
	            el = R._g.doc.getElementById(id);
	        if (!el) {
	            gradient = Str(gradient).replace(R._radial_gradient, function (all, _fx, _fy) {
	                type = "radial";
	                if (_fx && _fy) {
	                    fx = toFloat(_fx);
	                    fy = toFloat(_fy);
	                    var dir = ((fy > .5) * 2 - 1);
	                    pow(fx - .5, 2) + pow(fy - .5, 2) > .25 &&
	                        (fy = math.sqrt(.25 - pow(fx - .5, 2)) * dir + .5) &&
	                        fy != .5 &&
	                        (fy = fy.toFixed(5) - 1e-5 * dir);
	                }
	                return E;
	            });
	            gradient = gradient.split(/\s*\-\s*/);
	            if (type == "linear") {
	                var angle = gradient.shift();
	                angle = -toFloat(angle);
	                if (isNaN(angle)) {
	                    return null;
	                }
	                var vector = [0, 0, math.cos(R.rad(angle)), math.sin(R.rad(angle))],
	                    max = 1 / (mmax(abs(vector[2]), abs(vector[3])) || 1);
	                vector[2] *= max;
	                vector[3] *= max;
	                if (vector[2] < 0) {
	                    vector[0] = -vector[2];
	                    vector[2] = 0;
	                }
	                if (vector[3] < 0) {
	                    vector[1] = -vector[3];
	                    vector[3] = 0;
	                }
	            }
	            var dots = R._parseDots(gradient);
	            if (!dots) {
	                return null;
	            }
	            id = id.replace(/[\(\)\s,\xb0#]/g, "_");
	
	            if (element.gradient && id != element.gradient.id) {
	                SVG.defs.removeChild(element.gradient);
	                delete element.gradient;
	            }
	
	            if (!element.gradient) {
	                el = $(type + "Gradient", {id: id});
	                element.gradient = el;
	                $(el, type == "radial" ? {
	                    fx: fx,
	                    fy: fy
	                } : {
	                    x1: vector[0],
	                    y1: vector[1],
	                    x2: vector[2],
	                    y2: vector[3],
	                    gradientTransform: element.matrix.invert()
	                });
	                SVG.defs.appendChild(el);
	                for (var i = 0, ii = dots.length; i < ii; i++) {
	                    el.appendChild($("stop", {
	                        offset: dots[i].offset ? dots[i].offset : i ? "100%" : "0%",
	                        "stop-color": dots[i].color || "#fff",
	                        "stop-opacity": isFinite(dots[i].opacity) ? dots[i].opacity : 1
	                    }));
	                }
	            }
	        }
	        $(o, {
	            fill: fillurl(id),
	            opacity: 1,
	            "fill-opacity": 1
	        });
	        s.fill = E;
	        s.opacity = 1;
	        s.fillOpacity = 1;
	        return 1;
	    },
	    isIE9or10 = function () {
	      var mode = document.documentMode;
	      return mode && (mode === 9 || mode === 10);
	    },
	    fillurl = function (id) {
	      if (isIE9or10()) {
	          return "url('#" + id + "')";
	      }
	      var location = document.location;
	      var locationString = (
	          location.protocol + '//' +
	          location.host +
	          location.pathname +
	          location.search
	      );
	      return "url('" + locationString + "#" + id + "')";
	    },
	    updatePosition = function (o) {
	        var bbox = o.getBBox(1);
	        $(o.pattern, {patternTransform: o.matrix.invert() + " translate(" + bbox.x + "," + bbox.y + ")"});
	    },
	    addArrow = function (o, value, isEnd) {
	        if (o.type == "path") {
	            var values = Str(value).toLowerCase().split("-"),
	                p = o.paper,
	                se = isEnd ? "end" : "start",
	                node = o.node,
	                attrs = o.attrs,
	                stroke = attrs["stroke-width"],
	                i = values.length,
	                type = "classic",
	                from,
	                to,
	                dx,
	                refX,
	                attr,
	                w = 3,
	                h = 3,
	                t = 5;
	            while (i--) {
	                switch (values[i]) {
	                    case "block":
	                    case "classic":
	                    case "oval":
	                    case "diamond":
	                    case "open":
	                    case "none":
	                        type = values[i];
	                        break;
	                    case "wide": h = 5; break;
	                    case "narrow": h = 2; break;
	                    case "long": w = 5; break;
	                    case "short": w = 2; break;
	                }
	            }
	            if (type == "open") {
	                w += 2;
	                h += 2;
	                t += 2;
	                dx = 1;
	                refX = isEnd ? 4 : 1;
	                attr = {
	                    fill: "none",
	                    stroke: attrs.stroke
	                };
	            } else {
	                refX = dx = w / 2;
	                attr = {
	                    fill: attrs.stroke,
	                    stroke: "none"
	                };
	            }
	            if (o._.arrows) {
	                if (isEnd) {
	                    o._.arrows.endPath && markerCounter[o._.arrows.endPath]--;
	                    o._.arrows.endMarker && markerCounter[o._.arrows.endMarker]--;
	                } else {
	                    o._.arrows.startPath && markerCounter[o._.arrows.startPath]--;
	                    o._.arrows.startMarker && markerCounter[o._.arrows.startMarker]--;
	                }
	            } else {
	                o._.arrows = {};
	            }
	            if (type != "none") {
	                var pathId = "raphael-marker-" + type,
	                    markerId = "raphael-marker-" + se + type + w + h + "-obj" + o.id;
	                if (!R._g.doc.getElementById(pathId)) {
	                    p.defs.appendChild($($("path"), {
	                        "stroke-linecap": "round",
	                        d: markers[type],
	                        id: pathId
	                    }));
	                    markerCounter[pathId] = 1;
	                } else {
	                    markerCounter[pathId]++;
	                }
	                var marker = R._g.doc.getElementById(markerId),
	                    use;
	                if (!marker) {
	                    marker = $($("marker"), {
	                        id: markerId,
	                        markerHeight: h,
	                        markerWidth: w,
	                        orient: "auto",
	                        refX: refX,
	                        refY: h / 2
	                    });
	                    use = $($("use"), {
	                        "xlink:href": "#" + pathId,
	                        transform: (isEnd ? "rotate(180 " + w / 2 + " " + h / 2 + ") " : E) + "scale(" + w / t + "," + h / t + ")",
	                        "stroke-width": (1 / ((w / t + h / t) / 2)).toFixed(4)
	                    });
	                    marker.appendChild(use);
	                    p.defs.appendChild(marker);
	                    markerCounter[markerId] = 1;
	                } else {
	                    markerCounter[markerId]++;
	                    use = marker.getElementsByTagName("use")[0];
	                }
	                $(use, attr);
	                var delta = dx * (type != "diamond" && type != "oval");
	                if (isEnd) {
	                    from = o._.arrows.startdx * stroke || 0;
	                    to = R.getTotalLength(attrs.path) - delta * stroke;
	                } else {
	                    from = delta * stroke;
	                    to = R.getTotalLength(attrs.path) - (o._.arrows.enddx * stroke || 0);
	                }
	                attr = {};
	                attr["marker-" + se] = "url(#" + markerId + ")";
	                if (to || from) {
	                    attr.d = R.getSubpath(attrs.path, from, to);
	                }
	                $(node, attr);
	                o._.arrows[se + "Path"] = pathId;
	                o._.arrows[se + "Marker"] = markerId;
	                o._.arrows[se + "dx"] = delta;
	                o._.arrows[se + "Type"] = type;
	                o._.arrows[se + "String"] = value;
	            } else {
	                if (isEnd) {
	                    from = o._.arrows.startdx * stroke || 0;
	                    to = R.getTotalLength(attrs.path) - from;
	                } else {
	                    from = 0;
	                    to = R.getTotalLength(attrs.path) - (o._.arrows.enddx * stroke || 0);
	                }
	                o._.arrows[se + "Path"] && $(node, {d: R.getSubpath(attrs.path, from, to)});
	                delete o._.arrows[se + "Path"];
	                delete o._.arrows[se + "Marker"];
	                delete o._.arrows[se + "dx"];
	                delete o._.arrows[se + "Type"];
	                delete o._.arrows[se + "String"];
	            }
	            for (attr in markerCounter) if (markerCounter[has](attr) && !markerCounter[attr]) {
	                var item = R._g.doc.getElementById(attr);
	                item && item.parentNode.removeChild(item);
	            }
	        }
	    },
	    dasharray = {
	        "-": [3, 1],
	        ".": [1, 1],
	        "-.": [3, 1, 1, 1],
	        "-..": [3, 1, 1, 1, 1, 1],
	        ". ": [1, 3],
	        "- ": [4, 3],
	        "--": [8, 3],
	        "- .": [4, 3, 1, 3],
	        "--.": [8, 3, 1, 3],
	        "--..": [8, 3, 1, 3, 1, 3]
	    },
	    addDashes = function (o, value, params) {
	        value = dasharray[Str(value).toLowerCase()];
	        if (value) {
	            var width = o.attrs["stroke-width"] || "1",
	                butt = {round: width, square: width, butt: 0}[o.attrs["stroke-linecap"] || params["stroke-linecap"]] || 0,
	                dashes = [],
	                i = value.length;
	            while (i--) {
	                dashes[i] = value[i] * width + ((i % 2) ? 1 : -1) * butt;
	            }
	            $(o.node, {"stroke-dasharray": dashes.join(",")});
	        }
	        else {
	          $(o.node, {"stroke-dasharray": "none"});
	        }
	    },
	    setFillAndStroke = function (o, params) {
	        var node = o.node,
	            attrs = o.attrs,
	            vis = node.style.visibility;
	        node.style.visibility = "hidden";
	        for (var att in params) {
	            if (params[has](att)) {
	                if (!R._availableAttrs[has](att)) {
	                    continue;
	                }
	                var value = params[att];
	                attrs[att] = value;
	                switch (att) {
	                    case "blur":
	                        o.blur(value);
	                        break;
	                    case "title":
	                        var title = node.getElementsByTagName("title");
	
	                        // Use the existing <title>.
	                        if (title.length && (title = title[0])) {
	                          title.firstChild.nodeValue = value;
	                        } else {
	                          title = $("title");
	                          var val = R._g.doc.createTextNode(value);
	                          title.appendChild(val);
	                          node.appendChild(title);
	                        }
	                        break;
	                    case "href":
	                    case "target":
	                        var pn = node.parentNode;
	                        if (pn.tagName.toLowerCase() != "a") {
	                            var hl = $("a");
	                            pn.insertBefore(hl, node);
	                            hl.appendChild(node);
	                            pn = hl;
	                        }
	                        if (att == "target") {
	                            pn.setAttributeNS(xlink, "show", value == "blank" ? "new" : value);
	                        } else {
	                            pn.setAttributeNS(xlink, att, value);
	                        }
	                        break;
	                    case "cursor":
	                        node.style.cursor = value;
	                        break;
	                    case "transform":
	                        o.transform(value);
	                        break;
	                    case "arrow-start":
	                        addArrow(o, value);
	                        break;
	                    case "arrow-end":
	                        addArrow(o, value, 1);
	                        break;
	                    case "clip-rect":
	                        var rect = Str(value).split(separator);
	                        if (rect.length == 4) {
	                            o.clip && o.clip.parentNode.parentNode.removeChild(o.clip.parentNode);
	                            var el = $("clipPath"),
	                                rc = $("rect");
	                            el.id = R.createUUID();
	                            $(rc, {
	                                x: rect[0],
	                                y: rect[1],
	                                width: rect[2],
	                                height: rect[3]
	                            });
	                            el.appendChild(rc);
	                            o.paper.defs.appendChild(el);
	                            $(node, {"clip-path": "url(#" + el.id + ")"});
	                            o.clip = rc;
	                        }
	                        if (!value) {
	                            var path = node.getAttribute("clip-path");
	                            if (path) {
	                                var clip = R._g.doc.getElementById(path.replace(/(^url\(#|\)$)/g, E));
	                                clip && clip.parentNode.removeChild(clip);
	                                $(node, {"clip-path": E});
	                                delete o.clip;
	                            }
	                        }
	                    break;
	                    case "path":
	                        if (o.type == "path") {
	                            $(node, {d: value ? attrs.path = R._pathToAbsolute(value) : "M0,0"});
	                            o._.dirty = 1;
	                            if (o._.arrows) {
	                                "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
	                                "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
	                            }
	                        }
	                        break;
	                    case "width":
	                        node.setAttribute(att, value);
	                        o._.dirty = 1;
	                        if (attrs.fx) {
	                            att = "x";
	                            value = attrs.x;
	                        } else {
	                            break;
	                        }
	                    case "x":
	                        if (attrs.fx) {
	                            value = -attrs.x - (attrs.width || 0);
	                        }
	                    case "rx":
	                        if (att == "rx" && o.type == "rect") {
	                            break;
	                        }
	                    case "cx":
	                        node.setAttribute(att, value);
	                        o.pattern && updatePosition(o);
	                        o._.dirty = 1;
	                        break;
	                    case "height":
	                        node.setAttribute(att, value);
	                        o._.dirty = 1;
	                        if (attrs.fy) {
	                            att = "y";
	                            value = attrs.y;
	                        } else {
	                            break;
	                        }
	                    case "y":
	                        if (attrs.fy) {
	                            value = -attrs.y - (attrs.height || 0);
	                        }
	                    case "ry":
	                        if (att == "ry" && o.type == "rect") {
	                            break;
	                        }
	                    case "cy":
	                        node.setAttribute(att, value);
	                        o.pattern && updatePosition(o);
	                        o._.dirty = 1;
	                        break;
	                    case "r":
	                        if (o.type == "rect") {
	                            $(node, {rx: value, ry: value});
	                        } else {
	                            node.setAttribute(att, value);
	                        }
	                        o._.dirty = 1;
	                        break;
	                    case "src":
	                        if (o.type == "image") {
	                            node.setAttributeNS(xlink, "href", value);
	                        }
	                        break;
	                    case "stroke-width":
	                        if (o._.sx != 1 || o._.sy != 1) {
	                            value /= mmax(abs(o._.sx), abs(o._.sy)) || 1;
	                        }
	                        node.setAttribute(att, value);
	                        if (attrs["stroke-dasharray"]) {
	                            addDashes(o, attrs["stroke-dasharray"], params);
	                        }
	                        if (o._.arrows) {
	                            "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
	                            "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
	                        }
	                        break;
	                    case "stroke-dasharray":
	                        addDashes(o, value, params);
	                        break;
	                    case "fill":
	                        var isURL = Str(value).match(R._ISURL);
	                        if (isURL) {
	                            el = $("pattern");
	                            var ig = $("image");
	                            el.id = R.createUUID();
	                            $(el, {x: 0, y: 0, patternUnits: "userSpaceOnUse", height: 1, width: 1});
	                            $(ig, {x: 0, y: 0, "xlink:href": isURL[1]});
	                            el.appendChild(ig);
	
	                            (function (el) {
	                                R._preload(isURL[1], function () {
	                                    var w = this.offsetWidth,
	                                        h = this.offsetHeight;
	                                    $(el, {width: w, height: h});
	                                    $(ig, {width: w, height: h});
	                                });
	                            })(el);
	                            o.paper.defs.appendChild(el);
	                            $(node, {fill: "url(#" + el.id + ")"});
	                            o.pattern = el;
	                            o.pattern && updatePosition(o);
	                            break;
	                        }
	                        var clr = R.getRGB(value);
	                        if (!clr.error) {
	                            delete params.gradient;
	                            delete attrs.gradient;
	                            !R.is(attrs.opacity, "undefined") &&
	                                R.is(params.opacity, "undefined") &&
	                                $(node, {opacity: attrs.opacity});
	                            !R.is(attrs["fill-opacity"], "undefined") &&
	                                R.is(params["fill-opacity"], "undefined") &&
	                                $(node, {"fill-opacity": attrs["fill-opacity"]});
	                        } else if ((o.type == "circle" || o.type == "ellipse" || Str(value).charAt() != "r") && addGradientFill(o, value)) {
	                            if ("opacity" in attrs || "fill-opacity" in attrs) {
	                                var gradient = R._g.doc.getElementById(node.getAttribute("fill").replace(/^url\(#|\)$/g, E));
	                                if (gradient) {
	                                    var stops = gradient.getElementsByTagName("stop");
	                                    $(stops[stops.length - 1], {"stop-opacity": ("opacity" in attrs ? attrs.opacity : 1) * ("fill-opacity" in attrs ? attrs["fill-opacity"] : 1)});
	                                }
	                            }
	                            attrs.gradient = value;
	                            attrs.fill = "none";
	                            break;
	                        }
	                        clr[has]("opacity") && $(node, {"fill-opacity": clr.opacity > 1 ? clr.opacity / 100 : clr.opacity});
	                    case "stroke":
	                        clr = R.getRGB(value);
	                        node.setAttribute(att, clr.hex);
	                        att == "stroke" && clr[has]("opacity") && $(node, {"stroke-opacity": clr.opacity > 1 ? clr.opacity / 100 : clr.opacity});
	                        if (att == "stroke" && o._.arrows) {
	                            "startString" in o._.arrows && addArrow(o, o._.arrows.startString);
	                            "endString" in o._.arrows && addArrow(o, o._.arrows.endString, 1);
	                        }
	                        break;
	                    case "gradient":
	                        (o.type == "circle" || o.type == "ellipse" || Str(value).charAt() != "r") && addGradientFill(o, value);
	                        break;
	                    case "opacity":
	                        if (attrs.gradient && !attrs[has]("stroke-opacity")) {
	                            $(node, {"stroke-opacity": value > 1 ? value / 100 : value});
	                        }
	                        // fall
	                    case "fill-opacity":
	                        if (attrs.gradient) {
	                            gradient = R._g.doc.getElementById(node.getAttribute("fill").replace(/^url\(#|\)$/g, E));
	                            if (gradient) {
	                                stops = gradient.getElementsByTagName("stop");
	                                $(stops[stops.length - 1], {"stop-opacity": value});
	                            }
	                            break;
	                        }
	                    default:
	                        // don't round font size to lowest integer; was parseInt(value)
	                        att == "font-size" && (value = value + "px");
	                        var cssrule = att.replace(/(\-.)/g, function (w) {
	                            return w.substring(1).toUpperCase();
	                        });
	                        node.style[cssrule] = value;
	                        o._.dirty = 1;
	                        node.setAttribute(att, value);
	                        break;
	                }
	            }
	        }
	
	        tuneText(o, params);
	        node.style.visibility = vis;
	    },
	    leading = 1.2,
	    tuneText = function (el, params) {
	        if (el.type != "text" || !(params[has]("text") || params[has]("font") || params[has]("font-size") || params[has]("x") || params[has]("y"))) {
	            return;
	        }
	        var a = el.attrs,
	            node = el.node,
	             // don't round font size to lowest integer; was parseInt
	            fontSize = node.firstChild
	                ? parseFloat( R._g.doc.defaultView.getComputedStyle(node.firstChild, E).getPropertyValue("font-size") )
	                : 10,
	                // Allow user to override constant 1.2 leading by declaring lineHeight value on element.data.
	                lineHeight = el.data('lineHeight') ? el.data('lineHeight') : leading; 
	
	        if (params[has]("text")) {
	            a.text = params.text;
	            while (node.firstChild) {
	                node.removeChild(node.firstChild);
	            }
	            var texts = Str(params.text).split("\n"),
	                tspans = [],
	                tspan;
	            for (var i = 0, ii = texts.length; i < ii; i++) {
	                tspan = $("tspan");
	                i && $(tspan, {dy: fontSize * lineHeight, x: a.x});
	                tspan.appendChild(R._g.doc.createTextNode(texts[i]));
	                node.appendChild(tspan);
	                tspans[i] = tspan;
	            }
	        } else {
	            tspans = node.getElementsByTagName("tspan");
	            for (i = 0, ii = tspans.length; i < ii; i++) if (i) {
	                $(tspans[i], {dy: fontSize * lineHeight, x: a.x});
	            } else {
	                $(tspans[0], {dy: 0});
	            }
	        }
	        $(node, {x: a.x, y: a.y});
	        el._.dirty = 1;
	        var bb = el._getBBox(),
	            dif = a.y - (bb.y + bb.height / 2);
	        dif && R.is(dif, "finite") && $(tspans[0], {dy: dif});
	    },
	    getRealNode = function (node) {
	        if (node.parentNode && node.parentNode.tagName.toLowerCase() === "a") {
	            return node.parentNode;
	        } else {
	            return node;
	        }
	    },
	    Element = function (node, svg) {
	        var X = 0,
	            Y = 0;
	        /*\
	         * Element.node
	         [ property (object) ]
	         **
	         * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
	         **
	         * Note: Don’t mess with it.
	         > Usage
	         | // draw a circle at coordinate 10,10 with radius of 10
	         | var c = paper.circle(10, 10, 10);
	         | c.node.onclick = function () {
	         |     c.attr("fill", "red");
	         | };
	        \*/
	        this[0] = this.node = node;
	        /*\
	         * Element.raphael
	         [ property (object) ]
	         **
	         * Internal reference to @Raphael object. In case it is not available.
	         > Usage
	         | Raphael.el.red = function () {
	         |     var hsb = this.paper.raphael.rgb2hsb(this.attr("fill"));
	         |     hsb.h = 1;
	         |     this.attr({fill: this.paper.raphael.hsb2rgb(hsb).hex});
	         | }
	        \*/
	        node.raphael = true;
	        /*\
	         * Element.id
	         [ property (number) ]
	         **
	         * Unique id of the element. Especially useful when you want to listen to events of the element,
	         * because all events are fired in format `<module>.<action>.<id>`. Also useful for @Paper.getById method.
	        \*/
	        this.id = guid();
	        node.raphaelid = this.id;
	
	        /**
	        * Method that returns a 5 letter/digit id, enough for 36^5 = 60466176 elements
	        * @returns {string} id
	        */
	        function guid() {
	            return ("0000" + (Math.random()*Math.pow(36,5) << 0).toString(36)).slice(-5);
	        }
	
	        this.matrix = R.matrix();
	        this.realPath = null;
	        /*\
	         * Element.paper
	         [ property (object) ]
	         **
	         * Internal reference to “paper” where object drawn. Mainly for use in plugins and element extensions.
	         > Usage
	         | Raphael.el.cross = function () {
	         |     this.attr({fill: "red"});
	         |     this.paper.path("M10,10L50,50M50,10L10,50")
	         |         .attr({stroke: "red"});
	         | }
	        \*/
	        this.paper = svg;
	        this.attrs = this.attrs || {};
	        this._ = {
	            transform: [],
	            sx: 1,
	            sy: 1,
	            deg: 0,
	            dx: 0,
	            dy: 0,
	            dirty: 1
	        };
	        !svg.bottom && (svg.bottom = this);
	        /*\
	         * Element.prev
	         [ property (object) ]
	         **
	         * Reference to the previous element in the hierarchy.
	        \*/
	        this.prev = svg.top;
	        svg.top && (svg.top.next = this);
	        svg.top = this;
	        /*\
	         * Element.next
	         [ property (object) ]
	         **
	         * Reference to the next element in the hierarchy.
	        \*/
	        this.next = null;
	    },
	    elproto = R.el;
	
	    Element.prototype = elproto;
	    elproto.constructor = Element;
	
	    R._engine.path = function (pathString, SVG) {
	        var el = $("path");
	        SVG.canvas && SVG.canvas.appendChild(el);
	        var p = new Element(el, SVG);
	        p.type = "path";
	        setFillAndStroke(p, {
	            fill: "none",
	            stroke: "#000",
	            path: pathString
	        });
	        return p;
	    };
	    /*\
	     * Element.rotate
	     [ method ]
	     **
	     * Deprecated! Use @Element.transform instead.
	     * Adds rotation by given angle around given point to the list of
	     * transformations of the element.
	     > Parameters
	     - deg (number) angle in degrees
	     - cx (number) #optional x coordinate of the centre of rotation
	     - cy (number) #optional y coordinate of the centre of rotation
	     * If cx & cy aren’t specified centre of the shape is used as a point of rotation.
	     = (object) @Element
	    \*/
	    elproto.rotate = function (deg, cx, cy) {
	        if (this.removed) {
	            return this;
	        }
	        deg = Str(deg).split(separator);
	        if (deg.length - 1) {
	            cx = toFloat(deg[1]);
	            cy = toFloat(deg[2]);
	        }
	        deg = toFloat(deg[0]);
	        (cy == null) && (cx = cy);
	        if (cx == null || cy == null) {
	            var bbox = this.getBBox(1);
	            cx = bbox.x + bbox.width / 2;
	            cy = bbox.y + bbox.height / 2;
	        }
	        this.transform(this._.transform.concat([["r", deg, cx, cy]]));
	        return this;
	    };
	    /*\
	     * Element.scale
	     [ method ]
	     **
	     * Deprecated! Use @Element.transform instead.
	     * Adds scale by given amount relative to given point to the list of
	     * transformations of the element.
	     > Parameters
	     - sx (number) horisontal scale amount
	     - sy (number) vertical scale amount
	     - cx (number) #optional x coordinate of the centre of scale
	     - cy (number) #optional y coordinate of the centre of scale
	     * If cx & cy aren’t specified centre of the shape is used instead.
	     = (object) @Element
	    \*/
	    elproto.scale = function (sx, sy, cx, cy) {
	        if (this.removed) {
	            return this;
	        }
	        sx = Str(sx).split(separator);
	        if (sx.length - 1) {
	            sy = toFloat(sx[1]);
	            cx = toFloat(sx[2]);
	            cy = toFloat(sx[3]);
	        }
	        sx = toFloat(sx[0]);
	        (sy == null) && (sy = sx);
	        (cy == null) && (cx = cy);
	        if (cx == null || cy == null) {
	            var bbox = this.getBBox(1);
	        }
	        cx = cx == null ? bbox.x + bbox.width / 2 : cx;
	        cy = cy == null ? bbox.y + bbox.height / 2 : cy;
	        this.transform(this._.transform.concat([["s", sx, sy, cx, cy]]));
	        return this;
	    };
	    /*\
	     * Element.translate
	     [ method ]
	     **
	     * Deprecated! Use @Element.transform instead.
	     * Adds translation by given amount to the list of transformations of the element.
	     > Parameters
	     - dx (number) horisontal shift
	     - dy (number) vertical shift
	     = (object) @Element
	    \*/
	    elproto.translate = function (dx, dy) {
	        if (this.removed) {
	            return this;
	        }
	        dx = Str(dx).split(separator);
	        if (dx.length - 1) {
	            dy = toFloat(dx[1]);
	        }
	        dx = toFloat(dx[0]) || 0;
	        dy = +dy || 0;
	        this.transform(this._.transform.concat([["t", dx, dy]]));
	        return this;
	    };
	    /*\
	     * Element.transform
	     [ method ]
	     **
	     * Adds transformation to the element which is separate to other attributes,
	     * i.e. translation doesn’t change `x` or `y` of the rectange. The format
	     * of transformation string is similar to the path string syntax:
	     | "t100,100r30,100,100s2,2,100,100r45s1.5"
	     * Each letter is a command. There are four commands: `t` is for translate, `r` is for rotate, `s` is for
	     * scale and `m` is for matrix.
	     *
	     * There are also alternative “absolute” translation, rotation and scale: `T`, `R` and `S`. They will not take previous transformation into account. For example, `...T100,0` will always move element 100 px horisontally, while `...t100,0` could move it vertically if there is `r90` before. Just compare results of `r90t100,0` and `r90T100,0`.
	     *
	     * So, the example line above could be read like “translate by 100, 100; rotate 30° around 100, 100; scale twice around 100, 100;
	     * rotate 45° around centre; scale 1.5 times relative to centre”. As you can see rotate and scale commands have origin
	     * coordinates as optional parameters, the default is the centre point of the element.
	     * Matrix accepts six parameters.
	     > Usage
	     | var el = paper.rect(10, 20, 300, 200);
	     | // translate 100, 100, rotate 45°, translate -100, 0
	     | el.transform("t100,100r45t-100,0");
	     | // if you want you can append or prepend transformations
	     | el.transform("...t50,50");
	     | el.transform("s2...");
	     | // or even wrap
	     | el.transform("t50,50...t-50-50");
	     | // to reset transformation call method with empty string
	     | el.transform("");
	     | // to get current value call it without parameters
	     | console.log(el.transform());
	     > Parameters
	     - tstr (string) #optional transformation string
	     * If tstr isn’t specified
	     = (string) current transformation string
	     * else
	     = (object) @Element
	    \*/
	    elproto.transform = function (tstr) {
	        var _ = this._;
	        if (tstr == null) {
	            return _.transform;
	        }
	        R._extractTransform(this, tstr);
	
	        this.clip && $(this.clip, {transform: this.matrix.invert()});
	        this.pattern && updatePosition(this);
	        this.node && $(this.node, {transform: this.matrix});
	
	        if (_.sx != 1 || _.sy != 1) {
	            var sw = this.attrs[has]("stroke-width") ? this.attrs["stroke-width"] : 1;
	            this.attr({"stroke-width": sw});
	        }
	
	        return this;
	    };
	    /*\
	     * Element.hide
	     [ method ]
	     **
	     * Makes element invisible. See @Element.show.
	     = (object) @Element
	    \*/
	    elproto.hide = function () {
	        if(!this.removed) this.node.style.display = "none";
	        return this;
	    };
	    /*\
	     * Element.show
	     [ method ]
	     **
	     * Makes element visible. See @Element.hide.
	     = (object) @Element
	    \*/
	    elproto.show = function () {
	        if(!this.removed) this.node.style.display = "";
	        return this;
	    };
	    /*\
	     * Element.remove
	     [ method ]
	     **
	     * Removes element from the paper.
	    \*/
	    elproto.remove = function () {
	        var node = getRealNode(this.node);
	        if (this.removed || !node.parentNode) {
	            return;
	        }
	        var paper = this.paper;
	        paper.__set__ && paper.__set__.exclude(this);
	        eve.unbind("raphael.*.*." + this.id);
	        if (this.gradient) {
	            paper.defs.removeChild(this.gradient);
	        }
	        R._tear(this, paper);
	
	        node.parentNode.removeChild(node);
	
	        // Remove custom data for element
	        this.removeData();
	
	        for (var i in this) {
	            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
	        }
	        this.removed = true;
	    };
	    elproto._getBBox = function () {
	        if (this.node.style.display == "none") {
	            this.show();
	            var hide = true;
	        }
	        var canvasHidden = false,
	            containerStyle;
	        if (this.paper.canvas.parentElement) {
	          containerStyle = this.paper.canvas.parentElement.style;
	        } //IE10+ can't find parentElement
	        else if (this.paper.canvas.parentNode) {
	          containerStyle = this.paper.canvas.parentNode.style;
	        }
	
	        if(containerStyle && containerStyle.display == "none") {
	          canvasHidden = true;
	          containerStyle.display = "";
	        }
	        var bbox = {};
	        try {
	            bbox = this.node.getBBox();
	        } catch(e) {
	            // Firefox 3.0.x, 25.0.1 (probably more versions affected) play badly here - possible fix
	            bbox = {
	                x: this.node.clientLeft,
	                y: this.node.clientTop,
	                width: this.node.clientWidth,
	                height: this.node.clientHeight
	            }
	        } finally {
	            bbox = bbox || {};
	            if(canvasHidden){
	              containerStyle.display = "none";
	            }
	        }
	        hide && this.hide();
	        return bbox;
	    };
	    /*\
	     * Element.attr
	     [ method ]
	     **
	     * Sets the attributes of the element.
	     > Parameters
	     - attrName (string) attribute’s name
	     - value (string) value
	     * or
	     - params (object) object of name/value pairs
	     * or
	     - attrName (string) attribute’s name
	     * or
	     - attrNames (array) in this case method returns array of current values for given attribute names
	     = (object) @Element if attrsName & value or params are passed in.
	     = (...) value of the attribute if only attrsName is passed in.
	     = (array) array of values of the attribute if attrsNames is passed in.
	     = (object) object of attributes if nothing is passed in.
	     > Possible parameters
	     # <p>Please refer to the <a href="http://www.w3.org/TR/SVG/" title="The W3C Recommendation for the SVG language describes these properties in detail.">SVG specification</a> for an explanation of these parameters.</p>
	     o arrow-end (string) arrowhead on the end of the path. The format for string is `<type>[-<width>[-<length>]]`. Possible types: `classic`, `block`, `open`, `oval`, `diamond`, `none`, width: `wide`, `narrow`, `medium`, length: `long`, `short`, `midium`.
	     o clip-rect (string) comma or space separated values: x, y, width and height
	     o cursor (string) CSS type of the cursor
	     o cx (number) the x-axis coordinate of the center of the circle, or ellipse
	     o cy (number) the y-axis coordinate of the center of the circle, or ellipse
	     o fill (string) colour, gradient or image
	     o fill-opacity (number)
	     o font (string)
	     o font-family (string)
	     o font-size (number) font size in pixels
	     o font-weight (string)
	     o height (number)
	     o href (string) URL, if specified element behaves as hyperlink
	     o opacity (number)
	     o path (string) SVG path string format
	     o r (number) radius of the circle, ellipse or rounded corner on the rect
	     o rx (number) horisontal radius of the ellipse
	     o ry (number) vertical radius of the ellipse
	     o src (string) image URL, only works for @Element.image element
	     o stroke (string) stroke colour
	     o stroke-dasharray (string) [“”, “none”, “`-`”, “`.`”, “`-.`”, “`-..`”, “`. `”, “`- `”, “`--`”, “`- .`”, “`--.`”, “`--..`”]
	     o stroke-linecap (string) [“`butt`”, “`square`”, “`round`”]
	     o stroke-linejoin (string) [“`bevel`”, “`round`”, “`miter`”]
	     o stroke-miterlimit (number)
	     o stroke-opacity (number)
	     o stroke-width (number) stroke width in pixels, default is '1'
	     o target (string) used with href
	     o text (string) contents of the text element. Use `\n` for multiline text
	     o text-anchor (string) [“`start`”, “`middle`”, “`end`”], default is “`middle`”
	     o title (string) will create tooltip with a given text
	     o transform (string) see @Element.transform
	     o width (number)
	     o x (number)
	     o y (number)
	     > Gradients
	     * Linear gradient format: “`‹angle›-‹colour›[-‹colour›[:‹offset›]]*-‹colour›`”, example: “`90-#fff-#000`” – 90°
	     * gradient from white to black or “`0-#fff-#f00:20-#000`” – 0° gradient from white via red (at 20%) to black.
	     *
	     * radial gradient: “`r[(‹fx›, ‹fy›)]‹colour›[-‹colour›[:‹offset›]]*-‹colour›`”, example: “`r#fff-#000`” –
	     * gradient from white to black or “`r(0.25, 0.75)#fff-#000`” – gradient from white to black with focus point
	     * at 0.25, 0.75. Focus point coordinates are in 0..1 range. Radial gradients can only be applied to circles and ellipses.
	     > Path String
	     # <p>Please refer to <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path’s data attribute’s format are described in the SVG specification.">SVG documentation regarding path string</a>. Raphaël fully supports it.</p>
	     > Colour Parsing
	     # <ul>
	     #     <li>Colour name (“<code>red</code>”, “<code>green</code>”, “<code>cornflowerblue</code>”, etc)</li>
	     #     <li>#••• — shortened HTML colour: (“<code>#000</code>”, “<code>#fc0</code>”, etc)</li>
	     #     <li>#•••••• — full length HTML colour: (“<code>#000000</code>”, “<code>#bd2300</code>”)</li>
	     #     <li>rgb(•••, •••, •••) — red, green and blue channels’ values: (“<code>rgb(200,&nbsp;100,&nbsp;0)</code>”)</li>
	     #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (“<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>”)</li>
	     #     <li>rgba(•••, •••, •••, •••) — red, green and blue channels’ values: (“<code>rgba(200,&nbsp;100,&nbsp;0, .5)</code>”)</li>
	     #     <li>rgba(•••%, •••%, •••%, •••%) — same as above, but in %: (“<code>rgba(100%,&nbsp;175%,&nbsp;0%, 50%)</code>”)</li>
	     #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (“<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>”)</li>
	     #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
	     #     <li>hsba(•••, •••, •••, •••) — same as above, but with opacity</li>
	     #     <li>hsl(•••, •••, •••) — almost the same as hsb, see <a href="http://en.wikipedia.org/wiki/HSL_and_HSV" title="HSL and HSV - Wikipedia, the free encyclopedia">Wikipedia page</a></li>
	     #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
	     #     <li>hsla(•••, •••, •••, •••) — same as above, but with opacity</li>
	     #     <li>Optionally for hsb and hsl you could specify hue as a degree: “<code>hsl(240deg,&nbsp;1,&nbsp;.5)</code>” or, if you want to go fancy, “<code>hsl(240°,&nbsp;1,&nbsp;.5)</code>”</li>
	     # </ul>
	    \*/
	    elproto.attr = function (name, value) {
	        if (this.removed) {
	            return this;
	        }
	        if (name == null) {
	            var res = {};
	            for (var a in this.attrs) if (this.attrs[has](a)) {
	                res[a] = this.attrs[a];
	            }
	            res.gradient && res.fill == "none" && (res.fill = res.gradient) && delete res.gradient;
	            res.transform = this._.transform;
	            return res;
	        }
	        if (value == null && R.is(name, "string")) {
	            if (name == "fill" && this.attrs.fill == "none" && this.attrs.gradient) {
	                return this.attrs.gradient;
	            }
	            if (name == "transform") {
	                return this._.transform;
	            }
	            var names = name.split(separator),
	                out = {};
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                name = names[i];
	                if (name in this.attrs) {
	                    out[name] = this.attrs[name];
	                } else if (R.is(this.paper.customAttributes[name], "function")) {
	                    out[name] = this.paper.customAttributes[name].def;
	                } else {
	                    out[name] = R._availableAttrs[name];
	                }
	            }
	            return ii - 1 ? out : out[names[0]];
	        }
	        if (value == null && R.is(name, "array")) {
	            out = {};
	            for (i = 0, ii = name.length; i < ii; i++) {
	                out[name[i]] = this.attr(name[i]);
	            }
	            return out;
	        }
	        if (value != null) {
	            var params = {};
	            params[name] = value;
	        } else if (name != null && R.is(name, "object")) {
	            params = name;
	        }
	        for (var key in params) {
	            eve("raphael.attr." + key + "." + this.id, this, params[key]);
	        }
	        for (key in this.paper.customAttributes) if (this.paper.customAttributes[has](key) && params[has](key) && R.is(this.paper.customAttributes[key], "function")) {
	            var par = this.paper.customAttributes[key].apply(this, [].concat(params[key]));
	            this.attrs[key] = params[key];
	            for (var subkey in par) if (par[has](subkey)) {
	                params[subkey] = par[subkey];
	            }
	        }
	        setFillAndStroke(this, params);
	        return this;
	    };
	    /*\
	     * Element.toFront
	     [ method ]
	     **
	     * Moves the element so it is the closest to the viewer’s eyes, on top of other elements.
	     = (object) @Element
	    \*/
	    elproto.toFront = function () {
	        if (this.removed) {
	            return this;
	        }
	        var node = getRealNode(this.node);
	        node.parentNode.appendChild(node);
	        var svg = this.paper;
	        svg.top != this && R._tofront(this, svg);
	        return this;
	    };
	    /*\
	     * Element.toBack
	     [ method ]
	     **
	     * Moves the element so it is the furthest from the viewer’s eyes, behind other elements.
	     = (object) @Element
	    \*/
	    elproto.toBack = function () {
	        if (this.removed) {
	            return this;
	        }
	        var node = getRealNode(this.node);
	        var parentNode = node.parentNode;
	        parentNode.insertBefore(node, parentNode.firstChild);
	        R._toback(this, this.paper);
	        var svg = this.paper;
	        return this;
	    };
	    /*\
	     * Element.insertAfter
	     [ method ]
	     **
	     * Inserts current object after the given one.
	     = (object) @Element
	    \*/
	    elproto.insertAfter = function (element) {
	        if (this.removed || !element) {
	            return this;
	        }
	
	        var node = getRealNode(this.node);
	        var afterNode = getRealNode(element.node || element[element.length - 1].node);
	        if (afterNode.nextSibling) {
	            afterNode.parentNode.insertBefore(node, afterNode.nextSibling);
	        } else {
	            afterNode.parentNode.appendChild(node);
	        }
	        R._insertafter(this, element, this.paper);
	        return this;
	    };
	    /*\
	     * Element.insertBefore
	     [ method ]
	     **
	     * Inserts current object before the given one.
	     = (object) @Element
	    \*/
	    elproto.insertBefore = function (element) {
	        if (this.removed || !element) {
	            return this;
	        }
	
	        var node = getRealNode(this.node);
	        var beforeNode = getRealNode(element.node || element[0].node);
	        beforeNode.parentNode.insertBefore(node, beforeNode);
	        R._insertbefore(this, element, this.paper);
	        return this;
	    };
	    elproto.blur = function (size) {
	        // Experimental. No Safari support. Use it on your own risk.
	        var t = this;
	        if (+size !== 0) {
	            var fltr = $("filter"),
	                blur = $("feGaussianBlur");
	            t.attrs.blur = size;
	            fltr.id = R.createUUID();
	            $(blur, {stdDeviation: +size || 1.5});
	            fltr.appendChild(blur);
	            t.paper.defs.appendChild(fltr);
	            t._blur = fltr;
	            $(t.node, {filter: "url(#" + fltr.id + ")"});
	        } else {
	            if (t._blur) {
	                t._blur.parentNode.removeChild(t._blur);
	                delete t._blur;
	                delete t.attrs.blur;
	            }
	            t.node.removeAttribute("filter");
	        }
	        return t;
	    };
	    R._engine.circle = function (svg, x, y, r) {
	        var el = $("circle");
	        svg.canvas && svg.canvas.appendChild(el);
	        var res = new Element(el, svg);
	        res.attrs = {cx: x, cy: y, r: r, fill: "none", stroke: "#000"};
	        res.type = "circle";
	        $(el, res.attrs);
	        return res;
	    };
	    R._engine.rect = function (svg, x, y, w, h, r) {
	        var el = $("rect");
	        svg.canvas && svg.canvas.appendChild(el);
	        var res = new Element(el, svg);
	        res.attrs = {x: x, y: y, width: w, height: h, rx: r || 0, ry: r || 0, fill: "none", stroke: "#000"};
	        res.type = "rect";
	        $(el, res.attrs);
	        return res;
	    };
	    R._engine.ellipse = function (svg, x, y, rx, ry) {
	        var el = $("ellipse");
	        svg.canvas && svg.canvas.appendChild(el);
	        var res = new Element(el, svg);
	        res.attrs = {cx: x, cy: y, rx: rx, ry: ry, fill: "none", stroke: "#000"};
	        res.type = "ellipse";
	        $(el, res.attrs);
	        return res;
	    };
	    R._engine.image = function (svg, src, x, y, w, h) {
	        var el = $("image");
	        $(el, {x: x, y: y, width: w, height: h, preserveAspectRatio: "none"});
	        el.setAttributeNS(xlink, "href", src);
	        svg.canvas && svg.canvas.appendChild(el);
	        var res = new Element(el, svg);
	        res.attrs = {x: x, y: y, width: w, height: h, src: src};
	        res.type = "image";
	        return res;
	    };
	    R._engine.text = function (svg, x, y, text) {
	        var el = $("text");
	        svg.canvas && svg.canvas.appendChild(el);
	        var res = new Element(el, svg);
	        res.attrs = {
	            x: x,
	            y: y,
	            "text-anchor": "middle",
	            text: text,
	            "font-family": R._availableAttrs["font-family"],
	            "font-size": R._availableAttrs["font-size"],
	            stroke: "none",
	            fill: "#000"
	        };
	        res.type = "text";
	        setFillAndStroke(res, res.attrs);
	        return res;
	    };
	    R._engine.setSize = function (width, height) {
	        this.width = width || this.width;
	        this.height = height || this.height;
	        this.canvas.setAttribute("width", this.width);
	        this.canvas.setAttribute("height", this.height);
	        if (this._viewBox) {
	            this.setViewBox.apply(this, this._viewBox);
	        }
	        return this;
	    };
	    R._engine.create = function () {
	        var con = R._getContainer.apply(0, arguments),
	            container = con && con.container;
	        if (!container) {
	            throw new Error("SVG container not found.");
	        }
	        var x = con.x,
	            y = con.y,
	            width = con.width,
	            height = con.height,
	            cnvs = $("svg"),
	            css = "overflow:hidden;",
	            isFloating;
	        x = x || 0;
	        y = y || 0;
	        width = width || 512;
	        height = height || 342;
	        $(cnvs, {
	            height: height,
	            version: 1.1,
	            width: width,
	            xmlns: "http://www.w3.org/2000/svg",
	            "xmlns:xlink": "http://www.w3.org/1999/xlink"
	        });
	        if (container == 1) {
	            cnvs.style.cssText = css + "position:absolute;left:" + x + "px;top:" + y + "px";
	            R._g.doc.body.appendChild(cnvs);
	            isFloating = 1;
	        } else {
	            cnvs.style.cssText = css + "position:relative";
	            if (container.firstChild) {
	                container.insertBefore(cnvs, container.firstChild);
	            } else {
	                container.appendChild(cnvs);
	            }
	        }
	        container = new R._Paper;
	        container.width = width;
	        container.height = height;
	        container.canvas = cnvs;
	        container.clear();
	        container._left = container._top = 0;
	        isFloating && (container.renderfix = function () {});
	        container.renderfix();
	        return container;
	    };
	    R._engine.setViewBox = function (x, y, w, h, fit) {
	        eve("raphael.setViewBox", this, this._viewBox, [x, y, w, h, fit]);
	        var paperSize = this.getSize(),
	            size = mmax(w / paperSize.width, h / paperSize.height),
	            top = this.top,
	            aspectRatio = fit ? "xMidYMid meet" : "xMinYMin",
	            vb,
	            sw;
	        if (x == null) {
	            if (this._vbSize) {
	                size = 1;
	            }
	            delete this._vbSize;
	            vb = "0 0 " + this.width + S + this.height;
	        } else {
	            this._vbSize = size;
	            vb = x + S + y + S + w + S + h;
	        }
	        $(this.canvas, {
	            viewBox: vb,
	            preserveAspectRatio: aspectRatio
	        });
	        while (size && top) {
	            sw = "stroke-width" in top.attrs ? top.attrs["stroke-width"] : 1;
	            top.attr({"stroke-width": sw});
	            top._.dirty = 1;
	            top._.dirtyT = 1;
	            top = top.prev;
	        }
	        this._viewBox = [x, y, w, h, !!fit];
	        return this;
	    };
	    /*\
	     * Paper.renderfix
	     [ method ]
	     **
	     * Fixes the issue of Firefox and IE9 regarding subpixel rendering. If paper is dependent
	     * on other elements after reflow it could shift half pixel which cause for lines to lost their crispness.
	     * This method fixes the issue.
	     **
	       Special thanks to Mariusz Nowak (http://www.medikoo.com/) for this method.
	    \*/
	    R.prototype.renderfix = function () {
	        var cnvs = this.canvas,
	            s = cnvs.style,
	            pos;
	        try {
	            pos = cnvs.getScreenCTM() || cnvs.createSVGMatrix();
	        } catch (e) {
	            pos = cnvs.createSVGMatrix();
	        }
	        var left = -pos.e % 1,
	            top = -pos.f % 1;
	        if (left || top) {
	            if (left) {
	                this._left = (this._left + left) % 1;
	                s.left = this._left + "px";
	            }
	            if (top) {
	                this._top = (this._top + top) % 1;
	                s.top = this._top + "px";
	            }
	        }
	    };
	    /*\
	     * Paper.clear
	     [ method ]
	     **
	     * Clears the paper, i.e. removes all the elements.
	    \*/
	    R.prototype.clear = function () {
	        R.eve("raphael.clear", this);
	        var c = this.canvas;
	        while (c.firstChild) {
	            c.removeChild(c.firstChild);
	        }
	        this.bottom = this.top = null;
	        (this.desc = $("desc")).appendChild(R._g.doc.createTextNode("Created with Rapha\xebl " + R.version));
	        c.appendChild(this.desc);
	        c.appendChild(this.defs = $("defs"));
	    };
	    /*\
	     * Paper.remove
	     [ method ]
	     **
	     * Removes the paper from the DOM.
	    \*/
	    R.prototype.remove = function () {
	        eve("raphael.remove", this);
	        this.canvas.parentNode && this.canvas.parentNode.removeChild(this.canvas);
	        for (var i in this) {
	            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
	        }
	    };
	    var setproto = R.st;
	    for (var method in elproto) if (elproto[has](method) && !setproto[has](method)) {
	        setproto[method] = (function (methodname) {
	            return function () {
	                var arg = arguments;
	                return this.forEach(function (el) {
	                    el[methodname].apply(el, arg);
	                });
	            };
	        })(method);
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(183)], __WEBPACK_AMD_DEFINE_RESULT__ = function(R) {
	    if (R && !R.vml) {
	        return;
	    }
	
	    var has = "hasOwnProperty",
	        Str = String,
	        toFloat = parseFloat,
	        math = Math,
	        round = math.round,
	        mmax = math.max,
	        mmin = math.min,
	        abs = math.abs,
	        fillString = "fill",
	        separator = /[, ]+/,
	        eve = R.eve,
	        ms = " progid:DXImageTransform.Microsoft",
	        S = " ",
	        E = "",
	        map = {M: "m", L: "l", C: "c", Z: "x", m: "t", l: "r", c: "v", z: "x"},
	        bites = /([clmz]),?([^clmz]*)/gi,
	        blurregexp = / progid:\S+Blur\([^\)]+\)/g,
	        val = /-?[^,\s-]+/g,
	        cssDot = "position:absolute;left:0;top:0;width:1px;height:1px;behavior:url(#default#VML)",
	        zoom = 21600,
	        pathTypes = {path: 1, rect: 1, image: 1},
	        ovalTypes = {circle: 1, ellipse: 1},
	        path2vml = function (path) {
	            var total =  /[ahqstv]/ig,
	                command = R._pathToAbsolute;
	            Str(path).match(total) && (command = R._path2curve);
	            total = /[clmz]/g;
	            if (command == R._pathToAbsolute && !Str(path).match(total)) {
	                var res = Str(path).replace(bites, function (all, command, args) {
	                    var vals = [],
	                        isMove = command.toLowerCase() == "m",
	                        res = map[command];
	                    args.replace(val, function (value) {
	                        if (isMove && vals.length == 2) {
	                            res += vals + map[command == "m" ? "l" : "L"];
	                            vals = [];
	                        }
	                        vals.push(round(value * zoom));
	                    });
	                    return res + vals;
	                });
	                return res;
	            }
	            var pa = command(path), p, r;
	            res = [];
	            for (var i = 0, ii = pa.length; i < ii; i++) {
	                p = pa[i];
	                r = pa[i][0].toLowerCase();
	                r == "z" && (r = "x");
	                for (var j = 1, jj = p.length; j < jj; j++) {
	                    r += round(p[j] * zoom) + (j != jj - 1 ? "," : E);
	                }
	                res.push(r);
	            }
	            return res.join(S);
	        },
	        compensation = function (deg, dx, dy) {
	            var m = R.matrix();
	            m.rotate(-deg, .5, .5);
	            return {
	                dx: m.x(dx, dy),
	                dy: m.y(dx, dy)
	            };
	        },
	        setCoords = function (p, sx, sy, dx, dy, deg) {
	            var _ = p._,
	                m = p.matrix,
	                fillpos = _.fillpos,
	                o = p.node,
	                s = o.style,
	                y = 1,
	                flip = "",
	                dxdy,
	                kx = zoom / sx,
	                ky = zoom / sy;
	            s.visibility = "hidden";
	            if (!sx || !sy) {
	                return;
	            }
	            o.coordsize = abs(kx) + S + abs(ky);
	            s.rotation = deg * (sx * sy < 0 ? -1 : 1);
	            if (deg) {
	                var c = compensation(deg, dx, dy);
	                dx = c.dx;
	                dy = c.dy;
	            }
	            sx < 0 && (flip += "x");
	            sy < 0 && (flip += " y") && (y = -1);
	            s.flip = flip;
	            o.coordorigin = (dx * -kx) + S + (dy * -ky);
	            if (fillpos || _.fillsize) {
	                var fill = o.getElementsByTagName(fillString);
	                fill = fill && fill[0];
	                o.removeChild(fill);
	                if (fillpos) {
	                    c = compensation(deg, m.x(fillpos[0], fillpos[1]), m.y(fillpos[0], fillpos[1]));
	                    fill.position = c.dx * y + S + c.dy * y;
	                }
	                if (_.fillsize) {
	                    fill.size = _.fillsize[0] * abs(sx) + S + _.fillsize[1] * abs(sy);
	                }
	                o.appendChild(fill);
	            }
	            s.visibility = "visible";
	        };
	    R.toString = function () {
	        return  "Your browser doesn\u2019t support SVG. Falling down to VML.\nYou are running Rapha\xebl " + this.version;
	    };
	    var addArrow = function (o, value, isEnd) {
	        var values = Str(value).toLowerCase().split("-"),
	            se = isEnd ? "end" : "start",
	            i = values.length,
	            type = "classic",
	            w = "medium",
	            h = "medium";
	        while (i--) {
	            switch (values[i]) {
	                case "block":
	                case "classic":
	                case "oval":
	                case "diamond":
	                case "open":
	                case "none":
	                    type = values[i];
	                    break;
	                case "wide":
	                case "narrow": h = values[i]; break;
	                case "long":
	                case "short": w = values[i]; break;
	            }
	        }
	        var stroke = o.node.getElementsByTagName("stroke")[0];
	        stroke[se + "arrow"] = type;
	        stroke[se + "arrowlength"] = w;
	        stroke[se + "arrowwidth"] = h;
	    },
	    setFillAndStroke = function (o, params) {
	        // o.paper.canvas.style.display = "none";
	        o.attrs = o.attrs || {};
	        var node = o.node,
	            a = o.attrs,
	            s = node.style,
	            xy,
	            newpath = pathTypes[o.type] && (params.x != a.x || params.y != a.y || params.width != a.width || params.height != a.height || params.cx != a.cx || params.cy != a.cy || params.rx != a.rx || params.ry != a.ry || params.r != a.r),
	            isOval = ovalTypes[o.type] && (a.cx != params.cx || a.cy != params.cy || a.r != params.r || a.rx != params.rx || a.ry != params.ry),
	            res = o;
	
	
	        for (var par in params) if (params[has](par)) {
	            a[par] = params[par];
	        }
	        if (newpath) {
	            a.path = R._getPath[o.type](o);
	            o._.dirty = 1;
	        }
	        params.href && (node.href = params.href);
	        params.title && (node.title = params.title);
	        params.target && (node.target = params.target);
	        params.cursor && (s.cursor = params.cursor);
	        "blur" in params && o.blur(params.blur);
	        if (params.path && o.type == "path" || newpath) {
	            node.path = path2vml(~Str(a.path).toLowerCase().indexOf("r") ? R._pathToAbsolute(a.path) : a.path);
	            o._.dirty = 1;
	            if (o.type == "image") {
	                o._.fillpos = [a.x, a.y];
	                o._.fillsize = [a.width, a.height];
	                setCoords(o, 1, 1, 0, 0, 0);
	            }
	        }
	        "transform" in params && o.transform(params.transform);
	        if (isOval) {
	            var cx = +a.cx,
	                cy = +a.cy,
	                rx = +a.rx || +a.r || 0,
	                ry = +a.ry || +a.r || 0;
	            node.path = R.format("ar{0},{1},{2},{3},{4},{1},{4},{1}x", round((cx - rx) * zoom), round((cy - ry) * zoom), round((cx + rx) * zoom), round((cy + ry) * zoom), round(cx * zoom));
	            o._.dirty = 1;
	        }
	        if ("clip-rect" in params) {
	            var rect = Str(params["clip-rect"]).split(separator);
	            if (rect.length == 4) {
	                rect[2] = +rect[2] + (+rect[0]);
	                rect[3] = +rect[3] + (+rect[1]);
	                var div = node.clipRect || R._g.doc.createElement("div"),
	                    dstyle = div.style;
	                dstyle.clip = R.format("rect({1}px {2}px {3}px {0}px)", rect);
	                if (!node.clipRect) {
	                    dstyle.position = "absolute";
	                    dstyle.top = 0;
	                    dstyle.left = 0;
	                    dstyle.width = o.paper.width + "px";
	                    dstyle.height = o.paper.height + "px";
	                    node.parentNode.insertBefore(div, node);
	                    div.appendChild(node);
	                    node.clipRect = div;
	                }
	            }
	            if (!params["clip-rect"]) {
	                node.clipRect && (node.clipRect.style.clip = "auto");
	            }
	        }
	        if (o.textpath) {
	            var textpathStyle = o.textpath.style;
	            params.font && (textpathStyle.font = params.font);
	            params["font-family"] && (textpathStyle.fontFamily = '"' + params["font-family"].split(",")[0].replace(/^['"]+|['"]+$/g, E) + '"');
	            params["font-size"] && (textpathStyle.fontSize = params["font-size"]);
	            params["font-weight"] && (textpathStyle.fontWeight = params["font-weight"]);
	            params["font-style"] && (textpathStyle.fontStyle = params["font-style"]);
	        }
	        if ("arrow-start" in params) {
	            addArrow(res, params["arrow-start"]);
	        }
	        if ("arrow-end" in params) {
	            addArrow(res, params["arrow-end"], 1);
	        }
	        if (params.opacity != null ||
	            params.fill != null ||
	            params.src != null ||
	            params.stroke != null ||
	            params["stroke-width"] != null ||
	            params["stroke-opacity"] != null ||
	            params["fill-opacity"] != null ||
	            params["stroke-dasharray"] != null ||
	            params["stroke-miterlimit"] != null ||
	            params["stroke-linejoin"] != null ||
	            params["stroke-linecap"] != null) {
	            var fill = node.getElementsByTagName(fillString),
	                newfill = false;
	            fill = fill && fill[0];
	            !fill && (newfill = fill = createNode(fillString));
	            if (o.type == "image" && params.src) {
	                fill.src = params.src;
	            }
	            params.fill && (fill.on = true);
	            if (fill.on == null || params.fill == "none" || params.fill === null) {
	                fill.on = false;
	            }
	            if (fill.on && params.fill) {
	                var isURL = Str(params.fill).match(R._ISURL);
	                if (isURL) {
	                    fill.parentNode == node && node.removeChild(fill);
	                    fill.rotate = true;
	                    fill.src = isURL[1];
	                    fill.type = "tile";
	                    var bbox = o.getBBox(1);
	                    fill.position = bbox.x + S + bbox.y;
	                    o._.fillpos = [bbox.x, bbox.y];
	
	                    R._preload(isURL[1], function () {
	                        o._.fillsize = [this.offsetWidth, this.offsetHeight];
	                    });
	                } else {
	                    fill.color = R.getRGB(params.fill).hex;
	                    fill.src = E;
	                    fill.type = "solid";
	                    if (R.getRGB(params.fill).error && (res.type in {circle: 1, ellipse: 1} || Str(params.fill).charAt() != "r") && addGradientFill(res, params.fill, fill)) {
	                        a.fill = "none";
	                        a.gradient = params.fill;
	                        fill.rotate = false;
	                    }
	                }
	            }
	            if ("fill-opacity" in params || "opacity" in params) {
	                var opacity = ((+a["fill-opacity"] + 1 || 2) - 1) * ((+a.opacity + 1 || 2) - 1) * ((+R.getRGB(params.fill).o + 1 || 2) - 1);
	                opacity = mmin(mmax(opacity, 0), 1);
	                fill.opacity = opacity;
	                if (fill.src) {
	                    fill.color = "none";
	                }
	            }
	            node.appendChild(fill);
	            var stroke = (node.getElementsByTagName("stroke") && node.getElementsByTagName("stroke")[0]),
	            newstroke = false;
	            !stroke && (newstroke = stroke = createNode("stroke"));
	            if ((params.stroke && params.stroke != "none") ||
	                params["stroke-width"] ||
	                params["stroke-opacity"] != null ||
	                params["stroke-dasharray"] ||
	                params["stroke-miterlimit"] ||
	                params["stroke-linejoin"] ||
	                params["stroke-linecap"]) {
	                stroke.on = true;
	            }
	            (params.stroke == "none" || params.stroke === null || stroke.on == null || params.stroke == 0 || params["stroke-width"] == 0) && (stroke.on = false);
	            var strokeColor = R.getRGB(params.stroke);
	            stroke.on && params.stroke && (stroke.color = strokeColor.hex);
	            opacity = ((+a["stroke-opacity"] + 1 || 2) - 1) * ((+a.opacity + 1 || 2) - 1) * ((+strokeColor.o + 1 || 2) - 1);
	            var width = (toFloat(params["stroke-width"]) || 1) * .75;
	            opacity = mmin(mmax(opacity, 0), 1);
	            params["stroke-width"] == null && (width = a["stroke-width"]);
	            params["stroke-width"] && (stroke.weight = width);
	            width && width < 1 && (opacity *= width) && (stroke.weight = 1);
	            stroke.opacity = opacity;
	
	            params["stroke-linejoin"] && (stroke.joinstyle = params["stroke-linejoin"] || "miter");
	            stroke.miterlimit = params["stroke-miterlimit"] || 8;
	            params["stroke-linecap"] && (stroke.endcap = params["stroke-linecap"] == "butt" ? "flat" : params["stroke-linecap"] == "square" ? "square" : "round");
	            if ("stroke-dasharray" in params) {
	                var dasharray = {
	                    "-": "shortdash",
	                    ".": "shortdot",
	                    "-.": "shortdashdot",
	                    "-..": "shortdashdotdot",
	                    ". ": "dot",
	                    "- ": "dash",
	                    "--": "longdash",
	                    "- .": "dashdot",
	                    "--.": "longdashdot",
	                    "--..": "longdashdotdot"
	                };
	                stroke.dashstyle = dasharray[has](params["stroke-dasharray"]) ? dasharray[params["stroke-dasharray"]] : E;
	            }
	            newstroke && node.appendChild(stroke);
	        }
	        if (res.type == "text") {
	            res.paper.canvas.style.display = E;
	            var span = res.paper.span,
	                m = 100,
	                fontSize = a.font && a.font.match(/\d+(?:\.\d*)?(?=px)/);
	            s = span.style;
	            a.font && (s.font = a.font);
	            a["font-family"] && (s.fontFamily = a["font-family"]);
	            a["font-weight"] && (s.fontWeight = a["font-weight"]);
	            a["font-style"] && (s.fontStyle = a["font-style"]);
	            fontSize = toFloat(a["font-size"] || fontSize && fontSize[0]) || 10;
	            s.fontSize = fontSize * m + "px";
	            res.textpath.string && (span.innerHTML = Str(res.textpath.string).replace(/</g, "&#60;").replace(/&/g, "&#38;").replace(/\n/g, "<br>"));
	            var brect = span.getBoundingClientRect();
	            res.W = a.w = (brect.right - brect.left) / m;
	            res.H = a.h = (brect.bottom - brect.top) / m;
	            // res.paper.canvas.style.display = "none";
	            res.X = a.x;
	            res.Y = a.y + res.H / 2;
	
	            ("x" in params || "y" in params) && (res.path.v = R.format("m{0},{1}l{2},{1}", round(a.x * zoom), round(a.y * zoom), round(a.x * zoom) + 1));
	            var dirtyattrs = ["x", "y", "text", "font", "font-family", "font-weight", "font-style", "font-size"];
	            for (var d = 0, dd = dirtyattrs.length; d < dd; d++) if (dirtyattrs[d] in params) {
	                res._.dirty = 1;
	                break;
	            }
	
	            // text-anchor emulation
	            switch (a["text-anchor"]) {
	                case "start":
	                    res.textpath.style["v-text-align"] = "left";
	                    res.bbx = res.W / 2;
	                break;
	                case "end":
	                    res.textpath.style["v-text-align"] = "right";
	                    res.bbx = -res.W / 2;
	                break;
	                default:
	                    res.textpath.style["v-text-align"] = "center";
	                    res.bbx = 0;
	                break;
	            }
	            res.textpath.style["v-text-kern"] = true;
	        }
	        // res.paper.canvas.style.display = E;
	    },
	    addGradientFill = function (o, gradient, fill) {
	        o.attrs = o.attrs || {};
	        var attrs = o.attrs,
	            pow = Math.pow,
	            opacity,
	            oindex,
	            type = "linear",
	            fxfy = ".5 .5";
	        o.attrs.gradient = gradient;
	        gradient = Str(gradient).replace(R._radial_gradient, function (all, fx, fy) {
	            type = "radial";
	            if (fx && fy) {
	                fx = toFloat(fx);
	                fy = toFloat(fy);
	                pow(fx - .5, 2) + pow(fy - .5, 2) > .25 && (fy = math.sqrt(.25 - pow(fx - .5, 2)) * ((fy > .5) * 2 - 1) + .5);
	                fxfy = fx + S + fy;
	            }
	            return E;
	        });
	        gradient = gradient.split(/\s*\-\s*/);
	        if (type == "linear") {
	            var angle = gradient.shift();
	            angle = -toFloat(angle);
	            if (isNaN(angle)) {
	                return null;
	            }
	        }
	        var dots = R._parseDots(gradient);
	        if (!dots) {
	            return null;
	        }
	        o = o.shape || o.node;
	        if (dots.length) {
	            o.removeChild(fill);
	            fill.on = true;
	            fill.method = "none";
	            fill.color = dots[0].color;
	            fill.color2 = dots[dots.length - 1].color;
	            var clrs = [];
	            for (var i = 0, ii = dots.length; i < ii; i++) {
	                dots[i].offset && clrs.push(dots[i].offset + S + dots[i].color);
	            }
	            fill.colors = clrs.length ? clrs.join() : "0% " + fill.color;
	            if (type == "radial") {
	                fill.type = "gradientTitle";
	                fill.focus = "100%";
	                fill.focussize = "0 0";
	                fill.focusposition = fxfy;
	                fill.angle = 0;
	            } else {
	                // fill.rotate= true;
	                fill.type = "gradient";
	                fill.angle = (270 - angle) % 360;
	            }
	            o.appendChild(fill);
	        }
	        return 1;
	    },
	    Element = function (node, vml) {
	        this[0] = this.node = node;
	        node.raphael = true;
	        this.id = R._oid++;
	        node.raphaelid = this.id;
	        this.X = 0;
	        this.Y = 0;
	        this.attrs = {};
	        this.paper = vml;
	        this.matrix = R.matrix();
	        this._ = {
	            transform: [],
	            sx: 1,
	            sy: 1,
	            dx: 0,
	            dy: 0,
	            deg: 0,
	            dirty: 1,
	            dirtyT: 1
	        };
	        !vml.bottom && (vml.bottom = this);
	        this.prev = vml.top;
	        vml.top && (vml.top.next = this);
	        vml.top = this;
	        this.next = null;
	    };
	    var elproto = R.el;
	
	    Element.prototype = elproto;
	    elproto.constructor = Element;
	    elproto.transform = function (tstr) {
	        if (tstr == null) {
	            return this._.transform;
	        }
	        var vbs = this.paper._viewBoxShift,
	            vbt = vbs ? "s" + [vbs.scale, vbs.scale] + "-1-1t" + [vbs.dx, vbs.dy] : E,
	            oldt;
	        if (vbs) {
	            oldt = tstr = Str(tstr).replace(/\.{3}|\u2026/g, this._.transform || E);
	        }
	        R._extractTransform(this, vbt + tstr);
	        var matrix = this.matrix.clone(),
	            skew = this.skew,
	            o = this.node,
	            split,
	            isGrad = ~Str(this.attrs.fill).indexOf("-"),
	            isPatt = !Str(this.attrs.fill).indexOf("url(");
	        matrix.translate(1, 1);
	        if (isPatt || isGrad || this.type == "image") {
	            skew.matrix = "1 0 0 1";
	            skew.offset = "0 0";
	            split = matrix.split();
	            if ((isGrad && split.noRotation) || !split.isSimple) {
	                o.style.filter = matrix.toFilter();
	                var bb = this.getBBox(),
	                    bbt = this.getBBox(1),
	                    dx = bb.x - bbt.x,
	                    dy = bb.y - bbt.y;
	                o.coordorigin = (dx * -zoom) + S + (dy * -zoom);
	                setCoords(this, 1, 1, dx, dy, 0);
	            } else {
	                o.style.filter = E;
	                setCoords(this, split.scalex, split.scaley, split.dx, split.dy, split.rotate);
	            }
	        } else {
	            o.style.filter = E;
	            skew.matrix = Str(matrix);
	            skew.offset = matrix.offset();
	        }
	        if (oldt !== null) { // empty string value is true as well
	            this._.transform = oldt;
	            R._extractTransform(this, oldt);
	        }
	        return this;
	    };
	    elproto.rotate = function (deg, cx, cy) {
	        if (this.removed) {
	            return this;
	        }
	        if (deg == null) {
	            return;
	        }
	        deg = Str(deg).split(separator);
	        if (deg.length - 1) {
	            cx = toFloat(deg[1]);
	            cy = toFloat(deg[2]);
	        }
	        deg = toFloat(deg[0]);
	        (cy == null) && (cx = cy);
	        if (cx == null || cy == null) {
	            var bbox = this.getBBox(1);
	            cx = bbox.x + bbox.width / 2;
	            cy = bbox.y + bbox.height / 2;
	        }
	        this._.dirtyT = 1;
	        this.transform(this._.transform.concat([["r", deg, cx, cy]]));
	        return this;
	    };
	    elproto.translate = function (dx, dy) {
	        if (this.removed) {
	            return this;
	        }
	        dx = Str(dx).split(separator);
	        if (dx.length - 1) {
	            dy = toFloat(dx[1]);
	        }
	        dx = toFloat(dx[0]) || 0;
	        dy = +dy || 0;
	        if (this._.bbox) {
	            this._.bbox.x += dx;
	            this._.bbox.y += dy;
	        }
	        this.transform(this._.transform.concat([["t", dx, dy]]));
	        return this;
	    };
	    elproto.scale = function (sx, sy, cx, cy) {
	        if (this.removed) {
	            return this;
	        }
	        sx = Str(sx).split(separator);
	        if (sx.length - 1) {
	            sy = toFloat(sx[1]);
	            cx = toFloat(sx[2]);
	            cy = toFloat(sx[3]);
	            isNaN(cx) && (cx = null);
	            isNaN(cy) && (cy = null);
	        }
	        sx = toFloat(sx[0]);
	        (sy == null) && (sy = sx);
	        (cy == null) && (cx = cy);
	        if (cx == null || cy == null) {
	            var bbox = this.getBBox(1);
	        }
	        cx = cx == null ? bbox.x + bbox.width / 2 : cx;
	        cy = cy == null ? bbox.y + bbox.height / 2 : cy;
	
	        this.transform(this._.transform.concat([["s", sx, sy, cx, cy]]));
	        this._.dirtyT = 1;
	        return this;
	    };
	    elproto.hide = function () {
	        !this.removed && (this.node.style.display = "none");
	        return this;
	    };
	    elproto.show = function () {
	        !this.removed && (this.node.style.display = E);
	        return this;
	    };
	    // Needed to fix the vml setViewBox issues
	    elproto.auxGetBBox = R.el.getBBox;
	    elproto.getBBox = function(){
	      var b = this.auxGetBBox();
	      if (this.paper && this.paper._viewBoxShift)
	      {
	        var c = {};
	        var z = 1/this.paper._viewBoxShift.scale;
	        c.x = b.x - this.paper._viewBoxShift.dx;
	        c.x *= z;
	        c.y = b.y - this.paper._viewBoxShift.dy;
	        c.y *= z;
	        c.width  = b.width  * z;
	        c.height = b.height * z;
	        c.x2 = c.x + c.width;
	        c.y2 = c.y + c.height;
	        return c;
	      }
	      return b;
	    };
	    elproto._getBBox = function () {
	        if (this.removed) {
	            return {};
	        }
	        return {
	            x: this.X + (this.bbx || 0) - this.W / 2,
	            y: this.Y - this.H,
	            width: this.W,
	            height: this.H
	        };
	    };
	    elproto.remove = function () {
	        if (this.removed || !this.node.parentNode) {
	            return;
	        }
	        this.paper.__set__ && this.paper.__set__.exclude(this);
	        R.eve.unbind("raphael.*.*." + this.id);
	        R._tear(this, this.paper);
	        this.node.parentNode.removeChild(this.node);
	        this.shape && this.shape.parentNode.removeChild(this.shape);
	        for (var i in this) {
	            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
	        }
	        this.removed = true;
	    };
	    elproto.attr = function (name, value) {
	        if (this.removed) {
	            return this;
	        }
	        if (name == null) {
	            var res = {};
	            for (var a in this.attrs) if (this.attrs[has](a)) {
	                res[a] = this.attrs[a];
	            }
	            res.gradient && res.fill == "none" && (res.fill = res.gradient) && delete res.gradient;
	            res.transform = this._.transform;
	            return res;
	        }
	        if (value == null && R.is(name, "string")) {
	            if (name == fillString && this.attrs.fill == "none" && this.attrs.gradient) {
	                return this.attrs.gradient;
	            }
	            var names = name.split(separator),
	                out = {};
	            for (var i = 0, ii = names.length; i < ii; i++) {
	                name = names[i];
	                if (name in this.attrs) {
	                    out[name] = this.attrs[name];
	                } else if (R.is(this.paper.customAttributes[name], "function")) {
	                    out[name] = this.paper.customAttributes[name].def;
	                } else {
	                    out[name] = R._availableAttrs[name];
	                }
	            }
	            return ii - 1 ? out : out[names[0]];
	        }
	        if (this.attrs && value == null && R.is(name, "array")) {
	            out = {};
	            for (i = 0, ii = name.length; i < ii; i++) {
	                out[name[i]] = this.attr(name[i]);
	            }
	            return out;
	        }
	        var params;
	        if (value != null) {
	            params = {};
	            params[name] = value;
	        }
	        value == null && R.is(name, "object") && (params = name);
	        for (var key in params) {
	            eve("raphael.attr." + key + "." + this.id, this, params[key]);
	        }
	        if (params) {
	            for (key in this.paper.customAttributes) if (this.paper.customAttributes[has](key) && params[has](key) && R.is(this.paper.customAttributes[key], "function")) {
	                var par = this.paper.customAttributes[key].apply(this, [].concat(params[key]));
	                this.attrs[key] = params[key];
	                for (var subkey in par) if (par[has](subkey)) {
	                    params[subkey] = par[subkey];
	                }
	            }
	            // this.paper.canvas.style.display = "none";
	            if (params.text && this.type == "text") {
	                this.textpath.string = params.text;
	            }
	            setFillAndStroke(this, params);
	            // this.paper.canvas.style.display = E;
	        }
	        return this;
	    };
	    elproto.toFront = function () {
	        !this.removed && this.node.parentNode.appendChild(this.node);
	        this.paper && this.paper.top != this && R._tofront(this, this.paper);
	        return this;
	    };
	    elproto.toBack = function () {
	        if (this.removed) {
	            return this;
	        }
	        if (this.node.parentNode.firstChild != this.node) {
	            this.node.parentNode.insertBefore(this.node, this.node.parentNode.firstChild);
	            R._toback(this, this.paper);
	        }
	        return this;
	    };
	    elproto.insertAfter = function (element) {
	        if (this.removed) {
	            return this;
	        }
	        if (element.constructor == R.st.constructor) {
	            element = element[element.length - 1];
	        }
	        if (element.node.nextSibling) {
	            element.node.parentNode.insertBefore(this.node, element.node.nextSibling);
	        } else {
	            element.node.parentNode.appendChild(this.node);
	        }
	        R._insertafter(this, element, this.paper);
	        return this;
	    };
	    elproto.insertBefore = function (element) {
	        if (this.removed) {
	            return this;
	        }
	        if (element.constructor == R.st.constructor) {
	            element = element[0];
	        }
	        element.node.parentNode.insertBefore(this.node, element.node);
	        R._insertbefore(this, element, this.paper);
	        return this;
	    };
	    elproto.blur = function (size) {
	        var s = this.node.runtimeStyle,
	            f = s.filter;
	        f = f.replace(blurregexp, E);
	        if (+size !== 0) {
	            this.attrs.blur = size;
	            s.filter = f + S + ms + ".Blur(pixelradius=" + (+size || 1.5) + ")";
	            s.margin = R.format("-{0}px 0 0 -{0}px", round(+size || 1.5));
	        } else {
	            s.filter = f;
	            s.margin = 0;
	            delete this.attrs.blur;
	        }
	        return this;
	    };
	
	    R._engine.path = function (pathString, vml) {
	        var el = createNode("shape");
	        el.style.cssText = cssDot;
	        el.coordsize = zoom + S + zoom;
	        el.coordorigin = vml.coordorigin;
	        var p = new Element(el, vml),
	            attr = {fill: "none", stroke: "#000"};
	        pathString && (attr.path = pathString);
	        p.type = "path";
	        p.path = [];
	        p.Path = E;
	        setFillAndStroke(p, attr);
	        vml.canvas && vml.canvas.appendChild(el);
	        var skew = createNode("skew");
	        skew.on = true;
	        el.appendChild(skew);
	        p.skew = skew;
	        p.transform(E);
	        return p;
	    };
	    R._engine.rect = function (vml, x, y, w, h, r) {
	        var path = R._rectPath(x, y, w, h, r),
	            res = vml.path(path),
	            a = res.attrs;
	        res.X = a.x = x;
	        res.Y = a.y = y;
	        res.W = a.width = w;
	        res.H = a.height = h;
	        a.r = r;
	        a.path = path;
	        res.type = "rect";
	        return res;
	    };
	    R._engine.ellipse = function (vml, x, y, rx, ry) {
	        var res = vml.path(),
	            a = res.attrs;
	        res.X = x - rx;
	        res.Y = y - ry;
	        res.W = rx * 2;
	        res.H = ry * 2;
	        res.type = "ellipse";
	        setFillAndStroke(res, {
	            cx: x,
	            cy: y,
	            rx: rx,
	            ry: ry
	        });
	        return res;
	    };
	    R._engine.circle = function (vml, x, y, r) {
	        var res = vml.path(),
	            a = res.attrs;
	        res.X = x - r;
	        res.Y = y - r;
	        res.W = res.H = r * 2;
	        res.type = "circle";
	        setFillAndStroke(res, {
	            cx: x,
	            cy: y,
	            r: r
	        });
	        return res;
	    };
	    R._engine.image = function (vml, src, x, y, w, h) {
	        var path = R._rectPath(x, y, w, h),
	            res = vml.path(path).attr({stroke: "none"}),
	            a = res.attrs,
	            node = res.node,
	            fill = node.getElementsByTagName(fillString)[0];
	        a.src = src;
	        res.X = a.x = x;
	        res.Y = a.y = y;
	        res.W = a.width = w;
	        res.H = a.height = h;
	        a.path = path;
	        res.type = "image";
	        fill.parentNode == node && node.removeChild(fill);
	        fill.rotate = true;
	        fill.src = src;
	        fill.type = "tile";
	        res._.fillpos = [x, y];
	        res._.fillsize = [w, h];
	        node.appendChild(fill);
	        setCoords(res, 1, 1, 0, 0, 0);
	        return res;
	    };
	    R._engine.text = function (vml, x, y, text) {
	        var el = createNode("shape"),
	            path = createNode("path"),
	            o = createNode("textpath");
	        x = x || 0;
	        y = y || 0;
	        text = text || "";
	        path.v = R.format("m{0},{1}l{2},{1}", round(x * zoom), round(y * zoom), round(x * zoom) + 1);
	        path.textpathok = true;
	        o.string = Str(text);
	        o.on = true;
	        el.style.cssText = cssDot;
	        el.coordsize = zoom + S + zoom;
	        el.coordorigin = "0 0";
	        var p = new Element(el, vml),
	            attr = {
	                fill: "#000",
	                stroke: "none",
	                font: R._availableAttrs.font,
	                text: text
	            };
	        p.shape = el;
	        p.path = path;
	        p.textpath = o;
	        p.type = "text";
	        p.attrs.text = Str(text);
	        p.attrs.x = x;
	        p.attrs.y = y;
	        p.attrs.w = 1;
	        p.attrs.h = 1;
	        setFillAndStroke(p, attr);
	        el.appendChild(o);
	        el.appendChild(path);
	        vml.canvas.appendChild(el);
	        var skew = createNode("skew");
	        skew.on = true;
	        el.appendChild(skew);
	        p.skew = skew;
	        p.transform(E);
	        return p;
	    };
	    R._engine.setSize = function (width, height) {
	        var cs = this.canvas.style;
	        this.width = width;
	        this.height = height;
	        width == +width && (width += "px");
	        height == +height && (height += "px");
	        cs.width = width;
	        cs.height = height;
	        cs.clip = "rect(0 " + width + " " + height + " 0)";
	        if (this._viewBox) {
	            R._engine.setViewBox.apply(this, this._viewBox);
	        }
	        return this;
	    };
	    R._engine.setViewBox = function (x, y, w, h, fit) {
	        R.eve("raphael.setViewBox", this, this._viewBox, [x, y, w, h, fit]);
	        var paperSize = this.getSize(),
	            width = paperSize.width,
	            height = paperSize.height,
	            H, W;
	        if (fit) {
	            H = height / h;
	            W = width / w;
	            if (w * H < width) {
	                x -= (width - w * H) / 2 / H;
	            }
	            if (h * W < height) {
	                y -= (height - h * W) / 2 / W;
	            }
	        }
	        this._viewBox = [x, y, w, h, !!fit];
	        this._viewBoxShift = {
	            dx: -x,
	            dy: -y,
	            scale: paperSize
	        };
	        this.forEach(function (el) {
	            el.transform("...");
	        });
	        return this;
	    };
	    var createNode;
	    R._engine.initWin = function (win) {
	            var doc = win.document;
	            if (doc.styleSheets.length < 31) {
	                doc.createStyleSheet().addRule(".rvml", "behavior:url(#default#VML)");
	            } else {
	                // no more room, add to the existing one
	                // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	                doc.styleSheets[0].addRule(".rvml", "behavior:url(#default#VML)");
	            }
	            try {
	                !doc.namespaces.rvml && doc.namespaces.add("rvml", "urn:schemas-microsoft-com:vml");
	                createNode = function (tagName) {
	                    return doc.createElement('<rvml:' + tagName + ' class="rvml">');
	                };
	            } catch (e) {
	                createNode = function (tagName) {
	                    return doc.createElement('<' + tagName + ' xmlns="urn:schemas-microsoft.com:vml" class="rvml">');
	                };
	            }
	        };
	    R._engine.initWin(R._g.win);
	    R._engine.create = function () {
	        var con = R._getContainer.apply(0, arguments),
	            container = con.container,
	            height = con.height,
	            s,
	            width = con.width,
	            x = con.x,
	            y = con.y;
	        if (!container) {
	            throw new Error("VML container not found.");
	        }
	        var res = new R._Paper,
	            c = res.canvas = R._g.doc.createElement("div"),
	            cs = c.style;
	        x = x || 0;
	        y = y || 0;
	        width = width || 512;
	        height = height || 342;
	        res.width = width;
	        res.height = height;
	        width == +width && (width += "px");
	        height == +height && (height += "px");
	        res.coordsize = zoom * 1e3 + S + zoom * 1e3;
	        res.coordorigin = "0 0";
	        res.span = R._g.doc.createElement("span");
	        res.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;";
	        c.appendChild(res.span);
	        cs.cssText = R.format("top:0;left:0;width:{0};height:{1};display:inline-block;position:relative;clip:rect(0 {0} {1} 0);overflow:hidden", width, height);
	        if (container == 1) {
	            R._g.doc.body.appendChild(c);
	            cs.left = x + "px";
	            cs.top = y + "px";
	            cs.position = "absolute";
	        } else {
	            if (container.firstChild) {
	                container.insertBefore(c, container.firstChild);
	            } else {
	                container.appendChild(c);
	            }
	        }
	        res.renderfix = function () {};
	        return res;
	    };
	    R.prototype.clear = function () {
	        R.eve("raphael.clear", this);
	        this.canvas.innerHTML = E;
	        this.span = R._g.doc.createElement("span");
	        this.span.style.cssText = "position:absolute;left:-9999em;top:-9999em;padding:0;margin:0;line-height:1;display:inline;";
	        this.canvas.appendChild(this.span);
	        this.bottom = this.top = null;
	    };
	    R.prototype.remove = function () {
	        R.eve("raphael.remove", this);
	        this.canvas.parentNode.removeChild(this.canvas);
	        for (var i in this) {
	            this[i] = typeof this[i] == "function" ? R._removedFactory(i) : null;
	        }
	        return true;
	    };
	
	    var setproto = R.st;
	    for (var method in elproto) if (elproto[has](method) && !setproto[has](method)) {
	        setproto[method] = (function (methodname) {
	            return function () {
	                var arg = arguments;
	                return this.forEach(function (el) {
	                    el[methodname].apply(el, arg);
	                });
	            };
	        })(method);
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//todo: note -- here assuming base BB view proto already extended with mousetrap plugin -- both inherit from */
	
	/* Note: realy just overwriting the following proto method of Marionette with Raphael ... */
	/* Note want more for lifecycle -- not using behavior, model and collection events -- breaking w/mousetrap until put into hier (has delegate and undelegate */
	/* None of the raphael views are utilizing mousetrap anyway ...*/
	
	//todo: could really just extend from Marionette.Object then (for destroy) and have onRender, afterRender .... and in the shape render, have triggerMethods ... :
	// before:destroy, destroy, before:render
	
	
	var Marionette = __webpack_require__(61);
	var RaphaelView = __webpack_require__(188);
	
	/* todo: could normalize all events to jQ event for IE8 centrally */
	
	module.exports = Marionette.ItemView.extend({
	    render: Marionette.View.prototype, //(really overwritten now)
	   /* render: function() {
	        Marionette.View.prototype.render.apply(this, arguments); //not using onRender .... wasn't written for this ...
	        this.triggerMethod('afterRender');
	        return this;
	    },*/
	    setElement: function() {
	        var ret = RaphaelView.prototype.setElement.apply(this, arguments);
	        /* taken direct from Marionette) -- don't need entire -- don't want to inherit from Backbone here */
	       // _.invoke(this._behaviors, 'proxyViewProperties', this); /* not doing this */
	        return ret;
	    },
	    delegateEvents: function(events, undelegateEvents) {
	        var ret = RaphaelView.prototype.delegateEvents.apply(this, arguments);
	        /* not doing this */
	      /*  this._delegateDOMEvents(events); --(no UI hash)
	        this.bindEntityEvents(this.model, this.getOption('modelEvents'));
	        this.bindEntityEvents(this.collection, this.getOption('collectionEvents'));
	
	        _.each(this._behaviors, function(behavior) {
	            behavior.bindEntityEvents(this.model, behavior.getOption('modelEvents'));
	            behavior.bindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	        }, this);*/
	        return ret;
	
	    },
	
	    undelegateEvents: function() {
	        var ret =  RaphaelView.prototype.undelegateEvents.apply(this, arguments);
	
	        /* NOT DOING THIS
	         this.unbindEntityEvents(this.model, this.getOption('modelEvents'));
	         this.unbindEntityEvents(this.collection, this.getOption('collectionEvents'));
	
	         _.each(this._behaviors, function(behavior) {
	         behavior.unbindEntityEvents(this.model, behavior.getOption('modelEvents'));
	         behavior.unbindEntityEvents(this.collection, behavior.getOption('collectionEvents'));
	         }, this);
	         */
	
	        return ret;
	    },
	
	    /* this allows not to override Item View's render to allow template-less views */
	    getTemplate: function() {
	        return false;
	    }
	
	});
	


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {
	/**
	 * http://www.undiscoveredfeatures.com/2012/04/using-raphaeljs-and-backbonejs-together.html
	 * firing events may be better
	 */
	
	
	Backbone.RaphaelView = Backbone.View.extend({
	
	    setElement: function(element, delegate, undelegateEvents) {
	        if (this.el && undelegateEvents) this.undelegateEvents();
	        // el and $el will be the same, $el would have no special meaning...
	        this.el = this.$el = element;
	        if (delegate !== false) this.delegateEvents();
	        return this;
	    },
	
	    delegateEvents: function(events, undelegateEvents) {
	        if (!(events || (events = _.result(this, 'events')))) return this;
	        if(undelegateEvents) this.undelegateEvents();
	        for (var eventName in events) {
	            var method = events[eventName];
	            if (!_.isFunction(method)) method = this[events[eventName]];
	            if (!method) continue;
	
	            method = _.bind(method, this);
	            //If it is one of the svg/vml events
	            if(this.el[eventName]){
	                this.el[eventName](method);
	            }
	            // Custom events for RaphaelView object
	            else{
	                this.on(eventName, method);
	            }
	
	        }
	        return this;
	    },
	
	    // Clears all callbacks previously bound to the view with `delegateEvents`.
	    undelegateEvents: function() {
	        if(this.el.type) this.el.unbindAll();
	        return this;
	    }
	
	});
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = Backbone.RaphaelView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(49)))

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseMoveFnMixin = __webpack_require__(190),
	    DragHelper = __webpack_require__(191);
	
	
	module.exports = {
	
	    moveStart: function( x, y, e ) {
	
	        var dragHelperOptions = {
	            canvasBounds: this.channel.request('canvasContainerRel'),
	            dragOpacity: 0.6,
	            isTransformedShape: this.shapeModel.shapeViewSupportsTransforms(),
	            preventDragOffCanvas: !this.shapeModel.allowDragOffCanvas()
	        };
	
	        if ( this.shapeModel.shapeViewSupportsTransforms() ) {
	
	            // TODO: are these necessary now - can we just use the model ?
	            var shapePageTransformModel = this.shapeModel.getTransformModel().getPageModel();
	
	            _.extend( dragHelperOptions, {
	                pageScale: shapePageTransformModel.getScale(),
	                pageRotation: shapePageTransformModel.getRotation(),
	                pageTransform: shapePageTransformModel.getTransform()
	            });
	
	        }
	
	        this.dragHelper = new DragHelper( dragHelperOptions );
	
	        BaseMoveFnMixin.moveStart.call( this, x, y, e, this.dragHelper );
	
	        this.shapeModel.uiModel.set( 'isMoving', true );
	
	    },
	    moveMove: function( dx, dy, x, y, e ) {
	
	        /* ( now sets this.dx, this.dy ) */
	        BaseMoveFnMixin.moveMove.call( this, dx, dy, x, y, e, this.dragHelper, function() {
	
	            if ( !this.shapeUI.get('isMoving') || this.shapeUI.get('isResizing') )
	                return;
	
	            // was old hook -- now not used so put back here -- could override again at the shape level --
	            // TODO: prob want another place to override PUT BACK THE OLD FN
	            // maybe just check for existance of a transform fn ...?
	             if ( !this.dragHelper.isTransformedShape ) {
	                 this.el.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy );
	             } else {
	                 this.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy ); // ( assumes the transform function uses the page level transform ) !!
	             }
	
	            var getBox = function( cb ) { /* want to perf. calc prior to using it to base other moves */
	                    var box = this.el.getBBox();
	                    cb.call(this, box);
	                },
	                triggerMove = function( box ) {
	                    this.trigger( 'shape.move', box, this.dragHelper.dx, this.dragHelper.dy ); // want diff event
	                };
	
	            getBox.call( this, triggerMove );
	
	        } );
	
	
	    },
	    moveEnd: function(e) {
	
	        BaseMoveFnMixin.moveEnd.call( this, e, this.dragHelper );
	
	        if ( this.dragHelper.isTransformedShape ) {
	
	            // needs to have different fn's depending on path or x,y -- TODO: make it overwritable
	            // would need to loop through the elements in the set for path/not path ....
	            this.el.attr({
	                x:  this.el.attr('x') + this.dragHelper.invmDx,
	                y: this.el.attr('y') + this.dragHelper.invmDy
	            });
	
	
	            var shapeTransformModel = this.shapeModel.getTransformModel();
	            shapeTransformModel.setOx( this.el.attr('x') );
	            shapeTransformModel.setOy( this.el.attr('y') );
	            this.transform();
	
	            this.trigger( 'shape.selectBox.resetPath', this.el.getBBox(), true );
	
	
	        } else {
	
	            // quick fix for existing design which did assume all paths (would need to bake the transform)
	            // but now don't do for shapes that aren't paths -- graphic stamps are images ...
	            this.el.isPath() && this.el.bakeTransform();
	
	        }
	
	
	        this.shapeUI.set({isMoving: false});
	
	        this.trigger('shape.moveEnd');
	
	        // Now only holds primitives
	        delete this.dragHelper;
	
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael) {/**
	 * Here, we don't require a Shape View, and all it's assumptions.
	 */
	
	var BaseMoveFnMixin = __webpack_require__(190);
	
	
	module.exports = {
	
	    moveStart: function( x, y, e, dragHelper, onAfterMoveStart ) {
	
	        e.preventDefault();
	        e.stopImmediatePropagation();
	
	        if ( dragHelper.dragOpacity && dragHelper.dragOpacity < 1 ) {
	            this.el.animate( {opacity: dragHelper.dragOpacity}, 0, '>' );
	        }
	
	        dragHelper.originalOpacity =  this.el.attr('opacity');
	
	        dragHelper.obox = this.el.getBBox();
	        dragHelper.obx = dragHelper.obox.x;
	        dragHelper.oby = dragHelper.obox.y;
	
	        /* Adjusted dx, dy from moveMove taking boundaries into account ( really odx, ody ) */
	        dragHelper.dx = 0;
	        dragHelper.dy = 0;
	
	        onAfterMoveStart && onAfterMoveStart.apply( this, arguments );
	
	    },
	    moveMove: function( dx, dy, x, y, e, dragHelper, onAfterMove ) {
	
	        e.preventDefault();
	        e.stopImmediatePropagation(); //(stop red dialog dd from closing)
	
	        // Note: only not prevented now for graphic text stamps -- if we have a select set this could be problematic
	        if ( dragHelper.getPreventDragOffCanvas() ) {
	
	            /* Bounds check -- set dx, dy */
	            var c = dragHelper.canvasBounds,
	                odx = dragHelper.obx + dx,
	                odx2 = dragHelper.obox.x2 + dx,
	                ody = dragHelper.oby + dy,
	                ody2 = dragHelper.obox.y2 + dy;
	
	            if ( odx2 >= c.x2 ) {
	                dx = c.x2 - dragHelper.obx - dragHelper.obox.width;
	            } else if (odx <= c.x) {
	                dx = c.x - dragHelper.obx;
	            }
	
	            if ( ody2 >= c.y2 ) {
	                dy = c.y2 - dragHelper.oby - dragHelper.obox.height;
	            } else if (ody <= c.y) {
	                dy = c.y - dragHelper.oby;
	            }
	
	        }
	
	        // This should be known to the caller ... maybe we start out with the obj model on start ... or retun the value
	        dragHelper.dx = dx;
	        dragHelper.dy = dy;
	
	        onAfterMove && onAfterMove.apply( this, arguments );
	
	    },
	    moveEnd: function( e, dragHelper, onAfterMoveEnd ) {
	
	        e.preventDefault();
	        e.stopImmediatePropagation(); //(stop red dialog dd from closing)
	
	        this.el.animate( {opacity: dragHelper.originalOpacity}, 0, '>' );
	
	        /* Currently not a factory */
	        if ( dragHelper.isTransformedShape ) {
	
	            // dx, dy are client coordinates so use
	            // an inverse matrix to determine how the
	            var invm = Raphael.matrix();
	            invm.scale( dragHelper.pageScale, dragHelper.pageScale, 0, 0 );
	            invm.rotate( dragHelper.pageRotation, 0, 0 );
	
	            invm = invm.invert();
	
	            dragHelper.invmDx = Math.round( invm.x( dragHelper.dx, dragHelper.dy ) );
	            dragHelper.invmDy =  Math.round( invm.y( dragHelper.dx, dragHelper.dy) );
	
	        }
	
	
	        onAfterMoveEnd && onAfterMoveEnd.apply( this, arguments );
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * Object required for the move functions -- contains state between dragStart and dragEnd.
	 * Now holds all primitives.
	 * Left as non literal for future flexibility
	 * TODO: now maybe some overlap with the shapeTransform model
	 * A lot of intertwined with existing ShapeMoveFns -- could be cleaned-up
	 */
	
	
	var DragHelper = function( options ) {
	
	    this.canvasBounds = options.canvasBounds
	        ? options.canvasBounds
	        : null;
	
	    this.isTransformedShape = options.isTransformedShape;
	
	    this.preventDragOffCanvas = typeof options.preventDragOffCanvas !== 'undefined'
	        ? options.preventDragOffCanvas
	        : true;
	
	    if ( this.isTransformedShape ) {
	
	        // ---> used to calc dx, dy for inv matrix adjustment
	        this.pageScale = options.pageScale ? options.pageScale : 1.0;
	        this.pageRotation = options.pageRotation ? options.pageRotation : 0;
	        this.pageTransform = options.pageTransform ? options.pageTransform : '';
	
	    }
	
	    this.dragOpacity = options.dragOpacity ? options.dragOpacity : 1; // ( also serves as flag to change opacity on drag )
	    this.originalOpacity = 1; // set on move start from el
	
	    this.obox = null;
	    this.obx = 0;
	    this.oby = 0;
	
	    /* Adjusted dx, dy from moveMove taking boundaries into account */
	    this.dx = 0;
	    this.dy = 0;
	
	    /* Set on move end for this.isTransformedShape */
	    this.invmDx = 0;
	    this.invmDy = 0;
	
	    /* - callbacks: -- not implementing here now .... */
	        //- onAfterMoveStart
	        //- onAfterMove
	        //- onAfterMoveEnd
	
	
	};
	
	
	
	
	_.extend( DragHelper.prototype, {
	
	    getPreventDragOffCanvas: function() {
	
	        return this.preventDragOffCanvas;
	
	    }
	
	
	} );
	
	
	// For now since only primitives, no need for destroy
	
	
	
	module.exports = DragHelper;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Shape sub-type to its resize mixin functions.
	* Maybe if statement provides more flexibility ... i don't think I have a 'sub-shape' model/arch ...
	* */
	
	
	var Free = __webpack_require__(193),
	    Poly = __webpack_require__(200),
	    Line = __webpack_require__(202),
	    LineArrow = __webpack_require__(204),
	    FreeNoReflection = __webpack_require__(205);
	
	
	var XREF = {
	
	    rect: Free,
	    'rect-fill': Free,
	    'rect-nofill': Free,
	    free: Free,
	    text: Free,
	    signature: Free,
	    text_stamp: Free, // maybe a proportional resize 'free' here
	    graphic_stamp: FreeNoReflection,
	
	
	    poly: Poly,
	    line: Line,
	    'line-dashed': Line,
	    'line-arrow': LineArrow
	};
	
	
	module.exports = function(shapeSubType) {
	    return XREF[shapeSubType];
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Raphael = __webpack_require__(182),
	    BaseResize = __webpack_require__(194),
	    DummyRectBorder = __webpack_require__(199);
	
	// TODO: more sub-classing here (eg isRect) ...
	
	module.exports = {
	
	    resizeStart: function(x, y, e) {
	
	        if ( !BaseResize.start.apply(this, arguments) )
	            return;
	
	        var dhCursor = this.dragHandle.attr('cursor'),
	            noteSubType = this.channel.request('activeNoteSubType');
	
	        this.isEast = dhCursor === 'se-resize' || dhCursor === 'ne-resize';
	        this.isSouth = dhCursor === 'se-resize' || dhCursor === 'sw-resize';
	        this.isRect = noteSubType.indexOf('rect') > -1;  //TODO: util fn --- perhaps isRect function?
	        this.isText = noteSubType === 'text'; //TODO: util fn
	
	        if ( this.isRect ) {
	            /* ht and width can't be 0! -- otherwise NaN, Infinity in Matrix Calcs -- can occur if set on end resize (put there? */
	            var box = this.el.getBBox(),
	                ht = box.height,
	                wt = box.width,
	                noHt = ht === 0,
	                noWt = wt === 0;
	
	            if (noHt || noWt) {
	                var np = Raphael.fn.rectPath(box.x, box.y, noWt ? wt + 1 : wt, noHt ? ht + 1 : ht);
	                this.el.attr('path', np); //TODO: Raphael.parsePathString
	            }
	
	            this.dummyRectBorder = new DummyRectBorder(this.el);
	        }
	
	    },
	    /* Resize -- this should now be used for drawRect and End Rect --- huh?? */
	    resizeMove: function(dx, dy, x, y, e, onBeforeTransformEl ) {
	
	        if ( !BaseResize.move.apply(this, arguments) ) return;
	
	        // really only need the offset -- calc once on resize start -- ox + dx -- (do for optimization) ... ??
	        var pos = this.parent.getMousePos( $.event.fix(e) ),  //!!must do for IE8 -- otherwise won't get page.X, page.Y props in get position
	            mx = pos.x,
	            my = pos.y,
	
	            // why would I have put this here???
	            doTriggers = function(box) {
	                this.trigger('shape.resizeSelectBox', this.el.transform(), dx, dy);
	                this.trigger('shape.resizeRect', box, dx, dy); // listened to by the individual shapes -- redaction, buttonSet, signature
	            };
	
	        // hook if provided: if returns false will exit the resize move 
	        if (onBeforeTransformEl) {
	            if (!onBeforeTransformEl.call(this, mx, my)) return;
	        }
	
	        // this is what changes the size of the shape
	        this.el.setBoxTransformStr(mx, my, true, this.isEast, this.isSouth, this.proportionalResize);
	
	        this.isRect && this.dummyRectBorder.move();
	
	        doTriggers.call(this, this.el.getBBox() );
	    },
	
	    resizeEnd: function(e) {
	        if ( !BaseResize.end.call(this, e) ) return;
	
	        this.el.removeCachedBox();
	
	        //TODO: add on before/after event ...
	        if (this.isRect) {  //or TEXT too now?
	            this.el.attr({
	                path: this.el.getPathOfBBox(),
	                transform: ''
	            });
	            this.dummyRectBorder.destroy(true); //true sets back the original stroke width, stroke
	
	        } else { //free, textPath
	            // checking for path is a quick fix for the graphic stamp, which is an image ... could later be more (?)
	            this.el.isPath() && this.el.bakeTransform(1);
	        }
	
	        BaseResize.cleanUp.call(this);
	
	        this.isEast = null;
	        this.isSouth = null;
	        this.isRect = null;
	        this.isText = null;
	
	    }
	
	
	};
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var SelectHandles = __webpack_require__(195);
	
	/* return true of false to continue */
	
	module.exports = {
	
	    start:  function(x, y, e) {
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        // disallow if moving
	        if (this.shapeUI.get( 'isMoving') )
	            return false;
	
	        this.shapeUI.set('isResizing', true); //handle centrally
	
	        this.dragHandle = this.paper.getElementByPoint(x, y).attr({
	            fill: SelectHandles.prototype.hoverFill
	        });
	
	        return true;
	    },
	    move: function(dx, dy, x, y, e) {
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        if (dx === 0 && dy === 0)
	            return false;
	
	        if ( !this.parent.mouseInBounds(x, y) )  //(ref to parent)
	            return false;
	
	        return true;
	    },
	    end: function(e) {
	
	        e.preventDefault();
	        e.stopPropagation();
	        this.shapeUI.set({isResizing: false});
	        return true;
	
	    },
	    cleanUp: function() {
	
	        this.trigger('shape.resizeEnd'); // do after the shape is resized!
	        this.dragHandle = null;
	
	    }
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    RaphaelView = __webpack_require__(187),
	    _ = __webpack_require__(49),
	    SelectHandle = __webpack_require__(196),
	    ShapeUtils = __webpack_require__(197);
	
	__webpack_require__(198);
	
	
	var instVars = {
	
	    parent: null,
	    handleSet: null, //( Raphael set which is the el of the Raphael View)
	
	    /* cached on init */
	    _pathIsRect: null,
	    _hasBorderView: null,
	    _paper: null,
	    _pgRotation: null
	
	};
	
	var aCursors = ['nw-resize', 'ne-resize', 'se-resize', 'sw-resize' ]; //in order (clockwise) --- for dragging
	
	/* DO NOT PUT HANDLES INTO CHILDVIEWS AND SET -- OTHERWISE MEMORY ERROR ... yrs ago ...*/
	module.exports = RaphaelView.extend({
	
	    initialize: function(options) {
	
	        _.extend( this, instVars,
	            _.pick( options, 'parent', '_pathIsRect', '_hasBorderView', '_paper', '_pgRotation')
	        );
	
	        this.bindEntityEvents( this.parent, this.parentSubs );
	
	
	    },
	    parentSubs: {
	        'shape.move':                               'move',         // transform w/mouse move
	        'shape.onAfterBaseScale shape.moveEnd':     'reposition',   // like burning pts in
	        'shape.resizeRect':                         'resizeRect'    // note: poly resize is different (reposition?)
	    },
	    /*
	    * If changed, set the new shape -- it must come from path ...
	    * when redo on resize, setPoints won't work b/c get path coordinates
	    * */
	    render: function( emptySet ) {
	
	        this.handleSet = emptySet;
	        this._createHandleViews( this._getPointsFromPath() );
	        this.setElement(this.handleSet);
	
	        return this;
	    },
	    /*
	    * Point consists of {x, y, cursor, id -- (id is the index in the array)}
	    * */
	    _createHandleViews: function( aPts ) {
	
	        _.each( aPts, function(pt, i) {
	
	            this.handleSet.push( new SelectHandle({
	                pt: pt,
	                shapeView: this.parent
	            }).el );
	
	        }, this);
	
	    },
	    /*
	    *
	    * Like a reset ('bakeTrans'): set the new pt from the path and remove the transform.
	    * Assumes path (equiv to back in transformed pts)  // don't need hide/show
	    * Note: this could be optimized ...
	    * */
	    reposition: function() {
	
	        _.each( this._getPointsFromPath(), function(pt, i) {
	
	            this.el[i].attr({
	                cx: pt.x,
	                cy: pt.y
	            }).transform('');
	
	        },this);
	
	    },
	    move: function( box, dx, dy ) {
	
	        this.el.transform( 'T' + dx + ',' + dy );
	
	    },
	    /*
	    * If using the bbox, using the actuals.
	    * TODO: use same fn for resize w/ conditional (?)
	    * */
	    resizeRect: function( elBox ) {
	
	        var h = this.handleSet,
	            b = elBox;
	
	        h[0].attr({cx: b.x ,    cy: b.y });
	        h[1].attr({ cx: b.x2,    cy: b.y });
	        h[2].attr({ cx: b.x2 ,   cy: b.y2 });
	        h[3].attr({ cx: b.x,     cy: b.y2});
	
	    },
	    /*
	    * Note: also sets the cursors for resizing
	    * */
	    _getPointsFromPath: function() {
	
	        var pts,
	            shapeEl = this.parent.el,
	            hasSelectedBorder = this._hasBorderView;
	
	        if ( hasSelectedBorder ) {
	
	            // TODO: optimize? -- eg for reposition --- fn to return with creation of dummy shape
	
	            var dummyEl = this._paper.path( shapeEl.getPathOfBBox(), 1)
	                .hide();
	
	            pts = dummyEl.getPathCoordinates();  /* returns an array {x:y} of all points in the path -- equiv to getBBox for rectangles */
	
	            dummyEl.remove();
	
	        } else { // all others including rect, poly
	
	            pts = shapeEl.getPathCoordinates();
	
	            /*
	            * DVBC-1634 -- quick fix: if page is rotated, the path may not be in 'rect order'
	            * -- meaning from tl, tr, br, bl.
	            * We need this for setting the correct 'hover cursors' and for dragging logic ( getBoxTransformStr ).
	            * In it's current form, this could be optimized (eg called on scale)
	            * But a 'rewrite' using shapes with transforms is a MUCH better long term solution.
	            * */
	            if ( this._pgRotation !== 0 && this._pathIsRect ) {
	                pts = ShapeUtils.getPtsInRectOrder( pts );
	            }
	
	        }
	
	        /* then set cursor attributes on the points */
	        this._pathIsRect || hasSelectedBorder
	            ?   _.each( pts, function( p, i ) {
	                    _.extend( p, { cursor: aCursors[i], id: i} );
	                }, this)
	            :   _.each( pts, function( p, i ) {
	                    _.extend( p, { cursor:'nesw-resize', id: i });   //TODO: indicate this is the constant being used
	                });
	
	        return pts;
	
	    },
	
	    /**
	     * TODO:
	     * - the handleset should be a view with an all as a Raphael set, now it's just a the set
	     * - are the events undelegated in child?
	     * - needed?
	     */
	
	    onBeforeDestroy: function() {
	        // this.handleSet.destroy();
	        this.unbindEntityEvents(this, this.parentSubs);
	        this.el.remove().clear();
	        this.remove();
	
	    }
	});

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var RaphaelView = __webpack_require__(187),
	    _ = __webpack_require__(49);
	
	/*
	* Drag Event set on these.
	* Note: don't need view -- just create wrapper for the Raphael element --
	* if get rid of the events hash and go inline ( ... ? )
	* */
	
	module.exports = RaphaelView.extend({
	    svgAttrs: {
	        stroke: '#0F3CFF',
	        fill: '#FFF',
	        'fill-opacity': 1 //for IE8
	    },
	    nonHoverFill: '#FFF',
	    hoverFill: '#92C5F4',
	    CIRCLE_SIZE: 5,
	    /*
	    * Note: no render (see above)
	    * */
	    initialize: function(options) {
	
	        var sv = options.shapeView,
	            pt = options.pt,  //(could be model) -- this.oPos (don't need to pass in)
	
	            el = sv.paper.circle( pt.x, pt.y, this.CIRCLE_SIZE )
	                .attr( _.extend( this.svgAttrs, {cursor: pt.cursor} ) )
	                .data('ptIndex', pt.id) // Note: used to identify when element clicked; associated w/pt from handleset array
	                .data('shapeType', 'selectHandle');
	
	        el.drag( sv.resizeMove, sv.resizeStart, sv.resizeEnd, sv, sv, sv );
	
	        this.setElement(el);
	        return this;
	
	    },
	    events: {
	        'mouseover' : 'mouseover',
	        'mouseout'  : 'mouseout'
	    },
	    mouseover: function () {
	        this.el.attr('fill', this.hoverFill);
	    },
	    mouseout: function () {
	        this.el.attr('fill', this.nonHoverFill);
	    },
	    onBeforeDestroy: function () {
	        this.el.undrag(); //(not chained)
	        this.el
	            .unmouseover( this.mouseover )
	            .unmouseout( this.mouseout );
	        this.el.removeData().remove();
	        this.remove(); //no children
	    }
	});

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael, _) {// For Now, Fns Used to Calculate Pt Conversions From DB to Viewer Shape
	
	module.exports = {
	
	    INCHES_TENTHS_MM_TRANS: 0.00393701, // adjust x,y coordinates by this times the current page dpi (INCHES_TENTHS_MM_TRANS) ( divide by 25.4)
	
	    // (Not Cold; 'Coordinate Shapes)
	    // COULD HAVE A FLAG FOR DIVIDE / MULTIPLY AND USE FOR BOTH  ...
	    // rounding ...
	    adjustPtsFromDbToViewer: function( pts, scale, pgDPI, pgRotation, originalPgCenter ) {
	
	        var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI * scale;
	
	        if (pgRotation === 0) {
	
	            return pts.map( function(p) {
	                return {x: p.x * conv, y: p.y * conv };
	            });
	        }
	
	        // Rotated
	        var center = originalPgCenter,
	            rotRadians = Raphael.rad(pgRotation),
	            sinTheta = Math.sin(rotRadians),
	            cosTheta = Math.cos(rotRadians),
	            centerRotated = { //rotate image center
	                x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
	                y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
	            };
	
	        return pts.map( function(p) {
	            var dCenter = {   //diff from current point to current center
	                    x: p.x - center.x,
	                    y: p.y - center.y
	                },
	                rdCenter = {   // rotate dCenter (rotated diff of current pt from current center)
	                    x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
	                    y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
	                }; ///the rotated different from the center plus the rotated center
	            return {
	                x: (rdCenter.x + centerRotated.x) * conv,
	                y: (rdCenter.y + centerRotated.y) * conv
	            };
	        });
	
	    },
	
	    // Now only used for Floating Reason Codes.
	    // Same as above, but don't take page rotation or scale into account
	    // unlike base shape -- using transforms, so don't apply scale and rotation adjustments ---  just dpi and the conversionConstant
	    // when get rid of transforms, this will be the way to go ...
	    adjustPtsFromDbToViewerWithoutTransform: function( pts, pgDPI ) {
	
	        return this.adjustPtsFromDbToViewer( pts, 1, pgDPI, 0 );
	
	    },
	    
	    // pts typically come from a raphael element when persisting
	    
	    adjustPtsFromViewerToDb: function( pts, isCold, scale, pgDPI, pgRotation, originalPgCenter, pgOverlay ) {
	
	
	        if ( !isCold ) {
	
	            var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI * scale;
	
	            if (pgRotation === 0) {
	                return  _.map( pts , function(p) {
	                    return {
	                        x: +(p.x / conv).toFixed(3),
	                        y: +(p.y / conv).toFixed(3)
	                    };
	                });
	            }
	
	            //rotation adjustment -- normalize pts back to 0 -- to be read in by other fn --- note --same logic for svg but applicable to path
	            var center = originalPgCenter, //get center w/current Rotation
	                rotTo0 =  -1 * pgRotation,
	                rotRadians = Raphael.rad(rotTo0),
	                sinTheta = Math.sin(rotRadians),
	                cosTheta = Math.cos(rotRadians),
	                centerRotated = { //rotate image center
	                    x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
	                    y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
	                };
	
	            return _.map( pts, function(p) {
	
	                var dCenter = {
	                        x: (p.x / conv) - center.x,   //!!ONLY APPY THE CONVERSION TO THE POINT !!!
	                        y: (p.y / conv) - center.y
	                    }, //diff from current point to current center
	                    rdCenter = {   // rotate dCenter (rotated diff of current pt from current center)
	                        x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
	                        y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
	                    }, ///the rotated different from the center plus the rotated center
	                    newPt = {
	                        x: rdCenter.x + centerRotated.x,
	                        y: rdCenter.y + centerRotated.y
	                    };
	
	                return {
	                    x: +newPt.x.toFixed(3),
	                    y: +newPt.y.toFixed(3)
	                };
	
	            });
	
	        } else {
	
	            // COLD -- convert the 'pixel' coordinates to the cold 'grid' coordinates -- always a rectangle
	            // -1 is for base 0 which is how they appear to be saved in fat client
	
	            var o = pgOverlay,
	                coordinates = _.map(pts, function(p) {
	                    return  {
	                        x: Math.ceil( (p.x / 96 * o.cpi) / scale) - 1, /* no fractions in 'coordinates' -- is ceil correct -- always go to the larger size ? */
	                        y: Math.ceil( (p.y / 96 * o.lpi) / scale) - 1
	                    };
	                });
	
	            /* validate both horizontal and vertical dimensions are at least 1 */
	            var rectW = coordinates[1].x - coordinates[0].x,
	                rectH = coordinates[3].y - coordinates[0].y;
	
	            if (rectW === 0) {
	                coordinates[1].x += 1;
	                coordinates[2].x += 1;
	            }
	
	            if (rectH === 0) {
	                coordinates[2].y += 1;
	                coordinates[3].y += 1;
	            }
	
	            return coordinates;
	        }
	
	    },
	
	    /**
	     * Was used in initial iteration for  find and redact --
	     * Currently unused ...
	     */
	    adjustPtsFromPxToTenthsMM: function( pts, dpi ) {
	
	        var conv = this.INCHES_TENTHS_MM_TRANS * dpi;
	
	        return  _.map( pts , function(p) {
	            return {
	                x: +(p.x / conv).toFixed(3),
	                y: +(p.y / conv).toFixed(3)
	            };
	        });
	
	    },
	
	    // For now only used for floating reason code box (not the connection).
	    // Sure, could be more elegant -- but do some when start creating other shapes that don't have transforms included.
	    // Note: don't need to account for COLD pages for the Floating Codes note type.
	    // Now: also utilized for full page redactions -- see getPointsToSaveFromPageDimensions
	    adjustPtsFromViewerToDbNoTransform: function(pts, pgDPI) {
	
	        var conv = this.INCHES_TENTHS_MM_TRANS * pgDPI;
	
	        return _.map( pts , function(p) {
	            return {
	                x: +(p.x / conv).toFixed(3),
	                y: +(p.y / conv).toFixed(3)
	            };
	        });
	
	    },
	
	
	    /**
	     * Was only used in codesView -- like adjustPtsFromViewerToDb but doesn't take cold, conversion, dpi into account
	     * note: obvious area for code consolidation
	     * Now also used in hoverTextStamp ...
	     * Should put in Util or on the transformedMixinHelper -- 'inversePageRotate'
	     */
	    getPtsWithoutTransformApplied: function( pts, scale, pageRotation, originalPgCenter ) {
	
	        var newCoordinates = pts.map( function(p) {
	            return {
	                x: (p.x / scale),
	                y: (p.y / scale)
	            };
	        });
	
	        if ( pageRotation === 0 )
	            return newCoordinates;
	
	        var center = originalPgCenter,
	            rotTo0 =  -1 * pageRotation,
	            rotRadians = Raphael.rad(rotTo0),
	            sinTheta = Math.sin(rotRadians),
	            cosTheta = Math.cos(rotRadians),
	            centerRotated = { //rotate image center
	                x: Math.abs( (cosTheta * center.x) - (sinTheta * center.y) ),
	                y: Math.abs( (sinTheta * center.x) +  (cosTheta * center.y))
	            };
	
	        newCoordinates = newCoordinates.map( function(p) {
	
	            var dCenter = {
	                    x: (p.x) - center.x,
	                    y: (p.y) - center.y
	                },
	                rdCenter = {
	                    x: (cosTheta * dCenter.x) - (sinTheta * dCenter.y),
	                    y: (sinTheta * dCenter.x) + (cosTheta * dCenter.y)
	                },
	                newPt = {
	                    x: rdCenter.x + centerRotated.x,
	                    y: rdCenter.y + centerRotated.y
	                };
	
	            return {
	                x: newPt.x,
	                y: newPt.y
	            };
	
	        });
	
	        return newCoordinates;
	    },
	
	    /**
	     * Now used for full page redactions.
	     * Post refactor to apply transforms to all shape types, will likely not be necessary.
	     * Note: N/A for cold pages currently.
	     */
	    getPointsToSaveFromPageDimensions: function( page ) {
	
	        if ( page.isCold() )
	            return;
	
	        var originalPageDimensions = page.originalDimensions();
	
	        var dimensionsAsPoints = [
	            { x: 0, y: 0},
	            { x: originalPageDimensions.w,  y: 0},
	            { x: originalPageDimensions.w, y: originalPageDimensions.h },
	            { x: 0, y: originalPageDimensions.h }
	        ];
	
	        return this.adjustPtsFromViewerToDbNoTransform( dimensionsAsPoints,  page.getDPI() );
	
	    },
	
	
	    /*
	    * Return array of pts from 'getPtsWithoutTransformApplied' or similar in rectangle order (it may not return this in order if rotation is applied).
	    * Assumes it's a rectangle.
	    * Presumably better way to do this that doesn't require this extra call, perhaps could combine the 2.
	    * Probably belongs elsewhere but here for now to show where the Math comes from ( only used for this purpose )
	    * */
	    getPtsInRectOrder: function(pts) {
	
	        var xs = _.map(pts, function(p) {
	            return p.x;
	        });
	
	        var ys = _.map(pts, function(p) {
	            return p.y;
	        });
	
	        var minX = Math.min.apply( null, xs );
	        var maxX = Math.max.apply( null, xs );
	        var minY = Math.min.apply( null, ys );
	        var maxY = Math.max.apply( null, ys );
	
	        return [
	            { x: minX, y: minY },
	            { x: maxX, y: minY },
	            { x: maxX, y: maxY },
	            { x: minX, y: maxY }
	        ];
	
	    },
	
	
	    ptToPx: function( pt ) {
	        return pt * 96 / 72;
	    },
	
	    pxToPt: function( px ) {
	        return px / 96 * 72;
	    },
	
	    ptToTenthsMM: function( pt ) {
	        return pt * (1/72) / this.INCHES_TENTHS_MM_TRANS;
	    },
	
	    // Currently used in Find and Redact
	    pxToTenthsMM: function( px, dpi ) {
	
	        var conv = this.INCHES_TENTHS_MM_TRANS * dpi;
	
	        return  parseFloat( (px / conv).toFixed( 3  ));
	
	    }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(49)))

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael, _, $) {//TODO: rid underscore dependency -- will also optimize
	
	(function(R) {
	
	    // Return an array of {x:y} coordinates for all points in a path.
	    // isWithTransform: provide as true if you want to include the position of the transformed coordinates.
	    // Note: since historically I wasn't taking transforms into account, the parameter
	    // is named 'isWithTransform' -- unlike Raphael's 'isWithoutTransform' for bbox -- so false is the default.
	    R.el.getPathCoordinates = function( isWithTransform ) {
	
	        // If read in from file could be a convert string to array.
	        // If already an array, Raphael method checks and doesn't do much processing.
	        // If performance becomes an issue -- can look to optimize.
	
	        var path = Raphael.parsePathString( this.attr('path') );
	
	        // Handle case where path is yet to be defined -- parsePathString returns null here.
	        if ( !path )
	            return [];
	
	        return R.fn.getPathCoordinates( path, isWithTransform ? this.transform() : undefined );
	
	    };
	
	    // If transform is provided, adjust the path with the transform string.
	    // If performance becomes an issue, when a transform is provided, can optimize by adjusting the points directly here.
	    R.fn.getPathCoordinates = function(path, transform) {
	
	        path = !transform
	            ? path
	            : R.fn.mapPathStraight( path, R.toMatrix( path, transform ) );  // transformPath will turn into C's and not work
	
	        var coordinates = [];
	
	        for ( var i=0; i<path.length; i++ ) {
	
	            var segment = path[i];
	            if ( segment[0] === 'Z' )
	                continue;
	
	            coordinates.push({ x: segment[1], y: segment[2] });
	        }
	
	        return coordinates;
	
	    };
	
	
	    R.el.setPathFromPtsArray = function( ptsArray, closePath ) {
	
	        var path = R.fn.getPathFromPtsArray( ptsArray, closePath );
	        this.attr('path', path);
	        return this;
	
	    };
	
	    R.fn.getPathFromPtsArray = function( ptsArray, closePath ) {
	
	        var ptsArray = _.reject( ptsArray, function(p) {
	                return p === 'Z';
	            }),
	            path = 'M' + ptsArray[0].x + ' ' + ptsArray[0].y;
	
	        // could use map/reduce here
	        _.each( _.rest(ptsArray), function(p) {
	            path += 'L' + (p.x) + ' ' + (p.y);
	        });
	
	        if (closePath)
	            path += 'Z';
	
	        return path;
	    };
	
	    R.fn.rectPath = function(x, y, w, h) { //w and height must be > 0
	        var path = 'M' + x + ' ' + y;
	        path += 'L' + (x + w) + ' ' + y;
	        path += 'L' + (x + w) + ' ' + (y + h);
	        path += 'L' + x + ' ' + (y + h);
	        path += 'Z';
	        return path;
	    };
	
	    /* Outer offset from the box -- default is Zero */
	    R.el.getPathOfBBox = function(includeTransform, offset) {
	
	        var O = offset !== undefined
	            ? offset
	            : 0;
	
	        var box = this.getBBox(includeTransform !== undefined),
	            p = 'M' + (box.x - O) + ' ' + (box.y - O);
	
	        p += 'L' + (box.x2 + O) + ' ' + (box.y - O);
	        p += 'L' + (box.x2 + O) + ' ' + (box.y2 + O);
	        p += 'L' + (box.x - O) + ' ' + (box.y2 + O);
	        p += 'Z';
	
	        return p;
	
	    };
	
	
	
	    /* Determine if array of shape pts is rectangular */
	    R.fn.isRect = function(pts) {
	        if (pts.length !== 4) { return false; }
	        var tl = {x: pts[0][1], y: pts[0][2]},
	            tr = {x: pts[1][1], y: pts[1][2]},
	            br = {x: pts[2][1], y: pts[2][2]},
	            bl = {x: pts[3][1], y: pts[3][2]},
	            tla = R.angle(bl.x, bl.y, tr.x, tr.y, tl.x, tl.y) % 90, /* using mod 90 b/c bla gives 270  -- want all to be right angles */
	            tra = R.angle(tl.x, tl.y, br.x, br.y, tr.x, tr.y) % 90,
	            bra = R.angle(tr.x, tr.y, bl.x, bl.y, br.x, br.y) % 90,
	            bla = R.angle(tl.x, tl.y, br.x, br.y, bl.x, bl.y) % 90;
	        return (tla === 0 && tra === 0 && bra === 0 && bla === 0);
	    };
	
	    /* determine whether a path of points is a rectangle*/
	    R.el.pathIsRect = function () {
	        var pts = _.reject(R.parsePathString(this.attr('path')), function (p) {
	            return p[0] === 'Z';
	        });  //(get rid  z
	        return R.fn.isRect(pts);
	    };
	
	//* NOTE FOR NOW USE CHECKING 2 POINTS -- CAN LATER PUT IN ANGLE CHECK */
	    R.el.pathIsLine = function () {
	        var path = R.parsePathString(this.attr('path'));
	        return R.fn.pathIsLine( path ) ;
	    };
	
	    R.fn.pathIsLine = function(path) {
	        return path.length === 2;
	    };
	
	    /* Replace path with transformations by computing new actual values in the path from the transform */
	    R.el.bakeTransform = function(keepStrokeWidth) {
	
	        var fnKeepStrokeWidth = function() {
	            //        // console.log(swRatio); //todo: make more accurate method
	            ////        if Rapahel.svg( ) --> 'preserve stroke width' vector-effect="non-scaling-stroke
	            //        //parseFloat($(this.node).attr('stroke-width')) -- can get the scaled prior to transform ... as attr
	            //        //this would be the original, not accounting for scale  -- this is better: could calc the diff in change in x and y (translate for more accuracy)
	            //        //eg: sx / tx and sy / ty
	            //        //if vml use the average of the x and y scale
	            var osw = this.attr('stroke-width');
	            var m = this.matrix.split();
	            var scaleAvg = (m.scalex + m.scaley) / 2;
	            this.attr('stroke-width', osw * scaleAvg);
	
	        },
	            oPath = R.parsePathString( this.attr('path') );//need to normalize first for IE8 --- ISSUE VML IS RELATIVE, SVG IS NOT -- todo: only if IE for PERF
	
	        //if (R.vml) oPath = R._pathToAbsolute(oPath);  //need for IE8: path to string here is relative: //TODO: STILL NEEDED?
	
	        oPath = R._pathToAbsolute(oPath);
	
	        var pathHasCurves = oPath.toString().indexOf('C') > -1;  //this would be text
	
	        if ( pathHasCurves ) { //if the path has curves -- don't use the hack
	
	            this.attr('path', R.mapPath( oPath, this.matrix) );
	
	        } else
	        {
	
	            //version with hack) // TODO: STILL NECESSARY ?
	            var trans = R.parseTransformString(this.transform()),
	                trpath = R.prototype.mapPathStraight(oPath, R.toMatrix(oPath, trans));
	
	            this.attr('path', trpath);
	        }
	
	        if (keepStrokeWidth)
	            fnKeepStrokeWidth.call(this);
	
	        this.transform('');
	        return this;
	    };
	
	    R.st.bakeTransform = function (keepStrokeWidth) {
	        this.forEach(function (el) {
	            el.bakeTransform(keepStrokeWidth);
	        });
	        return this;
	    };
	
	    //TODO: optimize, round
	    R.el.scalePathWithCurves = function(scale, lastScale) {
	
	        var C = scale / lastScale,
	            p = this.attr('path'),
	            isClosed = _.last(p).toString().toUpperCase() === 'Z',
	            newPath = _.chain( R.parsePathString(p) )
	                .map(function (aSegment) {
	
	                    return _.map(aSegment,function (p) {
	                        return isNaN(p) ? p : (p *= C) + ',';
	                    }).join('').slice(0, -1);
	
	                }).value().join(' ');
	
	        if (isClosed)
	            newPath += 'Z';
	
	        this.attr('path', newPath);
	
	        return this;
	
	    };
	
	    /**
	     * Note: only applies to paths.
	     * @returns {R.st}
	     */
	    R.st.scaleWithPaper = function() {
	
	        this.forEach (function(el) {
	            el.scalePathWithCurves.apply(el, arguments);
	        });
	
	        return this;
	
	    };
	
	
	    /**
	     * Return path modified by given fn.
	     * Note: could now use for scale -- eg:
	     *  R.fn.adjustPath(oPath, function(i) {return i*= 0.5;} ); -- ( for now used for SVG )
	     */
	    R.fn.adjustPath = function(path, fn) {
	        return _.chain(R.parsePathString(path))
	            .map(function (aSegment) {
	                return _.map(aSegment,function (p) {
	                    return isNaN(p) ? p : (fn(p)) + ',';  //NOTE: ONLY USABLE IF SAME ADJ APPLIED TO ALL POINTS -- WOULDN'T DO ROTATE OF 'C'
	                }).join('');
	            }).value().join(' ');
	    };
	
	    /* Create Path From Rectangle Element -- todo: used still? */
	    R.el.pathFromRect = function () {
	        if (this.type !== 'rect') {
	            return false;
	        }
	        var oAttrs = this.attrs,
	            x = oAttrs.x,
	            y = oAttrs.y,
	            w = oAttrs.width,
	            h = oAttrs.height,
	            paper = this.paper,
	            el,
	            path = 'M' + x + ' ' + y;
	        path += 'L' + (x + w) + ' ' + y;
	        path += 'L' + (x + w) + ' ' + (y + h);
	        path += 'L' + x + ' ' + (y + h);
	        path += 'Z';
	        /* Must exclude path attr for IE8 (for R.vml) -- otherwise the new path value will remain the old */
	        el = paper.path(path).attr(_.omit(oAttrs, ['height', 'r', 'rx', 'ry', 'width', 'x', 'y', 'path'])).insertAfter(this);
	        this.remove();
	        return el;
	    };
	
	    // TODO: i dont see this used any longer
	    R.el.rectFromPath = function () {
	        var oAttrs = this.attrs,
	            pts = this.getPathCoordinates(),
	            x = pts[0].x,
	            y = pts[0].y,
	            w = pts[1].x - x,
	            h = pts[2].y - y,
	            paper = this.paper,
	            el = paper.rect(x, y, w, h).attr(_.omit(oAttrs, 'path')).insertAfter(this);
	        this.remove();  //do after insert (give it the 'zindex'/layer)
	        return el;
	    };
	
	
	    /**
	     * R patch -- see issue below.
	     * http://stackoverflow.com/questions/14689947/R-transformpath-to-return-lines-instead-of-curves
	     */
	    R.fn.mapPathStraight = function (path, matrix) {
	        if (!matrix) {
	            return path;
	        }
	        var x, y, i, j, ii, jj, pathi;
	
	        //replace following line with .parsePathString(), which also parses path string into an array without adding curves
	        //path = path2curve(path);
	        path = R.parsePathString(path);
	        for (i = 0, ii = path.length; i < ii; i++) {
	            pathi = path[i];
	            for (j = 1, jj = pathi.length; j < jj; j += 2) {
	                x = matrix.x(pathi[j], pathi[j + 1]);
	                y = matrix.y(pathi[j], pathi[j + 1]);
	                pathi[j] = x;
	                pathi[j + 1] = y;
	            }
	        }
	        return path;
	    };
	
	
	    /**
	     * Monkey Patch: Glow: Use Actual Path: not internal 'realPath'.
	     * Allow Glow for Text Elements.
	     */
	    R.el.glow = function(glow) {
	
	        //if (this.type == "text") {
	        //    return null;
	        //}
	        glow = glow || {};
	
	        var s = {
	                width: (glow.width || 10) + (+this.attr("stroke-width") || 1),
	                fill: glow.fill || false,
	                opacity: glow.opacity || .5,
	                offsetx: glow.offsetx || 0,
	                offsety: glow.offsety || 0,
	                color: glow.color || "#000"
	            },
	            c = s.width / 2,
	            r = this.paper,
	            out = r.set(),
	        // path = this.realPath || getPath[this.type](this);
	            path = R._getPath[this.type](this);
	
	        path = this.matrix
	            ? R.mapPath(path, this.matrix)
	            : path;
	
	        for (var i = 1; i < c + 1; i++) {
	            out.push(r.path(path).attr({
	                stroke: s.color,
	                fill: s.fill ? s.color : "none",
	                "stroke-linejoin": "round",
	                "stroke-linecap": "round",
	                "stroke-width": +(s.width / c * i).toFixed(3),
	                opacity: +(s.opacity / c).toFixed(3)
	            }));
	        }
	
	        return out.insertBefore(this).translate(s.offsetx, s.offsety);
	
	    };
	
	    /* TODO: name appropriately */
	    R.el.setBoxTransformStr = function() {
	        var t = this.getBoxTransformStr.apply(this, arguments);
	        this.transform(t);
	        return this;
	    };
	
	    /* X, Y are offset mouse position, cursor -- '**re-size' (for now, represents the cursor attr) */
	    /* Done Via Scale Transform To Resize 'Free Box */
	    R.el.getBoxTransformStr = function(x, y, includeTransform, isEast, isSouth, preserveAspectRatio, applyTrans) {
	
	        var box = this['cachedBox'] || this.getBBox(includeTransform !== undefined),
	            dx, dy, cx, cy, sx, sy;  //dx, dy is the hor or vert change; cx/cy is the scale origin
	
	        var t = applyTrans !== undefined
	            ? this.transform() + ' '
	            : '';
	
	        if (!isEast) {
	            cx = box.x2;
	            dx = (x - cx) * -1;
	        } else {
	            cx = box.x;
	            dx = (x - cx);
	        }
	        if (!isSouth) {
	            cy = box.y2;
	            dy = (y - cy) * -1;
	        } else {
	            cy = box.y;
	            dy = (y - cy);
	        }
	
	        sx = dx / box.width;
	        sy = dy / box.height;
	
	
	        if (preserveAspectRatio) {
	            // quick hack to preserve aspect ratio
	            // issue with keeping mouse at the same position on resize but ok for now
	            // can later revist
	            if (sx > sy ) {
	                sy = sx;
	            } else if (sy > sx) {
	                sx = sy;
	            }
	        }
	
	        t += 'S' + sx + ', ' + sy + ', ' + cx + ', ' + cy; //S MUST BE ABS (... still?)
	
	        this['cachedBox'] = box;
	
	        //note: be sure to delete the 'CACHED BOX' on resize/draw end or start for subsequent calls (can be relative ...);
	        return t;
	    };
	
	    /* for when used in tandem with getBoxTransformStr -- TODO: sloppy */
	    R.el.removeCachedBox = function() {
	        if (this.cachedBox) delete this.cachedBox;
	        return this;
	    };
	
	
	    R.el.nonScalingStroke = function () {
	        if (R.svg) {
	            $(this.node).css('vector-effect', 'non-scaling-stroke');
	        }
	    };
	
	    R.fn.rotatePt = function(pt, deg, cx, cy) {
	        var m = new R.matrix;
	        m.rotate(deg, cx, cy);
	        return {
	            x: m.x(pt.x, pt.y),
	            y: m.y(pt.x, pt.y)
	        };
	    };
	
	    //ben: unbindall doesn't exist in R library -- created own -- to do: get the events of the view, also on th el
	    R.el.unbindAll = function () {
	        while (this.events.length) {
	            var e = this.events.pop();
	            e.unbind();
	        }
	    };
	
	    R.st.unbindAll = function () { //todo: works but does calls of events of all children too (eg the click)
	        this.el.forEach(function (el) {
	            el.unbindAll();
	        });
	    };
	
	    R.fn.fadeIn = function(ms, easing) {
	        this.animate({opacity: 1.0}, ms ? ms : 200, easing ? easing : '>' );
	    };
	
	    R.fn.fadeOut = function(ms, easing) {
	        this.animate({opacity: 0.0}, ms ? ms : 200, easing ? easing : '>' );
	    };
	
	    R.st.fadeIn = function() {
	        var args = Array.prototype.slice.call(arguments);
	        this.forEach(function(el) {
	            R[el.length > 1 ? 'st' : 'fn'].fadeIn.prototype.constructor.apply(el, args);
	        });
	        return this;
	    };
	
	    R.st.fadeOut = function() {
	        var args = Array.prototype.slice.call(arguments);
	        this.forEach(function(el) {
	            R[el.length > 1 ? 'st' : 'fn'].fadeOut.prototype.constructor.apply(el, args);
	        });
	        return this;
	    };
	
	    /* Return a new element clone from this one, with it's attributes, overwritten with any given */
	    R.el.replaceWithClone = function(attrs) {
	        var old = this,
	            newShape = this.clone(); //attributes copied, TODO: optional data
	        newShape.attr(_.extend(old.attrs, attrs));
	        newShape.insertBefore(old);
	        old.remove();
	        return newShape;
	    };
	
	    //abstract about the scaling to fit the size of the old
	    /* essentially 'stretch-fit' */
	    /* if don't provide otherEl assume, replacing itself*/
	    /* rotation is optional, provide if want to position over the other shape rotated to that degree */
	    /* better name:  var textPathScaledToFitBox = Raphael.fn.fitTextAtopOtherText();? ... */
	
	    /* otherEl can be a bounding box*/
	
	    R.el.fitAndPositionPathToMatchAnother = function(otherEl, rotation) { /* eg for text paths -- change of font, fit a position */
	
	        var otherBox;
	        if (!otherEl) {
	            otherBox = R.pathBBox(this.attr('path')); /* fit itself by default */
	        } else {
	
	            var otherElIsBox = !otherEl.attrs; /* could be R.pathBBox */
	            otherBox = otherElIsBox
	                ? otherEl  /* assumes it is already a box */
	                : R.pathBBox(otherEl.attr('path'));
	        }
	
	
	        //todo: rotation working but want in other matrix calc for perf
	        rotation && this.rotate(rotation).bakeTransform();
	
	        var box = this.getBBox(),
	            dx = otherBox.x - box.x,
	            dy = otherBox.y - box.y,
	            sx = otherBox.width / box.width,
	            sy = otherBox.height / box.height,
	            cx = box.x,
	            cy = box.y,
	            mx = R.matrix();
	
	        mx.translate(dx, dy);
	        mx.scale(sx, sy, cx, cy); /* cx, cy necessary to work with elements not positioned at 0, 0 */
	
	        /* use this instead of mapPath b/c looks like bug in mapPath (which still isn't working when using the relative, not absolute path */
	        var relTrans = mx.toTransformString();
	        var pathWithMx = R.transformPath(this.attr('path'), relTrans); /* must use relative transform to work on shapes not at 0,0 */
	
	        this.attr('path', pathWithMx);
	
	        return this;
	    };
	
	    R.el.getPaperCenter = function() {
	        var canvas = this.paper.canvas;
	        return {
	            x: canvas.clientWidth / 2,
	            y: canvas.clientHeight / 2
	        };
	    };
	
	    /* Return adjusted path from a given path, page scale, and page rotation */
	    /* note: originalCenterPtRotated is also scaled */
	    //TODO: now passing in originalCenterPtRotated --- but i think can now do with mx -- see fitAndPositionPathToMatchAnother
	    R.fn.viewerAdjustedPath = function(originalPath, scale, rotation, originalCenterPtWithScaleAndRotationApplied) {
	
	        rotation = rotation % 360; //(mod fixes over 360), -- not really necessary (done on server) ? still -- do in page model?
	
	        var scaledPath = R.fn.adjustPath(originalPath, function(n) {
	            return n * scale;
	        });
	
	        //TODO: can now inc perf by combo'ing the calc utilizing a matrix (map path)
	
	        if (rotation === 0) return scaledPath;
	
	        /* adjust path for rotation, (already scaled) */
	        var c = originalCenterPtWithScaleAndRotationApplied, /* include scale in adjustment */
	            rc = R.fn.rotatePt({x: c.x, y: c.y}, rotation, 0, 0),
	            dc = {  //use to translate after other rotation
	                x: c.x  - Math.abs(rc.x) ,
	                y: c.y - Math.abs(rc.y)
	            },
	            t = 'R' + rotation + ',' + c.x + ',' + c.y +  ' t' + dc.x + ',' + dc.y;
	
	        return R.transformPath(scaledPath, t);
	    };
	
	    // The opposite of viewerAdjust -- normalize back to scale of 1 and if rotated, rotate back.
	    // Perform rounding of coordinates -- this is what is called for persistence.
	    // Note: any potential transforms on the path element not taken into account
	    R.fn.viewerUnadjustedPath = function(originalPath, scale, rotation, origDimsWithScaleApplied, originalCenterPtWithScaleAndRotationApplied) {
	
	        rotation = rotation % 360; //TODO: in caller
	
	        // ( scaledPath also performs rounding )
	        var scaledPath = function(path) {
	            return R.fn.adjustPath(path, function(n) {
	                return +(n / scale).toFixed(3);
	            });
	        };
	
	        if (rotation === 0)
	            return scaledPath(originalPath);
	
	        // rotation
	        var rotTo0 =  -1 * rotation,
	            dims = origDimsWithScaleApplied,
	            c = {
	                x: Math.round( dims.w / 2 ),  //TODO: pass c instead -- need to know .w vs .width ...
	                y: Math.round( dims.h / 2 )
	            },
	            rc = originalCenterPtWithScaleAndRotationApplied, //only abs values used in calc -- (not scaled)
	            dc = {
	                x: c.x  - Math.abs(rc.x) ,
	                y: c.y - Math.abs(rc.y)
	            },
	            t = 'R' + rotTo0 + ',' + c.x + ',' + c.y +  ' t' + dc.x + ',' + dc.y;
	
	        var rotatedPath = R.transformPath(originalPath, t);
	        var scaledRotatedPath = scaledPath(rotatedPath);
	
	        return scaledRotatedPath;
	
	    };
	
	    R.el.isPath = function() {
	        return this.node.tagName.toLowerCase() === 'path';
	    };
	
	    // return array of pts from a Raphael Bounding box
	    R.fn.getCoordinatesFromBBox = function(box) {
	        return [
	            {x: box.x,	y: box.y},
	            {x: box.x2,	y: box.y},
	            {x: box.x2, y: box.y2},
	            {x: box.x,	y: box.y2}
	        ];
	    };
	
	    // If element has either a stroke or fill, change them to the provided color
	    R.el.setStrokeAndFill = function(color) {
	        var attrs = this.attr();
	        attrs.fill && attrs.fill !== 'none' && ( this.attr('fill', color ) );
	        attrs.stroke && attrs.stroke !== 'none' && ( this.attr('stroke', color) );
	        return this;
	    };
	
	    // https://stackoverflow.com/questions/12059592/triggering-raphael-events-externally
	    // forked to add the e to the original event for 'drag'
	    R.el.trigger = function(eventName, e){
	        for(var i = 0, len = this.events.length; i < len; i++) {
	            if (this.events[i].name == eventName) {
	                this.events[i].f.call(this, e);
	            }
	        }
	    };
	
	
	    /** --- Text path functions created for text stamps  ---- */
	
	    /**
	     * Replace the text of a path created with paper.print
	     * keepTopLeftPosition: use if you want to keep in place at the top, left of the existing position.
	     * ( if transformed, you may not care )
	     * Use when desirable to not delete and create a new element.
	     * Raphael paper.print works at the element level -- there isn't a fn
	     * to generate the path so this is a 'heavy' solution:
	     * create a hidden element, get it's path, set it, remove the hidden element.
	     * font & fontSize: required ( these aren't attributes b/c we are talking about a path )
	     * ... I suppose could set as data-attrs ...
	     */
	
	    R.el.replaceTextPath = function( text, font, fontSize, keepTopLeftPosition ) {
	
	        var paper = this.paper;
	
	        if ( typeof font === 'string' ) {
	            font = paper.getFont( font );
	        }
	
	        var temp = paper.print( 0, 0, text, font, parseFloat( fontSize ), 'baseline' )
	            .hide();
	
	        var newPath =  temp.attr('path');
	
	        if ( keepTopLeftPosition ) {
	
	            var obox = this.getBBox();
	            newPath = R.fn.getTextPathAtTopLeftPosition( newPath, obox.x, obox.y );
	
	        }
	
	        this.attr( 'path', newPath );
	
	        temp.remove();
	
	        return this;
	
	    };
	
	
	    /**
	     * Originally placed position can be different than the bbox )
	     */
	    R.el.moveTextPathToTopLeft = function( x, y, x_padding, y_padding ) {
	
	        this.attr( 'path', R.fn.getTextPathAtTopLeftPosition( this.getPath(), x, y, x_padding, y_padding ) );
	        return this;
	
	    };
	
	    /* May be more efficient way by hooking into the font metrics */
	    R.fn.getTextPathAtTopLeftPosition = function( path, x, y, x_padding, y_padding ) {
	
	        x_padding = x_padding || 0;
	        y_padding = y_padding || 0;
	
	        var box = R.pathBBox( path );
	        var dx = x - box.x + x_padding;
	        var dy = y - box.y + y_padding;
	
	        return R.transformPath( path, 't' + dx + ',' + dy );
	    };
	
	
	    /**
	     * Wrapper around paper.print to position text at provided top, left coordinates.
	     * options: keys are the same as the parameters for paper.print as well as
	     * arguments for this function.
	     */
	    R.fn.printAtTopLeftPosition = function( options ) {
	
	        return this.print( options.x, options.y, options.text, options.font, options.size, 'baseline', options.letter_spacing  )
	            .moveTextPathToTopLeft( options.x, options.y, options.x_padding, options.y_padding );
	
	    };
	
	
	    /* -- End Text Stamp New Text Path Functions -- */
	
	
	})(Raphael);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/* A workaround For Raphael Inability to Maintain Constant Stroke Width When Drawing Rectangles */
	// $(this.el.node).attr('vector-effect', 'non-scaling-stroke'); won't work with older browsers
	//also turns on/off the stroke of the main el
	
	var Raphael = __webpack_require__(182);
	__webpack_require__(198);
	
	var BORDER = function(raphaelEl) {
	
	    this.raphaelEl = raphaelEl;
	    this.osw = raphaelEl.attr('stroke-width');
	    this.oStroke = raphaelEl.attr('stroke');
	
	    raphaelEl.attr('stroke-width', 0);
	
	    this.shape = raphaelEl.paper.path( raphaelEl.getPathOfBBox() ).attr({
	        'stroke-width': this.osw,
	        fill: 'none',
	        stroke: this.oStroke
	    }).toBack();
	
	    return this;
	
	};
	
	_.extend(BORDER.prototype, {
	    move: function() {
	        this.shape.attr( 'path', this.raphaelEl.getPathOfBBox() ).attr({
	            'stroke-width': this.osw,
	            stroke: this.oStroke
	        });
	        return this;
	    },
	    hide: function() {
	      this.shape.hide();
	      return this;
	    },
	    show: function() {
	        this.shape.show();
	        return this;
	    },
	    destroy: function(resetShapeAttrs)  {
	        this.shape.remove();
	        if (resetShapeAttrs) { //don't need for new (drawn)
	            this.raphaelEl.attr({
	                'stroke-width': this.osw,
	                stroke: this.oStroke
	            });
	        }
	        return this;
	    }
	});
	
	
	module.exports = BORDER;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var BasePolyResizeMixin = __webpack_require__(201);
	
	module.exports = {
	
	    resizeStart: BasePolyResizeMixin.resizeStart,
	
	    resizeMove: BasePolyResizeMixin.resizeMove,
	
	    resizeEnd: BasePolyResizeMixin.resizeEnd,
	
	    updateDragPtHandleAndPathOnMove: BasePolyResizeMixin.updateDragPtHandleAndPathOnMove,
	
	    // ( Difference is closing the path )
	    updatePath: function() {
	
	        this.el.setPathFromPtsArray( this.currentPts, 1 );
	
	    }
	
	};


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var Raphael = __webpack_require__(182),
	    _ = __webpack_require__(49),
	    BaseResize = __webpack_require__(194);
	
	/*
	 * Currently used for a lines types and polygon redactions.
	 * This involves dragging a 'point' on a polygon,
	 * then resizing the polygon to reflect the change in size from the drag.
	 * Context for all these is shape view.
	 * TODO:
	 *   - Now using inherited mixins and composition where necessary -- these should all be on shape view prototypes ...
	 *   - further cleanup this old mess
	 *   - 'Draw helper' objects would be more helpful as well instead of setting all these directly on the mixed-in-shapes.
	 * */
	
	
	module.exports = {
	
	    resizeStart: function(x, y, e) {
	
	        if ( !BaseResize.start.apply( this, arguments) )
	            return false;
	
	        this.currentPts = this.el.getPathCoordinates();
	
	        this.dragPoint = this.currentPts[ this.dragHandle.data('ptIndex') ];  // a reference to the pt coordinate corresponding to the drag handle
	
	        // Store the original position of the drag point and drag handle
	        _.extend( this.dragPoint, {
	            ox: this.dragPoint.x,
	            oy: this.dragPoint.y
	        });
	
	        _.extend( this.dragHandle, {
	            ox: this.dragHandle.attr('cx'),
	            oy: this.dragHandle.attr('cy')
	        });
	
	        this.trigger( 'shape.poly.resizeStart' );
	
	        return true;
	    },
	
	    resizeMove: function( dx, dy, x, y, e ) {
	
	        if ( !BaseResize.move.apply( this, arguments ) )
	            return false;
	
	        this.updateDragPtHandleAndPathOnMove.apply( this, arguments );
	
	        this.trigger( 'shape.poly.resize' );
	
	        return true;
	
	    },
	
	    resizeEnd: function( e ) {
	
	        if ( !BaseResize.end.call( this, e) )
	            return false;
	
	        BaseResize.cleanUp.call(this);
	
	        this.dragPoint = null;
	        this.currentPts = null;
	
	        this.trigger('shape.resizePolyEnd', this.el.getBBox() );
	
	        return true;
	
	    },
	
	   /*
	   * Update the dragHandle and the path getting dragged.
	   * Data is updated on dragPoint, which is later used to update the path in the DOM.
	   * The default action here, no shift key, etc.
	   * More flexibility would be creation of more objects, fns (eg here we have updatePath) ...
	   * */
	   updateDragPtHandleAndPathOnMove: function( dx, dy, x, y, e ) {
	
	       var dp = this.dragPoint;
	
	       _.extend( this.dragPoint, {
	           x: dp.ox + dx,
	           y: dp.oy + dy
	       });
	
	       this.dragHandle.attr({
	           cx: dp.ox + dx,
	           cy: dp.oy + dy
	       });
	
	       this.updatePath.call( this, e );
	
	    },
	
	    // Default Behavior -- Override If Necessary
	    updatePath: function() {
	        this.el.setPathFromPtsArray( this.currentPts, 0 );
	    }
	
	};
	
	


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BasePolyResizeMixin = __webpack_require__(201),
	    LockAngleCalcPosition = __webpack_require__(203).calculatePosition;
	
	
	module.exports = {
	
	    resizeStart: function( x, y, e ) {
	
	        if ( !BasePolyResizeMixin.resizeStart.apply( this, arguments ) )
	            return false;
	
	        this.lineBasePt = _.without( this.currentPts, this.dragPoint )[0];
	        this.lineBasePt['ox'] = this.lineBasePt.x;
	        this.lineBasePt['oy'] = this.lineBasePt.y;
	
	        // TODO: should have a mousemove that goes over the canvas in the base fns ... (or don't stop it)
	        var canvasContainerRel = this.channel.request('canvasContainerRel');
	
	        this.lockAngleBoundary = {
	            minX: canvasContainerRel.x,
	            minY: canvasContainerRel.y,
	            maxX: canvasContainerRel.x2,
	            maxY: canvasContainerRel.y2
	        };
	
	        return true;
	
	    },
	    /*
	    * TODO: if the shift key is down and drawing straight line,
	    *  may not want to return false if 'out of bounds' ...
	    * */
	    resizeMove: BasePolyResizeMixin.resizeMove,
	
	    updatePath: BasePolyResizeMixin.updatePath,
	
	    updateDragPtHandleAndPathOnMove: function( dx, dy, x, y, e ) {
	
	        if ( !e.shiftKey ) {
	
	            BasePolyResizeMixin.updateDragPtHandleAndPathOnMove.apply( this, arguments );
	
	        } else {
	
	            /*
	            * In libraray example, 'newPoint' is the one from the 'origin' (here, the mouse posiition),
	            * and last is the 'last one' placed down.
	            * So we want the coordinates of the initial placement and the one you're dragging to.
	            * */
	            var projection = LockAngleCalcPosition(
	                {
	                    x: e.offsetX,
	                    y: e.offsetY
	                },
	                { x: this.lineBasePt.ox, y: this.lineBasePt.oy },
	                {
	                    boundary: this.lockAngleBoundary
	                }
	            );
	
	            _.extend( this.dragPoint, {
	                x: projection.x,
	                y: projection.y
	            });
	
	            /* also update the position of the drag handle based on the change in the size of the line */
	            var cx = this.dragHandle.attr('cx'),
	                cy = this.dragHandle.attr('cy');
	
	            this.dragHandle.attr( {
	                cx: cx + ( projection.x - cx ),
	                cy: cy + ( projection.y - cy )
	            });
	
	            this.updatePath.apply( this, [e] );
	
	        }
	
	        return true;
	
	    },
	
	    resizeEnd: function() {
	
	        if ( !BasePolyResizeMixin.resizeEnd.apply( this, arguments ) )
	            return false;
	
	        delete this.lineBasePt;
	        delete this.lockAngleBoundary;
	
	        return true;
	
	    }
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var solveSimultaneousEquations = exports.solveSimultaneousEquations = function solveSimultaneousEquations(a, b, c, d, e, f) {
	  // Solve system of equations ax + by = e and cx + dy = f
	  var det = a * d - b * c;
	  var x = (d * e - b * f) / det;
	  var y = (a * f - c * e) / det;
	  return { x: x, y: y };
	};
	
	var getProjectionFromPointToLine = exports.getProjectionFromPointToLine = function getProjectionFromPointToLine(point, line) {
	  // Get projection from point (x, y) to a line ax + by + c = 0
	  var projection = solveSimultaneousEquations(line[0], line[1], -line[1], line[0], -line[2], line[0] * point.y - line[1] * point.x);
	  return projection;
	};
	
	var getDistanceFromPointToLine = exports.getDistanceFromPointToLine = function getDistanceFromPointToLine(point, line) {
	  return Math.abs(line[0] * point.x + line[1] * point.y + line[2]) / Math.sqrt(line[0] * line[0] + line[1] * line[1]);
	};
	
	var getClosestLine = exports.getClosestLine = function getClosestLine(currentPoint, lastPoint) {
	  // 4 base line in plane, horizontal, vertical, 45 degree, 135 degree
	  // each line formulation ax + by + c = 0 -> [a, b, c]
	  var lineList = [[1, 1, -1 * (lastPoint.x + lastPoint.y)], [1, -1, -1 * (lastPoint.x - lastPoint.y)], [1, 0, -lastPoint.x], [0, 1, -lastPoint.y]];
	
	  var distance = lineList.map(function (line) {
	    return getDistanceFromPointToLine(currentPoint, line);
	  });
	  var maxDistance = Math.min.apply(Math, _toConsumableArray(distance));
	  var maxIndex = distance.indexOf(maxDistance);
	  return lineList[maxIndex];
	};
	
	var calculateVerticalAndHorizontalLine = exports.calculateVerticalAndHorizontalLine = function calculateVerticalAndHorizontalLine(currentPoint, lastPoint) {
	  // simple calculation when we only want to lock 0, 90, 180, 270, 360 degree
	  var xDistance = Math.abs(currentPoint.x - lastPoint.x);
	  var yDistance = Math.abs(currentPoint.y - lastPoint.y);
	  if (xDistance > yDistance) {
	    return {
	      x: currentPoint.x,
	      y: lastPoint.y
	    };
	  } else {
	    return {
	      x: lastPoint.x,
	      y: currentPoint.y
	    };
	  }
	};
	
	var solveEquationX = function solveEquationX(line, yValue) {
	  // Find x when know y, equation line[0]x + line[1]y + line[2] = 0
	  if (line[0] === 0) {
	    throw new Error('There are infinite number of solutions');
	  }
	  return -1 * (line[1] * yValue + line[2]) / line[0];
	};
	
	var solveEquationY = function solveEquationY(line, xValue) {
	  // Find y when know x, equation line[0]x + line[1]y + line[2] = 0
	  if (line[1] === 0) {
	    throw new Error('There are infinite number of solutions');
	  }
	  return -1 * (line[0] * xValue + line[2]) / line[1];
	};
	
	var checkBoundary = exports.checkBoundary = function checkBoundary(point, boundary, line) {
	  /**
	   * If point is outside of boundary, return intersection between line and boundary
	   */
	  if (point.x < boundary.minX) {
	    point.x = boundary.minX;
	    point.y = solveEquationY(line, boundary.minX);
	  } else if (point.x > boundary.maxX) {
	    point.x = boundary.maxX;
	    point.y = solveEquationY(line, boundary.maxX);
	  }
	
	  if (point.y < boundary.minY) {
	    point.y = boundary.minY;
	    point.x = solveEquationX(line, boundary.minY);
	  } else if (point.y > boundary.maxY) {
	    point.y = boundary.maxY;
	    point.x = solveEquationX(line, boundary.maxY);
	  }
	  return point;
	};
	
	var calculateNearestPoint = exports.calculateNearestPoint = function calculateNearestPoint(currentPoint, lastPoint) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var nearestLine = getClosestLine(currentPoint, lastPoint);
	  var result = getProjectionFromPointToLine(currentPoint, nearestLine);
	  var boundary = config.boundary;
	  if (boundary) {
	    result = checkBoundary(result, boundary, nearestLine);
	  }
	  return result;
	};
	
	var calculatePosition = exports.calculatePosition = function calculatePosition(currentPoint, lastPoint) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!lastPoint || !currentPoint) {
	    return null;
	  }
	  if (config.isSimple) {
	    // only lock 0, 90, 180, 270, 360 degree
	    return calculateVerticalAndHorizontalLine(currentPoint, lastPoint);
	  } else {
	    // lock 0, 45, 90, 135... degree
	    return calculateNearestPoint(currentPoint, lastPoint, config);
	  }
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var Raphael = __webpack_require__(182);
	var LineResizeMixin = __webpack_require__(202);
	
	/*
	* Same as line, except for some hacks in place to deal
	* with bugs working with the arrow marker in Raphael.
	* */
	
	
	module.exports = {
	
	    resizeStart: function() {
	
	        if ( !LineResizeMixin.resizeStart.apply( this, arguments ) )
	            return false;
	
	        /*
	         * Hack work-around for Raphael issue with arrows.
	         * Still needed -- without -- will get the error on move (this sets up that hack).
	         * Could use clearer organization.
	         * */
	        var path = Raphael.parsePathString( this.el.attr('path') ); // if parse on move will get error on drag
	
	        this.oPt = {
	            x: path[0][1],
	            y: path[0][2]
	        };
	
	        this.oArrow = this.el.attr('arrow-end');
	
	        return true;
	
	    },
	
	    resizeMove: LineResizeMixin.resizeMove,
	
	    resizeEnd: function() {
	
	        if ( !LineResizeMixin.resizeEnd.apply( this, arguments ) )
	            return false;
	
	        delete this.oPt;
	        delete this.oArrow;
	
	        return true;
	
	    },
	
	    updateDragPtHandleAndPathOnMove: LineResizeMixin.updateDragPtHandleAndPathOnMove,
	
	    /* This still appears to be needed
	     * When line is small you'll get errors in Raphael when applying the arrow.
	     * TODO -- this can still break ...
	     *  try rapid resizing around the origin... (esp at larger sizes)
	     *  -- maybe make a fn of the arrow size ???
	     *  maybe store the limit on the arrow shape view or model when create it???
	     */
	    updatePath: function(e) {
	
	        var LIM = 10; // check if within 10 from the origin -- the other pt -- Raphael hack
	        var mousePos = this.parent.getMousePos(e);
	
	        // 1) hack to prevent 'size error'
	        if ( (Math.abs(this.oPt.x - mousePos.x) < LIM) || ( Math.abs(this.oPt.y - mousePos.y) < LIM ) )
	            return;
	
	        //2) other hack: remove the attr then add it after the path to allow the arrow to move when the path moves in IE10
	        this.el
	            .attr('arrow-end', '')
	            .setPathFromPtsArray( this.currentPts )
	            .attr( 'arrow-end', this.oArrow );
	
	    }
	
	};


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var FreeResize = __webpack_require__(193),
	    Slice = Array.prototype.slice;
	
	module.exports = {
	    resizeStart: function() {
	        
	        FreeResize.resizeStart.apply(this, arguments);
	        this.obox = this.el.getBBox(); // should make 'helper' object ... (and this would augment it)
	        this.HANDLE_D = this.dragHandle.attr('r') * 2;
	
	    },
	    resizeMove: function() {
	        var args = Slice.call(arguments);
	        FreeResize.resizeMove.apply(this, args.concat( preTransformShapeOnMove ) );
	
	        /** 
	            * return true / false indicating whether to continue in the resize move 
	            * mx, my are is the position of the mouse relative to the canvas
	            * this block the flip/'reflection'
	        */
	
	        function preTransformShapeOnMove(mx, my) {
	           
	             if ( this.isEast && ( mx < this.obox.x + this.HANDLE_D ) ) return false;
	             if ( this.isSouth && ( my < this.obox.y + this.HANDLE_D) ) return false;
	             if ( !this.isEast && ( mx > this.obox.x2 - this.HANDLE_D) ) return false;
	             if ( !this.isSouth && ( my > this.obox.y2 - this.HANDLE_D) ) return false;
	
	             return true;
	        }
	    },
	    resizeEnd: function() {
	        FreeResize.resizeEnd.apply(this, arguments);
	        this.obox = null;
	        this.HANDLE_D = null;
	    }
	
	};
	
	


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {// perhaps make like the fake line used for rect on scale resize
	// this could also just be a wrapper around the rEl
	// TODO: With untransformed shapes ( eg text stamp ), there are more optimal ways to handle now
	
	
	var Marionette = __webpack_require__(61),
	    Raphael = __webpack_require__(182),//(imported by Raphael view, but gets Sonar to shut up)
	    RaphaelView = __webpack_require__(187);
	
	var instVars = {
	    ox: null,
	    oy: null
	};
	
	module.exports = RaphaelView.extend({
	
	    svgAttrs: {
	        stroke: '#33A645',
	        'stroke-width': 1,
	        'stroke-linejoin': 'miter',
	        fill: 'none'
	         //'stroke-dasharray': '--' -- if use this may not want to transform, it doesn't look good ( see spiders, redraw path -- but for text stamps, we don't resize )
	    },
	
	    initialize: function(options) {
	
	        _.extend( this, instVars );
	
	        this.bindEntityEvents( options.parent, this.parentSubs );
	
	    },
	    parentSubs: {
	        'shape.move':                       'move',
	        'shape.resizeSelectBox':            'resize',   //for now the same event listened to by this resize handlers -- much faster than resizeFree -- TODO: CHANGE RESIZE
	        'shape.onAfterBaseScale':           'setPathToBBoxOfParent',
	        'shape.selectBox.resetPath':        'setPathToBBoxOfParent',
	        'shape.moveEnd shape.resizeEnd':    'bakeTransform'
	    },
	
	    render: function(shapeEl) {
	
	        var bboxPath = shapeEl.getPathOfBBox(),
	            borderPath = shapeEl.paper.path(bboxPath).attr( this.svgAttrs );
	
	        this.setElement(borderPath);
	
	        this.el
	            .attr('cursor', 'move')
	            .data('shapeType', 'selectBox')
	            .insertBefore(shapeEl); //position above handle but not in front of shape
	
	        this.ox = this.el.attr('x');
	        this.oy = this.el.attr('y');
	
	        return this;
	
	    },
	    move: function( box, dx, dy ) {
	
	        this.el.transform( 'T' + (this.ox + dx) + " " + (this.oy + dy) );  /* Note: Use This for Perf -- Not the Dashed LIne*/
	
	    },
	    resize: function( parentTrans ) {
	        //var p = Raphael.mapPath(this.el.attr('path'), shapeMatrix); // perhaps need mapPathStraight()...
	        this.el.transform( parentTrans );
	    },
	    // perhaps rid cachedBox in this but this isn't always the same transform
	    bakeTransform: function() {
	
	       // this.el.removeCachedBox(); -- doesn't fix
	
	        this.el
	            .bakeTransform()
	            .attr('stroke-width', this.svgAttrs['stroke-width']);
	
	    },
	
	    /**
	     * Set removeTransform to true now only done on move end of 'transformed' shapes
	     */
	    setPathToBBoxOfParent: function( box, removeTransform ) {
	
	        this.el.attr( 'path', Raphael.fn.rectPath(box.x, box.y, box.width, box.height) );
	
	        if ( removeTransform ) {
	            this.el.transform( '' );
	        }
	
	    },
	
	    onBeforeDestroy: function() {
	
	
	        this.unbindEntityEvents(this, this.parentSubs);
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	
	var RaphaelView = __webpack_require__(187),
	    DeleteBtn = __webpack_require__(208),
	    _ = __webpack_require__(49);
	
	
	/**
	 * Multiview set of button sets
	 * Could use model like this as proto for others -- easier shape/r_view management
	 * This really needs cleaning up ...
	 */
	
	module.exports = RaphaelView.extend({
	
	    PADDING: {
	        x: 10,
	        y: 0
	    },
	
	    initialize: function() {
	
	        /* These instance variables were very incorrectly on the prototype -- define here */
	        this.btnSet = null;
	        this.btnViewRef = {}; // button key labels by Raphael Views they represent (eg delete X raphael view)
	        this.oBox = null; // the original bounding box of the view
	        this.isFlippedHorizontally = false;
	
	        /* -- old init --*/
	        var self = this;
	        var pShape = this.options.parent;
	        this.btnSet = pShape.paper.set(); // TODO: only if it has them
	
	
	        // TODO: subclass or pass in option to create delete button by default
	        if ( !pShape.shapeModel.isFindAndRedactShape) {
	
	            this.addBtn('delete', DeleteBtn);
	
	        } else {
	
	            // TEMP ...
	            //this._setOBox();
	
	            this.oBox = {
	                height: 0,
	                width: 0,
	                x: 0,
	                y: 0,
	                x2: 0,
	                y2: 0
	            };
	
	        }
	
	
	        /* adjustment for print in the center vertical -- still with vert ?*/
	        this.cy = this.oBox.height / 2;
	
	        /* TODO: poly specific subset -- lines as well */
	        this.listenTo(pShape, 'shape.move shape.onAfterBaseScale shape.resizeRect', this.move);
	        this.listenTo(pShape, 'shape.redaction.poly.resize', this.fadeOut);
	        this.listenTo(pShape, 'shape.resizePolyEnd', function() {
	            var args = _.toArray(arguments);
	            self.move.apply(self, args.concat(1));
	        });
	
	        this.setElement(this.btnSet);
	        return this;
	
	    },
	
	    fadeOut: function() {
	        this.getIconSet().fadeOut();
	    },
	
	
	    /* adds to hash of BB R views (for destruction -- and also adds to the btn set (for collection R el actions */
	    // TODO: clean and make more generic -- now only assumes spec settings
	    // Note: also create first button set and the obox -- should separate ...
	    addBtn: function(btnLbl, ViewConstructor, onNewColumn) { 
	
	        var pBox = this.options.parent.el.getBBox();
	        var PAD = 5;
	
	        var v = new ViewConstructor( _.extend(this.options, {
	            x: !onNewColumn //always delete btn
	                ? pBox.x2 + this.PADDING.x      //(!this.oBox ? 0 : this.oBox.width),
	                : this.oBox.x2 + this.PADDING.x,
	            y: !onNewColumn 
	                ? pBox.y + this.PADDING.y  + (!this.oBox ? 0 : this.oBox.height + PAD)
	                : pBox.y
	        } )).render();
	
	        this.btnViewRef[btnLbl] = v;
	        this.btnSet.push(v.el);
	        this._setOBox();
	
	        return this;
	    },
	    getView: function(btnLabel) {
	        return this.btnViewRef[btnLabel];
	    },
	    // ( must call after shape rendered  )
	    _setOBox: function() {
	        this.oBox = this.btnSet.getBBox();
	    },
	
	
	    /**
	     * TODO: diff subtype for poly -- move goes to the outermost points
	     * Could only pass from triggerer on move --resize is moving diff ways -- getting rel to the shape is the key
	     * by default bbox of pshape , includes transform    --shape.move -- b, dx, dy, scale is diff -- so store here
	     * Check if in bounds (only right and top); only considering top left default
	     */
	
	    move: function(box, fadeIn) {
	
	        this.isFlippedHorizontally = false;
	
	        var dx = box.x2 - this.oBox.x + this.PADDING.x,
	            dy = box.y - (this.oBox.y + this.cy) + this.PADDING.y,// + this.topOffset, //not taking into account relation from op
	            paperBounds = this.options.channel.request('canvasContainerRel'), // TODO: -- cache
	            sx = 1, // currently only scaling one way
	            sy = 1;
	
	        // if over right
	        if (this.oBox.x2 + dx >= paperBounds.x2) {
	            dx -= box.width + this.oBox.width + (this.PADDING.x * 2);
	            this.isFlippedHorizontally = true;
	        }
	        // if over top, can (no else; can be both)
	        if (this.oBox.y + dy <= paperBounds.y) {
	            dy += box.height; //note: want relative to the parent shape
	        }
	
	        // DVBC-1425 - handle over bottom also -- would only occur for shapes with really small height
	        if ( this.oBox.y2 + dy >= paperBounds.y2) {
	            dy -= this.oBox.height;
	        }
	
	        this.btnSet.transform('S' + sx + ',' + sy + 'T' + dx + ',' + dy);
	
	        fadeIn && this.getIconSet().fadeIn(); //for end move of poly redact -- hidden on start
	
	        this.options.parent.trigger('shape.buttonSet.postMove');
	
	    },
	
	    /* return just the icons from the set -- now an array */
	    getIconSet: function() {
	
	      return this.btnSet.paper.set( _.map(this.btnViewRef, function(v) {
	           return v.getIcon();
	       }));
	
	    },
	
	
	    onBeforeDestroy: function() {
	
	        _.invoke(  _.values(this.btnViewRef), 'destroy' );
	
	        this.remove(); //(BB View)
	
	        // can't call from here (RECURSION)
	        // this.options.parent.shapeModel.trigger('destroy'); //(quick fix to destroy top up if not called -- eg on save when dialog close)
	    }
	
	});

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var ShapeBtn = __webpack_require__(209);
	
	module.exports = ShapeBtn.extend({
	    iconCode: 0xe80d,
	    color: '#ff0000',
	    title: 'Delete',
	    clickAction: function(e) { //delete the shape
	
	        e = $.event.fix(e);
	        e.stopImmediatePropagation();
	
	        // want inline require ? -- could make fn that returns the constructor or pass it in as arg
	        var SignatureShape =  __webpack_require__(211);
	
	        if ( !(this.parent instanceof SignatureShape) ) {
	            this.shapeModel.destroy();
	            this.options.parent.options.channel.command('deleteShape', this.shapeModel, 1); // (true indicate the delete call is from this button)
	        } else {
	            //horrible quick fix for signature specific func'lity -- one sig. per note: trigger cancel creation of the note, not delete of shape -- TODO: clean
	            this.options.parent.options.channel.command('cancelSignature', this.parent.pgNoteModel);
	        }
	
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* A set of two shapes, transPath and the Icon over it -- the base/'proto' from which the others extend */
	
	var RaphaelView = __webpack_require__(187),
	    Raphael = __webpack_require__(182),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49);
	
	__webpack_require__(198);
	__webpack_require__(210);
	
	var ICON_FONT = 'fontello';
	
	var instVars = {
	    isActive: false, //for hover -- todo: only used for redaction : means when the redactProp is open -- move there ( and i guess now sign. dialog)
	    parent: null, //todo: may not be necessary anymore if pass in derivations
	    pgNoteModel: null, //TODO: PUT just IN REDACTION? -- only used there ?
	    //sub r elements
	    icon: null,
	    transparentPath: null,
	    //currently derived from parent
	        paper: null,
	        shapeModel: null
	    //currently on proto of derivitives
	        //this.iconCode, this.title, iconMouseOverColor, color, clickAction, topOffset
	};
	
	module.exports = RaphaelView.extend({ //note the delete extended
	    scale: 1.2,   //want a little larger than the font
	    iconMouseOverColor: '#0F3CFF',
	    initialize: function(options) {
	        _.extend(this, instVars, _.pick(options, 'parent', 'pgNoteModel'), {
	            paper: options.parent.paper,
	            shapeModel: options.parent.shapeModel
	        });
	        if (!Raphael.fonts[ICON_FONT]) this.paper.getFont(ICON_FONT);
	        return this;
	    },
	    render: function() {
	        this.icon = this._drawIcon();
	        this.transparentPath = this._drawTransparentPath( this.icon.getBBox() );
	        // using the node and click fn fixes bug in IE* below -- don't really need now .. (still need?)
	        $(this.transparentPath.node).on( 'click', _.bind( function(e) {
	            this.clickAction(e);
	        }, this) );
	
	        var el = this.paper.set(this.icon, this.transparentPath)
	            .data('shapeType', 'button'); //todo *C
	        this.setElement(el);
	        this.delegateHover();
	        return this;
	    },
	    _drawIcon: function() {
	        return this.paper.print(
	            this.options.x, this.options.y,
	            String.fromCharCode(this.iconCode), /* note: designed to be used in deriving classes */
	            ICON_FONT
	        ).attr({
	            fill: this.color,
	            stroke: 'none',
	            cursor: 'pointer',
	            'stroke-width': 0,
	            transform: 'S' + this.scale
	        }).bakeTransform();
	    },
	    _drawTransparentPath: function(iconBox) {
	        return this.paper.rect(
	            iconBox.x,
	            iconBox.y,
	            iconBox.width,
	            iconBox.height
	        ).attr({
	            opacity: 0,
	            cursor: 'pointer',
	            stroke: 'none',  //OPACITY 0 MAKES POSSIBLE
	            fill: this.color,
	            title: this.title
	        });
	    },
	    getIcon: function() {
	      return this.icon;
	    },
	    getTransparentPathEl: function() {
	      return this.transparentPath.node;
	    },
	    /* !THIS IS THE FIX FOR IE LESS THAN 8 AND DISAPPEAR BTN ON HOVER */
	    delegateHover: function() {
	        this.transparentPath
	            .mouseover(function() {
	                return false;
	            }).mouseout(function() {
	                return false;
	            });
	        this.el.mouseover( _.bind( function(e) { this.mouseover(e); }, this));
	        this.el.mouseout( _.bind( function(e) { this.mouseout(e); }, this));
	    },
	    mouseover: function() {
	        if (!this.isActive) this.icon.stop().animate({fill: this.iconMouseOverColor} , 150);
	    },
	    mouseout: function() {
	        if (!this.isActive) this.icon.stop().animate({fill: this.color} , 150);
	    },
	    clickAction: $.noop,
	    destroy: function() {
	        $(this.transparentPath.node).off('click');
	        this.el.unmouseover().unmouseout(); //undelegate hover
	        this.transparentPath.remove();
	        this.icon.remove();
	        this.el.remove();
	        this.remove();
	    }
	});


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/* cufon file export filtered just for the glyphs using */
	
	var Raphael = __webpack_require__(182);
	
	Raphael.registerFont({
	    "w": 1000,
	    "face": {
	        "font-family": "fontello",
	        "font-weight": 400,
	        "font-stretch": "normal",
	        "units-per-em": "1000",
	        "panose-1": "2 0 5 3 0 0 0 0 0 0",
	        "ascent": "850",
	        "descent": "-150",
	        "bbox": "-4 -963 1391 266",
	        "underline-thickness": "0",
	        "underline-position": "0",
	        "unicode-range": "U+002B-U+F0C5"
	    },
	    "glyphs": {
	        "\ue80d": {
	            "d": "286,-439r0,321v0,5,-2,10,-5,13v-3,3,-8,5,-13,5r-36,0v-5,0,-10,-2,-13,-5v-3,-3,-5,-8,-5,-13r0,-321v0,-5,2,-10,5,-13v3,-3,8,-5,13,-5r36,0v5,0,10,2,13,5v3,3,5,8,5,13xm429,-439r0,321v0,5,-2,10,-5,13v-3,3,-8,5,-13,5r-36,0v-5,0,-10,-2,-13,-5v-3,-3,-5,-8,-5,-13r0,-321v0,-5,2,-10,5,-13v3,-3,8,-5,13,-5r36,0v5,0,10,2,13,5v3,3,5,8,5,13xm572,-439r0,321v0,5,-2,10,-5,13v-3,3,-8,5,-13,5r-36,0v-5,0,-10,-2,-13,-5v-3,-3,-5,-8,-5,-13r0,-321v0,-5,2,-10,5,-13v3,-3,8,-5,13,-5r36,0v5,0,10,2,13,5v3,3,5,8,5,13xm643,-35r0,-529r-500,0r0,529v0,8,1,16,4,23v3,7,5,12,8,15v3,3,5,4,6,5r464,0v1,0,3,-2,6,-5v3,-3,5,-8,8,-15v3,-7,4,-14,4,-23xm268,-635r250,0r-27,-65v-3,-3,-6,-5,-9,-6r-177,0v-4,1,-7,3,-9,6xm786,-617r0,36v0,5,-2,10,-5,13v-3,3,-8,5,-13,5r-54,0r0,529v0,31,-9,57,-26,80v-17,23,-38,34,-63,34r-464,0v-25,0,-46,-11,-63,-33v-17,-22,-26,-48,-26,-79r0,-531r-54,0v-5,0,-10,-2,-13,-5v-3,-3,-5,-8,-5,-13r0,-36v0,-5,2,-10,5,-13v3,-3,8,-5,13,-5r172,0r39,-93v5,-14,15,-26,30,-35v15,-9,29,-14,44,-15r179,0v15,0,29,5,44,15v15,10,25,22,30,35r39,93r172,0v5,0,10,2,13,5v3,3,5,8,5,13r1,0",
	            "w": 785
	        },
	        "\ue809": {
	            "d": "496,-189r65,-65r-85,-85r-65,65r0,31r54,0r0,54r31,0xm742,-591v-6,-6,-12,-6,-18,1r-195,195v-6,6,-6,12,-1,18v5,6,11,6,18,-1r195,-195v6,-6,6,-12,1,-18xm787,-260r0,106v0,44,-16,82,-47,114v-31,32,-69,48,-114,47r-464,0v-44,0,-82,-16,-114,-47v-32,-31,-48,-69,-47,-114r0,-464v0,-44,16,-82,47,-114v31,-32,69,-48,114,-47r464,0v23,0,45,5,65,14v5,3,9,7,10,13v1,6,0,11,-5,16r-27,27v-5,5,-11,7,-18,4v-9,-2,-17,-3,-25,-3r-464,0v-25,0,-46,9,-63,26v-17,17,-26,38,-26,63r0,464v0,25,9,46,26,63v17,17,38,26,63,26r464,0v25,0,46,-9,63,-26v17,-17,26,-38,26,-63r0,-70v0,-5,2,-9,5,-12r36,-36v5,-5,12,-7,20,-4v8,3,12,8,11,16r0,1xm733,-672r161,161r-375,375r-161,0r0,-161xm981,-598r-51,51r-161,-161r51,-51v11,-11,23,-16,38,-16v15,0,27,5,38,16r85,85v11,11,16,23,16,38v0,15,-5,27,-16,38"
	        },
	        //"\ue905": { //note: was not 1000 units per em ....
	        //    "d":"138,-45r123,-123v10,-21,-16,-34,-30,-43v-3,0,-6,2,-9,4r-93,94r-43,-43v-22,-10,-33,16,-42,30v19,33,52,53,76,81v6,6,12,5,18,0xm251,-280v31,-2,59,28,58,58r0,192v1,31,-27,59,-58,                 58r-193,0v-31,2,-59,-28,-58,-58r0,-192v-1,-31,27,-59,58,-58r193,0",
	        //    "w":308
	        //},
	        "\ue904":{"d":"653,-396r-235,235v-14,15,-36,15,-50,0r-164,-164v-15,-14,-15,-36,0,-50r57,-57v12,-15,36,-14,50,0r82,82r153,-153v15,-15,38,-16,51,0v23,28,97,66,56,107xm691,-198v57,-89,54,-214,0,-304v-48,-82,-140,-152,-262,-152v-230,0,-379,249,-263,456v49,87,138,150,263,152v125,2,211,-70,262,-152xm800,-565v82,126,73,301,0,430v-66,117,-201,214,-371,214v-251,0,-420,-180,-429,-429v-6,-170,103,-302,213,-371v121,-76,311,-77,431,0v62,39,114,91,156,156","w":857}
	    }
	});

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	//Main states: 'hovering new', creating: new, unsaved, saved not derived, saved derived, loaded derived, loaded not derived
	
	var _ = __webpack_require__(49),
	    Raphael = __webpack_require__(182),
	
	    /* (note: both extend from shape */
	    ShapeDialogView = __webpack_require__(212),
	    GraphicShapeView = __webpack_require__(215),
	
	    SignatureUIModel = __webpack_require__(216),
	    SignatureBottomTextView = __webpack_require__(220),
	    SignatureDialog = __webpack_require__(224),
	    SignatureDialogBtn = __webpack_require__(227),
	    SaveSigBtn = __webpack_require__(229),
	    SignatureEl = __webpack_require__(230);
	
	
	__webpack_require__(198);
	
	
	var instanceVars = {
	    os: null, // orig scale for bottom text scaling - when create new if toggled after scale change; ( put on uiModel ? )
	    signatureModel: null, // new one for each, otherwise used on alternatives!!
	    bottomText: null // the 'bottom text view', which may or may not exist; if it does, will also need to be on the shape model; note: presence indicates action
	};
	
	// make this a separate module if extend more ... ok for now b/c only init overwritten
	
	var DialogGraphicShape = GraphicShapeView.extend(
	    ShapeDialogView.prototype
	);
	
	
	module.exports = DialogGraphicShape.extend({
	    initialize: function(options) {
	
	        _.extend(this, instanceVars, _.pick(options, 'signatureModel'), {
	            os: options.scale,
	            signatureModel: new SignatureUIModel()
	        });
	
	        ShapeDialogView.prototype.initialize.call(this, _.extend(options, {
	            dialogConstructor: SignatureDialog,
	            dialogOptions: {
	                signatureModel: this.signatureModel
	            },
	            dialogBtnConstructor: SignatureDialogBtn
	        }));
	
	        this.bindEntityEvents(this.signatureModel,  this.signatureUISubs);
	
	    },
	
	    shapeSubs: _.extend( {}, DialogGraphicShape.prototype.shapeSubs, {
	        'shape.move shape.resizeRect shape.onAfterBaseScale':   'onAfterBaseShapeScale',     //repo children is really the secondary scale intended for the children
	        'shape.resizeEnd shape.moveEnd':                        'moveOrResizeEnd'
	    }),
	
	    signatureUISubs: {
	        'change:activeFont':                'fontChangeCB',
	        'change:showBottomText':            'toggleBottomText'
	    },
	
	    makeExpandedVisibleIndicator: DialogGraphicShape.prototype._createGlow,
	
	    moveOrResizeEnd: function() {
	        this.trigger('signature.moveOrResizeEnd'); /* pass down to children */
	    },
	    fontChangeCB: function () {
	
	        /* get b/f remove */
	        var elBox = Raphael.pathBBox( this.el.attr('path') );
	        var currentColor = this.el.attr('fill');
	
	        this.el.remove();
	
	        // Note: this is off elbox x, y though below should resolve
	        this.el = SignatureEl(
	            this.paper,
	            elBox.x,
	            elBox.y, // must adjust for this -- baseline is 'middle' -- (unless use borderView, see below)
	            this.pgNoteModel.get('creationUserDesc'),
	            this.signatureModel.get('activeFont'),
	            currentColor
	        );
	
	        this.el.fitAndPositionPathToMatchAnother( this.borderView.el ); /* use the border view; otherwise need to adjust the calc'd box's y position */
	
	        // Update original el
	        this.shapeUI.set('raphaelEl', this.el);
	        this.setElement(this.el);
	
	        this._enableMove();
	
	    },
	    /* note, this is now assuming on create (only newly created... */
	    toggleBottomText: function(m, show) {
	
	        if (show) {
	
	            this.bottomText = new SignatureBottomTextView( _.extend( _.clone(this.options), {
	                parent: this
	            })).render();
	
	            // if not a shape but its path needs to be passed like one
	            // alternative to save on model? (unnecessary dupe ref?)
	            // stored b/c not access to view when re-rendering
	            this.shapeModel['bottomText'] = this.bottomText;
	
	        } else {
	            this.bottomText.destroy();
	            delete this.shapeModel.bottomText;
	        }
	
	    },
	
	    /**
	     * If for more shapes have a child that needs to change color, trigger from the base shape
	     * take the fill applied for the above shape as it's 'derived'
	     * Note: Graphic has different implementation than DialogGraphicShape
	     * ( if more shapes extend, dialog graphic shape should point to that version )
	     */
	    noteConsultGroupChange: function() {
	
	        GraphicShapeView.prototype.noteConsultGroupChange.apply(this, arguments);
	        this.trigger('signature.noteConsultGroupChange', this.el.attr('fill') );
	
	    },
	
	    onAfterButtonSetCreation: function(isSelected) {
	        ShapeDialogView.prototype.onAfterButtonSetCreation.apply(this, arguments);
	        isSelected && this.btnSet.addBtn('save', SaveSigBtn, 1);
	    },
	    onAfterBaseShapeScale: function( signatureBBox, scale, lastScale ) {
	
	        // reposition the bottom text
	        this.trigger.call(this, 'signature.repositionBottomText', signatureBBox );
	
	        /**
	         * If expanded, scale the glow.
	         * Note: this will include the bottom text because when saved, it's read as one element.
	         * The signature can only be expanded when saved.
	         */
	        this.resetGlow();
	
	    },
	    onBeforeDestroy: function () {
	
	        this.bottomText && this.bottomText.destroy();
	
	        DialogGraphicShape.prototype.onBeforeDestroy.apply(this, arguments);
	        GraphicShapeView.prototype.onBeforeDestroy.apply(this, arguments);
	
	        this.unbindEntityEvents(this.signatureModel,  this.signatureUISubs);
	        this.signatureModel.destroy();
	
	        //TODO: events not cleaned ...
	        this.stopListening();
	        this.off();
	
	    }
	
	});
	
	


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var  Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    ShapeView = __webpack_require__(181),
	    HoverEditDialog = __webpack_require__(213);
	
	
	/**
	 * Shape View With a toggleable Edit Btn In its selectSet that hides/shows a HoverEditDialog that's a child of this view.
	 * The HoverEditDialog wraps a view to show ( now dialogConstructor )
	 */
	
	module.exports = ShapeView.extend({
	
	    initialize: function(options) {
	
	        ShapeView.prototype.initialize.apply(this, arguments);
	
	        this.listenTo( this.channel, 'canvas:closeAllDialogs', this._removeDialog );
	
	        this.dialogView = null;
	
	        /* req'd */
	        _.extend( this, _.pick( options, 'dialog', 'dialogConstructor','dialogBtnConstructor','dialogOptions') );
	        _.bindAll( this, '_closeDialog', '_showDialog' ); /* jqEvent callbacks from body / edit btn view -- bind to here for easier unbinding */
	
	    },
	
	
	    /**
	     * A continuation of base selection.
	     * Must catch at level of inheritance desired -- can't call _super on
	     */
	    onAfterButtonSetCreation: function() {
	        ShapeView.prototype.onAfterButtonSetCreation.apply(this, arguments);
	        this.btnSet.addBtn('edit', this.dialogBtnConstructor);
	        this._toggleEditBtnHandle(1);
	    },
	
	    //( Opposite of onAfterButtonSetCreation )
	    _destroySelectSet: function() {
	
	        ShapeView.prototype._destroySelectSet.call(this, arguments);
	        this._closeDialog({
	            fromDestroySelectSet: true
	        });
	
	    },
	
	    /**
	     * Note: don't want to use the dropdown plugin
	     * ability to have this and other dropdowns / views open (note view).
	     * Have separate 'body' click event to handle separately -- a number of its triggers on the canvas/shapes will prevent propagation
	     * (Separate Btn and Body Handlers B/C on start, only allow open via button (not, body click)
	     */
	    _toggleEditBtnHandle: function(turnOn) {
	
	        this._getEditBtn()
	            .off('click', this['_' + (turnOn ? 'close' : 'show')  + 'Dialog'])
	            .on ('click', this['_' + (turnOn ? 'show'  : 'close') + 'Dialog']);
	
	    },
	    _showDialog: function(e) {
	
	        if (e) {
	            e.stopPropagation(); // don't allow to hit body
	        }
	
	        $('body')
	            .off('click', this._showDialog)
	            .on('click',  this._closeDialog);
	
	        this._toggleEditBtnHandle(0);
	        this.trigger( 'shapeWithDialog:beforeOpen' );
	
	        this.shapeModel.trigger('canvas:zoneDialogOpened'); // ( now sole purpose is closed corresponding F&R dialog )
	
	        this.dialogView = this._createDialog();
	        this.dialogView.triggerMethod('show'); // mimic Marionette onShow used for Regions ( here it would be in DOM )
	
	    },
	
	    /**
	     * Remove the dialog under the following conditions.
	     * Inline dropdowns, allow clicks on the body.
	     * Note: the propagation of the event is often stopped from mouse events on the canvas/canvas shapes.
	     * Mouse events can also come from moving/resizing the shape on the canvas.
	     */
	    _closeDialog: function(e) {
	
	        // Always turn on click -- for button, may have already been deleted from destroy select set
	        $('body').off('click', this._closeDialog);
	
	        // From click (this check fixes issue of clicking another shape ---
	        // that will have already destroyed the select set
	        if (e && !e.fromDestroySelectSet) {
	
	            e.stopPropagation();
	
	            // Instead of messing with complex drawing event propagation: disallow those starting from certain node types
	            // Allow to Resize, move, etc ... without closing the dialog
	            // I is scale button, SPAN toggle FS -- only do if SVG? -- 'SHAPE' is IE8 ???
	            // DVBC-1824: is this still desired? -- dialog not closed for signature with click on another shape ...
	            var node = e.target.nodeName.toUpperCase(); // (allow edit btn)
	            if ( _.contains(['PATH', 'CIRCLE', 'DIV', 'INPUT', 'I', 'SPAN', 'SHAPE'], node) ) {
	                return;
	            }
	            this._toggleEditBtnHandle(1); // btn set should exist
	        }
	
	        this._removeDialog();
	
	    },
	
	    /* Create, render ,and append to DOM */
	    _createDialog: function() {
	
	        var $wr = $(this.channel.request('viewerContainer')), /* don't cache the dom reference */
	            dialog = new HoverEditDialog({
	
	                parent: this,
	                $opener: $(this.btnSet.getView('edit').getTransparentPathEl()),
	                dialogConstructor: this.dialogConstructor,
	                dialogOptions: this.dialogOptions
	
	            }).render(); // render is like 'start now
	
	        $wr.append( dialog.$el );
	
	        return dialog;
	    },
	
	    /* remove and turn off the body handler */
	    _removeDialog: function() {
	
	        // Only do if the dialog was actually created ( this could be called from elsewhere, eg deleteShape without dialog )
	        if ( this.dialogView ) {
	
	            this.trigger( 'shapeWithDialog:beforeClose' );
	            this.dialogView.destroy();
	            this.dialogView = null; // ( also a flag that it was opened )
	        }
	
	    },
	    _getEditBtn: function() {
	        return $(this.btnSet.getView('edit').getTransparentPathEl());
	    }
	
	
	
	});
	


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(214);
	
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	var instVars = {
	
	    parent: null,
	    $opener: null, // Note: this can be null in the case of full page redactions
	
	    ChildViewConstructor: null,
	    childView: null,
	    childViewOptions: null,
	
	    //cached value of the height of the button opener used in setPostion
	    _openerHt: null,
	    _openerWt: null,
	
	    // cache values when put in DOM -- assumes view dimensions are static
	    height: null,
	    width: null
	
	};
	
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: false,
	
	    className: 'shape-hover-edit-dialog',
	
	    initialize: function(options) {
	
	        var $opener = options.$opener;
	
	        _.extend( this, instVars, _.pick( options, 'parent', '$opener' ), {
	            _openerHt: $opener ? parseInt( $opener.attr('height') ) : 0,
	            _openerWt: $opener ? parseInt( $opener.attr('width') ) : 0
	        });
	
	        /* init the child view */
	        this.ChildViewConstructor = options.dialogConstructor;
	        this.childViewOptions = options.dialogOptions;
	
	        this.childView = new this.ChildViewConstructor(
	            this.childViewOptions
	        );
	
	        this.bindEntityEvents( this.parent, this.parentSubs );
	
	        _.bindAll(this, '_setPosition' );
	        $(window).on( 'resize scroll', this._setPosition );
	
	    },
	
	    // Really render the childView and attach the childView
	    // Since el is the only region, don't need a LayoutView ( could be a region )
	    onRender: function() {
	
	        this.$el.append( this.childView.render().el );
	
	    },
	    /* Called after render from parent and after appended to DOM */
	    onShow: function() {
	
	        this.height = this.$el.outerHeight();
	        this.width = this.$el.outerWidth();
	        this._setPosition();
	
	        /* Forward to childView */
	        this.childView.triggerMethod('show');
	
	    },
	
	    parentSubs: {
	        'shape.toggleFadeDialog':               '_fadeToggleDialog',
	        'shape.buttonSet.postMove':             '_setPosition', // (position after placement of $opener)
	        'shape.repositionShapeDialog':          '_setPosition' // overflow scroll, side panel move, side panel open/close, toggle full screen
	    },
	
	    events: {
	        'click'                     : '_stopPropagation',    //body now has onclick event...
	        'mouseup'                   : '_stopPropagation'
	    },
	    /* dir must be: In or Out */
	    _fadeToggleDialog: function(dir, duration) {
	        this.$el['fade' + dir](duration);
	    },
	
	    /* Move, Scale, Scroll -- should also be window resize, viewer panel moving, etc */
	    _setPosition: function() {
	
	        if (!this.$opener)
	            return;
	
	        var $win = $(window),
	            $oOffset = this.$opener.offset();
	
	        var top = $oOffset.top + this._openerHt - $win.scrollTop(),
	            left = $oOffset.left - $win.scrollLeft();
	
	        // flip the dialog if its bottom exceeds the bottom of the browser window
	        if ( top + this.height > $win.height() ) {
	            top -= this.height + this._openerHt;
	            left += !this.parent.btnSet.isFlippedHorizontally // quick hack, should really get from a shape model or something ..
	                ? this._openerWt
	                : (-1 * this.width);
	        }
	
	        this.$el.css({
	            top: top,
	            left: left
	        });
	
	    },
	    _stopPropagation: function(e) {
	
	        e.stopImmediatePropagation();
	
	    },
	    onBeforeDestroy: function() {
	
	        this.childView.destroy();
	
	        $(window).off('resize scroll', this._setPosition);
	        this.unbindEntityEvents(this.parent, this.parentSubs);
	
	    }
	
	});

/***/ },
/* 214 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var ShapeView = __webpack_require__(181);
	
	
	module.exports = ShapeView.extend({
	
	    shapeSubs: _.extend( {}, ShapeView.prototype.shapeSubs, {
	        'shape.onAfterBaseScale': 'resetGlow'
	    }),
	
	    /* 
	    * This is the change of color from the graphic note toolbar color picker.
	    * Note: shouldn't need to worry about 'derived' colors here -- picker would be disabled if they are applied.
	    * This should happen the other way around (change model attr for 'color', then change the color in the view ) ...
	    * maybe put color on the UI model
	    * */
	    onChangeColor: function( color ) {
	
	        this.shapeModel.setZoneColor( color );
	        this.el.setStrokeAndFill(color);
	
	    },
	
	    // Just change the color in the UI
	    noteConsultGroupChange: function() {
	        this.el.setStrokeAndFill( this.getColorToApply() );
	    },
	
	    onChangeStrokeWidth: function(width) {
	        this.el.attr({'stroke-width': width});
	    },
	
	    makeExpandedVisibleIndicator: ShapeView.prototype._createGlow
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/* Cufon generated fonts already registered with Raphael */
	
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(219);
	
	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49);
	
	
	
	module.exports = Backbone.Model.extend({
	
	    /**
	     * Possible font families from which to choose.
	     * Note -- the actually css @font-face styles are all suffixed with 'regular' --
	     * in cufon generator this was removed for this js files
	    */
	    fonts: [
	        'handlee',
	        'pacifico',
	        'yellowtail'
	    ],
	
	    /** Default color now defined on signature note model */
	    defaults: {
	        activeFont: 'handlee',
	        baseFontSize: '36px',
	        showBottomText: false,
	        cursor: 'pointer' // always selected when created
	    },
	
	    /* used in template */
	    fontNamesHash: function() {
	        return _.object( this.fonts, this._getStyleSheetFontNames() );
	    },
	
	    _getStyleSheetFontNames: function() {
	
	        return _.map( this.fonts, function( fname ) {
	            return fname + 'regular';
	        });
	
	    }
	});

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael) {/*!
	 * The following copyright notice may not be removed under any circumstances.
	 * 
	 * Copyright:
	 * Copyright (c) 2011, Admix Designs (http://www.admixdesigns.com/) with Reserved
	 * Font Name Handlee.
	 * 
	 * Trademark:
	 * Handlee is a trademark of Admix Designs (www.admixdesigns.com)
	 * 
	 * Manufacturer:
	 * Joe Prince
	 * 
	 * Designer:
	 * Joe Prince
	 * 
	 * Vendor URL:
	 * http://www.admixdesigns.com/
	 * 
	 * License information:
	 * http://scripts.sil.org/OFL
	 */
	Raphael.registerFont({"w":968,"face":{"font-family":"handlee","font-weight":400,"font-stretch":"normal","units-per-em":"2048","panose-1":"2 0 0 0 0 0 0 0 0 0","ascent":"1638","descent":"-410","cap-height":"37","bbox":"-188.37 -1655.39 2020 521.385","underline-thickness":"102","underline-position":"-613","unicode-range":"U+0020-U+007E"},"glyphs":{" ":{"w":462},"!":{"d":"230,61v-43,0,-124,-44,-124,-86v0,-84,57,-123,150,-120v44,0,100,40,100,92v0,53,-78,114,-126,114xm184,-1391v0,-57,144,-83,144,-14v0,403,-16,705,-31,907v-4,50,-141,85,-141,13v0,-202,28,-503,28,-906","w":477},"\"":{"d":"109,-1368v-5,-42,47,-72,92,-72v44,0,66,79,65,236r1,84v-4,72,-13,119,-95,119v-35,0,-53,-14,-53,-43v1,-112,3,-223,-10,-324xm403,-1047r0,-335v-4,-66,144,-83,144,-11r0,336v3,66,-144,88,-144,10","w":663,"k":{".":231}},"#":{"d":"1133,-418v2,92,-234,53,-302,41v-22,117,-50,228,-81,332v-9,28,-42,43,-101,43v-22,0,-33,-5,-33,-16v0,-53,87,-297,89,-355v-87,7,-186,18,-295,35v-33,107,-62,209,-78,307v-5,28,-57,49,-86,49v-31,0,-47,-10,-47,-30v-1,-72,56,-231,80,-312v-87,9,-203,32,-203,-26v0,-47,64,-48,108,-54v25,-4,96,-1,119,-4v35,-111,59,-188,70,-231v-85,22,-172,34,-241,17v-34,-21,-26,-46,26,-56v45,-9,193,-30,235,-39r51,-231v3,-39,49,-60,86,-60v31,0,46,11,48,33v5,53,-42,199,-50,230v79,-12,159,-20,240,-25v9,-75,24,-151,37,-229v6,-39,122,-68,131,-17v-11,53,-24,135,-41,244v151,4,227,15,227,33v0,38,-45,51,-135,51v-22,0,-89,-5,-104,-6r-37,235v4,1,31,2,82,2v137,0,205,13,205,39xm434,-422v130,-17,225,-27,285,-31r37,-241v-75,1,-158,10,-248,26v-22,82,-47,164,-74,246","w":1218,"k":{"7":63,"3":23,"2":35,"1":41}},"$":{"d":"600,358v-1,30,-84,51,-106,27v3,-207,5,-362,8,-465v-191,-1,-341,-41,-445,-127v-2,-16,89,-49,107,-49v14,0,26,1,33,6v84,59,185,96,305,107r8,-535v-101,-52,-179,-104,-234,-154v-116,-104,-106,-299,11,-407v65,-59,139,-105,229,-131r2,-223v3,-27,80,-50,105,-29r0,236v115,0,217,47,307,141v13,45,-87,73,-131,51v-51,-53,-109,-88,-176,-104v-3,243,-5,426,-7,548r160,84v28,17,130,77,150,104v69,61,162,216,68,322v-88,98,-229,124,-388,154xm516,-1300v-86,14,-186,138,-186,243v0,82,61,163,182,244v0,-109,1,-272,4,-487xm608,-143v129,-3,294,-76,287,-181v-9,-152,-188,-248,-281,-301","w":1103},"%":{"d":"312,-842v-147,-7,-240,-58,-240,-210v0,-145,202,-253,332,-253v129,0,229,58,229,185v0,122,-191,284,-321,278xm360,-1241v-97,0,-158,82,-159,169v0,84,46,144,131,144v82,0,174,-85,172,-168v-3,-91,-46,-145,-144,-145xm207,94v82,-134,227,-353,435,-656v208,-303,367,-552,476,-747v8,-41,130,-46,133,0v-253,463,-619,953,-915,1401v-24,36,-117,48,-129,2xm1114,6v-101,0,-182,-86,-182,-182v0,-177,85,-266,254,-266v118,0,252,74,252,194v0,126,-184,254,-324,254xm1180,-371v-91,1,-119,76,-119,170v0,67,50,131,113,131v65,0,135,-86,135,-160v0,-79,-54,-141,-129,-141","w":1505},"&":{"d":"424,-61v0,37,-105,64,-129,34v-12,-150,-18,-252,-19,-305v-90,-21,-180,-86,-180,-182v0,-69,40,-131,119,-186v-119,-62,-75,-229,39,-279v-26,-97,-25,-190,12,-285v13,-20,93,-31,127,-24v-36,91,-37,180,-10,270v74,0,111,12,111,35v1,28,-47,60,-78,59v-75,-2,-135,14,-135,90v0,45,43,68,81,72v55,6,82,15,82,29v1,45,-65,70,-110,61v-60,7,-101,69,-101,138v0,73,90,124,161,124v72,0,139,-57,203,-57v29,0,44,9,44,27v-2,61,-168,112,-233,118v1,31,16,118,16,261","w":692,"k":{"Y":39,"V":25,"T":41}},"'":{"d":"246,-936v0,40,-58,60,-99,51v-22,-5,-32,-18,-32,-39v0,-136,30,-270,30,-407v0,-29,43,-50,88,-51v26,0,40,11,43,34v-21,137,-31,274,-30,412","w":380,"k":{"q":20,"p":23,"o":16,"g":23,"e":39,"d":47,"c":31,"a":37,"J":160,"A":33,"@":59,"\/":133,".":190}},"(":{"d":"561,121v-5,34,-97,72,-129,35v-423,-485,-467,-1165,-113,-1729v12,-19,37,-29,73,-29v46,1,64,6,48,31v-344,548,-302,1207,113,1675v5,5,8,11,8,17","w":561,"k":{"{":47,"y":43,"w":39,"v":57,"u":45,"t":45,"r":31,"q":33,"o":39,"n":29,"m":20,"g":35,"f":35,"e":37,"d":29,"c":37,"b":23,"X":-12,"W":31,"U":41,"Q":49,"O":49,"G":47,"E":23,"C":45,"B":27,"9":57,"8":29,"7":29,"6":41,"4":55,"1":37,"0":39,"(":37}},")":{"d":"49,-1587v-6,-24,89,-44,107,-43v12,0,20,3,24,10v297,551,302,1210,-10,1749v-13,22,-99,46,-129,25v307,-542,307,-1196,8,-1741","w":487},"*":{"d":"530,-913v0,21,-36,35,-60,33v-14,-1,-20,-4,-21,-11r-23,-225v-63,61,-112,129,-188,179v-38,25,-67,37,-94,7v-10,-11,-10,-26,1,-37v59,-60,183,-157,261,-223v-98,-77,-186,-135,-267,-168v-36,-14,-28,-32,-1,-52v64,-48,139,15,184,45r98,67v-3,-76,-26,-211,66,-205v50,3,19,178,16,227r74,-62v49,-36,123,-100,187,-100v62,0,34,31,-2,58v-36,28,-205,133,-231,168v8,7,36,28,84,65v108,83,162,132,162,146v0,31,-13,47,-39,47v-71,0,-194,-82,-225,-150","w":905,"k":{"x":-12,"t":-47,"q":33,"p":35,"o":29,"g":33,"e":53,"d":57,"c":41,"a":47,"Z":-37,"X":-23,"T":-88,"J":162,"A":35}},"+":{"d":"346,-915v-1,-36,67,-59,106,-58v24,0,35,6,35,19r5,391v34,-4,138,-24,313,-41v82,-8,68,83,10,98v-118,30,-261,37,-323,45v-3,151,-6,265,-13,342v-3,31,-63,48,-103,46v-25,-1,-38,-9,-38,-25r12,-351v-78,3,-280,23,-287,-28v-9,-68,106,-81,181,-78r106,4v-3,-164,-4,-285,-4,-364","w":929,"k":{"7":82,"3":39,"2":49,"1":51}},",":{"d":"39,506v-50,40,-155,-5,-86,-55v122,-88,178,-227,178,-406v0,-86,-63,-240,66,-240v44,0,65,65,65,195v0,224,-77,390,-223,506","w":374,"k":{"j":-16}},"-":{"d":"914,-516v-199,61,-508,14,-726,14v-38,0,-57,-7,-57,-22v-9,-30,86,-86,133,-86v206,0,491,29,658,-8v42,0,63,11,63,32v0,30,-23,55,-71,70","w":1116,"k":{"z":96,"x":18,"v":23,"s":23,"k":16,"f":53,"Z":59,"Y":143,"X":106,"V":57,"T":160,"S":37,"M":16,"J":141,"8":39,"7":109,"5":29,"3":66,"2":80,"1":76}},".":{"d":"226,61v-47,0,-124,-44,-124,-94v0,-52,83,-110,138,-110v58,0,112,38,112,93v0,50,-79,111,-126,111","w":462,"k":{"v":68,"f":31,"Y":98,"V":115,"U":41,"T":147,"Q":43,"O":37,"G":29,"C":27,"9":102,"7":47,"4":45,"1":63,"'":190,"\"":231}},"\/":{"d":"84,268v-29,-1,-45,-3,-33,-16v121,-227,255,-536,403,-928v148,-392,268,-681,359,-870v12,-26,48,-39,109,-39v25,0,37,7,32,18v-89,189,-211,479,-358,871v-147,392,-280,701,-403,927v-14,26,-52,37,-109,37","w":1005,"k":{"z":45,"y":57,"x":39,"w":76,"v":29,"u":66,"s":72,"r":45,"q":88,"p":86,"o":82,"n":55,"m":72,"g":84,"e":94,"d":80,"c":88,"a":92,"W":23,"Q":41,"O":45,"J":115,"G":47,"D":25,"C":51,"A":63,"8":29,"6":61,"5":31,"4":33,"2":25,"0":37,"\/":449}},"0":{"d":"420,-1373v437,-195,810,241,799,666v-8,282,-134,514,-318,641v-105,72,-223,111,-357,111v-134,0,-241,-60,-318,-181v-77,-121,-116,-304,-116,-548v0,-244,53,-434,158,-569v38,-49,87,-91,152,-120xm319,-1090v-97,243,-82,591,-3,825v32,94,116,208,239,206v226,-2,386,-179,457,-353v81,-196,86,-390,-4,-576v-73,-151,-228,-321,-426,-321v-136,0,-220,110,-263,219","w":1318,"k":{"}":37,"]":53,"\\":39,"Z":33,"Y":33,"X":27,"T":39,"7":23,"2":37,"\/":59,".":47,")":35}},"1":{"d":"35,-1194v-10,-71,238,-195,319,-195v123,0,184,149,185,447v0,137,-13,429,-45,876v-3,39,-116,82,-140,35v-13,-215,29,-741,27,-964v-4,-322,-46,-344,-213,-199v-20,30,-127,42,-133,0","w":692,"k":{"\/":35}},"2":{"d":"1051,-25v-27,0,-557,-100,-607,-86v-67,0,-122,4,-165,13v-45,38,-111,112,-189,112v-37,0,-55,-13,-55,-39v2,-102,95,-149,184,-176v154,-151,258,-258,311,-321v162,-194,242,-385,242,-574v0,-124,-75,-186,-225,-186v-89,0,-177,25,-268,70v-39,19,-95,-10,-95,-50v0,-31,48,-61,144,-88v96,-27,184,-41,267,-41v171,1,316,116,316,304v0,275,-166,563,-497,864v141,-9,504,58,678,91v22,3,34,14,34,32v0,42,-45,75,-75,75","w":1163,"k":{"\\":55,"Y":37,"V":35,"U":23,"T":35,"Q":23,"O":20,"=":43,"9":31,"4":41,"2":-16,"-":63,"+":23,"'":27}},"3":{"d":"965,-430v7,231,-272,445,-504,438v-150,-4,-290,-82,-371,-170v-5,-5,-8,-11,-8,-18v0,-34,97,-89,133,-49v76,83,168,127,283,127v158,0,313,-118,313,-291v0,-186,-224,-305,-395,-205v-34,20,-90,-10,-90,-45v0,-19,10,-34,30,-43v284,-138,426,-275,426,-410v0,-105,-112,-137,-227,-137v-115,0,-218,22,-307,72v-38,21,-113,-6,-113,-41v0,-27,58,-60,175,-98v117,-38,218,-58,303,-58v165,0,307,80,307,248v0,138,-92,266,-275,385v156,26,315,127,320,295","w":1073,"k":{"]":29,"\\":23,"\/":43,")":23}},"4":{"d":"1051,-598v0,83,-143,63,-220,66r16,448v-2,14,-10,48,-22,55v-21,12,-46,21,-75,21v-29,0,-43,-6,-43,-17v0,-149,-6,-317,-17,-505v-106,-11,-268,2,-385,2v-169,0,-254,-18,-254,-54v0,-3,1,-6,2,-10v65,-194,110,-349,134,-466v24,-117,50,-195,77,-236v34,-54,94,-77,146,-46v10,10,11,21,6,33v-44,91,-88,219,-130,383v-42,164,-68,261,-77,291r477,4v-22,-241,2,-430,6,-665v1,-31,69,-50,106,-49v24,0,36,5,36,16v0,26,-4,101,-10,227v-9,202,-16,314,1,469v53,-3,100,-10,158,-6v45,3,68,16,68,39","w":1114,"k":{"}":33,"]":37,"\\":43,"Z":23,"Y":37,"V":23,"T":25,"J":23,"7":31,"3":23,"2":25,"1":23,"\/":49,".":33,")":33,"'":25}},"5":{"d":"354,-1233v32,161,30,313,-30,473v301,-33,592,-26,728,146v34,44,50,94,50,153v0,120,-58,224,-166,319v-160,141,-507,189,-716,70v-77,-45,-125,-112,-144,-202v3,-44,115,-87,139,-37v27,135,187,209,352,209v231,0,410,-155,410,-363v0,-133,-163,-199,-490,-199r-262,11v-38,0,-74,-16,-58,-59v18,-48,57,-372,54,-451r-4,-94v6,-97,45,-78,166,-78r129,0v117,0,255,8,414,8v57,0,99,31,66,75v-13,17,-34,25,-60,25r-465,-8v-45,0,-83,1,-113,2","w":1183,"k":{"]":20,"\/":39}},"6":{"d":"909,-700v121,0,234,125,228,260v-8,181,-198,328,-347,392v-177,75,-356,91,-497,-18v-221,-171,-232,-534,-107,-820v56,-128,133,-237,234,-324v101,-87,211,-131,330,-131v45,0,67,16,67,47v0,39,-61,63,-108,63v-207,0,-345,213,-406,389v-62,180,-75,383,-18,549v75,-93,174,-184,297,-273v123,-89,232,-134,327,-134xm1006,-444v3,-72,-45,-123,-113,-123v-171,0,-464,279,-539,383v113,100,211,104,363,36v110,-49,284,-161,289,-296","w":1189,"k":{"}":39,"]":53,"\\":66,"Y":57,"V":37,"T":59,"7":63,"1":45,"\/":31,")":23,"'":57}},"7":{"d":"573,-1235v-88,0,-345,33,-435,33v-53,0,-79,-10,-79,-31v1,-56,61,-74,123,-74v82,1,376,-42,470,-39v131,4,282,72,282,216v0,49,-30,129,-84,241r-401,836v-12,26,-44,39,-95,39v-44,0,-56,-24,-41,-56v93,-209,207,-442,344,-698v46,-87,138,-250,138,-348v0,-79,-74,-119,-222,-119","w":995,"k":{"J":82,"A":25,"=":23,"\/":102,".":117,"-":59,"+":37,"#":37}},"8":{"d":"115,-962v0,-242,321,-450,573,-441v129,5,269,50,362,113v110,74,109,166,45,274v-28,48,-72,96,-128,144v-89,77,-200,156,-334,239r190,113v94,57,171,112,234,194v84,111,34,197,-111,256v-100,42,-221,62,-364,62v-302,0,-453,-77,-453,-230v0,-60,25,-119,75,-176v50,-57,125,-121,224,-190v-209,-120,-313,-240,-313,-358xm643,-1296v-207,0,-394,104,-387,309v6,178,146,228,285,307v176,-120,290,-204,342,-252v79,-74,118,-141,118,-201v0,-98,-263,-163,-358,-163xm348,-408v-81,103,-105,205,23,265v116,55,339,47,473,12v138,-36,131,-102,45,-182v-75,-70,-244,-171,-375,-244v-67,44,-122,93,-166,149","w":1228,"k":{"=":20,"\/":37,"-":51}},"9":{"d":"311,-567v-163,0,-248,-105,-248,-281v0,-228,186,-502,402,-502v202,0,393,114,393,312v0,342,12,766,-16,999v-3,26,-31,39,-86,39v-33,0,-52,-10,-56,-31v29,-150,29,-498,25,-731v-130,130,-268,195,-414,195xm453,-1260v-131,-19,-252,281,-252,398v0,124,59,195,164,203v144,11,362,-228,362,-365v0,-90,-172,-248,-274,-236","w":1032,"k":{"]":23,"\\":37,"Y":27,"T":31,"\/":27,")":20}},":":{"d":"215,-86v-47,0,-86,-27,-86,-73v0,-44,84,-105,129,-103v50,2,96,23,96,74v0,48,-95,102,-139,102xm253,-653v-57,0,-95,-55,-95,-109v0,-55,30,-88,90,-92v58,-4,123,31,123,90v0,56,-62,111,-118,111","w":501,"k":{"Y":80,"V":37,"T":150}},";":{"d":"59,176v0,-22,11,-35,33,-39v125,-27,124,-174,121,-327v-1,-49,126,-64,127,-11v0,151,-16,254,-49,307v-42,68,-103,119,-193,119v-26,0,-39,-16,-39,-49xm362,-819v1,63,-104,97,-172,96v-41,0,-61,-20,-61,-59v0,-74,48,-111,143,-111v45,0,89,37,90,74","w":499},"<":{"d":"903,-126v0,32,-70,77,-121,60v-122,-41,-293,-139,-376,-206v-70,-57,-233,-210,-322,-294v-39,-37,-24,-31,14,-76v27,-32,305,-222,335,-248r129,-114v42,-38,122,-92,182,-92v66,0,71,44,36,78v-14,15,-69,53,-162,117v-257,176,-385,276,-385,295v-6,21,61,68,93,96r172,148v94,80,247,177,374,212v21,7,31,14,31,24"},"=":{"d":"160,-754v0,-37,47,-59,138,-76v121,-23,509,-26,622,-34v104,-7,81,89,12,119v-34,14,-134,25,-304,25v-187,-1,-294,12,-392,28v-38,-5,-76,-21,-76,-62xm1081,-453v0,34,-65,85,-110,86v-185,4,-772,24,-776,-41v-2,-37,66,-81,108,-81r727,8v34,0,51,9,51,28","w":1232,"k":{"7":88,"3":45,"2":55,"1":59}},">":{"d":"61,-1014v0,-26,58,-72,97,-63v318,72,524,300,739,485v16,27,0,31,-33,65v-70,72,-300,246,-401,339r-61,54v-36,31,-124,91,-181,91v-66,0,-70,-43,-35,-77v14,-15,67,-57,158,-126v258,-194,387,-300,387,-319v6,-22,-59,-71,-92,-97v-203,-159,-295,-250,-547,-327v-21,-7,-31,-15,-31,-25"},"?":{"d":"96,-1346v90,-53,212,-79,365,-79v187,0,305,28,344,90v56,90,28,179,-33,285v-82,143,-189,243,-274,382v-42,69,-68,126,-68,172v0,58,-139,96,-139,19v0,-245,230,-391,333,-571v38,-66,58,-121,58,-166v0,-45,-19,-76,-56,-92v-37,-16,-104,-25,-202,-25v-98,0,-180,20,-248,61v-42,43,-154,-33,-80,-76xm500,-130v0,56,-92,105,-152,105v-110,0,-87,-107,-38,-154v59,-57,190,-48,190,49","w":901},"@":{"d":"553,340v-302,-2,-467,-207,-463,-531v4,-265,92,-576,268,-708v143,-107,332,-106,454,31v106,118,196,322,196,512v0,143,-58,253,-199,252v-68,0,-114,-40,-139,-121v-51,109,-124,164,-219,164v-75,0,-113,-51,-113,-153v0,-180,119,-383,283,-380v74,1,135,65,135,161v0,57,8,109,26,159v18,50,39,75,62,75v39,0,54,-54,53,-104v0,-130,-35,-261,-105,-395v-70,-134,-144,-201,-223,-201v-68,0,-128,37,-186,103v-185,211,-263,801,-15,1001v59,48,130,74,216,74v61,0,136,-35,211,-35v18,0,27,7,26,20v-4,55,-200,77,-268,76xm662,-489v-127,-86,-206,137,-208,246v-3,134,60,83,101,13v34,-58,80,-212,107,-259","w":1073,"k":{"Y":90,"V":51,"T":150,"'":33}},"A":{"d":"78,-4r40,-337v6,-50,16,-113,28,-189v45,-277,107,-513,228,-711v76,-124,220,-228,380,-227v100,0,180,39,248,114v135,149,191,433,233,676v22,125,40,255,59,386v19,131,39,225,60,282v-27,38,-72,53,-127,41v-53,-86,-80,-434,-99,-537v-149,-5,-297,-8,-446,-8v-149,0,-282,6,-399,18v-20,80,-58,397,-72,476v-46,35,-86,48,-133,16xm303,-602v261,-31,545,-27,811,-10v-5,-21,-15,-70,-30,-146v-32,-157,-55,-254,-110,-389v-47,-114,-112,-213,-253,-213v-151,0,-257,171,-307,307v-59,163,-96,313,-111,451","w":1421,"k":{"y":14,"x":10,"w":14,"v":31,"u":14,"t":18,"r":14,"q":10,"o":10,"n":12,"m":10,"l":14,"k":10,"j":12,"i":12,"h":12,"g":10,"f":27,"e":10,"c":10,"b":14,"\\":61,"Y":74,"V":41,"U":14,"T":78,"?":20,"7":33,"1":31,"*":31,"'":25}},"B":{"d":"989,-737v161,53,346,142,348,338v0,87,-37,165,-112,231v-144,127,-367,190,-668,191v-251,0,-376,-50,-377,-150r-16,-1198v0,-87,177,-131,530,-131v167,0,306,31,419,94v113,63,169,153,169,270v0,161,-158,326,-293,355xm737,-780v119,6,418,-167,418,-283v0,-87,-56,-153,-164,-208v-181,-92,-494,-97,-684,-32r6,572v121,-50,261,-57,424,-49xm317,-608v4,163,6,328,7,495v218,50,471,26,648,-37v109,-38,216,-118,216,-249v0,-119,-128,-205,-385,-260v-173,48,-309,68,-486,51","w":1425,"k":{"}":20,"z":27,"y":10,"x":16,"v":14,"t":16,"s":14,"r":10,"n":10,"k":10,"j":10,"f":16,"]":39,"\\":23,"Z":14,"Y":16,"X":47,"T":61,"J":10,"\/":39}},"C":{"d":"719,12v-345,0,-632,-207,-621,-567v12,-394,190,-678,470,-815v102,-49,212,-74,331,-74v212,0,353,96,422,287v-33,26,-49,55,-97,43v-41,-10,-67,-67,-91,-98v-139,-177,-399,-156,-579,-24v-170,125,-319,363,-321,636v-3,310,238,520,559,520v201,0,399,-73,510,-207v50,-60,86,-98,177,-63v-112,228,-419,362,-760,362","w":1511,"k":{"x":16,"v":20,"t":16,"f":18,"\\":27,"Y":12,"X":70,"W":12,"V":10,"U":10,"T":74,"S":14,"Q":14,"O":14,"G":12,"C":10,"*":27}},"D":{"d":"680,-1456v421,0,780,269,774,678v-6,334,-176,537,-397,661v-155,87,-327,129,-516,129v-113,0,-306,16,-357,-32v-16,-15,-26,-31,-26,-55v0,-155,5,-359,16,-610v11,-251,16,-446,16,-585v0,-56,52,-101,156,-135v104,-34,215,-51,334,-51xm334,-1260v4,168,-33,796,-33,954v0,84,1,144,2,179v510,98,1006,-108,1006,-602v0,-352,-280,-623,-643,-623v-93,0,-203,31,-332,92","w":1550,"k":{"}":37,"w":12,"s":12,"q":14,"p":18,"o":12,"n":10,"m":12,"l":12,"k":16,"j":12,"i":14,"h":12,"g":14,"e":18,"d":14,"c":16,"b":12,"a":20,"]":55,"\\":35,"Z":53,"Y":33,"X":68,"V":12,"T":80,"J":66,"A":10,"?":23,"2":45,"\/":70,".":76,")":37}},"E":{"d":"1088,-131v88,2,138,-7,145,61v-13,80,-119,63,-209,68v-267,15,-439,18,-514,18v-225,0,-338,-31,-338,-94v0,-127,-4,-247,-4,-362v0,-378,12,-693,37,-944v29,-45,112,-69,250,-78v195,-12,351,-2,542,-2v105,0,178,12,217,37v-9,80,-59,95,-149,94r-442,-6v-112,0,-206,3,-283,10v-29,119,-20,375,-23,549v122,22,335,15,490,14v93,0,145,4,159,14v14,10,21,20,21,31v0,52,-66,82,-199,78r-464,-14v-1,33,-3,89,-5,168v-3,165,-9,290,-18,374r208,9v141,2,436,-28,579,-25","w":1290,"k":{"y":37,"x":20,"w":25,"v":61,"u":29,"t":39,"r":29,"q":12,"p":10,"o":18,"n":23,"m":16,"l":16,"g":16,"f":33,"e":14,"d":12,"c":14,"b":14,"W":25,"U":20,"S":12,"Q":53,"O":53,"G":47,"C":47,"9":29,"4":23,"-":43}},"F":{"d":"156,16r0,-129v0,-71,6,-222,18,-453v12,-231,19,-407,19,-526v0,-119,-9,-214,-9,-288v0,-33,34,-56,101,-70v225,-46,467,-18,714,-18v95,0,159,6,218,45v-11,57,-56,89,-136,86r-542,-17v-59,0,-129,3,-211,8v3,149,4,350,4,605v155,-13,285,-21,389,-21v201,0,301,20,301,60v0,77,-88,79,-166,69v-206,-28,-324,-24,-526,-2r-25,479v-13,80,-8,189,-90,189v-18,0,-38,-6,-59,-17","w":1232,"k":{"z":76,"y":96,"x":68,"w":119,"v":51,"u":88,"t":35,"s":100,"r":80,"q":121,"p":139,"o":109,"n":98,"m":115,"l":20,"k":18,"h":12,"g":117,"f":31,"e":133,"d":117,"c":123,"b":16,"a":137,"W":35,"U":18,"S":53,"R":10,"Q":55,"O":63,"J":276,"G":66,"D":16,"C":68,"A":72,"@":61,":":51,"8":33,"6":31,"5":20,"3":29,"2":31,"\/":123,".":123,"-":59,"*":-47,"&":23}},"G":{"d":"804,29v-416,4,-706,-212,-706,-609v0,-497,346,-882,822,-882v186,0,420,89,458,227v-64,55,-147,8,-196,-35v-53,-47,-179,-106,-287,-106v-369,0,-672,393,-672,780v0,329,294,533,613,533v358,0,504,-239,507,-582v-11,-9,-25,-14,-43,-14v-119,-2,-338,34,-442,34v-77,0,-115,-13,-115,-39v0,-30,47,-51,141,-70v140,-28,367,-35,498,-18v68,9,104,10,105,64v9,476,-226,712,-683,717","w":1558,"k":{"f":14,"]":23,"Z":23,"Y":14,"X":45,"T":20,"\/":43,".":31}},"H":{"d":"164,-20v-13,-297,-5,-471,20,-886v17,-281,26,-443,27,-487v21,-37,82,-55,131,-34v22,160,-18,506,-18,665v280,-50,560,-48,831,-26v11,-184,6,-371,-2,-613v25,-44,89,-64,139,-37v9,148,14,295,14,440v0,7,0,15,1,23v1,142,-2,318,-9,529v-7,223,-11,367,-12,432v-48,34,-76,39,-127,26v-25,-221,-2,-458,0,-688v-275,-23,-573,-27,-846,27v-11,271,-16,470,-16,598v-50,40,-81,51,-133,31","w":1476,"k":{"z":14,"y":18,"x":14,"w":18,"v":12,"u":18,"s":18,"r":16,"q":20,"p":20,"o":20,"n":14,"m":14,"l":16,"k":14,"j":14,"i":14,"h":14,"g":20,"e":27,"d":20,"c":25,"b":18,"a":23,"\/":27}},"I":{"d":"256,37v-66,-4,-86,-54,-86,-125v0,-657,7,-1041,14,-1153v7,-112,18,-177,32,-195v32,-39,69,-29,118,-6v-13,617,-21,1099,-23,1446v-21,22,-39,33,-55,33","w":499,"k":{"z":16,"y":18,"x":16,"w":18,"v":14,"u":20,"s":18,"r":16,"q":20,"p":20,"o":23,"n":16,"m":16,"l":16,"k":14,"j":16,"i":16,"h":14,"g":23,"f":10,"e":29,"d":20,"c":25,"b":18,"a":25,"\/":23,"-":16}},"J":{"d":"829,-475v-6,312,-86,480,-397,481v-178,1,-360,-87,-414,-211v57,-49,103,-59,159,-17v54,40,68,84,147,112v44,16,100,26,170,26v70,0,121,-31,150,-92v29,-61,44,-150,44,-266v0,-187,-43,-640,-41,-812v0,-81,9,-132,21,-155v23,-41,70,-36,116,-25v-4,181,48,777,45,959","w":976,"k":{"z":14,"y":18,"x":12,"w":16,"v":10,"u":12,"s":16,"r":16,"q":14,"p":20,"o":14,"n":14,"m":16,"l":16,"k":14,"j":14,"i":14,"h":14,"g":14,"e":16,"d":14,"c":16,"b":16,"a":16,"X":10,"\/":43,".":18}},"K":{"d":"512,-705v-25,9,-156,75,-188,82v0,231,-4,425,-11,582v-25,25,-69,37,-133,37v-3,-41,-5,-134,-4,-281r8,-1120v21,-42,80,-52,140,-41r6,481v0,68,-2,134,-6,199v208,-80,413,-220,536,-359v85,-95,158,-211,231,-294v48,-56,92,-61,150,-21v-130,318,-340,476,-623,674v142,68,284,229,367,356v119,181,230,311,334,390v-23,35,-57,53,-101,53v-44,0,-98,-35,-161,-105v-133,-146,-224,-333,-357,-486v-70,-80,-131,-130,-188,-147","w":1318,"k":{"}":-23,"y":63,"w":45,"v":84,"u":63,"t":76,"r":31,"q":31,"o":41,"n":23,"m":12,"l":33,"h":12,"g":37,"f":45,"e":39,"d":25,"c":37,"b":25,"a":12,"]":-16,"W":25,"U":27,"S":10,"Q":66,"O":70,"G":72,"C":72,"9":33,"4":33,"2":-37,"-":76}},"L":{"d":"184,-6v-16,-313,-7,-1028,0,-1430v35,-27,64,-41,86,-41v37,0,56,27,56,82r-11,908v0,141,4,274,13,399v225,16,428,2,653,0v67,0,100,19,100,57v0,45,-143,68,-430,68v-97,0,-412,-10,-467,-43","w":1095,"k":{"y":55,"w":23,"v":168,"u":53,"t":186,"r":25,"q":16,"o":29,"n":16,"l":33,"h":14,"g":20,"f":61,"e":23,"d":12,"c":23,"b":31,"\\":147,"Y":125,"W":20,"V":174,"U":82,"T":250,"Q":96,"O":84,"G":66,"C":61,"?":29,"9":152,"7":45,"4":117,"2":-23,"1":55,"-":174,"*":193,"'":190,"&":33}},"M":{"d":"156,-1421v0,-29,20,-43,59,-43v39,0,91,39,157,114v130,146,244,348,370,497v130,153,133,155,256,-6v121,-159,225,-373,356,-525v67,-79,120,-119,160,-119v40,0,61,11,61,33v0,501,9,956,0,1443v-27,40,-81,56,-127,31v-8,-168,-12,-366,-12,-594v0,-228,2,-464,6,-708v-143,146,-266,447,-418,602v-129,132,-208,123,-337,-14v-89,-94,-301,-448,-370,-537v7,115,11,234,11,357r-2,259v-1,219,-6,417,-13,596v-26,36,-83,53,-137,37v4,-469,-20,-993,-20,-1423","w":1763,"k":{"z":16,"y":18,"x":14,"w":16,"v":12,"u":18,"s":18,"r":14,"q":20,"p":18,"o":20,"n":14,"m":14,"l":16,"k":14,"j":14,"i":14,"h":14,"g":20,"f":10,"e":25,"d":18,"c":23,"b":16,"a":23,"\/":29}},"N":{"d":"172,-1384v45,-45,93,-48,147,-17v36,21,75,55,119,98v332,335,555,695,832,1143r18,-1270v32,-38,85,-40,127,-20v32,527,-2,954,-2,1475v-81,56,-152,64,-201,-3v-69,-93,-133,-212,-198,-314r-136,-216r-121,-182v-142,-218,-289,-389,-438,-531v7,178,11,369,11,573r0,23v0,197,-4,407,-13,629v-17,25,-62,37,-137,37v0,-771,-3,-1246,-8,-1425","w":1599,"k":{"z":14,"y":18,"x":14,"w":16,"v":12,"u":18,"s":18,"r":14,"q":20,"p":18,"o":20,"n":14,"m":14,"l":16,"k":14,"j":14,"i":14,"h":14,"g":20,"f":10,"e":27,"d":18,"c":25,"b":16,"a":23,"\/":20}},"O":{"d":"792,41v-386,0,-692,-284,-692,-692v0,-464,307,-758,727,-758v404,0,744,244,744,692v0,244,-117,465,-258,574v-158,122,-331,184,-521,184xm821,-1288v-355,3,-585,256,-585,641v0,341,216,579,550,579v372,0,639,-263,639,-626v0,-349,-268,-597,-604,-594","w":1669,"k":{"}":39,"y":10,"w":12,"s":10,"r":10,"q":12,"p":16,"o":10,"n":10,"m":10,"l":10,"k":14,"j":12,"i":12,"h":12,"g":12,"e":14,"d":12,"c":12,"b":10,"a":16,"]":59,"\\":41,"Z":49,"Y":47,"X":66,"V":16,"T":98,"J":33,"?":29,"7":29,"2":39,"\/":61,".":49,")":37}},"P":{"d":"1321,-962v0,445,-561,663,-999,485v-14,112,-8,325,-11,469v-27,35,-71,43,-133,41v-3,-103,-5,-195,-4,-277r6,-415v0,-213,-26,-400,-26,-564v0,-103,99,-156,194,-182v117,-32,246,-45,387,-45v347,0,586,147,586,488xm1171,-968v0,-389,-577,-456,-864,-277v7,89,10,295,10,620v99,66,221,99,359,99v262,0,495,-190,495,-442","w":1374,"k":{"w":18,"s":12,"q":29,"p":31,"o":23,"m":14,"k":10,"i":10,"g":25,"e":35,"d":25,"c":29,"a":35,"Z":23,"X":43,"J":176,"A":14,"@":20,"2":27,"\/":94,".":92,"-":27}},"Q":{"d":"745,-4v-381,0,-648,-278,-645,-643v3,-292,113,-540,286,-685v97,-81,206,-124,329,-124v408,0,780,217,780,651v0,277,-83,488,-248,633v51,46,66,89,141,122v54,24,83,35,87,95v-95,34,-211,-34,-261,-88r-59,-63v-113,68,-250,102,-410,102xm1343,-738v0,-402,-235,-603,-620,-603v-202,0,-347,193,-415,357v-133,322,-40,713,212,819v156,65,406,66,553,-23v-119,-119,-188,-189,-207,-211v-19,-22,-33,-47,-43,-76v15,-11,32,-17,49,-17v59,0,135,52,226,156r69,78v117,-113,176,-274,176,-480","w":1601,"k":{"y":12,"w":14,"s":10,"r":10,"q":14,"p":14,"o":12,"n":10,"m":10,"l":12,"k":12,"j":10,"i":12,"h":12,"g":14,"e":18,"d":12,"c":14,"b":12,"a":14,"\\":37,"Y":33,"X":18,"V":14,"T":80,"J":20}},"R":{"d":"313,-84v2,86,-54,125,-129,102v-59,-399,2,-912,2,-1318v0,-109,146,-164,439,-164v237,0,493,82,610,234v85,111,87,273,19,396v-67,121,-170,189,-300,248v-108,49,-228,82,-360,99v65,37,172,125,319,266v79,75,224,168,373,164v53,-1,160,-41,160,37v0,47,-63,70,-174,69v-135,0,-270,-52,-404,-155v-58,-45,-116,-89,-172,-136v-138,-116,-267,-189,-387,-219v-5,115,1,258,4,377xm324,-1319v3,158,-20,498,-21,631v0,49,1,85,2,108v202,-15,358,-39,469,-71v119,-34,206,-78,266,-127v161,-133,136,-387,-46,-487v-162,-89,-455,-110,-670,-54","w":1419,"k":{"}":-43,"]":-27,"T":70,"2":-66}},"S":{"d":"671,-1374v-219,0,-414,89,-409,297v5,199,200,241,368,291v258,77,566,128,566,456v0,109,-54,201,-161,278v-197,142,-528,148,-773,36v-120,-55,-180,-108,-180,-164v0,-47,80,-82,126,-46v27,21,75,65,103,83v104,65,220,98,348,98v171,0,404,-124,394,-305v-13,-231,-279,-254,-470,-310v-221,-65,-470,-120,-470,-386v0,-352,331,-471,695,-422v164,22,340,81,358,251v6,58,-90,81,-128,47v-11,-10,-20,-27,-30,-47v-51,-105,-164,-157,-337,-157","w":1284,"k":{"z":16,"y":16,"x":18,"w":10,"v":23,"u":10,"t":20,"r":14,"p":10,"n":14,"m":12,"l":12,"k":10,"i":10,"h":10,"f":18,"X":18,"\/":25}},"T":{"d":"616,-1331v-131,-16,-401,18,-530,18v-75,0,-113,-18,-113,-53v0,-65,235,-98,705,-98v108,0,247,4,416,13v169,9,257,21,262,38v-3,61,-59,92,-170,92v-71,0,-267,-20,-347,-20v-53,0,-79,11,-79,34v0,293,-7,731,-21,1313v-29,21,-71,31,-127,31v-1,-60,-3,-132,-2,-215r11,-885v0,-107,-2,-196,-5,-268","w":1320,"k":{"}":-35,"z":262,"y":291,"x":236,"w":295,"v":195,"u":283,"t":100,"s":274,"r":248,"q":289,"p":295,"o":287,"n":285,"m":289,"l":16,"k":68,"i":39,"h":57,"g":287,"f":102,"e":293,"d":287,"c":289,"b":55,"a":289,"]":-66,"\\":-18,"W":16,"S":14,"R":10,"Q":80,"P":12,"O":115,"J":201,"H":10,"G":111,"D":18,"C":117,"A":109,"@":143,"?":-31,":":141,"9":25,"8":35,"6":92,"4":20,"0":33,"\/":129,".":139,"-":150,"*":-55,"&":39}},"U":{"d":"201,-365v-92,-295,-66,-776,2,-1052v43,-25,70,-38,114,-25v17,5,23,20,19,45v-41,271,-62,458,-62,559v0,212,24,336,78,498v50,147,164,269,350,270v120,0,226,-73,316,-220v196,-319,172,-786,-8,-1137v41,-38,77,-43,129,-31v109,157,164,361,164,612v1,311,-143,663,-365,810v-147,98,-351,113,-498,26v-130,-77,-190,-197,-239,-355","w":1404,"k":{"y":12,"w":16,"u":10,"s":14,"r":10,"q":20,"p":25,"o":16,"n":12,"m":14,"l":14,"k":16,"j":12,"i":18,"h":12,"g":18,"e":23,"d":18,"c":20,"b":14,"a":23,"Z":16,"X":45,"J":45,"A":10,"2":20,"\/":66,".":59,")":20}},"V":{"d":"25,-1407v11,-42,74,-61,122,-41v173,388,313,1029,551,1360v75,-22,154,-194,242,-514v66,-240,133,-535,234,-727v47,-90,94,-135,143,-135v19,0,40,5,61,16v-35,34,-72,110,-112,228v-40,118,-78,246,-117,384v-72,255,-148,561,-275,750v-60,90,-123,135,-190,135v-93,0,-198,-157,-319,-471v-63,-164,-112,-293,-145,-388v-33,-95,-71,-210,-114,-346v-43,-136,-70,-220,-81,-251","w":1376,"k":{"z":49,"y":80,"x":41,"w":86,"v":27,"u":86,"t":16,"s":88,"r":59,"q":88,"p":90,"o":92,"n":80,"m":84,"k":10,"g":90,"f":12,"e":102,"d":88,"c":94,"a":96,"]":-43,"W":10,"Q":25,"O":27,"J":113,"G":33,"D":10,"C":37,"A":41,"@":66,":":47,"6":37,"\/":109,".":109,"-":63,"*":-41,"&":20}},"W":{"d":"479,45v-294,0,-342,-283,-342,-604v0,-228,37,-519,111,-873v51,-31,82,-37,133,-24r-55,399v-38,324,-56,593,16,843v26,92,83,175,186,175v63,0,119,-34,167,-103v183,-265,187,-785,294,-1120v52,-36,75,-44,127,-30v18,137,35,622,62,760v35,181,67,314,176,410v101,90,261,94,338,-26v117,-182,143,-525,143,-811v0,-195,-16,-347,-49,-456v72,-50,129,-58,168,31v53,121,66,360,66,514v0,341,-83,660,-286,812v-113,84,-291,107,-418,32v-107,-64,-153,-135,-202,-263v-35,-94,-65,-214,-90,-360v-57,201,-105,340,-145,416v-96,184,-230,278,-400,278","w":2144,"k":{"z":10,"y":16,"w":23,"u":14,"s":20,"r":14,"q":23,"p":29,"o":20,"n":16,"m":20,"l":18,"k":20,"j":12,"i":16,"h":16,"g":23,"e":27,"d":23,"c":25,"b":16,"a":27,"Z":12,"X":27,"J":37,"A":12,"\/":63,".":51}},"X":{"d":"1333,-20v-2,33,-58,54,-96,53v-45,0,-100,-42,-171,-118v-88,-94,-322,-446,-388,-533v-150,187,-270,484,-479,619v-65,42,-121,58,-199,50v206,-237,443,-520,598,-772v-108,-147,-360,-414,-464,-544v-46,-57,-68,-96,-68,-117v0,-43,55,-60,96,-60v34,0,77,33,129,98v52,65,115,150,189,256v74,106,138,187,194,244v70,-113,154,-294,226,-426v52,-95,131,-231,280,-190v-121,239,-261,477,-420,715v147,216,391,502,573,725","w":1316,"k":{"}":-29,"y":45,"w":27,"v":94,"u":45,"t":82,"r":18,"q":16,"o":25,"n":10,"l":33,"h":10,"g":18,"f":49,"e":20,"d":12,"c":20,"b":27,"]":-33,"W":25,"U":39,"Q":57,"O":61,"G":61,"C":59,"9":47,"4":41,"2":-51,"-":74,"'":20}},"Y":{"d":"397,29v52,-107,173,-445,232,-551v-190,-203,-335,-381,-437,-534v-102,-153,-153,-270,-153,-351v0,-30,46,-53,80,-51v21,0,38,11,53,34v44,72,83,181,132,272v86,161,237,356,384,497r134,-343v16,-40,37,-91,64,-151v49,-109,67,-139,130,-215v54,-65,122,-95,213,-68v-52,30,-115,127,-193,287v-148,304,-262,682,-410,974v-71,141,-128,212,-171,212v-18,0,-37,-4,-58,-12","w":1222,"k":{"}":-23,"z":102,"y":143,"x":86,"w":147,"v":63,"u":152,"t":33,"s":178,"r":100,"q":162,"p":166,"o":152,"n":137,"m":152,"l":12,"k":14,"h":10,"g":156,"f":25,"e":184,"d":154,"c":168,"b":10,"a":176,"]":-39,"W":18,"S":12,"R":14,"Q":57,"P":14,"O":70,"J":160,"H":14,"G":78,"E":12,"D":23,"C":78,"A":76,"@":104,":":88,"8":27,"6":63,"5":23,"4":27,"0":33,"\/":135,".":158,"-":123,"*":-68,"&":41}},"Z":{"d":"1122,-1448v60,-1,135,19,101,72v-209,328,-678,899,-987,1296v327,20,720,-24,1046,0v-8,69,-69,102,-184,105r-774,22v-181,0,-272,-22,-273,-67v0,-12,7,-25,17,-41v176,-278,805,-987,979,-1272v-357,15,-642,22,-854,22v-60,0,-115,-9,-115,-50v0,-43,51,-61,153,-64","w":1318,"k":{"y":33,"x":14,"w":20,"v":63,"u":27,"t":43,"r":27,"q":12,"o":16,"n":20,"m":14,"l":16,"k":10,"h":12,"g":14,"f":37,"e":12,"d":10,"c":14,"b":14,"W":10,"U":18,"Q":41,"O":41,"G":35,"C":35,"9":39,"4":37,"-":47,"&":20}},"[":{"d":"330,-1327v11,4,-110,1291,-101,1286v1,65,50,98,148,98v65,0,157,-16,274,-47v22,0,32,14,29,41v-3,33,-22,50,-57,55v-135,17,-288,27,-459,27v-31,0,-47,-10,-47,-29v-1,-274,63,-1196,104,-1439v3,-19,15,-35,39,-49v52,-30,185,-54,399,-54v30,0,44,8,46,25v3,32,-57,63,-103,63v-123,0,-213,8,-272,23","w":745,"k":{"{":39,"y":55,"w":55,"v":51,"u":59,"t":35,"s":33,"r":35,"q":49,"o":53,"n":35,"m":27,"g":51,"f":23,"e":55,"d":43,"c":53,"a":27,"W":20,"T":-53,"Q":61,"O":66,"J":35,"G":66,"C":68,"9":57,"8":39,"6":61,"5":25,"4":55,"3":23,"0":43}},"\\":{"d":"934,170v-5,27,-87,58,-113,31v-42,-105,-162,-375,-361,-807v-199,-432,-334,-754,-403,-967v2,-32,84,-60,113,-31v69,213,203,536,402,968v199,432,319,701,362,806","w":985,"k":{"y":33,"w":23,"v":68,"u":33,"t":61,"r":20,"l":25,"f":41,"b":23,"Y":82,"W":27,"V":100,"U":47,"T":127,"Q":43,"O":41,"G":37,"C":35,"B":20,"9":80,"7":57,"6":25,"4":57,"1":68,"0":29,"'":127}},"]":{"d":"432,-1382v-65,-3,-272,30,-338,30v-41,0,-61,-13,-61,-40v1,-40,36,-66,93,-64v93,3,303,-59,397,-20v9,8,22,21,22,36v34,529,51,1015,51,1458v0,32,-53,44,-92,41v-25,-1,-71,-3,-139,-2r-256,4v-26,0,-37,-9,-37,-28v0,-30,35,-65,75,-66r265,-8v31,0,54,1,67,4","w":727},"^":{"d":"817,-859v0,34,-100,63,-119,15v-46,-115,-250,-493,-299,-598v-70,84,-135,454,-192,545v-6,39,-140,42,-109,-10v64,-108,97,-331,150,-459v31,-75,71,-135,123,-184v31,-29,79,-36,104,-2v34,93,342,665,342,693","w":909},"_":{"d":"201,213v-1,-28,45,-55,75,-51v281,39,689,0,973,0v44,0,38,17,15,46v-12,16,-25,24,-42,26v-17,2,-66,4,-147,8v-227,10,-429,14,-607,14v-178,0,-267,-14,-267,-43","w":1484},"`":{"d":"639,-1182v0,29,-46,92,-96,72v-110,-44,-241,-110,-375,-225v-48,-41,35,-131,92,-90v142,100,254,180,352,215v18,7,27,16,27,28","w":729},"a":{"d":"261,17v-139,0,-180,-145,-179,-318v2,-231,83,-482,200,-615v67,-77,138,-118,216,-118v112,0,184,47,223,139v56,131,37,357,37,541v0,119,16,197,41,239v30,49,73,43,129,31v17,0,32,5,45,16v-9,48,-57,72,-144,72v-155,0,-140,-210,-165,-326v-89,169,-175,272,-258,310v-42,19,-90,29,-145,29xm639,-680v0,-119,-51,-240,-170,-242v-44,0,-84,26,-120,77v-93,135,-133,366,-140,575v-3,87,37,188,115,188v74,0,145,-70,213,-209v68,-139,102,-269,102,-389","w":919,"k":{"}":-37,"]":-23,"\\":47,"Y":123,"V":63,"T":258,"@":-16}},"b":{"d":"425,12v-167,0,-307,-154,-304,-316v1,-83,6,-236,15,-459v9,-216,16,-373,14,-472r-5,-238v18,-36,69,-54,119,-40v3,73,4,275,4,606v66,-60,119,-129,242,-133v201,-6,338,211,336,408v-3,228,-72,415,-192,540v-66,69,-142,104,-229,104xm711,-588v0,-168,-66,-375,-219,-375v-101,0,-148,113,-175,213v-31,121,-47,257,-47,406v0,175,32,256,168,256v53,0,101,-26,144,-76v86,-100,129,-241,129,-424","w":925,"k":{"}":41,"f":8,"]":53,"\\":68,"Z":47,"Y":156,"X":94,"W":12,"V":86,"U":16,"T":293,"S":18,"R":16,"P":23,"N":23,"M":25,"L":20,"K":20,"J":16,"I":20,"H":16,"F":20,"E":16,"D":18,"B":20,"A":12,"?":41,"\/":49,".":20,"*":25,")":39,"'":16}},"c":{"d":"430,2v-215,0,-353,-157,-348,-371v7,-288,126,-657,438,-657v167,0,231,130,289,258v-44,46,-104,56,-141,5v-36,-49,-39,-108,-90,-147v-91,-70,-178,-20,-240,80v-74,120,-125,295,-127,470v-2,142,89,274,231,274v82,0,148,-28,197,-86v44,-52,116,-160,176,-160v12,0,30,3,53,10v0,51,-46,117,-138,200v-92,83,-192,124,-300,124","w":913,"k":{"}":25,"x":12,"u":8,"s":8,"]":33,"\\":72,"Z":16,"Y":162,"X":70,"W":16,"V":82,"U":25,"T":309,"S":14,"Q":14,"P":10,"O":14,"N":12,"M":16,"L":10,"K":10,"I":12,"G":14,"C":14,"B":12,"?":35,"\/":25,"-":55,")":20}},"d":{"d":"293,-4v-165,0,-205,-181,-205,-362v0,-226,50,-424,160,-552v60,-69,131,-106,217,-106v102,-1,204,49,233,121r18,-374v7,-124,27,-390,118,-378v17,2,36,6,57,15v-52,470,-78,804,-78,1004v0,200,18,400,55,599v-41,43,-71,49,-123,33v-29,-101,-46,-211,-51,-330v-69,109,-72,114,-153,207v-71,81,-152,123,-248,123xm678,-729v0,-121,-74,-189,-208,-189v-47,0,-91,27,-132,80v-81,105,-121,258,-121,457v0,101,31,287,121,287v57,0,112,-38,168,-112v92,-122,172,-335,172,-523","k":{"Z":10,"W":12,"U":16,"R":12,"Q":14,"P":14,"O":14,"N":14,"M":14,"L":14,"K":14,"I":14,"H":12,"G":12,"F":14,"E":12,"D":12,"C":12,"B":12,"-":18}},"e":{"d":"430,-6v-192,0,-354,-138,-350,-340v5,-237,104,-438,242,-560v79,-70,159,-106,240,-106v148,-1,267,59,272,197v8,233,-271,414,-496,409v-31,0,-69,-3,-113,-10v-32,188,88,310,248,314v117,3,211,-39,260,-91v71,-77,102,-113,189,-79v-38,155,-266,266,-492,266xm692,-796v4,-72,-70,-140,-143,-140v-68,0,-131,48,-189,142v-58,94,-100,191,-124,292v139,30,224,30,317,-42v80,-63,133,-143,139,-252","k":{"}":23,"f":8,"]":33,"\\":74,"Z":12,"Y":158,"X":43,"W":12,"V":88,"U":25,"T":311,"R":12,"Q":10,"P":16,"O":10,"N":16,"M":18,"L":16,"K":16,"I":14,"H":10,"F":12,"E":12,"D":12,"B":16,"?":37,"\/":25,"-":43,")":23}},"f":{"d":"385,-182v0,123,-3,196,-111,196v-24,0,-36,-196,-36,-588r-2,-350v-69,-4,-150,4,-201,-18v-20,-9,-31,-22,-31,-43v0,-26,42,-39,127,-39v37,0,70,1,100,4r12,-293v7,-114,36,-189,109,-235v33,-21,83,-35,156,-35v175,0,202,88,256,237v-27,32,-57,44,-100,33v-25,-65,-49,-108,-67,-133v-31,-42,-116,-41,-157,-16v-87,52,-64,236,-71,430r174,-17v68,0,102,16,102,48v0,21,-17,33,-49,41v-49,13,-185,8,-227,24v-11,241,16,510,16,754","w":643,"k":{"}":-121,"|":-47,"w":23,"u":10,"s":18,"q":39,"p":37,"o":33,"m":33,"i":-25,"g":33,"e":49,"d":31,"c":39,"a":39,"]":-133,"\\":-49,"Z":-98,"Y":-133,"X":-104,"V":-135,"T":-203,"P":-20,"M":-14,"J":63,"G":10,"C":12,"B":-12,"A":23,"@":35,"?":-94,":":29,"\/":55,".":37,"-":68,"*":-119,")":-43,"'":-47,"\"":-68}},"g":{"d":"846,-91v2,310,-150,531,-454,531v-148,0,-271,-48,-369,-143v71,-65,124,-45,222,1v57,27,117,42,181,42v267,0,299,-243,305,-516v0,-21,-2,-96,-6,-227v-37,112,-89,204,-157,277v-68,73,-146,110,-232,110v-180,0,-250,-201,-250,-380v0,-216,66,-405,174,-528v131,-149,401,-125,477,52v51,118,86,182,97,348v8,127,12,271,12,433xm674,-688v0,-94,-107,-250,-219,-238v-162,17,-203,229,-231,383v-10,53,-13,107,-13,161v-1,90,41,278,133,278v86,0,163,-65,230,-194v67,-129,100,-259,100,-390","w":954,"k":{"v":14,"t":8,"f":23,"\\":90,"Z":12,"Y":150,"W":16,"V":94,"U":31,"T":334,"S":10,"R":16,"Q":14,"P":18,"O":12,"N":18,"M":20,"L":18,"K":18,"I":16,"H":16,"G":10,"F":16,"E":16,"D":16,"C":10,"B":20,"?":37,"*":23}},"h":{"d":"1071,-119v-2,36,-130,93,-180,90v-139,-8,-182,-173,-197,-319v-16,-161,-10,-355,-44,-490v-15,-62,-41,-94,-77,-94v-44,0,-82,48,-120,142v-73,182,-98,441,-159,630v-31,95,-59,142,-89,142v-48,0,-78,-135,-72,-406r19,-917v0,-71,-4,-119,-13,-146v25,-22,62,-33,113,-33v38,335,40,572,12,1039v64,-345,179,-518,344,-518v138,0,183,175,197,319v8,89,15,177,20,266v13,213,52,320,115,320v23,0,111,-42,131,-25","w":999,"k":{"v":10,"\\":61,"Y":123,"V":72,"T":258,"@":-41,";":-2,":":-20,".":-37,",":-14,"*":29,"'":20,"!":-29}},"i":{"d":"131,-1350v0,-80,-6,-179,71,-178v33,0,55,7,64,21v-3,72,-4,150,4,223v-51,54,-139,48,-139,-66xm272,-135v1,86,-56,140,-127,102v-11,-281,-31,-820,31,-934v23,-43,51,-20,103,0v-16,255,-12,560,-7,832","w":409,"k":{"Z":20,"Y":10,"X":10,"W":10,"U":20,"T":59,"S":10,"R":12,"Q":10,"P":14,"O":12,"N":14,"M":16,"L":14,"K":14,"I":12,"H":12,"G":10,"F":12,"E":12,"D":12,"C":10,"B":14,"A":10,"\/":25}},"j":{"d":"-41,510v-57,1,-143,-14,-147,-55v-7,-71,87,-52,147,-52v125,0,188,-216,188,-647v0,-125,-22,-560,-22,-659v0,-57,27,-86,82,-86v54,0,45,60,45,110v0,37,5,96,10,179v26,387,45,502,14,778v-23,209,-88,429,-317,432xm102,-1434v0,-60,6,-95,70,-94v26,0,45,3,57,8v15,57,23,126,23,207v0,38,-31,58,-84,58v-44,0,-66,-62,-66,-179","w":411,"k":{"Z":10,"Y":18,"W":12,"V":14,"U":25,"T":18,"S":10,"R":12,"Q":12,"P":14,"O":12,"N":14,"M":16,"L":12,"K":14,"I":12,"H":10,"G":10,"F":12,"E":12,"D":12,"C":10,"B":14}},"k":{"d":"195,8v-43,0,-68,-33,-67,-77v0,-20,4,-137,11,-351v16,-495,23,-812,23,-950v0,-64,7,-107,20,-129v24,-43,60,-37,106,-21r0,354r-16,586v110,-72,281,-267,383,-356v68,-59,120,-90,159,-90v27,0,66,27,54,49v-46,85,-184,176,-264,244v-64,54,-117,100,-155,143v100,13,182,68,239,168v75,131,172,325,281,377v-61,59,-138,52,-200,-10v-71,-70,-118,-179,-167,-273v-61,-117,-127,-178,-205,-178v-64,0,-133,55,-133,111v0,164,-3,285,-8,364v-19,26,-40,39,-61,39","w":966,"k":{"w":33,"u":27,"s":12,"q":27,"o":35,"l":8,"g":31,"e":35,"d":20,"c":33,"a":8,"\\":41,"Y":74,"W":25,"V":45,"U":33,"T":229,"Q":45,"O":45,"G":45,"C":47,"B":12,"-":78}},"l":{"d":"150,-255v-52,-281,38,-747,38,-970v0,-135,-18,-226,-55,-272v21,-32,66,-44,119,-37v34,34,51,133,51,297v0,200,-37,619,-37,760v0,258,50,387,150,387v37,0,83,-30,106,2v-4,49,-44,74,-120,74v-154,0,-228,-110,-252,-241","w":487,"k":{"}":-18,"]":-10}},"m":{"d":"1450,-72v-24,41,-118,66,-184,66v-140,0,-208,-162,-213,-290v-3,-69,-4,-128,-4,-177v2,-120,10,-245,-7,-354v-8,-55,-28,-82,-59,-82v-47,0,-92,97,-135,291v-43,194,-69,380,-78,555v-29,30,-73,48,-119,32v-28,-146,-14,-601,-45,-751v-20,-98,-53,-148,-110,-148v-38,0,-67,43,-95,127v-44,132,-92,507,-125,760v-38,31,-69,43,-118,33v-19,-228,-29,-511,-29,-848v15,-25,44,-37,88,-37v31,0,22,392,21,506v21,-243,36,-313,86,-459v32,-95,107,-177,200,-178v73,0,127,36,163,108v36,72,55,169,56,289v34,-247,124,-370,271,-370v140,1,175,174,172,325r-6,312v0,205,44,307,133,307v46,0,89,-21,137,-17","w":1368,"k":{"}":-39,"]":-31,"\\":59,"Y":115,"V":70,"U":12,"T":244,"@":-39,".":-53,",":-16,"!":-29}},"n":{"d":"119,-961v43,-31,75,-35,123,-22v13,52,11,620,14,674v53,-236,59,-555,242,-665v91,-55,220,-48,269,51v87,178,18,512,86,723v24,73,58,121,110,143v-71,73,-172,37,-215,-55v-82,-178,-36,-514,-82,-730v-13,-63,-37,-94,-72,-94v-48,0,-89,43,-122,129v-33,86,-57,182,-71,287v-38,293,-75,458,-110,493v-39,20,-69,23,-109,13v-29,-125,-48,-342,-55,-650v-4,-153,-5,-252,-8,-297","w":974,"k":{"\\":76,"Y":147,"V":84,"U":18,"T":303,"Q":10,"B":10,"-":16}},"o":{"d":"467,0v-269,0,-379,-159,-379,-426v0,-176,35,-317,104,-424v69,-107,169,-160,300,-160v262,0,432,266,432,524v0,262,-195,486,-457,486xm463,-80v188,3,323,-188,323,-385v0,-107,-28,-211,-85,-311v-57,-100,-126,-150,-207,-150v-173,0,-229,187,-254,344v-37,231,-11,497,223,502","w":1003,"k":{"}":41,"z":16,"v":8,"f":25,"]":51,"\\":86,"Z":35,"Y":164,"X":86,"W":12,"V":92,"U":23,"T":334,"S":16,"R":18,"P":23,"N":25,"M":27,"L":20,"K":20,"I":20,"H":16,"F":20,"E":18,"D":18,"B":23,"A":10,"?":41,"\/":45,"*":18,")":39}},"p":{"d":"881,-461v1,238,-177,443,-432,443v-83,0,-153,-15,-209,-45v4,111,18,267,41,469v-32,30,-65,43,-115,36v-2,-114,-60,-663,-57,-796v5,-198,19,-333,81,-467v61,-133,175,-199,340,-199v103,0,186,56,252,168v66,112,99,242,99,391xm483,-121v165,3,258,-158,258,-328v0,-135,-21,-245,-61,-331v-40,-86,-95,-129,-166,-129v-116,0,-190,61,-231,180v-40,116,-57,383,-47,569v121,26,204,39,247,39","w":964,"k":{"}":41,"z":12,"f":18,"]":51,"\\":84,"Z":35,"Y":158,"X":86,"W":12,"V":90,"U":23,"T":332,"S":14,"R":16,"P":23,"N":25,"M":25,"L":23,"K":23,"I":20,"H":14,"F":20,"E":18,"D":18,"B":23,"A":10,"?":39,"\/":43,")":37}},"q":{"d":"329,-29v-272,0,-261,-335,-217,-563v41,-210,136,-403,390,-403v315,0,327,395,325,717v0,54,-3,116,-8,188v-9,137,-21,417,25,524v-24,39,-72,57,-119,37v-31,-247,6,-626,-23,-877v-69,184,-149,298,-239,345v-40,21,-84,32,-134,32xm649,-758v-1,-66,-99,-145,-180,-141v-112,6,-171,101,-201,197v-35,110,-51,207,-51,288v0,183,36,275,107,275v138,0,220,-127,258,-244v44,-137,67,-262,67,-375","w":948,"k":{"v":14,"t":8,"f":27,"\\":90,"Z":16,"Y":156,"W":18,"V":96,"U":31,"T":342,"S":12,"R":16,"Q":14,"P":18,"O":14,"N":18,"M":20,"L":18,"K":18,"I":16,"H":16,"G":12,"F":16,"E":16,"D":16,"C":12,"B":20,"?":39,",":-18,"*":20}},"r":{"d":"328,-84v5,72,-66,93,-129,72v-46,-177,-85,-827,-97,-994v32,-36,77,-32,125,-20v11,47,14,468,23,516v33,-174,90,-362,210,-456v44,-34,92,-50,143,-50v90,0,209,116,206,193v-2,44,-100,61,-125,21v-28,-45,-28,-124,-104,-124v-61,0,-114,55,-158,166v-78,195,-112,424,-94,676","w":815,"k":{"}":39,"q":14,"p":14,"o":8,"g":12,"e":35,"d":10,"c":18,"a":25,"]":59,"\\":37,"Z":90,"Y":76,"X":154,"V":25,"T":225,"S":12,"R":14,"P":16,"N":18,"M":20,"L":16,"K":16,"J":197,"I":16,"H":16,"F":20,"E":14,"D":16,"B":12,"A":29,"@":29,"?":41,"\/":90,".":117,"-":109,"*":-10,")":37}},"s":{"d":"451,-2v-96,0,-400,-74,-400,-174v0,-35,30,-53,90,-53v18,0,41,11,70,32v87,64,177,96,268,97v127,2,230,-65,226,-176v-3,-102,-120,-139,-215,-164v-176,-46,-391,-84,-394,-297v-2,-180,196,-281,391,-281v143,0,295,80,295,227v0,49,-28,74,-84,74v-47,-1,-57,-12,-58,-56v-2,-72,-26,-93,-74,-120v-124,-70,-345,-5,-337,139v10,181,241,185,393,234v108,35,216,102,216,237v0,191,-192,281,-387,281","w":892,"k":{"}":20,"f":10,"]":31,"\\":74,"Z":12,"Y":162,"X":39,"W":12,"V":86,"U":23,"T":317,"R":14,"Q":10,"P":16,"O":10,"N":18,"M":18,"L":16,"K":16,"I":14,"H":10,"F":14,"E":14,"D":12,"B":16,"?":35,"\/":25,"-":29,")":23}},"t":{"d":"733,-139v5,60,-173,123,-235,123v-150,0,-244,-142,-281,-426v-11,-82,-19,-223,-24,-422v-71,14,-170,5,-195,-39v-1,-46,48,-69,88,-75v22,-3,58,-6,107,-9v17,-136,-9,-430,59,-490v21,-18,49,-18,78,-12v13,221,-1,292,-6,485v50,7,116,-4,170,-4v106,0,159,16,159,49v-3,152,-207,59,-325,72v-13,160,-4,303,13,471v9,81,28,150,58,208v30,58,68,87,115,87v40,0,119,-55,154,-55v28,0,64,14,65,37","w":733,"k":{"\\":39,"Y":66,"V":37,"U":12,"T":215,"-":66}},"u":{"d":"92,-592v0,-145,18,-254,56,-326v14,-26,41,-66,80,-61v17,3,38,9,61,18v-35,67,-53,166,-53,299v0,199,40,357,112,478v79,132,225,139,303,8v92,-155,79,-580,-8,-715v-24,-38,-35,-68,-38,-86v-6,-44,27,-50,75,-51v83,0,138,86,164,258v30,191,5,346,-62,516v-67,171,-179,256,-329,256v-79,0,-147,-29,-203,-88v-105,-112,-158,-281,-158,-506","w":937,"k":{"}":39,"]":51,"\\":61,"Z":43,"Y":133,"X":88,"W":12,"V":72,"U":16,"T":307,"S":14,"R":16,"P":18,"N":20,"M":20,"L":18,"K":18,"J":14,"I":18,"H":16,"F":18,"E":16,"D":16,"B":18,"A":12,"?":37,"\/":49,".":18,")":37}},"v":{"d":"25,-985v12,-38,86,-51,125,-27r112,318v69,195,134,350,195,463v29,-167,84,-335,167,-504v83,-169,158,-254,226,-254v21,0,41,5,61,14v-157,206,-270,479,-338,819v-24,114,-21,148,-101,154v-72,6,-77,-72,-101,-117v-140,-260,-255,-549,-346,-866","w":919,"k":{"}":29,"w":12,"s":8,"q":27,"p":27,"o":18,"m":10,"g":20,"e":41,"d":20,"c":27,"a":33,"]":41,"\\":23,"Z":53,"Y":37,"X":88,"V":10,"T":215,"R":10,"N":10,"M":14,"L":10,"K":10,"J":100,"I":10,"H":10,"F":14,"D":10,"A":29,"@":35,"?":27,":":16,"\/":80,".":63,"-":47,"*":-31,")":31}},"w":{"d":"672,-238v-44,173,-383,342,-499,116v-38,-74,-60,-174,-60,-304v0,-366,54,-549,161,-549v13,0,31,2,52,6v-23,104,-74,334,-74,443v0,92,13,188,39,290v36,143,101,202,182,105v60,-73,91,-210,127,-301v-24,-92,-31,-178,-31,-280v0,-108,15,-222,125,-222v51,0,76,76,76,229v0,42,-22,189,-22,228v0,101,156,400,258,393v171,-12,168,-336,132,-484v-38,-155,-150,-334,-212,-436v34,-29,65,-43,94,-43v83,60,149,158,198,294v49,136,74,260,74,371v-1,212,-83,358,-291,357v-149,0,-287,-97,-329,-213","w":1376,"k":{"}":33,"z":10,"v":10,"f":18,"]":39,"\\":86,"Z":25,"Y":152,"X":66,"W":12,"V":86,"U":25,"T":328,"S":10,"R":16,"P":20,"N":20,"M":23,"L":20,"K":20,"I":18,"H":14,"F":16,"E":16,"D":16,"B":20,"?":39,"\/":33,"*":20,")":31}},"x":{"d":"293,-352v-120,-198,-214,-343,-238,-611v32,-42,78,-61,129,-36v29,183,89,350,181,503v60,-112,132,-270,217,-473v49,-28,79,-33,127,-20v-69,224,-177,403,-273,600v78,96,106,135,209,201v63,40,122,61,178,61v29,0,49,5,60,16v-15,47,-52,70,-109,70v-95,0,-191,-38,-287,-113v-67,-54,-69,-60,-118,-106v-64,88,-90,293,-260,252v22,-45,54,-106,97,-184","w":792,"k":{"}":-27,"]":-27,"\\":33,"Y":68,"V":59,"T":201,"Q":29,"O":29,"G":20,"C":16,"@":-55,";":-2,":":-37,".":-49,"-":47,",":-31,")":-16,"!":-41}},"y":{"d":"799,51v-5,329,-86,455,-397,455v-144,0,-279,-46,-406,-139v48,-52,100,-58,168,-15v95,60,177,86,242,86v222,0,258,-143,262,-393v0,-34,-4,-157,-11,-369v-18,70,-42,175,-85,222v-32,36,-87,80,-158,80v-136,0,-187,-69,-226,-158v-85,-192,-66,-484,-69,-758v18,-50,154,-49,147,18v-24,220,-9,476,44,648v39,125,75,188,114,188v132,0,138,-225,164,-356v19,-96,21,-335,22,-420v1,-114,41,-163,131,-144v-15,242,61,815,58,1055","w":905,"k":{"\\":66,"Z":10,"Y":127,"W":14,"V":82,"U":25,"T":293,"R":12,"Q":14,"P":14,"O":14,"N":14,"M":16,"L":14,"K":14,"I":12,"H":12,"G":12,"F":12,"E":12,"D":12,"C":12,"B":16,"?":33,"-":16}},"z":{"d":"506,-897v-79,0,-317,49,-394,49v-44,0,-65,-15,-65,-45v0,-38,61,-67,185,-87v124,-20,230,-30,319,-30v157,0,235,48,235,145v0,65,-28,142,-85,231v-57,89,-135,191,-235,306v-100,115,-155,178,-163,189v209,-18,355,-27,438,-27v83,0,125,20,125,60v0,29,-16,46,-47,51v-25,4,-76,6,-153,6v-111,0,-434,26,-530,26v-40,0,-60,-11,-60,-34v0,-33,48,-83,129,-166r123,-125v116,-121,178,-177,263,-314v37,-60,56,-110,56,-151v0,-56,-47,-84,-141,-84","w":901,"k":{"\\":68,"Y":123,"X":10,"W":16,"V":86,"U":29,"T":303,"R":14,"Q":16,"P":16,"O":16,"N":16,"M":18,"L":16,"K":16,"I":14,"H":12,"G":14,"F":12,"E":14,"D":12,"C":14,"B":18,"?":29,"-":55}},"{":{"d":"651,0v-1,50,-106,87,-166,84v-357,-12,-162,-565,-403,-723v-37,-24,-39,-81,0,-102v101,-54,137,-162,137,-310v0,-125,11,-216,32,-273v44,-116,123,-142,281,-146v42,-1,59,47,38,84v-10,19,-25,29,-46,32v-161,14,-182,114,-186,286v-3,144,-8,193,-62,284v-26,42,-55,73,-90,94v73,44,123,102,136,176v21,122,5,327,63,420v27,42,55,67,96,67v25,0,88,-45,115,-43v33,3,57,31,55,70","w":677,"k":{"{":35,"y":27,"v":45,"u":27,"t":35,"f":20,"X":-45,"U":25,"Q":43,"O":43,"G":39,"C":39,"9":53,"6":31,"4":51,"0":25,"(":20}},"|":{"d":"186,-1536v29,0,58,23,58,55v0,974,40,1520,45,1641v2,50,-49,66,-86,49v-19,-9,-30,-26,-31,-49v-4,-121,-19,-668,-45,-1641v-2,-31,30,-55,59,-55","w":411},"}":{"d":"223,129v-47,1,-166,-27,-166,-78v0,-121,134,-6,195,-61v29,-26,44,-81,55,-125v18,-71,12,-209,12,-307v0,-121,27,-213,82,-275v-91,-26,-165,-194,-155,-311r18,-207v0,-57,-22,-86,-67,-86v-52,0,-140,38,-140,-43v0,-62,120,-88,185,-88v123,0,154,105,135,246v-18,139,-30,397,69,397v83,0,123,52,76,96v-46,43,-76,160,-88,357v-9,151,-18,316,-81,412v-32,48,-74,73,-130,73","w":598,"k":{")":20}},"~":{"d":"149,-475v-46,2,-76,-49,-53,-88v47,-78,99,-139,152,-183v53,-44,117,-67,190,-67v49,0,114,30,194,91v80,61,140,91,180,91v105,0,106,-76,128,-190v5,-27,20,-41,49,-41v27,1,64,26,64,61v0,160,-104,295,-262,295v-48,0,-110,-28,-185,-85v-181,-138,-283,-108,-409,87v-12,19,-27,29,-48,29","w":1142},"\u00a0":{"w":462}}});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael) {/*!
	 * The following copyright notice may not be removed under any circumstances.
	 * 
	 * Copyright:
	 * Copyright (c) 2011 by Vernon Adams. All rights reserved.
	 * 
	 * Trademark:
	 * Pacifico Regular is a trademark of Vernon Adams.
	 * 
	 * Description:
	 * Copyright (c) 2011 by vernon adams. All rights reserved.
	 * 
	 * Manufacturer:
	 * Vernon Adams
	 * 
	 * Designer:
	 * Vernon Adams
	 * 
	 * License information:
	 * http://scripts.sil.org/OFL
	 */
	Raphael.registerFont({"w":1248,"face":{"font-family":"pacifico","font-weight":400,"font-stretch":"normal","units-per-em":"2048","panose-1":"2 0 0 0 0 0 0 0 0 0","ascent":"1638","descent":"-410","cap-height":"32","bbox":"-183 -1985.76 2630 928","underline-thickness":"102","underline-position":"-613","unicode-range":"U+0020-U+007E"},"glyphs":{" ":{"w":545},"!":{"d":"410,2v-107,-1,-164,-56,-164,-164v0,-116,63,-189,183,-191v103,-1,169,59,162,162v-7,108,-55,195,-181,193xm513,-476v-33,20,-105,24,-97,-36v58,-438,183,-811,292,-1192v28,-99,99,-148,220,-152v94,-3,80,114,64,192v-60,284,-180,535,-288,784r-160,368v-3,17,-18,28,-31,36","w":1184},"\"":{"d":"304,-1208v-62,50,-150,12,-144,-75r16,-258v5,-58,11,-120,16,-187v7,-87,80,-124,168,-128v93,-4,149,65,120,160r-98,328v-23,65,-34,125,-78,160xm688,-1208v-62,50,-150,12,-144,-75r16,-258v5,-58,11,-120,16,-187v7,-87,80,-124,168,-128v93,-4,149,65,120,160r-98,328v-23,65,-34,125,-78,160","w":1184},"#":{"d":"317,-447v-99,6,-184,-59,-141,-154v32,-69,129,-76,240,-71r129,-288v-105,5,-196,-11,-196,-108v0,-129,162,-113,295,-116r138,-306v35,-75,99,-141,205,-141v104,0,33,154,11,206r-104,241r269,-1r112,-309v31,-76,89,-141,193,-141v103,0,49,147,29,206r-84,244v84,6,209,-27,208,62v-2,143,-128,166,-282,163r-98,287v77,0,169,-11,169,64v0,130,-110,160,-249,161r-73,193v-36,80,-61,177,-108,246v-44,63,-201,60,-201,-51v0,-29,8,-66,24,-112r97,-275r-324,2r-189,394v-27,50,-58,85,-130,86v-58,0,-100,-18,-98,-78v1,-45,16,-84,34,-125xm800,-960r-123,291r303,-1r103,-290r-283,0"},"$":{"d":"862,225v-131,0,-115,-135,-92,-229v-214,-20,-389,-90,-473,-240v-68,-121,-36,-322,35,-407v62,-74,149,-127,285,-127v69,0,116,34,116,98v0,46,-34,82,-86,82v-103,0,-154,66,-151,178v4,150,149,197,311,210r116,-643v-146,-81,-307,-156,-389,-297v-52,-89,-49,-202,0,-298v91,-177,285,-283,550,-295v17,-117,27,-250,166,-241v109,7,52,172,43,256v161,33,299,105,371,226v55,94,46,275,-80,275v-81,0,-122,-62,-127,-147v-6,-88,-101,-131,-198,-149r-96,557v135,80,273,166,342,310v49,102,38,249,-7,348v-82,182,-264,281,-506,304v-27,93,-1,229,-130,229xm1046,-1531v-146,19,-279,63,-279,207v0,133,111,182,198,243xm1033,-224v142,-39,264,-113,264,-283v0,-125,-94,-177,-173,-234","w":1735},"%":{"d":"594,-1728v298,-3,401,271,340,564v-44,213,-156,386,-338,465v-91,39,-215,34,-297,-9v-162,-85,-239,-314,-191,-558v41,-209,147,-369,332,-437v46,-17,98,-25,154,-25xm687,-1160v34,-149,41,-376,-119,-376v-131,0,-179,134,-204,254v-30,139,-20,322,55,396v43,42,100,22,142,-20v59,-59,103,-155,126,-254xm823,-48v-66,55,-251,85,-243,-48v6,-99,48,-167,84,-236r708,-1364v35,-60,99,-96,196,-96v85,0,35,152,12,200r-464,991r-132,271r-120,234v-11,20,-25,35,-41,48xm1669,-64v-298,0,-395,-271,-343,-571v38,-217,143,-387,329,-459v91,-35,222,-32,305,10v194,98,229,465,126,691v-60,132,-149,247,-282,303v-42,17,-87,26,-135,26xm1689,-890v-98,95,-140,296,-114,485v10,73,36,143,112,149v118,-18,165,-149,195,-262v35,-132,25,-315,-46,-388v-40,-41,-108,-21,-147,16","w":2208},"&":{"d":"960,-128v-100,72,-227,128,-402,128v-223,0,-388,-67,-462,-210v-74,-142,-4,-307,70,-399v79,-98,182,-182,305,-248v-68,-138,-168,-355,-83,-540v77,-168,288,-309,528,-233v144,46,243,205,180,392v-57,169,-187,281,-338,374v24,47,73,121,104,171r146,236v40,-28,63,-63,61,-129v-3,-124,-78,-160,-124,-246v9,-10,24,-26,37,-32v101,24,179,97,235,172v34,46,64,106,64,179v0,117,-63,189,-147,257v45,28,104,73,141,109v42,41,-6,111,-32,139v-30,31,-91,77,-137,38v-48,-41,-105,-109,-146,-158xm525,-704v-97,79,-197,166,-203,323v-7,173,215,210,371,157v42,-14,80,-35,116,-58r-76,-94v-80,-104,-138,-202,-208,-328xm794,-1440v-109,10,-170,125,-138,257v16,64,33,140,55,190v95,-95,209,-169,217,-339v4,-81,-51,-116,-134,-108","w":1472},"'":{"d":"304,-1208v-62,50,-150,12,-144,-75r16,-258v5,-58,11,-120,16,-187v7,-87,80,-124,168,-128v93,-4,149,65,120,160r-98,328v-23,65,-34,125,-78,160","w":609},"(":{"d":"1116,-52v84,-26,133,71,116,155v-2,10,-8,19,-15,26v-142,146,-286,255,-513,255v-195,0,-270,-153,-301,-326v-63,-357,32,-712,131,-987v89,-247,214,-476,382,-641v109,-107,270,-203,465,-136v125,43,249,114,284,242v-14,64,-73,114,-140,126v-36,-5,-46,-29,-70,-51v-54,-50,-106,-115,-207,-115v-106,0,-175,72,-232,144v-197,250,-310,615,-363,1006v-20,148,-22,306,15,424v20,67,69,107,156,86v118,-28,181,-101,264,-188v9,-9,18,-17,28,-20","w":1377},")":{"d":"218,260v-66,-31,-139,-71,-157,-140v14,-64,73,-114,140,-126v94,30,147,108,277,101v108,-6,169,-103,216,-195v127,-249,203,-595,203,-962v0,-165,-17,-323,-92,-408v-51,-56,-147,-36,-214,-6v-80,36,-144,90,-209,164v-14,15,-31,26,-55,26v-62,0,-94,-65,-94,-129v0,-25,7,-44,20,-58v142,-146,286,-255,513,-255v241,0,325,217,362,438v72,424,-26,861,-162,1164v-72,160,-168,298,-298,388v-128,89,-324,57,-450,-2","w":1279},"*":{"d":"191,-1120v-81,33,-159,-38,-159,-115v0,-93,130,-90,212,-103r137,-22r-253,-117v-110,-55,-27,-187,75,-186v23,0,42,8,57,23r213,203r5,-294v5,-64,57,-91,123,-93v63,-2,114,47,88,116r-103,279r267,-145v81,-9,140,50,140,122v0,93,-131,91,-213,104r-138,22r255,118v31,18,54,37,54,75v0,83,-121,149,-186,88r-152,-143v-24,-23,-44,-43,-60,-60r-5,291v2,107,-217,134,-217,14v0,-119,72,-209,107,-312","w":1024},"+":{"d":"673,-416v-139,-9,-353,42,-353,-95v0,-137,213,-89,353,-97r0,-228v3,-70,42,-119,109,-119v50,0,83,40,83,100r0,247r250,0v61,-3,100,33,100,83v0,67,-49,109,-119,109r-231,0v-8,141,41,356,-97,356v-138,0,-85,-217,-95,-356","w":1503},",":{"d":"424,176v-74,42,-156,-11,-131,-104r84,-309v17,-55,67,-84,137,-84v94,0,188,58,150,155v-43,111,-123,199,-187,295v-15,23,-34,36,-53,47","w":609},"-":{"d":"160,-512v-68,0,-96,-44,-97,-109v0,-58,35,-84,97,-83r448,0v52,2,94,21,95,76v0,80,-44,117,-128,116r-415,0","w":768},".":{"d":"484,0v-106,0,-164,-54,-164,-162v0,-116,63,-189,183,-191v108,-1,169,56,169,162v0,116,-64,191,-188,191","w":704},"\/":{"d":"428,17v-76,31,-213,32,-206,-72v6,-91,50,-168,82,-240r624,-1401v45,-87,126,-160,256,-160v118,0,40,176,12,234v-37,77,-75,170,-120,280r-151,366r-186,432v-68,154,-141,315,-225,480v-20,40,-48,66,-86,81"},"0":{"d":"490,-1058v277,0,356,270,304,546v-41,216,-141,399,-316,484v-81,39,-192,34,-268,-6v-187,-97,-206,-451,-118,-676v54,-139,133,-261,264,-320v41,-18,86,-28,134,-28xm569,-691v0,-85,-8,-175,-83,-186v-86,14,-118,103,-146,181v-44,123,-76,311,-36,458v14,52,69,77,110,32v97,-108,155,-289,155,-485","w":863},"1":{"d":"320,-850v-34,33,-70,77,-118,93v-63,0,-111,-6,-144,-17v-33,-11,-50,-22,-50,-33v12,-38,85,-14,119,-41r120,-96v66,-47,132,-112,233,-112v52,0,81,-1,90,29r-14,125r-95,646v-21,93,-40,191,-105,240v-14,10,-30,16,-48,16v-84,2,-171,-15,-148,-107r62,-246r51,-241v17,-86,33,-171,47,-256","w":672},"2":{"d":"518,-105v-87,65,-223,138,-358,85v-81,-31,-150,-96,-150,-201v0,-117,70,-193,194,-195v108,-1,183,37,251,78v69,-89,146,-190,146,-339v0,-134,-32,-237,-153,-237v-93,0,-155,55,-160,148v13,43,62,56,120,76v8,36,-45,47,-78,60v-41,16,-101,27,-153,27v-8,-9,-16,-10,-29,-10v-77,-53,-106,-171,-48,-267v68,-112,194,-197,370,-197v225,0,383,121,383,361v0,207,-113,365,-216,495v44,21,89,38,151,38v42,-12,56,-77,88,-100v24,2,33,19,31,50v-5,98,-31,239,-154,232v-103,-6,-167,-59,-235,-104xm345,-233v-32,-28,-102,-43,-147,-25v-12,5,-19,12,-19,20v0,30,32,47,65,47v28,0,62,-14,101,-42","w":927},"3":{"d":"396,16v-211,-1,-340,-77,-350,-279v-7,-156,189,-155,286,-93v19,13,26,25,0,34v-37,13,-93,24,-93,73v0,72,23,124,90,126v152,5,198,-233,95,-323v-41,-35,-102,-50,-174,-57v-35,-3,-60,-13,-60,-42v0,-48,18,-93,66,-95v99,-5,172,-62,172,-156v0,-50,-33,-82,-89,-82v-50,0,-107,36,-77,82v4,13,35,22,40,37v-14,28,-72,35,-107,41v-53,-5,-67,-53,-67,-114v0,-290,576,-251,576,0v0,131,-70,202,-174,240v142,38,229,142,229,315v0,141,-105,222,-217,267v-44,17,-93,26,-146,26","w":831},"4":{"d":"120,-192v-48,0,-37,-67,-18,-106v11,-23,25,-48,42,-74r70,-194v9,-30,19,-60,26,-90r47,-204r26,-132v38,-66,181,-68,273,-51v16,3,33,10,36,24v-36,238,-127,431,-211,625r124,3r77,-242v16,-62,72,-94,144,-97v143,-7,57,159,31,234r-28,82v54,-8,106,-22,158,-23v19,0,24,19,24,40v-1,66,-11,120,-60,133r-166,-5v-10,56,-38,126,-7,180v22,38,63,74,77,117v-1,9,-4,10,-15,10v-130,0,-314,49,-304,-109v4,-68,19,-139,35,-202v-154,-3,-242,81,-381,81","w":927},"5":{"d":"396,16v-211,-1,-340,-77,-350,-279v-7,-156,189,-155,286,-93v19,13,26,25,0,34v-37,13,-93,24,-93,73v0,72,23,126,90,126v133,0,226,-127,177,-267v-35,-101,-187,-91,-298,-119v-65,-42,-37,-177,-48,-283v-9,-86,-1,-178,34,-217v15,-17,29,-17,55,-15v123,8,283,70,381,-4v66,-13,84,61,82,132v-37,78,-134,94,-234,119v-84,-4,-136,-36,-219,-28r28,166v296,-32,528,52,512,342v-8,152,-118,237,-241,285v-49,18,-103,28,-162,28","w":831},"6":{"d":"425,0v-247,0,-390,-143,-390,-400v0,-310,183,-504,370,-652v84,-66,171,-122,275,-160v81,-29,163,42,116,119v-9,16,-24,32,-46,46v-181,112,-345,276,-429,485v-58,143,-78,395,108,395v131,0,187,-131,196,-265v6,-88,-47,-166,-120,-122v-46,28,-54,102,-87,144v-7,8,-15,12,-24,12v-27,-38,-21,-136,4,-181v43,-79,121,-138,235,-138v158,0,241,108,241,275v0,199,-115,334,-261,403v-55,26,-118,39,-188,39","w":928},"7":{"d":"102,-739v-38,-2,-31,-63,-25,-98v28,-155,84,-275,247,-275v135,0,211,76,371,76v53,0,89,-7,126,-10v70,-6,73,83,60,149v-27,37,-82,65,-121,93v-164,213,-236,490,-320,778v-18,64,-89,82,-169,82v-68,0,-138,-40,-123,-121v57,-315,240,-539,396,-767v-102,-22,-175,-82,-300,-52v-60,28,-78,132,-142,145","w":608},"8":{"d":"384,128v-203,-4,-352,-80,-352,-290v0,-214,139,-304,272,-390v-122,-66,-208,-257,-120,-403v63,-105,195,-164,357,-164v151,0,292,47,292,192v0,234,-143,332,-299,411v101,83,228,157,228,330v0,160,-102,247,-227,291v-46,15,-96,23,-151,23xm422,-399v-89,44,-182,90,-182,218v0,73,36,130,102,130v105,0,164,-74,164,-186v0,-77,-44,-119,-84,-162xm499,-996v-105,0,-163,81,-139,193v13,65,41,123,80,164v81,-58,177,-138,177,-259v0,-67,-51,-98,-118,-98","w":801},"9":{"d":"491,-532v12,0,10,9,10,21v0,85,-51,157,-115,183v-227,92,-384,-159,-320,-408v51,-199,180,-352,426,-352v168,0,283,94,340,222v59,132,36,344,-12,477v-99,276,-314,452,-582,557v-77,30,-164,-32,-116,-108v10,-16,23,-34,46,-46v243,-129,447,-297,447,-662v0,-124,-19,-249,-138,-249v-128,0,-185,140,-185,275v0,81,32,144,106,151v42,4,67,-51,93,-61","w":927},":":{"d":"484,0v-106,0,-164,-54,-164,-162v0,-116,63,-189,183,-191v108,-1,169,56,169,162v0,116,-64,191,-188,191xm544,-672v-106,0,-164,-54,-164,-162v0,-116,63,-189,183,-191v108,-1,169,56,169,162v0,116,-64,191,-188,191","w":704},";":{"d":"424,176v-74,42,-156,-11,-131,-104r84,-309v17,-55,67,-84,137,-84v94,0,188,58,150,155v-43,111,-123,199,-187,295v-15,23,-34,36,-53,47xm544,-672v-106,0,-164,-54,-164,-162v0,-116,63,-189,183,-191v108,-1,169,56,169,162v0,116,-64,191,-188,191","w":768},"<":{"d":"1039,-205v0,87,-117,90,-199,63v-117,-38,-232,-94,-347,-133v-143,-49,-256,-88,-348,-160v-59,-47,-87,-97,-87,-191v0,-173,174,-185,298,-237r398,-169r226,-86v107,-33,154,60,154,156v0,56,-34,75,-78,90r-802,259r655,240v62,30,130,80,130,168","w":1184},"=":{"d":"483,-382v-75,-3,-134,-32,-134,-108v0,-145,204,-116,353,-116r837,-1v50,0,82,16,82,62v0,131,-107,163,-246,163r-892,0","w":1707},">":{"d":"362,-122v-83,28,-199,25,-199,-63v0,-81,41,-136,90,-168r685,-260r-722,-219v-44,-15,-78,-34,-78,-90v1,-96,46,-189,154,-156v22,7,52,15,86,29r568,231v93,37,188,67,188,192v0,168,-95,222,-216,284v-120,61,-310,122,-446,181v-38,17,-75,27,-110,39","w":1184},"?":{"d":"558,0v-106,0,-164,-54,-164,-162v0,-116,63,-189,183,-191v108,-1,169,56,169,162v0,116,-64,191,-188,191xm556,-1250v-84,33,-147,-37,-147,-120v0,-57,51,-94,86,-126v91,-83,256,-137,416,-86v137,43,247,139,250,318v6,326,-213,420,-376,578v-30,29,-58,62,-74,102v-20,51,-47,98,-103,98v-45,0,-89,-18,-88,-64v4,-305,263,-364,368,-566v20,-37,29,-80,29,-129v0,-103,-71,-154,-170,-154v-73,0,-122,68,-153,119v-9,15,-24,24,-38,30","w":1292},"@":{"d":"1733,-7v82,-38,127,50,98,131v-5,16,-13,27,-22,32v-238,137,-551,228,-913,228v-362,0,-621,-116,-734,-359v-101,-216,-32,-517,44,-709v131,-330,354,-588,650,-758v217,-125,600,-167,866,-56v266,110,461,344,410,736v-33,251,-172,452,-337,586v-82,66,-186,121,-320,122v-134,2,-138,-167,-112,-291v-66,133,-157,249,-299,293v-246,77,-449,-68,-444,-326v5,-237,110,-419,228,-562v130,-157,302,-301,573,-301v41,0,75,6,68,49v71,29,193,-6,207,91v41,284,-148,493,-148,761v0,27,7,51,32,51v108,0,163,-95,210,-175v56,-97,98,-221,98,-368v0,-361,-192,-544,-544,-544v-332,0,-534,191,-684,392v-140,189,-260,421,-260,723v0,315,259,386,592,389v299,2,547,-44,741,-135xm1486,-1029v-76,-20,-156,-18,-222,20v-173,99,-288,287,-348,497v-36,126,-32,291,111,285v146,-6,214,-115,273,-213v25,-41,42,-92,55,-138","w":2241},"A":{"d":"1368,32v-196,1,-203,-246,-166,-431v-98,196,-236,356,-441,433v-188,70,-394,1,-494,-100v-119,-120,-171,-358,-117,-587v79,-338,254,-610,480,-807v166,-145,365,-268,659,-268v61,0,109,10,101,73v57,39,163,5,203,67v73,115,30,344,-3,483v-13,55,-26,110,-42,166r-130,434r-7,161v3,49,-8,102,36,106v149,-28,253,-122,374,-181r51,195v-105,104,-243,199,-408,244v-33,8,-65,12,-96,12xm1399,-1517v-98,-27,-213,-28,-305,12v-302,130,-479,413,-608,719v-87,206,-140,635,162,626v180,-5,283,-117,368,-226v78,-101,139,-225,175,-359","w":1632},"B":{"d":"581,-892v-9,-126,151,-73,248,-75v184,-4,323,-64,389,-181v32,-57,49,-136,7,-188v-157,-196,-633,-197,-931,-124v-96,24,-191,63,-234,130v-49,75,-82,138,-116,177v-34,39,-62,59,-83,59v-29,0,-44,-34,-44,-101v0,-348,246,-485,553,-528v392,-55,761,48,990,217v75,55,144,127,144,236v0,214,-146,325,-322,387v-74,26,-163,40,-267,42v198,1,328,93,372,240v100,338,-115,595,-402,665v-258,63,-546,-17,-750,-86v-36,-12,-71,-22,-71,-71v2,-496,44,-969,248,-1266v99,-69,189,-71,251,33v-180,252,-211,658,-211,1082v0,29,5,61,21,75v170,65,447,66,578,-37v77,-61,139,-147,137,-283v-3,-232,-270,-206,-428,-285v-44,-22,-74,-55,-79,-118","w":1292},"C":{"d":"384,-472v2,255,115,408,366,408v318,0,492,-170,688,-302v102,-69,205,-141,328,-187r0,215v-156,74,-260,208,-394,308v-172,128,-383,226,-687,222v-299,-4,-468,-185,-547,-416v-108,-314,11,-659,127,-889v142,-281,338,-528,644,-643v172,-65,386,-31,493,68v102,94,171,290,110,474v-70,210,-213,373,-413,452v-105,42,-311,49,-319,-69v-5,-73,-2,-175,79,-147v124,44,266,-20,333,-89v63,-64,121,-156,120,-277v-2,-143,-78,-224,-224,-224v-190,0,-299,126,-392,245v-144,184,-248,420,-298,693v-10,57,-14,110,-14,158","w":1440},"D":{"d":"-123,-1195v0,-390,282,-541,672,-541v458,0,765,158,841,528v75,364,-60,695,-222,913v-154,208,-385,389,-752,348v-104,-12,-198,-46,-274,-87v-17,-9,-18,-30,-18,-59v0,-496,44,-969,248,-1266v99,-69,189,-71,251,33v-161,220,-179,583,-229,910v-5,32,-7,61,-8,86v-3,96,-26,209,94,202v241,-14,385,-148,492,-300v106,-151,192,-342,192,-581v0,-246,-123,-395,-309,-459v-205,-70,-509,-28,-655,60v-36,22,-61,48,-80,78v-48,76,-89,133,-120,174v-31,41,-58,62,-79,62v-29,0,-44,-34,-44,-101","w":1272},"E":{"d":"1477,-250v-194,198,-468,346,-840,346v-251,0,-439,-86,-527,-254v-58,-110,-61,-277,-10,-400v88,-211,295,-322,596,-329v-213,-1,-349,-89,-409,-241v-35,-88,-39,-204,-1,-289v95,-211,327,-309,626,-309v251,0,465,77,568,230v46,68,80,173,28,249v-40,59,-108,123,-192,123v-14,0,-21,-12,-21,-37v0,-76,21,-136,46,-215v-113,-76,-294,-125,-482,-125v-183,0,-337,53,-337,235v0,253,318,201,463,316v35,28,39,81,39,139v0,78,-22,107,-103,107v-237,0,-443,29,-531,176v-24,40,-38,85,-38,138v-1,182,101,262,279,262v241,0,434,-88,592,-182v74,-44,143,-100,185,-167"},"F":{"d":"1728,-864v-4,72,-26,95,-110,98r-539,17v-58,372,-132,728,-442,845v-156,59,-411,36,-492,-68v-11,-15,-17,-32,-17,-51v0,-69,37,-144,110,-144v113,0,189,71,308,71v103,0,137,-119,175,-208v56,-131,91,-290,123,-445v-113,-2,-268,18,-268,-83v0,-67,83,-64,137,-75r178,-35v16,-71,29,-133,38,-186r64,-386v-141,42,-260,104,-319,218v-15,28,-20,57,-20,84v0,55,-45,77,-110,76v-87,-2,-161,0,-161,-80v0,-223,124,-348,285,-430v339,-171,948,-155,1406,-87v56,8,90,41,90,95v0,64,-29,120,-95,120v-267,0,-606,-67,-889,-26r-49,377v-7,58,-14,127,-22,207r555,0v55,-1,67,43,64,96","w":1376},"G":{"d":"1269,-25v-137,131,-309,222,-584,217v-299,-5,-469,-185,-547,-416v-105,-309,-1,-682,118,-896v142,-257,354,-466,644,-566v86,-30,173,-44,260,-44v251,0,375,155,375,414v0,123,-56,237,-162,253v-89,-5,-116,-121,-79,-200v10,-22,18,-48,18,-78v0,-117,-53,-200,-154,-200v-235,0,-389,143,-510,287v-156,186,-264,443,-264,782v0,255,115,408,366,408v228,0,395,-67,541,-162v9,-34,20,-70,20,-108v2,-67,-35,-86,-101,-86v-86,0,-155,-36,-155,-115v0,-133,217,-119,321,-89v118,35,161,131,160,283v-4,371,-90,691,-258,901v-121,151,-428,238,-642,116v-32,-18,-61,-46,-61,-91v0,-69,37,-144,110,-144v128,0,261,140,367,23v105,-115,172,-309,217,-489","w":1536},"H":{"d":"370,-1373v-16,-10,-16,-58,-16,-92v0,-132,95,-201,184,-257v88,-55,195,-102,326,-102v224,0,352,121,352,352v0,218,-80,408,-134,596r491,-28v34,-111,72,-227,113,-346v41,-119,84,-235,130,-350v27,-65,69,-121,149,-125v115,-6,123,125,88,221r-155,430r-50,155r219,-15v107,-21,131,135,36,152v-100,18,-200,21,-305,32v-37,133,-77,272,-77,414v0,89,34,152,123,145v105,-8,166,-78,240,-140v38,-32,79,-72,124,-117r75,191v-123,128,-257,244,-435,301v-272,87,-450,-112,-410,-405v17,-121,52,-248,82,-363r-502,49r-192,544v-33,71,-68,118,-96,150v-81,91,-237,24,-206,-101v51,-203,124,-385,192,-573v-193,-2,-340,-70,-340,-250v0,-29,10,-44,31,-44v47,9,64,45,101,86r291,-4r69,-179v41,-118,97,-227,97,-377v0,-102,-31,-177,-133,-177v-170,0,-270,105,-384,192v-25,19,-45,33,-78,35","w":2111},"I":{"d":"1154,-1618v4,129,-147,118,-275,114r-118,490r-95,422r-112,435v88,7,189,21,237,70v43,45,6,83,-55,119r-804,-2v-33,-2,-40,1,-22,-12v26,-19,54,-46,58,-89v11,-33,69,-48,111,-61v52,-15,127,-26,185,-31r184,-761r58,-221r54,-189v0,0,34,-107,49,-150v-117,12,-214,43,-304,82v-5,-32,-24,-126,3,-162v101,-136,322,-166,567,-166v106,0,179,5,238,34v32,16,40,39,41,78","w":863},"J":{"d":"2127,-256v-105,0,-202,-42,-296,-81v-101,415,-272,760,-559,977v-118,89,-305,167,-472,88v-151,-72,-224,-242,-224,-472v0,-356,204,-599,427,-766v89,-66,189,-115,299,-149v-151,-125,-307,-266,-374,-461v-109,-319,66,-629,262,-774v110,-81,297,-134,438,-47v214,132,292,423,292,789v0,214,-15,408,-45,590r321,188v21,16,63,40,36,68v-25,26,-55,50,-105,50xm856,176v-49,145,-31,348,120,351v44,0,95,-18,150,-58v143,-105,245,-283,328,-488v51,-125,94,-273,129,-445r-37,-23v-295,66,-488,270,-620,501v-31,55,-52,109,-70,162xm1627,-725v27,-243,56,-564,22,-819v-19,-140,-98,-279,-248,-210v-118,54,-197,173,-235,310v-48,173,36,313,119,416v93,113,214,212,342,303","w":1952},"K":{"d":"1760,-160v152,0,265,-76,359,-146r116,196r-72,44v-115,63,-252,130,-429,130v-268,0,-334,-222,-422,-412r-56,-128v-38,-83,-79,-164,-136,-228v-63,243,-147,442,-282,588v-115,125,-267,199,-496,175v-68,-6,-140,-19,-184,-48v-84,-56,11,-164,65,-199v9,-5,19,-8,28,-8v48,13,91,37,148,36v146,-4,230,-99,294,-205v184,-304,234,-768,288,-1203v-277,6,-428,149,-489,368v-10,36,-12,70,-12,103v0,55,-56,73,-124,73v-90,0,-164,-14,-164,-96v0,-448,429,-608,913,-608v76,0,126,26,126,96v0,223,-37,424,-47,640v258,2,470,-23,566,-184v61,-103,74,-265,74,-440v0,-75,53,-80,128,-80v103,0,126,55,126,167v0,322,-63,559,-287,655v-119,51,-267,74,-447,74v88,206,157,465,304,598v32,29,71,42,112,42","w":1920},"L":{"d":"-92,-129v-67,-11,-100,-91,-84,-169v6,-31,40,-42,64,-58r164,-110r95,-68v48,-516,208,-933,499,-1196v85,-77,181,-142,310,-142v234,0,263,284,200,499v-99,336,-313,589,-552,795v-67,58,-137,107,-210,152r-6,187v3,41,48,38,94,38v30,0,70,-7,121,-22r351,-99v124,-21,149,176,58,217v-186,83,-381,149,-635,155v-187,4,-245,-131,-246,-316v-78,55,-151,113,-223,137xm928,-1472v9,-71,15,-182,-53,-182v-71,0,-120,69,-165,129v-157,212,-266,505,-298,847r106,-116v141,-163,284,-340,374,-551v18,-45,31,-87,36,-127","w":992},"M":{"d":"-25,-1201v-21,-12,-36,-60,-27,-89v56,-180,129,-325,280,-392v34,-15,69,-20,101,-20v277,0,222,386,179,614r-60,320v81,-325,203,-622,400,-826v66,-68,139,-130,249,-130v220,0,229,288,193,502r-17,130r21,-1v69,-256,177,-481,377,-593v87,-48,200,-69,279,-8v220,170,133,663,68,945v-31,132,-67,267,-76,413v-6,91,59,139,132,100v116,-62,180,-170,255,-282r77,197v-81,138,-168,258,-322,304v-228,68,-416,-66,-396,-314v27,-329,149,-595,149,-944v0,-94,3,-197,-86,-197v-92,0,-147,68,-189,139v-194,324,-254,797,-344,1231v-14,67,-74,102,-156,102v-173,0,-98,-243,-70,-386r40,-194v14,-70,28,-141,40,-214v21,-129,43,-276,43,-414v0,-122,11,-256,-103,-264v-64,14,-104,79,-142,143v-173,287,-299,655,-391,1025v-17,73,-30,142,-39,206v-10,71,-69,99,-146,99v-69,0,-133,-22,-135,-88v-3,-138,45,-253,65,-363v12,-67,26,-130,36,-190v10,-60,19,-118,26,-174v7,-56,16,-113,20,-170r30,-395v-1,-29,-7,-57,-36,-57v-88,0,-150,73,-207,126v-26,24,-49,52,-70,81v-7,19,-25,28,-48,28","w":2175},"N":{"d":"87,-1224v-35,63,-125,3,-129,-51v54,-176,123,-328,266,-399v32,-16,65,-22,96,-22v303,0,275,350,213,594v-14,54,-27,109,-43,166r-49,169r17,6v107,-311,213,-582,392,-791v85,-99,172,-176,333,-176v158,0,217,143,217,301v0,337,-128,614,-128,960v0,134,17,276,148,276v177,0,284,-147,386,-243v31,-29,60,-63,77,-86r60,217v-116,149,-271,275,-479,331v-131,35,-262,-5,-324,-76v-91,-104,-134,-266,-134,-457v0,-321,166,-518,166,-822v0,-63,-6,-145,-69,-145v-79,0,-127,74,-169,141v-223,350,-345,822,-501,1246v-24,64,-69,99,-146,99v-141,0,-148,-179,-119,-313r86,-396v12,-59,22,-116,32,-171v10,-55,19,-110,27,-166v8,-56,17,-112,21,-171r16,-211v-1,-29,-7,-56,-36,-57v-79,17,-124,89,-170,150v-22,29,-38,63,-57,97","w":1623},"O":{"d":"474,131v-292,-146,-427,-523,-364,-961v55,-385,226,-684,494,-864v157,-106,457,-153,660,-58v234,110,368,342,368,679v0,456,-167,819,-406,1056v-117,116,-270,207,-484,209v-99,0,-188,-20,-268,-61xm447,-1025v-73,173,-134,431,-67,653v53,178,166,320,386,320v193,0,299,-118,380,-242v138,-211,230,-485,230,-818v0,-199,-63,-354,-192,-426v-97,-53,-228,-45,-328,8v-190,102,-321,296,-409,505","w":1632},"P":{"d":"266,98v-204,-307,-231,-970,-64,-1346v107,-241,267,-440,514,-534v159,-60,384,-50,536,4v214,78,380,230,380,498v0,260,-157,414,-346,511v-78,39,-168,67,-273,83v-9,211,-3,425,-69,586v-58,141,-139,266,-276,326v-91,40,-210,40,-288,-14v-42,-29,-82,-66,-114,-114xm883,-1326v68,-49,227,-43,206,69v-21,112,-59,212,-70,336v169,-26,298,-95,355,-225v54,-125,2,-265,-73,-332v-106,-96,-377,-153,-549,-72v-368,173,-441,735,-372,1276v13,100,40,193,86,254v41,55,124,54,169,6v125,-133,128,-406,130,-660v-87,-36,-150,-59,-202,-106v-31,-27,-35,-56,-37,-108v-2,-52,10,-119,62,-93r81,41v31,13,56,23,86,30v0,-9,1,-26,1,-52v5,-151,34,-296,127,-364","w":1441},"Q":{"d":"1444,224v89,-4,118,97,102,180v-85,103,-205,187,-352,232v-80,24,-185,23,-251,-12v-134,-72,-176,-237,-235,-382v-12,-30,-26,-52,-42,-67v-381,-72,-570,-361,-570,-803v0,-451,161,-804,403,-1030v120,-112,279,-198,497,-198v334,0,514,200,592,468v109,371,1,820,-144,1080v-124,223,-297,412,-594,456v80,76,133,171,228,225v54,30,125,27,180,-4v67,-38,116,-79,165,-136v7,-5,14,-8,21,-9xm571,-1305v-127,232,-242,571,-161,911v43,179,144,330,356,330v186,0,286,-120,362,-244v131,-215,216,-493,216,-824v0,-221,-51,-406,-184,-492v-90,-58,-216,-50,-311,7v-116,71,-208,184,-278,312","w":1512},"R":{"d":"1601,-128v141,0,237,-84,319,-158r116,196r-72,46v-114,67,-250,140,-429,140v-225,0,-264,-230,-314,-420v-14,-52,-23,-104,-33,-154v-19,-88,-41,-172,-80,-230v-28,-41,-68,-36,-128,-36v-25,260,-53,500,-130,687v-57,139,-135,249,-306,249v-186,0,-286,-114,-360,-238v-115,-194,-157,-526,-82,-798v117,-418,390,-711,798,-839v188,-58,442,-63,611,10v166,72,313,183,313,410v0,200,-130,313,-273,391v-99,54,-223,88,-371,96v196,67,254,262,300,478v17,79,32,170,121,170xm1050,-1200v0,81,-24,163,-31,254v190,-2,333,-38,437,-107v88,-59,148,-181,88,-296v-54,-104,-178,-155,-341,-155v-443,0,-671,248,-801,567v-101,247,-133,702,54,865v45,39,131,66,174,14v125,-151,127,-443,137,-709v-52,-25,-92,-48,-119,-69v-27,-21,-40,-46,-40,-74v1,-39,8,-79,48,-79v41,0,99,14,140,17r4,-65v15,-117,42,-237,167,-243v61,-3,83,27,83,80","w":1700},"S":{"d":"1351,-1034v0,-112,106,-179,106,-297v0,-170,-185,-206,-369,-206v-158,0,-281,48,-334,146v-69,127,36,236,120,293v240,162,584,239,720,506v48,95,51,239,9,342v-102,249,-352,378,-693,378v-276,0,-490,-100,-600,-276v-71,-113,-73,-324,16,-410v34,-33,78,-63,133,-66v58,-2,86,46,71,108v-20,84,-32,197,11,271v107,182,498,182,680,66v79,-50,155,-120,155,-237v0,-112,-68,-176,-140,-230v-229,-172,-578,-243,-722,-498v-54,-96,-52,-225,2,-326v100,-187,316,-290,612,-290v235,0,413,104,506,255v111,180,0,429,-126,511v-63,41,-157,47,-157,-40","w":1695},"T":{"d":"360,-1202v-98,-1,-161,-44,-161,-128v0,-266,235,-334,474,-370v396,-59,860,-31,1235,37v54,10,87,41,87,94v0,62,-46,109,-110,109v-249,0,-473,-51,-719,-61v-85,499,-235,967,-360,1429v-21,76,-63,148,-145,156v-91,9,-143,-58,-125,-156v74,-398,217,-727,330,-1084r114,-345r-108,9v-134,15,-269,32,-332,116v-13,19,-20,41,-20,66v0,82,-62,129,-160,128","w":1536,"k":{"o":384}},"U":{"d":"1423,-1728v85,-1,114,48,113,135v0,521,-88,962,-270,1293v-100,181,-228,323,-404,407v-150,72,-359,68,-493,-7v-370,-206,-295,-973,-163,-1386v39,-122,61,-251,137,-324v20,-20,43,-21,77,-22v101,-5,177,22,154,129v-21,101,-54,170,-83,273r-49,174v-44,171,-90,361,-90,568v0,236,65,424,299,424v108,0,179,-63,233,-136v243,-326,328,-836,364,-1368v7,-109,64,-159,175,-160","w":1382},"V":{"d":"312,33v-260,0,-207,-312,-224,-548r-48,-681r-9,-240v-1,-107,39,-163,141,-163v95,0,118,57,121,150r44,1189r651,-1250v25,-70,87,-120,178,-120v88,0,89,124,58,210v-103,288,-257,553,-392,812v-14,27,-24,60,-24,98v0,138,108,199,257,199v70,0,115,-50,162,-82v33,-23,65,-51,99,-82r-23,207v-90,69,-191,142,-320,145v-197,4,-310,-119,-279,-325v-66,153,-124,276,-210,378v-50,60,-97,103,-182,103","w":1056},"W":{"d":"2330,-125v-113,0,-158,-78,-172,-183v-88,161,-195,305,-364,376v-101,42,-229,38,-308,-22v-171,-129,-208,-456,-174,-750v-42,264,-100,473,-218,628v-86,112,-200,172,-378,172v-114,0,-183,-81,-232,-173v-158,-293,-104,-867,2,-1181v43,-127,75,-290,176,-352v66,-41,219,-43,202,68v-55,350,-224,649,-224,1045v0,131,19,253,89,311v81,67,182,-10,225,-64v109,-137,181,-329,241,-518v57,-178,103,-382,149,-609v22,-111,60,-191,192,-191v102,0,137,41,120,152r-48,314v-10,68,-18,138,-26,210v-8,72,-16,142,-21,212v-12,168,-17,348,21,479v16,57,41,105,102,105v110,0,168,-94,212,-184v161,-325,216,-780,249,-1226v8,-109,62,-158,175,-158v77,0,113,38,112,118v-8,394,-167,718,-167,1068v0,93,47,146,139,146v113,0,170,-94,209,-183r17,207v-78,88,-171,183,-300,183","w":2399},"X":{"d":"1741,-1257v-45,-16,5,-136,-38,-155v-45,7,-79,42,-112,77v-122,127,-229,286,-331,434v21,80,37,154,53,222v34,143,51,315,109,435v25,52,61,84,133,85v41,0,86,-20,136,-60v50,-40,105,-106,164,-197v10,-10,21,-15,34,-15v71,0,126,113,73,174v-108,127,-227,240,-388,301v-103,39,-226,23,-290,-32v-105,-91,-143,-245,-188,-413v-20,-76,-40,-167,-62,-270r-472,702v-29,41,-94,74,-162,74v-80,0,-134,-32,-137,-100v-2,-68,69,-142,107,-189r586,-719v-44,-205,-62,-451,-216,-545v-35,-21,-81,-41,-116,-6v-55,56,-118,132,-156,210v-26,53,-54,20,-65,-18v-14,-50,-28,-113,-29,-174v-5,-218,143,-327,368,-284v288,55,376,312,443,604v124,-185,269,-367,435,-506v51,-42,103,-82,171,-88v108,17,136,141,141,260v5,122,-75,192,-191,193","w":1696},"Y":{"d":"335,-1289v0,32,17,90,-24,81v-62,-13,-69,-107,-80,-180v-5,-34,-6,-69,-6,-106v0,-74,73,-102,158,-102v181,0,291,102,384,214v117,141,204,332,287,518r214,-404r143,-280v17,-32,72,-54,122,-54v114,0,135,116,86,214v-17,34,-37,81,-65,137v-28,56,-60,119,-98,188r-125,221r-205,336r-148,196v-99,121,-181,230,-308,304v-66,38,-166,60,-247,23v-72,-32,-142,-78,-171,-148v-14,-34,-1,-83,41,-66v63,48,175,45,252,11v187,-83,267,-284,359,-459r-72,-175v-68,-157,-143,-314,-244,-432v-46,-54,-97,-104,-178,-108v-51,-2,-75,23,-75,71","w":1472,"k":{"o":149}},"Z":{"d":"74,-51v-68,2,-125,-38,-121,-105v5,-83,60,-130,111,-196r734,-960r-98,2v-118,1,-203,-38,-290,-64v-188,-57,-149,233,-301,267v-45,-2,-36,-71,-30,-112v18,-148,58,-258,125,-337v44,-50,95,-77,169,-77v157,0,250,89,431,87r206,-2r135,-10v83,-3,87,94,72,170v-11,18,-29,34,-56,48v-285,276,-511,588,-713,935v-26,45,-39,47,-45,86r115,53v54,22,114,52,183,53v197,4,316,-84,436,-159v93,-58,199,79,140,170v-140,107,-323,224,-564,232v-165,-30,-293,-99,-445,-165v-54,48,-114,81,-194,84","w":1025},"[":{"d":"353,192v-132,6,-195,-67,-171,-198r46,-252r70,-444r94,-713v31,-145,99,-252,280,-252r318,0v62,2,98,47,98,106v0,68,-62,118,-130,118r-286,0r-213,1411r286,0v61,2,103,63,71,122v-27,49,-72,102,-145,102r-318,0","w":927},"\\":{"d":"1159,-55v6,106,-136,110,-209,67v-33,-19,-66,-43,-83,-76v-85,-165,-157,-326,-225,-480r-186,-432r-271,-646v-17,-38,-28,-75,-30,-121v-5,-110,111,-151,195,-95v73,49,102,157,139,240r631,1401v20,48,37,89,39,142"},"]":{"d":"735,-1667v132,-6,196,66,171,198r-46,251r-70,445r-94,713v-31,145,-99,252,-280,252r-308,0v-67,-3,-101,-50,-108,-112v7,-64,55,-112,119,-112r297,0r213,-1411r-260,0v-58,-6,-99,-43,-105,-101v9,-66,52,-123,125,-123r346,0","w":927},"^":{"d":"257,-532v-106,74,-199,-55,-138,-172r237,-452v54,-114,121,-211,268,-182v81,16,124,76,161,149v81,156,159,331,228,509v38,98,-38,212,-135,156v-43,-25,-74,-71,-94,-118r-206,-482r-260,521v-19,34,-40,56,-61,71","w":1089},"_":{"d":"128,0v-75,-3,-134,-32,-134,-108v0,-145,203,-116,352,-116r838,-1v50,0,82,16,82,62v0,131,-107,163,-246,163r-892,0"},"`":{"d":"496,-1203v32,61,-17,149,-82,107v-68,-44,-114,-124,-164,-189r-149,-192v-101,-113,25,-283,163,-218v18,9,30,27,40,49","w":609},"a":{"d":"627,-161v-73,77,-170,163,-312,163v-212,0,-293,-222,-230,-437v63,-220,190,-405,383,-493v60,-28,152,-52,192,0v18,42,68,49,132,45v56,-4,73,34,72,93v-4,160,-64,302,-64,466v0,52,0,100,45,100v85,0,133,-72,182,-121v34,-35,66,-77,99,-122r48,222v-61,83,-150,175,-251,223v-37,18,-73,27,-110,27v-108,0,-148,-77,-186,-166xm332,-418v-19,89,-28,218,66,226v116,-21,149,-169,172,-282r61,-294v-109,7,-168,83,-217,156v-37,55,-66,122,-82,194","w":928},"b":{"d":"528,0v-210,0,-359,-77,-496,-152v2,-54,6,-115,12,-183v5,-59,13,-127,22,-207v9,-80,22,-169,38,-267v11,-65,24,-139,40,-219v50,-244,116,-501,220,-691v53,-96,115,-197,234,-201v192,-7,240,139,234,329v-8,252,-142,430,-256,594v-45,65,-93,124,-140,181r16,11v37,-47,72,-83,102,-113v89,-89,225,-14,276,53v85,110,79,357,18,488v-12,29,-28,58,-48,89v109,-63,216,-118,301,-208r77,165v-126,118,-277,192,-474,235v-46,41,-113,70,-176,96xm672,-607v10,-150,-189,-148,-265,-65v-87,95,-101,282,-119,447v73,17,183,61,250,13v99,-72,123,-230,134,-395xm640,-1648v0,-36,-13,-79,-51,-80v-42,9,-65,60,-84,106v-88,211,-138,476,-185,727r128,-225r66,-124v59,-118,126,-244,126,-404","w":950},"c":{"d":"382,-698v-81,135,-124,506,98,506v87,0,160,-58,222,-104v72,-55,149,-133,203,-201r69,116v-115,156,-231,307,-432,365v-318,91,-533,-175,-466,-518v35,-182,123,-333,275,-402v37,-16,78,-24,123,-24v153,0,262,82,262,231v0,97,-41,178,-134,185v-91,7,-73,-89,-73,-168v0,-28,-1,-55,-27,-56v-60,0,-97,31,-120,70","w":736},"d":{"d":"654,-178v-90,82,-187,174,-346,178v-274,7,-302,-383,-190,-586v89,-161,225,-292,446,-319v13,-351,97,-657,251,-866v57,-77,127,-149,237,-149v162,0,184,194,169,366v-34,402,-214,673,-339,990v-19,47,-29,110,-30,173v-2,84,23,174,112,139v106,-41,178,-107,262,-175r30,231v-102,76,-194,143,-324,186v-20,6,-38,9,-55,9v-116,0,-183,-80,-223,-177xm312,-435v-32,104,-30,232,94,224v66,-4,97,-59,126,-104v20,-30,36,-65,51,-104v-14,-96,-6,-235,-15,-337v-125,61,-212,181,-256,321xm1044,-1592v0,-54,-1,-88,-37,-96v-59,8,-85,82,-104,144v-69,229,-95,499,-95,791v38,-87,73,-173,105,-259r41,-116v46,-136,90,-290,90,-464","w":1072},"e":{"d":"356,-303v29,49,54,91,126,91v206,0,351,-139,470,-243r129,134v-137,136,-281,257,-497,307v-337,78,-547,-167,-483,-522v33,-182,120,-330,271,-398v38,-16,80,-25,126,-25v159,0,263,91,263,250v0,169,-124,267,-243,339v-49,30,-104,51,-162,67xm552,-599v43,-51,27,-159,-32,-169v-153,7,-182,144,-187,298v96,-7,170,-71,219,-129","w":787},"f":{"d":"535,-397v73,141,157,319,120,535v-32,185,-83,366,-223,443v-56,30,-144,34,-195,-2v-226,-161,-169,-624,-138,-965v8,-81,18,-168,31,-258v13,-90,28,-183,46,-278v53,-274,125,-545,252,-740v65,-100,148,-194,289,-194v134,0,212,88,212,232v0,186,-81,336,-149,480v-92,193,-210,380,-335,541r-2,16v22,-10,28,-15,51,-16v30,-1,38,16,66,16v186,-2,314,-66,409,-153r-22,243v-114,62,-253,92,-412,100xm326,-420v-36,205,-45,525,-12,727v7,43,12,64,40,72v110,-22,103,-194,103,-322v0,-171,-39,-347,-96,-472v-12,-27,-28,-44,-35,-5xm747,-1529v0,-58,-11,-102,-56,-102v-72,0,-89,41,-113,98v-97,233,-153,439,-179,717r235,-434v46,-94,113,-182,113,-279","w":723},"g":{"d":"160,928v-134,0,-232,-57,-224,-199v9,-149,102,-251,181,-351v113,-143,255,-273,397,-390r27,-93v-76,68,-193,142,-319,87v-93,-41,-158,-129,-158,-263v0,-257,131,-441,277,-568v67,-59,152,-108,262,-109v74,-1,57,86,144,76r45,-1v115,1,71,164,57,261r-33,233v-14,92,-30,190,-48,295v153,-90,248,-219,358,-373r48,222v-62,100,-162,177,-255,249v-56,43,-118,84,-183,124v-50,274,-124,532,-290,688v-70,65,-160,112,-286,112xm147,641v-20,41,-29,95,25,95v111,0,162,-98,206,-180v47,-87,80,-195,102,-300v-136,97,-257,230,-333,385xm332,-418v-19,89,-28,218,66,226v116,-21,149,-169,172,-282r61,-294v-109,7,-168,83,-217,156v-37,55,-66,122,-82,194","w":928},"h":{"d":"214,0v-98,0,-97,-121,-97,-223v0,-45,0,-103,1,-175v1,-72,5,-153,10,-241v25,-397,77,-801,236,-1067v68,-114,161,-208,323,-214v200,-7,201,212,159,385v-83,338,-246,621,-393,899r20,14v91,-115,188,-237,307,-320v82,-57,194,-44,190,74v-7,203,-119,325,-120,533v0,42,11,84,43,88v93,-9,152,-66,207,-115v37,-33,73,-73,108,-116r17,266r-107,80v-86,56,-175,132,-305,132v-154,0,-214,-152,-214,-306v0,-144,70,-268,123,-368r-21,-3v-153,144,-293,366,-389,579v-22,49,-35,98,-98,98xm336,-710v101,-248,242,-524,312,-788v19,-70,26,-122,26,-155v0,-51,-7,-76,-20,-76v-17,0,-44,28,-77,85v-43,73,-123,228,-151,361v-8,40,-19,78,-26,117r-38,223v-11,79,-20,157,-26,233","w":1025},"i":{"d":"282,0v-130,6,-190,-72,-186,-201v7,-237,85,-458,136,-662v17,-68,99,-94,182,-97v125,-4,57,140,37,214r-64,234v-16,68,-35,147,-35,222v0,52,4,98,51,98v110,0,186,-98,257,-159r76,-65r0,203v-113,94,-261,205,-454,213xm461,-1089v-109,2,-172,-53,-172,-152v0,-105,78,-167,196,-167v99,0,170,40,170,140v0,115,-74,177,-194,179","w":537},"j":{"d":"488,-384v61,160,111,369,74,588v-25,147,-74,292,-176,365v-67,48,-186,55,-249,-2v-120,-109,-137,-330,-137,-567v0,-286,79,-578,150,-820v29,-98,78,-144,203,-140v56,2,76,47,61,103v-29,109,-61,213,-98,313v130,-18,242,-20,362,-58v52,-16,114,-38,186,-70r0,192v-106,57,-229,90,-376,96xm394,-1089v-109,2,-172,-53,-172,-152v0,-105,78,-167,196,-167v99,0,170,40,170,140v0,115,-74,177,-194,179xm286,-447v-33,202,-63,408,-62,639v0,80,12,143,46,182v59,36,90,-56,100,-115v44,-262,-24,-500,-84,-706","w":672},"k":{"d":"244,0v-118,0,-125,-111,-126,-230v0,-38,1,-88,4,-151v3,-63,7,-132,12,-207v5,-75,13,-153,22,-235v9,-82,19,-162,32,-239r18,-100v50,-246,121,-492,268,-644v54,-56,122,-99,221,-101v201,-4,189,231,151,405v-62,279,-183,531,-302,750r-119,178r24,15r163,-206v80,-91,140,-198,307,-195v121,2,170,155,119,266v-57,124,-171,214,-230,337v-29,59,-36,161,52,151v64,-7,102,-59,142,-98v46,-46,89,-105,132,-152r60,245v-86,114,-224,203,-411,211v-171,7,-260,-93,-229,-262v20,-111,74,-193,138,-276v26,-34,71,-53,82,-101v1,-52,-38,-58,-73,-25v-17,16,-38,40,-59,77r-294,516v-26,44,-47,71,-104,71xm347,-685r205,-609r86,-229v13,-40,27,-84,28,-127v2,-52,-55,-31,-76,-12v-64,59,-101,172,-131,265v-68,210,-92,462,-112,712","w":991},"l":{"d":"727,-1920v180,0,158,259,123,418v-85,386,-306,665,-456,992v-32,70,-44,196,7,254v28,32,81,-3,113,-18v93,-43,162,-99,244,-163r82,210v-130,90,-249,169,-416,217v-143,42,-208,-63,-254,-165v-96,-213,-84,-564,-23,-816v72,-298,173,-587,339,-787v60,-73,132,-142,241,-142xm663,-1594v0,-27,3,-63,-11,-70v-61,12,-99,77,-130,139v-97,191,-165,442,-170,725v121,-228,311,-487,311,-794","w":575},"m":{"d":"223,0v-179,0,-135,-266,-109,-424r40,-250v8,-39,15,-76,24,-108v18,-66,25,-122,62,-160v28,-29,127,-24,160,-4v35,62,6,189,-6,266r-19,122r11,12r131,-224v40,-63,75,-119,125,-163v61,-53,181,-24,179,67v-3,118,-39,207,-55,308r11,12r139,-224v40,-62,76,-116,123,-162v58,-57,183,-22,183,66v0,185,-46,321,-46,505v0,73,19,146,92,113v100,-46,166,-118,235,-198r17,236v-117,92,-212,210,-417,210v-126,0,-128,-172,-128,-312v0,-92,7,-188,17,-276r-15,0r-203,517v-30,49,-64,71,-132,71v-136,0,-100,-224,-81,-344r37,-241r-15,0v-94,160,-169,347,-255,515v-23,46,-49,70,-105,70","w":1312},"n":{"d":"255,0v-160,0,-129,-207,-119,-362v4,-58,12,-116,20,-176v8,-60,16,-117,27,-172v25,-122,23,-250,157,-250v176,0,60,272,56,416r20,0r174,-322v36,-62,81,-94,164,-94v111,0,113,147,93,257r-31,167v-8,53,-16,114,-16,170v-2,79,21,172,98,133v99,-50,166,-125,246,-202r17,224v-124,86,-224,211,-423,211v-37,0,-67,-27,-92,-80v-57,-120,-38,-357,-10,-511r-16,0r-262,520v-23,46,-46,71,-103,71","w":927},"o":{"d":"742,-749v72,127,74,346,8,481v-67,138,-163,268,-356,268v-238,0,-330,-199,-330,-437v0,-240,109,-405,278,-483v107,-50,261,-52,378,-10v176,62,300,191,407,324r-19,141v-93,-115,-234,-208,-358,-295xm608,-551v0,-106,-18,-208,-117,-217v-112,17,-159,138,-187,245v-36,141,-24,329,129,331v98,-20,135,-139,161,-238v11,-42,14,-82,14,-121","w":873},"p":{"d":"68,778v-170,0,-197,-173,-197,-349v0,-171,91,-302,154,-429v43,-86,97,-173,155,-264r22,-160v33,-214,78,-423,241,-506v39,-20,85,-30,140,-30v194,3,293,109,293,309v0,250,-164,365,-346,452r6,21v266,-1,432,-108,555,-251r11,229v-93,105,-235,230,-426,198r-242,-41v1,327,-65,612,-229,764v-43,40,-90,57,-137,57xm205,-20v-67,127,-119,294,-143,461v5,47,20,103,68,108v65,-23,58,-136,61,-218xm410,-279v133,-67,223,-170,262,-325v18,-74,4,-176,-77,-170v-126,9,-147,143,-169,262v-13,71,-16,152,-16,233","w":854},"q":{"d":"384,-160v-177,23,-287,-84,-330,-218v-82,-257,75,-471,262,-548v54,-23,108,-34,164,-34v230,0,318,181,257,396r-88,308r13,56v88,29,160,-38,220,-78v34,-22,64,-48,95,-73r79,-65r0,224v-91,87,-198,164,-355,186v17,96,36,218,35,326v-3,240,-86,416,-320,416v-170,0,-218,-181,-176,-364v41,-179,96,-359,144,-532xm544,-736v-32,-42,-114,-38,-160,-7v-156,64,-188,441,32,455xm410,433v-12,54,-20,102,28,111v124,-12,138,-154,138,-288v0,-99,-10,-209,-32,-289r-78,255v-12,39,-23,77,-32,113v-9,36,-18,69,-24,98","w":832},"r":{"d":"288,-6v-205,44,-165,-249,-142,-429v6,-43,12,-88,20,-133v8,-45,16,-87,25,-128v9,-41,16,-78,26,-112v17,-59,25,-107,61,-140v35,-18,133,-28,134,30r4,242r11,0v47,-95,95,-194,178,-254v68,-49,199,-37,195,64v-3,74,-32,153,-32,229v0,70,18,125,82,125v119,0,198,-74,273,-131r-15,234r-59,38v-64,38,-134,83,-231,83v-198,0,-231,-171,-255,-346r-16,0r-179,499v-22,55,-36,104,-80,129","w":864},"s":{"d":"130,-190v-65,12,-138,13,-130,-66v7,-66,59,-96,96,-128r91,-80v140,-128,229,-295,355,-435v30,-33,69,-60,131,-61v80,0,134,22,128,96v-7,82,-95,130,-128,192v3,119,52,185,59,305v2,31,5,68,5,111v112,-71,248,-109,352,-192r1,224v-168,121,-393,233,-669,233v-160,0,-276,-53,-291,-199xm385,-160v175,0,139,-232,96,-352r-257,256v55,22,80,96,161,96","w":865},"t":{"d":"335,-46v-183,-150,-196,-554,-156,-882r-129,-22v-35,-8,-126,-4,-138,-42v-7,-12,-8,-29,-8,-45v31,-83,194,-39,303,-51v52,-246,130,-498,274,-644v60,-61,135,-82,207,-36v74,48,112,148,112,269v0,188,-101,315,-177,444r299,12v30,2,37,34,38,68v1,41,-29,78,-64,79r-384,0r-113,148r-13,328v-8,137,69,229,200,186v148,-49,275,-143,374,-246r0,256r-171,98v-107,55,-186,126,-320,126v-51,0,-96,-15,-134,-46xm640,-1490v0,-41,-9,-79,-53,-78v-17,0,-35,15,-53,46v-64,115,-102,293,-136,442r61,7r63,-111v47,-93,118,-189,118,-306","w":801},"u":{"d":"253,2v-191,0,-175,-227,-143,-418r52,-312v28,-101,57,-231,174,-231v53,0,91,7,99,42r-97,599v2,47,13,93,58,93v90,0,132,-84,149,-169r99,-508v20,-72,232,-84,232,7v0,188,-84,360,-84,543v0,60,-7,129,53,129v139,0,237,-108,325,-183v19,-16,33,-33,44,-48r2,220v-101,93,-235,173,-389,214v-29,7,-57,10,-82,10v-119,-4,-143,-104,-168,-205v-65,83,-140,160,-241,201v-28,11,-56,16,-83,16","w":962},"v":{"d":"823,-145v-135,0,-219,-73,-232,-197v-57,115,-131,240,-221,320v-50,44,-122,41,-165,4v-91,-79,-74,-283,-83,-436v-8,-130,-18,-307,0,-422v6,-38,20,-60,41,-63r139,-21v42,-2,74,29,72,66r-39,633r14,-1r263,-627v20,-98,244,-95,244,13v0,152,-125,213,-125,378v0,85,45,134,135,129v93,-5,161,-61,228,-103r0,235v-74,47,-166,92,-271,92","w":907},"w":{"d":"1216,-145v-151,0,-249,-67,-253,-218v-58,132,-119,263,-226,336v-34,23,-87,49,-105,5v-48,-118,-36,-305,-40,-467r-29,-5v-51,184,-122,359,-246,458v-88,70,-178,43,-209,-79v-54,-210,-82,-716,86,-828v53,-34,188,-22,179,48r-70,541r13,-1r136,-338v59,-128,92,-260,266,-266v51,-1,98,20,91,64r-83,541r15,-1r239,-534v29,-85,274,-107,274,13v0,161,-110,255,-165,378v27,67,64,140,150,140v102,0,176,-68,249,-114r0,235v-74,47,-166,92,-272,92","w":1301},"x":{"d":"1216,-234v-116,106,-267,234,-480,234v-27,0,-62,-19,-104,-56v-42,-37,-86,-96,-134,-179r-82,93v-44,48,-84,98,-137,124v-150,73,-225,-97,-227,-254r146,-194v5,83,-30,211,58,215v44,-14,69,-70,95,-107r50,-72v-46,-108,-88,-223,-122,-351v15,-66,83,-110,157,-115v68,-5,72,67,91,112r55,131v73,-77,156,-149,250,-211v26,-18,52,-29,87,-31v112,-3,118,177,41,223v-106,63,-196,149,-280,236v37,72,73,148,128,196v47,42,113,-2,158,-24v94,-46,184,-114,248,-190","w":1025},"y":{"d":"160,928v-134,0,-232,-57,-224,-199v9,-149,102,-251,181,-351v113,-143,255,-273,397,-390r27,-93v-76,68,-193,142,-319,87v-93,-41,-156,-129,-158,-263v-1,-231,52,-396,128,-551v25,-51,85,-88,150,-92v69,-4,101,58,74,124v-53,130,-96,302,-96,476v0,67,13,129,78,132v116,-21,145,-170,172,-282r70,-294v23,-82,89,-136,186,-141v47,-3,80,26,70,77r-56,294r-72,444v153,-90,248,-219,358,-373r48,222v-62,100,-162,177,-255,249v-56,43,-118,84,-183,124v-50,274,-124,532,-290,688v-70,65,-160,112,-286,112xm147,641v-20,41,-29,95,25,95v111,0,162,-98,206,-180v47,-87,80,-195,102,-300v-136,97,-257,230,-333,385","w":928},"z":{"d":"210,-70v-112,45,-211,-38,-175,-154v21,-37,60,-52,86,-87r311,-418v-36,-13,-54,-37,-100,-39v-77,-4,-111,12,-140,60v-28,46,-47,81,-90,93v-38,-2,-31,-63,-25,-98v28,-155,84,-275,247,-275v89,0,124,76,230,76v58,0,116,0,157,-10v70,-1,73,83,60,149v-13,22,-41,34,-80,44v-105,164,-236,321,-353,474r-5,20v59,24,148,63,227,33v87,-33,141,-101,215,-144v89,-51,170,66,108,146v-78,99,-213,163,-357,198v-37,8,-71,12,-104,12v-77,-15,-144,-46,-212,-80","w":673},"{":{"d":"209,-632v-104,-1,-84,-165,-43,-226v20,-29,46,-62,88,-62v171,0,233,-106,233,-256r0,-208v30,-186,114,-336,254,-408v122,-62,318,-32,439,12v54,19,125,39,125,111v0,91,-71,145,-179,128v-108,-17,-276,-69,-331,33v-116,214,-45,640,-307,727v179,36,144,310,116,492r-16,115v-13,106,-23,230,87,230v102,0,153,-69,251,-74v100,-5,122,144,56,200v-95,82,-251,130,-412,130v-244,0,-288,-267,-242,-510r36,-208v9,-126,-32,-225,-155,-226","w":1153},"|":{"d":"625,24v-125,42,-168,-93,-148,-221r238,-1499v15,-91,72,-160,177,-160v105,0,98,136,83,234r-225,1494v-11,79,-61,130,-125,152"},"}":{"d":"1175,-766v45,95,4,250,-102,254v-115,4,-177,70,-193,166v-36,212,-60,435,-178,562v-71,76,-164,143,-307,122v-117,-17,-242,-48,-308,-118v-15,-17,-23,-36,-23,-57v2,-88,55,-151,134,-151v105,0,173,110,287,60v138,-102,106,-402,185,-573v35,-76,81,-141,170,-160v-97,-35,-138,-124,-138,-255v0,-149,46,-292,46,-434v0,-82,-16,-139,-96,-138v-102,0,-195,28,-293,32v-103,4,-105,-151,-33,-192v113,-64,260,-96,431,-96v183,0,259,140,259,329v0,165,-58,306,-61,472v-2,105,58,142,163,143v26,1,46,11,57,34"},"~":{"d":"288,-1394v-58,31,-143,12,-142,-57v1,-42,28,-80,45,-111v43,-81,127,-184,255,-142v68,22,113,88,162,136r102,101v56,-54,77,-159,181,-163v68,-4,102,64,69,126v-54,101,-127,247,-286,200v-68,-20,-113,-88,-162,-136r-102,-101r-48,63v-22,29,-42,67,-74,84","w":864},"\u00a0":{"w":545}}});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael) {/*!
	 * The following copyright notice may not be removed under any circumstances.
	 * 
	 * Copyright:
	 * Copyright (c) 2011 by Brian J. Bonislawsky DBA Astigmatic (AOETI). All rights
	 * reserved. Available under the Apache 2.0 licence.
	 * http://www.apache.org/licenses/LICENSE-2.0.html
	 */
	Raphael.registerFont({"w":750,"face":{"font-family":"yellowtail","font-weight":400,"font-stretch":"normal","units-per-em":"2048","panose-1":"2 0 5 3 0 0 0 0 0 0","ascent":"1638","descent":"-410","x-height":"27","cap-height":"30","bbox":"-500.063 -1737.03 2285 617","underline-thickness":"41","underline-position":"-432","unicode-range":"U+0020-U+007E"},"glyphs":{" ":{"w":425},"!":{"d":"373,-106v0,73,-92,172,-165,172v-39,0,-58,-22,-58,-64v0,-79,88,-166,164,-166v39,0,59,19,59,58xm452,-344v-30,0,-27,12,-59,12v-25,0,-37,-13,-37,-38v0,-45,58,-158,172,-342v114,-184,226,-354,336,-512v110,-158,180,-250,211,-273v25,-19,97,-3,134,0v24,2,32,12,21,29r-690,1071v-26,40,-39,53,-88,53","w":670},"\"":{"d":"530,-909v-15,0,-57,-41,-53,-61v15,-68,139,-333,176,-404v15,-31,38,-47,68,-47v50,0,87,13,90,53v-20,85,-125,274,-182,356v-47,68,-79,103,-99,103xm742,-968v-13,-14,190,-391,180,-402v5,-31,33,-47,84,-47v51,0,76,13,76,40v0,107,-126,293,-184,375v-43,61,-69,91,-79,91v-51,0,-77,-19,-77,-57","w":692},"#":{"d":"306,-365v-63,0,-153,8,-166,-41v1,-12,37,-30,39,-44v10,-19,104,-64,142,-64v26,0,52,-1,79,-4r38,-66v35,-65,65,-113,89,-145v-39,1,-69,2,-93,2v-43,0,-120,-22,-77,-57v27,-22,21,-34,65,-56v60,-30,123,-19,199,-26v42,-52,169,-252,205,-301v16,-22,26,-33,32,-33v13,0,37,63,37,81v0,13,-6,33,-19,57r-103,190r145,-5r180,-278v8,-8,13,-12,16,-12v20,5,54,73,54,109v0,25,-27,84,-82,177v47,6,106,-11,128,23v25,23,63,54,14,74v-67,27,-79,10,-211,24r-138,228r163,3v18,4,44,37,59,47v24,15,18,45,-13,56v-87,29,-106,15,-284,29v-63,133,-113,210,-113,292v0,13,-5,19,-14,19v-44,-17,-91,-102,-91,-160v0,-18,17,-64,50,-139v-27,1,-88,6,-181,14v-78,135,-130,235,-155,301v0,21,-6,31,-17,31v-51,-15,-82,-116,-57,-177v22,-56,53,-99,80,-149xm554,-522r153,-6v43,-81,87,-155,131,-224r-151,13","w":1112},"$":{"d":"629,-590v121,35,236,65,236,200v0,88,-95,165,-169,203v-103,53,-204,84,-304,93v-71,154,-67,184,-112,227v-40,20,-114,21,-119,-25v-3,-7,-4,-13,-4,-18v0,-5,29,-72,87,-199v-63,-22,-94,-59,-94,-110v0,-69,52,-129,116,-129v44,0,44,14,44,49v0,15,4,24,12,28r96,-196v-111,-25,-184,-60,-184,-156v0,-108,78,-188,153,-240v89,-62,190,-110,302,-145v75,-149,126,-247,151,-293v10,-34,110,-66,149,-67v17,0,26,8,26,25v-38,83,-109,210,-154,298v118,2,178,27,178,93v-1,93,-37,119,-101,153v-57,31,-112,34,-149,0v-22,-21,16,-51,18,-72v-20,3,-33,5,-39,5xm402,-658v10,32,47,27,92,39r92,-184v-49,25,-92,53,-129,84v-37,31,-55,51,-55,61xm472,-273v58,-11,107,-25,144,-47v96,-57,68,-85,-65,-114","w":889},"%":{"d":"280,-522v-65,-83,-40,-194,12,-306v66,-143,168,-272,290,-358v61,-43,116,-65,167,-65v58,0,120,104,111,168v-26,176,-141,362,-242,471v-76,82,-156,126,-245,129v-37,1,-70,-10,-93,-39xm370,27v-60,-1,-44,-186,-8,-217v3,-4,50,-59,141,-166r409,-460r376,-416v18,-18,48,-30,48,16v0,52,-2,75,-16,110v-9,24,-83,110,-217,259v-256,287,-485,562,-686,825v-9,13,-28,55,-47,49xm382,-660v0,25,7,37,20,37v94,0,173,-111,219,-186v44,-71,108,-191,108,-275v0,-25,-4,-37,-13,-37v-26,0,-66,27,-120,81v-80,79,-214,250,-214,380xm895,27v-85,-1,-141,-65,-133,-159v19,-230,177,-431,331,-544v60,-43,115,-65,166,-65v79,0,132,106,93,192v-26,57,11,65,-12,125v-64,167,-172,331,-323,417v-42,24,-83,34,-122,34xm902,-150v0,25,7,37,20,37v40,0,85,-31,137,-91v77,-89,171,-255,180,-386v0,-14,-4,-21,-13,-21v-26,0,-65,27,-117,81v-78,80,-207,251,-207,380","w":1366},"&":{"d":"828,-854v53,-16,81,56,86,85v-21,67,-107,77,-176,95r-119,238v99,-33,292,-133,339,-196v15,-20,24,-32,33,-32v29,-2,56,56,56,85v0,43,-25,89,-75,138v-92,94,-275,183,-441,199v-65,147,-101,226,-109,239v-23,36,-130,36,-131,-13v-3,-7,-4,-14,-4,-24v0,-10,31,-79,93,-206v-88,-18,-161,-79,-161,-177v0,-115,71,-210,214,-284v-115,-64,-98,-198,-6,-285v100,-95,237,-160,416,-190v80,-157,122,-238,125,-243v7,-33,110,-68,142,-68v43,0,35,27,16,64r-126,241v63,3,117,29,117,87v0,114,-138,169,-250,169xm413,-453v0,30,13,47,40,50r101,-203v-94,47,-141,98,-141,153xm517,-838v14,36,103,6,149,7r82,-162v-57,24,-109,53,-158,87v-49,34,-73,56,-73,68","w":924},"'":{"d":"530,-909v-15,0,-80,-40,-74,-60v0,-26,69,-161,207,-405v18,-31,51,-47,97,-47v46,0,69,13,69,37v0,99,-131,285,-193,371v-50,69,-84,104,-106,104","w":391},"(":{"d":"1355,-1661v27,0,43,77,41,100v-3,42,-29,44,-72,59v-384,138,-684,508,-836,886v-80,199,-119,400,-128,600v-5,122,23,244,36,326v12,86,-30,85,-75,38v-63,-67,-150,-211,-148,-307v10,-538,197,-935,455,-1229v173,-198,373,-345,598,-442v47,-21,90,-31,129,-31"},")":{"d":"-87,369v-77,0,-124,-52,-124,-111v0,-38,37,-46,77,-50v79,-8,166,-53,262,-130v199,-158,355,-378,480,-617v112,-215,208,-508,211,-807r-8,-203v2,-91,6,-92,116,-95v17,0,32,31,41,96v28,193,19,424,-34,629v-104,405,-307,760,-551,1021v-77,82,-159,146,-241,194v-82,48,-158,73,-229,73"},"*":{"d":"928,-937v1,44,-22,101,-62,101v-18,0,-30,-14,-44,-36r-84,-134v-68,113,-109,170,-123,170v-15,1,-53,-25,-53,-42v0,-10,20,-56,63,-138v-78,15,-129,23,-153,23v-24,0,-35,-6,-35,-17v0,-53,69,-102,207,-147r-33,-43v-26,-13,-59,-69,-59,-104v0,-32,19,-64,54,-62v43,1,107,100,136,141v23,-42,42,-86,60,-131v14,-35,43,-51,83,-51v30,0,51,9,52,34v0,11,-24,60,-72,148v91,-20,144,-36,158,-49v7,-11,14,-16,21,-16v14,-2,27,37,26,51v0,69,-68,124,-205,164v38,51,60,68,63,138"},"+":{"d":"760,-928v-7,76,-86,160,-113,221v109,5,178,7,207,7v80,0,83,46,52,86v-16,33,-37,63,-87,61r-237,-10v-40,84,-52,191,-82,283v-46,27,-65,-46,-96,-70v-8,-10,-21,-25,-12,-43v26,-52,54,-125,69,-172v-101,3,-164,4,-187,4v-48,0,-74,-19,-60,-53v18,-42,20,-105,79,-105v53,0,125,2,215,6r108,-191v26,-43,19,-79,72,-87v27,-4,74,35,72,63","w":850},",":{"d":"285,-148v110,0,125,125,69,197v-31,40,-143,140,-199,144v-34,3,-47,-19,-64,-26v-10,-4,-9,-35,1,-39v8,-4,77,-103,79,-114v-53,-67,39,-162,114,-162","w":487},"-":{"d":"214,-399v-45,0,-82,-37,-54,-77v22,-32,13,-44,50,-77v48,-42,54,-32,135,-39v38,-3,76,-5,114,-8v50,-4,136,-10,171,0v12,7,28,50,39,59v27,38,-12,86,-49,91r-179,22v-68,10,-151,29,-227,29","w":650},".":{"d":"375,-98v0,72,-79,161,-153,161v-48,0,-72,-24,-72,-73v0,-72,79,-157,142,-156v55,0,83,23,83,68","w":475},"\/":{"d":"-105,250v-57,-13,-62,-155,-47,-219v58,-118,151,-227,270,-373v89,-109,188,-222,297,-340r295,-317r606,-628v7,-6,14,-9,20,-9v17,0,25,28,25,84v0,43,-7,71,-25,100v-105,166,-609,699,-845,956v-261,285,-447,518,-554,697v-8,13,-20,54,-42,49","w":775},"0":{"d":"232,27v-106,3,-173,-70,-173,-178v0,-159,86,-324,164,-444v147,-226,349,-455,586,-585v68,-37,125,-55,168,-55v117,0,160,115,128,245v-10,43,-34,98,-77,165v6,73,-8,90,-46,167v-93,189,-246,378,-400,515v-88,79,-213,166,-350,170xm245,-264v-13,54,7,117,57,117v38,0,85,-22,142,-66v97,-75,210,-199,340,-372v-75,53,-154,37,-154,-59v0,-29,9,-48,29,-55v134,-47,282,-195,282,-347v0,-21,-16,-32,-45,-32v-29,0,-76,29,-144,88v-145,127,-287,304,-394,481v-58,96,-97,177,-113,245","w":875},"1":{"d":"137,4v-8,4,-74,37,-80,12v-26,-48,-32,-59,-66,-82v36,-100,461,-793,538,-888v-32,20,-75,61,-101,73v-19,-5,-15,-38,-28,-51v-11,-18,-5,-22,2,-44v35,-53,155,-153,222,-200v53,-37,88,-57,106,-57v34,0,90,57,87,91v-38,76,-263,422,-339,546v-207,342,-321,542,-341,600","w":467},"2":{"d":"899,-1235v102,-5,158,76,158,149v0,44,-21,98,-63,162v-88,138,-245,300,-371,420r-356,340v172,-34,291,-51,358,-51v38,0,38,20,52,37v18,22,50,131,0,145v-70,19,-500,58,-570,58v-14,0,-36,-8,-67,-23v-11,-10,-31,-51,-30,-72v0,-11,6,-30,19,-55v2,-5,44,-52,125,-141v38,-43,293,-262,332,-310v31,-38,91,-99,174,-185v83,-86,144,-153,184,-201v40,-48,60,-81,60,-101v0,-13,-10,-19,-29,-19v-64,0,-112,35,-167,70v-87,55,-169,139,-248,250v-4,3,-6,10,-6,21v-6,23,-51,45,-76,46v-40,-9,-100,-18,-89,-74v28,-142,165,-249,273,-333v79,-61,221,-127,337,-133","w":770},"3":{"d":"202,25v-82,0,-133,-63,-137,-132v-3,-54,64,-139,112,-137v10,0,16,11,18,32v5,40,22,60,52,60v123,-2,281,-78,359,-140v85,-67,108,-130,8,-175v-42,-19,-104,-27,-183,-27v-46,0,-61,-86,-33,-124v44,-60,131,-98,189,-142r124,-94v49,-38,77,-64,117,-106v36,-37,54,-68,54,-93v0,-15,-12,-22,-36,-22v-178,45,-400,205,-480,361v-44,35,-111,-39,-99,-83v38,-131,165,-229,273,-305v83,-58,215,-114,340,-117v96,-2,152,50,152,133v0,55,-32,123,-96,203v-64,80,-166,166,-306,258v100,-2,227,74,217,174v-19,190,-194,328,-357,405v-98,47,-195,71,-288,71","w":841},"4":{"d":"129,-466v0,-27,2,-45,6,-54v24,-56,103,-143,235,-261v132,-118,266,-225,400,-321v134,-96,219,-147,256,-153v28,15,68,10,82,41v8,18,24,30,17,49v-141,217,-257,406,-346,567v139,-14,215,-21,229,-21v14,0,20,3,20,9v0,13,-108,172,-127,168v-22,5,-96,13,-222,24r-242,438v-9,20,-44,38,-106,47v-43,6,-50,26,-76,1v-9,-8,-13,-17,-14,-25v30,-64,112,-213,246,-446v-207,15,-315,22,-325,22v-22,0,-33,-28,-33,-85xm317,-535v81,-15,171,-30,272,-43v93,-157,197,-316,312,-479v-71,59,-180,155,-327,289","w":900},"5":{"d":"450,-696v149,-31,341,4,341,162v0,231,-153,372,-304,468v-109,69,-212,103,-307,103v-115,0,-172,-53,-172,-158v0,-61,29,-134,84,-135v15,0,22,12,22,35v0,54,36,81,100,81v126,0,272,-90,346,-168v49,-51,74,-98,74,-145v0,-100,-284,-72,-354,-48v-20,0,-36,-58,-39,-75v31,-112,61,-140,173,-326v85,-141,137,-220,152,-237v15,-17,34,-26,56,-26v55,-13,188,-25,397,-49v26,-3,80,84,78,103v-4,39,-7,73,-49,82v-118,25,-298,41,-430,52","w":795},"6":{"d":"217,37v-87,0,-147,-83,-141,-185v14,-248,290,-669,518,-862v121,-102,364,-256,479,-256v55,0,82,31,82,94v0,29,-6,46,-18,50v-307,104,-505,256,-702,497v126,-87,226,-131,301,-131v72,0,138,57,134,140v-12,216,-152,377,-280,494v-89,81,-223,159,-373,159xm227,-164v0,34,11,51,33,51v153,-35,303,-188,384,-309v36,-53,51,-94,51,-120v0,-45,-23,-68,-60,-68v-91,0,-251,99,-303,149v-70,130,-105,229,-105,297","w":841},"7":{"d":"287,31v-29,53,-136,0,-140,-41v-4,-45,27,-84,41,-113v83,-178,319,-486,463,-665v103,-128,181,-216,234,-265r-543,54v-36,-3,-16,-29,-7,-57v19,-60,43,-47,107,-112v51,-52,72,-34,241,-50v121,-12,217,-13,286,-14r35,1v41,9,80,110,45,159r-44,62v-19,28,-74,101,-169,220v-227,285,-408,564,-549,821","w":700},"8":{"d":"253,31v-127,0,-233,-50,-233,-171v0,-119,90,-226,160,-298v77,-78,159,-148,248,-209v-36,-65,-58,-132,-47,-211v20,-142,120,-267,226,-338v117,-79,362,-89,362,62v0,7,-9,36,-27,85v5,-6,240,-176,228,-157v48,1,112,-21,112,36v0,18,-10,36,-30,54v-50,43,-155,118,-218,166r-386,302r-3,9v49,71,136,143,125,259v-23,249,-273,411,-517,411xm324,-136v130,-7,279,-92,287,-224v2,-41,-33,-98,-87,-161v-9,-12,-18,-19,-25,-20v-121,95,-204,179,-251,249v-67,100,-17,161,76,156xm872,-995v-87,-182,-330,-29,-330,133v0,31,9,69,26,114","w":820},"9":{"d":"393,-485v-74,0,-127,-52,-127,-131v0,-220,137,-357,264,-468v91,-80,291,-187,396,-188v112,0,168,56,168,167v0,80,-30,173,-89,279v-119,216,-295,413,-466,581v-88,86,-171,156,-250,209v-79,53,-139,79,-180,79v-44,0,-50,-31,-67,-67v-19,-40,-30,-70,16,-87v218,-80,429,-277,595,-460r-5,-6v-115,61,-200,92,-255,92xm950,-1059v0,-40,-23,-69,-56,-69v-46,0,-106,27,-180,81v-74,54,-140,115,-196,183v-56,68,-84,122,-84,161v0,29,19,43,56,43v57,0,153,-36,290,-108v54,-72,96,-133,126,-182v30,-49,44,-86,44,-109","w":818},":":{"d":"395,-98v0,72,-79,161,-153,161v-48,0,-72,-24,-72,-73v0,-72,79,-157,142,-156v55,0,83,23,83,68xm692,-649v0,69,-82,160,-153,160v-49,0,-73,-24,-73,-72v0,-72,80,-158,144,-158v55,0,82,23,82,70","w":692},";":{"d":"298,-148v108,0,131,123,72,197v-31,39,-143,140,-199,144v-34,3,-47,-19,-64,-26v-10,-4,-9,-35,1,-39v8,-4,77,-103,79,-114v-53,-66,39,-162,111,-162xm703,-649v0,70,-81,160,-154,160v-48,0,-72,-24,-72,-72v0,-77,78,-158,154,-158v48,0,72,23,72,70","w":703},"<":{"d":"541,-332v0,23,-52,192,-78,185v-44,-12,-34,-41,-47,-107v-30,-152,-57,-243,-114,-411v10,-66,118,-107,172,-145r225,-157r107,-87v10,-10,20,-15,29,-15v23,0,35,35,35,104v0,63,-7,67,-48,101v-49,41,-316,174,-372,217v9,60,64,235,83,273v5,9,8,23,8,42","w":700},"=":{"d":"242,-399v-53,3,-120,-27,-77,-73v30,-32,17,-42,71,-73v31,-18,55,-29,72,-30v166,-14,368,-20,489,-10v17,6,40,47,55,57v21,20,16,50,-13,66v-49,27,-49,17,-133,26r-144,16v-127,13,-234,16,-320,21xm365,-686v-53,3,-121,-28,-77,-73v31,-31,21,-44,71,-73v31,-19,55,-29,72,-30v169,-14,404,-21,530,-10v17,7,41,44,55,56v22,19,16,53,-14,68v-61,32,-56,16,-177,29v-216,24,-370,28,-460,33","w":879},">":{"d":"135,-293v-1,-68,158,-176,220,-211r212,-121v-23,-51,-84,-219,-99,-262v-20,-59,22,-103,39,-150v11,-18,45,-90,77,-65v18,147,50,310,106,465v19,53,8,89,-39,113v-163,82,-273,181,-414,276v-21,14,-46,53,-67,60v-23,0,-35,-35,-35,-105","w":700},"?":{"d":"491,-116v0,70,-90,172,-163,172v-39,0,-58,-20,-58,-60v0,-77,87,-170,164,-170v35,0,57,22,57,58xm525,-936v-67,0,-154,-61,-152,-123v5,-133,116,-232,217,-288v139,-77,277,-115,415,-115v161,0,277,47,355,137v111,129,35,348,-54,436v-166,164,-494,268,-646,424v-22,23,-29,52,-23,87v4,25,-23,41,-51,40v-65,-1,-125,-15,-125,-77v0,-63,29,-118,82,-170v78,-77,413,-264,506,-329v127,-89,193,-171,193,-252v0,-87,-74,-131,-223,-131v-137,0,-296,67,-377,137v-48,41,-73,80,-73,119v1,7,22,16,31,15v18,3,62,-50,64,-4v2,65,-71,94,-139,94","w":1098},"@":{"d":"642,44v-252,0,-442,-162,-442,-415v0,-345,208,-568,410,-748v193,-173,536,-343,828,-343v164,0,303,174,303,298v0,288,-145,501,-288,667v-64,74,-160,144,-275,149v-119,5,-161,-127,-117,-229v-48,63,-103,117,-165,161v-62,44,-116,65,-160,65v-87,0,-154,-80,-149,-168v10,-190,142,-322,261,-415v99,-76,190,-114,271,-114v58,0,78,16,94,55v20,-32,52,-48,97,-48v64,0,83,46,56,83v-55,74,-180,269,-180,394v0,37,9,56,27,56v27,0,67,-37,123,-110v84,-108,216,-340,224,-500v5,-98,-87,-169,-158,-169v-245,0,-477,119,-629,262v-250,234,-379,449,-379,653v0,149,126,252,283,255v139,2,305,-56,452,-162v41,2,26,80,18,117v-10,47,-62,93,-157,138v-95,45,-211,68,-348,68xm745,-523v0,14,6,21,18,21v83,0,173,-117,220,-180r193,-262v-49,-2,-109,23,-178,75v-69,52,-128,112,-178,180v-50,68,-75,123,-75,166","w":1471},"A":{"d":"187,24v-50,41,-127,-20,-127,-75v0,-67,86,-209,258,-428v-110,-1,-139,12,-195,12v-18,0,-27,-15,-27,-45v0,-83,115,-116,222,-116v41,0,84,-4,127,-5v235,-275,575,-628,868,-782v40,-21,53,-20,84,12v25,-48,30,-69,49,-69v19,0,117,63,107,92v10,34,-544,1243,-549,1238v-44,79,-45,88,-90,142v-29,35,-64,53,-107,53v-24,0,-55,13,-70,13v-21,0,-32,-5,-32,-15v23,-69,76,-163,237,-510v-157,-6,-294,-11,-413,-14v-114,143,-218,293,-310,450v-12,21,-22,38,-32,47xm660,-633v118,3,237,8,358,15r309,-644v-243,185,-466,394,-667,629","w":1203},"B":{"d":"316,22v-75,0,-116,-63,-87,-131v15,-85,603,-1010,651,-1056v24,-23,70,-39,145,-39v30,0,45,7,45,20v0,10,-44,85,-133,225v-89,140,-135,213,-139,220v188,-54,402,-155,538,-267v72,-59,109,-112,109,-159v0,-78,-85,-117,-254,-117v-207,0,-461,86,-605,205v-22,18,-32,33,-32,41v1,32,44,-15,45,16v-7,24,-71,64,-117,64v-63,0,-104,-40,-104,-101v0,-63,42,-126,124,-189v144,-112,411,-205,652,-206v162,0,283,26,362,79v79,53,118,123,118,212v0,113,-79,223,-236,329v-83,56,-172,101,-268,134v165,19,323,94,323,265v0,66,-33,132,-95,201v-113,125,-343,239,-572,238v-126,0,-219,-28,-278,-83v-47,-44,-49,-72,-25,-130v-49,88,-84,154,-107,199v-10,20,-30,30,-60,30xm1194,-526v-74,-47,-365,-65,-450,-20v-12,0,-25,-14,-40,-42v-63,101,-130,214,-199,338v31,-43,77,-65,137,-65v50,0,79,11,47,26v-26,12,-40,25,-40,45v0,48,51,72,153,72v138,0,265,-46,375,-144v96,-86,134,-137,17,-210","w":1400},"C":{"d":"452,4v-146,5,-296,-154,-288,-308v18,-339,198,-565,388,-753v143,-142,307,-256,507,-328v92,-33,179,-49,262,-49v94,-1,203,59,203,166v0,110,-114,236,-188,305v-74,69,-185,172,-289,172v-72,0,-147,-59,-109,-138v9,-19,16,-29,27,-29v-11,16,2,22,31,22v81,0,206,-132,262,-198v43,-51,65,-89,65,-114v0,-17,-12,-26,-35,-26v-63,0,-150,30,-260,88v-233,125,-441,315,-578,552v-73,127,-112,240,-112,341v0,86,46,145,136,139v206,-13,375,-154,507,-257v67,-52,135,-112,168,-163v1,-6,4,-9,9,-9v16,0,24,13,24,39v0,26,-5,69,-17,132v-8,42,-56,103,-144,180v-155,134,-320,227,-569,236","w":1164},"D":{"d":"557,-1008v-70,47,-187,35,-179,-66v8,-103,114,-184,206,-236v126,-73,332,-124,535,-124v214,0,379,44,501,126v194,131,226,355,125,581v-121,272,-368,461,-637,589v-199,95,-391,138,-574,138v-118,0,-158,-1,-196,-44v-21,-25,-38,-24,-38,-70v0,-26,1,-51,8,-72v63,-196,541,-864,670,-1041v7,-10,45,-22,113,-22v43,0,74,-3,74,27v0,10,-17,40,-52,88v-35,48,-146,218,-334,508v-188,290,-282,438,-282,446v0,8,30,12,89,12v372,0,662,-228,857,-442v110,-121,162,-232,162,-327v0,-219,-229,-343,-488,-343v-170,0,-393,80,-476,142v-35,26,-51,45,-51,54v9,22,50,-10,64,4v-4,9,-38,25,-44,36v-7,8,-26,18,-53,36","w":1607},"E":{"d":"288,-38v-110,-73,-131,-243,-60,-374v83,-151,237,-267,378,-352v-137,-31,-206,-102,-206,-212v0,-124,95,-237,286,-340v172,-93,437,-182,673,-121v62,16,117,119,57,179v-53,32,-149,66,-208,66v-67,0,-103,-9,-109,-26v1,-17,9,-37,22,-60v-202,13,-390,107,-496,216v-32,33,-48,61,-48,84v0,43,76,65,227,65v37,0,65,-4,83,-12v47,-23,106,-33,175,-33v107,2,122,39,86,114v-29,62,-16,51,-91,74v-71,22,-77,14,-141,26v-17,3,-30,3,-38,0v-221,109,-372,228,-455,358v-37,59,-56,109,-56,151v0,66,46,99,137,99v195,0,440,-169,564,-288v84,-81,128,-148,128,-207v0,-19,14,-28,42,-28v65,0,97,38,97,115v0,113,-97,205,-178,280v-148,137,-371,281,-628,292v-115,5,-173,-21,-241,-66","w":1232},"F":{"d":"540,25v-41,0,-128,-7,-128,-47v0,-10,3,-23,9,-41v16,-45,128,-217,336,-517v-163,12,-268,6,-369,33v-43,-5,-28,-63,-4,-92v46,-57,53,-100,160,-106v104,-6,217,-16,340,-17v133,-202,242,-352,326,-450v-125,23,-278,34,-459,34v-246,0,-369,-55,-369,-165v0,-71,86,-117,168,-117v48,0,72,6,72,17v0,6,-7,9,-22,9v-25,0,-62,27,-62,48v0,15,33,28,98,34v209,20,512,16,746,-26v89,-70,162,-123,290,-131v74,-4,107,37,116,80v-8,39,-51,70,-90,95v-67,42,-156,66,-265,74v-117,147,-237,314,-361,500v51,2,99,6,144,12v45,6,67,23,67,52v7,13,-51,57,-72,90v-11,16,-21,24,-31,24v-77,-7,-149,-8,-218,-6v-235,365,-356,556,-364,570v-14,24,-26,43,-58,43xm1619,-1434r39,-16v-11,3,-24,9,-39,16","w":1189},"G":{"d":"299,-45v-124,-2,-193,-90,-189,-225v6,-197,116,-371,224,-506v210,-261,502,-498,851,-618v111,-38,216,-56,315,-56v134,0,205,56,205,207v0,34,-22,75,-65,123v-83,93,-226,190,-350,240v53,-14,139,-9,147,34v0,5,-9,18,-27,39v-187,217,-359,432,-516,645v64,-50,121,-98,170,-143v27,-25,61,-37,100,-37v50,0,80,21,50,47v-111,97,-293,239,-545,426v-43,49,-153,165,-328,348v-31,32,-66,48,-104,48v-132,-3,-131,-65,-68,-148v44,-58,167,-126,303,-275r183,-200v164,-179,263,-293,297,-344v-176,166,-256,237,-445,337v-80,42,-151,58,-208,58xm1029,-930v-8,-40,60,-107,84,-109v23,-2,10,14,9,25v0,11,8,17,23,17v101,-4,278,-120,338,-180v43,-42,65,-76,65,-103v0,-23,-21,-35,-62,-35v-191,0,-378,102,-516,194v-244,162,-490,385,-632,639v-39,71,-58,132,-58,183v0,40,25,76,69,76v70,0,183,-54,339,-161v156,-109,355,-264,550,-454v17,-16,30,-31,45,-39v-55,22,-99,33,-134,33v-62,1,-120,-29,-120,-86","w":1295},"H":{"d":"236,-4v-8,-8,-9,-3,-19,0v-60,-2,-44,-53,-26,-99v34,-88,255,-396,301,-475r-116,-6v-51,1,-85,-90,-88,-148v-2,-33,29,-28,49,-20r205,9r57,-2v87,-136,190,-290,311,-461v-88,72,-186,108,-293,108v-89,0,-183,-48,-186,-129v-3,-67,67,-120,122,-121v25,0,38,4,38,12v2,5,-22,12,-21,19v6,28,73,44,114,41v144,-10,297,-129,392,-184v47,-27,116,-19,132,20v12,17,29,25,12,51r-412,637v178,0,370,-3,577,-10v251,-397,384,-605,398,-624v25,-32,35,-47,80,-47v54,0,133,-8,143,41v0,8,-8,25,-24,50r-120,186r-401,636r-313,518v-2,10,-15,4,-22,3v-37,10,-81,5,-122,15v-52,1,-58,-31,-41,-69v22,-48,125,-226,312,-531v-123,3,-245,5,-365,5r-215,-1r-145,241v-133,227,-203,341,-212,343v-24,12,-36,-6,-46,-15v-11,6,-35,10,-56,7","w":1536},"I":{"d":"36,30v-21,2,-50,-12,-58,-20v0,-33,1,-52,4,-59v14,-47,91,-181,231,-401r427,-642v145,-209,232,-328,264,-350v37,-26,107,-2,164,-10v21,-3,30,13,24,29v-319,469,-624,924,-893,1378v-28,47,-83,56,-119,64v-30,-4,-25,9,-44,11","w":574},"J":{"d":"125,602v-84,0,-130,-91,-125,-174v12,-195,181,-298,309,-394v135,-102,326,-192,482,-265r747,-1051v-45,-11,-77,-1,-164,16v-314,60,-639,249,-835,442v-106,104,-160,188,-160,253v0,64,71,112,133,112v86,0,173,-69,224,-98v3,0,5,5,5,14v1,153,-130,230,-275,230v-167,0,-327,-121,-271,-303v66,-215,282,-421,647,-621v218,-119,549,-224,860,-227v58,-1,112,51,90,113v-70,115,-175,239,-256,349v-43,57,-202,281,-477,674v29,-15,153,-69,188,-71v31,8,-1,56,-9,69v-61,97,-140,152,-262,202v-40,16,-66,30,-81,38v-180,265,-324,498,-545,636v-63,39,-140,56,-225,56xm143,414v0,15,12,22,35,22v69,0,149,-73,196,-117v91,-87,183,-206,261,-313v-328,203,-492,339,-492,408","w":1314},"K":{"d":"76,30v-12,2,-48,-31,-48,-45v0,-8,4,-22,14,-42v10,-20,133,-206,369,-557v-45,2,-90,-6,-86,-36v-3,-44,57,-110,101,-110v23,0,48,2,75,6r291,-438v-77,73,-151,109,-220,109v-63,0,-108,-54,-108,-113v0,-66,48,-110,95,-122v16,3,0,22,0,32v0,9,14,14,43,14v123,0,263,-176,382,-190v48,-6,56,16,85,27v10,9,12,19,25,29v15,12,13,36,3,52r-312,484v165,-86,354,-196,567,-330v213,-134,329,-213,345,-238v12,-19,35,-3,53,0v85,13,127,38,127,76v0,11,-4,20,-12,27v-302,259,-712,477,-1135,673v95,54,221,146,385,269v216,163,351,241,401,241v25,0,55,-23,65,-29v11,0,17,5,17,16v-1,23,-71,156,-90,167v-68,38,-129,18,-211,-29v-200,-115,-570,-443,-727,-510v-205,324,-310,492,-316,503v-16,40,-64,42,-118,42v-29,0,-34,19,-60,22","w":1468},"L":{"d":"1415,-129v83,0,123,-14,163,-35v11,6,3,19,-4,32v-8,15,-80,122,-97,130v-136,61,-432,15,-562,-22r-360,-101v-124,111,-272,166,-444,166v-104,0,-178,-22,-223,-66v-25,-24,-38,-66,-38,-127v0,-136,188,-194,374,-194v63,0,148,12,257,35v180,-205,364,-562,557,-785v61,-70,121,-135,186,-192v131,-117,261,-176,390,-176v104,0,162,57,162,146v0,175,-196,302,-322,382v-46,29,-82,43,-109,43v-48,0,-99,-56,-98,-99v-1,-32,7,-52,26,-57v6,0,10,4,11,11v64,-25,178,-118,231,-172v39,-38,58,-62,58,-72v-7,-27,-39,-13,-65,-2v-64,27,-129,90,-188,146v-186,177,-482,670,-638,874v342,90,586,135,733,135xm59,-155v0,21,46,31,76,30v65,0,127,-17,187,-51v-51,-7,-95,-10,-132,-10v-87,0,-131,10,-131,31","w":1476},"M":{"d":"576,-27v-54,42,-157,-13,-154,-77v42,-139,422,-858,510,-998v-308,335,-751,943,-919,1292v-22,46,-47,34,-101,21v-59,-14,-88,-44,-88,-84v0,-24,49,-109,147,-257v210,-314,489,-695,743,-990v192,-223,314,-336,369,-336v13,0,33,12,40,13v34,-37,159,-15,169,30v0,8,-33,72,-100,191v-223,396,-373,668,-450,816v188,-225,504,-561,744,-792v195,-189,312,-284,350,-284v51,0,124,33,177,28v24,3,51,30,33,53v-217,288,-399,542,-548,762v-149,220,-240,369,-275,446v66,-6,212,-133,333,-275v11,-13,23,-5,26,25v7,63,34,116,-7,169v-59,75,-314,304,-426,309v-84,4,-146,-59,-147,-133v0,-41,43,-133,130,-274v130,-210,296,-455,498,-736r-340,356v-407,427,-644,670,-714,725","w":1582},"N":{"d":"26,50v-25,2,-62,-19,-62,-40v0,-27,36,-106,110,-239v158,-284,370,-619,567,-887v107,-147,192,-245,249,-297v24,-22,56,-14,88,-8r73,-16v41,1,76,20,57,65r-192,942v151,-206,574,-800,662,-1018v21,-50,40,-83,111,-80v37,2,116,16,116,58v0,39,-59,152,-175,340v-199,323,-555,828,-775,1097v-18,22,-39,33,-65,33v-45,-1,-124,-13,-124,-61v0,-73,64,-426,193,-1057v-141,169,-609,904,-679,1086v-21,53,-26,67,-75,73","w":1325},"O":{"d":"1478,-1339v67,0,158,74,152,142v-19,206,-121,375,-220,527v-137,211,-319,406,-528,544v-145,96,-287,144,-426,144v-94,0,-174,-65,-215,-113v-48,-56,-71,-135,-71,-235v0,-100,34,-219,100,-354v135,-276,385,-534,658,-680v143,-76,278,-115,407,-115v56,0,137,37,95,93v-12,15,-26,43,-38,55v22,-5,51,-8,86,-8xm1091,-857v-19,1,-112,-100,-102,-130v0,-51,34,-110,103,-175v69,-65,146,-115,231,-149v-238,23,-509,226,-649,387v-91,105,-167,213,-224,326v-57,113,-86,205,-86,276v1,86,36,163,128,158v133,-7,265,-96,358,-174v213,-181,380,-381,500,-602v49,-91,73,-153,73,-188v0,-14,-5,-21,-14,-21v-82,0,-198,109,-249,168v-43,50,-65,69,-55,104v0,13,-5,20,-14,20","w":1306},"P":{"d":"505,-883v-92,2,-134,-57,-135,-145v0,-43,23,-89,71,-136v185,-181,505,-276,887,-276v148,0,271,30,371,86v189,105,181,255,71,422v-101,154,-265,268,-452,337v-168,62,-333,97,-428,-36r-377,602v-25,29,-57,22,-94,32v-42,-1,-100,0,-100,-39v0,-31,66,-149,197,-354r372,-557v116,-167,184,-260,203,-281v40,-41,49,-42,124,-42v26,0,65,-14,63,20v0,14,-2,24,-5,29v-59,82,-165,244,-318,486v13,28,56,24,95,24v225,0,413,-148,522,-281v60,-74,78,-131,25,-201v-61,-80,-188,-100,-329,-103v-188,-4,-546,142,-651,223v-36,28,-54,83,11,83v13,0,30,-5,50,-11v7,1,6,43,1,45v-69,49,-127,73,-174,73","w":1478},"Q":{"d":"309,16v-114,-1,-207,-122,-207,-252v0,-74,26,-164,78,-274v96,-205,225,-383,387,-532v282,-259,541,-388,776,-388v191,0,322,102,322,268v0,196,-88,355,-180,500v-168,264,-407,519,-709,644r158,125v58,39,155,119,240,59v6,-7,12,-23,22,-23v9,0,13,5,13,14v-20,97,-142,171,-251,171v-111,0,-270,-119,-475,-357v-63,30,-121,45,-174,45xm297,-247v0,35,9,59,26,73v37,0,99,-23,185,-68v86,-45,160,-104,225,-178v24,-28,34,16,45,30v24,50,21,100,-11,148v-18,28,-55,64,-112,109v178,-68,495,-420,609,-585v78,-113,136,-210,170,-292v34,-82,51,-138,51,-170v0,-59,-32,-88,-96,-88v-296,0,-532,186,-710,359v-111,107,-201,226,-273,355v-72,129,-109,232,-109,307","w":1393},"R":{"d":"457,-915v-44,0,-90,-54,-90,-115v0,-37,23,-78,68,-124v161,-160,509,-281,820,-288v224,-5,375,45,470,159v135,162,-10,360,-115,441v-149,116,-360,213,-572,258v71,75,279,349,366,434v66,65,114,100,149,100v13,0,38,-23,44,-4v-6,21,-80,98,-100,111v-58,36,-121,25,-179,-24v-185,-156,-332,-392,-482,-586r-166,261v-24,38,-43,69,-56,92v-37,62,-63,108,-76,139v-22,52,-72,46,-136,46v-41,0,-62,-17,-62,-52v0,-26,12,-63,34,-111v22,-48,140,-230,355,-542v215,-312,333,-479,355,-500v30,-29,43,-33,65,-44v12,3,23,3,35,0v43,23,90,60,58,110v-41,65,-131,191,-182,264r-110,157v229,-28,453,-165,584,-301v48,-50,72,-94,72,-131v0,-51,-60,-80,-109,-93v-175,-48,-312,-32,-511,23v-184,51,-285,98,-384,177v-26,21,-37,36,-37,45v16,21,66,-7,76,-14v15,-2,20,19,10,28v-56,56,-121,84,-194,84","w":1502},"S":{"d":"1314,-1186v-17,12,-28,-9,-27,-30v0,-12,13,-34,39,-66v-264,21,-521,153,-671,288v-62,56,-87,69,-53,124v37,60,437,145,497,176v111,57,240,124,240,258v0,124,-70,192,-155,257v-173,132,-427,208,-730,208v-155,0,-253,-41,-296,-123v-11,-21,-17,-42,-17,-64v0,-71,68,-129,114,-129v31,0,11,26,5,39v0,19,28,38,82,56v195,66,455,-7,596,-74v58,-28,106,-57,144,-88v87,-72,73,-113,-44,-160v-126,-50,-471,-112,-570,-194v-114,-95,-108,-237,-18,-352v99,-126,263,-213,428,-281v183,-75,353,-111,510,-111v111,0,290,34,291,98v1,70,-15,89,-50,115v-31,23,-110,40,-241,46v-45,2,-70,4,-74,7","w":1369},"T":{"d":"445,49v-65,-1,-115,-35,-115,-107v0,-67,123,-224,154,-249v19,-16,32,-24,39,-24v16,1,8,24,5,34v0,14,22,22,32,8v97,-134,182,-249,247,-349r216,-334v48,-73,96,-139,143,-197v-260,66,-436,93,-643,49v-85,-18,-107,-49,-107,-144v0,-60,103,-112,154,-114v80,-3,4,47,4,66v0,21,77,32,231,32v154,0,331,-20,531,-61v115,-93,214,-140,297,-140v104,0,171,97,95,159v-77,62,-194,82,-323,105v-74,94,-217,310,-304,435v-25,36,-67,100,-123,192r-146,238v-41,67,-85,134,-132,199v-95,135,-180,202,-255,202","w":1161},"U":{"d":"354,4v-106,0,-162,-67,-162,-156v0,-115,67,-277,202,-486v135,-209,260,-380,373,-513v-96,85,-163,127,-199,127v-68,0,-103,-50,-108,-110v-4,-45,69,-115,98,-117v12,0,19,1,19,3v3,7,-56,53,-17,54v92,-16,321,-171,394,-233v32,-28,81,-26,120,-5v28,-4,82,42,54,76v-277,359,-452,592,-523,701v-145,221,-217,364,-217,430v0,23,10,35,30,35v20,0,75,-37,166,-112v251,-204,601,-565,1054,-1080v21,-24,34,-31,60,-29v21,-3,45,-8,83,-7v110,3,119,26,71,93r-123,172r-231,335v-92,135,-173,260,-240,373v-67,113,-100,185,-100,216v8,3,13,-3,35,-13v84,-36,296,-220,347,-276v20,-23,33,-35,37,-35v38,-3,27,145,18,166v-55,126,-242,267,-379,335v-87,44,-159,66,-215,66v-56,0,-95,-51,-95,-112v0,-59,34,-150,102,-272v68,-122,150,-249,247,-382v-161,187,-274,313,-341,378v-112,108,-209,203,-322,279v-99,67,-179,99,-238,99","w":1516},"V":{"d":"373,14v-104,0,-162,-87,-162,-182v0,-136,96,-293,162,-400v122,-198,281,-404,432,-581v-107,89,-180,142,-219,157v-39,15,-74,23,-102,23v-56,0,-89,-60,-89,-113v0,-47,56,-128,97,-124v37,4,-34,50,13,52v85,-18,96,-41,219,-120v91,-58,156,-110,198,-149v53,-50,198,-8,212,46v-6,27,-6,43,-22,67v-9,14,-78,111,-207,292v-323,451,-485,717,-485,799v0,30,12,45,35,45v32,0,94,-30,186,-88v287,-185,497,-421,723,-675v82,-92,149,-182,205,-269v56,-87,84,-152,84,-197v0,-32,-55,16,-57,-19v0,-9,3,-15,8,-18v64,-37,125,-55,184,-55v56,0,80,49,80,109v0,33,-24,90,-70,172v-194,339,-525,698,-836,944v-120,94,-228,164,-322,212v-94,48,-183,72,-267,72","w":1368},"W":{"d":"289,18v-46,0,-144,-83,-144,-135v0,-166,115,-398,346,-697v88,-114,198,-241,329,-382v-115,99,-202,149,-262,149v-53,0,-90,-63,-92,-111v-11,-28,74,-101,87,-103v8,-1,19,8,19,14v-9,10,-14,16,-14,19v0,3,4,5,12,5v8,0,75,-39,200,-115v125,-76,194,-114,206,-114v51,0,148,42,148,76v0,13,-6,31,-20,52v-139,201,-590,739,-700,976v-29,62,-46,100,-46,113v0,13,2,20,6,20v28,0,128,-84,300,-253r493,-502v156,-165,241,-256,255,-274v29,-36,50,-50,116,-50v165,0,161,46,76,140v-155,173,-220,286,-362,547v-104,192,-153,316,-153,370v0,15,5,22,15,22v10,0,39,-18,86,-57v254,-212,537,-511,738,-816v90,-135,136,-219,136,-254v0,-63,-49,-54,-91,-42v-15,0,-14,-31,-3,-34v64,-25,108,-67,198,-67v48,-1,117,41,117,94v0,58,-24,136,-76,231v-179,331,-479,651,-751,899v-93,85,-183,153,-266,206v-83,53,-146,80,-191,80v-95,0,-142,-43,-142,-129v0,-121,68,-295,205,-523v-266,315,-489,518,-668,609v-47,24,-82,36,-107,36","w":1835},"X":{"d":"746,35v-88,0,-146,-72,-146,-181v0,-63,17,-168,52,-317v-381,320,-574,481,-579,483v-12,7,-22,-3,-34,0v-27,-15,-70,-53,-92,-78v-6,-16,-3,-29,4,-51v7,-23,75,-87,205,-193r565,-446r94,-356v17,-65,25,-102,25,-111v0,-9,-3,-14,-9,-14v-29,-17,-313,234,-294,264v-5,37,-27,22,-49,-1v-31,-32,-35,-79,-35,-126v0,-34,32,-80,96,-140v64,-60,134,-113,211,-158v77,-45,133,-68,168,-68v75,1,117,57,115,140v0,45,-29,174,-86,386v374,-287,571,-437,591,-448v54,-29,149,-22,212,6v40,18,7,54,-16,70r-220,162r-641,491v-64,246,-96,405,-96,477v0,34,4,30,24,20v50,-26,324,-263,355,-302v18,-21,29,-31,36,-30v14,-3,17,32,14,53v13,29,31,115,5,151v-94,127,-286,317,-475,317","w":1206},"Y":{"d":"298,10v-89,0,-127,-53,-127,-170v0,-50,21,-121,64,-214v120,-258,350,-586,495,-785v-89,81,-162,121,-219,121v-58,0,-54,-18,-85,-48v-36,-35,-20,-103,8,-126v37,-31,30,-46,68,-46v10,0,15,1,15,4v2,8,-41,31,-10,33v101,-23,174,-91,259,-131v50,-23,129,-120,196,-105v52,12,112,32,112,85v0,20,-9,42,-28,68r-128,184r-224,334v-83,126,-155,244,-218,354v-63,110,-95,179,-95,208v0,10,3,15,8,15v5,0,25,-13,59,-39v179,-138,406,-354,683,-649v227,-242,360,-392,402,-449v25,-34,38,-43,94,-44v61,-2,136,-10,154,40v-3,15,-82,149,-236,402v-481,790,-745,1236,-794,1337v28,-32,102,-98,131,-114v15,3,25,22,9,36v-17,15,-123,161,-142,179v-29,29,-53,88,-81,110v-76,61,-180,-65,-180,-127v0,-47,100,-229,298,-546v198,-317,373,-584,524,-799v-350,413,-629,685,-836,814v-72,45,-131,68,-176,68","w":1362},"Z":{"d":"1082,-29v-167,-2,-717,50,-859,63v-70,7,-140,-68,-143,-121r8,-32v0,-32,79,-127,234,-287v234,-242,660,-638,888,-821v-113,33,-320,64,-468,64v-195,0,-292,-42,-292,-127v0,-96,113,-165,176,-165v20,0,29,4,29,13v3,7,-36,29,-33,37v0,29,83,43,250,43v106,0,438,-15,508,-36v40,-13,78,-42,100,-66v21,-25,50,-37,84,-37v57,-1,135,23,135,73v0,105,-136,150,-205,199r-50,43v-237,196,-791,731,-1092,1020v218,-44,648,-123,878,-42v57,20,84,61,84,116v0,36,-25,116,-47,122v-6,1,-11,-27,-16,-28v-31,-21,-88,-31,-169,-31","w":1259},"[":{"d":"124,317v-80,0,-125,-95,-124,-174v0,-32,15,-78,46,-138r568,-1149r84,-164r82,-174r73,-170v10,-30,64,-56,98,-56v113,0,229,12,340,12v23,0,35,22,35,66v0,71,-18,109,-55,114v-101,15,-191,9,-293,5v-273,607,-528,1137,-772,1587v-12,22,-21,36,-21,43v1,7,14,4,21,4v110,0,198,-16,285,-16v17,0,26,7,26,20v0,70,-128,127,-194,152v-68,25,-134,38,-199,38"},"\\":{"d":"411,-1599v0,-13,10,-19,29,-19v42,0,175,100,177,145v121,433,141,864,142,1422v0,95,-23,168,-68,219v-48,55,-81,82,-101,82v-20,0,-30,-12,-30,-37v0,-3,3,-67,10,-194v30,-531,-14,-914,-98,-1424v-8,-47,-61,-157,-61,-194","w":775},"]":{"d":"1029,-1724v103,-4,113,132,113,222v0,20,-12,57,-36,108r-250,554v-143,319,-233,516,-268,588r-130,273v-52,110,-91,196,-125,253v-36,61,-263,43,-386,34v-76,-6,-114,-20,-114,-45v0,-39,60,-146,92,-146v68,0,209,30,287,26v349,-737,597,-1282,747,-1634v27,-64,19,-56,-73,-61v-77,-4,-145,4,-205,16v-29,0,-43,-34,-43,-100v0,-66,18,-100,55,-99"},"^":{"d":"548,-806v-20,2,-105,-68,-100,-96v10,-55,44,-83,85,-121v27,-25,56,-47,83,-69r302,-240v59,-47,96,-79,112,-94v53,-48,55,-20,120,37v12,11,17,24,15,41v-29,223,-35,317,-35,475v0,44,-92,70,-146,68v-45,-1,-59,-16,-48,-51v12,-38,58,-318,61,-373v-52,67,-384,343,-430,420v-2,2,-8,3,-19,3","w":1024},"_":{"d":"-80,279v-50,3,-123,-26,-78,-68v30,-28,21,-41,72,-67v72,-38,90,-30,200,-34r488,-16v76,3,77,-8,104,28v18,23,39,23,41,56v-10,42,-53,47,-117,52r-362,28v-147,13,-263,16,-348,21","w":788},"`":{"d":"538,-1223v9,-36,150,-116,181,-43v24,57,44,151,61,199v26,73,37,121,37,144v0,60,-90,29,-109,1v-43,-63,-55,-119,-104,-188v-23,-33,-59,-70,-66,-113","w":819},"a":{"d":"172,31v-104,0,-170,-79,-166,-183v8,-229,154,-376,292,-486v110,-88,213,-130,306,-130v63,0,116,22,131,63v30,-41,33,-51,90,-55v72,-5,92,51,63,93v-73,108,-219,328,-219,498v0,82,55,58,101,27v66,-43,121,-116,172,-167v4,-3,10,-5,18,-5v37,4,33,101,21,132v-26,67,-205,217,-307,217v-139,0,-187,-146,-136,-262v-55,72,-118,133,-190,183v-72,50,-131,75,-176,75xm164,-166v0,23,7,35,20,35v45,-2,304,-241,326,-273v28,-40,91,-120,182,-245v-167,-9,-387,190,-474,353v-34,64,-54,107,-54,130","w":834},"b":{"d":"177,33v-62,0,-137,-91,-137,-178v0,-53,24,-136,69,-248v94,-235,241,-467,369,-680v67,-111,126,-200,174,-270v48,-70,77,-110,88,-121v19,-21,92,-40,132,-38v44,2,34,44,13,75v-142,211,-278,432,-411,663v41,-25,132,-43,184,-45v108,-4,176,53,176,155v0,135,-77,249,-150,344v-88,115,-198,227,-330,294v-63,33,-122,49,-177,49xm618,-657v-29,-9,-185,65,-203,65v-7,0,-17,-6,-29,-18v-130,234,-195,383,-195,448v0,30,10,45,29,45v46,0,112,-38,199,-115v87,-77,152,-156,196,-235v27,-48,41,-92,41,-131v0,-39,-13,-59,-38,-59","w":763},"c":{"d":"318,37v-136,2,-281,-105,-273,-247v15,-273,193,-455,397,-551v76,-35,152,-52,227,-52v69,-1,140,45,140,116v0,64,-93,205,-162,205v-43,0,-64,-20,-64,-61v-6,-16,65,-98,60,-113v0,-10,-4,-14,-11,-14v-87,1,-176,75,-232,118v-88,69,-204,203,-198,329v4,75,50,122,138,120v208,-4,364,-87,474,-184v29,-26,59,-26,53,29v-16,138,-173,204,-296,250v-99,37,-183,55,-253,55","w":747},"d":{"d":"136,16v-94,0,-125,-72,-125,-174v0,-154,132,-322,231,-416v105,-99,268,-214,439,-221v21,0,46,13,75,39v19,-31,54,-93,107,-184v162,-276,273,-442,324,-504v29,-36,72,-55,131,-55v46,0,49,40,22,83r-199,322v-151,246,-271,453,-356,624v-89,179,-132,264,-129,316v3,67,60,40,102,13v67,-41,128,-118,179,-167v40,-23,45,31,45,76v0,26,-2,42,-6,50v-32,66,-205,217,-314,217v-100,0,-150,-42,-150,-127v0,-53,20,-122,60,-207v-95,130,-285,315,-436,315xm179,-170v0,22,5,33,14,33v69,6,421,-395,502,-525v-187,37,-375,204,-454,348v-41,74,-62,122,-62,144","w":843},"e":{"d":"291,39v-152,0,-275,-63,-275,-184v0,-92,64,-162,191,-209v-53,-25,-60,-50,-60,-128v0,-100,108,-190,188,-232v118,-62,222,-95,314,-95v39,0,101,21,101,61v0,86,-89,166,-175,166v-41,0,-39,-39,-32,-71v-71,26,-120,59,-188,111v-43,33,-64,57,-64,73v0,5,7,8,23,8v39,0,124,-45,167,-31v14,5,46,50,43,68v-6,43,-94,68,-129,86v-143,75,-211,133,-211,162v0,52,44,78,133,78v151,0,289,-142,377,-206v33,-24,49,-7,49,47v0,83,-1,83,-47,122v-141,117,-278,174,-405,174","w":650},"f":{"d":"-144,614v-62,0,-124,-35,-123,-101v2,-78,37,-179,65,-239v87,-186,153,-282,306,-542v-57,17,-95,-7,-98,-54v-1,-14,-16,-32,0,-42v37,-37,70,-88,128,-102v42,-10,76,-23,105,-28r409,-666v103,-160,163,-248,176,-266v19,-27,117,-66,158,-66v28,0,29,25,18,47v-4,10,-40,69,-109,177r-488,774r25,9v155,-29,236,-43,242,-43v10,0,89,29,98,29v30,-1,30,74,2,75r-185,45v83,108,61,187,-10,321v-87,164,-234,320,-367,446v-72,67,-140,122,-206,164v-66,42,-114,62,-146,62xm-100,419v0,14,4,21,11,21v138,-59,274,-214,377,-331v75,-85,176,-218,176,-339v0,-40,-20,-75,-59,-106r-111,25r-278,479v-33,69,-116,178,-116,251","w":737},"g":{"d":"949,-305v45,-22,51,25,49,73v-1,68,-1,49,-51,83v-188,127,-415,265,-547,428v-99,122,-172,218,-215,292v-16,28,-43,43,-81,43v-75,0,-113,-36,-113,-107v-2,-172,228,-337,327,-423r201,-315v-72,75,-141,135,-209,180v-68,45,-119,67,-152,67v-102,0,-153,-44,-153,-131v0,-265,199,-429,369,-549v99,-70,218,-139,350,-139v45,0,74,13,87,39v37,-40,71,-49,139,-49v45,0,40,32,49,57v-1,12,-19,23,-24,31v-148,210,-298,452,-452,723v159,-141,301,-242,426,-303xm164,-150v0,34,21,16,46,-1v214,-146,353,-304,544,-539v-221,49,-392,183,-500,340v-59,86,-90,153,-90,200","w":857},"h":{"d":"48,20v-34,21,-62,4,-86,-6v-9,0,-13,-2,-13,-8v168,-421,320,-689,602,-1190v72,-129,131,-219,172,-272v29,-38,79,-57,148,-57v38,0,30,45,22,71r-107,167v-212,331,-372,605,-479,822v104,-127,205,-224,303,-293v61,-43,106,-65,136,-65v63,2,124,12,120,84v0,13,-22,63,-65,148v-130,256,-195,399,-195,427v0,28,12,42,35,42v46,18,230,-170,258,-195v7,-7,15,-9,22,-9v35,0,23,73,28,92v-3,54,-17,60,-51,100v-63,73,-194,159,-303,159v-110,0,-165,-49,-165,-146v0,-77,95,-291,232,-526v-89,55,-525,545,-584,635v-4,6,-15,11,-30,20","w":805},"i":{"d":"203,41v-92,5,-193,-82,-193,-161v0,-137,174,-349,220,-450v4,-8,-46,-52,-41,-62v31,-60,153,-175,233,-187v37,-5,82,47,82,79v0,15,-81,159,-238,433v-26,45,-75,101,-75,160v0,23,15,34,46,34v114,0,246,-188,288,-202v17,0,26,30,26,90v0,20,-2,34,-6,43v-43,110,-212,216,-342,223xm713,-1098v0,71,-91,172,-163,172v-38,0,-58,-20,-58,-60v0,-76,85,-169,162,-169v36,0,59,21,59,57","w":415},"j":{"d":"-404,602v-52,0,-98,-40,-96,-91v3,-74,37,-102,85,-151v87,-89,179,-155,281,-241r220,-375v76,-127,136,-222,180,-285v-29,-1,-57,10,-74,-9v-11,-11,-17,-24,-17,-39v-14,-41,243,-210,278,-197v62,-3,92,51,67,106v-38,83,-308,505,-398,649r259,-186v85,-59,134,-88,147,-88v20,-16,40,-11,44,14v7,38,9,75,-1,109v-128,86,-295,163,-429,268v-71,55,-132,106,-179,158v-52,117,-262,358,-367,358xm795,-1112v0,83,-128,192,-209,192v-31,0,-47,-20,-47,-58v0,-73,119,-183,194,-183v41,0,62,16,62,49","w":453},"k":{"d":"876,-314v37,4,29,100,21,132v-32,66,-204,217,-313,217v-74,0,-124,-36,-158,-64v-78,-64,-130,-164,-180,-262r-148,299v-15,33,-55,3,-84,2v-24,-1,-47,-28,-56,-53v42,-135,118,-256,366,-711v218,-399,336,-604,346,-616v28,-52,101,-61,152,-90v22,-13,46,7,42,35v-29,67,-428,771,-539,972v61,-13,383,-254,383,-315v0,-49,40,-76,84,-76v45,0,77,31,73,83v-7,94,-105,198,-174,255v-102,87,-187,144,-255,172v54,146,116,219,186,219v71,0,182,-138,236,-193v4,-4,10,-6,18,-6","w":753},"l":{"d":"292,39v-128,4,-193,-86,-192,-215v3,-301,200,-711,340,-907v198,-277,347,-418,451,-418v65,0,121,42,121,113v0,37,-20,97,-62,176v-172,323,-452,646,-680,907v-2,23,-17,77,-16,110v1,47,53,86,106,86v119,0,254,-206,310,-206v16,0,24,24,24,73v1,31,-2,62,-14,77v-90,112,-222,199,-388,204xm311,-532v79,-93,188,-238,327,-436v139,-198,208,-320,208,-367v0,-10,-3,-15,-10,-15v-23,0,-86,66,-184,200v-183,250,-243,328,-341,618","w":528},"m":{"d":"62,6v-64,2,-136,-9,-104,-78v130,-286,257,-514,377,-686v24,-35,94,-56,151,-57v27,0,31,44,17,69v-32,59,-130,170,-166,218v91,-95,173,-166,247,-212v74,-46,127,-69,160,-69v100,0,123,110,82,189v-34,66,-88,132,-133,188r163,-175v91,-95,232,-227,402,-227v47,0,91,37,90,82v0,22,-27,76,-81,160r-161,254v-54,85,-81,138,-81,160v-2,90,74,65,125,30v68,-47,125,-104,180,-157v7,-6,14,-9,22,-9v37,4,29,100,21,132v-33,67,-206,225,-318,218v-125,-8,-198,-57,-198,-168v0,-210,188,-372,278,-518v0,-3,-3,-5,-8,-5v-21,0,-67,33,-138,100v-221,212,-286,281,-482,543v-30,40,-142,15,-150,-25v0,-7,53,-101,159,-281v106,-180,159,-278,159,-294v0,-16,-9,-25,-29,-25v-20,0,-61,29,-122,88v-169,161,-299,322,-392,481v-6,10,-56,74,-70,74","w":1246},"n":{"d":"688,20v-119,47,-253,-28,-254,-142v0,-96,67,-221,104,-286v28,-49,127,-186,142,-233v-25,-6,-78,43,-166,128v-187,180,-256,260,-418,472v-40,52,-49,50,-110,29v-44,-16,-64,-20,-45,-66v29,-69,44,-80,95,-166r246,-418v56,-96,78,-149,214,-153v16,0,24,10,24,30v9,33,-86,179,-129,240v115,-128,214,-206,292,-243v83,-40,197,-32,206,56v-28,142,-131,230,-192,341r-63,106v-21,38,-50,84,-50,131v0,29,20,44,60,44v97,0,249,-197,286,-205v17,0,26,25,26,75v0,50,-19,80,-47,103v-99,82,-170,137,-221,157","w":800},"o":{"d":"191,27v-105,4,-175,-73,-170,-183v10,-232,156,-409,297,-522v109,-87,204,-131,286,-131v44,0,87,11,93,49v76,-14,145,30,137,108v-21,204,-173,371,-296,496v-84,85,-209,178,-347,183xm172,-177v0,37,14,56,41,56v27,0,67,-19,122,-54v98,-62,225,-228,279,-327v26,-49,40,-82,40,-100v-1,-21,-4,-27,-21,-27v-23,0,-35,-17,-35,-51v-112,38,-224,132,-296,226v-84,110,-129,202,-130,277"},"p":{"d":"-326,617v-68,-12,-92,-111,-49,-181r521,-846v257,-414,396,-628,417,-643v22,-16,45,-7,73,-13v18,-4,33,49,33,61v0,6,-8,16,-20,34r-285,434v100,-100,202,-173,305,-219v40,-17,77,-26,109,-26v63,-2,112,48,107,110v-15,169,-114,304,-205,420v-79,100,-168,191,-284,247v-55,27,-103,40,-144,40v-83,0,-125,-38,-125,-115r-434,683v-7,9,-14,14,-19,14xm180,-156v17,21,43,32,77,32v101,0,217,-115,282,-186v67,-74,167,-187,167,-294v0,-14,-7,-21,-20,-21v-36,0,-112,55,-228,166v-116,111,-209,212,-278,303","w":801},"q":{"d":"142,37v-174,3,-174,-207,-104,-341v89,-169,274,-338,416,-416v97,-52,176,-79,239,-79v63,0,101,21,116,62v22,-45,21,-43,75,-66v55,-23,92,-23,99,29v-11,54,-37,90,-73,153r-278,483v-109,192,-190,342,-245,449v35,-34,107,-123,146,-125v49,-3,68,32,92,58v27,52,-63,99,-88,125v-159,162,-258,239,-286,239v-52,0,-102,-46,-101,-96v-12,-61,143,-358,346,-698v-70,79,-229,221,-354,223xm172,-162v0,14,6,21,19,21v96,0,315,-211,379,-278v53,-55,115,-134,186,-238v-11,-9,-28,-13,-49,-13v-104,1,-272,127,-331,186v-54,54,-199,233,-204,322","w":837},"r":{"d":"727,-440v-41,60,-123,26,-123,-45v0,-46,25,-98,74,-156v-25,-6,-78,43,-166,128v-179,172,-271,272,-420,472v-38,52,-49,45,-110,29v-78,-20,-42,-73,-12,-124r310,-526v56,-96,78,-149,214,-153v16,0,24,10,24,30v9,33,-86,179,-129,240v157,-179,291,-268,402,-268v53,-1,97,36,94,88v-4,74,-120,229,-158,285","w":715},"s":{"d":"172,-200v-9,40,24,77,53,77v80,0,151,-12,213,-36v62,-24,92,-48,92,-72v0,-11,-12,-21,-34,-29v-89,-34,-261,-53,-328,-105v-69,-54,-53,-158,2,-229v67,-87,169,-145,278,-191v110,-47,204,-69,279,-69v95,0,145,14,145,93v0,81,-36,106,-94,137v-44,22,-74,31,-112,20v-11,-3,-15,-16,-26,-20v-23,-18,14,-47,17,-66v-140,9,-270,85,-347,157v-41,38,-55,55,12,69v138,27,229,51,272,71v67,29,115,69,115,137v0,103,-96,175,-177,214v-107,53,-200,79,-280,79v-128,0,-204,-30,-211,-123v-5,-59,35,-136,91,-135v27,0,40,7,40,21","w":753},"t":{"d":"371,-6v-128,88,-329,34,-321,-133v7,-144,88,-285,154,-406v71,-130,144,-251,216,-364r-182,18v-31,1,-81,-14,-83,-40v-2,-20,30,-45,32,-58v4,-25,94,-76,121,-77r223,-11v76,-112,99,-147,152,-201v17,-6,47,-6,67,-10v25,8,62,6,64,36v-15,43,-82,137,-101,171v74,-4,109,-12,155,-1v18,4,42,45,56,56v22,18,17,52,-12,66v-18,9,-36,16,-55,18v-155,15,-240,23,-256,24v-63,93,-361,600,-381,715v-8,46,-11,88,37,88v104,0,267,-189,303,-200v17,0,26,30,26,90v0,33,-15,62,-45,88v-67,58,-125,100,-170,131","w":440},"u":{"d":"125,41v-102,-1,-145,-106,-113,-211v53,-174,142,-304,222,-450v30,-55,56,-96,76,-122v33,-46,74,-54,111,-16v15,15,22,29,22,39v0,10,-22,55,-67,135v-132,239,-198,378,-198,417v0,10,4,15,11,15v50,21,459,-443,460,-474v28,-56,64,-120,101,-148v30,-23,76,-32,128,-29v8,0,23,33,22,42v2,15,-154,278,-158,286v-77,163,-118,269,-118,318v0,28,11,42,32,42v72,0,181,-139,236,-193v5,-4,10,-6,17,-6v37,4,29,100,21,132v-32,66,-204,224,-313,217v-81,-5,-146,-48,-146,-146v0,-54,14,-107,43,-159v-165,207,-295,311,-389,311","w":810},"v":{"d":"155,35v-63,0,-113,-48,-109,-125v5,-116,129,-358,184,-445v-35,26,-56,39,-64,39v-19,-4,-65,-62,-42,-88v129,-148,224,-219,278,-219v42,0,80,29,80,68v-25,99,-151,319,-204,429v-44,91,-68,148,-68,171v0,4,2,6,6,6v69,-23,275,-229,326,-296v61,-80,161,-210,178,-297v7,-35,-25,-54,-23,-86v2,-35,56,-75,105,-75v63,0,94,38,94,113v0,46,-26,114,-77,202v-105,181,-283,381,-453,504v-90,66,-160,99,-211,99","w":745},"w":{"d":"126,33v-60,0,-91,-36,-88,-105v5,-108,145,-392,201,-471v-40,36,-89,-5,-99,-36v0,-7,6,-17,15,-32v9,-15,216,-199,252,-186v40,0,104,16,104,53v0,16,-48,110,-139,285v-93,178,-144,265,-137,286v14,0,83,-71,209,-214v126,-143,227,-259,297,-352v13,-18,29,-28,54,-24r55,-11v14,-2,38,16,38,28v-45,94,-225,427,-231,564v0,12,4,18,13,18v25,0,78,-46,158,-138v80,-92,149,-177,197,-263v63,-113,93,-141,64,-226v-1,-55,45,-89,100,-88v56,0,84,36,84,107v0,51,-25,122,-76,212v-100,178,-245,359,-399,482v-77,62,-136,94,-178,94v-93,0,-126,-68,-112,-159v10,-65,25,-128,54,-187v-71,93,-148,178,-230,252v-82,74,-151,111,-206,111","w":1134},"x":{"d":"41,41v-35,40,-118,-24,-120,-59v0,-14,1,-25,4,-33v7,-27,51,-82,129,-167v78,-85,167,-170,268,-257v-6,-73,1,-139,-10,-179v-8,-1,-70,66,-86,58v-21,6,-47,-62,-47,-77v0,-59,148,-197,217,-185v23,-1,79,33,79,59v0,70,7,128,7,174v105,-114,208,-206,309,-276v45,-31,125,28,125,61v0,12,-4,23,-13,30r-432,394v-5,64,-8,130,-8,198v0,68,9,103,27,103v72,0,181,-138,236,-193v42,-21,44,30,43,76v0,26,-2,43,-5,50v-30,67,-206,217,-315,217v-97,0,-145,-67,-145,-200v0,-27,2,-60,6,-99v-111,117,-197,222,-269,305","w":760},"y":{"d":"115,37v-67,3,-122,-37,-122,-115v0,-111,67,-212,113,-289r83,-143v39,-55,99,-181,132,-232v13,-21,26,-32,38,-32v26,0,81,41,75,76v19,11,-284,531,-262,540v0,5,3,8,8,8v18,0,58,-25,120,-76v150,-124,336,-338,442,-501v21,-33,47,-62,106,-45v41,12,64,34,46,72v-5,10,-36,63,-93,158v-167,281,-281,487,-344,616r428,-379v7,-6,15,-9,22,-9v21,0,31,32,31,95v0,19,-3,32,-10,37v-199,154,-397,317,-563,514v-65,77,-119,247,-227,276v-78,21,-128,-13,-129,-89v-2,-118,126,-285,221,-373v44,-41,67,-66,71,-72v4,-6,54,-100,150,-281v-64,70,-123,127,-178,171v-55,44,-107,71,-158,73","w":799},"z":{"d":"798,-286v41,0,42,24,42,96v0,34,-39,90,-68,99v-97,7,-688,173,-752,101v-14,-10,-24,-25,-24,-64v0,-28,1,-45,4,-50v115,-225,340,-386,523,-535v-217,13,-343,25,-379,31v-16,2,-23,-7,-23,-26v0,-45,61,-120,108,-130v31,-7,65,-14,102,-15v152,-3,281,-12,388,-28v8,-2,60,-24,75,-20v50,0,74,94,37,130v-12,12,-34,22,-65,31v-292,228,-473,403,-544,525v22,-7,78,-18,168,-35v235,-43,363,-77,385,-100v7,-7,15,-10,23,-10","w":735},"{":{"d":"334,317v-77,0,-128,-94,-124,-165v13,-217,156,-375,252,-525v88,-137,137,-231,137,-286v0,-65,-88,-83,-151,-95v-76,-14,-95,-100,-54,-156v37,-50,76,8,138,-2v192,-29,357,-179,376,-382v4,-39,5,-77,5,-114v0,-179,125,-300,310,-300v195,0,292,35,292,104v0,60,-67,170,-133,106v-53,-51,-187,-74,-242,-7v-48,59,-23,177,-48,269v-56,208,-168,337,-385,410v84,42,105,110,79,208v-36,136,-294,483,-334,576v-22,51,-36,89,-36,118v-1,150,207,33,290,31v14,0,21,7,21,20v0,70,-128,127,-194,152v-68,25,-134,38,-199,38","w":900},"|":{"d":"108,245v-28,12,-67,10,-67,-35v0,-13,0,-20,1,-22v13,-59,176,-378,486,-954v310,-576,482,-879,516,-909v26,-22,78,-8,123,-8v14,0,21,5,21,16r-481,891r-507,969v-9,36,-71,49,-92,52","w":768},"}":{"d":"1042,-752v0,34,-32,96,-55,99v-305,-33,-468,172,-516,430v-28,149,-52,351,-126,418v-53,48,-142,93,-234,93v-195,0,-292,-35,-292,-104v0,-56,74,-172,137,-104v30,32,67,48,109,48v89,0,143,-46,160,-137v83,-437,243,-695,482,-775v-53,-44,-98,-65,-98,-143v0,-149,139,-253,219,-351v77,-95,118,-169,118,-226v0,-47,-24,-80,-66,-81v-22,-6,-230,62,-250,58v-15,0,-23,-7,-23,-20v-2,-112,38,-148,143,-159v66,-7,184,-32,234,-31v151,6,161,193,108,314v-66,150,-287,316,-287,476v0,100,132,97,199,139v25,15,38,33,38,56","w":900},"~":{"d":"177,-468v-21,-5,-29,-27,-27,-62v6,-118,185,-253,273,-257v106,-5,143,66,200,112v66,53,176,-2,209,-52v19,-28,41,-40,58,-40v49,0,60,85,44,129v-49,130,-274,230,-406,120v-51,-42,-100,-119,-181,-74v-57,31,-102,122,-170,124","w":793},"\u00a0":{"w":425}}});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BottomTxtUIModel = __webpack_require__(221),
	    BottomTextEl = __webpack_require__(222),
	    RaphaelView = __webpack_require__(187),
	    Raphael = __webpack_require__(182);
	
	__webpack_require__(223);
	
	
	var instanceVars = {
	    parent: null, // the parent shape
	    uiModel: null, // BottomTxtUIModel (set on init)
	
	    /* for use in positioning */
	    oSigBox: undefined,
	    oBox: undefined
	};
	
	// note this is for new, unsaved signatures,
	// ...others already persisted are attached directly to signature path,
	// ( just as this will be when saved )
	
	module.exports = RaphaelView.extend({
	
	    initialize: function(options) {
	
	        _.extend( this, instanceVars, _.pick(options, 'parent'), {
	            uiModel:  new BottomTxtUIModel([], {
	                color: this.options.parent.el.attr('fill')
	            })
	        });
	
	        this.bindEntityEvents(this.parent, this.parentSubs);
	    },
	
	    parentSubs: {
	        'signature.repositionBottomText':       '_position', // handles scale changes
	        'signature.moveOrResizeEnd':            'moveOrResizeEnd',
	        'signature.noteConsultGroupChange':     'noteConsultGroupChange'
	    },
	
	    // (from toggle) -- if from model, it's derived and appended to the other path -- this shape is never created;
	    //note: never adjusting for scale of the paper -- the size of the derived shape should always be be the same
	    render: function() {
	
	        var box = this.parent.el.getBBox(),
	            uim = this.uiModel,
	
	            el = BottomTextEl( this.parent.el.paper , {
	                x: box.x + uim.get('paddingX'),  //coord relative to bottom left of parent (top left of this),
	                y: box.y2 + uim.get('paddingY'),
	                cUsr: this.options.pgNoteModel.get('creationUserDesc'),
	                cTime: null, /* indicates new */
	
	                font: uim.get('font'),
	                fontSize: uim.get('fontSize'),
	                attrs: uim.get('attrs') /* INCLUDES the necessary shape type attr !!! */
	        });
	
	        this.setElement(el); // do here, or el is made a jq obj
	        this.triggerMethod('afterRender'); // not a shape
	        return this;
	
	    },
	    onAfterRender: function() {
	        this._setOBoxValues();
	        this._position(this.oSigBox);  //in case if over the bounds
	    },
	    _setOBoxValues: function() {
	        this.oSigBox = this.parent.el.getBBox(); //TODO: put on model
	        this.oBox =  this.el.getBBox();
	    },
	    _position: function(sigBox) {
	
	        var ob = this.oSigBox,
	            b = sigBox,
	            uim = this.uiModel,
	            dx = b.x -  ob.x,
	            dy = b.y2 - ob.y2, //!must use the same coordinates -- it's size will change ! */
	            paperBounds = this.options.channel.request('canvasContainerRel'),
	            paddingY = uim.get('paddingY');
	
	         /* primarily y -- though x can go over if shape shorter than this */
	        if (ob.y2 + this.oBox.height + dy + paddingY >= paperBounds.y2) {
	            var dHeight = ob.height - b.height;
	            dy -= ob.height + this.oBox.height + paddingY - dHeight; //note: want relative to the parent shape -- height is fine for the first
	        }
	        if (this.oBox.x2 + dx >= paperBounds.x2) {
	            dx = paperBounds.x2 - b.x2 - b.width + dx;  //note: really show stop to shape from moving more when boundary hit
	        }
	        this.el.transform('T' + dx + ',' + dy);   //(no bake for performance )
	    },
	    moveOrResizeEnd: function() {
	        this.el.bakeTransform();
	        this._setOBoxValues();
	    },
	    //counter-intuitive, but store in case needed later (not even using now except on initial render)
	    noteConsultGroupChange: function(color) {
	        this.uiModel.setColor(color);
	        this.el.attr('fill', color);
	    },
	    onBeforeDestroy: function() {
	
	        this.unbindEntityEvents(this.parent, this.parentSubs);
	        this.el.remove(); //wanted here --- show really be done on after re-rendered ... ?
	        this.uiModel.destroy();
	
	    }
	
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	module.exports = Backbone.Model.extend({
	    defaults: {
	        paddingX: 10,
	        paddingY: 10,
	        fontSize: 10,
	        font: 'Arial',
	        attrs: {
	            'fill': 'black',
	            'text-anchor': 'start',
	            'shape-type': 'bottomText' // export only recognizes the attributes, nothing on the node or data
	        }
	    },
	    initialize: function(attrs, options) {
	        this.setColor( options.color );
	    },
	    setColor: function(color) {
	        this.get('attrs').fill = color;
	    }
	});

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/* Wrapper around Raphael text path used to make the bottom text path */
	var Util = __webpack_require__(48);
	var moment = __webpack_require__(69);
	var fvChannel = __webpack_require__(72).channel('FV');
	
	/* note: cTime is null for new */
	
	module.exports = function(paper, opts) {
	
	    return paper.print(
	        opts.x,
	        opts.y,
	        deriveTxt(opts.cUsr, opts.cTime), //null for new
	        paper.getFont(opts.font),
	        parseFloat(opts.fontSize)
	    ).attr(opts.attrs);
	
	    /* note: this implies new -- for others take from note model if not a concatentated path -- could put on model */
	    /* latter condition for NEW shapes */
	    function deriveTxt(cUsr, cTime) {
	
	        return Util.deriveInitials(cUsr) + '-' + cUsr + '\n' +
	            moment(cTime ? cTime : undefined).format( fvChannel.request('settings').DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR ) + ' ' + moment.getTimeZoneAbbrevation();
	    }
	
	};


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael) {/*!
	 * The following copyright notice may not be removed under any circumstances.
	 * 
	 * Copyright:
	 * � 2011 The Monotype Corporation. All Rights Reserved.
	 * 
	 * Trademark:
	 * Arial is a trademark of The Monotype Corporation.
	 * 
	 * Manufacturer:
	 * The Monotype Corporation
	 * 
	 * Designer:
	 * Monotype Type Drawing Office - Robin Nicholas, Patricia Saunders 1982
	 */
	Raphael.registerFont({"w":1139,"face":{"font-family":"arial","font-weight":400,"font-stretch":"normal","units-per-em":"2048","panose-1":"2 11 6 4 2 2 2 2 2 4","ascent":"1638","descent":"-410","x-height":"24","bbox":"-94 -1601 2005 431","underline-thickness":"150","underline-position":"-142","unicode-range":"U+0020-U+007E"},"glyphs":{" ":{"w":569,"k":{"Y":37,"T":37,"A":113}},"\u00a0":{"w":569},"!":{"d":"231,-364r-55,-777r0,-325r223,0r0,325r-52,777r-116,0xm184,0r0,-205r207,0r0,205r-207,0","w":569},"\"":{"d":"144,-947r-50,-279r0,-240r205,0r0,240r-45,279r-110,0xm475,-947r-49,-279r0,-240r205,0r0,240r-48,279r-108,0","w":727},"#":{"d":"103,25r87,-426r-169,0r0,-149r199,0r74,-363r-273,0r0,-149r303,0r87,-429r150,0r-87,429r315,0r87,-429r151,0r-87,429r173,0r0,149r-203,0r-75,363r278,0r0,149r-308,0r-87,426r-150,0r86,-426r-314,0r-87,426r-150,0xm370,-550r314,0r75,-363r-315,0"},"$":{"d":"510,211r0,-180v-90,-11,-164,-32,-220,-61v-56,-29,-105,-75,-146,-140v-41,-65,-64,-144,-71,-237r181,-34v14,97,39,168,74,213v51,64,111,100,182,107r0,-573v-74,-14,-150,-43,-227,-86v-57,-32,-102,-76,-133,-133v-31,-57,-46,-121,-46,-193v0,-128,45,-232,136,-311v61,-53,151,-86,270,-98r0,-86r106,0r0,86v105,10,188,41,249,92v79,65,126,155,142,269r-186,28v-11,-71,-33,-124,-67,-162v-34,-38,-79,-63,-138,-75r0,519v91,23,151,40,180,53v56,25,102,55,137,90v35,35,62,77,81,126v19,49,29,101,29,158v0,125,-40,229,-119,312v-79,83,-182,128,-308,134r0,182r-106,0xm510,-1365v-70,11,-126,39,-166,84v-40,45,-60,99,-60,161v0,61,18,113,52,154v34,41,92,74,174,99r0,-498xm616,-121v70,-9,128,-39,174,-91v46,-52,68,-116,68,-193v0,-65,-16,-117,-48,-157v-32,-40,-97,-76,-194,-107r0,548"},"%":{"d":"119,-1114v0,-105,26,-194,79,-267v53,-73,129,-110,229,-110v92,0,169,33,229,99v60,66,90,162,90,289v0,124,-31,220,-92,287v-61,67,-136,100,-225,100v-89,0,-162,-33,-221,-99v-59,-66,-89,-166,-89,-299xm432,-1367v-45,0,-82,19,-112,58v-30,39,-44,110,-44,213v0,94,15,160,45,198v30,38,67,58,111,58v45,0,82,-19,112,-58v30,-39,45,-109,45,-212v0,-95,-15,-162,-45,-200v-30,-38,-67,-57,-112,-57xm433,54r802,-1545r146,0r-799,1545r-149,0xm1067,-344v0,-105,26,-195,79,-268v53,-73,129,-109,230,-109v92,0,168,33,228,99v60,66,91,162,91,289v0,124,-30,220,-91,287v-61,67,-137,100,-227,100v-89,0,-162,-34,-221,-100v-59,-66,-89,-165,-89,-298xm1381,-597v-45,0,-83,19,-113,58v-30,39,-44,110,-44,213v0,93,15,159,45,198v30,39,67,58,111,58v46,0,84,-19,114,-58v30,-39,44,-109,44,-212v0,-95,-15,-162,-45,-200v-30,-38,-67,-57,-112,-57","w":1821},"&":{"d":"973,-173v-59,66,-124,116,-194,149v-70,33,-146,49,-227,49v-150,0,-269,-51,-357,-152v-71,-83,-107,-175,-107,-277v0,-91,30,-173,88,-246v58,-73,145,-137,261,-192v-66,-76,-110,-138,-132,-185v-22,-47,-33,-93,-33,-137v0,-88,35,-165,104,-230v69,-65,155,-97,260,-97v100,0,182,31,246,92v64,61,95,135,95,221v0,139,-92,258,-277,357r263,335v30,-59,53,-127,70,-204r187,40v-32,128,-75,233,-130,316v67,89,144,164,229,225r-121,143v-73,-47,-148,-116,-225,-207xm607,-937v78,-46,128,-86,151,-121v23,-35,35,-73,35,-115v0,-50,-15,-91,-47,-123v-32,-32,-72,-47,-119,-47v-49,0,-89,16,-121,47v-32,31,-49,70,-49,115v0,23,5,46,17,71v12,25,30,52,53,80xm860,-315r-330,-409v-97,58,-163,112,-197,162v-34,50,-51,98,-51,147v0,59,24,121,71,185v47,64,114,96,201,96v54,0,110,-16,168,-50v58,-34,103,-78,138,-131","w":1366},"'":{"d":"136,-947r-46,-274r0,-245r205,0r0,245r-48,274r-111,0","w":391},"(":{"d":"479,431v-99,-125,-183,-272,-252,-440v-69,-168,-103,-342,-103,-522v0,-159,26,-311,77,-456v60,-169,153,-337,278,-504r129,0v-81,139,-134,238,-160,297v-41,92,-73,188,-96,288v-29,125,-43,250,-43,376v0,321,100,641,299,961r-129,0","w":682},")":{"d":"253,431r-129,0v199,-320,299,-640,299,-961v0,-125,-14,-250,-43,-373v-23,-100,-54,-196,-95,-288v-26,-60,-80,-160,-161,-300r129,0v125,167,218,335,278,504v51,145,77,297,77,456v0,180,-35,354,-104,522v-69,168,-152,315,-251,440","w":682},"*":{"d":"64,-1197r46,-142v106,37,183,70,231,97v-13,-121,-19,-204,-20,-249r145,0v-2,66,-10,149,-23,248v69,-35,147,-67,236,-96r46,142v-85,28,-168,47,-249,56v41,35,98,98,172,189r-120,85v-39,-53,-84,-124,-137,-215v-49,94,-93,166,-130,215r-118,-85v77,-95,133,-158,166,-189v-86,-17,-168,-35,-245,-56","w":797},"+":{"d":"513,-237r0,-402r-399,0r0,-168r399,0r0,-399r170,0r0,399r399,0r0,168r-399,0r0,402r-170,0","w":1196},",":{"d":"182,0r0,-205r205,0r0,205v0,75,-13,136,-40,182v-27,46,-69,83,-127,108r-50,-77v38,-17,66,-41,84,-73v18,-32,28,-79,30,-140r-102,0","w":569},"-":{"d":"65,-440r0,-181r553,0r0,181r-553,0","w":682},"\u00ad":{"d":"65,-440r0,-181r553,0r0,181r-553,0","w":682},".":{"d":"186,0r0,-205r205,0r0,205r-205,0","w":569},"\/":{"d":"0,25r425,-1516r144,0r-424,1516r-145,0","w":569},"0":{"d":"85,-723v0,-173,17,-313,53,-419v36,-106,90,-187,160,-244v70,-57,158,-86,265,-86v79,0,148,16,207,48v59,32,108,76,147,136v39,60,69,132,91,218v22,86,33,202,33,347v0,172,-18,311,-53,417v-35,106,-88,186,-158,244v-70,58,-160,87,-267,87v-141,0,-252,-51,-333,-152v-97,-122,-145,-321,-145,-596xm270,-723v0,241,28,401,84,481v56,80,126,119,209,119v83,0,153,-40,209,-120v56,-80,84,-240,84,-480v0,-241,-28,-402,-84,-481v-56,-79,-127,-119,-211,-119v-83,0,-149,35,-198,105v-62,89,-93,254,-93,495"},"1":{"d":"763,0r-180,0r0,-1147v-43,41,-101,83,-171,124v-70,41,-133,72,-189,93r0,-174v101,-47,189,-105,264,-172v75,-67,129,-133,160,-196r116,0r0,1472","k":{"1":152}},"2":{"d":"1031,-173r0,173r-969,0v-1,-43,6,-85,21,-125v25,-66,65,-131,119,-195v54,-64,132,-138,235,-222v159,-131,267,-234,323,-310v56,-76,84,-149,84,-217v0,-71,-25,-132,-76,-181v-51,-49,-118,-73,-200,-73v-87,0,-156,26,-208,78v-52,52,-78,124,-79,216r-185,-19v13,-138,60,-244,143,-316v83,-72,194,-108,333,-108v141,0,252,39,334,117v82,78,123,175,123,290v0,59,-12,116,-36,173v-24,57,-63,116,-119,179v-56,63,-149,149,-278,258v-108,91,-177,153,-208,185v-31,32,-56,64,-76,97r719,0"},"3":{"d":"86,-387r180,-24v21,102,56,176,106,221v50,45,110,67,181,67v85,0,157,-29,215,-88v58,-59,87,-131,87,-218v0,-83,-27,-151,-81,-205v-54,-54,-123,-80,-206,-80v-34,0,-76,7,-127,20r20,-158v12,1,22,2,29,2v77,0,146,-20,207,-60v61,-40,92,-102,92,-185v0,-66,-22,-121,-67,-164v-45,-43,-102,-65,-173,-65v-70,0,-128,22,-175,66v-47,44,-77,110,-90,198r-180,-32v22,-121,72,-214,150,-280v78,-66,175,-100,291,-100v80,0,154,18,221,52v67,34,118,81,154,140v36,59,54,122,54,189v0,63,-17,121,-51,173v-34,52,-84,93,-151,124v87,20,154,61,202,124v48,63,72,142,72,237v0,128,-47,236,-140,325v-93,89,-211,134,-354,134v-129,0,-235,-38,-320,-115v-85,-77,-134,-176,-146,-298"},"4":{"d":"662,0r0,-351r-636,0r0,-165r669,-950r147,0r0,950r198,0r0,165r-198,0r0,351r-180,0xm662,-516r0,-661r-459,661r459,0"},"5":{"d":"85,-384r189,-16v14,92,47,162,98,208v51,46,112,69,184,69v87,0,160,-33,220,-98v60,-65,90,-152,90,-260v0,-103,-28,-184,-86,-243v-58,-59,-134,-89,-227,-89v-58,0,-110,13,-157,39v-47,26,-83,61,-110,103r-169,-22r142,-753r729,0r0,172r-585,0r-79,394v88,-61,180,-92,277,-92v128,0,236,44,324,133v88,89,132,203,132,342v0,133,-39,247,-116,344v-94,119,-222,178,-385,178v-133,0,-242,-37,-326,-112v-84,-75,-133,-174,-145,-297"},"6":{"d":"1019,-1107r-179,14v-16,-71,-39,-122,-68,-154v-49,-51,-109,-77,-180,-77v-57,0,-108,16,-151,48v-57,41,-101,102,-134,181v-33,79,-50,192,-51,339v43,-66,96,-115,159,-147v63,-32,128,-48,197,-48v120,0,222,45,306,133v84,88,127,202,127,342v0,92,-19,177,-59,256v-40,79,-95,140,-164,182v-69,42,-148,63,-236,63v-150,0,-272,-55,-367,-165v-95,-110,-142,-293,-142,-546v0,-283,52,-489,157,-618v91,-112,214,-168,369,-168v115,0,209,32,283,97v74,65,118,154,133,268xm284,-475v0,62,14,121,40,178v26,57,63,99,110,129v47,30,97,45,149,45v76,0,141,-31,196,-92v55,-61,82,-145,82,-250v0,-101,-27,-181,-81,-239v-54,-58,-122,-88,-204,-88v-81,0,-150,30,-207,88v-57,58,-85,134,-85,229"},"7":{"d":"97,-1274r0,-173r949,0r0,140v-93,99,-186,231,-278,396v-92,165,-162,334,-212,508v-36,123,-59,257,-69,403r-185,0v2,-115,25,-255,68,-418v43,-163,105,-320,186,-472v81,-152,168,-280,259,-384r-718,0"},"8":{"d":"362,-795v-75,-27,-130,-66,-166,-117v-36,-51,-54,-111,-54,-182v0,-107,38,-196,115,-269v77,-73,179,-109,306,-109v128,0,231,38,309,112v78,74,117,164,117,271v0,68,-17,127,-53,177v-36,50,-90,90,-163,117v90,29,158,77,205,142v47,65,71,143,71,234v0,125,-44,231,-133,316v-89,85,-205,128,-350,128v-145,0,-261,-43,-350,-129v-89,-86,-133,-192,-133,-320v0,-95,25,-176,73,-240v48,-64,117,-108,206,-131xm326,-1100v0,69,22,126,67,170v45,44,103,66,174,66v69,0,127,-22,171,-66v44,-44,66,-97,66,-160v0,-66,-22,-121,-68,-166v-46,-45,-103,-68,-171,-68v-69,0,-126,22,-171,66v-45,44,-68,97,-68,158xm268,-423v0,51,12,101,36,149v24,48,61,86,109,112v48,26,100,39,155,39v86,0,157,-28,213,-83v56,-55,84,-126,84,-211v0,-87,-29,-158,-87,-215v-58,-57,-129,-85,-216,-85v-85,0,-154,28,-210,84v-56,56,-84,126,-84,210"},"9":{"d":"112,-339r173,-16v15,81,43,140,84,177v41,37,94,55,159,55v55,0,104,-13,146,-38v42,-25,75,-59,102,-101v27,-42,49,-100,67,-172v18,-72,27,-145,27,-220v0,-8,0,-20,-1,-36v-36,57,-85,104,-147,140v-62,36,-130,53,-203,53v-121,0,-224,-44,-308,-132v-84,-88,-126,-204,-126,-348v0,-149,43,-268,131,-359v88,-91,198,-136,330,-136v95,0,183,26,262,77v79,51,139,124,180,219v41,95,61,233,61,413v0,187,-20,336,-61,447v-41,111,-102,196,-182,254v-80,58,-174,87,-282,87v-115,0,-208,-31,-281,-95v-73,-64,-116,-154,-131,-269xm849,-986v0,-103,-28,-185,-83,-246v-55,-61,-121,-91,-198,-91v-80,0,-150,33,-209,98v-59,65,-89,150,-89,254v0,93,28,169,84,227v56,58,126,88,209,88v83,0,151,-30,205,-88v54,-58,81,-139,81,-242"},":":{"d":"185,-857r0,-205r205,0r0,205r-205,0xm185,0r0,-205r205,0r0,205r-205,0","w":569},";":{"d":"182,-857r0,-205r205,0r0,205r-205,0xm182,0r0,-205r205,0r0,205v0,75,-13,136,-40,182v-27,46,-69,83,-127,108r-50,-77v38,-17,66,-41,84,-73v18,-32,28,-79,30,-140r-102,0","w":569},"\u037e":{"d":"182,-857r0,-205r205,0r0,205r-205,0xm182,0r0,-205r205,0r0,205v0,75,-13,136,-40,182v-27,46,-69,83,-127,108r-50,-77v38,-17,66,-41,84,-73v18,-32,28,-79,30,-140r-102,0","w":569},"<":{"d":"112,-641r0,-168r971,-410r0,179r-770,316r770,319r0,179","w":1196},"=":{"d":"1082,-862r-968,0r0,-168r968,0r0,168xm1082,-417r-968,0r0,-168r968,0r0,168","w":1196},">":{"d":"1083,-641r-971,415r0,-179r769,-319r-769,-316r0,-179r971,410r0,168","w":1196},"?":{"d":"472,-361v-1,-24,-1,-42,-1,-54v0,-71,10,-132,30,-183v15,-39,38,-78,71,-117v24,-29,68,-70,130,-125v62,-55,102,-99,121,-132v19,-33,28,-68,28,-107v0,-70,-27,-132,-82,-185v-55,-53,-122,-79,-201,-79v-77,0,-141,24,-192,72v-51,48,-85,123,-101,225r-185,-22v17,-137,66,-241,148,-314v82,-73,192,-109,327,-109v143,0,258,39,343,117v85,78,128,172,128,283v0,64,-15,123,-45,177v-30,54,-89,120,-176,197v-59,52,-97,90,-115,115v-18,25,-31,53,-40,85v-9,32,-14,84,-15,156r-173,0xm461,0r0,-205r205,0r0,205r-205,0"},"@":{"d":"1161,-163v-43,50,-91,91,-145,121v-54,30,-108,45,-162,45v-59,0,-117,-17,-173,-52v-56,-35,-102,-88,-137,-160v-35,-72,-52,-151,-52,-237v0,-106,28,-212,82,-318v54,-106,121,-187,202,-240v81,-53,159,-80,235,-80v58,0,113,16,166,46v53,30,98,76,136,138r34,-155r179,0r-144,671v-20,93,-30,145,-30,155v0,18,6,34,20,47v14,13,31,19,50,19v35,0,82,-20,139,-61v76,-53,137,-124,181,-214v44,-90,66,-183,66,-278v0,-111,-29,-215,-86,-312v-57,-97,-141,-174,-254,-232v-113,-58,-238,-87,-375,-87v-156,0,-298,36,-427,109v-129,73,-229,178,-300,314v-71,136,-107,283,-107,439v0,163,36,304,107,422v71,118,174,205,308,261v134,56,283,85,446,85v175,0,321,-29,439,-88v118,-59,206,-130,265,-214r181,0v-34,70,-92,141,-175,214v-83,73,-181,131,-295,173v-114,42,-251,63,-412,63v-148,0,-284,-19,-409,-57v-125,-38,-232,-96,-320,-172v-88,-76,-154,-164,-199,-263v-56,-126,-84,-262,-84,-408v0,-163,33,-318,100,-465v81,-181,197,-319,347,-415v150,-96,331,-144,544,-144v165,0,314,33,446,101v132,68,235,169,311,303v65,115,97,241,97,376v0,193,-68,365,-204,515v-121,135,-254,202,-398,202v-46,0,-84,-7,-112,-21v-28,-14,-49,-34,-62,-60v-9,-17,-15,-45,-19,-86xm677,-434v0,91,22,162,65,213v43,51,93,76,149,76v37,0,77,-11,118,-33v41,-22,81,-56,119,-100v38,-44,68,-100,92,-168v24,-68,36,-135,36,-203v0,-91,-23,-161,-68,-211v-45,-50,-99,-75,-164,-75v-43,0,-82,11,-120,33v-38,22,-75,56,-110,104v-35,48,-64,106,-85,175v-21,69,-32,132,-32,189","w":2079},"A":{"d":"-3,0r563,-1466r209,0r600,1466r-221,0r-171,-444r-613,0r-161,444r-206,0xm420,-602r497,0r-153,-406v-47,-123,-81,-225,-104,-304v-19,94,-45,187,-79,280","w":1366,"k":{"y":37,"w":37,"v":37,"Y":152,"W":76,"V":152,"T":152," ":113}},"B":{"d":"150,0r0,-1466r550,0v112,0,202,14,270,44v68,30,120,76,158,138v38,62,58,126,58,193v0,63,-17,122,-51,177v-34,55,-85,100,-154,134v89,26,157,70,205,133v48,63,71,137,71,222v0,69,-14,132,-43,191v-29,59,-65,105,-108,137v-43,32,-96,57,-160,73v-64,16,-144,24,-237,24r-559,0xm344,-850r317,0v86,0,148,-6,185,-17v49,-15,87,-39,112,-73v25,-34,37,-77,37,-128v0,-49,-12,-91,-35,-128v-23,-37,-57,-62,-100,-76v-43,-14,-118,-21,-223,-21r-293,0r0,443xm344,-173r365,0v63,0,107,-2,132,-7v45,-8,82,-21,112,-40v30,-19,55,-46,74,-82v19,-36,29,-76,29,-123v0,-55,-14,-103,-42,-143v-28,-40,-66,-68,-116,-84v-50,-16,-122,-25,-215,-25r-339,0r0,504","w":1366},"C":{"d":"1204,-514r194,49v-41,159,-114,281,-220,365v-106,84,-234,125,-387,125v-158,0,-286,-33,-385,-97v-99,-64,-174,-157,-226,-279v-52,-122,-78,-253,-78,-393v0,-153,30,-286,88,-400v58,-114,140,-199,248,-258v108,-59,227,-89,356,-89v147,0,270,37,370,112v100,75,170,180,209,315r-191,45v-34,-107,-83,-184,-148,-233v-65,-49,-146,-73,-244,-73v-113,0,-206,27,-282,81v-76,54,-129,127,-160,218v-31,91,-46,184,-46,281v0,125,18,234,54,327v36,93,93,162,170,208v77,46,160,69,249,69v109,0,201,-31,276,-94v75,-63,126,-156,153,-279","w":1479},"D":{"d":"158,0r0,-1466r505,0v114,0,201,7,261,21v84,19,156,54,215,105v77,65,135,148,173,250v38,102,58,218,58,349v0,111,-13,210,-39,296v-26,86,-59,157,-100,213v-41,56,-85,102,-133,134v-48,32,-108,56,-176,73v-68,17,-146,25,-235,25r-529,0xm352,-173r313,0v97,0,172,-9,227,-27v55,-18,99,-43,132,-76v46,-46,82,-108,108,-186v26,-78,38,-171,38,-282v0,-153,-26,-272,-76,-354v-50,-82,-111,-137,-183,-165v-52,-20,-136,-30,-251,-30r-308,0r0,1120","w":1479},"E":{"d":"162,0r0,-1466r1060,0r0,173r-866,0r0,449r811,0r0,172r-811,0r0,499r900,0r0,173r-1094,0","w":1366},"F":{"d":"168,0r0,-1466r989,0r0,173r-795,0r0,454r688,0r0,173r-688,0r0,666r-194,0","w":1251,"k":{"A":113,".":227,",":227}},"G":{"d":"844,-575r0,-172r621,-1r0,544v-95,76,-194,134,-295,172v-101,38,-205,57,-312,57v-144,0,-274,-31,-392,-93v-118,-62,-207,-150,-267,-267v-60,-117,-90,-247,-90,-391v0,-143,29,-276,89,-400v60,-124,146,-215,258,-275v112,-60,241,-90,387,-90v106,0,201,17,287,51v86,34,153,83,202,144v49,61,86,141,111,240r-175,48v-22,-75,-49,-133,-82,-176v-33,-43,-79,-76,-140,-102v-61,-26,-128,-39,-202,-39v-89,0,-165,14,-230,41v-65,27,-116,62,-156,106v-40,44,-71,92,-93,145v-37,91,-56,189,-56,295v0,131,22,240,67,328v45,88,111,153,197,196v86,43,177,64,274,64v84,0,166,-16,246,-48v80,-32,141,-67,182,-104r0,-273r-431,0","w":1593},"H":{"d":"164,0r0,-1466r194,0r0,602r762,0r0,-602r194,0r0,1466r-194,0r0,-691r-762,0r0,691r-194,0","w":1479},"I":{"d":"191,0r0,-1466r194,0r0,1466r-194,0","w":569},"J":{"d":"59,-416r175,-24v5,112,26,189,63,230v37,41,89,62,155,62v49,0,91,-12,126,-34v35,-22,60,-52,73,-90v13,-38,20,-100,20,-184r0,-1010r194,0r0,999v0,123,-15,218,-45,285v-30,67,-76,119,-140,154v-64,35,-140,53,-227,53v-129,0,-227,-37,-295,-111v-68,-74,-102,-184,-99,-330","w":1024},"K":{"d":"150,0r0,-1466r194,0r0,727r728,-727r263,0r-615,594r642,872r-256,0r-522,-742r-240,234r0,508r-194,0","w":1366},"L":{"d":"150,0r0,-1466r194,0r0,1293r722,0r0,173r-916,0","k":{"y":76,"Y":152,"W":152,"V":152,"T":152," ":76}},"M":{"d":"152,0r0,-1466r292,0r347,1038r70,217r78,-235r351,-1020r261,0r0,1466r-187,0r0,-1227r-426,1227r-175,0r-424,-1248r0,1248r-187,0","w":1706},"N":{"d":"156,0r0,-1466r199,0r770,1151r0,-1151r186,0r0,1466r-199,0r-770,-1152r0,1152r-186,0","w":1479},"O":{"d":"99,-714v0,-243,65,-434,196,-572v131,-138,299,-206,506,-206v135,0,257,32,366,97v109,65,192,155,249,271v57,116,85,246,85,393v0,149,-30,282,-90,399v-60,117,-145,206,-255,266v-110,60,-229,91,-356,91v-138,0,-261,-33,-370,-100v-109,-67,-191,-158,-247,-273v-56,-115,-84,-237,-84,-366xm299,-711v0,177,48,315,143,417v95,102,214,153,357,153v146,0,267,-51,361,-154v94,-103,141,-248,141,-437v0,-119,-21,-223,-61,-312v-40,-89,-98,-159,-176,-208v-78,-49,-165,-73,-262,-73v-137,0,-255,47,-354,141v-99,94,-149,252,-149,473","w":1593},"P":{"d":"158,0r0,-1466r553,0v97,0,172,5,223,14v72,12,132,34,181,68v49,34,87,81,117,142v30,61,45,127,45,200v0,125,-40,230,-119,316v-79,86,-223,130,-430,130r-376,0r0,596r-194,0xm352,-769r379,0v125,0,214,-23,267,-70v53,-47,79,-112,79,-197v0,-61,-16,-114,-47,-158v-31,-44,-71,-72,-122,-86v-33,-9,-93,-13,-181,-13r-375,0r0,524","w":1366,"k":{"A":152,".":264,",":264," ":37}},"Q":{"d":"1269,-157v90,62,173,107,249,136r-57,135v-105,-38,-210,-98,-315,-180v-109,61,-229,91,-360,91v-133,0,-253,-32,-361,-96v-108,-64,-191,-154,-249,-270v-58,-116,-88,-247,-88,-392v0,-145,29,-276,88,-395v59,-119,142,-209,250,-271v108,-62,230,-93,364,-93v135,0,257,32,366,96v109,64,191,154,248,270v57,116,86,247,86,392v0,121,-18,230,-55,326v-37,96,-92,180,-166,251xm842,-405v112,31,204,78,277,140v114,-104,171,-260,171,-469v0,-119,-20,-222,-60,-311v-40,-89,-100,-158,-178,-207v-78,-49,-164,-73,-261,-73v-145,0,-265,50,-360,149v-95,99,-143,246,-143,443v0,191,48,337,142,439v94,102,214,153,361,153v69,0,135,-13,196,-39v-61,-39,-125,-67,-192,-84","w":1593},"R":{"d":"161,0r0,-1466r650,0v131,0,230,14,298,40v68,26,122,72,163,139v41,67,61,140,61,221v0,104,-34,192,-101,263v-67,71,-171,117,-312,136v51,25,90,49,117,73v57,52,110,117,161,195r255,399r-244,0r-194,-305v-57,-88,-103,-155,-140,-202v-37,-47,-70,-79,-99,-98v-29,-19,-58,-32,-88,-39v-22,-5,-58,-7,-108,-7r-225,0r0,651r-194,0xm355,-819r417,0v89,0,158,-9,208,-27v50,-18,88,-48,114,-88v26,-40,39,-85,39,-132v0,-69,-25,-126,-75,-171v-50,-45,-130,-67,-239,-67r-464,0r0,485","w":1479,"k":{"Y":37,"W":37,"V":37,"T":37}},"S":{"d":"92,-471r183,-16v9,73,29,134,61,181v32,47,80,85,147,114v67,29,142,43,225,43v74,0,139,-11,196,-33v57,-22,98,-52,126,-90v28,-38,42,-81,42,-126v0,-46,-13,-86,-40,-120v-27,-34,-71,-64,-132,-87v-39,-15,-126,-39,-261,-71v-135,-32,-229,-63,-283,-92v-70,-37,-122,-82,-156,-136v-34,-54,-52,-116,-52,-183v0,-74,21,-143,63,-207v42,-64,103,-114,184,-147v81,-33,170,-50,269,-50v109,0,205,18,288,53v83,35,146,86,191,154v45,68,69,145,72,231r-186,14v-10,-93,-43,-163,-101,-210v-58,-47,-143,-71,-256,-71v-117,0,-202,21,-256,64v-54,43,-81,95,-81,156v0,53,19,96,57,130v37,34,134,68,292,104v158,36,266,67,325,94v85,39,148,90,189,150v41,60,61,129,61,208v0,78,-22,151,-67,220v-45,69,-108,124,-192,162v-84,38,-178,57,-283,57v-133,0,-243,-19,-333,-58v-90,-39,-161,-97,-212,-175v-51,-78,-77,-165,-80,-263","w":1366},"T":{"d":"531,0r0,-1293r-483,0r0,-173r1162,0r0,173r-485,0r0,1293r-194,0","w":1251,"k":{"y":113,"w":113,"u":76,"s":227,"r":76,"o":227,"i":76,"e":227,"c":227,"a":227,"O":37,"A":152,";":227,":":227,".":227,"-":113,",":227," ":37}},"U":{"d":"1120,-1466r194,0r0,847v0,147,-17,264,-50,351v-33,87,-93,158,-180,212v-87,54,-202,81,-343,81v-137,0,-250,-24,-337,-71v-87,-47,-150,-116,-187,-206v-37,-90,-56,-212,-56,-367r0,-847r194,0r0,846v0,127,11,222,35,282v24,60,64,106,122,139v58,33,129,49,212,49v143,0,244,-32,305,-97v61,-65,91,-189,91,-373r0,-846","w":1479},"V":{"d":"577,0r-568,-1466r210,0r381,1065v31,85,56,165,77,240v23,-80,49,-160,79,-240r396,-1065r198,0r-574,1466r-199,0","w":1366,"k":{"y":76,"u":76,"r":76,"o":113,"i":37,"e":113,"a":152,"A":152,";":76,":":76,".":188,"-":113,",":188}},"W":{"d":"414,0r-389,-1466r199,0r223,961v24,101,45,201,62,300v37,-157,59,-247,66,-271r279,-990r234,0r210,742v53,184,91,357,114,519v19,-93,43,-199,73,-319r230,-942r195,0r-402,1466r-187,0r-309,-1117v-26,-93,-41,-151,-46,-172v-15,67,-30,125,-43,172r-311,1117r-198,0","w":1933,"k":{"y":18,"u":37,"r":37,"o":37,"e":37,"a":76,"A":76,";":37,":":37,".":113,"-":37,",":113}},"X":{"d":"9,0r567,-764r-500,-702r231,0r266,376v55,78,95,138,118,180v33,-53,71,-109,116,-167r295,-389r211,0r-515,691r555,775r-240,0r-369,-523v-21,-30,-42,-63,-64,-98v-33,53,-56,90,-70,110r-368,511r-233,0","w":1366},"Y":{"d":"571,0r0,-621r-565,-845r236,0r289,442v53,83,103,165,149,248v44,-77,97,-163,160,-259r284,-431r226,0r-585,845r0,621r-194,0","w":1366,"k":{"v":113,"u":113,"q":188,"p":152,"o":188,"i":76,"e":188,"a":152,"A":152,";":133,":":113,".":264,"-":188,",":264," ":37}},"Z":{"d":"41,0r0,-180r751,-939v53,-67,104,-125,152,-174r-818,0r0,-173r1050,0r0,173r-823,1017r-89,103r936,0r0,173r-1159,0","w":1251},"[":{"d":"139,407r0,-1873r397,0r0,149r-217,0r0,1575r217,0r0,149r-397,0","w":569},"\\":{"d":"425,25r-425,-1516r145,0r424,1516r-144,0","w":569},"]":{"d":"436,407r-397,0r0,-149r217,0r0,-1575r-217,0r0,-149r397,0r0,1873","w":569},"^":{"d":"239,-690r-185,0r353,-801r145,0r355,801r-181,0r-247,-597","w":961},"_":{"d":"-31,407r0,-130r1193,0r0,130r-1193,0"},"`":{"d":"465,-1194r-145,0r-231,-280r241,0","w":682},"a":{"d":"828,-131v-67,57,-130,97,-192,120v-62,23,-128,35,-199,35v-117,0,-206,-29,-269,-86v-63,-57,-94,-129,-94,-218v0,-52,12,-99,36,-142v24,-43,54,-78,92,-104v38,-26,82,-46,130,-59v35,-9,89,-18,160,-27v145,-17,252,-38,321,-62v1,-25,1,-40,1,-47v0,-73,-17,-125,-51,-155v-46,-41,-114,-61,-205,-61v-85,0,-148,15,-188,45v-40,30,-70,82,-89,157r-176,-24v16,-75,42,-137,79,-183v37,-46,90,-81,159,-106v69,-25,150,-38,241,-38v91,0,164,11,221,32v57,21,98,48,125,80v27,32,45,74,56,123v6,31,9,86,9,166r0,240v0,167,3,273,11,317v8,44,23,87,46,128r-188,0v-19,-37,-31,-81,-36,-131xm813,-533v-65,27,-163,49,-294,68v-74,11,-126,23,-157,36v-31,13,-54,33,-71,59v-17,26,-25,54,-25,85v0,48,18,88,54,120v36,32,90,48,160,48v69,0,131,-15,185,-45v54,-30,94,-72,119,-125v19,-41,29,-101,29,-180r0,-66"},"b":{"d":"301,0r-167,0r0,-1466r180,0r0,523v76,-95,173,-143,291,-143v65,0,127,14,185,40v58,26,106,62,144,110v38,48,68,106,89,173v21,67,32,139,32,216v0,182,-45,323,-135,422v-90,99,-198,149,-324,149v-125,0,-224,-52,-295,-157r0,133xm299,-539v0,127,17,219,52,276v57,93,133,139,230,139v79,0,147,-34,204,-102v57,-68,86,-171,86,-306v0,-139,-28,-241,-83,-307v-55,-66,-121,-99,-199,-99v-79,0,-147,34,-204,102v-57,68,-86,168,-86,297"},"c":{"d":"828,-389r177,23v-19,122,-69,217,-149,286v-80,69,-177,104,-293,104v-145,0,-263,-47,-351,-142v-88,-95,-132,-232,-132,-409v0,-115,19,-215,57,-301v38,-86,95,-151,173,-194v78,-43,163,-64,254,-64v115,0,210,30,283,88v73,58,120,141,141,248r-175,27v-17,-71,-47,-125,-89,-161v-42,-36,-93,-54,-153,-54v-91,0,-164,33,-221,98v-57,65,-85,167,-85,308v0,143,27,246,82,311v55,65,126,97,214,97v71,0,130,-22,177,-65v47,-43,77,-110,90,-200","w":1024},"d":{"d":"824,0r0,-134v-67,105,-166,158,-297,158v-85,0,-162,-23,-233,-70v-71,-47,-127,-112,-166,-196v-39,-84,-58,-179,-58,-288v0,-106,18,-202,53,-288v35,-86,88,-153,159,-199v71,-46,150,-69,237,-69v64,0,121,13,171,40v50,27,91,63,122,106r0,-526r179,0r0,1466r-167,0xm255,-530v0,136,29,238,86,305v57,67,125,101,203,101v79,0,145,-32,200,-96v55,-64,83,-163,83,-295v0,-145,-28,-252,-84,-320v-56,-68,-125,-102,-207,-102v-80,0,-146,33,-200,98v-54,65,-81,168,-81,309"},"e":{"d":"862,-342r186,23v-29,109,-84,193,-163,253v-79,60,-181,90,-304,90v-155,0,-278,-48,-369,-144v-91,-96,-137,-229,-137,-402v0,-179,46,-317,138,-416v92,-99,211,-148,358,-148v142,0,258,48,348,145v90,97,135,233,135,408v0,11,0,27,-1,48r-792,0v7,117,40,206,99,268v59,62,133,93,222,93v66,0,122,-17,169,-52v47,-35,84,-90,111,-166xm271,-633r593,0v-8,-89,-31,-156,-68,-201v-57,-69,-132,-104,-223,-104v-83,0,-153,28,-209,83v-56,55,-87,129,-93,222"},"f":{"d":"178,0r0,-922r-159,0r0,-140r159,0r0,-113v0,-71,6,-124,19,-159v17,-47,47,-85,91,-114v44,-29,105,-43,184,-43v51,0,107,6,168,18r-27,157v-37,-7,-73,-10,-106,-10v-55,0,-93,12,-116,35v-23,23,-34,67,-34,131r0,98r207,0r0,140r-207,0r0,922r-179,0","w":569,"k":{"f":37}},"g":{"d":"102,88r175,26v7,54,28,93,61,118v45,33,106,50,183,50v83,0,148,-17,193,-50v45,-33,76,-80,92,-140v9,-37,14,-114,13,-231v-79,93,-177,139,-294,139v-146,0,-259,-53,-339,-158v-80,-105,-120,-232,-120,-379v0,-101,18,-195,55,-281v37,-86,89,-151,159,-198v70,-47,152,-70,246,-70v125,0,229,51,310,152r0,-128r166,0r0,918v0,165,-16,283,-50,352v-34,69,-87,123,-160,163v-73,40,-163,60,-270,60v-127,0,-229,-28,-307,-85v-78,-57,-116,-143,-113,-258xm251,-550v0,139,28,241,83,305v55,64,125,96,208,96v83,0,152,-31,208,-95v56,-64,84,-164,84,-300v0,-130,-28,-228,-86,-294v-58,-66,-128,-99,-209,-99v-80,0,-148,32,-204,97v-56,65,-84,162,-84,290"},"h":{"d":"135,0r0,-1466r180,0r0,526v84,-97,190,-146,318,-146v79,0,147,15,205,46v58,31,99,74,124,129v25,55,38,134,38,238r0,673r-180,0r0,-673v0,-90,-19,-156,-58,-197v-39,-41,-95,-61,-166,-61v-53,0,-103,13,-150,41v-47,28,-81,66,-101,113v-20,47,-30,113,-30,196r0,581r-180,0"},"i":{"d":"136,-1259r0,-207r180,0r0,207r-180,0xm136,0r0,-1062r180,0r0,1062r-180,0","w":455},"j":{"d":"134,-1257r0,-209r180,0r0,209r-180,0xm-94,412r34,-153v36,9,64,14,85,14v37,0,64,-13,82,-37v18,-24,27,-85,27,-182r0,-1116r180,0r0,1120v0,131,-17,222,-51,273v-43,67,-115,100,-216,100v-49,0,-96,-6,-141,-19","w":455},"k":{"d":"136,0r0,-1466r180,0r0,836r426,-432r233,0r-406,394r447,668r-222,0r-351,-543r-127,122r0,421r-180,0","w":1024},"l":{"d":"131,0r0,-1466r180,0r0,1466r-180,0","w":455},"m":{"d":"135,0r0,-1062r161,0r0,149v33,-52,78,-93,133,-125v55,-32,118,-48,189,-48v79,0,144,16,194,49v50,33,85,78,106,137v84,-124,193,-186,328,-186v105,0,186,30,243,88v57,58,85,148,85,269r0,729r-179,0r0,-669v0,-72,-5,-123,-17,-155v-12,-32,-33,-58,-64,-77v-31,-19,-67,-29,-108,-29v-75,0,-137,24,-186,74v-49,50,-74,130,-74,239r0,617r-180,0r0,-690v0,-80,-15,-140,-44,-180v-29,-40,-77,-60,-144,-60v-51,0,-97,13,-140,40v-43,27,-75,66,-94,117v-19,51,-29,125,-29,222r0,551r-180,0","w":1706},"n":{"d":"135,0r0,-1062r162,0r0,151v78,-117,191,-175,338,-175v64,0,123,11,177,34v54,23,93,54,120,91v27,37,45,82,56,133v7,33,10,92,10,175r0,653r-180,0r0,-646v0,-73,-7,-128,-21,-164v-14,-36,-39,-66,-75,-88v-36,-22,-77,-32,-125,-32v-77,0,-143,24,-199,73v-56,49,-83,141,-83,277r0,580r-180,0"},"o":{"d":"68,-531v0,-197,55,-342,164,-437v91,-79,203,-118,334,-118v146,0,265,48,358,144v93,96,139,227,139,396v0,137,-20,244,-61,322v-41,78,-102,140,-180,183v-78,43,-163,65,-256,65v-149,0,-268,-48,-360,-143v-92,-95,-138,-233,-138,-412xm253,-531v0,136,30,237,89,305v59,68,134,102,224,102v89,0,164,-34,223,-102v59,-68,89,-172,89,-311v0,-131,-30,-231,-90,-299v-60,-68,-133,-101,-222,-101v-90,0,-165,34,-224,101v-59,67,-89,169,-89,305"},"p":{"d":"135,407r0,-1469r164,0r0,138v39,-54,82,-95,131,-122v49,-27,108,-40,177,-40v91,0,171,23,240,70v69,47,122,113,157,198v35,85,53,178,53,279v0,109,-20,206,-59,293v-39,87,-96,154,-170,200v-74,46,-152,70,-234,70v-60,0,-114,-13,-162,-38v-48,-25,-86,-57,-117,-96r0,517r-180,0xm298,-525v0,137,28,238,83,303v55,65,122,98,201,98v80,0,149,-34,206,-102v57,-68,85,-172,85,-314v0,-135,-27,-237,-83,-304v-56,-67,-123,-101,-200,-101v-77,0,-145,35,-204,107v-59,72,-88,176,-88,313"},"q":{"d":"812,407r0,-520v-28,39,-68,72,-118,98v-50,26,-103,39,-160,39v-126,0,-235,-50,-326,-151v-91,-101,-136,-239,-136,-414v0,-107,19,-202,56,-287v37,-85,90,-148,160,-192v70,-44,148,-66,232,-66v131,0,235,55,310,166r0,-142r162,0r0,1469r-180,0xm257,-534v0,137,29,240,86,308v57,68,126,102,206,102v77,0,143,-33,198,-98v55,-65,83,-163,83,-296v0,-141,-30,-248,-88,-319v-58,-71,-126,-107,-205,-107v-78,0,-145,34,-199,100v-54,66,-81,169,-81,310"},"r":{"d":"133,0r0,-1062r162,0r0,161v41,-75,80,-125,115,-149v35,-24,73,-36,115,-36v61,0,122,19,185,58r-62,167v-44,-26,-88,-39,-132,-39v-39,0,-75,12,-106,36v-31,24,-54,56,-67,98v-20,64,-30,134,-30,210r0,556r-180,0","w":682,"k":{".":113,",":113}},"s":{"d":"63,-317r178,-28v10,71,37,126,83,164v46,38,110,57,192,57v83,0,144,-16,184,-50v40,-34,60,-74,60,-119v0,-41,-18,-73,-53,-96v-25,-16,-86,-36,-184,-61v-132,-33,-224,-62,-275,-86v-51,-24,-90,-59,-116,-102v-26,-43,-39,-90,-39,-142v0,-47,11,-92,33,-132v22,-40,51,-73,88,-100v28,-21,66,-38,114,-52v48,-14,101,-22,156,-22v83,0,157,12,220,36v63,24,109,57,139,98v30,41,51,95,62,164r-176,24v-8,-55,-31,-97,-69,-128v-38,-31,-93,-46,-163,-46v-83,0,-142,14,-177,41v-35,27,-53,59,-53,96v0,23,7,44,22,63v15,19,38,35,69,48v18,7,71,22,159,46v127,34,217,62,267,84v50,22,89,53,118,94v29,41,43,93,43,154v0,60,-18,117,-53,170v-35,53,-85,93,-151,122v-66,29,-141,44,-224,44v-138,0,-243,-29,-315,-86v-72,-57,-119,-142,-139,-255","w":1024},"t":{"d":"528,-161r26,159v-51,11,-96,16,-136,16v-65,0,-116,-10,-152,-31v-36,-21,-61,-47,-76,-81v-15,-34,-22,-105,-22,-213r0,-611r-132,0r0,-140r132,0r0,-263r179,-108r0,371r181,0r0,140r-181,0r0,621v0,51,3,84,9,99v6,15,18,26,32,35v14,9,34,13,61,13v20,0,46,-2,79,-7","w":569},"u":{"d":"831,0r0,-156v-83,120,-195,180,-337,180v-63,0,-122,-12,-176,-36v-54,-24,-94,-54,-120,-90v-26,-36,-45,-81,-56,-134v-7,-35,-11,-91,-11,-168r0,-658r180,0r0,589v0,94,4,157,11,190v11,47,35,84,72,111v37,27,82,41,136,41v54,0,105,-13,152,-41v47,-28,80,-66,100,-114v20,-48,30,-116,30,-207r0,-569r180,0r0,1062r-161,0"},"v":{"d":"430,0r-404,-1062r190,0r228,636v25,69,47,140,68,214v16,-56,38,-123,67,-202r236,-648r185,0r-402,1062r-168,0","w":1024,"k":{".":152,",":152}},"w":{"d":"331,0r-325,-1062r186,0r169,613r63,228v3,-11,21,-84,55,-219r169,-622r185,0r159,616r53,203r61,-205r182,-614r175,0r-332,1062r-187,0r-169,-636r-41,-181r-215,817r-188,0","w":1479,"k":{".":113,",":113}},"x":{"d":"15,0r388,-552r-359,-510r225,0r163,249v31,47,55,87,74,119r81,-117r179,-251r215,0r-367,500r395,562r-221,0r-218,-330r-58,-89r-279,419r-218,0","w":1024},"y":{"d":"127,409r-20,-169v39,11,74,16,103,16v40,0,72,-7,96,-20v24,-13,44,-32,59,-56v11,-18,30,-63,55,-134v3,-10,9,-25,16,-44r-403,-1064r194,0r221,615v29,78,54,160,77,246v21,-83,45,-163,74,-242r227,-619r180,0r-404,1080v-43,117,-77,197,-101,241v-32,59,-69,103,-110,131v-41,28,-91,41,-148,41v-35,0,-73,-7,-116,-22","w":1024,"k":{".":152,",":152}},"z":{"d":"40,0r0,-146r676,-776v-77,4,-144,6,-203,6r-433,0r0,-146r868,0r0,119r-575,674r-111,123v81,-6,156,-9,227,-9r491,0r0,155r-940,0","w":1024},"{":{"d":"57,-612v51,-1,93,-16,125,-42v32,-26,54,-62,65,-108v11,-46,16,-125,17,-236v1,-111,3,-185,6,-220v6,-56,18,-101,34,-135v16,-34,36,-61,60,-81v24,-20,55,-36,92,-47v25,-7,67,-10,124,-10r56,0r0,157r-31,0v-69,0,-115,13,-138,38v-23,25,-34,80,-34,167v0,175,-4,285,-11,331v-12,71,-33,126,-62,165v-29,39,-74,73,-136,103v73,31,127,77,160,140v33,63,49,167,49,310v0,130,1,207,4,232v5,45,19,77,41,95v22,18,64,27,127,27r31,0r0,157r-56,0v-65,0,-113,-5,-142,-16v-43,-15,-78,-41,-106,-75v-28,-34,-46,-77,-54,-130v-8,-53,-13,-139,-14,-259v-1,-120,-6,-203,-17,-249v-11,-46,-33,-82,-65,-109v-32,-27,-74,-41,-125,-42r0,-163","w":684},"|":{"d":"188,431r0,-1922r157,0r0,1922r-157,0","w":532},"}":{"d":"626,-612r0,163v-51,1,-94,15,-126,42v-32,27,-53,63,-64,109v-11,46,-16,124,-17,235v-1,111,-3,185,-6,220v-6,57,-17,101,-33,135v-16,34,-37,62,-61,82v-24,20,-55,35,-92,46v-25,7,-67,11,-124,11r-56,0r0,-157r31,0v69,0,115,-13,138,-38v23,-25,34,-81,34,-168v0,-167,3,-272,9,-317v11,-74,32,-133,64,-177v32,-44,77,-79,136,-104v-77,-37,-131,-86,-162,-146v-31,-60,-47,-162,-47,-305v0,-130,-2,-208,-5,-233v-5,-45,-17,-76,-39,-94v-22,-18,-65,-26,-128,-26r-31,0r0,-157r56,0v65,0,113,5,142,16v43,15,78,39,106,74v28,35,47,78,55,131v8,53,12,139,13,259v1,120,6,203,17,249v11,46,32,81,64,108v32,27,75,41,126,42","w":684},"~":{"d":"87,-557r0,-205v71,-80,163,-120,278,-120v40,0,82,6,126,18v44,12,107,34,188,69v46,19,80,32,103,38v23,6,47,9,70,9v43,0,88,-13,134,-39v46,-26,88,-59,124,-98r0,212v-43,40,-86,69,-130,87v-44,18,-92,27,-147,27v-40,0,-79,-5,-115,-14v-36,-9,-93,-32,-172,-67v-79,-35,-145,-53,-198,-53v-43,0,-82,9,-120,27v-38,18,-85,55,-141,109","w":1196}}});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(225);
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    Raphael = __webpack_require__(182);
	
	
	var instanceVars = {
	    signatureModel: null
	};
	
	/* Note: clicking the canvas will not deselect the edit dialog if it is open -- can only draw one shape so propagation stopped */
	
	module.exports = Marionette.ItemView.extend({
	
	    id: 'signatureDialog',
	
	    template: __webpack_require__(226),
	
	    initialize: function(options) {
	
	        _.extend(this, instanceVars, _.pick(options, 'signatureModel'));
	    },
	
	    serializeData: function() {
	
	        var signature = this.signatureModel,
	            fontHash = signature.fontNamesHash();
	
	        return {
	            fontHash: fontHash, /* key by font-face value -- may no longer be necessary */
	            showBottomText: signature.get('showBottomText')
	        };
	
	    },
	    onRender: function() {
	
	        this._checkFontRadio( this.signatureModel.get('activeFont') );
	
	    },
	
	    /* must attach $el before print label */
	    onShow: function() {
	
	        this._renderRaphaelFontLabels( this.signatureModel.fontNamesHash() );
	
	    },
	    events: {
	        'click      .ftInputRow'        : 'fontRowClick',
	        'mouseover  .ftInputRow'        : 'onHover',
	        'mouseout   .ftInputRow'        : 'onHover',
	        'change     #showBottomText'    : 'toggleBottomText'
	    },
	    toggleBottomText: function(e) {
	
	        var isChecked = $(e.currentTarget).is(':checked');
	        this.signatureModel.set('showBottomText', isChecked); //-- triggers (mediate?)
	
	    },
	    _renderRaphaelFontLabels: function(fontHash) {
	
	        var baseColor = this.$el.css('color');
	
	        _.each( _.keys(fontHash), function(font) {
	
	            var k = font,
	                $div = this.$('.rFontElPlaceHolder[data-font="' + k + '"]'),
	                paper = new Raphael($div[0], '100%', '100%'), /* take up space set in css */
	                ht = $div.height(),
	                fontSize = ht - 5, //ensure fits inside (fonts have diff sizes) .. so it's 5 px less the the css
	                LEFT_OFFSET = 4,
	                fontEl = paper.print(0 + LEFT_OFFSET,ht/2, k, paper.getFont(k), fontSize).attr({
	                    'text-anchor': 'start',
	                    fill: this.signatureModel.get('activeFont') === k ? 'black' : baseColor
	                });
	
	            $div.data('printedFont', fontEl); //for ref'ing the paper from the div
	
	        }, this);
	    },
	    _getFontEls: function() {
	        return $('.rFontElPlaceHolder').map(function() {
	            return $(this).data().printedFont;
	        });
	    },
	    onHover: function(e) {
	
	        var nonSelectedEls =  $('.rFontElPlaceHolder').siblings().not(':checked').map(function() {
	            return $(this).siblings().data().printedFont;
	        });
	
	        _.each(nonSelectedEls, function(el) {
	            el.animate({
	                fill: this.$el.css('color'),
	                transform: 's1'
	            }, 50);
	        }, this);
	
	        if (e.type === 'mouseover') {
	            var fontEl = $(e.currentTarget).find('.rFontElPlaceHolder').data('printedFont'); //could also forward events to the paper
	           // fontEl.animate({ fill: 'black'}, 100, '<'); //todo: would need to be cleaner
	            fontEl.animate({
	                fill: 'black',
	                transform: 's1.1'
	            }, 50);
	        }
	
	    },
	    fontRowClick: function(e) {
	        var val = $(e.currentTarget).find('input').val();
	        this._unselectAll();
	        var fontEl = $(e.currentTarget).find('.rFontElPlaceHolder').data('printedFont'); //could also forward events to the paper
	        fontEl.animate({
	            fill: 'black',
	            transform: 's1.1'
	        }, 50);
	        this._checkFontRadio(val, fontEl);
	        this.signatureModel.set('activeFont', val);
	    },
	    _checkFontRadio: function(fontName) {
	        this.$('input[type="radio"][value="' + fontName + '"]').prop('checked', true);
	    },
	    _unselectAll: function() {
	
	        var rEls = this._getFontEls();
	        _.each(rEls, function(el) {
	            el.animate({
	                fill: this.$el.css('color'),//(no bold)
	                transform: 's1'
	            }, 50);
	        }, this);
	
	    }
	
	});

/***/ },
/* 225 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "        <div class=\"ftInputRow\" data-font=\""
	    + alias4(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
	    + "\">\n            <input type=\"radio\" name=\"font\" value=\""
	    + alias4(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
	    + "\" title=\""
	    + alias4(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
	    + "\">\n            <div class=\"rFontElPlaceHolder\" data-font=\""
	    + alias4(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
	    + "\"></div>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"ftLbl\">Font:</div>\n\n<form class=\"fontForm\">\n\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.fontHash : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <div class=\"showBottomTextSection\">\n        <input id=\"showBottomText\" type=\"checkbox\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showBottomText : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " title=\"Toggle Details\">\n        <label for=\"showBottomText\">Show Details</label>\n    </div>\n\n</form>\n\n\n";
	},"useData":true});

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var EditDialogButton = __webpack_require__(228);
	
	module.exports = EditDialogButton.extend({
	    iconCode: 0xe809,
	    color: '#3399FF',
	    title: 'Signature Dialog'
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var ShapeBtn = __webpack_require__(209);
	
	module.exports = ShapeBtn.extend({
	    clickAction: function(e) {
	        /*don't allow event to propagate -- now captured in shape view */
	        !this.isActive
	            ? this.el
	                .unmouseover()
	                .unmouseout()
	            : this.delegateHover();
	
	        this.isActive = !this.isActive;
	
	    }
	});
	


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/* todo: these should all be mixins */
	
	/* this provides an interface to save because only one shape per note */
	var ShapeBtn = __webpack_require__(209),
	    $ = __webpack_require__(59);
	
	module.exports = ShapeBtn.extend({
	    iconCode: 0xe904,
	    color: 'lightgreen', //todo: hex
	    title: 'Save',
	    clickAction: function(e) { //NOTE, SAME AS REDACTION
	        e.stopImmediatePropagation();
	        this.el.unmouseover().unmouseout(); /* remove event before destroy called, otherwise error on mouseout animate */
	        $('#notesCollection .ok:first').trigger('click'); //todo: just quick proto
	    }
	});

/***/ },
/* 230 */
/***/ function(module, exports) {

	module.exports = function( paper, x, y, text, font, fontSize, color ) {
	
	    return paper.print( x, y, text, paper.getFont( font )).attr({
	        color: color
	    });
	
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(232);
	
	var _ = __webpack_require__(49),
		fvChannel = __webpack_require__(72).channel('FV'),
		DrawablePageNoteView = __webpack_require__(179);
	
	/*
	* Note: for now not sub-classing the floating - non floating note views.
	* This would require a refactor of ViewConstructor on the note model to accept a function,
	* and it may prove easier anyway when converting between note types.
	*
	* */
	
	
	module.exports = DrawablePageNoteView.extend({
	
		templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {
	
			isRedactionNote: function() {
				return true;
			},
			reasonCodes: function() { 
				return this.note.getUniqueListOfSavedReasonCodesForNoteView(); // null if none returned ...;
			},
			showConversionToFloatingCodes: function() {
				// cold cache this on init ...
				var parentPgIsCold = this.viewerChannel.request('activeDocPages').findWhere({ pageId: this.note.get('pageId') }).isCold();
	
				return fvChannel.request('applyFloatingReasonCodes') &&
					this.note.get('noteType') === 'REDACTION_NOTE' &&
					// Here interested in note edit perm;  quick code reuse taking adv of this fn already being on note view;
					// Could be more efficient but plan to move note perm logic to server anyway ( eg .. can modify )
					this.includeEditBtn() &&
					!parentPgIsCold ;
			}
	
		}),
	
		ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {
			reasonCodesLabel:			'.note-sat-info-lbl',
			convertToFloatingCodesBtn:	'.btn-convert-to-floating',
			convertingIndicator:		'.redaction-convert-indicator'
		}),
	
		triggers: _.extend( {}, DrawablePageNoteView.prototype.triggers, {
			'click @ui.convertToFloatingCodesBtn': 'convertToFloatingCodes',
			'click @ui.editBtn': 'modifyClicked'
		}),
	
		_highlightDomForSATFilterToggle: function(satFilterTxt) {
	
			DrawablePageNoteView.prototype._highlightDomForSATFilterToggle.call(this, satFilterTxt);
	
			/*
			* Quick hack to ensure the reason codes label isn't highlighted in the UI.
			* see notes on base note object here
			* With faster browsers, now may be time to move to different method / plugin here for SAT filter
			* */
			this.ui.reasonCodesLabel.unhighlight();
	
		},
		/*
		* Show the converting indicator only in edit mode when converting.
		* Don't need to toggle back because view will be redrawn on save/edit.
		* ( And can't toggle edit/expanded in between active note toggle ).
		* */
		_postBaseToggleEditMode: function(isEntering) {
	
			DrawablePageNoteView.prototype._postBaseToggleEditMode.apply( this, arguments );
	
			if (isEntering && this.model.isConvertingToFloatingCodes)
				this.ui.convertingIndicator.removeClass('hide');
	
		},
		/*
		* Override base note view modify forward trigger.
		* If a floating redaction note and the system is not set for spider redactions,
		* show a warning dialog to proceed.
		* */
		onModifyClicked: function() {
	
			var args =  _.toArray(arguments),
				triggerBaseModifyEvent = function() {
					this.channel.trigger.apply( this.channel, ['noteView:enterEdit', this].concat( args ));
				};
	
			if ( !this.model.isFloatingRedactionAndSystemNotSetForFloatingCodes() ) {
				triggerBaseModifyEvent.call( this );
				return;
			}
	
			this.channel.request('vChannel').trigger( 'modal:open', {
				confirmType: 'warning',
				title: 'Confirm',
				content: 'This redaction contains data to display floating reason codes.  Modifying it will result in a loss of this data.  Do you wish to proceed?',
				okCB: _.bind( triggerBaseModifyEvent, this )
			});
	
		}
	
	});

/***/ },
/* 232 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var ShapeDialogView = __webpack_require__(212),
	    ShapeView = __webpack_require__(181),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    RedactionCodesView = __webpack_require__(234),
	    RedactionShapeButton = __webpack_require__(235),
	    RedactionPropertiesDialog = __webpack_require__(236);
	
	
	var POLY_DIALOG_FADE_OUT_DURATION = 200;
	
	
	module.exports = ShapeDialogView.extend({
	
	    DialogView: RedactionPropertiesDialog,
	
	    CodeLettersView: RedactionCodesView,
	
	    initialize: function(options) {
	
	        // First store reference of the 'selectedCodes'
	        // Perhaps just get from the shape -- for now realize it's a direct reference
	        this.selectedCodes = options.shapeModel.getReasonCodeCollection();
	
	        // init the properties dialog -- it will be rendered when the edit button is clicked
	        ShapeDialogView.prototype.initialize.call(this, _.extend(options, {
	            dialogConstructor: this.DialogView,
	            dialogOptions: {
	                shapeModel: options.shapeModel
	            },
	            dialogBtnConstructor: RedactionShapeButton
	        }));
	
	        //TODO: really only wanted for poly redaction shapes -- break poly and rect apart
	        this.listenTo(this.shapeUI, 'change:isParentNoteDrawing', this.prtNoteDrawingToggled);
	
	    },
	
	    // create and render the code letters view even if there aren't any selected codes
	    // so they are printed from existing shapes
	    onAfterRender: function() {
	
	        this.codeLettersView = new this.CodeLettersView({
	            parent: this,
	            shape: this.options.shapeModel,
	            selectedCodes: this.selectedCodes
	        }).render();
	
	    },
	    //TODO: on base shape trigger onMove / onAfterMove ...  poly should be diff shape type and overload ...
	    shapeSubs: _.extend( {}, ShapeDialogView.prototype.shapeSubs, {
	        'shape.poly.resizeStart':       'resizePolyStart',
	        'shape.resizePolyEnd':          'resizePolyEnd',
	        'shape.poly.resize':            'resizePoly',
	        'shapeWithDialog:beforeOpen':   'onDialogOpen',
	        'shapeWithDialog:beforeClose':  'onDialogClose'
	    }),
	
	    resizePolyStart: function() {
	        /*
	        * '#0F3CFF': the icon mosue over color.
	        * May want a derivative of the actual shape color now that not necessarily red
	        * */
	        this.el.animate( {stroke: '#0F3CFF'}, POLY_DIALOG_FADE_OUT_DURATION );
	
	        this.trigger( 'shape.toggleFadeDialog', 'Out', POLY_DIALOG_FADE_OUT_DURATION );
	
	        /*
	        * DVBC-1596 -- must trigger below event separately b/c it acts on the presense of the argument
	        * and 'Out' is invalid.  (It wants the bounding box of the shape or nothing).
	        * */
	        this.trigger('shape.redaction.poly.resize');
	
	    },
	    resizePoly: function() {
	        this.trigger('shape.redaction.poly.resize');
	    },
	    resizePolyEnd: function() {
	
	        this.el.animate( {
	            stroke: this.getColorToApply()
	        }, POLY_DIALOG_FADE_OUT_DURATION );
	
	        this.trigger('shape.toggleFadeDialog', 'In', POLY_DIALOG_FADE_OUT_DURATION);
	
	        /*
	        * Reposition the code letters, its not done during the actual resize like with rectangles,
	        * or update the connection for floating codes.
	        * */
	        this.trigger('shape.redaction.poly.resizeEnd');
	
	    },
	    prtNoteDrawingToggled: function(uiModel, noteIsDrawing) { //(really only wanted for poly redactions)
	        this[(noteIsDrawing ? '_disable' : '_enable') + 'Select']();
	        this.$el.attr('cursor', noteIsDrawing ? 'crosshair' : 'pointer');
	    },
	    toggleActive: function() {
	
	        ShapeDialogView.prototype.toggleActive.apply( this, arguments );
	        // Set the svg attributes for the code letters ( the shape is handled first in the base class ).
	        this.trigger('codeLetters.updateStyleAndPosition');
	
	    },
	    /*
	    * Hack!!! -- calling toggleExpanded the base ShapeView, not ShapeDialogView.
	    * This is because ShapeDialogView.toggleExpanded calls the overwritten function in the GraphicShapeView
	    * ( see signature.js )
	    *  Rather than fix that now and deal with any fallout, use this quick fix for now.
	    * */
	    toggleExpanded: function() {
	
	        ShapeView.prototype.toggleExpanded.apply( this, arguments );
	
	        // TODO -- perhaps a generic layer fn for compound shapes like this that is called whenever they are moved front/back
	        this.trigger('codeLetters.updateStyleAndPosition');
	
	    },
	
	    noteConsultGroupChange: function() {
	
	        ShapeView.prototype.noteConsultGroupChange.apply( this, arguments );
	        this.trigger('codeLetters.updateStyleAndPosition');
	
	    },
	
	    onDialogOpen: function() {
	
	        this.shapeModel.setSelectedCodeAndFillOnDialogOpen();
	
	    },
	
	    /*
	     * Only update the reason codes in local storage if they changed from open to close of the dialog
	     * ( don't have it automatically set on exit ).
	     * Prevents case of updating local storage when the user made no changes to the codes.
	     * This mimics functionality in the fat client, where the dialog is a 'save' dialog, and local storage
	     * is only updated if the user explicitly chooses to 'save changes'.
	     * */
	    onDialogClose: function() {
	
	        this.shapeModel.updateLocalStoragePostDialogClose( 0 );
	
	    },
	
	    onBeforeDestroy: function() {
	
	        // (former predicate for spider redactions, which may have not code view )
	        this.codeLettersView && this.codeLettersView.destroy();
	
	        ShapeDialogView.prototype.onBeforeDestroy.apply( this, arguments );
	
	    }
	
	
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Note: View is always created, even if no codes exist
	 * for now parent events passed to this (and other children)
	 * */
	
	var RaphaelView = __webpack_require__(187),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49);
	
	var instVars = {
	    shape: null,
	    selectedCodes: null,
	    parent: null
	};
	
	module.exports = RaphaelView.extend({
	
	    initialize: function(options) {
	
	        _.extend( this, _.pick( options, instVars, 'shape', 'selectedCodes', 'parent') );
	
	        this.listenTo( this.selectedCodes, 'add remove reset', this._printAndPosition );
	
	        this.bindEntityEvents(this.parent, this.parentSubs);
	
	    },
	
	    parentSubs: {
	        'shape.move shape.resizeRect shape.onAfterBaseScale shape.redaction.poly.resizeEnd': '_printAndPosition',
	        'codeLetters.updateStyleAndPosition': 'setSVGAttributesAndLayeredPosition', // when called from toggleActive, could be incorporated into render now
	        'redactionShape.layerCodesView': 'layer'
	    },
	
	    // mouse hover events: because now positioned atop parent shape when inactive,
	    // forward mouseover, mouseout calls to the parent shape
	    events: {
	        'mouseover': 'onMouseover',
	        'mouseout':  'onMouseout'
	    },
	    onMouseover: function(e) {
	        this.parent.onEnterMouseHover.call( this.parent, e );
	    },
	    onMouseout: function(e) {
	        this.parent.onExitMouseHover.call( this.parent, e );
	    },
	
	    render: function() {
	
	        var rEl = this.shape.uiModel.raphaelEl(); // TODO: fn to get paper off shape ui model ...
	        this.el = rEl.paper.text(0,0,'');
	
	        this.setSVGAttributesAndLayeredPosition();
	
	        // The canvas should now always be rendered in the DOM prior to printing any shapes,
	        // so we don't need to worry about waiting for the canvas to load before printing the codes.
	        (this.selectedCodes.length > 0) &&
	            this._printAndPosition();
	
	        // (necessary to wire events -- done in other views of this type)
	        this.setElement( this.el );
	
	        return this;
	
	    },
	
	    // DVBC-1393 - currently not most optimized or elegant positioning of the letters
	    // but working in regards to keeping the letters in inside the rectangles.
	    // This is intended to work with existing architecture (one Raphael text element) and
	    // using method of splitting codes onto new lines if the shapes' height > than its width.
	    // If this needs to be more elegant, do so when refactor with new drawing library.
	    // Note: not intended to fit the codes in polygons; (we don't care about polygons);
	    // This method is not as good for polygons as the old one
	    // DVBC-1411 - change for to Courier to match CRE ... all calculation except the font-aspect ratio
	    // are the same used for Arial which was more tested; appears to be working
	    _printAndPosition: function() {
	
	        var parentBox = this.shape.uiModel.getBBoxOfEl(),
	            height = parentBox.height,
	            width = parentBox.width,
	            isWider = width > height,
	            sCodes = this._getCodeTextToPrint(isWider);
	
	        this.el.attr({
	            'font-size': Math.floor( this._getFontSize( sCodes, height, width, isWider ) ),
	            text: sCodes
	        });
	
	        this._position(parentBox);
	
	    },
	
	    // If the box is wider (than taller), put each code on a new line
	    _getCodeTextToPrint: function( zoneIsWider ) {
	
	        return this.selectedCodes.getCodesAsString( zoneIsWider ? ' ' : '\n' );
	
	    },
	
	    _getFontSize: function( sCodes, height, width, isWider ) {
	
	        var COURIER_ASPECT_RATIO = 0.43, //(think of as units of height per column) -- MAYBE NOW DON'T NEED FOR MONOSPACE FONT
	            PCT_H_PADDING = 0.35; // Conservative so letter fits inside; seems to work fine; will be taken as a percentage of the width (worked with .25)
	
	        var aCodes = sCodes.split('\n'),
	            nLines = aCodes.length;// if wider, will be one line; otherwise the number of codes
	
	        // Determine a font size so that the longest line will fit inside the shape's width
	        var maxLineLength = Math.max.apply( null, _.map( aCodes, function(c) {
	                return c.length;
	            })),
	            desiredCharsPerLine = (width - (width * PCT_H_PADDING) ) / maxLineLength,
	            fontSize = desiredCharsPerLine / COURIER_ASPECT_RATIO;
	
	        // Now ensure text fits vertically after the above fit-width calculation
	
	        if ( nLines === 1 ) {
	
	            // Height adjustment: make sure the codes don't exceeds the height
	            if (fontSize > height)
	                fontSize = height - 1;
	
	            // DVBC-1416: adjustment for text with underscore characters
	            // these characters can go underneath the box
	            // obviously not exact or most dynamic fix, but again, all this is quick fix to work in existing framework
	            // problem only seems to occur with one line (so in here; see calcs below for when there are multiple lines)
	            // and when the shape is wider (the lines aren't split)
	            // must do after the height adjustment in case the height is larger than the font
	
	            if ( sCodes.indexOf('_') > -1 && isWider )
	                fontSize -= fontSize * 0.18;
	
	        } else {
	
	            // Vertically may not fit (esp. if there are many codes)
	            // Also: Raphael's generated dy for tspans can be greater than the font size
	            var RAPHAEL_LEADING = 1.2, // value in Raphael source (tuneText function) used in setting tspan's dy (font-size*this amount); unable to be monkey-patched
	                V_BUFFER = 20; // Give some wiggle room in case
	
	            if ( Math.floor( nLines * fontSize * RAPHAEL_LEADING ) + V_BUFFER > Math.ceil(height) ) {
	                // Take the minimum to ensure we don't go over the width of the rectangle
	                // Later 2 constants: some buffer just in case
	                fontSize = Math.min( fontSize - 1 , (height / nLines / RAPHAEL_LEADING) - 2 );
	            }
	        }
	
	        return fontSize;
	
	    },
	
	    /*  Center in parent el */
	    _position: function(parentBox) { // could pass cached box
	
	        var box = parentBox || this.shape.uiModel.getBBoxOfEl(),
	            x = box.x + (box.width/2),
	            y = box.y + (box.height/2);
	
	        this.el.transform( 'T' + x + ',' + y  );
	
	        return this.el;
	    },
	
	
	    setSVGAttributesAndLayeredPosition: function() {
	
	        this.setSVGAttributes();
	        this.layer();
	    },
	
	    setSVGAttributes: function() {
	        this.el.attr( this.shape.getReasonCodeSvgAttrs( this.parent.getColorToApply() ) );
	    },
	
	    // When 'apply all redactions' is in effect, the redaction shape has no opacity.
	    // So we need to move the letters in front of the shape for them to be visible.
	    // But when the shape is active, we want the letters behind the shape ...
	    // ( when active the shape has transparency and if the codes are in front, they will take over
	    // the mouse cursor and events ).
	    // Note: this is not attempting to solve the issue of which codes should appear above the other
	    // (when they don't have opacity).
	    layer: function() {
	
	        this.shape.uiModel.get('isActive')
	            ? this.el.insertBefore( this.shape.uiModel.raphaelEl() )
	            : this.el.insertAfter( this.shape.uiModel.raphaelEl() );
	
	    },
	
	    // DVBC-1762: don't destroy the selected codes.  For now, at least for full page
	    // redactions, we need to persist them on activeNote change (on the note model); and we may later
	    // want to start parsing shape models on parse of other note models as well.
	    onBeforeDestroy: function() {
	
	        this.undelegateEvents(); //(uses custom unbind all for Raphael view -- undelegate the events on here )
	        this.unbindEntityEvents(this, this.parentSubs);
	
	        this.stopListening();
	        this.off();
	        this.el.remove(); //memory leak somewhere ...
	    }
	
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var EditDialogButton = __webpack_require__(228);
	
	
	
	module.exports = EditDialogButton.extend({
	    topOffset: 20,     //temp offset from the other button -- static for now
	    iconCode: 0xe809,
	    color: '#3399FF',
	    title: 'Properties'
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(237);
	
	var Marionette = __webpack_require__(61),
	    FillView = __webpack_require__(238),
	    ReasonCodeSelectorView = __webpack_require__(241),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	// DVBC-1796: hide from UI but leave rest of functionality intact in case someone wants this back.
	var SHOW_COMMENTS = 0;
	
	
	var instVars = {
	    selectedCodes: null,
	    shapeModel: null,
	    availableReasonCodes: null, //cache the collection now that we have a search-as-you-type filter
	    renderDisabled: false
	};
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    className: 'redactionProps',
	
	    SHOW_FILL_VIEW: 1,
	
	    template: __webpack_require__(243),
	
	    regions: {
	        fillRegion:         '.redact-zone-dialog-fill-region',
	        reasonCodeRegion:   '.rd-reason-code-region'
	    },
	
	    initialize: function(options) {
	
	        _.extend( this, instVars, _.pick( options, 'shapeModel', 'renderDisabled' ) );
	
	        // Want a reference to the selectedCodes from the model from listening here
	        this.selectedCodes = this.shapeModel.getReasonCodeCollection();
	        this.availableReasonCodes = this.shapeModel.getAvailableCodesToSelectInZoneDialog();
	
	        this.listenTo( this.selectedCodes, 'add remove', this._codeSelectionCB );
	
	        /* just normalize Backbone's callback parameters from a reset to add/remove*/
	        this.listenTo( this.selectedCodes, 'reset',  _.bind( function( collection, options ) {
	            this._codeSelectionCB( null, collection, options );
	        }, this ));
	
	
	        /* Hack instead of 'subclassing' the find and redact classes for now -- override these fn's when provided  */
	        if ( options.onReasonCodeSubViewChange ) {
	            this.onReasonCodeSubViewChange = options.onReasonCodeSubViewChange;
	        }
	
	        if (options.selectAllReasonCodes) {
	            this.selectAllReasonCodes = options.selectAllReasonCodes;
	        }
	
	        if ( options.clearAllReasonCodes ) {
	            this.clearAllReasonCodes = options.clearAllReasonCodes;
	        }
	
	    },
	    serializeData: function() {
	
	        return {
	            comment: this.shapeModel.get('comments') ? this.shapeModel.get('comments') : '',
	            hideComments: !SHOW_COMMENTS
	        };
	
	    },
	
	    ui: {
	        commentsTextArea:   '.rd-comments',
	        numberSelected:     '.r-count',
	        selectAllRcButton:  '.rd-select-all-rc',
	        clearAllRcButton:   '.rd-clear-all-rc'
	    },
	
	    onRender: function() {
	
	        if ( this.SHOW_FILL_VIEW ) {
	          this.showFillView();
	        }
	
	        this.showReasonCodeView();
	
	        this._updateSelectAllStateAndNumberSelectedCodes();
	
	        if ( this.renderDisabled ) {
	            this.ui.commentsTextArea.attr( 'disabled', 'disabled' );
	            this.disableReasonCodesInteraction(); //  a bit superfluous since the subview can be rendered disabled
	        }
	
	    },
	
	    showFillView: function() {
	
	        this.fillRegion.show( new FillView({
	            renderDisabled: this.renderDisabled,
	            originalFill: this.shapeModel.get('fill'),
	            onChange: _.bind( function( fill ) {
	                this.shapeModel.set( { fill: fill });
	            }, this )
	        }));
	
	    },
	
	    showReasonCodeView: function() {
	
	        this.reasonCodeRegion.show( new ReasonCodeSelectorView({
	            renderDisabled: this.renderDisabled,
	            availableCodes: this.availableReasonCodes,
	            selectedCodes: this.selectedCodes,
	            onChange: _.bind( function( selectedReasonCodes ) {
	                this.onReasonCodeSubViewChange( selectedReasonCodes ) ;
	            }, this)
	        }));
	
	    },
	
	    /* This can be ovewritten by an option */
	    onReasonCodeSubViewChange: function( selectedReasonCodes ) {
	        this.selectedCodes.set( selectedReasonCodes );
	    },
	
	    events: {
	        'input @ui.commentsTextArea':       'commentChange',
	        'click @ui.selectAllRcButton':      'selectAllReasonCodes',
	        'click @ui.clearAllRcButton':       'clearAllReasonCodes'
	    },
	
	    selectAllReasonCodes: function() {
	        this.selectedCodes.reset( this._getReasonCodeModelsForSelectAll(), { sourceNotFromChosen: true } );
	    },
	
	    /**
	     * Ideally would like an alphanumeric sort to match the order seen in code letter views and code boxes.
	     * But sorting these as a ShapeReasonCode collection won't help, eg ( new ShapeReasonCodeCollection( this.availableReasonCodes.models ).models ),
	     * reset is called on the selected codes, which has the correct comparator.
	     * Issue is with Chosen.js.
	     * There is a plugin that is no longer supported by Chosen.js to try -- but it's not available on NPM --
	     * -- would need to store in source/create separate NPM repo from its git repository.
	     * We shouldn't change the order they are added by the user, but if the plugin supported, we could allievate somewhat here and on render.
	     */
	    _getReasonCodeModelsForSelectAll: function() {
	        return this.availableReasonCodes.models;
	
	    },
	
	    clearAllReasonCodes: function() {
	        this.selectedCodes.reset( null, { sourceNotFromChosen: true } );
	    },
	
	    _codeSelectionCB: function( codeModel, selectedCodes, options ) {
	
	        this._updateSelectAllStateAndNumberSelectedCodes();
	
	        if ( options && options.sourceNotFromChosen ) {
	            this.reasonCodeRegion.currentView.setUiValueFromSelectedCodes();
	        }
	
	    },
	
	    // Called onRender and SelectedCodeUpdate -- not a different subview now.
	    _updateSelectAllStateAndNumberSelectedCodes: function() {
	
	        var nSelectedCodes = this.selectedCodes.length;
	
	        this.ui.numberSelected.html('(' + nSelectedCodes + ')');
	
	        this._setDisabledSelectAllButtons( false );
	
	        if ( nSelectedCodes ===  this._getReasonCodeModelsForSelectAll().length ) {
	            this._disableSelectAllBtn( true );
	        }
	
	        if ( nSelectedCodes < 1 ) {
	            this._disableClearAllBtn( true );
	        }
	
	    },
	
	    commentChange: function(e) {
	        this.shapeModel.set({ comments: $(e.target).val() });
	    },
	
	    enableReasonCodesInteraction: function() {
	
	        this._setDisabledSelectAllButtons( false );
	        this.reasonCodeRegion.currentView.enable();
	
	    },
	
	    disableReasonCodesInteraction: function() {
	
	        this._setDisabledSelectAllButtons( true );
	        this.reasonCodeRegion.currentView.disable();
	    },
	
	    _setDisabledSelectAllButtons: function( disabled ) {
	
	        this._disableSelectAllBtn( disabled );
	        this._disableClearAllBtn( disabled );
	        this.ui.clearAllRcButton[0].disabled = disabled;
	
	    },
	
	    _disableSelectAllBtn: function( disable ) {
	        this.ui.selectAllRcButton[0].disabled = disable;
	    },
	
	    _disableClearAllBtn: function( disable ) {
	        this.ui.clearAllRcButton[0].disabled = disable;
	    }
	
	});

/***/ },
/* 237 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(239);
	
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    tagName: 'form', // ( make a form so can embed inside other forms and handle hitting return -- see click event )
	
	    className: 'redaction-fill-selector',
	
	    template: __webpack_require__(240),
	
	    initialize: function( options ) {
	
	        this.renderDisabled = options.renderDisabled;
	        this.originalFill = options.originalFill; // not sure if need direct ref
	        this.onChange = options.onChange;
	
	    },
	
	    onRender: function() {
	
	        this.ui.fillButtons.filter('[data-fill="' + this.originalFill + '"]').addClass('selected');
	
	        if ( this.renderDisabled ) {
	            this.ui.fillButtons.addClass('disabled');
	        }
	
	    },
	
	    ui: {
	
	        fillButtons:    '.redaction-props-fill-square'
	    },
	
	    events: {
	        'click @ui.fillButtons':    'fillClicked'
	    },
	
	    fillClicked: function(e) {
	
	        // prevent from submitting this form on enter ( outer form should still allow a return keypress )
	        e.preventDefault();
	
	        var $target = $(e.target);
	
	        if ( $target.hasClass('disabled') )
	            return;
	
	        this.ui.fillButtons.removeClass('selected');
	
	        $target.addClass('selected');
	
	        var selectedFill = $target.data('fill');
	
	        this.onChange( selectedFill );
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 239 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<button class=\"redaction-props-fill-square sq-white-w-border\" data-fill=\"WHITE_BLACK_BORDER\" title=\"White With Black Border\">\n</button>\n\n<button class=\"redaction-props-fill-square sq-black\" data-fill=\"BLACK\" title=\"Black\">\n</button>\n\n<button class=\"redaction-props-fill-square sq-white\" data-fill=\"WHITE\" title=\"White\">\n</button>\n";
	},"useData":true});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	__webpack_require__(163);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function(options) {
	
	        this.onChange = options.onChange;
	        this.selectedCodes = options.selectedCodes;
	        this.availableCodes = options.availableCodes;
	        this.renderDisabled = options.renderDisabled;
	
	    },
	
	    template: __webpack_require__(242),
	
	    onRender: function() {
	
	        this.unwrap(); // required for plugin markup -- see note in consultGroupSelector
	
	        if ( this.selectedCodes && this.selectedCodes.length > 0 ) {
	
	            this.setUiValueFromSelectedCodes();
	        }
	    },
	
	    /* Note: order of the provided codes will not be kept in tact -- would like to fork or use plugin if problematic */
	    setUiValueFromSelectedCodes: function() {
	
	        this.$el.val( this.selectedCodes.map( function( reasonCode ) {
	            return reasonCode.get('code');
	        }));
	
	        this.$el.trigger('chosen:updated'); // For when called externally
	
	    },
	
	    serializeData: function() {
	
	        return {
	            renderDisabled: this.renderDisabled || this.availableCodes.length < 1,
	            reasonCodes: this.availableCodes.toJSON()
	        };
	
	    },
	
	    // ( Chosen must be in DOM )
	    onShow: function() {
	
	        this.$el.chosen({
	            width: '100%',
	            placeholder_text_multiple: 'Select Reason Codes...'
	        }).on('change', _.bind( function() {
	
	            this.onChange( this.getSelectedReasonCodes() );
	
	        }, this) );
	    },
	
	    getSelectedReasonCodes: function() {
	
	        // Value on multi-selects doesn't return disabled options, so use this:
	        var aSelectedCodes = this.$('option:selected').map( function(i, el) {
	            return el.value;
	        }).get();
	
	        if ( aSelectedCodes.length < 1 )
	            return null;
	
	        return _.map( aSelectedCodes, function(code) {
	            return this.availableCodes.findWhere({code: code});
	        }, this);
	
	    },
	
	
	    enable: function() {
	
	        this.el.disabled = false;
	        this.$el.trigger('chosen:updated');
	
	    },
	
	    disable: function() {
	
	        this.el.disabled = true;
	        this.$el.trigger('chosen:updated');
	
	    },
	
	    disableOption: function( code ) {
	        this._setOptionDisabled( code, true );
	    },
	
	    enableOption: function( code ) {
	        this._setOptionDisabled( code, false );
	    },
	
	    /**  Fail silently if option doesn't exist **/
	    _setOptionDisabled: function( code, disable ) {
	
	        var $option = this._getOptionFromDOM( code );
	
	        if ( $option && $option.length > 0 ) {
	            $option[0].disabled = disable;
	        }
	
	        this.$el.trigger('chosen:updated');
	
	    },
	
	    _getOptionFromDOM: function( code ) {
	        return this.$('option[value=' + code + ']');
	    },
	
	
	    onBeforeDestroy: function() {
	
	        this.$el
	            .off()
	            .chosen('destroy');
	    }
	
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <option value=\""
	    + alias2(alias1((depth0 != null ? depth0.code : depth0), depth0))
	    + "\" "
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.description : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">"
	    + alias2(alias1((depth0 != null ? depth0.code : depth0), depth0))
	    + "</option>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "title=\""
	    + container.escapeExpression(container.lambda((depth0 != null ? depth0.description : depth0), depth0))
	    + "\"";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<select class=\"reason-code-select\" multiple "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.renderDisabled : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.reasonCodes : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</select>";
	},"useData":true});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "\n        <div class=\"redact-dialog-section redact-dialog-section-redact-by\">\n            <label class=\"rc-label redact-by-label\">Redact By:</label>\n            <div class=\"redact-zone-dialog-fill-region\"></div>\n        </div>\n\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "\n        <div class=\"fp-redaction-denied-checkboxes\">\n\n            <!-- wrap inputs in labels since could be > 1 id in DOM -->\n            <label>\n                <input class=\"cb-denied-in-full cb-full-or-non-responsive\"\n                       type=\"radio\" name=\"full-or-non-responsive\" value=\"DENIED_IN_FULL\" title=\"Denied in Full\">\n                Denied In Full\n            </label>\n\n\n            <label>\n                <input class=\"cb-non-responsive cb-full-or-non-responsive\"\n                       type=\"radio\" name=\"full-or-non-responsive\" value=\"NON_RESPONSIVE\" title=\""
	    + alias4(((helper = (helper = helpers.nonResponsiveReasonCode || (depth0 != null ? depth0.nonResponsiveReasonCode : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"nonResponsiveReasonCode","hash":{},"data":data}) : helper)))
	    + "\">\n                "
	    + alias4(((helper = (helper = helpers.nonResponsiveReasonCode || (depth0 != null ? depth0.nonResponsiveReasonCode : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"nonResponsiveReasonCode","hash":{},"data":data}) : helper)))
	    + "\n            </label>\n\n        </div>\n\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "rds-no-margin";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<!-- Since there can be multiple in DOM, must wrap radios in form -->\n<form class=\"redaction-props-form\">\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.isFullPageRedaction : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isFullPageRedaction : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <div class=\"redact-dialog-section "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideComments : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n\n        <div class=\"rd-reason-code-header\">\n\n            <div class=\"rc-label-count-wr\">\n                <label class=\"rc-label rc-above-item-label\">Reasons:</label>\n                <span class=\"r-count\"></span>\n            </div>\n\n            <div class=\"rd-select-all-wr\">\n\n                <button class=\"rd-select-all-rc btn btn-mini btn-link\">\n                    <i class=\"icon-check\"></i>Select All\n                </button>\n\n                <button class=\"rd-clear-all-rc btn btn-mini btn-link\">\n                    <i class=\"icon-check-empty\"></i>Clear\n                </button>\n\n            </div>\n\n        </div>\n\n        <div class=\"rd-reason-code-region\" data-region=\"true\"></div>\n\n    </div>\n\n\n    <div class=\"redact-dialog-section "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideComments : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n        <label class=\"rc-label rc-above-item-label\">Comments:</label>\n        <textarea class=\"rd-comments\">"
	    + container.escapeExpression(((helper = (helper = helpers.comment || (depth0 != null ? depth0.comment : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"comment","hash":{},"data":data}) : helper)))
	    + "</textarea>\n    </div>\n\n\n</form>\n\n";
	},"useData":true});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	var RedactionShapeView = __webpack_require__(233),
	    FloatingCodesController = __webpack_require__(245);
	
	__webpack_require__(251);
	
	
	// this.selectedCodes
	// (these can be null)
	    // this.connection
	    // reasonCodeUiModel -- this the same as that on the code letters; set from the 'controller'
	
	module.exports = RedactionShapeView.extend({
	    initialize: function(options) {
	
	        RedactionShapeView.prototype.initialize.apply(this, arguments);
	
	        this.listenTo( this.selectedCodes, 'add remove reset', this._updateReasonCodeViewAndConnection );
	
	        this.listenTo( this, 'shape.move shape.resizeRect shape.redaction.poly.resizeEnd shape.redaction.poly.resize', this.onAfterMoveOrResize );
	
	        if ( !this.pgNoteModel.floatingCodesController ) {
	            this.pgNoteModel['floatingCodesController'] = new FloatingCodesController( this.options.channel, this.pgNoteModel );
	        }
	
	        /*
	        * Whenever there is a connection, there should always be a reasonCodeUiModel.
	        * However, I've encountered a circumstance where this is not the case -- see comment in _setConnectionStrokeWidthAndDashArray.
	        * This should be cleanup up and fixed.
	        * */
	
	        this.connection = null;
	        this.reasonCodeUiModel = null;
	
	        // Flags to determine whether to draw a new box from existing points for notes that have been saved.
	        // Probably belong on the shape models ... TODO: yes put on the model
	        this.originalUniqueReasonCodeString = this.selectedCodes.getCodesAsString();
	
	        // Always set on _updateReasonCodeViewAndConnection, though set here redundantly for clarity.
	        this.nLastSelectedCodes = this.selectedCodes.length;
	
	    },
	    onAfterRender: function() {
	
	        this.pgNoteModel.floatingCodesController.addShapeView( this );
	        this._updateReasonCodeViewAndConnection();
	        this.connection && this.scaleConnection( this.options.scale ); // just put this in update/create ?
	
	    },
	
	    _updateReasonCodeViewAndConnection: function() {
	
	        this.pgNoteModel.floatingCodesController.update( this, this.selectedCodes.getCodesAsString() );
	        this.nLastSelectedCodes = this.selectedCodes.length;
	
	    },
	
	    createConnection: function(codeLettersView) {
	
	        var paper = this.shapeUI.getRaphaelElPaper();
	
	        this.connection =
	            paper.connection( this.el, codeLettersView.el, this.reasonCodeUiModel.getConnectionLineColor() );
	
	        this.connection.line.attr( this.reasonCodeUiModel.getConnectionLineAttrs() );
	
	        this._setConnectionStrokeWidthAndDashArray( this.channel.request('currentScaleValue') ); 
	
	    },
	    
	    onAfterMoveOrResize: function(elBox) {
	
	        /*
	        * Forward to the uiModel which is shared parents with the same codes
	        * -- there is no one parent to many child relationship anymore.
	        * Position the corresponding codes view if it's not set, then update this connection.
	        * ( No need to update other potential shape view connections b/c if the codeView moves with this;
	        *  ... once 2 shape views are attached, codesWerePositioned is set to true ).
	        * DVBC-1589: hack -- if event chain leading to this fn don't provide the bounding box,
	        * calc it here; really should go through and clean up the event chain ...
	        * */
	        var rcm = this.reasonCodeUiModel;
	
	        if ( rcm && !rcm.get('codesWerePositioned') ) {
	            rcm.trigger('updatePositionToMatchShapeView', elBox || this.el.getBBox() );
	        }
	
	        this.updateConnection();
	
	    },
	
	    updateConnection: function() {
	
	        if (!this.connection)
	            return;
	
	        var paper = this.shapeUI.getRaphaelElPaper(), // TODO: cache candidate (?)... but then ref issues
	            connection = this.connection;
	
	        paper.connection( connection );
	
	    },
	
	    scaleConnection: function(scale) {
	
	        if (!this.connection)
	            return;
	
	        this.updateConnection();  
	        
	        this._setConnectionStrokeWidthAndDashArray(scale);
	     
	    },
	
	    /*
	    * 2 hacks for scaling not working with stroke-width and dash array on transformed elements.
	    * Can probably eliminate if/when implement a viewbox.
	    * Stroke-width: Raphael transform doesn't touch it -- see code.
	    * Stroke-width hack also done in codeBox view (there, done in overall 'transform')
	    * Dash-Array: bypass Raphael.attr -- its formula takes stroke-width and some other factors into account.
	    * Maybe want to extend Raphael / use attribute for these if end up using in > 1 place ...
	    * Potential for optimization here ... especially when called on scale when scale is 'Fit Width'
	    * */
	    _setConnectionStrokeWidthAndDashArray: function(scale) {
	
	        /*
	        * Exit immediately if there is no reasonCodeUiModel --
	        * this is a quick HACK for a bug encountered where the view can have a connection but not a reasonCodeUiModel --
	        * this should never be the case but I don't want to break anything and discovering the fix is quick complicated ...
	        * I'd need to go through the entire rendering logic for the note type.
	        * ! THIS REALLY SHOULD BE FIXED AT SOME POINT !
	        * To reproduce:
	        *   - create 2 shapes each with 2 reasonCodes pointing to the same codeView
	        *   - remove a reason code from one so it's no longer connected to the same codeView
	        *   - then add back the same reason code so it's connected again
	        *   - then change the scale
	        *   - now this.connection will exist but this.reasonCodeUiModel will be null
	        * */
	
	        if ( !this.reasonCodeUiModel )
	            return;
	
	        var connectionWidth = this.reasonCodeUiModel.getConnectionLineWidth(),
	            connectionLine = this.connection.line;
	
	        connectionLine.attr( 'stroke-width', +(connectionWidth * scale).toFixed(3) );
	
	        // Only apply the dash-array value if it isn't null (the line is not dotted),
	        // for a bit of a performance boast in that case.
	        var dashArray = this.reasonCodeUiModel.getConnectionDashArraySVGValue(scale);
	        if (dashArray) 
	            connectionLine.node.setAttribute( 'stroke-dasharray',  dashArray);
	        
	    },
	
	    onAfterButtonSetCreation: function() {
	        RedactionShapeView.prototype.onAfterButtonSetCreation.apply(this, arguments);
	
	        // Should be mediated but get going with this for now
	        // Only want to call for the code views of this note
	        // use paper.top -- it will be the topmost element in the selectSet
	        this.pgNoteModel.floatingCodesController.moveCodeViewsToFrontOfCanvas( this.shapeUI.getRaphaelElPaper() );
	    },
	
	    destroyConnection: function() {
	        //  will prob need to write a wrapper around connection eventually ...
	        if ( !this.connection )
	            return;
	
	        this.connection.line.remove();
	        this.connection = null;
	    },
	
	    // Ensure Code Boxes Remain In Front on the Shapes
	    bringToFront: function() {
	        RedactionShapeView.prototype.bringToFront.apply( this, arguments );
	        this.channel.trigger('imgCanvas.moveAllCodeBoxesToFront', this.paper);
	    },
	
	    /*
	    * Don't just clean up this view, but utilize the destroy call from
	    * other areas in canvas workflow to destroy the floatingCodesController, if it exists.
	    * */
	    onBeforeDestroy: function(manualUserDelete) {
	
	        RedactionShapeView.prototype.onBeforeDestroy.apply( this, arguments );
	        this.stopListening();
	
	        // Always remove this view from the controller -- would really
	        // only want to remove manualUserDelete (delete btn / hotkey) , but if it's not,
	        // the shapeView will still exist floatingCodesController.destroy and recursion will occur.
	        this.pgNoteModel.floatingCodesController.removeShapeView(this);
	
	        if (!manualUserDelete && this.pgNoteModel.floatingCodesController) {
	
	            this.pgNoteModel.floatingCodesController.destroy();
	            delete this.pgNoteModel.floatingCodesController;
	        }
	
	    }
	
	});


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    FloatingCodesView = __webpack_require__(246),
	    FloatingCodesUiModel = __webpack_require__(248);
	
	__webpack_require__(60);
	__webpack_require__(63);
	
	// Note: this is really at the page note level so if > 1 note there could be multiple
	// ( Events can appear to have been called multiple times -- one for each instance )
	// Maybe call the PageNoteFloatingCodeController???
	
	var FloatingCodeController = function( canvasChannel, noteModel ) {
	
	    _.extend(this, Backbone.Events);
	
	    this.canvasChannel = canvasChannel;
	
	    this.shapeViews = new Backbone.ChildViewContainer();
	    this.codeViews = new Backbone.ChildViewContainer();
	
	    /**
	     * ID:
	     * - For now don't need a reference to the model, so just store it's id; maybe need to change in the future.
	     * - Use cid: for new notes id is now undefined and channels created from them will not be unique to the note model!
	     * - (encountered issue on drag of code boxes when editing a find and redact (new) and non find and redact note at the same time )
	     */
	    this.id = noteModel.cid;
	    this.channel = new Backbone.Radio.channel( 'FloatingCodeChannel:' + this.id );
	
	    this.listenTo( this.channel, 'reasonCodeView.drag', this.onReasonCodeViewDrag );
	
	    this.listenTo( this.canvasChannel, 'scaleFloatingReasonCodeViews', this.updateScale );
	    this.listenTo( this.canvasChannel, 'imgCanvas.moveAllCodeBoxesToFront', this.moveCodeViewsToFrontOfCanvas );
	
	     // called from routine in canvas.js activeNote change ... only want called at the note level instance
	    this.listenTo( this, 'floatingCodesView.toggleActive', this.toggleActiveCodeViews );
	
	};
	
	
	
	_.extend( FloatingCodeController.prototype, {
	
	    addShapeView: function(view) {
	        this.shapeViews.add(view);
	    },
	
	    removeShapeView: function(view) {
	
	        this.shapeViews.remove(view); //(already destroyed in onBeforeDestroy on shapeView)
	        view.destroyConnection();
	
	        // ah: if was attached to others with a model and this wasn't, maybe those shape ids aren't removed ...
	        // ensure id removed from all code view model references ....
	        this.codeViews.each( function(cv) {
	            cv.model.removeShapeViewId(view.cid);
	        });
	
	        this._pruneCodeViews();
	
	    },
	
	    update: function(shapeView, uniqueCodeStr) {
	
	        // Always destroy then create a connection for the shapeView
	        shapeView.destroyConnection();
	
	        /*
	        * Determine if a codeView already exists for the given uniqueCodeStr.
	        * ( Note: Babysitter findByCustom will not work when swapping models (when need to add, then remove ... )
	        *  and also can't use find by model in this case b/c the model may not exist
	        * */
	        var existingCodeView =  this.codeViews.find( function(v) {
	            return v.model.get('uniqueCodeString') === uniqueCodeStr;
	        });
	
	        var shapeIsNewlyDrawn = shapeView.shapeUI.get('isNewlyDrawn');
	
	        /*
	        *  If the codeView already exists, point the shapeView point to it.
	        *  (wouldn't happen for empty uniqueCodeStr).
	        * */
	        if ( existingCodeView ) {
	
	            var existingUIModel = existingCodeView.model;
	
	            existingUIModel.addShapeViewId(shapeView.cid);
	            shapeView.reasonCodeUiModel = existingUIModel;
	            shapeView.createConnection( existingCodeView );
	
	            // Only update layering if newlyDrawn; if drawn from model -- set after all shapes have been drawn
	            shapeIsNewlyDrawn &&
	                existingCodeView.triggerMethod('updateShapeLayering', shapeView.el );
	        }
	
	        /*
	        * If the shapeView only has 1 connection, update its codeView to that of uniqueCodeStr (if uniqueCodeStr isn't blank).
	        * ( If other shapes also have the combo, this is covered above ).
	        * ( Implies there is not already a view for the code combo ) .
	        * */
	        else if ( uniqueCodeStr.length > 0 && shapeView.reasonCodeUiModel && shapeView.reasonCodeUiModel.get('shapeViewIds').length === 1 ) {
	
	            var codeViewOfShapeView = this.codeViews.findByCid( shapeView.reasonCodeUiModel.get('codeViewId') ),
	                existingUIModel = codeViewOfShapeView.model;
	
	            existingUIModel.set({
	                uniqueCodeString: uniqueCodeStr
	            });
	
	            existingUIModel.addShapeViewId(shapeView.cid);
	            shapeView.reasonCodeUiModel = codeViewOfShapeView.model;
	
	            // Instead of update could destroy and re-render
	            codeViewOfShapeView.triggerMethod('updateText', shapeView.selectedCodes.getCodesAsString('\n'), shapeView.el.getBBox() );
	            shapeView.createConnection(codeViewOfShapeView);
	
	        }
	        /*
	        * Else: codeView doesn't exist && shapeView is not connected to just one codeView.
	        * ( and uniqueCodeStr isn't blank ).
	        * Create a new codeView with uniqueCodeStr.
	        * (Prior if rules out it being connected to multiple ).
	        * The ONLY a place new uiModel/codeView is created.
	        * */
	        else if ( uniqueCodeStr.length > 0 ) {
	
	            var sm = shapeView.shapeModel,
	                renderBoxFromShapeModelPts = this._renderNewBoxFromPts( sm, shapeView, shapeIsNewlyDrawn, uniqueCodeStr );
	
	            var newCodeUIModelOptions = {
	                renderBoxFromShapeModelPts: renderBoxFromShapeModelPts // needed on here .. it's really for the shape and can be interpreted (?)
	            };
	
	            if (renderBoxFromShapeModelPts) {
	
	                var boxModel = sm.getBox();
	
	                // Adjust the points on this version of the boxModel -- used for rendering  -- should update the reference on the shapeModel as well.
	                // ... maybe want to clone instead ?
	                boxModel.set( 'points', sm.getAdjustedBoxPts() );
	
	                _.extend( newCodeUIModelOptions, {
	                    boxModel: boxModel,
	                    connectionModel: sm.getConnection()
	                });
	            }
	
	            var newCodeUiModel = new FloatingCodesUiModel({
	                uniqueCodeString: uniqueCodeStr,
	                pgDPI: sm.pageModel.getDPI(), // could also store on here and cache on creation ... (all on same page)
	                parentNoteIsActive: sm.uiModel.get('isActive')
	            }, newCodeUIModelOptions);
	
	
	            var newCodeView = this._createCodeLettersView( shapeView.el.paper , newCodeUiModel, sm.pageModel )
	                .render(
	                    shapeView.selectedCodes.getCodesAsString('\n'), // get the from the ui model ?
	                    shapeView.el.getBBox(0)
	                );
	
	            /*
	            * Only update layering if newlyDrawn; if drawn from model -- set after all shapes have been drawn.
	            * Newly drawn shapes will be put in front by default, show use shapeView.el instead of paper.top.
	            * */
	            shapeIsNewlyDrawn && newCodeView.triggerMethod('updateShapeLayering', shapeView.el );
	
	            shapeView.reasonCodeUiModel = newCodeUiModel; // (set first before the connection -- attrs are necessary for drawing it)
	            shapeView.createConnection(newCodeView);
	
	            newCodeUiModel.addShapeViewId( shapeView.cid );
	            newCodeUiModel.set('codeViewId', newCodeView.cid);
	
	            this.codeViews.add( newCodeView, uniqueCodeStr );
	
	            // TODO: if code view will be placed in default position -- don't allow to it cover another code box
	
	        }
	
	        this._pruneCodeViews();
	    },
	
	    /**
	     * Determines whether to draw a new code box from points or
	     * allow it to be generated on the fly when rendered ( where size is derived )
	     * Would set the box codeUi model's codesWerePositioned to true
	     */
	    _renderNewBoxFromPts: function( sm, shapeView, shapeIsNewlyDrawn, uniqueCodeStr ) {
	
	        // First handle new logic for find and redact
	        // Of now: the original shape models will not have a box set until the have been 'applied' or canvas re-rendered
	        // ( we don't care about for the other 2 cases in the update routine, since no new model/view is created )
	        // TODO: combo with below logic I think -- originalUniqueReasonCodeString !== uniqueCodeStr
	
	        if ( sm.isFindAndRedactShape ) {
	
	            /**
	             * Handle Case where codes from F&R interface on page different than the current canvas.
	             * Box is dirty now implies:
	             * 1) set from different while not on the same page
	             * 2) came from different mode
	             */
	            if ( sm.getBoxIsDirty() ) {
	
	                // For now set back immediately
	                // TODO: do this after all shapes are rendered? perhaps clearer in WF debug
	                sm.setBoxIsDirty( false );
	                return false;
	            }
	
	            var hasBox = sm.getBox(); // points were set, these don't get saved
	
	            if ( hasBox ) {
	
	                // Maybe I can get this from the model so if change when not rendered we are good
	                // Other predicates from below:
	                // Codes were changed by user ( from below ) and canvas later 're-rendered' (like after a page change) -- equivalent of being saving from DB (below)
	                // Required, otherwise if box points will be off if codes changes after a re-render !
	                // Eg: search that results in > 1 hit; change page, go back to page, change codes of a zone, you'll be off
	                // TODO: now could be handle with 'boxIsDirty' above
	
	                if ( shapeView.originalUniqueReasonCodeString !== uniqueCodeStr )
	                    return false;
	
	                if ( shapeView.nLastSelectedCodes === 0 )
	                    return false;
	
	                return true;
	
	            }
	
	            return false;
	        }
	
	        if ( sm.isConvertingToFloatingCodes || shapeIsNewlyDrawn )
	            return false;
	
	        // Condition necessary for shapes read in from the db (!shapeIsNewlyDrawn) and whose codes were changed by the user.
	        // Without, the prior points saved on the model will be set, and then the code view will not be positioned.
	        // ( new views need to be placed at default position, and won't be if the points are set )
	        // ( we don't care about for the other 2 cases in the update routine, since no new model/view is created )
	        if ( shapeView.originalUniqueReasonCodeString !== uniqueCodeStr )
	            return false;
	
	        // Above case doesn't handle situation where a shape is saved with one reasonCode,
	        // and during an edit all reason codes are removed, and then then original reason code is put back.
	        // In this case, we want a new box placed at 'default position', not set from existing points, which would result in error (placement at 0,0).
	        // ( Above condition still necessary for when shape is attached to box with > 1 reason code ).
	        // Note: there's probably a clearer way to organize all of this ....
	        if ( shapeView.nLastSelectedCodes === 0 )
	            return false;
	
	        return true;
	
	    },
	
	    /*
	    *  Prune any code views that aren't attached to any shapes.
	    *  Get the actual uniqueCodeStrs assigned to each shape,
	    *  then loop through each code view.
	    *  If the uniqueCodeStr of the view isn't one that exists, remove the view.
	    * */
	    _pruneCodeViews: function() {
	
	        var uniqueCodeStrings = this._getExistingUniqueCodeStrings();
	
	        this.codeViews.each( function(cv) {
	
	            var uid = cv.model.get('uniqueCodeString');
	
	            if ( !_.contains(uniqueCodeStrings, uid) ) {
	
	                // remove it
	                // TODO: this should be a fn -- remove the view and connection to its shape views
	
	                cv.destroy();
	                this.codeViews.remove(cv);
	
	                /*
	                * I forget why this is here but it's necessary.
	                * There may be an issue here causing the shapeViews reasonCodeUiModel to get out of sync with it's connection
	                * -- see comment in shapeView._setConnectionStrokeWidthAndDashArray.
	                * */
	                var attachedShapeViewIds = cv.model.get('shapeViewIds');
	                _.each( attachedShapeViewIds, function(cid) {
	
	                    var sv = this.shapeViews.findByCid(cid);
	                    sv.reasonCodeUiModel = null;  // so now this acts like a flag for is connected
	
	                }, this);
	            }
	
	        }, this);
	    },
	
	    _getExistingUniqueCodeStrings: function() {
	        var uniqueCodeStrings = this.shapeViews.map(function(s) {
	            return s.selectedCodes.getCodesAsString();
	        });
	        uniqueCodeStrings = _.uniq( uniqueCodeStrings );
	        uniqueCodeStrings = _.without( uniqueCodeStrings, '');
	        return uniqueCodeStrings;
	    },
	
	    _createCodeLettersView: function(paper, reasonCodeViewModel, pageModel) {
	
	        return new FloatingCodesView({
	
	            noteCodesChannel: this.channel,
	            canvasChannel: this.canvasChannel,
	            model: reasonCodeViewModel,
	            paper: paper,
	            pageModel: pageModel,
	            originalScale: this.canvasChannel.request('currentScaleValue')
	
	        });
	
	    },
	
	    // TODO: could also cache those on drag start, etc
	    // may want to throttle this especially if many are attached ... but this looks choppy
	    onReasonCodeViewDrag: function(uiModel) {
	
	         var attachedViewIds = uiModel.get('shapeViewIds');
	         for (var i=0; i<attachedViewIds.length; i++) {
	             this.shapeViews.findByCid( attachedViewIds[i]).updateConnection();
	         }
	
	    },
	
	    // currently unused
	    getShapeViewsOfUniqueCodeString: function(uid) {
	
	        return this.shapeViews.filter( function(v) {
	            return v.reasonCodeUiModel.get('uniqueCodeString') === uid;
	        });
	
	    },
	    // currently unused
	    getCodeViewsOfUniqueCodeString: function(uid) {
	        return this.codeViews.filter( function(v) {
	            return v.model.get('uniqueCodeString') === uid;
	        });
	    },
	
	    getCodeViewOfUniqueCodeString: function(uid) {
	        return this.codeViews.find( function(v) {
	            return v.model.get('uniqueCodeString') === uid;
	        });
	    },
	
	    getShapeViewByShapeModel: function(sm) {
	        return this.shapeViews.find( function(v) {
	            return v.shapeModel.cid === sm.cid;
	        });
	    },
	
	    // only want called once for each code view, so not triggering from the codeViews themselves, when they update scale
	    // (they update first in the scale change workflow)
	    updateScale: function(scale, lastScale) {
	
	        // first update the scale of all codeViews
	        this.codeViews.each( function(cv) {
	            cv.updateScale(scale, lastScale); // prob as event ....  //var args = Array.prototype.slice.call(this);
	        });
	
	        // now update the connections to all the shape views (if they are connected)
	        this.shapeViews.each( function(sv) {
	           sv.connection && sv.scaleConnection(scale); // TODO: should have a is connected fn ...
	        });
	
	    },
	
	    // Note: NOT forwarded from each shape view.  They are called first and then this is called after all completed.
	    // Only called once after all shape views have been 'toggled'.
	    // TODO: maybe store the paper instance on here and use throughout ... no need to keep passing / deriving (except mem ref issues)
	
	    // Layer and enable drag
	    toggleActiveCodeViews: function(isActive, paper) {
	
	        this.codeViews.each( function(cv) {
	
	            //  capture the event here & forward to all code views utilizing the shared ui model
	            //  due to nature of attribute only changing once, will only trigger a change to code view the first time this is set
	            // (now that not passed from shapeView -- this is a separate event -- no longer as big an issue; will be called once anyway)
	
	            // Paper.top will be the highest of all zones in the note; this is necessary so code views are put above zones they aren't attached to
	            // this is somewhat sloppy (should really be storing the position in a data model somewhere -- and
	            // ultimately may need to), but it should work BECAUSE toggleActive on the shape set's each shape 'toFront'
	
	            cv.model.set('parentNoteIsActive', isActive, {
	                shapeViewEl: paper.top
	            });
	
	        }, this);
	
	    },
	
	    // Position the codes views from their models' box points.
	    // Then update the connections of the shape views.
	    // TODO: is this still used ???
	    positionCodeViewsFromModelPts: function() {
	
	        // should apply to all (if canvas not yet rendered, they can't be new yet)
	        this.codeViews.each( function(cv) {
	            cv.positionFromCoordinates();
	        }, this);
	
	        // would apply to all, forget getting those attached, though that's more performant
	        this.shapeViews.each( function(sv) {
	            sv.updateConnection();
	        });
	
	    },
	
	    // Really only called for notes converting from normal to floating.
	    positionCodeViewsAtDefaultPosition: function() {
	
	        this.codeViews.each( function(cv) {
	
	            // not sure what to align with ... now using the first ... (could be multi attached)
	            // may want to use the topmost???
	            var shapeViewIdToAlignWith = cv.model.get('shapeViewIds')[0];
	            var shapeViewToAlignWith = this.shapeViews.findByCid( shapeViewIdToAlignWith );
	
	            // *** For some reason when rendered entering from different page, the size of the text isn't correct.
	            // Below is a hack to reset the text attribute now that it's in the DOM so its size is correct prior to calling position
	            // uses the size of the text box in it's calculations
	            cv.textEl.attr('text', cv.textEl.attr('text') ); // TODO:  fn ..
	
	            cv.placeAtDefaultPosition( shapeViewToAlignWith.el.getBBox(0) );
	
	        }, this);
	
	
	        this.shapeViews.each( function(sv) {
	            sv.updateConnection();
	        });
	
	    },
	    // called after all shapes have been rendered (from model) on the canvas
	    moveCodeViewsToFrontOfCanvas: function( paper ) {
	
	        this.codeViews.each( function(cv) {
	            cv.triggerMethod( 'updateShapeLayering', paper.top );
	        });
	
	        // TODO: may also want to move the line connections the front
	    },
	
	    destroy: function() {
	
	        this.channel.reset();
	
	        this.stopListening();
	
	        this.codeViews.each( function(cv) {
	            cv.destroy();
	            this.codeViews.remove(cv);
	        }, this);
	
	
	        this.shapeViews.each( function(sv) {
	           sv.destroy();
	           this.shapeViews.remove(sv);
	        }, this);
	
	    }
	
	});
	
	
	module.exports = FloatingCodeController;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var RaphaelView = __webpack_require__(187),
	    _  = __webpack_require__(49),
	    Raphael = __webpack_require__(182),
	    ShapeUtils = __webpack_require__(197),
	    BaseMoveFunctions = __webpack_require__(190),
	    DragHelper = __webpack_require__(191),
	    ShapePageTransformModel = __webpack_require__(247);
	
	
	/*
	* El now really like the wrapper ... there are inner view that affect this display ...
	* ... explain ...
	* */
	
	var instVars = {
	
	    noteCodesChannel: null,
	    canvasChannel: null,
	    model: null, // shared with the parent shape (and others that could share it)
	    paper: null, // reference to the Raphael paper instance
	    pageModel: null,
	    shapePageTransformModel: null,
	
	    // sub-views
	    borderEl: null,
	    innerEl: null, // view underneath el; el is the full size but only the border is visible
	    textEl: null // maybe want this to be a subview ... though could be overkill,
	
	};
	
	
	var CodesView = RaphaelView.extend({
	
	    initialize: function( options ) {
	
	        _.extend( this, instVars, options );
	
	        /* We only use the 'page level' transform for this shape  */
	        this.shapePageTransformModel = new ShapePageTransformModel( ).initializeValues( this.pageModel, this.options.originalScale );
	
	        // Take DPI of the underlying image into account.  1/4 inch from the page in physical dimensions.
	        // TODO: put this on the codeUI model ...
	        this.GUTTER = (0.25 * 96) * ( this.model.getPgDpi() / 96 );
	
	        this.listenTo( this.model , 'updatePositionToMatchShapeView', this.placeAtDefaultPosition );
	        this.listenTo( this.model , 'change:parentNoteIsActive', this._toggleActive );   // note: will ONLY  be call once per shape
	
	        return this;
	
	    },
	
	    /*
	    * Render empty, un-sized, rectangle path (el), borderEl, innerEl, and empty text el.
	    * Also print and position on render since canvas loaded in no longer async --
	    * Canvas shapes are NOW always rendered when the canvas in in the DOM.
	    * */
	    render: function( lineDelimitedCodes, shapeViewBox ) {
	
	        this.el = this.paper.path().attr({
	            stroke: 'none',
	            fill: 'none'
	        });
	
	        /*
	        * These inner ones are now rects -- could work with paths but this is just as easy as something funky was going on
	        * innerEl outline in css -- it was much larger than the shape when it was a path; not so when a rect.
	        * */
	        this.borderEl = this.paper.rect()
	            .attr(  this.model.getBorderElAttrs() );
	
	        this.innerEl = this.paper.rect()
	            .attr( this.model.getInnerElAttributes() );
	
	
	        /* --- Text El --*/
	        this.textEl = this.paper.text( 0, 0, '' );
	
	        // Must set the line height prior to the attrs here -- this is for the lib fork.
	        this.textEl.data('lineHeight', this.model.getTextLineHeight() );
	
	        this.textEl.attr(  _.extend( {}, this.model.getTextElAttrs(), {
	            text: lineDelimitedCodes
	        }));
	
	        // start with the transform applied
	        this._updateTransformAndTransformView();
	
	        if ( this.model.get('codesWerePositioned') ) {
	            this.positionFromCoordinates();
	        } else {
	            this.placeAtDefaultPosition(shapeViewBox);
	        }
	
	        this._toggleActive( this.model, this.model.get('parentNoteIsActive') ) ;
	
	        return this;
	
	    },
	
	    onUpdateShapeLayering: function( shapeEl ) {
	        this.el.insertAfter( shapeEl );
	        this.borderEl.insertAfter( this.el );
	        this.innerEl.insertAfter( this.borderEl );
	        this.textEl.insertAfter( this.innerEl );
	    },
	
	    /**
	     * Note:
	     * - must exist in DOM b/c of Raphael text bug ... hence events thrown to call this;
	     *  - Update: this may not longer be an issue since the canvas in rendered synchrounously and the canvas should now be positioned in the DOM
	     * - This expects the coordinates to be 'untransformed'.
	     * - Coordinates here don't need to take conversion constant into account
	     */
	    positionFromCoordinates: function(coordinates) {
	
	        var coords = coordinates || this.model.getBoxCoordinates(),
	            topLeft = coords[0],
	            topRight = coords[1],
	            bottomLeft = coords[2],
	            height = bottomLeft.y - topLeft.y,
	            width = topRight.x - topLeft.x,
	            sw = this.model.getStrokeWidth();
	
	
	        // first position el
	        this.el.setPathFromPtsArray( coords, 1 );
	
	        // now position the subviews ... TODO: comment an explanation of why necessary
	        this.borderEl.attr({
	            x: topLeft.x + (sw / 2),
	            y: topLeft.y + (sw / 2),
	            width: width - sw,
	            height: height - sw
	        });
	
	        this.innerEl.attr({
	            x: topLeft.x + sw,
	            y: topLeft.y + sw,
	            width: width - (sw * 2),
	            height: height - (sw * 2)
	        });
	        // now position the text relative to it (vertically align in center)
	
	
	        // x position:
	        //  push over once for the 'padding'
	        //  push over only once for stroke-width (the stroke width is 'centered' -- only push over from the 'inner', not 'outer' portion')
	
	        this.textEl.attr({
	            x: topLeft.x + ( this.model.getPadding() + sw ),
	            y: topLeft.y + ( height / 2 ) // centering vertically should account for any padding and border
	        });
	
	        // update & then apply the pageTransform
	        this._updateTransformAndTransformView();
	
	    },
	
	    /**
	     * Update the text in the box, resize the box while keeping it's top-left position
	     * Tested: working on all rotations
	     * Maybe better to remove and recreate the view, then don't need this here and this is easy.
	     */
	    onUpdateText: function( lineDelimitedCodes, shapeViewBox ) {
	
	        // change the text so we can get it's size
	        this.textEl.attr({
	            text: lineDelimitedCodes
	        });
	
	        // if doesn't have position, use the existing logic to position at the default
	        if ( !this.model.get('codesWerePositioned') ) {
	            this.placeAtDefaultPosition(shapeViewBox);
	            return;
	        }
	
	        // now calc the would be new coordinates to render correctly around the new text
	        var oCodebox = this.el.getBBox(1); // use the untransformed -- then shouldn't need to convert
	
	        // see notes in generating the default position
	        var borderAndPadding = ( this.model.getPadding() + this.model.getStrokeWidth() ) * 2;
	
	        var textBox = this.textEl.getBBox(1),
	            shapeWidth = textBox.width + borderAndPadding,
	            shapeHeight = textBox.height + borderAndPadding;
	
	        var topLeft = {
	            x: oCodebox.x,
	            y: oCodebox.y
	        };
	
	        var newCoordinates = [
	            {
	                x: topLeft.x,
	                y: topLeft.y
	            },
	            {
	                x: topLeft.x + shapeWidth,
	                y: topLeft.y
	            },
	            {
	                x: topLeft.x + shapeWidth ,
	                y: topLeft.y + shapeHeight
	            },
	            {
	                x: topLeft.x,
	                y: topLeft.y + shapeHeight
	            }
	        ];
	
	        this.positionFromCoordinates( newCoordinates );
	
	    },
	
	    updateScale: function(scale) {
	        this.shapePageTransformModel.setScale( scale );
	        this._updateTransformAndTransformView();
	    },
	
	
	    /*
	    * Position relative to parent shape on move / resize / initial render.
	    * Assumes textEl is created.
	    * Note: the parent shapes don't have transforms -- getBBox(1) wouldn't change things ... if they did the calc's here could be much simpler !!!
	    * Note: canvasContainerRel shouldn't be an issue on initial render of existing shapes on canvas,
	    * even though, this doesn't exist ( b/c these will have 'position' set ) and this wont be called.
	    * *** However -- it will be for conversion ***
	    * -------
	    * Goal is to get what would be the untransformed coordinates to draw the box from coordinates.
	    * The coordinates include border and stroke-width so these are taken into account when deriving for the size for the shape.
	    * Note that they must be scaled to reflect the current page transform.
	    * Handling positioning of the text inside the box will be done in the placement routine (so we don't
	    * need to worry about offsetting for the position of the stroke width here (and the coordinates are all inclusive anyway);
	    * Note: confirmed that stroke-width is not taken into account in Raphael.getBBox and DOM getBoundlingClientRect.
	    * Will also give the first size to the box from the generated text if it hasn't been set yet  --
	    * TODO: potential area for perf improvement if text box size is already know (esp for IE)
	    * */
	    placeAtDefaultPosition: function(shapeViewBox) {
	
	        var shapePageTransformModel = this.shapePageTransformModel,
	            scale = shapePageTransformModel.getScale(),
	            rotation = shapePageTransformModel.getRotation(),
	            strokeWidth = this.model.getStrokeWidth(),
	            borderAndPadding = ( this.model.getPadding() + strokeWidth ) * 2 * scale,
	            scaledStrokeWidth = strokeWidth * scale;
	
	        var paperDims = this.canvasChannel.request('canvasContainerRel'),
	            paperWidth = paperDims.x2,
	            paperHeight = paperDims.y2,
	
	            textBox = this.textEl.getBBox(),
	            textWidth = textBox.width,
	            textHeight = textBox.height,
	
	            shapeWidth = textWidth + borderAndPadding,
	            shapeHeight = textHeight + borderAndPadding,
	
	            scaledGutter = this.GUTTER * scale,
	            halfScaledStrokeWidth = scaledStrokeWidth / 2;
	
	        var topLeft = {x: 0, y: 0},
	            shapeExceedsCodeView;
	
	
	        if ( rotation === 0) {
	
	            // Take off half the total stroke-width b/c the stroke is centered on the shape in SVG
	            shapeExceedsCodeView = shapeViewBox.x2 >=  paperWidth - scaledGutter - shapeWidth - halfScaledStrokeWidth;
	
	            topLeft.x = shapeExceedsCodeView
	                ? scaledGutter + halfScaledStrokeWidth
	                : paperWidth - scaledGutter - shapeWidth - halfScaledStrokeWidth;
	
	            topLeft.y = shapeViewBox.y;
	
	        }
	
	        else if (rotation === 90) {
	
	            shapeExceedsCodeView = shapeViewBox.y2 >= paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth;
	
	            topLeft.x = shapeViewBox.x2 - shapeWidth;
	            topLeft.y = shapeExceedsCodeView
	                 ? scaledGutter + halfScaledStrokeWidth
	                 : paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth;
	
	        }
	
	        else if ( rotation === 270 ) {
	
	            shapeExceedsCodeView = shapeViewBox.y <= scaledGutter + shapeHeight + halfScaledStrokeWidth;
	
	            topLeft.x = shapeViewBox.x;
	            topLeft.y = shapeExceedsCodeView
	                ? paperHeight - scaledGutter - shapeHeight - halfScaledStrokeWidth
	                : scaledGutter + halfScaledStrokeWidth;
	
	
	        } else if ( Math.abs(rotation) === 180 ) {
	
	            shapeExceedsCodeView = shapeViewBox.x < scaledGutter + shapeWidth + halfScaledStrokeWidth;
	
	            topLeft.x = shapeExceedsCodeView
	                ? paperWidth - shapeWidth - scaledGutter - halfScaledStrokeWidth
	                : scaledGutter + halfScaledStrokeWidth;
	
	            topLeft.y = shapeViewBox.y2 - shapeHeight;
	
	        }
	
	        // now create coordinates of the box from it -- combo'd with that of size of the text el (it was already printed),
	        // to position el and textEl in positionFromCoordinates
	
	        var boxCoordinates = [
	            {
	                x: topLeft.x,
	                y: topLeft.y
	            },
	            {
	                x: topLeft.x + shapeWidth,
	                y: topLeft.y
	            },
	            {
	                x: topLeft.x + shapeWidth,
	                y: topLeft.y + shapeHeight
	            },
	            {
	                x: topLeft.x,
	                y: topLeft.y + shapeHeight
	            }
	        ];
	
	        // potential optimization is cached on initial render, then adjusting on move ...
	
	        // now normalize the pts back to no transformation applied (100% scale, no rotation)
	        // TODO: can cache original center for perf and / or not provide it if rotation is 0
	        var normalizedPts = ShapeUtils.getPtsWithoutTransformApplied(
	            boxCoordinates, scale, rotation, this.pageModel.getOriginalCenterPtRotated()
	        );
	
	        // the above algorithm doesn't return the points in the 'rect' order; below is a quick fix
	        if ( rotation !== 0)
	            normalizedPts = ShapeUtils.getPtsInRectOrder( normalizedPts );
	
	        this.positionFromCoordinates( normalizedPts );
	
	    },
	
	
	    // Now only called on entry on render -- no need parent should always be active and no need to disable drag;
	    _toggleActive: function(model, parentNoteIsActive, options) {
	
	
	        if (parentNoteIsActive) {
	
	            this._enableDrag();
	
	            // when a note is toggled active, it's set to the 'front', so update the z-positioning
	            if (options && options.shapeViewEl) { // maybe want to break this out into a separate call ... it's also called on the initial render
	                this.triggerMethod('updateShapeLayering', options.shapeViewEl);
	            }
	
	        }
	
	    },
	    /*
	    * Set a drag event handler on this.el.
	    * Capture and forward mousedown events of the subviews to el to trigger a dragStart on el.
	    * */
	    _enableDrag: function() {
	
	        // Always disable first in case -- ran into case with find and redact after saving
	        // Note where if drag was set twice, the drag-end event handle was set twice, which
	        // Resulted in a run time error ( this.grab deleted )
	        // While this doesn't hurt, we still need to refactor any 'toggling' active to be done
	        // render of shapes !
	        this._disableDrag();
	
	        this.el
	            .drag(
	                function( dx, dy, x, y, e ) {
	
	                    return this.moveMove( dx, dy, x, y, e, this.dragHelper, function() {
	
	                        // may be able to consolidate that into use of shape el mixin ( assuming el or a set )
	                        this.transform( 'T' + this.dragHelper.dx + ',' + this.dragHelper.dy ); // could put this login in the transform fn ... ( check for move )
	
	                        this.noteCodesChannel.trigger( 'reasonCodeView.drag', this.model );
	
	                    });
	
	                },
	
	                function( x, y, e ) {
	
	                    var pageShapeTransformModel = this.shapePageTransformModel;
	
	                    // TODO: if pass el or set, can use same as shapeMove fn's -- more clear code sharing
	                    this.dragHelper = new DragHelper({
	                        canvasBounds: this.canvasChannel.request('canvasContainerRel'),
	                        dragOpacity: 0.5,
	                        isTransformedShape: 1,
	                        pageScale: pageShapeTransformModel.getScale(),
	                        pageRotation: pageShapeTransformModel.getRotation(),
	                        pageTransform: pageShapeTransformModel.getTransform()
	                    });
	
	                    return this.moveStart( x, y, e, this.dragHelper, function() {
	
	                        this.model.set( 'codesWerePositioned', true );
	
	                        // this.el already done now -- but this is like a set
	
	                        // TODO: may be able to send these into helper as set ( see above ) -- set opacity of all
	                        _.each( [ this.borderEl, this.innerEl, this.textEl], function(el) {
	                            el.attr('opacity', 0.5);
	                        });
	
	                    });
	
	                },
	
	                function(e) {
	
	                    return this.moveEnd( e, this.dragHelper, function() {
	
	                        //--> want dx, dy for the client matrix adjustment on move end
	
	                        // TODO: make this a callback with a default ?
	                        _.each( [this.textEl, this.borderEl, this.innerEl ], function(el) {
	                            el.attr({
	                                x: el.attr('x') + this.dragHelper.invmDx,
	                                y: el.attr('y') + this.dragHelper.invmDy,
	                                opacity: 1.0
	                            });
	                        }, this);
	
	                        /*
	                         * handle the path element differently
	                         * var nPath = Raphael.transformPath( boxEl.attr('path') , 't' + dx + ',' + dy );
	                         *  note: transformPath ... so adds curves to the rect path, so below instead
	                         * */
	                        var oElPath = this.el.attr('path');
	                        var newElPath = Raphael.fn.mapPathStraight( oElPath , Raphael.toMatrix(oElPath, 't' + this.dragHelper.invmDx + ',' + this.dragHelper.invmDy) );
	
	                        this.el.attr({
	                            'path': newElPath
	                        });
	
	                        this.transform();
	
	                        this.noteCodesChannel.trigger( 'reasonCodeView.drag', this.model );
	
	                        delete this.dragHelper; // ( now only primitives )
	
	                    } );
	
	                },
	                this, this, this
	            )
	            .attr('cursor', 'move');
	
	        // ( maybe we want to treat these as a set, but then we run into memory reference issues )
	        // TODO: retest this ...
	        _.each( [this.textEl,this.borderEl, this.innerEl ] , function(el) {
	
	                el.mousedown( _.bind (function(e) {
	                        e.preventDefault(); // disallow text selection (for text element)
	                        e.stopPropagation();
	                        this.el.trigger('mousedown', e); // start drag of el (which is underneath)
	                    }, this))
	                    .attr('cursor', 'move');
	
	        }, this);
	
	    },
	
	    _disableDrag: function() {
	
	        this.el
	            .attr('cursor', 'inherit')
	            .undrag();
	
	        _.each( [this.textEl,this.borderEl, this.innerEl ] , function(el) {
	
	            el.unmousedown()
	                .attr('cursor', 'inherit');
	
	        });
	
	    },
	
	    _updateTransformAndTransformView: function() {
	        this.shapePageTransformModel.updateTransform( );
	        this.transform();
	    },
	
	    // transform both el and all subviews
	    // could potentially cache and uptimate getting the transform value
	    transform: function(t) {
	
	        var shapePgTransformModel = this.shapePageTransformModel;
	
	        var trans = shapePgTransformModel.getTransform();
	
	        if ( t ) {
	            trans += t;
	        }
	
	        this.el.transform( trans );
	        this.borderEl.transform( trans );
	        this.innerEl.transform( trans );
	        this.textEl.transform( trans );
	
	        /*
	        * Hack to fix stroke-width at different scales; see source code for transform --- it sets it back to the original.
	        * First implementation didn't use this and always assumed a size of 1 px; changed when started storing stroke with as pts, and
	        * then needed to adjust for image dpi ... this could now be larger and the may could manifest more.
	        * Note: this will look a bit out of whack with the stroke width of the active redaction zones, which aren't scaled.
	        * With an implementation of a viewbox, presumably wouldn't require.
	        * */
	
	        this.borderEl.attr('stroke-width', this.model.getStrokeWidth() * shapePgTransformModel.getScale() );
	
	    },
	
	    onBeforeDestroy: function() {
	
	        this.stopListening();
	        this._disableDrag();
	
	        this.borderEl.remove();
	        this.innerEl.remove();
	        this.textEl.remove();
	        this.el.remove();
	
	    }
	
	});
	
	
	_.extend( CodesView.prototype, BaseMoveFunctions );
	
	
	module.exports = CodesView;


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	var ShapePageTransformModel = function() {
	
	    this.rotation = 0;
	    this.width = 0;
	    this.height = 0;
	    this.scale = 0;
	    this.transform = '';
	
	    return this;
	
	};
	
	
	_.extend( ShapePageTransformModel.prototype, {
	
	    initializeValues: function( pageModel, scale ) {
	
	        var pgDims = pageModel.getOriginalPageCanvasDimensions();
	
	        this.rotation = pageModel.get('rotation') % 360;
	        this.width = pgDims.w;
	        this.height = pgDims.h;
	        this.scale = scale;
	
	        return this;
	
	    },
	
	    /* Update the values -- cb: typically function to transform the view --> was updatePageTransform */
	    updateTransform: function( transformCb ) {
	
	        var s = this.scale,
	            r = this.rotation,
	            pw = this.width,
	            ph = this.height,
	            cx = pw / 2,
	            cy = ph / 2;
	
	        this.transform = 's' + s + ',' + s + ',' + 0 + ',' + 0 +
	            'r' + r + ',' + cx + ',' + cy;
	
	        if ( r === 90 || r === 270 )
	            this.transform += 'T' + ((ph - pw) * s / 2) + ',' + ((pw - ph) * s / 2);
	
	        transformCb && transformCb.call( this, this.transform );
	
	    },
	    setTransform: function( transform ) {
	        this.transform = transform;
	    },
	    getTransform: function( ) {
	        return this.transform;
	    },
	
	    getRotation: function(  ) {
	        return this.rotation;
	    },
	    setRotation: function( rotation ) {
	        this.rotation = rotation;
	    },
	    getWidth: function() {
	        return this.width;
	    },
	    setWidth: function( width ) {
	        return this.width;
	    },
	    getHeight: function( ) {
	        return this.height;
	    },
	    setHeight: function( height ) {
	        this.height = height;
	    },
	    getScale: function() {
	        return this.scale;
	    },
	    setScale: function( scale ) {
	        this.scale = scale;
	    },
	
	
	    getCenter: function() {
	
	        return {
	            x: this.width / 2,
	            y: this.height /2
	        };
	
	    }
	
	
	});
	
	
	
	
	module.exports = ShapePageTransformModel;
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    BoxModel = __webpack_require__(249),
	    ConnectionModel = __webpack_require__(250),
	    ShapeUtils = __webpack_require__(197); // TODO: call this calc's or something ...
	
	module.exports = Backbone.Model.extend({
	
	    idAttribute: 'uniqueCodeString', // useful if use in a collection
	
	    defaults: {
	
	        uniqueCodeString: null, // the 'id' of the collection
	        shapeViewIds: [], // cids of the views are are connected to it
	        codeViewId: null, // cid of the reason code view
	
	        // codesWerePositioned: true if ---
	            // 1) view was dragged (dragStart), or
	            // 2) more than one shape view had been connected (it doesn't go back), or
	            // 3) read in on load of canvas from the controller
	            // ( originally: saved note when certain conditions are met ( set on init of this model where options.renderBoxFromShapeModelPts = true )
	            // once true -- never goes back
	        codesWerePositioned: false,
	
	        pgDPI: 200, // DPI of the page used in font-size calcs; set on init -- TODO: use a better default???
	
	
	        /*
	        * Set on init with pgDPI taken into account -- what is used to print the text.
	        * Converted from points to pixels (different than the box model).
	        * What is used in rendering the letters on the screen -- not persisting them.
	        *  .... so this default value essentially never used ...
	        * */
	
	        adjustedFontSize: BoxModel.prototype.defaults.fontSize,
	        adjustedLineHeight: BoxModel.prototype.defaults.lineHeight,
	
	        // ui attributes & state -- triggering events
	
	        // setting here solves problem of activating code view multiple times if they're attached to > 1 shapeView;
	        // the shape views will each listen to the events and this set accordingly, but it will only change change (and fire) once
	        parentNoteIsActive: false,
	
	        /*
	        * Stroke-width and padding now stored as pt -- convert them to pixels for rendering ...
	        * */
	        adjustedStrokeWidth: BoxModel.prototype.defaults.strokeWidth,
	        adjustedPadding: BoxModel.prototype.defaults.padding,
	
	
	        // Adjusted property from the line
	        adjustedConnectionWidth: ConnectionModel.prototype.defaults.width,
	        adjustedConnectionDashArray: ConnectionModel.prototype.defaults.dashArray
	
	    },
	
	    initialize: function(attrs, options) {
	
	        if (options.renderBoxFromShapeModelPts) {
	
	            // Note: the points here have already been 'adjusted'
	            this.boxModel = options.boxModel;
	            this.connectionModel = options.connectionModel;
	
	            this.set({
	                codesWerePositioned: true
	            });
	
	        } else {
	
	            this.boxModel = new BoxModel();
	            this.connectionModel = new ConnectionModel();
	
	        }
	
	        var pgDpi = this.get('pgDPI');
	
	        // TODO: will need different model if/when we let the user change these values (and others) -- maybe an intermediary render attributes object
	        // perhaps an alternative is converting automatically to pixel on way in and way out like we do for the shape
	        // ... should prob think about this now ...
	        // ... now static and defaults taken directly from the box
	        // eg on save the values are taken from the box model, which would be the unconverted values here ...
	        // all values applied should come from this: eg lineHeight comes from the codebox, not here ... this should be changed especially when we let users change values
	
	        // Font-Size: Stored in Pts
	        var adjustedFontSize = +( (ShapeUtils.ptToPx( this.boxModel.get('fontSize') ) * (pgDpi / 96)).toFixed(3) );
	
	        // Stroke-Width: 1/10 mm
	        var adjustedStrokeWidth = +( (this.boxModel.get('strokeWidth') * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) )  ;
	
	        // Padding: 1/10 mm
	        var adjustedPadding = +( (this.boxModel.get('padding') * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) );
	
	        // Connection width:  1/10 mm
	        var baseConnectionWidth = this.connectionModel.get('width');
	        var adjustedConnectionWidth = +( ( baseConnectionWidth * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) );
	
	        var baseDashArray = this.connectionModel.get('dashArray');
	
	        /*
	        * Connection Dash-Array: 1/10 mm values.
	        * Adjust by multiplying by connection width at onset, rather than whenever a scale is applied using current hack.
	        * If the base is null or an empty array; will be set to null (also serving as a flag).
	        * */
	
	        var adjustedConnectionDashArray = ( baseDashArray && baseDashArray.length > 0 )
	            ? _.map( baseDashArray, function( dashValue ) {
	                return +( dashValue  * baseConnectionWidth * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3);
	            })
	         : null;
	
	        this.set({
	            adjustedFontSize: adjustedFontSize,
	            adjustedLineHeight: adjustedFontSize * this.boxModel.get('lineHeight'), // calculate off the pixels
	            adjustedStrokeWidth: adjustedStrokeWidth,
	            adjustedPadding: adjustedPadding,
	
	            adjustedConnectionWidth: adjustedConnectionWidth,
	            adjustedConnectionDashArray: adjustedConnectionDashArray
	        });
	
	    },
	
	    addShapeViewId: function(cid) {
	        var newCids = _.uniq( this.get('shapeViewIds').concat(cid) );
	        this.set('shapeViewIds', newCids);
	        (newCids.length > 1) && this.set('codesWerePositioned', true);
	    },
	    removeShapeViewId: function(cid) {
	        this.set('shapeViewIds', _.without( this.get('shapeViewIds'), cid  ));
	    },
	
	    getBoxCoordinates: function() {
	        return this.boxModel.get('points');
	    },
	
	    /*
	    * Note: this is the 'border' path.
	    * */
	    getBorderElAttrs: function() {
	
	        var boxAttrs = this.boxModel.toJSON();
	
	        return {
	            'stroke-width': this.getStrokeWidth(), // (now adjusted from pts to px)
	            stroke: boxAttrs.stroke,
	            'stroke-opacity': boxAttrs.strokeOpacity
	        };
	
	    },
	
	    /*
	    * The 'inner box' -- fill, not-stroke
	    * */
	
	    getInnerElAttributes: function() {
	
	        var boxAttrs = this.boxModel.toJSON();
	
	        return {
	            stroke: 'none',
	            fill: boxAttrs.fill,
	            'fill-opacity': boxAttrs.fillOpacity
	        };
	    },
	
	    /*
	    * The Raphael attributes to apply the text path on render.
	    * Include all but 'lineHeight', which isn't an available Raphael attribute,
	    * or valid SVG attribute.
	    * It's applied separately via a data attribute to calc the dy of generated tspans
	    * ( font-size * lineHeight ).
	    * */
	    getTextElAttrs: function() {
	
	        var boxAttrs = this.boxModel.toJSON();
	
	        return {
	            'font-family': boxAttrs.font,
	            'font-size': this.get('adjustedFontSize'),
	            fill: boxAttrs.textColor,
	            'text-anchor':
	                boxAttrs.textAlign === 'left'
	                    ? 'start'
	                    : '' //TODO: other valid values ... though not allowing to change currently -- 'start', 'middle', 'end' -- all values would require changes to the text placement inside the box
	        };
	
	    },
	
	
	    getTextLineHeight: function() {
	        return this.getBoxModel().get('lineHeight');
	    },
	
	
	    getConnectionLineColor: function() {
	        return this.connectionModel.get('color');
	    },
	
	    getConnectionLineWidth: function()  {
	        return this.get('adjustedConnectionWidth');
	    },
	
	    // Returns the array
	    getConnectionDashArray: function() {
	        return this.get('adjustedConnectionDashArray');
	    },
	
	    /* Note: connection width already taken into account at onset -- set on init */
	    // TODO: better performance ... using rounding and _.map ???
	    getConnectionDashArraySVGValue: function(scale ) {
	
	        scale = scale || 1;
	       
	        var dashArray = this.getConnectionDashArray(); 
	        
	        // Don't perform any calc's if the value is null
	        if (!dashArray)
	            return null;
	
	        return  _.map( dashArray, function(i) {
	            return +( i * scale ).toFixed(3);
	        } ).join(',');
	
	    },
	
	    /*
	    * Connection attr's except:
	    *   - color: passed in separately to the connect 'plugin'
	    *   - dashArray: applied separately to avoid Raphael internal dashArray calculations (and to include scale value)
	    *   - stroke-width: now set separately to include the scale value ( see shapeView )
	    * */
	    getConnectionLineAttrs: function() {
	
	        var connectionAttrs = this.connectionModel.toJSON();
	
	        var attrs = {
	            'stroke-opacity': connectionAttrs.opacity
	        };
	
	        return attrs;
	
	    },
	
	    getStrokeWidth: function() {
	        return this.get('adjustedStrokeWidth');
	    },
	
	    getPadding: function() {
	        return this.get('adjustedPadding');
	    },
	
	    getBoxModel: function() {
	        return this.boxModel;
	    },
	    getConnectionModel: function() {
	        return this.connectionModel;
	    },
	
	    getPgDpi: function() {
	        return this.get('pgDPI');
	    }
	
	
	});
	
	


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {__webpack_require__(58);
	
	
	var ShapeUtils = __webpack_require__(197);
	
	
	/*
	*   Properties used in drawing and persisting the box.
	*   Padding, strokeWidth, fontSize now stored in pts, not pixels;
	*
	* */
	
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        points: [],
	
	        padding: +( ShapeUtils.ptToTenthsMM(5).toFixed(3) ), // point equivalent of 5; really: 17.639 -- round down ?
	
	        /*
	         * strokeWidth:
	         * Raphael doesn't scale stroke width correctly, see hack in codesView to overcome this.
	         * Now in 1/10 mm to store as a physical dimension.
	         * Must be at least 1 so we don't get < 1 pixel value -- fractional pixel won't be rendered by the browser as some round down (1px would be 0.75pt).
	         * Value of 1 will convert to 1.33 if dpi is not taken into account -- so leave at 1 like doing b/f with pixels.
	         * This will be more apparent now that we are scaling the stroke-width, especially at images of higher DPI. ...
	         * FDD start with adjusted 2px value;  I think do in pts in case we ever have a picker -- just convert pt values (dpi independent)
	         * One pt converted to 1/10 mm -- really 3.528-- may not want to be a decimal ... still problematic ???
	         * */
	
	        strokeWidth: +(ShapeUtils.ptToTenthsMM(1).toFixed(3) ),
	
	        // properties not involved with positioning the coordinates -- MAY WANT A 'BOX' OBJECT THAT GETS PASSED IN FROM THE NOTE MODEL
	        fill: '#fffbcc', //html yellow, though intertwined with transparency if we ever start using it --
	        fillOpacity: 1.0,
	        stroke: '#000000', // black: looks like other software has one
	        strokeOpacity: 0.35, // name the same as the line (black with this opacity) ///0.2, // may as well make grey
	
	        // those applied to text el ... again, maybe a diff obj
	        font: 'Arial',
	
	        fontSize: 9, // Points: equivalent of 12 pixels (which was using b/f) and people deemed good
	
	        textColor: '#000000',
	        textAlign: 'left',  // horizontal alignment of the text in the box, i don't think we want; I'm currently assuming everything is left -- THIS IS TEXT ANCHOR, IF CHANGE WHAT TO DO
	        lineHeight: 1.2
	
	    },
	
	    getPoints: function() {
	        return this.get('points');
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    ShapeUtils = __webpack_require__(197);
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        points: [],
	        color: '#000000',
	        opacity: 0.35,
	
	        /*
	        *  Note: these are the 'base' values: the ones applied when rendering are multiplied by width.
	        *  This is done by drawing programs ... it comes into play by making the dash look better on lines with different widths,
	        *  eg: try with a higher width and without the calculation.
	        *  Default is just 1 item but leave the option open for more if later desired.
	        * */
	        dashArray: [ +( ShapeUtils.ptToTenthsMM( 1 ).toFixed(3)  ) ],
	
	        //  width: configurable but there are problems:
	            // if wide, top doesn't align with default position ( points connected from center )
	        width: +( ShapeUtils.ptToTenthsMM( 1 ).toFixed(3) ) // ( now the same as code box width by default ) -- TODO: share it
	
	    },
	    /*
	    *  If value read from db is null, don't allow it to be set to the default defined here.
	    *  This is done in  constructor code: if (defaults = _.result(this, 'defaults')) { attrs = _.defaults({}, attrs, defaults); },
	    *  where _.defaults applies the models defaults if corresponding attributes are undefined ...
	    *  but here, dashArray is set to null if none is to be applied and we want to leave it's default value defined in the model defaults.
	    * */
	    constructor: function(attrs, options) {
	
	        Backbone.Model.prototype.constructor.apply( this, arguments );
	
	        if (!attrs)
	            return;
	
	        if ( !attrs.dashArray ) {
	
	            this.set({
	                dashArray: null
	            }, options);
	        }
	    }
	
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var Raphael = __webpack_require__(182);
	__webpack_require__(198);
	
	
	// Custom fork of Raphael Giraffe for drawing floating reason codes in this application.
	// Find example and original source at http://dmitrybaranovskiy.github.io/raphael/graffle.html.
	// Main changes:
	// - Not using bounding boxes: assumes the objects passed in are paths with transforms.
	// - Connections are made at points, not 'ports' which could be an edge of the shape.
	// - Only interested in straight lines (no bezier curves)
	// - Don't add/subtract pixels when derives the port locations; have them exact.
	// This is working -- if performance becomes an issue there is room for optimization.
	
	Raphael.fn.connection = function(redaction, codeBox, line, bg) {
	
	    if (redaction.line && redaction.from && redaction.to) {
	        line = redaction;
	        redaction = line.from;
	        codeBox = line.to;
	    }
	
	    var codeBoxPts = codeBox.getPathCoordinates(1),
	        redactionPts = redaction.getPathCoordinates(1),
	        nRedactionPts = redactionPts.length,
	        dists = {}, // keys: box pt array index; values: array of distances of other shape points to the box
	        minDists = {}; // box pt array index by array ( indexOfMinDist, minDist )
	
	    //  Handle in case the codeBoxPts have yet to be defined to prevent error.
	    ( codeBoxPts.length < 1 ) && codeBoxPts.push( {x:0, y:0} );
	
	    for ( var c=0; c<codeBoxPts.length; c++ ) {
	
	        var aDistToOtherPts = [];
	
	        for (var r=0; r<nRedactionPts; r++) {
	            aDistToOtherPts.push( distBetweenPoints( codeBoxPts[c], redactionPts[r] ) );
	        }
	
	        dists[c] = aDistToOtherPts;
	
	        // Need the index and the distance -- here stored in array
	        // Room for optimization: could only have pt index min distance obj and replace it if a subsequent one is smaller, etc
	        var minDist = Math.min.apply( Math , dists[c] );
	
	        minDists[c] = {
	            idx: dists[c].indexOf(minDist),
	            dist: minDist
	        };
	    }
	
	    // Get the min pt and it's min distance to get its 'pair' point to draw the line.
	
	    var theMinDisIdx = 0,
	        theMinDist = minDists[0];
	
	    for (k in minDists) {
	        // Extra first loop: suboptimal ...
	        if (minDists[k].dist < theMinDist.dist) {
	            theMinDisIdx = k;
	            theMinDist = minDists[k];
	        }
	    }
	
	    var codePt = codeBoxPts[theMinDisIdx],
	        redactionPt = redactionPts[theMinDist.idx],
	        path = ["M", codePt.x.toFixed(3), codePt.y.toFixed(3), "L", redactionPt.x.toFixed(3), redactionPt.y.toFixed(3)].join(",");
	
	    if (line && line.line) {
	
	        line.bg && line.bg.attr({path: path});
	        line.line.attr({path: path});
	
	    } else {
	
	        var color = typeof line == "string" ? line : "#000";
	
	        return {
	            bg: bg && bg.split && this.path(path)
	                .attr( {stroke: bg.split("|")[0], fill: "none", "stroke-width": bg.split("|")[1] || 3} ),
	            line: this.path(path).attr({stroke: color, fill: "none"}),
	            from: redaction,
	            to: codeBox
	        };
	    }
	
	};
	
	
	function distBetweenPoints(pt1, pt2) {
	    var a = pt1.x - pt2.x,
	        b = pt1.y - pt2.y;
	    return Math.sqrt( a*a + b*b );
	}

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var CoordinateShape = __webpack_require__(253),
	    ZoneReasonCodeCollection = __webpack_require__(257),
	    AvailableZoneReasonCodes = __webpack_require__(79),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    _ = __webpack_require__(49);
	
	
	
	module.exports = CoordinateShape.extend({
	
	    APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE: 1,
	    APPLY_LAST_FILL_FROM_LOCAL_STORAGE: 1,
	
	    STORE_SELECTED_FILL_TO_LOCAL_STORAGE: 1,
	    STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE: 1,
	
	    hasCustomizableProperties: 1,
	
	    constructor: function(attrs, options) {
	
	        CoordinateShape.prototype.constructor.apply( this, arguments );
	
	        // A collection of redaction code models that are later converted back to array format for persistence
	        // Should rename
	        this.colRedactionCodes = this.generateReasonCodeCollectionOnParse(attrs);
	
	        // Necessary to set flag on the shape level to indicate if it's being converted (can't just use the higher level note model )
	        this.isConvertingToFloatingCodes = options.isConvertingToFloatingCodes;
	
	        // Really a UI model attribute: utilized to centralize logic from multiple dialog views
	        // to see if codes changed/where added in the views by the user
	        // Not always set on close on a dialog -- eg for find and redact, needed when hit search
	        this.selectedCodesOnDialogOpen = null;
	        this.selectedFillOnDialogOpen = null;
	
	
	    },
	    defaults: function() {
	
	        var lastRedactionFill = fvChannel.request('localStorage').getLastRedactionFill();
	
	        return _.extend( {}, CoordinateShape.prototype.defaults.apply( this, arguments ), {
	
	            fill: lastRedactionFill
	                ? lastRedactionFill
	                : 'WHITE_BLACK_BORDER',
	            comments: null, // * besides fill, those sent to server -- remove fill default? */
	            reasonCodes: null // obj: {code ,description, active, .. everything from the reasonCode model; corresponds to this.colRedactionCodes }
	        });
	
	    },
	
	    /**
	     * Logic to apply codes from local storage (old notes when this was on view):
	     * 1) New Notes: new shape created -- apply last codes if they exist (won't be called for others when toggle on/off)
	     * 2) Not New Note
	     *      a) After save or render from the model: don't apply the last codes
	     *      b) Modify existing and a newly created shape, not rendered from the model: apply the codes
	     * Sum: if not rendered from the model (isNewlyDrawn), apply the code from local storage, otherwise do not
	     * Note: not called again after initial render of note and select/deselect different shapes
	     * applyFromLastUsedReasonCodes:
	     * - Perhaps this is a function ... but cleaner way than this flag ... maybe the flag is on the uiModel
	     * - currently need to check parentNote to see if flag set ( shapeModel is not subclassed ) ... should refactor ....
	     */
	    generateReasonCodeCollectionOnParse: function( attrs ) {
	
	        var sm = this,
	            applyFromLastUsedReasonCodes =
	                ( this.parentNote.isFindAndRedactNote && !this.parentNote.isFromAPI )||   // latter: is for notes passed through the API by user
	                ( sm.APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE && this.uiModel.get('isNewlyDrawn') ),
	            shapeReasonCodeAttributes = [];
	
	        // Populate from the last used codes from local storage, if those from local storage exist in the system.
	        // Get the description and other attributes from the locally stored codes from the system codes collection ( we only store the code )
	        if ( applyFromLastUsedReasonCodes ) {
	
	            var lastRedactionCodes = fvChannel.request('localStorage').getLastReasonCodes(),
	                systemReasonCodeModels = fvChannel.request('reasonCodes'), // ( empty array if none exist )
	                systemReasonCodeModelCodes = systemReasonCodeModels.pluck('code');
	
	            var lastUsedCodesThatExistInSystemCodes = _.filter( lastRedactionCodes, function( c ) {
	                return _.contains( systemReasonCodeModelCodes, c );
	            });
	            
	            shapeReasonCodeAttributes = _.map( lastUsedCodesThatExistInSystemCodes, function(code) {
	
	                return systemReasonCodeModels.findWhere({code: code}).toJSON();
	            });
	
	            // Filter out any that aren't active on way in ( still storing last used ones on way out )
	            // ( Alternative is whenever we write them out, don't write them ... either works, though this logic is more consistent )
	            shapeReasonCodeAttributes = _.filter( shapeReasonCodeAttributes, function(codeAttrs) {
	               return codeAttrs.active;
	            });
	
	        } else {
	
	            shapeReasonCodeAttributes = attrs.reasonCodes;
	
	        }
	
	        return new ZoneReasonCodeCollection( shapeReasonCodeAttributes );
	
	    },
	
	    getReasonCodeCollection: function() {
	        return this.colRedactionCodes;
	    },
	
	    setReasonCodeCollection: function( reasonCodes ) {
	        this.colRedactionCodes = reasonCodes;
	    },
	
	    /*
	    * ( I don't think this would ever get called if 'active', though could be that in here explicitly )
	    * */
	    getNonPathInactiveSVGAttrs: function() {
	
	        if ( this.uiModel.get('isExpanded') || !fvChannel.request('localStorage').getPgModeApplyAllRedactions() )
	            return CoordinateShape.prototype.getNonPathInactiveSVGAttrs.apply( this, arguments );
	
	        var BLACK = '#000000',
	            WHITE = '#ffffff',
	            shapeFill = this.get('fill');
	
	        return {
	            stroke: shapeFill === 'WHITE' ? WHITE : BLACK,
	            fill: shapeFill === 'BLACK' ? BLACK : WHITE,
	            'stroke-width': shapeFill === 'WHITE_BLACK_BORDER' ? 2 : 0,
	            'fill-opacity': 1
	        };
	
	    },
	
	    /**
	     * (This would only be for non-floating codes ).
	     * When not in redaction preview mode, the see through color is no longer hard-coded --
	     * it's the same as the shape ( DVBC-1812).  After some experiment, this seems the best
	     * option.  There is always a black fill so you can see the letters, even for light colors.
	     * Also, there's no need to determine white/black text depending on the background, since the
	     * zones have opacity.
	     */
	    getReasonCodeSvgAttrs: function( derivedSeeThroughColor ) {
	
	        if ( this.uiModel.get('isActive') || this.uiModel.get('isExpanded') || !fvChannel.request('localStorage').getPgModeApplyAllRedactions() ) {
	
	            return {
	                fill: derivedSeeThroughColor,
	                stroke: '#000000',
	                'stroke-width': 1,
	                'font-family': 'Courier New' // Match the CRE's font
	            };
	
	        } else {
	
	            // apply all redaction attributes
	            return {
	                fill: this.get('fill') === 'BLACK' ? '#ffffff' : '#000000',
	                'font-family': 'Courier New', // Match the CRE's font
	                stroke: 'none', // need for toggling between the 2
	                'stroke-width': 0 // probably unnecessary
	            };
	
	        }
	
	    },
	
	    getAvailableCodesToSelectInZoneDialog: function() {
	
	        // Always add the active reason code models to choose from
	        var rcModels =
	            fvChannel.request('reasonCodes').getActiveReasonCodes().models;
	
	        /**
	         *  Now add inactive code models already on the zone.
	         *  ( only applicable to existing notes ---  inactive codes from local storage are not read in ).
	         *  Here we add all of the codes, inactive/not: this is to avoid logic in the node server
	         *  to sync the active status of codes from the system and shape.
	         *  Backbone's collection will not add duplicate models, and since those from the system are added first,
	         *  they will take precedence.
	         *  You'd want to do this anyway, but the point is moot because user's cannot delete codes applied to
	         *  documents -- before this -- they would have been 'reassigned' but that feature has been taken away.
	         *  Bottom line is all codes on the prod server will be the same whether from fdd.reason_codes or the stored on note zones.
	         *  This now also handles the Non-Responsive reason code being added to full page redactions if for some reason
	         *  it no longer exists in the system.
	         */
	
	        var zoneCodes = this.getReasonCodeCollection();
	        if ( zoneCodes && zoneCodes.length > 0 ) {
	            rcModels = rcModels.concat( zoneCodes.models ); // ( .getInactiveCodes() )
	        }
	
	        return new AvailableZoneReasonCodes( rcModels );
	
	    },
	
	    getAttrsToPersist: function(scale) {
	
	        var baseAttrs = CoordinateShape.prototype.getAttrsToPersist.apply(this, arguments);
	
	        var attrs = _.extend( {}, baseAttrs, {
	            fill: this.get('fill'),
	            reasonCodes: this.getReasonCodeCollection().toJSON()
	        });
	
	        if ( this.get('comments') && this.get('comments').length > 0 )
	            attrs['comments'] = this.get('comments');
	
	        return attrs;
	    },
	
	    /**
	     * TODO:
	     * - make an object?
	     */
	    setSelectedCodeAndFillOnDialogOpen: function( codeCollection, fill ) {
	
	        /* Clone so it's not the same reference for later comparison to the original */
	        this.selectedCodesOnDialogOpen = codeCollection || this.getReasonCodeCollection().clone();
	        this.selectedFillOnDialogOpen = fill || this.get('fill');
	
	    },
	
	    getSelectedFillOnDialogOpen: function() {
	        return this.selectedFillOnDialogOpen;
	    },
	
	    getSelectedCodesOnDialogOpen: function() {
	        return this.selectedCodesOnDialogOpen;
	    },
	
	    /* Return selected codes that weren't added since open, or null if there were none */
	    selectedCodesAddedSinceDialogOpen: function( selectedCodes ) {
	
	        selectedCodes = selectedCodes || this.getReasonCodeCollection();
	
	        var originalCodes = this.selectedCodesOnDialogOpen.pluck('code'),
	            currentCodes = selectedCodes.pluck('code'),
	            codesAdded = _.difference( currentCodes, originalCodes );
	
	        return codesAdded.length > 0
	            ? codesAdded
	            : null;
	
	    },
	
	
	    // Return true if the selectedCodes changed between opening and closing the dialog
	    // Put on here for consistency with other consolidating code ( from original redaction prop dialog ).
	    selectedCodesChangedSinceDialogOpen: function( selectedCodes ) {
	
	        selectedCodes = selectedCodes || this.getReasonCodeCollection();
	
	        var selectedCodesOnDialogOpen = this.getSelectedCodesOnDialogOpen();
	
	        if ( selectedCodesOnDialogOpen.length !== selectedCodes.length )
	            return true;
	
	        var originalCodes = selectedCodesOnDialogOpen.pluck('code'),
	            currentCodes = selectedCodes.pluck('code');
	
	        return  _.difference( currentCodes, originalCodes ).length > 0 ||
	            _.difference( originalCodes, currentCodes ).length > 0;
	
	    },
	
	    /**
	     * Centralized local here for several UI's.
	     * Not necessarily from a dialog close -- eg a find and redact search.
	     * Find and redact search: we don't need to check the 'original' values changed:
	     * - these are always new and created from local storage
	     * - except for getting which ones were added
	     * resetWithCurrentValuesAfterUpdate: update the properties at end of routine ( maybe just always do this ).
	     */
	    updateLocalStoragePostDialogClose: function( resetWithCurrentValuesAfterUpdate ) {
	
	        var localStorage = fvChannel.request('localStorage');
	
	        if ( this.STORE_SELECTED_FILL_TO_LOCAL_STORAGE && this.get('fill') !== this.getSelectedFillOnDialogOpen() ) {
	            localStorage.setLastRedactionFill( this.get('fill') );
	        }
	
	        // Even for F&R search do it ( doesn't hurt) AND for F&R dialog only on change
	        // ( if open dialog that is difference, don't set value to it )
	        if ( this.STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE && this.selectedCodesChangedSinceDialogOpen() ) {
	            localStorage.setLastReasonCodes( this.getReasonCodeCollection().pluck('code') );
	        }
	
	        // Only add codes selected since dialog open to the most used
	        // New zones automatically populate those from the last
	        var codesAddedSinceOpen = this.selectedCodesAddedSinceDialogOpen();
	        if ( codesAddedSinceOpen ) {
	            localStorage.setAppliedReasonCodeCounts( codesAddedSinceOpen );
	        }
	
	        if ( resetWithCurrentValuesAfterUpdate ) {
	            this.setSelectedCodeAndFillOnDialogOpen();
	        }
	
	    }
	
	});
	


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var Raphael = __webpack_require__(182),
	    _ = __webpack_require__(49),
	    BaseShape = __webpack_require__(254),
	    ShapeUtils = __webpack_require__(197);
	
	/*
	* 'Coordinate' implies zones peristed in fdd.graphic_object files on EDSTOR.
	*  They are rendered from coordinate/points, unlike Doc Viewer SVG note types.
	* */
	
	module.exports = BaseShape.extend({
	
	    /*
	    * seeThroughFill: 'color' stored in Edstor Zone files
	    * subtype: 'RECTANGLE' or 'POLYGON'; really only applicable for redactions but write to Edstor file for the other types
	    *   - ( highlight, strikeThrough ) for consistency with FDD and future flexibility in case we ever utilize the value
	    *   - note: not used in this app except for persisting to the appropriate file ( it's derived from points ... would have made things
	    *   - much easier if this was passed down to me from the backend in the first place ....
	    * */
	    defaults: function() {
	
	        return _.extend( {}, BaseShape.prototype.defaults.apply( this, arguments ), {
	            points: null,
	            seeThroughFill: null,
	            subtype: null
	        });
	
	    },
	    /*
	    *  TODO: when refactor this to defaults instead ( and move away from parse to constructor --  should be clearer )
	    * */
	    setZoneColorOnParse: function( attrs, options ) {
	
	        var defaultNoteShapeColor = options.parentNote.getDefaultShapeColor();
	
	        var color = !options.isNewlyDrawn
	            ? attrs.seeThroughFill
	                ? attrs.seeThroughFill
	                : defaultNoteShapeColor // ( handle modification of notes with shapes created before seeThroughFill )
	            : defaultNoteShapeColor;
	
	        this.setZoneColor( color );
	
	    },
	
	    getNonPathActiveSVGAttrs: function( canvasChannel ) {
	
	        var attrs = canvasChannel.request( 'getAttributesToApplyToShapeEl', this.parentNote, true, this );
	
	        // TODO: subclass
	        if ( this.isFindAndRedactShape ) {
	
	            attrs['stroke-width'] = 1; // like the smaller stroke width
	            // defaultNoteLevelAttrs['stroke-dasharray'] = '-'; // this is the best but kinda distracting ... may be better to utitlize if selected
	            // eh but could run into conflict ...
	            // maybe no fill at all - this could also help with overlap issue (if that comes back)
	            // green makes red look like watermelon
	            // want different color to distinqush from regular active notes
	            // '#3399FF'; same color as textEditBtn.js -- doesn't look good -- too light
	            attrs.stroke = 'blue';
	
	            // actually I kind of like this ... but it's not as noticable; looks better with dash array and with a consistent border stroke
	            // but don't have no b/c then can't click
	            // defaultNoteLevelAttrs.fill = 'none' -- so you fill opacity
	            // ** side effect is you don't see the 'preview' -- eg if you sent consult color or whatever **
	            //defaultNoteLevelAttrs['fill-opacity'] = 0;
	
	            if ( this.uiModel.get('isHitApplied') ) {
	                attrs.stroke = '#35aa47'; // now same green as apply button
	            }
	            // would need to redo glow on this when change the color's
	        }
	
	        return attrs;
	
	    },
	
	    /*
	    * This applies to non-redaction -- will be overwritten
	    * For now we aren't working with zone color so all will have the same (that's why this is at the note level).
	    * this would apply on here
	    * */
	    getNonPathInactiveSVGAttrs: function( canvasChannel ) {
	
	        return canvasChannel.request( 'getAttributesToApplyToShapeEl', this.parentNote, false, this ); // don't need subtype
	
	    },
	
	    getPathToRenderFromModel: function(scale) {
	        return Raphael.fn.getPathFromPtsArray(
	            this.getAdjustedPointsArray(scale), this.shouldCloseElementPath()
	        );
	    },
	    /*
	    * TODO:
	    *  - will want a current color when the user is able to change it
	    *  - subclass into find and redact
	    *  - could update points of all shapes on move/drag as well
	    * seeThroughFill: normalize hex color values to lowercase just in case
	    * subtype: values map to Java enums; it's ignored in the application but we need to write for FDD client (and should have needed for this app)
	    * */
	    getAttrsToPersist: function(scale) {
	
	        var isFindAndRedact = this.isFindAndRedactShape;
	
	        return {
	
	            points: !isFindAndRedact
	                ? this._getPointsFromEl( scale )
	                : this.get('points'), // points set prior to render and updated on move/resize -- don't get from el
	
	            seeThroughFill: this.getZoneColor().toLowerCase(),
	
	            subtype: !isFindAndRedact
	                ? this.uiModel.raphaelEl().pathIsRect() ? 'RECTANGLE' : 'POLYGON'
	                : 'RECTANGLE' // for now, if we don't let user modify, always rectangle
	
	        };
	
	    },
	    /*
	    * Used to draw and return new raphael el from the existing points in the model.
	    * Scale, adjustment, and rotation taken into account.
	    * Called from renderFromModel.
	    * Note: for now pg is the fullPage model.
	    * */
	    getAdjustedPointsArray: function(scale) {
	
	        return this.pageModel.isCold()
	            ? this._getColdPageAdjustedPointsArray(scale)
	            : this._getImagePgAdjustedPtsArray(scale);
	    },
	
	    // Note: find and redact points are stored at the in 1/10 mm
	    // at the FDD's dpi, not the OCR engine, so conversion to pixels from 1/10th mm
	    // should always use FDD's DPI from the page model.
	    // note: not called for COLD pages but check in place
	    // TODO: maybe put isCold into adjustPtsFromDbToViewer ?
	    _getImagePgAdjustedPtsArray: function(scale) {
	
	        var pg = this.pageModel,
	            isColdPage = pg.isCold();
	
	        return ShapeUtils.adjustPtsFromDbToViewer(
	            this.get('points'),
	            scale,
	            isColdPage ? null : pg.getDPI(),
	            pg.get('rotation'),
	            isColdPage ? null : pg.getOriginalCenter()
	
	        );
	
	    },
	    /*
	    * Always a rectangle, no rotation, conversion constant, polygon redactions.
	    * Cover text coordinate values to pixel values.
	    * TODO: if the point overlap a fraction of a coordinate, need to extend the coordinate ...
	    * */
	    _getColdPageAdjustedPointsArray: function(scale) {
	
	        var pts = this.get('points'),
	            o = this.pageModel.get('overlay');
	
	        return _.map(pts, function(p) {
	            return  {
	                x: (p.x / o.cpi  * 96) * scale,
	                y: (p.y / o.lpi * 96) * scale
	            };
	        });
	
	    },
	    /**
	     * Note: always at FDD's DPI ( vs OCR engine's for find and redact shapes.
	     * If/when we move to storing the coordinates live may no longer be necessary.
	     */
	    _getPointsFromEl: function(scale, pts) {
	
	        var pg = this.pageModel,
	            isCold = pg.isCold();
	
	        return ShapeUtils.adjustPtsFromViewerToDb(
	            !pts ? this.uiModel.raphaelEl().getPathCoordinates() : pts,
	            isCold,
	            scale,
	            isCold ? null : pg.getDPI(),
	            pg.get('rotation'),
	            isCold ? null : pg.getOrigRotatedCenter(), // TODO: have diff fn's to call if page has rotation, and pass in accordingly ... (?) -- or pass 0 if no rotation ...
	            isCold  // break up cold ?
	                ? pg.get('overlay')
	                : undefined
	        );
	
	    }
	
	});

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	     _ = __webpack_require__(49),
	    Raphael = __webpack_require__(182),
	    $ = __webpack_require__(59),
	    ShapeUIModel = __webpack_require__(255),
	    ShapeTransformModel = __webpack_require__(256),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = Backbone.Model.extend({
	
	    ShapeUIModel: ShapeUIModel, // shapeUIModel set on parse; flag on here for subclasses rather than use of factory
	
	    placedOpacity: 1, // the opacity at which the shape should be when placed atop the page/image (differs from the fill-opacity) -- should prob put on shapeUIModel
	
	    hasCustomizableProperties: 0, // flag if the shape type has user customizable zone properties (eg to show an interface in the UI for them -- like a dialog)
	
	    VIEW_SUPPORTS_TRANSFORM: 0, // transitionary refactor
	
	    ALLOW_DRAG_OFF_CANVAS: 0,
	
	
	    constructor: function(attrs, options) {
	
	        delete this.id;   // bypass sync when deleting to avoid error
	        options || (options = {});
	        options.parse = true; // always parse -- these are UI models
	
	        /*
	        *  Note: these are set on parse; put here for definition clarity
	        *  ( don't put in initialize, which is called after parse )
	        * */
	        this.parentNote = null;
	        this.pageModel = null;
	        this.uiModel = null;
	
	        this.transformModel = this.shapeViewSupportsTransforms() ? new ShapeTransformModel() : null;
	
	        /*
	        * zoneColor: the actual color of the zone; what is persisted in the DB and set by color pickers.
	        * It is 'live': for applicable shapes, updated on color picker change.
	        * Not necessarily what is shown in the UI ( it could be overwritten by consult group color, group color -- see canvas.getColorToApplyToShape )
	        * We need to revert to the 'original'/live zone color if any override is removed.
	        * Set on:
	        * 1) model parse: from db or from newly drawn shape
	        * 2) color-picker change when the shape is selected (for applicable note types that support it )
	        * */
	        this.zoneColor = null;
	
	        return Backbone.Model.prototype.constructor.apply(this, arguments);
	
	    },
	
	    /*
	    * Note: this is a fn so can we can reference fvChannel to get the last redaction fill (if not, wiring wouldn't yet be set up
	    * */
	    defaults: function() {
	        return {};
	    },
	
	    /*
	    * When refactor Canvas Module, maybe just handle this in the constructor for more simplicity.
	    * */
	    parse: function( attrs, options ) {
	
	        this.parentNote = options.parentNote;
	        this.pageModel = options.pageModel;
	
	        // Set a unique id that we can use to distinguish and remember between renders
	        // Use cid -- these are UI models
	        // Don't use id -- see comment above for shape.destroy; also can continue to reference unique shapes by cid
	        attrs.uid = this.parentNote.cid + '_' + options.shapeIndexOfNote;
	
	        this.uiModel = new this.ShapeUIModel(
	            _.extend( {}, _.pick( options, 'isActive', 'isExpanded', 'isNewlyDrawn'), {
	                raphaelEl: options.raphaelEl
	            })
	        );
	
	        this.setZoneColorOnParse.apply( this, arguments );
	
	        return attrs;
	
	    },
	
	    setZoneColorOnParse: $.noop,
	
	    /*
	    * The 'shape' attributes to save on the note model gathered from the newly saved shapes.
	    * Called from the shapes collection.
	    * Overwritten but left here for clarity.
	    * */
	    getAttrsToPersist: function() {
	       return {};
	    },
	
	    /*
	    * Can't put on note level 'defaultSVGAttrs' because this is now at the shape level (diff fills can have diff types) !
	    * ( Also now implementing the zone color stored in EDSTOR ).
	    * Larger refactor: move defaultSVGAttributes from the note model to the shape model.
	    * */
	    getNonPathInactiveSVGAttrs: $.noop,
	
	    getNonPathActiveSVGAttrs: $.noop,
	
	    /*
	    * Left for clarity -- always overwritten: get the Raphael path to render from shapeView renderFromModel
	    * */
	    getPathToRenderFromModel: $.noop,
	
	    isChildOfNote: function(note) {
	
	        return note.cid === this.parentNote.cid;
	
	    },
	    getParentNote: function() {
	        return this.parentNote;
	    },
	
	    getZoneColor: function() {
	        return this.zoneColor;
	    },
	
	    setZoneColor: function( color ) {
	        this.zoneColor = color;
	    },
	
	    /*
	    * Returns if the shape's path should be closed / or not (can tell by combo of isRect and note type )
	    * existing: on draw come from imgCanvas allNotes.get(shape.parentNoteId) ? allNotes.get(shape.parentNoteId) :.get('activeNote') -- should change
	    * Not stored; get from the current pts or a new shape w/out them (param)
	    * TODO: still necessary? ... I think area for refactor
	    *
	    * true: rectangles and polygon redactions should close
	    * false: 'free', 'line', 'line-dashed', 'line-arrow'
	    * */
	    shouldCloseElementPath: function(pts, parentNoteType) {
	
	        var isRect = Raphael.fn.isRect( pts || this.get('points') ),
	            pNoteType = parentNoteType ? parentNoteType : this.getParentNote().get('noteType');
	
	        // TODO: should use .isRedactionNote but larger refactor imminent
	        return isRect || ( pNoteType === 'REDACTION_NOTE' || pNoteType === 'FLOATING_REDACTION_NOTE' );
	
	    },
	
	    /*
	    * Used to determine the sub-shape type on click of the base shape view.
	    * el: used for those whose model doesn't yet exist.
	    * TODO:
	    *  - id and use data-type in svg or gd forbid actually help this client by giving storage in the DB.
	    *  - Logic here can be simplified if every note type has it's own shape.
	    * */
	    deriveShapeSubType: function(el) {
	
	        var parentNote = this.getParentNote(),
	            noteType = parentNote ?
	                parentNote.get('noteType')
	                : this.vChannel.request('activeNote').get('noteType'),  // can't just use this.getParentNote; if new not yet added to shapes collection
	            el = el ? el : this.uiModel.raphaelEl(), // can't get if not yet rendered -- so get from canvas Controller (?)
	            subType;
	
	        // TODO: change to using the note model and then functions that encapsulate the enums
	        switch(noteType) {
	
	            case 'SVG_SIGNATURE':
	                subType = 'signature';
	                break;
	
	            case 'GRAPHIC_TEXT_STAMP':
	                subType = 'text_stamp'; // could also use get default subType from the note model ...
	                break;
	            // TODO: would want to use fn here ...isRedactionNote() ... change from switch statement
	            // though if refactoring should handle this another way, eg, custom data-attribute ... need to revisit how this works
	            case 'REDACTION_NOTE':
	            case 'FLOATING_REDACTION_NOTE':
	                subType = el.pathIsRect() ? 'rect' : 'poly';
	                break;
	
	            case 'SVG_GRAPHIC_NOTE':
	                subType = this.determineGraphicNoteShapeSubType(el.attrs);
	                break;
	
	            default:
	                subType = 'rect';
	                break;
	        }
	
	        return subType;
	
	    },
	
	    /**
	     * Return the sub-shape type of a graphic note from attrs.
	     * Attrs are those supported (and in use by the Raphael.js library.
	     * The caller either passes them from an existing DOM element or from those stored in the DB.
	     * All elements are paths.
	     * On baseShape due to legacy architechture --
	     * This design should change -- the placement here is just a small compromise to consolidate
	     * logic that used to exist in 2 places.
	     */
	    determineGraphicNoteShapeSubType: function(attrs) {
	
	        var pathIsRect = Raphael.fn.isRect( Raphael.fn.getPathCoordinates(attrs.path) );
	        var subType;
	
	        // Distinguish rectangles from other types
	        if ( pathIsRect ) {
	
	            // Note: fill-opacity can be a string (DVBC-1478)
	            var fillOpacity = attrs['fill-opacity'];
	            subType = fillOpacity && parseFloat(fillOpacity) === 0
	                ? 'rect-nofill'
	                : 'rect-fill';
	        }
	        else // line is a polygon; only others is free & text
	        {
	            if ( Raphael.fn.pathIsLine( attrs.path ) ) {
	
	                if ( _.has( attrs , 'arrow-end')) {
	
	                    subType = 'line-arrow';
	
	                } else if ( _.has( attrs, 'stroke-dasharray')) {
	
	                    subType = 'line-dashed';
	                } else {
	
	                    subType = 'line';
	                }
	
	            } else if ( _.has( attrs, 'font-family') ) {
	
	                subType = 'text';
	            } else {
	
	                subType = 'free';
	            }
	        }
	
	        return subType;
	
	    },
	
	    getPathToRender: function(scale) {
	        return Raphael.fn.getPathFromPtsArray(
	            this.getAdjustedPointsArray(scale, this.parentNote),
	            this.shouldCloseElementPath()
	        );
	    },
	
	    getHasCustomizableProperties: function() {
	        return this.hasCustomizableProperties;
	    },
	
	
	    shapeViewSupportsTransforms: function() {
	        return this.VIEW_SUPPORTS_TRANSFORM;
	    },
	
	    allowDragOffCanvas: function() {
	        return this.ALLOW_DRAG_OFF_CANVAS;
	    },
	
	    getTransformModel: function() {
	        return this.transformModel;
	    },
	
	    destroy: function() {
	
	        Backbone.Model.prototype.destroy.call(this);
	        this.uiModel.destroy();
	
	    }
	
	});


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	/* Here not to persist attributes with the note */
	var Backbone = __webpack_require__(58);
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        /* set on init */
	        raphaelEl:              null,
	        isActive:               false, // (active, not selected ) is the parent note of the shape the active note in the viewer/canvas
	        isSelected:             false, // (active && selected)
	
	        isMoving:               false,
	        isResizing:             false,
	        isExpanded:             false,
	        isHighlighted:          false,
	        isParentNoteDrawing:    false,
	        isNewlyDrawn:           false, // flag set to true if model created from addNewlyDrawnShape: if renderedFromModel will remain false; basically implies was the shape just drawn / not
	
	        // Find and redact only -- need to subclass but larger project
	        isMouseOverFindAndRedactHitView: false,
	        isHitApplied: false,
	        isDirty: false // if the user moved/resize the shape so it's position is different than the original of the hit
	
	    },
	
	    // DVBC-1762: called on central shape removal --
	    // In current WF, some notes ( now only FPR ) are persisted on the note model
	    // in between canvas render/re-render -- this is a quick fix to make sure they are
	    // always set back to not active or expanded but default before re-rendering the shapes
	    // and handling active/expanded notes.
	    // Longer term approach ( if use for other shape types ) could involve always resetting,
	    // the shape models on the note when they are toggled active/expanded.
	    resetActiveAndExpandedState: function() {
	
	        this.set({
	            isActive: false,
	            isExpanded: false
	        }, {
	            silent: true
	        });
	
	    },
	
	    getCursor: function() {
	        return this.get('raphaelEl').attr('cursor');
	    },
	    setExpanded: function() {
	        this.set({
	            isExpanded: true,
	            isHighlighted: false
	        });
	    },
	    // Shouldn't need anymore -- re-rendering canvas
	    unsetExpanded: function() {
	        this.set({
	            isExpanded: false,
	            isHighlighted: false
	        });
	    },
	    unSelect: function() {
	        this.set({ isSelected: false });
	    },
	    select: function() {
	        this.set({ isSelected: true });
	    },
	    highlight: function() {
	        this.set({ isHighlighted: true });
	    },
	    unhighlight: function() {
	        this.set({ isHighlighted: false });
	    },
	    activate: function() {
	        this.set({
	            isActive: true,
	            isHighlighted: false
	        }, {isEntering: true} );
	    },
	    deactivate: function() {
	        this.set({
	            isActive: false,
	            isHighlighted: false
	        }, {isEntering: false} );
	    },
	    raphaelEl: function() {
	        return this.get('raphaelEl');
	    },
	    getBBoxOfEl: function() {
	      return this.get('raphaelEl').getBBox();
	    },
	    getRaphaelElPaper: function() {
	        var rEl = this.raphaelEl();
	        return !rEl
	            ? null
	            : rEl.paper;
	    },
	
	
	    destroy: function() {
	        this.get('raphaelEl').remove();
	        this.set('raphaelEl', null);
	    }
	
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var ShapePageTransformModel = __webpack_require__(247);
	
	
	var ShapeTransformModel = function() {
	
	    this.ox = 0;
	    this.oy = 0;
	    this.r = 0;
	    this.obox = null;
	
	    // only for Hover Shapes -- could extend -- this are computed as 'rotated'
	    this.dx = 0;
	    this.dy = 0;
	
	    /* Storage of the rotation types for persisting the SVG -- now only in text stamps -- if have more, extend to other objects later */
	    /* Non-view implies not from the page transform */
	    this.nonViewRotateTransform = '';
	    this.nonViewTransform = '';
	    this.textYOffsetTransform = '';
	
	    this.pageTransformModel = new ShapePageTransformModel();
	
	    return this;
	
	};
	
	
	
	_.extend( ShapeTransformModel.prototype, {
	
	    initializePageValues: function( pageModel, scale ) {
	        this.pageTransformModel.initializeValues( pageModel, scale );
	        return this;
	    },
	
	    setRotation: function( rotation ) {
	        this.r = rotation;
	    },
	
	    getRotation: function() {
	        return this.r;
	    },
	
	    getPageModel: function() {
	        return this.pageTransformModel;
	    },
	
	    getOBox: function() {
	        return this.obox;
	    },
	
	    setOBox: function( box ) {
	        this.obox = box;
	    },
	
	    setDx: function( dx ) {
	        this.dx = dx;
	    },
	
	    getDx: function( ) {
	        return this.dx;
	    },
	
	    setDy: function( dy ) {
	        this.dy = dy;
	    },
	
	    getDy: function() {
	        return this.dy;
	    },
	
	    setOx: function( ox ) {
	        this.ox = ox;
	    },
	
	    getOx: function() {
	        return this.ox;
	    },
	
	    setOy: function( oy ) {
	        this.oy = oy;
	    },
	
	    getOy: function() {
	        return this.oy;
	    },
	
	    getNonViewRotateTransform: function() {
	        return this.nonViewRotateTransform;
	    },
	
	    setNonViewRotateTransform: function( transform ) {
	        this.nonViewRotateTransform = transform;
	    },
	
	    getNonViewTransform: function() {
	        return this.nonViewTransform;
	    },
	    setNonViewTransform: function( transform ) {
	        this.nonViewTransform = transform;
	    },
	
	    getTextYOffsetTransform: function() {
	        return this.textYOffsetTransform;
	    },
	
	    setTextYOffsetTransform: function( transform ) {
	        this.textYOffsetTransform = transform;
	    }
	
	});
	
	
	
	module.exports = ShapeTransformModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var ReasonCodeCollection = __webpack_require__(80);
	
	
	module.exports = ReasonCodeCollection.extend({
	
	     // Not for displaying available in order ... this guarantees uniqueness in floating code redactions
	    comparator: function(rc) {
	        return rc.get('code').toLowerCase();
	    },
	
	
	    // If want to wrap text use '\n' as delimiter
	    // note: already sorted via the comparator
	    getCodesAsString: function( delimeter ) {
	        return this.pluck('code').join( delimeter ? delimeter : '' );
	    }
	
	
	});

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var RedactionShapeModel = __webpack_require__(252),
	    CodeBoxModel = __webpack_require__(249),
	    ConnectionModel = __webpack_require__(250),
	    ShapeUtils = __webpack_require__(197);
	
	
	module.exports = RedactionShapeModel.extend({
	
	    /**
	     * isBoxDirty
	     * - now only require for Find and Redact
	     * - true if codes changed, box moved, box resized
	     * Must to be in constructor, not initialize, b/c of sub shapes
	     * Obvious candidate for Find and Redact sub-classing
	     */
	    constructor: function() {
	
	        this.isBoxDirty = false;
	        RedactionShapeModel.prototype.constructor.apply( this, arguments );
	
	    },
	    /*
	    * seeThroughFillOpacity:
	    *   - Write just in case; not applicable to FDD zone redactions since this value can't be stored.
	    *   - Now no option exist for user to change it
	    *   - Should store this on shape, not note model
	    *   - Read in but never applied ... with current infrastructure (need to move color attrs to shapes )
	    * */
	    defaults: function() {
	
	        return _.extend( {} , RedactionShapeModel.prototype.defaults.apply(this, arguments), {
	            box: null,
	            connection: null,
	            seeThroughFillOpacity: this.parentNote.getDefaultFillOpacity()
	        });
	
	    },
	
	    /**
	     * seeThroughFillOpacity is read in but never applied; any value is ignored for the default; would need to change arch for that.
	     * options.onlySetBoxAndConnection: another temporary F&R POC
	     */
	    parse: function( attrs, options ) {
	
	        if ( options && !options.onlySetBoxAndConnection )
	        {
	            attrs = RedactionShapeModel.prototype.parse.apply(this, arguments);
	        }
	
	        attrs.box &&
	            ( this.box = new CodeBoxModel( attrs.box) );
	
	        attrs.connection &&
	            ( this.connection = new ConnectionModel( attrs.connection ) );
	
	        return _.omit(attrs, 'box', 'connection');
	    },
	
	    /*
	    * Augment the base with box, connection, and seeThroughFillOpacity.
	    * */
	    getAttrsToPersist: function( scale ) {
	
	        /*
	        * While blocked in the UI, emphasize that this model will never on exist on COLD pages,
	        * and that we don't need to include calculations for that page type here.
	        * If this ever changes, will need to adjust code accordingly.
	        * */
	        if ( this.pageModel.isCold() )
	            return;
	
	
	        /*
	         * seeThroughFillOpacity:
	         * - doesn't apply to the base coordinate shape so apply here whether there are reason codes applied / not.
	         * - need to change arch to use this.get('seeThroughFillOpacity') ... this would not necessarily be correct ( but for now should never change )
	         */
	        var attrs = _.extend( {}, RedactionShapeModel.prototype.getAttrsToPersist.apply(this, arguments) , {
	                box: null,
	                connection: null,
	                seeThroughFillOpacity: this.parentNote.getDefaultFillOpacity()
	            }),
	            reasonCodesCollection = this.getReasonCodeCollection();
	
	
	        if (reasonCodesCollection.length < 1)
	            return attrs;
	
	        /*
	        * It has reason codes, get the box and connection from the 'controller' stored on the parent note model;
	        * Use attributes stored (that could later be changed) from that on the box and connection models,
	        * except for the points: get them from the actual Raphael el's like doing for all other shapes.
	        * ( Alternative would be updating the coordinates of each on every change ).
	        * */
	        var floatingCodesController = this.parentNote.floatingCodesController,
	            uniqueCodeStr = reasonCodesCollection.getCodesAsString(),
	            codesView = floatingCodesController.getCodeViewOfUniqueCodeString( uniqueCodeStr ),
	            shapeView = floatingCodesController.getShapeViewByShapeModel(this),
	            connectionLine = shapeView.connection.line,
	            codeUIModel = codesView.model,
	            boxModelAttrs = codeUIModel.getBoxModel().toJSON(),
	            connectionModelAttrs = codeUIModel.getConnectionModel().toJSON();
	
	        boxModelAttrs.points =
	            ShapeUtils.adjustPtsFromViewerToDbNoTransform( codesView.el.getPathCoordinates(), this.pageModel.getDPI() );
	
	        // Note: use the 'old' method for the connection pts (it doesn't have transforms applied )
	        connectionModelAttrs.points =
	            this._getPointsFromEl( scale, connectionLine.getPathCoordinates() );
	
	        _.extend( attrs, {
	            box:  boxModelAttrs,
	            connection: connectionModelAttrs
	        });
	
	        return attrs;
	
	    },
	
	    /*
	    * Could also point on the box but this is working and simpler.
	    * If start using other shape typea that don't do transforms, will prob want a mixin, util fn for them.
	    * TODO: these type of redactions are now not supported on COLD pages
	    * */
	    getAdjustedBoxPts: function() {
	
	        return this.pageModel.isCold()
	            ? RedactionShapeModel.prototype._getColdPageAdjustedPointsArray(1) // just call the original with a scale of 1 ( no transform) TODO: test
	            : ShapeUtils.adjustPtsFromDbToViewerWithoutTransform( this.getBox().getPoints() , this.pageModel.getDPI() );
	
	    },
	
	    getBox: function() {
	        return this.box;
	    },
	    getConnection: function() {
	        return this.connection;
	    },
	
	    /**
	     * POC -- Used for Find and Redact.
	     * ( Another candidate for shape sub-classing ).
	     * Now only used for floating codes -- --- may prove helpful for other shapes (if we allow to move points, eg )
	     * Remember on page change, save if not from hidden canvas -- so the box can be positioned correctly on re-entry.
	     * Set the saved attributes on the now contrived shape model.
	     * Some may be redundant if we save as we go -- ! at least we need box ( and connection ?) !
	     */
	    updateShapeAttributes: function( scale ) {
	
	        var attrsToSave =  this.getAttrsToPersist( scale ); // points not taken from el
	
	        this.set( attrsToSave, {silent: true} ); // ( Silent just in case )
	
	        // Setting the attributes isn't enough -- the box, connection attributes must to be set
	        // to create the box and connection objects -- which aren't attributes but instance variables; these are set on parse
	        // I suppose only really need to update the box and the connection -- now we don't need the points
	        this.parse( this.attributes, {
	            onlySetBoxAndConnection: 1
	        } );
	
	    },
	
	    /* Now only used for Find and Redact */
	    setBoxIsDirty: function( isDirty ) {
	        this.isBoxDirty = isDirty;
	    },
	
	    getBoxIsDirty: function() {
	        return this.isBoxDirty;
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                <tr>\n                    <td>url:</td>\n                    <td>\n                        <div class=\"pg-info-max-width-cell\">\n                            <a href=\""
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "\" title=\""
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "\" target=\"_blank\">"
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "</a>\n                        </div>\n                    </td>\n                </tr>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <table class=\"tbl-page-info tbl-two-cell tbl-secondary-info\">\n            <tbody>\n                <tr>\n                    <td>compression:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.originalImageProperties : depth0)) != null ? stack1.compression : stack1), depth0))
	    + "</td>\n                </tr>\n\n                <tr>\n                    <td>width:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.originalImageProperties : depth0)) != null ? stack1.width : stack1), depth0))
	    + "</td>\n                </tr>\n\n                <tr>\n                    <td>height:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.originalImageProperties : depth0)) != null ? stack1.height : stack1), depth0))
	    + "</td>\n                </tr>\n\n                <tr>\n                    <td>horizontal dpi:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.originalImageProperties : depth0)) != null ? stack1.originalHDPI : stack1), depth0))
	    + "</td>\n                </tr>\n\n                <tr>\n                    <td>vertical dpi:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.originalImageProperties : depth0)) != null ? stack1.originalVDPI : stack1), depth0))
	    + "</td>\n                </tr>\n            </tbody>\n        </table>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <table class=\"tbl-page-info tbl-two-cell tbl-secondary-info\">\n            <tbody>\n                <tr>\n                    <td>file:</td>\n                    <td>\n                        <div class=\"pg-info-max-width-cell\" title=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.filename : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.filename : stack1), depth0))
	    + "</div>\n                    </td>\n                </tr>\n                <tr>\n                    <td>path:</td>\n                    <td>\n                        <div class=\"pg-info-max-width-cell\" title=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.pathname : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.pathname : stack1), depth0))
	    + "</div>\n                    </td>\n                </tr>\n                <tr>\n                    <td>size:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.size : stack1), depth0))
	    + "</td>\n                </tr>\n            </tbody>\n        </table>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <table class=\"tbl-page-info tbl-two-cell tbl-two-cell-compact tbl-secondary-info\">\n            <tbody>\n                <tr>\n                    <td>overlay id:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.overlayId : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>font:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.fontName : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>font size:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.fontSize : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>cpi:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.cpi : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>lpi:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.lpi : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>xoffset:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.xTextOffset : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>yoffset:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.yTextOffset : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>width:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.paperWidth : stack1), depth0))
	    + "</td>\n                </tr>\n                <tr>\n                    <td>height:</td>\n                    <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.overlay : depth0)) != null ? stack1.paperHeight : stack1), depth0))
	    + "</td>\n                </tr>\n            </tbody>\n        </table>\n\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <div class=\"pg-info-reason-codes-wr\">\n        <span class=\"pg-info-reason-codes-header\">Reason Codes:</span>\n        <span class=\"pg-info-reason-codes\">"
	    + container.escapeExpression(((helper = (helper = helpers.nonFullPgReasonCodeStr || (depth0 != null ? depth0.nonFullPgReasonCodeStr : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"nonFullPgReasonCodeStr","hash":{},"data":data}) : helper)))
	    + "</span>\n    </div>\n\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <div class=\"pg-info-reason-codes-wr\">\n        <span class=\"pg-info-reason-codes-header\">Full Page Reason Codes:</span>\n        <span class=\"pg-info-reason-codes\">"
	    + container.escapeExpression(((helper = (helper = helpers.fullPageReasonCodesStr || (depth0 != null ? depth0.fullPageReasonCodesStr : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fullPageReasonCodesStr","hash":{},"data":data}) : helper)))
	    + "</span>\n    </div>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"pg-info-table-row-wr\">\n\n    <h5 class=\"pgInfoPgHeader\">Page "
	    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
	    + "</h5>\n\n    <table class=\"tbl-page-info tbl-two-cell tbl-primary-info\">\n        <tbody>\n            <tr>\n                <td>page id:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.pageId || (depth0 != null ? depth0.pageId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pageId","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>document id:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.docId || (depth0 != null ? depth0.docId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docId","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n\n            <tr>\n                <td>type:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.pageType || (depth0 != null ? depth0.pageType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pageType","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.url : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            <tr>\n                <td>created by:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.createdBy || (depth0 != null ? depth0.createdBy : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"createdBy","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>created on:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.createdOn || (depth0 != null ? depth0.createdOn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"createdOn","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>server:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.server || (depth0 != null ? depth0.server : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"server","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>offset:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.optOffset || (depth0 != null ? depth0.optOffset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"optOffset","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>volume:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.optVolume || (depth0 != null ? depth0.optVolume : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"optVolume","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>side:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.optSide || (depth0 != null ? depth0.optSide : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"optSide","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>offset in record:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.optRecordOffset || (depth0 != null ? depth0.optRecordOffset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"optRecordOffset","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n\n        </tbody>\n\n    </table>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showOriginalImageInfo : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showGOSInfo : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showOverlayInfo : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>\n\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasNonFullPageReasonCodes : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hasFullPageReasonCodes : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n\n\n\n";
	},"useData":true});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"pageInfo\">\n    <div id=\"pgInfoWr\">\n        <h3 id=\"pgInfoModalHeader\">\n            <span class=\"icon-doc-text-1\"></span>\n            Page Information\n        </h3>\n        <ul class=\"pg-info-tbl-wr\"></ul>\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {__webpack_require__(262);
	
	var Modal = __webpack_require__(110),
	    _ = __webpack_require__(49);
	
	__webpack_require__(71);
	
	
	module.exports = Modal.extend({
	
	    contentTemplate: __webpack_require__(263),
	
	    initialize: function( options ) {
	
	        Modal.prototype.initialize.call( this, _.extend( {}, options, {
	            content: this.contentTemplate(
	                this.serializeContentTemplateData( options.docModel, options.docLockStatus )
	            ),
	            hideFooter: true
	        }) );
	
	        return this;
	    },
	
	    serializeContentTemplateData: function( docModel ) {
	
	        var userLock = docModel.get('userLock'),
	            mtime =  moment.convertDBTimeToLocalTime( docModel.get('modifyTime') ),
	            context = {
	                docID: docModel.getId(),
	                ctime: moment.convertDBTimeToLocalTime( docModel.get('creationTime') ),
	                mtime: mtime,
	                docIsLocked: userLock !== null
	            };
	
	
	        if (userLock) {
	
	            var userLockDescription = docModel.get('userDesc');
	
	            _.extend( context, {
	                lockUser: userLockDescription // ( user description can be null )
	                    ? userLockDescription
	                    : userLock,
	                lockTime: mtime
	            });
	        }
	
	        return context;
	
	
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ },
/* 262 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <tr>\n                <td class=\"userLock\">\n                    <span class=\"lockIcon\" title=\"\">\n                        <i class=\"icon-lock-1\"></i>\n                    </span>\n                </td>\n                <td>\n                    <b>"
	    + alias4(((helper = (helper = helpers.lockUser || (depth0 != null ? depth0.lockUser : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lockUser","hash":{},"data":data}) : helper)))
	    + "</b>\n                    "
	    + alias4(((helper = (helper = helpers.lockTime || (depth0 != null ? depth0.lockTime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"lockTime","hash":{},"data":data}) : helper)))
	    + "\n                </td>\n            </tr>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div id=\"dd-docInfo\">\n    <div class=\"dd-head\">\n        <span class=\"dd-icon icon-doc\"></span>\n        Document Information\n    </div>\n    <table id=\"FV-info\" class=\"tbl-two-cell\" >\n        <tbody>\n            <tr>\n                <td>document id:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.docID || (depth0 != null ? depth0.docID : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docID","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>created:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.ctime || (depth0 != null ? depth0.ctime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ctime","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n            <tr>\n                <td>modified:</td>\n                <td>"
	    + alias4(((helper = (helper = helpers.mtime || (depth0 != null ? depth0.mtime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"mtime","hash":{},"data":data}) : helper)))
	    + "</td>\n            </tr>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.docIsLocked : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </tbody>\n    </table>\n</div>";
	},"useData":true});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(265);
	
	var Modal = __webpack_require__(110),
	    Util = __webpack_require__(48);
	
	/*
	 * TODO: common code here for the modals, ew, should have new widget
	 */
	
	module.exports = Modal.extend({
	
	    baseModalDefaults: {
	        hideFooter: true
	    },
	
	    contentTemplate: __webpack_require__(266),
	
	    /*
	    * Complete Fetched userModel, authModel, versionModel required.
	    * */
	    initialize: function( options ) {
	
	
	        this.settings = _.extend( {}, {
	            content: this.contentTemplate(
	                this.serializeContentTemplateData( options.versionModel, options.userModel, options.authModel )
	            )
	        }, options );
	
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );
	
	        return this;
	    },
	
	
	    serializeContentTemplateData: function( versionModel, userModel, authModel ) {
	
	        var frig = __webpack_require__(267), // may want to preload this or require once ... maybe use CSS / base64 image (?)
	            userName = userModel.getUserName(),
	            userDescription = userModel.getUserDescription(),
	            userNameOrDescription = userDescription
	                ? userDescription
	                : userName,
	            userGroupOfDerivedColor = userModel.getGroupOfDerivedUserColor();
	
	        return {
	
	            frigImageUrl: frig,
	
	            clientVersion: versionModel.getVersion(),
	            clientDate: versionModel.getFormattedDate(),
	            dvServicesVersion: versionModel.servicesModel.getVersion(),
	            dvServicesDate: versionModel.servicesModel.getBuild(),
	            creVersion: versionModel.creServiceModel.getVersion(),
	            creDate: versionModel.creServiceModel.getBuild(),
	            copyRightDate: versionModel.getCopyRightDate(),
	
	            userNameOrDescription: userNameOrDescription,
	            userNameAndDatabase: userName + '@' + authModel.getDataService(), // (eg: ben@fdd92_pecan )
	
	            userDerivedDrawingColor: userGroupOfDerivedColor
	                ? userGroupOfDerivedColor.getColor()
	                : null,
	
	            userDerivedColorGroupName: userGroupOfDerivedColor
	                ?  userGroupOfDerivedColor.getName()
	                : null,
	
	            userDeriveDrawingColorTitle: userGroupOfDerivedColor
	                ? 'Drawing color derived from membership in group ' + userGroupOfDerivedColor.getName()
	                : null
	
	
	        };
	
	
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 265 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div id=\"FV-about-color-square\" style=\"background:"
	    + alias4(((helper = (helper = helpers.userDerivedDrawingColor || (depth0 != null ? depth0.userDerivedDrawingColor : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userDerivedDrawingColor","hash":{},"data":data}) : helper)))
	    + ";\" title=\""
	    + alias4(((helper = (helper = helpers.userDeriveDrawingColorTitle || (depth0 != null ? depth0.userDeriveDrawingColorTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userDeriveDrawingColorTitle","hash":{},"data":data}) : helper)))
	    + "\"></div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div id=\"FV-about\">\n\n    <div id=\"FV-about-title\">\n        <img id=\"FV-frig-about-img\" src=\""
	    + alias4(((helper = (helper = helpers.frigImageUrl || (depth0 != null ? depth0.frigImageUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"frigImageUrl","hash":{},"data":data}) : helper)))
	    + "\">\n        Feith Document Viewer\n    </div>\n\n    <div id=\"FV-about-content\">\n\n        <div id=\"FV-about-version-info\">\n\n            <div class=\"FV-version-row\">\n                <div class=\"about-subtitle\">Browser Client</div>\n                <div class=\"version\">Version "
	    + alias4(((helper = (helper = helpers.clientVersion || (depth0 != null ? depth0.clientVersion : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"clientVersion","hash":{},"data":data}) : helper)))
	    + "</div>\n                <div class=\"version-date\">"
	    + alias4(((helper = (helper = helpers.clientDate || (depth0 != null ? depth0.clientDate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"clientDate","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n\n            <div class=\"FV-version-row\">\n                <div class=\"about-subtitle\">Viewer Services</div>\n                <div class=\"version\">Version "
	    + alias4(((helper = (helper = helpers.dvServicesVersion || (depth0 != null ? depth0.dvServicesVersion : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dvServicesVersion","hash":{},"data":data}) : helper)))
	    + "</div>\n                <div class=\"version-date\">"
	    + alias4(((helper = (helper = helpers.dvServicesDate || (depth0 != null ? depth0.dvServicesDate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dvServicesDate","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n\n            <div class=\"FV-version-row\">\n                <div class=\"about-subtitle\">Central Rendering Engine</div>\n                <div class=\"version\">Version "
	    + alias4(((helper = (helper = helpers.creVersion || (depth0 != null ? depth0.creVersion : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"creVersion","hash":{},"data":data}) : helper)))
	    + "</div>\n                <div class=\"version-date\">"
	    + alias4(((helper = (helper = helpers.creDate || (depth0 != null ? depth0.creDate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"creDate","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n\n        </div>\n\n        <div id=\"FV-about-user-section\">\n\n            <div id=\"FV-about-user-col-1\">\n                <div id=\"FV-about-user-icon-circle\" title=\""
	    + alias4(((helper = (helper = helpers.userNameOrDescription || (depth0 != null ? depth0.userNameOrDescription : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userNameOrDescription","hash":{},"data":data}) : helper)))
	    + "\">\n                    <i id=\"FV-about-user-icon\" class=\"icon-user-1\"></i>\n                </div>\n            </div>\n\n            <div id=\"FV-about-user-col-2\">\n\n                <div id=\"FV-about-user-info\">\n\n                    <div id=\"FV-about-user-common\">\n\n                        <div class=\"FV-about-user-item\">"
	    + alias4(((helper = (helper = helpers.userNameOrDescription || (depth0 != null ? depth0.userNameOrDescription : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userNameOrDescription","hash":{},"data":data}) : helper)))
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.userDerivedDrawingColor : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                        </div>\n\n                        <div class=\"FV-about-user-item\">"
	    + alias4(((helper = (helper = helpers.userNameAndDatabase || (depth0 != null ? depth0.userNameAndDatabase : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"userNameAndDatabase","hash":{},"data":data}) : helper)))
	    + "</div>\n\n                    </div>\n\n\n                </div>\n\n            </div>\n\n\n        </div>\n\n    </div>\n\n\n    <div id=\"FV-about-legalInfo\">\n        &copy "
	    + alias4(((helper = (helper = helpers.copyRightDate || (depth0 != null ? depth0.copyRightDate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"copyRightDate","hash":{},"data":data}) : helper)))
	    + " Feith Systems and Software, Inc. All Rights Reserved\n    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "01dfd42ee33e76b22e99cf38d30e1a6a.png";

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    BasePage = __webpack_require__(269),
	    DocModePage = __webpack_require__(344),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * Should have all notes collection or mediate fns w/vChannel.
	 * TODO:
	 * - everything 'renderable GOS' could be removed from here (anything involving originalImageProperties) and subclassed for clarity (?)
	 * - also subclassing of the page types would make more flex and maintanable ...
	 */
	
	
	
	var DEFAULT_COLD_OVERLAY_DIMENSIONS = {
	    width: 8.5,
	    height: 11
	};
	
	module.exports = BasePage.extend({
	
	    typeIdentifier: 'PG_MODE',
	    SPIN_JS_OPTS: { top: '40px', left: '60px', length: 6, radius: 6, width: 2, lines: 13 },
	    nonRenderableOrigDimensions: BasePage.prototype.STANDARD_PG_DIMS,
	    defaults: _.omit( DocModePage.prototype.defaults, 'vOffset)' ),
	
	    parse: function( pageAttrs, options ) {
	
	        pageAttrs = _.clone(pageAttrs);
	
	        /**
	         * If COLD: convert original image properties from inches to pixels -- adjusting the original,
	         *  -- essentially indicating this has known dimensions  -- that of the paper.
	         * But now with the default overlay page dimensions set at 0x0, in a sense this also has 'unknown' dimensions ( below ).
	         */
	        if ( this._pageTypeIsCold(pageAttrs.pageType) ) {
	
	            // Set the derived attributes differently.
	            // Note: these will change on load.
	            var dpi = fvChannel.request('settings').DPI;
	            var paperWidth = pageAttrs.overlay.paperWidth;
	            var paperHeight = pageAttrs.overlay.paperHeight;
	
	
	            /**
	             *  DVBC-1820: handling 0 x 0 page sizes -- to temporary allow for a loading 'placeholder'.
	             *  Ideally would want to set immediately to the 'derived' size that it will become,
	             *  which can be determined when we get the text; however, we can't introduce
	             *  something asynchronous into this WF.
	             *  If needed, could put a flag on the here or the doc mode model.
	             *  Initially only did if there was no image overlay, but not longer -- do for both.
	             *  If there is an image overlay, the paper size will be set according to the the derived text dimensions --
	             *  this is different behavior than FDD, which wouldn't show the image.  If we want to do that,
	             *  we shouldn't request the image at all and create a different WF.
	             *  If there is not an overlay, it will be set according to FDD's logic,
	             *  which would also set to the derived text dimensions since the derived text would always exceed the bounds.
	             */
	
	            if (paperWidth === 0) {
	                paperWidth = DEFAULT_COLD_OVERLAY_DIMENSIONS.width;
	            }
	
	            if (paperHeight === 0) {
	                paperHeight = DEFAULT_COLD_OVERLAY_DIMENSIONS.height;
	            }
	
	
	            var derivedAttrs = {
	                width: paperWidth * dpi,
	                height: paperHeight * dpi,
	                isRenderable: true,
	                parentDocument: options.parentDocument,
	                imageFileType: options.imageFileType
	            };
	
	
	            return _.extend (pageAttrs, derivedAttrs );
	
	        } else {
	
	            /* normal not cold */
	
	            return  _.omit( BasePage.prototype.parse.apply(this,arguments), 'vOffset' );
	        }
	
	    },
	
	
	    /**
	     * TODO: don't call this 'setWidth', here it's dynamic (???)
	     */
	    _getSetWidth: function( attrs, isRenderable ) {
	
	        if (!isRenderable)
	            return this.nonRenderableOrigDimensions.w;
	
	        return attrs.originalImageProperties
	            ? attrs.originalImageProperties.width
	            : this.unknownOrigDimsDimensions.w;
	
	    },
	
	    /**
	     * Really the derived height from the original width of the image and that width of it's container
	     * Now same as docMode except we don't adjust for container size ...
	     * TODO: here height is now not dervied from width ...
	     */
	    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {
	
	        // Note: this top part is resuable with pgDocMode
	        if (!isRenderable)
	            return this.nonRenderableOrigDimensions.h;
	
	        return attrs.originalImageProperties
	            ? attrs.originalImageProperties.height
	            : this.unknownOrigDimsDimensions.h;
	
	
	    },
	
	    getImgRenderRequest: function() {
	
	        // Now loading GOS in full page mode as PDFs inside iframes
	        // I think image parameters are on here unecessarily, should probably
	        // change that on nonImgRenderRequest, but don't want to break anything
	
	        if ( this.isGOS() ) {
	            var req = BasePage.prototype.nonImgRenderRequest.apply(this, ['pdf', 'pdf']);
	            return req;
	        }
	
	        // Same as the request from base but without the width parameter
	        var request = BasePage.prototype.getImgRenderRequest.call(this);
	        delete request.renderRequest.renderingParameters.imageParameters;
	        return request;
	    },
	
	    /* In this mode COLD page dimensions are known and defined from the 'paper' ( above ) */
	    resizePageFromDummyDimensionsPostLoad: function() {
	
	        if ( this.isCold() )
	            return false;
	
	        return BasePage.prototype.resizePageFromDummyDimensionsPostLoad.apply( this, arguments );
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	/**
	 * Should start subclassing the pages by type (eg GOS).
	 * Would probably want to create from factory -- though for time being may be simpler with
	 * conditional statements in here.
	 */
	
	
	var Backbone = __webpack_require__(58),
	    Util = __webpack_require__(48),
	    ViewerSettings = __webpack_require__(99),
	    PageNotes = __webpack_require__(270),
	    PgNameXref = __webpack_require__(343),
	    ShapeUtils = __webpack_require__(197),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	// put standard dims on viewer settings ...
	// where did these numbers come from? (8.5 x 11 ?)
	var STANDARD_PG_DIMS = {
	    h: 2244,
	    w: 1728
	};
	
	
	module.exports = Backbone.Model.extend({
	
	  /*  TODO:
	   *divide into ui, non ui - REALLY NEED TO CREATE A CHILD UI MODEL FOR THE NON SERVER ATTRIBUTES
	    * clear up terminology: eg  WHAT THE WIDTH AND HT VALUES MEAN
	 * */
	    STANDARD_PG_DIMS: STANDARD_PG_DIMS,
	    unknownOrigDimsDimensions: STANDARD_PG_DIMS,
	    SPIN_JS_OPTS: { top: '15%', length: 6, radius: 6, width: 2, lines: 13 }, //the default, should always be overwritten by subclasses
	
	
	    /**
	     * isRenderable:
	     * - refers to whehter a page is renderable ( will be shown in viewer ); does not imply GOS or has unknown dimensions
	     * - set on init -- based off file ext --- if gos and not a valid file extension
	     * DVBC-1423:
	     * - make defaults a function so the new notes collection is a different instance when extended by the other page models
	     * - cleaner than setting on init/parse b/c the full page model on viewer.state is recreated on each page change
	     * TODO:
	     *  - put only the server attributes here
	     *  - make these other ones instance variables
	     * Note: server attribute rotation
	     *  - this can now be different from the value in the DB with users who lack rotation permission.
	     *  - it's set on fetch, when rotation changes, and overwritten on viewer reset / open new window functionality
	     *  - for now not storing the original and a different value
	     *  - The viewer is now handling everything with 0 rotation and then displaying/exporting with an adjustment for the rotation
	     */
	    defaults: function() {
	
	        return {
	
	            isRenderable: true,
	            number: 0,
	
	            /* height and width always in pixels (cold pages original attributes may be in inches) */
	            /* now unscaled and unrotated -- the could be 'derived' in the case doc mode and thumbnails  */
	            width: 0,
	            height: 0,
	
	            /*  TODO: vOffset: -- its set when used ...
	                 the thresholds to change page for scrolling up / down in doc-mode-container:
	                 (pgHeight * scale) + vPadding (of current page plus all those above it)
	                 really the scroll top position of the top of the next element in the scrolling container (including padding)
	             /* now init'd by get set width, getHeight derived from width
	
	             /* would also equal the size of the el for the pg, which includes padding */
	
	            parentDocument: null,
	            imageFileType: null,
	
	            textGridModel: null, /* exclusive exclusive to COLD pages -- we cache once fetched -- area for subclass */
	
	            // ensure notesCollection is never null for ease in adding/setting if it doesn't yet exist
	            // if any notes exist for the page, a new collection is set in the viewer loading WF in the document model
	            notesCollection: new Backbone.Collection() ,
	
	            /* states*/
	            wasRequested: false, /* request to sent to CRE */
	            isLoaded: false,
	            loadError: false // Set to true there was an error loading the page. TODO -- should be null for no error, or the error message itself
	
	        };
	
	    },
	
	
	    /**
	     * Note: page number set in collection parse.
	     * TODO:
	     * - move all to constructor for simplicity in the use of attr value and .get,
	     *  and get rid of _isPageType( attr ) fns
	     */
	    parse: function( pageAttrs, options ) {
	
	        var isRenderable = this._isRenderable( pageAttrs.gosInfo, pageAttrs.pageType );
	
	        /*
	         * Would be clearer if get orig dims to render ...
	         * height and width are either from the model, unrenderableOriginalDimensions, or unknownOrigDimsDimensions.
	         * These would be the 'placeholder' dimensions when first rendered pre-image load.
	        */
	
	        // Note: getSetWidth also used in above calc (and requires fn param set in constructor)
	        // TODO:
	        // - These are probably better set on the constructor, not parse
	        // - make functions for .get('height'), 'width') to make references easier to find and change
	        // note: these are 'derived' in a sense ... they aren't the actual (eg can be requested at a smaller aspect ratio )
	        // maybe need to take both into account
	
	        var derivedAttrs = {
	
	            height: this._getHeightDerivedFromWidth( pageAttrs, isRenderable ),
	            width: this._getSetWidth( pageAttrs, isRenderable ),
	
	            isRenderable: isRenderable,
	            parentDocument: options.parentDocument,
	            imageFileType: options.imageFileType
	
	        };
	
	
	        return _.extend( pageAttrs, derivedAttrs );
	
	    },
	    /*
	    *   Only called on parse (not yet set).
	    *   Renderable pages' are not GOS or GOS with a valid file extension.
	    *   DVBC-1476 -- now considering multi pg GOS types unrenderable.
	    *   Note -- Url Pages: these are renderable except in PDF mode (which will show an unrenderable view --
	     *  so they are considered renderable ...  this is somewhat hacky.
	     *  DVBC-1704 - TODO: ultimately should do a larger refactor where URL pages aren't considered renderable.
	    * */
	    _isRenderable: function(gosInfo, pageType) {
	
	        if ( this._pageTypeIsMultipartGos(pageType) )
	            return false;
	
	        return !gosInfo
	            ? true
	            : _.contains( ViewerSettings.prototype.renderableFileExts,  Util.getFileExtension( gosInfo.filename).toUpperCase() );
	    },
	
	    isRenderable: function() {
	        return this.get('isRenderable');
	    },
	    // Add the the below clause or clause to allow rotation of GOS 'image' types; waiting on DOCVIEW-98
	    //      || ( this.isGOS() && this._hasImageTypeFileExtension() );
	    isRotatable: function() {
	        return this.isFddImage() && !this.imgLoadFailed();
	    },
	
	    _pageTypeIsGOS: function(type) {
	        return type === 'FDD_GOS_TYPE';
	    },
	    // http://maven.feith.com/feith/data-services/blob/DEVELOPMENT/Common/src/main/java/com/feith/dataservices/common/objects/storage/FddObjectType.java
	    // types where isCold is true
	    _pageTypeIsCold: function(type) {
	        return type.indexOf('COLD') > -1 || type === 'FDD_UTF8_TEXT_OPTREC' || type === 'FDD_UTF8_COMPRESS_OPTREC';
	    },
	    _pageTypeIsURL: function(type) {
	        return type === 'FDD_URL_OPTREC';
	    },
	    _pageTypeIsFormsIQ: function(type) {
	        return type === 'FDD_FORMSIQ_OPTREC';
	    },
	    _pageTypeIsParsedEmail: function(type) {
	        return type === 'FDD_EML_V2_OPTREC' || type === 'FDD_EML_OPTREC';  /* note: Tom says now treating email the same as parsed email */
	    },
	    _pageTypeIsFddImage: function(type) {
	        return type === 'FDD_IMAGE_TYPE';
	    },
	    _pageTypeIsWindowsText: function(type) {
	        return type === 'FDD_CF_TEXT_OPTREC';
	    },
	    _pageTypeIsMultipartGosSkeleton: function(type) {
	        return type === 'FDD_GOS_TOC_OPTREC';
	    },
	    // These should never really exist in Doc Viewer -- can't be requested as a document,
	    // and are only used to comprise the Skeleton.
	    _pageTypeIsMultipartGosPart: function(type) {
	        return type === 'FDD_GOS_V3_OPTREC';
	    },
	
	    // Type 22 & 23 respectively
	    _pageTypeIsMultipartGos: function(type) {
	        return this._pageTypeIsMultipartGosSkeleton(type) || this._pageTypeIsMultipartGosPart(type);
	    },
	
	    isFddImage: function() {
	        return this._pageTypeIsFddImage( this.get('pageType') );
	    },
	    /* Note: Old applications may have never have written this gosInfo attr to DB -- it can be NULL, resulting in errors --  can use this to check instead of attribute presence */
	    isGOS: function() {
	        return this._pageTypeIsGOS (this.get('pageType') );
	    },
	    isCold: function() {
	        return this._pageTypeIsCold( this.get('pageType') );
	    },
	    isUrl: function() {
	        return this._pageTypeIsURL( this.get('pageType') );
	    },
	    isFormsIQ: function() {
	        return this._pageTypeIsFormsIQ( this.get('pageType') );
	    },
	    isParsedEmail: function() {
	        return this._pageTypeIsParsedEmail( this.get('pageType') );
	    },
	    /* DVBC-1111 - this type is obsolete but still supported -- fdd treats as text but treat by showing image from cre */
	    /* will be displayed as 8.5 x 11 by default */
	    isWindowsText: function() {
	        return this._pageTypeIsWindowsText( this.get('pageType') );
	    },
	    // Either 22 or 23 (the skeleton or part).
	    isMultipartGos: function() {
	        return this._pageTypeIsMultipartGos( this.get('pageType') );
	    },
	
	    isMultipartGosSkeleton: function() {
	        return this._pageTypeIsMultipartGosSkeleton( this.get('pageType') );
	    },
	
	    isMultipartGosPart: function() {
	        return this._pageTypeIsMultipartGosPart( this.get('pageType') );
	    },
	    /*
	     * Instead of checking for page types -- isGos or isMultipartGosPart,
	     * just return whether gosInfo is populated.
	     * Used for consistency in printing gosInfo in various views: pageInfo, unrenderable page views, etc
	     */
	    hasGosInfo: function() {
	
	        var gosInfo = this.get('gosInfo');
	        return gosInfo !== undefined && gosInfo !== null;
	
	    },
	
	    isGosHtmlFile: function() {
	
	        if ( !this.isGOS() )
	            return false;
	
	        var fileExt = this.getFileNameExtension();
	        return fileExt && _.contains( ['HTML', 'HTM', 'XHTML'], fileExt.toUpperCase() );
	
	    },
	
	    renderUrlViewForDocAndPageMode: function() {
	        return this.isUrl() || this.isFormsIQ() || this.isGosHtmlFile();
	    },
	
	    /*
	    *  Note: GOS html files will be loaded as image previews in thumbnails.
	    *  FormsIQ pages now rendered as images -- could potentially do for URL
	    *  pages, but still get an error for them when requested from CRE.
	    * */
	    renderUrlViewForThumbnail: function() {
	        return this.isUrl();
	    },
	
	    setRotation: function(deg) {
	        this.set({ rotation: deg }, {silent: true});
	        return this;
	    },
	
	    updateUnknownDimensionsPostLoad: function(loadDimensions) {
	        this.set(loadDimensions);
	    },
	    imgLoadFailed: function() {
	        return this.get('loadError');
	    },
	
	    /* --- DIMENSIONS ---- */
	
	
	    // Return the 'derived dimensions' -- don't include rotation
	    getDimensions: function() {
	
	        return {
	            width: this.get('width'),
	            height: this.get('height')
	        };
	    },
	
	
	    getRotatedDimensions: function() {
	
	        var dims = this.getDimensions(),
	            rotation = this.get('rotation'),
	            rIs90 = rotation === 90 || rotation === 270;
	
	        return {
	            width: rIs90 ? dims.height : dims.width,
	            height: rIs90 ? dims.width : dims.height
	        };
	
	    },
	
	    getRotatedDimensionsWithScale: function(scale) {
	
	        var rotatedDims = this.getRotatedDimensions();
	
	        if ( !scale )
	            return rotatedDims;
	
	        return {
	            width: Math.round( rotatedDims.width * scale ),
	            height: Math.round( rotatedDims.height * scale )
	        };
	
	    },
	
	    getRotatedWidth: function() {
	
	        var rotation = this.get('rotation');
	
	        return rotation !== 90 && rotation !== 270
	            ? this.get('width')
	            : this.get('height');
	
	    },
	
	    getRotatedHeight: function() {
	
	        var rotation = this.get('rotation');
	
	        return rotation !== 90 && rotation !== 270
	            ? this.get('height')
	            : this.get('width');
	
	    },
	
	    /* -- Original Image Properties ( only appliable to FDD images, should subclass & have better organization */
	
	    /*
	    * Return the original dimensions, optionally with scale applied -- if provided
	    * Note: this is only for FDD images which would have original image properties ...
	    * */
	    originalDimensions: function(scale) {
	
	        scale = scale ? scale : 1;
	
	        var orDims = this.get('originalImageProperties');
	        if (!orDims)
	            return null;
	
	        return {
	            w: orDims.width * scale,
	            h: orDims.height * scale
	        };
	
	    },
	
	    // Note: only applicable for FDD images
	    getOriginalAspectRatio: function() {
	
	        var orDims = this.get('originalImageProperties');
	        if (!orDims)
	            return null;
	
	        return orDims.width / orDims.height;
	    },
	
	    /* includes scale adjustments if provided -- original always rotated */
	    getOriginalCenterPtRotated: function(scale) { //*** NO DPI -- don't rotate?
	
	        var origDims = this.originalDimensions(scale ? scale : 1);  //--> w, h scaled -- need to do first b/f rotate
	        if (!origDims)
	            return null;
	
	        var absRot = Math.abs(this.get('rotation'));
	        var rIs90  = absRot === 90 || absRot === 270;
	        var rtDims = {
	            w: rIs90 ? origDims.h : origDims.w,
	            h: rIs90 ? origDims.w : origDims.h
	        };
	        return {
	            x: Math.round(rtDims.w / 2), //want an integer
	            y: Math.round(rtDims.h / 2)
	        };
	    },
	
	    /**
	     * Intermediate refactor in lieu of subclassing ( eg for COLD pages ).
	     * For FDD images, original image dimensions; for COLD, the size of the generated text,
	     * which is the size of the canvas we provide for drawing on.
	     */
	    getOriginalPageCanvasDimensions: function() {
	
	        if ( this.isCold() ) {
	
	            /*  grid model only know if page was loaded ( and text was retrieved ) in page mode  */
	            var gridModel = this.getTextGridModel();
	            if ( !gridModel )
	                return null;
	
	            /* Normalize w, h to mimiick other fns -- TODO: refactor all .w, .h */
	            var dims = gridModel.actualDimensions();
	            return {
	                w: dims.width,
	                h: dims.height
	            };
	
	        }
	
	        return this.originalDimensions();
	
	    },
	
	
	
	    /* ------ end dimensions ------ */
	
	
	    /**
	     * Should indicate when use conversion constant or not -- see other fns, other page -- and put on base page
	     * (used for rotate -- need to include dpi calcs UNSCALED && NOT ROTATION !
	     */
	    getOriginalCenter: function() {
	
	        var origImgProps = this.get('originalImageProperties');
	        if ( !origImgProps )
	            return null;
	
	        var conv = ShapeUtils.INCHES_TENTHS_MM_TRANS,
	            ow = origImgProps.width / origImgProps.originalHDPI / conv,
	            oh = origImgProps.height / origImgProps.originalVDPI / conv;
	        return {
	            x: Math.round( ow / 2 ),
	            y: Math.round( oh / 2)
	        };
	    },
	
	    /**
	     * The original center with current rotation taken into account
	     */
	    getOrigRotatedCenter: function() {
	
	        var origImgProps = this.get('originalImageProperties');
	        if (!origImgProps)
	            return null;
	
	        var conv = ShapeUtils.INCHES_TENTHS_MM_TRANS,
	            ow = origImgProps.width / origImgProps.originalHDPI / conv,
	            oh = origImgProps.height / origImgProps.originalVDPI / conv;
	
	        // Don't really need 360 (server does)
	        // make pg fn for isRot90 -- (also one that returns the width and height of them) ... ?
	        var absRot = Math.abs( this.get('rotation') ),
	            rIs90  = absRot === 90 ||absRot === 270 ;
	
	        return {
	            x: rIs90 ? Math.round(oh / 2) :  Math.round(ow / 2),
	            y: rIs90 ?  Math.round(ow / 2) : Math.round(oh / 2)
	
	        };
	    },
	
	    getDPI: function() {
	
	        var originalImageProperties = this.get('originalImageProperties');
	        if ( !originalImageProperties )
	            return null;
	
	        return originalImageProperties.normalizedDPI;
	    },
	
	    // Returns either 'jpeg' or 'tiff' -- defined in doc info fetch based on image compression type.
	    getFDDImageType: function() {
	
	        var originalImageProperties = this.get('originalImageProperties');
	        if ( !originalImageProperties )
	            return null;
	
	        return this.get('originalImageProperties').type;
	    },
	
	    getOriginalImgCompressionType: function() {
	
	        var originalImageProperties = this.get('originalImageProperties');
	        if ( !originalImageProperties )
	            return null;
	
	        return this.get('originalImageProperties').type;
	    },
	
	    /* ----------------------------- File Name ------------------------------ */
	
	    /*
	    * Central point for getting page names.
	    * Return the page name appended with file extension if provided.
	    * If fileExtension not provided, use that derived from the page inherently.
	    * ( It currently appears that page names are always displayed with a file extension ).
	    * */
	    getPageName: function( fileExtension, forDownload ) {
	
	        var nameWithoutExtension = this._getPageNameWithoutExtension();
	
	        var extension = fileExtension
	            ? fileExtension
	            : this.getFileNameExtension(); // some overlap with GOS, but worth if for the clarity
	
	        var pageName = nameWithoutExtension + '.' + extension;
	
	        if (forDownload)
	            pageName = Util.sanitizeFileNameForFileSystem(pageName);
	
	        return pageName;
	
	    },
	
	    _getPageNameWithoutExtension: function() {
	
	        var gosInfoFileName = this.gosInfoFileName();
	
	        if (gosInfoFileName)
	            return Util.stripFileExtension( gosInfoFileName );
	
	        var derivedDocName = this.getParentDocument().getNonGosNameWithoutExtension();
	
	        // Add the page # to distinguish pages in the document that would otherwise have the same name.
	        return derivedDocName + '_' + this.get('number');
	
	    },
	
	    /*
	    * Returns either the gosInfo.fileName if it exists or null.
	    * Convenience to both determine if the name exists and return it if it does.
	    * */
	    gosInfoFileName: function() {
	        var gos = this.get('gosInfo');
	        return gos && gos.filename && gos.filename.length > 0
	            ? gos.filename
	            : null;
	    },
	
	    /*
	    *  Note: applies only to requests for FDD images (which include image overlays).
	    *  This is what would be printed as the file name in corresponding <image> tags.
	    *  For text (COLD) pages, the 'overlay' property is populated if the page has an overlay applied.
	    *  If there's no overlay on the COLD page, this won't be requested.
	    *  Note:
	    *   - Overlay images are not requested in 'preview' requests.
	    *   - The 'address' is the 'location' of the image overlay (the image requested);
	    *     it won't exist if there's no image overlay applied.
	    *   - The name for an image overlay only comes into play if the user clicks 'save as' on the image
	    *    in the browser ( the page name is different ).
	    *   - Use 'forDownload' so downloads from image tags are 'file system escaped'
	    * */
	
	    getCreImgRequestFileName: function() {
	
	        var overlay = this.get('overlay'),
	            fileType = this.get('imageFileType');
	
	        return overlay && overlay.address
	            ? overlay.overlayName + '-' + 'overlay' + '.' + fileType
	            : this.getPageName( fileType, 1 );
	    },
	
	    // Provide hasGosInfo in case we already know this prior to the fn call.
	    getFileNameExtension: function( hasGosInfo ) {
	
	        if ( hasGosInfo || this.hasGosInfo() )
	            return Util.getFileExtension( this.get('gosInfo').filename );
	
	        if ( this.isFddImage() ) {
	            // Return the shortened jpg for type 'jpeg': this is what's output by CRE (and is shorter)
	            // The only other type would be tiff
	            return this.getFDDImageType() === 'jpeg' ? 'jpg' : 'tiff';
	        }
	
	        if ( this.isCold() )
	            return 'txt';
	
	        if ( this.isParsedEmail() )
	            return 'eml';
	
	        return '';
	
	    },
	
	
	    /* ----------------------------- Render Requests  ------------------------------ */
	
	    getImgRenderRequest: function() {
	
	        // Temp for testing CRE ...
	        var INCLUDE_NOTES = 1; //
	        if (true) {
	            INCLUDE_NOTES = 0;
	        }
	
	        return {
	            renderRequest: {
	                renderingParameters: {
	                    containerType: 'raw',
	                    pageType: this.get('imageFileType'),
	                    imageParameters: {
	                        fixWidth: this._getFixedWidthForImgRenderRequest()
	                    },
	                    preview: !this.isFddImage()
	                },
	                slices: [{
	                    documentAddress: this.get('parentDocument').docAddress(),
	                    pageIds: [ this.get('pageId') ],
	                    fddImageParameters: {
	                        disableFddRotation: true
	                    },
	                    pageNotesByType: INCLUDE_NOTES
	                        ? ['REDACTION_NOTE', 'GRAPHIC_NOTE', 'HIGHLIGHT_NOTE', 'GRAPHIC_STAMP', 'INITIALS',
	                        'SIGNATURE', 'SVG_SIGNATURE', 'SVG_GRAPHIC_NOTE', 'STRIKE_THROUGH', 'FLOATING_REDACTION_NOTE', 'FULL_PAGE_REDACTION', 'GRAPHIC_TEXT_STAMP' ]
	                        : []
	                }],
	                destinations: {
	                    allowDownload: true
	                }
	            }
	
	        };
	
	
	    },
	
	    // Width is be the default -- applicable only to thumbnails; N/A for page mode
	    // Document mode now overrides with rotated width
	    _getFixedWidthForImgRenderRequest: function() {
	        return this.get('width');
	    },
	
	    /**
	     * Essentially that of the doc, then alters the resp for the page.
	     * (non-image)
	     */
	    nonImgRenderRequest: function() {
	
	        var parentDoc = this.get('parentDocument'),
	            req = parentDoc.docRenderRequest.apply(parentDoc, arguments);
	
	
	        req.renderRequest.slices[0]['pageIds'] = [ this.get('pageId') ];
	
	
	        return req;
	
	    },
	
	    /*
	    * Only for COLD type pages -- would put there if/when subclass by type in addition to mode.
	    * This is for the cold text, not the overlay image.
	    * */
	    getTextOverlayRenderRequest: function() {
	
	        var imgReq = this.getImgRenderRequest();
	
	        _.extend( imgReq.renderRequest.renderingParameters, {
	            containerType: 'raw',
	            pageType: 'raw'
	        });
	
	        return imgReq;
	    },
	    getOverlayImageRequest: function(address) {
	        return  {
	            renderRequest: {
	                renderingParameters: {
	                    containerType: 'raw',
	                    pageType: this.get('imageFileType')
	                },
	                slices: [{  //note: single pg
	                    documentAddress: {
	                        containerType: address.containerType,
	                        containerId:  address.containerId,
	                        documentId: address.documentId
	                    },
	                    pageIds: [address.pageId]
	                }
	                ],
	                destinations: {
	                    allowDownload: true
	                }
	            }
	        };
	    },
	
	    /*
	     * Currently not using the cookie functionality (DVBC-1366, 1367) for downloads.
	     * The cookie would be read at the window level so would want something to identify
	     * the download and we aren't using this with the other cre downloads -- see download frame.
	     * Provide inline as true to utilize for the src for HTML GOS iframe page loads (the are 'raw').
	     * DVBC-1476 -- previously all downloads went to CRE; Multi-Part-Gos now go through different url.
	     */
	    getRawDownloadUrl: function(inline) {
	
	        if ( this.isMultipartGos() )
	            return fvChannel.request('apiUrl').multiPartGosPageDownload( this.getParentDocument(), this );
	
	        //var DL_COOKIE = 'dlComplete';
	
	        // Traditional CRE download
	
	        var docContainer = this.getParentDocContainer(),
	            CRE_ROOT = fvChannel.request('settings').getCRERoot(),
	            url = CRE_ROOT + 'rest/v2/api/cre/raw/download?'; // maybe put on API_URL ... or make fn of ...
	
	        // required
	        url += 'containerType=' + docContainer.getType().toUpperCase() + '&';
	        url += 'containerId=' + docContainer.getId()  + '&';
	        url += 'docId=' + this.getParentDocument().getId();
	
	        // now treating this as required for Doc Viewer purposes
	        url += '&pageId=' + this.getId();
	
	        // (true prob not necessary but in testing to identify the need to send a file in app.js)
	
	        url += '&inline=' + (inline ? 'true' : 'false');
	        url += '&filename=' + encodeURIComponent( this.getPageName( undefined, 1) );
	
	        //url += '&cookieName=' + DL_COOKIE;
	
	        return url;
	
	    },
	
	    /* ------------------------------------------------- */
	
	    resetLoadState: function() {
	        this.set({
	            isLoaded: false,
	            wasRequested: false,
	            loadError: false
	        }, {silent: true});
	    },
	
	    //TODO: mediate -- call off channel, don't pass in (?)
	    shapeModelsToRender: function() {
	
	        var shapes = this.drawableNotes().map( _.bind(function(n) {
	            return n.shapeModelsToRender(this);
	        }, this));
	
	        /* turn array of shapes per note into one large array per page */
	        shapes = _.flatten(shapes);
	        return shapes;
	
	
	    },
	
	    /**
	     * Return collection of notes of this page that are drawable AND user has access to view
	     * ( if user is not in the note's access group, it's not returned from the server ).
	     */
	    drawableNotes: function() {
	
	        var notes = this.get('notesCollection').filter( function(n) {
	            return n.isDrawable();
	        });
	
	        return new PageNotes( notes );
	
	    },
	
	    // Only for txt pages ... ideal candicate for subclass
	    hasImageOverlay: function() {
	        var overlay = this.get('overlay');
	        return overlay && overlay.address;
	    },
	    
	    // Applicable to page types that are rendered in an iframe: URL, FormsIQ, and GOS HTML files
	    getPageUrl: function() {
	
	        if ( this.isGosHtmlFile() )
	            return this.getRawDownloadUrl(1);
	
	        return this.get('url');
	
	    },
	     // Don't mess with original is renderable for the page views for url pages -->
	     // they will be treated as url page type views anyway -- this is simply for including them in pdf mode
	    isRenderableInPDFMode: function() {
	        return this.isRenderable() && !this.isUrl();
	    },
	    /* the unrenderable and url pages -- needed to retrieve those from isRenderableInPDFMode */
	    isUrlOrUnrenderable: function() {
	        return this.isUrl() || !this.isRenderable();
	    },
	    /* note: would only apply to GOS*/
	    _hasImageTypeFileExtension: function() {
	       return _.contains( ViewerSettings.prototype.validImgFileTypes, this.getFileNameExtension().toUpperCase() );
	    },
	
	    /* a derived type -- basically, should it render in the viewer like an image (vs a document) */
	    /* note: may now want to change with rendering PDFs in single page mode for certain types */
	    isImageType: function() {
	
	        if ( this.isGOS() )
	            return this._hasImageTypeFileExtension();
	
	        if ( this.isFddImage() )
	            //note: Paul -- would really only be applicable to JPG, TIFF -- where fdd sets the compressions --
	            // compression isn't always the file type, only when uploaded
	            return _.contains( ViewerSettings.prototype.validImgFileTypes , this.getOriginalImgCompressionType().toUpperCase() );
	
	        return false;
	    },
	    getFriendlyName: function() {
	        return PgNameXref[ this.get('pageType') ];
	    },
	
	    // Return whether page is downloadable from the CRE as 'raw' or if not provided, as a PDF.
	    // Note: Gos Skeleton Pgs are not downloaded by the CRE.
	    isDownloadable: function(isPDF) {
	
	        // Url pages not working for either pdf/raw -- not sure if a bug with the CRE / not.
	        // Note URL pages are considered renderable ( DVBC-1704)
	        if (  this.isWindowsText() || this.isUrl() || this.isMultipartGosPart() )
	            return false;
	
	        // Raw Forms IQ pages: don't seem to work (PDF works); unsure if this is a bug in the CRE/not:
	        // what's returned is a text file with the url to the formsIQ page.
	        // GOS HTML pages: work for pdf/raw.
	        if ( this.isFormsIQ() ) {
	            return isPDF;
	        }
	
	        // Multi-Part-Gos Skeletons are downloadable RAW, though not via the CRE
	        if ( this.isMultipartGosSkeleton() ) {
	            return !isPDF;
	        }
	
	        // For PDF, true for any non GOS page or any 'renderable' GOS page determined by file extension
	        // (and now either multi-part-GOS page types)
	        if (isPDF) {
	            return this.isRenderable(); // (this may belong better in 'isRenderable logic')
	        }
	
	        return true;
	    },
	
	    getSpinJSOptions: function() {
	        return this.SPIN_JS_OPTS;
	    },
	    //TODO: put in with DVBC-1366 -- replace direct gets with these fns throughout codebase
	    getParentDocument: function() {
	        return this.get('parentDocument');
	    },
	    getParentDocContainer: function() {
	        return this.getParentDocument().getDocContainer();
	    },
	    getId: function() {
	        return this.get('pageId');
	    },
	
	    /**
	     * DVBC-1382: return unique object of { reasonCode, count } from all redaction notes on the page
	     * if there are no redaction notes or none have reason codes assigned, return null
	     * could be optimized though performance shouldn't be an issue
	     * currently unsorted ( this is later done upon display in the view)
	     * if want the descriptions will need to derive from reason codes endpoint / collection ...
	     * noteTypeFilter:
	     *  - 'nonFullPage': regular: type D and B
	     *  - 'fullPage': type E -- only full page redactions ( max is one )
	     *   - undefined (or anything else): include all types (full page & non full page)
	     */
	    getReasonCodesCounts: function( noteTypeFilter ) {
	
	        var pgCodesByCounts = {},
	            aRedactionNotes;
	
	        if ( noteTypeFilter === 'nonFullPage' ) {
	
	            aRedactionNotes = this.getNonFullPageRedactionNotes();
	
	        } else if ( noteTypeFilter === 'fullPage' ) {
	
	            aRedactionNotes = this.getFullPageRedactionNotes();
	
	        } else {
	
	            aRedactionNotes = this.getRedactionNotes();
	        }
	
	
	        if (!aRedactionNotes || aRedactionNotes.length < 1)
	            return null;
	
	        _.each( aRedactionNotes, function(n) {
	
	            var noteCodesByCounts = n.getReasonCodeCounts();
	            if (!noteCodesByCounts)
	                return; // (note has no codes assigned, next)
	
	            for (var code in noteCodesByCounts) {
	                pgCodesByCounts[code] = !_.contains( _.keys(pgCodesByCounts), code )
	                    ? noteCodesByCounts[code]
	                    : pgCodesByCounts[code] += noteCodesByCounts[code];
	            }
	
	        });
	
	        if ( _.keys( pgCodesByCounts).length < 1 )
	            return null;
	
	        return pgCodesByCounts;
	
	    },
	
	    // Return true if the page has redaction notes
	    hasRedactionNotes: function() {
	        var aRedactionNotes = this.getRedactionNotes();
	        return aRedactionNotes && aRedactionNotes.length > 0;
	    },
	
	    // Return array of redaction note models in the page
	    getRedactionNotes: function() {
	        return this.get('notesCollection').filter( function(n) {
	            return n.isRedactionNote();
	        });
	    },
	
	    getNonFullPageRedactionNotes: function() {
	        return this.get('notesCollection').filter( function(n) {
	            return n.isNonFullpageRedactionNote();
	        });
	    },
	
	    // Should only ever by one per page -- not enforcing if read in by a client that doesn't enforce
	    getFullPageRedactionNotes: function() {
	
	        return this.get('notesCollection').filter( function(n) {
	            return n.isFullPageRedactionNote();
	        });
	
	    },
	
	    // Should only ever by one per page -- not enforcing if read in by a client that doesn't enforce
	    hasAFullPageRedactionNote: function() {
	        return this.get('notesCollection').find( function(note) {
	            return note.isFullPageRedactionNote();
	        }) !== undefined;
	    },
	
	    // called on: viewer init WF from document model after the note to set are known
	    setNoteCollection: function(aNotes) {
	        this.set('notesCollection', new Backbone.Collection(aNotes) ) ;
	    },
	    addNewPageNote: function(note) {
	        this.get('notesCollection').add(note);
	    },
	    deleteNote: function(note) {
	        this.get('notesCollection').remove(note);
	    },
	    /* Return if the user can draw page notes atop the page.
	     * Note: imgLoad failed only applies to those pages that have already loaded in error --
	     * it's an extra check that can't hurt.
	     */
	    supportsAnnotation: function() {
	
	        if ( this.imgLoadFailed() )
	            return false;
	
	        return this.isFddImage() || this.isCold();
	
	    },
	
	    allowCreationOfFullPageRedaction: function() {
	        return !this.isCold() && !this.hasAFullPageRedactionNote();
	    },
	    /**
	     * Determine whether to print the preview icon on page views.
	     * Here to clean up some old logic on the base page view.
	     */
	    renderPrintPreviewIconOnPageImageViews: function() {
	
	        // It's only printed in the template if the page has unknown dimensions.
	        if ( this.isFddImage() )
	            return false;
	
	        // This was the existing logic encountered 4.9.20 -- don't remember why ...
	        // we may only be concerned with COLD and GOS page types for the previews
	        return !this.isParsedEmail() && !this.isWindowsText();
	
	    },
	
	    resizePageFromDummyDimensionsPostLoad: function() {
	        return !this.isFddImage() && ! this.renderUrlViewForDocAndPageMode(); // Forget why the latter is working ...
	    },
	
	    /**-- Cold Specific -- */
	    getTextGridModel: function() {
	        return this.get('textGridModel');
	    },
	
	    setTextGridModel: function( model ) {
	        this.set( 'textGridModel', model );
	    }
	
	
	    /** -- End Cold -- */
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var _ = __webpack_require__(49),
	    NotesCollection = __webpack_require__(271),
	    NoteModelFactory = __webpack_require__(275),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = NotesCollection.extend({
	
	    url: function() {
	        return fvChannel.request('apiUrl').pageNotes;
	    },
	
	    // Currently not in use -- ( now retreived from docInfo )
	    // Note: there are 2: one on the document (POST) and other is a get -- here is the POST
	    fetch: function() {
	
	        return Backbone.Collection.prototype.fetch.call( this, {
	            type: 'POST',
	            data:  JSON.stringify( [ this.document.getDocSlice() ] ) ,
	            contentType: 'application/json' // must include or server responds with 415
	        } );
	
	    },
	
	    parse: function(resp) {
	
	        var availableNoteTypes = NoteModelFactory.noteTypesToInclude('page');
	        resp =_.filter(resp, function(n) {
	            return _.contains(availableNoteTypes, n.noteType);
	        });
	
	        return resp;
	
	    },
	
	    model: function(attrs, options) {
	
	        delete options.url;  //looks like set by default: need to delete prior to model creation to allow for rootURL to take precedence over the collections' //TODO: still using?
	        var Note = NoteModelFactory.factory( attrs.noteType, false );
	        return new Note(attrs, options);
	
	    },
	
	    /**
	     *  pageNumber: set from page collection where the pageId of the pageNote is the pageId of the page
	     * (pageNumbers are set in the parse of the page collection from the array index of the model
	     * the notes have an id -- map with the document page numbers
	     */
	    setPageNumbers: function(pgCollection) {
	
	        var pgNotes = this.models,
	            pgs = pgCollection.models;
	
	        _.each( pgNotes, function(pn) {
	
	            var pgNum = _.find(pgs, function(pg) {
	                return pg.get('pageId') === pn.get('pageId');
	            }).get('number');
	
	            pn.pageNumber = pgNum; // not a server prop
	
	        });
	
	    },
	
	    // Need to use link on pageId, not page # ( which is based on sequence ).
	    // This is because documents can have > 1 copy of the same page,
	    // and accordingly, > 1 page can share the same notes.
	    getNotesOfPage: function(page) {
	        return this.filter( function(n) {
	            return n.get('pageId') === page.get('pageId');
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    NoteFilterState = __webpack_require__(272);
	
	/*
	 * 'Base' notes collection from which document and page note collections extend.
	 * Should create a separate class for the 'allNotes' collection used in this application --
	 * eg: for the other collections, where aren't interested in definiting this.sortDir && this.comparator
	 */
	
	module.exports = Backbone.Collection.extend({
	
	    comparators: __webpack_require__(274),
	
	    initialize: function(models, options) {
	        // required to ref the doc of the note ( could subclass )
	        options && options.document && ( this.document = options.document );
	
	    },
	    /*
	    *
	    * Needs to be called before the allNotes collection is rendered in layout for the proper sort to be respected.
	    * dir: asc/desc
	    * */
	    updateSort: function(sortType, dir) {
	
	        this.sortDir = dir;
	        this.comparator = this.comparators[sortType].sortFn;
	        this.sort();
	
	    },
	
	    getUIModels: function() {
	        return this.map( function(note) {
	            return note.uiModel;
	        });
	    },
	
	    /*
	    * Entry point to set isVisible on the noteUi Models.
	    * If options.fromViewerLoad, create a new filter model, otherwise
	    * use the model passed in (from the notes module state).
	    * A potential improvement would be to store the filterModel directly on here for clarity.
	    * */
	    setIsFiltered: function( noteFilterModel, options ) {
	
	        if (options && options.fromViewerLoad) {
	            noteFilterModel = new NoteFilterState();
	            // (always set: falsely would be passed if provided -- it's a double negative )
	            noteFilterModel.setHideActivityNotes( options.hideActivityNotes );
	        }
	
	        this.each( function(note) {
	           note.uiModel.setIsFiltered( noteFilterModel.shouldFilterNote (note) );
	        });
	
	    },
	
	    /*
	    * Return the visible/unfiltered noteModels in the collection.
	    * If noteModels is provided, just return the visible models from that subset.
	    * */
	    getVisibleNotes: function( noteModels ) {
	
	        if ( !noteModels ) {
	            return this.filter( function(note) {
	                return !note.uiModel.isFiltered();
	            });
	        }
	
	        return _.filter( noteModels, function(note) {
	            return !note.uiModel.isFiltered();
	        });
	
	    },
	    /*
	    * Return the number of notes that would be visible in the UI.
	    * The 'unfiltered notes'.
	    * */
	    getNumberOfVisibleNotes: function() {
	
	        var visibleNotes = this.getVisibleNotes();
	        return visibleNotes.length;
	
	    },
	
	    notesAreFiltered: function() {
	        return this.getNumberOfVisibleNotes() < this.length;
	    },
	
	    getNotesOfPage: function(pageNumber) {
	
	        return this.filter( function(note) {
	            return note.pageNumber === pageNumber;
	        });
	    },
	
	    getNotesOfGroupType: function(groupType) {
	        return _.where( this.models, { noteTypeGroup: groupType } );
	    }
	
	});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    NoteSettings = __webpack_require__(273);
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        pageFilter: 'all-pages',  // other is 'current-page' (possible values printed on view template)
	        noteTypeFilter: 'all', // possible values: all existing note types; now based on groupNoteType: //TODO: reflect change in code but now have higher priority
	        referralFilter: 'all', // possible values printed on view template
	
	        hideActivityNotes: NoteSettings.prototype.defaults.hideActivityNotes,
	
	        satFilterTxt: '',
	        filterSrc: '', // dropdown, sat, pageChange, modeChange, noteDeleted, noteSaved
	        currentPage: 1  //cache here -- don't get from each mode
	    },
	
	
	    dropDownFilter: function(options) {
	        this.set({
	            filterSrc: 'dropdown',
	            pageFilter: options.page, //TODO: use the same name in the attr's and pick
	            currentPage: options.currentPage, /* (pgNum) */
	            noteTypeFilter: options.noteType,
	            hideActivityNotes: options.hideActivityNotes,
	            referralFilter: options.referralFilter
	        });
	    },
	
	    satFilter: function(options) {
	        this.set({
	            filterSrc: 'sat',
	            satFilterTxt: options.satFilterTxt,
	            currentPage: options.currentPage
	        });
	    },
	
	    updatePgNum: function(num) {
	        this.set('currentPage', num);
	    },
	    setPageFilterToAllPgs: function() {
	        this.set({
	            pageFilter: 'all-pages'
	        });
	    },
	
	    setHideActivityNotes: function(hideActivityNotes) {
	        this.set('hideActivityNotes', hideActivityNotes);
	    },
	
	    isSourceSAT: function() {
	        return this.get('filterSrc') === 'sat';
	    },
	
	    getSatTxt: function() {
	        return this.get('satFilterTxt');
	    },
	
	    isCurrentPageFilterApplied: function() {
	        return this.get('pageFilter') === 'current-page';
	    },
	
	    hideActivityNotes: function() {
	        return this.get('hideActivityNotes');
	    },
	    /*
	    * Return if a note model should be filter from the UI, given the state of the filter.
	    * */
	    shouldFilterNote: function(note) {
	
	        var filterAttrs = this.toJSON(),
	            consultGroupAssigned = note.consultGroupsAssigned(),
	
	            showPage =  filterAttrs.pageFilter === 'all-pages' || filterAttrs.currentPage === note.pageNumber,
	            showType =  filterAttrs.noteTypeFilter === 'all' || filterAttrs.noteTypeFilter === note.noteTypeGroup,
	            showSAT =  note.textToFilter().toLowerCase().indexOf( filterAttrs.satFilterTxt.toLowerCase() ) > -1, //reg expr would be faster but would have to escape the text stored in var.
	            showReferral =
	                filterAttrs.referralFilter === 'all' ||
	                ( filterAttrs.referralFilter === 'referred' && consultGroupAssigned ) ||
	                ( filterAttrs.referralFilter === 'not-referred' && !consultGroupAssigned ),
	            showNote = showPage && showType && showSAT && showReferral;
	
	        if ( note.isActivityNote() && filterAttrs.hideActivityNotes )
	            showNote = false;
	
	        /* allow notes not of the filter type to display in the collection view so they can be created */
	        if ( note.isNew())
	            showNote = true;
	
	        return !showNote;
	    }
	
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	module.exports = Backbone.Model.extend({
	    defaults: {
	        hideActivityNotes: true //separate from viewer default b/c this could later be sep module -- maybe pull from a config file for both
	    }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(69);
	
	/*
	* Note: context here is notesCollection, which relies on it's 'sortDir' instance variable
	* */
	
	module.exports = {
	
	    ctime: {
	
	        name: 'Time Created',
	        sortFn: function (a, b) {
	
	            var aMoment = moment(a.get('creationTime')),
	                bMoment = moment(b.get('creationTime')),
	                diff = aMoment.diff(bMoment); // milliseconds
	
	            //moment: If the moment is later than the moment you are passing to moment.fn.diff, the return value will be negative
	            if (this.sortDir === 'desc') {
	                if (diff < 0) {
	                    return 1;
	                } else if (diff > 0) {
	                    return -1;
	                } else {
	                    return 0;
	                }
	            } else {  //asc
	                if (diff < 0) {
	                    return -1;
	                } else if (diff > 0) {
	                    return 1;
	                } else {
	                    return 0;
	                }
	            }
	        }
	
	    },
	
	    cusr: {
	
	        name: 'Creation User',
	        /*
	         * TODO: this is example of string descending; encapsulate into fn
	         */
	        sortFn: function (a, b) {
	
	            if (this.sortDir === 'asc') {
	
	                if (a.get('creationUserDesc') > b.get('creationUserDesc')) {
	                    return 1;
	                }
	                else if (a.get('creationUserDesc') < b.get('creationUserDesc')) {
	                    return -1;
	                }
	                else {
	                    return 0;
	                }
	
	            } else {
	
	                if (a.get('creationUserDesc') > b.get('creationUserDesc')) {
	                    return -1;
	                }
	                else if (a.get('creationUserDesc') < b.get('creationUserDesc')) {
	                    return 1;
	                }
	                else {
	                    return 0;
	                }
	            }
	        }
	    },
	
	    type: {
	
	        name: 'Type',
	        sortFn: function (a, b) {
	            if (this.sortDir === 'asc') {
	                if (a.noteTypeGroup > b.noteTypeGroup) {
	                    return 1;
	                }
	                else if (a.noteTypeGroup < b.noteTypeGroup) {
	                    return -1;
	                } else {
	                    return 0;
	                }
	            } else {
	                if (a.noteTypeGroup > b.noteTypeGroup) {
	                    return -1;
	                }
	                else if (a.noteTypeGroup < b.noteTypeGroup) {
	                    return 1;
	                } else {
	                    return 0;
	                }
	            }
	
	        }
	
	    },
	    /*
	     * (Numeric example)
	     */
	    pageNumber: {
	        name: 'Page',
	        sortFn: function (a) {
	            if (this.sortDir === 'asc') {
	                return a.pageNumber;
	            } else {
	                return -a.pageNumber;
	            }
	        }
	    }
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	var DocTextNote = __webpack_require__(276),
	    DocHTMLNote = __webpack_require__(278),
	    FlashNote = __webpack_require__(279),
	    ActivityNote = __webpack_require__(284);
	
	
	var PgTxtNote = __webpack_require__(285),
	    KeyedTxtNote = __webpack_require__(286),
	    HighlightNt = __webpack_require__(287),
	    RedactionNt = __webpack_require__(149),
	    FddGraphicNt = __webpack_require__(290),
	    SvgGraphicNt = __webpack_require__(291),
	    Signature = __webpack_require__(296),
	    GraphicStamp = __webpack_require__(299),
	    StrikeThrough = __webpack_require__(308),
	    FullPageRedaction = __webpack_require__(311),
	    TextStamp = __webpack_require__(320);
	
	
	/*
	  FDD orange Java Note Type Enum X Viewer JS Note Model Constructor
	*/
	
	var DOC_XREF = {
	    TEXT_NOTE: DocTextNote,
	    HTML_NOTE: DocHTMLNote, //(normalized to text -- can import but can't create) */
	    FLASH_NOTE: FlashNote,
	    ACTIVITY_NOTE: ActivityNote
	};
	
	var PG_XREF = {
	    TEXT: PgTxtNote, /* ENUM IS TEXT -- makes easier so doesn't overlap with TEXT_NOTE */
	    KEYED_TEXT_NOTE: KeyedTxtNote, //like TEXT notes; always display; these are created instead of regular text notes in auto utr file cabinets
	    HIGHLIGHT_NOTE: HighlightNt,
	    REDACTION_NOTE: RedactionNt,
	    FLOATING_REDACTION_NOTE: RedactionNt,
	    SVG_SIGNATURE: Signature,
	    SVG_GRAPHIC_NOTE: SvgGraphicNt, // this is the new type for graphic notes created in the Doc Viewer
	    GRAPHIC_NOTE: FddGraphicNt, //these are not the legacy FDD graphic notes
	    GRAPHIC_STAMP: GraphicStamp,
	    STRIKE_THROUGH: StrikeThrough,
	    FULL_PAGE_REDACTION: FullPageRedaction,
	    GRAPHIC_TEXT_STAMP: TextStamp
	};
	
	
	
	/**
	 *
	 * Need to return the constructor for the collection to add post parse/fetch.
	 */
	module.exports = {
	
	    factory: function( noteType, isDocumentNote ) {
	        return (isDocumentNote ? DOC_XREF : PG_XREF)[noteType];
	    },
	
	    /**
	     * Need these, otherwise will error on getting corresponding note types -- never import these.
	     * Called on parse on page and document note collections.
	     * DVBC-1791: server is no longer return UTR page notes ( they're already filtered out )
	     */
	    noteTypesToInclude: function( type ) {
	
	        var XREF = type === 'document' ? DOC_XREF : PG_XREF;
	        return _.keys(XREF);
	
	    },
	
	    /**
	     * noteType X Constructor -- which contains the properties
	     * type: 'document' or 'page*
	     * Use this as central fn get get any 'creatable note types' ( it will rid FLOATING_REDACTION_NOTE )
	     */
	    creatableNotes: function( type ) {
	
	        var isDocument = type === 'document',
	            XREF = isDocument ? DOC_XREF : PG_XREF,
	            hash = {};
	
	        for (var k in XREF) {
	
	            if ( !XREF[k].prototype.notCreatable )
	                hash[k] = XREF[k];
	
	        }
	
	        // Don't show 2 menu items for Floating and Non-Floating Redaction Modes (quick fix) -- they both share the same model
	        // ( Maybe utilizing something like noteTypeGroup for this purpose )
	        !isDocument && delete hash['FLOATING_REDACTION_NOTE' ];
	
	        return hash;
	    },
	
	    /* Only returning the types/keys */
	    creatableDrawableNoteTypes: function() {
	
	        var creatablePgNotes = this.creatableNotes( 'page '); // ( call central fn )
	        var noteTypes = [];
	
	        for ( var noteType in creatablePgNotes ) {
	
	            if (  creatablePgNotes[noteType].prototype.isDrawable() ) {
	                noteTypes.push( noteType );
	            }
	        }
	
	        return noteTypes;
	
	    },
	
	    //
	    //
	    /**
	     * Here we want a hash -- not the keys.
	     * supportsFindAndRedact: only on the drawableNoteType prototypes
	     * ( these are creatable by nature )
	     */
	    getNoteTypesThatSupportFindAndRedact: function() {
	
	        var noteTypes = {};
	
	        var creatablePgNotes = this.creatableNotes( 'page '); // ( call central fn )
	
	        for ( var noteType in creatablePgNotes ) {
	
	            if (  creatablePgNotes[noteType].prototype.isDrawable() && creatablePgNotes[noteType].prototype.supportsFindAndRedact() ) {
	                noteTypes[noteType] = creatablePgNotes[noteType];
	            }
	        }
	
	        return noteTypes;
	
	    }
	
	
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	var DocNote = __webpack_require__(277);
	
	module.exports = DocNote.extend({
	
	    createHotKey: 'd',
	    desc: "Doc Note",
	    actionTitle: 'Doc Note',
	    init: "DTN",
	    iconClass: "icon-comment",
	    isText: true //flag determining if doc/pg note if a text note //todo: still used?
	
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var BaseNote = __webpack_require__(153),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = BaseNote.extend({
	
	    isDocument: true,
	    pageNumber: 0,  // mimic attribute stored on pgNotes -- set to 0 for sorting reasons
	
	    /*
	    * Note: not the url for get -- (these are retrieved in bulk from docInfo and put into collection)
	    * This is only used for CRUD operations.
	    * The collection here would be 'allNotes', which has ref to document.
	    * Add the note sequence for modify operations.
	    * */
	    url: function() {
	        
	        var docNotesUrl = fvChannel.request('apiUrl').docNotes( this.collection.document );
	        return docNotesUrl + ( this.isNew() ? '' : '/' + this.get('sequence') );
	        
	    },
	
	    parse: function(response) {
	
	        var resp = BaseNote.prototype.parse.apply( this, arguments );
	
	        // Only do if new ( have not yet been saved ), sequence should suffice for determining if these have been saved.
	        // Must do as attribute: don't do this.id ... then we mess we Backbone's guts
	        // ( eg if not an attribute save won't automatically add a model to its collection )
	        if ( resp.sequence ) {
	            resp.id = 'D_' + resp.sequence;
	        }
	
	        return resp;
	
	    }
	
	});
	


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/*NOTE 10.1 -- THESE ARE NOW NORMALIZED IN THE RESP TO TEXT_NOTE */
	
	var DocTextNote = __webpack_require__(276);
	
	module.exports = DocTextNote.extend({        //include with documents : this seems to be what the fat client is creating
	    notCreatable: true,
	    isText: true //flag determining if doc/pg note if a text note
	});

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(59);
	var DocNote = __webpack_require__(277);
	var fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = DocNote.extend({
	
	    ViewConstructor: __webpack_require__(280),
	    desc: "Flash Note",
	    actionTitle: 'Flash Note',
	    init: "F",
	    iconClass: "icon-flash", //icon-clock
	
	    createHotKey: 'l',
	
	    /*
	    * Fetch individually on open.
	    * Note: fetch WILL ALSO DELETE from the database.
	    * */
	    getFlashNoteContentAndDestroyOnServer: function() {
	
	        var docNotesUrl = fvChannel.request('apiUrl').docNotes( this.collection.document );
	
	        return $.ajax({
	            url: docNotesUrl + '/text/' + this.get('sequence'),
	            type: 'GET',
	            dataType: 'text' // DVBC-1746 -- override global setting
	        });
	
	    },
	
	    /*
	    * These are never destroyed by sending an http request.
	    * Destroy will be called to:
	    * 1) delete new note view sent to other user
	    * 2) remove the note view after it's been opened ( opening will get the text, and destory it on the server )
	    * Don't send an http request.
	    * Just trigger the destory event that will be listened to on all collections (so it's removed from them).
	    * Also -- employ success and error callbacks so this can be called from the same 'workflow' as other note models.
	    * Somewhat hacky solution for DVBC-1620 -- fixes without intruding into the workflow, which would be complicated.
	    * Note: this is synchronous and doesn't return and xhr; -- shouldn't matter for this use case.
	    * */
	    destroy: function(options) {
	
	        this.trigger('destroy', this, this.collection, options);
	
	        if (options.success) {
	            options.success(this, {}, options);
	            return;
	        }
	
	        // Should never reach here -- but left in case
	        if (options.error) {
	            options.error && options.error(this, {}, options);
	            return;
	        }
	
	    }
	});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(281);
	
	var NoteView = __webpack_require__(155),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    Flashback;
	
	__webpack_require__(282);
	
	
	
	module.exports = NoteView.extend({
	
	    defaultCountdown: 10,
	
	    ui: _.extend( NoteView.prototype.ui, {
	        emailWr:        '.fn-email-wr',
	        fnEmail:        '.fn-email',
	        flashIcon:      '.icon-flash',
	        toggleDiv:      '.r2',
	        userName:       '.userName',
	        modBtns:        '.modBtns',
	        submitRow:      '.submit-row',
	        headRight:      '.headRight',
	        headLeft:       '.headLeft' //don't append to username.... max width
	    }),
	
	    onRender: function () {
	
	        NoteView.prototype.onRender.call(this);
	         _.bindAll(this, 'openUnread', 'openingNote', 'closeNote', 'destroy');
	
	        this[ this.model.isNew() ? 'onRenderNewUnsaved' : 'onRenderNotNewOrNewCreatedByUser' ]();
	
	        return this;
	
	    },
	
	
	    onRenderNewUnsaved: function() {
	
	        // Not using _recipientIsCurrentUser b/c view not ready until 'show' now
	        this.model.get('accessGroup') !== this.options.channel.request('notes:getUserPrivateID') &&
	            this.ui.emailWr.removeClass('hide');
	    },
	    /*
	    * A newly created note by the user or a note that isn't new.
	    * check if accesibleBy is null, if so, use the prev
	    * TODO: template -- extend template part or extend ui post prepend -- could have 2 templates
	    * */
	    onRenderNotNewOrNewCreatedByUser: function() {  /*  */
	
	        this.$timer = $('<span class="timer hide"></span>')
	            .prependTo( this.ui.iconWrapper ); //(don't append at time (start it hidden), then dupe made when toggleReply mode)
	
	        this.$el.unselectable().on( 'click', this.openUnread ); //(don't delegate events on view -- not working for new
	        this._fadeFlashInAndOut();
	
	    },
	
	    _fadeFlashInAndOut: function() {
	        var $flash = this.ui.flashIcon,
	         fadeInAndOut = function() {
	            $flash.stop(true).fadeOut(600).fadeIn( {
	                duration: 600,
	                complete: fadeInAndOut
	            });
	        };
	        fadeInAndOut();
	    },
	
	    // Access group is really mail recipient for this note type
	    // Toggle email option if not 'me'
	    onAccessGroupChange: function( accessGroup ) {
	
	        this.ui.emailWr[ (this._recipientIsCurrentUser() ? 'add' : 'remove') + 'Class' ]('hide');
	
	    },
	
	    openUnread: function() {
	
	        var lCh = this.options.channel,
	            vCh = lCh.request('vChannel');
	
	        // TODO: for edit/expand toggle call from WF -- set css and toggle event handlers there -- more intuitive
	        //( if a note is clicked while in edit mode, don't allow open)
	        if ( lCh.request('inEditMode' ))
	            return false;
	
	        this.$el
	            .addClass('self-destruct')
	            .off('click'); //set b/f open
	
	        this.unbindKeyboardEvents();
	        this.model.FN_WAS_OPENED = true; // SET FLAG ON MODEL TO PREV ESC FROM ESCAPING IT
	
	        this.model.getFlashNoteContentAndDestroyOnServer()
	
	            .done( _.bind( function(noteContent) {
	
	                // Setting to the active note disallows interaction w/other flash notes (dupes into edit mode)
	                // -- it's not really active in the sense others are in the application; but piggy-back off certain functionality it gives us
	                lCh.trigger( 'notes:changeActiveNote', this.model, {isReadingFlashNote: true} );
	                this.$el.removeClass('edit-mode'); // applied from reg note toggle ....
	                this.ui.bodyField.text(noteContent); // should have below in reaction to event above
	
	                if ( this.options.channel.request('vChannel').request('allowCreateDocNote') ) {
	
	                    this.listenToOnce( this.uiModel, 'change:replyMode', this._toggleReplyMode );
	                    this._createReplyBtn();
	                }
	
	                this.selfDestruct( this.defaultCountdown );
	
	            }, this))
	
	            .fail( function(data)  {
	
	                vCh.command('ajaxError', data, 'Unable to Retrieve Flash Note Message.  Please try again later.');
	
	            });
	
	    },
	    _createReplyBtn: function() {
	        //use mousedown -- will fire b/f click
	        this.btnReply = $('<i class="btnFlashBack icon-reply-1" title="Flashback"></i>')
	            .appendTo(this.ui.headLeft)
	            .on('mousedown', _.bind(this._replyBtnHandle, this));
	    },
	    _replyBtnHandle: function(e) {
	        e.stopPropagation();
	        this.uiModel.toggle('replyMode');
	    },
	    _toggleReplyMode: function(ui, enter) {
	
	        if (enter) {
	            this.undelegateEvents(); //-- DONT DO -- THEN THIS.UI.TOGGLEDIV WILL CAUSE ERR WHEN ENTER STOP SELF DESTRUCT
	
	            this.listenToOnce(this.uiModel, 'change:replyMode', this._toggleReplyMode); //need to put in again .... (i think marionette's undelegate ...)
	            this.btnReply.addClass('active').off('mousedown');
	            this._stopSelfDestruct();
	            this.$el.addClass('replyMode');
	
	            var newModel = this.options.channel.request('newNoteModel', true, 'FLASH_NOTE');
	
	            newModel.parentFlashBackNote = this.model; //for identification
	
	            Flashback = Flashback || __webpack_require__(283); //necessary for recursion
	            this.flashBackView = new Flashback({
	                model: newModel,
	                parentView: this, //to access the toggle
	                channel: this.options.channel
	            });
	            this.flashBackView.render().$el.insertAfter( this.$('.r2') ); /* have the text above */
	
	        } else {
	
	            /* this should come from save / cancel of new note */
	            this.delegateEvents();
	            this.listenToOnce(this.uiModel, 'change:replyMode', this._toggleReplyMode); //need to put in again .... (i think marionette's undelegate ...)
	            this.flashBackView.destroy();
	            this.btnReply.removeClass('active');
	            this.selfDestruct( parseInt(this.$('.timer').text()) ); //for now get back time from the DOM
	            this.$el.removeClass('replyMode');
	            this.btnReply.on('mousedown', _.bind(this._replyBtnHandle, this));
	        }
	    },
	
	    // TODO: disallow if click reply button
	    openingNote: function() {
	        var self = this;
	        return $.Deferred(function($dfd) {
	            $.when( self.ui.toggleDiv.stop().slideDown() ).done($dfd.resolve);
	        }).promise();
	    },
	    closeNote: function (e) {
	        this.delegateCollapsibleHandlers();
	        this.ui.toggleDiv.stop().slideUp();
	    },
	    delegateCollapsibleHandlers: function() {
	        this.$el.off('mousedown mouseup').on('mousedown', this.openingNote).on('mouseup', this.closeNote);
	    },
	    /* start / resume self destruct */
	    selfDestruct: function(timeLeft) {
	
	        this.openingNote().done( _.bind(function() {
	
	            this.destructTimer = null; /* gl: now start, stop */
	            this.delegateCollapsibleHandlers();
	
	            var self = this,
	                fnSetTime = function() {
	                    self.$timer.fadeOut(200, function() {
	                        $(this).text(timeLeft).fadeIn(200);
	                    });
	                };
	
	
	            //DOM slop for now: replace the icon w/ timer -- have space remain the same size
	            this.ui.iconWrapper.width( this.ui.iconWrapper.width()  );
	            this.ui.flashIcon.stop(true).fadeIn(0).stop(true).remove();
	            this.$timer.removeClass('hide');
	
	            fnSetTime.call(this);
	
	            /*gl to pause */
	            this.destructTimer = setInterval( _.bind( function() {
	
	                fnSetTime.call(this);
	                timeLeft--;
	
	                if (timeLeft === 0) {
	                    // ( if no perm, btnReply doesn't exist )
	                    this.btnReply && this.btnReply.off().fadeOut(200, function() {
	                        $(this).remove();
	                    });
	                    this._stopSelfDestruct();
	                    this._blowUpAndDestroy();
	                }
	
	            }, this), 1000);
	
	        }, this));
	
	
	    },
	    _stopSelfDestruct: function() {
	
	        this.$el.stop(true).off('mousedown mouseup');
	        this.$el.removeClass('replyMode');
	        clearInterval(this.destructTimer);
	
	    },
	    _getRawUserInput: function() {
	
	
	        return _.extend( NoteView.prototype._getRawUserInput.call(this), {
	            sendEmail: !this._recipientIsCurrentUser() && this.ui.fnEmail.is(':checked') //send email to recipient if checked and is not the current user
	        });
	
	     },
	
	    // Prior to save (note: user the selected value -- not bound to the model)
	    // TODO: it should be bound to the model ... refactor
	    _recipientIsCurrentUser: function() {
	        return this.accessGroupSelectorView.getSelectedGroup().groupId ===
	            this.options.channel.request('notes:getUserPrivateID');
	    },
	
	    onSaveIndicatorComplete: function() {
	
	        var sentToSelf =
	            this.model.get('accessGroup') === this.options.channel.request('notes:getUserPrivateID');
	
	        !sentToSelf && this._blowUpAndDestroy(1);
	    },
	    /*
	    * Also called on creation after save of new ones sent to other users
	    * (the user will not see, so delete the view).
	    * ( In additional to blowing up after reading ).
	    * */
	    _blowUpAndDestroy: function( postSaveOfNewNoteSentToOtherUser ) {
	
	        var params = {
	            effect: 'explode',
	            pieces: 50,
	            duration: 1000,
	            complete: _.bind (this._destroyFlashNote, this, postSaveOfNewNoteSentToOtherUser )
	        },
	        self = this;
	
	        setTimeout( function() {
	            self.$el.effect( params );
	        }, 1000);
	
	    },
	
	    /*
	    * Really: 'Destroy after blowup'
	    * Sources:
	    * - post save of newly created note not sent to self (want view removed)
	    * - post user opening note and countdown expiration ( it's already destroyed on the server )
	    * ( Now only called from fn'_blowUpAndDestroy')
	    * TODO: (old) if note created to self -- zombie's created -- remove the model/view -- STILL AN ISSUE ?
	    * */
	    _destroyFlashNote: function( postSaveOfNewNoteSentToOtherUser ) {
	
	
	        this.$el.stop(true);
	
	        /*
	        * Enter the 'delete note' workflow to remove from collections, update note counts, etc.
	        * The model's destroy is overridden to not send an http delete request,
	        * so no error will ensue on the server if we enter here from the user
	        * reading its contents (the note was already destroyed on the server in the case).
	        * */
	        this.channel.trigger( 'noteView:flashNoteDestruct', this.model );
	
	        /*
	        * (Want to go through higher level active note process -- not just the delete)
	        * It appears we treat 'open' notes as the active note.
	        * TODO: should prob combo this with the above in one workflow?
	        * DVBC-1619 -- don't do if called from successful save of note not created for current user ( changeActiveNote already fired ).
	        * ( active note is checked in subscriptionCallbacks.notes:setActiveNote and it will be null -- prevent from entering that,
	        *  it doesn't make sense here anyway ).
	        * */
	
	        if ( !postSaveOfNewNoteSentToOtherUser ) {
	            // Active Note Already Changed Here -- set to null -- don't need to go through workflow again
	            this.channel.trigger( 'notes:changeActiveNote', null, { flashNoteDestructed: true} );
	        }
	
	    },
	    _stopFlashingIcon: function() {
	        this.ui.flashIcon.stop(true); //(remove from queue)
	    },
	    // should this be blowup?
	    onDestroy: function() {
	
	        this._stopFlashingIcon();
	        this.$timer && this.$timer.stop(true).remove();
	        NoteView.prototype.destroy.call(this);
	
	    }
	});

/***/ },
/* 281 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Effects Explode 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Explode Effect
	//>>group: Effects
	// jscs:disable maximumLineLength
	//>>description: Explodes an element in all directions into n pieces. Implodes an element to its original wholeness.
	// jscs:enable maximumLineLength
	//>>docs: http://api.jqueryui.com/explode-effect/
	//>>demos: http://jqueryui.com/effect/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(59),
				__webpack_require__(65),
				__webpack_require__(64)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	return $.effects.define( "explode", "hide", function( options, done ) {
	
		var i, j, left, top, mx, my,
			rows = options.pieces ? Math.round( Math.sqrt( options.pieces ) ) : 3,
			cells = rows,
			element = $( this ),
			mode = options.mode,
			show = mode === "show",
	
			// Show and then visibility:hidden the element before calculating offset
			offset = element.show().css( "visibility", "hidden" ).offset(),
	
			// Width and height of a piece
			width = Math.ceil( element.outerWidth() / cells ),
			height = Math.ceil( element.outerHeight() / rows ),
			pieces = [];
	
		// Children animate complete:
		function childComplete() {
			pieces.push( this );
			if ( pieces.length === rows * cells ) {
				animComplete();
			}
		}
	
		// Clone the element for each row and cell.
		for ( i = 0; i < rows; i++ ) { // ===>
			top = offset.top + i * height;
			my = i - ( rows - 1 ) / 2;
	
			for ( j = 0; j < cells; j++ ) { // |||
				left = offset.left + j * width;
				mx = j - ( cells - 1 ) / 2;
	
				// Create a clone of the now hidden main element that will be absolute positioned
				// within a wrapper div off the -left and -top equal to size of our pieces
				element
					.clone()
					.appendTo( "body" )
					.wrap( "<div></div>" )
					.css( {
						position: "absolute",
						visibility: "visible",
						left: -j * width,
						top: -i * height
					} )
	
					// Select the wrapper - make it overflow: hidden and absolute positioned based on
					// where the original was located +left and +top equal to the size of pieces
					.parent()
						.addClass( "ui-effects-explode" )
						.css( {
							position: "absolute",
							overflow: "hidden",
							width: width,
							height: height,
							left: left + ( show ? mx * width : 0 ),
							top: top + ( show ? my * height : 0 ),
							opacity: show ? 0 : 1
						} )
						.animate( {
							left: left + ( show ? 0 : mx * width ),
							top: top + ( show ? 0 : my * height ),
							opacity: show ? 1 : 0
						}, options.duration || 500, options.easing, childComplete );
			}
		}
	
		function animComplete() {
			element.css( {
				visibility: "visible"
			} );
			$( pieces ).remove();
			done();
		}
	} );
	
	} ) );


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	/**
	 * TODO: include specific css here
	 * override some, which breaking core note model that will need to change anyway
	 */
	
	var FlashNote = __webpack_require__(280),
	    NoteView = __webpack_require__(155);
	
	module.exports = FlashNote.extend({
	
	    onRender: function() {
	
	        FlashNote.prototype.onRender.apply(this, arguments); /* note: always new */
	
	        this.$el.addClass('flashback edit-mode');
	        this.ui.noteHeader.remove();
	        this.ui.emailWr.prependTo(this.ui.submitRow);
	
	        this.recipientIsCurrentUser =
	            this.model.get('accessGroup') === this.options.channel.request('notes:getUserPrivateID');
	
	        this.recipientIsCurrentUser &&
	            this.ui.emailWr.addClass('hide');
	
	        this.delegateEvents();
	        this.bindKeyboardEvents(); //(delegate turns them off ... this should all be cleaned up)
	
	        setTimeout( _.bind( function() {
	            this.ui.textArea.focus();
	        }, this), 0);
	
	    },
	
	    // temp override since not reading from DOM
	    _recipientIsCurrentUser: function() {
	
	        return this.recipientIsCurrentUser;
	
	    },
	
	    templateHelpers: _.extend( {}, FlashNote.prototype.templateHelpers, {
	
	        isFlashBackNote: function() {
	            return true;
	        }
	
	    }),
	
	    // TODO: fix up -- interferes with delegateCollapsibleHandlers -- (mousedown)
	    events: {
	        'mousedown @ui.okBtn':      'save', /* mousedown caught b/f click -- even though the parent */
	        'mousedown @ui.cancelBtn':  'cancel'
	    },
	    /* need to override these ..... trigger event from the view to the collection view .... */
	    keyboardEvents: {
	
	        'shift+enter':  function() {
	            NoteView.prototype.keyboardEvents['shift+enter'].apply(this, arguments);
	           this.save();
	        },
	        'esc': function() {
	            //note --- a string so the fn application will err --- not needed here anyway
	            this.cancel();
	        }
	
	    },
	    /* don't change the activeNote -- (its still the parent, these are an outlier */
	    save: function() {
	        this.options.channel.trigger('noteView:enterSave', this);
	    },
	
	    // Note: no need to worry about active note
	    cancel: function() {
	
	        this.options.parentView.uiModel.set('replyMode', false);
	    }
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(59);
	var DocNote = __webpack_require__(277);
	
	module.exports = DocNote.extend({
	    desc: "Activity",
	    actionTitle: 'Activity',
	    iconClass: 'icon-clipboard',
	    init: 'A',
	    notCreatable: true
	});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var PageNote = __webpack_require__(152);
	
	
	
	module.exports = PageNote.extend({
	    init: 'T',
	    desc: 'Page Text Note',
	    createHotKey: 't',
	    actionTitle: 'Page Text Note',
	    iconClass: 'icm-type',
	    autoDisplayApplies: false,
	    isText: true, // flag determining if doc/pg note if a 'text note'
	    consultsApplicable: false, // could apply to non drawable note types, but I think we only care about drawable ones here; a change would necessitate change in the slop note ui
	
	    /**
	     * DVBC-1299: currently auto display has no meaning for page text notes DV,
	     * ( it only means showing the shapes of drawable notes ).
	     * But leave this here is cause it ever does.  Unlike drawable notes, a value of null ( new notes )
	     * or 'V' ( existing notes ) implies that autoDisplay should apply ( if there's ever a need ).
	     */
	    applyAutoDisplay: function() {
	
	        var noteStatus = this.get('noteStatus');
	        return noteStatus === null || noteStatus === 'V';
	
	    }
	
	
	});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var PageTextNote = __webpack_require__(285);
	
	module.exports = PageTextNote.extend({
	    init: 'K',
	    // like html notes, don't allow to create; all will be sent to server with type 'T'
	    // and if 'autoUtr' prop of container (bin/FC) is true, will be sent back down as type 'K'
	    notCreatable: true, 
	    /* for the view, apply the same class as the text note */
	    getNoteClass: function() {
	        return PageTextNote.prototype.getNoteClass();
	    }
	});


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var CoordinateNote = __webpack_require__(150),
	    HighlightShapeModel = __webpack_require__(288),
	    HighlightNoteView = __webpack_require__(289);
	
	
	
	module.exports = CoordinateNote.extend({
	
	    SUPPORTS_FIND_AND_REDACT: true,
	
	    init: 'H',
	    desc: 'Highlight',
	    createHotKey: 'h',
	    actionTitle: 'Highlight',
	    iconClass: 'icon-pencil-6',
	    defaultShapeColor: '#FFF600',
	    ShapeModel: HighlightShapeModel,
	    ViewConstructor: HighlightNoteView
	
	});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var CoordinateShape = __webpack_require__(253);
	
	module.exports = CoordinateShape.extend({
	
	});

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DrawablePageNoteView = __webpack_require__(179);
	
	
	module.exports = DrawablePageNoteView.extend({
	
	
	    serializeData: function() {
	
	        var context =
	            DrawablePageNoteView.prototype.serializeData.apply( this, arguments );
	
	        context.allowModifyOrDelete =
	            context.viewerChannel.request('allowModifyOrDeleteHighlight');
	
	        return context;
	
	    },
	
	
	    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {
	
	        includeEditBtn: function() {
	
	           return this.allowModifyOrDelete;
	
	        },
	
	        includeDeleteBtn: function() {
	
	            return this.allowModifyOrDelete;
	
	        }
	
	    })
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var PageNote = __webpack_require__(152);
	
	module.exports = PageNote.extend({
	    init: 'G',
	    desc: 'Graphic',
	    iconClass:  'icon-picture',
	    notCreatable: true,
	    getNoteClass: function(isSVG) {
	        var c = PageNote.prototype.getNoteClass.call(this);
	        return isSVG
	            ? c
	            : c + ' ' + c + '-FDD';
	    },
	    getIconHoverLbl: function(isSVG) {
	        var l = PageNote.prototype.getIconHoverLbl.call(this);
	        return isSVG
	            ? l
	            : 'Legacy FDD ' + l + '\n' + '(Not rendered on page)';
	    }
	});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Raphael = __webpack_require__(182),
	    SVGNote = __webpack_require__(292),
	    TextShapeView = __webpack_require__(294),
	    GraphicShapeView = __webpack_require__(215),
	    FDDGraphicNote = __webpack_require__(290),
	    GraphicShapeModel = __webpack_require__(295),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = SVGNote.extend({
	
	    SUPPORTS_COLOR_PICKER: 1,
	
	    ShapeModel: GraphicShapeModel,
	    init: 'V',
	    createHotKey: 'g',
	    desc: FDDGraphicNote.prototype.desc,
	    iconClass: FDDGraphicNote.prototype.iconClass,
	    actionTitle: 'Draw',
	    defaultSubType: 'free',
	
	    /**
	     * defaultShapeColor:
	     *  DVBC-1779: INSCOM wants black -- was:
	     *  #0064CD, blue, like the note view color from SVG graphic notes
	     *  this should change when define attributes at the shape level
	     *  or at least come from central setting file -- in case needs to be overwritten
	     */
	    defaultShapeColor: '#000000',
	    defaultStrokeWidth: 2, // stroke width to apply to newly drawn shapes
	
	    subTypes: ['free', 'rect-fill', 'rect-nofill', 'line', 'line-dashed', 'line-arrow', 'text'], // could have another level-- sub-sub type
	    DEFAULT_FILL_OPACITY: {
	        'fill-opacity': 0.25 // (it's lighter than the stroke)
	    },
	    getNoteClass: function() {
	       return FDDGraphicNote.prototype.getNoteClass(1);
	    },
	    getIconHoverLbl: function() {
	        return FDDGraphicNote.prototype.getIconHoverLbl(1);
	    },
	    shapeView: function(options) {
	
	        // This needs review
	        // Really need to stop deriving the shape models !
	        var sm = options.shapeModel,
	            preExisting = sm.uiModel.get('raphaelEl') === null && sm.origSVGAttrs !== undefined, //(existed on canvas render)
	            shapeType = preExisting
	                ? sm.determineGraphicNoteShapeSubType( sm.origSVGAttrs )
	                : sm.deriveShapeSubType();
	
	        switch(shapeType) {
	            case 'text':
	                return new TextShapeView(options);
	            default:
	                return new GraphicShapeView(options);
	        }
	
	    },
	
	    /**
	     * Probably best to always store the subtype on the shape
	     */
	    defaultSVGAttrsEdit: function( color, noteSubType, currentDrawingAttrs ) {
	
	        // Hack! NEED TO OVERRIDE CURRENT DRAWING ATTRIBUTE COLOR WITH 'OVERRIDE COLOR'
	        currentDrawingAttrs.color = color;
	
	        var attrs = this._getBaseSVGAttributes( currentDrawingAttrs );
	
	        switch( noteSubType ) {
	
	            case 'rect-nofill':
	                attrs['fill-opacity'] = 0; //alter the opacity to 0 -- its see through but mouseover will still work
	                _.extend( attrs, {'stroke-linejoin': 'miter'} );
	                break;
	
	            case 'line':
	                attrs = _.omit(attrs, 'fill-opacity');
	                break;
	
	            case 'line-dashed':
	                attrs = _.omit(attrs, 'fill', 'fill-opacity');
	                _.extend( attrs, {'stroke-dasharray': '- '} );
	                break;
	
	            case 'line-arrow':
	                attrs = _.omit(attrs, 'fill', 'fill-opacity');
	                _.extend( attrs, {'arrow-end': 'block-wide-long'} );
	                break;
	
	            case 'free':
	                attrs = _.omit(attrs, 'fill', 'fill-opacity');
	                _.extend( attrs, {'stroke-linejoin': 'round'} );
	                break;
	
	            case 'rect-fill': //nothing for now
	                _.extend( attrs, {'stroke-linejoin': 'miter'} );
	                break;
	
	            case 'text':
	                attrs = { // this would be for the text-area, which is then later applied to the svg shape
	                    color: attrs.color
	                };
	                break;
	        }
	
	        return attrs;
	
	    },
	
	    _getBaseSVGAttributes: function( currentDrawingAttrs ) {
	
	        var o = _.pick( currentDrawingAttrs , 'stroke-width'),
	            color = currentDrawingAttrs.color; // applicable to stroke & fill
	
	        _.extend( o, {
	            stroke: color,
	            fill: color
	        }, this.DEFAULT_FILL_OPACITY );
	
	        return o;
	
	    },
	
	    getDefaultStrokeWidth: function() {
	        return this.defaultStrokeWidth;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Raphael, $, _) {var DrawableNote = __webpack_require__(151);
	
	__webpack_require__(293);
	
	
	
	module.exports = DrawableNote.extend({
	
	    setOriginalShapeAttrsOnParse: function( response ) {
	        this.originalShapeAttrs = response.text;
	    },
	
	    resetShapeAttrsOnCancelChanges: function() {
	        this.set( 'text', this.originalShapeAttrs );
	    },
	
	    hasShapes: function() {
	        return this.get('text') && this.get('text').length > 0;
	    },
	
	    // put this on parse of the note models ?
	    shapeModelsToRender: function( page ) {
	
	        var shapes,
	            r_shapeSet,
	            svg = this.get('text');
	
	        // DVBC - 1184: fix to import back in arrows
	        // sets the svg defs (if SVG ... could probably not do if VML but I dont think we care about that anymore),
	        // which would otherwise be undefined on if called on Raphael.fn ... (Raphael.fn is a paper)
	        // perhaps just pass in a canvas obj here, but then would need to change WF / timing (now the shape models are created prior to canvas view creation)
	        // will fix issue rendering arrow shapes on import -- addArrow relies on this being defined,
	        // though the svg export would still not output the arrow shapes (if rendered by the CRE)
	        // put the custom attributes on here (see notes atop canvas where put on Raphael.fn ...
	        // would this break anything outside the viewer's div? -- R._engine.create ...
	        //  R._g.doc.body.appendChild(c); -- appends to body with position absolute at 0,0 so its out of the flow of the doc
	        // if anything probably a flicker ... maybe position it offscreen ... this is is in a model ...
	        // if becomes a problem can change order and use existing paper (draw it first), passIn FV wr and have it append to that div, change css to offscreen
	        // keep outlining WF to see whats best
	
	        var dummyPaper = Raphael(0, 0, 0, 0);
	        dummyPaper.customAttributes = Raphael.fn.customAttributes; //need to apply the customAttributes to apply shape-type in parseElement
	
	        /* err handling: ensure the svg is not blank or error will result) */
	        if ( svg === '' || !svg )
	            return;
	
	
	        /* raphael will get rid of the data type attribute, will need to put back */
	        r_shapeSet = dummyPaper.importSVG( $(svg)[0], {
	
	            // each model could have a parseElement -- though its probably wanted at the subtype level
	            // it now recognizes data-* attributes but this was done before ( and the one here is not a data-attribute )
	            parseElement: function(raphaelEl, domEl) {
	                // domEl will have the shapeType attr as persisted in it's html;
	                // raphaelEl will have been removed at this point, so but it back for future reference as a custom-attribute
	                var shapeType = domEl.getAttribute('shape-type');
	                shapeType && raphaelEl.attr('shape-type',shapeType);
	                return raphaelEl;
	            }
	
	        });
	
	        shapes = _.map( r_shapeSet, function( r_shape, i ) {
	
	            return new this.ShapeModel( r_shape.attrs, {
	                parentNote: this,
	                pageModel: page,
	                shapeIndexOfNote: i
	            });
	
	        }, this);
	
	        /*
	            Note: once removed from the canvas, shapes Raphael properties will be null --
	            however, the properties will be stored on the originalSVG attributes of the model
	         */
	
	        r_shapeSet.remove();
	        dummyPaper.remove();
	
	        return shapes;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182), __webpack_require__(59), __webpack_require__(49)))

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, Raphael) {/*
	* Raphael SVG Import Classic Copyright (c) 2013 Chris Chang, Ingvar Stepanyan
	* Original Raphael SVG Import Copyright (c) 2009 Wout Fierens
	* Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
	*
	*/
	
	
	/**
	 * Fork notes: 2/21/22
	 * - with Graphic stamps a number of changes made but this library is no longer relevant/maintained,
	 * - and changes made as necessary
	 * - Changes:
	 *    - a null check on group transforms
	 *    - Support to read in text with multiple lines
	 *    - import certain properties as numbers
	 * -
	 */
	
	/* global Raphael */
	Raphael.fn.importSVG = function (svgXML, options) {
	  "use strict";
	  var myNewSet = this.set();
	  var groupSet = {};
	  var defaultTextAttr = {
	    // stroke: "none"
	    "text-anchor": "start"  // raphael defaults to "middle"
	  };
	
	
	  this.parseElement = function(elShape) {
	    // skip text nodes
	    if (elShape.nodeType === 3) {
	      return;
	    }
	    var attr = {"stroke": "none", "stroke-width": 1, "fill":"black"},
	        shapeName = elShape.nodeName,
	        i, n, key, shape;
	
	    if (elShape.attributes) {
	      for (i = 0, n = elShape.attributes.length; i < n; i++) {
	        attr[elShape.attributes[i].name] = elShape.attributes[i].value;
	      }
	    }
	    switch(shapeName) {
	      case "svg":
	      case "g":
	        var groupId = elShape.getAttribute('id');
	        var groupClass = elShape.getAttribute('class');
	        if (groupId || groupClass) {
	          var elShapeChildren = elShape.childNodes;
	          for (i = 0, n = elShapeChildren.length; i < n; i++) {
	            var elShapeChild = elShapeChildren[i];
	            if (elShapeChild.nodeType === 3) {
	              // skip text nodes
	              continue;
	            }
	            if (groupId) {
	              // FIXME data-* attrs are not part of the SVG spec
	              elShapeChild.setAttribute('data-svg-group', groupId);
	            }
	            if (groupClass) {
	              elShapeChild.setAttribute('class', (elShapeChild.getAttribute('class') || '') + ' ' + groupClass);
	            }
	          }
	        }
	        var thisGroup = this.set();
	        for (i = 0, n = elShape.childNodes.length; i < n; i++) {
	          thisGroup.push(this.parseElement(elShape.childNodes.item(i)));
	        }
	
	        // handle transform attribute
	        if (attr.transform){
	          var match = /translate\(([^,]+),([^,]+)\)/.exec(attr.transform);
	
	          if (match) { // ben: null check
	            if (match.length == 3){
	              thisGroup.translate(match[1], match[2]);
	            }
	          }
	
	
	
	        }
	
	        // handle display=none
	        if (attr.display === "none") {
	          thisGroup.hide();
	        }
	        // hold onto thisGroup just in case
	        if (groupId && elShape.childNodes.length) {
	          groupSet[groupId] = thisGroup;
	        }
	        return;
	      case "rect":
	        if (attr.rx && attr.ry) {
	          attr.r = (+(attr.rx || 0) + (+(attr.ry || 0))) / 2;
	          delete attr.rx;
	          delete attr.ry;
	        } else {
	          attr.r = attr.rx || attr.ry || 0;
	          delete attr.rx;
	          delete attr.ry;
	        }
	        /* falls through */
	      case "circle":
	      case "ellipse":
	        shape = this[shapeName]();
	      break;
	      case "path":
	        shape = this.path(attr.d);
	        delete attr.d;
	      break;
	      case "polygon":
	        shape = this.polygon(attr);
	      break;
	      case "polyline":
	        shape = this.polyline(attr);
	      break;
	      case "line":
	        shape = this.line(attr);
	      break;
	      case "image":
	        shape = this.image();
	      break;
	      case "text":
	
	        for (key in defaultTextAttr){
	          if (!attr[key] && defaultTextAttr.hasOwnProperty(key)) {
	            attr[key] = defaultTextAttr[key];
	          }
	        }
	
	        /**
	         * Solution for multiple lines -- reading in from the t-spans;
	         * This plugin doesn't support.
	         */
	
	        var txt = '';
	        var tspans = elShape.childNodes; // ( even if only one line, it's input into a tspan )
	
	        tspans = Array.prototype.slice.call( tspans ); // ( for IE )
	
	        tspans.forEach( function( tspan ) {
	            txt += tspan.textContent + '\n'; // Text Content For IE
	        });
	
	        txt = txt.slice( 0, -1 );
	
	        shape = this.text( parseFloat(attr.x), parseFloat(attr.y), txt);
	
	        // also set dy in case -- could expand to other attributes
	        var newShapeSpans = shape.node.childNodes;
	        newShapeSpans = Array.prototype.slice.call( newShapeSpans ); // (IE)
	
	        newShapeSpans.forEach( function( newTspan, i) {
	
	          newTspan.setAttribute('dy', parseFloat(tspans[i].getAttribute('dy')) );
	
	        });
	
	
	      break;
	      default:
	        var elSVG = elShape.getElementsByTagName("svg");
	        if (elSVG.length){
	          elSVG[0].normalize();
	          this.parseElement(elSVG[0]);
	        }
	        return;
	    }
	
	    // apply matrix transformation
	    var matrix = attr.transform;
	    if (matrix) {
	      // strip `matrix(...)` text and then tokenize
	      matrix = matrix.substring(7, matrix.length-1).split(' ');
	      // cast matrix elements, parseFloat don't care if there's commas or not
	      for (var idx in matrix) {
	        matrix[idx] = parseFloat(matrix[idx]);
	      }
	
	      var m = shape.matrix;
	      m.add.apply(m, matrix);
	      // this seems like a very odd step:
	      shape.transform(m.toTransformString());
	      delete attr.transform;
	
	    }
	
	    // Raphael throws away the `style` attribute; re-interpret it.
	
	    if (attr.style) {
	      var styleBits = attr.style.split(';'),
	          styleBitBits;
	      for (i = 0; i < styleBits.length; i++) {
	        styleBitBits = styleBits[i].split(':');
	        key = $.trim(styleBitBits[0]);
	        if (key) {
	          attr[key] = $.trim(styleBitBits[1]);
	        }
	      }
	    }
	
	    // Ben: -- do this after the style -- ensure attributes that Raphael expects to be numbers are not strings.. this can lead to issues
	    // Adding as I go ... here just added for text-elements
	    var numericAttributes = [ 'font-size', 'opacity', 'stroke-width', 'x', 'y' ];
	    numericAttributes.forEach( function(na) {
	
	      if ( attr[na] ) {
	        attr[na] = parseFloat( attr[na] );
	      }
	    } );
	
	    shape.attr(attr);
	
	    // copy group id
	    var shapeClass = elShape.getAttribute('class');
	    if (shapeClass) {
	      shape.node.setAttribute('class', (shape.node.getAttribute('class') || '') + ' ' + shapeClass);
	    }
	    // FIXME data-* attrs are not part of the SVG spec
	    shape.node.setAttribute('data-svg', shapeName);
	
	    var group = elShape.getAttribute('data-svg-group');
	    if (group) {
	      // FIXME data-* attrs are not part of the SVG spec
	      shape.node.setAttribute('data-svg-group', group);
	    }
	
	    var nodeID = elShape.getAttribute("id");
	    if (nodeID) {
	      shape.node.id = nodeID;
	    }
	
	    if (options && options.parseElement) {
	      shape = options.parseElement(shape, elShape);
	    }
	
	    if (shape) {
	      myNewSet.push(shape);
	    }
	
	    return shape;
	  };
	
	  this.parseElement(svgXML);
	
	
	  // TODO add tests for svg style attr functionality
	  var forEach = Function.prototype.bind && Array.prototype.forEach ? Function.prototype.call.bind(Array.prototype.forEach) : function (arr, callback) {
	    for (var i = 0, length = arr.length; i < length; i++) {
	      callback(arr[i], i, arr);
	    }
	  };
	  var paper = this;
	
	  forEach(svgXML.getElementsByTagName('style'), function (xmlStyle, i) {
	    var domStyle = document.createElement('style'), css = xmlStyle.textContent || xmlStyle.text;
	    domStyle.type = 'text/css';
	    document.head.appendChild(domStyle);
	    var rules;
	    if (domStyle.styleSheet) {
	      domStyle.styleSheet.cssText = css;
	      rules = domStyle.styleSheet.rules;
	    } else {
	      domStyle.appendChild(document.createTextNode(css));
	      rules = domStyle.sheet.cssRules;
	    }
	    forEach(rules, function (rule) {
	      var style = rule.style, elements = document.querySelectorAll(rule.selectorText), attrs = {};
	      for (var name in Raphael._availableAttrs) {
	        var value = style[name];
	        if (!value) continue;
	        // fix for Chrome
	        attrs[name] = typeof Raphael._availableAttrs[name] === 'number' ? parseFloat(value) : value;
	      }
	      forEach(elements, function (element) {
	        paper.getById(element.raphaelid).attr(attrs);
	      });
	    });
	  });
	
	
	  var groupsExist = false, x;
	  for (x in groupSet){
	    groupsExist = true;
	    break;
	  }
	  if (groupsExist) {
	    myNewSet.groups = groupSet;
	  }
	  return myNewSet;
	};
	
	
	Raphael.fn.line = function(attr){
	  var pathString = ["M",
	                    attr.x1,
	                    attr.y1,
	                    "L",
	                    attr.x2,
	                    attr.y2,
	                    "Z"];
	  delete attr.x1;
	  delete attr.y1;
	  delete attr.x2;
	  delete attr.y2;
	  return this.path(pathString);
	};
	
	
	// extending raphael with a polygon function
	Raphael.fn.polygon = function(attr) {
	  var pointString = attr.points;
	  var poly = ['M'],
	      point = pointString.split(' ');
	
	  for(var i=0; i < point.length; i++) {
	     var c = point[i].split(',');
	     for(var j=0; j < c.length; j++) {
	        var d = parseFloat(c[j]);
	        if (!isNaN(d))
	          poly.push(d);
	     }
	     if (i === 0)
	      poly.push('L');
	  }
	  poly.push('Z');
	  delete attr.points;
	  return this.path(poly);
	};
	
	
	Raphael.fn.polyline = function(attr) {
	  var pointString = attr.points;
	  var poly = ['M'],
	      point = pointString.split(' ');
	
	  for(var i=0; i < point.length; i++) {
	     var c = point[i].split(',');
	     for(var j=0; j < c.length; j++) {
	        var d = parseFloat(c[j]);
	        if (!isNaN(d))
	          poly.push(d);
	     }
	     if (i === 0)
	      poly.push('L');
	  }
	  delete attr.points;
	  return this.path(poly);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(182)))

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* B/C done after already rendered */
	
	var GraphicShapeView = __webpack_require__(215);
	
	module.exports = GraphicShapeView.extend();
	
	/* note: took out btn for selecting edit options -- not used */
	


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var Raphael = __webpack_require__(182),
	    ShapeModel = __webpack_require__(254),
	      _ = __webpack_require__(49);
	
	
	module.exports = ShapeModel.extend({
	
	    DISABLED_RAPHAEL_ATTRS:  {
	        opacity: 0.5
	    },
	    ENABLED_RAPHAEL_ATTRS: {
	        opacity: 1.0
	    },
	    /*
	    * Base shape attrs don't apply here; these are the Raphael attributes.
	    * Store the attributes on this.origSVGAttrs.
	    * */
	    parse: function( raphaelAttrs, options ) {
	
	        /*
	        * Note: origSVGAttrs not set if shape isNewlyDrawn in current workflow (shouldn't matter)
	        * Could make this a model attribute now.
	        * */
	        this.origSVGAttrs = raphaelAttrs;
	
	        /*
	        * Call parse on baseShape to set instance variables but return none for this shape type.
	        * Invoke for flexibility and to set instance variables.
	        * Note: need to pass in attributes for anything set based on raphaelAttrs.
	        * When refactor: move everything from the shapeModel parses to the constructor.
	        * */
	        var attrs = ShapeModel.prototype.parse.apply(this, arguments);
	
	        /* Only return the uid -- now that we are using that*/
	        return {
	            uid: attrs.uid
	        };
	
	    },
	
	    /*
	    * All the shape types have a stroke except signatures (they use fill)
	    * May be better to store as custom attribute in the SVG
	    * For now not an issue for signatures because their color can't be over-written
	    *
	    * This could later be broken up using a fn ala 'getZoneColorOnParse' but,
	    * for now I think code is clearer having the logic in one place;
	    * and especially in case I start storing a color custom attribute and/or
	    * I implement the ability to change signature note color.
	    * Note: now subclassed for text stamp;
	    * TODO: break this up now that it's already different for text stamp
	    * */
	    setZoneColorOnParse: function( raphaelAttrs, options ) {
	
	        var isSignature =
	            options.parentNote.isSignature();
	
	        var color = !options.isNewlyDrawn
	
	            ? isSignature
	                ? raphaelAttrs.fill
	                : raphaelAttrs.stroke
	
	            : isSignature
	                // now they are all black -- quick hack in lieu of letting user change their color
	                ? options.parentNote.getDefaultShapeColor()
	                /*
	                 * The visible color of the shape may have been overridden.
	                 * set from currentDrawingAttributes --- it must have been created with this color
	                 * ( also, no raphael attributes are passed in here ).
	                 * */
	                : options.channel.request('getCurrentDrawingAttributes').color; // for newly drawn notes, options.channel is passed in
	
	        this.setZoneColor( color );
	
	    },
	
	    /**
	     * Secondary enabled/disabled ... of other graphic notes other than active one on same canvas.
	     * TODO: put this on the ui model / view
	     */
	    setDisabled: function() {
	        var ui = this.uiModel,
	            rEl = ui.raphaelEl(),
	            lastAttrs = rEl.attrs,
	            newAttrs = _.extend( {}, lastAttrs, this.DISABLED_RAPHAEL_ATTRS);
	        ui.lastAttrs = lastAttrs;
	        ui.raphaelEl().attr(newAttrs);
	    },
	    setEnabled: function() {
	        var ui = this.uiModel;
	        ui.raphaelEl().attr( _.extend({}, ui.lastAttrs, this.ENABLED_RAPHAEL_ATTRS) );
	         _.omit(ui, 'lastAttrs');
	    },
	
	    getNormalizedElToPerist: function() {
	
	        var el = this.uiModel.get('raphaelEl'),
	            path = Raphael.fn.viewerUnadjustedPath.apply( Raphael.fn, [el.attr('path')].concat( _.toArray(arguments)) ),
	            clone = el.clone();
	
	        clone.attr('path', path);
	        clone.attrs =  _.omit(clone.attrs, 'cursor'); // don't persist any cursor attribute
	        clone.setStrokeAndFill( this.getZoneColor() ); // change the color to persist, in case it was overwritten (eg by consult group )
	
	        return clone;
	
	    },
	    /*
	    * Called from view.renderFromModel (model > el)
	    * Adjusts for scale, rotation ... no dpi, conversion coordinate)
	    * */
	    getPathToRenderFromModel: function(scale) {
	
	        var pg = this.pageModel;
	
	        return Raphael.fn.viewerAdjustedPath(
	            this.origSVGAttrs.path,
	            scale,
	            pg.get('rotation'),
	            pg.getOriginalCenterPtRotated(scale) //don't need if rotation
	        );
	
	    },
	
	    /**
	     * Note: not using the central getAttributesToApplyToShapeEl ...
	     */
	    getNonPathInactiveSVGAttrs: function( canvasChannel ) {
	
	        var attrs = _.omit( this.origSVGAttrs, 'path' );
	
	        var color = canvasChannel.request( 'getColorToApplyToShape', this.parentNote, this, false );
	
	        if (color) {
	            attrs.fill && attrs.fill !== 'none' && ( attrs.fill = color );
	            attrs.stroke && attrs.stroke !== 'none' && ( attrs.stroke = color );
	        }
	
	        return attrs;
	
	    }
	
	});

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var GraphicNote = __webpack_require__(291),
	    SignatureShapeView = __webpack_require__(211),
	    BaseSVGNote = __webpack_require__(292),
	    SignatureShapeModel = __webpack_require__(297);
	
	
	/**
	 * This should probably extend BaseSVGNote and mix-in GraphicNote properties as applicable
	 * instVars
	 * - bottomTextModel
	 */
	
	
	module.exports = GraphicNote.extend({
	
	    SUPPORTS_COLOR_PICKER: 0,
	
	    ShapeModel: SignatureShapeModel,
	    ViewConstructor: __webpack_require__(298),
	    init: 'X',
	    desc: "Signature",
	    createHotKey: 's',
	    actionTitle: 'Sign',
	    iconClass: 'icm-quill',
	    defaultSubType: 'signature',
	    getNoteClass: BaseSVGNote.prototype.getNoteClass,
	
	    defaultShapeColor: '#000000',
	
	    defaultSVGAttrsEdit: function( color ) {
	
	        return {
	            fill: color ? color : this.getDefaultShapeColor()
	        };
	
	    },
	
	    shapeView: function(options) {
	        return new SignatureShapeView(options);
	    },
	    /* SHOULD ALWAYS RETURN array of ONE SHAPE */
	    shapeModelsToRender: function(page) {
	        //if bottom text: return 2 GRAPHIC NOTE shapes, otherwise one shape
	        var shapes = BaseSVGNote.prototype.shapeModelsToRender.apply(this, arguments);
	
	        //store the bottom text on the signature shape model
	        var bottomTextShape = _.find(shapes, function(s) {
	            return s.origSVGAttrs['shape-type'] === 'bottomText';
	        });
	
	        // want to know the bottom text but not yet part of shape
	        // it's rendered after where the original should from the model
	
	        if ( !bottomTextShape )
	            return shapes;
	
	        //now doing first but prob best in render ... also the raphael el
	        // store the bottom shape as a property on this model
	        var aSigShape = _.without(shapes, bottomTextShape)[0];
	        this['bottomTextModel'] = bottomTextShape; /* store it on the model -- if there will be check to render on render on the shape*/ //todo: no longer necessary (?)
	        return [aSigShape];
	
	    }
	
	});
	
	
	
	
	
	/*
	
	 // Make signature but incorp in here --
	
	 this['INITIALS'] = PgNote.extend({
	     init: 'I',
	     desc: "Initials",
	     iconClass: 'icm-alertpay',
	     include: false,
	     draw: false,   //?
	     autoDisplayApplies: false
	 });
	
	 */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Raphael = __webpack_require__(182),
		GraphicShape = __webpack_require__(295),
		BottomTxtUIModel = __webpack_require__(221);
	
	
	module.exports = GraphicShape.extend({
	
		//export as 2 shapes -- will be recognized on import and drawn as one
	
		hasCustomizableProperties: 1,
	
		ALLOW_DRAG_OFF_CANVAS: 1,
	
		getNormalizedElToPerist: function() {
	
			var sigEl = GraphicShape.prototype.getNormalizedElToPerist.apply(this, arguments);
			var bt = this.bottomText;
	
			if (!bt)
				return sigEl;
	
	
			/**
			 * Bottom text -- also return to add to set of shapes to save
			 * DVBC-1823 - bakeTransform: when scale changes we don't bake in the transform ( we do on move ) --
			 * Utilize existing bake function on the element so the persisted path takes the transform into account.
			 * Could check for existance of transform and split bakeTransform R.el function to use a separate function that would
			 * return a path if we continue using Raphael in the future.
			 */
			bt.el.bakeTransform();
	
			var btPath = Raphael.fn.viewerUnadjustedPath.apply( Raphael.fn, [bt.el.attr('path')].concat( _.toArray(arguments)) );
	
			//TODO: util --
			var btClone = bt.el.clone();
			btClone.attr('path', btPath);
			btClone.attrs =  _.omit(btClone.attrs, 'cursor'); //remove any cursor attribute on the clone (don't want persisted)
			//the original will be removed on destroy called after save -- and left if there is an error
	
			return [sigEl, btClone];
	
		},
	
		// Don't auto-render the shape because if there is the 'bottom text',
		// combine it into the path of the this shape.
		// The bottom text is stored as a prop on the model, not merged with the path of the shape.
		// (It's stored to know it's position, for re-render with derived values in it's old position, without already rendering).
	
		getPathToRenderFromModel: function(scale) {
	
			var signaturePath = GraphicShape.prototype.getPathToRenderFromModel.apply (this, arguments );
	
			var btModel = this.parentNote.bottomTextModel; //(flag from shapeModelsToRender)
	
			if (btModel) {
	
				var btP = this._getDerivedBottomTextPathFromModel( btModel.origSVGAttrs, scale ); // (takes state into acct)
	
				btModel.origSVGAttrs.path = btP;  //eh -- rid?
	
				signaturePath = signaturePath.concat(btP);
				this.origSVGAttrs.path = signaturePath; //(what is then rendered, if called from shape render) //rid(?)
			}
	
			return signaturePath;
	
		},
	
		_getDerivedBottomTextPathFromModel: function( originalBTAttrs, scale ) {
	
			var btPathAdjusted = Raphael.fn.viewerAdjustedPath(
				originalBTAttrs.path,
				scale,
				this.pageModel.get('rotation'),
				this.pageModel.getOriginalCenterPtRotated(scale)
			);
	
			originalBTAttrs.path = btPathAdjusted;  // TODO: still necessary?
	
			return btPathAdjusted;
	
	
	
		}
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	/*
	*  For now just augment logic to show the delete button.
	*
	* */
	
	var DrawablePageNoteView = __webpack_require__(179),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = DrawablePageNoteView.extend({
	
	
	    templateHelpers: _.extend( _.clone( DrawablePageNoteView.prototype.templateHelpers), {
	
	        /*
	         *  Allow the current user if he created the note / users that belong to group type “ADMINISTRATOR” or “SUPERADMINISTRATOR”
	         *  Note: N/A when note is 'new/creating' and other states.
	         * */
	
	        includeDeleteBtn: function() {
	
	            // First Check 'Base Permission'
	            if ( !DrawablePageNoteView.prototype.templateHelpers.includeDeleteBtn.apply( this, arguments ) )
	                return false;
	
	            var user = fvChannel.request('user'),  // TODO: pass in as param
	                errorOccurredFetchingUserGroups = user.groups.length < 1,
	                userCreatedNote = this.note.get('creationUser') === user.getUserID();
	           
	            return errorOccurredFetchingUserGroups
	                ? userCreatedNote
	                : userCreatedNote ||  _.contains(['SUPERADMINISTRATOR', 'ADMINISTRATOR'], user.groupStatus() );
	
	      } 
	        
	    })
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/* Not a coordinate / SVG shape -- kind of a mixture of the 2 */
	
	var DrawableNote = __webpack_require__(151),
	    GraphicStampShapeView = __webpack_require__(300),
	    GraphicStampShapeModel = __webpack_require__(301),
	    GraphicStampNoteUiModel = __webpack_require__(302),
	    GraphicStampNoteView =  __webpack_require__(303),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = DrawableNote.extend({
	
	    STORES_COLOR: 0,
	
	    NoteUIModel: GraphicStampNoteUiModel, //extending the base here ...
	    ShapeModel: GraphicStampShapeModel,
	
	    init: 'M',
	    desc: 'Graphic Stamp',
	    createHotKey: 'm',
	    actionTitle: 'Graphic Stamp',
	    iconClass: 'icm-stamp', // should get better one: like a 'stamper' ... this is also used in graphic toolbar, would be accessibility issue; icomoon has one's that are premium
	    defaultSubType: 'graphic_stamp',
	    ViewConstructor: GraphicStampNoteView,
	    autoDisplayApplies: false, // FDD saves with I, but they are always shown
	
	    defaultSVGAttrs: function() {
	        return {};
	    },
	    defaultSVGAttrsEdit: function() {
	        return {};
	    },
	    shapeView: function(options) {
	        return new GraphicStampShapeView(options);
	    },
	    shapeModelsToRender: function(page) {
	
	        //note: there will always be one -- one shape per note
	        var shapeModel = new this.ShapeModel( {
	            x: this.get('x'),
	            y: this.get('y'),
	            width: this.get('width'),
	            height: this.get('height'),
	            graphicStampHeader: this.get('graphicStampHeader') // pass in case need it's attributes (eg, w, h, dpi)
	        }, {
	            parentNote: this,
	            pageModel: page,
	            shapeIndexOfNote: 0 // only one
	        });
	
	        return[shapeModel];
	
	    },
	
	    updateAttributesToCreateShapeModelsOnCanvasReRender: function( shapeAttributesOfNote ) {
	
	        DrawableNote.prototype.updateAttributesToCreateShapeModelsOnCanvasReRender.apply( this, arguments );
	
	        /**
	         * Make src an array -- when getting the attributes of the note to save, we only
	         * return the src of the image, which is the src of the selectedStamp from the dropdown.  This
	         * doesn't contain the source at all rotations, and would break the shape view's getImgSource.
	         * If needed could also get from this.uiModel.get('selectedStamp').getImgSrc()
	         */
	
	        this.set( 'src', [ this.get('src') ] );
	
	        /* graphicStampHeader is also never set in the workflow and is necessary to render from model
	        * ( it'd come from the server )
	        * */
	        this.set( 'graphicStampHeader', this.uiModel.getSelectedStampImgHeader() );
	
	    },
	
	    // the the src of the image given the requested rotation
	    getImgSource: function(rotation) {
	
	        var src = this.get('src');
	
	        if (!rotation)
	            return src['0'];
	
	        return src[String(rotation)];
	
	    }
	
	
	});

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {//TODO: now this is the only 'image': if there are more, have extend from a base image prototype (eg maybe legacy graphic notes) ...
	
	var Raphael = __webpack_require__(182),
	    ShapeView = __webpack_require__(181),
	    GraphicShapeView = __webpack_require__(215);
	
	module.exports = ShapeView.extend({
	
	    dontCreateButtonSet: true, // we don't want to the default delete shape button
	    proportionalResize: true, //flag to resize proportionally
	
	    // TODO: these should be subscribed to from the base shape obj, even if not used ... could use noop's
	    shapeSubs: _.extend( {}, ShapeView.prototype.shapeSubs, {
	        'shape.moveEnd':            'onMoveEnd',
	        'shape.resizeEnd':          'resizeEnd',
	        'shape.onAfterBaseScale':   'onAfterBaseShapeScale'
	    }),
	
	    _renderFromModel: function(shapeModel, scale) {
	
	        var sm = this.shapeModel;
	
	        // adjust the path (from the pts array used in coordinate shapes)
	        var pts = sm.getAdjustedPointsArray(scale);
	
	        // get it's bbox to more easily get the dimensions needed to draw the image (especially when dealing with rotation)
	        var box = Raphael.pathBBox( Raphael.fn.getPathFromPtsArray( pts ) );
	
	        var w = box.width,
	            h = box.height;
	
	        // ensure the stamp is printed with the original aspect ratio of the image
	        // ( it could differ from width & height in page_note_info )
	        // must take rotation into account for the aspect ratio !
	        var oAR = sm.getOriginalImgAspectRatio ( sm.pageModel.get('rotation') % 360 ),
	            ar = w / h; // this should already have rotation taken into account (no need to flip)
	
	        if ( oAR > ar ) {
	            h = w / oAR;
	        } else {
	            w = h * oAR;
	        }
	
	        return this.paper.image( sm.getImgUrl(), box.x , box.y , w , h ).attr({
	            opacity: sm.placedOpacity
	        });
	
	    },
	    _scaleShapeEl: function(scale, lastScale) {
	
	        var C = scale / lastScale,
	            el = this.el,
	            attrs = el.attrs;
	
	        el.attr({
	            x: attrs.x * C,
	            y: attrs.y * C,
	            width: attrs.width * C,
	            height: attrs.height * C
	        });
	    },
	
	    onAfterBaseShapeScale: function() {
	        this.resetGlow();
	    },
	
	    onMoveEnd: function() {
	
	        var elMatrixPrimitive = this.el.matrix.split(),
	            elAttrs = this.el.attrs;
	
	        this.el.attr({
	            x: elAttrs.x += elMatrixPrimitive.dx, //TODO rounding, at what?
	            y: elAttrs.y += elMatrixPrimitive.dy
	        }).transform('');
	    },
	    resizeEnd: function() {
	        var box = this.el.getBBox();
	        this.el.attr({
	            width: box.width,
	            height: box.height,
	            // x and y needed for a resize coming from the north or the west
	            x: box.x,
	            y: box.y
	        }).transform('');
	    },
	
	    makeExpandedVisibleIndicator: ShapeView.prototype._createGlow,
	
	    // take out of the part about defaultSVGAttrsEdit and this should be fine ... (only one can be active at a time per note)
	    // would only apply to exiting --- maybe dont need this concept at all; only one can be selected at a time
	    // default SVG attributes also dont apply
	    // note: current workflow assumes coming in from modify ...
	    toggleActive: function() {
	
	        this.el.toFront();
	
	        // don't need to make cursor pointer,
	        // not enabling select -- there's only one: select on entry into edit mode
	        // autodisplay always applies to these
	        // I suppose handle the select here ...
	
	        this.channel.command( 'setSelectedShape', this.shapeModel );
	
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
		Raphael = __webpack_require__(182),
		ShapeUtils = __webpack_require__(197),
		CoordinateShape = __webpack_require__(253);
	
	// Kind of a hybrid 'coordinate' shape: doesn't have 'coordinates' but when read in,
	// converts x, y, width and height values to coordinates to share functions when rendering from model.
	module.exports = CoordinateShape.extend({
	
		glowColor: '#f89406', // defined b/c the image will have no fill or stroke ( not inherited from the shape ) -- orange; same as that used for the stamp note color
		hoverOpacity: 0.5,
		placedOpacity: 0.8, // use this so can see underneath the image -- a 'compromise'
		// all of these can be gotten from the parent note model ... passing in for more clarity ( i guess i used to be much more into brevity )
		defaults: function() {
			return _.extend( {}, CoordinateShape.prototype.defaults.apply(this, arguments) , {
				x: 0,
				y: 0,
				width: 0,
				height: 0,
				graphicStampHeader: null
			});
		},
	
		// Note for new unsaved stamps, parse is called but is really N/A --
		// Page Note Width/Height not yet set, eg.
		parse: function(attrs) {
			attrs = CoordinateShape.prototype.parse.apply(this, arguments);
			attrs.points = this._generatePtsArray(attrs);
	        return attrs;
	
	    },
		// request with the rotation of the page b/c
		// stamps are stored rotated at the 'inverse' rotation of the page in which they were created
		getImgUrl: function() {
			return this.parentNote.getImgSource( this.pageModel.get('rotation') );
		},
	    // Create an array of coordinate pts from the dimensions of the image.
		// This is used to facilitate rendering from the model with the necessary conversion adjustments like Coordinate Shapes
	    _generatePtsArray: function(attrs) {
			var attrs = attrs || this.attributes,
				x = attrs.x,
				x2 = x + attrs.width,
				y = attrs.y,
				y2 = y + attrs.height;
			return [
				{ x: x,  y: y  },
				{ x: x2, y: y  },
				{ x: x2, y: y2 },
				{ x: x,  y: y2 }
			];
	    },
		getAttrsToPersist: function(scale) {
	
			var el = this.uiModel.get('raphaelEl'),
				pg = this.pageModel,
				cc = ShapeUtils.INCHES_TENTHS_MM_TRANS,
				box;
	
			if ( !pg.isCold() ) {
	
				var conv = cc * pg.getDPI();
	
				// get the bbox of the unadjusted path utilizing fn taken from graphic svg shapes
				// especially convenient for get the x, y values if rotation is involved
				box = Raphael.pathBBox( Raphael.fn.viewerUnadjustedPath(
					el.getPathOfBBox(),
					scale,
					pg.get('rotation') % 360,
					pg.originalDimensions(scale),
					pg.getOriginalCenterPtRotated(scale)
				));
	
				// Round to nearest integer -- in the Java code the placement attributes are integers
				// (though that could be a bug; they are type 'number' in Oracle)
				return {
					x: Math.round(box.x / conv),
					y: Math.round(box.y / conv),
					width: Math.round(box.width / conv),
					height: Math.round(box.height / conv),
					src: el.attr('src') //note: this isn't the entire src obj -- never sending that to Java Server so will be removed anyway
				};
	
			} else {
	
				var o = this.pageModel.get('overlay');
	
				//use for convenience (not necessary, especially b/c these pages can't be rotated)
				box = Raphael.pathBBox( el.getPathOfBBox() );
	
				return {
					x: Math.round( ( box.x / cc / scale / 96 ) + ( o.xTextOffset * 254 ) ), // 254 is inches to 1/10 of mm
					y: Math.round( ( box.y / cc / scale / 96 ) + ( o.yTextOffset * 254 ) ),
					width: Math.round( box.width / cc / scale / 96 ) ,
					height: Math.round( box.height / cc / scale / 96 ) ,
					src: el.attr('src') //note: this isn't the entire src obj -- never sending that to Java Server so will be removed anyway
				};
			}
	
		},
		/**
		 * for this shape we don't take cpi/lpi into account
		 * need to account for the overlay offset here
		 * appears could be off here for rounding (like other shapes)
		 * depending on overlay offsets margins, some of the stamp may be cut off or not shown -- DVBC-1391
		**/
		_getColdPageAdjustedPointsArray: function(scale) {
	
			var cc = ShapeUtils.INCHES_TENTHS_MM_TRANS,
				pts = this.get('points'),
				o = this.pageModel.get('overlay');
	
			return _.map(pts, function(p) {
				// ( 96 pixels/inch is sorta like the DPI part of the calculation for image pages )
				return  {
					x: (p.x * scale * cc * 96) - (o.xTextOffset * 96 * scale),
					y: (p.y * scale * cc * 96) - (o.yTextOffset * 96 * scale)
				};
			});
		},
		getOriginalImgAspectRatio: function(pgRotation) {
	
			var ow = this.get('graphicStampHeader').width,
				oh = this.get('graphicStampHeader').length;
	
			if (pgRotation === 90 || pgRotation === 270) {
				ow = this.get('graphicStampHeader').length;
				oh = this.get('graphicStampHeader').width;
			}
	
			return ow / oh;
		}
	});

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var  _ = __webpack_require__(49),
	    NoteUiModel = __webpack_require__(154),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = NoteUiModel.extend({
	
	    defaults: _.extend( {}, NoteUiModel.prototype.defaults, {
	        // the selected stamp on the note view -- really the selected 'new' stamp
	        // also passed into the view on render to tell if which should be selected (if new or if the decide to modify the existing)
	        // TODO: name change here -- something like selectedUnsavedStamp
	
	        // should now always be the getDefaultStampForNewNote, unless the user has no stamps
	        selectedStamp: null
	
	    }),
	    initialize: function(options) {
	
	        NoteUiModel.prototype.initialize.apply(this, arguments);
	
	        var user = fvChannel.request('user'),
	            selectedStamp;
	
	        if ( user.hasGraphicStamps() ) {
	
	            var stamps = user.getGraphicStamps();
	            // in the UI, one is always assumed to be selected (can't be empty) ...  unless there are none)
	            // this will be the first in the list
	            selectedStamp = stamps.getDefaultStampForNewNote();
	            this.set('selectedStamp', selectedStamp);
	
	        }
	    },
	    getSelectedStampImgHeader: function() {
	        return this.get('selectedStamp').get('imageHeader');
	    }
	
	
	
	});


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(304);
	
	var _ = __webpack_require__(49),
	    DrawablePageNoteView = __webpack_require__(179),
	    GraphicStampSelectorView = __webpack_require__(305),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = DrawablePageNoteView.extend({
	
	    initialize: function() {
	
	        DrawablePageNoteView.prototype.initialize.apply(this, arguments);
	        this.stampSelectView = null;
	        this.userChangedSubjectInput = false; //(only applies if the note is new)
	
	    },
	    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {
	
	        isGraphicStamp: function()
	        {
	            return true;
	        },
	
	        // TODO: may need to rid since can't derive the proper page rotation -- awaiting feedback
	        // fyi: 0 in the new response isn't 0 rotation: its the rotation of page at the time it was created
	        stampNoteSrc: function() {
	            return !this.isNew
	                ?  this.note.getImgSource()
	                : ''; // should never get here
	        },
	        subject: function() {
	            return this.isNew
	                ? this.note.uiModel.get('selectedStamp').get('subject') //should always exist, if not, user can't create new stamp note
	                : this.note.getSubject();
	        }
	    }),
	
	    ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {
	        imgSelectPlaceholder:       '[data-stamp-select-holder]',
	        savedImgPreview:            '.savedStampImgPreview'
	    }),
	
	    // use events: triggers are 'forwarded'
	    events: _.extend( {}, DrawablePageNoteView.events, {
	        'keypress @ui.noteSubject'   :   'userChangedNoteSubject'
	    } ),
	
	    userChangedNoteSubject: function() {
	        // tab, arrows (others, etc) won't detect keypress ... could put in more intricate logic to detect if there was a change
	        this.model.isNew() && (this.userChangedSubjectInput = true);
	    },
	
	    onRender: function() {
	        DrawablePageNoteView.prototype.onRender.apply(this, arguments);
	        this._createStampSelectView();
	    },
	
	    _createStampSelectView: function() {
	
	        this.stampSelectView = new GraphicStampSelectorView({
	            graphicStamps: fvChannel.request('user').getGraphicStamps(), // should pass this down for a bit of perf gain ...
	            notesChannel: this.channel, // now not using ... pass for time being ...
	            parent: this,
	            initialStamp: this.uiModel.get('selectedStamp'),
	            noteModel: this.model
	        });
	
	        this.ui.imgSelectPlaceholder.replaceWith( this.stampSelectView.render().el );
	
	    },
	
	    onShow: function() {
	
	        // currently 'super' doesn't have onShow method but call in case it ever does
	        var superOnShow = DrawablePageNoteView.prototype.onShow;
	        superOnShow && superOnShow.apply(this, arguments);
	
	        // pass down the on show method to the child view
	        // this should be a layout/region so we could hook into the events but dont want to break what exist
	        // a better refactor would be to update to MUCH newer version of Marionette, where I believe all views inherit this functionality
	        this.stampSelectView.triggerMethod('show');
	
	    },
	    // ( bubbles from the child view )
	    onUserChangedStamp: function(stamp) {
	
	        this.uiModel.set( 'selectedStamp', stamp, {silent: true} );
	
	        // if a new note, automatically change the subject if the user didn't type put another value in there
	        if ( this.model.isNew() && !this.userChangedSubjectInput )
	            this.ui.noteSubject.val( stamp.get('subject') );
	
	        // select the text of the subject text box as an indication to the user that they may want to change the title
	        // do in a timeout b/c of Chosen.prototype.search_results_mouseup, which will over-write the select
	        // do for new as well as modify to emphasize the change (even though new may change what's in there)
	        setTimeout ( _.bind( function() {
	            this.ui.noteSubject.select();
	        }, this), 250 );
	
	        this.channel.trigger('notes:graphicStampChanged', stamp, this.model);
	
	    },
	    onBeforeDestroy: function() {
	
	        this.stampSelectView.destroy();
	        DrawablePageNoteView.prototype.onBeforeDestroy.apply(this, arguments);
	
	    }
	});


/***/ },
/* 304 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(306);
	
	var Marionette = __webpack_require__(61),
		_ = __webpack_require__(49);
	
	__webpack_require__(163);
	
	module.exports = Marionette.ItemView.extend({
	
		tagName: 'select',
		className: 'graphicStampSelect',
		template: __webpack_require__(307),
	
		initialize: function(options) {
	
			this.graphicStamps = options.graphicStamps;
			this.parent = options.parent; //now assuming tied to the notes view, may not want
			this.noteModel = options.noteModel;
			this.initialStamp = options.initialStamp;
			this.numberOptions = 0;
	
		},
	
		/**
		 * If there are none, will return empty array ( for both stamp types now types now )
		 * TODO
		 * - if there are none, will need to put in that from the stamp note in the view -- THIS MAY BE A BUG ALONG WITH MODIFY ( eg stamp deleted )
		 */
		serializeData: function() {
	
			var myStampDataToPopulateDropdown = this.graphicStamps.getDataToPopulateCreateStampDropDown();
	
			this.numberOptions = myStampDataToPopulateDropdown.length;
	
			return {
				stamps: myStampDataToPopulateDropdown
			};
	
		},
		onRender: function() {
			// set the value of the select before applying chosen plugin
			// there wouldn't be an initial stamp if this.numberOptions = 0, so would get an error setting its value
			this.initialStamp && this.$el.val( this.initialStamp.get('id') );
	
			// disable if there are no more choices to chose from
			if ( this.numberOptions < 2 )
				this.$el.attr('disabled', 'disabled');
	
		},
	
		// for the image extension to work, the view must first be in the DOM,
		// unlike chosen without the extension (or not utilizing it )
		onShow: function() {
	
			this.$el
				.chosen({
					width: '100%',
					placeholder_text_single: 'Select a Stamp...',
					// no option in the image extension to set a class -- it will only take the template
					// here can put in own class name, alternative is to override the predefined styles in node_modules/css ...
					html_template: '<img class="chose-image-stamp" src="{url}" />{text}'
				})
				.on('change', _.bind( this._onStampSelectChange, this) );
	
			// ugh: known issue -- when searching the images disappear: https://github.com/websemantics/Image-Select/issues/29
	
		},
		// maybe want less coupled to parent view, now working on noteUIModel, but that's not a part of this view
		_onStampSelectChange: function(e, params) {
	
			this.parent.triggerMethod( 'userChangedStamp', this.graphicStamps.getStampModelFromId( parseInt( params.selected ) ) );
	
		},
	
		onBeforeDestroy: function() {
			this.$el
				.off()
				.chosen('destroy');
	
		}
	});

/***/ },
/* 306 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <option data-img-src="
	    + alias2(alias1((depth0 != null ? depth0.src : depth0), depth0))
	    + " value=\""
	    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.subject : depth0), depth0))
	    + "</option>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.stamps : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"useData":true});

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var CoordinateNote = __webpack_require__(150),
	    StrikeThroughShapeModel = __webpack_require__(309),
	    ShrikeThroughShapeView = __webpack_require__(310);
	
	module.exports = CoordinateNote.extend({
	
	    init: 'L',
	    desc: 'Strikethrough',
	    createHotKey: 'k',
	    actionTitle: 'Strikethrough',
	    iconClass: 'icon-strike',
	
	    defaultShapeColor: '#000000',
	    defaultFillOpacity: 1, // ( when not editing, these should be opaque )
	
	    ShapeModel: StrikeThroughShapeModel,
	
	    shapeView: function(options) {
	        return new ShrikeThroughShapeView(options);
	    },
	
	    /*
	    *  With this design may want different attributes for different states:
	    *  - creation prior to shrink
	    *  - post shrink
	    *  - resizing shrunken rectangle
	    *  - waiting to see what people think
	    * fill-opacity:
	    *  - rect and highlight are 0.25 -- if left 0.25 and box is small, (and left stroke),
	    *  - the stroke will be the color the user see's and not see through anyway.
	    *  - want see through to some extent: user can see what doing and to denote the active note
	    *  - on the other hand want as dark as possible so it will look like the product ( less confusion )
	    * stroke-width:
	    * - still want a way to differentiate the active shape from others (like with rects and highlights) ...
	    * - Could leave it and make fill transparent but the problem is ihis makes the lines look like rectangles,
	    * - which the aren't.
	    * - an issue is not being able to depict the 'active' note like with the other coordinate shapes without a stroke,
	    * - but I think the trade-off is worse
	    * could give a stroke with a different color but then the 'line' looks like the other color -- too confusing
	    * */
	    defaultSVGAttrsEdit: function() {
	
	        var baseAttrs = CoordinateNote.prototype.defaultSVGAttrsEdit.apply( this, arguments );
	
	        return _.extend( {}, baseAttrs, {
	            'fill-opacity': 0.7 ,
	            'stroke-width': 0
	        });
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var CoordinateShape = __webpack_require__(253);
	
	module.exports = CoordinateShape.extend({
	
	});

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* TODO -- subclass the shape views into coordinate/svg etc
	* */
	
	var BaseShapeView = __webpack_require__(181);
	
	/*
	* PCT_HT_SHRINK:
	* Don wants 0.05 but this seems too small (it's always small -- another case for having a line )*
	* Update: 9/27: Don says bump to 15
	* */
	var PCT_HT_SHRINK = 0.15;
	
	
	module.exports = BaseShapeView.extend({
	
	    // TODO: this would fit better on 'draw end' ... but need to reorganize the draw fn into the shape views classes also ...
	    // ( that would need to come first )
	
	    onAfterRender: function() {
	
	        if ( this.options.shapeModel.uiModel.get('isNewlyDrawn') ) { // Should proxy this through the shape model
	
	            var pgRotation = this.shapeModel.pageModel.get('rotation') % 360,
	                shrinkTransform = pgRotation === 0 || pgRotation === 180
	                    ? 'S1,' + PCT_HT_SHRINK
	                    : 'S' + PCT_HT_SHRINK + ',1';
	
	            this.el
	                .transform( shrinkTransform )
	                .bakeTransform();
	
	        /*
	        * Below animation snippet -- we prob don't want but leaving commented out in case
	        * Introduces problems with synchronicity but it's funny
	        * */
	
	        /*
	            var el = this.el;
	            var self = this;
	            el.animate( { transform:  'S1,' + PCT_HT_SHRINK }, 500, 'bounce', function() {
	                el.bakeTransform();
	                self.trigger('shape.onAfterBaseScale'); // reposition the handles -- would need to reposition them as well -- if did this would need a new name
	
	            });
	
	        */
	        }
	    }
	
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var RedactionNoteModel = __webpack_require__(149),
	    FullPageRedactionNoteView = __webpack_require__(312),
	    FullPageRedactionShapeView = __webpack_require__(316),
	    FullPageRedactionShapeModel =  __webpack_require__(318),
	    ShapeUtils = __webpack_require__(197);
	
	
	/**
	 * this.isConvertingToFloatingCodes should always be false.
	 * init: won't be saved using this -- it's type 'E' -- use to style the same as type D redactions.
	 * This notetype is now the only one we are parsing the shapes models with the note model.
	 * Note: on subsequent parse we now aren't deleting the existing shape models -- as that's causing issues --
	 * see inline comments.
	 */
	
	
	module.exports = RedactionNoteModel.extend({
	
	    SUPPORTS_FIND_AND_REDACT: false,
	
	    ViewConstructor: FullPageRedactionNoteView,
	    desc: 'Full Page Redaction',
	    actionTitle: 'Full Page Redaction',
	    iconClass: 'icon-resize-full-alt-1',//'icon-doc-inv',
	    createHotKey: 'f',
	    init: 'E',
	    subTypes: ['rect'], // TODO: not necessary and these aren't used in the app anymore
	
	    parse: function(response, options) {
	
	        var resp = RedactionNoteModel.prototype.parse.apply( this, arguments );
	
	        // create shapes if new -- can't use isNew yet b/c haven't gone through constructor process
	        // sequence will indicate if the note is new/not
	        if ( !resp.sequence ) {
	
	            // here we create one shape model for the shapes array -- there can only be one for this note type
	            // we can preset the points first b/c its the dimensions of the page
	            var ShapeModel = this.getShapeModel();
	            var pageModel = options.pageModel;
	
	            // Note: last reason codes not set for this noteType b/c of flag on shapeModel,
	            // and also because this shape type is NEVER 'newlyDrawn'.
	            var shape = new ShapeModel(
	                {
	                    points: ShapeUtils.getPointsToSaveFromPageDimensions(pageModel) // ( pixels --> 1/10 mm)
	                },
	                {
	                    // TODO: should be using ID's everywhere; too many references; eg the page has a notesCollection ...
	                    parentNote: this,
	                    pageModel: pageModel,
	                    shapeIndexOfNote: 0 // should only be one
	
	                }
	            );
	
	            this.shapes.push( shape );
	
	        } else {
	
	
	            // If employ for other shape types we may want to destroy any remaining on parse ( a reset ).
	            // But without larger changes now this is problematic: on activeNoteChange (eg edit),
	            // You'd need reset the shape collection ... and/or tie the model from the note to the canvas.
	            // But now its creating errors -- eg raphaelEl is not set after save; you'd need alter canvas/note
	            // Workflow so that canvas is always rendered with the updated shapes, set after parse.
	            /*
	             if ( this.shapes.length > 0) {
	
	                 _.each( this.shapes, function( shape, i ) {
	                 shape.destroy();
	                 }, this);
	
	                 this.shapes = null;
	                 this.shapes = [];
	             }
	             */
	
	            var pageId = resp.pageId,
	                pageModel = options.pageCollection.findWhere({ pageId: pageId });
	
	            this.createShapesFromModelAttributes( resp.shapes, pageModel );
	
	        }
	
	        return resp;
	
	    },
	
	    // Called on parse or on reset
	    // Shapes are the attributes from the model
	    // Could share logic with getShapeModelsToRender from other notetypes
	    createShapesFromModelAttributes: function( shapes, pageModel ) {
	
	        var ShapeModel = this.getShapeModel();
	
	        this.shapes = _.map( shapes, function( shape, i ) {
	
	            return new ShapeModel( shape, {
	                parentNote: this,
	                pageModel: pageModel,
	                shapeIndexOfNote: i // ( should only be 1 )
	            });
	
	        }, this);
	
	
	    },
	
	
	    // Utilize existing reset function to reset the shapes array when the user cancels changes.
	    // ( from its current state to what was sent from the server -- what exists in the attributes )
	    // Can make this generic is employ a generic parse for other shape/note types
	    resetOnCancelChanges: function() {
	
	        RedactionNoteModel.prototype.resetOnCancelChanges.apply( this, arguments );
	
	        // Store pageModel for upcoming 'parse' prior to destruction
	        var pageModel = this.shapes[0].pageModel;
	
	        // Reset: now not doing and not sure if needed -- there are listeners (like with above on parse)
	        // Destroying causes issues.
	        // All the other views on the canvas should be removed in subsequent call anyway.
	
	        //_.each( this.shapes, function(shape) {
	            //shape.destroy(); -- destroy here has listeners ...
	            //shape = null;
	        //});
	
	        //this.shapes = null;
	
	        this.createShapesFromModelAttributes( this.get('shapes'), pageModel );
	
	    },
	
	
	    // This is also called from the canvas -- here we want to return the shapes we stored already
	    // May want to make this more generic is expand to other note types
	    shapeModelsToRender: function() {
	
	        return this.shapes;
	
	    },
	
	    // Convenience given only ever one shape
	    getShape: function() {
	        return this.shapes[0];
	    },
	
	    shapeView: function(options) {
	       return new FullPageRedactionShapeView(options);
	    },
	
	    getShapeModel: function() {
	        return FullPageRedactionShapeModel;
	    },
	
	    // Don't apply any stroke-width -- its the size of the page
	    defaultSVGAttrsEdit: function() {
	
	        var attrs = RedactionNoteModel.prototype.defaultSVGAttrsEdit.apply( this, arguments );
	        attrs['stroke-width'] = 0;
	        return attrs;
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(313);
	
	var RedactionNoteView = __webpack_require__(231),
	    ZonePropertiesView = __webpack_require__(314);
	
	
	module.exports = RedactionNoteView.extend({
	
	    initialize: function() {
	
	        RedactionNoteView.prototype.initialize.apply( this, arguments );
	
	        this.zonePropertiesView = null;
	
	    },
	
	
	    templateHelpers: _.extend( {}, RedactionNoteView.prototype.templateHelpers, {
	
	        isFullPageRedaction: function() {
	            return true;
	        }
	
	    }),
	
	    ui: _.extend( {}, RedactionNoteView.prototype.ui, {
	
	        zonePropertiesDialogHolder:     '.note-fpr-zone-props-wr'
	
	    }),
	
	    onRender: function() {
	
	        RedactionNoteView.prototype.onRender.apply( this, arguments );
	
	        this.renderZonePropertiesView();
	
	    },
	
	    /**
	     * Treat this like a region.  Should refactor note view to be a LayoutView.
	     */
	    renderZonePropertiesView: function() {
	
	        var shapeModel = this.model.getShape();
	
	        this.zonePropertiesView && this.zonePropertiesView.destroy();
	
	        this.zonePropertiesView = new ZonePropertiesView({
	            shapeModel: shapeModel
	        });
	
	        this.ui.zonePropertiesDialogHolder.append(
	            this.zonePropertiesView.render().el
	        );
	
	    },
	
	    toggleExpandMode: function() {
	
	        RedactionNoteView.prototype.toggleExpandMode.apply( this, arguments );
	
	        this.renderZonePropertiesView();
	
	    },
	
	    onBeforeDestroy: function() {
	
	        this.zonePropertiesView.destroy();
	
	        RedactionNoteView.prototype.onBeforeDestroy.apply( this, arguments );
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 313 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(315);
	
	var RedactionPropertiesDialog = __webpack_require__(236),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = RedactionPropertiesDialog.extend({
	
	    SHOW_FILL_VIEW: 0,
	
	    className: function() {
	        return RedactionPropertiesDialog.prototype.className + ' redactionProps-fullPage';
	    },
	
	    initialize: function() {
	
	        RedactionPropertiesDialog.prototype.initialize.apply( this, arguments );
	
	        // Non-Responsive Reason Code can be added to available codes, need to check vs original collection
	        this.nonResponsiveReasonCodeExistsInSystem =
	            fvChannel.request('reasonCodes').containsNonResponsiveReasonCode();
	
	        /* Cache */
	        this.NON_RESPONSIVE_REASON_CODE = fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE;
	
	        this.shapeUiModel = this.shapeModel.uiModel;
	
	        // Set the value of the shapeUiModel.isDeniedInFull here, utilizing the fact
	        // that selectedCodes where generated on init of the redaction shape view.
	        // Seems clearer than doing in the model initialize/parse process.
	        // ( Would never apply to new notes -- only those being modified )
	        if ( this.selectedCodes.containsNonResponsiveReasonCode() ) {
	            this.shapeUiModel.set({ isDeniedInFull: false} );
	        }
	
	        // If expanded, disable all controls --
	        // only needed on entry; on exit the dialog is destroyed ( so no need to revert );
	        // ( Use the note in case enter though a different page and the shape model --
	        // the shape model is set in the canvas workflow and may not yet be set ).
	        // In the future, if parse shapes with notes, will likely want to set the model values first.
	        // TODO - 3.31.21 ( WF has changed since ): pass in so disable to rid dependency of the UI model, esp for test
	        this.renderDisabled = this.shapeModel.parentNote.uiModel.get('expanded');
	
	        this.listenTo( this.shapeUiModel, 'change:isDeniedInFull', this.updateToReflectDeniedInFullState );
	
	    },
	
	    serializeData: function() {
	
	        var cxt = RedactionPropertiesDialog.prototype.serializeData.call( this );
	
	        cxt = _.extend( {}, cxt, {
	            dontApplyDropdownClass: true,
	            nonResponsiveReasonCode: this.NON_RESPONSIVE_REASON_CODE
	        });
	
	        return cxt;
	
	    },
	
	    templateHelpers: _.extend( {}, RedactionPropertiesDialog.prototype.templateHelpers, {
	
	        isFullPageRedaction: function() {
	            return true;
	        }
	
	    }),
	
	    ui: function() {
	
	        return   _.extend( {}, RedactionPropertiesDialog.prototype.ui, {
	            fullOrNonResponsiveRadioBtns:       '[name=full-or-non-responsive]',
	            cbDeniedInFull:                     '.cb-denied-in-full',
	            cbNonResponsive:                    '.cb-non-responsive'
	        });
	
	    },
	    events: _.extend( {}, RedactionPropertiesDialog.prototype.events, {
	        'change @ui.fullOrNonResponsiveRadioBtns': 'fullOrNonResponseRadioButtonChange'
	    }),
	
	    // Note: now called from the noteView; not from the shape's dialog open events
	    onRender: function() {
	
	        RedactionPropertiesDialog.prototype.onRender.apply( this, arguments );
	
	        this.updateToReflectDeniedInFullState();
	
	        // Handle fringe case if the 'Non Responsive' reason code doesn't exist in the system
	        // Don't need to worry about future change of the radio buttons because one will be disabled
	        if ( !this.nonResponsiveReasonCodeExistsInSystem ) {
	            this._updateViewIfNonResponsiveReasonCodeIsNotInSystem();
	        }
	
	        if ( this.renderDisabled ) {
	            this.ui.fullOrNonResponsiveRadioBtns.attr( 'disabled', 'disabled' );
	        }
	
	        /**
	         * For now this will be called superfluously ( but will work since nothing will change from render to destroy ).
	         * A better long term solution is to do when active and editing, but save is problematic in current WF.
	         * Could also try when this.shapeModel.uiModel.get('isActive') ... but there are better ways to optimize
	         */
	        this.shapeModel.setSelectedCodeAndFillOnDialogOpen();
	
	
	    },
	
	    // ( Only called on render )
	    // Disable either radio button and set it's title to a message why
	    _updateViewIfNonResponsiveReasonCodeIsNotInSystem: function() {
	
	        if ( this.nonResponsiveReasonCodeExistsInSystem )
	            return;
	
	        var NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG =
	            this.NON_RESPONSIVE_REASON_CODE +
	                ' reason code does not exist in database.  Please contact your system administrator.';
	
	        var isDeniedInFull = this.shapeUiModel.get('isDeniedInFull');
	
	        if (isDeniedInFull) {
	
	            // Just Disallow Selection of Non-Responsive -- you can't allow it because the code doesn't exist
	            disableNonResponsive.call( this );
	
	        } else {
	
	            if ( this.shapeModel.parentNote.isNew() ) {
	
	                // This could occur if we apply the last code from local store.  We currently aren't doing this --
	                // but left here in case we change that.
	                disableNonResponsive.call( this );
	
	            } else {
	
	                // When modified, the reasonCode would have to exist on the note --
	                // could either disallow a change ( with a prompt the data will be lost ).
	                // But for now just don't allow modification .
	                // Here the reason code must be selected (by definition); it's put into the 'available' reason codes for the view (see above)
	                this.ui.cbDeniedInFull
	                    .attr( 'disabled', 'disabled' )
	                    .attr( 'title', NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG );
	            }
	
	        }
	
	        function disableNonResponsive() {
	            this.ui.cbNonResponsive
	                .attr( 'disabled', 'disabled' )
	                .attr( 'title', NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG );
	        }
	
	    },
	
	    updateToReflectDeniedInFullState: function() {
	
	        var isDeniedInFull = this.shapeUiModel.get('isDeniedInFull');
	
	        // Check the approppriate radio button on initial render first ( won't trigger value change event )
	        if ( isDeniedInFull ) {
	
	            this.ui.cbDeniedInFull.attr('checked', 'checked');
	
	            // Remove the non-responsive code if it was selected
	            if ( this.selectedCodes.containsNonResponsiveReasonCode() ) {
	                this.selectedCodes.remove( this.selectedCodes.getNonResponsiveCodeModel(), {
	                    sourceNotFromChosen: true
	                } );
	            }
	
	            // Disable selection of the 'non-responsive' code if
	            // if it exists OR does not exist, in the latter case it is added to the available reason codes collection and printed.
	            // It's not an item with a model as part of a collection view, just get from the DOM.
	
	            this.reasonCodeRegion.currentView.disableOption( this.NON_RESPONSIVE_REASON_CODE );
	
	            if ( !this.renderDisabled ) {
	                this.enableReasonCodesInteraction();
	            }
	
	
	        } else {
	
	            this.ui.cbNonResponsive.attr('checked', 'checked');
	
	            // Re-enable the non-responsive reason code row
	            if ( this.nonResponsiveReasonCodeExistsInSystem ) {
	                this.reasonCodeRegion.currentView.enableOption( this.NON_RESPONSIVE_REASON_CODE );
	            }
	
	            // Remove any selected reason codes and apply the non-responsive reason code.
	            // For now, do so without a prompt.
	            // Add the Non-Responsive Code ( this will be disabled if it doesn't exist ).
	            this.selectedCodes.remove( this.selectedCodes.models, { silent: true} );
	            this.selectedCodes.add( this.availableReasonCodes.getNonResponsiveCodeModel(), {
	                sourceNotFromChosen: true
	            } );
	
	            this.disableReasonCodesInteraction();
	
	        }
	
	    },
	
	    fullOrNonResponseRadioButtonChange: function(e) {
	
	        var $target = $(e.target),
	            isDeniedInFull = $target.val() === 'DENIED_IN_FULL'; // (hard coded now ... could get from reason code collection )
	
	        this.shapeUiModel.set({ isDeniedInFull: isDeniedInFull });
	
	    },
	
	
	    /* Disallow adding 'Non-Responsive' Code on select all when denied in full */
	    _getReasonCodeModelsForSelectAll: function() {
	
	        if ( this.shapeUiModel.get('isDeniedInFull') ) {
	
	            /* could cache */
	            return this.availableReasonCodes.reject ( function(rc) {
	                return rc.get('code') === this.NON_RESPONSIVE_REASON_CODE;
	            }, this);
	
	        } else {
	
	            return this.availableReasonCodes.models;
	        }
	
	    },
	
	    onBeforeDestroy: function() {
	
	        // Again, would rather called on save but that's a bit problematic and would need more outlining.
	        this.shapeModel.updateLocalStoragePostDialogClose();
	
	        this.stopListening( this.shapeUiModel );
	
	
	
	    }
	
	
	});

/***/ },
/* 315 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    RedactionShapeView = __webpack_require__(233),
	    FullPageRedactionCodeLettersView = __webpack_require__(317),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	/**
	 * Note: dialog now printed inside noteView -- don't need to set the Dialog Constructor
	 * for the 'super' ShapeViewDialog View Class.
	 */
	
	module.exports = RedactionShapeView.extend({
	
	    CodeLettersView: FullPageRedactionCodeLettersView,
	
	    shapeSubs: _.extend( {}, RedactionShapeView.prototype.shapeSubs, {
	        'shape.onAfterBaseScale': 'resetGlow' // ( note: codeLetters sub-view also listens for this but they shouldn't collide)
	    }),
	
	    shapeUIEvents: _.extend( {}, RedactionShapeView.prototype.shapeUIEvents, {
	        'fullPgRedactionShape:layerAfterShapesRendered':    'layerAfterAllShapesRendered'
	    }),
	
	    /**
	     * Called on canvas' renderShapes.
	     * Do like this for now; could employ more sophisticated layering schema from a model later on.
	     */
	    layerAfterAllShapesRendered: function() {
	
	        var applyAllRedactionsMode =
	            fvChannel.request('localStorage').getPgModeApplyAllRedactions();
	
	        if ( !applyAllRedactionsMode ) {
	
	            // Move to the back -- if were shapes were underneath, we don't capture capture mouseover events
	           this.el.toBack();
	
	        } else {
	
	            /**
	             * Position in front of all shapes -- the others won't be visible unless toggleActive, toggleExpanded, toggleHighlight.
	             * - active: we don't require any changes; create will put in front and modify we cause a re-render of all shapes
	             * - expanded: will temporary be brought in front
	             * - highlight: when hover of notes, glow is brought to the front as an indicator
	             */
	            this.el.toFront();
	
	        }
	
	        // Update the position of the reason codes sub view
	        this.trigger('redactionShape.layerCodesView');
	
	    },
	
	    /**
	     * Dirty but works turn off 'selection.'
	     * All activity is disabled when you can't select, eg drag, buttons, etc.
	     */
	    toggleSelected: function() {},
	
	    // Now only occurs on entry -- just make the cursor default,
	    // to indicate its not selectable.
	    // Could create an 'isSelectable' property to distinguish this and make it more generic.
	    toggleActive: function() {
	        RedactionShapeView.prototype.toggleActive.apply( this, arguments );
	        this.el.attr('cursor', 'default');
	    },
	
	    /**
	     * getNonPathActiveSVGAttrs.stroke-width is 0; utilize the glow so for it to stand out.
	     * Note: don't override with makeExpandedVisibleIndicator with toggle glow (we still want the base)
	     */
	    makeExpandedVisibleIndicator: function() {
	
	        RedactionShapeView.prototype.makeExpandedVisibleIndicator.apply( this, arguments ); // ( if apply redactions, it shouldn't be see through here )
	        this._createGlow();
	
	    }
	
	
	});

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var BaseCodeLettersView = __webpack_require__(234);
	
	
	module.exports = BaseCodeLettersView.extend({
	
	
	    MAX_PAGE_FONT_SIZE_PROPORTION: 0.10,
	
	    /* Always print all codes on new lines */
	    _getCodeTextToPrint: function( ) {
	
	        return this.selectedCodes.getCodesAsString('\n');
	    },
	
	    /**
	     * Utilize all logic from base:
	     * - fontSize should be no longer than the longest line that will fit the width of the box
	     * - verticalAdjustments: may not be necessary but utilize same logic as in base; perf shouldn't be hit too roughly
	     * Then perform another vertical adjustment to cap the font-size
	     */
	    _getFontSize: function( sCodes, height, width, isWider ) {
	
	        var fontSize = BaseCodeLettersView.prototype._getFontSize.apply( this, arguments );
	
	        var pageProportionalFontSize = height * this.MAX_PAGE_FONT_SIZE_PROPORTION;
	
	        return fontSize > pageProportionalFontSize
	            ? pageProportionalFontSize
	            : fontSize;
	
	    }
	
	
	});

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var RedactionShapeModel = __webpack_require__(252),
	    FullPageRedactionShapeUiModel = __webpack_require__(319),
	    ShapeUtils = __webpack_require__(197),
	    _ = __webpack_require__(49);
	
	
	
	module.exports = RedactionShapeModel.extend({
	
	    APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE: 0,
	    APPLY_LAST_FILL_FROM_LOCAL_STORAGE: 0,
	
	    STORE_SELECTED_FILL_TO_LOCAL_STORAGE: 0,
	    STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE: 0,
	
	    ShapeUIModel: FullPageRedactionShapeUiModel,
	
	    // Make clear these can't be converted to float
	    constructor: function(attrs) {
	
	        RedactionShapeModel.prototype.constructor.apply( this, arguments );
	
	        this.isConvertingToFloatingCodes = false;
	
	    },
	
	    /**
	     * Fill is essentially not applicable.
	     * White is chosen because it's more printer friendly and it
	     * will work out of the box with 'apply all redactons mode'.
	     * Override also serves to ignore setting the fill from local storage
	     * -- which aren't applicable to the note type
	     */
	    defaults: function() {
	
	        return _.extend( {}, RedactionShapeModel.prototype.defaults.apply( this, arguments ), {
	            fill: 'WHITE'
	        });
	
	    },
	
	    /**
	     * Don't derive the points from the shape el, which will
	     * results in rounding issues and potentially negative values.
	     * Plus it's simpler just to get the values directly from the converted page dimensions.
	     */
	    _getPointsFromEl: function() {
	
	        // First emphasize can't be created on cold/text pages
	        if ( this.pageModel.isCold() )
	            return null;
	
	        return ShapeUtils.getPointsToSaveFromPageDimensions( this.pageModel );
	
	    }
	
	
	});

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseShapeUIModel = __webpack_require__(255);
	
	
	/**
	 * Extend base defaults with isDeniedInFull flag ,which defaults to true.
	 * These shapes can either be 'Denied in Full' (true) or 'Non-Responsive' (false).
	 * Utilize to track and trigger changes in the associated view, as well as validate values on save,
	 * which come directly from the parent shape model.
	 */
	
	
	module.exports = BaseShapeUIModel.extend({
	
	    defaults: _.extend( {}, BaseShapeUIModel.prototype.defaults, {
	
	        isDeniedInFull: true
	
	    })
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var SVGNote = __webpack_require__(292),
	    SignatureNoteModel = __webpack_require__(296),
	    GraphicTextStampShapeModel = __webpack_require__(321),
	    GraphicTextStampShapeView = __webpack_require__(322),
	    GraphicStampNoteView = __webpack_require__(323),
	    NoteUIModel = __webpack_require__(338),
	    TextStampModel = __webpack_require__(96),
	    $ = __webpack_require__(59);
	
	
	
	module.exports = SVGNote.extend({
	
	    constructor: function() {
	
	        this.existingStamp = null; // ( set on parse and set on UI model if not new ) .... see parse
	
	        SVGNote.apply( this, arguments );
	
	    },
	
	    autoDisplayApplies: false, // for consistency with graphic stamps
	
	    NoteUIModel: NoteUIModel,
	    ShapeModel: GraphicTextStampShapeModel,
	    ViewConstructor: GraphicStampNoteView,
	    SUPPORTS_COLOR_PICKER: 1,
	    init: 'J',
	    createHotKey: 'j', // ( no good choices available -- so random )
	    desc: 'Text Stamp',
	    actionTitle: 'Text Stamp',
	    defaultSubType: 'text_stamp',
	
	    // This currently only has one color: not sure what would happen if we implement backgrounds ( then there would be 2 )
	    defaultShapeColor: NoteUIModel.prototype.defaults.textColor,
	    defaultSVGAttrsEdit: SignatureNoteModel.prototype.defaultSVGAttrsEdit,
	
	    // We should refactor this to used a factor so it's no longer a model function
	    shapeView: function( options ) {
	        return new GraphicTextStampShapeView( options );
	
	    },
	    iconClass: 'icon-font-1', // TODO: get better one and update font files ( also need update of graphic to differentiate )
	
	    /**
	     * We want to recreate the uiModel here ( at least ), so it's updated with the approp. values post save.
	     * At least do this 1st for testing without having to read in and out -- should refactor however.
	     * ( this was on the uiModel.selectedStamp )
	     * uiModel is created on init ... REFACTOR ...
	     *  TODO: prob want to create the shapes on parse; outline workarounds ( need to look at shape and UI model )
	     */
	    parse: function( attrs ) {
	
	        attrs = SVGNote.prototype.parse.apply( this, arguments );
	
	        // could use import - get shape models to render here and create a shape model first, but I don't think necessary ... just get the data from the svg
	        // need stamp from SVG
	        var isNew = !attrs.sequence;
	
	        if ( !isNew ) {
	
	            var svg = attrs.text;
	            var $svg = $(svg); // utilize jquery to parse the svg
	
	            /**
	             * Always get all non text related attributes that we need at the top level element;
	             * Get those specific to text ( font, font size ); from the text element
	             * Later we may have a background - in which case wed' have to get the attributes from a rect ( with an identifier if > 1 )
	             * The alternative is putting every single attribute we will need to know into data attributes.
	             * For now it is save to assume there will be a single text element.
	             * At first used $topLevelElement for settings but now we have the data attributes.
	             */
	
	            var textElement = $svg.find('g text')[0];
	
	            var $stamp = $svg.find('stamp');
	
	            // Version: in future, if version is different than the default current,
	            // may need to switch-track -- maybe only be necessary for parsing the XML
	            // Modified stamps would be stored with the newest update to date version.
	            // Change if/when necessary -- maybe store the original on the modified stamp model/as the originalVersion on the uiModel
	            var version = $stamp.find('version').text();
	
	            var rotation = parseFloat( $stamp.find('rotation').text() );
	            var subject = $stamp.find('subject').text();
	            var template = $stamp.find('template').text();
	
	            var stamp = new TextStampModel({
	                src: template, // sets aVariables ( need to set the values on here )
	                subject: subject, // use data attributes; I think this is all we need
	                id: 0  // we store the original id but it is meaningless here ... give it one of 0 ( which doesn't exist in the db and can be used to tell if new/not new )
	            });
	
	            /**
	             * Variables: Create object who's keys are the variable keys and values are the variable values
	             * Store this on the UI model.
	             */
	            var oVariables = {};
	            var $variables = $svg.find('variables');
	            if ( $variables.length > 0 ) {
	                $variables.children().each( function() {
	                    oVariables[ $(this).attr('key') ] = $(this).text();
	                } );
	            }
	
	            /**
	             * Tokens -- do the same as variables
	             * ( we don't want to replace existing values that were printed, etc ).
	             */
	
	            var oTokens = {};
	            var $tokens = $svg.find('tokens');
	            if ( $tokens.length > 0 ) {
	                $tokens.children().each( function() {
	                    oTokens[ $(this).attr('key') ] = $(this).text();
	                } );
	            }
	
	            var fontSize = parseFloat( textElement.getAttribute('font-size') ); // TODO: stored in px -- LEAVE THAT WAY or allow ???
	            var fontFamily = textElement.getAttribute('font-family');
	            var textColor = textElement.getAttribute('fill');
	
	            var textOpacity = textElement.getAttribute('opacity');
	            if ( textOpacity === null ) { // if a value of 1, it isn't written on export
	                textOpacity = 1.0;
	            }
	
	            var stampPlaced = true; // must be tried by nature
	
	            /* Hack b/c UI model not yet init'd ( it has to be put in parse or vice versa ) */
	            /* Store these values here for now then on init on UI model they'll be set */
	            // this.version = version; -- now not passing setting -- any existing stamp would be saved with the latest version
	            this.existingStamp = stamp;
	            this.rotationAtZeroPageRotation = rotation;
	            this.fontSize = fontSize;
	            this.fontFamily = fontFamily;
	            this.textColor = textColor;
	            this.textOpacity = textOpacity;
	            this.stampPlaced = stampPlaced; // must be true by definition
	            this.originalVariables = Object.keys( oVariables ).length > 0 ? oVariables : null;
	            this.originalTokens = Object.keys( oTokens ).length > 0 ? oTokens : null;
	
	            // Would occur for those not created on load of page currently ( eg newly saved ) --
	            // INIT OF THE MODEL AND UI MODEL IS NOT CALLED AGAIN CURRENTLY
	            if ( this.uiModel ) {
	
	                // Variables and tokens must be set prior to the selected stamp -- clear old values here too
	
	                this.uiModel.setOriginalStampVariableInputs(  Object.keys( oVariables ).length > 0 ? oVariables : null );
	
	                this.uiModel.setOriginalTokenValues(  Object.keys( oTokens ).length > 0 ? oTokens : null );
	
	                this.uiModel.setSelectedStamp( this.existingStamp ); // may need to take setting the values out of here )
	
	                this.uiModel.set({
	                    //version: version, -- now not setting
	                    rotationAtZeroPageRotation: rotation,
	                    fontSize: fontSize,
	                    font: fontFamily,
	                    stampPlaced: stampPlaced,
	                    textColor: textColor,
	                    textOpacity: textOpacity
	                });
	
	            }
	
	        }
	
	        return attrs;
	
	    }
	
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var GraphicShape = __webpack_require__(295),
	    ShapeUtils = __webpack_require__(197),
	    NormalizeNewLineCharacters = __webpack_require__(48).normalizeNewLineCharacters,
	    Raphael = __webpack_require__(182);
	
	
	module.exports = GraphicShape.extend({
	
	    VIEW_SUPPORTS_TRANSFORM: 1,
	    ALLOW_DRAG_OFF_CANVAS: 1,
	
	    /* TODO: Potential Issue if implement background -- would have 2 colors */
	    /* For now we export as a group but import just the text element, which is what we work with */
	    setZoneColorOnParse: function( raphaelAttrs, options ) {
	
	        var color = !options.isNewlyDrawn
	            ? raphaelAttrs.fill
	            : this.parentNote.uiModel.get('textColor'); // raphaelAttrs wouldn't exist
	
	        this.setZoneColor( color );
	
	    },
	
	    /**
	     * This is much simpler than you think because we only render transformed --
	     * just pass the original x, y coordinates, remove the transform, and store the rotation for reading back in.
	     */
	    getNormalizedElToPerist: function( ) {
	
	        var noteUiModel = this.parentNote.uiModel;
	
	        var shapeRotation = noteUiModel.get('rotationAtZeroPageRotation') % 360;
	        shapeRotation = parseFloat( shapeRotation ); // if -0, make it 0 -- should also set before here
	
	        var stampModel = noteUiModel.getSelectedStamp();
	
	        /* nonViewTransform now not used here, we break up for rotation and text offset to export */
	        var shapeTransformModel = this.getTransformModel();
	
	        var noViewRotateTransform = shapeTransformModel.getNonViewRotateTransform();
	        var textYOffsetTransform = shapeTransformModel.getTextYOffsetTransform();
	
	
	        // Clone: give some consistency with the other shapes; will still allow to use Raphael's attributes
	        // later when move off Raphael, can just deal with the actual attributes
	        var el = this.uiModel.get('raphaelEl');
	        var clone = el.clone();
	
	        // Raphael applies this to the style element; it not a direct attribute
	        // further .attr() does not affect the underlying DOM element, it attaches a property to the Rapha�l object ( its the CSS(!) cursor )
	        clone.node.style.removeProperty('cursor');
	
	        // actually its on the style element
	        clone.setStrokeAndFill( this.getZoneColor() ); // change the color to persist, in case it was overwritten (eg by consult group )
	
	        clone.attr({
	            transform: textYOffsetTransform,
	            x: +(el.attr('x' ).toFixed( 3 )),
	            y: +(el.attr('y' ).toFixed( 3 ))
	        });
	
	
	        var SVG_NAMESPACE_XMLS = 'http://www.w3.org/2000/xmlns/';
	        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
	        var FEITH_STAMP_NAMESPACE = 'http://www.feith.com/graphic_text_stamp';
	        var TEXT_ELEMENT_CLASS_NAME = 'gts_text';
	
	
	        // TODO: if leave this logic -- put fn to share it with shapes.toSVG -- getSVGCanvasDimensions to save
	        // Awaiting Tom to see appropriate logic
	
	        var pageDimensions = this.pageModel.isCold()
	            ? { width: '100%', height: '100%' }
	            : this.pageModel.getOriginalPageCanvasDimensions();
	
	        if ( !this.pageModel.isCold() ) {
	            pageDimensions.width = pageDimensions.w + 'px';
	            pageDimensions.height =  pageDimensions.h +'px';
	        }
	
	        var variableInputs = noteUiModel.getVariableInputs(),
	            tokenInputs = noteUiModel.getTokenInputs();
	
	        var svg = document.createElementNS( SVG_NAMESPACE, 'svg');
	        svg.setAttribute( 'width', pageDimensions.width );
	        svg.setAttribute( 'height', pageDimensions.height );
	        svg.setAttribute( 'version', '1.1' );
	        svg.setAttributeNS( SVG_NAMESPACE_XMLS, 'xmlns', 'http://www.w3.org/2000/svg' );
	        svg.setAttributeNS( SVG_NAMESPACE_XMLS, 'xmlns:xlink', 'http://www.w3.org/1999/xlink' );
	
	
	        /* Now creating the meta-data element -- could have attributes */
	        var metadataTag = document.createElementNS( SVG_NAMESPACE, 'metadata' );
	        var stampMetaDataXml = createStampNSElement( 'stamp' );
	
	        stampMetaDataXml.appendChild( createStampNSElement( 'version', noteUiModel.getVersion().toString() ) ); // ( needs to be a string to write )
	        stampMetaDataXml.appendChild( createStampNSElement( 'id', stampModel.get('id').toString() ) );
	        stampMetaDataXml.appendChild( createStampNSElement( 'rotation', shapeRotation.toString() ) );
	        stampMetaDataXml.appendChild( createStampNSElement( 'subject', stampModel.get('subject') ) );
	
	        /* Normalize should already be complete by now but doesn't hurt */
	        stampMetaDataXml.appendChild( createStampNSElement( 'template', NormalizeNewLineCharacters( stampModel.getText() ) ) ); // already normalized but again do in case
	        stampMetaDataXml.appendChild( createStampNSElement( 'content', NormalizeNewLineCharacters( clone.attr('text') ) ));  // already normalized but done again
	
	        if ( variableInputs && variableInputs.length > 0 ) {
	
	            var variableInputsTag = createStampNSElement( 'variables' );
	            variableInputs.each( function( vi ) {
	                variableInputsTag.appendChild( createInputElement( 'variable', vi.get('key'), vi.get('value') ) );
	            });
	
	            stampMetaDataXml.appendChild( variableInputsTag );
	        }
	
	        if ( tokenInputs && tokenInputs.length > 0 ) {
	
	            var tokenInputsTag = createStampNSElement( 'tokens' );
	            tokenInputs.each( function( vi ) {
	                tokenInputsTag.appendChild( createInputElement( 'token', vi.get('key'), vi.get('value') ) );
	            });
	
	            stampMetaDataXml.appendChild( tokenInputsTag );
	        }
	
	        metadataTag.appendChild( stampMetaDataXml );
	        svg.appendChild( metadataTag );
	
	        /* create g with the non rotate part of the transform */
	        var g = document.createElementNS( SVG_NAMESPACE, 'g' );
	        g.setAttribute( 'class', 'gts_top_group' );
	
	        // Move the 'ROTATION' transform to the top level group element -- text element is different
	        // Note: both transforms (both here and on the text element are currently ignored by this app ( svgImport ) -- this just
	        // read in the text element now, and the code later applies the appropriate transforms via the calculations used to create it
	        if ( shapeRotation !== 0 ) {
	
	            //  el.setAttribute(key, Str(attr[key])); -- if have transform string to mx fn -- don't need the el
	            var dummyPath =  el.paper.path('');
	
	            dummyPath.transform(  noViewRotateTransform  ); // hack to get the transform on the element -- would only exist if new on page rotation other than 0
	
	            g.setAttribute( 'transform',  dummyPath.node.getAttribute('transform') );
	
	            dummyPath.remove();
	
	        }
	
	
	        /* Remove pixels from the font size -- Raphael only allows us to use pixels, but we don't need to store it as such
	        /* This is consistent with all the other values we are working with -- just use user units */
	        clone.node.setAttribute( 'font-size', parseFloat( clone.node.getAttribute('font-size') ) );
	
	
	        /**
	         * Modify the text attribute
	         * Stroke-width: svg stroke is none by default but Raphael 'transform' fn will give this a value even if one doesn't exist; this messes up glow and is not necessary for storage.
	         */
	        clone.node.removeAttribute('stroke-width');
	
	        /** Always review stroke -- it is set as 'none' **/
	
	        clone.node.removeAttribute('stroke');
	
	        /** Don't store attributes if they are default SVG values */
	
	        if ( parseFloat( clone.node.getAttribute('opacity') ) === 1  ) {
	            clone.node.removeAttribute('opacity');
	            clone.node.style.removeProperty('opacity');
	        }
	
	        /* Remove the style attribute -- currently not necessary */
	
	        clone.node.removeAttribute('style');
	
	        /* Put a class identfier on the text element ( can't do with Raphael ) */
	        clone.node.setAttribute( 'class', TEXT_ELEMENT_CLASS_NAME );
	
	        /** Round the tspans and remove unused style attributes -- slice for IE **/
	        /* Note: we need the x attributes */
	        Array.prototype.forEach.call( clone.node.childNodes, function( tSpan ) {
	
	            tSpan.setAttribute('style',''); // for some reason, need to set to empty before removal ( could use jQuery -- but see jQuery source for explanation )
	            tSpan.removeAttribute('style');
	            tSpan.setAttribute( 'dy', parseFloat( tSpan.getAttribute('dy') ).toFixed( 3 ) );
	
	        });
	
	
	        g.appendChild( clone.node ); // this won't working being added to set
	
	        /* --- TEST print of dummy bkgnd to see how would look on export -- in real world would want under the text.
	        var box = el.getBBox(1);
	        var dummyRect =  el.paper.rect( el.attr('x'), el.attr('y'), box.width, box.height).attr({
	            fill: 'green',
	            opacity: 0.5
	        });
	         g.appendChild( dummyRect.clone().node  ); // clone for remove
	
	
	         dummyRect.remove();
	         ---- */
	
	        svg.appendChild( g );
	
	        var svgXML = new XMLSerializer().serializeToString( svg ); // for IE, need the XMLSeriealizer; otherwise use svg.outerHTML;
	
	        //console.log( svgXML );
	
	        clone.remove(); // this also takes out of the new element
	
	        return svgXML;
	
	
	        function createStampNSElement( tagName, value ) {
	
	            var tag = document.createElementNS( FEITH_STAMP_NAMESPACE, tagName );
	            if ( value && value.length > 0 ) {
	                tag.textContent = value; // textContent for IE
	            }
	            return tag;
	
	        }
	
	        function createInputElement( tagName, key, value ) {
	
	            var tag = document.createElementNS( FEITH_STAMP_NAMESPACE, tagName );
	            tag.setAttribute( 'key', key );
	            tag.textContent = value; // textContent for IE
	            return tag;
	
	        }
	
	
	    }
	
	
	});


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var GraphicShapeView = __webpack_require__(215),
	    _ = __webpack_require__(49),
	    GraphicStampShape = __webpack_require__(300);
	
	
	/**
	 *
	 * Likely want an SVG shape rather than extending from graphic shape.
	 * intertwined with color change, other aspects of it
	 */
	
	
	var TextStampView = GraphicShapeView.extend({
	
	    dontCreateButtonSet: true, // we don't want the delete button
	    DONT_CREATE_SELECT_HANDLES: true, // test no resize ... only want font-size, text change, font having this resizable ( not both )
	
	    initialize: function( options ) {
	
	        GraphicShapeView.prototype.initialize.apply( this, arguments );
	
	        this.shapeTransformModel = this.shapeModel.getTransformModel();
	
	        var uiModel = this.pgNoteModel.uiModel;
	
	        this.shapeTransformModel.initializePageValues( this.shapeModel.pageModel, this.options.scale );
	        this.shapeTransformModel.setRotation( uiModel.get( 'rotationAtZeroPageRotation') );
	
	        this.listenTo( uiModel, 'change:selectedStamp', this.stampChange );
	
	        /* Don't allow any changes that would alter the existing path now -- it is a path that can only be moved and resized, like a graphic */
	        this.listenTo( uiModel, 'change:generatedText', this.update );
	        this.listenTo( uiModel, 'change:fontSize',      this.update );
	        this.listenTo( uiModel, 'change:font',          this.update );
	
	        this.listenTo( uiModel, 'change:textColor',     this.textColorChange ); // could put an option parent in the event ...
	        this.listenTo( uiModel, 'change:textOpacity',   this.textColorChange ); // note: change change opacity and color at the same time, so no dupe
	
	    },
	
	    render: function() {
	
	        GraphicShapeView.prototype.render.apply( this, arguments );
	        this._setTransformValuesOnRender( this.transform.bind(this) );
	
	    },
	
	    _renderFromModel: function( shapeModel, scale ) {
	
	        var el = this.paper.text()
	            .attr( shapeModel.getNonPathInactiveSVGAttrs( this.channel ) );
	
	        this.setElement( el );
	        this._setTransformValuesOnRender( this.transform.bind(this) );
	
	        return el;
	
	    },
	
	    _setTransformValuesOnRender: function( cb ) {
	
	        var shapeTransformModel = this.shapeTransformModel;
	        shapeTransformModel.setOBox(  this.el.getBBox(1) );
	        shapeTransformModel.setOx( this.el.attr('x') );
	        shapeTransformModel.setOy( this.el.attr('y') );
	        shapeTransformModel.getPageModel().updateTransform();
	        cb && cb();
	
	    },
	
	    // TODO: a better way to update 'mediated' with probably an option to indicate size change ( and need to update bbox ) or note
	    update: function( noteUiModel ) {
	
	        this._updateAttributes( noteUiModel );
	
	        this.shapeTransformModel.setOBox( this.el.getBBox(1) );  // Need to update since the bbox changes
	        this.shapeTransformModel.getPageModel().updateTransform(); // needed these aren't changing
	        this.transform();
	
	        // This should be slow but appears to work ( comment written when did a resize, without it is good )
	        // Performance is not great in IE
	        this._destroySelectSet();
	        this._createSelectSet();
	
	    },
	
	    /**
	     *   TODO: shapeModel.setZoneColor
	     *    - hack for now: -- would call this.onChangeColor but attributes updated
	     *    - just set color on the shape model -- if leave like this should also do on the hover model
	     *    - real answer is linking the noteUiModel to the shape model ...
	     */
	    textColorChange: function( noteUiModel ) {
	
	        this._updateAttributes( noteUiModel );
	        this.shapeModel.setZoneColor( noteUiModel.get('textColor') );
	
	    },
	
	    _updateAttributes: function(noteUiModel) {
	
	        this.el.attr({
	            text: noteUiModel.getGeneratedText(),
	            'font-size': noteUiModel.getFontSize(),
	            'font-family': noteUiModel.getFont(),
	            fill: noteUiModel.getColorToApply(),
	            opacity: noteUiModel.getTextOpacity()
	        });
	
	    },
	
	    // -- may want a handleset that share the same transform ...
	    _scaleShapeEl: function( scale ) {
	
	        var shapePageTransformModel = this.shapeTransformModel.getPageModel();
	        shapePageTransformModel.setScale( scale );
	        shapePageTransformModel.updateTransform();
	        this.transform();
	    },
	
	    // Depends if new or not ... now the inputs could be invalid ... what to do ? -- logic may need to go into re-render canvas
	    stampChange: function( noteUiModel ) {
	
	        if ( !noteUiModel.getInputsValid() ) {
	
	            noteUiModel.setStampPlaced( false ); // TODO: this should be higher up when changing the stamp
	            this.channel.command( 'replaceExistingTextStampShapeWithHoverStamp' );
	        }
	        else
	        {
	            this.update( noteUiModel );
	
	        }
	
	    },
	
	    /* Could put into a getTransform string on the model -- and have others inherit from it -- do if need to use for other shapes */
	    /* Eg have a getTransform function on the model -- it is created from those values now -- diff modules would override */
	    transform: function( t ) {
	
	        var shapeTransModel = this.shapeTransformModel;
	
	        var trans = '';
	        var non_view_transform = '';
	
	        if ( t ) {
	            trans += t; // I think this is typically the view transform
	        }
	
	        trans += shapeTransModel.getPageModel().getTransform(); // was passing in via cb param ( which here was t )
	
	        // trans += 's' + stamp.sx + ',' + stamp.sy;  // good for move but breaks resize moves ... ( RESIZE NOT DONE )
	        // Rotation -- From Original -- resize move becomes off
	
	        var r = shapeTransModel.getRotation();
	
	        if ( r !== 0 ) {
	
	            var rotateTrans = 'r' + r  + ',' + shapeTransModel.getOx() + ',' +  shapeTransModel.getOy();
	            non_view_transform += rotateTrans;
	            shapeTransModel.setNonViewRotateTransform( rotateTrans );
	        }
	
	        // Y-Char Offset
	        var textOffsetTransform = 't0,' + shapeTransModel.getOBox().height / 2;
	        shapeTransModel.setTextYOffsetTransform( textOffsetTransform );
	
	        non_view_transform += textOffsetTransform ;
	        shapeTransModel.setNonViewTransform( non_view_transform );
	
	        trans += non_view_transform;
	        this.el.transform( trans );
	
	    },
	
	    // It's only one shape, select it automatically
	    // Maybe this is a single shape mixin -- but we already need to refactor toggle active
	    toggleActive: GraphicStampShape.prototype.toggleActive
	
	});
	
	
	module.exports = TextStampView;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(324);
	
	/* Start as POC -- some similarities to graphicStamps */
	
	var DrawablePageNoteView = __webpack_require__(179),
	    StampSelectorView = __webpack_require__(325),
	    VariableInputsView = __webpack_require__(328),
	    ExistingTokensView = __webpack_require__(331),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    Picker = __webpack_require__(334),
	    Util = __webpack_require__(48),
	    getContrastYIQ = Util.getContrastYIQ,
	    hexToRgba = Util.hexToRgba;
	
	/*
	* TODO:
	* - really need refactor to make regions
	* Certainly areas to look at with detached dom nodes - memory leaks here ( regions would help
	* */
	module.exports = DrawablePageNoteView.extend({
	
	    initialize: function() {
	
	        DrawablePageNoteView.prototype.initialize.apply(this, arguments);
	
	        this.stampSelectView = null;
	        //this.textPreviewView = null; -- for now not a value ... we just update
	        this.variableInputsView = null;
	        this.chosenFontSizeSelector = null;
	        this.chosenFontSelector = null;
	        this.existingTokensView = null;
	        this.userChangedSubjectInput = false; // ( only applies if new ) -- could logic on uiModel but larger refactor with saving, etc ( also in graphic stamp )
	        this.colorPicker = null;
	
	    },
	
	    modelEvents: _.extend( {}, DrawablePageNoteView.prototype.modelEvents, {
	
	        'colorPicker:toggleEnabled': '_toggleEnabledColorPicker'  // This is really from consult group change
	
	    }),
	
	    // TODO: maybe combo fontSize, generatedText and font
	    uiModelEvents: _.extend( {}, DrawablePageNoteView.prototype.uiModelEvents, {
	
	        'change:selectedStamp':     'stampChanged',
	        'change:generatedText ':    'generatedTextChange',
	        'change:fontSize':          'generatedTextChange',
	        'change:font':              'generatedTextChange',
	        'change:stampPlaced':       '_updateStampReady',
	        'change:textColor ':        '_updateTextColor',
	        'change:textOpacity':        '_updateTextColor'
	
	    }),
	
	    ui: _.extend( {}, DrawablePageNoteView.prototype.ui, {
	
	        stampSelectPlaceHolder:     '[data-stamp-select-holder]',
	        templateDiv:                '.text-stamp-template',
	        previewViewWrDiv:           '.text-stamp-preview-wr',
	        inputsViewWr:               '.text-stamp-variables-wr',
	        variableInputField:         '.txt-stamp-variable-input',  // in the inputs view but catch from here ... easier ..
	        fontSizeSelect:             '.text-stamp-font-size-select',
	        fontSelect:                 '.text-stamp-font-select',
	        fontSelectWr:               '.ts-font-select-wr',
	        existingTemplateSelectedIndicator: '.text-stamp-note-template-selected-indicator',
	        existingTokensWrDiv:        '.existing-tokens-wr',
	        stampReadyIndicator:        '.ts-stamp-ready-ind',
	        colorPickerParent:          '.ts-cp-parent',
	        opacitySlider:              '.ts-opacity-slider'
	
	    }),
	
	    events: function() {
	
	        var evts =  _.extend( {}, DrawablePageNoteView.prototype.events, {
	            'input @ui.variableInputField':     'variableInputBoxChange', // should these be reset when the stamp changes> -- doesn't seem to matter ( can revisit if issue )
	            'input @ui.noteSubject':            'userChangedNoteSubject'
	        });
	
	        if ( !fvChannel.request('settings').isIE ) {
	
	            _.extend( evts, {
	                'input @ui.opacitySlider':  'textOpacityChange' // not working IE
	            });
	        }
	        else {
	
	            _.extend( evts, {
	                'change @ui.opacitySlider': 'textOpacityChange'  // change works same as input browser other than IE
	            });
	
	        }
	
	        return evts;
	
	    },
	
	    templateHelpers: _.extend( {}, DrawablePageNoteView.prototype.templateHelpers, {
	
	        isTextStamp: function () {
	            return true;
	        },
	
	        fontSizes: function() {
	            return this.note.uiModel.getFontSizesToPopulateDropdown();
	        },
	
	        fonts: function() {
	            return this.note.uiModel.getFontsToPopulateDropdown();
	        }
	
	    }),
	
	    // Shared code now with graphicStamp ....
	
	    onRender: function() {
	
	        DrawablePageNoteView.prototype.onRender.apply(this, arguments);
	
	        this._createStampSelectView();
	
	        // Maybe after show to go with stamp selector ... would like refactor of all to my regions
	        this.stampChanged();
	        this._createFontPicker();
	        this._createFontColorPicker();
	        this._setColorPickerColor();
	        this._toggleEnabledColorPicker(); // destroys ( so can't be in create )
	
	        this._updateOpacitySlider();
	
	    },
	
	    /* Direct Copy */
	    // TODO: change all note views to Marionette Layout Views ...
	    onShow: function() {
	
	        // currently 'super' doesn't have onShow method but call in case it ever does
	        var superOnShow = DrawablePageNoteView.prototype.onShow;
	        superOnShow && superOnShow.apply( this, arguments );
	
	        // must be in DOM for width to be calc'd according to size ( on toggle active note it still may be hidden however ) - so doesn't matter
	        this._createFontSizePicker();
	
	        // pass down the on show method to the child view
	        // this should be a layout/region so we could hook into the events but dont want to break what exist
	        // a better refactor would be to update to MUCH newer version of Marionette, where I believe all views inherit this functionality
	        this.stampSelectView.triggerMethod('show');
	
	    },
	
	    /* --- Kind of an entry point --- */
	    stampChanged: function() {
	
	        this._createTemplatePreview();
	        this._createTextPreviewView();
	        this._createVariableInputsView();
	        this.createExistingTokensView();
	        this._updateStampReady();
	
	        var selectedStamp =  this.uiModel.get('selectedStamp'),
	            selectedStampIsDerivedFromPageNote =
	            this.uiModel.get('selectedStamp') && this.uiModel.get('selectedStamp').isDerivedFromPageNote();
	
	        this.ui.existingTemplateSelectedIndicator
	            .toggleClass( 'active', selectedStampIsDerivedFromPageNote )
	            .attr( 'title', selectedStampIsDerivedFromPageNote ? 'Selected stamp is that chosen when note was created.' : '' );
	
	
	        if ( this.model.isNew() && !this.userChangedSubjectInput ) {
	            this.ui.noteSubject.val( selectedStamp.get('subject') );
	        }
	
	
	    },
	
	    userChangedNoteSubject: function() {
	
	        this.model.isNew() && (this.userChangedSubjectInput = true);
	
	    },
	
	    /* TODO: new name -- now not just generated text -- font, font-size */
	    generatedTextChange: function() {
	
	        this._createTextPreviewView();
	        //this._createVariableInputsView(); -- don't need to re-render on every kevpress
	        this._updateStampReady();
	
	        this._updateFontPickerCss();
	
	    },
	
	    _createStampSelectView: function() {
	
	        this.stampSelectView && this.stampSelectView.destroy();
	
	        var userStamps = fvChannel.request('user').getTextStamps(),
	            initialStamp = this.uiModel.get('selectedStamp');
	
	        this.stampSelectView = new StampSelectorView({
	            userStamps: userStamps,
	            initialStamp: initialStamp,
	            onChange: function( stampId ) {
	
	                var stamp = stampId > 0
	                    ? userStamps.get( stampId )
	                    : initialStamp;
	
	                this.uiModel.setSelectedStamp( stamp );
	
	            }.bind( this )
	
	        });
	
	        this.ui.stampSelectPlaceHolder.replaceWith( this.stampSelectView.render().el );
	
	    },
	
	    /**
	     * Need to update from chosen -- it is limited -- below is one time hack to allow input of text not in the options
	     * without a fork; and this lib doesn't allow monkey patch.
	     * https://stackoverflow.com/questions/18706735/adding-text-other-than-the-selected-text-options-to-the-select-with-the-chosen-p
	     * prob should make this a separate view
	     */
	    _createFontSizePicker: function() {
	
	        this.chosenFontSizeSelector = this.ui.fontSizeSelect
	
	            .val( this.uiModel.get('fontSize') )
	
	            .chosen({
	                width: '65px', // define it here, could be hidden on active note change
	                no_results_text: 'Press enter to add:'
	            }).on( 'change', _.bind( function() {
	
	                this.uiModel.set( 'fontSize', parseFloat( this.ui.fontSizeSelect.val() ) ); // this will trigger change
	
	            }, this ) )
	
	            .data( 'chosen' );
	
	        //
	        // var existingKeyDown = $._data( this.ui.fontSizeSelect.data('chosen').search_field.get(0) , "events").keydown[0].handler;
	        // keyup comes after keydown; forked chosen we are using also prevents default on keydown of enter
	
	
	        /**
	         * Exist FV bundle keydown patch already looks for the enter key on keydown ---
	         * this should work b/c keyup comes after.
	         */
	        this.chosenFontSizeSelector.search_field.on( 'keyup', _.bind( function(e)  {
	
	            var inputValue = this.chosenFontSizeSelector.search_field.val();
	            var inputValueIsNumeric = validateFreeFontSizeInput(inputValue);
	            var $noResultsMenuItem = this.chosenFontSizeSelector.dropdown.find('li.no-results');
	
	            $noResultsMenuItem.removeClass('hide');
	
	            if ( !inputValueIsNumeric ) {
	                $noResultsMenuItem.addClass('hide');
	                return;
	            }
	
	            var select = this.ui.fontSizeSelect;
	
	            if ( e.which === 13 && $noResultsMenuItem.length > 0  ) // $noResultsMenuItem.addClass('hide');
	            {
	                var option = $('<option>').val( inputValue ).text( inputValue );
	                select.prepend( option );
	                select.find( option ).prop('selected', true);
	
	                // Could sort but I don't think we need to
	                select
	                    .trigger('chosen:close')
	                    .trigger('chosen:updated')
	                    .trigger('change');
	
	            }
	
	            function validateFreeFontSizeInput(input) {
	                if ( isNaN(input) )
	                    return false;
	
	                return true;
	            }
	
	        }, this));
	
	    },
	
	    _createFontPicker: function() {
	
	        this.chosenFontSelector = this.ui.fontSelect
	            .val( this.uiModel.get('font') )
	            .chosen({
	                width: '100%'
	            }).on( 'change', function() {
	
	                this.uiModel.set( 'font', this.ui.fontSelect.val() );
	
	            }.bind( this) );
	
	        this._updateFontPickerCss();
	
	    },
	
	    _updateFontPickerCss: function() {
	        this.ui.fontSelectWr.css({ 'font-family': this.uiModel.get('font') });
	    },
	
	    /**
	     * This should now be a sub-view
	     * Was going to handle the text opacity but can't do that:
	     * - if derived color rule applies, we can't disable this picker as well
	     * - anyway, ran into trouble with the plugin because the alpha selector didn't work horizontally
	     * In the future, if we have backgrounds, the opacity would presumably apply to the entire shape.
	     */
	    _createFontColorPicker: function() {
	
	        if ( this.colorPicker ) {
	            return;
	        }
	
	        var uiModel = this.uiModel;
	
	        this.colorPicker = new Picker({
	            parent:  this.ui.colorPickerParent[0],
	            color:  uiModel.getTextColor(),
	            editorFormat: 'hex', // can't be this if want to track alpha events ( but now we need separate controls )
	            editor: false,
	            alpha: false,
	            onChange: function( color ) {
	                //uiModel.setTextColorAndOpacity(  color.printHex(), color._rgba[3] ); -- if used for alpha
	                uiModel.setTextColor( color.printHex() );
	            }
	
	        });
	
	    },
	
	    _setColorPickerColor: function() {
	
	        this.ui.colorPickerParent.css({
	            'background-color': this.uiModel.getTextColor()
	        } );
	    },
	
	    textOpacityChange: function( e ) {
	
	        this.uiModel.setTextOpacity( parseFloat(e.target.value) / 100 );
	
	    },
	
	    _updateOpacitySlider: function( ) {
	
	        this.ui.opacitySlider.val( this.uiModel.getTextOpacity() * 100 );
	
	    },
	
	    _updateTextColor: function() {
	
	        this._setColorPickerColor();
	        this._createTextPreviewView(); // could make more efficient ... with only a color change ...
	    },
	
	    /**
	     * Copied from the old color picker for the color rules.... also sets the title of the color picker.
	     * Now extra logic for when 'expanded'.
	     */
	    _toggleEnabledColorPicker: function() {
	
	        var colorRuleDisabledReason = this.model.disableColorPickerDueToColorRules( );
	        var isDisabledDueToColorRule = colorRuleDisabledReason !== null;
	        var isExpanded = this.uiModel.get('expanded');
	        var disable = colorRuleDisabledReason !== null || isExpanded;
	
	        // Destroy or create -> there isn't a 'disable'
	        if ( disable ) {
	            this._destroyColorPicker();
	        }
	        else {
	            this._createFontColorPicker();
	        }
	
	        this.ui.colorPickerParent
	            .toggleClass( 'disabled', disable )
	            .attr( 'title', isDisabledDueToColorRule
	                ? this._getTitleAttrForColorPicker( disable, colorRuleDisabledReason )
	                : 'Color'
	            );
	
	        this._updateTextColor();
	
	    },
	
	    _getTitleAttrForColorPicker: function( isDisabled, disabledReason ) {
	
	        var ORIGINAL_TITLE = 'Color';
	
	        var title = ORIGINAL_TITLE;
	
	        if ( isDisabled ) {
	            title += ' (disabled):\n' + disabledReason;
	        }
	
	        return title;
	
	    },
	
	    /* -- CP */
	
	    // TODO: TEMP now with just a text area
	    // TODO: toggle white space ???
	    _createTemplatePreview: function() {
	
	        this.ui.templateDiv.html( this.uiModel.getSelectedStamp().getText() );
	
	    },
	
	    _createVariableInputsView: function() {
	
	        this.variableInputsView && this.variableInputsView.destroy(); // TODO: regions
	
	        if ( this.uiModel.getSelectedStamp().hasVariables() ) {
	
	            this.variableInputsView = new VariableInputsView({
	                inputCollection: this.uiModel.getVariableInputs()
	            });
	
	            this.ui.inputsViewWr.append( this.variableInputsView.render().el );
	
	        }
	
	    },
	
	    createExistingTokensView: function() {
	
	       this.existingTokensView && this.existingTokensView.destroy();
	
	        var selectedStamp = this.uiModel.getSelectedStamp();
	
	        if ( selectedStamp.isDerivedFromPageNote() && selectedStamp.hasTokens() ) {
	
	            this.existingTokensView = new ExistingTokensView({
	                stampNoteUiModel: this.uiModel
	            });
	
	            this.ui.existingTokensWrDiv.append(this.existingTokensView.render().el);
	
	        }
	
	    },
	
	    _createTextPreviewView: function() {
	
	        var uiModel = this.uiModel,
	            textColor = uiModel.getColorToApply(),
	            backgroundColor =  getContrastYIQ( textColor, '#333');
	
	        // Not doing font-size -- can lead to spacing issues
	        this.ui.previewViewWrDiv
	            .css({
	                color: hexToRgba( textColor, uiModel.getTextOpacity() ),
	                'background-color': backgroundColor,
	                'font-family': uiModel.getFont()
	            })
	            .html( this.uiModel.getGeneratedText() );
	    },
	
	    /**
	     * From change in stampPlaced or change stampReady --
	     * could name more appropriately.
	     * Show checkmark icon and indicator if user if ready to place a stamp ( assuming it is valid and not placed ).
	     * Stamps can be placed and invalid if the user changes the input after the place the stamp.
	     * If stamp is placed, never show.
	     * If not, show if the inputs are valid and the stamp is ready.
	     * If stamp is placed and the inputs are not valid, use will get a validation error msg if they try to save.
	     */
	
	    _updateStampReady: function() {
	
	        if ( this.uiModel.get('stampPlaced') ) {
	
	            this.ui.stampReadyIndicator.addClass( 'hide' );
	            return;
	        }
	
	        this.ui.stampReadyIndicator.toggleClass( 'hide',  !this.uiModel.getInputsValid() );
	
	    },
	
	    /** Note: length validated in html */
	    variableInputBoxChange: function(e) {
	
	        var $input = $(e.target),
	            variableKey = $input.data('key'),
	            inputValue = $input.val();
	
	        this.uiModel.updateInputVariableValue( variableKey, inputValue );
	
	    },
	
	    toggleExpandMode: function( uiModel, expanded ) {
	
	        DrawablePageNoteView.prototype.toggleExpandMode.apply( this, arguments );
	
	        this._toggleEnabledColorPicker();
	
	    },
	
	    _destroyColorPicker: function() {
	
	        if ( !this.colorPicker ) {
	            return;
	        }
	
	        this.colorPicker.destroy();
	        this.colorPicker = null;
	    },
	
	    onBeforeDestroy: function() {
	
	        this.stampSelectView && this.stampSelectView.destroy();
	        this.variableInputsView && this.variableInputsView.destroy();
	        this.existingTokensView && this.existingTokensView.destroy();
	
	        this.ui.fontSelect.chosen('destroy').off();
	
	
	        /* font-selector -- maybe want to self encapsulate */
	        if ( this.chosenFontSizeSelector )
	        {
	            this.chosenFontSizeSelector.search_field.off(); // unsure if necessary
	            this.ui.fontSizeSelect
	                .chosen('destroy')
	                .off();
	        }
	
	        this._destroyColorPicker();
	
	        DrawablePageNoteView.prototype.onBeforeDestroy.apply( this, arguments );
	
	    }
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 324 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/** STARTING WITH COPY-PASTE FROM GRAPHIC STAMP SELECTOR -- see difference and maybe combo code with graphic  */
	
	__webpack_require__(326);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	__webpack_require__(163);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    tagName: 'select',
	    className: 'textStampSelect',
	    template: __webpack_require__(327),
	
	    initialize: function( options ) {
	
	        this.userStamps = options.userStamps;
	        this.initialStamp = options.initialStamp;
	        this.stampIsDerivedFromPageNote = this.initialStamp && this.initialStamp.isDerivedFromPageNote();
	
	        this.onChange = options.onChange; // TODO: make the graphic one this ...
	        this.numberOptions = 0; // TODO: template in other class ...
	
	    },
	    serializeData: function() {
	
	        // ( its a 'cached' clone of the original user stamp model attributes, reference is still in tact )
	        var myStampsArray = this.userStamps.getDataToPopulateCreateStampDropDown();
	
	        var myStampDataToPopulateDropdown = [];
	
	        if ( !this.stampIsDerivedFromPageNote ) {
	
	            myStampDataToPopulateDropdown = [].concat( myStampsArray );
	
	        } else {
	
	            var stampFromTemplate = this.initialStamp.attributes;
	            stampFromTemplate.isFromNote = true;
	            myStampDataToPopulateDropdown = [ this.initialStamp.attributes ].concat( myStampsArray ); // ( make this this first so it is selected -- template only interest in the attributes )
	
	        }
	
	        this.numberOptions = myStampDataToPopulateDropdown.length;
	
	        return {
	            stamps: myStampDataToPopulateDropdown
	        };
	
	
	    },
	
	    //  Maybe we don't select one automatically for new stamps?
	    onRender: function() {
	
	        this.initialStamp && this.$el.val( this.initialStamp.get('id') );
	
	        // disable if there are no more choices to chose from -- do in template?
	        if ( this.numberOptions < 2 )
	            this.$el.attr('disabled', 'disabled');
	
	    },
	
	    onShow: function() {
	
	        this.$el
	            .chosen({
	                width: '100%', // Do in CSS?
	                placeholder_text_single: 'Select a Stamp...'
	            })
	            .on('change', _.bind( this._onStampSelectChange, this) );
	
	
	    },
	
	    _onStampSelectChange: function( e, params ) {
	
	        this.onChange( parseFloat( params.selected ) );
	
	    },
	
	    onBeforeDestroy: function() {
	        this.$el
	            .off()
	            .chosen('destroy');
	
	    }
	});

/***/ },
/* 326 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "    <option value=\""
	    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.subject : depth0), depth0))
	    + " "
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.isFromNote : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" "
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.isFromNote : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">"
	    + alias2(alias1((depth0 != null ? depth0.subject : depth0), depth0))
	    + "</option>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "--from existing note template";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "class=\"stampFromNote\"";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.stamps : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"useData":true});

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(329);
	
	
	var Marionette = __webpack_require__(61);
	
	
	// For now now doing collection view ... if leave that way may was well do collection
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(330),
	
	    serializeData: function() {
	
	        return {
	            inputs: this.options.inputCollection.toJSON()
	        };
	
	    }
	
	
	
	});

/***/ },
/* 329 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "\n    <div class=\"note-opts-row note-opts-row-txt-stamp-variable\">\n        <label class=\"note-opts-lbl-left txt-stamp-variable-lbl\">"
	    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
	    + ":</label>\n        <input class=\"txt-stamp-variable-input placeholder\" type=\"text\" value=\""
	    + alias2(alias1((depth0 != null ? depth0.value : depth0), depth0))
	    + "\" maxlength=\"1000\"\n               placeholder=\""
	    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.keyNoSymbol : depth0), depth0))
	    + "\" data-key=\""
	    + alias2(alias1((depth0 != null ? depth0.key : depth0), depth0))
	    + "\" required>\n    </div>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div class=\"note-opts-row\">\n    <span>Variables:</span>\n</div>\n\n\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.inputs : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(332);
	
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(333),
	
	    initialize: function( options ) {
	
	        this.stampNoteUiModel = options.stampNoteUiModel;
	
	    },
	
	    ui: {
	        'useExistingCb': '.existing-wc-checkbox'
	    },
	
	    events: {
	
	        'change @ui.useExistingCb': 'onUseExistingTokensChange'
	    },
	
	    serializeData: function() {
	
	        var originalTokens = this.stampNoteUiModel.get( 'originalStampTokens' );
	
	        var messageForExistingTokens = 'Selected stamp was originally created with the following token values: ' +
	            originalTokens.map( function( t ) {
	                return t.get('key') + ' (' + t.get('value') + ')';
	            } ).join(', ') + '.';
	
	        return {
	            message: messageForExistingTokens,
	            useNewValues: this.stampNoteUiModel.get( 'useNewTokenValues' )
	        };
	
	    },
	
	    onUseExistingTokensChange: function() {
	
	        this.stampNoteUiModel.toggleUseNewTokenValues();
	
	    }
	
	
	});

/***/ },
/* 332 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n<label class=\"\">\n    <input type=\"checkbox\" class=\"existing-wc-checkbox\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.useNewValues : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n    Update Existing Tokens With Current Values\n</label>\n<i class=\"icon-info-circled existing-token-icon\" title=\""
	    + container.escapeExpression(((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"message","hash":{},"data":data}) : helper)))
	    + "\"></i>\n\n\n\n\n\n\n";
	},"useData":true});

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(335);
	
	var Picker = __webpack_require__(337); // ( the csp version )
	
	module.exports = Picker;

/***/ },
/* 335 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 336 */,
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * vanilla-picker v2.12.1
	 * https://vanilla-picker.js.org
	 *
	 * Copyright 2017-2021 Andreas Borgen (https://github.com/Sphinxxxx), Adam Brooks (https://github.com/dissimulate)
	 * Released under the ISC license.
	 */
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Picker = factory());
	})(this, (function () { 'use strict';
	
	  var classCallCheck = function (instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };
	
	  var createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  var slicedToArray = function () {
	    function sliceIterator(arr, i) {
	      var _arr = [];
	      var _n = true;
	      var _d = false;
	      var _e = undefined;
	
	      try {
	        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	          _arr.push(_s.value);
	
	          if (i && _arr.length === i) break;
	        }
	      } catch (err) {
	        _d = true;
	        _e = err;
	      } finally {
	        try {
	          if (!_n && _i["return"]) _i["return"]();
	        } finally {
	          if (_d) throw _e;
	        }
	      }
	
	      return _arr;
	    }
	
	    return function (arr, i) {
	      if (Array.isArray(arr)) {
	        return arr;
	      } else if (Symbol.iterator in Object(arr)) {
	        return sliceIterator(arr, i);
	      } else {
	        throw new TypeError("Invalid attempt to destructure non-iterable instance");
	      }
	    };
	  }();
	
	  String.prototype.startsWith = String.prototype.startsWith || function (needle) {
	      return this.indexOf(needle) === 0;
	  };
	  String.prototype.padStart = String.prototype.padStart || function (len, pad) {
	      var str = this;while (str.length < len) {
	          str = pad + str;
	      }return str;
	  };
	
	  var colorNames = { cb: '0f8ff', tqw: 'aebd7', q: '-ffff', qmrn: '7fffd4', zr: '0ffff', bg: '5f5dc', bsq: 'e4c4', bck: '---', nch: 'ebcd', b: '--ff', bvt: '8a2be2', brwn: 'a52a2a', brw: 'deb887', ctb: '5f9ea0', hrt: '7fff-', chcT: 'd2691e', cr: '7f50', rnw: '6495ed', crns: '8dc', crms: 'dc143c', cn: '-ffff', Db: '--8b', Dcn: '-8b8b', Dgnr: 'b8860b', Dgr: 'a9a9a9', Dgrn: '-64-', Dkhk: 'bdb76b', Dmgn: '8b-8b', Dvgr: '556b2f', Drng: '8c-', Drch: '9932cc', Dr: '8b--', Dsmn: 'e9967a', Dsgr: '8fbc8f', DsTb: '483d8b', DsTg: '2f4f4f', Dtrq: '-ced1', Dvt: '94-d3', ppnk: '1493', pskb: '-bfff', mgr: '696969', grb: '1e90ff', rbrc: 'b22222', rwht: 'af0', stg: '228b22', chs: '-ff', gnsb: 'dcdcdc', st: '8f8ff', g: 'd7-', gnr: 'daa520', gr: '808080', grn: '-8-0', grnw: 'adff2f', hnw: '0fff0', htpn: '69b4', nnr: 'cd5c5c', ng: '4b-82', vr: '0', khk: '0e68c', vnr: 'e6e6fa', nrb: '0f5', wngr: '7cfc-', mnch: 'acd', Lb: 'add8e6', Lcr: '08080', Lcn: 'e0ffff', Lgnr: 'afad2', Lgr: 'd3d3d3', Lgrn: '90ee90', Lpnk: 'b6c1', Lsmn: 'a07a', Lsgr: '20b2aa', Lskb: '87cefa', LsTg: '778899', Lstb: 'b0c4de', Lw: 'e0', m: '-ff-', mgrn: '32cd32', nn: 'af0e6', mgnt: '-ff', mrn: '8--0', mqm: '66cdaa', mmb: '--cd', mmrc: 'ba55d3', mmpr: '9370db', msg: '3cb371', mmsT: '7b68ee', '': '-fa9a', mtr: '48d1cc', mmvt: 'c71585', mnLb: '191970', ntc: '5fffa', mstr: 'e4e1', mccs: 'e4b5', vjw: 'dead', nv: '--80', c: 'df5e6', v: '808-0', vrb: '6b8e23', rng: 'a5-', rngr: '45-', rch: 'da70d6', pgnr: 'eee8aa', pgrn: '98fb98', ptrq: 'afeeee', pvtr: 'db7093', ppwh: 'efd5', pchp: 'dab9', pr: 'cd853f', pnk: 'c0cb', pm: 'dda0dd', pwrb: 'b0e0e6', prp: '8-080', cc: '663399', r: '--', sbr: 'bc8f8f', rb: '4169e1', sbrw: '8b4513', smn: 'a8072', nbr: '4a460', sgrn: '2e8b57', ssh: '5ee', snn: 'a0522d', svr: 'c0c0c0', skb: '87ceeb', sTb: '6a5acd', sTgr: '708090', snw: 'afa', n: '-ff7f', stb: '4682b4', tn: 'd2b48c', t: '-8080', thst: 'd8bfd8', tmT: '6347', trqs: '40e0d0', vt: 'ee82ee', whT: '5deb3', wht: '', hts: '5f5f5', w: '-', wgrn: '9acd32' };
	
	  function printNum(num) {
	      var decs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	      var str = decs > 0 ? num.toFixed(decs).replace(/0+$/, '').replace(/\.$/, '') : num.toString();
	      return str || '0';
	  }
	
	  var Color = function () {
	      function Color(r, g, b, a) {
	          classCallCheck(this, Color);
	
	
	          var that = this;
	          function parseString(input) {
	
	              if (input.startsWith('hsl')) {
	                  var _input$match$map = input.match(/([\-\d\.e]+)/g).map(Number),
	                      _input$match$map2 = slicedToArray(_input$match$map, 4),
	                      h = _input$match$map2[0],
	                      s = _input$match$map2[1],
	                      l = _input$match$map2[2],
	                      _a = _input$match$map2[3];
	
	                  if (_a === undefined) {
	                      _a = 1;
	                  }
	
	                  h /= 360;
	                  s /= 100;
	                  l /= 100;
	                  that.hsla = [h, s, l, _a];
	              } else if (input.startsWith('rgb')) {
	                  var _input$match$map3 = input.match(/([\-\d\.e]+)/g).map(Number),
	                      _input$match$map4 = slicedToArray(_input$match$map3, 4),
	                      _r = _input$match$map4[0],
	                      _g = _input$match$map4[1],
	                      _b = _input$match$map4[2],
	                      _a2 = _input$match$map4[3];
	
	                  if (_a2 === undefined) {
	                      _a2 = 1;
	                  }
	
	                  that.rgba = [_r, _g, _b, _a2];
	              } else {
	                  if (input.startsWith('#')) {
	                      that.rgba = Color.hexToRgb(input);
	                  } else {
	                      that.rgba = Color.nameToRgb(input) || Color.hexToRgb(input);
	                  }
	              }
	          }
	
	          if (r === undefined) ; else if (Array.isArray(r)) {
	              this.rgba = r;
	          } else if (b === undefined) {
	              var color = r && '' + r;
	              if (color) {
	                  parseString(color.toLowerCase());
	              }
	          } else {
	              this.rgba = [r, g, b, a === undefined ? 1 : a];
	          }
	      }
	
	      createClass(Color, [{
	          key: 'printRGB',
	          value: function printRGB(alpha) {
	              var rgb = alpha ? this.rgba : this.rgba.slice(0, 3),
	                  vals = rgb.map(function (x, i) {
	                  return printNum(x, i === 3 ? 3 : 0);
	              });
	
	              return alpha ? 'rgba(' + vals + ')' : 'rgb(' + vals + ')';
	          }
	      }, {
	          key: 'printHSL',
	          value: function printHSL(alpha) {
	              var mults = [360, 100, 100, 1],
	                  suff = ['', '%', '%', ''];
	
	              var hsl = alpha ? this.hsla : this.hsla.slice(0, 3),
	                  vals = hsl.map(function (x, i) {
	                  return printNum(x * mults[i], i === 3 ? 3 : 1) + suff[i];
	              });
	
	              return alpha ? 'hsla(' + vals + ')' : 'hsl(' + vals + ')';
	          }
	      }, {
	          key: 'printHex',
	          value: function printHex(alpha) {
	              var hex = this.hex;
	              return alpha ? hex : hex.substring(0, 7);
	          }
	      }, {
	          key: 'rgba',
	          get: function get() {
	              if (this._rgba) {
	                  return this._rgba;
	              }
	              if (!this._hsla) {
	                  throw new Error('No color is set');
	              }
	
	              return this._rgba = Color.hslToRgb(this._hsla);
	          },
	          set: function set(rgb) {
	              if (rgb.length === 3) {
	                  rgb[3] = 1;
	              }
	
	              this._rgba = rgb;
	              this._hsla = null;
	          }
	      }, {
	          key: 'rgbString',
	          get: function get() {
	              return this.printRGB();
	          }
	      }, {
	          key: 'rgbaString',
	          get: function get() {
	              return this.printRGB(true);
	          }
	      }, {
	          key: 'hsla',
	          get: function get() {
	              if (this._hsla) {
	                  return this._hsla;
	              }
	              if (!this._rgba) {
	                  throw new Error('No color is set');
	              }
	
	              return this._hsla = Color.rgbToHsl(this._rgba);
	          },
	          set: function set(hsl) {
	              if (hsl.length === 3) {
	                  hsl[3] = 1;
	              }
	
	              this._hsla = hsl;
	              this._rgba = null;
	          }
	      }, {
	          key: 'hslString',
	          get: function get() {
	              return this.printHSL();
	          }
	      }, {
	          key: 'hslaString',
	          get: function get() {
	              return this.printHSL(true);
	          }
	      }, {
	          key: 'hex',
	          get: function get() {
	              var rgb = this.rgba,
	                  hex = rgb.map(function (x, i) {
	                  return i < 3 ? x.toString(16) : Math.round(x * 255).toString(16);
	              });
	
	              return '#' + hex.map(function (x) {
	                  return x.padStart(2, '0');
	              }).join('');
	          },
	          set: function set(hex) {
	              this.rgba = Color.hexToRgb(hex);
	          }
	      }], [{
	          key: 'hexToRgb',
	          value: function hexToRgb(input) {
	
	              var hex = (input.startsWith('#') ? input.slice(1) : input).replace(/^(\w{3})$/, '$1F').replace(/^(\w)(\w)(\w)(\w)$/, '$1$1$2$2$3$3$4$4').replace(/^(\w{6})$/, '$1FF');
	
	              if (!hex.match(/^([0-9a-fA-F]{8})$/)) {
	                  throw new Error('Unknown hex color; ' + input);
	              }
	
	              var rgba = hex.match(/^(\w\w)(\w\w)(\w\w)(\w\w)$/).slice(1).map(function (x) {
	                  return parseInt(x, 16);
	              });
	
	              rgba[3] = rgba[3] / 255;
	              return rgba;
	          }
	      }, {
	          key: 'nameToRgb',
	          value: function nameToRgb(input) {
	
	              var hash = input.toLowerCase().replace('at', 'T').replace(/[aeiouyldf]/g, '').replace('ght', 'L').replace('rk', 'D').slice(-5, 4),
	                  hex = colorNames[hash];
	              return hex === undefined ? hex : Color.hexToRgb(hex.replace(/\-/g, '00').padStart(6, 'f'));
	          }
	      }, {
	          key: 'rgbToHsl',
	          value: function rgbToHsl(_ref) {
	              var _ref2 = slicedToArray(_ref, 4),
	                  r = _ref2[0],
	                  g = _ref2[1],
	                  b = _ref2[2],
	                  a = _ref2[3];
	
	              r /= 255;
	              g /= 255;
	              b /= 255;
	
	              var max = Math.max(r, g, b),
	                  min = Math.min(r, g, b);
	              var h = void 0,
	                  s = void 0,
	                  l = (max + min) / 2;
	
	              if (max === min) {
	                  h = s = 0;
	              } else {
	                  var d = max - min;
	                  s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	                  switch (max) {
	                      case r:
	                          h = (g - b) / d + (g < b ? 6 : 0);break;
	                      case g:
	                          h = (b - r) / d + 2;break;
	                      case b:
	                          h = (r - g) / d + 4;break;
	                  }
	
	                  h /= 6;
	              }
	
	              return [h, s, l, a];
	          }
	      }, {
	          key: 'hslToRgb',
	          value: function hslToRgb(_ref3) {
	              var _ref4 = slicedToArray(_ref3, 4),
	                  h = _ref4[0],
	                  s = _ref4[1],
	                  l = _ref4[2],
	                  a = _ref4[3];
	
	              var r = void 0,
	                  g = void 0,
	                  b = void 0;
	
	              if (s === 0) {
	                  r = g = b = l;
	              } else {
	                  var hue2rgb = function hue2rgb(p, q, t) {
	                      if (t < 0) t += 1;
	                      if (t > 1) t -= 1;
	                      if (t < 1 / 6) return p + (q - p) * 6 * t;
	                      if (t < 1 / 2) return q;
	                      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	                      return p;
	                  };
	
	                  var q = l < 0.5 ? l * (1 + s) : l + s - l * s,
	                      p = 2 * l - q;
	
	                  r = hue2rgb(p, q, h + 1 / 3);
	                  g = hue2rgb(p, q, h);
	                  b = hue2rgb(p, q, h - 1 / 3);
	              }
	
	              var rgba = [r * 255, g * 255, b * 255].map(Math.round);
	              rgba[3] = a;
	
	              return rgba;
	          }
	      }]);
	      return Color;
	  }();
	
	  var EventBucket = function () {
	      function EventBucket() {
	          classCallCheck(this, EventBucket);
	
	          this._events = [];
	      }
	
	      createClass(EventBucket, [{
	          key: 'add',
	          value: function add(target, type, handler) {
	              target.addEventListener(type, handler, false);
	              this._events.push({
	                  target: target,
	                  type: type,
	                  handler: handler
	              });
	          }
	      }, {
	          key: 'remove',
	          value: function remove(target, type, handler) {
	              this._events = this._events.filter(function (e) {
	                  var isMatch = true;
	                  if (target && target !== e.target) {
	                      isMatch = false;
	                  }
	                  if (type && type !== e.type) {
	                      isMatch = false;
	                  }
	                  if (handler && handler !== e.handler) {
	                      isMatch = false;
	                  }
	
	                  if (isMatch) {
	                      EventBucket._doRemove(e.target, e.type, e.handler);
	                  }
	                  return !isMatch;
	              });
	          }
	      }, {
	          key: 'destroy',
	          value: function destroy() {
	              this._events.forEach(function (e) {
	                  return EventBucket._doRemove(e.target, e.type, e.handler);
	              });
	              this._events = [];
	          }
	      }], [{
	          key: '_doRemove',
	          value: function _doRemove(target, type, handler) {
	              target.removeEventListener(type, handler, false);
	          }
	      }]);
	      return EventBucket;
	  }();
	
	  function parseHTML(htmlString) {
	
	      var div = document.createElement('div');
	      div.innerHTML = htmlString;
	      return div.firstElementChild;
	  }
	
	  function dragTrack(eventBucket, area, callback) {
	      var dragging = false;
	
	      function clamp(val, min, max) {
	          return Math.max(min, Math.min(val, max));
	      }
	
	      function onMove(e, info, starting) {
	          if (starting) {
	              dragging = true;
	          }
	          if (!dragging) {
	              return;
	          }
	
	          e.preventDefault();
	
	          var bounds = area.getBoundingClientRect(),
	              w = bounds.width,
	              h = bounds.height,
	              x = info.clientX,
	              y = info.clientY;
	
	          var relX = clamp(x - bounds.left, 0, w),
	              relY = clamp(y - bounds.top, 0, h);
	
	          callback(relX / w, relY / h);
	      }
	
	      function onMouse(e, starting) {
	          var button = e.buttons === undefined ? e.which : e.buttons;
	          if (button === 1) {
	              onMove(e, e, starting);
	          } else {
	              dragging = false;
	          }
	      }
	
	      function onTouch(e, starting) {
	          if (e.touches.length === 1) {
	              onMove(e, e.touches[0], starting);
	          } else {
	              dragging = false;
	          }
	      }
	
	      eventBucket.add(area, 'mousedown', function (e) {
	          onMouse(e, true);
	      });
	      eventBucket.add(area, 'touchstart', function (e) {
	          onTouch(e, true);
	      });
	      eventBucket.add(window, 'mousemove', onMouse);
	      eventBucket.add(area, 'touchmove', onTouch);
	      eventBucket.add(window, 'mouseup', function (e) {
	          dragging = false;
	      });
	      eventBucket.add(area, 'touchend', function (e) {
	          dragging = false;
	      });
	      eventBucket.add(area, 'touchcancel', function (e) {
	          dragging = false;
	      });
	  }
	
	  var BG_TRANSP = 'linear-gradient(45deg, lightgrey 25%, transparent 25%, transparent 75%, lightgrey 75%) 0 0 / 2em 2em,\n                   linear-gradient(45deg, lightgrey 25%,       white 25%,       white 75%, lightgrey 75%) 1em 1em / 2em 2em';
	  var HUES = 360;
	
	  var EVENT_KEY = 'keydown',
	      EVENT_CLICK_OUTSIDE = 'mousedown',
	      EVENT_TAB_MOVE = 'focusin';
	
	  function $(selector, context) {
	      return (context || document).querySelector(selector);
	  }
	
	  function stopEvent(e) {
	
	      e.preventDefault();
	      e.stopPropagation();
	  }
	  function onKey(bucket, target, keys, handler, stop) {
	      bucket.add(target, EVENT_KEY, function (e) {
	          if (keys.indexOf(e.key) >= 0) {
	              if (stop) {
	                  stopEvent(e);
	              }
	              handler(e);
	          }
	      });
	  }
	
	  var Picker = function () {
	      function Picker(options) {
	          classCallCheck(this, Picker);
	
	
	          this.settings = {
	
	              popup: 'right',
	              layout: 'default',
	              alpha: true,
	              editor: true,
	              editorFormat: 'hex',
	              cancelButton: false,
	              defaultColor: '#0cf'
	          };
	
	          this._events = new EventBucket();
	
	          this.onChange = null;
	
	          this.onDone = null;
	
	          this.onOpen = null;
	
	          this.onClose = null;
	
	          this.setOptions(options);
	      }
	
	      createClass(Picker, [{
	          key: 'setOptions',
	          value: function setOptions(options) {
	              var _this = this;
	
	              if (!options) {
	                  return;
	              }
	              var settings = this.settings;
	
	              function transfer(source, target, skipKeys) {
	                  for (var key in source) {
	                      if (skipKeys && skipKeys.indexOf(key) >= 0) {
	                          continue;
	                      }
	
	                      target[key] = source[key];
	                  }
	              }
	
	              if (options instanceof HTMLElement) {
	                  settings.parent = options;
	              } else {
	
	                  if (settings.parent && options.parent && settings.parent !== options.parent) {
	                      this._events.remove(settings.parent);
	                      this._popupInited = false;
	                  }
	
	                  transfer(options, settings);
	
	                  if (options.onChange) {
	                      this.onChange = options.onChange;
	                  }
	                  if (options.onDone) {
	                      this.onDone = options.onDone;
	                  }
	                  if (options.onOpen) {
	                      this.onOpen = options.onOpen;
	                  }
	                  if (options.onClose) {
	                      this.onClose = options.onClose;
	                  }
	
	                  var col = options.color || options.colour;
	                  if (col) {
	                      this._setColor(col);
	                  }
	              }
	
	              var parent = settings.parent;
	              if (parent && settings.popup && !this._popupInited) {
	
	                  var openProxy = function openProxy(e) {
	                      return _this.openHandler(e);
	                  };
	
	                  this._events.add(parent, 'click', openProxy);
	
	                  onKey(this._events, parent, [' ', 'Spacebar', 'Enter'], openProxy);
	
	                  this._popupInited = true;
	              } else if (options.parent && !settings.popup) {
	                  this.show();
	              }
	          }
	      }, {
	          key: 'openHandler',
	          value: function openHandler(e) {
	              if (this.show()) {
	
	                  e && e.preventDefault();
	
	                  this.settings.parent.style.pointerEvents = 'none';
	
	                  var toFocus = e && e.type === EVENT_KEY ? this._domEdit : this.domElement;
	                  setTimeout(function () {
	                      return toFocus.focus();
	                  }, 100);
	
	                  if (this.onOpen) {
	                      this.onOpen(this.colour);
	                  }
	              }
	          }
	      }, {
	          key: 'closeHandler',
	          value: function closeHandler(e) {
	              var event = e && e.type;
	              var doHide = false;
	
	              if (!e) {
	                  doHide = true;
	              } else if (event === EVENT_CLICK_OUTSIDE || event === EVENT_TAB_MOVE) {
	
	                  var knownTime = (this.__containedEvent || 0) + 100;
	                  if (e.timeStamp > knownTime) {
	                      doHide = true;
	                  }
	              } else {
	
	                  stopEvent(e);
	
	                  doHide = true;
	              }
	
	              if (doHide && this.hide()) {
	                  this.settings.parent.style.pointerEvents = '';
	
	                  if (event !== EVENT_CLICK_OUTSIDE) {
	                      this.settings.parent.focus();
	                  }
	
	                  if (this.onClose) {
	                      this.onClose(this.colour);
	                  }
	              }
	          }
	      }, {
	          key: 'movePopup',
	          value: function movePopup(options, open) {
	
	              this.closeHandler();
	
	              this.setOptions(options);
	              if (open) {
	                  this.openHandler();
	              }
	          }
	      }, {
	          key: 'setColor',
	          value: function setColor(color, silent) {
	              this._setColor(color, { silent: silent });
	          }
	      }, {
	          key: '_setColor',
	          value: function _setColor(color, flags) {
	              if (typeof color === 'string') {
	                  color = color.trim();
	              }
	              if (!color) {
	                  return;
	              }
	
	              flags = flags || {};
	              var c = void 0;
	              try {
	
	                  c = new Color(color);
	              } catch (ex) {
	                  if (flags.failSilently) {
	                      return;
	                  }
	                  throw ex;
	              }
	
	              if (!this.settings.alpha) {
	                  var hsla = c.hsla;
	                  hsla[3] = 1;
	                  c.hsla = hsla;
	              }
	              this.colour = this.color = c;
	              this._setHSLA(null, null, null, null, flags);
	          }
	      }, {
	          key: 'setColour',
	          value: function setColour(colour, silent) {
	              this.setColor(colour, silent);
	          }
	      }, {
	          key: 'show',
	          value: function show() {
	              var parent = this.settings.parent;
	              if (!parent) {
	                  return false;
	              }
	
	              if (this.domElement) {
	                  var toggled = this._toggleDOM(true);
	
	                  this._setPosition();
	
	                  return toggled;
	              }
	
	              var html = this.settings.template || '<div class="picker_wrapper" tabindex="-1"><div class="picker_arrow"></div><div class="picker_hue picker_slider"><div class="picker_selector"></div></div><div class="picker_sl"><div class="picker_selector"></div></div><div class="picker_alpha picker_slider"><div class="picker_selector"></div></div><div class="picker_editor"><input aria-label="Type a color name or hex value"/></div><div class="picker_sample"></div><div class="picker_done"><button>Ok</button></div><div class="picker_cancel"><button>Cancel</button></div></div>';
	              var wrapper = parseHTML(html);
	
	              this.domElement = wrapper;
	              this._domH = $('.picker_hue', wrapper);
	              this._domSL = $('.picker_sl', wrapper);
	              this._domA = $('.picker_alpha', wrapper);
	              this._domEdit = $('.picker_editor input', wrapper);
	              this._domSample = $('.picker_sample', wrapper);
	              this._domOkay = $('.picker_done button', wrapper);
	              this._domCancel = $('.picker_cancel button', wrapper);
	
	              wrapper.classList.add('layout_' + this.settings.layout);
	              if (!this.settings.alpha) {
	                  wrapper.classList.add('no_alpha');
	              }
	              if (!this.settings.editor) {
	                  wrapper.classList.add('no_editor');
	              }
	              if (!this.settings.cancelButton) {
	                  wrapper.classList.add('no_cancel');
	              }
	              this._ifPopup(function () {
	                  return wrapper.classList.add('popup');
	              });
	
	              this._setPosition();
	
	              if (this.colour) {
	                  this._updateUI();
	              } else {
	                  this._setColor(this.settings.defaultColor);
	              }
	              this._bindEvents();
	
	              return true;
	          }
	      }, {
	          key: 'hide',
	          value: function hide() {
	              return this._toggleDOM(false);
	          }
	      }, {
	          key: 'destroy',
	          value: function destroy() {
	              this._events.destroy();
	              if (this.domElement) {
	                  this.settings.parent.removeChild(this.domElement);
	              }
	          }
	      }, {
	          key: '_bindEvents',
	          value: function _bindEvents() {
	              var _this2 = this;
	
	              var that = this,
	                  dom = this.domElement,
	                  events = this._events;
	
	              function addEvent(target, type, handler) {
	                  events.add(target, type, handler);
	              }
	
	              addEvent(dom, 'click', function (e) {
	                  return e.preventDefault();
	              });
	
	              dragTrack(events, this._domH, function (x, y) {
	                  return that._setHSLA(x);
	              });
	
	              dragTrack(events, this._domSL, function (x, y) {
	                  return that._setHSLA(null, x, 1 - y);
	              });
	
	              if (this.settings.alpha) {
	                  dragTrack(events, this._domA, function (x, y) {
	                      return that._setHSLA(null, null, null, 1 - y);
	                  });
	              }
	
	              var editInput = this._domEdit;
	              {
	                  addEvent(editInput, 'input', function (e) {
	                      that._setColor(this.value, { fromEditor: true, failSilently: true });
	                  });
	
	                  addEvent(editInput, 'focus', function (e) {
	                      var input = this;
	
	                      if (input.selectionStart === input.selectionEnd) {
	                          input.select();
	                      }
	                  });
	              }
	
	              this._ifPopup(function () {
	
	                  var popupCloseProxy = function popupCloseProxy(e) {
	                      return _this2.closeHandler(e);
	                  };
	
	                  addEvent(window, EVENT_CLICK_OUTSIDE, popupCloseProxy);
	                  addEvent(window, EVENT_TAB_MOVE, popupCloseProxy);
	                  onKey(events, dom, ['Esc', 'Escape'], popupCloseProxy);
	
	                  var timeKeeper = function timeKeeper(e) {
	                      _this2.__containedEvent = e.timeStamp;
	                  };
	                  addEvent(dom, EVENT_CLICK_OUTSIDE, timeKeeper);
	
	                  addEvent(dom, EVENT_TAB_MOVE, timeKeeper);
	
	                  addEvent(_this2._domCancel, 'click', popupCloseProxy);
	              });
	
	              var onDoneProxy = function onDoneProxy(e) {
	                  _this2._ifPopup(function () {
	                      return _this2.closeHandler(e);
	                  });
	                  if (_this2.onDone) {
	                      _this2.onDone(_this2.colour);
	                  }
	              };
	              addEvent(this._domOkay, 'click', onDoneProxy);
	              onKey(events, dom, ['Enter'], onDoneProxy);
	          }
	      }, {
	          key: '_setPosition',
	          value: function _setPosition() {
	              var parent = this.settings.parent,
	                  elm = this.domElement;
	
	              if (parent !== elm.parentNode) {
	                  parent.appendChild(elm);
	              }
	
	              this._ifPopup(function (popup) {
	
	                  if (getComputedStyle(parent).position === 'static') {
	                      parent.style.position = 'relative';
	                  }
	
	                  var cssClass = popup === true ? 'popup_right' : 'popup_' + popup;
	
	                  ['popup_top', 'popup_bottom', 'popup_left', 'popup_right'].forEach(function (c) {
	
	                      if (c === cssClass) {
	                          elm.classList.add(c);
	                      } else {
	                          elm.classList.remove(c);
	                      }
	                  });
	
	                  elm.classList.add(cssClass);
	              });
	          }
	      }, {
	          key: '_setHSLA',
	          value: function _setHSLA(h, s, l, a, flags) {
	              flags = flags || {};
	
	              var col = this.colour,
	                  hsla = col.hsla;
	
	              [h, s, l, a].forEach(function (x, i) {
	                  if (x || x === 0) {
	                      hsla[i] = x;
	                  }
	              });
	              col.hsla = hsla;
	
	              this._updateUI(flags);
	
	              if (this.onChange && !flags.silent) {
	                  this.onChange(col);
	              }
	          }
	      }, {
	          key: '_updateUI',
	          value: function _updateUI(flags) {
	              if (!this.domElement) {
	                  return;
	              }
	              flags = flags || {};
	
	              var col = this.colour,
	                  hsl = col.hsla,
	                  cssHue = 'hsl(' + hsl[0] * HUES + ', 100%, 50%)',
	                  cssHSL = col.hslString,
	                  cssHSLA = col.hslaString;
	
	              var uiH = this._domH,
	                  uiSL = this._domSL,
	                  uiA = this._domA,
	                  thumbH = $('.picker_selector', uiH),
	                  thumbSL = $('.picker_selector', uiSL),
	                  thumbA = $('.picker_selector', uiA);
	
	              function posX(parent, child, relX) {
	                  child.style.left = relX * 100 + '%';
	              }
	              function posY(parent, child, relY) {
	                  child.style.top = relY * 100 + '%';
	              }
	
	              posX(uiH, thumbH, hsl[0]);
	
	              this._domSL.style.backgroundColor = this._domH.style.color = cssHue;
	
	              posX(uiSL, thumbSL, hsl[1]);
	              posY(uiSL, thumbSL, 1 - hsl[2]);
	
	              uiSL.style.color = cssHSL;
	
	              posY(uiA, thumbA, 1 - hsl[3]);
	
	              var opaque = cssHSL,
	                  transp = opaque.replace('hsl', 'hsla').replace(')', ', 0)'),
	                  bg = 'linear-gradient(' + [opaque, transp] + ')';
	
	              this._domA.style.background = bg + ', ' + BG_TRANSP;
	
	              if (!flags.fromEditor) {
	                  var format = this.settings.editorFormat,
	                      alpha = this.settings.alpha;
	
	                  var value = void 0;
	                  switch (format) {
	                      case 'rgb':
	                          value = col.printRGB(alpha);break;
	                      case 'hsl':
	                          value = col.printHSL(alpha);break;
	                      default:
	                          value = col.printHex(alpha);
	                  }
	                  this._domEdit.value = value;
	              }
	
	              this._domSample.style.color = cssHSLA;
	          }
	      }, {
	          key: '_ifPopup',
	          value: function _ifPopup(actionIf, actionElse) {
	              if (this.settings.parent && this.settings.popup) {
	                  actionIf && actionIf(this.settings.popup);
	              } else {
	                  actionElse && actionElse();
	              }
	          }
	      }, {
	          key: '_toggleDOM',
	          value: function _toggleDOM(toVisible) {
	              var dom = this.domElement;
	              if (!dom) {
	                  return false;
	              }
	
	              var displayStyle = toVisible ? '' : 'none',
	                  toggle = dom.style.display !== displayStyle;
	
	              if (toggle) {
	                  dom.style.display = displayStyle;
	              }
	              return toggle;
	          }
	      }]);
	      return Picker;
	  }();
	
	  return Picker;
	
	}));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	// TODO: a lot pasted initially from graphicStampUiModel -- see common areas
	
	/* State Logic here will be shared on the note view and canvas */
	/* Kind of a like a state object */
	
	
	var  _ = __webpack_require__(49),
	    NoteUiModel = __webpack_require__(154),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    DynamicInputCollection = __webpack_require__(339),
	    VariableInputModel = __webpack_require__(340),
	    TokenInputModel = __webpack_require__(342),
	    Util = __webpack_require__(48),
	    NormalizeNewLineCharacters = Util.normalizeNewLineCharacters;
	
	
	module.exports = NoteUiModel.extend({
	    // Fonts:  originally was testing vs Liberation Sans, Liberation Mono, Liberation, Courier New ( of the Liberation fonts )
	    // Now we have the go ahead to use the MS core fonts but just using these:
	    // - in case there is an issue with the others not being installed so we can fall back to the liberation ones
	    // - there aren't many 'big names' fonts in MS fonts anyway
	    // If coordination with CRE was possible, we could provide exact fonts and there would be no issue -- though the liberation ones should be
	    // installed and metrically equivalent
	    // Worse case is we serve the liberation ones but CRE will not check to see what font it uses
	    availableFonts: [ 'Arial', 'Courier New', 'Times New Roman' ],
	
	    availableFontSizes: [ 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72 ], // those from MS-word
	
	    defaults:  _.extend({}, NoteUiModel.prototype.defaults, {
	
	        version: '1.0', // where storing the current -- will be used for new stamps and to save that of originals ( could call current version )
	
	        selectedStamp: null,
	        variableInputs: null,
	        tokenInputs: null,
	
	        generatedText: null,  // store to trigger a change
	        inputsValid: false, // may want to trigger though may not need; not trigger for time being ....
	        stampPlaced: false,
	
	        // Other characteristics ...
	        fontSize: 36, // Same as signatures, this should be a config option; idea of making it proportional to the size of the page
	        font: 'Arial',
	
	        // Note: must use here and then pull into the parent note model class, not vice versa
	        // TODO: do we remember the last selected like with graphic notes? -- we store this on the defaultFor the noteModel
	
	        textColor: '#000000', //
	        textOpacity: 1.0,
	
	        rotationAtZeroPageRotation: 0, // These are created at a rotation of 0; we need to know the rotation at which they were created -- should always be 0 for those creating
	
	        // * Set if read in from template and the originalSelectedStamp.isDerivedFromPageNote */
	        originalStampVariables: null,
	        originalStampTokens: null,
	        useNewTokenValues: false // ( always default by default )
	
	
	    }),
	
	    /**
	     * Set on init -- only would apply to new -- currently no link on modify
	     * Should move to constructor ...
	     * Maybe easier to do from the note model -- setting the stamp on init after the ui model has been created
	     * Also could be easier to put some of this sutff on a shape model
	     */
	    initialize: function() {
	
	        NoteUiModel.prototype.initialize.apply(this, arguments);
	
	        // There is no selected stamp / link to the original on modify -- if modify will have been set on parse
	        if ( this.get('parent').isNew() )
	        {
	            var user = fvChannel.request('user');
	
	            if ( user.hasTextStamps() ) {
	
	                this.setSelectedStamp( user.getTextStamps().getDefaultStampForNewNote() );
	
	            }
	        }
	
	        else {
	
	            // This is the case when read in initially -- not after an original save -- see parent model parse code
	            // Refactor needed....
	
	
	            this.set({
	                rotationAtZeroPageRotation: this.parent.rotationAtZeroPageRotation,
	                font: this.parent.fontFamily,
	                fontSize: this.parent.fontSize,
	                stampPlaced: this.parent.stampPlaced,
	                textColor: this.parent.textColor,
	                textOpacity: this.parent.textOpacity
	            });
	
	
	            /* Do before selected stamp */
	
	            if ( this.parent.originalVariables ) {
	                this.setOriginalStampVariableInputs( this.parent.originalVariables );
	            }
	
	            if ( this.parent.originalTokens ) {
	                this.setOriginalTokenValues( this.parent.originalTokens );
	            }
	
	            // Also sets version
	            this.setSelectedStamp( this.parent.existingStamp );
	
	
	        }
	
	    },
	
	    resetOnCancelChanges: function() {
	
	        NoteUiModel.prototype.resetOnCancelChanges.apply( this, arguments );
	
	        // Reset values on here vs shape ( here 'text' attributes of the note ) .... quick hack ...
	        // Will want to change WF of parse/init of the parent note model ... ( see code )
	        this.initialize( {parent: this.parent} );
	
	    },
	
	    /**
	     * Central Pt -- also sets variableInputs, tokens from the stamp, and generatedText.
	     *
	     */
	    setSelectedStamp: function( stamp ) {
	
	        /* Variable inputs */
	        this.set({
	            variableInputs: null,
	            tokenInputs: null,
	            useNewTokenValues: false // always change back to false
	        });
	
	        var inputCollection;
	
	        if ( stamp.isDerivedFromPageNote() && stamp.hasVariables() ) {
	
	            // BB collection clone leaves references
	            inputCollection = new DynamicInputCollection( this.get('originalStampVariables').toJSON() );
	            this.set( 'variableInputs', inputCollection );
	            this.set({ inputsValid: inputCollection.allInputsAreValid() }) ; // ( Should be true )
	
	        } else {
	
	            var selectStampHasVariables = stamp.hasVariables();
	
	            if (selectStampHasVariables) {
	
	                // this may be heavier than we need with backbone ....
	                inputCollection = new DynamicInputCollection();
	
	                stamp.getVariables().forEach( function(v) {
	
	                    // Assuming coming from new.. don't need values and they are all invalid
	                    inputCollection.add({
	                        key: v,
	                        keyNoSymbol: v.substring(1)
	                    });
	
	                });
	
	                this.set('variableInputs', inputCollection);
	            }
	
	            this.set({ inputsValid: selectStampHasVariables ? false : true }); // inputCollection.allInputsAreValid() -- isNew, can't be valid
	
	
	        }
	
	        if ( stamp.hasTokens() ) {
	
	            this.set( 'tokenInputs', this._getTokenInputs( stamp ) );
	
	        }
	
	        this.set({ generatedText: this._derivedGeneratedText(stamp) }, {silent: true} );
	
	        this.set( 'selectedStamp', stamp ); /* trigger event */
	
	    },
	
	    _getTokenInputs: function( stamp ) {
	
	        stamp = stamp || this.getSelectedStamp();
	
	        if ( stamp.isDerivedFromPageNote() && !this.get('useNewTokenValues') ) {
	
	            return new DynamicInputCollection( this.get('originalStampTokens').toJSON() );
	
	        } else {
	
	            var tokenModels = stamp.getTokens().map( function( t ) {
	
	                var m = new TokenInputModel({
	                    key: t,
	                    keyNoSymbol: t.substring(1)
	                });
	
	                m.set( 'value', m.getNewGeneratedValue() );
	
	                return m;
	
	            });
	
	            return new DynamicInputCollection( tokenModels );
	        }
	
	    },
	
	    updateInputVariableValue: function( variableKey, value ) {
	
	        // Update that model
	        var variableInputModel = this.getVariableInputs().get( variableKey );
	        variableInputModel.setValue( value ); // ( handles is valid -- maybe can rid -- just derived )
	
	        // Now update the generated values ....
	        this.set({
	            inputsValid: this.getVariableInputs().allInputsAreValid(),
	            generatedText: this._derivedGeneratedText()  // triggers event
	        });
	
	    },
	
	    /**
	     * objVariables: key/value pairs of the variables' keys and values.
	     */
	    setOriginalStampVariableInputs: function( objVariables ) {
	
	        var inputCollection = new DynamicInputCollection();
	
	        for ( var k in objVariables ) {
	
	            var m = new VariableInputModel({
	                key: k,
	                keyNoSymbol: k.substring(1)
	            });
	
	            m.setValue( objVariables[k] );
	            inputCollection.add(m);
	        }
	
	        this.set( 'originalStampVariables', inputCollection );
	
	    },
	
	    setOriginalTokenValues: function( objTokens ) {
	
	        var inputCollection = new DynamicInputCollection();
	
	        for ( var k in objTokens ) {
	
	            var m = new VariableInputModel({
	                key: k,
	                keyNoSymbol: k.substring(1),
	                value: objTokens[k]
	            });
	
	            inputCollection.add(m);
	        }
	
	        this.set( 'originalStampTokens', inputCollection );
	
	    },
	
	
	    /**
	     * Could optimize more on init if necessary ( the non variable part )
	     * EOL whitespace:
	     * - normalize here again although aren't don't on load for the stamp module
	     * - variable could change and could prevent EOL characters or prevent on change, but simpler to to here
	     * - ( Raphael text relies on '\n' to create it's tspans
	     */
	    _derivedGeneratedText: function( stamp ) {
	
	        stamp = stamp || this.getSelectedStamp(); // ( former for init )
	
	        var output = stamp.getText();
	
	        // Replace tokens first
	
	        if ( stamp.hasTokens() ) {
	
	            this.getTokenInputs().each( function( t ) {
	
	                // To replace multiple, need to use a regExp; when ditch IE support, use replaceAll with a string. ( eg $date$date )
	                // Could cache for better optimization.
	                output = output.replace( new RegExp(  Util.escapeRegExp( t.get('key') ), 'g'), t.get('value') );
	
	            });
	
	        }
	
	        if ( stamp.hasVariables() ) {
	
	            this.getVariableInputs().each( function( variableInputModel ) {
	
	                var inputValue = variableInputModel.get('value');
	
	                // If nothing entered, leave the token in the preview
	                if ( inputValue && inputValue.length > 0 ) {
	
	                    // could store on the model for speed ...
	                    var escapedKey = Util.escapeRegExp( variableInputModel.get('key') ); // ( always starts with % )
	
	                    /**
	                     * Dupes  are all set with the same value.
	                     * \b -- see input on the stamps module:
	                     *  - now that all incoming variable must be there own words, get those with the exact number of characters
	                     *  - eg: %pet10 %pet1 would just match %pet1 ( and %pet10%pet1 could not exist )
	                     */
	                    var inputKeyRegExp = new RegExp( escapedKey + '\\b' , 'g' );
	
	                    output = output.replace( inputKeyRegExp, variableInputModel.get('value') );
	
	                }
	
	            });
	
	        }
	
	
	        output = NormalizeNewLineCharacters( output );
	
	        return output;
	
	    },
	
	    getSelectedStamp: function() {
	        return this.get('selectedStamp');
	    },
	
	    getVariableInputs: function() {
	        return this.get('variableInputs');
	    },
	
	    getTokenInputs: function() {
	        return this.get('tokenInputs');
	    },
	
	    getGeneratedText: function() {
	        return this.get('generatedText');
	    },
	
	    /* Implies ready to be stamped */
	    getInputsValid: function() {
	        return this.get('inputsValid');
	    },
	    getFont: function() {
	        return this.get('font');
	    },
	    getFontSize: function() {
	        return this.get('fontSize');
	    },
	
	    getFontSizesToPopulateDropdown: function() {
	
	        var currentFontSize = this.getFontSize();
	
	        if ( this.availableFontSizes.indexOf( currentFontSize ) > 0 )  {
	
	            return this.availableFontSizes;
	        }
	        else {
	
	            return [currentFontSize].concat( this.availableFontSizes ).sort( function( a, b) {
	                return a - b;
	            });
	        }
	
	    },
	
	    getFontsToPopulateDropdown: function() {
	
	        return this.availableFonts;
	
	    },
	
	    setStampPlaced: function( isPlaced ) {
	        this.set( 'stampPlaced', isPlaced );
	    },
	
	    hasVariableInputs: function() {
	
	        var inputs = this.getVariableInputs();
	
	        return inputs && inputs.length > 0;
	
	    },
	
	    /** ( Use seperate sets as functions rely on state/attribute values ) */
	    toggleUseNewTokenValues: function( ) {
	
	        this.set( 'tokenInputs', null );
	
	        this.set({ useNewTokenValues: !this.get('useNewTokenValues') });
	
	        this.set({ tokenInputs: this._getTokenInputs( this.get('selectedStamp') )} );
	
	        this.set({ generatedText: this._derivedGeneratedText()  } ) ; // triggers event
	
	    },
	
	    // Triggers an event -- color and opacity must be separate controls b/c color could be disabled!
	    //setTextColorAndOpacity: function( color, opacity ) {
	    //
	    //    this.set({
	    //        textColor: color,
	    //        textOpacity: +(opacity.toFixed(2) )
	    //    });
	    //
	    //},
	    //
	
	    setTextColor: function( color ) {
	        this.set( 'textColor', color );
	    },
	
	    setTextOpacity: function( alpha ) {
	
	        this.set( 'textOpacity', alpha );
	
	    },
	
	    getTextColor: function() {
	        return this.get('textColor');
	    },
	
	    getTextOpacity: function() {
	        return this.get('textOpacity');
	    },
	
	    /**
	     * Logic containing the color rules -- here v. larger refactor with canvas
	     * TODO: clean / and refactor -- this is copy'd from the canvas code
	     * would like to move that logic to the note model, for the other note types -- we don't have the shapes zone color on the note
	     * this would be something look into more when implemented color pickers for the other zones
	     */
	    getColorToApply: function() {
	
	        if ( fvChannel.request('supportConsults') ) {
	
	            var consultGroupColor = this.parent.getCurrentConsultColorForShapes(); // logic appears to handle setting this live ( vs deriving from selected consult groups )
	            if (consultGroupColor)
	                return consultGroupColor;
	        }
	
	        // 2) Groups of Note Creation User ( if belongs to one group with 1 color assigned )
	        // ( must override zone color -- otherwise  group color would never get applied ( see discussion in ticket DVBC-1780 )
	        var noteCreationUserGroupColor = this.parent.getCreationUserGroupColor();
	        if ( noteCreationUserGroupColor ) {
	            return noteCreationUserGroupColor;
	        }
	
	        // 3) Zone Color -- here, stored on this model -- default would already have been set before this is called
	        // ( There are no 'currentDrawing attributes' coming from the graphic shape toolbar here )
	        return this.get( 'textColor' );
	
	
	    },
	
	    getVersion: function() {
	
	        return this.get('version');
	
	    }
	
	
	});


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    VariableInputModel = __webpack_require__(340);
	
	
	module.exports = Backbone.Collection.extend({
	
	    model: VariableInputModel,
	
	    /* Now only applicable to Variables, not Tokens */
	    allInputsAreValid: function() {
	
	        return this.every( function( m ) {
	            return m.get('isValid');
	        });
	    }
	
	
	});


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DynamicInput = __webpack_require__(341);
	
	
	module.exports = DynamicInput.extend({
	
	    idAttribute: 'key',
	
	    defaults: _.extend( {}, DynamicInput.prototype.defaults, {
	
	        isValid: false // N/A
	
	    }),
	
	    setValue: function( value ) {
	
	        this.set({
	            value: value,
	            isValid: value.length > 0
	        });
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	    idAttribute: 'key',
	
	    defaults: {
	        key: '',
	        keyNoSymbol: '', // ( not the first letter )
	        value: '',
	        isValid: false // no entered ( maybe later too long )
	    }
	
	
	});

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var DynamicInput = __webpack_require__(341),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    moment = __webpack_require__(69);
	
	
	// isValid currently N/A ....
	
	module.exports = DynamicInput.extend({
	
	    idAttribute: 'key',
	
	    getNewGeneratedValue: function(  ) {
	
	        var type = this.get('keyNoSymbol');
	
	        var fvSettings = fvChannel.request('settings');
	
	        if ( type === 'date' ) {
	            return moment().format( fvSettings.DATE_FMT_STR);
	        }
	
	        /**
	         * We aren't storing UTC -- if we did, would need to refactor this and the XML -- these aren't just key-values if anything,
	         * and absolutely necessary, could store in XML attribute values.
	         */
	        if ( type === 'time' ) {
	            return moment.getCurrentTimestampWithTimezoneAbbreviation( 'h:mm A' );
	        }
	
	    }
	
	
	
	});

/***/ },
/* 343 */
/***/ function(module, exports) {

	/*
	 *
	 * For now just a friendly name mapping ... later perhaps the basis for a model factory.
	 * Taken from FddObjectTypeDBTranslater -- should be provided in webservice --
	 * only including those supported in data services.
	 * ( Update: I think only the enums (keys) are in the FddObjectTypeDBTranslater;
	 * the descriptions appear manually derived from schema documentation )
	 *
	 */
	
	module.exports = {
	    FDD_COLD_TEXT_OPTREC: 'Text (ANSI)',
	    FDD_CF_TEXT_OPTREC: 'Windows Text',
	    FDD_COLD_COMPRESS_OPTREC: 'Compressed COLD text',
	    FDD_IMAGE_TYPE: 'Native image',
	    FDD_GOS_TYPE: 'GOS',
	    FDD_FORMSIQ_OPTREC: 'Forms IQ',
	    FDD_EML_OPTREC: 'Email',
	    FDD_EML_V2_OPTREC: 'Parsed Email',
	    FDD_URL_OPTREC: 'URL',
	    FDD_UTF8_COMPRESS_OPTREC: 'Compressed COLD UTF8',
	    FDD_UTF8_TEXT_OPTREC: 'UTF8',
	    FDD_REPORT_OPTREC: 'Report page', //(only FDD support)
	    FDD_GOS_V3_OPTREC: 'Multi-part GOS part',
	    FDD_GOS_TOC_OPTREC: 'Multi-part GOS skeleton'
	};

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    BasePage = __webpack_require__(269),
	    _ = __webpack_require__(49),
	    PagePositionalTextModel = __webpack_require__(345);
	
	
	module.exports = BasePage.extend({
	
	    typeIdentifier: 'DOC_MODE',
	    SPIN_JS_OPTS: { top: '15%', length: 6, radius: 6, width: 2, lines: 13 },
	
	    /**
	     * Unlike thumbnail, based on fixed ht and width for the expected non-renderable placeholder.
	     * Note: this is diff than unknown -- for non-renderable placeholder.
	     * Note: height is arbitrary -- will be set by docModeImageWidthFn parameter (unless set it explicity)
	     * I think width is also arbitrary
	     */
	    nonRenderableOrigDimensions: {
	        w: 200,
	        h: 200
	    },
	
	    unknownOrigDimsDimensions: BasePage.prototype.STANDARD_PG_DIMS,
	
	    /**
	     * Store docModeImageWidthFn once -- used in getSetWidth.
	     * Only store positionalTextDataModel on Doc Mode pages -- can be referenced via the pages Collection on the active document
	     */
	    constructor: function(attrs, options) {
	
	        this.positionalTextDataModel = null;
	        this.docModeImageWidthFn = options.docModeImageWidthFn;
	
	        BasePage.prototype.constructor.apply(this, arguments);
	
	    },
	
	    // This works  but you need to update the derived dimensions on rotate
	    // do only for renderable pages / rotatable pages ... ???
	    parse: function(attrs) {
	
	        // the original is called first -- hack in change below ...
	        attrs = BasePage.prototype.parse.apply( this, arguments );
	
	
	        // Note: returns null from server if doesn't exist
	        if ( attrs.ocrNote ) {
	
	            this.positionalTextDataModel = new PagePositionalTextModel( attrs.ocrNote, {
	                parse: true,
	                pageNumber: attrs.number,
	                pageId: attrs.pageId,
	                fddPageOriginalImageProperties: attrs.originalImageProperties
	            });
	
	        }
	
	        // keep rotated 'derived' width at max of 1000 -- we request with the actual ...
	        var r = attrs.rotation;
	
	        // Get the what would be be the visible dimensions if printed with rotation
	
	        var rw = attrs.width,
	            rh = attrs.height;
	
	        if ( r === 90 || r === 270 ) {
	            rw = attrs.height;
	            rh = attrs.width;
	        }
	
	        var setWidth = this._getSetWidth();
	
	        // we just want it so width is not requested > MAX
	        // ( we don't want anything > a max width ) --  this resolves problems with fit width scaling ...
	        if ( rw > setWidth ) {
	
	            var rar = rw / rh; // do the calc at the current rotation ... maybe do on the actual width and height, non rotated ...
	            var nw = setWidth; // get a new width
	            var nh = Math.round( nw / rar );  // derive its new height from the original aspect ratio
	
	            // now unrotate if need be -- this also seems to work ... should do based off the original aspect ratio
	            // better refactor would be getting rid of the first part ... where the non rotated width is already maxed out at set width ...
	            // so we only update if rotated ...
	            if ( r === 90 || r === 270 ) {
	
	                attrs.width = nh;
	                attrs.height = nw;
	            }
	
	        }
	
	        return attrs;
	
	       // alternatively, after all pages parse, get the max width and apply that ... don't want any bigger than another ? ... that could be cleaner
	
	    },
	
	    /**
	     * Note: this can be dynamic so needs a fn to pass in that gets value from viewer
	     * TODO: I don't think we care about the max of the container width now and 1000
	     * --- could just say max of 1000 ... and max.min ( return Math.min( width, 1000 );
	     */
	    _getSetWidth: function() {
	        return this.docModeImageWidthFn();
	    },
	    /**
	     * Really the derived height from the original width of the image and the width of it's container -- (takes rotation into account)
	     * Should optimize the calc: cache and then only update on rotation change
	     */
	    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {
	
	        if ( !isRenderable )
	            return this.nonRenderableOrigDimensions.h;
	
	        var originalDimensions = attrs.originalImageProperties // ( only exists for FDD image -- TODO: may be better to check page type for fixtures that diverged since change )
	            ? {
	                w: attrs.originalImageProperties.width,
	                h: attrs.originalImageProperties.height
	            }
	            : this.unknownOrigDimsDimensions; // this will be set post load ( updateUnknownDimensionsPostLoad )
	
	
	        // Basically calc to fit to the size of the container
	        var ar = originalDimensions.w / originalDimensions.h;
	        return Math.round( this._getSetWidth() / ar );
	
	    },
	
	    updateUnknownDimensionsPostLoad: function(loadDimensions) {
	
	        var containerWidth = this.docModeImageWidthFn(),
	            imgWtToContainerWidthRatio = containerWidth / loadDimensions.width,
	            h =  Math.round( loadDimensions.height * imgWtToContainerWidthRatio);
	
	        this.set({
	           width: containerWidth,
	           height: h
	        });
	
	    },
	
	    // This allows for requesting with the correct aspect ratio given then adjustment made
	    // to keep a max width for all pages, given they can be rotated but the non rotated image is requested
	    _getFixedWidthForImgRenderRequest: function() {
	        return this.getRotatedWidth();
	    },
	
	    setRotation: function( rotation ) {
	
	        BasePage.prototype.setRotation.call( this, rotation );
	
	        // TODO: better way here --
	        // for this mode reset the height / width ( which are set on parse) in case the rotate width would be greater than the 'max width'
	
	        this.parse( this.attributes, {
	            parentDocument: this.get('parentDocument'),
	            imageFileType: this.get('imageFileType')
	        } );
	    },
	
	    /* -- positional text data model -- */
	
	    getPositionalTextDataModel: function() {
	
	        return this.positionalTextDataModel;
	
	    },
	
	    hasPositionalTextData: function() {
	
	        return this.getPositionalTextDataModel() !== null;
	
	    }
	
	
	});

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * Try utilizing a Backbone Model since still using Backbone, ugh
	 * Attributes here will be all server
	 * These are actually and OCR note in the database.
	 * Now used to print the page text overlays -- TODO: a candidate for removal ( everything at doc level now -- see DocumentTextModel )
	**/
	
	var Backbone = __webpack_require__(58),
	    PositionTextUiModel = __webpack_require__(346),
	    Zones = __webpack_require__(347),
	    Zone = __webpack_require__(348),
	    Lines = __webpack_require__(351),
	    Line = __webpack_require__(352),
	    Words = __webpack_require__(353),
	    ShapeUtils = __webpack_require__(197);
	
	
	module.exports = Backbone.Model.extend({
	
	    constructor: function( attrs, options ) {
	
	        this.zones = new Zones();
	        this.lines = new Lines();
	        this.words = new Words();
	
	        this.uiModel = new PositionTextUiModel();
	
	        Backbone.Model.apply( this, arguments );
	
	    },
	
	    /**
	     * Return only the page object in the 'pages array '-- there will always be one ( it is a page ).
	     * Could make it easier to work with server side.
	     */
	
	    defaults: {
	        version: null,
	        pageNumber: null,
	        pageId: null,
	
	        'ocr-vers': null,
	        'app-vers': null,
	        dpix: null,
	        dpiy: null,
	        sizex: null,
	        sizey: null,
	        language: null
	    },
	
	
	    //
	    /**
	     * Return the attrs hash to be set on the model
	     * Fuck all these Backbone Model's -- extra overhead ... only good for using approp BB views
	     * This is candidate for refactor -- parsed and looped through again at the Doc Level now.
	     * ( And now not all attributes set on the models on parse so we loop again ( setDerivedBoxes )
	     */
	
	    parse: function( attrs, options ) {
	
	        var pageAttrs = attrs.pages[0],
	            pageNumber = options.pageNumber,
	            pageId = options.pageId,
	            ocr_xdpi = pageAttrs.dpix,
	
	            //dpiy = pageAttrs.dpiy, // note: now note using dpiy anywhere
	
	            fddPgOriginalImageProperties = options.fddPageOriginalImageProperties,
	            fdd_xdpi = fddPgOriginalImageProperties.originalHDPI, // note: not using vDPI
	
	            ocrDpiDifferentThanFddDpi = fdd_xdpi !== ocr_xdpi, // leaving to emphasize the logic, but currently not used
	
	            box_px_adjustment = this.uiModel.get('BOX_PX_ADJUSTMENT');
	
	
	        var nLines = 0;
	        var nWords = 0;
	
	        var zones = pageAttrs.textzones;
	
	
	        for (var z in zones) {
	
	            z = parseInt(z);
	            var zone = zones[z];
	            var nWordsInZone = 0;
	
	            var zoneModel = new Zone( zone, {
	                parse: true,
	                page_level_id: z,
	                pageNumber: pageNumber,
	                pageId: pageId,
	                ocr_xdpi: ocr_xdpi,
	                fdd_xdpi: fdd_xdpi
	            });
	
	            // Now only take the box_px_adjustment into account -- not taking into acct other zones/lines
	            zoneModel.setDerivedBoxes( box_px_adjustment, fdd_xdpi );
	
	            this.zones.add( zoneModel );
	
	            var lines = zone.lines;
	
	            for (var l in lines) {
	
	                l = parseInt(l);
	
	                var line = lines[l];
	
	                var lineModel = new Line( line, {
	                    parse: true,
	                    page_level_id: nLines,
	                    pageLevelZoneId: z,
	                    pageLevelZoneLineId: l,
	                    pageNumber: pageNumber,
	                    pageId: pageId,
	                    ocr_xdpi: ocr_xdpi,
	                    fdd_xdpi: fdd_xdpi
	                });
	
	                // Now only take the box_px_adjustment into account -- not taking into acct other zones/lines
	                lineModel.setDerivedBoxes( box_px_adjustment, fdd_xdpi );
	
	                this.lines.add( lineModel );
	
	                this.zones.at(z).addPageLevelLineId( nLines );
	
	                var words = line.words;
	
	                for (var w in words) {
	
	                    var word = words[w];
	
	                    this.words.add( word, {
	
	                        parse: true,
	                        page_level_id: nWords,
	                        pageLevelZoneId: z,
	                        pageLevelLineId: nLines,
	                        pageLevelLineWordId: parseInt(w),
	                        pageLevelZoneWordId: nWordsInZone,
	                        pageLevelZoneLineId: l,
	                        pageNumber: pageNumber,
	                        pageId: pageId,
	
	                        ocr_xdpi: ocr_xdpi,
	                        fdd_xdpi: fdd_xdpi
	
	                    });
	
	                    this.lines.at( nLines ).addPageLevelWordId( nWords );
	                    this.zones.at( z ).addPageLevelWordId( nWords );
	
	                    nWords++;
	                    nWordsInZone++;
	
	                }
	
	                nLines++;
	
	            }
	
	        }
	
	
	        /**
	         * Set derived dimension for words which requires calcuations to be done after the first loop ( next word, line ).
	         * For now nothing special with text areas or zones other than padding ( above ); maybe later we do those too.
	         * Definitely more efficient way to accomplish -- eg combo with looping when need to parse in document ...
	         * For Lines -- important: these in page order can be adjacent to each other, so we need to concern ourselves
	         * with those in the same zone ( as we do with words on the lines ).
	         */
	        this.words.each( function( word, i ) {
	
	            var pageLevelZoneId = word.get('pageLevelZoneId');
	            var pageLevelLineId = word.get('pageLevelLineId');
	
	            // --- Lines ---
	            var line = this.lines.at(  pageLevelLineId );
	            var previousLine = this.lines.at( pageLevelLineId - 1 ); // ( undefined if not returned )
	            var nextLine = this.lines.at( pageLevelLineId + 1);
	
	            var prevLineInZone = previousLine && previousLine.get( 'pageLevelZoneId' ) === pageLevelZoneId
	                ? previousLine
	                : undefined;
	
	            var nextLineInZone = nextLine && nextLine.get('pageLevelZoneId') === pageLevelZoneId
	                ? nextLine
	                : undefined;
	
	            // --- Words ---
	            var prevWd = this.words.at( i - 1 );
	            var nextWd = this.words.at( i + 1 );
	
	            var prevWordOnLine = prevWd && prevWd.get('pageLevelLineId') === pageLevelLineId
	                ? prevWd
	                : undefined;
	
	            var nextWordOnLine = nextWd && nextWd.get('pageLevelLineId') === pageLevelLineId
	                ? nextWd
	                : undefined;
	
	            word.setDerivedBoxes(
	                box_px_adjustment, fdd_xdpi, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine
	            );
	
	
	        }, this);
	
	
	
	        var modelAttrs = _.extend( {}, pageAttrs , { // don't need to put pageAttrs on here again ...
	            version: attrs.version,
	            pageNumber: options.pageNumber, // maybe we want a reference to the parent model ?
	            pageId: options.pageId
	        });
	
	        delete modelAttrs.textzones;
	
	        return modelAttrs;
	
	    },
	
	    getZones: function() {
	        return this.zones;
	    },
	
	    getLines: function() {
	        return this.lines;
	    },
	
	    getWords: function() {
	        return this.words;
	    },
	
	    getFont: function() {
	        return this.uiModel.get('font');
	    },
	
	    // Now used in parsing at the doc level from these
	    getWord: function( pageLevelWordId ) {
	
	        return this.words.findWhere({ page_level_id: pageLevelWordId });
	
	    },
	
	    // Now used in parsing at the doc level from these
	    // Now not used -- used as doc level parse ( as long as still using this obj )
	    getLine: function( pageLevelLineId ) {
	        return this.lines.findWhere( { page_level_id: pageLevelLineId } );
	    },
	
	    /**
	     * TODO: this is not page-line-ids -- can't use get unless pass in the doc level id
	     *  Could have both ...
	     * No longer used ...
	     */
	    getWordsOfLine: function( pageLevelLineId ) {
	
	
	        var line = this.getLine( pageLevelLineId );
	
	        return _.map( line.pgLevelWordIds, function( wid ) {
	
	           // return this.words.findWhere(wid); // add these may also blow up now with id and .get
	            return this.words.findWhere({ page_level_id: wid });
	
	        }, this );
	
	    },
	
	    /**
	     * Convenience if has access to line model -- now unused but would need to change
	     * No longer used
	     */
	    getWordModelsOfLine: function( lineModel ) {
	
	        return _.map( lineModel.pgLevelWordIds, function( wid ) {
	           return this.words.get(wid);
	        }, this);
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	/**
	 * TODO: if we only apply this document wide, do so at the state level -- or maybe have a doc model UI
	 * BOX_PX_ADJUSTMENT:
	 * - now 8 ( we want larger ); 8 for 8x8 coordinates that are used to jpg compression to prevent
	 *   potential issue with artifacts ( though now John says to not worry about that ).
	 *   - To avoid covering document with large padding, we don't allow it to extend to the adjacent lines and words.
	 * - Now the same for lines, zones, and words -- may later want to break apart and have different values.
	 * - Later phase this will likely be configurable.
	 * Font:
	 *  - show or hide may also want to be configurable, so that would be a setting
	 *  - others sue when testing: 'Times New Roman', 'Courier New', Courier, monospace;
	 *  - really the CSS font family
	 */
	
	
	
	module.exports = Backbone.Model.extend({
	
	
	    defaults: {
	        font: 'Arial, Helvetica, sans-serif',
	        BOX_PX_ADJUSTMENT: 8
	    }
	
	
	});

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Zone = __webpack_require__(348);
	
	module.exports = Backbone.Collection.extend({
	
	    model: Zone
	
	});

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var TextArea = __webpack_require__(349);
	
	
	module.exports = TextArea.extend({
	
	    initialize: function() {
	
	        this.pageLevelLineIds = [];
	        this.pageLevelWordIds = [];
	
	        this.docLevelLineIds = [];
	        this.docLevelWordIds = [];
	
	        TextArea.prototype.initialize.apply( this, arguments );
	    },
	
	    addPageLevelLineId: function( pageLevelLineId ) {
	
	        this.pageLevelLineIds.push( pageLevelLineId );
	
	    },
	
	
	    addPageLevelWordId: function( pageLevelWordId ) {
	
	        this.pageLevelWordIds.push( pageLevelWordId );
	
	    },
	
	    /* Don't add dupes */
	    addDocLevelLineId: function( docLevelLineId ) {
	
	        if ( this.docLevelLineIds.indexOf( docLevelLineId ) < 0 )
	            this.docLevelLineIds.push( docLevelLineId );
	
	    },
	
	    addDocLevelWordId: function( docLevelWordId ) {
	
	        this.docLevelWordIds.push( docLevelWordId );
	
	    },
	
	    getPageLevelLineIds: function() {
	        return this.pageLevelLineIds;
	    },
	
	    getPageLevelWordsIds: function() {
	        return this.pageLevelWordIds;
	    },
	
	    getDocLevelLineIds: function() {
	
	        return this.docLevelLineIds;
	
	    },
	
	    getDocLevelWordIds: function() {
	
	        return this.docLevelWordIds;
	
	    }
	
	});

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Box = __webpack_require__(350),
	    ShapeUtils = __webpack_require__(197);
	
	
	module.exports = Backbone.Model.extend({
	
	    /**
	     * boxPx:
	     * - always derived from the DPI of the OCR engine from twips
	     * - since images in DV are always printed in pixels, should always work; use for 'overlays'
	     * - also if DPI incorrect for OCR ( it gives default of 300 if none exists ), it's coordinates should still map to the image,
	     * - to get to pixels with whatever DPI it chooses
	     * - also store on load in case we need to use to calc 'space' on the page
	     * - can be used for positioning via CSS
	     * boxFDDZoneUnits:
	     * - use for anything canvas/zone related
	     * - really the the the size of 1/10 mm using FDD's DPI ( in case different than that of the OCR engine )
	     * - now really the units the box would be stored in, in zone files -- not just 1/10mm but assumes FDD's DPI
	     * - this will resolve problems where the DPI of the OCR engine and FDD differ, which could occur, for instance,
	     * - if there is no DPI stored with the image; here they each can make different assumptions.
	     */
	    defaults: {
	
	        id: null, // overall id at the document level ( not the page level; index of the original and derived word arrays )
	
	        page_level_key: null, // this could also be a unique identifier
	        page_level_id: null, // unique index of this item type on the page ( line and zone )
	
	        pageNumber: null,
	        pageId: null,
	
	        boxPx: null,
	        boxFDDZoneUnits: null,
	        boxPxDerived: null,
	        boxFDDZoneUnitsDerived: null
	
	    },
	
	    parse: function( attrs, options ) {
	
	        var taAttrs = {
	            page_level_id: options.page_level_id,
	            page_level_key:  this._generatePageKeyId( options ),
	            pageNumber: options.pageNumber,
	            pageId: options.pageId
	        };
	
	        /** For now continue to set non-derived boxes on parse */
	        taAttrs.boxPx = this._generateBoxPx( attrs, options.ocr_xdpi );
	
	        // Always use the dpi from FDD ( if it's the same as the OCR engine, it will be the same anyway )
	        taAttrs.boxFDDZoneUnits = this._generateBoxFDDZoneUnits( taAttrs.boxPx, options.fdd_xdpi );
	
	        return taAttrs;
	
	    },
	
	    _generatePageKeyId: function( options ) {
	        return options.pageNumber + '_' + options.page_level_id;
	    },
	
	
	    // Always use OCR-DPI !
	    _generateBoxPx: function( attrs, ocr_xdpi ) {
	
	        return new Box({
	            l: this.twipsToPx( attrs.l, ocr_xdpi, 1, 0 ),
	            r: this.twipsToPx( attrs.r, ocr_xdpi, 0, 1 ),
	            t: this.twipsToPx( attrs.t, ocr_xdpi, 1, 0 ),
	            b: this.twipsToPx( attrs.b, ocr_xdpi, 0, 1 )
	        } );
	
	    },
	
	    // Conversion performed with appropriate rounding to get more of the area
	    // DPI is is the DPI of the FDD image ( if they are the same, it'd be the same value anyway )
	    _generateBoxFDDZoneUnits: function( boxPx, fdd_xdpi ) {
	
	        return new Box({
	            l: Math.floor( ShapeUtils.pxToTenthsMM( boxPx.get('l'), fdd_xdpi ) ),
	            r: Math.ceil( ShapeUtils.pxToTenthsMM( boxPx.get('r'), fdd_xdpi ) ),
	            t: Math.floor( ShapeUtils.pxToTenthsMM( boxPx.get('t'), fdd_xdpi ) ),
	            b: Math.ceil( ShapeUtils.pxToTenthsMM( boxPx.get('b'), fdd_xdpi ) )
	        });
	
	    },
	
	
	    /**
	     * Called post-parse ( in case needs other models needed for calculation )--
	     * see word model.
	     * Refactor warranted.
	     */
	    setDerivedBoxes: function( box_px_adjustment, fdd_xdpi ) {
	
	        var boxPxDerived =
	            this._generateBoxPxDerived( this.get('boxPx'), box_px_adjustment );
	
	        var boxFDDZoneUnitsDerived =
	            this._generateBoxFDDZoneUnitsDerived( boxPxDerived, fdd_xdpi );
	
	        this.set({
	            boxPxDerived: boxPxDerived,
	            boxFDDZoneUnitsDerived: boxFDDZoneUnitsDerived
	        });
	
	
	    },
	
	    /**
	     * Adjust with BOX_PX_ADJUSTMENT ( sides )
	     * This adjustment just adds to the pixels in the original -- no DPI taken into account
	     * Can be overwritten for words
	     * No rounding here ...
	     */
	    _generateBoxPxDerived: function( boxPx, box_px_adjustment  ) {
	
	        return new Box({
	            l: boxPx.get('l') - box_px_adjustment,
	            r: boxPx.get('r') + box_px_adjustment,
	            t: boxPx.get('t') - box_px_adjustment,
	            b: boxPx.get('b') + box_px_adjustment
	        } );
	
	    },
	
	
	    // Basically same as as proto._generateBoxFDDZoneUnits, without floor/ceil
	    // Don't think need  floor/ ceil here -- it's already done on the initial pixel conversion
	    _generateBoxFDDZoneUnitsDerived: function( boxPxDerived, fdd_xdpi ) {
	
	        return new Box({
	            l: ShapeUtils.pxToTenthsMM( boxPxDerived.get('l'), fdd_xdpi ) ,
	            r: ShapeUtils.pxToTenthsMM( boxPxDerived.get('r'), fdd_xdpi ) ,
	            t: ShapeUtils.pxToTenthsMM( boxPxDerived.get('t'), fdd_xdpi ) ,
	            b: ShapeUtils.pxToTenthsMM( boxPxDerived.get('b'), fdd_xdpi )
	        });
	
	    },
	
	
	
	    // TODO: what if different h and vdpi?
	    // Note: control rounding so to the 'outside' to be more inclusive
	    twipsToPx: function( twips, dpi, roundDown, roundUp ) {
	
	        var unRoundedPixels = twips * dpi / 1440;
	
	        if ( roundDown )
	            return Math.floor( unRoundedPixels );
	
	        if ( roundUp )
	            return Math.ceil( unRoundedPixels );
	
	        return Math.round( unRoundedPixels );
	
	    },
	
	
	    getBoxPx: function() {
	        return this.get('boxPx');
	    },
	
	    getBoxPxDerived: function() {
	        return this.get('boxPxDerived');
	    },
	
	    /**
	     * Default return coordinates from boxPx
	     * If useDerived, return coordinates from boxPxDerived ( use for testing calc's )
	     */
	    getBoxCssStyle: function( useDerived ) {
	
	        var boxToUse = !useDerived
	            ? this.getBoxPx()
	            : this.getBoxPxDerived();
	
	        return boxToUse.getBoxCssStyle( );
	    }
	
	
	
	
	});

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	/**
	 * Should make an object -- would likely increase performance
	 * Not using parse to set height and width; unecessary and can be derived --
	 * put fn's on here to show that
	 */
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        l: null,
	        r: null,
	        t: null,
	        b: null
	
	    },
	
	    // Note: assumed to be 'bbox' order --
	    // will come into play for shape select sets
	    getBoxCoordinates: function() {
	
	        var attrs = this.attributes;
	
	        return [
	            {x: attrs.l, y: attrs.t},
	            {x: attrs.r, y: attrs.t},
	            {x: attrs.r, y: attrs.b},
	            {x: attrs.l, y: attrs.b}
	        ];
	
	    },
	
	    getHeight: function() {
	
	        return this.get('b') - this.get('t');
	
	    },
	
	    getWidth: function() {
	
	        return this.get('r') - this.get('l');
	
	    },
	
	    // Now this can likely go on view that would utilize
	    // ( For absolute positioning )
	    getBoxCssStyle: function() {
	
	        var attrs = this.attributes;
	
	        var style = 'left:' + attrs.l + 'px; ';
	        style += 'top:' + attrs.t + 'px; ';
	
	        var width = attrs.r - attrs.l; // maybe better pre conversion ....
	        var height = attrs.b - attrs.t;
	
	        style += 'width:' + width + 'px; ';
	        style += 'height:' + height + 'px;';
	
	        return style;
	
	    },
	
	    // Create a new box by combing this and another
	    combo: function( otherBox ) {
	
	        return new this.constructor({
	            l: Math.min( this.get('l'), otherBox.get('l') ),
	            r: Math.max( this.get('r'), otherBox.get('r') ),
	            t: Math.min( this.get('t'), otherBox.get('t') ),
	            b: Math.max( this.get('b'), otherBox.get('b') )
	        });
	
	    }
	
	
	});
	


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Line = __webpack_require__(352);
	
	
	module.exports = Backbone.Collection.extend({
	
	    model: Line
	
	});

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var TextArea = __webpack_require__(349),
	    _ = __webpack_require__(49);
	
	
	module.exports = TextArea.extend({
	
	    initialize: function() {
	
	        this.pgLevelWordIds = [];
	        this.docLevelWordIds = [];
	
	        TextArea.prototype.initialize.apply( this, arguments );
	
	    },
	
	    defaults: _.extend( {}, TextArea.prototype.defaults, {
	
	        pageLevelZoneId: null,
	        pageLevelZoneLineId: null, // maybe just call index ?
	
	        // TODO: see if these help with any positioning
	        baseline: null,
	        fontsize: null
	
	    }),
	
	    parse: function(attrs, options) {
	
	        var baseAttrs = TextArea.prototype.parse.apply(this, arguments);
	
	        baseAttrs.pageLevelZoneId = options.pageLevelZoneId;
	        baseAttrs.pageLevelZoneLineId = options.pageLevelZoneLineId;
	
	        baseAttrs.baseline = attrs.baseline;
	        baseAttrs.fontsize = attrs.fontsize;
	
	        return baseAttrs;
	
	    },
	
	    _generatePageKeyId: function(options) {
	        return options.pageNumber + '_' + options.pageLevelZoneId + '_' + options.page_level_id;
	    },
	
	    addPageLevelWordId: function( pgLevelWordId ) {
	
	        this.pgLevelWordIds.push( pgLevelWordId );
	
	    },
	
	    addDocLevelWordId: function( docLevelWordId ) {
	
	        this.docLevelWordIds.push( docLevelWordId );
	    },
	
	    getPageLevelWordIds: function() {
	        return this.pgLevelWordIds;
	    },
	
	    getDocLevelWordIds: function() {
	        return this.docLevelWordIds;
	    }
	
	
	});

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Word = __webpack_require__(354);
	
	// maybe a base for these collections ....
	
	module.exports = Backbone.Collection.extend({
	
	    model: Word
	
	});

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var TextArea = __webpack_require__(349),
	    Line = __webpack_require__(352),
	    Box = __webpack_require__(350),
	    ShapeUtils = __webpack_require__(197);
	
	/**
	 * Not exactly the line, it's going to inherit fontsize and line-height,
	 * which is OK -- they currently aren't used but could be.
	 */
	
	module.exports = TextArea.extend({
	
	    defaults: _.extend( {}, Line.prototype.defaults, {
	
	        wd: null,
	        originalWd: null ,// this will exist for sanitizing any characters, like different kinds of dashes; sanitized output will be stored in wd; and the original here; facilitate easy debugging
	        isTextSanitized: false, // store a flag to mark if the word was sanitized ( wd != originalWd ); same as originalWd === null
	
	        pageLevelLineId: null,
	        pageLevelZoneWordId: null, // really index - necessary ?
	        pageLevelLineWordId: null, // really index - necessary ?
	
	        isDerived: false,
	        derivedParentId: null // for original subword that compose derived words, a link back to the derived parent -- only will be put on words in the original, not derived array
	
	    }),
	
	
	    parse: function(attrs, options ) {
	
	        var baseAttrs = Line.prototype.parse.apply( this, arguments );
	
	        var wdRaw = attrs.wd;
	        var sanitizedWord = this._getSanitizedWord( wdRaw );
	
	        if ( wdRaw === sanitizedWord ) {
	
	            baseAttrs.wd = attrs.wd;
	
	        } else {
	
	            baseAttrs.wd = sanitizedWord;
	            baseAttrs.originalWd = wdRaw;
	            baseAttrs.isTextSanitized = true;
	        }
	
	        baseAttrs.pageLevelLineId = options.pageLevelLineId;
	        baseAttrs.pageLevelZoneWordId = options.pageLevelZoneWordId;
	        baseAttrs.pageLevelLineWordId = options.pageLevelLineWordId;
	
	        return baseAttrs;
	
	    },
	
	
	    _generatePageKeyId: function(options) {
	        return options.pageNumber + '_' + options.pageLevelZoneId + '_' + options.pageLevelLineId + '_' + options.page_level_id;
	    },
	
	    /* Called post-parse -- needs other model data */
	    setDerivedBoxes: function( box_px_adjustment, fdd_xdpi, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine ) {
	
	
	        var boxPxDerived = this._generateBoxPxDerived(
	            this.get('boxPx'), box_px_adjustment, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine
	        );
	
	        var boxFDDZoneUnitsDerived = TextArea.prototype._generateBoxFDDZoneUnitsDerived.call(
	            this, boxPxDerived, fdd_xdpi
	        );
	
	        this.set({
	            boxPxDerived: boxPxDerived,
	            boxFDDZoneUnitsDerived: boxFDDZoneUnitsDerived
	        });
	
	    },
	
	    /**
	     * Difference from the base:
	     * Vertical: at least the size of the word's line plus padding, up to the prior/next line in it's zone.
	     * - I have seen any cases where not covering just line fails to cover the word.
	     * - Perhaps would want in the middle of the line?
	     * Horizontal: at the padding but without overlapping the adjacent words on its line.
	     * - Padding helps to cover words if the OCR engine is off.
	     * Note: we aren't taking page dimensions into account ( we could )
	     */
	    _generateBoxPxDerived: function( boxPx, box_px_adjustment, line, prevLineInZone, nextLineInZone, prevWordOnLine, nextWordOnLine ) {
	
	        /* --- Vertical ---- */
	
	        var lineBoxPx = line.get('boxPx');
	
	        var lineTopPlusPadding = lineBoxPx.get('t') - box_px_adjustment;
	        var lineBottomPlusPadding = lineBoxPx.get('b') + box_px_adjustment;
	
	        var t = prevLineInZone
	            ? Math.max( lineTopPlusPadding, prevLineInZone.get('boxPx').get('b') )
	            : lineTopPlusPadding;
	
	        var b = nextLineInZone
	            ? Math.min( lineBottomPlusPadding, nextLineInZone.get('boxPx').get('t') )
	            : lineBottomPlusPadding;
	
	        /* --- Horizontal --- */
	
	        var wordLeftPlusPadding = boxPx.get('l') - box_px_adjustment;
	        var wordRightPlusPadding = boxPx.get('r') + box_px_adjustment;
	
	        var l = prevWordOnLine
	            ? Math.max( wordLeftPlusPadding, prevWordOnLine.get('boxPx').get('r') )
	            : wordLeftPlusPadding;
	
	        var r = nextWordOnLine
	            ? Math.min( wordRightPlusPadding, nextWordOnLine.get('boxPx').get('l') )
	            : wordRightPlusPadding;
	
	        return new Box({
	            l: l,
	            r: r ,
	            t: t,
	            b: b
	        } );
	
	    },
	
	
	    getWord: function() {
	        return this.get('wd');
	    },
	
	    /**
	     * For time being, normalize all dash or hyphen like characters as a regular '-'.
	     * This is necessary for logic implemented that allows us to search for words for dashes.
	     * Maybe later will need further sanitize the raw output.
	     * Definitely the types Nuance recognizes ( see documentation ) and while we're at it, some others
	     * just in case they appear or we hook into different OCR engine, eg Abby );
	     * Nuance documentation says recognizes the following:
	     *  - Em Dash: 0x2014
	     *  - En Dash: 0x2013
	     *  - Soft Hyphen: 0x20ad ( note: not sure how this works in practice, these should not be visible )
	     *  - Hyphen-Minus: 0x002d ( this is what we are normalizing to)
	     *  Others we're filtering -- this is a good source: http://jkorpela.fi/dashes.html --
	     *  not including all but ones that could be more common than others:
	     *  - u2010: hyphen
	     *  - u2011: non-breaking-hyphen
	     *  - u2012: figure dash
	     *  - u2015: horizontal bar
	     *  Note the regexp must be case sensitive ( eg \u00AD )
	     */
	    _getSanitizedWord: function( wdRaw ) {
	
	        var HYPHEN_AND_DASH_REG_EXP =
	                /\u2010|\u2011|\u2012|\u2013|\u2014|\u2015|\u00AD/g;
	
	        return wdRaw.replace( HYPHEN_AND_DASH_REG_EXP, '-' );
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    Canvas = __webpack_require__(356),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * Just a 'dummy page container' to wrap a canvas.
	 * Necessary to set the canvas dimensions, which stretch to the size of it's
	 * parent container.
	 * Done in lieu of extending canvas module and setting dimensions on it directly, due
	 * to current architecture involving the page-canvas channel.
	 * Basically like an empty page view.
	 * Debug mode is intended to be called from the console -- and SHOULD ONLY BE DONE in page mode to
	 * ensure the rendered shape positions should match up correctly.
	 * It should always be 0 in production
	 */
	
	
	var DEBUG_MODE = 0;
	
	if (true) {
	    DEBUG_MODE = 0;
	}
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function() {
	
	        this.canvas = null;
	
	    },
	
	    render: function( vChannel, pageNumber, shapes ) {
	
	        var pgCanvasChannel = new Backbone.Radio.Channel( 'pgCanvasChannel:p' + pageNumber );
	
	        var docModePage =
	            vChannel.request('activeDocPages').findWhere({ number: pageNumber });
	
	        var pageModePage =
	            vChannel.request('getNewFullPageModelFromDocModePage', docModePage);
	
	        // Canvas expect a scale model -- it does many calculations from it.
	        // In the future post a refactor, rendering everything non-transformed, this should no longer be necessary.
	        var currentScaleModel =
	            vChannel.request('pageViewScale');
	
	        var clonedPageModeScale = currentScaleModel.clone();
	
	        /**
	         * If we're not in page mode, a 'derived scale' may not be set correctly because the
	         * derived dimensions would be off -- this is because the DOM elements are hidden if we haven't entered
	         * the mode yet when the page is loaded.
	         * ( This is similar to the problem of going to page mode from doc mode after a F&R search is done for floating
	         *  redactions when page mode hasn't loaded yet -- the box sizes and position would be incorrect ).
	         * We could create a new scale model but making a clone is sufficient.
	         * A clone vs directly modifying the page mode scale allows us to change the scale to a 'non derived' value,
	         * without needed to set back the actual page mode scale values, which is problematic because we'd need to
	         * somehow trigger a 'scale callback' event to update the changes in the rest of the views ( eg the scale value ).
	         * Without doing this, if you save a spider redaction from document mode/pdf mode, the box positions will be calculated
	         * incorrected for 'derived scale' values.
	         * We set to a value of 1.0 -- which is fine for F&R (non-debug mode) where the canvas is hidden; BUT:
	         * if trying to debug from the command line -- do it in PAGE MODE and set to the derived value to see the shapes as they
	         * would appear over the page image.
	         */
	
	        if ( !DEBUG_MODE ) {
	            clonedPageModeScale.setScale( pageModePage, 1.0, 'custom' );
	        }
	
	        var rotatedDimensions =
	            pageModePage.getRotatedDimensionsWithScale( clonedPageModeScale.getScaleValue() );
	
	        var cssToApply = {
	            width: rotatedDimensions.width,
	            height: rotatedDimensions.height
	        };
	
	        if ( DEBUG_MODE ) {
	
	            cssToApply = _.extend( {}, cssToApply, {
	                outline: '1px solid blue',
	                position: 'fixed',
	                top: 0,
	                right: 0
	            });
	
	        } else {
	
	            this.$el.addClass('offScreen');
	
	        }
	
	        this.$el.css( cssToApply );
	
	        this.canvas = new Canvas({
	            vChannel: vChannel,
	            pageCanvasCh: pgCanvasChannel,
	            page: pageModePage,
	            scale: clonedPageModeScale // do it at the current scale to avoid problems -- I suppose you could try a new model at 1?
	        });
	
	        this.$el.append( this.canvas.canvasView.el );
	
	        // First ensure canvas in DOM prior to render !
	        $('body').append( this.el );
	
	        // Call shape render when in DOM
	        pgCanvasChannel.command( 'reRenderShapes', shapes );
	
	        return this;
	
	    },
	
	
	    onBeforeDestroy: function() {
	
	        this.canvas.destroy();
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(357);
	
	var Marionette = __webpack_require__(61),
	    Raphael = __webpack_require__(182),
	    _ = __webpack_require__(49),
	    CanvasState = __webpack_require__(358),
	    CanvasView = __webpack_require__(359),
	    Shapes = __webpack_require__(387),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	var ShapeUtils = __webpack_require__(197);
	
	__webpack_require__(198);
	
	
	
	/*
	* Store Raphael customAttributes on the Raphael.fn namespace.
	* This can then be referenced to apply to any Paper instances created that need them.
	* this may fit better on FV or setup in FV-bootstrap (or put on extendRaphael) -- here now for clarity.
	* Actually after first set, can reference from Raphael._Paper.prototype.customAttributes I believe but this works.
	* Note: need CA's applied directly to the paper to write them on the shapes.
	* */
	if (!Raphael.fn.customAttributes) {
	
	    Raphael.fn.customAttributes = {};
	
	    Raphael.fn.customAttributes['shape-type'] = function(type) {
	        return type;
	    };
	}
	
	
	var instVars = {
	    vChannel: null,
	    pageCanvasCh: null,
	
	    /*
	    * A collection shape models.
	    * Correspond to shape property of pgNoteModel (can have multi from diff pages).
	    * Contains reference to the pageNoteModel.
	    * Set from page.shapeModelsToRender + newly added shapes after they are drawn.
	    * New ones added when new shape drawn but isn't unsaved
	    * */
	    shapes: null,
	
	    state: null,
	    canvasView: null,
	    page: null,
	    scale: null
	
	};
	
	
	
	module.exports = Marionette.Object.extend({
	
	    initialize: function(options) {
	
	        _.extend( this, instVars, _.pick( options, 'scale', 'page', 'vChannel', 'pageCanvasCh' ), {
	            shapes: new Shapes(),
	            state: new CanvasState() // DVBC-1747 -- need to reset each time ... don't want a reference
	        });
	
	
	        // outer comm w/page and inner comm just in canvas through here
	        this.pageCanvasCh.reply(    _.extend(this.outerRequests, this.localRequests), this);
	        this.pageCanvasCh.comply(   _.extend(this.outerCommands, this.localCommands), this);
	
	        Marionette.bindEntityEvents( this, this.pageCanvasCh, this.localEvents );
	
	
	        // Create as much of the canvas view prior to calling render which requires it to be in the DOM
	        // ( Doesn't render shapes or set bounds )
	        this.canvasView = new CanvasView({
	            channel: this.pageCanvasCh
	        });
	
	    },
	
	
	    /**
	     * Sets the shape model collection back from reading in from note model attributes,
	     * and now find and redact search models.
	     * userProvidedShapes: if provided, use them, and none from the canvas
	     * newShapeModelsOfActiveNote: added if not userProvidedShapes -- see notes in re-render
	     */
	    _setShapesCollection: function( userProvidedShapes, newShapeModelsOfActiveNote  ) {
	
	        var shapes = [];
	
	        if ( !userProvidedShapes ) {
	
	            // 1) normal -- get the shapes from the page
	            shapes = this.page.shapeModelsToRender();
	
	            // Special case -- add shape model for full page redactions to shapes collection
	            // ( the activeNote, if new, is not yet a part of the collection )
	            // ( No drawing done for this shape )
	            var activeNote = this.pageCanvasCh.request('activeNote');
	            if ( activeNote && activeNote.isFullPageRedactionNote() && activeNote.isNew() ) {
	                shapes.push(  activeNote.getShape() );
	            }
	
	            // See notes from canvas.re-render for the active note
	            if ( newShapeModelsOfActiveNote ) {
	                shapes = shapes.concat( newShapeModelsOfActiveNote );
	            }
	
	            // 2) Add 'Find and Redact' shapes for the page if they exist
	
	            var findAndRedactSearchModel =
	                this.vChannel.request('findAndRedactSearchModel');
	
	            if ( findAndRedactSearchModel && findAndRedactSearchModel.searchHasResults() ) {
	
	                var pageHitShapes = findAndRedactSearchModel.get('searchResults').getAllShapesPerPage(  this.page.get('pageId') );
	
	                if ( pageHitShapes && pageHitShapes.length > 0 ) {
	
	                    shapes = shapes.concat( pageHitShapes ); // note: will be rendered from model
	
	                }
	
	            }
	
	        } else {
	
	            shapes = userProvidedShapes;
	
	        }
	
	
	        this.shapes.set( shapes );
	
	    },
	    localEvents: {
	        'shapeView:toggleMouseOver':    'toggleShapeMouseOver' /* forwarding the mouseover/mouseevent of shapes of shapes on the canvas */
	    },
	    outerRequests: {
	
	        getShapeAttrsToPersist: function( note, scale ) {
	
	            return this.shapes.getShapeAttributesOfNote( note, scale, this.page );
	
	        }
	
	    },
	    outerCommands: {
	
	        //TODO: cache AND/or fwd for perf ..
	        updateScale: function() {
	
	            var cv = this.canvasView;
	            cv.triggerMethod.apply(cv, ['updateScale'].concat( _.toArray(arguments) ));
	
	        },
	
	        // This is really like re-render the 'canvas view' now -- the second part (IN DOM)
	        // A bit more than just the shapes -- 'edit mode' in the canvas' -- TODO: should combine these
	        // could use something like onBeforeDestroy -- then hook back into render --- that way can edit view 'edit mode' and shapes at same time
	
	        // Note: must call once the view is in the DOM -- removed 'render' from imgCanvas  Not using an 'onShow' or anything
	        // else that could make this process asynchronous -- necessary for:
	        // 1) setting the bounds
	        // 2) rendering anything with text, which would err if not in the DOM using Raphael's library, which
	        // under the hood utilizes getComputedStyle under the hood, which requires elements to be in the DOM -- comes into play
	        // with the text for reason codes in regular and floating redactions
	        // It's not not just shapes -- it includes setting handlers on the canvas depending on the presence of
	        // Active/Find and redact notes
	
	        // TODO: REFACTOR -- process now more intertwined with active note, aside from just the end --
	        // see enter/exit edit mode, etc .. should incorporate in this as 're-render' -- and no longer just call re-render shapes
	        // and also logic persisting active note shape attributes and reselected the selected shape.
	
	        reRenderShapes: function( userProvidedShapes ) {
	
	            // If called while in edit mode, will need to restore shapes of the active note,
	            // which have yet to have been saved.
	            var activeNote = this.pageCanvasCh.request('activeNote');
	
	            var findAndRedactSearchModel =
	                this.vChannel.request('findAndRedactSearchModel');
	
	
	            // Note: no shape models yet applied if a hover shape has yet to be placed
	            var shapesOfActiveNote = activeNote
	                ? this.shapes.getShapesOfNote(activeNote)
	                : null;
	
	            var persistAttributesOfActiveNoteShapes =
	                shapesOfActiveNote && shapesOfActiveNote.length > 0;
	
	            var lastSelectedShapeUid = this.state.get('selectedShape')
	                ? this.state.get('selectedShape').get('uid')
	                : null;
	
	
	            // Unlike find and redact shapes, these aren't persisted between re-render calls,
	            // so set back the attributes necessary on the note models to re-create new shape models.
	            // would be enough for modifying notes -- but if new, the note won't yet be part of the collection on the page and it's notes,
	            // so we add it to the shape collection below.
	            // Would be more efficient to not use the read from the DOM: save, store, the attributes in live a refactor!!!
	            // Note this will kinda break the meaning of 'isNewlyDrawn' on the shapeUIModels, since they will be rendered from model
	            // Note: this will give floating reason code boxes position for shapes that aren't newly drawn,
	            // but that's not a huge deal.  Ultimately, when have more time this could be fixed, probably as part of larger necesary refactor
	            // ( store shapes on the note, etc ).
	            // I went through other references to isNewlyDrawn and others involve rendering the shapes with attributes and are ok with this change.
	            // Hovershapes:
	            // - will not include; their position will not be persisted between re-renders
	            // - I don't think a big deal: actions that would trigger would likely have mouse outside the canvas,
	            // - the worst that will happen is the hoverStamp will jump back to the default position -- looked
	            // - at a fix for this, but for now not worth the effort.
	            // - user can just reposition the mouse if this were to happen ( or if hidden, move mouse off and back on canvas ).
	            if ( persistAttributesOfActiveNoteShapes ) {
	
	                activeNote['isPersistingShapeModelAttributesDuringCanvasRerender'] = 1; // HACK flag for current WF
	
	                var shapeAttributesOfNote =
	                    this.shapes.getShapeAttributesOfNote( activeNote, this.scale.getScaleValue(), this.page );
	
	                activeNote.updateAttributesToCreateShapeModelsOnCanvasReRender( shapeAttributesOfNote );
	
	            }
	
	            this.state.set({editMode: false});
	            this.canvasView._exitEditMode(); // (Also removes hover stamp )
	            this.canvasView.unsetSelectHandlerForFindAndRedact(); // TEMP: until combo with exit edit mode ( a function to call before and after based on the active/f&r note)
	            this.state.set({selectedShape: null}); // 'selected shapes may not exist yet': this.pageCanvasCh.command('setSelectedShape', null);
	
	            // F&R -- 'hack' to persist 'position of the boxes' ( which currently aren't set live )
	            // F&R shapes persisted on F&R search model in between canvas render/destruction -- unlike shapes from notes
	            // (new exception being FP redactions ).
	            this.updateFindAndRedactFloatingShapeModels();
	
	            this.pageCanvasCh.command('deleteAllShapes');
	
	            // New shapes will not exist in the page note models yet, so gather these shapes back and add to collection.
	            // After we set them back to a state where they are ready to be rendered
	            // as if read in from the server on the note attributes (renderShapeViewFromModel)
	            var newShapeModelsOfActiveNote = persistAttributesOfActiveNoteShapes && activeNote.isNew()
	                ? activeNote.shapeModelsToRender( this.page )
	                : null;
	
	            this._setShapesCollection( userProvidedShapes, newShapeModelsOfActiveNote );
	
	            this.canvasView._renderShapes( this.shapes );
	
	            // An intermediary refactor step: much should be incorporated into render of shapes/canvas
	            this.reflectActiveExpandedAndFindAndRedactNotes();
	
	            // Reset the selected shape, if necessary --
	            // Can't just use the index -- with find and redact -- the number of shapes can change when called
	            // Need the uid that would be the same in between re-renders -- note_cid + shape index
	            // Note: F&R shapes persisted in between -- others are not -- they are recreated from note model attributes -- above
	            // With current WF must come after reflectActiveExpandedAndFindAndRedactNotes or it won't work
	            var lastSelectedShape = this.shapes.findWhere({ uid: lastSelectedShapeUid });
	
	            if ( lastSelectedShape ) {
	
	                // Regular Note -- only re-select if still in edit mode -- save could be called after
	                if ( !lastSelectedShape.isFindAndRedactShape ) {
	
	                    if ( this.state.get('editMode') ) { // ( same as activeNote )
	
	                        // Don't override selection from reflectActiveExpandedAndFindAndRedactNotes if 'fr.goToHit'
	                        // ( Check for null so id of 0 doesn't return true )
	                        if ( !findAndRedactSearchModel || findAndRedactSearchModel.get('userClickedHitId') === null ) {
	                            this.pageCanvasCh.command( 'setSelectedShape', lastSelectedShape );
	                        }
	                    }
	
	                } else {
	
	                    // F & R note -- always reselect if one was selected -- not in edit mode here ( go to hit already taken care of )
	                    // latter: don't override selection done above in fr.goToHit
	                    if ( findAndRedactSearchModel && findAndRedactSearchModel.get('userClickedHitId') === null ) {
	                        this.pageCanvasCh.command('setSelectedShape', lastSelectedShape);
	                    }
	                }
	
	            }
	
	            // Unset userClickedHitId so it's not persisted after initial render of this canvas.
	            // Taken out of reflectActiveExpandedAndFindAndRedactNotes WF to not interfere with last shape selection ( above ).
	            if ( findAndRedactSearchModel ) {
	                findAndRedactSearchModel.set({ userClickedHitId: null }, {silent: true });
	            }
	
	            // Clear flag for hover stamps
	            if ( persistAttributesOfActiveNoteShapes ) {
	                activeNote['isPersistingShapeModelAttributesDuringCanvasRerender'] = 0;
	            }
	
	        },
	
	        expandedNoteChange: function() {
	            this.pageCanvasCh.command('reRenderShapes');
	        },
	
	
	        // Reset the shapes collection from the persisted attributes -- eg: they should now have attributes -- at least the signature todo ...
	        // Essentially, put the attributes from the new shapes persisted on the notes onto the shape ui objects ...
	        noteSaved: function() {
	            this.pageCanvasCh.command('reRenderShapes');
	        
	        },
	        noteDeleted: function(note) {
	            _.each(this.shapes.getShapesOfNote(note), function(shape) {
	                this.pageCanvasCh.command('deleteShape', shape);
	            }, this);
	        },
	
	        activeNoteSubTypeChange: function(subType, options) {
	
	            var isEntering = options.activeNote;
	
	            (isEntering && options.changeOrigin !== 'shapeSelected') &&
	                this._unselectAllShapes();
	
	            // TODO: any other options other than active note here --  also could simplify and get in fn where needed
	            // from the state ?
	            isEntering && this.canvasView._enableDrawing( subType, options.activeNote );
	
	        },
	        /**
	         * Going forward, probably best to get the derived color using the central fn ( and not pass the parameter )
	         * But we still need to set the 'zone' color on the shape models, which is done here.
	         * color: hex
	         */
	        setDrawColor: function( color ) {
	
	            var shape = this.pageCanvasCh.request('selectedShape');
	            shape && this.canvasView.shapeViewFromModel(shape).triggerMethod( 'changeColor', color );
	
	            this.pageCanvasCh.trigger( 'textAreaView.updateColor' , color );
	
	        },
	        setStrokeWidth: function( strokeWidth ) {
	
	            var shape = this.pageCanvasCh.request('selectedShape');
	            shape && this.canvasView.shapeViewFromModel(shape).triggerMethod( 'changeStrokeWidth', strokeWidth );
	
	        },
	
	        // Now only listened to by hover edit dialog
	        // ( page container overflow scroll, sidePanel drag, side panel toggle, toggle full screen )
	        // ( note -- for the latter 2: will be called twice with set scale )
	        repositionShapeDialog: function() {
	            this.canvasView.shapeViews.call('trigger', 'shape.repositionShapeDialog');
	        },
	
	
	        /**
	         * When a modal window is shown -- close dialogs -- click event may not propagate to body.
	         * For new notes, this was always getting called -- presumably b/c of edited
	         * one's which weren't getting selected ( something else to look into ).
	         * Now also called if FR dialog is opened.
	         */
	        closeCanvasDialogs: function() {
	            this.pageCanvasCh.trigger('canvas:closeAllDialogs');
	
	        },
	        graphicStampChanged: function() {
	            this.canvasView.graphicStampChanged.apply(this.canvasView, arguments);
	        },
	        consultGroupChange: function( note ) {
	
	            var ch = this.pageCanvasCh;
	
	            _.invoke( this.shapes.getShapeUIModelsOfNote(note), 'trigger', 'shape:consultGroupChange' );
	
	            // Could get active subType ...
	            note.isSVGGraphicNote() &&
	                ch.trigger( 'textAreaView.updateColor', ch.request('getColorToApplyToShape', note) );
	
	            // One-off for the hover signature, which currently isn't a view
	            note.isSignature() && this.canvasView.hoverShape &&
	                ch.trigger( 'hoverSignature:consultGroupChange', ch.request('getColorToApplyToShape', note) );
	
	        },
	
	        // Re-draw all shapes to take into account the difference in appearance of redaction shapes.
	        // ( Could just do redaction shapes but performance is good here ).
	        // Note: because things don't have opacity, order may change (like when editing/creating new notes).
	        // If any issues encountered, could just get all redaction shape (and subview) attributes to change their settings.
	        // Perhaps an attribute on the redactionShape uiModel would be beneficial.
	        applyAllRedactionsToggled: function() {
	            this.pageCanvasCh.command('reRenderShapes');
	        },
	
	        pageRotated: function() {
	            this.pageCanvasCh.command('reRenderShapes');
	        }
	
	
	    },
	    localCommands: {
	
	        /* when add newly drawn shape, need to create the shape model from which is it drawn */
	        addNewlyDrawnShape: function(shapeEl) {
	
	            var activeNote = this.pageCanvasCh.request('activeNote');
	
	            var nShapesOfNote = this.shapes.getShapesOfNote( activeNote ).length;
	
	            // If do this, sloppier, but don't need to worry about tracking the number of shapes on the note model on parse/add/delete/etc
	            // Eg: here it avoids - something like:
	            // And for now allows us to avoid getting into parsing shape models on the note models
	            // For now -- the uid is necessary for re-selection of the shape on re-renderShapes
	
	            /*
	                activeNote['numberShapes'] =
	                    ( activeNote['numberShapes'] ? activeNote['numberShapes'] : 0 ) + 1;
	
	            */
	
	            var options = {
	                    parentNote: activeNote,
	                    channel: this.pageCanvasCh,
	                    raphaelEl: shapeEl,
	                    isActive: true,  // must be active
	                    isExpanded: false,
	                    pageModel: this.page, /* don't rely on getting off note -- ensure it's the full page model (or the correct one when necessary) */
	                    isNewlyDrawn: true,
	                    shapeIndexOfNote: nShapesOfNote++
	                };
	
	
	            var ShapeModelConstructor = activeNote.getShapeModel();
	            var shapeModel = new ShapeModelConstructor([], options);
	
	            this.shapes.add(shapeModel); /* no event */
	            this.canvasView.renderShapeViewFromModel(shapeModel, this.scale.get('scale'), false); // (must have permission)
	            this.pageCanvasCh.command('setSelectedShape', shapeModel);
	
	        },
	
	        cancelSignature: function(note) {
	            this.pageCanvasCh.trigger('cancelSignature', note);
	        },
	
	        /**
	         * Delete model from this.shapes and destroy its corresponding view from the canvas shapeViews collection.
	         * Single entry point for shape deletion.
	         * manualUserDelete: true if called from delete button or delete/backspace hotkey,
	         * comes into play with floating redactions
	         * TODO: if it's the selected shape, set the selected shape to null (?) -- see also replaceExistingTextStampShapeWithHoverStamp
	         */
	        deleteShape: function(shape, manualUserDelete) {
	
	            this.canvasView.destroyShapeView(shape, manualUserDelete);
	            this.shapes.remove(shape);
	
	
	            // For shapes that are persisted on note models -- see comment in class model
	            shape.uiModel.resetActiveAndExpandedState();
	
	        },
	
	        // Clone: -- otherwise not all will be deleted -- (eg the # of shapes will not be the same as it was when started
	        // Update 10.1.20: clone still required, otherwise, we get 'duplicates' printed -- may want to look into WF here.
	        deleteAllShapes: function() {
	
	            var shapes = this.shapes.clone();
	
	            shapes.each(function(s) {
	                this.pageCanvasCh.command('deleteShape', s);
	            }, this);
	
	        },
	
	        setSelectedShape: function(shape) {
	
	            this.state.set('selectedShape', shape);
	            shape
	                ? this._selectShapeAndUnselectOthers(shape)
	                : this._unselectAllShapes();
	
	
	        },
	        toggleUserDrawing: function(isDrawing) {
	
	            var activeNote = this.pageCanvasCh.request('activeNote');
	            
	            // Set a flag on the note model that will not allow the user to save it while the shape is being drawn
	            activeNote.uiModel.set('isUserDrawingShape', isDrawing);
	
	            // This was the old callback after set
	            this.state.set('isDrawing', isDrawing);
	            this.pageCanvasCh.trigger('drawingToggled',isDrawing, activeNote);
	
	            if ( !activeNote.isRedactionNote() )
	                return;
	
	            _.each( this.shapes.getShapeUIModelsOfNote(activeNote), function(s) {
	                s.set('isParentNoteDrawing', isDrawing);
	            });
	
	        },
	
	        replaceExistingTextStampShapeWithHoverStamp: function() {
	
	            var activeNote = this.pageCanvasCh.request('activeNote');
	            var currentShapeModel = this.pageCanvasCh.request('selectedShape'); // ( it must be selected )
	
	            this.state.set({selectedShape: null}); // Temp: should put into delete shape routine ( which doesn't unset the selected shape )
	
	            this.pageCanvasCh.command( 'deleteShape', currentShapeModel );
	            this.canvasView._enableDrawing( 'text_stamp', activeNote );
	
	        },
	
	        destroyTextArea: function() {
	            // would have the shapes listen to an event; but also remove the view from canvasView
	            // (its like a flag)
	            this.canvasView.destroyTextAreaView();
	        }
	
	    },
	    localRequests: {
	        selectedShape: function() {
	            return this.state.get('selectedShape');
	        },
	        editMode: function() {
	            return this.state.get('editMode');
	        },
	        state: function() {
	            return this.state;
	        },
	        getPage: function() {
	            return this.page;
	        },
	        vChannel: function() { //for internal fer to vChannel for requests
	            return this.vChannel;
	        },
	        viewerContainer: function() {
	            return this.vChannel.request('getWrapper');
	        },
	        activeNote: function() {
	            return this.vChannel.request('activeNote');
	        },
	        expandedNote: function() {
	            return this.vChannel.request('expandedNote');
	        },
	        activeNoteSubType: function() {
	          return this.vChannel.request('activeNoteSubType');
	        },
	        scale: function() {
	            return this.scale;
	        },
	        currentScaleValue: function() {
	          return this.scale.getScaleValue();
	        },
	        shapes: function() {
	            return this.shapes;
	        },
	
	        getCurrentDrawingAttributes: function() {
	            return this.vChannel.request('getCurrentDrawingAttributes');
	        },
	
	        canvasContainerRel: function() {
	            return this.canvasView.containerRel;
	        },
	
	
	        /*
	        * ** Centralized Setting of Attributes & Colors -- An intermediate refactor **
	        * Get the raphael attributes to apply to an element -- incorporates logic to apply appropriate color.
	        * Color is used to set various Raphael properties like fill, stroke.
	        * Works for shapes that don't yet have a model/view yet and those that do.
	        * note: required
	        * active: required: want edit (true) or non edit attributes (false)
	        * shape: can be empty ( in the current workflow that's if during initial draw
	        * noteSubType: can be empty ... now only applicable to graphic notes
	        * Sources:
	        * - baseCanvasDrawnFns.setShapeAttrs ( shape will not be defined )
	        * - coordinateShape.getNonPathActiveSVGAttrs
	        * - coordinateShape.getNonPathInactiveSVGAttrs
	        * */
	        getAttributesToApplyToShapeEl: function( note, active, shape, noteSubType ) {
	
	            var attrs = {},
	                ch = this.pageCanvasCh,
	                colorToApply = ch.request( 'getColorToApplyToShape', note, shape );
	
	            if ( !shape ) {
	
	                if ( note.isSVGGraphicNote()  ) {
	
	                    // if employ more color pickers for other types, may want to utilize note.supportsColorPicker ...
	                    attrs = note.defaultSVGAttrsEdit( colorToApply, noteSubType, ch.request( 'getCurrentDrawingAttributes' ) );
	
	                } else {
	
	                    attrs = note.defaultSVGAttrsEdit( colorToApply, noteSubType );
	
	                }
	
	            } else {
	
	                if ( !active ) {
	
	                    attrs = note.defaultSVGAttrs( colorToApply );
	
	                } else {
	
	                    attrs = note.defaultSVGAttrsEdit( colorToApply );
	
	                }
	
	            }
	
	            return attrs;
	
	        },
	
	        /**
	         * Centralized logic to derive shape colors -- * only go through here *
	         * The cascade of rules to apply
	         * Intermediary refactor: combines logic from the note level and the shape level when it exists --
	         * a shape may not always exist so this is why it's not put on the shape model.
	         * Note: required -- the note model
	         * Shape: shape model: won't exist for newlyDrawn shapes -- and that is where we store the zone color
	         * Text Stamps:
	         * - the logic is a bit different ( no current currentDrawing attributes )
	         * - similar logic is duplicated on the note model here b/c we need it in the note view:
	         *   ... theTextColor is stored on the note model as well as shape models
	         * - look at this when refactor to implement zone color for non graphic notes
	         * - potential reason to refactor to where shapes are parsed and set with the notes, not just derived,
	         *   when we need them for the canvas ( eg full page redactions )
	         */
	        getColorToApplyToShape: function( note, shape ) {
	
	
	            if ( note.isTextStamp() ) {
	               return note.uiModel.getColorToApply();
	            }
	
	            // First look at any 'overriders' of the 'actual color' -- consults and group color
	
	            // 1) Consult Group -- if the system supports them,
	            //    and only one with a color assigned is applied to the note ( note level )
	
	            if ( fvChannel.request('supportConsults') ) // could cache for perf.
	
	                var consultGroupColor = note.getCurrentConsultColorForShapes(); // logic appears to handle setting this live ( vs deriving from selected consult groups )
	                if ( consultGroupColor )
	                    return consultGroupColor;
	
	
	            // 2) Groups of Note Creation User ( if belongs to one group with 1 color assigned )
	            // ( must override zone color -- otherwise  group color would never get applied ( see discussion in ticket DVBC-1780 )
	            var noteCreationUserGroupColor = note.getCreationUserGroupColor();
	            if ( noteCreationUserGroupColor ) {
	                return noteCreationUserGroupColor;
	            }
	
	            // 3) Zone Color -- all shapes should have ( from DB or color picker )
	            // ( color pickers disable if any of the above 2 overrides exist.
	
	            if ( shape ) {
	
	                var zoneColor = shape.getZoneColor();
	                if ( zoneColor ) {
	                    return zoneColor;
	                }
	
	            }
	
	            else {
	
	                // Note: color pickers would be disabled if there is an 'override'
	                // Now only SVGGraphicNotes
	                if ( note.supportsColorPicker() ) {
	
	                    return this.pageCanvasCh.request( 'getCurrentDrawingAttributes').color;
	
	                } else {
	
	                    return note.getDefaultShapeColor();
	
	                }
	
	            }
	
	        }
	
	    },
	
	    // From re-render shapes - at the end
	    reflectActiveExpandedAndFindAndRedactNotes: function() {
	
	        var activeNote = this.pageCanvasCh.request('activeNote'); // utilize for now
	
	        // Shouldn't reach if not drawable but leave an extra check
	        var isDrawableActiveNote = activeNote && activeNote.isDrawable();
	
	        if ( isDrawableActiveNote ) {
	            this.state.set({editMode: true}); //(just storage)
	            this.activeNoteChange(activeNote);
	        }
	
	        var expandedNote = this.pageCanvasCh.request('expandedNote');
	        if ( expandedNote ) {
	            this.expandedNoteChange(expandedNote);
	        }
	
	        // TODO: we should want this just off shape render ... that should be next ... just get going now to text active ?
	        var findAndRedactSearchModel =
	            this.vChannel.request('findAndRedactSearchModel');
	
	
	        if ( findAndRedactSearchModel && findAndRedactSearchModel.searchHasResults() ) {
	
	            var pageId = this.page.get('pageId');
	
	            var hitShapesOfPage = findAndRedactSearchModel.get('searchResults').getAllShapesPerPage( pageId );
	
	            if ( hitShapesOfPage && hitShapesOfPage.length > 0 ) {
	
	                var hitShapeOfPageUiModels =  hitShapesOfPage.map( function(shape) {
	                    return shape.uiModel;
	                });
	
	                // TODO: this is temp -- will need some sort of 'reset' of the UI models ... need to map this out ...
	                // these would not have been destroyed ...
	                // They may also be holding on to the raphael el's which we don't want .
	                 hitShapeOfPageUiModels.forEach( function( shapeUiModel ) {
	                     shapeUiModel.deactivate();
	                     // also unselect ... that's done below ... could combo
	                 });
	
	                // TODO: also need to handle mouseover
	                // -- that trigger the pageNoteModel; here we want the shape --> so extend the shapeView...
	
	                _.invoke( hitShapeOfPageUiModels, 'activate' );
	
	                // For Floating, need to enable layer and drag them ... ( again, this should be done on render )
	                // Note: there is no activeNote on them now.
	               //  New: there can be > 1.
	                // TODO: handle in the render process when refactor!
	
	
	                findAndRedactSearchModel.get('searchResults').getTopDownResults().getFloatingReasonCodesNotesOfPage( pageId ).forEach( function( note ) {
	                    note.floatingCodesController &&
	                        note.floatingCodesController.trigger('floatingCodesView.toggleActive', 1, this.canvasView.paper );
	                }, this);
	
	
	                /* -------'goToHit'/selection --------- */
	
	                // Here -- handle entry of the 'goToHit' and shape selection.
	                // All shapes already unselected in re-render.
	                // Alternatively, we select the shape first (now that we use selected) and just incorporate into render of the shapes
	                // with active and expanded
	                // TODO: incorporate into re-render process -- part of unselect all shapes ( though these attributes are persisted )
	                _.invoke( hitShapeOfPageUiModels, 'unSelect');
	
	                var userClickHitId = findAndRedactSearchModel.get('userClickedHitId');
	                if ( userClickHitId !== null ) { // ( can be zero )
	
	                    var shapeOfClickedHit = _.find(hitShapesOfPage, function(s) {
	                        return s.get('hitId') === userClickHitId;
	                    });
	
	                    // Utilize the existing isSelected attribute (independently of notes)
	                    // shapeOfClickedHit.uiModel.select(); // need make the 'selected note' for last note selection process above ( not just set the attribute ) -
	                    // ( selectedShape must be set )
	                    this.pageCanvasCh.command( 'setSelectedShape' , shapeOfClickedHit );
	
	                }
	
	                // userClickedHitId unset at end of re-render process so as not to interfere with lastShape selection -- see re-render ...
	
	                /**
	                 * Allow for unselection of the selected shape.
	                 * Don't do if activeNote -- this will be handled by drawStart ( only if there is not active mode )
	                 */
	                if ( !isDrawableActiveNote ) {
	
	                    // Will need to turn off
	
	                    this.canvasView.setUnselectedShapeHandlerForFindAndRedact();
	
	                }
	
	
	            }
	
	        }
	
	
	
	
	    },
	
	    // TODO: This some of this ( at least the shapes ) should now be combined with render ...
	    // Since re-rendering -- this only encompasses enter now -- it's not a change
	    // Intermedite refactor step
	    activeNoteChange: function(note) {
	
	        // Also sets mousedown listener that will handle shape selection
	        // Always set the listener even if find and redact shapes
	        this.canvasView.enterEditMode( note );
	
	        // TODO: set on model and then do on render of the shapes
	        _.invoke( this.shapes.getShapeUIModelsOfNote(note), 'activate' );
	
	        /**
	         * If a floating code redaction note, toggle active on it's floating codes controller
	         *( for layering, do after all shapes have been toggle active, which puts them to the front )
	         * ( don't call on all: eg don't want to enable drag on code boxes of notes other than the active note )
	         * This does allow you to drag the code boxes of the active note
	         * TODO: if refactor: i think we now just do on render
	         */
	        note.floatingCodesController &&
	            note.floatingCodesController.trigger('floatingCodesView.toggleActive', 1, this.canvasView.paper );
	
	        // If the active note is graphic, make any others appear 'disabled'
	        note.isSVGGraphicNote() &&
	            _.invoke(this.shapes.getAllShapesButNote( note, note.getNoteType() ), 'setDisabled');
	
	    },
	
	    // Now just the entering part from the original event (shapes re-rendered)
	    expandedNoteChange: function( note ) {
	
	        var shapeUiModesOfNote = this.shapes.getShapeUIModelsOfNote(note);
	        _.invoke( shapeUiModesOfNote, 'setExpanded' );
	
	    },
	
	
	    toggleShapeMouseOver: function( note, options ) {
	
	        this.toggleHighlightedNote.apply(this, arguments);
	        this.pageCanvasCh.trigger('hoveredNoteChange', note, options.isEntering ? 1 : 0); //note: this also an external req
	
	    },
	    toggleHighlightedNote: function(note, options) {
	
	        var ch = this.pageCanvasCh,
	            shapes = this.shapes;
	
	        if ( ch.request('editMode') || ch.request('vChannel').request('noteIsActiveOrExpanded') )
	            return false;
	
	        options.isEntering
	            ? _.invoke(shapes.getShapeUIModelsOfNote(note), 'highlight') // could cache per note
	            : _.invoke(shapes.getAllShapeUIModels(), 'unhighlight');
	
	    },
	    _selectShapeAndUnselectOthers: function(shape) {
	
	        this.shapes.each( function(s) {
	            s.uiModel.set( 'isSelected', s.cid === shape.cid );
	        });
	
	    },
	    _unselectAllShapes: function() {
	
	        _.invoke( this.shapes.getAllShapeUIModels(), 'unSelect');
	
	    },
	
	    /**
	     * First -- must call before canvas is destroyed:
	     * - Issue: reason code box data is stored on the floating codes controller of the note,
	     *  which will be destroyed on destruction of the canvas.
	     * - Persist the floating codes controller before it's destroyed (eg on page change)
	     *      - Note: this will just check the mode; want to ensure we're only working with the notes on this canvas, not another
	     *      - Don't check mode from vChannel ( maybe the shapes were deleted ), just check for their existence on the canvas.
	     * Second -- discovered needed anything that would be needed on 're-render of the canvas' to persist
	     *  - codes box locations using the existing model ( not saving on move )
	     *  with the code boxes, though needs to go through how that's working with the lines, etc.
	     *  TODO:
	     *      - now that we are updating the location the shapes on move / resize, maybe we make that consistent with the boxes
	     *      - this is difficult now, need to outline and refactor; get functionality working
	     */
	
	    updateFindAndRedactFloatingShapeModels: function() {
	
	        if (!this.shapes)
	            return;
	
	        /* There can now be more than one note on a page for find and redact */
	        var findAndRedactShapesOfFloatingReasonCodeNotes = this.shapes.filter( function(s) {
	            return s.isFindAndRedactShape && s.parentNote.isFloatingRedaction() && s.parentNote.floatingCodesController ;
	        });
	
	        if ( findAndRedactShapesOfFloatingReasonCodeNotes.length > 0 ) {
	
	            // *** Update the shape's attributes ***
	            // What they are rendered from on the canvas ... not the 'shapes' attribute of the note ***
	            // Now updating the shape models, as opposed to deleting and recreating them (as they are persisted for F & R)
	            var scale = this.scale.getScaleValue();
	
	            findAndRedactShapesOfFloatingReasonCodeNotes.forEach( function(shape) {
	                shape.updateShapeAttributes( scale );
	            });
	
	        }
	
	    },
	
	    onBeforeDestroy: function() {
	
	        // Check for shapes -- eg if call a destroy prior to a render ('reset'), these won't exist
	        if ( this.shapes ) {
	
	            // Update the shape attributes from the shape models on the find and redact search model prior to destruction
	            // of the floating codes controller
	            this.updateFindAndRedactFloatingShapeModels();
	
	            // TODO: better destroy workflow -- eg if put below with other this.shapes, won't get destroyed
	            // this is a VERY QUICK FIX
	            // ensure all shapes are not selected -- eg if change page with find and redact hit -- it's view will not be selected
	            this.pageCanvasCh.command('setSelectedShape', null);
	
	        }
	
	        _.invoke([ this.canvasView, this.state ], 'destroy'); //this.page, this.scale
	
	
	        // Check for shapes -- eg if call a destroy prior to a render ('reset'), these won't exist
	        // do before canvasView destroy -- otherwise shapes will be gone already; needs better org
	        if ( this.shapes) {
	
	
	            // TODO: this should also reset the UI models ... see above ...
	            this.shapes.triggerMethod('destroy'); //-- causing mem leak ...
	
	            this.shapes = null;
	
	        }
	
	        this.pageCanvasCh.reset();
	
	        Marionette.unbindEntityEvents(this, this.pageCanvasCh, this.localEvents);
	        Marionette.unbindEntityEvents(this, this.pageCanvasCh, this.outerEvents);
	
	    }
	});

/***/ },
/* 357 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        selectedShape: null, //only one shape can be selected on canvas at a time, when true, is selected and all others unselected  -- shape has isSelected prop.
	        editMode: false,  // true if can draw -- opens into 'non edit' mode (toggled on activeNote changed)
	        isDrawing: false /* necessary -- base entering the draw can occur mult times  (OR DISABLE/ENABLE THE INITIAL MOUSEDOWN -- also broadcast to page note view */
	
	    }
	
	});

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    Raphael = __webpack_require__(182),
	    BaseDrawFns = __webpack_require__(360),
	    CanvasDrawFns = __webpack_require__(362),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    CreateGraphicStampEl = __webpack_require__(385);
	
	__webpack_require__(114);
	
	
	var instVars = {
	    shapeViews: null,
	    containerAbs: null, // bounds of the view offset from the window (not starting at 0,0)
	    containerRel: null, // 'relative' bounds of the view; starts at 0,0, and includes current dimensions
	    paper: null
	};
	
	// more dynamic added:
	    // mouseModel -- store the others on here?
	
	    //shape -- if a shape is being drawn, its the raphael el
	    //drawStart, drawStop, drawMove
	    //drawRect
	        //dummyRectBorder
	        //osw
	    //polyHelper
	        //this.currentPathString, line, free
	    //this.textAreaView (text area before it becomes a text shape -- can't have more than 1)
	
	    //hoverShape (if create signature or stamp)
	
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'canvasWr', // can't add class to svg
	
	    initialize: function(options) {
	
	        _.extend( this, instVars, _.pick( options, 'channel'), {
	            shapeViews: new Backbone.ChildViewContainer() // must recreate on init -- otherwise reference error if more than 1 canvas (eg from find and redact -- canvas's will share the view )
	        });
	
	        // el is already created; set up everything possible prior to appended to DOM
	        // note: the container must be the underlying div, not the svg element!
	        this._preDOMRender();
	
	    },
	
	    keyboardEvents: {
	        'backspace'    : '_deleteSelectedShapeFromHotkey',
	        'del'          : '_deleteSelectedShapeFromHotkey'
	    },
	
	    _preDOMRender: function( ) {
	
	        this.paper = this._renderPaper();
	
	        if ( this.channel.request('getPage').get('overlay') ) {
	            this._applyOverlayAdjustments();
	        }
	
	        /* DVBC-893 bizarre hack -- need underlay with box shadow for IE<10 -- also allows not to put the image in the same layer as the canvas */
	        fvChannel.request('settings').isIE &&
	            this.$el.append($('<div class="IE-canvas-drawing-shim"></div> '));
	
	    },
	
	    /* Note: paper isn't the el, the canvasWr is */
	    _renderPaper: function() {
	
	        var paper = new Raphael(this.el, '100%', '100%');
	        paper.customAttributes = Raphael.fn.customAttributes;
	        $(paper.canvas)
	            .removeAttr('style') /* remove what output from raphael by default */
	            .attr('class', 'img-paper-canvas');
	
	        return paper;
	
	    },
	
	    // Now also handles edit/mode, etc
	    // Set bounds here so we can place the initial render with a call to what's now 'reRender' shapes (doesn't hurt)
	    _renderShapes: function(shapes) {
	
	        this._setBounds();
	
	        var scale = this.channel.request('currentScaleValue');
	
	        shapes instanceof Backbone.Collection &&
	            (shapes = shapes.models);
	
	        _.each(shapes, function(s) {
	            this.renderShapeViewFromModel(s, scale, true);
	        }, this);
	
	
	        /* -- Layering -- */
	
	        /**
	         * For Floating Codes Positioning -- the code views must be positioned above all shapes.
	         * This can't be done until all shapes have been rendered on the canvas --
	         * Only then will be know the 'top'. ( Setting to-front manually won't work as this is called sequentially )
	         * We probably want a more organized way of positioning shapes, etc ... but this will have to do for now.
	         * ( Main problem is we don't store a position in the db ).
	         *  Any other layering logic may want to be centralized here,
	         *  if we have more in the future (other than code views go atop other shapes).
	         */
	        this.channel.trigger('imgCanvas.moveAllCodeBoxesToFront', this.paper);
	
	
	        /**
	         * Now handle logic of 'layering' full page redactions, if they exist on the page.
	         * Do after the floating codes.
	         * Could  do more elegantly (model driven by determining the rendering order of the shape first and storing on a model, then, rendering them
	         * all, though the order is really that from the shape collection, so this should work.
	         *  Note: there can only be one full page redaction note on a page.
	         */
	        var fullPageRedactionShape = _.find(shapes, function(s) {
	            return s.parentNote.isFullPageRedactionNote();
	        });
	
	        if ( fullPageRedactionShape )
	            fullPageRedactionShape.uiModel.trigger( 'fullPgRedactionShape:layerAfterShapesRendered' );
	
	
	    },
	
	    /**
	     * Central pt for creation.
	     * Creates a new shape view from given a shape model
	     * From both initial render of models AND immediately after 'addNewlyDrawnShape'
	     */
	    renderShapeViewFromModel: function(shape, pgScaleVal, fromModel) {
	
	        var note = shape.getParentNote(),
	            channel = this.channel,
	            scale = pgScaleVal,
	            shapeView = note.shapeView({ /* Note -- this is an xref -- change when the individual shape models */
	                parent: this,
	                shapeModel: shape,
	                pgNoteModel: note,
	                scale: scale,
	                channel: channel
	            });
	
	        shapeView.render(shape, scale, channel, fromModel);
	        this.shapeViews.add(shapeView);
	
	        return shapeView;
	
	    },
	    // Only called from canvas.deleteShape -- the central point of shape deletion
	    destroyShapeView: function(shape, manualUserDelete) {
	
	        var v = this.shapeViewFromModel(shape);
	        this.shapeViews.remove(v);
	
	        // Note: we are destroying the views, not the models.  This is important now for full page redactions,
	        // (DVBC-1762) where the shape model is stored on the note model.  It could later be important if we
	        // start using the same approach for other shape types -- otherwise you'd need to
	        // create new shape object and potentially re-render note views on activeNoteChange, for example.
	        v.destroy(manualUserDelete);
	
	    },
	    shapeViewFromModel: function(shape) {
	        return this.shapeViews.find(function(v) {
	            return v.shapeModel === shape;
	        });
	    },
	    onUpdateScale: function( curScale, prevScale, options ) {
	
	        var args = Array.prototype.slice.call(arguments);
	
	        if ( options && options.updateCanvasOverlay ) {
	            this._applyOverlayAdjustments( options.pageModel, curScale);
	        }
	
	        this._setBounds();
	        this.shapeViews.apply( 'trigger', ['shape.scaleWithPaper'].concat(args) ); // perf hit but keep mediation strategy clear
	
	
	        // For performance, perhaps combine all these events
	        this.channel.trigger.apply( this.channel, ['scaleFloatingReasonCodeViews'].concat(args) );
	
	        // Hovers tamp and Hover Signature
	        this.channel.trigger.apply( this.channel, ['hoverShape:scale'].concat(args) );
	
	        // (textAreaView is not one of the shapeViews)
	        this.channel.trigger.apply( this.channel, ['textAreaView.scaleWithPaper'].concat(args) );
	
	    },
	    /* overlay offsets AND potentially height and width*/
	    _applyOverlayAdjustments: function( pageModel, currentScale ) {
	
	        pageModel = pageModel || this.channel.request('getPage');
	        currentScale = currentScale || this.channel.request('currentScaleValue');
	
	        var overlay = pageModel.get('overlay'),
	            actualDimensions = pageModel.get( 'textGridModel' ).actualDimensions( currentScale );
	
	        this.$el.css({
	            left: (overlay.xTextOffset * currentScale) + 'in',
	            top: (overlay.yTextOffset * currentScale) + 'in',
	            width: actualDimensions.width + 'px', //(scale already adjusted) from fn in view
	            height: actualDimensions.height + 'px'
	        });
	
	    },
	
	    // implies the user is 'drawing', occurs if rendered with an active note set
	    enterEditMode: function(note) {
	
	        // cursor: default -- this is now not necessary,
	        // you can't draw shapes new shapes unless you hit toggle active note; in this mode cursor will be default
	
	        var pnClass = note.getNoteClass(),
	            noteSubType = note.getDefaultShapeSubType(); //this is what the draw functions are based on
	
	        this.$el
	            .addClass('edit-mode ' + pnClass)
	            .data('init', pnClass);
	
	        if ( note.supportsHoverShape() ) {
	
	            // Note: DVBC-1763 -- can't combine note.isNew() with above predicate,
	            // otherwise on modify, the final else is reached, drawing is enabled,
	            // and an extra hoverstamp is created.
	            // Note: Signature's can't be modified -- will always be new.
	            // !note.isPersistingShapeModelAttributesDuringCanvasRerender: don't if a unsaved shape (that has been placed) from a note that will be re-rendered.
	            if ( note.isNew() && !note.isPersistingShapeModelAttributesDuringCanvasRerender && !this.hoverShape ) {
	                this._enableDrawing(noteSubType, note);
	            }
	
	        } else {
	
	            this._enableDrawing(noteSubType, note);
	        }
	
	    },
	
	
	    // Still needed because not destroying and re-creating the view ...
	    // Called at beginning re-render shapes (with is like the view reset) ... area for refactor
	    // More like a reset called first on reRender shapes
	    _exitEditMode: function() {
	
	        this.$el
	            .removeClass('edit-mode ' + this.$el.data('init') + ' text-cursor')
	            .removeClass('default-cursor'); // this is only for hover shape ( can't place another )
	
	        this._disableDrawing();
	
	    },
	
	
	    /*--- ---*/
	
	    /**
	     *   For now left as intermediary refactor, left seperate from enterEditMode, exitEditMode.
	     *   There should be a combined pre and post shape 'render function' that is combined with the above
	     *   on re-render shapes -- resets the state of this view depending on the presence of these notes.
	     *   Here, this is only called if there is not activeNote ( not in edit mode ); that logic is now in the
	     *   canvas module. See comment there for interaction with drawStart ( which accomplishes this if in edit mode ).
	     *
	     *   If we click on the canvas, unless we select a button (it could be the current shapes select button), unselect the shape.
	     *   Issue: this breaks drag functionality -- drag is an outer html element and it's mouse will get called,
	     *   which will also unselect the shape.
	     *   We want to only unselect if the event is not from the drag.
	     */
	
	    setUnselectedShapeHandlerForFindAndRedact: function() {
	
	        this.$el.on( 'mousedown', _.bind( function(e) { // use mousedown -- consistent with other methods ...
	
	            e.preventDefault();
	
	            // Without stopping propagation, a second event will be called from the parent drag container.
	            // So the problem is that if you drag, it will unselect the shape.
	            // We want to unselect the shape, but not if we are dragging.
	            // e.stopPropagation(); // this would prevent drag scrolling
	            // I think you'd need to capture, the drag event 1st ( to say don't do the hide, but it happens 2nd ) -- otherwise this is very confusing and not worth it
	            // Maybe we don't do it ... could also trying not using mousedown but a click event which would occur after
	
	            var rId = e.target.raphaelid;
	            if (rId && this.paper.getById(rId).data('shapeType') === 'button')
	                return;
	
	            this.channel.command('setSelectedShape', null);
	
	        }, this ));
	
	
	    },
	
	    unsetSelectHandlerForFindAndRedact: function() {
	        this.$el.off('mousedown');
	    },
	
	
	    /*---  ---*/
	
	    _deleteSelectedShapeFromHotkey: function(e) {
	        e.preventDefault(); // Don't allow backspace to go to last page
	        var selectedShape = this.channel.request('selectedShape');
	        selectedShape && this.channel.command('deleteShape', selectedShape, 1);
	    },
	
	    /**
	     * Also deals with subType change ( in addition to active note change; really need to refactor this )
	     * Handles mousedown on view and unselecting shapes ( in drawStart )
	    */
	    _enableDrawing: function( subType, note ) {
	
	        /* temp fix for drawing the hover-signature b/f the canvas is rendered */
	        if (!this.paper)
	            return false;
	
	        this._disableDrawing(); //(clear in case) -- note: doesn't fix problem of not being able to edit post page change
	        this.$el[(subType === 'text') ? 'addClass' : 'removeClass']('text-cursor');  //(also small code for changing subtype)
	
	        // with new shape types (eg text shape, signature, graphic stamp ... may not always want this ... again more refactor ...
	        _.extend( this, CanvasDrawFns[subType] ); // why not just change prototype?
	        _.bindAll(this, 'drawStart', 'drawStop', 'drawMove');
	
	        this.$el.on( 'mousedown', this.drawStart );
	
	        /* must do after extension of drag fns   ... off('mousedown', this.model.unselectAllShapes ) ? */
	        /* note: needed (opposed to just draw start, b/c need to capture position of click from mouse event */
	
	        if ( note.supportsHoverShape() ) {
	            this.createHoverShape( note );
	        }
	
	    },
	    _disableDrawing: function() {
	
	        this.$el
	            .off('mousedown', this.drawStart)
	            .off('mousemove', this.drawMove)
	            .off('mouseup', this.drawStop);
	
	        // Handles case where changeNoteType, cancel note, save note, modeChange, pageChange, selectShape (but not another text shape)
	        this.channel.command('destroyTextArea');
	
	        /**
	         * TODO: really need to clean all these plugs ...
	         * hoverShape 'flag' (really the 'hover view' now implies Graphic Stamps and Signatures ( and now Text Stamps )
	         * Same hack to remove the hoverShape as hoverSignature if user cancel creating the note when creating it
	         * Only doing if already created (and would only exist if type is signature/stamp), on exit subtype is undefined )
	         * Only do on exit.
	         * Destroy: if note cancelled, before placed, this will still exist --> mem leaks, etc.
	         * TODO: put listener on the hover shape ?
	         *
	         */
	        this.hoverShape
	            && !this.channel.request('editMode')
	            && this.destroyHoverShape();
	
	    },
	
	
	    getMousePos: function(e) {
	
	        var offset = this.$el.offset();
	        return {
	            x: e.pageX - offset.left,
	            y: e.pageY - offset.top
	        };
	
	    },
	    _setBounds: function() {
	
	        var $el = this.$el,
	            ht = $el.height(),
	            wt = $el.width(),
	            $offset = $el.offset(),
	            left = $offset.left,
	            top = $offset.top;
	
	        this.containerAbs = {
	            x: left,
	            x2: left + wt,
	            y: top,
	            y2: top + ht
	        };
	
	        this.containerRel = {
	            x: 0,
	            y: 0,
	            x2: wt,
	            y2: ht
	        };
	
	    },
	
	    // the abs position (rel to doc)-- for draw and drag
	    // TODO: may no longer be working as intended -- eg: when drawing line we're always in bounds (forget original intention)
	    mouseInBounds: function(x, y) {
	
	        var box = this.containerAbs,
	            outOfBounds = x <= box.x || x >= box.x2 || y <= box.y ||  y >= box.y2;
	
	        return !outOfBounds;
	
	    },
	    baseDraw: BaseDrawFns,
	    destroyTextAreaView: function() {
	
	        if (!this.textAreaView)
	            return;
	
	        this.textAreaView.destroy();
	        this.textAreaView = null;
	        delete this.textAreaView;
	
	    },
	    // Occurs when user is modifying a stamp and changes the stamp image
	    graphicStampChanged: function(stamp, note) {
	
	        if ( this.hoverShape ) {
	
	            // I don't think need to call enable/disable drawing; this appears to just work ( must be in edit mode for it to exist )
	            // This would occur for new, unsaved notes where the stamp has yet to have been placed
	            this.destroyHoverShape();
	            this.createHoverShape( note );
	
	        } else {
	
	            var currentShapeModel = this.channel.request('selectedShape'),
	                currentShapeBbox = currentShapeModel.uiModel.getBBoxOfEl(),
	                scale = this.channel.request('currentScaleValue');
	
	            //TODO: check if this reset the state, eg the selected shape (maybe put that in there, could be mem leaks) ...
	                // ( now see text stamp change where we set to null ... )
	            // go through code ... maybe a better way to accomplish this
	            // brief look shows there doesn't appear to be mem leak
	            this.channel.command('deleteShape', currentShapeModel);
	
	            this.shape = CreateGraphicStampEl(
	                this.paper,
	                stamp.getImgSrc(),
	                currentShapeBbox.x,
	                currentShapeBbox.y,
	                stamp.getWidth() * scale,
	                stamp.getHeight() * scale
	            );
	
	            // TODO: also make sure it's in bounds (?); the size of the new shape could go outside it
	            this.channel.command( 'addNewlyDrawnShape', this.shape ); // ( this will also select it )
	        }
	
	    },
	
	    // still small mem leak when switch pages
	    // ... this may want cleanup now and it could have overlap with canvas.destroy
	    onBeforeDestroy: function() {
	
	        this.$el.off(); // eg mousedown for unselect shapes
	
	        this.channel.command('deleteAllShapes');
	        this.channel.reset();
	
	        this.shapeViews.call('destroy'); // this is breaking it -- it destroy shapeViews on the other canvas ... are they the same
	
	        this.shapeViews.each(function(sv) {
	            this.shapeViews.remove(sv);
	        }, this);
	
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(58)))

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var MouseDragTracker = __webpack_require__(361);
	
	module.exports = {
	    /**
	     * Note: these called from the originals
	     * Returns true if want to continue, else false
	     * Sets: this.mouseModel, this.bbox, model.mouseDrawing(true), the event handlers
	     * can think of as mousedown
	     */
	    start: function(e) {
	
	        var ch = this.channel;
	
	        // Only allow if drawing is enabled and not already drawing ( this.model.get('isDrawing') ) -- get rid for poly-redact
	        // TODO: can't have b/f other clicks to catch -- put catch of mousedown prior to draw start for clarity
	        if (!ch.request('editMode')) 
	            return false;
	
	        e.preventDefault(); //IE
	        e.stopPropagation();
	
	        // Disallow right: be able to capture on shapes ... (unselect any shapes)
	        if (e.which !== 1) 
	            return false;
	
	        // allow to draw on other shape, but not if button
	        // div is for DVBC-893 shim (with IE8)
	        // tspan is for redaction reason codes
	        var targetNode = $(e.target)[0].nodeName.toUpperCase(),
	            targetIsRaphaelElement = targetNode !== 'SVG' && targetNode !== 'IMG' && 
	                targetNode !== 'TEXTAREA' && targetNode !== 'TSPAN' && targetNode !== 'DIV';
	
	        if (targetIsRaphaelElement) {
	
	            var rId = e.target.raphaelid,
	                rEl = this.paper.getById(rId),
	                rElShapeType = rEl.data('shapeType'),
	                isExitEl = rElShapeType === 'button'; //|| rElShapeType === 'selectHandle' (want to prop to handle)
	
	            if (isExitEl) {
	                return false;
	            }
	
	
	        }
	
	        /* _____________ the drawing ______________ */
	
	        //TODO: facade combining both
	        ch.command('setSelectedShape', null);  // do after the above which looks for other clicks (eg that from the delete button; if before will break
	        ch.command('toggleUserDrawing', true); // use in case -- esp for drawing poly -- don't allow new mousedown events
	
	        // Start the Mousedown Tracker
	        this.mouseModel = new MouseDragTracker({
	            xy: this.getMousePos(e)
	        });
	
	        return true;
	    },
	    move: function (e, x, y) {
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        var mm = this.mouseModel.update( this.getMousePos(e) );
	        if ( mm.noChangeInOriginalPosition() )
	            return false;
	
	        // TODO: this may not be working  ... at least for line ... may want to use container relational here
	        // forget the original purpose
	        if ( !this.mouseInBounds(x, y) ) {
	
	            this.$el
	                .off('mouseup', this.drawStop)
	                .off('mousedown', this.drawStart)
	                .on('mousedown', this.drawStop);
	
	            return false;
	        }
	
	        return true;
	    },
	    end: function (e) {
	
	        e.preventDefault();
	        e.stopPropagation();
	
	        //TODO: combo both calls even though R fn ... b/c trickle down
	
	        this.shape.removeCachedBox();
	        /* necessary for IE8 fix involved with newer Raphael version and getBoxTransformStr (and also provides a perf boost) */
	        //TODO: would like to call off the shape view, but not yet created ... fired off something else ..
	            // note: not the 'selectedShape' of the canvas yet
	
	        this.mouseModel.update(this.getMousePos(e));
	        this.channel.command('toggleUserDrawing', false);  //don't unselect all shapes (already done at start)
	
	    },
	
	    /*
	    * Set attributes of to-be-shape's Raphael element prior to its view being created.
	    * (Can't call on shape view yet; it's created on the end of the draw (when added to the shapes collection).
	    * */
	    setShapeAttrs: function( rEl ) {
	
	        var ch = this.channel;
	
	        rEl.attr(
	            ch.request( 'getAttributesToApplyToShapeEl',
	                ch.request('activeNote'),
	                true,
	                null,
	                ch.request('activeNoteSubType') )
	        );
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Raphael = __webpack_require__(182);
	
	module.exports = Backbone.Model.extend({
	    minDimension: 5, //the smallest a shape can be in order to be created  (pixels)   -- for rect -- either vertical / horizontal
	    minDrawTime: 100, //threshold for how long to allow mousedown to mouseup in drawing shap
	    defaults: {
	        xy: {x: 0, y: 0},
	        oxy: {x: 0, y: 0},
	        dxy: {x: 0, y: 0},
	        odxy: {x: 0, y: 0},
	        start: null
	    },
	    initialize: function(options) {
	        this.set({
	            xy: options.xy,
	            oxy: options.xy,
	            start: new Date().getTime()
	        });
	        return this;
	    },
	    update: function(xy) {
	        this.set({
	            xy: xy,
	            dxy: {
	                x: xy.x - this.previous('xy').x,
	                y: xy.y - this.previous('xy').y
	            },
	            odxy: {
	                x: xy.x - this.get('oxy').x,
	                y: xy.y - this.get('oxy').y
	            }
	        });
	        return this; //allow changing
	    },
	    isTooShortOrSmall: function( pathStr ) {
	        var stop = new Date().getTime(), //make the time of the stop
	            isRect = !pathStr ,  //use diff method for rect (non total path len)
	            tooShort = Math.abs(this.get('start') - stop) < this.minDrawTime,
	            tooSmall = isRect ?  Math.abs(this.get('odxy').x) <= this.minDimension || Math.abs(this.get('odxy').y) <= this.minDimension
	                              :  Raphael.getTotalLength( pathStr ) <= this.minDimension;
	        return (tooShort || tooSmall);
	    },
	    noChangeInOriginalPosition: function() {
	        return this.get('odxy').x === 0 && this.get('odxy').y === 0;
	    }
	
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Currently a mixin to the canvas view (access channel from there).
	* TODO:
	* - the draw move fns should be the same as the resize fns -- start should create the basic shape .. in prog
	* - get rid of IIFE singleton W/exports
	* - re-org to store on shape view deriving from the base itself (now that have the ability)
	* */
	
	var $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    Raphael = __webpack_require__(182),// really want the extension here
	    DummyRectBorder = __webpack_require__(199),
	    PolygonDrawHelper = __webpack_require__(363),
	    Mousetrap = __webpack_require__(68),
	    LockAngleCalcPosition = __webpack_require__(203).calculatePosition,
	    fvChannel = __webpack_require__(72).channel('FV'),
	    TextAreaShape = __webpack_require__(364),
	    HoverShapeFactory = __webpack_require__(381);
	
	var ARROW_MIN = 10; // TODO: share with 'resize fns'
	
	
	module.exports = new function() {
	
	    function init() {
	
	        _.extend( this, {
	            'rect-fill': this.rect,
	            'rect-nofill': this.rect,
	            line: this.line,
	            'line-dashed': this.line,
	            'line-arrow': this.line,
	            text: this.text,
	            signature: this.hoverShape,
	            graphic_stamp: this.hoverShape,
	            text_stamp: this.hoverShape
	        });
	    }
	
	    this.rect = {
	
	        drawStart: function(e) {
	
	            if (!this.baseDraw.start.call(this, e))
	                return;
	
	            var mm = this.mouseModel,    /* NOW NOT CONVERTING FROM RECT -- START AS PATH */
	                RECT_START_LEN = 10; //*C  //NOTE IF THIS IS TOO SMALL WILL RESULT IN  Illegal input string in Vector2D (IE8) R.BUG -- ON MOVE -- 10 SEEMS TO WORK
	
	            this.shape = this.paper.path
	                ( Raphael.fn.rectPath( mm.get('xy').x, mm.get('xy').y, RECT_START_LEN, RECT_START_LEN) ).hide();    //can't use 0 for parse path to work
	
	            this.shape.transform('');
	
	            this.baseDraw.setShapeAttrs.call(this, this.shape);
	            this.osw = this.shape.attr('stroke-width');
	            this.dummyRectBorder = new DummyRectBorder(this.shape).hide();
	
	            this.$el
	                .off('mousedown', this.drawStart)
	                .on('mouseup', this.drawStop)
	                .on('mousemove', this.drawMove); // TODO: common fn
	
	        },
	        drawMove: function(e, dx, dy, x, y) {
	
	            if (!this.baseDraw.move.call(this, e, x, y))
	                return;
	
	            var pos = this.getMousePos(e);
	
	            this.shape
	                .show()
	                .setBoxTransformStr(pos.x, pos.y, true, true, true); //assuming south east // show
	
	            this.dummyRectBorder
	                .move()
	                .show();
	
	        },
	        drawStop: function(e) {
	            this.baseDraw.end.call(this, e);
	            this.$el
	                .off('mouseup', this.drawStop)
	                .off('mousemove', this.drawMove)
	                .on('mousedown', this.drawStart); //must come b/f add
	
	            if ( this.mouseModel.isTooShortOrSmall() ) {
	                this.shape.remove();
	            } else {
	                /* Successful: get the path of the bbox if drawing w/path b/c it may not be in 'rect' order
	                      -- need to bake transform pts in 'order' for rect */
	                this.shape.attr({
	                    path: this.shape.getPathOfBBox(),
	                    transform: ''
	                });
	
	                this.shape.attr('stroke-width', this.osw);
	                this.channel.command('addNewlyDrawnShape', this.shape);
	            }
	            this.dummyRectBorder.destroy();
	            this.osw = null; //TODO: only vml ... rid now ?
	        }
	    };
	
	    this.poly = { //polygon redaction
	        drawStart: function(e) {
	
	            //called on every node (pt) created) -- mouseup
	            if (!this.baseDraw.start.call(this, e))
	                return;
	
	            var mm = this.mouseModel;
	            Mousetrap.bind('escape', this.drawStop);
	
	            if (!this.polyHelper) { //first time in: create first node
	
	                this.polyHelper = new PolygonDrawHelper();
	                this.polyHelper.createFirstNode( this, mm.get('xy') );
	
	                this.shape = this.paper.path(this.polyHelper.currentPathString);
	                this.baseDraw.setShapeAttrs.call(this, this.shape);
	
	                this.$el.on('mousemove', this.drawMove);
	
	                this.listenToOnce(this, 'firstnode.clicked', this.drawStop);
	
	            } else {
	                //create additional nodes -- must be on mouseup
	                if (this.polyHelper.nodes.length < 1) return false;
	                this.polyHelper.createAdditionalNode(this, mm.get('xy'), e);
	                this.shape.attr('path', this.polyHelper.currentPathString);
	            }
	        },
	        drawMove: function(e, dx, dy, x, y) {   //draws a temp path -- line to where the mouse currently is
	            if (!this.baseDraw.move.call(this, e, x, y))
	                return;
	
	            var ph = this.polyHelper;
	            if (ph.nodes.length < 1) return; //exit if there are no nodes
	            ph.createPolyTempPath(this.paper, this.mouseModel.get('xy') );
	        },
	        drawStop: function(e) { //called when last node clicked
	            this.baseDraw.end.call(this, e); //need to turn off events (set isDrawing to false)
	            var atLeast3SidesDrawn =  this.polyHelper.nodes.length > 2; //must be a least 3 sides -- coming from first node clicked
	            if (e.type !== 'keydown' && atLeast3SidesDrawn) {
	                this.shape.attr('path', this.polyHelper.getFinalPath() );
	                this.channel.command('addNewlyDrawnShape', this.shape );
	            } else {
	                this.shape.remove();
	            }
	            //cleanup regardless
	            this.stopListening(this, 'firstnode.clicked', this.drawStop); //NEED IF USER CANCELS WITH ESCAPE (EVEN THOUGH IS LISTENTOONCE)
	            this.$el.off('mousemove', this.drawMove).off('mouseup', this.drawStart);
	            Mousetrap.unbind('escape'); //it only wants the keyboard event !
	            this.polyHelper.destroy();
	            this.polyHelper = null; //(need obj ref)
	        }
	    };
	
	    this.line = {
	
	        drawStart: function(e) {
	
	            if ( !this.baseDraw.start.call( this, e) )
	                return;
	
	            var mm = this.mouseModel,
	                x =  mm.get('xy').x,
	                y = mm.get('xy').y;
	
	            this.lineStart = 'M' + x + ' ' + y;
	
	            /*
	            * Cache the boundary parmater required for the Lock Angle lib.
	            * It wants container relative
	            * TODO: -- we don't want to apply the boundary on the main fn call if using this ... ( but that's not working)
	            * */
	            this.lockAngleBoundary = {
	                minX: this.containerRel.x,
	                minY: this.containerRel.y,
	                maxX: this.containerRel.x2,
	                maxY: this.containerRel.y2
	            };
	
	            // TODO: should know the activeNoteSubType; don't retrieve --
	            // later address with subclassing
	            var lCh = this.channel,
	                arrowAttr = lCh.request('activeNote').defaultSVGAttrsEdit(
	                    null, // ( don't need color for this purpose )
	                    lCh.request('activeNoteSubType'),
	                    lCh.request('getCurrentDrawingAttributes')
	                )['arrow-end'],
	                isArrow = arrowAttr !== undefined;
	
	            _.extend( mm, {
	                isArrow: isArrow,
	                arrowAttr: arrowAttr
	            });
	
	            this.currentPathString = this.lineStart
	                + (isArrow ? 'L' + (x + ARROW_MIN) + ' ' + (y + ARROW_MIN) : ''); // Raphael line hack (size)
	
	            this.shape = this.paper.path( this.currentPathString );
	            this.baseDraw.setShapeAttrs.call(this, this.shape);
	
	            this.$el
	                .off( 'mousedown', this.drawStart )
	                .on(  'mouseup', this.drawStop )
	                .on(  'mousemove', this.drawMove ); //TODO: make fn -- might put this in cb
	
	        },
	
	        // Note: dx, dy, x, y aren't used here -- should clean up
	        drawMove: function(e, dx, dy, x, y) {
	
	            if ( !this.baseDraw.move.call(this, e, x, y))
	                return;
	
	            var mm = this.mouseModel,
	                x = mm.get('xy').x,
	                y = mm.get('xy').y,
	                p = '';
	
	            if ( !e.shiftKey) {
	
	                p = this.currentPathString = this.lineStart + 'L' + (x > 0 ? x : 0) + ' ' + (y > 0 ? y : 0);
	
	            } else {
	
	                var projection = LockAngleCalcPosition( { x: x, y: y }, mm.get('oxy'), {
	                    boundary: this.lockAngleBoundary
	                });
	
	                p = this.currentPathString = this.lineStart + 'L' + projection.x + ' ' + projection.y;
	            }
	
	            /*
	            * Size hack for lines with arrows: get error if path length is too short
	            * TODO: this doesn't seem to stop in all cases -- eg
	            * - IE SVG4601: SVG Path data has incorrect format and could not be completely parsed.
	            * - Chrome <path> attribute d: Expected number, "M461,197CNaN,NaN,NaN,NaN,�".
	            * Same issue as was trying to stop in IE below -- unsure, need to research ...
	            * */
	            if ( mm.isArrow && Raphael.getTotalLength(p) < ARROW_MIN )
	                return;
	
	
	            /*
	            * IE hack - TODO: STILL NEEDED???
	            * Can still get error: SVG4601: SVG Path data has incorrect format and could not be completely parsed.
	            * Same issue as line with too small size ??
	            * */
	            mm.isArrow
	                ? this.shape
	                    .attr( 'arrow-end', '' )
	                    .attr( 'path', p )
	                    .attr( 'arrow-end', mm.arrowAttr )
	                : this.shape.attr( 'path', p );
	
	        },
	        drawStop: function(e) {
	
	            this.baseDraw.end.call(this, e);
	            var mm = this.mouseModel;
	
	            mm.isTooShortOrSmall( this.currentPathString )
	                ? this.shape.remove()
	                : this.channel.command('addNewlyDrawnShape', this.shape); //Successful: create shape model with the shape and add it to the shape collection
	
	            //Cleanup :
	            this.$el.off('mouseup', this.drawStop).off('mousemove', this.drawMove).on('mousedown', this.drawStart); // Note: must come b/f add
	
	            // TODO: this should be helpers
	            this.mm = null;
	            this.currentPathString = null;
	            this.shape = null;
	            this.lockAngleBoundary = null;
	        }
	    };
	
	
	    this.free = {  //todo: on draw if too short not want wanted -- eg bracket shape
	        drawStart: function(e) {
	
	            if (!this.baseDraw.start.apply(this, arguments))
	                return;
	
	            var mm = this.mouseModel;
	            this.$el.off('mousedown', this.drawStart).on('mouseup', this.drawStop).on('mousemove', this.drawMove);
	
	            this.currentPathString = 'M' +  mm.get('xy').x + ' ' +  mm.get('xy').y; //wants points relative to the previous point, not to the top left of the canvas
	            this.shape = this.paper.path(this.currentPathString);
	            this.baseDraw.setShapeAttrs.call(this, this.shape);
	        },
	        drawMove: function(e) {
	
	            if ( !this.baseDraw.move.apply(this, arguments))
	                return;
	
	            var mm = this.mouseModel,
	                x = mm.get('xy').x,
	                y = mm.get('xy').y,
	                lx = mm.previous('xy').x,
	                ly = mm.previous('xy').y;
	            this.currentPathString += 'l' + (x - lx) + ' ' + (y - ly);
	            this.shape.attr('path', this.currentPathString);
	        },
	        drawStop: function(e) {
	            this.baseDraw.end.call(this, e);
	            this.$el.off('mouseup', this.drawStop).off('mousemove', this.drawMove).on('mousedown', this.drawStart);
	            if ( !this.mouseModel.isTooShortOrSmall( this.currentPathString ) ) { //only complete if long enough -- really only dealing with time on this one
	                this.channel.command('addNewlyDrawnShape', this.shape );
	            } else {
	                this.shape.remove();
	            }
	            //cleanup
	            this.mouseModel = null;
	            this.currentPathString = null;
	            this.shape = null;
	
	        }
	    };
	
	    this.text = {
	        drawStart: function(e) {
	
	            //exit if already in 'create' mode
	            if (this.textAreaView)
	                return;
	
	            if (!this.baseDraw.start.apply(this, arguments))
	                return;
	
	            var mm = this.mouseModel,
	                ch = this.options.channel;
	
	            this.textAreaView = new TextAreaShape({
	                x: mm.get('xy').x,
	                y:  mm.get('xy').y,
	                color: ch.request( 'getColorToApplyToShape', ch.request('activeNote') ),
	                canvasView: this,
	                paper: this.paper,
	                channel: ch,
	                onOk: _.bind(function(text) {
	                    if (text.length > 0) {
	                        this.shape = this.textAreaView.replaceWithTextPath();
	                        ch.command('addNewlyDrawnShape', this.shape );
	                        ch.command('destroyTextArea'); 
	                    } else {
	                        ch.command('destroyTextArea', this); //maybe disable in 'dialog' show not possible
	                    }
	                    ch.command('toggleUserDrawing', false);
	                    this.$el.on('mousedown', this.drawStart);
	
	                }, this),
	                onCancel: _.bind(function() {
	                    ch.command('destroyTextArea', this);
	                    ch.command('toggleUserDrawing', false);
	                    this.$el.on('mousedown', this.drawStart);
	                }, this)
	
	            }).render();
	
	            this.$el.off('mousedown', this.drawStart);
	        },
	        drawMove: $.noop,
	        drawStop: $.noop
	    };
	
	    this.hoverShape = {
	
	
	        // This is really like 'draw end'; occurs after user has placed the temporary 'hover shape'
	        // ( CanvasView.enableDrawing sets mousedown handler to drawStart )
	        // Note: we don't reach here on edit for signatures, and graphic stamps ( had code to return if not new )
	        drawStart: function(e) {
	
	            /* One off for text stamps which may not be ready to be placed yet -- just don't allow */
	            if ( this.hoverShape.note.isTextStamp() && !this.hoverShape.note.uiModel.getInputsValid() ) {
	                return false;
	            }
	
	            this._disableDrawing();
	
	            if (!this.baseDraw.start.apply(this, arguments))
	                return;
	
	
	            this.shape = this.hoverShape.deriveShapeFromClone();
	
	            if ( this.hoverShape.note.isTextStamp() ) {
	                this.hoverShape.note.uiModel.setStampPlaced( true );
	            }
	
	            this.destroyHoverShape();
	
	            this.baseDraw.end.call( this, e ); //sets is drawing to false
	
	            this.channel.command( 'addNewlyDrawnShape', this.shape ); //adds shape to collection
	
	            // Temp for this: don't want to allow to place others
	            this.$el.addClass('default-cursor');
	
	
	        },
	        drawMove: $.noop,
	        drawStop: $.noop,
	
	        /**
	         * TODO:
	         * - This really should be done by having 'subShapes' and getting the draw functions from them, not the prototype ...
	         * - ( this would be more flexible and get rid of the 'ifs' ... )
	         */
	        createHoverShape: function( note ) {
	
	            var hoverShape = this.hoverShape =
	                HoverShapeFactory( note, this.paper, this.channel ).render();
	
	            // --- put all off this into factor ... ---
	
	            /**
	             * Note: need mouseenter and mouseleave (vs. mouseover, mouseout) so events don't bubble from descendants (eg: shapes)
	             * Utilizing jQuery hover events, not Raphael for the paper (would need an element of it's size).
	             * Move shape with cursor at the top-right of the mouse position until draw start.
	             */
	            this.$el
	                .on('mousemove', _.bind(function (e) {
	
	                    // TODO: now same as e.offsetX, e.offsetY ( change it and test )
	                    var mousePos = this.getMousePos(e),
	                        x = mousePos.x,
	                        y = mousePos.y;
	
	                    // No longer using -- perhaps could utilize something like this to persist
	                    // position between canvas re-renders
	                    // this.lastMousePosition = mousePos;
	
	                    hoverShape.trigger( 'hoverShape:mouseMove', x, y );
	
	                }, this))
	
	            /**
	             * Must defer in case mouse moves too fast --
	             * DVBC-310: is this not getting caught still an issue ?
	             */
	                .on('mouseenter', function() {
	                    _.defer( function() {
	                        hoverShape.trigger('hoverShape:mouseEnterCanvas');
	                    });
	                })
	                .on('mouseleave', function() {
	                    _.defer( function() {
	                        hoverShape.trigger('hoverShape:mouseExitCanvas');
	                    });
	                });
	
	        },
	        destroyHoverShape: function() {
	
	            this.hoverShape.destroy();
	            delete this.hoverShape; //( also serves as a flag that we're not already creating )
	            this.$el.off('mousemove mouseenter mouseleave');
	
	        }
	    };
	
	
	    init.call(this);
	
	
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    RaphaelView = __webpack_require__(187);
	
	/* Note tied to and communication with parent which is the shape -- acts like the other subShapes -- could mediate better */
	
	var Helper = function() {
	    this.nodes = [];
	    this.firstNode = null;
	    this.lastNode = null;
	    this.currentPathString = '';
	    this.polyTempPath = null;
	};
	
	module.exports = Helper;
	
	_.extend(Helper.prototype, {
	    createFirstNode: function(canvasView, pos) {
	        this.firstNode = new FirstDrawNode({
	            parent: canvasView,
	            position: {x: pos.x, y:  pos.y}
	        });
	        this.currentPathString  = 'M' + pos.x + ' ' + pos.y;   //now create the path
	        this.lastNode = this.firstNode;
	        this.nodes.push(this.firstNode);
	    },
	    createAdditionalNode: function(canvasView, pos) {
	        var x = pos.x,
	            y = pos.y;
	        this.lastNode = new PolyDrawNode({
	            parent: canvasView,
	            position: {x: x, y: y}
	        });
	        this.nodes.push(this.lastNode);
	        this.currentPathString += ' L' + x + ' ' + y;
	    },
	    createPolyTempPath: function(paper, pos) {
	        if (this.polyTempPath) this.polyTempPath.destroy();
	        var lastNodePosition = this.lastNode.position;
	        // draw temporary path to from the mouse pointer thing to the mouse position
	        this.polyTempPath = new PolyTempPath({
	            paper: paper,
	            x: pos.x,
	            y:  pos.y,
	            xLastNode: lastNodePosition.x,
	            yLastNode: lastNodePosition.y
	        });
	
	    },
	    getFinalPath: function() {
	        if (this.polyTempPath) this.polyTempPath.destroy();
	        this.currentPathString += ' Z'; //end with z
	        return this.currentPathString;
	    },
	    destroy: function() {
	        _.invoke(this.nodes.concat([this.firstNode, this.polyTempPath, this.lastNode]), 'destroy');
	        this.nodes = [];
	        this.firstNode = null; //clear up some references
	        this.lastNode = null;
	        this.polyTempPath = null;
	        this.currentPathString = null;
	    }
	});
	
	
	var PolyTempPath = RaphaelView.extend({
	    svgAttrs: {
	        stroke: '#7F7F7F',
	        'stroke-width': 1,
	        'fill-opacity': 0.25
	    },
	    initialize: function(options) {
	        var x = options.x,
	            y = options.y;
	        this.parent = options.parent;
	        this.path = 'M' + options.xLastNode + ' '  + options.yLastNode + 'L' + (x > 0 ? x : 0) + ' ' + (y > 0 ? y : 0);
	        this.render(options);
	    },
	    render: function(options) {
	        var el = options.paper.path(this.path).attr(this.svgAttrs).toBack();  // put behind nodes
	        this.setElement(el);
	        return this;
	    }
	});
	
	var PolyDrawNode = RaphaelView.extend({
	    radius: 5,
	    svgAttrs: {
	        fill: '#00FFFF',
	        stroke: '#0000FF',
	        'stroke-width': 2
	    },
	    initialize: function(options) {
	        this.parent = options.parent;
	        var p = this.position = options.position,  //STORED -- ACCESSED IN DRAWING
	            el = this.parent.paper.circle(p.x, p.y, this.radius).attr(this.svgAttrs);
	        this.setElement(el);
	        this.parent.trigger('node.created');
	    }
	});
	
	var FirstDrawNode = PolyDrawNode.extend({
	    svgAttrs: {
	        fill: '#3BC938',
	        stroke: '#158527',
	        'stroke-width': 2
	    },
	    events: {
	        'mouseover': 'mouseover',
	        'mouseout' : 'mouseout',
	        'mousedown': 'mousedown'
	    },
	    initialize: function() {
	        PolyDrawNode.prototype.initialize.apply(this, arguments);
	        this.listenToOnce(this.parent, 'node.created', this.moveForward);
	    },
	    mouseover: function(e) {
	        this.el.attr('cursor', 'move');
	    },
	    mouseout: function(e) {
	        this.el.attr('cursor', 'crosshair');  //that which exists when drawing
	    },
	    mousedown: function(e) {
	        e = $.event.fix(e);
	        e.stopImmediatePropagation();
	        this.parent.trigger('firstnode.clicked', e); //must pass the event
	    },
	    moveForward: function() {
	        this.el.toFront();
	    }
	});

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(365);
	
	var Marionette = __webpack_require__(61);
	
	__webpack_require__(182);
	__webpack_require__(176);
	__webpack_require__(76); //(unselectable)
	
	__webpack_require__(366);
	__webpack_require__(375);
	
	
	module.exports = Marionette.ItemView.extend({
	    className: 'text-area-shape-wr',
	    template: __webpack_require__(380),
	
	    initialize: function() {
	
	        var ch = this.options.channel;
	
	        this.listenTo(ch, 'textAreaView.scaleWithPaper',        this.scaleWithPaper);
	        this.listenTo(ch, 'textAreaView.updateColor',           this._updateColor );
	
	    },
	    ui: {
	        header:     '.ta-shape-header',
	        textarea:   '.text-area-shape-ta',
	        okBtn:      '.ta-btn-ok',
	        cancelBtn:  '.ta-btn-cancel'
	    },
	    onRender: function() {
	
	        var o = this.options;
	        this.ui.header.unselectable();
	
	        //put in DOM first for measurements
	        this.$el.appendTo( o.canvasView.$el );
	
	        // https://github.com/jackmoore/autosize/issues/336 -- perhaps update (the jquery one had an extra line)
	        // setting rows to 1 doesn't fix in this version
	        // will set size -- do b/f other size calcs or will be off
	        this._setupAutosizePlugin();
	
	        var headerHt = this.ui.header.outerHeight();
	
	        /* position in bounds on first click -- not doing on rescale for now -- prob more performant way to handle */
	        var mouseX = o.x,
	            mouseY = o.y,
	            elW = this.$el.outerWidth(),
	            elH = this.$el.outerHeight(),
	            mouseLeftBound = mouseX + elW,
	            mouseBottomBound = mouseY + elH,
	            canvasLeftBound = o.canvasView.$el.outerWidth(),
	            canvasBottomBound = o.canvasView.$el.outerHeight(),
	            px = mouseLeftBound > canvasLeftBound
	                    ? canvasLeftBound - elW
	                    : mouseX,
	            py = mouseBottomBound > canvasBottomBound
	                    ? canvasBottomBound - elH
	                    : mouseY;
	
	        this._position(px, py);
	
	        this.ui.textarea
	            .css({ color: o.color})
	            .focus();
	
	        this.$el.draggable({
	            containment: o.canvasView.$el,
	            scroll: false, // something funky so turn off ... maybe need diff container ... plus other shapes don't scroll
	            addClasses: false, // working, though  prob don't need -- 'dragging class still applied
	            handle: this.ui.header
	        })
	        .resizable({
	            containment: o.canvasView.$el,
	            minWidth: 140, //fix to stop header from collapsing ...
	            // ... maybe don't want resizable, esp combo with autosize on the textarea -- at least one line ... wait for feedback b/f finalizing ...
	            minHeight: this.$el.outerHeight(), // don't allow it smaller than the original size
	            // helper: "ui-resizable-helper", -- resize event still called with this
	           // ghost: true, resize still called ... eh
	            resize: _.bind(function(e, ui) {
	                var size = ui.size;
	                this.ui.textarea.css({
	                    height: size.height - headerHt,
	                    width: size.width
	                });
	            }, this),
	            start: _.bind(function() {
	                //alternative would be to not use the resize callback but to use a 'helper' or a 'ghost'
	                this.ui.textarea.trigger('autosize.destroy');
	            }, this),
	            stop: _.bind(function() {
	                this._setupAutosizePlugin(); //maybe better to use the update here (if use ghost/helper) ...
	            }, this)
	            //maybe only allow horizontal???
	        });
	        // could also have better styles for resizable corners ... wait for feedback ...
	        return this;
	    },
	    _setupAutosizePlugin: function() {
	        this.ui.textarea.autosize({
	            callback: _.bind(this.resizeFromTextAreaResize, this)
	        });
	    },
	    events: {
	        'mousedown': function(e) {
	            //allow clicking on the text area
	            e.stopPropagation();
	        },
	        'click @ui.okBtn': function() {
	            this.options.onOk( this.getText() );
	        },
	        'click @ui.cancelBtn': function() {
	            this.options.onCancel();
	        }
	    },
	    replaceWithTextPath: function() {
	
	        var $ta = this.ui.textarea,
	            paper = this.options.paper,
	            elPos = this.$el.position(),
	            taPos = this.ui.textarea.position(),
	            x = elPos.left + taPos.left + parseFloat( this.ui.textarea.css('padding-left') ), //currently no border
	            y = elPos.top + taPos.top + parseFloat( this.ui.textarea.css('padding-top') ), //currently no border
	            fontSize = parseFloat( $ta.css('font-size') ) ,
	            fontFamily = $ta.css('font-family'), //ARIAL -- now defined in css; must be the same as the cufon font
	            txt = this.getText(),
	            $fvWr = this.options.channel.request('viewerContainer'), //could mediate better (or pass in)
	            wrappedText = $.fn.textWrap( txt, $ta.width(), fontSize, fontFamily, $fvWr ); //currently not worrying about padding ...
	
	        this.$el.css('visibility', 'hidden');  //create box first  -- out for debug -- still needed? could just remove ...
	        //this.$el.css('opacity', 0.3); //for test positioning of the raphael path
	
	        //long paths will be very non-performant -- would lend case to using text, not the path, if can do that ...
	        //TODO: get default attr's from page XREF (defaultSVGAttrsEdit)
	        //Paper.print aligns with the baseline of the first line -- this is different that paper.text (wouldn't need the adjustment)
	        var textShape = paper.print( x, y + fontSize , wrappedText, paper.getFont(fontFamily), fontSize, 'baseline')
	            .attr({
	                //'text-anchor': 'start', //middle by default -- N/A for path -- see origin param above
	                'font-family': fontFamily,
	                'font-size': fontSize,
	                stroke: 'transparent',
	                'stroke-opacity': 0.01,
	                fill: $ta.css('color')
	        });
	
	        //remove $ta?
	        return textShape;
	    },
	    getText: function() {
	        return this.ui.textarea.val();
	    },
	    resizeFromTextAreaResize: function() {
	        var headerHt = this.ui.header.outerHeight(),
	            taHeight = this.ui.textarea.outerHeight();
	        this.$el.css('height', headerHt + taHeight);
	    },
	    // not scaling: just repositioning
	    scaleWithPaper: function(curScale, prevScale) {
	        var C = curScale / prevScale,
	            pos = this.$el.position();
	        this._position( pos.left * C, pos.top * C );
	    },
	    _position: function(x, y) {
	        this.$el.css({ left: x, top: y });
	    },
	
	    _updateColor: function( color ) {
	        this.ui.textarea.css({ color: color });
	    },
	    onBeforeDestroy: function() {
	        this.ui.textarea.trigger('autosize.destroy');
	        this.$el
	            .draggable('destroy')
	            .resizable('destroy');
	    },
	    destroy: function() {
	        Marionette.ItemView.prototype.destroy.apply(this, arguments);
	        /* ensure clear of jq cache */
	        this.$('*').remove();
	        this.$el.remove();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 365 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Draggable 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Draggable
	//>>group: Interactions
	//>>description: Enables dragging functionality for any element.
	//>>docs: http://api.jqueryui.com/draggable/
	//>>demos: http://jqueryui.com/draggable/
	//>>css.structure: ../../themes/base/draggable.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(59),
				__webpack_require__(367),
				__webpack_require__(370),
				__webpack_require__(371),
				__webpack_require__(372),
				__webpack_require__(373),
				__webpack_require__(374),
				__webpack_require__(65),
				__webpack_require__(369)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.draggable", $.ui.mouse, {
		version: "1.12.0",
		widgetEventPrefix: "drag",
		options: {
			addClasses: true,
			appendTo: "parent",
			axis: false,
			connectToSortable: false,
			containment: false,
			cursor: "auto",
			cursorAt: false,
			grid: false,
			handle: false,
			helper: "original",
			iframeFix: false,
			opacity: false,
			refreshPositions: false,
			revert: false,
			revertDuration: 500,
			scope: "default",
			scroll: true,
			scrollSensitivity: 20,
			scrollSpeed: 20,
			snap: false,
			snapMode: "both",
			snapTolerance: 20,
			stack: false,
			zIndex: false,
	
			// Callbacks
			drag: null,
			start: null,
			stop: null
		},
		_create: function() {
	
			if ( this.options.helper === "original" ) {
				this._setPositionRelative();
			}
			if ( this.options.addClasses ) {
				this._addClass( "ui-draggable" );
			}
			this._setHandleClassName();
	
			this._mouseInit();
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
			if ( key === "handle" ) {
				this._removeHandleClassName();
				this._setHandleClassName();
			}
		},
	
		_destroy: function() {
			if ( ( this.helper || this.element ).is( ".ui-draggable-dragging" ) ) {
				this.destroyOnClear = true;
				return;
			}
			this._removeHandleClassName();
			this._mouseDestroy();
		},
	
		_mouseCapture: function( event ) {
			var o = this.options;
	
			this._blurActiveElement( event );
	
			// Among others, prevent a drag on a resizable-handle
			if ( this.helper || o.disabled ||
					$( event.target ).closest( ".ui-resizable-handle" ).length > 0 ) {
				return false;
			}
	
			//Quit if we're not on a valid handle
			this.handle = this._getHandle( event );
			if ( !this.handle ) {
				return false;
			}
	
			this._blockFrames( o.iframeFix === true ? "iframe" : o.iframeFix );
	
			return true;
	
		},
	
		_blockFrames: function( selector ) {
			this.iframeBlocks = this.document.find( selector ).map( function() {
				var iframe = $( this );
	
				return $( "<div>" )
					.css( "position", "absolute" )
					.appendTo( iframe.parent() )
					.outerWidth( iframe.outerWidth() )
					.outerHeight( iframe.outerHeight() )
					.offset( iframe.offset() )[ 0 ];
			} );
		},
	
		_unblockFrames: function() {
			if ( this.iframeBlocks ) {
				this.iframeBlocks.remove();
				delete this.iframeBlocks;
			}
		},
	
		_blurActiveElement: function( event ) {
			var activeElement = $.ui.safeActiveElement( this.document[ 0 ] ),
				target = $( event.target );
	
			// Only blur if the event occurred on an element that is:
			// 1) within the draggable handle
			// 2) but not within the currently focused element
			// See #10527, #12472
			if ( this._getHandle( event ) && target.closest( activeElement ).length ) {
				return;
			}
	
			// Blur any element that currently has focus, see #4261
			$.ui.safeBlur( activeElement );
		},
	
		_mouseStart: function( event ) {
	
			var o = this.options;
	
			//Create and append the visible helper
			this.helper = this._createHelper( event );
	
			this._addClass( this.helper, "ui-draggable-dragging" );
	
			//Cache the helper size
			this._cacheHelperProportions();
	
			//If ddmanager is used for droppables, set the global draggable
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.current = this;
			}
	
			/*
			 * - Position generation -
			 * This block generates everything position related - it's the core of draggables.
			 */
	
			//Cache the margins of the original element
			this._cacheMargins();
	
			//Store the helper's css position
			this.cssPosition = this.helper.css( "position" );
			this.scrollParent = this.helper.scrollParent( true );
			this.offsetParent = this.helper.offsetParent();
			this.hasFixedAncestor = this.helper.parents().filter( function() {
					return $( this ).css( "position" ) === "fixed";
				} ).length > 0;
	
			//The element's absolute position on the page minus margins
			this.positionAbs = this.element.offset();
			this._refreshOffsets( event );
	
			//Generate the original position
			this.originalPosition = this.position = this._generatePosition( event, false );
			this.originalPageX = event.pageX;
			this.originalPageY = event.pageY;
	
			//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
			( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );
	
			//Set a containment if given in the options
			this._setContainment();
	
			//Trigger event + callbacks
			if ( this._trigger( "start", event ) === false ) {
				this._clear();
				return false;
			}
	
			//Recache the helper size
			this._cacheHelperProportions();
	
			//Prepare the droppable offsets
			if ( $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
	
			// Execute the drag once - this causes the helper not to be visible before getting its
			// correct position
			this._mouseDrag( event, true );
	
			// If the ddmanager is used for droppables, inform the manager that dragging has started
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStart( this, event );
			}
	
			return true;
		},
	
		_refreshOffsets: function( event ) {
			this.offset = {
				top: this.positionAbs.top - this.margins.top,
				left: this.positionAbs.left - this.margins.left,
				scroll: false,
				parent: this._getParentOffset(),
				relative: this._getRelativeOffset()
			};
	
			this.offset.click = {
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			};
		},
	
		_mouseDrag: function( event, noPropagation ) {
	
			// reset any necessary cached properties (see #5009)
			if ( this.hasFixedAncestor ) {
				this.offset.parent = this._getParentOffset();
			}
	
			//Compute the helpers position
			this.position = this._generatePosition( event, true );
			this.positionAbs = this._convertPositionTo( "absolute" );
	
			//Call plugins and callbacks and use the resulting position if something is returned
			if ( !noPropagation ) {
				var ui = this._uiHash();
				if ( this._trigger( "drag", event, ui ) === false ) {
					this._mouseUp( new $.Event( "mouseup", event ) );
					return false;
				}
				this.position = ui.position;
			}
	
			this.helper[ 0 ].style.left = this.position.left + "px";
			this.helper[ 0 ].style.top = this.position.top + "px";
	
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.drag( this, event );
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			//If we are using droppables, inform the manager about the drop
			var that = this,
				dropped = false;
			if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
				dropped = $.ui.ddmanager.drop( this, event );
			}
	
			//if a drop comes from outside (a sortable)
			if ( this.dropped ) {
				dropped = this.dropped;
				this.dropped = false;
			}
	
			if ( ( this.options.revert === "invalid" && !dropped ) ||
					( this.options.revert === "valid" && dropped ) ||
					this.options.revert === true || ( $.isFunction( this.options.revert ) &&
					this.options.revert.call( this.element, dropped ) )
			) {
				$( this.helper ).animate(
					this.originalPosition,
					parseInt( this.options.revertDuration, 10 ),
					function() {
						if ( that._trigger( "stop", event ) !== false ) {
							that._clear();
						}
					}
				);
			} else {
				if ( this._trigger( "stop", event ) !== false ) {
					this._clear();
				}
			}
	
			return false;
		},
	
		_mouseUp: function( event ) {
			this._unblockFrames();
	
			// If the ddmanager is used for droppables, inform the manager that dragging has stopped
			// (see #5003)
			if ( $.ui.ddmanager ) {
				$.ui.ddmanager.dragStop( this, event );
			}
	
			// Only need to focus if the event occurred on the draggable itself, see #10527
			if ( this.handleElement.is( event.target ) ) {
	
				// The interaction is over; whether or not the click resulted in a drag,
				// focus the element
				this.element.trigger( "focus" );
			}
	
			return $.ui.mouse.prototype._mouseUp.call( this, event );
		},
	
		cancel: function() {
	
			if ( this.helper.is( ".ui-draggable-dragging" ) ) {
				this._mouseUp( new $.Event( "mouseup", { target: this.element[ 0 ] } ) );
			} else {
				this._clear();
			}
	
			return this;
	
		},
	
		_getHandle: function( event ) {
			return this.options.handle ?
				!!$( event.target ).closest( this.element.find( this.options.handle ) ).length :
				true;
		},
	
		_setHandleClassName: function() {
			this.handleElement = this.options.handle ?
				this.element.find( this.options.handle ) : this.element;
			this._addClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_removeHandleClassName: function() {
			this._removeClass( this.handleElement, "ui-draggable-handle" );
		},
	
		_createHelper: function( event ) {
	
			var o = this.options,
				helperIsFunction = $.isFunction( o.helper ),
				helper = helperIsFunction ?
					$( o.helper.apply( this.element[ 0 ], [ event ] ) ) :
					( o.helper === "clone" ?
						this.element.clone().removeAttr( "id" ) :
						this.element );
	
			if ( !helper.parents( "body" ).length ) {
				helper.appendTo( ( o.appendTo === "parent" ?
					this.element[ 0 ].parentNode :
					o.appendTo ) );
			}
	
			// Http://bugs.jqueryui.com/ticket/9446
			// a helper function can return the original element
			// which wouldn't have been set to relative in _create
			if ( helperIsFunction && helper[ 0 ] === this.element[ 0 ] ) {
				this._setPositionRelative();
			}
	
			if ( helper[ 0 ] !== this.element[ 0 ] &&
					!( /(fixed|absolute)/ ).test( helper.css( "position" ) ) ) {
				helper.css( "position", "absolute" );
			}
	
			return helper;
	
		},
	
		_setPositionRelative: function() {
			if ( !( /^(?:r|a|f)/ ).test( this.element.css( "position" ) ) ) {
				this.element[ 0 ].style.position = "relative";
			}
		},
	
		_adjustOffsetFromHelper: function( obj ) {
			if ( typeof obj === "string" ) {
				obj = obj.split( " " );
			}
			if ( $.isArray( obj ) ) {
				obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
			}
			if ( "left" in obj ) {
				this.offset.click.left = obj.left + this.margins.left;
			}
			if ( "right" in obj ) {
				this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
			}
			if ( "top" in obj ) {
				this.offset.click.top = obj.top + this.margins.top;
			}
			if ( "bottom" in obj ) {
				this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
			}
		},
	
		_isRootNode: function( element ) {
			return ( /(html|body)/i ).test( element.tagName ) || element === this.document[ 0 ];
		},
	
		_getParentOffset: function() {
	
			//Get the offsetParent and cache its position
			var po = this.offsetParent.offset(),
				document = this.document[ 0 ];
	
			// This is a special case where we need to modify a offset calculated on start, since the
			// following happened:
			// 1. The position of the helper is absolute, so it's position is calculated based on the
			// next positioned parent
			// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
			// the document, which means that the scroll is included in the initial calculation of the
			// offset of the parent, and never recalculated upon drag
			if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== document &&
					$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
				po.left += this.scrollParent.scrollLeft();
				po.top += this.scrollParent.scrollTop();
			}
	
			if ( this._isRootNode( this.offsetParent[ 0 ] ) ) {
				po = { top: 0, left: 0 };
			}
	
			return {
				top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
				left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
			};
	
		},
	
		_getRelativeOffset: function() {
			if ( this.cssPosition !== "relative" ) {
				return { top: 0, left: 0 };
			}
	
			var p = this.element.position(),
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollTop() : 0 ),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					( !scrollIsRootNode ? this.scrollParent.scrollLeft() : 0 )
			};
	
		},
	
		_cacheMargins: function() {
			this.margins = {
				left: ( parseInt( this.element.css( "marginLeft" ), 10 ) || 0 ),
				top: ( parseInt( this.element.css( "marginTop" ), 10 ) || 0 ),
				right: ( parseInt( this.element.css( "marginRight" ), 10 ) || 0 ),
				bottom: ( parseInt( this.element.css( "marginBottom" ), 10 ) || 0 )
			};
		},
	
		_cacheHelperProportions: function() {
			this.helperProportions = {
				width: this.helper.outerWidth(),
				height: this.helper.outerHeight()
			};
		},
	
		_setContainment: function() {
	
			var isUserScrollable, c, ce,
				o = this.options,
				document = this.document[ 0 ];
	
			this.relativeContainer = null;
	
			if ( !o.containment ) {
				this.containment = null;
				return;
			}
	
			if ( o.containment === "window" ) {
				this.containment = [
					$( window ).scrollLeft() - this.offset.relative.left - this.offset.parent.left,
					$( window ).scrollTop() - this.offset.relative.top - this.offset.parent.top,
					$( window ).scrollLeft() + $( window ).width() -
						this.helperProportions.width - this.margins.left,
					$( window ).scrollTop() +
						( $( window ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment === "document" ) {
				this.containment = [
					0,
					0,
					$( document ).width() - this.helperProportions.width - this.margins.left,
					( $( document ).height() || document.body.parentNode.scrollHeight ) -
						this.helperProportions.height - this.margins.top
				];
				return;
			}
	
			if ( o.containment.constructor === Array ) {
				this.containment = o.containment;
				return;
			}
	
			if ( o.containment === "parent" ) {
				o.containment = this.helper[ 0 ].parentNode;
			}
	
			c = $( o.containment );
			ce = c[ 0 ];
	
			if ( !ce ) {
				return;
			}
	
			isUserScrollable = /(scroll|auto)/.test( c.css( "overflow" ) );
	
			this.containment = [
				( parseInt( c.css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingLeft" ), 10 ) || 0 ),
				( parseInt( c.css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( c.css( "paddingTop" ), 10 ) || 0 ),
				( isUserScrollable ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( c.css( "borderRightWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width -
					this.margins.left -
					this.margins.right,
				( isUserScrollable ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( c.css( "borderBottomWidth" ), 10 ) || 0 ) -
					( parseInt( c.css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height -
					this.margins.top -
					this.margins.bottom
			];
			this.relativeContainer = c;
		},
	
		_convertPositionTo: function( d, pos ) {
	
			if ( !pos ) {
				pos = this.position;
			}
	
			var mod = d === "absolute" ? 1 : -1,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] );
	
			return {
				top: (
	
					// The absolute mouse position
					pos.top	+
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top * mod -
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) ) * mod )
				),
				left: (
	
					// The absolute mouse position
					pos.left +
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left * mod +
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left * mod	-
					( ( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) ) * mod )
				)
			};
	
		},
	
		_generatePosition: function( event, constrainPosition ) {
	
			var containment, co, top, left,
				o = this.options,
				scrollIsRootNode = this._isRootNode( this.scrollParent[ 0 ] ),
				pageX = event.pageX,
				pageY = event.pageY;
	
			// Cache the scroll
			if ( !scrollIsRootNode || !this.offset.scroll ) {
				this.offset.scroll = {
					top: this.scrollParent.scrollTop(),
					left: this.scrollParent.scrollLeft()
				};
			}
	
			/*
			 * - Position constraining -
			 * Constrain the position to a mix of grid, containment.
			 */
	
			// If we are not dragging yet, we won't check for options
			if ( constrainPosition ) {
				if ( this.containment ) {
					if ( this.relativeContainer ) {
						co = this.relativeContainer.offset();
						containment = [
							this.containment[ 0 ] + co.left,
							this.containment[ 1 ] + co.top,
							this.containment[ 2 ] + co.left,
							this.containment[ 3 ] + co.top
						];
					} else {
						containment = this.containment;
					}
	
					if ( event.pageX - this.offset.click.left < containment[ 0 ] ) {
						pageX = containment[ 0 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top < containment[ 1 ] ) {
						pageY = containment[ 1 ] + this.offset.click.top;
					}
					if ( event.pageX - this.offset.click.left > containment[ 2 ] ) {
						pageX = containment[ 2 ] + this.offset.click.left;
					}
					if ( event.pageY - this.offset.click.top > containment[ 3 ] ) {
						pageY = containment[ 3 ] + this.offset.click.top;
					}
				}
	
				if ( o.grid ) {
	
					//Check for grid elements set to 0 to prevent divide by 0 error causing invalid
					// argument errors in IE (see ticket #6950)
					top = o.grid[ 1 ] ? this.originalPageY + Math.round( ( pageY -
						this.originalPageY ) / o.grid[ 1 ] ) * o.grid[ 1 ] : this.originalPageY;
					pageY = containment ? ( ( top - this.offset.click.top >= containment[ 1 ] ||
						top - this.offset.click.top > containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) : top;
	
					left = o.grid[ 0 ] ? this.originalPageX +
						Math.round( ( pageX - this.originalPageX ) / o.grid[ 0 ] ) * o.grid[ 0 ] :
						this.originalPageX;
					pageX = containment ? ( ( left - this.offset.click.left >= containment[ 0 ] ||
						left - this.offset.click.left > containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) : left;
				}
	
				if ( o.axis === "y" ) {
					pageX = this.originalPageX;
				}
	
				if ( o.axis === "x" ) {
					pageY = this.originalPageY;
				}
			}
	
			return {
				top: (
	
					// The absolute mouse position
					pageY -
	
					// Click offset (relative to the element)
					this.offset.click.top -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.top -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.top +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.top :
						( scrollIsRootNode ? 0 : this.offset.scroll.top ) )
				),
				left: (
	
					// The absolute mouse position
					pageX -
	
					// Click offset (relative to the element)
					this.offset.click.left -
	
					// Only for relative positioned nodes: Relative offset from element to offset parent
					this.offset.relative.left -
	
					// The offsetParent's offset without borders (offset + border)
					this.offset.parent.left +
					( this.cssPosition === "fixed" ?
						-this.offset.scroll.left :
						( scrollIsRootNode ? 0 : this.offset.scroll.left ) )
				)
			};
	
		},
	
		_clear: function() {
			this._removeClass( this.helper, "ui-draggable-dragging" );
			if ( this.helper[ 0 ] !== this.element[ 0 ] && !this.cancelHelperRemoval ) {
				this.helper.remove();
			}
			this.helper = null;
			this.cancelHelperRemoval = false;
			if ( this.destroyOnClear ) {
				this.destroy();
			}
		},
	
		// From now on bulk stuff - mainly helpers
	
		_trigger: function( type, event, ui ) {
			ui = ui || this._uiHash();
			$.ui.plugin.call( this, type, [ event, ui, this ], true );
	
			// Absolute position and offset (see #6884 ) have to be recalculated after plugins
			if ( /^(drag|start|stop)/.test( type ) ) {
				this.positionAbs = this._convertPositionTo( "absolute" );
				ui.offset = this.positionAbs;
			}
			return $.Widget.prototype._trigger.call( this, type, event, ui );
		},
	
		plugins: {},
	
		_uiHash: function() {
			return {
				helper: this.helper,
				position: this.position,
				originalPosition: this.originalPosition,
				offset: this.positionAbs
			};
		}
	
	} );
	
	$.ui.plugin.add( "draggable", "connectToSortable", {
		start: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.sortables = [];
			$( draggable.options.connectToSortable ).each( function() {
				var sortable = $( this ).sortable( "instance" );
	
				if ( sortable && !sortable.options.disabled ) {
					draggable.sortables.push( sortable );
	
					// RefreshPositions is called at drag start to refresh the containerCache
					// which is used in drag. This ensures it's initialized and synchronized
					// with any changes that might have happened on the page since initialization.
					sortable.refreshPositions();
					sortable._trigger( "activate", event, uiSortable );
				}
			} );
		},
		stop: function( event, ui, draggable ) {
			var uiSortable = $.extend( {}, ui, {
				item: draggable.element
			} );
	
			draggable.cancelHelperRemoval = false;
	
			$.each( draggable.sortables, function() {
				var sortable = this;
	
				if ( sortable.isOver ) {
					sortable.isOver = 0;
	
					// Allow this sortable to handle removing the helper
					draggable.cancelHelperRemoval = true;
					sortable.cancelHelperRemoval = false;
	
					// Use _storedCSS To restore properties in the sortable,
					// as this also handles revert (#9675) since the draggable
					// may have modified them in unexpected ways (#8809)
					sortable._storedCSS = {
						position: sortable.placeholder.css( "position" ),
						top: sortable.placeholder.css( "top" ),
						left: sortable.placeholder.css( "left" )
					};
	
					sortable._mouseStop( event );
	
					// Once drag has ended, the sortable should return to using
					// its original helper, not the shared helper from draggable
					sortable.options.helper = sortable.options._helper;
				} else {
	
					// Prevent this Sortable from removing the helper.
					// However, don't set the draggable to remove the helper
					// either as another connected Sortable may yet handle the removal.
					sortable.cancelHelperRemoval = true;
	
					sortable._trigger( "deactivate", event, uiSortable );
				}
			} );
		},
		drag: function( event, ui, draggable ) {
			$.each( draggable.sortables, function() {
				var innermostIntersecting = false,
					sortable = this;
	
				// Copy over variables that sortable's _intersectsWith uses
				sortable.positionAbs = draggable.positionAbs;
				sortable.helperProportions = draggable.helperProportions;
				sortable.offset.click = draggable.offset.click;
	
				if ( sortable._intersectsWith( sortable.containerCache ) ) {
					innermostIntersecting = true;
	
					$.each( draggable.sortables, function() {
	
						// Copy over variables that sortable's _intersectsWith uses
						this.positionAbs = draggable.positionAbs;
						this.helperProportions = draggable.helperProportions;
						this.offset.click = draggable.offset.click;
	
						if ( this !== sortable &&
								this._intersectsWith( this.containerCache ) &&
								$.contains( sortable.element[ 0 ], this.element[ 0 ] ) ) {
							innermostIntersecting = false;
						}
	
						return innermostIntersecting;
					} );
				}
	
				if ( innermostIntersecting ) {
	
					// If it intersects, we use a little isOver variable and set it once,
					// so that the move-in stuff gets fired only once.
					if ( !sortable.isOver ) {
						sortable.isOver = 1;
	
						// Store draggable's parent in case we need to reappend to it later.
						draggable._parent = ui.helper.parent();
	
						sortable.currentItem = ui.helper
							.appendTo( sortable.element )
							.data( "ui-sortable-item", true );
	
						// Store helper option to later restore it
						sortable.options._helper = sortable.options.helper;
	
						sortable.options.helper = function() {
							return ui.helper[ 0 ];
						};
	
						// Fire the start events of the sortable with our passed browser event,
						// and our own helper (so it doesn't create a new one)
						event.target = sortable.currentItem[ 0 ];
						sortable._mouseCapture( event, true );
						sortable._mouseStart( event, true, true );
	
						// Because the browser event is way off the new appended portlet,
						// modify necessary variables to reflect the changes
						sortable.offset.click.top = draggable.offset.click.top;
						sortable.offset.click.left = draggable.offset.click.left;
						sortable.offset.parent.left -= draggable.offset.parent.left -
							sortable.offset.parent.left;
						sortable.offset.parent.top -= draggable.offset.parent.top -
							sortable.offset.parent.top;
	
						draggable._trigger( "toSortable", event );
	
						// Inform draggable that the helper is in a valid drop zone,
						// used solely in the revert option to handle "valid/invalid".
						draggable.dropped = sortable.element;
	
						// Need to refreshPositions of all sortables in the case that
						// adding to one sortable changes the location of the other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
	
						// Hack so receive/update callbacks work (mostly)
						draggable.currentItem = draggable.element;
						sortable.fromOutside = draggable;
					}
	
					if ( sortable.currentItem ) {
						sortable._mouseDrag( event );
	
						// Copy the sortable's position because the draggable's can potentially reflect
						// a relative position, while sortable is always absolute, which the dragged
						// element has now become. (#8809)
						ui.position = sortable.position;
					}
				} else {
	
					// If it doesn't intersect with the sortable, and it intersected before,
					// we fake the drag stop of the sortable, but make sure it doesn't remove
					// the helper by using cancelHelperRemoval.
					if ( sortable.isOver ) {
	
						sortable.isOver = 0;
						sortable.cancelHelperRemoval = true;
	
						// Calling sortable's mouseStop would trigger a revert,
						// so revert must be temporarily false until after mouseStop is called.
						sortable.options._revert = sortable.options.revert;
						sortable.options.revert = false;
	
						sortable._trigger( "out", event, sortable._uiHash( sortable ) );
						sortable._mouseStop( event, true );
	
						// Restore sortable behaviors that were modfied
						// when the draggable entered the sortable area (#9481)
						sortable.options.revert = sortable.options._revert;
						sortable.options.helper = sortable.options._helper;
	
						if ( sortable.placeholder ) {
							sortable.placeholder.remove();
						}
	
						// Restore and recalculate the draggable's offset considering the sortable
						// may have modified them in unexpected ways. (#8809, #10669)
						ui.helper.appendTo( draggable._parent );
						draggable._refreshOffsets( event );
						ui.position = draggable._generatePosition( event, true );
	
						draggable._trigger( "fromSortable", event );
	
						// Inform draggable that the helper is no longer in a valid drop zone
						draggable.dropped = false;
	
						// Need to refreshPositions of all sortables just in case removing
						// from one sortable changes the location of other sortables (#9675)
						$.each( draggable.sortables, function() {
							this.refreshPositions();
						} );
					}
				}
			} );
		}
	} );
	
	$.ui.plugin.add( "draggable", "cursor", {
		start: function( event, ui, instance ) {
			var t = $( "body" ),
				o = instance.options;
	
			if ( t.css( "cursor" ) ) {
				o._cursor = t.css( "cursor" );
			}
			t.css( "cursor", o.cursor );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._cursor ) {
				$( "body" ).css( "cursor", o._cursor );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "opacity", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
			if ( t.css( "opacity" ) ) {
				o._opacity = t.css( "opacity" );
			}
			t.css( "opacity", o.opacity );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
			if ( o._opacity ) {
				$( ui.helper ).css( "opacity", o._opacity );
			}
		}
	} );
	
	$.ui.plugin.add( "draggable", "scroll", {
		start: function( event, ui, i ) {
			if ( !i.scrollParentNotHidden ) {
				i.scrollParentNotHidden = i.helper.scrollParent( false );
			}
	
			if ( i.scrollParentNotHidden[ 0 ] !== i.document[ 0 ] &&
					i.scrollParentNotHidden[ 0 ].tagName !== "HTML" ) {
				i.overflowOffset = i.scrollParentNotHidden.offset();
			}
		},
		drag: function( event, ui, i  ) {
	
			var o = i.options,
				scrolled = false,
				scrollParent = i.scrollParentNotHidden[ 0 ],
				document = i.document[ 0 ];
	
			if ( scrollParent !== document && scrollParent.tagName !== "HTML" ) {
				if ( !o.axis || o.axis !== "x" ) {
					if ( ( i.overflowOffset.top + scrollParent.offsetHeight ) - event.pageY <
							o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop + o.scrollSpeed;
					} else if ( event.pageY - i.overflowOffset.top < o.scrollSensitivity ) {
						scrollParent.scrollTop = scrolled = scrollParent.scrollTop - o.scrollSpeed;
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( ( i.overflowOffset.left + scrollParent.offsetWidth ) - event.pageX <
							o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft + o.scrollSpeed;
					} else if ( event.pageX - i.overflowOffset.left < o.scrollSensitivity ) {
						scrollParent.scrollLeft = scrolled = scrollParent.scrollLeft - o.scrollSpeed;
					}
				}
	
			} else {
	
				if ( !o.axis || o.axis !== "x" ) {
					if ( event.pageY - $( document ).scrollTop() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() - o.scrollSpeed );
					} else if ( $( window ).height() - ( event.pageY - $( document ).scrollTop() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollTop( $( document ).scrollTop() + o.scrollSpeed );
					}
				}
	
				if ( !o.axis || o.axis !== "y" ) {
					if ( event.pageX - $( document ).scrollLeft() < o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() - o.scrollSpeed
						);
					} else if ( $( window ).width() - ( event.pageX - $( document ).scrollLeft() ) <
							o.scrollSensitivity ) {
						scrolled = $( document ).scrollLeft(
							$( document ).scrollLeft() + o.scrollSpeed
						);
					}
				}
	
			}
	
			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( i, event );
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "snap", {
		start: function( event, ui, i ) {
	
			var o = i.options;
	
			i.snapElements = [];
	
			$( o.snap.constructor !== String ? ( o.snap.items || ":data(ui-draggable)" ) : o.snap )
				.each( function() {
					var $t = $( this ),
						$o = $t.offset();
					if ( this !== i.element[ 0 ] ) {
						i.snapElements.push( {
							item: this,
							width: $t.outerWidth(), height: $t.outerHeight(),
							top: $o.top, left: $o.left
						} );
					}
				} );
	
		},
		drag: function( event, ui, inst ) {
	
			var ts, bs, ls, rs, l, r, t, b, i, first,
				o = inst.options,
				d = o.snapTolerance,
				x1 = ui.offset.left, x2 = x1 + inst.helperProportions.width,
				y1 = ui.offset.top, y2 = y1 + inst.helperProportions.height;
	
			for ( i = inst.snapElements.length - 1; i >= 0; i-- ) {
	
				l = inst.snapElements[ i ].left - inst.margins.left;
				r = l + inst.snapElements[ i ].width;
				t = inst.snapElements[ i ].top - inst.margins.top;
				b = t + inst.snapElements[ i ].height;
	
				if ( x2 < l - d || x1 > r + d || y2 < t - d || y1 > b + d ||
						!$.contains( inst.snapElements[ i ].item.ownerDocument,
						inst.snapElements[ i ].item ) ) {
					if ( inst.snapElements[ i ].snapping ) {
						( inst.options.snap.release &&
							inst.options.snap.release.call(
								inst.element,
								event,
								$.extend( inst._uiHash(), { snapItem: inst.snapElements[ i ].item } )
							) );
					}
					inst.snapElements[ i ].snapping = false;
					continue;
				}
	
				if ( o.snapMode !== "inner" ) {
					ts = Math.abs( t - y2 ) <= d;
					bs = Math.abs( b - y1 ) <= d;
					ls = Math.abs( l - x2 ) <= d;
					rs = Math.abs( r - x1 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l - inst.helperProportions.width
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r
						} ).left;
					}
				}
	
				first = ( ts || bs || ls || rs );
	
				if ( o.snapMode !== "outer" ) {
					ts = Math.abs( t - y1 ) <= d;
					bs = Math.abs( b - y2 ) <= d;
					ls = Math.abs( l - x1 ) <= d;
					rs = Math.abs( r - x2 ) <= d;
					if ( ts ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: t,
							left: 0
						} ).top;
					}
					if ( bs ) {
						ui.position.top = inst._convertPositionTo( "relative", {
							top: b - inst.helperProportions.height,
							left: 0
						} ).top;
					}
					if ( ls ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: l
						} ).left;
					}
					if ( rs ) {
						ui.position.left = inst._convertPositionTo( "relative", {
							top: 0,
							left: r - inst.helperProportions.width
						} ).left;
					}
				}
	
				if ( !inst.snapElements[ i ].snapping && ( ts || bs || ls || rs || first ) ) {
					( inst.options.snap.snap &&
						inst.options.snap.snap.call(
							inst.element,
							event,
							$.extend( inst._uiHash(), {
								snapItem: inst.snapElements[ i ].item
							} ) ) );
				}
				inst.snapElements[ i ].snapping = ( ts || bs || ls || rs || first );
	
			}
	
		}
	} );
	
	$.ui.plugin.add( "draggable", "stack", {
		start: function( event, ui, instance ) {
			var min,
				o = instance.options,
				group = $.makeArray( $( o.stack ) ).sort( function( a, b ) {
					return ( parseInt( $( a ).css( "zIndex" ), 10 ) || 0 ) -
						( parseInt( $( b ).css( "zIndex" ), 10 ) || 0 );
				} );
	
			if ( !group.length ) { return; }
	
			min = parseInt( $( group[ 0 ] ).css( "zIndex" ), 10 ) || 0;
			$( group ).each( function( i ) {
				$( this ).css( "zIndex", min + i );
			} );
			this.css( "zIndex", ( min + group.length ) );
		}
	} );
	
	$.ui.plugin.add( "draggable", "zIndex", {
		start: function( event, ui, instance ) {
			var t = $( ui.helper ),
				o = instance.options;
	
			if ( t.css( "zIndex" ) ) {
				o._zIndex = t.css( "zIndex" );
			}
			t.css( "zIndex", o.zIndex );
		},
		stop: function( event, ui, instance ) {
			var o = instance.options;
	
			if ( o._zIndex ) {
				$( ui.helper ).css( "zIndex", o._zIndex );
			}
		}
	} );
	
	return $.ui.draggable;
	
	} ) );


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Mouse 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Mouse
	//>>group: Widgets
	//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
	//>>docs: http://api.jqueryui.com/mouse/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(59),
				__webpack_require__(368),
				__webpack_require__(65),
				__webpack_require__(369)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var mouseHandled = false;
	$( document ).on( "mouseup", function() {
		mouseHandled = false;
	} );
	
	return $.widget( "ui.mouse", {
		version: "1.12.0",
		options: {
			cancel: "input, textarea, button, select, option",
			distance: 1,
			delay: 0
		},
		_mouseInit: function() {
			var that = this;
	
			this.element
				.on( "mousedown." + this.widgetName, function( event ) {
					return that._mouseDown( event );
				} )
				.on( "click." + this.widgetName, function( event ) {
					if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
						$.removeData( event.target, that.widgetName + ".preventClickEvent" );
						event.stopImmediatePropagation();
						return false;
					}
				} );
	
			this.started = false;
		},
	
		// TODO: make sure destroying one instance of mouse doesn't mess with
		// other instances of mouse
		_mouseDestroy: function() {
			this.element.off( "." + this.widgetName );
			if ( this._mouseMoveDelegate ) {
				this.document
					.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
					.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
			}
		},
	
		_mouseDown: function( event ) {
	
			// don't let more than one widget handle mouseStart
			if ( mouseHandled ) {
				return;
			}
	
			this._mouseMoved = false;
	
			// We may have missed mouseup (out of window)
			( this._mouseStarted && this._mouseUp( event ) );
	
			this._mouseDownEvent = event;
	
			var that = this,
				btnIsLeft = ( event.which === 1 ),
	
				// event.target.nodeName works around a bug in IE 8 with
				// disabled inputs (#7620)
				elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
					$( event.target ).closest( this.options.cancel ).length : false );
			if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
				return true;
			}
	
			this.mouseDelayMet = !this.options.delay;
			if ( !this.mouseDelayMet ) {
				this._mouseDelayTimer = setTimeout( function() {
					that.mouseDelayMet = true;
				}, this.options.delay );
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted = ( this._mouseStart( event ) !== false );
				if ( !this._mouseStarted ) {
					event.preventDefault();
					return true;
				}
			}
	
			// Click event may never have fired (Gecko & Opera)
			if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
				$.removeData( event.target, this.widgetName + ".preventClickEvent" );
			}
	
			// These delegates are required to keep context
			this._mouseMoveDelegate = function( event ) {
				return that._mouseMove( event );
			};
			this._mouseUpDelegate = function( event ) {
				return that._mouseUp( event );
			};
	
			this.document
				.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.on( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			event.preventDefault();
	
			mouseHandled = true;
			return true;
		},
	
		_mouseMove: function( event ) {
	
			// Only check for mouseups outside the document if you've moved inside the document
			// at least once. This prevents the firing of mouseup in the case of IE<9, which will
			// fire a mousemove event if content is placed under the cursor. See #7778
			// Support: IE <9
			if ( this._mouseMoved ) {
	
				// IE mouseup check - mouseup happened when mouse was out of window
				if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
						!event.button ) {
					return this._mouseUp( event );
	
				// Iframe mouseup check - mouseup occurred in another document
				} else if ( !event.which ) {
	
					// Support: Safari <=8 - 9
					// Safari sets which to 0 if you press any of the following keys
					// during a drag (#14461)
					if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
							event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
						this.ignoreMissingWhich = true;
					} else if ( !this.ignoreMissingWhich ) {
						return this._mouseUp( event );
					}
				}
			}
	
			if ( event.which || event.button ) {
				this._mouseMoved = true;
			}
	
			if ( this._mouseStarted ) {
				this._mouseDrag( event );
				return event.preventDefault();
			}
	
			if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
				this._mouseStarted =
					( this._mouseStart( this._mouseDownEvent, event ) !== false );
				( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
			}
	
			return !this._mouseStarted;
		},
	
		_mouseUp: function( event ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
	
			if ( this._mouseStarted ) {
				this._mouseStarted = false;
	
				if ( event.target === this._mouseDownEvent.target ) {
					$.data( event.target, this.widgetName + ".preventClickEvent", true );
				}
	
				this._mouseStop( event );
			}
	
			if ( this._mouseDelayTimer ) {
				clearTimeout( this._mouseDelayTimer );
				delete this._mouseDelayTimer;
			}
	
			this.ignoreMissingWhich = false;
			mouseHandled = false;
			event.preventDefault();
		},
	
		_mouseDistanceMet: function( event ) {
			return ( Math.max(
					Math.abs( this._mouseDownEvent.pageX - event.pageX ),
					Math.abs( this._mouseDownEvent.pageY - event.pageY )
				) >= this.options.distance
			);
		},
	
		_mouseDelayMet: function( /* event */ ) {
			return this.mouseDelayMet;
		},
	
		// These are placeholder methods, to be overriden by extending plugin
		_mouseStart: function( /* event */ ) {},
		_mouseDrag: function( /* event */ ) {},
		_mouseStop: function( /* event */ ) {},
		_mouseCapture: function( /* event */ ) { return true; }
	} );
	
	} ) );


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// This file is deprecated
	return $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );
	} ) );


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );
	
					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}
	
					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}
	
					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}
	
					methodValue = instance[ options ].apply( instance, args );
	
					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI :data 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: :data Selector
	//>>group: Core
	//>>description: Selects elements which have data stored under the specified key.
	//>>docs: http://api.jqueryui.com/data-selector/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.extend( $.expr[ ":" ], {
		data: $.expr.createPseudo ?
			$.expr.createPseudo( function( dataName ) {
				return function( elem ) {
					return !!$.data( elem, dataName );
				};
			} ) :
	
			// Support: jQuery <1.8
			function( elem, i, match ) {
				return !!$.data( elem, match[ 3 ] );
			}
	} );
	} ) );


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	// $.ui.plugin is deprecated. Use $.widget() extensions instead.
	return $.ui.plugin = {
		add: function( module, option, set ) {
			var i,
				proto = $.ui[ module ].prototype;
			for ( i in set ) {
				proto.plugins[ i ] = proto.plugins[ i ] || [];
				proto.plugins[ i ].push( [ option, set[ i ] ] );
			}
		},
		call: function( instance, name, args, allowDisconnected ) {
			var i,
				set = instance.plugins[ name ];
	
			if ( !set ) {
				return;
			}
	
			if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode ||
					instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
				return;
			}
	
			for ( i = 0; i < set.length; i++ ) {
				if ( instance.options[ set[ i ][ 0 ] ] ) {
					set[ i ][ 1 ].apply( instance.element, args );
				}
			}
		}
	};
	
	} ) );


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeActiveElement = function( document ) {
		var activeElement;
	
		// Support: IE 9 only
		// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
		try {
			activeElement = document.activeElement;
		} catch ( error ) {
			activeElement = document.body;
		}
	
		// Support: IE 9 - 11 only
		// IE may return null instead of an element
		// Interestingly, this only seems to occur when NOT in an iframe
		if ( !activeElement ) {
			activeElement = document.body;
		}
	
		// Support: IE 11 only
		// IE11 returns a seemingly empty object in some cases when accessing
		// document.activeElement from an <iframe>
		if ( !activeElement.nodeName ) {
			activeElement = document.body;
		}
	
		return activeElement;
	};
	
	} ) );


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	return $.ui.safeBlur = function( element ) {
	
		// Support: IE9 - 10 only
		// If the <body> is blurred, IE will switch windows, see #9420
		if ( element && element.nodeName.toLowerCase() !== "body" ) {
			$( element ).trigger( "blur" );
		}
	};
	
	} ) );


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Scroll Parent 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: scrollParent
	//>>group: Core
	//>>description: Get the closest ancestor element that is scrollable.
	//>>docs: http://api.jqueryui.com/scrollParent/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.scrollParent = function( includeHidden ) {
		var position = this.css( "position" ),
			excludeStaticParent = position === "absolute",
			overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
			scrollParent = this.parents().filter( function() {
				var parent = $( this );
				if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
					return false;
				}
				return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
					parent.css( "overflow-x" ) );
			} ).eq( 0 );
	
		return position === "fixed" || !scrollParent.length ?
			$( this[ 0 ].ownerDocument || document ) :
			scrollParent;
	};
	
	} ) );


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* combo plugin with some of its custom styles in the node-modules dir */
	
	__webpack_require__(376);
	
	var JQR = __webpack_require__(378);
	module.exports = JQR;

/***/ },
/* 376 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 377 */,
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Resizable 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Resizable
	//>>group: Interactions
	//>>description: Enables resize functionality for any element.
	//>>docs: http://api.jqueryui.com/resizable/
	//>>demos: http://jqueryui.com/resizable/
	//>>css.structure: ../../themes/base/core.css
	//>>css.structure: ../../themes/base/resizable.css
	//>>css.theme: ../../themes/base/theme.css
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
				__webpack_require__(59),
				__webpack_require__(367),
				__webpack_require__(379),
				__webpack_require__(371),
				__webpack_require__(65),
				__webpack_require__(369)
			], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	$.widget( "ui.resizable", $.ui.mouse, {
		version: "1.12.0",
		widgetEventPrefix: "resize",
		options: {
			alsoResize: false,
			animate: false,
			animateDuration: "slow",
			animateEasing: "swing",
			aspectRatio: false,
			autoHide: false,
			classes: {
				"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"
			},
			containment: false,
			ghost: false,
			grid: false,
			handles: "e,s,se",
			helper: false,
			maxHeight: null,
			maxWidth: null,
			minHeight: 10,
			minWidth: 10,
	
			// See #7960
			zIndex: 90,
	
			// Callbacks
			resize: null,
			start: null,
			stop: null
		},
	
		_num: function( value ) {
			return parseFloat( value ) || 0;
		},
	
		_isNumber: function( value ) {
			return !isNaN( parseFloat( value ) );
		},
	
		_hasScroll: function( el, a ) {
	
			if ( $( el ).css( "overflow" ) === "hidden" ) {
				return false;
			}
	
			var scroll = ( a && a === "left" ) ? "scrollLeft" : "scrollTop",
				has = false;
	
			if ( el[ scroll ] > 0 ) {
				return true;
			}
	
			// TODO: determine which cases actually cause this to happen
			// if the element doesn't have the scroll set, see if it's possible to
			// set the scroll
			el[ scroll ] = 1;
			has = ( el[ scroll ] > 0 );
			el[ scroll ] = 0;
			return has;
		},
	
		_create: function() {
	
			var margins,
				o = this.options,
				that = this;
			this._addClass( "ui-resizable" );
	
			$.extend( this, {
				_aspectRatio: !!( o.aspectRatio ),
				aspectRatio: o.aspectRatio,
				originalElement: this.element,
				_proportionallyResizeElements: [],
				_helper: o.helper || o.ghost || o.animate ? o.helper || "ui-resizable-helper" : null
			} );
	
			// Wrap the element if it cannot hold child nodes
			if ( this.element[ 0 ].nodeName.match( /^(canvas|textarea|input|select|button|img)$/i ) ) {
	
				this.element.wrap(
					$( "<div class='ui-wrapper' style='overflow: hidden;'></div>" ).css( {
						position: this.element.css( "position" ),
						width: this.element.outerWidth(),
						height: this.element.outerHeight(),
						top: this.element.css( "top" ),
						left: this.element.css( "left" )
					} )
				);
	
				this.element = this.element.parent().data(
					"ui-resizable", this.element.resizable( "instance" )
				);
	
				this.elementIsWrapper = true;
	
				margins = {
					marginTop: this.originalElement.css( "marginTop" ),
					marginRight: this.originalElement.css( "marginRight" ),
					marginBottom: this.originalElement.css( "marginBottom" ),
					marginLeft: this.originalElement.css( "marginLeft" )
				};
	
				this.element.css( margins );
				this.originalElement.css( "margin", 0 );
	
				// support: Safari
				// Prevent Safari textarea resize
				this.originalResizeStyle = this.originalElement.css( "resize" );
				this.originalElement.css( "resize", "none" );
	
				this._proportionallyResizeElements.push( this.originalElement.css( {
					position: "static",
					zoom: 1,
					display: "block"
				} ) );
	
				// Support: IE9
				// avoid IE jump (hard set the margin)
				this.originalElement.css( margins );
	
				this._proportionallyResize();
			}
	
			this._setupHandles();
	
			if ( o.autoHide ) {
				$( this.element )
					.on( "mouseenter", function() {
						if ( o.disabled ) {
							return;
						}
						that._removeClass( "ui-resizable-autohide" );
						that._handles.show();
					} )
					.on( "mouseleave", function() {
						if ( o.disabled ) {
							return;
						}
						if ( !that.resizing ) {
							that._addClass( "ui-resizable-autohide" );
							that._handles.hide();
						}
					} );
			}
	
			this._mouseInit();
		},
	
		_destroy: function() {
	
			this._mouseDestroy();
	
			var wrapper,
				_destroy = function( exp ) {
					$( exp )
						.removeData( "resizable" )
						.removeData( "ui-resizable" )
						.off( ".resizable" )
						.find( ".ui-resizable-handle" )
							.remove();
				};
	
			// TODO: Unwrap at same DOM position
			if ( this.elementIsWrapper ) {
				_destroy( this.element );
				wrapper = this.element;
				this.originalElement.css( {
					position: wrapper.css( "position" ),
					width: wrapper.outerWidth(),
					height: wrapper.outerHeight(),
					top: wrapper.css( "top" ),
					left: wrapper.css( "left" )
				} ).insertAfter( wrapper );
				wrapper.remove();
			}
	
			this.originalElement.css( "resize", this.originalResizeStyle );
			_destroy( this.originalElement );
	
			return this;
		},
	
		_setOption: function( key, value ) {
			this._super( key, value );
	
			switch ( key ) {
			case "handles":
				this._removeHandles();
				this._setupHandles();
				break;
			default:
				break;
			}
		},
	
		_setupHandles: function() {
			var o = this.options, handle, i, n, hname, axis, that = this;
			this.handles = o.handles ||
				( !$( ".ui-resizable-handle", this.element ).length ?
					"e,s,se" : {
						n: ".ui-resizable-n",
						e: ".ui-resizable-e",
						s: ".ui-resizable-s",
						w: ".ui-resizable-w",
						se: ".ui-resizable-se",
						sw: ".ui-resizable-sw",
						ne: ".ui-resizable-ne",
						nw: ".ui-resizable-nw"
					} );
	
			this._handles = $();
			if ( this.handles.constructor === String ) {
	
				if ( this.handles === "all" ) {
					this.handles = "n,e,s,w,se,sw,ne,nw";
				}
	
				n = this.handles.split( "," );
				this.handles = {};
	
				for ( i = 0; i < n.length; i++ ) {
	
					handle = $.trim( n[ i ] );
					hname = "ui-resizable-" + handle;
					axis = $( "<div>" );
					this._addClass( axis, "ui-resizable-handle " + hname );
	
					axis.css( { zIndex: o.zIndex } );
	
					this.handles[ handle ] = ".ui-resizable-" + handle;
					this.element.append( axis );
				}
	
			}
	
			this._renderAxis = function( target ) {
	
				var i, axis, padPos, padWrapper;
	
				target = target || this.element;
	
				for ( i in this.handles ) {
	
					if ( this.handles[ i ].constructor === String ) {
						this.handles[ i ] = this.element.children( this.handles[ i ] ).first().show();
					} else if ( this.handles[ i ].jquery || this.handles[ i ].nodeType ) {
						this.handles[ i ] = $( this.handles[ i ] );
						this._on( this.handles[ i ], { "mousedown": that._mouseDown } );
					}
	
					if ( this.elementIsWrapper &&
							this.originalElement[ 0 ]
								.nodeName
								.match( /^(textarea|input|select|button)$/i ) ) {
						axis = $( this.handles[ i ], this.element );
	
						padWrapper = /sw|ne|nw|se|n|s/.test( i ) ?
							axis.outerHeight() :
							axis.outerWidth();
	
						padPos = [ "padding",
							/ne|nw|n/.test( i ) ? "Top" :
							/se|sw|s/.test( i ) ? "Bottom" :
							/^e$/.test( i ) ? "Right" : "Left" ].join( "" );
	
						target.css( padPos, padWrapper );
	
						this._proportionallyResize();
					}
	
					this._handles = this._handles.add( this.handles[ i ] );
				}
			};
	
			// TODO: make renderAxis a prototype function
			this._renderAxis( this.element );
	
			this._handles = this._handles.add( this.element.find( ".ui-resizable-handle" ) );
			this._handles.disableSelection();
	
			this._handles.on( "mouseover", function() {
				if ( !that.resizing ) {
					if ( this.className ) {
						axis = this.className.match( /ui-resizable-(se|sw|ne|nw|n|e|s|w)/i );
					}
					that.axis = axis && axis[ 1 ] ? axis[ 1 ] : "se";
				}
			} );
	
			if ( o.autoHide ) {
				this._handles.hide();
				this._addClass( "ui-resizable-autohide" );
			}
		},
	
		_removeHandles: function() {
			this._handles.remove();
		},
	
		_mouseCapture: function( event ) {
			var i, handle,
				capture = false;
	
			for ( i in this.handles ) {
				handle = $( this.handles[ i ] )[ 0 ];
				if ( handle === event.target || $.contains( handle, event.target ) ) {
					capture = true;
				}
			}
	
			return !this.options.disabled && capture;
		},
	
		_mouseStart: function( event ) {
	
			var curleft, curtop, cursor,
				o = this.options,
				el = this.element;
	
			this.resizing = true;
	
			this._renderProxy();
	
			curleft = this._num( this.helper.css( "left" ) );
			curtop = this._num( this.helper.css( "top" ) );
	
			if ( o.containment ) {
				curleft += $( o.containment ).scrollLeft() || 0;
				curtop += $( o.containment ).scrollTop() || 0;
			}
	
			this.offset = this.helper.offset();
			this.position = { left: curleft, top: curtop };
	
			this.size = this._helper ? {
					width: this.helper.width(),
					height: this.helper.height()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.originalSize = this._helper ? {
					width: el.outerWidth(),
					height: el.outerHeight()
				} : {
					width: el.width(),
					height: el.height()
				};
	
			this.sizeDiff = {
				width: el.outerWidth() - el.width(),
				height: el.outerHeight() - el.height()
			};
	
			this.originalPosition = { left: curleft, top: curtop };
			this.originalMousePosition = { left: event.pageX, top: event.pageY };
	
			this.aspectRatio = ( typeof o.aspectRatio === "number" ) ?
				o.aspectRatio :
				( ( this.originalSize.width / this.originalSize.height ) || 1 );
	
			cursor = $( ".ui-resizable-" + this.axis ).css( "cursor" );
			$( "body" ).css( "cursor", cursor === "auto" ? this.axis + "-resize" : cursor );
	
			this._addClass( "ui-resizable-resizing" );
			this._propagate( "start", event );
			return true;
		},
	
		_mouseDrag: function( event ) {
	
			var data, props,
				smp = this.originalMousePosition,
				a = this.axis,
				dx = ( event.pageX - smp.left ) || 0,
				dy = ( event.pageY - smp.top ) || 0,
				trigger = this._change[ a ];
	
			this._updatePrevProperties();
	
			if ( !trigger ) {
				return false;
			}
	
			data = trigger.apply( this, [ event, dx, dy ] );
	
			this._updateVirtualBoundaries( event.shiftKey );
			if ( this._aspectRatio || event.shiftKey ) {
				data = this._updateRatio( data, event );
			}
	
			data = this._respectSize( data, event );
	
			this._updateCache( data );
	
			this._propagate( "resize", event );
	
			props = this._applyChanges();
	
			if ( !this._helper && this._proportionallyResizeElements.length ) {
				this._proportionallyResize();
			}
	
			if ( !$.isEmptyObject( props ) ) {
				this._updatePrevProperties();
				this._trigger( "resize", event, this.ui() );
				this._applyChanges();
			}
	
			return false;
		},
	
		_mouseStop: function( event ) {
	
			this.resizing = false;
			var pr, ista, soffseth, soffsetw, s, left, top,
				o = this.options, that = this;
	
			if ( this._helper ) {
	
				pr = this._proportionallyResizeElements;
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName );
				soffseth = ista && this._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height;
				soffsetw = ista ? 0 : that.sizeDiff.width;
	
				s = {
					width: ( that.helper.width()  - soffsetw ),
					height: ( that.helper.height() - soffseth )
				};
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null;
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
				if ( !o.animate ) {
					this.element.css( $.extend( s, { top: top, left: left } ) );
				}
	
				that.helper.height( that.size.height );
				that.helper.width( that.size.width );
	
				if ( this._helper && !o.animate ) {
					this._proportionallyResize();
				}
			}
	
			$( "body" ).css( "cursor", "auto" );
	
			this._removeClass( "ui-resizable-resizing" );
	
			this._propagate( "stop", event );
	
			if ( this._helper ) {
				this.helper.remove();
			}
	
			return false;
	
		},
	
		_updatePrevProperties: function() {
			this.prevPosition = {
				top: this.position.top,
				left: this.position.left
			};
			this.prevSize = {
				width: this.size.width,
				height: this.size.height
			};
		},
	
		_applyChanges: function() {
			var props = {};
	
			if ( this.position.top !== this.prevPosition.top ) {
				props.top = this.position.top + "px";
			}
			if ( this.position.left !== this.prevPosition.left ) {
				props.left = this.position.left + "px";
			}
			if ( this.size.width !== this.prevSize.width ) {
				props.width = this.size.width + "px";
			}
			if ( this.size.height !== this.prevSize.height ) {
				props.height = this.size.height + "px";
			}
	
			this.helper.css( props );
	
			return props;
		},
	
		_updateVirtualBoundaries: function( forceAspectRatio ) {
			var pMinWidth, pMaxWidth, pMinHeight, pMaxHeight, b,
				o = this.options;
	
			b = {
				minWidth: this._isNumber( o.minWidth ) ? o.minWidth : 0,
				maxWidth: this._isNumber( o.maxWidth ) ? o.maxWidth : Infinity,
				minHeight: this._isNumber( o.minHeight ) ? o.minHeight : 0,
				maxHeight: this._isNumber( o.maxHeight ) ? o.maxHeight : Infinity
			};
	
			if ( this._aspectRatio || forceAspectRatio ) {
				pMinWidth = b.minHeight * this.aspectRatio;
				pMinHeight = b.minWidth / this.aspectRatio;
				pMaxWidth = b.maxHeight * this.aspectRatio;
				pMaxHeight = b.maxWidth / this.aspectRatio;
	
				if ( pMinWidth > b.minWidth ) {
					b.minWidth = pMinWidth;
				}
				if ( pMinHeight > b.minHeight ) {
					b.minHeight = pMinHeight;
				}
				if ( pMaxWidth < b.maxWidth ) {
					b.maxWidth = pMaxWidth;
				}
				if ( pMaxHeight < b.maxHeight ) {
					b.maxHeight = pMaxHeight;
				}
			}
			this._vBoundaries = b;
		},
	
		_updateCache: function( data ) {
			this.offset = this.helper.offset();
			if ( this._isNumber( data.left ) ) {
				this.position.left = data.left;
			}
			if ( this._isNumber( data.top ) ) {
				this.position.top = data.top;
			}
			if ( this._isNumber( data.height ) ) {
				this.size.height = data.height;
			}
			if ( this._isNumber( data.width ) ) {
				this.size.width = data.width;
			}
		},
	
		_updateRatio: function( data ) {
	
			var cpos = this.position,
				csize = this.size,
				a = this.axis;
	
			if ( this._isNumber( data.height ) ) {
				data.width = ( data.height * this.aspectRatio );
			} else if ( this._isNumber( data.width ) ) {
				data.height = ( data.width / this.aspectRatio );
			}
	
			if ( a === "sw" ) {
				data.left = cpos.left + ( csize.width - data.width );
				data.top = null;
			}
			if ( a === "nw" ) {
				data.top = cpos.top + ( csize.height - data.height );
				data.left = cpos.left + ( csize.width - data.width );
			}
	
			return data;
		},
	
		_respectSize: function( data ) {
	
			var o = this._vBoundaries,
				a = this.axis,
				ismaxw = this._isNumber( data.width ) && o.maxWidth && ( o.maxWidth < data.width ),
				ismaxh = this._isNumber( data.height ) && o.maxHeight && ( o.maxHeight < data.height ),
				isminw = this._isNumber( data.width ) && o.minWidth && ( o.minWidth > data.width ),
				isminh = this._isNumber( data.height ) && o.minHeight && ( o.minHeight > data.height ),
				dw = this.originalPosition.left + this.originalSize.width,
				dh = this.originalPosition.top + this.originalSize.height,
				cw = /sw|nw|w/.test( a ), ch = /nw|ne|n/.test( a );
			if ( isminw ) {
				data.width = o.minWidth;
			}
			if ( isminh ) {
				data.height = o.minHeight;
			}
			if ( ismaxw ) {
				data.width = o.maxWidth;
			}
			if ( ismaxh ) {
				data.height = o.maxHeight;
			}
	
			if ( isminw && cw ) {
				data.left = dw - o.minWidth;
			}
			if ( ismaxw && cw ) {
				data.left = dw - o.maxWidth;
			}
			if ( isminh && ch ) {
				data.top = dh - o.minHeight;
			}
			if ( ismaxh && ch ) {
				data.top = dh - o.maxHeight;
			}
	
			// Fixing jump error on top/left - bug #2330
			if ( !data.width && !data.height && !data.left && data.top ) {
				data.top = null;
			} else if ( !data.width && !data.height && !data.top && data.left ) {
				data.left = null;
			}
	
			return data;
		},
	
		_getPaddingPlusBorderDimensions: function( element ) {
			var i = 0,
				widths = [],
				borders = [
					element.css( "borderTopWidth" ),
					element.css( "borderRightWidth" ),
					element.css( "borderBottomWidth" ),
					element.css( "borderLeftWidth" )
				],
				paddings = [
					element.css( "paddingTop" ),
					element.css( "paddingRight" ),
					element.css( "paddingBottom" ),
					element.css( "paddingLeft" )
				];
	
			for ( ; i < 4; i++ ) {
				widths[ i ] = ( parseFloat( borders[ i ] ) || 0 );
				widths[ i ] += ( parseFloat( paddings[ i ] ) || 0 );
			}
	
			return {
				height: widths[ 0 ] + widths[ 2 ],
				width: widths[ 1 ] + widths[ 3 ]
			};
		},
	
		_proportionallyResize: function() {
	
			if ( !this._proportionallyResizeElements.length ) {
				return;
			}
	
			var prel,
				i = 0,
				element = this.helper || this.element;
	
			for ( ; i < this._proportionallyResizeElements.length; i++ ) {
	
				prel = this._proportionallyResizeElements[ i ];
	
				// TODO: Seems like a bug to cache this.outerDimensions
				// considering that we are in a loop.
				if ( !this.outerDimensions ) {
					this.outerDimensions = this._getPaddingPlusBorderDimensions( prel );
				}
	
				prel.css( {
					height: ( element.height() - this.outerDimensions.height ) || 0,
					width: ( element.width() - this.outerDimensions.width ) || 0
				} );
	
			}
	
		},
	
		_renderProxy: function() {
	
			var el = this.element, o = this.options;
			this.elementOffset = el.offset();
	
			if ( this._helper ) {
	
				this.helper = this.helper || $( "<div style='overflow:hidden;'></div>" );
	
				this._addClass( this.helper, this._helper );
				this.helper.css( {
					width: this.element.outerWidth(),
					height: this.element.outerHeight(),
					position: "absolute",
					left: this.elementOffset.left + "px",
					top: this.elementOffset.top + "px",
					zIndex: ++o.zIndex //TODO: Don't modify option
				} );
	
				this.helper
					.appendTo( "body" )
					.disableSelection();
	
			} else {
				this.helper = this.element;
			}
	
		},
	
		_change: {
			e: function( event, dx ) {
				return { width: this.originalSize.width + dx };
			},
			w: function( event, dx ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { left: sp.left + dx, width: cs.width - dx };
			},
			n: function( event, dx, dy ) {
				var cs = this.originalSize, sp = this.originalPosition;
				return { top: sp.top + dy, height: cs.height - dy };
			},
			s: function( event, dx, dy ) {
				return { height: this.originalSize.height + dy };
			},
			se: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			sw: function( event, dx, dy ) {
				return $.extend( this._change.s.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			},
			ne: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.e.apply( this, [ event, dx, dy ] ) );
			},
			nw: function( event, dx, dy ) {
				return $.extend( this._change.n.apply( this, arguments ),
					this._change.w.apply( this, [ event, dx, dy ] ) );
			}
		},
	
		_propagate: function( n, event ) {
			$.ui.plugin.call( this, n, [ event, this.ui() ] );
			( n !== "resize" && this._trigger( n, event, this.ui() ) );
		},
	
		plugins: {},
	
		ui: function() {
			return {
				originalElement: this.originalElement,
				element: this.element,
				helper: this.helper,
				position: this.position,
				size: this.size,
				originalSize: this.originalSize,
				originalPosition: this.originalPosition
			};
		}
	
	} );
	
	/*
	 * Resizable Extensions
	 */
	
	$.ui.plugin.add( "resizable", "animate", {
	
		stop: function( event ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				pr = that._proportionallyResizeElements,
				ista = pr.length && ( /textarea/i ).test( pr[ 0 ].nodeName ),
				soffseth = ista && that._hasScroll( pr[ 0 ], "left" ) ? 0 : that.sizeDiff.height,
				soffsetw = ista ? 0 : that.sizeDiff.width,
				style = {
					width: ( that.size.width - soffsetw ),
					height: ( that.size.height - soffseth )
				},
				left = ( parseFloat( that.element.css( "left" ) ) +
					( that.position.left - that.originalPosition.left ) ) || null,
				top = ( parseFloat( that.element.css( "top" ) ) +
					( that.position.top - that.originalPosition.top ) ) || null;
	
			that.element.animate(
				$.extend( style, top && left ? { top: top, left: left } : {} ), {
					duration: o.animateDuration,
					easing: o.animateEasing,
					step: function() {
	
						var data = {
							width: parseFloat( that.element.css( "width" ) ),
							height: parseFloat( that.element.css( "height" ) ),
							top: parseFloat( that.element.css( "top" ) ),
							left: parseFloat( that.element.css( "left" ) )
						};
	
						if ( pr && pr.length ) {
							$( pr[ 0 ] ).css( { width: data.width, height: data.height } );
						}
	
						// Propagating resize, and updating values for each animation step
						that._updateCache( data );
						that._propagate( "resize", event );
	
					}
				}
			);
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "containment", {
	
		start: function() {
			var element, p, co, ch, cw, width, height,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				el = that.element,
				oc = o.containment,
				ce = ( oc instanceof $ ) ?
					oc.get( 0 ) :
					( /parent/.test( oc ) ) ? el.parent().get( 0 ) : oc;
	
			if ( !ce ) {
				return;
			}
	
			that.containerElement = $( ce );
	
			if ( /document/.test( oc ) || oc === document ) {
				that.containerOffset = {
					left: 0,
					top: 0
				};
				that.containerPosition = {
					left: 0,
					top: 0
				};
	
				that.parentData = {
					element: $( document ),
					left: 0,
					top: 0,
					width: $( document ).width(),
					height: $( document ).height() || document.body.parentNode.scrollHeight
				};
			} else {
				element = $( ce );
				p = [];
				$( [ "Top", "Right", "Left", "Bottom" ] ).each( function( i, name ) {
					p[ i ] = that._num( element.css( "padding" + name ) );
				} );
	
				that.containerOffset = element.offset();
				that.containerPosition = element.position();
				that.containerSize = {
					height: ( element.innerHeight() - p[ 3 ] ),
					width: ( element.innerWidth() - p[ 1 ] )
				};
	
				co = that.containerOffset;
				ch = that.containerSize.height;
				cw = that.containerSize.width;
				width = ( that._hasScroll ( ce, "left" ) ? ce.scrollWidth : cw );
				height = ( that._hasScroll ( ce ) ? ce.scrollHeight : ch ) ;
	
				that.parentData = {
					element: ce,
					left: co.left,
					top: co.top,
					width: width,
					height: height
				};
			}
		},
	
		resize: function( event ) {
			var woset, hoset, isParent, isOffsetRelative,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cp = that.position,
				pRatio = that._aspectRatio || event.shiftKey,
				cop = {
					top: 0,
					left: 0
				},
				ce = that.containerElement,
				continueResize = true;
	
			if ( ce[ 0 ] !== document && ( /static/ ).test( ce.css( "position" ) ) ) {
				cop = co;
			}
	
			if ( cp.left < ( that._helper ? co.left : 0 ) ) {
				that.size.width = that.size.width +
					( that._helper ?
						( that.position.left - co.left ) :
						( that.position.left - cop.left ) );
	
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
				that.position.left = o.helper ? co.left : 0;
			}
	
			if ( cp.top < ( that._helper ? co.top : 0 ) ) {
				that.size.height = that.size.height +
					( that._helper ?
						( that.position.top - co.top ) :
						that.position.top );
	
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
				that.position.top = that._helper ? co.top : 0;
			}
	
			isParent = that.containerElement.get( 0 ) === that.element.parent().get( 0 );
			isOffsetRelative = /relative|absolute/.test( that.containerElement.css( "position" ) );
	
			if ( isParent && isOffsetRelative ) {
				that.offset.left = that.parentData.left + that.position.left;
				that.offset.top = that.parentData.top + that.position.top;
			} else {
				that.offset.left = that.element.offset().left;
				that.offset.top = that.element.offset().top;
			}
	
			woset = Math.abs( that.sizeDiff.width +
				( that._helper ?
					that.offset.left - cop.left :
					( that.offset.left - co.left ) ) );
	
			hoset = Math.abs( that.sizeDiff.height +
				( that._helper ?
					that.offset.top - cop.top :
					( that.offset.top - co.top ) ) );
	
			if ( woset + that.size.width >= that.parentData.width ) {
				that.size.width = that.parentData.width - woset;
				if ( pRatio ) {
					that.size.height = that.size.width / that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( hoset + that.size.height >= that.parentData.height ) {
				that.size.height = that.parentData.height - hoset;
				if ( pRatio ) {
					that.size.width = that.size.height * that.aspectRatio;
					continueResize = false;
				}
			}
	
			if ( !continueResize ) {
				that.position.left = that.prevPosition.left;
				that.position.top = that.prevPosition.top;
				that.size.width = that.prevSize.width;
				that.size.height = that.prevSize.height;
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				co = that.containerOffset,
				cop = that.containerPosition,
				ce = that.containerElement,
				helper = $( that.helper ),
				ho = helper.offset(),
				w = helper.outerWidth() - that.sizeDiff.width,
				h = helper.outerHeight() - that.sizeDiff.height;
	
			if ( that._helper && !o.animate && ( /relative/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
	
			if ( that._helper && !o.animate && ( /static/ ).test( ce.css( "position" ) ) ) {
				$( this ).css( {
					left: ho.left - cop.left - co.left,
					width: w,
					height: h
				} );
			}
		}
	} );
	
	$.ui.plugin.add( "resizable", "alsoResize", {
	
		start: function() {
			var that = $( this ).resizable( "instance" ),
				o = that.options;
	
			$( o.alsoResize ).each( function() {
				var el = $( this );
				el.data( "ui-resizable-alsoresize", {
					width: parseFloat( el.width() ), height: parseFloat( el.height() ),
					left: parseFloat( el.css( "left" ) ), top: parseFloat( el.css( "top" ) )
				} );
			} );
		},
	
		resize: function( event, ui ) {
			var that = $( this ).resizable( "instance" ),
				o = that.options,
				os = that.originalSize,
				op = that.originalPosition,
				delta = {
					height: ( that.size.height - os.height ) || 0,
					width: ( that.size.width - os.width ) || 0,
					top: ( that.position.top - op.top ) || 0,
					left: ( that.position.left - op.left ) || 0
				};
	
				$( o.alsoResize ).each( function() {
					var el = $( this ), start = $( this ).data( "ui-resizable-alsoresize" ), style = {},
						css = el.parents( ui.originalElement[ 0 ] ).length ?
								[ "width", "height" ] :
								[ "width", "height", "top", "left" ];
	
					$.each( css, function( i, prop ) {
						var sum = ( start[ prop ] || 0 ) + ( delta[ prop ] || 0 );
						if ( sum && sum >= 0 ) {
							style[ prop ] = sum || null;
						}
					} );
	
					el.css( style );
				} );
		},
	
		stop: function() {
			$( this ).removeData( "ui-resizable-alsoresize" );
		}
	} );
	
	$.ui.plugin.add( "resizable", "ghost", {
	
		start: function() {
	
			var that = $( this ).resizable( "instance" ), cs = that.size;
	
			that.ghost = that.originalElement.clone();
			that.ghost.css( {
				opacity: 0.25,
				display: "block",
				position: "relative",
				height: cs.height,
				width: cs.width,
				margin: 0,
				left: 0,
				top: 0
			} );
	
			that._addClass( that.ghost, "ui-resizable-ghost" );
	
			// DEPRECATED
			// TODO: remove after 1.12
			if ( $.uiBackCompat !== false && typeof that.options.ghost === "string" ) {
	
				// Ghost option
				that.ghost.addClass( this.options.ghost );
			}
	
			that.ghost.appendTo( that.helper );
	
		},
	
		resize: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost ) {
				that.ghost.css( {
					position: "relative",
					height: that.size.height,
					width: that.size.width
				} );
			}
		},
	
		stop: function() {
			var that = $( this ).resizable( "instance" );
			if ( that.ghost && that.helper ) {
				that.helper.get( 0 ).removeChild( that.ghost.get( 0 ) );
			}
		}
	
	} );
	
	$.ui.plugin.add( "resizable", "grid", {
	
		resize: function() {
			var outerDimensions,
				that = $( this ).resizable( "instance" ),
				o = that.options,
				cs = that.size,
				os = that.originalSize,
				op = that.originalPosition,
				a = that.axis,
				grid = typeof o.grid === "number" ? [ o.grid, o.grid ] : o.grid,
				gridX = ( grid[ 0 ] || 1 ),
				gridY = ( grid[ 1 ] || 1 ),
				ox = Math.round( ( cs.width - os.width ) / gridX ) * gridX,
				oy = Math.round( ( cs.height - os.height ) / gridY ) * gridY,
				newWidth = os.width + ox,
				newHeight = os.height + oy,
				isMaxWidth = o.maxWidth && ( o.maxWidth < newWidth ),
				isMaxHeight = o.maxHeight && ( o.maxHeight < newHeight ),
				isMinWidth = o.minWidth && ( o.minWidth > newWidth ),
				isMinHeight = o.minHeight && ( o.minHeight > newHeight );
	
			o.grid = grid;
	
			if ( isMinWidth ) {
				newWidth += gridX;
			}
			if ( isMinHeight ) {
				newHeight += gridY;
			}
			if ( isMaxWidth ) {
				newWidth -= gridX;
			}
			if ( isMaxHeight ) {
				newHeight -= gridY;
			}
	
			if ( /^(se|s|e)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
			} else if ( /^(ne)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.top = op.top - oy;
			} else if ( /^(sw)$/.test( a ) ) {
				that.size.width = newWidth;
				that.size.height = newHeight;
				that.position.left = op.left - ox;
			} else {
				if ( newHeight - gridY <= 0 || newWidth - gridX <= 0 ) {
					outerDimensions = that._getPaddingPlusBorderDimensions( this );
				}
	
				if ( newHeight - gridY > 0 ) {
					that.size.height = newHeight;
					that.position.top = op.top - oy;
				} else {
					newHeight = gridY - outerDimensions.height;
					that.size.height = newHeight;
					that.position.top = op.top + os.height - newHeight;
				}
				if ( newWidth - gridX > 0 ) {
					that.size.width = newWidth;
					that.position.left = op.left - ox;
				} else {
					newWidth = gridX - outerDimensions.width;
					that.size.width = newWidth;
					that.position.left = op.left + os.width - newWidth;
				}
			}
		}
	
	} );
	
	return $.ui.resizable;
	
	} ) );


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Disable Selection 1.12.0
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: disableSelection
	//>>group: Core
	//>>description: Disable selection of text content within the set of matched elements.
	//>>docs: http://api.jqueryui.com/disableSelection/
	
	// This file is deprecated
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(59), __webpack_require__(65) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	return $.fn.extend( {
		disableSelection: ( function() {
			var eventType = "onselectstart" in document.createElement( "div" ) ?
				"selectstart" :
				"mousedown";
	
			return function() {
				return this.on( eventType + ".ui-disableSelection", function( event ) {
					event.preventDefault();
				} );
			};
		} )(),
	
		enableSelection: function() {
			return this.off( ".ui-disableSelection" );
		}
	} );
	
	} ) );


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"text-area-shape\">\n    <div class=\"ta-shape-header\">\n        <div class=\"ta-shape-caption-wr\">\n            Enter text:\n        </div>\n        <div class=\"ta-shape-btn-panel-wr\">\n            <span class=\"ta-btn-wr ta-btn-ok\" title=\"Ok\">\n                <i class=\"icon-ok\"></i>\n            </span>\n             <span class=\"ta-btn-wr ta-btn-cancel\" title=\"Cancel\">\n                 <i class=\"icon-cancel-1\"></i>\n             </span>\n        </div>\n    </div>\n    <textarea class=\"text-area-shape-ta\"></textarea>\n</div>";
	},"useData":true});

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var HoverSignature = __webpack_require__(382),
	    HoverGraphicStamp = __webpack_require__(384),
	    HoverTextStamp = __webpack_require__(386);
	
	
	module.exports = function( note, paper, channel ) {
	
	    var HoverShapeConstructor;
	
	    if ( note.isSignature() )
	    {
	        HoverShapeConstructor = HoverSignature;
	    }
	    else if ( note.isGraphicStamp() ) {
	        HoverShapeConstructor = HoverGraphicStamp;
	    }
	    else if ( note.isTextStamp() )
	    {
	        HoverShapeConstructor = HoverTextStamp;
	    }
	
	
	    // Note: was using this.lastMousePosition (set on mousemove) instead of 0 for x,y
	    // ( if it persisted ) to persist position between canvas re-renders but have since removed logic,
	    // as it wasn't important and had it's own problems.
	    var baseOptions = {
	        note: note,
	        paper: paper,
	        channel: channel,
	        originalScale: channel.request('currentScaleValue')
	    };
	
	    return new HoverShapeConstructor( baseOptions );
	
	
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Wrapper around Raphael text path used as el of the Signature View
	 * (created on fontChange and when user chooses to create new note )
	 */
	
	var HoverShapeView = __webpack_require__(383),
	    CreateSignatureEl = __webpack_require__(230),
	    defaultAttrs = __webpack_require__(216).prototype.defaults;
	
	
	module.exports = HoverShapeView.extend({
	
	    initialize: function( options ) {
	
	        HoverShapeView.prototype.initialize.apply( this, arguments );
	
	        this.listenTo( this.channel, 'hoverSignature:consultGroupChange', this.changeFill );
	
	        this.originalBBoxHeight = 0;
	
	        this.scale = this.originalScale;
	
	    },
	
	    createEl: function( ) {
	
	        return CreateSignatureEl(
	            this.paper,
	            this.ox,
	            this.oy,
	            this.note.get('creationUserDesc'),
	            defaultAttrs.activeFont,
	            parseFloat( defaultAttrs.baseFontSize ),
	            this.channel.request( 'getColorToApplyToShape', this.note )
	        );
	
	    },
	
	    render: function() {
	
	        HoverShapeView.prototype.render.apply( this, arguments );
	
	        this.originalBBoxHeight = this.el.getBBox().height;
	
	        return this;
	
	    },
	
	    /**
	     * Previously: always at 0,0 and was transformed with the mouse position.
	     * Changed to reflect that mouse position could move in between canvas 're-renders',
	     * so now we take the original position into account to derive dx, dy.
	     * Note: have since removed attempt to reposition on re-render but left the above logic
	     * here in case there's a need to revisit, and b/c logic will still work.
	     *
	     */
	    onMouseMove: function( x, y ) {
	
	        var yOffset =
	            ( this.originalBBoxHeight * ( this.scale ) ) ;
	
	        var dx = x - this.ox;
	        var dy = y - this.oy;
	
	        var t = 'T' + dx + ',' +  ( dy + yOffset );
	
	        this.el.transform( t );
	
	    },
	
	    scale: function( scale, lastScale ) {
	
	        this.scale = scale;
	        this.el.scalePathWithCurves.apply( this.el, arguments );
	    },
	
	    deriveShapeFromClone: function() {
	
	        this.el.bakeTransform();
	        return HoverShapeView.prototype.deriveShapeFromClone.apply( this, arguments );
	
	    },
	
	    changeFill: function( color ) {
	        this.el.attr('fill', color);
	    }
	
	
	});
	
	


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var RaphaelView = __webpack_require__(187);
	
	/**
	 * Base 'hover' shape utilized for stamps and signature notes.
	 */
	
	
	module.exports = RaphaelView.extend({
	
	    hoverOpacity: 0.5,
	    placedOpacity: 1,
	
	    initialize: function(options) {
	
	        this.options = options;
	
	        this.ox = 0;
	        this.oy = 0;
	
	        this.note = options.note; // can now use this to listen to events
	        this.paper = options.paper;
	        this.channel = options.channel;
	        this.originalScale = options.originalScale;
	
	        this.listenTo( this.channel, 'hoverShape:scale', this.scale );
	        this.listenTo( this, 'hoverShape:mouseMove', this.onMouseMove );
	        this.listenTo( this, 'hoverShape:mouseEnterCanvas', this.show );
	        this.listenTo( this, 'hoverShape:mouseExitCanvas', this.hide );
	
	    },
	
	    render: function() {
	
	        this.el = this.createEl()
	            .attr({
	                opacity: this.getHoverOpacity()
	            })
	            .hide()
	            .toFront();  // Ensure seen above other shapes
	
	        return this;
	
	    },
	
	    createEl: $.noop,
	
	    scale: $.noop,
	
	    onMouseMove: $.noop,
	
	    show: function() {
	        this.el.show();
	    },
	
	    hide: function() {
	        this.el.hide();
	    },
	
	
	    deriveShapeFromClone: function() {
	        return this.el
	            .clone()
	            .attr( 'opacity', this.getPlacedOpacity() );
	    },
	
	    getHoverOpacity: function() {
	        return this.hoverOpacity;
	    },
	    getPlacedOpacity: function() {
	        return this.placedOpacity;
	    },
	
	    onBeforeDestroy: function() {
	        this.stopListening();
	        this.el.remove();
	    }
	
	
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	var HoverShapeView = __webpack_require__(383),
	    GraphicStampModel = __webpack_require__(301),
	    CreateImgEl = __webpack_require__(385);
	
	
	module.exports = HoverShapeView.extend({
	
	    placedOpacity: GraphicStampModel.prototype.placedOpacity,
	    hoverOpacity: GraphicStampModel.prototype.hoverOpacity,
	
	    initialize: function( options ) {
	
	        HoverShapeView.prototype.initialize.apply( this, arguments );
	
	        this.stamp = this.note.uiModel.get('selectedStamp');
	
	        this.width = this.stamp.getWidth();
	        this.height = this.stamp.getHeight();
	
	    },
	
	    createEl: function() {
	
	        return CreateImgEl(
	            this.paper,
	            this.stamp.getImgSrc(),
	            this.ox,
	            this.oy,
	            this.width * this.originalScale,
	            this.height * this.originalScale
	        );
	
	    },
	
	    onMouseMove: function( x,y ) {
	
	        this.el.attr({
	            x: x,
	            y: y
	        });
	
	    },
	
	    /**
	     * Note: for now don't need to worry about moving with scaling, as the user can only change the
	     * scale with the mouse clicking buttons, menu items, or dragging a panel.  When doing this, the
	     * mouse is no longer above the canvas so the element will not be visible.  When it returns it will
	     * be in the correct position.
	     */
	    scale: function( scale ) {
	
	        this.el.attr({
	            width: this.width * scale,
	            height: this.height * scale
	        });
	
	    },
	
	
	    onBeforeDestroy: function() {
	        this.stopListening();
	        this.el.remove();
	    }
	
	});
	
	
	


/***/ },
/* 385 */
/***/ function(module, exports) {

	/** Now really just wrapping Raphael.image */
	
	module.exports = function( paper, src, x, y, width, height ) {
	
	    return paper.image( src, x, y, width, height );
	
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var HoverShape = __webpack_require__(383),
	    ShapeUtils = __webpack_require__(197),
	    ShapeTransformedModel = __webpack_require__(256);
	
	
	/**
	 * Now printing a 'not ready indicator' -- there will just be nothing.
	 * TODO:
	 * - have it's own event on the noteModel for all of them for consult group change now*
	 */
	
	var HoverTextStamp = HoverShape.extend({
	
	    initialize: function( options ) {
	
	        HoverShape.prototype.initialize.apply( this, arguments );
	
	        // ( there is no shape yet created with current design so we need to create an instance )
	        this.shapeTransformModel = new ShapeTransformedModel( ).initializePageValues( this.channel.request('getPage'), this.originalScale );
	
	        this.listenTo( this.channel, 'hoverShape:scale', this.updateScale ); // TODO: better org: scale from mixin is the scale fn name from base ( get rid of mixin ??? -- need to outline )
	
	        var uiModel = this.note.uiModel;
	
	        this.listenTo( uiModel, 'change:selectedStamp', this.update );
	        this.listenTo( uiModel, 'change:inputsValid',   this.update );
	
	        this.listenTo( uiModel, 'change:generatedText', this.update );
	        this.listenTo( uiModel, 'change:fontSize',      this.update );
	        this.listenTo( uiModel, 'change:font',          this.update );
	
	        // could be less efficent, but probably won't occur-- eg break up into change size or note like shapeView ( need to outline )
	        this.listenTo( uiModel, 'change:textColor',     this.update );
	        this.listenTo( uiModel, 'change:textOpacity',   this.update );
	        // if ready ... can also, change the text on set text ...
	
	        /* Cache pgCenterRotatedAtScaleOf1 for Move Transforms */
	
	        var pgRotation = this.shapeTransformModel.getPageModel().getRotation();
	        var pgCenter = this.shapeTransformModel.getPageModel().getCenter();
	
	        // Store on model if have other instances
	        this.pgCenterRotatedAtScaleOf1 = ShapeUtils.getPtsWithoutTransformApplied( [ pgCenter  ] , 1.0, pgRotation, pgCenter )[0];
	
	        // Could also encapsulate this on model
	        this.shapeTransformModel.setRotation( pgRotation % 360 * -1 );
	
	        uiModel.set( 'rotationAtZeroPageRotation', this.shapeTransformModel.getRotation() ); // ( for passing to the shapeView )
	
	    },
	
	    /* ( text set in update attributes ) */
	    createEl: function( ) {
	
	        var el = this.paper.text( this.ox, this.oy, '' ).attr({
	            'text-anchor': 'start', // ( horizontal )
	            stroke: 'none' // stroke width may be set via other Raphael attrs changes
	        });
	        this._updateAttributes( this.note.uiModel, el );
	
	        // Transform only takes page model into account now;
	        // this.el doesn't yet exist -- so use calc'd transform to call directly on the element with that value
	        // not this.el which is done on this object
	        this.shapeTransformModel.getPageModel().updateTransform( el.transform.bind(el) );
	
	        return el;
	
	    },
	
	
	    /**
	     * inputsValid: for now not printing a warning just show the preview
	     */
	    _getTextToPrint: function( inputsValid )  {
	        //return inputsValid ? this.note.uiModel.getGeneratedText(): this.note.uiModel.getGeneratedText();
	        return this.note.uiModel.getGeneratedText();
	
	    },
	
	    /**
	     * x, y are client coordinates
	     * rPt: the point at original page rotation of 0, scale 1
	     */
	    onMouseMove: function( x, y ) {
	
	        var shapeTransModel = this.shapeTransformModel,
	            shapePgTransModel = shapeTransModel.getPageModel();
	
	        // Could encapsulate on model ...
	        var rPt = ShapeUtils.getPtsWithoutTransformApplied( [{ x: x , y: y }] , shapePgTransModel.getScale(), shapePgTransModel.getRotation(),  this.pgCenterRotatedAtScaleOf1  )[0];
	        shapeTransModel.setDx( rPt.x );
	        shapeTransModel.setDy( rPt.y );
	
	        this.transform();
	
	    },
	
	    
	    update: function() {
	        this._updateAttributes();
	        this.transform( );
	
	    },
	
	    /* Also updates this.obox */
	    _updateAttributes: function ( noteUiModel, el ) {
	
	        noteUiModel = noteUiModel || this.note.uiModel;
	        el = el || this.el;
	
	        el.attr({
	            text: this._getTextToPrint( noteUiModel.getInputsValid() ),
	            'font-size': noteUiModel.getFontSize(),
	            'font-family': noteUiModel.getFont(),
	            fill: noteUiModel.getColorToApply(),
	            opacity: noteUiModel.getTextOpacity()
	        });
	
	        this.shapeTransformModel.setOBox( el.getBBox(1) );
	
	    },
	
	    updateScale: function( scale ) {
	
	        var shPgTransformModel = this.shapeTransformModel.getPageModel();
	        shPgTransformModel.setScale( scale ); // could the update the transform there
	        shPgTransformModel.updateTransform(); // could have set scale update the transform
	        this.transform();
	
	    },
	
	    transform: function( t ) {
	
	        var trans = '';
	
	        if ( t ) {
	            trans += t;
	        }
	
	        var shapeTransModel = this.shapeTransformModel;
	        var r = shapeTransModel.getRotation();
	
	        trans += shapeTransModel.getPageModel().getTransform();
	
	        trans += 't' + shapeTransModel.getDx()  + ',' + shapeTransModel.getDy(); // move transform
	
	        if ( r !== 0 ) {
	            trans += 'r' + r  + ',' + this.ox + ',' +  this.oy;
	        }
	
	        // Y-Char Offset
	        trans += 't0,' + shapeTransModel.getOBox().height / 2 ; // could also be on model ...
	
	        this.el.transform( trans );
	
	
	    },
	
	    /**
	     * OR: called on render -- this shape has opacity and use that
	     * I don't think we'd want this to have 0 opacity so maybe don't reflect the hovershape ?
	     * could have flag to bypass this in the base class -- so it is not overruled
	     */
	    getHoverOpacity: function() {
	
	        return this.note.uiModel.getTextOpacity();
	    },
	    /* OR: called on clone -- this shape has opacity and use that */
	    getPlacedOpacity: function() {
	
	        return this.note.uiModel.getTextOpacity();
	    },
	
	    deriveShapeFromClone: function() {
	
	        var el = HoverShape.prototype.deriveShapeFromClone.apply( this, arguments );
	
	        el.attr({
	            transform: '',
	            x: this.shapeTransformModel.getDx(),
	            y: this.shapeTransformModel.getDy()
	        });
	
	        return el;
	
	    }
	
	
	});
	
	
	
	module.exports = HoverTextStamp;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Raphael = __webpack_require__(182),
	    Shape = __webpack_require__(254),
	     _ = __webpack_require__(49);
	
	__webpack_require__(388);
	
	module.exports = Backbone.Collection.extend({
	
	    model: Shape,
	
	    /* get data */
	    getShapesOfNote: function(note) {
	        return this.filter(function(s) {
	            return s.isChildOfNote(note) ;
	        });
	    },
	
	    getShapeUIModelsOfNote: function(note) { /* (the child ui models */
	
	        return this.chain()
	            .filter(function(s) { return s.isChildOfNote(note); })
	            .map( function(s) { return s.uiModel; })
	            .value();
	
	    },
	
	    getAllShapeUIModels: function() {
	        return this.map(function(s) {
	            return s.uiModel;
	        });
	    },
	
	    // Returns all shapes on canvas other than those of the given note.
	    // noteTypeFilter filter is optional.
	    getAllShapesButNote: function(note, noteTypeFilter) {
	
	        var shapes = this.filter(function(s) {
	            return !s.isChildOfNote(note);
	        });
	
	        noteTypeFilter && (shapes = _.filter(shapes, function(s) {
	            return s.getParentNote().get('noteType') === noteTypeFilter;
	        }));
	
	        return shapes;
	    },
	    /*
	    * Get the SVG of the note -- unadjusted for scaling and rotation ('denormalized').
	    * ( the active note, adjusted for current scale )
	    * TODO: branch from single fn, put on view / model, out of model ...
	    * TODO: s/b able to get the full page model from the note
	    * */
	    _getNoteShapesSVG: function(note, scale, pageModel) {
	
	        var shapes = this.getShapesOfNote(note);
	        if (shapes.length < 1)
	            return '';
	
	        // get Raphael from paper to feed plugin (Raphael.fn.toSVG)
	        // don't want to feed the entire paper (eg this.shapes (not just this note), subshapes) -- could have a filter in the fork instead
	
	        var shapeSet = [], // shapes[0].uiModel.getRaphaelElPaper().set(), no longer a set ... can take a group ... or Raphael el
	            pg = pageModel,
	            pgIsCold = pg.isCold(),
	            rotation = pg.get('rotation') % 360,
	
	            origDimsWithScaleApplied = pgIsCold ? null : pg.originalDimensions(scale),
	            //center pt of the original dimensions scaled and rotated
	            originalCenterPtWithScaleAndRotationApplied = pgIsCold ? null : pg.getOriginalCenterPtRotated(scale);
	
	
	        /* plugin wants to export an entire paper obj -- changed for set ... */
	        _.each( shapes, function(s) {
	
	            var normalizedShapeEl =
	                s.getNormalizedElToPerist(scale, rotation, origDimsWithScaleApplied, originalCenterPtWithScaleAndRotationApplied);
	
	            //note: can return multi (eg for signature array of 2 rEls )
	
	            if ( !(normalizedShapeEl instanceof Array) ) {
	
	                shapeSet.push(normalizedShapeEl);
	
	            } else {
	
	                _.each( normalizedShapeEl, function(s) {
	                    shapeSet.push(s);
	                });
	            }
	
	        });
	
	        /*
	        *  Maybe want to just call off the paper, not Raphael fn
	        * ... perhaps issue with clones has something to do with this ...
	        * ... and then no need to remove ... ???
	        * DVBC-1592 - provide the original, non rotated dimensions of the paper.
	        * DVBC-1594 - hack: temp transform until refactor w, h to be width, height.
	        * */
	        var originalPgDimensions = pg.originalDimensions();
	
	        var pageDimensions = pgIsCold
	            ?  { width: '100%',  height: '100%' } // previously in plugin was deriving from paper.width, paper.height, which was 100%
	            :  { width: originalPgDimensions.w + 'px', height: originalPgDimensions.h + 'px' };
	
	        var svg = Raphael.fn.toSVG( shapeSet, pageDimensions );
	
	        // Uncomment for debug without escaped markup ( it is escaped however in the plugin )
	        //console.log( svg );
	
	        // now remove the clones (they are put on the paper) ... TODO: don't need to have clone ...
	
	        shapeSet.forEach( function(s) {
	            s.remove && s.remove();
	        } );
	
	        shapeSet = null;
	
	        return svg;
	
	    },
	
	    /*
	    * Export for save.
	    * TODO: an override for each type
	    * */
	    getShapeAttributesOfNote: function(note) {
	
	        var shapeAttrsToPersist = this._getNoteShapesAttrsToPersist.apply(this, arguments);
	
	        if ( note.isSVGGraphicNote() || note.isSignature() || note.isTextStamp() ) { // TODO: better XREF, eg : 'SVG'
	            
	            return {text: shapeAttrsToPersist};
	
	        } else if ( note.isGraphicStamp() ) {
	
	            // pageNote properties already on the object: x, y, width, height (there's only ever one shape)
	            return shapeAttrsToPersist;
	
	        } else {
	            
	            // the original coordinate shapes
	            return {shapes: shapeAttrsToPersist };
	        }
	
	    },
	    /*
	    * These should be on the note -- but on the canvas: the shapes on the canvas of the note
	    * */
	    _getNoteShapesAttrsToPersist: function(note, scale, page) {
	
	        if ( note.isTextStamp() ) {
	
	            var shapeOfNotes = this.getShapesOfNote(note);
	            /**
	             * Prevent error here in current WF is stamp is not placed when cancel changes ( if user changed to stamp that wasn't ready ) -- cancel modify
	             * Better answer is not allow WF to get to this point unless a stamp has been placed
	             * ( Though this is good to prevent errors anyway )
	             */
	            if ( shapeOfNotes.length < 1 )
	                return '';
	
	            /* There can only be one */
	            return shapeOfNotes[0].getNormalizedElToPerist();
	
	        }
	        else if ( note.isSVGGraphicNote() || note.isSignature() ) { //TODO: a better XREF, eg : 'SVG'
	
	            return this._getNoteShapesSVG.apply(this, arguments);
	
	        }  else if ( note.isGraphicStamp() ) {
	
	            // only one shape can exist for this note type
	            var shapesOfNote = this.getShapesOfNote(note);
	
	            // return empty array to handle case where the note is new and no shape has been created
	            // this will then fail the 'no shapes' validation in the save note workflow
	            if ( shapesOfNote.length < 1 )
	                return [];
	
	            return shapesOfNote[0].getAttrsToPersist(scale);
	        }
	
	        else {
	            /*
	            * The 'original' coordinate notes.
	            * Here called at the shape level.
	            * */
	            return _.map( this.getShapesOfNote(note) , function(s) {
	                return s.getAttrsToPersist(scale);
	            });
	        }
	
	    }
	
	});

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Raphael) {/**
	 *
	 * Fork Of Below -- In addition to taking paper can also take a set of Raphael Elements
	 *	-- 7/6/2015: Optional parameter absolutePaperDimensions -- if provided
	 *		will use it's height and width properties (opposed to that derived from the set, which could be relative) to use as the exports height and width attributes
	 *		(numeric values converted to strings with pixels)
	 * -- 7/10/2015: Optional parameter to not include html style tag on svg element; Default is No
	 * -- 12/14/2021: Update some text element code from latest version on Github (3/8/2018)
	 * -- 2/21/2022 -- Changes implemented with Text Stamps ( library is obsolete )
	 * 	- take an array of elements, no longer a set with the assumption of a paper
	 * 	- ability to handle export of text with multiple lines
	 *
	 * Raphael.Export https://github.com/ElbertF/Raphael.Export
	 *
	 * Licensed under the MIT license:
	 * http://www.opensource.org/licenses/mit-license.php
	 *
	 */
	
	(function(R) {
		/**
		* Escapes string for XML interpolation
		* @param value string or number value to escape
		* @returns string escaped
		*/
		function escapeXML(s) {
			if ( typeof s === 'number' ) return s.toString();
	
			var replace = { '<': 'lt', '>': 'gt', '"': 'quot', '\'': 'apos' };
	
			for ( var entity in replace ) {
				s = s.replace(new RegExp(entity, 'g'), '&' + replace[entity] + ';');
			}
	
			return s;
		}
	
		/**
		* Generic map function
		* @param iterable the array or object to be mapped
		* @param callback the callback function(element, key)
		* @returns array
		*/
		function map(iterable, callback) {
			var mapped = [],
				undef = 'undefined',
				i;
	
			// use an index iteration if we're dealing with an array
			if( typeof iterable.unshift != 'undefined'){
				var l = iterable.length;
				for ( i = 0; i < l; i++ ) {
					if( typeof iterable[i] != undef ){
						var value = callback.call(this, iterable[i], i);
						if( value !== null ) mapped.push(value);
					}
				}
			} else {
				for ( i in iterable ) {
					if ( iterable.hasOwnProperty(i) ) {
						var value = callback.call(this, iterable[i], i);
						if ( value !== null ) mapped.push(value);
					}
				}
			}
	
			return mapped;
		}
	
		/**
		* Generic reduce function
		* @param iterable array or object to be reduced
		* @param callback the callback function(initial, element, i)
		* @param initial the initial value
		* @return the reduced value
		*/
		function reduce(iterable, callback, initial) {
			for ( var i in iterable ) {
				if ( iterable.hasOwnProperty(i) ) {
					initial = callback.call(this, initial, iterable[i], i);
				}
			}
	
			return initial;
		}
	
		/**
		* Utility method for creating a tag
		* @param name the tag name, e.g., 'text'
		* @param attrs the attribute string, e.g., name1="val1" name2="val2"
		* or attribute map, e.g., { name1 : 'val1', name2 : 'val2' }
		* @param content the content string inside the tag
		* @returns string of the tag
		*/
		function tag(name, attrs, matrix, content) {
			if ( typeof content === 'undefined' || content === null ) {
				content = '';
			}
	
			if ( typeof attrs === 'object' ) {
				attrs = map(attrs, function(element, name) {
					switch ( name ) {
						case 'transform':
							return;
	
						case 'fill':
							if ( element.match(/^hsb/) ) {
								var hsb = element.replace(/^hsb\(|\)$/g, '').split(',');
	
								if ( hsb.length === 3 ) {
									element = R.hsb2rgb(hsb[0], hsb[1], hsb[2]).toString();
								}
							}
					}
	
					return name + '="' + escapeXML(element) + '"';
				}).join(' ');
			}
	
			return '<' + name + ( matrix ? ' transform="matrix(' + matrix.toString().replace(/^matrix\(|\)$/g, '') + ')" ' : ' ' ) + attrs + '>' +  content + '</' + name + '>';
		}
	
		/**
		* @return object the style object
		*/
		function extractStyle(node) {
			return {
				font: {
					family: typeof node.attrs.font === 'undefined' ? null : node.attrs.font.replace(/^.?"(\w+)".$/, '$1'),
					size:   typeof node.attrs['font-size'] === 'undefined' ? null : parseInt( node.attrs['font-size'] ),
					style: typeof node.attrs['font-style'] === 'undefined' ? null : node.attrs['font-style'],
					weight: typeof node.attrs['font-weight'] === 'undefined' ? null : node.attrs['font-weight']
				},
				anchor: typeof node.attrs['text-anchor'] === 'undefined' ? null : node.attrs['text-anchor']
			};
		}
	
		/**
		* @param style object from style()
		* @return string
		*/
		function styleToString(style) {
			// TODO figure out what is 'normal'
			// Tyler: it refers to the default inherited from CSS. Order of terms here:
			// 		  http://www.w3.org/TR/SVG/text.html#FontProperty
			var norm = 'normal',
				textAnchor = 'text-anchor: ' + ( style.anchor || 'middle' ) + '; ',
				font = style.font;
			// return 'font: normal normal normal 10px/normal ' + style.font.family + ( style.font.size === null ? '' : '; font-size: ' + style.font.size + 'px' );
			return textAnchor + [ 'font:',
					(font.style || norm), // font-style (e.g. italic)
					norm, // font-variant
					(font.weight || norm), // font-weight (e.g. bold)
					(font.size ? font.size + 'px' : '10px') + '/normal', // font-size/IGNORED line-height!
					font.family ].join(' ');
		}
	
		/**
		 * repairs the hex color which missed the '#'
		 * @param any string
		 * @return hexvalue of rgb
		 */
		function convertToHexColor(value) {
	
			if(/^[0-9A-F]{6}$/i.test(value)){
				value = '#' + value;
			}
	
			return value;
		}
	
		/**
		* Computes tspan dy using font size. This formula was empircally determined
		* using a best-fit line. Works well in both VML and SVG browsers.
		* @param fontSize number
		* @return number
		*/
		function computeTSpanDy(fontSize, line, lines) {
			if ( fontSize === null ) fontSize = 10;
	
			//return fontSize * 4.5 / 13
			return fontSize * 4.5 / 13 * ( line - .2 - lines / 2 ) * 3.5;
		}
	
		var serializer = {
			'text': function(node) {
	
	            //
				//var style = extractStyle(node),
				//	tags = new Array,
				//	textLines = node.attrs['text'].toString().split('\n'),
				//	totalLines = textLines.length;
	            //
	            //
				//map(textLines, function(text, line) {
	            //
				//	var attrs = reduce(
				//		node.attrs,
				//		function(initial, value, name) {
				//			if ( name !== 'text' && name !== 'w' && name !== 'h' ) {
				//				if ( name === 'font-size') value = parseInt(value) + 'px';
				//				if( name === 'stroke'){
				//					value = convertToHexColor(value);
				//				}
	            //
				//				initial[name] = escapeXML(value.toString());
				//			}
				//			return initial;
				//		},
				//		{ style: styleToString(style) + ';' }
				//	);
	            //
	            //
				//	/**
				//	 * if text node has a class set, apply it to the attrs object
				//	 */
				//	if (node.node.className.baseVal != "" && node.node.className.baseVal !== undefined) {
				//		attrs["class"] = node.node.className.baseVal;
				//	}
	            //
				//	tags.push(tag(
				//		'text',
				//		attrs,
				//		node.matrix,
				//		tag('tspan', { dy: computeTSpanDy(style.font.size, line + 1, totalLines) }, null, text.replace(/&/g, "&amp;"))
				//	));
				//});
	            //
				//
				//return tags;
	
	
				// TODO: we may want to ensure consistent between browsers -- if not, generate
	
				var tSpans = Array.prototype.slice.call( node.node.childNodes );
	
				var tSpanContent = tSpans.map( function( tspan ) {
					return tag( 'tspan', { dy: tspan.getAttribute('dy') }, null, tspan.innerHTML ); //  text.replace(/&/g, "&amp;"
				}).join('');
	
	
				var textTag = tag('text', node.attrs, node.matrix, tSpanContent  );
	
	
				return [textTag]; // rather than just 'node.node.outerHTML' --> gives more control and will also apply custom data attributes
	
				//return [node.node.outerHTML]; // may need to put line breaks back in the text -- we may want ?
	
			},
			'path' : function(node) {
	
				var initial = ( node.matrix.a === 1 && node.matrix.d === 1 ) ? {} : { 'transform' : node.matrix.toString() };
	
				return tag(
					'path',
					reduce(
						node.attrs,
						function(initial, value, name) {
							if ( name === 'path' ) name = 'd';
	
							initial[name] = value.toString();
	
							return initial;
						},
						{}
					),
					node.matrix
					);
			}
	
	
			// Other serializers should go here
		};
	
	
		R.fn.toSVG = function( elements , absolutePaperDimensions, includeSVGStyleTag ) {
	
			var paperWidth =  absolutePaperDimensions.width,
				paperHeight =  absolutePaperDimensions.height,
				restore = { svg: R.svg, vml: R.vml },
				svg     = '<svg ' + (includeSVGStyleTag ? 'style="overflow: hidden; position: relative;" ' : '') +
					'xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + paperWidth + '" version="1.1" height="' + paperHeight + '">';
	
			R.svg = true;
			R.vml = false;
	
			for ( var n = 0; n < elements.length; n ++) {
	
				var node = elements[n];
	
				if ( node.node.style.display === 'none' ) continue;
	
				var attrs = '';
	
				// Use serializer
				if ( typeof serializer[node.type] === 'function' ) {
					svg += serializer[node.type](node);
	
					continue;
				}
	
				switch ( node.type ) {
					case 'image':
						attrs += ' preserveAspectRatio="none"';
						break;
				}
	
				for ( i in node.attrs ) {
					var name = i;
	
					switch ( i ) {
						case 'src':
							name = 'xlink:href';
	
							break;
						case 'transform':
							name = '';
	
							break;
					}
	
					if ( name ) {
						attrs += ' ' + name + '="' + escapeXML(node.attrs[i].toString()) + '"';
					}
				}
	
				svg += '<' + node.type + ' transform="matrix(' + node.matrix.toString().replace(/^matrix\(|\)$/g, '') + ')"' + attrs + '></' + node.type + '>';
			}
	
			svg += '</svg>';
	
			R.svg = restore.svg;
			R.vml = restore.vml;
	
			return svg;
		};
	})(__webpack_provided_window_dot_Raphael);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, $) {(function($) {
	
	    /* this is a 'render request' */
	    $.fn.creRequest = function(options) {
	
	        /* DEFAULTS */
	        var settings,
	            creXHR = { //really anything for exports
	                settings: {}, // ... i don't thing used anymore
	                rid: null, //defined if first successful
	                //$currentPollReqXHR
	                // cancelRenderReq: $.fn.creRequest.cancel
	            },
	            s = settings = {
	                POLL_FREQ: 250,
	                CRE_ROOT: 'http://localhost:8080/docview/viewer/',
	                renderRequest: {
	                    renderingParameters: {
	                        containerType: 'raw', // , 'PDF', 'ZIP'  -- THIS IS THE FINAL OUTPUT TYPE FOR ALL 'PAGES'
	                        pageType: 'raw',//, // raw, pdf, jpg, gif, png --> the format the image is output as : eg you could convert from the original
	                        imageParameters: {
	                            fixWidth: null,  //if NULL ignored --> DOT PER DOT  --
	                            hdpi: null,          //i don't need
	                            vdpi: null
	                        },
	                        pdfParameters: null, //(only want if pdf)
	                        pageStamps: null
	                    },
	                    slices: [], //no defaults -- todo: check if passed in on validation ...
	                    destinations: {  /* what you want to do with the file */
	                        allowDownload: true  //allows the browser to download
	                    }
	                },
	                fileName: 'file.pdf', //required for inline/download -- this is just the default -- optional for image
	                completeCookie: null //(optional)
	            },
	            $vent = $({}),
	            reqestCancelled = false, //flag
	            $dfdPolling, //promise resolved / rejected when polling complete -- also abort on user cancel
	            $currentPollReqXHR, //want global to abort
	            stateRef = {
	              'UNKNOWN': '',
	              'AWAITING_EXECUTION': 'Waiting...',
	              'EXECUTING_GATHERING_INFO': 'Gathering Info...',
	              'EXECUTING_RENDERING': 'Rendering...',
	              'EXECUTING_PACKAGING': 'Packaging...',
	              'COMPLETE': 'Complete',
	              'CANCELED_USER': 'User Cancelled',
	              'CANCELED_ERROR': 'Error',
	              'CANCELED_QUEUE_TIMEOUT': 'Request Timed Out',
	              'CANCELED_ORPHAN': 'Request No Longer Available'
	            };
	
	        function validateOptions(options) {
	            //TODO: required params
	            //TODO: validate if jpg can only be 1 page in the pages array -- param validation
	            options.CRE_ROOT = urlEndSlash(options.CRE_ROOT);
	        }
	
	        function sumbitRequest(renderRequest) {
	
	            renderingRequest(renderRequest).done( function(renderStatus) {  //TODO: create a post render fn
	
	
	                var rid = renderStatus.requestId;
	                creXHR.rid = rid;
	
	                $dfdPolling = new $.Deferred();
	
	                $vent.on('cre.cancelRenderRequest', function(e, options) {
	                    reqestCancelled = true;   //cancel the polling -- and flag to not enter succes
	                    
	                    $dfdPolling.resolve();
	                    $currentPollReqXHR.abort(); //end the current status req
	                    
	                    cancelRenderReq(rid, options);
	                } );
	
	                // poll for completion
	                $currentPollReqXHR = checkingRenderState(rid, $dfdPolling);
	                creXHR.$currentPollReqXHR = $currentPollReqXHR; //put on there ... TODO: just use the obj
	
	                $dfdPolling.done( function(renderStatus) { //note: stateDesc already added
	                    
	                    if (reqestCancelled) {
	                        cleanUp();
	                        return false;
	                    }
	
	                    var rid = renderStatus.requestId; //rid could be undefined if request cancelled
	                    s.onComplete && s.onComplete({
	                        renderStatus: renderStatus,
	                        imgUrl: getBaseUrl(rid, s.fileName),
	                        inlineUrl: downloadUrl(rid , true, s.fileName, s.completeCookie),
	                        downloadUrl: downloadUrl(rid , false, s.fileName, s.completeCookie)
	                    });
	
	                    cleanUp();
	
	                }).fail(function(renderStatus) { //any of the cancels or unknown -- IF USER CANCELLED, WILL BE jqXHR OR renderStatus
	                    
	                    if (reqestCancelled || $currentPollReqXHR.status === 0) return;  //don't handle error if user cancel -- its handled separately --
	                    handlerErr('render', renderStatus);
	
	                });
	
	            }).fail(function(jqXHR) {
	                  handlerErr('network', jqXHR);
	            });
	        }
	
	        function renderingRequest(renderReq) {
	            return $.ajax({
	                url: s.CRE_ROOT + 'rest/v2/api/cre',
	                type: 'POST',
	                contentType: 'application/json', ///json necessary for express.js
	                data: JSON.stringify(renderReq)
	            }).promise();
	        }
	
	        function checkingRenderState(requestId, $dfdDone) {
	
	            var checkStateTimer;
	
	            return $.ajax({
	                url: s.CRE_ROOT + 'rest/v2/api/cre/' + requestId + '/status',
	                type: 'GET'
	            }).done( function(renderStatus) { //this should be in diff fn -- loop check render state
	
	                var state = renderStatus.state;
	                renderStatus['stateDesc'] = stateRef[state]; //add a friendly desc to the resp for use in oncheckstate
	                s.onCheckState && s.onCheckState(renderStatus);
	
	                //user cancelled trapped by plugin (don't catch here)
	                if ( (state.indexOf('CANCEL') > -1 || state === 'UNKNOWN') && state !=='CANCELED_USER') {
	                    clearTimeout(checkStateTimer);
	                    $dfdDone.reject(renderStatus);
	                } else if (state === 'COMPLETE') {
	                    // TODO: MAY NEED QUEUE IN CASE MULTI GOING ON AT SAME TIME AND THEY OVERLAP EACHOTHER
	                    clearTimeout(checkStateTimer);
	                    // $currentPollReqXHR.abort(); //prevent any called in between poll freq?
	                    $dfdDone.resolve(renderStatus);
	                } else if (state !=='CANCELED_USER') {  //poll -- still disallow cancelled user
	
	                    checkStateTimer = setTimeout( function () {
	                        reqestCancelled
	                            ? clearTimeout(checkStateTimer)
	                            : $currentPollReqXHR = checkingRenderState(renderStatus.requestId, $dfdDone); //recursion
	                    }, s.POLL_FREQ );
	
	                }
	
	            }).fail(function(jqXHR) {  //regular failure
	                clearTimeout(checkStateTimer);
	                $dfdDone.reject(jqXHR);  //(this can pick up user cancelled / aborted)
	            }); //return the xhr to abort on cancel
	        }
	
	        function cancelRenderReq(rid, options) {
	            return $.ajax({
	                url: s.CRE_ROOT + 'rest/v2/api/cre/' + rid,
	                type: 'DELETE'
	            }).done( function(renderStatus) {
	
	                settings.onCancel && settings.onCancel(renderStatus, options);
	
	            }).fail(function(jqXHR, options) {
	                settings.onCancelError && settings.onCancelError('Error Cancelling Render Request: ' + jqXHR.status + ' ' + jqXHR.statusText + ' -- ' + jqXHR.responseText, options);
	            });
	        }
	
	        /* normalize error callbacks render, network, userCancel err */
	        /* type is 'render' --> renderStatus object, or 'network' --> */
	        function handlerErr(errType, errObj) {
	            var fnErr = s.onError;
	            if (fnErr) {
	                switch(errType) {
	                    case 'render':
	                        fnErr(errObj.text); //(renderStatus)
	                        break;
	                    case 'network':
	                        fnErr(errObj.status + ' ' + errObj.statusText + ' -- ' + errObj.responseText); //(jqXHR)
	                        break;
	                }
	            }
	            cleanUp();
	        }
	
	        function getBaseUrl(rid, filename) {
	
	            var u = s.CRE_ROOT + 'rest/v2/api/cre/' + rid + '/download/';
	
	            if (filename)
	                u += encodeURIComponent(filename);
	
	            return u;
	        }
	
	        /* inline or download */
	        function downloadUrl(rid, isInline, filename, completeCookie) {
	
	            var u = getBaseUrl(rid, filename) + '?inline=' +  String(isInline);
	            if (completeCookie)
	                u += '&cookieName=' + encodeURIComponent(completeCookie);
	
	            return u;
	        }
	
	        function cleanUp() {
	            $vent.off('cre.cancelRenderRequest');
	        }
	
	        /* Expose Public fn on namespace to cancel;
	          * param: distinguish between user cancel and force cancel (options.forceCancel -- eg session timeout)
	        */
	
	        /* TODO: NEED A QUEUE -- EG: THESE FNS WILL ONLY EXIST IF A REQUEST HAS BEEN MADE -- WANT AN OPTION TO CANCEL ALL */
	        /* or -- return a ref for each --- */
	
	        //todo: now call from cancelRenderReq and remove these
	
	        $.fn.creRequest.cancel = function(options) {
	            $vent.trigger('cre.cancelRenderRequest', options );
	        };
	
	         creXHR.cancel = $.fn.creRequest.cancel;
	
	
	        $.fn.creRequest.pollInterval = function() {
	            return s.POLL_FREQ;
	        };
	
	        function init(options) {
	            validateOptions(options);
	            $.extend(true, s, options);
	            creXHR.settings = s.renderRequest;
	            s.onStart && s.onStart();
	            sumbitRequest(s.renderRequest);
	        }
	
	        init(options);
	
	        return creXHR; //this is jquery -- jq returns a jqxhr
	
	    };
	
	    /* Helpers */
	    function urlEndSlash(url) {
	        var lastChar = url.charAt(url.length-1);
	        url = (lastChar !== '/') ? url  + '/' : url;
	        return url;
	    }
	
	
	})(jQuery);
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = $.fn.creRequest;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(59)))

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<!DOCTYPE html>\n\n<html>\n<head>\n    <meta charset=\"utf-8\">\n    <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n    <title>Document Viewer</title>\n    <meta name=\"viewport\" content=\"width=device-width\">\n    <script src=\""
	    + container.escapeExpression(((helper = (helper = helpers.js || (depth0 != null ? depth0.js : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"js","hash":{},"data":data}) : helper)))
	    + "\" charset=\"UTF-8\"></script>\n</head>\n\n<body>\n    <script>\n        FV.docViewer( "
	    + ((stack1 = ((helper = (helper = helpers.docRequest || (depth0 != null ? depth0.docRequest : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docRequest","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + ", "
	    + ((stack1 = ((helper = (helper = helpers.instanceOptions || (depth0 != null ? depth0.instanceOptions : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"instanceOptions","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + ", "
	    + ((stack1 = ((helper = (helper = helpers.fvOptions || (depth0 != null ? depth0.fvOptions : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fvOptions","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + " );\n    </script>\n\n</body>\n\n</html>";
	},"useData":true});

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var fvChannel = __webpack_require__(72).channel('FV'),
	    Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    Document = __webpack_require__(392),
	    Moment = __webpack_require__(69),
	    $ = __webpack_require__(59);
	
	module.exports = Backbone.Collection.extend({
	    model: Document,
	    url: function() {
	        return fvChannel.request('apiUrl').docInfo;
	    },
	    fetch: function(options) {
	
	        // TODO: this should be moved to init
	
	        this.docReq = options.docReq; // (slices and vOptions)
	
	        this.docSlices = _.map( this.docReq, function(d) {
	            return _.omit(d, 'vOptions');
	        });
	
	        this.vOptions = _.map( this.docReq, function(d) {
	            return d.vOptions;
	        });
	
	        return Backbone.Collection.prototype.fetch.call( this, _.extend( {}, options, {
	            type: 'POST',
	            data: JSON.stringify( this.docSlices )
	        }));
	
	    },
	
	    /**
	     * Hacked in here from current viewer reset workflow to
	     * reflect that page rotation values may diverge from the database on load if the user lacks
	     * rotate-save permission.
	     * Notes that pages may have changed depending on the type of reset.
	     * Loop through the prior documents and update any new ones,
	     * rather than vice-versa; in case we can add/remove from the document collection
	     */
	    updatePageRotationsPostViewerReset: function( priorDocumentCollection ) {
	
	        priorDocumentCollection.each( function( priorDocument ) {
	
	            var document = this.findWhere({ docId: priorDocument.get('docId') });
	
	            if (document) {
	
	                var priorPageCollection = priorDocument.pageCollection;
	
	                document.pageCollection.each( function(page) {
	
	                    var pageId = page.get('pageId'),
	                        correspondingPage = priorPageCollection.findWhere({ pageId: pageId });
	
	                    if ( correspondingPage ) {
	
	                        var correspondingPageRotation = correspondingPage.get('rotation');
	
	                        page.setRotation( correspondingPageRotation ); // Don't need to check if same / not -- can overwrite
	
	                        // also do the thumbnail -- it must exist
	                        document.thumbCollection
	                            .findWhere({ pageId: pageId  })
	                            .setRotation( correspondingPageRotation );
	                    }
	
	                });
	
	            }
	
	        }, this);
	
	    },
	
	    /*
	     * CRE Request for the 'PDF Combo' Functionality.
	     * All docs with renderable pages requested (see 'allowPDFCombo' comment); not necessarily just the Active Document.
	     * Requested in the order provided (not the active document first).
	     */
	    pdfRenderRequest: function() {
	
	        var docsWithRenderablePgs = this.getDocumentsWithRenderablePgs();
	
	        /*
	         * Extra validation check (should already be blocked in the UI).
	         * Note: this will stiff barf on URL page types ... (STILL?)
	         */
	        if (docsWithRenderablePgs.length < 1)
	            return;
	
	        return {
	            renderRequest: {
	
	                slices: _.map( docsWithRenderablePgs, function(d) {
	                    return d.getDocSliceForRenderRequest();
	                }),
	                renderingParameters: {
	                    containerType: 'pdf',
	                    pageType: 'pdf'
	                },
	                destinations: {
	                    allowDownload: true
	                }
	            }
	
	        };
	
	    },
	    pdfFileName: function() {
	        return 'FDD-Multi-Doc-PDF-' + Moment().format() + '.pdf';
	        //fvChannel.request('settings').DATE_FMT_STR -- don't want '/" in file name --> will result in error ( TODO ... friendlier name )
	    },
	
	    getDocumentsWithRenderablePgs: function() {
	
	        return this.filter( function( doc ) {
	            return doc.hasRenderablePgs();
	        });
	    },
	     /*
	     *  Allow the operation if there's more than one document and at least 1 document has renderable pages.
	     *  When invoked only documents that have renderable pages are requested -- this prevents the CRE from bombing on
	     *  requests with documents that have multi-part-GOS-pages (at least as a stop gap until the CRE
	     *  recognizes that page type as unrenderable and ignores them as it does with other unrenderable page types).
	     *  TODOs / notes --
	     *  - May want to combo this concept with PDF renderable pages -- unsure if URL page types are supposed to be rendered by the CRE ...
	     *  - Multi-part-GOS-pages -- I'm assuming requesting a PDF is not an issue for this page types b/c the document
	     *    containing it is now assumed to have only have 1 page of this type.  In this case, an unrenderable view will be shown
	     *    in PDF mode.
	     *  - This 'renderable' logic should all should be be cleaned up / made consistent when get time and learn how CRE treats URL pages types
	     *      -- eg do something similar when making PDF requests for a document to only include pages that are renderable
	     * */
	    allowPDFCombo: function() {
	        return this.length > 1 && this.getDocumentsWithRenderablePgs().length > 0;
	    }
	
	});

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/* Really a 'Doc-Slice */
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49),
	    Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    Util = __webpack_require__(48),
	    DocContainerFactory = __webpack_require__(393),
	    NotesCollection = __webpack_require__(271),
	    DocNotes = __webpack_require__(397),
	    PgNotes = __webpack_require__(270),
	    Pages = __webpack_require__(398),
	    ThumbNails = __webpack_require__(399),
	    Indexes = __webpack_require__(401),
	    FullTextModel = __webpack_require__(403), /* TODO: separate from document -- should be a setting and then put in the fulltext module*/
	    ViewerSettings = __webpack_require__(99), //maybe just take the fn needed
	    DocumentLockStatus = __webpack_require__(405),
	    DocumentTextModel = __webpack_require__(406),
	    ContextualPermissionsModel = __webpack_require__(410);
	
	
	__webpack_require__(411); // May want to put this in FV.bootstrap under a 'polyfills' section (though woudn't work for testing this specifically)
	
	
	var instanceProps = {
	
	    pageCollection: {}, // note: the document mode pages
	    thumbCollection: {},
	
	    documentTextModel: null,
	
	    allNotes: {},
	    pgNotes: {},
	    docNotes: {},
	
	    docContainer: null,
	
	    permissions: null,
	
	    indexCollection: null, // server side treated as on the container -- but storing on the object; only set if they exist
	    fullTextModel: null, /* will be created if settings has fullTextQuery in settings */
	    docSlice: null, /* this is the container requested */
	    vOptions: null
	
	};
	
	
	module.exports = Backbone.Model.extend({
	
	    constructor: function(attrs, options) {
	
	        _.extend(this, instanceProps);
	        this.options = options;
	        Backbone.Model.prototype.constructor.apply(this, arguments);
	
	    },
	    defaults: function() {
	        return {
	            docNumber: null, // now not used but set b/c could be handy -- now storing base 1 -- maybe superflous if stays in order -- can get from collection index; it's in the order requested
	            openToPageNumber: 1,
	            docHasNoPages: false, // flag that no pages in doc -- used to disable lots of things; noPages view replaces other view modes
	            docHasNoRenderablePgs: false, //flag: true if no pages renderable -- pdf mode doesn't launch pdf viewer -- lists the pages; other modes show as unrenderable
	            //TODO: could also disable thumbs, doc pgs, and single pg mode (like in no pages)
	            docHasSomeUnrenderablePgs: false, // for pdf mode header download dd -- indicates that some, but not all pages are unrenderable
	            shouldLoadPDF: true
	        };
	    },
	    parse: function(resp, options) {
	
	        var pages = resp.pages,
	            imgFileType = options.imageFileType;
	
	        // resp.container will be null if user doesn't have necessary permissions, BUT:
	        // this should never occur (so now not checking); if the user has perm to view the doc, they have can view info about the container
	        // with virtual fcs, the user should have access to the virtual but not the base fc
	        // if issue, could get container types and ids from the doc request now stored here (or have server send it regardless)
	        this.docContainer = new DocContainerFactory( resp.container );
	
	        this.permissions = new ContextualPermissionsModel( resp.permissions );
	
	        var pgOpts = {
	            parse: true,
	            parentDocument: this,
	            imageFileType: imgFileType
	        };
	
	        // Allow for pages to reference their parent document ( collection.parentDocument )
	        // TODO: docModeImageWidthFn
	        // - pass from the channel requests ( fn from channel / store elsewhere ); perhaps derivable from pg attributes
	        // - we may be able to remove now -- don't take consideration of the container width into account for derived doc mode width
	        this.pageCollection = new Pages( pages, _.extend( pgOpts, {
	            docModeImageWidthFn: options.docModeImageWidthFn
	        }));
	
	
	
	        if ( this.hasPagesWithPositionalData() ) {
	
	            this.documentTextModel = new DocumentTextModel().create( this );
	
	        }
	
	        /**
	         * DVBC-1823 - always create the thumbnails collection even if we don't include the thumbnails module ( eg if thumbs are disabled ).
	         * We could stop doing this but processing time is negligible and removing this entirely is error prone.
	         */
	        this.thumbCollection = new ThumbNails( pages, pgOpts );
	
	        this.docNotes = new DocNotes( resp.documentNotes, {
	            parse: true,
	            allowFlashNotes: options.allowFlashNotes,
	            document: this // used for the url of the document note model, collection
	        } );
	
	        // Page Notes must come after the pageCollection is set, it's now referenced on parse of the pageNote model
	        this.pgNotes = new PgNotes( options.includePageNotes ? resp.pageNotes : [], {
	            parse: true,
	            document: this,
	            pageCollection: this.pageCollection // now necessary to parse page notes
	        });
	
	        // Set the index collection if there are fields ( terminology interchangable with indexes currently ).
	        // Doing even if option to not include indexes is set -- this won't affect anything, plus will need index values to derive file names.
	        if ( this.docContainer.hasFields() )
	            this.indexCollection = new Indexes( this.docContainer.getFields() );
	
	
	        /* -- old sync finish start -- */
	
	        if ( this.hasPages() && this.pgNotes.length > 0 ) {
	
	            this.pgNotes.setPageNumbers( this.pageCollection );
	
	            // Also store collection of pageNotes for each page on the pageObject.
	            // TODO: this has proven problematic -- change it to get one source of truth.
	            this.pageCollection.each( function(p) {
	
	                var notesOfPage = this.pgNotes.getNotesOfPage(p);
	
	                p.setNoteCollection( notesOfPage );
	
	                /**
	                 * Also set on the corresponding thumbnail.
	                 * Now only utilized for note info (reason codes) in page info dialog but could later prove beneficial.
	                 * May be more elegant way of sharing the references across page and thumbnail models.
	                 */
	                this.thumbCollection.findWhere( {number: p.get('number')} ).setNoteCollection( notesOfPage ) ;
	
	            }, this);
	
	        }
	
	        this.allNotes = new NotesCollection( this.pgNotes.models.concat( this.docNotes.models ), {
	            document: this
	        });
	
	        /* -- old sync finish end -- */
	
	
	        /* Note: isRenderable set on init of the pages */
	        //determine whether the document has any renderable pages & set flag (or some, for PDF mode)
	
	        var hasNoPgs = pages.length < 1,
	            hasNoRenderablePgs = this.pageCollection.noRenderablePagesExist(),
	            hasSomeRenderablePgs = this.pageCollection.someRenderablePagesExist(),
	            hasNoPDFRenderablePgs = this.pageCollection.noPDFRenderablePagesExist(),
	            hasSomePDFRenderablePgs = this.pageCollection.somePDFRenderablePgsExist();
	
	        return _.extend( resp, {
	            docHasNoPages: hasNoPgs,   // flag & evt trigger to indicator no pages in doc -- used to disable lots of things
	            // setting to true will create the 'Doc has no pages view' over the center content
	            //not sure if still need these, those that defined what's used in pdf mode now driven by combo with url page (below)
	            docHasNoRenderablePgs: hasNoRenderablePgs,  // flag: set to true if no pages are renderable -- if so: PDF mode is disabled
	            docHasSomeUnrenderablePgs: hasSomeRenderablePgs,
	            docHasNoPDFRenderablePgs: hasNoPDFRenderablePgs,
	            docHasSomePDFRenderablePgs: hasSomePDFRenderablePgs,
	            shouldLoadPDF: !hasNoPgs && !hasNoPDFRenderablePgs /* flag to determine whether to trigger loading of pdf from outside its view */
	        });
	
	    },
	    /*
	    * Set properties that can't be done in parse because they require the index of the model in the collection.
	    * Must be called immediately post a successful doc info fetch.
	    * Simpler than override documents.fetch to return the original jqXHR post changing the model attrs.
	    * Better solution would be to send the number in the server response.
	    * */
	    setPropertiesPostParse: function(options) {
	
	        var docIndex = this.collection.indexOf( this.collection.get(this) );
	
	        this.docSlice = this.collection.docSlices[docIndex];
	        this.vOptions = this.collection.vOptions[docIndex];
	
	        this.set({
	            docNumber: docIndex, //could be superflous
	            openToPageNumber: this._determinePgNumToOpenTo(options.viewerLevelOpenToPageNumber)
	        }, {silent: true});
	
	    },
	    _determinePgNumToOpenTo: function(viewerLevelOpenToPageNumber) {
	
	        var lastPageNumber = Math.max.apply( null, this.pageCollection.pluck('number') ); //could cache this
	
	        //if defined and not valid, it was set to the default
	        var vOptionPgNumber = this.vOptions && this.vOptions.openToPageNumber
	            ? ViewerSettings.prototype.getValidatedOpenToPageNumber(this.vOptions.openToPageNumber) //could argue that if invalid and the instance var is set, use that
	            : undefined;
	
	        var userProvidedPgToOpenTo = vOptionPgNumber
	            ? vOptionPgNumber
	            : viewerLevelOpenToPageNumber;  //viewerLevelOpenToPageNumber is already validated (less knowing number of pages in the document)
	
	        //Validation to be performed after we know the # of pages in the doc
	        (userProvidedPgToOpenTo === 'last') && (userProvidedPgToOpenTo = lastPageNumber);
	
	        var pgNumToOpenTo = userProvidedPgToOpenTo > lastPageNumber
	            ? lastPageNumber
	            : userProvidedPgToOpenTo;
	
	        return pgNumToOpenTo;
	
	    },
	    getPageToOpenTo: function(options) {
	        
	        var pgNumToOpen = options && options.pgNumberToOpenTo
	            ? getValidatedPgNumToOpen.call(this, options.pgNumberToOpenTo)
	            : this.get('openToPageNumber');
	
	        return this.pageCollection.findWhere({number: pgNumToOpen});
	
	        function getValidatedPgNumToOpen(pgNumberToOpenTo) {
	
	            //shouldn't happen, only called if has pages in workflow
	            if ( this.get('docHasNoPages') )
	                return 0;
	
	            var lastPgNum = Math.max.apply(null, this.pageCollection.pluck('number'));
	
	            /* if the prior active page number > than number of pages, go to the last page */
	            if ( pgNumberToOpenTo > lastPgNum )
	                return lastPgNum;
	
	            /* the prior active page # exists, go to it */
	            return pgNumberToOpenTo;
	        }
	
	    },
	
	    /**
	     * Called post successful docInfo fetch.
	     * This used to contain a number webservice calls utilizing the async queue library.
	     * Those have now all been combined in the docInfo object and logic from here has been
	     * moved to parse of this model.
	     * Sole remaining is the full-text query, which we may want to get rid of now that we have
	     * implemented a text layer.
	     */
	    fetchData: function(options, cbCxt) {
	
	        var self = this;
	        cbCxt = cbCxt ? cbCxt : this;
	
	        return $.Deferred(function($dfd) {
	
	            /**
	             * WF for FT 2, forced in here for now ....
	             * (Allow for empty string values: default is null -- is never undefined in viewer settings)
	             */
	            if ( typeof options.fullTextQuery === 'string' ) {
	
	                /**
	                 * Allow to set later, always created (otherwise errMsg will be incorrect ).
	                 * Also current wf runs query when FV.fullTextModel (which here is always), which calls the query -- so need something set
	                 */
	                var ftm = self.fullTextModel = new FullTextModel([], {
	                    searchText: options.fullTextQuery,
	                    docId: self.get('docId'),
	                    fetchUrl: fvChannel.request('esURL')
	                });
	
	                ftm.fetch().always( function() {
	                    $dfd.resolveWith(cbCxt);
	                });
	
	
	            } else {
	                $dfd.resolveWith(cbCxt);
	            }
	
	
	        }).promise();
	
	    },
	
	    hasPages: function() {
	        return this.pageCollection && this.pageCollection.length > 0;
	    },
	
	    hasNotes: function() {
	        return this.allNotes && this.allNotes.length > 0;
	    },
	
	    hasIndexes: function() {
	        return this.indexCollection && this.indexCollection.length > 0;
	    },
	    /*
	    *  Return the derived 'name' of the document.
	    *  If fileExtension provided, add it to the end.
	    *  If forDownload is provided, ensure the file name is properly url and 'file-system' escaped.
	    *  Note: page-less document downloads are blocked in the UI.
	    * */
	    documentName: function(fileExtension, forDownload) {
	
	        var name = this._getNameWithoutFileExtension(fileExtension);
	
	        if (fileExtension)
	             name += '.' + fileExtension;
	
	        if (forDownload) {
	            // Note: Url Escaping
	            // - file names with download URLs going to the CRE are already url sanitized in the jQuery CRE plugin.
	            // - file names not set with requests for big gos files (and these are set through the page request)
	            name = Util.sanitizeFileNameForFileSystem(name);
	        }
	
	        return name;
	
	    },
	    /*
	    * Return the derived document name without an extension.
	    * Exception for special case:
	    * return the file extension for documents whose first page is GOS when fileExtensionRequested is not defined.
	    * */
	    _getNameWithoutFileExtension: function(fileExtensionRequested) {
	
	        // If document has pages and the first page is GOS and gosInfo.fileName is set), return gosInfo.fileName.
	        // Applies to documents in File Cabinet and Bin containers
	        var pgs = this.pageCollection,
	            firstPgGosFileName = (pgs.length > 0) && pgs.at(0).gosInfoFileName();
	
	        if ( firstPgGosFileName )
	            return fileExtensionRequested
	                ? Util.stripFileExtension( firstPgGosFileName )
	                : firstPgGosFileName;
	
	       return this.getNonGosNameWithoutExtension();
	
	    },
	    /*
	    * Used in getting document and page names for non-GOS page types.
	    * */
	    getNonGosNameWithoutExtension: function() {
	
	        var docContainer = this.docContainer.getType(),
	            name;
	
	        if (docContainer === 'FILECABINET') {
	
	            var indexes = this.indexCollection;
	
	            if ( indexes && indexes.length > 0 ) {
	
	                var firstIndexValue = indexes.firstIndexValue(1);
	
	                if (firstIndexValue && firstIndexValue.length > 0)
	                    name = firstIndexValue;
	            }
	
	        }
	        else if (docContainer === 'BIN') {
	
	            // docName is really doc_info.title (the 'batch' title) -- I have no idea why it was named that way on the server
	            name = this.get('docName');
	
	        }
	
	        // If either is not defined, return the doc_id;
	        return name
	            ? name
	            : this.getId();
	
	    },
	
	    docRenderRequest: function(contType, pgType) {
	
	        var defaultRequestForThisDoc = {
	                renderRequest: {
	                    renderingParameters: {
	                        containerType: contType,
	                        pageType: pgType // could implement default image fmt -- for now jpg
	                    },
	                    slices: [ this.getDocSliceForRenderRequest() ],
	                    destinations: {
	                        allowDownload: true
	                    }
	                }
	            };
	
	
	        return defaultRequestForThisDoc;
	
	    },
	
	    // could now map to getSlice() ...
	    getDocSliceForRenderRequest: function() {
	
	        var INCLUDE_NOTES = 1; // TESTING
	        if (true) {
	            INCLUDE_NOTES = 0;
	        }
	
	
	        return {
	            documentAddress: this.docAddress(),
	            perPageFddImageParameters: getPerPageImageParameters.call(this),
	            pageNotesByType: INCLUDE_NOTES
	                ? ['REDACTION_NOTE', 'GRAPHIC_NOTE', 'HIGHLIGHT_NOTE', 'GRAPHIC_STAMP', 'INITIALS', 'SIGNATURE',
	                'SVG_SIGNATURE', 'SVG_GRAPHIC_NOTE', 'STRIKE_THROUGH', 'FLOATING_REDACTION_NOTE', 'FULL_PAGE_REDACTION', 'GRAPHIC_TEXT_STAMP' ]
	                : []
	        };
	
	
	        /**
	         * Now always request pages without rotation because users may not have save rotation permission.
	         * Always ask un-rotated and then rotate by the page rotation value, which is set on load and when the
	         * pages are rotated.
	         * Potentially only add this if the user lacks rotation permission?
	         */
	        function getPerPageImageParameters() {
	
	            var perPageImageParams = {};
	
	            this.pageCollection.forEach( function(p) {
	
	                perPageImageParams[ p.get('pageId') ] = {
	                    disableFddRotation: true,
	                    rotation: p.get('rotation')
	                };
	
	            });
	
	            return perPageImageParams;
	
	        }
	
	    },
	
	    getFileExtension: function(isPDF) {
	        var ext;
	        if (this.pageCollection.length > 1) { //if multi-page
	            ext = isPDF ? 'pdf' : 'zip';
	        } else {
	            // for 1 pg use the file extension, not zip (pdf always pdf)
	            // latter getting from the first page, ( request container is for 'raw' for a 'download', not zip -- so CRE returns one page )
	            ext = isPDF ? 'pdf' : this.pageCollection.at(0).getFileNameExtension();
	        }
	        return ext;
	    },
	
	
	    docIndexes: function() {
	        return this.indexCollection;
	    },
	    getId: function() {
	        return this.get('docId');
	    },
	    // container related:
	    //TODO: handle if no in there (and for others)... maybe on server always fill in type and id -- don't need perm for this ...
	    // aimee says shouldn't be the case that can view the doc but not the container info -- test on virtual
	    docAddress: function() {
	        return {
	            containerType: this.docContainer.getType(),
	            containerId: this.docContainer.getId(),
	            documentId: this.getId()
	        };
	    },
	    getDocContainer: function() {
	        return this.docContainer;
	    },
	    getContainerType: function() {
	        return this.docContainer.getType();
	    },
	    friendlyContainerType: function() {
	        return this.docContainer.getFriendlyTitle();
	    },
	    getContainerId: function() {
	        return this.docContainer.getId();
	    },
	    getContainerIcon: function() {
	        return this.docContainer.getIcon();
	    },
	    containerTitle: function() {
	        return this.docContainer.getTitle();
	    },
	    getDocSlice: function() {
	        return this.docSlice;
	    },
	
	    //TODO: combo ... --------------
	    docHasSomeUnrenderablePgs: function() { //TODO: use this instead of call on the pages
	        return this.get('docHasSomeUnrenderablePgs');
	    },
	    docHasNoRenderablePgs: function() {
	        return this.get('docHasNoRenderablePgs');
	    },
	    docHasNoPDFRenderablePgs: function() {
	        return this.get('docHasNoPDFRenderablePgs');
	    },
	    docHasSomePDFRenderablePgs: function() {
	        return this.get('docHasSomePDFRenderablePgs');
	    },
	    //-------------
	    shouldLoadPDF: function() {
	      return this.get('shouldLoadPDF');
	    },
	    hasRenderablePgs: function() {
	        return this.hasPages() && !this.docHasNoRenderablePgs();
	    },
	    resetLoadStateOfAllPgs: function() {
	        this.pageCollection.invoke('resetLoadState');
	        this.thumbCollection.invoke('resetLoadState');
	
	    },
	
	    deletePages: function(aPages, cxt) {
	        // could double-check if the pages are deletable on the model function (if pass that in);
	        // now just using the UI to prevent which should suffice
	        var url = fvChannel.request('apiUrl').deletePages(this);
	
	        return $.Deferred(function($dfd) {
	            /* note: stringify'd body required for express to read req body */
	            $.ajax({
	                url: url,
	                type: 'DELETE',
	                context: cxt ? cxt : this,
	                //array of object consisting seq, pageId
	                data: JSON.stringify(_.map( aPages, function(p) {
	                    return {
	                        seq: p.get('seq'), //sequence all that's really needed for the operation
	                        pageId: p.get('pageId'), //not needed but can't hurt -- now used to identify pages that failed
	                        pageNumber: p.get('number') //may want to start using in success/error messages instead of pageId
	                    };
	                }))
	            }).done( function( data ) {
	                // data returned is array of obj with pageId, seq, errorMessage
	                // parse the data and just return obj for help displaying as success/error message (or combo)
	                /* [ {"pageId": 1149131, "errorMessage": null }]*/
	
	                $dfd.resolveWith( this, [{
	                    successfulPages: _.filter( data, function(d) {
	                        return d.errorMessage === null;
	                    }),
	                    errorPages: _.filter( data, function(d) {
	                        return d.errorMessage !== null;
	                    })
	                }] );
	
	            }).fail( function(jqXHR) {
	                //Note: this would be entire failure, we are making a batch request and individual errors will be reported in successful respp
	                $dfd.rejectWith( this, [jqXHR] );
	            } );
	
	        }).promise();
	    },
	
	    addPages: function( fileList, insertAtPgNum ) {
	
	        var url = fvChannel.request('apiUrl').addPages( this, insertAtPgNum ),
	            formData = new FormData();  //Note: FormData only works IE10+, given OK for this !!!
	
	        _.each( fileList, function(f) {
	            formData.append( 'files', f );
	        });
	
	        return $.Deferred(function($dfd) {
	            $.ajax({
	                url: url,
	                type: 'POST',
	                contentType: false, // // Set content type to false as jQuery will tell the server its a query string request ( really: 'multipart/form-data' )
	                processData: false, // Important!: don't process the files
	                data: formData
	            }).done( function( pages ) {
	                $dfd.resolve( pages );
	            }).fail( function(jqXHR) {
	                $dfd.reject( jqXHR );
	            } );
	        }).promise();
	
	    },
	
	    reorderPages: function(pgsToMove, destinationPg, insertAfter) {
	
	        var pgs = this.pageCollection,
	            self = this;
	
	        return $.Deferred(function($dfd) {
	            $.ajax({
	                url: fvChannel.request('apiUrl').reorderPages( self ),
	                type: 'PUT',
	                data: JSON.stringify( {
	                    pages: _.map( pgsToMove, function(p) {
	                        var pg = pgs.findWhere( {number: p });
	                        return {
	                            seq: pg.get('seq'),
	                            pageId: pg.get('pageId'),
	                            pageNumber: pg.get('number')
	                        };
	                    }),
	                    destSeq:  pgs.findWhere({ number: destinationPg }).get('seq'),
	                    after: insertAfter
	                } )
	            }).done( function( data ) {
	                $dfd.resolve( data );
	            }).fail( function(jqXHR) {
	                $dfd.reject( jqXHR );
	            } );
	
	        }).promise();
	
	    },
	    /*
	     * Check Document Lock Status.
	     * Wrap successful resp to return DocumentLockStatus model.
	     * */
	    checkLockStatus: function(context) {
	
	        var cxt = context || this,
	            url = fvChannel.request('apiUrl').lockStatus( this );
	
	        return $.Deferred(function($dfd) {
	
	            $.ajax({
	                url: url,
	                type: 'GET',
	                context: cxt
	            }).done( function( resp ) {
	                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
	            } ).fail( function( jqXHR ) {
	                $dfd.rejectWith( cxt, [jqXHR ] );
	            });
	
	        }).promise();
	
	    },
	    /*
	     * Attempt to lock the document.
	     * Wrap successful resp to return DocumentLockStatus model.
	     * */
	    lock: function(context) {
	
	        var cxt = context || this,
	            url = fvChannel.request('apiUrl').lockDocument( this );
	
	        return $.Deferred(function($dfd) {
	
	            $.ajax({
	                url: url,
	                type: 'POST',
	                context: cxt
	            }).done( function( resp ) {
	                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
	            } ).fail( function( jqXHR ) {
	                $dfd.rejectWith( cxt, [jqXHR ] );
	            });
	
	        }).promise();
	
	    },
	    /*
	    * Attempt to unlock the document.
	    * Wrap successful resp to return DocumentLockStatus model.
	    * Force: optional -- if provided & true, unlock regardless of the user who currently holds the lock;
	    * if false, will only succeed if the user is the one who currently holds the lock.
	    * Synchronous: perform a synchronous request; useful if call on window unload. -- may rid if use sendBeacon polyfil
	    * Note: if sync employed, jqXHR methods are deprecated in favor of success/error/complete callbacks.
	    * */
	    unlock: function( force, context, synchronous ) {
	
	        var cxt = context || this,
	            url = fvChannel.request('apiUrl').unlockDocument( this, force ),
	            async = synchronous ? false : true; //
	
	        return $.Deferred(function($dfd) {
	
	            $.ajax({
	                url: url,
	                type: 'POST',
	                context: cxt,
	                async: async
	            }).done( function( resp ) {
	                $dfd.resolveWith( cxt, [ new DocumentLockStatus(resp) ] );
	            } ).fail( function( jqXHR ) {
	                $dfd.rejectWith( cxt, [jqXHR ] );
	            });
	
	        }).promise();
	
	    },
	    /*
	    * Unlock with the navigator.sendBeacon API (or polyfill that falls back to a sync ajax post -- IE).
	    * Note: send empty string (even though it's not necessary) to avoid run time error in the polyfill
	    * that occurs in IE9 when checking the data argument for a Blob type  ( the check routine
	    * exits before if a string is passed).
	    * If sendBeacon fails for any reason, fallback with already written ajax unlock call with a sync option
	    * ( unlikely this would happen but a good failsafe -- sendBeacon only queues the request ).
	    * */
	    unlockWithBeacon: function() {
	        var success = navigator.sendBeacon( fvChannel.request('apiUrl').unlockDocument( this ), ''  );
	        if (!success)
	            this.unlock(0, this, 1);
	    },
	
	    hasMultipartGosPages: function() {
	        return this.pageCollection.hasMultipartGosPages();
	    },
	
	    isOnePageMultiPartGosSkeleton: function() {
	        return this.pageCollection.length === 1 && this.pageCollection.at(0).isMultipartGosSkeleton();
	    },
	
	    // Returns whether the document can be download.
	    // isPDF: if provided, isPDF implies via the CRE, otherwise raw.
	    isDownloadable: function(isPDF) {
	
	        if ( this.get('docHasNoPages') )
	            return false;
	
	        // DVBC-1704 -- hack: special logic for document with only URL pages,
	        // which currently are considered 'renderable', but shouldn't be downloadable.
	        if ( this.pageCollection.allPagesAreUrlPages() )
	            return false;
	
	
	        if (isPDF)
	            return this.hasRenderablePgs(); // ( unrenderable includes multipart-GOS )
	
	
	        // Original:
	
	        // Only downloads of documents with multi-part-gos-page types if they contain one pg and it's the skeleton --
	        // we are assuming that to be the case for documents created with these page types
	        if ( this.hasMultipartGosPages() )
	            return this.isOnePageMultiPartGosSkeleton();
	
	        return true;
	    },
	
	    // ---- Perms ----
	
	    allowAddPages: function() {
	        return this.permissions.canAddPages();
	    },
	
	    allowDeletePages: function() {
	        return this.permissions.canDeletePages() && !this.get('docHasNoPages');
	    },
	
	    // (need at least 1 page to reorder)
	    allowReorderPages: function() {
	        return this.pageCollection.length > 1 && this.permissions.canReorderPages();
	    },
	
	    // Rotate is really 'Allow to Save Rotation' -- don't disable the button b/c of it
	    allowRotatePages: function() {
	        return !this.get('docHasNoPages');
	    },
	
	    allowSaveRotation: function() {
	        return this.permissions.canSavePageRotation();
	    },
	
	    allowCreatePgNote: function() {
	        return this.permissions.canCreatePageNotes();
	    },
	
	    allowCreateDocNote: function() {
	        return this.permissions.canCreateDocNotes();
	    },
	    allowModifyOrDeleteNote: function() {
	        return this.permissions.canModifyOrDeleteNotes();
	    },
	    allowCreateHighlight: function() {
	        return this.permissions.canCreateHighlights();
	
	    },
	    allowModifyOrDeleteHighlight: function() {
	        return this.permissions.canModifyOrDeleteHighlights();
	    },
	
	
	    /** --- Positional Text Data: want to think of the words at the document level now --- */
	
	    hasPagesWithPositionalData: function() {
	
	        return this.pageCollection.find( function(p) {
	                return p.hasPositionalTextData();
	            }) !== undefined;
	
	    },
	
	    fddImagePagesExistAndAllHavePositionalData: function() {
	
	        var fddImagesPages = this.pageCollection.filter( function(p) {
	            return p.isFddImage();
	        });
	
	        if ( fddImagesPages.length < 1 ) {
	            return false;
	        }
	
	        return _.every( fddImagesPages, function(p) {
	            return p.hasPositionalTextData();
	        } );
	
	    },
	
	    getDocumentTextModel: function() {
	        return this.documentTextModel;
	    },
	
	    // X-ref btn getDerivedWordModels subwords and their originals
	    // Could use cleanup but no longer used
	    getOriginalWordModelByIdFromPageDataModels: function( docLevelWdId ) {
	
	        var pagesWithPositionalData = this.pageCollection.pagesWithPositionalData();
	
	        if (!pagesWithPositionalData || pagesWithPositionalData.length < 1)
	            return null;
	
	        // actually we want a fn that return all the words from the page objects for this ...
	        // Need to search them all .... bummer ... just store the models directly ???
	
	        for ( var i=0; i< pagesWithPositionalData.length; i++) {
	
	            var pageTextData = pagesWithPositionalData[i].getPositionalTextDataModel();
	            var words = pageTextData.words;
	            var word = words.get( docLevelWdId );
	
	            if (word)
	                return word;
	
	        }
	
	    },
	
	
	    /* --- End positional text data -- */
	
	
	    onDestroy: function() {
	        _.each( _.keys(instanceProps), function(p) {
	            Marionette.blindTriggerOn(this[p], 'destroy');
	            this[p] = null;
	        }, this);
	    }
	
	});

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/* Note: WORKFLOW_TASK may be added in the future; this could be used to display info about the WF / do WF tasks if requested */
	
	var ModelXref = {
	    FILECABINET:  __webpack_require__(394),
	    BIN: __webpack_require__(396)
	};
	
	module.exports = function(containerAttrs, options) {
	    return new ModelXref[containerAttrs.type](containerAttrs, options);
	};


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var Container = __webpack_require__(395);
	
	module.exports = Container.extend({
	    icon: 'icon-box', //icm-drawer
	    desc: 'File Cabinet'
	});
	


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	module.exports = Backbone.Model.extend({
	    getId: function() {
	        return this.get('id');
	    },
	    getType: function() {
	        return this.get('type');
	    },
	    getIcon: function() {
	        return this.icon;
	    },
	    getTitle: function() {
	        var name = this.get('name');
	        return name ? name : ''; //would latter occur?
	    },
	    getFriendlyTitle: function() {
	        return this.desc;
	    },
	    // Fields is only defined for File Cabinets, not Bins
	    getFields: function() {
	        return this.get('fields');
	    },
	    hasFields: function() {
	        var flds = this.getFields();
	        return flds && flds.length > 0;
	    }
	});

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var Container = __webpack_require__(395);
	
	module.exports = Container.extend({
	    icon: 'icon-inbox',
	    desc: 'Bin'
	});

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var NotesCollection = __webpack_require__(271),
	    NoteModelFactory = __webpack_require__(275),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = NotesCollection.extend({
	
	    // Currently not used but here in case
	    url: function() {
	
	        return fvChannel.request('apiUrl').docNotes( this.document );
	    },
	
	    model: function (attrs, options ) {
	
	        var Note = NoteModelFactory.factory( attrs.noteType , true);
	        return new Note( attrs, options );
	
	    },
	
	    parse: function(resp, options) {
	
	        var availableNoteTypes = NoteModelFactory.noteTypesToInclude('document');
	
	        // May want to move this logic to the NoteModel factory for clearer centralization
	        !options.allowFlashNotes &&
	            (availableNoteTypes = _.without(availableNoteTypes, 'FLASH_NOTE'));
	
	        return _.filter(resp, function(n) {
	            return _.contains(availableNoteTypes, n.noteType);
	        });
	
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    DocMdPage = __webpack_require__(344),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/* inst:
	*    V_PADDING
	*    H_PADDING
	*    totalPagesHeight
	*    parentDocument
	* */
	
	/* Note: thumbs extended from this) */
	module.exports = Backbone.Collection.extend({
	
	    model: DocMdPage, /* (derived from base page */
	
	    initialize: function(models, options) {
	
	        var cssConstants = fvChannel.request('cssConstants');
	        this.totalPagesHeight = 0;
	        this.parentDocument = options.parentDocument; //(can also ref state from here)
	        this.V_PADDING = cssConstants.V_PADDING;  //used in voffset and scale calc
	        this.H_PADDING = cssConstants.H_PADDING;  //used in scale calc via ref to collection -- GET elsewhere?
	        _.bindAll(this, 'setVOffsets');
	
	
	    },
	
	    /* Add Page Number to the models from the array index (also parsed individually) */
	    parse: function(models) {
	        return _.map(models, function(m, i) {
	            return _.extend(m, {number: i+1});
	        });
	    },
	
	    /**
	     * Called from:
	     * - post render docMode view ( TODO - should now have enough info to call prior to rendering )
	     * - Document mode scale change
	     * - Post page rotation: new
	     * - Most be called after a 'page size' change
	     * The bottom of the page relative to the top of its scroll container ( Doc Mode El )
	     *
	     */
	    setVOffsets: function(scale) {
	
	        var vPadding =  this.V_PADDING,
	            pages = this.models,
	            numPages = pages.length,
	            pagePadding = (2 * vPadding), /* the vertical padding of the imgWr (no more border --uses outline) -- need to check this now */
	            totalPagesHeight = 0; // Note: should equal docMode scroll height tough could be off a bit due to rounding
	
	        /* GOOD OLE for for performance */
	        for (var i=0; i < numPages; i++) {
	
	            var pg = pages[i],
	                pgHt = Math.round( pg.getRotatedHeight() * scale ),
	                roundedBottom = pgHt + pagePadding; /* don't scale the padding -- note: using outline, not border -- so not included */
	
	            totalPagesHeight += roundedBottom;
	
	            pg.set({ 'vOffset': totalPagesHeight });
	        }
	
	        // Note: no longer need to add an extra vPadding to -- format must have changed .
	        this.totalPagesHeight = totalPagesHeight;
	
	    },
	
	    getRequestedButUnloadedModels: function() {
	        return this.where({
	            isLoaded: false,
	            wasRequested: true
	        });
	    },
	
	    noRenderablePagesExist: function() { /* note: set on pg init */
	        return this.where({isRenderable: true}).length < 1;
	    },
	
	    someRenderablePagesExist: function() {
	        var unRenderablePgs = this.getUnrenderablePages();
	        return unRenderablePgs.length > 0 && unRenderablePgs.length < this.length;
	    },
	
	    getUnrenderablePages: function() { //return subset of pages that are not renderable
	        return new Backbone.Collection( this.where({isRenderable: false}) );
	    },
	
	    getModelFromPgNumber: function(pgNumber) { /* Works Page or Thumb */
	        return this.at( pgNumber -1 );
	    },
	
	    unrenderablePDFModePgs: function() {
	        return new Backbone.Collection( this.filter(function(p) {
	            return p.isRenderableInPDFMode();
	        }));
	    },
	
	    noPDFRenderablePagesExist: function() {
	        return this.unrenderablePDFModePgs().length < 1;
	    },
	
	    somePDFRenderablePgsExist: function() {
	        var unRenderablePDFPgs = this.unrenderablePDFModePgs();
	        return unRenderablePDFPgs.length > 0 && unRenderablePDFPgs.length < this.length;
	    },
	
	    urlOrUnrenderablePages: function() {
	
	        return new Backbone.Collection( this.filter(function(p) {
	            return p.isUrlOrUnrenderable();
	        }));
	
	    },
	    hasMultipartGosPages: function() {
	
	        return this.find( function(p) {
	            return p.isMultipartGos();
	        }) !== undefined;
	
	    },
	
	    allPagesAreUrlPages: function() {
	
	        var numberUrlPages = this.filter(function(p) {
	            return p.isUrl();
	        }).length;
	
	        return numberUrlPages === this.length;
	
	    },
	
	    pagesWithPositionalData: function() {
	
	        return this.filter( function(p) {
	            return p.hasPositionalTextData();
	        });
	
	    },
	
	    getPositionalTextModelOfPage: function( pageNumber ) {
	
	        var page = this.findWhere({ number: pageNumber} );
	
	        return page
	            ? page.getPositionalTextDataModel()
	            : null; // use null as 'falsey' value; null returned from server if ocrNote doesn't exist
	
	    }
	
	
	
	});

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var PageCollection = __webpack_require__(398),
	    ThumbNail = __webpack_require__(400),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	
	module.exports = PageCollection.extend({
	
	    model: ThumbNail,
	
	    initialize: function() {
	
	        // This will match the height of the Thumb Scroller Div
	        // I think this was only put in for debugging purposes -- can remove
	        this.totalThumbScrollHeight = 0;
	
	    },
	
	    /**
	     * Thumbs unaffected by scale, don't need to be recalculated.
	     * The bottom position of the current thumb from the top of the container
	     */
	    setVOffsets: function() {
	
	        var vPADDING = fvChannel.request('cssConstants').V_PADDING,
	            totalThumbsHeight = 0;
	
	        this.each( function(thumb) {
	
	            var curOffset =  (2 * vPADDING) + thumb.getRotatedHeight();
	            totalThumbsHeight += curOffset;
	            thumb.set({'vOffset':  totalThumbsHeight});
	
	        });
	
	        this.totalThumbScrollHeight = totalThumbsHeight;
	
	    }
	
	});

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    BasePage = __webpack_require__(269),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = BasePage.extend({
	
	    typeIdentifier: 'THUMB',
	
	    SPIN_JS_OPTS: { length: 4, radius: 4, width: 2 },
	
	    nonRenderableOrigDimensions: BasePage.prototype.STANDARD_PG_DIMS,
	
	
	    _getSetWidth: function() {
	
	       return fvChannel.request('cssConstants').THUMB_WIDTH;
	
	    },
	
	    _getHeightDerivedFromWidth: function( attrs, isRenderable ) {
	
	        var originalDimensions;
	
	        if (!isRenderable) {
	
	            originalDimensions = this.nonRenderableOrigDimensions;
	
	        } else if (attrs.originalImageProperties) {
	
	            originalDimensions = {
	                w: attrs.originalImageProperties.width,
	                h: attrs.originalImageProperties.height
	            };
	
	        } else {
	
	            originalDimensions = this.unknownOrigDimsDimensions;
	        }
	
	        return Math.round( this._getSetWidth() * ( originalDimensions.h / originalDimensions.w  ) );
	
	    }
	
	    
	});


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
		IndexModel = __webpack_require__(402);
	
	module.exports = Backbone.Collection.extend({
	
	    model: IndexModel,
	    /*
	    * Note: if forDocumentName provided for the intention of a file download,
	    * the file name needs to be sanitized afterward by the caller.
	    * */
	    firstIndexValue: function(forDocumentName) {
	
	        if ( this.length < 1 )
	            return null;
	
	        var firstModel = this.at(0);
	
	        return forDocumentName
	            ? firstModel.getShortenedDisplayValue()
	            : firstModel.getMultiLineDisplayValue();
	
	    }
	
	});

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    moment = __webpack_require__(69),
	    Util = __webpack_require__(48),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        name: '',
	        type: '',
	        data: []
	    },
	
	    /*
	    * Return the 'friendly' display value.
	    * If a multi-value field, returns only the value of the first field.
	    * */
	    getShortenedDisplayValue: function() {
	
	        var rawValue = this._getDisplayValue();
	
	        return rawValue instanceof Array
	            ? rawValue[0]
	            : rawValue;
	
	    },
	
	    /*
	    * Returns the 'friendly' display value of the field as one or more lines.
	    * If a multi-value field, each value will be displayed on a separate line.
	    * Used to print field values in the indexes module.
	    * Could also be beneficial to print in HTML elements with correct CSS overflow settings for multivalue fields ...
	    * eg, if display on one line with text-overflow ellipsis, could still only return the first value on one line
	    * and use the title attribute to the entire value so the user could see it in the entirety.  A use case for this is
	    * printing document names in the multi-doc nav select dropdown, though for now this is displaying 'document names', which is
	    * now interpreted to mean only the first line.
	    * */
	    getMultiLineDisplayValue: function() {
	
	        var rawValue = this._getDisplayValue();
	
	        return rawValue instanceof Array
	            ? rawValue.join('\n')
	            : rawValue;
	    },
	
	    /*
	    * Return either 'friendly' array of values (if multi value field) or just 'friendly' value as a string.
	    * */
	    _getDisplayValue: function() {
	
	        var dataType = this.get('type'),
	            initialValue = this.get('data'), // (this is an array)
	            valueToOutput = '',
	            s = fvChannel.request('settings');
	
	        if (initialValue.length > 1) {
	
	            // 'Multi-Value'
	
	            if ( dataType === 'LIST_OF_DATE' ) {
	
	                valueToOutput = _.map( initialValue, function(val) {
	                    return moment(val).format(s.DATE_FMT_STR);
	                });
	
	            } else {
	
	                // LIST OF STRING, LIST OF INTEGER
	                valueToOutput = initialValue;
	            }
	
	
	
	        } else if ( initialValue.length > 0 ) {
	
	            // Don't print formatted values if they don't exist
	            // Note: decimal, small integer, & integer not formatted to mimic fat client.
	
	            var firstValue = initialValue[0];
	
	            switch(dataType) {
	
	                case 'DATE':
	
	                    // Note: non-valid iso -- see docs, as of v.2.9;
	                    valueToOutput = moment(firstValue, s.DATE_FMT_STR).format(s.DATE_FMT_STR);
	                    break;
	
	                case 'DATE_TIME':
	                    valueToOutput = moment(firstValue, s.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR).format(s.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR);
	                    break;
	
	                case 'MONEY':
	                    valueToOutput = Util.formatNumber(firstValue);
	                    break;
	
	                default:
	                    // STRING, INTEGER, BIG_INTEGER, SMALL_INTEGER, DECIMAL, SIGNATURE
	                    valueToOutput = firstValue;
	            }
	        }
	
	        return valueToOutput;
	
	    }
	
	});

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    moment = __webpack_require__(69),
	    UTRNoteVersion3TextParser = __webpack_require__(404);
	
	__webpack_require__(71);
	
	var HIT_CLASS =  'hit',
	    PRE_TAGS = ['<span class="' + HIT_CLASS + '">' ], /*not escaped by span is harmless */
	    POST_TAGS = ['</span>'],
	    reHasHit = new RegExp(PRE_TAGS[0], 'g'),
	    reTestHasHit = new RegExp(PRE_TAGS[0]); //(no global)
	
	
	/**
	 * TODO: clarify terminology now that referring to 'notes', not pages
	 * Note: now stored as an instance on the document model for the viewer ( this is going to be taken out of DV )
	 * The attributes are the results retrieved from ES.
	 * A lot of this can now be set on parse after fetch and cached (not always returned in functions) ...
	 * Performance can be enhanced with a lot of the functional stuff here.
	 * No longer makes sense for this to be a Backbone Model.
	 * 2/1/22: with upgrade to ES7 there is a breaking schema changes
	 */
	
	var props = {
	
	    // perhaps store these in state now
	    searchText: '',
	    docId: null,
	    fetchUrl: null,
	
	    docNotOnES: null,
	    fetchErrorJQXHR: null,
	
	    // TODO: could use MSEARCH -- check if lowest version allows for it
	    // With need to always perform two queries always now (to show doc notes w/out hits), store these here, not on data attributes
	    q1: null,
	    q2: null,
	
	    // The previous & now current (adapted to fit old model) access point to all the necessary data
	    // Generated in _setHits from a combo combo of q1 and q2 data
	    // Accessible from this._getAllNoteHits
	    hits: null,
	
	    schemaVersion: null, // Property appeared when upgrading to when updating to support to ES7 and corresponding ES FDD schema version 3, which had breaking changes
	
	    ajaxQueue: {}, //not yet implemented -- would be for 'abortAjaxRequests'
	    fetchAborted: null //flag used to allow resolution of fetch (dfd) in case document switched (DVBC-1065)
	
	};
	
	
	module.exports = Backbone.Model.extend({
	    // Return the array of 'note hits' found in the search.
	    // ( will only be one for UTR notes )
	    // Now the single access point in getting necessary data post fetch
	    _getAllNoteHits: function() {
	        return this.hits.hits.hits;
	    },
	    // Only one of these will exist, the other will be undefined --  both passed in init.
	    constructor: function( attrs, options ) {
	
	        _.extend( this, props, _.pick( options, 'searchText', 'docId', 'fetchUrl'), {
	            parse: false, // custom fetch
	            query:  this._constructESQuery( options.searchText, options.docId, options.additionalSearchClauses )
	        });
	
	        Backbone.Model.prototype.constructor.apply(this, arguments);
	    },
	
	    _constructESQuery: function(textQuery, docId, additionalSearchClauses) {
	
	        // Query constructed to work with both ES versions supported by Feith -- 1.7 and 5.2.
	        var v1orv5Query =  {
	            query: {
	                bool: {
	                    must: [
	                        { term: {doc_id: docId} }, // have doc_id first -- this is for ES plugin to know that that first item in the array is the DOC id , if may check it
	                        { query_string: {query: textQuery} }
	                    ]
	                }
	            },
	            highlight: {
	                pre_tags: PRE_TAGS, // not escaped by span is harmless
	                post_tags: POST_TAGS,
	                encoder: 'html', //escape
	                // what fields to highlight -- here all
	                fields: {
	                    '*': { number_of_fragments: 0 } //dont filter
	                },
	                "require_field_match": false  //this is required for version 5.2, not 1.7.6 -- in latter, was false by default; in former, true is the default
	            }
	        };
	
	        if (additionalSearchClauses && additionalSearchClauses.length > 0) {
	            var newMust = v1orv5Query.query.bool.must.concat( additionalSearchClauses );
	            v1orv5Query.query.bool.must = newMust;
	        }
	
	        return v1orv5Query;
	
	    },
	
	    /**
	     * Note: really the results of the search -- not the model 'fetch' in the Backbone sense.
	     * contentType: previoulsy ,'text/plain', though to hit ES directly now need application/json; this is also now working for the proxy
	     */
	    fetch: function(cxt) {
	
	        var self = this,
	            cxt = cxt || self,
	            ajaxOps = {
	                url: this.fetchUrl,
	                type: 'POST',
	                contentType: 'application/json',
	                dataType: 'json',
	                context: cxt
	            };
	
	        return $.Deferred( function($dfd ) {
	            
	            $.ajax( _.extend( ajaxOps, { data: JSON.stringify(self.query) } )).done( function(data)  {
	                    
	                    /*  quick fix to prevent run time errors when switch docs fast in the viewer (on reset, query would now be null)
	                        should really be taken care of in outside workflow -- though no one uses this anyway in doc viewer
	                     */
	                    if (!self.query)
	                        return;
	
	                    self.q1 = data;
	                    /* if searching for all doc notes, will always need the second query to get ones without hits */
	                    /* need to search again with NO QUERY to get results for document notes that wouldn't have highlights
	                     * -- prior: was only doing this if no utr_note hits were returned */
	
	                    //TODO: may be better to have 2 searches and use MSEARCH
	                    //TODO: now that we have gotten rid of providing a 'pass through' query -- may be more clear to just create a separate query for this one
	                    var q = _.clone(self.query);
	                    q.query.bool.must.splice(1); //remove not just the search term but also all the others
	
	                    $.ajax( _.extend( ajaxOps,{ data: JSON.stringify( q ) })).done( function( data ) {
	
	                        /*  quick fix to prevent run time errors when switch docs fast in the viewer (on reset, query would now be null)
	                            should really be taken care of in outside workflow -- though no one uses this anyway in doc viewer
	                         */
	                        if ( !self.query )
	                            return;
	
	                        var hits = data.hits.hits;
	
	                        self.q2 = data;
	
	                        /* CHECK IF THE DOC IS IN THE ELASTIC SEARCH SERVER -- MUST DO ON SECOND REQ */
	
	                        if ( hits[0] === undefined ) {
	                            self.docNotOnES = true; //set flag to be picked up on render
	                        }
	                        else
	                        {
	                            /**
	                             * Store the version here -- after docNotOnEsCheck and called to set hits.
	                             * If no documents returned, we can't get the schema version for any of the hits.
	                             * I think a bunch of functions in here check perform a preliminary check before returning data --
	                             * this is good but in real world could be moot -- since the data is not fetched if this is the case, so maybe we remove.
	                             * Refactor Candidate.
	                             * Need to make sure any functions that would call know schema version this in advance.
	                             */
	                            self.schemaVersion = parseFloat( data.hits.hits[0]._id.split(':')[1] );
	                        }
	
	                        self.hits = self._setHits( self.q1, self.q2 );
	
	                        !self.fetchAborted && $dfd.resolveWith( cxt );
	
	                    }).fail( onJqXHRFail );
	
	            }).fail( onJqXHRFail );
	
	            function onJqXHRFail(jqXHR) {
	
	                self.fetchErrorJQXHR = jqXHR;
	                !self.fetchAborted && $dfd.rejectWith(cxt, [jqXHR]);
	
	            }
	
	        }).promise();
	
	    },
	
	    // LOGIC HERE IS EVOLVED SLOP ... BUT ES SCHEMA IS GOING TO CHANGE ANYWAY (from notes to documents) SO DEAL WITH IT FOR NOW
	    // ( update 2/28/19 - this comment is old ... doubtful the ES schema will change now ... need to clean this up )
	
	    // Set up this.hits as it was done before doc notes were introduced where they were set once, from either the first or second query.
	    // Previously, this.hits would have been stored on model attributes after a fetch.
	    // Since we're now always performing 2 queries, setting models attrs would override one another,
	    // so here we return a munged combination of the both.
	
	    _setHits: function(q1, q2) {
	
	        var q1Hits = q1.hits.hits,
	            q2Hits = q2.hits.hits,
	
	            // Ah: perhaps this doesn't apply if there is no highlight AND if there is no note_* 
	            // in the _source -- UTR will exist with metadata for a document with no pages (eg folders). ???
	            utrNoteHitsReturnedinFirstQuery = q1Hits.length > 0 && _.find( q1Hits, function(h) {
	                return h._source.type === 'U';
	            }),
	
	            // Use q1 as the base if UTR notes exists in the first query (pages found), otherwise use query 2.
	            // Note: DVBC-1176 -- if document is a FOLDER, it will never have any UTR notes highlights --
	            // notes may exist, but there will never be a note_* attribute on the source.
	            resp = utrNoteHitsReturnedinFirstQuery ? q1 : q2,
	
	            // Add any doc note hits from q2 that didn't exist in q1 to the resp to return.
	            docNoteHitsReturnedinSecondQuery = _.filter( q2Hits , function( h ) {
	                return h._source.type === 'T' || h._source.type === 'X';
	            }),
	            docNoteHitsFirstQuery = _.filter( q1Hits, function( h ) {
	                return h._source.type === 'T' || h._source.type === 'X';
	            }),
	            docNoteIdsInFirstQuery = _.pluck( docNoteHitsFirstQuery, '_id' );
	
	        // DVBC-1487 -- can no longer rely on sequence (could have the same in doc and page notes, so identify by id).
	        // Note -- DVBC-1489 -- this really needs be cleaned: eg,
	        // a dupe doc note can be added to the end of the resp array if a hit in first query if no utr notes returned in the 1st query
	        // ... though this doesn't seem to cause any issue with current logic.
	        // I expect this to change with the introduction of page text notes.
	
	        _.each( docNoteHitsReturnedinSecondQuery, function(h) {
	            if ( !_.contains( docNoteIdsInFirstQuery, h._id )) {
	                resp.hits.hits.push(h);
	            }
	        });
	
	        // If there were no UTR page hits in the first query, add highlights of doc notes from q1 
	        // to corresponding DOC NOTE(!) hits in the resp (here would be second query)
	        // DVBC-1101: in q2 no doc notes have highlights.
	        if (!utrNoteHitsReturnedinFirstQuery) {
	
	            var docNoteHitsFirstQueryWithHighlights = _.filter(docNoteHitsFirstQuery, function(h) {
	                return h.highlight !== undefined;
	            });
	
	            _.each( docNoteHitsFirstQueryWithHighlights, function(h) {
	                var correspondingNoteHit = _.find( resp.hits.hits, function( correspondingHit ) {
	                    return h._id === correspondingHit._id;
	                });
	                correspondingNoteHit && (correspondingNoteHit.highlight = h.highlight);
	            });
	        }
	
	        return resp;
	    },
	    // These are really UTR NOTES (or rather the contents of all UTR notes in the document)
	    getPageTextObjs: function(esGrep, localGrepStr) {
	
	        var aPgTxtObjs = this._getArrayOfPageTextObjs();
	
	        if (esGrep)
	            aPgTxtObjs = this._getArrayOfGreppedPageTextObjs(aPgTxtObjs);
	
	        if (localGrepStr)
	            aPgTxtObjs = this._getArrayOfLocalGreppedPageTextObjs(aPgTxtObjs, localGrepStr);
	
	        return aPgTxtObjs;
	    },
	    /**
	     * Return array of { pgNum, pgId, pgText }
	     * If hits, take from the highlight for 'highlighting', otherwise, take from the source.
	     * Highlights won't have hits if not found, so NEED THE SOURCE in case not found -- not just the highlight section.
	     * docPgsIds:
	     * - now not using a separate function to get these -- so consider this the central pt for obtaining page ids
	     * - normalize them into an array: if there's only one page in the document, the value will not be an array (otherwise it will)
	     * - Also note: it will be undefined if the document has no pages; but this is ok b/bc the variable will not be referenced in this routine
	     *   in the for loop below because the # of pages will be 0.
	     * Pageless documents:
	     * - should work ... see notes ... if there are fields but no pages, # returned will just be zero.
	     * - if no properties returned at all, it will appears as 'Document Not on ES Server' ( DVBC-1852 )
	     * Version differences:
	     * - version < 3: didn't employ a notes array;  had properties on the source highlights, eg { .note_#: text }*
	     * - version 3:
	     *      - the note field were replaced with an array of notes
	     *      - value in the array is the text prefixed by "FDDPage 2: ";
	     *      - the prefix is necessary to link the page number in the highlights section
	     */
	    _getArrayOfPageTextObjs: function() {
	
	        var aPagesText = [],
	            pageSource = this._getDocumentPageSource(),
	            aPageHighlightResults = this._getUTRNoteHighlightResponse(),
	            docPgsIds =  pageSource.doc_pg_ids instanceof Array ? pageSource.doc_pg_ids : [pageSource.doc_pg_ids],
	            numberPgsInDocument = this.numberOfPgsInDoc();
	
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            var pageKeysWithHits = this._UTRNoteHasPageResults() // ( superflous in this routine )
	                    ? Object.keys( aPageHighlightResults )
	                    : [], // use empty array if none returned
	                pageKey,
	                pgNum,
	                pgId;
	
	            for ( var i = 0; i < numberPgsInDocument; i++ ) {
	
	                pgNum = i + 1;
	                pageKey = 'note_' + pgNum; // ( pages are in page seq order )
	
	                // Set pageIds from the doc page ids array.  This should work b/c the array of pg ids should be in seq order.
	                // Though we could run into problems: eg if user reorders doc pages and UTR is not re-run.
	                // Note: ES is not storing page sequence
	                pgId = docPgsIds[i];
	
	                aPagesText[i] = _.contains( pageKeysWithHits, pageKey )
	                    ? {
	                        pgNum: pgNum,
	                        pgId: pgId,
	                        pgText: aPageHighlightResults[pageKey][0]
	                    }
	                    : {
	                        pgNum: pgNum,
	                        pgId: pgId,
	                        pgText: pageSource[pageKey]
	                    };
	            }
	
	            return aPagesText;
	        }
	
	        /* --- Version 3+ --- */
	
	        var aSourceNotes = pageSource.note; // These should always exist
	        var aHighlightNotes = this._UTRNoteHasPageResults() ? aPageHighlightResults.note : [];
	
	
	        var aHighlightPgNumbersByText = aHighlightNotes.reduce( function( obj, pageTextWithDelimiter ) {
	
	            var pgNumberAndText = UTRNoteVersion3TextParser.getPageNumberAndText( pageTextWithDelimiter );
	            obj[pgNumberAndText.pgNumber] = pgNumberAndText.pgText;
	            return obj;
	
	        }, {} );
	
	        // If page is in the highlight, use it -- can tell by getting the 1st un-delimited
	        // ( pages are in seq order )
	        for (var i = 0; i < numberPgsInDocument; i++) {
	
	            var actualPageNumber = i + 1; // ( base 1 )
	
	            // Should make class -- not a literal -- now its context of a template
	            var pageTemplateData = {
	                pgNum: actualPageNumber,
	                pgId: docPgsIds[i]
	            };
	
	            /* Higlights are base 1 ( actual #; source is base 0 */
	            var pageText = aHighlightPgNumbersByText[actualPageNumber]
	                ? aHighlightPgNumbersByText[actualPageNumber]
	                : UTRNoteVersion3TextParser.getPageText( aSourceNotes[i] );
	
	            pageTemplateData['pgText'] = pageText;
	
	            aPagesText[i] = pageTemplateData;
	
	        }
	
	        return aPagesText;
	
	
	
	    },
	    // Only return lines with hits (and pages with lines with hits).
	    _getArrayOfGreppedPageTextObjs: function( allPgTextObjects ) {
	
	        allPgTextObjects = allPgTextObjects || this._getArrayOfPageTextObjs();
	
	        var aPgsWithHits = _.filter( allPgTextObjects , function(p) {
	            return reTestHasHit.test(p.pgText);
	        });
	
	        return _.map(aPgsWithHits, function(p) {
	
	            var aLinesWithHits = _.filter( p.pgText.split('\n') , function(line) {
	                return reTestHasHit.test(line);
	            });
	
	            return {
	                pgNum: p.pgNum,
	                pgId: p.pgId,
	                pgText: aLinesWithHits.join('\n')  // Note: put back the new line char that got stripped from split
	            };
	        });
	    },
	
	    _getArrayOfLocalGreppedPageTextObjs: function( aPgTxtObjs, localGrepStr ) {
	
	        aPgTxtObjs = aPgTxtObjs || this._getArrayOfPageTextObjs();
	
	        var reTestLocal = new RegExp(localGrepStr, 'i');
	        var reReplace = new RegExp( '(<span class="hit")(>)', 'gi' ); // continue using?
	
	        var aPgsWithHits = _.filter( aPgTxtObjs, function(p) {
	            return reTestLocal.test(p.pgText);
	        });
	
	        return _.map(aPgsWithHits, function(p) {
	
	            var pgText = p.pgText,
	                pgNum = p.pgNum;
	
	            var aLinesWithNumberedHits = _.map( pgText.split('\n'), function(line, i) {
	                return line.replace(reReplace, function(match, p1, p2) {
	                    return p1 +  ' data-pg="' + pgNum + '" data-line="' + i + '"' + p2;
	                });
	            });
	
	            var aLinesWithHits = _.filter( aLinesWithNumberedHits , function(line, i) {
	                return reTestLocal.test(line);
	            });
	
	            /*        
	                var aLinesWithHitsInLinesNumbered = _.map(aLinesWithHits, function(line, i) {
	                    debugger;
	                    //set data attribute of each hit in the line
	                });
	            */
	
	            return {
	                pgNum: p.pgNum,
	                pgId: p.pgId,
	                pgText: aLinesWithHits.join('\n')
	            };
	        });
	
	    },
	
	    getFCFields: function( localGrepStr, includeNonHits ) {
	
	        var flds = this._getAllFCFields(includeNonHits);
	        flds = order(flds); //sort: if toggle btn local/es grep, may get diff order
	
	        if (!localGrepStr)
	            return _.keys(flds).length > 0 ? flds : null;
	
	        return this._getLocalGreppedDocProperties(flds, localGrepStr);
	
	    },
	    // Return key, value of the hits -- null if empty.
	    // Note: the keys are string of unwanted prefix.
	    _getAllFCFields: function( includeNonHits ) {
	        
	        // First get any with hits
	        var fieldsWithHits = this._getFCFields(true);
	        if (!includeNonHits)
	            return fieldsWithHits;
	
	        // Then get those without hits (if desired)
	        var fieldsWithoutHits = this._getFCFields(false);
	
	        // Merge them, with precedence to the hits
	        return _.extend( fieldsWithoutHits, fieldsWithHits );
	
	    },
	
	    /**
	     * Return Hash Of 'Display Field Name' (no prefix identifier) X Field Value {actual field name: field value}
	     * If from hits, the value will contain HTML markup; if not, its text.
	     * fromHits: get the properties from the highlight or src section of the response.
	     */
	    _getFCFields: function( fromHits ) {
	
	        var resp = this[fromHits ? '_getFirstNoteHitHighlightResp' : '_getFirstNoteHitSourceResp']();
	
	        if ( !resp || resp.length < 1 )
	            return null;
	
	        var ret = {};
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            /**
	             *  DVBC-1486 -- for the source response -- fc_flx and fc_fld values are the same but we can't just filter for one:
	             *  'x' values are indexed differently (stemming, tokenizing, etc.. ) than 'd' values, so sometimes a search will include
	             *  one but not the other or both in the 'highlights' section.  If both are returned, ES could make the hit
	             *  in HTML differently depending on the search, but give precedence to 'x'.
	             *  TODO: common code for getting 'x' vs 'd' values -- do after init imple of props ...
	             */
	            for ( var k in resp ) {
	
	                if ( k.indexOf('fc_fl') < 0 )
	                    continue;
	
	                var isX = k.indexOf('fc_flx') > -1,
	                    displayKey = k.substr(9, k.length); // Can be diff types, can't just replace txt to get the display value (eg: ..._c_ )
	
	                if (isX) {
	                    //fc_flx: Remove 'd' (if exists) to eliminate dupes
	                    var dKey = _.find(_.keys(resp), function (k) {
	                        return k.indexOf('fc_fld') > -1 && k.indexOf(displayKey) > -1;
	                    });
	                    dKey && delete resp[dKey];
	                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
	
	                } else {
	                    // fc_fld:
	                    // Check if there's a 'x' of the same 'name', if so use that instead (will be picked up later in iteration);
	                    // If not, use the value of the 'd'
	                    var xKey = _.find(_.keys(resp), function (k) {
	                        return k.indexOf('fc_flx') > -1 && k.indexOf(displayKey) > -1;
	                    });
	
	                    !xKey && ( ret[displayKey] = fromHits ? resp[k][0] : resp[k] );
	                }
	            }
	
	        } else {
	
	            /* With version 3 the 'fc-flx_c' fields were removed.  We now only have 'fc_fld_c_' fields. */
	
	            for ( var k in resp ) {
	
	                if ( k.indexOf('fc_fld') > -1 ) {
	
	                    var displayKey = k.substr( 9, k.length ); // share this?
	                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
	                }
	
	            }
	
	        }
	
	        return Object.keys(ret).length > 0 ? ret : null;
	
	    },
	
	    // TODO: common code w/ fields, security, rma properties ... but refactoring anyway
	    getDocProperties: function(localGrepStr, includeNonHits) {
	
	        var docProps = this._getAllDocProperties(includeNonHits);
	        docProps = order(docProps); //sort: if toggle between local/es grep, may get diff order
	
	        if (!localGrepStr)
	            return _.keys(docProps).length > 0 ? docProps : null;
	
	        return this._getLocalGreppedDocProperties(docProps, localGrepStr);
	    },
	
	    _getAllDocProperties: function( includeNonHits ) {
	        //First get any with hits
	        var withHits = this._getDocProperties(true);
	        if (!includeNonHits) return withHits; //(null if none)
	
	        //Then get those without hits (if desired)
	        var withoutHits = this._getDocProperties(false); //(null if none)
	
	        //(merge them, with precedence to the hits)
	        return _.extend(withoutHits, withHits);
	    },
	    _getDocProperties: function( fromHits ) {
	
	        var resp = this[fromHits ? '_getFirstNoteHitHighlightResp' : '_getFirstNoteHitSourceResp']();
	
	        if (!resp || resp.length < 1)
	            return null;
	        
	        var ret = {};
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            for (var k in resp) {
	
	                // Will be doc_prox and doc_prop
	                // Sometimes not the same value so can't filter out; if both found, give precedence to the 'X'
	                if (k.indexOf('doc_pro') < 0)
	                    continue;
	
	                var isX = k.indexOf('doc_prox') > -1, //(to distinguish from doc prop)
	                    displayKey = k.substr(11, k.length);
	
	                if (isX) {
	                    //remove any doc_prop (if exists) to eliminate dupes
	                    var docPKey = _.find(_.keys(resp), function (k) {
	                        return k.indexOf('doc_prop') > -1 && k.indexOf(displayKey) > -1;
	                    });
	                    docPKey && delete resp[docPKey];
	                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
	
	                } else { //doc_prop
	
	                    // check if there's a doc_prox, if use that instead (will be pick up later in iteration);
	                    // if not, use the value of the 'p'
	                    var xKey = _.find(_.keys(resp), function (k) {
	                        return k.indexOf('doc_prox') > -1 && k.indexOf(displayKey) > -1;
	                    });
	
	                    !xKey && ( ret[displayKey] = fromHits ? resp[k][0] : resp[k] );
	                }
	            }
	        }
	        else
	        {
	            /* With version 3 doc_prox is gone just like fc_flx. We now only have 'doc_prop' fields. */
	            for ( var k in resp ) {
	
	                if ( k.indexOf('doc_prop') > -1 ) {
	                    var displayKey = k.substr( 11, k.length );
	                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
	                }
	            }
	        }
	
	        return Object.keys(ret).length > 0 ? ret : null;
	
	    },
	
	    // Return Security or RMA metadata applied to the Document.
	    // If isSecurity -- return security properties, otherwise return RMA properties.
	    // (Later may be better to break apart, but now going for code reuse).
	    getSecurityOrRMAProperties: function( localGrepStr, includeNonHits, isSecurity ) {
	
	        var rmaOrSecurityProps = this._getAllSecurityOrRmaProperties( includeNonHits, isSecurity );
	
	        // sort: if toggle between local/es grep, may get diff order
	        rmaOrSecurityProps = order(rmaOrSecurityProps);
	
	        if (!localGrepStr)
	            return _.keys(rmaOrSecurityProps).length > 0 ? rmaOrSecurityProps : null;
	
	        return this._getLocalGreppedDocProperties(rmaOrSecurityProps, localGrepStr);
	
	    },
	
	    _getAllSecurityOrRmaProperties: function( includeNonHits, isSecurity ) {
	
	        var withHits = this._getSecurityOrRMAProperties( 1, isSecurity );
	
	        if (!includeNonHits)
	            return withHits;
	
	        var withoutHits = this._getSecurityOrRMAProperties( 0, isSecurity );
	
	        return _.extend (withoutHits, withHits );
	    },
	
	    /**
	     * The 'Big 5': Return Security if isSecurity provided, otherwise, RMA.
	     * Return object of 'Display Name' x Value; return null if none exist.
	     * Note: the value is an array that can contain a mixture of html and text (hits and non hits)
	     * If hits ... will be array of [<span class="hit">Record</span>, <span class="hit">Record</span>] ... so dealing with the html here anyway ....
	     */
	    _getSecurityOrRMAProperties: function( fromHits, isSecurity ) {
	
	        var firstNoteHitHighlightResp = this._getFirstNoteHitHighlightResp(),
	            firstNoteHitSrcResp = this._getFirstNoteHitSourceResp(); // prob bad naming here; if no hits in q1 will be not src, so q2 ... anyway it's always returning the values
	
	        // Use 'resp' as base to build return obj -- if there is a hit and fromHits,
	        // need to combo it with the non hits (the latter won't be included) -- ( so its not 1 or the other like other categories here ).
	        var resp = fromHits ? firstNoteHitHighlightResp : firstNoteHitSrcResp;
	
	        if (!resp || resp.length < 1)
	            return null;
	
	        var ret = {};
	
	        // May want to make own obj or at least own fns -- more flexibility in the future ... get going first .....
	
	        if (isSecurity) {
	
	            // Classification:  There is only one allowed for this one; don't need to check for others that aren't hits, if there are hits
	
	            var classifications = this._getRMAorSecurityProperty( 'class_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits, 1 ),
	                markings = this._getRMAorSecurityProperty( 'mark_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits ),
	                countries = this._getRMAorSecurityProperty( 'country_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits );
	
	            classifications && ( ret['Classification'] = classifications );
	            markings && ( ret['Marking'] = markings );
	            countries && ( ret['Countries'] = countries );
	
	
	        } else {   // RMA
	
	            // Categories: upcoming cat_id ... not sure how will handle ...
	
	            // States:
	                // Could be 'dupes' -- unique state is made of name & description, but ES only stores the name.
	                // Could return unique list but leaving the dupes to show that more were assigned.
	
	           var categories = this._getRMAorSecurityProperty( 'cat_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits ),
	               states = this._getRMAorSecurityProperty( 'state_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits );
	
	            categories && ( ret['Categories'] = categories );
	            states && ( ret['States'] = states );
	
	        }
	
	        return _.keys(ret).length > 0 ? ret : null;
	
	    },
	    /* For RMA/Security Properties, there is no '_x' suffix in the keys */
	    _getRMAorSecurityProperty: function( propName, firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits, onlyOneValuePossible ) {
	
	        var aTextToReturn = fromHits
	            ? firstNoteHitHighlightResp[propName] ? firstNoteHitHighlightResp[propName] : null
	            : firstNoteHitSrcResp[propName] ? firstNoteHitSrcResp[propName] : null;
	
	        if (!aTextToReturn)
	            return null;
	
	        // Note: clone required to not change the actual source value ( can be not when merging hits and non hits )
	        aTextToReturn = aTextToReturn instanceof Array ? _.clone(aTextToReturn) : [ _.clone(aTextToReturn) ];
	
	        if (fromHits && !onlyOneValuePossible)
	            aTextToReturn = combineHitsAndNonHits( aTextToReturn, propName );
	
	        // Sort the values to consistently display them in order.
	        // They can appear differently if modified in 'combineHitsAndNonHits' or if taken from hit/no hits.
	        return onlyOneValuePossible
	            ? aTextToReturn
	            : sortMixedTextAndHtmlValues( aTextToReturn );
	
	        /**
	         * If from hits, need to include others that weren't highlighted.
	         * Purpose is to show all properties and highlight the hits -- not just the hits (if searching from hits).
	         * Could further condense code here but leaving being more verbose
	         * If not from hits, should return all anyway.
	         * At least for an attempt at clarity -- can later change when do some more testing -- and in case later changes need to be made for each category
	         * Hit array eg -- "<span class="hit">Frozen</span>", "<span class="hit">Record</span>"
	         */
	        function combineHitsAndNonHits( hitsArray, propName ) {
	
	            // Get unique 'hits' utilizing jQuery as a convenience -- these will either be
	            // markup (<span class="hit">Frozen</span>) or a mixture of it ("Unit <span class="hit">Manning</span> Documents)
	            // mixture require to wrap in $div
	            var uniqueHitsAsText = _.map( hitsArray, function( hit ) {
	                return $('<div>').html(hit).text();
	            });
	
	            // Get non hits to see if there's a difference (these will be text)
	            // If there is, add the text values to the array to return.
	            var nonHits = firstNoteHitSrcResp[propName],
	                nonHitsNotIncluded = _.difference( nonHits, uniqueHitsAsText );
	
	            (nonHitsNotIncluded.length > 0) &&
	                ( hitsArray = hitsArray.concat( nonHitsNotIncluded ) );
	
	            return hitsArray;
	
	        }
	
	        // Sort array of items that can either be text or mixed text and html by their text values/
	        // This could be a jq / underscore / util helper fn
	        function sortMixedTextAndHtmlValues( unsortedValues ) {
	
	            var textByMixedHtmlValues = _.map( unsortedValues, function(v) {
	                return {
	                    textValue: $('<div>').html(v).text(), // TODO: This could also be a helper ...
	                    mixedHtmlValue: v
	                };
	            });
	
	            var sortedByTextValue = _.sortBy( textByMixedHtmlValues, 'textValue' );
	
	            return _.pluck( sortedByTextValue, 'mixedHtmlValue' );
	
	        }
	
	    },
	
	    getDocNotes: function(esGrep, localGrepStr, includeNonHits) {
	
	        var docNotes = this._getAllDocNotes(includeNonHits);
	
	        if (esGrep)
	            docNotes = this._getGreppedDocNotes(docNotes);
	
	        if (localGrepStr)
	            docNotes = this._getLocalGreppedDocNotes(docNotes, localGrepStr);
	
	
	        return docNotes;
	    },
	
	    /* Return object of Doc Note Sequence By 'Display Value' to Return or null if none exist */
	    _getAllDocNotes: function(includeNonHits) {
	
	        var ret = {},
	            allDocNoteHits = this._getDocNoteHitsResp(); // Those w/and w/out highlights -- next split into groups
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            // Could loop and split for perf to create the 2 below
	            var hitsWithHighlights = _.filter(allDocNoteHits, function(hit) {
	                if (!hit.highlight) return false;
	                return _.filter( _.keys(hit.highlight), function(k) {
	                        return k.indexOf('note_') > -1;
	                    }).length > 0;
	            });
	
	            var hitsWithoutHighlights = _.filter(allDocNoteHits, function(hit) {
	                if (!hit.highlight) return true;
	                return _.filter(  _.keys(hit.highlight) , function(k) {
	                        return k.indexOf('note_') > -1;
	                    }).length < 1;
	            });
	
	            // Always do the highlights first
	            _.each( hitsWithHighlights , function(hit, i) {
	                var src = hit._source;
	                var highlight = hit.highlight;
	                for (var k in highlight) {
	                    // Use sequence as identifier -- perhaps could store more data about the note on data-attr's
	                    if (k.indexOf('note_') > -1) {
	                        ret[ src.seq ] = createNoteValueLine(highlight[k][0], src.author, src.created, src.seq );
	                    }
	                }
	            });
	
	            if (!includeNonHits)
	                return _.keys(ret).length > 0 ? ret : null;
	
	            // Non Highlights -- unlike with pages, this is optional to include; get text from src, not the highlights
	            _.each( hitsWithoutHighlights , function(hit, i) {
	                var src = hit._source;
	                for (var k in src) {
	                    if (k.indexOf('note_') > -1) {
	                        ret[ src.seq ] = createNoteValueLine(src[k], src.author, src.created, src.seq);
	                    }
	                }
	            });
	
	        }
	
	        else
	        {
	            // Should use one loop for performance ...
	            var hitsWithHighlights = allDocNoteHits.filter( function( hit ) {
	                return hit.highlight && hit.highlight.note;
	            });
	
	            var hitsWithoutHighlights = allDocNoteHits.filter( function(hit) {
	                return !hit.highlight || !hit.highlight.note;
	            });
	
	            // Always do the highlights first --
	            hitsWithHighlights.forEach( function(hit, i) {
	                var src = hit._source;
	                var noteText = hit.highlight.note[0]; // should only ever be one
	                // Use sequence as identifier -- perhaps could store more data about the note on data-attr's
	                ret[ src.seq ] = createNoteValueLine( noteText , src.author, src.created, src.seq );
	            });
	
	            if ( !includeNonHits )
	                return Object.keys(ret).length > 0 ? ret : null;
	
	            // Non Highlights -- unlike with pages, this is optional to include; get text from src, not the highlights
	            //
	            hitsWithoutHighlights.forEach( function( hit ) {
	                var src = hit._source;
	                var noteText = src.note[0];
	                ret[ src.seq ] = createNoteValueLine( noteText, src.author, src.created, src.seq );
	
	            });
	
	        }
	
	        return Object.keys(ret).length  > 0 ? ret : null;
	
	        /**
	         * Returning html as easy hack to keep on same line, allowing to keep grep functionality --
	         * if gets more complex prob will want to create new collection view.
	         * could try breaking by br? (not 'n')
	         * This should really be done in the view layer; this is a quick shortcut.
	         * TODO:
	         * - put esdn line around what will be the key -- esDNLine
	         */
	        function createNoteValueLine(noteText, author, created, seq) {
	
	            return '<span class="esDN" data-seq="' + seq + '">' +
	                '<span class="esDNKey">' +
	                    '<span class="esDNAuthor">' + author + '</span>' +
	                    '<span class="esDNTime">(' + moment.convertDBTimeToLocalTime(created) + ')</span>:' +
	                '</span>'  +
	                noteText +
	            '</span>';
	        }
	
	    },
	    _getGreppedDocNotes: function(allDocNotes) {
	        allDocNotes = allDocNotes || this._getAllDocNotes(false);
	        var ret = {};
	        for (var seq in allDocNotes) {
	            var aLinesWithHits = _.filter( allDocNotes[seq].split('\n'), function(line) {
	                return reTestHasHit.test(line);
	            });
	            ret[seq] = $.trim( aLinesWithHits.join('\n') ); //trim so lines don't break in ui on the first, last ...
	        }
	        return _.keys(ret).length > 0 ? ret : null;
	    },
	    _getLocalGreppedDocNotes: function(docNotes, localGrepStr) {
	
	        docNotes = docNotes || this._getAllDocNotes(false);
	
	        var reHasLocalHit = new RegExp(localGrepStr, 'i'),
	            greppedNotes = {},
	            docNotesWithHits = {};
	
	        // First filter out notes that don't contain localGrepStr
	        for (var seq in docNotes) {
	            if (reHasLocalHit.test(docNotes[seq]))
	                docNotesWithHits[seq] = docNotes[seq];
	        }
	
	        // Now filter for lines of the note text that contain localGrepStr
	        for (var seq in docNotesWithHits) {
	
	            var aLinesWithHits = _.filter( docNotesWithHits[seq].split('\n'), function(line) {
	                return reHasLocalHit.test(line);
	            });
	
	            greppedNotes[seq] = $.trim( aLinesWithHits.join('\n') ); //trim so lines don't break in ui on the first, last ...
	        }
	
	        return _.keys(greppedNotes).length > 0 ? greppedNotes : null;
	
	    },
	    /*
	     * Take a 'docProperties obj' and only return properties whose key or value matches localGrepStr.
	     * Returns null if nothing matches.
	     * 'DocProperties obj' is whats returned for FC Fields, Doc Properties, RMA, & Security
	     * ( currently the doc meta data we're interested in ).
	     * It's what currently populates their display templates.
	     * Search both the key and value b/c 'keys' are also searched by SAT.
	     * docProperties: an array of key, 'display values'; 'display values' can be an array ( the case for RMA & Security )
	     * localGrepStr: the string to search
	     */
	   _getLocalGreppedDocProperties: function(docProperties, localGrepStr) {
	
	        var lclGreppedProperties = {},
	            reTestLocal = new RegExp(localGrepStr, 'i');
	
	        for (var k in docProperties) {
	
	            // Utilize jQ html to not search any potential html (eg <span class=hit>) which could come back in highlights.
	            // Utilize a join for array values  (rmaOrSecurityProps are arrays, unlike doc props or fc fields).
	            var propertyValue = docProperties[k] instanceof Array
	                ? docProperties[k].join('')
	                : docProperties[k];
	
	            var valueToSearch = $('<div>').html( propertyValue ).text();
	            var textToSearch = valueToSearch + k;
	
	            if ( reTestLocal.test(textToSearch) )
	                lclGreppedProperties[k] = docProperties[k];
	
	        }
	
	        return _.keys(lclGreppedProperties).length > 0 ? lclGreppedProperties : null;
	
	    },
	    // FC Fields and Doc Property metadata will be in any of the note fields.
	    _getFirstNoteHitHighlightResp: function() {
	
	        return this._hasAnyResults()
	            ? this._getAllNoteHits()[0].highlight
	            : null;
	
	    },
	    _getFirstNoteHitSourceResp: function() {
	
	        if ( !this.docOnServerAndNoFetchErr() )
	            return null;
	
	        return this._getAllNoteHits()[0]._source;
	
	    },
	
	    /**
	     * Return the first UTR note hit;
	     * there should only ever be one for a document (these are document UTR notes )
	     */
	    _getUTRNoteHitResponse: function() {
	        return _.find(  this._getAllNoteHits(), function(noteHitArray) {
	            return noteHitArray._source.type === 'U';
	        });
	    },
	
	    /* Return true if there's a UTR note highlight and it has 'page text' */
	    _UTRNoteHasPageResults: function() {
	
	        if ( !this.docOnServerAndNoFetchErr() )
	            return false;
	
	        var utrNoteHit = this._getUTRNoteHitResponse();
	        if ( !utrNoteHit )
	            return false;
	
	        if ( !utrNoteHit.highlight )
	            return false;
	
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            // IE doesn't support find, startsWith ... can later rid
	            // _.findKey in later underscore version
	            var hasNoteHighlightKey = _.find(Object.keys(utrNoteHit.highlight), function (k) {
	                return k.substring(0, 5).indexOf('note_') > -1;
	            });
	
	            return hasNoteHighlightKey ? true: false;
	
	        } else {
	
	            return utrNoteHit.highlight.note ? true : false;
	
	        }
	
	    },
	    _hasAnyResults: function() {
	
	        if ( !this.docOnServerAndNoFetchErr() )
	            return false;
	
	        return _.filter( this._getAllNoteHits() , function(noteHitArray) {
	            return  _.contains( _.keys(noteHitArray), 'highlight');
	        }).length > 0;
	
	    },
	    _getDocNoteHitsResp: function() {
	
	        return this._getAllNoteHits().filter( function(noteHitArray) {
	            var noteType = noteHitArray._source.type;
	            return noteType === 'T' || noteType === 'X';
	        });
	
	    },
	
	    _getUTRNoteHighlightResponse: function() {
	        var utrNoteHit = this._getUTRNoteHitResponse();
	        return utrNoteHit ? utrNoteHit.highlight : null;
	    },
	    /*
	     *  Return _source of the document's utr note: should always exists with the combo of queries 1 and 2
	     *  (and should only be one).
	     *   -- though can run into issues, eg: (utr notes not getting written to ES -- DVBC-1147
	     *  Original purpose was to always return something to get the page text.
	     *  Return null if no utr notes have been written.
	     *  utrNoteHitsResponse would be null if utr notes aren't written
	     * */
	    _getDocumentPageSource: function() {
	        var utrNoteHitsResponse = this._getUTRNoteHitResponse();
	        return utrNoteHitsResponse
	            ? this._getUTRNoteHitResponse()._source
	            // case to handle issues for DVBC-1147
	            // (really only used to prevent run time error -- this should always return something otherwise blank searches or those with no hits will not work (DVBC-1154)
	            : null;
	    },
	
	    // Return the total # of hits.
	    getNumberOfHits: function() {
	
	        var allTextWithHits = this._getAllTextWithHits();
	        if (allTextWithHits === '')
	            return 0;
	
	        // Perform an extra check to ensure match doesn't return null; this can occur when using IDOL proxy,
	        // where allTextWithHits may not be blank if there are hits (DVBC-1114).
	        var aHitMatches = allTextWithHits.match(reHasHit);
	
	        return aHitMatches == null ? 0 : aHitMatches.length;
	
	    },
	
	    // Return the source of all 'highlights' from the note hit arrays.
	    // De-dupe metadata: (doc props, fc fields, etc) will exist in all note hits; just return those from the first.
	    // Used to calc total number of hits.
	    // Left as a fn for now; prob better to set & cache on parse, along with everything else -- its called multi time on the same search.
	    // REALLY NEED TO RE-WRITE THIS MODULE !
	
	    // See DVBC-1488 -- this # should be off but it appears to work:
	    // - not taking into account page text notes ('K') in set hits (so prob why these aren't counted)
	    // - previously could have been wrong if not accepting 'd' or 'x' values as printed from the search,
	    //      but that should now be fixed, (since using same search logic)
	
	    _getAllTextWithHits: function() {
	
	        var allNoteHitHighlights = this._getAllNoteHitHighlights();
	
	        if (!allNoteHitHighlights || allNoteHitHighlights.length < 1)
	            return '';
	
	        var txt = '';
	
	        // First get any 'metadata' (not notes) utilizing re-writing the logic from other fns.
	        // ( It's more complicated to parse the metadata for non-notes -- don't worry about dupes and the 'x' vs 'd' logic).
	
	        var fcFieldHighlightValues = _.values( this._getFCFields(1)).join(''),
	            docProperHighlightValues = _.values( this._getDocProperties(1)).join(''),
	            // Note - security & rma: these return an array so need to 'flatten'.
	            // Also note that non hit values are combined with hit values in this function -- though it shouldn't hurt anything other than negligible performance.
	            securityPropertyHighlightValues =  _.flatten( _.values( this._getSecurityOrRMAProperties(1, 1) )).join(''),
	            rmaPropertiesHighlightValues = _.flatten( _.values( this._getSecurityOrRMAProperties(1, 0) )).join('');
	
	        txt = fcFieldHighlightValues + docProperHighlightValues + securityPropertyHighlightValues + rmaPropertiesHighlightValues;
	
	
	        if ( this.getSchemaVersion() < 3 ) {
	
	            _.each( allNoteHitHighlights, function(noteHitHighlight) {
	                // noteHitHighlight can be undefined ...
	                for (var k in noteHitHighlight) {
	                    if (k.indexOf('note_') > -1)
	                        txt += noteHitHighlight[k][0]; // highlight values for the notes all appear to be arrays}
	                }
	
	            });
	
	        } else {
	
	            /**
	             * Version 3: can't use allNoteHitHighlights need to know if they come from Doc Notes or Page Text
	             * hits to know when to parse the delimited text for the Page Text.
	             * So this isn't the most efficent ...
	             */
	
	           /* UTR Note */
	
	            var utrNoteHighlights = this._getUTRNoteHighlightResponse();
	            if ( utrNoteHighlights ) {
	
	                var aUtrNotes = utrNoteHighlights.note;
	                if ( aUtrNotes ) {
	                    aUtrNotes.forEach( function( note ) {
	                        txt += UTRNoteVersion3TextParser.getPageText( note );
	                    });
	                }
	            }
	
	            /* Doc Notes */
	            var docNoteHits = this._getDocNoteHitsResp();
	            if ( docNoteHits && docNoteHits.length > 0 ) {
	                docNoteHits.forEach( function( docNoteHit ) {
	                    if ( docNoteHit.highlight && docNoteHit.highlight.note ) {
	                        txt += docNoteHit.highlight.note[0];
	                    }
	                });
	            }
	        }
	
	        return txt;
	
	    },
	    _getAllNoteHitHighlights: function() {
	
	        if ( !this._hasAnyResults() )
	            return null;
	
	        return _.pluck( this._getAllNoteHits(), 'highlight' );
	
	    },
	
	
	    /**
	     * num_pages: doesn't appear to exist if there are no pages in the document.
	     * Could also try looking at doc_pg_ids which would be an empty array if there are none in the UTR note.
	     * Note: this is only the number of pages, not including 'metadata'.
	     */
	    numberOfPgsInDoc: function() {
	
	        if ( !this.docOnServerAndNoFetchErr() )
	            return 0;
	
	        var docPageSrc = this._getDocumentPageSource();
	
	        return docPageSrc && docPageSrc.num_pages
	            ? docPageSrc.num_pages
	            : 0;
	
	    },
	    getFetchErr: function() {
	        return this.fetchErrorJQXHR;
	    },
	
	    /**
	     * This this is misleading if utr notes don't exist but text notes exist (DVBC-1147).
	     * Should really do a query for this but schema based on notes, not docs (which is going to change )
	     * Update -- this will not change, it's based on notes.
	     */
	    docNotOnESServer: function() {
	        return this.docNotOnES !== null;
	    },
	    errorOccurredOnFetch: function() {
	        return this.getFetchErr() !== null;
	    },
	    docOnServerAndNoFetchErr: function() {
	        return !this.docNotOnESServer() && !this.errorOccurredOnFetch();
	    },
	    isBlankSearch: function() {
	        return this.searchText === '';
	    },
	    // Note: now this really just sets a flag so the dfds don't run
	    abortAjaxRequests: function() {
	       
	        //TODO: get working ... 
	        //_.each( this.ajaxQueue, function(jqXHR) {
	        //    jqXHR.abort();
	        //});
	
	        // Don't resolve the fetch deferred -- will result in err on next doc render
	        this.fetchAborted = true;
	    },
	    getSearchTxt: function() {
	        return this.searchText;
	    },
	
	    getSchemaVersion: function() {
	        return this.schemaVersion;
	    }
	
	});
	
	
	//TODO: Underscore util
	function order(unordered)
	{
	    return _.object( _.sortBy( _.pairs( unordered), function(o){
	        return o[0]}
	    ));
	}

/***/ },
/* 404 */
/***/ function(module, exports) {

	var PAGE_TEXT_DELIMITER = ': ';
	
	
	/**
	 * Helper for parsing the text found in V3 UTR notes ( page text )
	 * Now not using as an Object -- but in just a functional manner -- could change to have state.
	 * Values come from the src our highlight note array in the form: "FDDPage 2: Lorem Ipsum...";
	 * Can't use split on the page text in case there's another ": "
	 */
	
	
	module.exports = {
	
	    getPageNumberAndText: function( rawText ) {
	
	        var delimiterIndex = rawText.indexOf( PAGE_TEXT_DELIMITER );
	        var pageDelimiter = rawText.substring( 0, delimiterIndex );
	
	        return {
	            pgNumber: parseFloat( pageDelimiter.split(' ')[1] ),
	            pgText: this.getPageText( rawText, delimiterIndex )
	        };
	
	    },
	
	    getPageText: function( rawText, delimiterIndex ) {
	
	        delimiterIndex = delimiterIndex || rawText.indexOf( PAGE_TEXT_DELIMITER );
	
	        return rawText.substring( delimiterIndex + PAGE_TEXT_DELIMITER.length );
	
	    }
	
	};
	
	
	
	


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    moment = __webpack_require__(69);
	
	/*
	* Model representing a DocumentLockStatus response from the server.
	* Sent as response body for document lock web services (status, lock, unlock),
	* as well as in the response body of 409 errors in failed transactions due to
	* the document being locked by another user.
	* Useful for showing a consistent error message due to documents being locked by another user.
	* */
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        "locked": null,
	        "userLockId": null,
	        "userLockName": null,
	        "userLockDescription": null,
	        "userLockFriendlyName": null,
	        "lockedByCurrentUser": null,
	        "lockedSince": null,
	        "docId": null,
	        "success": null // flag indicating if call to lock/unlock was successful
	    },
	
	    isLocked: function() {
	        return this.get('locked');
	    },
	
	    isLockedByOtherUser: function() {
	        return this.isLocked() && !this.get('lockedByCurrentUser');
	    },
	
	    /*
	    * Return the default error message displayed in alert dialogs.
	    * */
	    getDefaultErrorMessage: function() {
	        return 'Document locked by ' + this.getUserLockFriendlyName() +
	            ' since ' + moment.convertDBTimeToLocalTime( this.getLockedSince() ); //TODO: time from server appears off
	
	    },
	
	    getSuccess: function() {
	        return this.get('success');
	    },
	
	    getUserLockFriendlyName: function() {
	        return this.get('userLockFriendlyName');
	    },
	
	    getLockedSince: function() {
	        return this.get('lockedSince');
	    },
	
	    getDocId: function() {
	        return this.get('docId');
	    }
	
	
	});

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    DerivedWordModels = __webpack_require__(407);
	
	
	var DocumentTextModel = function() {
	
	    // Could also make these a classes or collection ( they are made of models ) ...
	
	    this.originalWordModels = null; // doc level array containing references to all the wdModels from the pages' positionalTextDataModels in order ( maybe we rid the latter )
	    this.derivedWordModels = null; // 'derived words' from their originals; combo words with dashed as one, remove empty words or those with only white-space
	    this.lineModels = null; // doc level array referencing line models from positionalTextDataModels
	    this.zoneModels = null; // doc level array referencing zones models from positionalTextDataModels
	
	    return this;
	};
	
	_.extend( DocumentTextModel.prototype, {
	
	
	    // Further processing of the page text data models augenting for ids at the document level.
	    // Now also create an array of original word models (document level) to facilitate getting original sub-words from words on > 1 page
	    // TODO: maybe we rid positionalTextDataModels -- they aren't really needed anymore --
	    // and should parse at the page level ...
	    // ... just store at the doc level w/functions
	    // Setting up a doc level id reference for the data-models
	    // Obviously not the fastest way to parse given already parsing with the page data models, but use
	    // this for now to not break ...
	
	    create: function( documentModel ) {
	
	        var pagesWithPositionalData = documentModel.pageCollection.pagesWithPositionalData(), // (already parsed)
	            originalWdModels = this.originalWordModels = [],
	            originalLineModels = this.lineModels = [],
	            originalZoneModels = this.zoneModels = [],
	            nZones = 0,
	            nLines = 0,
	            nWords = 0;
	
	        _.each( pagesWithPositionalData, function( page ) {
	
	            var pageTextDataModel = page.getPositionalTextDataModel();
	
	            pageTextDataModel.zones.each( function( zone ) {
	
	                zone.set({
	                    id: nZones
	                });
	                originalZoneModels.push( zone );
	
	                _.each( zone.getPageLevelLineIds(), function( pgLineId ) {
	
	                    var line = pageTextDataModel.getLine( pgLineId );
	
	                    line.set({
	                        id: nLines
	                    });
	
	                    originalLineModels.push( line );
	
	                    _.each( line.getPageLevelWordIds(), function( pgWordId ) {
	
	                        var word = pageTextDataModel.getWord( pgWordId );
	
	                        word.set({
	                            id: nWords,
	                            docLevelLineId: nLines,
	                            docLevelZoneId: nZones
	                        });
	
	                        originalWdModels.push( word );
	
	                        line.addDocLevelWordId( nWords );
	                        zone.addDocLevelLineId( nLines );
	                        zone.addDocLevelWordId( nWords );
	
	                        nWords++;
	
	                    });
	
	                    nLines++;
	
	                });
	
	                nZones++;
	
	            });
	
	        });
	
	
	        // Create the derived word models -- we search off these
	        this.derivedWordModels = new DerivedWordModels( pagesWithPositionalData );
	
	        // Set a link from the derive sub-words their original parent
	        _.each( this.derivedWordModels.getDerivedWords(), function( derivedWord ) {
	
	            var derivedWdId = derivedWord.id;
	
	            _.each( derivedWord.get('subWordReferences'), function(subWordReference) {
	
	                // Wrap original in collection/class ??
	                var originalWdModel = _.find( originalWdModels, function(m) {
	                    return m.id === subWordReference.originalId;
	                });
	
	                originalWdModel.set( 'derivedParentId', derivedWdId );
	
	            });
	
	        });
	
	        return this;
	
	    },
	
	    getOriginalWordModels: function() {
	        return this.originalWordModels;
	    },
	
	    // Note: these can be derived and will have different ids than originals on the positional page models
	    getDerivedWordModels: function() {
	        return this.derivedWordModels.getWords();
	    },
	
	    getLineModels: function() {
	        return this.lineModels;
	    },
	
	    getZoneModels: function() {
	        return this.zoneModels;
	    },
	
	    getOriginalWordModelById: function( docLevelWdId ) {
	
	        return _.find( this.getOriginalWordModels(), function( word ) {
	            return word.id === docLevelWdId;
	        });
	    }
	
	});
	
	
	
	module.exports = DocumentTextModel;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	
	var _ = __webpack_require__(49),
	    TextBox = __webpack_require__(350),
	    DerivedWordModel = __webpack_require__(408);
	
	
	/**
	 * These are the 'derived' word model from the create from pages' positional text data models.
	 * A mixture of 'original' and 'derived' words
	 * Avoiding a Backbone Collection now due to overhead, wanting to rid Backbone, and existing logic implemented for an array.
	 * Really a 'wrapper class' for the array.
	 * 1) Combines words with dashes
	 * 2) Removes words that are just white space or are empty.
	 */
	
	
	function DocumentWordModels( aPagesWithPositionalData ) {
	
	    this.words = [];
	
	    if ( aPagesWithPositionalData && aPagesWithPositionalData.length > 0 ) {
	        this.setWords( aPagesWithPositionalData );
	    }
	
	}
	
	
	_.extend( DocumentWordModels.prototype, {
	
	
	    setWords: function( aPagesWithPositionalData ) {
	
	        var allWords = this._getAllWordModels( aPagesWithPositionalData );
	
	        // Filter out any words that are empty or only contain white-space
	        // https://stackoverflow.com/questions/17524290/how-to-check-for-string-having-only-spaces-in-javascript
	        // We don't want to include or search for words that are whitespace or empty
	        // This is an outlier but may as well nip in the bud with this new design with a one-liner,
	        // Just in case
	        allWords = _.reject( allWords, function(word) {
	            return /^\s*$/.test( word.get('wd') );
	        } );
	
	        // Create combined words from dashes
	        this.words = this.squashDashes( allWords );
	
	        // Set the document level ids of all the word models after they are 'squashed'
	        _.each( this.words, function(word, i) {
	            word.set('id', i);
	        });
	
	        // Post-process 'derived' words -- again could be more efficient with squashDashes/combo
	        var combinedWords = this.getDerivedWords();
	
	        _.each( combinedWords, function( word ) {
	
	            word.postProcessCombinedWord();
	
	        });
	
	        // inspection:
	        // viewer.activeDocument.derivedWordModels.words.filter( w => w.get('isDerived') ).map( w => w.get('subWordReferences').map( sw => JSON.stringify(sw) ))
	
	    },
	
	    getWords: function() {
	
	        return this.words;
	
	    },
	
	    getDerivedWords: function() {
	
	        return _.filter( this.words, function( word ) {
	           return word.get('isDerived');
	        });
	
	    },
	
	    // ('Non-derived')
	    _getAllWordModels: function( aPagesWithPositionalData ) {
	
	        return _.reduce( aPagesWithPositionalData, function( allWordModels, page ) {
	            return allWordModels.concat( page.getPositionalTextDataModel().getWords().models );
	        }, [] );
	
	    },
	
	    // Adapted from dash-test
	    squashDashes: function( aWordModels ) {
	
	        // First create array from the original 'combining' words that start with a dash
	        // with the those before them.
	        var aDashStart = [];
	
	        for ( var i=0; i< aWordModels.length ; i++ ) {
	
	            var currentWord = aWordModels[i];
	            var startsWithDash = currentWord.get('wd')[0] === '-'; // Can put on the word model
	
	            if ( startsWithDash ) {
	
	                var lastDerivedWdIndex = aDashStart.length-1;
	                var prevDerivedWd = aDashStart[lastDerivedWdIndex];
	
	                if ( prevDerivedWd ) {
	
	                    aDashStart[lastDerivedWdIndex] =
	                        new DerivedWordModel( prevDerivedWd, currentWord, 1 );
	
	                } else {
	
	                    aDashStart.push( currentWord );
	                }
	
	            }
	
	            else {
	                aDashStart.push( currentWord );
	            }
	
	        }
	
	        // Take the first array and loop through backwards, combining words that end with a dash
	        // and those before them.
	        var aEndsWith = [];
	
	        for ( var i= aDashStart.length - 1; i >-1 ; i-- ) {
	
	            var currentWord = aDashStart[i];
	            var currentWordTxt = currentWord.get('wd');
	            var endsWithDash = currentWordTxt[currentWordTxt.length - 1] === '-'; // can be fn of word
	
	            if ( endsWithDash ) {
	
	                var lastDerivedWdIndex = aEndsWith.length-1;
	                var prevDerivedWd = aEndsWith[lastDerivedWdIndex];
	
	                if ( prevDerivedWd ) {
	
	                    aEndsWith[lastDerivedWdIndex] =
	                        new DerivedWordModel( prevDerivedWd, currentWord, 0 );
	
	
	                } else {
	                    aEndsWith.push( currentWord );
	                }
	
	            } else {
	
	                aEndsWith.push( currentWord );
	            }
	
	        }
	
	
	        return aEndsWith.reverse();
	
	    }
	
	
	    // troubleshooting snippet:
	    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( w => w.get('isDerived') ).map( w => JSON.stringify( w.get('subwordIds' ) ) )
	    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( w => w.get('isDerived') ).map( w => JSON.stringify(w.get('subwordPageLevelKeys' )) )
	
	    // eg -- debug words spit on different lines
	    // viewer.request('activeDocumentTextModel').getDerivedWordModels().filter( m => m.get('isMultiLine' ) ).map( m => ({ wd: m.get('wd'), page: m.get('pageNumber') }) )
	
	});
	
	
	
	
	module.exports = DocumentWordModels;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var WordModel = __webpack_require__(354),
	    Box = __webpack_require__(350),
	    SubWordReference = __webpack_require__(409);
	
	
	var modelDefaults =  _.extend( {}, WordModel.prototype.defaults, {
	
	    isDerived: true,
	
	    isMultiPage: false,
	    isMultiLine: false,
	    isMultiZone: false,
	
	    // Could rid -- used to create subWordReferences in squashes dashes routine
	    subwordIds: [],
	    subwordPageLevelKeys: [], // currently for debug -- don't think necessary here
	
	    subWordReferences: [] // id's back to reference the subwords
	
	});
	
	// Ignore values that have no meaning here -- explicitly remove from the defaults
	modelDefaults = _.omit( modelDefaults,
	    'boxPx', 'boxFDDZoneUnits', 'derivedParentId',
	    'page_level_id', 'page_level_key',
	    'pageLevelLineId', 'pageLevelLineWordId', 'pageLevelZoneId', 'pageLevelZoneLineId', 'pageLevelZoneWordId'
	);
	
	
	module.exports = WordModel.extend({
	
	    defaults: modelDefaults,
	
	    // Really just want to set the attributes from a combo of each as pass to Backbone Model constructor
	    // Now only created from the derived words sqashed dash routine
	    constructor: function( word1, word2, word1TextFirst ) {
	
	
	        var wd = word1TextFirst
	            ? word1.get('wd') + word2.get('wd')
	            : word2.get('wd') + word1.get('wd');
	
	        var isTextSanitized = word1.get('isTextSanitized') || word2.get('isTextSanitized');
	
	        // Prob not necessary -- but stored the originalWdText for derived word ( may be good for debug )
	        var originalWd = isTextSanitized
	            ? getOriginalWdText( word1, word2, word1TextFirst )
	            : null; // ( don't attempt if N/A )
	
	        /**
	         * subwordIds, subwordPageLevelKeys are temporary; used to create subWordReferences
	         * Could do some of the work in post-process but that's less clear and only provides a negligible performance boost
	         * Note: need to include  word.get('subwordIds') in addition to the word ids here -- eg if '-' and combo, if won't carry over those added in previous iteration
	         */
	
	        var subwordIds =
	            ensureArray(word1.get('subwordIds')).concat(
	                ensureArray(word2.get('subwordIds')), [word1.id, word2.id]
	            );
	        subwordIds = _.reject(subwordIds, function (i) {
	            return i === null;
	        }); // can be null if derived and not yet set ( would be word 1 or 2)
	        subwordIds = _.unique(subwordIds);
	        subwordIds = _.sortBy(subwordIds, function (i) {
	            return i;
	        });
	
	        var subwordPageLevelKeys =
	            ensureArray(word1.get('subwordPageLevelKeys')).concat(
	                ensureArray(word2.get('subwordPageLevelKeys')), [word1.get('page_level_key'), word2.get('page_level_key')]
	            );
	        subwordPageLevelKeys = _.reject(subwordPageLevelKeys, function (i) {
	            return i === null;
	        });
	        subwordPageLevelKeys = _.unique(subwordPageLevelKeys); // not really necessary
	        subwordPageLevelKeys = _.sortBy(subwordPageLevelKeys, function (i) {
	            return i;
	        }); // not really necessary
	
	
	        var pageId = getUniqueArrayFromArrayOrItems(word1.get('pageId'), word2.get('pageId'), 1);
	        var pageNumber = getUniqueArrayFromArrayOrItems(word1.get('pageNumber'), word2.get('pageNumber'), 1);
	        var docLevelLineId = getUniqueArrayFromArrayOrItems(word1.get('docLevelLineId'), word2.get('docLevelLineId'), 1);
	        var docLevelZoneId = getUniqueArrayFromArrayOrItems(word1.get('docLevelZoneId'), word2.get('docLevelZoneId'), 1);
	
	
	        WordModel.call(this, {
	
	            wd: wd,
	            originalWd: originalWd,
	            isTextSanitized: isTextSanitized,
	
	            subwordIds: subwordIds,
	            subwordPageLevelKeys: subwordPageLevelKeys,
	
	            pageId: pageId, // (array if > 1 )
	            pageNumber: pageNumber, //(array if > 1 )
	            docLevelLineId: docLevelLineId, //(array if > 1 )
	            docLevelZoneId: docLevelZoneId, // array if > 1
	
	            isMultiPage: pageId instanceof Array,
	            isMultiLine: docLevelLineId instanceof Array,
	            isMultiZone: docLevelZoneId instanceof Array,
	
	            boxPxDerived: word1.get('boxPxDerived').combo(word2.get('boxPxDerived')),
	            boxFDDZoneUnitsDerived: word1.get('boxFDDZoneUnitsDerived').combo(word2.get('boxFDDZoneUnitsDerived'))
	
	
	        });
	
	
	        function ensureArray(a) {
	            return a
	                ? a instanceof Array
	                ? a
	                : [a]
	                : [];
	        }
	
	        // Now will also return string if only one item
	        // And if not array, just return 1
	        function getUniqueArrayFromArrayOrItems(a, b, sort) {
	
	            var aArray = a instanceof Array ? a : [a];
	            var bArray = b instanceof Array ? b : [b];
	            var combinedUniqueArray = _.unique(aArray.concat(bArray));
	
	            if (combinedUniqueArray.length === 1)
	                return combinedUniqueArray[0];
	
	            return !sort
	                ? combinedUniqueArray
	                : _.sortBy(combinedUniqueArray, function (i) {
	                return i;
	            });
	        }
	
	        // Not as simple as getting the wd: word1 or word2 may not have sanitized text,
	        // so it can be a combo of wd and originalWord.
	        function getOriginalWdText( word1, word2, word1TextFirst ) {
	
	            var word1Txt = word1.get('isTextSanitized')
	                ? word1.get('originalWd')
	                : word1.get('wd');
	
	            var word2Txt = word2.get('isTextSanitized')
	                ? word2.get('originalWd')
	                : word2.get('wd');
	
	            return word1TextFirst
	                ? word1Txt + word2Txt
	                : word2Txt + word1Txt;
	
	         }
	
	
	    },
	
	    postProcessCombinedWord: function() {
	
	        var pageId = this.get('pageId');
	        var pageNumber = this.get('pageNumber');
	
	        var subWordReferences = _.map( this.get('subwordIds'), function(subWordId, i) {
	
	            return new SubWordReference({
	                originalId: subWordId,
	                pageLevelKey: this.get('subwordPageLevelKeys')[i],
	                parentId: this.id,
	                pageId: pageId instanceof Array ? pageId[i] : pageId,
	                pageNumber: pageNumber instanceof Array ? pageNumber[i] : pageNumber
	            });
	
	        }, this);
	
	
	        this.set( 'subWordReferences', subWordReferences );
	
	
	    },
	
	    // Should never get here
	    parse: function(attrs) {
	
	        return attrs;
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 409 */
/***/ function(module, exports) {

	
	
	// Really a reference -- forget BB model here ...
	
	module.exports = function( options ) {
	
	    this.originalId = options.originalId;
	    this.pageLevelKey = options.pageLevelKey;
	    this.parentId = options.parentId;
	
	    this.pageId = options.pageId;
	    this.pageNumber = options.pageNumber;
	
	};
	


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	/**
	 * Sub-object of the document model.
	 * With Feith Drive permissions, these are at the document level.
	 */
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        "addPages": false,
	        "deletePages": false,
	        "reorderPages": false,
	        "rotatePages": false,
	        "createPageNotes": false,
	        "createDocumentNotes": false,
	        "modifyOrDeleteNotes": false,
	        "createHighlights": false,
	        "modifyOrDeleteHighlights": false
	    },
	
	    canAddPages: function() {
	        return this.get('addPages');
	    },
	
	    canDeletePages: function() {
	        return this.get('deletePages');
	    },
	
	    canReorderPages: function() {
	        return this.get('reorderPages');
	    },
	
	    // Currently undecided if Feith Drive perm weighs on this
	    canSavePageRotation: function() {
	       return 1;
	        //return this.get('rotatePages');
	
	    },
	    /* All page notes except highlight  */
	    canCreatePageNotes: function() {
	        return this.get( 'createPageNotes' );
	    },
	
	    canCreateDocNotes: function() {
	        return this.get('createDocumentNotes');
	    },
	
	    /* Applicable to both doc and page notes -- except Highlights */
	    canModifyOrDeleteNotes: function() {
	        return this.get('modifyOrDeleteNotes');
	    },
	
	    canCreateHighlights: function() {
	        return this.get('createHighlights');
	    },
	
	    canModifyOrDeleteHighlights: function() {
	        return this.get('modifyOrDeleteHighlights');
	    }
	
	
	});

/***/ },
/* 411 */
/***/ function(module, exports) {

	'use strict';
	
	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function (obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function (obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	var isString = function isString(val) {
	  return typeof val === 'string';
	};
	
	var isBlob = function isBlob(val) {
	  return val instanceof Blob;
	};
	
	polyfill.call((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' ? window : undefined || {});
	
	function polyfill() {
	  if (isSupported.call(this)) return;
	  if (!('navigator' in this)) this.navigator = {};
	  this.navigator.sendBeacon = sendBeacon.bind(this);
	}
	
	function sendBeacon(url, data) {
	  var event = this.event && this.event.type;
	  var sync = event === 'unload' || event === 'beforeunload';
	  var xhr = 'XMLHttpRequest' in this ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
	  xhr.open('POST', url, !sync);
	  xhr.withCredentials = true;
	  xhr.setRequestHeader('Accept', '*/*');
	
	  if (isString(data)) {
	    xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
	    xhr.responseType = 'text/plain';
	  } else if (isBlob(data) && data.type) {
	    xhr.setRequestHeader('Content-Type', data.type);
	  }
	
	  try {
	    xhr.send(data);
	  } catch (error) {
	    return false;
	  }
	
	  return true;
	}
	
	function isSupported() {
	  return 'navigator' in this && 'sendBeacon' in this.navigator;
	}


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(413);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    DocModeContainer = __webpack_require__(414),
	    PgModeContainer = __webpack_require__(461),
	    PDFModeContainer = __webpack_require__(475),
	    NoPagesView = __webpack_require__(480);
	
	__webpack_require__(114);
	__webpack_require__(60);
	
	
	/**
	 * Not using composite view -- want this rendered prior to rendering the pages
	 * (don't know scale b/f hand )
	 */
	
	var lChEventFwds =
	    [   'noteSaved', 'expandedNoteChange', 'activeNoteSubTypeChange', 'toggleHighlightedNote',
	        'noteDeleted', 'setDrawColor', 'setStrokeWidth', 'closeCanvasDialogs',
	        'graphicStampChanged', 'consultGroupChange', 'applyAllRedactionsToggled', 'repositionShapeDialog', 'reRenderShapes'
	    ];
	
	
	module.exports = Marionette.LayoutView.extend({
	    className: 'FV-center-inner',
	    template: __webpack_require__(483),
	    onRender: Backbone.View.prototype.unwrap,
	
	    /**
	     * @param options: vChannel, initialViewMode, channelName
	     * Temp -- make sub app ... not much comm -- if just extend
	     * TODO:
	     * - if just extend, doesn't put on Radio proto -- doesn't have a channel itself -- so can't use Radio top level API
	     * - want to listen off channel for testing -- no explicit reference to know
	     */
	    initialize: function(options) {
	
	        _.extend( this, Backbone.Radio.Channel.prototype, options );
	
	        /*
	         * Bridge For Forwarding Viewer Events to the Page Canvas (not calling directly on it)
	         * TODO: should rename to canvas channel or something or use the mixed in channel.
	         * -- this get's wired to pageCanvas channel's ( clean up ; I don't think all are necessary
	         * why do we care about this commands ???
	         */
	        this.viewMdsCh = Backbone.Radio.channel('viewCanvasBridge: ' + this.cid);
	
	        Backbone.fwdFnsOnObjAsFn.apply(this, [this.viewMdsCh, 'trigger', lChEventFwds, this.commands]);
	
	        this.comply(this.commands, this);
	        this.reply(this.requests, this);
	
	    },
	    regions: {
	        docModeContainer:   '.FV-region-docMode',
	        pgModeContainer:    '.FV-region-pgMode',
	        pdfContainer:       '.FV-region-pdfMode',
	        noPagesOverlay:     '#noPagesOverlay'
	    },
	    serializeData: function() {
	        return {
	            viewModeClass: this.initialViewMode + '-mode', // the initial viewMode
	            documentHasNoPages: this.documentHasNoPages
	        };
	    },
	    commands: {
	
	        // Note: filtered for drawable notes
	        activeNoteChange: function(note, options) {
	
	            var pgModeContainer = this.pgModeContainer.currentView;
	            pgModeContainer.toggleDrawingMode.apply(pgModeContainer, arguments);
	
	        },
	
	        /**
	         * Re-render the shape of the canvas.
	         * Intermediate step for floating reason codes - forceDerivisionOfPageModeDomElements:
	         * - If 'entering' search and its a floating redaction note, ensure page mode
	         * isn't hidden via CSS.  If this is the case, box dimensions are not derived correctly
	         * for floating redactions.  Issue encountered and what this resolves ( thus far ), is:
	         * If the page was already loaded in page mode, then user moves to another mode, and does a search,
	         * upon re-entry to page mode the box sizing is incorrect because boxes don't yet have 'position' ( same now true of adding a search )
	         * ( in this case they are drawn at default position, but the DOM hidden ).
	         * Tried other solutions but this is by far the simplest.
	         * Don't want to muck around with changing CSS for the modes from 'display:none' to 'visibility',
	         * as that may break other parts of the application.
	         * Could also only do if the page is loaded to emphasize the problem, but this is not intensive and that's probably overkill.
	         * Could make generic function if useful in other areas -- eg: could be a solution to 'saving notes' from the hidden
	         * canvas view in a different mode, however solution for that is working and fairly simple.
	         * New: also necessary for adding and removing searches -- would encounter the same problem.
	         */
	        redrawCanvasForFindAndRedact: function( findAndRedactSearchModel ) {
	
	            var forceDerivisionOfPageModeDomElements =
	                this.vChannel.request('viewMode') !== 'page' && // page hadn't loaded ?
	                findAndRedactSearchModel &&
	                findAndRedactSearchModel.searchHasResults() &&
	                findAndRedactSearchModel.get( 'searchResults' ).hasHitsFromFloatingRedactionNotesOnPage( this.vChannel.request('currentPage').get('pageId') );
	
	
	            if ( forceDerivisionOfPageModeDomElements ) {
	                this.command( 'toggleForceDerivisionOfPageModeDomElements', 1 );
	            }
	
	
	            this.viewMdsCh.trigger('reRenderShapes');
	
	
	            if ( forceDerivisionOfPageModeDomElements ) {
	                this.command( 'toggleForceDerivisionOfPageModeDomElements', 0 );
	
	            }
	
	
	        },
	
	        toggleForceDerivisionOfPageModeDomElements: function( on ) {
	            on
	                ? this.$el.addClass('page-mode-not-hidden-and-visible')
	                : this.$el.removeClass('page-mode-not-hidden-and-visible');
	        },
	
	        renderPgModePgView: function( fullPageModel ) {
	
	            this.pgModeContainer.currentView.renderNewPageView( fullPageModel );
	
	        },
	        // Note: synchronous
	        renderPDFMode: function(docHasNoPDFRenderablePgs) {
	
	            return this.getRegion('pdfContainer').show( new PDFModeContainer({
	                docHasNoPDFRenderablePgs: docHasNoPDFRenderablePgs,
	                vChannel: this.vChannel,
	                lCh: this.viewMdsCh
	            }) );
	
	        },
	        // Note: synchronous
	        renderNoPagesView: function() {
	            return this.getRegion('noPagesOverlay').show( new NoPagesView() ) ;
	        },
	
	        /**
	         * Blocked from atop if PDF mode.
	         * Shouldn't happen but if settings disable Doc Mode and somehow it is set, check to see if it exists --
	         * event would be better here ...
	         */
	        changeScale: function( mode, scale, prevScale, scaleModel, options ) {
	
	            var isDocMode = mode === 'document';
	
	            if ( isDocMode && !this.docModeViewRendered() ) {
	                return;
	            }
	
	            this.getRegion( (mode === 'document' ? 'doc': 'pg') + 'ModeContainer' )
	                .currentView.postScaleChange( scale, prevScale, options );
	
	        },
	
	        // Should trigger off internal channel ...
	        scaleTypeChange: function() {
	            this.pgModeContainer.currentView.postScaleTypeChange();
	        },
	
	        setViewMode: function(mode, prevMode) {
	            this.$el.removeClass(prevMode  + '-mode').addClass( mode +  '-mode');
	        },
	
	
	        /**
	         * Need to check existence Doc Mode Container Viewer -- with logic current view may not yet be set --
	         * or viewer loaded with settings that wouldn't render it.
	         * Can now change to Util.blindForward ...
	         */
	        docModeChangePage: function( loadImages ) {
	
	            Marionette.blindTriggerOn( this.getRegion('docModeContainer').currentView, 'changePage', loadImages );
	
	        }
	    },
	    requests: {
	        docModeViewOfPg: function(pg) {
	
	            if ( !this.docModeViewRendered() ) {
	                return null;
	            }
	
	            // Here could also use Util.blindForward
	            return this.getRegion('docModeContainer').currentView.children.findByModel( pg );
	        },
	        pgModeView: function() {
	            return this.getRegion('pgModeContainer').currentView.getRegion('pageView').currentView;
	        },
	
	        renderDocContainer: function( pageCollection ) {
	
	            var docModeRegion = this.getRegion('docModeContainer'),
	                vChannel = this.vChannel,
	                viewMdsCh = this.viewMdsCh;
	
	            return $.Deferred(function($dfd) {
	
	                 var docModeView = new DocModeContainer({
	                     collection: pageCollection,
	                     vChannel: vChannel,
	                     viewMdsCh: viewMdsCh
	                 });
	                 docModeView.onShow = _.partial($dfd.resolve, docModeView);
	                 docModeRegion.show(docModeView);
	
	            }).promise();
	
	        },
	
	        /* renders the view -- once in main WF to calc scale -- no image is loaded */
	        initialPgModeViewRender: function(options) {
	
	           var pgModeRegion = this.getRegion('pgModeContainer'),
	               viewMdsCh = this.viewMdsCh;
	
	            return $.Deferred(function($dfd) {
	                 var pgModeView = new PgModeContainer( _.extend(options, {
	                     viewMdsCh: viewMdsCh
	                 }));
	                 pgModeView.onShow = _.partial($dfd.resolve, pgModeView);
	                 pgModeRegion.show(pgModeView);
	            }).promise();
	
	        },
	        pdfWrapper: function() {
	            return this.viewMdsCh.request('pdfWrapper');
	        },
	        /**
	         * Link to canvas -- current pg of either mode
	         * Call of note, scale should be on there ...
	         * Now only applicable to page mode -- will get error if use for document and doc mode wasn't created ( docModeViewRendered )
	         */
	        getCanvasShapeAttrs: function(note, scale, viewMode ) {
	
	            var pageCanvasCh = viewMode === 'document'
	                ? this.request( 'docModeViewOfPg', note.getPageModel() ).canvas.pageCanvasCh
	                : this.request( 'pgModeView').canvas.pageCanvasCh ;
	
	            return pageCanvasCh.request.apply( pageCanvasCh, ['getShapeAttrsToPersist', note, scale] );
	
	        }
	
	    },
	
	    /** Utilize this here instead of breaking into SubApps and a more
	     * obtrusive refactor; this is like an intermediate refactor.
	     * Doc Mode may now not exist -- we could employ a better or similar patter for the other mode views,
	     * but currently has no reason not to render them.
	     * ( Would want for requests -- alternative is events, blindTriggers, and now Util.blindForward ... ).
	     */
	    docModeViewRendered: function() {
	        return this.getRegion('docModeContainer').hasView();
	
	    },
	
	    onBeforeDestroy: function() {
	
	        Backbone.Radio.Channel.prototype.reset.call(this);
	        this.viewMdsCh.reset();
	
	    },
	    destroy: function() {
	
	        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
	        this.$('*').remove();  // clear ref's from jq cache -- el and $el still ref'd
	
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 413 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    BaseContainer = __webpack_require__(415),
	    $ = __webpack_require__(59),
	    DocPgImgWr = __webpack_require__(416),
	    UnRenderablePg = __webpack_require__(452).document,
	    UrlPg = __webpack_require__(455);
	
	__webpack_require__(457);
	__webpack_require__(458);
	
	
	// Note: common code with thumb-mode container here
	
	
	module.exports = Marionette.CompositeView.extend({
	
	    lazyLoadDelay: 200,   // Delay also prevents from loading too many images
	    scrollThrottle: 200,  // There is also a queue of max images to load
	
	    constructor: function(options) {
	
	        // Prevent need to pass in option -- greatly optimizes for pages with large documents
	        this.sort = false;
	
	        // From old initialize:
	        _.extend( this, BaseContainer );
	
	        this.scale = {};
	        this.collection = options.collection;
	        this.lastScrollTop = 0;
	        this.pageChangedFromScroll = false;  // Leave here for now: this needs cleanup --
	
	        Marionette.CompositeView.prototype.constructor.apply( this, arguments );
	
	    },
	
	    getChildView: function(model) {
	        
	        if ( model.renderUrlViewForDocAndPageMode() ) {
	            return UrlPg;
	        } else {
	            return model.isRenderable()
	                ? DocPgImgWr
	                : UnRenderablePg;
	        }
	        
	    },
	    template:  __webpack_require__(460),
	    childViewContainer: '.FV-paneContent',
	    childViewOptions: function() {
	        return {
	            scale: this.scale,
	            vChannel: this.options.vChannel
	        };
	    },
	
	    serializeData: function() {
	        return {
	            docOrPg: 'doc'
	        };
	    },
	
	    /* Override Render Children (Don't Yet know Scale */
	    render: function() {
	        this._ensureViewIsIntact();
	        this.isRendered = true;
	        this.resetChildViewContainer();
	        this.triggerMethod('before:render', this);
	        this._renderTemplate();
	        this.triggerMethod('render', this);
	        return this;
	    },
	    onRender: function() {
	        this.unwrap();
	        this.$el.scrollTop(0).dragScoller(); // note: onShow used in WF promise -- must use here
	    },
	
	    /* when called from viewer, vOffsets are now set */
	    onRenderPages: function(scale) {
	
	        this.scale = scale; // must set for childView options
	        this._renderChildren();
	
	        // DVBC-1444: ensure the current page is scrolled to on load after viewer reset from pages added/deleted
	        this.scrollToCurrentPageTop();
	
	        // Apply lazy load plugin in bulk to all the element  -- DOM related
	        // Note: this.$ would work --
	        // could filter for renderable children ...
	        $(this.children.pluck('el')).lazyLoad({
	            container: this.$el,
	            delay: this.lazyLoadDelay,
	            skipClass: 'invisible'
	        });
	
	        this.checkForPagesInView();
	
	    },
	    events: {
	        'scroll': 'scrollCB'
	    },
	    scrollCB: function(e) {
	        this.options.vChannel.command('forceClosePageActionDropdownMenus'); // could just call if any of them open
	        _.throttle(this.pageScrollThresholdCheck(e), this.scrollThrottle) ;
	    },
	    scrollToCurrentPageTop: function() {
	
	        var vCh = this.options.vChannel;
	
	        /**
	         *  Commenting out exiting the routine if viewer not loaded to allow for scrolling
	         *  to the current page if it isn't the first in the document.
	         *  Perf. downside minimal, which is probably why put in, in the first place.
	         *  On load process, this is called from callbacks in 'postScaleChange' event listeners.
	         *  Perhaps better to call explicitly -- if so, appears should call at the end of this.onRenderPages
	         *  (page vOffsets are set immediately after it is called)
	         */
	        //if ( !vCh.request('viewerLoaded')) return;
	
	
	        // this is coming from the scroll event check
	        if ( this.pageChangedFromScroll ) {
	            this.pageChangedFromScroll = false; //set the variable back here: AFTER THE PAGE HAS CHANGED !
	            return;
	        }
	
	        // Leave for now : don't scroll more is already scrolling by grab --
	        // The page number change is still set by this view's events
	        // TODO: uncouple the data attribute
	        if (this.$el.data('dragging') === true)
	            return;
	
	        this.$el.scrollTop(
	            this.children.findByModel( vCh.request('currentPage')).$el.position().top
	        );
	
	    },
	    checkForPagesInView: function() {
	        var allowImagesToLoad =  this.options.vChannel.request('loadImages');
	        allowImagesToLoad && this.$el.trigger('checkInView');
	    },
	
	    // Used to see if should move to next/prev page after a scroll event (if we pass a threshold )
	    // The 'OLD' prob is when it can never get there!
	    pageScrollThresholdCheck: function() {
	
	        var currentScrollTop = this.$el.scrollTop(),
	            dy = currentScrollTop - this.lastScrollTop,
	            vCh = this.options.vChannel;
	
	        this.lastScrollTop = currentScrollTop;
	
	        if ( dy === 0 ) {
	            return;
	        }
	
	        if (dy > 0) { // scrolldown
	
	            var currentPgScrollThreshold =  vCh.request('currentPage').get('vOffset');
	            if (currentScrollTop > currentPgScrollThreshold) {
	
	                var nextPage = vCh.request('nextPage');
	                if (nextPage) { // if not on last page -- trigger to change the current page to the next
	                    this.pageChangedFromScroll = true;
	                    vCh.command('goToPage', nextPage);
	                }
	            }
	
	        }  else if (dy < 0) { //scrollup : dy would be negative
	
	            var prevPg = vCh.request('prevPage');
	            if (prevPg) {
	
	                // When most of first page visible -- scroll  -- this fixes for now!  (I think need the padding amt)
	                // Rounding issues, can't get around here; err on the side of this not being the case -- 10 is a buffer for now  (see above)
	                var prevPgThreshold = prevPg.get('vOffset') - Math.round((this.$el.height()/2)) - 10;
	
	                if (currentScrollTop < prevPgThreshold) {
	                    this.pageChangedFromScroll = true;
	                    vCh.command('goToPage', prevPg);
	                }
	            }
	        }
	    },
	
	    /**
	     * TODO: pass from mediator with vars .. clean -- pass scale Model and other params here? -- higher up
	     * (has already changed)
	     * First check if scale is fit-height, if so, set the scale prior to changing the page.
	     * Need to do this for pages of var height (now using actual heights )
	     */
	    onChangePage: function(options) {
	
	        var vCh = this.options.vChannel;
	
	        if ( this.scale.scaledTypeIsDerived() ) {
	
	            if (!this.pageChangedFromScroll) {  // changed from scroll, don't set scale (time being) -- during this process, things may have changed from scroll
	
	                vCh.command('setScale');
	                this.scrollToCurrentPageTop();
	
	            } else {
	
	                //still must scroll to page if not from scroll  -- sets the pg and calls events ( from scroll enter? )
	                this.scrollToCurrentPageTop();
	            }
	
	        } else {
	
	            this.scrollToCurrentPageTop();
	        }
	
	        options.loadImages &&
	            vCh.command('handleDocModeImgPrefetching', vCh.request('currentPage'));
	
	    },
	
	    postScaleChange: function(scale, prevScale, options) {
	
	        var fromPageRotation = options && options.fromRotation;
	
	        this.children.call('updateViewPort', scale);
	
	        // TODO: this should be moved up
	        // ... do immediatley post change change to get the new offsets  ???
	        this.collection.setVOffsets(scale); // need to update the offsets for scrolling after the scale change
	
	        // I think we want if from rotation so commenting out; forgot why was put in ...
	        // If not could rotate, and then appear to be on a different page
	        //if ( !fromPageRotation )
	            this.scrollToCurrentPageTop();
	
	        if ( (scale < prevScale) || fromPageRotation )
	            this.checkForPagesInView();
	
	    },
	
	    onBeforeDestroy: function() {
	        this.$el.destroyDragScroller();
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(59);
	
	
	// TODO: move all these up ...
	// Keyboard events: mousestrap and bbplugin to dele. events
	
	module.exports = {
	
	    keyboardEvents: {
	        'down'      : 'keyScroll',
	        'up'        : 'keyScroll',
	        'left'      : 'keyScroll',
	        'right'     : 'keyScroll',
	        'pageup'    : 'pageKeyCB',
	        'pagedown'  : 'pageKeyCB',
	        'end'       : 'pageKeyCB',
	        'home'      : 'pageKeyCB'
	    },
	
	    pageKeyCB: function(e, key) {
	
	        var vCh = this.options.vChannel;
	
	        switch(key) {
	
	            case 'pageup':
	                vCh.command('goPrevPage');
	                break;
	
	            case 'pagedown':
	                vCh.command('goNextPage');
	                break;
	
	            case 'end':
	                vCh.command('goToLastPage');
	                break;
	
	            case 'home':
	                vCh.command('goToFirstPage');
	                break;
	
	            default:
	                return;
	
	        }
	    },
	
	    //TODO: move up aand catch at the viewer level, component level prior to firing ...
	    keyScroll: function(e, key) { 
	
	        var threshold = 40,
	            $el = this.$el,
	            x = this.$el.scrollLeft(),
	            y = this.$el.scrollTop(),
	            dy = key === 'down' ? y + threshold: y - threshold,
	            dx = key === 'right' ? x + threshold: x - threshold;
	
	        $el.scrollTop(dy).scrollLeft(dx);  //optimize needed? ... prob not
	
	    },
	
	    // Now only returns el, the inner div is no longer used ( and no longer passes the jq elements )
	    getElsForScaleCalc: function() {
	        return {
	            outerDiv: this.el
	        };
	    }
	
	
	};


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(417);
	
	
	var PageImageWr = __webpack_require__(418),
	    $ = __webpack_require__(59),
	    DocModeTextLayer = __webpack_require__(450);
	
	
	module.exports = PageImageWr.extend({
	
	    className: 'FV-pgWr FV-pgWr-PgDocMode',
	
	    TEXT_LAYER_VIEW: DocModeTextLayer,
	
	    /**
	     * TODO:
	     * - should all come from higher level queue function -- handleDocModeImgPrefetch
	     * - should be before request image at higher level when using queue
	     * Always call from dimUnknown preload ( non FDD images )
	     */
	    requestImg: function() {
	
	        if ( !this.model.isFddImage() || !this.options.vChannel.request('docModeImagesLoadingExceedsThreshold') ) {
	            PageImageWr.prototype.requestImg.apply(this, arguments);
	        }
	
	    },
	    onRender: function() {
	
	        PageImageWr.prototype.onRender.call(this);
	
	        /* Must come after -- unwrap will be diff $el */
	        this.$el.on('inview', _.bind(function() {
	            this.model.trigger('creRequest');
	        }, this ));
	
	    },
	
	    // Necessary for rotation on text-layer ( rotate is not called explicitly anymore )
	    updateViewPort: function() {
	
	        PageImageWr.prototype.updateViewPort.apply( this, arguments );
	
	        // TODO: only if rotation value changed ... can handle here on in child
	        this.textLayerView && this.textLayerView.rotate();
	
	    },
	
	
	    onBeforeImageRequest: function() {
	        this.$el.off('inview');
	        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: true});
	    },
	    enterLoadError: function() {
	        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: false});
	        PageImageWr.prototype.enterLoadError.apply(this, arguments);
	    },
	    enterImageLoaded: function() {
	        this.options.vChannel.command('updateImgsLoadingDocMode', {increase: false});
	        PageImageWr.prototype.enterImageLoaded.apply(this, arguments);
	    },
	
	    // Part of quick fix before implementation of image queue
	    // load others not queued up b/c not yet using queue
	    onAfterImgRevealed: function() {
	        this.imgView.el !== null && //in case of quick change
	            this.options.vChannel.command('checkForDocModeImagesInView');
	    },
	
	    onBeforeDestroy: function() {
	        this.$el.off('inview');
	        PageImageWr.prototype.onBeforeDestroy.apply( this, arguments );
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 417 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette) {__webpack_require__(419);
	
	
	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    Spinner = __webpack_require__(160),
	    CREImage = __webpack_require__(420),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    UnknownDimIndicator = __webpack_require__(421),
	    pgDDButtonMarkup =  __webpack_require__(427),
	    PageActionsDD = __webpack_require__(430),
	    PageErrorView = __webpack_require__(436),
	    TextLayerView = __webpack_require__(440);
	
	/**
	 * A Page View Wrapper View Around CRE Image -- can be placeholder.
	 * Evolved heavily over the years with a ton of hacks -- needs cleanup.
	 * Image States:
	 * - Not Requested (creRequest) --- essentially no styling: outline and background …
	 * - Requested & Loading – request for CRE request (and then CRE request).…  spinner, loading labels
	 * - Loaded (wasRequested from cre: true)
	 * - Loaded – preImage Appended (change:isLoaded)
	 * - Appended - Post Appended (change:isAppended)
	 * - Error
	 * - Revealed  ‘revealImage’) -- fade in ... hm
	 * Hooks:
	 * - before:ImageRequest
	 * - before:EnterImgLoadingState
	 * - before:ImageAppend
	 * - before:renderError
	 * - after:ImageAppend
	 * Swapping templates, could also swap els (huh?)
	 * Note: scale for doc and pg -- no i think just not thumb, pdf unrenderable (huh?)
	 * TODO:
	 *  - make this class into a Babysitter View / Marionette Region
	 *  - a lot of this is evolved and can be cleaned up ... eg setting height & width on multiple divs
	 *  - further subclassing
	 */
	
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'FV-pgWr', // note: b/c unwrapped, replaced with template
	
	    template: __webpack_require__(449),
	    PageActionsDropDownView: PageActionsDD,
	
	    FADEIN_TIMER: 400, // time in milliseconds to fade out the 'placeholder' post image load (can't be 0); 400 is the default for jQuery animations
	
	    NON_LOADING: 0, // may encompass all below
	
	    RENDER_LOADING_LABELS: 1, // flag to render the loading labels in the template ... only now turned off for thumbnails ... leave, may want elsewhere
	    APPLY_TRANSFORM: 1, // override to not apply a transform -- eg unrenderable views ... TODO: more semantic, see with the other page types (non-image)?
	    APPLY_SCALE: 1, // means apply scale to the outer div, would also imply there's a transform
	
	    SUPPORTS_PAGE_TEXT_LAYER: 1,
	
	    TEXT_LAYER_VIEW: TextLayerView,
	
	    initialize: function(options) {
	
	        _.extend( this, _.pick( options, 'model', 'vChannel', 'scale') );
	
	        this.imgView = new CREImage(options);
	        this.errorView = null;
	        this.unknownDimensionsIndicatorView = null;
	
	        this.creXHR = null;
	        
	        this.textLayerView = null;
	    },
	
	    // Note: for unknown dimensions page height, width are first approximated
	    // (will see the approximates in the 'placeholder') until the actual size is derived and then updated
	
	    // for now, height & width are use by similar views (thumbs, unrenderable)
	    // for 'pages': we encapsulate setting all of that into the 'updateTransform' on render ( now: updateViewPort )
	    // doesn't hurt here ... see how it plays with other view types ...
	
	    //var originalDerivedDimensions = this.model.getDimensions();
	    // TODO: put in template for clarifty?
	
	    serializeData: function() {
	
	        return {
	            classNames: this.className, // put on template b/c of unwrap onRender -- TODO:  but  get rid of this
	            pgNumber: this.model.get('number'),
	            printWithDummyDimensions: this.model.resizePageFromDummyDimensionsPostLoad(),
	            pgId: this.model.get('pageId'),
	            includeLoadingLabels: this.RENDER_LOADING_LABELS,
	            includeTextLayer: this._supportsPageTextLayer()
	        };
	
	    },
	
	    onRender: function() {
	
	        // note: small leak with loadingLabels ... should get rid of unwrap everywhere
	        // TODO: rid
	        this.unwrap();
	
	        // I suppose could apply in template variables as well for clarity ...
	        // same page types don't 'scale' -- here we just use a value of 1 in the calc's
	        this.updateViewPort();
	
	        // Note: former is hack to view creation on non-image views ( cleanup needed! )
	        // ( the views won't be in the DOM (see serialize data ) but could still get created
	        // note: apply_transform now has multiple meanings ...
	
	        if ( this.APPLY_TRANSFORM && this.model.renderPrintPreviewIconOnPageImageViews() ) {
	
	            this.unknownDimensionsIndicatorView = new UnknownDimIndicator({
	                model: this.model
	            });
	
	            this.ui.unknownDimIndHolder.replaceWith( this.unknownDimensionsIndicatorView.render().el );
	
	        }
	
	        // Print on render, not load
	        if ( this.NON_LOADING ) {
	            this._createPageActionDropDown();
	        }
	
	        // No scale/rotate transform will be applied, have transformedWr
	        // TODO: better way to accomplish ... eg now the could also just not print this div (eg url doesn't need); markup thumbs don't have ...
	        // - need to map out and plan similarieties
	        if ( !this.APPLY_TRANSFORM ) {
	            this.ui.transformedWr &&
	                this.ui.transformedWr.addClass('noTransform');
	        }
	
	        if ( this._includeTextLayer() )
	            this._createTextLayer();
	
	        if ( this._applyTextOnlyMode() ) {
	           this._toggleTextOnlyMode(true);
	        }
	
	
	    },
	    /**
	     * Use model to communicate between views
	     */
	    modelEvents: {
	        'creRequest':           'requestImg', // Triggering from the view mode container (typically)
	        'change:wasRequested':  'enterLoadingState', // really: 'queued' in CRE
	        'change:isLoaded':      'enterImageLoaded',
	        'imgLoadError':         'enterLoadError',
	        'page:cancelLoad':      'abort',
	        'pageView:rotate':      'rotate', // For now the same as scale, but left as separate currently for differentiation
	        'pageView:showFindAndRedactHits':   'showFindAndRedactHits',
	        'pageView:toggleTextLayer':         '_toggleTextLayer',
	        'pageView:toggleTextOnlyMode':      '_toggleTextOnlyMode'
	
	    },
	    ui: {
	        innerWr:                '.FV-pg-inner-wr', // wraps all layers, and allows to position them atop
	        placeHolder:            '.FV-pg-loading-placeholder',
	        transformedWr:           '.FV-pg-transform-wr', // layer that is transformed; contains image and text layer, not canvas
	        canvasPlaceholder:      '[data-canvas-holder]', // may or may not have -- note: if Cold with img overlay -- put canvas inside the overlay (just pg mode?)
	        imageHolder:            '[data-img-stub]', // replaced with imgView
	        unknownDimIndHolder:    '[data-unknown-dim-ind-stub]',
	        dropDownStub:           '[data-page-dd-stub]',
	        loadingLabels:          '.FV-imgLoading-label',
	        textLayerHolder:          '[data-text-layer-holder]'
	    },
	
	    /* Whether to print the placeholder DIV to the template at all; text can be toggled on off */
	    _supportsPageTextLayer: function() {
	        return this.SUPPORTS_PAGE_TEXT_LAYER && this.model.isFddImage();
	    },
	    
	    _includeTextLayer: function() {
	
	        return this._supportsPageTextLayer() && this._pageHasPositionalTextData() &&
	            this.vChannel.request('showPageTextMode');
	    },
	
	    _applyTextOnlyMode: function() {
	
	        return this._supportsPageTextLayer() && this._pageHasPositionalTextData &&
	            this.vChannel.request('textOnlyMode');
	
	    },
	
	    _pageHasPositionalTextData: function() {
	
	        // Only defined on doc mode models
	        if ( this.model.hasPositionalTextData )
	            return this.model.hasPositionalTextData();
	
	        // Handle page mode -- could use both for the above
	        return this.vChannel.request( 'pageHasPositionTextModel', this.model.get('number') );
	
	    },
	
	    _getPositionalTextModel: function() {
	
	        if ( this.model.getPositionalTextDataModel )
	            return this.model.getPositionalTextDataModel();
	
	        return this.vChannel.request( 'getPagePositionalTextModel', this.model.get('number') );
	
	    },
	
	    _toggleTextLayer: function( show ) {
	
	        // Check in case -- this toggle is fired on a page types
	        if ( !this._supportsPageTextLayer() )
	            return;
	
	        // For now just a toggle --> ignoring show parameter
	        !this.textLayerView
	            ? this._createTextLayer()
	            : this._removeTextLayer();
	
	    },
	
	    _toggleTextOnlyMode: function( enter ) {
	
	        if ( !this._supportsPageTextLayer() )
	            return;
	
	        this.$el.toggleClass( 'textOnlyMode', enter );
	
	
	    },
	
	    _createTextLayer: function() {
	
	        if ( !this._includeTextLayer() )
	            return;
	
	        this.textLayerView = new this.TEXT_LAYER_VIEW({
	            page: this.model,
	            pagePositionalTextModel: this._getPositionalTextModel()
	        });
	
	        // Leave the holder in place, will need to reappend with toggle functionality
	        // Later migrate this to a layout view with regions
	        this.ui.textLayerHolder.append( this.textLayerView.render().el );
	
	        this.$el.addClass('showTextMode');
	
	    },
	
	    _removeTextLayer: function() {
	
	        this.$el.addClass('showTextMode');
	
	        this.textLayerView && this.textLayerView.destroy(); // If toggle on/off maybe better way to cache?
	        this.textLayerView = null;
	
	    },
	
	
	    // Now trying utilizing existing text layer if it exists ...
	    // Not sure if we want to show hits in this mode .... could be helpful ....
	    showFindAndRedactHits: function( searchResults ) {
	
	      /*  if ( this.textLayerView ) {
	            this.textLayerView.showFindAndRedactHits( searchResults.getResultsForPage( this.model.get('number')) );
	        }*/
	
	    },
	
	    rotate: function() {
	        this.updateViewPort();
	    },
	
	    /**
	     * The entry point of the 'image'/'url' load cycle.
	     * Note: can be for overlay of the regular image in case of COLD.
	     * Can also be the iframe source url for GOS-PDF pages.
	     * If NON_LOADING, not applicable, so return;
	     */
	    requestImg: function(overlayAddress) {
	
	
	        if ( this.NON_LOADING ) {
	            return;
	        }
	
	        var pm = this.model,
	            imgView = this.imgView,
	            self = this;
	
	        pm.off('creRequest');
	        this.triggerMethod('before:ImageRequest');
	
	        // Should prevent prior to call ...
	        if ( pm.get('isLoaded' ))
	            return;
	
	
	        var fvSettings = fvChannel.request('settings'),
	            imageRenderRequest = overlayAddress         // TODO: subclass & breakout
	                ? pm.getOverlayImageRequest(overlayAddress)
	                : pm.getImgRenderRequest();
	
	
	        this.creXHR = $.fn.creRequest( _.extend( {}, imageRenderRequest, {
	
	            onStart: _.bind(pm.set, pm, {'wasRequested': true}),
	            onComplete: function(creResp) {
	
	                /* store here for now -- could just send the url here base on the model type -- eg inlineUrl or imageUrl*/
	                pm.creResp = creResp;
	
	                imgView.el !== null && // temp fix switching too fast
	                    imgView.loadImg( self._getCreUrlToLoad( creResp) );
	            },
	
	            onError: _.bind( self.enterLoadError, self ),
	            fileName: self._getCRERequestFileName(),
	
	            /* TODO: store defaults on FV to merge with -- with cre req queue should be one place to call */
	            CRE_ROOT: fvSettings.getCRERoot(),
	            POLL_FREQ: fvSettings.crePollInterval
	        }));
	
	
	    },
	
	    _getCreUrlToLoad: function( creResponse ) {
	        return creResponse['imgUrl'];
	    },
	
	    _getCRERequestFileName: function() {
	        return this.model.getCreImgRequestFileName();
	    },
	
	    // TODO: prevent at onset .. this covers page types not inheriting (eg url)
	    abort: function() {
	        this.creXHR && this.creXHR.cancel();
	    },
	
	    enterLoadingState: function() {
	
	        this.model.off('change:wasRequested');
	        this.triggerMethod('before:EnterImgLoadingState');
	        this.spinner = new Spinner( this.model.getSpinJSOptions() ).spin(this.el);
	
	    },
	    /**
	     * DOM manipulation necessary to due to need to maintain height and position --
	     * -- other alternative: a region with swapped views... but heavy
	     */
	    enterImageLoaded: function() {
	
	        this.model.off('change:isLoaded');
	
	        if ( this.vChannel.request('disableImageDownloads') ) {
	            this._disableContextMenu();
	        }
	
	        this._postImgLoadOfPageWithUnknownDimensions();
	
	        this._stopSpinner(); //  why not put in before image append?
	        this.triggerMethod('before:ImageAppend');
	
	        //(image loaded but not yet in DOM) --> append so it takes up same space (has same outline as the placeholder)
	        this._appendImageView();
	
	        this._createPageActionDropDown();
	
	        this.triggerMethod('after:ImageAppend');
	
	    },
	
	    /** Override as noop if there's nothing to append -- eg cold pages without overlays **/
	    _appendImageView: function() {
	
	        this.ui.imageHolder.replaceWith( this.imgView.$el );
	    },
	
	    /**
	     * The image has been downloaded, (though hidden) set the actual size of 'unknownDimension' images to the actual size of the image.
	     * Note:
	     * - on pages with 'unknown dimensions', rotation doesn't apply.
	     * - for now not a separate class.
	     * - doesn't imply COLD text pg -- dims there are the paper ( resizePageFromDummyDimensionsPostLoad )
	     * This is likely now a command that should go higher up ...
	     * Url page types:
	     * - can't get the size if on diff domain / iframe sandbox attribute set
	     * - if can access the contents to get the size on load, will need to refactor so that iframe is loaded in the DOM, to catch it's 'load' event
	     * Also then scale the dimensions to fit the viewer container size and current scale:
	     * - need to update the scale model for the calculations b/f setting the dimensions of the view
	     * - ... still necessary ... the scale will not have been changed since loaded ???
	     * TODO:
	     * - should have higher level way of doing this in WF, eg: should need to rescale the thumb
	     * - document mode -- load if not threshold && update the vOffsets
	     */
	    _postImgLoadOfPageWithUnknownDimensions: function() {
	
	        if ( !this.model.resizePageFromDummyDimensionsPostLoad() )
	            return;
	
	        // weird, it's actually not loaded yet ... ?
	        var actualImgDims = this._getActualImgDimensionsPreLoad();
	        this.model.updateUnknownDimensionsPostLoad( actualImgDims );
	
	        this.options.vChannel.command('setScale');
	
	        // Redundant in some page types after updating setScale ??? -- maybe
	        this.updateViewPort();
	
	    },
	
	    /**
	     * DVBC-1713 - disable context menu over images to limit users from being
	     * able to right click, download.
	     * Currently not putting on the CRE Image -- in page mode this is a layer behind the canvas,
	     * so the event will not get caught.
	     * The innerWr div wraps the image and the canvas, so for our purpose it's essentially the same
	     * as blocking on the image.  This also won't block an error view, so the user can still access
	     * the dropdown to select text from there.
	     * Note: only called if the user lack permission after a successful load
	     */
	    _disableContextMenu: function() {
	
	        this.ui.innerWr.on('contextmenu', function(e) {
	
	            e.preventDefault();
	        });
	
	    },
	
	    _createPageActionDropDown: function() {
	
	        this.ui.dropDownStub.replaceWith( pgDDButtonMarkup );
	        this.pageDDView = new this.PageActionsDropDownView( this._getActionDropDownOptions() ).render();
	
	    },
	    _getActionDropDownOptions: function() {
	        return {
	            el: this.$('.page-dd'),
	            model: this.model,
	            vChannel: this.options.vChannel
	        };
	    },
	
	    /**
	     *  Note:
	     *  - putting in the DOM will trigger a request -- may not be desirable
	     *  - DVBC-1818: !if browser cache is disabled, this will not work! ( even though image was
	     *  already loaded, the plugin will not load it from the cache, the call would be async, & this wouldn't be accurate).
	     *  For clarity, if/when needed, could alter plugin fn to take this into account.
	     */
	    _getActualImgDimensionsPreLoad: function() {
	
	        var $imgEl = this.imgView.$el;
	
	        var actualDims = $imgEl.getHiddenElementDimensions({
	            removeInlineDimensions: true,
	            $container: this.options.vChannel.request('getWrapper'), // cache? -- it's offset the screen so don't put in rel. container
	            useOuter: false,
	            removeClass: $imgEl.attr('class') // ( in case any width / height would be on there )
	        });
	
	        return actualDims;
	
	    },
	
	    /* Note: overwritten by page mode to create canvas */
	    onAfterImageAppend: function() {
	
	        this._reveal().done( function() {
	             this.triggerMethod('afterImgRevealed');
	        });
	
	    },
	
	    /**
	     * Dfd b/c of fade.
	     * Note: self.FADEIN_TIMER can't be 0; if it is, jQuery UI falls back to the normal
	     * addClass, which doesn't include a callback and this callback will never be called.
	     */
	    _reveal: function() {
	
	        var $placeholder = this.ui.placeHolder,
	            self = this;
	
	        return $.Deferred(function($dfd) {
	            $placeholder.addClass( 'noOpacity', self.FADEIN_TIMER , function() {
	                 $placeholder.remove();
	                 $dfd.resolveWith(self);
	             });
	
	        });
	
	    },
	    /*
	    * From CRE or 'Loading' Image -- latter will be an event.
	    * */
	    enterLoadError: function(errMsg) {
	
	        this.model.set( 'loadError', true, {silent: true} ); //should have this occur as result of setting the attr
	        this.model.off( 'imgLoadError' );
	        Marionette.triggerMethodOn( this.imgView, 'abortImageRequestOnErr' ); // turn off events, req loop
	
	        // First check if 401 (user timed out) -- if so, not an image error -- redirect to login state
	        fvChannel.request('auth')._keepAlive().then( _.bind( function(isAuthenticated) {
	
	            isAuthenticated
	                ?  this._renderError(errMsg) // regular error
	                : fvChannel.request('auth').setUserAuth(false); //set state to auth screen: user timed out
	
	        }, this));
	
	    },
	    /**
	     * Inserted into the placeHolder (same where image goes )
	     */
	    _renderError: function(errMsg) {
	
	        this._stopSpinner();
	
	        this.unknownDimensionsIndicatorView && this.unknownDimensionsIndicatorView.destroy();
	
	        this.imgView.destroy();
	        this.triggerMethod('before:renderError');
	        this._appendErrorViewInDOM(errMsg);
	        this._createPageActionDropDown();
	    },
	
	    _appendErrorViewInDOM: function(errMsg) {
	
	        this.errorView = new PageErrorView({
	            errMsg: errMsg
	        });
	
	        this.ui.placeHolder.replaceWith( this.errorView.render().el );
	
	    },
	
	    // Previous just reflected an update in scale, but now scale and rotation
	    // For certain page types that can't be rotated, will just scale.
	    updateViewPort: function() {
	
	        if ( !this.APPLY_SCALE )
	            return;
	
	        var originalDerivedDimensions = this.model.getDimensions();
	
	        var r = this.model.get('rotation'); // Note: rotation N/A for all page types -- see APPLY_TRANSFORM
	
	        var s = this.scale
	            ? this.scale.getScaleValue()
	            : 1; // For page types that don't have scale ( thumbs, see if others ) -- just set to the derived dimensions
	
	        var w = originalDerivedDimensions.width; // not necessarily the originals; can be requested differently, eg in doc mode
	        var h = originalDerivedDimensions.height;
	
	        // It we are off by the requested width and height when rotated 90, 270 ...
	        // when don't request the actual image size ... ( this.get('width') )
	
	        if (r !== 90 && r !== 270 ) {
	
	            this.$el.css({
	                height: Math.round(h * s), // Round stops jumpiness on scroll !
	                width: Math.round(w * s)
	            });
	
	        } else {
	
	            this.$el.css({
	                height: Math.round(w * s),
	                width: Math.round(h * s)
	            });
	
	        }
	
	        if ( this.APPLY_TRANSFORM ) {
	
	            this.ui.transformedWr.css({
	                height: h,
	                width: w,
	                transform: this._getTransform(s, r, w, h)
	            });
	
	        }
	
	        // For now canvas is handled in page mode for clarify ( only done there ) ...
	
	    },
	
	    _getTransform: function( s, r, w, h ) {
	
	        var t  = '';
	
	        var sTransform = 'scale(' + s + ')';
	        var rTransform = 'rotate(' + r + 'deg)';
	
	        var tx = 0,
	            ty = 0;
	
	        if ( r === 90 )
	        {
	            tx = h;
	            ty = 0;
	        } else if ( r === 180 ) {
	            tx = w;
	            ty = h;
	        } else if ( r === 270 ) {
	            tx = 0;
	            ty = w;
	        }
	
	        var tTransform = 'translate(' + tx + 'px, ' + ty + 'px)';
	
	        // Only apply the scale if it exists -- doesn't for some types like thumbnails
	        (s != 1) &&
	            (t = sTransform);
	
	        (r != 0) &&
	            (t += ' ' + tTransform + ' ' + rTransform);
	
	        return t;
	
	    },
	
	    // TODO: I think want this on on before image append ( where we also rid the loading labels )
	    // though it's called from other places
	    // predicate in case to prevent run time errors ( in case forgot in a page type )
	    _stopSpinner: function() {
	        this.spinner && this.spinner.stop();
	    },
	
	    // Shows the loading labels (removes the hidden div -- revealing the other elements lbl elements )
	    // ( if they exist )
	    onBeforeEnterImgLoadingState: function() {
	
	        this.ui.loadingLabels  && this.ui.loadingLabels.unwrap();
	    },
	
	    onBeforeImageAppend: function() {
	        this.ui.loadingLabels && this.ui.loadingLabels.remove();
	    },
	    onBeforeRenderError: function() {
	        this.ui.loadingLabels.remove();
	        this.options.vChannel.command('pageImgLoadError', this.model);
	    },
	
	    onBeforeDestroy: function() {
	
	        // remove the context menu listener if it was applied on load
	        this.ui.innerWr.off();
	
	        // Could move to page mode ..
	        if (this.canvas) {
	            //this.unwireCommunicationWithCanvas();
	            this.canvas.destroy();
	        }
	
	        this.unknownDimensionsIndicatorView && this.unknownDimensionsIndicatorView.destroy();
	
	        this.errorView && this.errorView.destroy();
	
	        // DVBC-1449 -- If page loaded in error, the image view was already destroyed,
	        // so calling destroy again will result in a runtime error.
	        !this.model.imgLoadFailed() && this.imgView.destroy();
	
	        this.pageDDView && this.pageDDView.destroy();
	
	        this.textLayerView && this._removeTextLayer();
	
	        // need to remove/destroy the spinner ?
	
	        this.off();
	        this.$el.off(); // plugins (in case of plugins) -- eg inview
	        this.stopListening();
	
	
	    },
	
	    destroy: function() {
	        Marionette.ItemView.prototype.destroy.apply(this, arguments);
	        this.el = null;
	        this.$el = null;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 419 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * Just an img element.
	 * Create the img on the fly to control order of image loading (vs. replacing the src of existing img)
	 */
	
	var Backbone = __webpack_require__(58);
	
	__webpack_require__(389);
	__webpack_require__(64); // for remove class with time !!! otherwise fade in
	
	
	module.exports = Backbone.View.extend({
	    tagName: 'img',
	    className: 'FV-pgImg',
	
	    // Note: model required
	    initialize: function(options) {
	
	        this.model = options.model;
	        this.imgLoadTimer = null;
	        this.undelegateEvents(); // start turned off
	        _.bindAll(this, 'nonCREError');
	
	    },
	
	    events: {
	        'load':     'imgLoaded',
	        'error':    'nonCREError' // error loading the image -- not from cre (eg: 404 not found)
	    },
	
	    /*
	    * Set the src of the img with URL returned from CRE.
	    * Note: not in DOM when set src.
	    * Timer: 800 WORKING for firefox with node 10 timeout -- timing issue occurring --- the lower the timeout in node server,
	    * lower this must be for firefox -- can we lower this ?
	    * */
	    loadImg: function(imgUrl) {
	
	        this.delegateEvents();
	        var pm = this.model,
	            $el = this.$el,
	            imgLoadTimer = this.imgLoadTimer = setInterval(function() {
	                if ( pm.get('isLoaded') ) {
	                    clearInterval(imgLoadTimer);
	                    return;
	                }
	                $el.attr('src', imgUrl);
	         }, 800) ;
	
	    },
	    imgLoaded: function() {
	        this._cleanUp();
	        this.model.set({'isLoaded': true});
	    },
	    nonCREError: function(e) {
	        this.model.trigger('imgLoadError', e);
	    },
	    onAbortImageRequestOnErr: function() {
	        this._cleanUp();
	    },
	    _cleanUp: function() {
	        clearInterval(this.imgLoadTimer); //( !prevent subsequent image requests that will hang)
	        this.undelegateEvents();
	    },
	
	    destroy: function() {
	        this._cleanUp();
	        this.remove();
	
	
	        /* for resolving leaks w/ jq cache*/
	        this.el = null;
	        this.$el = null;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {__webpack_require__(422);
	
	var Marionette = __webpack_require__(61);
	var markupPrintPreview = __webpack_require__(423);
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'unknown-dim-indicator',
	
	    template: __webpack_require__(426),
	
	    onRender: Backbone.View.prototype.unwrap,
	
	    serializeData: function() {
	
	        var isGOS = this.model.isGOS(),
	            isCold = this.model.isCold();
	
	        return {
	            printPreview: markupPrintPreview,
	            titleMsg: isGOS
	                ? 'First Page Preview'
	                : isCold
	                    ? 'Image of Text' + '\n' + 'Includes Overlay and Offsets'
	                    : '' // TODO: message for any other types?
	        };
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 422 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(424);
	module.exports = __webpack_require__(425);

/***/ },
/* 424 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<span class=\"pg-preview\">\n    <i class=\"icon-doc-inv\"></i>\n    <i class=\"icon-search\"></i>\n</span>";
	},"useData":true});

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<span class=\"unknown-dim-indicator\" title=\""
	    + container.escapeExpression(((helper = (helper = helpers.titleMsg || (depth0 != null ? depth0.titleMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"titleMsg","hash":{},"data":data}) : helper)))
	    + "\">\n    "
	    + ((stack1 = ((helper = (helper = helpers.printPreview || (depth0 != null ? depth0.printPreview : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"printPreview","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n</span>\n";
	},"useData":true});

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(428);
	module.exports = __webpack_require__(429);

/***/ },
/* 428 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<span class=\"page-dd\" tabindex=\"0\">\n    <span class=\"icon-down-dir-1\" title=\"Page Actions\"></span>\n</span>";
	},"useData":true});

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {// TODO: would actually probably want to extend dd menu that changes its contents on each open
	// this was problematic with memory leaks ...  for now just creating separate one's for each ... this is the easiest way to go with the existing architecture
	
	var DropDown = __webpack_require__(431),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    PAGE_ACTION_ID = 'dd-page-actions';
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(435),
	    templateOptions: function() {
	
	        var pgModelIdentifier = this.model.typeIdentifier,
	            vChannel = this.options.vChannel;
	
	        return {
	            id: PAGE_ACTION_ID + '-' + pgModelIdentifier + '-' + this.model.get('number'),
	
	            isDownloadableAsPdf: vChannel.request('allowPageDownload', this.model, 1),
	            isDownloadableRaw: vChannel.request('allowPageDownload', this.model),
	
	            canBeLaunchedViaUrl: this.model.renderUrlViewForDocAndPageMode(),
	            allowDelete: vChannel.request('allowDeletePages') // (could also get from page model but now centralized with delete multiple pages)
	
	        };
	
	    },
	    onRender: function() {
	        this.options.applyIframeShim && this._applyIframeShim();
	    },
	    ddOptions: function() {
	        return {
	            container: this.options.vChannel.request('getWrapper'),
	            hPos: this.model.typeIdentifier === 'THUMB' ? 'left' : 'right'
	        };
	    },
	    ui: {
	        pageInfo:           '.pgInfo',
	        launchPDF:          '.pop-page-pdf',
	        dlOriginal:         '.dn-pg-raw',
	        dlPDF:              '.dn-pg-pdf',
	        launchUrl:          '.pop-url',
	        deletePg:           '.delete-pg'
	    },
	    events: function() {
	
	        var vCh = this.options.vChannel,
	            m = this.options.model;
	
	        return {
	            'click @ui.pageInfo': function() {
	                vCh.command('showPgInfo', m);
	            },
	            'click @ui.dlOriginal': function() {
	                vCh.command('download', 'page', 'raw', m.get('pageNumber'));
	            },
	            'click @ui.dlPDF': function() {
	                vCh.command('download', 'page', 'pdf', m.get('pageNumber'));
	            },
	            'click @ui.launchPDF': function() {
	                vCh.command('openPageInNewWindowAsPDF', m);
	            },
	            'click @ui.launchUrl': function() {
	                window.open( m.getPageUrl() );
	            },
	            'click @ui.deletePg': function() {
	                vCh.command('showDeletePageDialog', m);
	            }
	
	        };
	    },
	    _applyIframeShim: function() {
	
	        /*  not using iframeShim plugin b/c that only move with window repositioning, scroll
	         *  this can move on panel resize, open/close etc, so make a shim that positions them with the actual element via DOM manip.
	         *  for now this is custom: if there's a need for it again, make a generic jq plugin
	         * */
	
	        this.$iframeShimWr = this.$el
	            .wrap('<div class="fixed-iframe-shim-wr">')
	            .parent()
	            .css({
	                height:  this.$el.outerHeight(),
	                width: this.$el.outerWidth(),
	                position: 'absolute',
	                top: this.$el.css('top'),
	                right: this.$el.css('right'), //this is positioned right, not left for all types
	                //if make generic jq plugin, make it top/left auto -- or just apply if they exist
	                'z-index': parseInt( this.$el.css('z-index') ) + 1
	            }).prepend(
	                $('<iframe class="iframeShim" scrolling="no" frameborder="0">').css({ height:  '100%', width: '100%' })
	            );
	
	        this.$el.css({ top: 0, left: 0});
	
	    },
	    onBeforeDestroy: function() {
	        //note: tested & confirmed the removal of the shim doesn't cause any more memory leaks than already exists via removal of the dropdown
	        DropDown.prototype.onBeforeDestroy.apply(this, arguments);
	        this.$iframeShimWr && this.$iframeShimWr.remove(); //do after (since it wraps, what is now dropdown, the old el)
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Here, el is the set to the contents of the dropdown, the opener is $ddOpener.
	 * Custom events handled by view contents created in template, not plugin.
	 * TODO: if use this remove all 'select options' -- they would no longer apply
	 */
	
	var Marionette = __webpack_require__(61),
	    DropDownBase = __webpack_require__(432),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59);
	
	
	module.exports = DropDownBase.extend({  //(could make factory)
	    render: function() {
	        DropDownBase.prototype.render.apply(this, arguments);
	        this.setElement( this.getDDContent() ); //set el to the contents of the DD menu, not the opener: TODO: if id (like overflow, need to unwrap) and apply id attributes
	        this.triggerMethod('afterSwapEl', this); /* provide a hook */
	        this.bindUIElements(); //do after swap in case new elements are added to el (eg cold-page action dropdown menu)
	        return this;
	    },
	    ddDefaults: function() {
	        return _.extend({}, {
	            isNotMenu: true, //allows click event to prop. here
	            onOpen: _.bind(this.delegateEvents, this) //(must bind to view, otherview cxt is plugin) ... //TODO: needed each time?
	        }, DropDownBase.prototype.ddDefaults.call(this));
	    },
	    // !!!! TEMP STOPGAP FOR HORRIBLE MEM LEAK ISSUE TO DEBUG
	    onBeforeDestroy: function() {
	        this.unbindUIElements();
	        this.off();
	        this.stopListening();
	        this.$('*').remove();
	        DropDownBase.prototype.onBeforeDestroy.apply(this, arguments);
	    },
	    destroy: function() {
	        DropDownBase.prototype.destroy.apply(this, arguments);
	        this.$el = null;
	        this.el = null;
	    }
	
	});

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(433);
	
	/* wraps $.fn.dropDown -- $el of the view is the opener */
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59);
	
	__webpack_require__(434);
	
	//TODO: just listing ... would be on proto
	
	var instVars = {
	    template: '',   /*req'd* -- if not existing markup , IF DD.OPTIONS.$CONTENT IS NOT GIVEN */
	    templateOptions: null, //apply from instances -- can be fn / obj -- optional
	    onChange: null, //apply from inst. - req'd if onChange $.fn option
	    defaultSelector: null, /*optional -- fn or str */
	    dropdown: null, //the instance of the dd created with the $.fn.dropDown on this.el
	    ddOptions: {}
	};
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function(options) { /* el is the opener */
	
	        this.ddOptions = _.extend({}, _.result(this, 'ddOptions'), options.ddOptions);
	    },
	    render: function() {
	        var opts = _.extend( {}, this.ddDefaults(), this.ddOptions);
	        this.dropdown = this.$el.dropDown(opts);
	        this.triggerMethod('render', this);
	        return this;
	    },
	    ddDefaults: function() {
	        var content = this.ddOptions.$content
	                ? this.ddOptions.$content
	                : this._templateContentAndID().content,
	
	            //el in onOpen
	            onChange = this.onChange ? _.bind(this.onChange, this) : null, /* must bind to this if want cb to be inside dd instance -- otherwise cxt is plugin $opener */
	            defaultSelector = this.defaultSelector ? _.result(this, 'defaultSelector') : null,
	            defaults = {
	                content: content,
	                applyIframeShim: true
	            };
	        /* extend with optional settings if exist on inst */
	        content.id && _.extend( defaults, {id: templateData.id}); //todo: i don't think template data still exists ...
	        onChange && _.extend( defaults, {onChange: onChange});
	        defaultSelector && _.extend( defaults, {defaultSelector: defaultSelector});
	        return defaults;
	    },
	    _templateContentAndID: function() { //return the content for the dropdown (combo b/c need markup for id)
	        var templateOpts = _.result(this, 'templateOptions'),
	            content = templateOpts ? this.template(templateOpts) : this.template(),
	            templateId = $(content).attr('id');
	        return {
	            content: content,
	            id: templateId
	        };
	    },
	    getDDContent: function() {
	        return this.dropdown.getDDEl(); /* hook into the plugin */
	    },
	    onBeforeDestroy: function() {
	        this.dropdown.destroy();
	        this.dropdown[0] = null; //still ref here
	        this.dropdown = null;
	    }
	});

/***/ },
/* 433 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, Mousetrap, _) {/**
	 * Simple click dropdown -- extendable -- cleanup put class dropdown on element.
	 * .dropdown, .dropdown-menu -- classes
	 * For select: change return the text value and and object of the assoc data prop.
	 * Really anything that pops up --- can be a 'selectmenu'.
	 * For now .mi class is what distinguishes from drop down -- can also be dd without select --
	 * change also to allow data-close (eg close buttons on dialog).
	 * Note: if want to use iframe shim, must be on $.fn ( this now requires iframe shim.
	 * Update 3/24/20 --- this is extremely old and requires a lot of cleanup.  When initially written,
	 * requires a custom plugin for various reasons; with current requirements maybe time to switch to an
	 * existing one.  Lots of quick hacks have been implemented over the years and this have grown
	 * more and more application specific.
	 */
	
	
	(function($, Mousetrap, _) {
	
	    $.fn.dropDown = function(options) {
	
	        var settings = {
	            content: '', // html markup or jq object
	            eventTrigger: 'click', // click OR 'mouseover'; may want to consider custom; TODO: I don't think mouseover still working
	            container: 'body', // Don't need if settings.content is a jQuery object -- will use the existing hidden element -- otherwise markup appended to it
	            isSelect: false,
	            selectNoOpenerText: false, //if a select w/out a box at the top
	            hPos: 'left', //default (left or right),
	            activeClass: 'active',   //note: can be more than one,
	            dropUp: false,
	            isSelectForceChangeOnClick: false,
	            // maxWidth: provide a max width for the opener (and correspondingly the dropdown content);
	            // pixel value as an integer (200) or string '200px';
	            // now only applicable to 'isSelect'
	            maxWidth: null
	        };
	
	
	        if (options)
	            $.extend(settings, options);
	
	
	        var $opener = $(this),
	            $win = $(window),
	            openEvent = settings.eventTrigger,
	            closeEvent = openEvent === 'click' ? 'click' : 'mouseout',
	            $dd = ddContent(),
	            $subMenubars = $dd.find('.mi.dropdown-submenu'),
	            hasSubMenubars = $subMenubars.length > 0,
	            applyIframeShim = settings.applyIframeShim && $.fn.iframeShim,
	
	            position = function() {
	                var openerOffset = $opener.offset();
	                $dd.css({
	                    top: !settings.dropUp
	                        ? openerOffset.top + $opener.outerHeight() -1 - $win.scrollTop()
	                        : openerOffset.top  - getDDHeight() - $win.scrollTop() - 1,
	                    left: settings.hPos === 'left'
	                        ? openerOffset.left - $win.scrollLeft()
	                        : openerOffset.left - $win.scrollLeft() + $opener.outerWidth() - getDDWidth() //note: recalc the ddwidth b/c if was appended to dom on render, will be 0
	                });
	            },
	            open = function() {
	
	                if (options.onBeforeOpen)
	                    options.onBeforeOpen();
	
	                $opener.data('is-open', 'true');
	
	                position();
	                $dd.removeClass('hide').addClass('open');
	                applyIframeShim && $dd.iframeShim();
	                $opener.addClass( settings.activeClass );
	
	                /**
	                 * Post left aligned sub-menus.
	                 * Could cache.
	                 * Done on open so will be visible ( and can calc width )
	                 */
	                if (settings.isSelect || settings.ddNoSelect) {
	                    $dd.find('.sm-left').each(function() {
	                        $(this).css('margin-left', -1 * $(this).outerWidth() );
	                    });
	                }
	
	                setHandlersPostEnter();
	
	                // Maybe only if 'is-current' ??
	                if ( options.onOpen )
	                    options.onOpen() ;
	            },
	
	            // TODO: prevent mem leak in first place -- temp fix for selecting new doc for dropdown when others are closed by still have refs ???
	            close = function() {
	
	                if (!$opener)
	                    return false;
	
	                // Don't close the current one when closing all before an open
	                // *** If rid, looks like can't close the current by clicking on the opener ***
	                if ( $opener.data('is-current') ) {
	                    return;
	                }
	
	                // Provide a hook into taking an action before the 'close' action is taken
	                if (options.onBeforeClose) {
	                    options.onBeforeClose();
	                }
	
	                $opener.removeData('is-open');
	
	                if (applyIframeShim)
	                    $dd.iframeShim('destroy');
	
	                $dd.removeClass('open')
	                    .addClass('hide');
	
	                $opener.removeClass(settings.activeClass);
	
	                destroyOpenListeners();
	
	                if (settings.isSelect)
	                    $opener.removeClass('open');//* note: could used open selector to close all others
	
	                $dd.off(openEvent, dropDownClick);
	
	                Mousetrap.unbind('escape', close);
	
	                if ( hasSubMenubars )
	                    closeSubMenus();
	
	                // Note: onClose hook is really like onAfterClose
	                if (options.onClose)
	                    options.onClose();
	
	            },
	
	            /**
	             * When dropdown element is clicked -- for menus (not options.isNotMenu)
	             * TODO: clean up logic for closing dialog -- now using the 'select' params
	             */
	            dropDownClick = function(e) {
	
	                // If target is a menu item allow it to close; otherwise clicks will leave it open --
	                // will also allow the click event to propagate to another handler.
	                if ( !settings.isSelect && !options.ddNoSelect )
	                    return false;
	
	                //Allow to capture clicks from html elements within '.mi tags'
	                var $target = $(e.target).closest('.mi');
	
	                if ($target.hasClass('disabled'))  // Note: N/A for contentDDView
	                    return false;
	
	                if (settings.isSelect) {
	
	                      // TODO: allow option to trigger change even if same 'text' value selected
	                      // -- prob should store id data of the opener as well as the text ...
	                      // ... misleading b/c the menu item changes as well ... otherwise s/b in if clause
	                      // ... quick fix now is isSelectForceChangeOnClick
	
	                    $dd.find('.mi').removeClass('active');
	                    $target.addClass('active');
	
	                    // Allow onchange if noOpenerText
	                    if ($opener.find('.ddValue').text() !== $target.text() || settings.isSelectForceChangeOnClick || settings.selectNoOpenerText) {
	
	                        if (!settings.selectNoOpenerText)
	                            $opener.find('.ddValue').text($target.text());
	
	                        if (options.onChange)
	                            options.onChange.call( $opener, $target.text(), $target.data() ) ;  //pass back the selected item and any data attr of it
	                    }
	
	                    close();
	
	                } else if (options.ddMultiSelect) {  //same as select -- but can choose mult options in the dd -- and returns each active
	
	                    var $targetGrp = $target.closest('.dd-grp');
	                    $targetGrp.find('.mi').removeClass('active');
	                    $target.addClass('active');
	
	                    var $selectedOpts = $dd.find('.mi.active');
	
	                    if (options.onChange) {
	                        options.onChange.call( //return array of (data-attr: value) -- like the opt and value from select
	                            $opener,
	                            _.map($selectedOpts, function(m) {
	                                return {
	                                    value: $(m).text(),
	                                    group:  _.keys($(m).data())[0],
	                                    groupVal: _.values($(m).data())[0]
	                                };
	                            })  //sloppy for time being: give the data-attr value
	                        );
	                    }
	
	                    close();
	
	                 // Menubar - no select
	                } else if (options.ddNoSelect) {
	
	                    if (options.onChange)
	                        options.onChange.call( $opener, $target.text(), $target.data() );
	
	                    close();
	                }
	            },
	
	            setHandlersPostEnter = function() {
	
	                $opener.on( closeEvent, close );
	
	                $('body').on('click', close);
	
	                $win
	                    .on('resize', position)
	                    .on('scroll', close); //latter (b/c taking window scroll into account
	
	                // Don't pick up click: allow orig handle to target !
	                !options.isNotMenu && $dd.on('click', dropDownClick);  // Note: only set on dropDown contentMenu where events delegated to the view
	                Mousetrap.bind('escape', close);
	
	            },
	
	            destroyOpenListeners = function() {
	
	                $opener.off( openEvent, open );
	
	                $('body').off('click', close);
	
	                $dd.off('click', dropDownClick);
	
	                $opener.off('close', close); // where set on the opener?
	
	                $win
	                    .off('resize', position)
	                    .off('scroll', close);
	
	            };
	
	
	
	        if ( options.defaultSelector )
	            $dd.find( options.defaultSelector ).addClass('active');
	
	        // Temp fix: a way to identify the drowpdown (uses id)
	        if (options.id)
	            $dd.attr('id', options.id);
	
	        if (options.ddClass)
	            $dd.attr('class', options.ddClass);
	
	
	        var ddWidth = getDDWidth();
	
	        //if (settings.hPos === 'right')
	        //  _.extend(settings, {  menuWidth: ddWidth }); note: no longer using -- calc on open (should be in DOM)
	
	
	        // if select and width of dd < opener , make opener wider
	        // if select and change the opener value on select, ensure width is as width as the dropdown
	        if (settings.isSelect && !options.selectNoOpenerText)
	            $opener.outerWidth(ddWidth);
	
	
	        if (settings.maxWidth && settings.isSelect)
	            applyMaxWidthToSelectDropdown();
	
	        // TODO: can still make invalid selection
	        if (settings.isSelect || settings.ddNoSelect)
	            $dd.unselectable();
	
	
	        $dd.on( 'close', close ); // for closing others
	
	        $opener.on( openEvent, function(e) {
	
	            /**
	             *  Don't allow to click to hit body.
	             *  Would want to just stopPropgation but other handlers are put on the element in this process,
	             *  and not using stopImmediatePropagation will break this.
	             *  see console.log( $._data( $opener[0], 'events' ) );
	             *  Click event is added each time clicked ( probably the 'off' ).
	             *  Should change but we need a refactor anyway, so not worth the effort.
	             */
	            e.stopImmediatePropagation();
	
	
	            // Set flag for close trigger -- to not close this one
	            $opener.data('is-current', true);
	
	            // Close any others that are open
	            // issue is that this still does close this one ....even though not selected ....
	            // the event will still be broadcast here to this -- seems to be closing this (even though not broadcast)
	            // Update: this is working, but maybe it includes both dropdown and dropdown menu ???
	
	            $('.dropdown, .dropdown-menu').not( this ).trigger('close');
	
	            if ( $opener.hasClass('disabled') )
	                return false;
	
	            $opener.removeData('is-current');
	
	            $opener.data('is-open')
	                ? close(e)
	                : open(e);
	
	        });
	
	        /**
	         * Contol sub-menu's not via css-hover due to need to iframe-shim them.
	         * Compromise implementation -- still have the menu markup positioned adjacent to the menu items.
	         * This is all hacky ... fix when clean up entire use of plugin ... only used in app in hover menu.
	         * This is working without closing the submenu when the mouse hover's off its parent item ... just go with it
	         */
	        if (hasSubMenubars) {
	
	            $subMenubars.on('mouseenter mouseleave', function(e) {
	
	                var $subMenuItem = $(e.currentTarget);
	                if (e.type === 'mouseenter') {
	                    !$subMenuItem.hasClass('disabled') && openSubMenu($subMenuItem);
	                } else {
	                    closeSubMenu($subMenuItem);
	                }
	
	            });
	        }
	
	
	        function closeSubMenus() {
	            $subMenubars.each(function() {
	                 closeSubMenu($(this));
	            });
	        }
	
	        function openSubMenu($subMenuBar) {
	            var $submenu = $subMenuBar.find('.dropdown-menu');
	            $submenu.css({display: 'block'});
	             /* (note: element must first be visible to calc position) for shim */
	            applyIframeShim && $submenu.iframeShim();
	        }
	
	        function closeSubMenu($subMenuBar) {
	            var $submenu = $subMenuBar.find('.dropdown-menu');
	            $submenu.css({display: 'none'});
	            applyIframeShim && $submenu.iframeShim('destroy');
	        }
	
	        function ddContent() {
	
	            var $content = settings.content.jquery
	                ? settings.content //if jquery -- keep events, etc ( assumes already embedded on container )
	                : $(settings.content).appendTo( settings.container ); // html markup -- not on container
	
	            !$content.hasClass('dropdown-menu') &&
	                $content.addClass('dropdown-menu');
	
	            // Always add the hidden class
	            // TODO: take this out -- have dropdown menu include hidden, then toggle with open
	            $content.addClass('hide');
	
	            return $content;
	
	        }
	
	        /**
	         * Note: should only call when in DOM, otherwise will be off
	         * Could cache if not 0 ( ? ... old TODO item )
	         */
	        function getDDWidth() {
	            return ddDimension();
	        }
	
	        function getDDHeight() {
	           return ddDimension(1);
	        }
	
	        /* default is width */
	        function ddDimension(isHeight) {
	            var container = settings.container;
	            !container.jquery && (container = $(container));
	
	            return $dd.is(':visible')
	                ? $dd['outer' + (isHeight ? 'Height' : 'Width')]()
	                : $dd.getHiddenElementDimensions({
	                    $container: container && container.is(':visible') ? container : null
	                    })[(isHeight ? 'height' : 'width')];
	        }
	
	        /*
	         *  Apply a max width to the size of the dropdown.
	         *  Use Case: a value in the select dropdown could be very long.
	         *  Quickly put in for one use case and only tested on 'isSelect' (so limiting to that) --- could later expand & clean functionality.
	         *  Better markup may also be a better answer.
	         *  If want to get fancier, can only apply if the size would exceed the content ...
	         *  Much could also be accomplished with CSS overrides.
	         *   If start uses this in more places, take a look at doing this (... this plugin is already a mess).
	         * */
	        function applyMaxWidthToSelectDropdown() {
	
	            // Accept pixel and integer values
	            settings.maxWidth = parseFloat(settings.maxWidth);
	
	            $opener.css({
	                'max-width': settings.maxWidth,
	                overflow: 'hidden'
	            });
	
	            // Set this on the individual menu items (as opposed to the container) so text doesn't cover the 'dropdown icon' on the right.
	            $opener.find('.ddValue').css({
	                'max-width': settings.maxWidth - 30,
	                display: 'inline-block', // maybe should be hardcoded in CSS anyway ?
	                overflow: 'hidden',
	                'text-overflow': 'ellipsis'
	            });
	
	            $dd.css({
	                'max-width': settings.maxWidth
	            });
	
	            $dd.find('.mi').each( function() {
	                $(this).css({
	                    overflow: 'hidden',
	                    'text-overflow': 'ellipsis'
	                });
	            });
	        }
	
	
	        this.getDDEl = function() {
	            return $dd;
	        };
	
	
	
	        this.destroy = function() {
	
	            if (hasSubMenubars) {
	                closeSubMenus();
	                $subMenubars.off();
	            }
	
	            if (settings.applyIframeShim && $.fn.iframeShim)
	                $dd.iframeShim('destroy'); /* must do b/f dd remove */
	
	            //TODO: header if also if 'switched' by content wr?
	            $dd.remove(); //this is where the majority of leak comes from in destroy
	            $opener.remove(); //smaller leak here -- though when continue will still get leak ...
	
	            /* remove references that could be help in wrapper views */
	            $dd = null;
	            $opener = null;
	
	            $('body').off('click', close);
	            $win.off('resize', position).off('scroll', close);
	        };
	
	        return this;
	    };
	
	
	
	}(jQuery, Mousetrap, _));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(68), __webpack_require__(49)))

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"mi pop-page-pdf\" title=\"Open as PDF in New Window\">\n            <span class=\"dd-icon icon-link-ext\"></span>\n            Launch PDF\n        </div>\n\n        <div class=\"mi dn-pg-pdf\" title=\"Download PDF\">\n            <span class=\"dd-icon icm-file-pdf3\"></span>\n            Download PDF\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"mi dn-pg-raw\" title=\"Download Original\">\n            <span class=\"dd-icon icon-doc\"></span>\n            Download Original\n        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"mi pop-url\" title=\"Open in New Window\">\n            <span class=\"dd-icon icon-link-ext-alt\"></span>\n            Launch URL\n        </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"mi delete-pg\" title=\"Delete Page\">\n            <span class=\"dd-icon icon-trash\"></span>\n            Delete Page\n        </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\""
	    + container.escapeExpression(((helper = (helper = helpers.id || (depth0 != null ? depth0.id : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"id","hash":{},"data":data}) : helper)))
	    + "\" class=\"dropdown-menu dd-page-action-content hide\">\n\n    <div class=\"mi pgInfo\" title=\"Page Info\">\n        <span class=\"dd-icon icon-doc-text-1\"></span>\n        Page Info...\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDownloadableAsPdf : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isDownloadableRaw : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.canBeLaunchedViaUrl : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.allowDelete : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>\n";
	},"useData":true});

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(437);
	
	var Marionette = __webpack_require__(61),
	    PreventDragEventsMixin = __webpack_require__(438);
	
	
	/**
	 * A simple view displaying an error message that is appended to pages that load in error.
	 */
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'pageLoadError',
	
	    template: __webpack_require__(439),
	
	    serializeData: function() {
	
	        var errMsg = this.options.errMsg;
	
	        errMsg = _.isString(errMsg)
	            ? errMsg
	            : 'Error Loading Image'; //Generic Error if not from CRE
	
	        return {
	            errMsg: errMsg
	        };
	
	    },
	
	    // Allow user to select and copy the text
	    // TODO: need  only over the text -- want to allow drag on the page itself
	    events: PreventDragEventsMixin
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 437 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * Mix this into the events of views where we don't want mouse events captured by the 'drag' plugin to be applied.
	 * ( The 'drag' / 'grabby hand' feature that overlays the page views in Document and Page Mode. )
	 * Most notably this allow the selection of text in these views.
	 * Examples: unrenderable pages, error pages, cold/text overlays
	 */
	
	
	module.exports = {
	
	    'mousedown': function(e) {
	        e.stopPropagation();
	    },
	
	    'mouseup': function(e) {
	        e.stopPropagation();
	    },
	
	    mousemove: function(e) {
	        e.stopPropagation();
	    }
	
	};

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<div class=\"pgErrInner\">\n    <div class=\"pgErrHeader\">\n        <i class=\"icon-attention-circled\"></i>\n        Error\n    </div>\n    <div class=\"pageErrBody\" title=\""
	    + ((stack1 = ((helper = (helper = helpers.errMsg || (depth0 != null ? depth0.errMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errMsg","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\">"
	    + ((stack1 = ((helper = (helper = helpers.errMsg || (depth0 != null ? depth0.errMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errMsg","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</div>\n</div>\n";
	},"useData":true});

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(441);
	
	
	var Marionette = __webpack_require__(61),
	    PreventDragEventsMixin = __webpack_require__(438);
	
	// These are actually collection views ... rename as such ...
	var ZoneLayer = __webpack_require__(442),
	    LineLayer = __webpack_require__(444),
	    WordLayer = __webpack_require__(446);
	
	var DEBUG_MODE = 1;
	
	if ( true ) {
	    DEBUG_MODE = 0;
	}
	
	// For now a flag to create these layers.
	// Maybe later they become an option if desired but currently don't have a use for them.
	// Main goal now if find and redact portion.
	// For now these are more useful for debugging for development.
	var CREATE_ZONE_LAYER = 1;
	var CREATE_LINE_LAYER = 1;
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    className: 'FV-page-text-layer',
	
	    template: __webpack_require__(448),
	
	    initialize: function( options ) {
	
	        this.page = options.page;
	        this.positionalTextDataModel = options.pagePositionalTextModel;
	
	
	        this.zoneLayer = null;
	        this.lineLayer = null;
	        this.wordLayer = null;
	
	        this.wordResultViews = null; // now created from those existing ... should prob be another layer ... need to get flow for saving, etc
	
	    },
	
	    //regions: {
	    //    zoneRegion:  '.layer-zone',
	    //    lineRegion:  '.layer-line'
	    //},
	
	    // May want regions for easier management
	    ui: {
	        zoneLayer:  '.layer-zone',
	        lineLayer:  '.layer-line',
	        wordLayer:  '.layer-word'
	    },
	
	    events: _.extend( {}, PreventDragEventsMixin, {
	
	    }),
	
	    onRender: function() {
	
	        if ( DEBUG_MODE ) {
	            this.$el.addClass('FV-page-text-layer-debug');
	        }
	
	        // could decide whether we even want the extra models ... could just utilize data in the DOM ..
	        // EG: we search on another layer, do we ever care about these ???
	        if ( CREATE_ZONE_LAYER )
	            this.createZoneLayer( );
	
	
	       if ( CREATE_LINE_LAYER )
	            this.createLineLayer( );
	
	        this.createWordLayer( );
	
	    },
	
	    // TODO could be a collection / baby sitter  (collection inherits ) view if need to access via model, not markup now ... or collection view
	    // Model here would be the zone
	    // maybe just do a babysitter view ...
	    createZoneLayer: function() {
	
	        this.zoneLayer = new ZoneLayer({
	            collection: this.positionalTextDataModel.getZones(),
	            el: this.ui.zoneLayer,
	            sort: false // for perf gains ... but do outside Marionette prob faster
	        });
	
	        // TODO: want to make sure its in the buffer ... but at least nothing yet in the DOM ...
	        this.zoneLayer.render();
	
	        //this.zoneRegion.show( this.zoneLayer ); // Note: if use regions, use get extra div ...
	    },
	
	    createLineLayer: function() {
	
	        // TODO: test with new font metrics coming from real data ...
	
	        this.lineLayer = new LineLayer({
	            collection: this.positionalTextDataModel.getLines(),
	            el: this.ui.lineLayer,
	            sort: false // for perf gains ... but do outside Marionette prob faster
	        });
	
	        // TODO: want to make sure its in the buffer ... but at least nothing yet in the DOM ...
	        this.lineLayer.render();
	
	        //this.lineRegion.show( this.lineLayer );
	    },
	
	
	    // Note: these are really collections
	    createWordLayer: function(  ) {
	
	        // TODO:
	        // - this should go prior to render of the collection view
	        // - cache
	        var spacer =  document.createElement('span');
	        spacer.style['font-family'] = this.positionalTextDataModel.getFont();
	        spacer.className = 'offScreen';
	        document.body.appendChild( spacer );
	
	        this.wordLayer = new WordLayer({
	            el: this.ui.wordLayer,
	            collection: this.positionalTextDataModel.getWords(),
	            spacer: spacer,
	            sort: false // for perf gains ... but do outside Marionette prob faster
	        });
	
	        this.wordLayer.render();
	
	        document.body.removeChild( spacer );
	
	    },
	
	
	    // TODO: this doesn't seem like the way to go: now trying to draw on the canvas ...
	    // May want to leave something like this on doc mode but likely in a different view in a layer above the canvas
	
	    showFindAndRedactHits: function( pageResults ) {
	/*
	
	        // shapeViews: new Backbone.ChildViewContainer()
	        // iF create collection: want new view anyway -- DON'T NEED THIS: DO ANOTHER LAYER ...
	        // I suppose could have a collection view in Doc Mode we render the text layer before the image ....
	
	        if ( this.wordResultViews ) {
	            this.wordResultViews.each( function(view) {
	
	                view.$el.removeClass('hit');
	                this.wordResultViews.remove(view);
	
	            }, this);
	        }
	
	        // do we even need this ?
	        this.wordResultViews = new Backbone.ChildViewContainer();
	
	        _.each( pageResults, function(pageResult) {
	
	            // with this model, not necessary -- the view already exists
	            // also todo: could have diff zones per model if > 1 word ...
	            // if go this route, could have hit ui model for the word to link them ....
	            // now starting to think we create new ones ( linked by the hit models ) ... this isn't good
	
	            // Also -- don't use findByModel -- in full page mode we are looking at docModelPage
	           // var view = this.wordLayer.children.findByModel( pageResult.attributes.words[0] );
	
	            var view =
	                this.wordLayer.children.find( function(v) { return v.model.attributes.id ===  pageResult.attributes.words[0].id; }); // hack to get workin on page model with has diff model
	
	            // TODO: should also link it to the hit ...
	            view.$el.addClass('hit'); // this is just for testing now ...
	
	            this.wordResultViews.add( view );
	
	        }, this);
	*/
	
	
	    },
	
	    onBeforeDestroy: function() {
	
	        this.zoneLayer && this.zoneLayer.destroy();
	        this.lineLayer && this.lineLayer.destroy();
	        this.wordLayer && this.wordLayer.destroy();
	
	    }
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 441 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    ZoneView = __webpack_require__(443);
	
	
	module.exports = Marionette.CollectionView.extend({
	
	    childView: ZoneView
	
	});

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'ocr_zone',
	
	    template: false,//require('./template.hbs'),
	
	    // this is prob small, can put on template instead ?
	    // faster in template/not?
	    onRender: function() {
	
	        var model = this.model;
	
	        this.el.id = 'zone_' + model.get('id');
	        this.el.setAttribute( 'data-page-zone', model.get('page_level_id') );
	        this.el.setAttribute( 'style',  model.getBoxCssStyle() );
	
	    }
	
	
	});
	
	//


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    LineView = __webpack_require__(445);
	
	
	module.exports = Marionette.CollectionView.extend({
	
	    childView: LineView
	
	});

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    tagName: 'span',
	
	    className: 'ocr_line',
	
	    template: false,//require('./template.hbs'),
	
	    // this is prob small, can put on template instead ?
	    // faster in template/not?
	    onRender: function() {
	
	        var model = this.model;
	
	        //this.el.id = model.get('page_level_key');
	        this.el.id = 'line_' + model.get('id');
	        // TODO: would want this linked back to the overall document one
	        this.el.setAttribute( 'data-page-zone', model.get('pageLevelZoneId') );
	        this.el.setAttribute( 'data-page-line', model.get('page_level_id') );
	
	        // maybe store dpi on the model / parse on init
	        this.el.setAttribute( 'style',  model.getBoxCssStyle() );
	
	    }
	
	
	});
	
	//


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    WordView = __webpack_require__(447);
	
	
	module.exports = Marionette.CollectionView.extend({
	
	    childView: WordView,
	
	    childViewOptions: function( ) {
	
	        return {
	            spacer: this.options.spacer
	        };
	
	    }
	
	
	});

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61);
	
	
	var TEST_DERIVED_COORDINATES = 0;
	if ( true ) {
	    TEST_DERIVED_COORDINATES = 0;
	}
	
	
	module.exports = Marionette.ItemView.extend({
	
	    tagName: 'span',
	
	    className: 'ocr_word',
	
	    template: false,
	
	    // this is prob small, can put on template instead ?
	    // faster in template/not?
	    onRender: function() {
	
	        var model = this.model,
	            word = this.model.getWord();
	
	        // TODO: may not even need to print all these -- have a debug mode -- and be able to print from derived if desired?
	
	        this.el.id = 'word_' + model.get('id'); // note the is the original, 'not the derived'
	        this.el.setAttribute( 'data-page-key', model.get('page_level_key') );
	        this.el.setAttribute( 'data-page-zone', model.get('pageLevelZoneId') );
	        this.el.setAttribute( 'data-page-line', model.get('pageLevelLineId') );
	        this.el.setAttribute( 'data-page-word', model.get('page_level_id') );
	
	        // maybe store dpi on the model / parse on init
	        this.el.setAttribute( 'style',  this.getStyle( model, word ) );
	
	        // with white-space 'pre': allows to copy spaces (can't be nowrap) and text only wrap on line breaks
	        // this can help to also test with browser find .. can copy but still can 'find' -- prob absolute positioning ..
	        // TODO: maybe only in debug???
	        // https://stackoverflow.com/questions/62381455/how-do-i-make-my-html-searchable-by-a-browser-ctrl-f-and-use-absolute-text-posit
	        // -- would need to stop with layers and absolute positioning -- more calc's necessary --
	        // position within line and zone ...
	        // could just test search by removal of abs position
	        this.el.innerHTML = (word += ' ');
	
	        //this.el.innerHTML = word;
	
	    },
	
	    getStyle: function( model, word )
	    {
	        var style = model.getBoxCssStyle( TEST_DERIVED_COORDINATES );
	
	        style += this.getFontStyle(
	            !TEST_DERIVED_COORDINATES
	                ? model.getBoxPx()
	                : model.getBoxPxDerived(), // TODO: box derived logic not correct but only for debug
	            word,
	            this.options.spacer
	        );
	
	        return style;
	
	    },
	
	   getFontStyle: function( box, word, spacer ) {
	
	        var containerWidth = box.getWidth();
	        var containerHeight = box.getHeight();
	
	        spacer.style['font-size'] = containerHeight + 'px'; // need to calc based off 100% height
	        spacer.innerHTML = word;
	
	        var actualWidth = spacer.clientWidth;
	
	        var widthScale = containerWidth / actualWidth;
	        var fontSize = Math.floor( widthScale * containerHeight );
	
	        var style = 'line-height:' + containerHeight + 'px;'; // 'center vertical alignment' -- could make a bit smaller
	        style += 'font-size:' + fontSize + 'px;';
	
	        return style;
	
	    }
	
	
	});
	
	//


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"orc-page\">\n    <div class=\"text-overlay-layer layer-zone\"></div>\n    <div class=\"text-overlay-layer layer-line\"></div>\n    <div class=\"text-overlay-layer layer-word\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "                <div data-text-layer-holder=\"true\"></div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "            <div data-canvas-holder=\"true\"></div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"pageLoading hide\">\n                <div class=\"FV-imgLoading-label loadingTop\">Loading page "
	    + alias4(((helper = (helper = helpers.pgNumber || (depth0 != null ? depth0.pgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNumber","hash":{},"data":data}) : helper)))
	    + " ...</div>\n                <div class=\"FV-imgLoading-label loadingBottom\">Loading page "
	    + alias4(((helper = (helper = helpers.pgNumber || (depth0 != null ? depth0.pgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNumber","hash":{},"data":data}) : helper)))
	    + " ...</div>\n            </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "            <div data-unknown-dim-ind-stub=\"true\"></div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\""
	    + container.escapeExpression(((helper = (helper = helpers.classNames || (depth0 != null ? depth0.classNames : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"classNames","hash":{},"data":data}) : helper)))
	    + "\"> <!-- this is for layout and ie transform overflow issue -->\n\n    <div class=\"FV-pg-inner-wr\">\n\n        <!-- annoying -- must still overlay canvas so must position absolute and give height and width of\n            could change if put canvas inside here -->\n        <div class=\"FV-pg-loading-placeholder\"></div>\n\n        <div class=\"FV-pg-transform-wr\">\n            <div data-img-stub=\"true\"></div>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeTextLayer : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </div>\n\n        <!-- since we aren't applying a css transform to the canvas NOW, must place in outside layer -->\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.excludeCanvasStub : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n        <!-- outside: no transform ... may want to change that ... -->\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeLoadingLabels : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.printWithDummyDimensions : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n\n    <!-- maybe move to innerWr -- there were problems with could pages -->\n    <div data-page-dd-stub=\"true\"></div>\n\n\n</div>\n\n";
	},"useData":true});

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(451);
	
	var TextLayerView = __webpack_require__(440);
	
	
	module.exports = TextLayerView.extend({
	
	    onRender: function() {
	
	        this.updateTransform();
	        TextLayerView.prototype.onRender.apply( this, arguments );
	
	    },
	
	    /* Note: needs update on rotation because of the scale factor between the original and derived dimensions */
	    rotate: function() {
	
	        if ( this.page.get('rotation') !== this.page.previous('rotation') )
	            this.updateTransform();
	    },
	
	    updateTransform: function() {
	
	        var dmRatio = this._getDocModeRatio();
	
	        this.$el.css({
	            transform: 'scale(' + dmRatio + ')'
	        });
	
	    },
	
	    // TODO: belongs on model  -- needs to scale to match difference in 'derived' vs original dimensions ( in pixels )
	    // This could also apply to other layers
	    _getDocModeRatio: function() {
	
	        var originalDimensions = this.page.originalDimensions();
	        var derivedDimensions = this.page.getDimensions();
	
	        var r = this.page.get('rotation');
	
	        var dmRatio = ( r === 0 || r === 180 )
	            ? derivedDimensions.width / originalDimensions.w
	            : derivedDimensions.height / originalDimensions.h;
	
	        return dmRatio;
	
	    }
	
	});

/***/ },
/* 451 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(453);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    moment = __webpack_require__(69),
	    BasePage = __webpack_require__(418),
	    PreventDragEventsMixin = __webpack_require__(438),
	    $ = __webpack_require__(59);
	
	__webpack_require__(71);
	__webpack_require__(76); // ( unselectable )
	
	
	/**
	 * TODO: make GOS INFO portion same as page info?
	 * Note: different activity for these views in PDF mode with pages with URLs (they can't be downloaded) --
	 * see PDF subclass below.
	 * TODO: Could now have this inherit from page like the thumbnails views ... yes try it
	 *
	 */
	
	var UnRenderableView = BasePage.extend({
	
	    template: __webpack_require__(454),
	    viewMode: 'base',
	
	    NON_LOADING: 1,
	    APPLY_TRANSFORM: 0,
	
	    onRender: function() {
	
	        BasePage.prototype.onRender.apply( this, arguments );
	        this.ui.downloadBtn.unselectable();
	
	    },
	
	    // Note: not extending here now ...
	    serializeData: function() {
	
	        var m = this.model,
	
	            isGosPageType =  m.hasGosInfo(),
	            gosInfo = m.get('gosInfo'),
	            url = m.getPageUrl(), /* for PDF MODE, THE CRE WON'T RENDER url pages -- so more conditions ... would only be used in PDF MODE */
	
	            data = {
	                viewMode: this.viewMode, /* see below -- class extended */
	                pgNumber: m.get('number'),
	                fmtCtime: moment.convertDBTimeToLocalTime( m.get('ctime') ),
	                isGosPageType: isGosPageType,
	                gosInfo: isGosPageType ? m.get('gosInfo') : null,
	                url: url,
	                showDownloadOriginalButton: this.options.vChannel.request('allowPageDownload', m ),
	                showLargeDownloadWarning: m.isMultipartGosSkeleton()
	            };
	
	        return data;
	
	    },
	    ui: _.extend( {}, BasePage.prototype.ui, {
	        downloadBtn: '.btn-download'
	    }),
	    /**
	     * DVBC-805- Stop propagation of all mouse events catpured by dragScroll plugin.
	     * The will allow the user to select text page info text in the view.
	     * Not applicable to PDF mode, but doesn't hurt here.
	     */
	    events: _.extend( {},
	
	        PreventDragEventsMixin, {
	
	        // Note: this at the page level -- i guess pdf would be at the doc level
	        'click @ui.downloadBtn': function () {
	            this.options.vChannel.command('download', 'page', 'raw', this.model.get('number'));
	        }
	
	    })
	
	});
	
	
	var uDM = UnRenderableView.extend({
	        viewMode: 'document'
	    }),
	
	    uPM = UnRenderableView.extend({
	        viewMode: 'page',
	        APPLY_SCALE: 0
	    }),
	
	    uPDFM = UnRenderableView.extend({
	
	        APPLY_SCALE: 0,
	        viewMode: 'pdf',
	
	        ui: _.extend( {}, UnRenderableView.prototype.ui, {
	            popUrlBtn: '.popUrl'
	        }),
	
	        events: _.extend( {}, UnRenderableView.prototype.events, {
	
	            // Url pages not rendered by the CRE -- don't provide a download button for them but a launch url button.
	            // (They won't be GOS).
	            // For simplicity,  left url in serialize data of the inherited view --
	            // it will either be a GOS page or a page with a non renderable page with a URL.
	            // (view will show either a url with launch, or GOS info table with a download btn ).
	            'click @ui.popUrlBtn': function() {
	                window.open( this.model.getPageUrl() );
	            }
	
	        })
	
	});
	
	
	
	
	module.exports = {
	    base: UnRenderableView,
	    document: uDM,
	    page: uPM,
	    pdf: uPDFM
	};


/***/ },
/* 453 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "                    <button class=\"btn btn-small btn-download\" title=\"Download Original\">\n                        <span class=\"icon-download\"></span>\n                        Download\n                    </button>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "\n                <div class=\"unrenderable-lrg-download-warning\">\n\n                    <span class=\"nr-warning-icon\" title=\"Multi-part GOS skeleton page\">\n                        <i class=\"icon-attention-1\"></i>\n                    </span>\n\n                    <span>\n                        Page is large and may take a while to download.\n                    </span>\n\n                </div>\n\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                        <tr>\n                            <td>file:</td>\n                            <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.filename : stack1), depth0))
	    + "</td>\n                        </tr>\n                        <tr>\n                            <td>path:</td>\n                            <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.pathname : stack1), depth0))
	    + "</td>\n                        </tr>\n                        <tr>\n                            <td>size:</td>\n                            <td>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.gosInfo : depth0)) != null ? stack1.size : stack1), depth0))
	    + "</td>\n                        </tr>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                        <tr>\n                            <td>url:</td>\n                            <td style=\"position: relative;\">\n                                <span title=\""
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "</span>\n                                <span class=\"popUrl\" title=\"Open In New Window\">\n                                    <i class=\"icon-link-ext-alt\"></i>\n                                </span>\n                            </td>\n                        </tr>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-pgWr\">\n\n    <div class=\"nonRenderable nr-"
	    + alias4(((helper = (helper = helpers.viewMode || (depth0 != null ? depth0.viewMode : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"viewMode","hash":{},"data":data}) : helper)))
	    + "-mode\">\n\n        <div class=\"nonRender-wr\">\n\n            <div class=\"subheader\">\n\n                <span class=\"icon icon-attention-circled\"></span>\n                <span class=\"nr-page-lbl\">Page "
	    + alias4(((helper = (helper = helpers.pgNumber || (depth0 != null ? depth0.pgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNumber","hash":{},"data":data}) : helper)))
	    + " Not Renderable</span>\n\n                <div data-page-dd-stub=\"true\"></div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showDownloadOriginalButton : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            </div>\n\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLargeDownloadWarning : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            <table id=\"gosInfo\" class=\"tbl-two-cell\">\n                <tbody>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isGosPageType : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.url : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                    <tr>\n                        <td>creation time:</td>\n                        <td>"
	    + alias4(((helper = (helper = helpers.fmtCtime || (depth0 != null ? depth0.fmtCtime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fmtCtime","hash":{},"data":data}) : helper)))
	    + "</td>\n                    </tr>\n\n                </tbody>\n            </table>\n\n        </div>\n\n    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var PgView = __webpack_require__(418),
	    IframeView = __webpack_require__(456),
	    DocModePg = __webpack_require__(416),
	    PageErrorView = __webpack_require__(436);
	
	
	module.exports = PgView.extend({
	
	    className: 'FV-pgWr FV-pgWr-url', // TODO: inherit ... ( get rid of set element )
	
	    APPLY_TRANSFORM: 0, // hack flag --  could make more generic
	
	    initialize: function(options) {
	
	        _.extend( this, _.pick(options, 'model', 'vChannel', 'scale') );
	
	        this.imgView = new IframeView(options);
	
	    },
	    /**
	     *  Need the 'inView call' for DocMode -- could also apply in viewMode change callback
	     *  Do even if page mode, because won't be able to get its view mode easily onRender
	     */
	    onRender:  DocModePg.prototype.onRender,
	
	    serializeData: function() {
	
	        return _.extend( PgView.prototype.serializeData.call(this), {
	            printWithDummyDimensions: false, // it does have unknown dims, but don't display unnecessary markup
	            excludeCanvasStub: true
	        });
	
	    },
	
	    // TODO: more consolidation ... put the code after isLoaded into separate function
	    requestImg: function() {
	
	        var pm = this.model,
	            imgView = this.imgView;
	
	        pm.off('creRequest');
	        this.triggerMethod('before:ImageRequest');
	
	        if ( !pm.get('isLoaded') ) { // use this or a param for the 're-render' hack
	            pm.set({wasRequested: true}); // --> enter loading state ( show spinner, etc )
	            imgView.loadImg( pm.getPageUrl() );
	        }
	
	    },
	
	    /**
	     * IMPORTANT: unable to determine if from XFRAME-options -- user will prob never see this -- it will just fail hard.
	     * Would require endpoint in server to parse http header.
	     * I don't think Tom allowed me to do this ... not used ... maybe I could implement later on server.
	     * Put in the transformedWr because placeholder may have already been removed ..
	     * here, an error can occur after a successful load.
	     * Note: there is no CRE request going on here.
	     * TODO: the loading cycle here is different; clean up and use what is common.
	     * Note -- this is called from urlFrame and is commented out for the time being -- related to DVBC-1703.
	     */
	    _appendErrorViewInDOM: function(errMsg) {
	
	        this.ui.placeHolder.length > 0 &&
	            this.ui.placeHolder.remove();
	
	        var urlLoadingErr = !errMsg;
	
	        var errMsg = urlLoadingErr
	            ? 'Error Loading URL.\n It may exist on a server set with X-FRAME-OPTIONS="SAMEORIGIN."' //this is a non 'cre loading error' .... now for handling xframe
	            : _.isString(errMsg) ? errMsg : 'Error Loading URL';  //would this ever occur actually ?
	
	
	        this.errorView = new PageErrorView({
	            errMsg: errMsg
	        });
	
	        // Note: transform wr is not transformed here
	        this.ui.transformedWr.append( this.errorView.render().el );
	
	        // this would need to be appended to to the initial view
	
	        if (urlLoadingErr) {
	
	            //very quick imple. -- should make template and/or part/extenstion of the error view
	            var url = this.model.get('url');
	            var $lnk = $('<a>')
	                .attr('href', url)
	                .attr('target', '_blank')
	                .text(url)
	                .attr('title', 'Open In New Window');
	
	            this.$('.pageErrBody').append( $('<div>')
	                .css({
	                    'margin-top': '15px',
	                    'line-height': '1.5em'
	                 })
	                .append('Click below to try opening in it in a new window ')
	                .append( $('<i>').attr('class', 'icon icon-link-ext-alt') )
	                .append('<br>')
	                .append( $lnk) );
	
	        }
	
	    },
	    onBeforeDestroy: function() {
	
	        DocModePg.prototype.onBeforeDestroy.apply( this, arguments );
	
	        // need to investigate why doc mode page view didn't call destroy of super ( and calling this here )
	        this.errorView && this.errorView.destroy();
	
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var CreImage = __webpack_require__(420);
	
	/**
	 * Treat like an image but this is actually an iframe with the page source.
	 * Bypasses any need to get a url to load from the CRE.
	 * Currently used for URL page, formsIQ page, and GOS html pages (in page mode).
	 */
	
	
	module.exports = CreImage.extend({
	
	    tagName: 'iframe',
	
	    attributes: function() {
	
	        var attrs = {
	            frameborder: '0'
	        };
	
	        // May want to white list others ...
	
	        // DVBC-989
	        if ( this.model.isGosHtmlFile() ) {
	            attrs['sandbox'] = '';  // note: will disallow getting the size on load for resize
	        }
	
	        return attrs;
	
	    },
	    className: function() {
	        return CreImage.prototype.className + ' FV-pgIframe';
	    },
	    loadImg: function(url) {
	
	        // Note: not in DOM when src is set (!)
	        this.$el.attr('src', url);
	
	        /**
	         * Manually trigger isLoaded b/c 'load' event of iframe won't fire if it's not in the DOM.
	         * - DVBC-1128: load indicator is shown but the quickly covered up bc of this while the content of the iframe is loading in the DOM.
	         * - this whole workflow should be fixed (eg load in hidden tag, not append to DOM) ...
	         */
	
	        this.model.set({'isLoaded': true});
	    },
	
	    /**
	     * Looks like this was an attempt to determine if the url was on a different domain or if
	     * an x-frame-option was set from the browser.
	     * For now not using -- unable to determine if X-FRAME-OPTION is set from the browser -- leave commented out.
	     * This will fail hard (I don't think a good solution).
	     * See urlPage _appendErrorViewInDOM .
	     * See related issue: DVBC-1703 -- a related issue trying to cache 'error' event from an iframe ( not possible ).
	     */
	
	  /*
	    imgLoaded: function() {
	
	        /!**
	         * handle X-FRAME-OPTIONS set to SAME-ORIGIN in the success callback -- error won't be called in this case
	         * this is currently the default in Feith setup -- can be configured differently
	         * TODO -- issue: differentiate between cross origin and xdomain option
	         * I don't think possible without server or extreme hack.
	         * Presumably the below was to check if cross-domain ... it should not work for catching load errors ( DVBC-1703 )
	         *!/
	
	          try {
	
	            // var x = this.el.contentDocument || this.el.contentWindow.document;
	            // former will break if XDOMAIN in chrome; latter firefox and IEs (tested 9-11) -- NO: THIS WILL ALSO BREAK ONES THAT DO WORK
	
	              var src = this.el.src;
	
	            } catch(err) {
	
	
	                this.model.trigger('imgLoadError');
	                return;
	            }
	
	        CreImage.prototype.imgLoaded.apply(this, arguments);
	
	        // can access this.el.src ... but not contentWindow .... (was allowed to in insecure mode, ugh)
	
	        this.model.get('url') === this.el.src // No, not reliable: can be redirected; http to https
	            ? CreImage.prototype.imgLoaded.apply(this, arguments)
	            : this.model.trigger('imgLoadError');
	
	    }
	*/
	
	});

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/**
	 * Custom for dragging operations relative to the element provided.
	 * Hooks for callbacks.
	 * Support for legacy browsers.
	 * Should decouple 'dragging': data-attribute
	 */
	
	
	
	(function ($) {
	
	    $.fn.dragScoller = function (options) {
	
	        var settings = {
	                sensitivity: 1,
	                sensitivityMultiplier: 2.0,
	                grabClass: 'grab',    //not used, assumes is already applied
	                grabbingClass: 'grabbing',
	                vScrollEnabled: true,
	                hScrollEnabled: true
	            },
	            lastMousePos = {x: 0, y: 0},
	            dragging = false,
	            bbox = {xL: 0, xR: 0, yT: 0, yB: 0},
	            $el = this,
	            $innerDiv = $el.children(':first').addClass(settings.grabClass);  // what is actually scrolled, used for applying the grabbing class
	
	        options && $.extend(settings, options); /* export to see if applied if want to toggle */
	
	        $el.data('grabbyHandApplied', true);
	
	        $el.on('mousedown', function(e) {
	
	            if (e.which === 1) { //left click
	
	                e.preventDefault();
	
	                $innerDiv.addClass(settings.grabbingClass);
	                lastMousePos = $.fn.getMouseCoordinate(e); //start with initial values
	                bbox = $el.getBBox();
	                dragging = true;
	
	                $el.data('dragging', true); //for export
	            }
	
	        }).on('mouseup', function(e) {
	
	            e.preventDefault();
	
	            dragging = false;
	            $el.data('dragging', false); //for export
	
	
	            bbox = null;
	            $innerDiv.removeClass(settings.grabbingClass);
	
	        }).on('mousemove', function(e) {
	
	            e.preventDefault();
	
	            var $win = $(window),
	                s = settings;
	            
	            if (dragging) {
	
	
	                var mousePageX = e.pageX - $win.scrollLeft(),
	                    mousePageY = e.pageY - $win.scrollTop();
	
	                // If out of bounds, trigger a mouse up and exit
	                if (mousePageX <= bbox.xL || mousePageX >= bbox.xR || mousePageY <= bbox.yT || mousePageY >= bbox.yB) {
	                    $el.trigger('mouseup', e);
	                    return false;
	                }
	
	                var dx = (e.pageX - lastMousePos.x) * s.sensitivityMultiplier * s.sensitivity,
	                    dy = (e.pageY - lastMousePos.y) * s.sensitivityMultiplier * s.sensitivity;
	
	                lastMousePos = $.fn.getMouseCoordinate(e);
	
	                if (dx === 0 && dy === 0) {
	                    return;
	                }
	
	                s.hScrollEnabled && $el.scrollLeft($el.scrollLeft() - dx);
	                s.vScrollEnabled && $el.scrollTop($el.scrollTop() - dy);
	            }
	        });
	
	
	        this.destroyDragScroller = function () {
	
	            $el.off('mousedown mouseup mousemove')
	                .data('grabbyHandApplied', '');
	
	            $innerDiv.removeClass(settings.grabClass);
	        };
	
	        // TODO: implement these function
	        this.toggleVerticalScroll = function(turnOn) {
	             settings.vScrollEnabled = turnOn ? true : false;
	        };
	
	        this.toggleHorizontalScroll = function (turnOn) {
	            settings.hScrollEnabled = turnOn ? true : false;
	        };
	
	        return this;
	    };
	
	
	    /**
	     * Return 'bounding box' of element for use in grabby-hand scrolling.
	     * Return bbox of dimensions of element at the document level -- only used in this grabby hand plugin
	     */
	    $.fn.getBBox = function(options) {
	        var settings = {
	            yBuffer: 5,
	            xBuffer: 5
	        },
	       outerLeft = this.offset().left - $(window).scrollLeft(),
	       outerTop = this.offset().top - $(window).scrollTop();
	
	       options && $.extend(settings, options);
	
	       return {
	            xL: outerLeft + settings.xBuffer,
	            xR: outerLeft + this.width() - settings.xBuffer,
	            yT: outerTop + settings.yBuffer,
	            yB: outerTop + this.height() - settings.yBuffer
	        };
	    };
	
	
	}(jQuery));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/* ben: smaller fork of lazy load 
	    -- combo of this and remy sharp inview plugin -- emit event by default, no placeholder ... */
	/* now relies on lazyload */
	__webpack_require__(459); //todo: take off plugin
	
	(function($) {
	
	    /* the former -- triggers inview event when the element is in view; checked in response to center events */
	    $.fn.lazyLoad = function(options) {
	        var settings = {
	            delay: 100,       /* the throttle value -- the amount of time to wait after the triggering event occurs before checking for visibility */
	            container: window,
	            skipClass: 'invisible',
	            inViewEvent: 'inview', //todo: cb instead?  //trigger internally, then have cb
	            eventTriggers: 'scroll checkInView'
	        },
	        elements = this,
	        timeout = null;
	
	        function checkElements() { //todo: filter those already inView ... cache
	            var s = settings,
	                containerOffsets = $(s.container).getOffsets();
	
	            //todo: should check the container offsets first
	            elements.each(function() {
	                var $el = $(this); 
	                if ( !($el.hasClass(s.skipClass) )) {
	                 
	                    if ( $el.inView(s.container, {containerOffsets: containerOffsets}) ) {    /* plugin fn req'd in webpack config */
	
	                        $el.trigger(s.inViewEvent)[0].loaded = true;
	                        var temp = $.grep(elements, function(elem) {
	                            return !elem.loaded;
	                        });
	                        elements = $(temp);
	
	                    }
	                }
	
	            });
	        }
	
	        if (options) $.extend(settings, options);
	
	        var $container = settings.container;
	
	        $.each(elements, function() {
	            this.loaded = false; //undefined vs bool (store on dom node)
	        });
	
	        /* Check if Element are 'InView on these Events -- they trigger 'inview' if inview or 'notinview' if not*/
	        $container.on(settings.eventTriggers, function(e) {
	            if (timeout) clearTimeout(timeout);
	            timeout = setTimeout(function() {
	                  checkElements();
	                }, settings.delay);
	            }
	        );
	
	        /* turn off events for the container, and also inview events for all elements its checking */
	        $container.on('lazyload.destroy', function(e) {
	            //clear all from the container
	            $container
	                .off('lazyload.destroy')
	                .off(settings.eventTriggers);
	
	            $.each(elements, function() {
	                $(this).off(settings.inViewEvent);
	            });
	        });
	
	        return this;
	    };
	
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function($) {
	
		/* one time call if element is in the view of a container element -- return true or false */
	    /* container req'd unless it's offsets are passed in the options prop */
	
	    $.fn.inView = function(container, options) {
	
	        var $container,
	            settings = {
	                yOverflow: false, //if overflow, take the scrollbar width into account
	                xOverflow: false,
	                scrollBarWidth: 0,
	                threshold: 0
	            };
	
	        container && ($container = container.jquery ? container : $(container));
	        options && $.extend(settings, options);
	
	        var containerOffsets = settings.containerOffsets 
	                ? settings.containerOffsets /* eg for lazy load */
	                : $container.getOffsets(),
	            elementOffsets = $(this).getOffsets();
	
	        //adjust container offset width and height if have overflow -- not using client height so can support IE8
	        settings.yOverflow && (containerOffsets.height -= settings.scrollBarWidth);
	        settings.xOverflow && (containerOffsets.width -= settings.scrollBarWidth);
	
	        if (aboveTheTop(containerOffsets, elementOffsets, settings) ||
	            leftOfBegin(containerOffsets, elementOffsets, settings)) {
	            return false;
	        } else if ( !belowTheFold(containerOffsets, elementOffsets, settings) &&
	            !rightOfFold(containerOffsets, elementOffsets, settings)) {
	            return true;
	        } else {
	            return false;
	        }
	
	        function belowTheFold(containerOffsets, elementOffsets, settings) {
	            var fold = containerOffsets.top + containerOffsets.height;
	            return fold <= elementOffsets.top - settings.threshold;
	        }
	
	        function rightOfFold(containerOffsets, elementOffsets, settings) {
	            var fold = containerOffsets.left + containerOffsets.width;
	            return fold <= elementOffsets.left - settings.threshold;
	        }
	
	        function aboveTheTop(containerOffsets, elementOffsets, settings) {
	            var fold = containerOffsets.top;
	            return fold >= elementOffsets.top + settings.threshold + elementOffsets.height;
	        }
	
	        function leftOfBegin(containerOffsets, elementOffsets, settings) {
	            var fold = containerOffsets.left;
	            return fold >= elementOffsets.left + settings.threshold + elementOffsets.width;
	        }
	    };
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div class=\"FV-"
	    + container.escapeExpression(((helper = (helper = helpers.docOrPg || (depth0 != null ? depth0.docOrPg : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"docOrPg","hash":{},"data":data}) : helper)))
	    + "Mode FV-paneContentWr\">\n    <div class=\"FV-paneContent FV-page\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * The Image height/width set from calcuations's after loading into browser
	 * -- allows for display of cold images (no size).
	 */
	
	
	var Marionette = __webpack_require__(61),
	    PgModeImgWr = __webpack_require__(462),
	    UnRenderablePg = __webpack_require__(452).page,
	    PgModeColdPg = __webpack_require__(466),
	    BaseContainer = __webpack_require__(415),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    UrlPage = __webpack_require__(455),
	    PgModeGosPg = __webpack_require__(473);
	
	
	__webpack_require__(457);
	
	
	var instVars = {
	    scaleModel: {}, // always starts blank, needs to render first
	
	    /* From init of options */
	    model: null,  // note: not really needed until renderNewPageView but stored for clarity -- the pageModel -- always reset on renderNewPageView
	    vChannel: null,
	    viewMdsCh: null // now communication proxy from viewer to pages
	};
	
	/* Note: the view in the pageMode Region -- the view holds an image view -- dependent on props of the model */
	module.exports = Marionette.LayoutView.extend({
	
	    template: __webpack_require__(460), // should put in base mode container mixin
	
	    /**
	     * Only change scale mode to that of doc mode on entry if the page wasn't originally opened in page mode
	     */
	    initialize: function(options) {
	
	        _.extend( this, BaseContainer, instVars, _.pick(options, 'model', 'vChannel', 'viewMdsCh') );
	
	    },
	    serializeData: function() {
	        return {
	            docOrPg: 'pg'  //TODO: base
	        };
	    },
	    onRender: function() {
	        this.unwrap();
	        this.$el.dragScoller();
	    },
	    regions: {
	        pageView: '.FV-paneContent' //use to show new view in there w/out override of scale divs -- the old image wrapper
	    },
	    onSetScaleModel: function(sm) { //scale model can only created post render
	        this.scaleModel = sm;
	        this.postScaleTypeChange(); //must be done if viewer opened into page mode view
	    },
	    _getPgViewConstructor: function(pgModel) {
	
	        if ( pgModel.isCold() )
	            return PgModeColdPg;
	
	        if ( !pgModel.isRenderable() )
	            return UnRenderablePg;
	
	        if ( pgModel.renderUrlViewForDocAndPageMode() )
	            return UrlPage; // (Include GOS html )
	
	        return pgModel.isGOS()
	            ? PgModeGosPg
	            : PgModeImgWr;
	            
	    },
	
	    renderNewPageView: function( fullPageModel ) {
	
	        this.model = fullPageModel;  // always reset the page model: will override that set in init (this.options)
	
	        this.$el.scrollTop(0).scrollLeft(0); //reset viewport -- allow to see loading indicator
	
	        var pgModel = this.model,
	            PageViewConstructor = this._getPgViewConstructor(pgModel),
	            pageView = new PageViewConstructor({
	                scale: this.scaleModel,
	                vChannel: this.vChannel,
	                viewMdsCh: this.viewMdsCh,
	                model: pgModel // model not really necessary for the container -- instead for the page view
	            });
	
	        // Note: first the initial is removed anyway -- have an alternative path of just setting
	        this.getRegion('pageView').once('show', function() {
	            pgModel.trigger('creRequest');
	        }).show(pageView);
	
	    },
	    events: {
	        // this is for the properties dialog view of the redaction shape --
	        // perhaps only fire if flag set and or debounce the callback
	        'scroll': function() {
	            this.viewMdsCh.trigger('repositionShapeDialog');
	        }
	    },
	    /**
	     * Comes from successful image load or scale change model.
	     * Will get called twice on first entry ( both called ) -- will have no effect
	     * Set the scale first,then change the size elements with the new scale value
	     * Don't allow (if cold and the image isn't loaded, don't use the size that wasn't yet set by image load)
	     * Called if in pageMode from state controller (same method name in doc mode)
	     * Note: now also comes from rotation change
	     */
	    postScaleChange: function( scale, previousScale, options ) {
	
	
	        if ( !this.model.isRenderable() )
	            return;
	
	        // Check to not scale if view doesn't yet exist
	        var currentPgView = this.getRegion('pageView').currentView;
	        if ( ! currentPgView )
	            return;
	
	
	        if ( options && options.fromRotation ) {
	
	            currentPgView.rotate.apply( currentPgView, arguments );
	
	        } else {
	
	            currentPgView.updateViewPort.apply( currentPgView, arguments );
	
	        }
	
	    },
	
	    /**
	     *  Note:
	     *  - now filtered and only called for drawable note types.
	     *  - no longer creating a canvas if one doesn't exist ( eg if user creates new note -- canvas should always exist )
	     *  - central point for canvas creation is now on load of the page
	     *  - find and redact drawing mode may be different -- eg: want 'grab'; change to always render canvas
	     *    should help facilitate ( if already created, just trigger 're-render' shapes equivalent )
	     *    - will prob not want to call this toggle active note, it will no longer have anything to do with find & redact
	     *     unless why utilize the change activePage outline
	     *  - Now that canvas always created; may want to put in DOM first before shapes are to simplify canvas creation WF due
	     *   to errors with Raphael text having to be in DOM.
	     */
	    toggleDrawingMode: function(pgNote, options) {
	
	        var pgRegion = this.getRegion('pageView');
	
	        if (pgNote) {
	
	            pgRegion.$el.removeClass('grab');
	            this.$el.destroyDragScroller();
	
	        } else {
	
	            pgRegion.$el.addClass('grab');
	            this.$el.dragScoller();
	        }
	
	        // Note: this will take action on the page and then re-render the shapes on the canvas
	        // If the page hasn't yet loaded (eg enter from mode/page change), same logic is applied
	        // prior to render of the canvas so this action is not skipped.
	        // Separate now for find and redact -- want to re-render shapes.
	        this.viewMdsCh.trigger('activeNoteChange', pgNote, options);
	
	    },
	
	    /**
	     * Now just handle the disabling grabby hand for 'Best Fit scale';
	     * Previously also prevented overflow via CSS.
	     */
	    postScaleTypeChange: function() {
	
	        var scaleType = this.scaleModel.get('scaleType'),
	            grabbyHandApplied = this.$el.data('grabbyHandApplied'); // this should be a state/variable
	
	        if ( this.scaleModel.isBestFit() ) {
	
	            this.$el.destroyDragScroller(); // ( toggles grabbyHandApplied )
	
	        } else {
	
	            !grabbyHandApplied && this.$el.dragScoller();
	        }
	
	    },
	
	    onBeforeDestroy: function() {
	        this.$el.destroyDragScroller();
	    }
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(463);
	
	var PageImageWr = __webpack_require__(418),
	    $ = __webpack_require__(59),
	    CanvasBridgeMixin = __webpack_require__(464);
	
	
	module.exports = PageImageWr.extend({
	
	    className: 'FV-pgWr FV-pgWr-PgMode',
	
	
	    onAfterImageAppend: function() {
	
	        this.createCanvas(); // now sync
	        this._reveal();
	
	    },
	
	    // renders too
	    createCanvas: function() {
	
	        _.extend( this, CanvasBridgeMixin );
	
	        /**
	         * Prior to creation of the canvas, handle stuff on the page
	         * to avoid potential race-condition with toggleDrawingMode when coming from a different mode/page --
	         * same strategy as how now handling the canvas itself.
	         * I suppose this could be done render but if we only we creating a canvas, placing here makes sense.
	         * Note, unlike the canvas module, no action must be taken on the page view for an expanded note.
	         */
	        var activeNote = this.vChannel.request('activeNote');
	        activeNote && this.triggerMethod( 'activeNoteChange', activeNote );
	
	        this.createAndRenderCanvas(); // also puts in the channel ... that's not good; now also appends ...
	
	    },
	
	    /**
	     * Hook forwarded from canvas mixin, called before event passed to the canvas.
	     * Also now triggered on creation of canvas -- so if coming from different mode/page will not be skipped
	     * from toggleEditMode from activeNote change ( like how where checking this on render of canvas now ).
	     */
	    onActiveNoteChange: function(note) {
	
	        this.$el.toggleClass('canvas-edit-mode', note && note.isDrawable());
	
	    },
	
	    /**
	     * For now canvas is still a separate layer.  The outer html el
	     * Should be resized with the page but re-render the shapes.
	     * Dream is later utilizing the css transform to be on the same plane as the Raphael canvas,
	     * but that's a LARGE refactor.
	     * Kept separate from scale for time-being.
	     * Now, set a flag so update viewport doesn't touch the canvas (this must be done after).
	     * Without, a scale would scale the canvas -- which we DON'T WANT --
	     * It will break floating redaction, where if scale is called,
	     * positions are not calculated correctly for code boxes ( think of it hacked in approach )
	     * see controller.positionCodeViewsFromModelPts
	     */
	    rotate: function() {
	
	        this.skipScalingCanvas = 1;
	
	        PageImageWr.prototype.rotate.apply( this, arguments );
	
	        delete this.skipScalingCanvas;
	
	        // Now 'rotate' the canvas by redrawing the shapes ( the redraw takes rotation into account)
	        if ( this.canvas ) {
	            this.pgCanvasChannel.trigger('pageRotated');
	        }
	
	    },
	
	    // Add's scaling the canvas -- ultimately we may want in basePage --
	    // For now, leaves clearer what skipScalingCanvas means when called from rotation
	    updateViewPort: function() {
	
	        PageImageWr.prototype.updateViewPort.apply( this, arguments );
	
	        if ( this.canvas && !this.skipScalingCanvas )
	            this.canvas && this.scaleCanvas.apply(this, arguments);  //  trigger and optimize ..
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 463 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, Marionette, _) {var Canvas = __webpack_require__(356);
	
	__webpack_require__(465);
	
	/**
	 * Mixed into Page If Canvas Necessary
	 * Allows to have page module without Raphael for just rendering images
	 * Also, commands pass though the viewer to the page to the canvas; not from the viewer to the canvas -- allowing for multi canvases
	 * Note: renders and wires but doesn't put in DOM
	 */
	
	
	module.exports = {
	
	    canvas: null, /* the instance of the canvas */
	
	    pgCanvasChannel: null,
	
	    // note: set upon canvas creation && forwarded directly to canvasPageChannel outer subscriptions/requests ... so to not break ...
	    // TODO: combine any that just call re-render into re-render shapes
	    viewModesSubs: {
	        noteSaved:                  'noteSaved',
	        activeNoteChange:           'activeNoteChange',
	        expandedNoteChange:         'expandedNoteChange',
	        activeNoteSubTypeChange:    'activeNoteSubTypeChange',
	        toggleHighlightedNote:      'toggleHighlightedNote',
	        noteDeleted:                'noteDeleted',
	        setDrawColor:               'setDrawColor',
	        setStrokeWidth:             'setStrokeWidth',
	        closeCanvasDialogs:          'closeCanvasDialogs',
	        repositionShapeDialog:      'repositionShapeDialog', // ( this not forward when the page container is scrolled )
	        graphicStampChanged:        'graphicStampChanged',
	        consultGroupChange:         'consultGroupChange',
	        applyAllRedactionsToggled:  'applyAllRedactionsToggled',
	        pageRotated:                'pageRotated',
	        reRenderShapes:             'reRenderShapes'
	    },
	
	
	    /* exports -- TODO: just forward events to vChannel ( and I think can rid from here -- just go to subsCallbacks */
	    canvasSubs: {
	        hoveredNoteChange:          'hoveredNoteChange',
	        drawingToggled:             'drawingToggled',
	        changeActiveNoteSubtype:    'changeActiveNoteSubtype',
	        cancelSignature:            'cancelSignature'
	    },
	
	    createAndRenderCanvas: function() {
	
	        this.pgCanvasChannel = new Backbone.Radio.Channel('pgCanvasChannel:' + this.cid);
	
	        this._wireCommunicationWithCanvas();
	
	        // Note: init will create the canvasView but not render the shapes/set the dimensions
	        // ( Everything that can be done with it being in the DOM yet )
	        // At this point in page loading WF, page view must be in the DOM
	
	        this.canvas = new Canvas({
	            vChannel: this.vChannel,
	            pageCanvasCh: this.pgCanvasChannel,
	            page: this.model,
	            scale: this.scale
	        });
	
	        // Put the canvas view in the DOM prior to rendering the shapes and setting the bounds
	        this.ui.canvasPlaceholder.append( this.canvas.canvasView.el );
	
	        // Post DOM 'render'; no longer a render method on the view.
	        // First time through this sets the bounds and renders the shapes
	        this.pgCanvasChannel.command( 'reRenderShapes' );
	
	    },
	
	    /* all viewer communication needs to pass through the page object and filter it applies to the page */
	    _wireCommunicationWithCanvas: function() {
	
	        Backbone.fwd.call( this.options.viewMdsCh, this.pgCanvasChannel );
	        Marionette.bindEntityEvents(this, this.options.viewMdsCh, this.viewModesSubs);   /* FORWARD TO */
	        Marionette.bindEntityEvents(this, this.pgCanvasChannel, this.canvasSubs);   /* FORWARD FROM */
	    },
	
	    scaleCanvas: function(scale, prevScale, options) {
	
	        var c = this.pgCanvasChannel;
	        c.command('updateScale', scale, prevScale, options);
	
	    },
	
	
	    //  unsure if necessary ....
	    // unwireCommunicationWithCanvas: function() {
	    //
	    //    this.options.viewMdsCh.stopListening(this.pgCanvasChannel);
	    //    Marionette.unbindEntityEvents(this, this.options.viewMdsCh, this.viewModesSubs);
	    //    Marionette.unbindEntityEvents(this, this.pgCanvasChannel, this.canvasSubs);
	    //
	    //},
	
	    /* ----- The Forwards ----- */
	
	    // Intermediary steps here desired before forwarding directly from here (page) to the canvas
	    // Also this one not a one-one forward -- just call reRenderShapes
	    activeNoteChange: function(note, options) {
	
	        var c = this.pgCanvasChannel,
	            args = _.toArray(arguments);
	
	        // Take action on the page first
	        this.triggerMethod.apply( this, ['activeNoteChange'].concat(args) );
	
	        c.command('reRenderShapes');
	
	    },
	
	    closeCanvasDialogs: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['closeCanvasDialogs'].concat( _.toArray(arguments)) );
	    },
	    repositionShapeDialog: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['repositionShapeDialog'].concat(_.toArray(arguments)));
	    },
	    toggleHighlightedNote: function() {
	        var c = this.canvas; //(this one also trigger from the other side)
	        c.toggleHighlightedNote.apply(c, arguments);
	    },
	    setDrawColor: function() {  //overlap with active note change -- removeNoteShapesFromCanvas old
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['setDrawColor'].concat(_.toArray(arguments)));
	    },
	    setStrokeWidth: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['setStrokeWidth'].concat(_.toArray(arguments)));
	    },
	    noteDeleted: function() {  //overlap with active note change -- removeNoteShapesFromCanvas old
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['noteDeleted'].concat(_.toArray(arguments)));
	    },
	    noteSaved: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['noteSaved'].concat(_.toArray(arguments)));
	    },
	    activeNoteSubTypeChange: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['activeNoteSubTypeChange'].concat(_.toArray(arguments)));
	    },
	
	    expandedNoteChange: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply( c, ['expandedNoteChange'].concat(_.toArray(arguments)) );
	    },
	
	    graphicStampChanged: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['graphicStampChanged'].concat( _.toArray(arguments)) );
	    },
	
	    consultGroupChange: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['consultGroupChange'].concat( _.toArray(arguments)) );
	    },
	
	    reRenderShapes: function() {
	        this.pgCanvasChannel.command('reRenderShapes');
	    },
	
	    /* ------ exports -- of vChannel ----- */
	    cancelSignature: function() {
	        var c = this.vChannel;
	        c.trigger.apply(c, ['canvas:cancelSignature'].concat( _.toArray(arguments) ));
	    },
	    changeActiveNoteSubtype: function() {
	        var c = this.vChannel;
	        c.trigger.apply(c, ['canvas:changeActiveNoteSubtype'].concat( _.toArray(arguments) ));
	    },
	    drawingToggled: function() {
	        var c = this.vChannel;
	        c.trigger.apply(c, ['canvas:drawingToggled'].concat( _.toArray(arguments) ));
	    },
	    hoveredNoteChange: function() {
	        var c = this.vChannel;
	        c.trigger.apply(c, ['canvas:hoveredNoteChange'].concat( _.toArray(arguments) ));
	    },
	    applyAllRedactionsToggled: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['applyAllRedactionsToggled'].concat( _.toArray(arguments)) );
	    },
	    pageRotated: function() {
	        var c = this.pgCanvasChannel;
	        c.command.apply(c, ['pageRotated'].concat( _.toArray(arguments)) );
	    }
	
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(61), __webpack_require__(49)))

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {Backbone.fwd = function(source, options){
	  options = options || {};
	
	  this.listenTo(source, "all", function(){
	    var args = Array.prototype.slice.call(arguments);
	    var eventName = args.shift();
	
	    // handle prefix for event name
	    if (options.prefix){
	      eventName = options.prefix + ":" + eventName;
	    }
	
	    // handle suffix for event name
	    if (options.suffix){
	      eventName = eventName + ":" + options.suffix;
	    }
	
	    args.unshift(eventName);
	    this.trigger.apply(this, args);
	  }, this);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(467);
	
	var _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV'),
	
	    PgModeImgWr = __webpack_require__(462),
	    TextOverlay = __webpack_require__(468),
	    TextGridModel = __webpack_require__(470),
	    TextPageActionDropdown = __webpack_require__(471);
	
	__webpack_require__(389);
	
	
	/**
	 * TODO: this whole process should be cleaned up, especially with new rotation method and given other text page tickets
	 * Continue fetching page text on demand due to bottleneck loading document with many pages
	 * ( vs send in original doc info response ).
	 * - should have at least a wrapper around the paper and overlay with the max dimensions for positioning
	 * childViews: -- want to make base page a babysitter view and then add these children for cleanup
	 *  - textOverlay
	 */
	
	var instVars = {
	
	    hasImageOverlay: 0, // cache
	
	    // (only applicable to when 'drawing'; always start disabled, enable only after canvas is put on DOM )
	    // means the z-index of the text view is above the canvas (when in canvas edit mode)
	    selectTextMode: 0,
	
	    showImgOverlay: null,
	    showGreenbar: null,
	
	    $dfdTextFetched: null, // deferreds must be set anew each time (extend is copying by ref onto the PROTOTYPE)
	    $dfdImageAppended: null,
	
	    imgActualDims: null, //(only set if has img overlay)
	
	    wasDestroyed: 0 // DVBC-1728: flag the the view was destroyed
	
	};
	
	
	module.exports = PgModeImgWr.extend({
	
	    PageActionsDropDownView: TextPageActionDropdown,
	
	    // Note: called twice due to Marionette _ensureElement constructor (and on serialize data); doesn't hurt:
	    // Just make sure don't change the prototype (why interm. step)
	    className: function() {
	        var c = PgModeImgWr.prototype.className;
	        return c += ' FV-pgCold';
	    },
	
	    initialize: function() {
	
	        PgModeImgWr.prototype.initialize.apply(this, arguments);
	
	        var localStorage = fvChannel.request('localStorage');
	
	        _.extend( this, instVars, {
	
	            $dfdTextFetched: $.Deferred(),
	            $dfdImageAppended: $.Deferred(),
	
	            hasImageOverlay: this.model.hasImageOverlay(),
	            showImgOverlay: localStorage.getShowOverlays(),
	            showGreenbar: localStorage.getShowGreenbar()
	
	        } );
	
	
	        if ( this.hasImageOverlay ) {
	
	            var overlayImgProps = this.model.get('overlay').imageProperties;
	
	            this.imgActualDims =  {
	                width: overlayImgProps.width / overlayImgProps.originalHDPI * 96,
	                height: overlayImgProps.height / overlayImgProps.originalVDPI * 96
	            };
	
	        }
	
	        var self = this;
	
	        // Take over page workflow here
	        $.when( this.$dfdTextFetched, this.$dfdImageAppended ).done( function() {
	
	            // DVBC-1728- if the view was destroyed from changing the page prior to
	            // completion of the dfd's, abort; otherwise runtime errors will ensure trying
	            // to append things to a DOM that no longer exists.
	            if ( self.wasDestroyed ) {
	                return;
	            }
	
	            /**
	             * Stop spinner when no image overlay
	             * ( we could actually call regardless because the event will only be listened to once, and skipped the 2nd time if an overlay )
	             *
	             */
	            if ( !self.hasImageOverlay ) {
	                self.model.set( 'isLoaded', true );
	            }
	
	            self._createTextOverlayView.call( self );
	
	
	            // 'Continue': create canvas if necessary and reveal as for regular page with just an image
	            PgModeImgWr.prototype.onAfterImageAppend.call( self );
	
	        });
	
	
	        if (!this.hasImageOverlay) {
	            this.$dfdImageAppended.resolveWith( this );
	        }
	
	
	    },
	
	    /**
	     * Combo the image request (if there is an overlay), with the text request.
	     * For the former, onAfterImageAppend is overwritten: proceeding to it require the text as well.
	     * Failure: of either cre req or text req after successful cre req
	     * Now skip the getting the text and creating the grid model if it was already fetched.
	     */
	    requestImg: function() {
	
	        this.hasImageOverlay &&
	            PgModeImgWr.prototype.requestImg.call( this, this.model.get('overlay').address );
	
	        if ( this.model.get('textGridModel') ) {
	            this.$dfdTextFetched.resolveWith( this );
	            return;
	
	        }
	
	        this.doTextRequest()
	            .done( function( text ) {
	                var textGridModel =  new TextGridModel( text, this.model.get('overlay') );
	
	                // Cache on the document mode page model ( it would get cleared from the page model )
	                var pgModel =  this.vChannel.request( 'getPageModelFromNumber', this.model.get('number') ); // this is different than this.model
	                pgModel.setTextGridModel( textGridModel );
	
	                // And the first time through store on the full page model -- subsequent times will be cloned.
	                this.model.setTextGridModel( textGridModel );
	
	                this.$dfdTextFetched.resolveWith( this );
	
	            })
	            .fail( function( shortMessage, detailedMsg ) {
	                // Note: the top $dfd won't be resolved.
	                this.model.trigger( 'imgLoadError', shortMessage + ': ' + detailedMsg );
	
	            });
	
	    },
	
	    /* ( override -- don't do if no image overlay ) */
	    _appendImageView: function() {
	
	        if ( !this.hasImageOverlay ) {
	            return;
	        }
	
	        PgModeImgWr.prototype._appendImageView.apply( this, arguments );
	
	    },
	
	    /**
	     * Must do here otherwise reveal won't work if option it to not show.
	     * Leave invisible to take up space (still need to measure size) and make opaque for visual effect
	     */
	    onBeforeImageAppend: function() {
	
	        PgModeImgWr.prototype.onBeforeImageAppend.apply(this, arguments);
	        !this.showImgOverlay && this.imgView.$el.addClass('noOpacity');
	
	    },
	    /**
	     * Only applicable is there is an overlay image.
	     * Override 'base' to resolve the $dfdImage appended, taking over regular page
	     * workflow to account for requesting the text from the CRE.
	     */
	    onAfterImageAppend: function() {
	
	        // This could be in template if want sep template here ... that could clean up a bunch of stuff
	        // Unsure exactly what this was for or if still necessary
	        this.imgView.$el.wrap( $('<div class="coldImgOverlayWr">') );
	
	        // Must scale prior to creation of canvas -- and do b/f reveal anyway
	        // Unknowns dims does this after setting the dims as well
	        this.updateViewPort();
	
	        this.$dfdImageAppended.resolveWith(this);
	
	    },
	
	    /**
	     *
	     * Toggle enabled the text-selection menu-item -- feature only applies if there is a canvas on the page
	     * - (selecting text over the canvas)
	     * - this will cover the case of when a canvas is created on page load & when a new one is created by creating a new drawable note
	     * Don't disable the menu item after it's already been enabled
	     * - (the canvas is not deleted if there are no shapes; still want to be able to select text)
	     * -  improvement would be to set this back already
	     * TODO ... on close of canvas without shapes, set back its z-index, maybe can get from is page has drawable notes / shapes ?
	     * it should do the right thing, if no shapes, always put it in select text mode
	     */
	    _createPageActionDropDown: function() {
	
	        PgModeImgWr.prototype._createPageActionDropDown.apply(this, arguments);
	
	        /**
	         * Very hacky way of positioning the dropdown menu outside the page inner wrapper
	         * Quick fix in lieu of creating another template.
	         * Can't do with page css b/c no longer in the page (its in the container) -- may be able to change this now ....
	         */
	        this.pageDDView.options.el.css({
	            right: '5px'
	        }).insertAfter(this.$el);
	
	        /**
	         * DVBC-1141 -- notes:
	         * Like the old buttons, not great b/c if page scale is small, will not be positioned relative to the page -- its now positioned to the container
	         * For fit width, it's ok looking
	         * Real answer is different markup where the page is not the placeholder for the loading image -- so can position accordingly, but will likely break existing model
	         * AND NOW ITS VIEWABLE AND OUT OF THE WAY OF THE OTHER BUTTONS
	         * And it's now viewable out of the way of the old buttons
	         */
	    },
	    _getActionDropDownOptions: function() {
	
	        return _.extend( {}, PgModeImgWr.prototype._getActionDropDownOptions.apply(this, arguments), {
	                parent: this, //prob better mediated later on ... now imple. like had done with the old toggle buttons ... see the callbacks below
	                hasImageOverlay: this.hasImageOverlay //I think also on model
	            },
	            // values are what to set on the first render --
	            // 'selectTextMode' not needed -- on render it always start false
	            _.pick( this, 'showImgOverlay', 'showGreenbar')
	        );
	
	    },
	
	    /**
	     * Toggle button callbacks.
	     * Note: only applicable when in 'canvas editing mode'
	     * Swap the z-index of the canvas and text views -- selectTextMode is when the text is above the canvas
	     */
	    onToggleTextSelection: function() {
	        this.selectTextMode = !this.selectTextMode; // not sure if variable is still what is wanted here
	        this.$el.toggleClass('canvas-edit-mode-select-text', this.selectTextMode);
	    },
	
	    onToggleOverlayImg: function() {
	        this.showImgOverlay = !this.showImgOverlay;
	        fvChannel.request('localStorage').setShowOverlays( this.showImgOverlay ? 1 : 0 );
	        this.imgView.$el.toggleClass('noOpacity', !this.showImgOverlay, 400); // Allow to take up space!
	    },
	
	    onToggleGreenBar: function() {
	        this.showGreenbar = !this.showGreenbar;
	        fvChannel.request('localStorage').setShowGreenbar( this.showGreenbar ? 1 : 0 );
	        this.textOverlay.toggleGreenBar(); // mediate?
	    },
	    /*
	    * Actually 2 requests:
	    * - the render request from the CRE then,
	    * - the text to render from the 'inlineUrl' returned from the first.
	    * The text is what is really desired (along with deferred).
	    * Now only called if not already fetched.
	    * onStart:
	    * - onStart as base page ( kick off 'loading state' with spinner ) -- $.noop
	    * - if there's an image overlay, the event can only be kicked off once ( see .off in base page ),
	    * - so in general, error handling works for pages with and without overlays ( tested )
	    * */
	    doTextRequest: function() {
	
	        var fvSettings = fvChannel.request('settings'),
	            self = this,
	            model = this.model;
	
	        return $.Deferred(function($dfd) {
	
	            $.fn.creRequest( _.extend( {}, model.getTextOverlayRenderRequest(), {
	
	                onStart: _.bind( model.set, model, {'wasRequested': true}),
	
	                onComplete: function(data) {
	
	                    /* Get the overlay text from the resulting data */
	                    $.ajax({
	                        url: data.downloadUrl,
	                        type: 'GET',
	                        dataType: 'text'
	                    }).done( function(text) {
	                        $dfd.resolveWith(self, [text]);
	
	                    }).fail( function( jqXHR ) {
	                        $dfd.rejectWith( self, ['Error Retrieving Overlay Text', $.fn.ajaxErrorMessage( jqXHR ) ] );
	                    });
	
	                },
	                onError: function(errMsg) {
	                    $dfd.rejectWith( self, ['Error Requesting Overlay From CRE', errMsg] );
	                },
	                fileName: model.getPageName( undefined, 1 ),
	                CRE_ROOT: fvSettings.getCRERoot(),
	                POLL_FREQ: fvSettings.crePollInterval
	            }));
	
	        }).promise();
	
	    },
	
	    _createTextOverlayView: function( ) {
	
	        var pageDimensionsChanged = false;
	
	        if ( !this.hasImageOverlay ) {
	            pageDimensionsChanged = this._adjustPageDimsBasedOnActualTextDims();
	        }
	
	        this.textOverlay = new TextOverlay({
	            parent: this,
	            model: this.model,
	            textGridModel: this.model.getTextGridModel()
	        });
	
	        var overlay = this.model.get('overlay');
	
	
	        /**
	         * For pages with image overlays without dimensions -- apply the CRE's logic of setting the page size to
	         * that derived from the text (CRE-260; if there's no overlay, FDD's adjustment logic would always work,
	         * since pages without dimensions would be adjusted ).
	         * Do this after the first conditional -- until refactor, utilize textOverlay to get the actual dimensions.
	         */
	        if ( this.hasImageOverlay ) {
	
	            if (  overlay.paperWidth === 0 || overlay.paperHeight === 0 ) {
	
	                var actualTextDimensions = this.model.getTextGridModel().actualDimensions( );
	
	                this.model.set({
	                    width: actualTextDimensions.width,
	                    height: actualTextDimensions.height
	                }, {silent: true});
	
	                pageDimensionsChanged = true;
	
	            }
	        }
	
	        // Order: for now put on the bottom below the image (which is under the canvas)
	        // !! append to DOM first, prior to render, (or else widths will be 0)
	        this.ui.transformedWr.append( this.textOverlay.el );
	
	        /**
	         * DVBC-1168 -- if the width/height are changed, need to reset the scale
	         * Otherwise, the calc's done pre-fetching the text will be off (for derived scale types).
	         * This must be done prior to rendering the text overlay view, which incorporates the scale value.
	         * What should be do instead is render the view at a scale of 1 and then update the viewport instead ...
	         * REFACTOR THIS MESS
	         */
	        if ( pageDimensionsChanged ) {
	            this.vChannel.command('setScale');
	        }
	
	        this.textOverlay.render( this.scale.getScaleValue(), this.showGreenbar );
	
	        // this required now to update different dimensions like page .... rewrite inevitable )
	        // what s/b done is render the overlay without the scale value -- then call update viewport ( which would scale it )
	        this.updateViewPort();
	
	    },
	
	    /**
	     * Note: only applicable to pages without image overlays.
	     * Returns true/false if dimensions are changed
	     */
	    _adjustPageDimsBasedOnActualTextDims: function() {
	
	        var m = this.model,
	            o = m.get('overlay'),
	            bPageDimsChanged = false,
	            textGridModel = m.getTextGridModel();
	
	        var derivedWidth = textGridModel.maxCols / o.cpi,
	            derivedHeight = textGridModel.nRows / o.lpi,
	            derivedWidthIncludingOffset = derivedWidth + o.xTextOffset,
	            derivedHeightIncludingOffset = derivedHeight + o.yTextOffset;
	
	        // If the actual size of the grid is greater than the size of the paper (the text extends beyond the page dimension)
	        if ( (derivedWidthIncludingOffset > o.paperWidth) || (derivedHeightIncludingOffset > o.paperHeight ) )  {
	
	            var derivedHtIsLessThanWidth = derivedHeightIncludingOffset < derivedWidthIncludingOffset,
	                paperHtIsLessThanWidth = o.paperHeight < o.paperWidth;
	
	            // if the aspect ratio of the text is different from the aspect ratio of the page,
	            if ( derivedHtIsLessThanWidth || paperHtIsLessThanWidth && !(derivedHtIsLessThanWidth && paperHtIsLessThanWidth) ) { //if and only if
	
	                //  switch the page width and height
	                m.set({
	                    width: o.paperHeight * 96,
	                    height: o.paperWidth * 96
	                }, {silent: true});
	
	                bPageDimsChanged = true;
	            }
	        }
	
	        /**
	         * Expand the size of the paper, if the derived text size doesn't fit
	         * TODO: will also need to ceil the height / width in scale calcs ( the paper and the text should differ here ) ... still ?
	         * Note: this page type doesn't support rotation so width is ok, not rotated width
	         */
	
	        if ( derivedWidthIncludingOffset * 96 > m.get('width') ) {
	            m.set('width', derivedWidthIncludingOffset * 96 , {silent: true} );
	            bPageDimsChanged = true;
	        }
	
	        // TODO - don't include whitespace (linebreak ) in the last line in the size calc,
	        // it doesn't look like that should be included in the derived height ( still ?)
	        if ( derivedHeightIncludingOffset * 96 > m.get('height') ) {
	            m.set('height', derivedHeightIncludingOffset * 96, {silent: true} );
	            bPageDimsChanged = true;
	        }
	
	        return bPageDimsChanged;
	
	    },
	
	    /* Set on model parse -- though now can change in _adjustPageDimsBasedOnActualTextDims
	     * ( and the actual height and width set by the image size on load ... unsure if still applicable ... )
	     * *** TODO: removal of necessary arguments, they aren't always called now ... I think can take out ***
	     * Note: page type doesn't support rotation so don't need to take rotated height and width into account
	     */
	    updateViewPort: function( scale, prevScale ) {
	
	        scale = this.scale.getScaleValue();
	
	        prevScale = this.scale.previous('scale'); // TODO: still necessary for canvas???
	
	        var model = this.model,
	            pgW = model.get('width'),
	            pgH = model.get('height'),
	            scaledWt = pgW * scale,
	            scaledHt = pgH * scale,
	            pgCh = this.pgCanvasChannel;
	
	
	        // The text in the overlay view
	        // ensure the text is scaled first prior to the comparison -- unsure if still necessary --
	        // This would change with the transform
	        this.trigger( 'scaleColdText', scale, this.showGreenbar );
	
	        // The paper -- el is the paper ( it's a text page )
	        this.$el.css({
	            width: scaledWt,
	            height: scaledHt
	        });
	
	        /* **/
	        /**
	         * -- The image overlay --
	         * DVBC- 980 -- IN SCALE PG (BASE) WHEN ADD this.ui.transformedWr to scale, don't need anymore -- so took out
	         * DVBC-1004 - need to put back
	         * DVBC-1821 -- need to include the height
	         */
	
	         if ( this.hasImageOverlay ) {
	
	             // If there was a load error, there will be no image el to adjust ...
	             if ( !this.model.get('loadError') ) {
	
	                 this.imgView.$el.css({
	                     width: this.imgActualDims.width * scale,
	                     height: this.imgActualDims.height * scale
	                 });
	             }
	         }
	
	        /**
	         * This must have been for the canvas.
	         * Clean up when refactor this whole mess.
	         * See pagePageMode.updateViewPort ( this.canvas && this.scaleCanvas.apply(this, arguments); )
	         */
	
	        if ( pgCh ) {
	            // Here passing the page model as minor perf gain and flag
	            pgCh.command('updateScale', scale, prevScale, {
	                pageModel: model,
	                updateCanvasOverlay: true
	            });
	        }
	    },
	
	    onActiveNoteChange: function(note) {
	
	        PgModeImgWr.prototype.onActiveNoteChange.apply(this, arguments);
	
	        /* toggle disabled 'text selection' menu item if the note is drawable */
	        var entering = note !== null;
	
	        // enable/disable the menu item allowing user to toggle text selection
	        // (when disable, its also made 'inactive')
	        this.pageDDView.triggerMethod('canvasEditModeToggled', entering);
	
	        //on exit, always get out of selectTextMode, which no longer applies (may want to change this; no grabby hand or shape hovers by default)
	        if ( !entering ) {
	            this.selectTextMode = 0;
	            this.$el.removeClass('canvas-edit-mode-select-text');
	        }
	
	    },
	
	    onDestroy: function() {
	
	        this.wasDestroyed = 1;
	        this.textOverlay && this.textOverlay.destroy();
	
	        this.remove();
	
	    }
	
	});
	


/***/ },
/* 467 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(469);
	
	var Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    PreventDragEventsMixin = __webpack_require__(438);
	
	var instVars = {
	    parent: null,
	    model: null,
	    textGridModel: null,
	    chrWt: 0,
	    chrHt: 0
	};
	
	var TESTING = 0; /* show indicators via css */
	
	if (true)
	    TESTING = 0;
	
	module.exports = Backbone.View.extend({
	
	    className: 'textOverlay',
	
	    initialize: function(options) {
	
	        _.extend( this, instVars, _.pick( options, 'parent', 'model', 'textGridModel') );
	
	
	        /* Unscaled: cached  for performance */
	        this.chrWt = this.textGridModel.chrWt;
	        this.chrHt = this.textGridModel.chrHt;
	
	        this.listenTo( this.parent, 'scaleColdText', this.render );
	
	    },
	    //TODO: take greenbar out of render call
	    render: function( scale, showGreenBar ) {
	
	        this.$el.empty();
	        this._printText(scale);
	        this._formatEl(scale);
	        TESTING && this.$el.addClass('testing');
	        showGreenBar && this.$el.addClass('greenBar');
	        return this;
	
	    },
	    //TODO --  subscriber
	    toggleGreenBar: function() {
	        this.$el.toggleClass('greenBar');
	    },
	    /**
	     * Stop propagation of grabby hand drag events from the mode container to allow selection of the text.
	     * Note: these mouseevents are no longer captured here were drawing atop the canvas.
	     */
	    events: PreventDragEventsMixin,
	
	    onMouseDown: function(e) {
	        e.stopPropagation();
	    },
	    onMouseMove: function(e) {
	        e.stopPropagation();
	    },
	    onMouseUp: function(e) {
	        e.stopPropagation();
	    },
	
	    _formatEl: function( scale ) {
	
	        var attrs = this.model.get('overlay'),
	            actualDims = this.textGridModel.actualDimensions( scale ),
	            format = {
	                top: attrs.yTextOffset * scale + 'in', //(must have position) --- don't use padding/margin
	                left: attrs.xTextOffset * scale + 'in',
	                'font-family': attrs.fontName,
	                'font-size':  attrs.fontSize  * scale +  'pt',
	                'line-height':  this.chrHt * scale + 'px', //note: would think not necessary anymore but it is!!!! -- DVBC-1162
	                width: actualDims.width + 'px',   // not necessarily needed ...
	                height: actualDims.height + 'px'
	            };
	
	        this.$el.css(format);
	
	    },
	
	    _printText: function(scale, $container) {
	
	        var aRowDivs = this.textGridModel.textInNonDOMMarkup,
	            chrW = this.chrWt * scale + 'px',
	            chrH = this.chrHt * scale + 'px',
	            appendToContainer = $container ? $container[0] : this.el,
	            fragment = document.createDocumentFragment(),
	            nRows = aRowDivs.length;
	
	        // set the height and width of each element
	        for ( var r=0; r < nRows; r++) {
	            var curRowDiv = aRowDivs[r];
	            curRowDiv.style['height'] = chrH; //now inheriting from line-height of $el (1em)
	
	            var rowCharSpans = curRowDiv.childNodes,
	                nCols = rowCharSpans.length;
	
	            for (var c=0; c < nCols; c++) {
	                rowCharSpans[c].style['width'] = chrW;
	            }
	            fragment.appendChild(curRowDiv);
	        }
	
	        appendToContainer.appendChild (fragment.cloneNode(true) );
	
	    },
	
	    //TODO:
	    onBeforeDestroy: function() {
	
	        //console.log('text overlay on destroy');
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 469 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/*
	    The text in the grid, and the text in DOM nodes
	    No Size Adjustments Made ('unformatted') -- DOM only created once for performance
	 */
	
	
	var NormalizeNewLineCharacters = __webpack_require__(48).normalizeNewLineCharacters;
	
	/**
	 * overlayAttributes -- taken from the page model; should probably be wrapped in a class
	 */
	
	var TextGridModel = function( overlayText, overlayAttributes ) {
	
	    this.text = NormalizeNewLineCharacters( overlayText );
	
	    this.nRows = 0;
	    this.maxCols = 0;
	
	    //also sets nRows, maxCols (which is really nCols)
	    this.textInNonDOMMarkup = this._unformattedTextInDomNodes();
	
	    /* Values from the overlay necessary for fn actualDimensions */
	    /* Could just store oWidth, oHeight */
	
	    this.chrWt =  1 / overlayAttributes.cpi * 96;
	    this.chrHt = 1 / overlayAttributes.lpi * 96;
	
	
	};
	
	/* (unformatted -- only needs to be done once ) */
	/* also sets this.nRows && this.maxCols to later retrieve the actual text dimensions (not from the DOM) */
	
	TextGridModel.prototype._unformattedTextInDomNodes = function() {
	
	    var delimitedTxt = this.text.split('\n'), //this puts into rows (delimits by line)
	        nRows = delimitedTxt.length,
	        nCols,
	        aRowDivs = [],
	        span,
	        div,
	        maxCols = 0,
	        rowDiv = document.createElement('div'),
	        charSpan = document.createElement('span');
	
	    rowDiv.className = 'row';
	    charSpan.className = 'char';
	
	    for (var r=0; r < nRows; r++) {  //looping by this allows to tell the actual end of the line
	
	        var curRowDiv = rowDiv.cloneNode();
	
	        if (delimitedTxt[r].length > 0) { //not a line break -- this is the 'row'
	            nCols = delimitedTxt[r].length;
	            nCols > maxCols && (maxCols = nCols);
	            for (var c = 0; c < nCols; c++) {
	                span = charSpan.cloneNode();
	                span.innerHTML = delimitedTxt[r][c];
	                curRowDiv.appendChild(span); //don't see perf gains by using arrays with dom elements
	            }
	            aRowDivs.push( curRowDiv );
	
	        } else { //line break -- print back (esp if copied text to preserve the actual whitespace)
	            //for now -- spans are required in print out ... can change this ... (but if do the new lines with be off the char at the end)
	            span = charSpan.cloneNode();
	            span.innerHTML = '\n';
	            curRowDiv.appendChild(span);
	            curRowDiv.className += ' newline';
	            aRowDivs.push( curRowDiv );
	        }
	    }
	
	    this.nRows = nRows;
	    this.maxCols = maxCols;
	
	    return aRowDivs;
	};
	
	
	
	
	/* Ceil: b/c no such thing as fractional coordinates here */
	
	TextGridModel.prototype.actualDimensions = function( scale ) {
	
	    scale = scale || 1.0;
	
	    // TODO: change the originals for width and height
	
	    return {
	        width: Math.ceil( this.maxCols * this.chrWt * scale ),
	        height: Math.ceil( this.nRows * this.chrHt * scale )
	    };
	
	};
	
	
	
	
	
	//now not necessary, but it is called ... so leave in to avoid run time errors
	TextGridModel.prototype.destroy = function() {
	  //console.log('enter destroy text grid model');
	};
	
	
	
	
	
	module.exports = TextGridModel;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var PageDD = __webpack_require__(430),
	    PartialTemplate = __webpack_require__(472);
	
	module.exports = PageDD.extend({
	    onAfterSwapEl: function() {
	        var o = this.options;
	        this.$el.append( PartialTemplate({
	            hasImageOverlay: o.hasImageOverlay,
	            showImgOverlay: o.hasImageOverlay && o.showImgOverlay,
	            showGreenbar: o.showGreenbar
	        }) );
	    },
	    ui: _.extend( {}, PageDD.prototype.ui, {
	        overlayMi:          '.toggle-overlay',
	        textSelectionMi:    '.toggle-text-selection',
	        greenBarMi:         '.toggle-greenBar'
	    }),
	    /* textSelectionMi only applicable when in canvas edit mode --- will never occur on initial render */
	    onCanvasEditModeToggled: function(entering) {
	        this.ui.textSelectionMi.toggleClass('disabled', !entering);
	        //ensure its not active when closing ... go back to default
	        !entering && this.ui.textSelectionMi.removeClass('active'); //(active will override disabled in appearance)
	    },
	    events: function() {
	        //var vCh = this.options.vChannel;
	        var parent = this.options.parent;
	
	        return _.extend( {}, PageDD.prototype.events.apply(this, arguments), {
	            'click @ui.overlayMi': function(e) {
	                var $target =  $(e.currentTarget); //TODO: common
	                if ($target.hasClass('disabled')) return;
	                $target.toggleClass('active');
	                parent.triggerMethod('toggleOverlayImg');
	            },
	            'click @ui.textSelectionMi': function(e) {
	                var $target =  $(e.currentTarget);
	                if ($target.hasClass('disabled')) return;
	                $target.toggleClass('active');
	                parent.triggerMethod('toggleTextSelection');
	            },
	            'click @ui.greenBarMi': function(e) {
	                var $target =  $(e.currentTarget);
	                if ($target.hasClass('disabled')) return;
	                $target.toggleClass('active');
	                parent.triggerMethod('toggleGreenBar');
	            }
	        });
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "active";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"divider\"></div>\n\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-overlay "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hasImageOverlay : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showImgOverlay : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Overlay\">\n    Overlay\n</div>\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-greenBar "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showGreenbar : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Green Bar\">\n    Green Bar\n</div>\n<div class=\"mi mi-cb-mixed-with-dd-icon toggle-text-selection disabled\" title=\"Enable Text Selection When Annotating\">\n    Text Selection\n</div>\n";
	},"useData":true});

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(474);
	
	var PgModeView = __webpack_require__(462),
	    UrlPgView = __webpack_require__(455),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * Underlying urlFrame view should probably extend a pdf view equivalent to that in PDF Mode
	 * pdfs options, request mime-type, for example -- see what doing with -- see DVBC-1220 (how loading PDFs in the current pdf container )
	 */
	
	module.exports = UrlPgView.extend({
	
	
	    /*
	     *  DVBC-1457: get rid of delay for this page type to make this appear to load faster
	     *  Note: can't be 0 -- see reveal function ( addClass callback won't be called )
	     *  in the future maybe we apply this to all iframe/url types in page mode
	     * */
	
	    FADEIN_TIMER: 1,
	
	    APPLY_SCALE: 0,
	
	
	    // TODO: here is example of extending the class names
	    // TODO: FV-pgWr-PgMode ... why did I need to put this ...
	
	    className: function() {
	        return _.result(UrlPgView.prototype, 'className') + ' FV-pgWr-PgMode FV-pgPDF';
	    },
	
	    /**
	     *
	     * If PDF.js, may want to set zoom here since page mode values correspond to PDF.js,
	     * though would want to encapsulate in URL function.
	     */
	    _getCreUrlToLoad: function( creResponse ) {
	
	        return this.vChannel.request('getPdfUrlToLoadInFrame', creResponse);
	
	    },
	
	
	    _getCRERequestFileName: function() {
	        return this.model.getPageName( 'pdf', 1 );
	    },
	
	
	    requestImg: PgModeView.prototype.requestImg,
	
	    // could also put an option if isIE here ...
	    // TODO: this is now breaking the position ... application of the iframe shim is breaking it
	
	    _getActionDropDownOptions: function() {
	
	        return  _.extend( {}, PgModeView.prototype._getActionDropDownOptions.call(this), {
	            applyIframeShim: 1
	        } );
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 474 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(476);
	
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    CRE_Download_Defaults = __webpack_require__(107),
	    UnrenderablePgsView = __webpack_require__(477);  /* collection view generated if docHasNoRenderable Pgs (if mixed, you get the dropdown list */
	
	$.fn.creRequest = $.fn.creRequest || __webpack_require__(389);
	
	
	module.exports = Marionette.ItemView.extend({
	    className: 'FV-pdfMode FV-paneContentWr',
	    template: __webpack_require__(479),
	    initialize: function(options) {
	
	        this.lCh = options.lCh;
	        this.lCh.reply({
	            pdfWrapper: function() { return this.ui.pdfWrapper; }
	        }, this);
	
	        this.renderCancelled = false;//flag for requested after a cancel by the user
	
	    },
	    serializeData: function() {
	       return {
	           docHasNoPDFRenderablePgs: this.options.docHasNoPDFRenderablePgs
	       };
	    },
	    onRender: function() {
	        this.unwrap();
	        this.options.docHasNoPDFRenderablePgs && this._createNonRenderableCollectionView();
	    },
	    ui: {
	        pdfHolder:              '#iframeViewer', // either iframe or object
	        pdfWrapper:             '.iframeWr', // starts invisible
	        downloadCancelledWr:    '#dlCancelledPDF',
	        reloadBtn:              '#reloadPDF'
	    },
	    events:  {
	        'click @ui.reloadBtn': 'loadPDFDocument'
	    },
	    loadPDFDocument: function() {
	
	        var vCh = this.options.vChannel;
	        var self = this,
	            activeDoc = vCh.request('activeDocument'),
	            renderRequest = activeDoc.docRenderRequest('pdf','pdf'), /* just the active document */
	            creOptions = _.extend( {},
	                renderRequest,
	                {
	                    fileName: activeDoc.documentName('pdf', 1) // Note: using first file name if more requested (pdf)
	                }, new CRE_Download_Defaults({
	                    isPDF: true,
	                    vChannel: vCh,
	                    startCB: function() {
	                        self.renderCancelled = false;
	                        self.ui.downloadCancelledWr.addClass('hide'); //hide on start in case was cancelled
	                    },
	                    completeCB:  _.bind(this.loadSuccess, this), //TODO: the download view could get first
	                    errorCB: _.bind(this.loadError, this),
	                    cancelCB: _.bind(this.renderCancelledByUser, this),
	                    dontShowErrMsg: true,
	                    inlinePDF: true
	            })
	        );
	
	        $.fn.creRequest(creOptions);
	    },
	    loadSuccess: function(data) {
	
	        !this.ui.pdfHolder.attr && this.bindUIElements();
	
	        this.ui.pdfHolder.attr( 'src' ,
	            this.options.vChannel.request('getPdfUrlToLoadInFrame', data )
	        );
	
	        this.ui.pdfWrapper.removeClass('invisible');
	        this.options.vChannel.command('setPDFisLoaded');
	
	    },
	    loadError: function(errMsg) {
	
	        $.when( fvChannel.request('auth')._keepAlive() ).then( _.bind( function(isAuthenticated) {
	            if (isAuthenticated) {
	                //TODO: print in view w/retry
	                this.options.vChannel.trigger('alert:show', {
	                    type: 'error',
	                    shortMessage: 'Error loading PDF',
	                    detailedMsg: errMsg
	
	                });
	            } else {  //set state to auth screen: user timed out -- if successfuly will reload (continueLoadingImgPostAuthorization)
	                fvChannel.command('unauthorizedLogout');
	            }
	        }, this));
	    },
	    renderCancelledByUser: function() {
	        this.renderCancelled = true;
	        this.ui.downloadCancelledWr.removeClass('hide');
	    },
	    _createNonRenderableCollectionView: function() {
	        var vCh = this.options.vChannel;
	        this.$el.append( new UnrenderablePgsView({
	            collection: vCh.request('unrenderablePDFModePgs'), //here would be all
	            vChannel: vCh,
	            viewMode: 'pdf'
	        }).render().el );
	    },
	    /*
	    * Note: quick fix: DVBC-807 -- here, if request never made, .cancel will not exist -- so check for it.
	    * Real fix is to change arch of the plugin AND have a cancel of all possible requests on reset, where this would be destroyed --
	    * this would be the CRE queue -- shouldn't be done here.
	    * Only other place called now is in the CRE - defaults, which this overrides -- (on cancel)
	    * */
	    onBeforeDestroy: function() {
	        var fnCancelReq = $.fn.creRequest.cancel;
	        fnCancelReq && fnCancelReq({byForce: true});
	        this.lCh.reset();
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 476 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(478);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    PageNotRenderable = __webpack_require__(452).pdf;
	
	module.exports =  Marionette.CollectionView.extend({
	    id: 'pdfModeUnrenderablePgs',
	    childView: PageNotRenderable,
	    childViewOptions: function() {
	        return {
	            vChannel: this.options.vChannel
	        };
	    }
	});


/***/ },
/* 478 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "\n        <div class=\"iframeWr invisible\">\n            <iframe id=\"iframeViewer\" frameBorder=\"0\" scrolling=\"no\" type=\"application/pdf\"></iframe>\n        </div>\n\n        <div id=\"dlCancelledPDF\" class=\"hide\">\n            <div>\n                <span class=\"icon-attention-1\"></span>\n                Loading of PDF cancelled by user\n            </div>\n            <button id=\"reloadPDF\" class=\"btn\">\n                <span class=\"icm-file-pdf3\"></span>\n                Load PDF\n            </button>\n        </div>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div class=\"FV-pdfMode FV-paneContentWr\">\n\n"
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.docHasNoPDFRenderablePgs : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>";
	},"useData":true});

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(481);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58);
	
	/* Really the Center Content */
	module.exports = Marionette.ItemView.extend({
	    template: __webpack_require__(482),
	    onRender: Backbone.View.prototype.unwrap
	});

/***/ },
/* 481 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"noPagesOverlay\" class=\"FV-paneContentWr\">\n    <h3>\n        <span class=\"icon-attention-circled\"></span>\n        <span>Document Has No Pages</span>\n    </h3>\n</div>";
	},"useData":true});

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "noPages";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"FV-center-inner "
	    + container.escapeExpression(((helper = (helper = helpers.viewModeClass || (depth0 != null ? depth0.viewModeClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"viewModeClass","hash":{},"data":data}) : helper)))
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.documentHasNoPages : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n	<div class=\"FV-region-docMode\"></div>\n	<div class=\"FV-region-pgMode\"></div>\n	<div class=\"FV-region-pdfMode\"></div>\n	<div id=\"noPagesOverlay\" class=\"FV-paneContentWr\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    Layout = __webpack_require__(485),
	    State = __webpack_require__(520),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    NoteModelFactory = __webpack_require__(275),
	    NoteSettings = __webpack_require__(273),
	    CreatableNoteTypesHelper = __webpack_require__(522),
	    SubApp = __webpack_require__(98);
	
	
	
	var instVars = {
	    notesCollection: null,
	    region: null,
	    state: null,
	    vChannel: null,
	    channel: null,
	    layout: null, // the view hierarchy (layout)
	    settings: null, // in progress -- pass w/out vChannel to modularize; now just hideActivityNotes
	    creatableNoteTypesHelper: null
	};
	
	
	module.exports = Marionette.Object.extend({
	    request: SubApp.prototype.request,
	    command: SubApp.prototype.command,
	    initialize: function(options, id) {
	
	        _.extend( this, instVars, _.pick(options, '$container', 'vChannel', 'notesCollection'), {
	           region: new Marionette.Region({ //( put in region -- note Layout set with onShow logic )
	               el: options.$container
	           }),
	           channel: new Backbone.Radio.Channel('notes:' + id),
	           settings: new NoteSettings({
	               hideActivityNotes: options.hideActivityNotes
	           })
	        });
	
	        var localStorage = fvChannel.request('localStorage');
	
	        this.state = new State({
	            channel: this.channel,
	            hideActivityNotes: options.hideActivityNotes,
	            sortType: localStorage.getLastNoteSortType(),
	            sortDir: localStorage.getLastNoteSortDirection()
	        });
	
	        /*
	        * If called from the viewer, this was already set (needed creating the layout), though no harm in setting it again.
	        * Calling again to get filtering functionality to work with existing architecture -- filter is on notes.state,
	        * which wouldn't work if the module is invoked independently from the viewer.
	        * A better design may be to store filterState on the notesCollection, but that requires a larger refactor
	        * and this is working fine for now.  It's somewhat done with 'sort' already. ((See base Notes Collection).
	        * ( Determining whether notes are filtered is now done on the note UI models of the collection).
	        * ( Could call command after communication is wired )
	        * */
	        this.notesCollection.setIsFiltered( this.state.filterState );
	
	        /*
	        * Set the sort direction and comparator (sortType) on the notesCollection
	        * before it's rendered ( so it is rendered in the correct order ).
	        * Don't call the update sort command after the channel is wired --
	        * it's superflous we only want to set local storage values when the user changes them.
	        * */
	        this.notesCollection.updateSort( this.state.getSortType(), this.state.getSortDirection() );
	
	        this.creatableNoteTypesHelper =
	            new CreatableNoteTypesHelper()
	                .initialize( this.vChannel, fvChannel.request('user') );
	
	
	        this.layout = new Layout({
	           channel: this.channel,
	           notesCollection: this.notesCollection
	        });
	
	        this._wireCommunication();
	
	   },
	    /*
	    *  Use as direct triggerOn after init -- its external.
	    * */
	    onRender: function() {
	        this.region.show(this.layout);
	    },
	    _wireCommunication: function() {
	
	        /* Because not a subapp -- extend */
	        this.channel.reply(  _.extend( this.innerRequests(), this.outerRequests), this );
	        this.channel.comply( _.extend( this.innerCommands, this.outerCommands ), this );
	
	        /* inner event publisher but only listened to once */
	        this.channel.once('notes:newNoteMenuRendered', _.bind(function(ddContent) {
	            this.vChannel.trigger('notes:newNoteMenuRendered', ddContent, this.channel);
	        }, this));
	
	        Marionette.bindEntityEvents( this, this.channel, this.innerSubs );
	
	        //TODO: generic -- listenAndForward...w/same name and arguments -- no extra logic applied
	        var vCh = this.vChannel;
	        _.each(this.outerPublishers, function(evt) {
	            this.listenTo(this.channel, evt, function() {
	                vCh.trigger.apply(vCh, [evt].concat( _.toArray(arguments)));
	            });
	        }, this);
	
	    },
	    outerRequests: {
	        drawingAttributes: function() {
	            return this.channel.request('drawingAttrs');
	        },
	 
	        getNewNoteModel: function( isDocNote, noteType ) {
	            return this.channel.request( 'newNoteModel', isDocNote, noteType );
	        }
	    },
	
	    /**
	     * (from vChannel)
	     * could/should fwd some with same name ...
	     */
	    outerCommands: {
	        pageImgLoadError: function(page) {
	
	            this.channel.trigger('notes:updateNoteTypesToDisable', {
	                fromPageLoadError: 1,
	                page: page
	            });
	
	        },
	        hoveredCanvasNoteChange: function() {
	            var c = this.channel;
	            c.trigger.apply(c, ['notes:hoveredCanvasNoteChange'].concat( _.toArray(arguments)) ); //TODO: fwd wrapper
	        },
	        canvasDrawingToggled: function() {
	            var c = this.channel;
	            c.trigger.apply(c, ['notes:canvasDrawingToggled'].concat( _.toArray(arguments)) );
	        },
	        activeNoteSubTypeChange: function(noteSubType, options) {
	
	            var c = this.channel,
	                activeNote = options.activeNote;
	
	            // exiting ( we don't need to change the toolbar button)
	            if (!activeNote) return;
	
	            // Note: there could be other instances to avoid unnecessary calls to update the toolbar shape button,
	            // but, doing so doesn't hurt anything so let it pass.
	            // Previously, there was a noteType on the shapeToolbar prototypes and the button wasn't updated if:
	            //      activeNote.getNoteType() !== this.noteType
	            //      or this.activeItem === noteSubType
	            //     ( basically, only change if the new value does not equal the last -- it could have changed already )
	            // Removed to get rid of the noteType on the shapeToolbars (which can now have multiple noteTypes)
	
	            c.command.apply(c, ['updateShapeToolbarBtn'].concat( _.toArray(arguments )) );
	
	        },
	        cancelSignature: function() {
	            /* hack for signature, which can only be deleted, not modified */
	            this.enterCancelChanges.apply(this, arguments); /* (same as from cancel click on view) */
	        },
	        activeNoteChange: function() {
	            this.activeNoteChangeCB.apply(this, arguments);
	        },
	        expandedNoteChange: function() {
	            this.expandedNoteChange.apply(this, arguments);
	        },
	        changePage: function(options) {
	
	            this.channel.command('updateFilter', {
	                filterSrc: 'pageChange',
	                currentPage: options.page.get('number')
	            });
	
	            this.layout.updateOnPgChange(options);
	
	        },
	        viewModeChange: function(mode, options) {
	
	            this.layout.updateOnViewModeChange.apply(this, arguments);
	
	            this.channel.command('updateFilter', {
	                filterSrc: 'modeChange',
	                mode: this.channel.request('viewMode')
	            });
	
	        },
	        togglePanelResize: function(isOn) {
	            /* could really just pick the hover mod buttons, and hover shapes but more convenient to do all */
	            this.channel.trigger('noteViews:toggleEventListeners', isOn);
	        },
	        createRedactionOnViewerLoad: function() {
	            var c = this.channel;
	            c.trigger( 'notes:changeActiveNote',
	                c.request( 'newNoteModel', false, 'REDACTION_NOTE' ), {createNote: true}
	            );
	        }
	    },
	    //
	    /**
	     * this.channel --> this.vChannel
	     * TODO: rid any overlap here
	     */
	    outerPublishers: [
	        'notes:setActiveNote', 'notes:setExpandedNote', 'notes:goToPage', 'notes:toggleShapeHighlight', 'notes:noteSaved', 'notes:noteDeleted',
	        'notes:setNoteSubType', 'notes:setDrawColor', 'notes:setDrawStrokeWidth', 'notes:graphicStampChanged'
	    ],
	    /* this.channel --> this.channel */
	    /* no forward -- inner communication */
	    innerSubs: {
	
	        /* first 2: wrapper functions pre sending to note vent to viewer -- have all go through here, which then calls the publisher if necessary */
	        'notes:changeActiveNote':          'triggerActiveNoteChange',   //***save, mod, cancel, del, etc ...
	        'noteView:flashNoteDestruct':       '_deleteNote',   // the note being blown up is the active note -- was set on open ( delete called auto'ly, not from view )
	
	        'notes:updateLastFlashPrId':        'updateLastFlashNtUser',
	        'consultSelectView:groupsChanged':  'consultGroupChange',
	
	        /* below forwarded from the note view */
	        'noteView:enterSave':               'enterSaveNote',
	        'noteView:enterCancel':             'enterCancelChanges',
	        'noteView:enterEdit':               'enterEditNote',
	        'noteView:enterDelete':             'enterDeleteNote',
	        'noteView:enterExpand':             'expandNote',
	        'noteView:convertToFloatingCodes':  'convertToFloatingCodes',
	
	        'notes:updateNoteTypesToDisable':   'updateNoteTypesToDisable'
	
	
	    },
	    innerRequests: function() {
	
	        var user = fvChannel.request('user'),
	            vChannel = this.vChannel;
	
	        return {
	            /*
	            * Returns the note model attributes that have changed, or
	            * if none have changed, returns false ( like Backbone's changedAttributes ),
	            * which is also called from this function.
	            * */
	            'notes:changedNoteAttributes': function(noteView) {
	
	                // this should be on the view
	                var note = noteView.model,
	                    sanitizeNotesViewAttrs = note.sanitizeUserInput( noteView._getRawUserInput(), user ),
	
	                    // if a drawable note and not changed, the text/shapes will be diff on the FIRST edit
	                    // ... not sure if really matters (also think title is doing this)
	                    changedAttrs = note.isDrawable()
	                        ? note.hasNoteChanged( sanitizeNotesViewAttrs, vChannel.request('getAttributesToPersistOfNoteOnCanvas', note) )
	                        : note.hasNoteChanged( sanitizeNotesViewAttrs ); //this condition here in case of image load failure
	
	                /*
	                * Hack --- should clean up ...
	                * For graphic stamps, the text attribute is re-purposed as the stamp's id.
	                * Return the stamp id if new or if the stamp image was swapped ( can tell from whether the image 'src' attr is present in changedAttrs )
	                * */
	                if ( note.isGraphicStamp() ) {
	
	                    // text attribute -- do here b/c can tell if change from preceding hasNoteChanged call
	                    if ( note.isNew() ) {
	
	                        changedAttrs.text = note.uiModel.get('selectedStamp').get('id');
	
	                    } else {
	
	                        if ( _.has(changedAttrs, 'src') ) {
	                            changedAttrs.text = note.uiModel.get('selectedStamp').get('id');
	                        } else {
	                            /*
	                            * Another hack: there's definitely a better way to do this
	                            * Must pass the text attribute as null to the java server.
	                            * Currently at the point it's undefined and so wont be sent at all in the request body
	                            * */
	                            changedAttrs.text = null;
	                        }
	                    }
	                }
	
	                return changedAttrs;
	
	            },
	            'notes:getUserPrivateID': function () {
	                return user.get('privateGrpId'); //todo make fn in other
	            },
	            'notes:getUserId': function () { //ACTUALLY, NEED ANYTHING FROM CORE?
	                return user.getUserID();
	            },
	            vChannel: function () { /* Internal ref to vs --*/
	                return vChannel;
	            },
	            noteIsActiveNote: function (note) {
	                return vChannel.request('noteIsActiveNote', note);
	            },
	            currentPageNumber: function () {
	                return vChannel.request('currentPageNumber');
	            },
	
	            newNoteModel: this.createNewNote,
	
	            inEditMode: _.bind(this.state.inEditMode, this.state),
	
	            filterState: function() {
	                return this.state.filterState;
	            },
	
	            noteSortType: function() {
	                return this.state.getSortType();
	            },
	            noteSortDirection: function() {
	                return this.state.getSortDirection();
	            },
	
	            viewMode: function() {
	                return vChannel.request('viewMode');
	            },
	            currentPageIsCold: function() {
	                return vChannel.request('currentPage').isCold();
	            },
	            creatableNoteTypesHelper: function() {
	                return this.creatableNoteTypesHelper;
	            }
	
	
	        };
	    },
	    innerCommands:  {
	
	        updateSort: function(sortBy, dir) {
	
	            var localStorage = fvChannel.request('localStorage');
	            sortBy && localStorage.setLastNoteSortType( sortBy );
	            dir && localStorage.setLastNoteSortDirection( dir );
	
	            /* (changing comparator will trigger view update */
	            this.notesCollection.updateSort.apply( this.notesCollection, arguments );
	            this.command( 'changeSortIndicator', dir );
	
	        },
	        filterUpdated: function(filterModel) {
	
	            this.notesCollection.setIsFiltered( filterModel );
	
	            this.channel.command('updateNoteFilterInHeader'); // could pass the model in here
	            this.channel.command('filterNoteViews', filterModel);
	
	        }
	    },
	
	    triggerActiveNoteChange: function(note, options) {
	
	        var opts = !options ? {} : options;
	        this.vChannel.request('getViewer')
	            ? this.channel.trigger('notes:setActiveNote', note, opts)
	            : this.activeNoteChangeCB.apply( this, arguments ); // no longer necessary -- not making separate module ...
	
	    },
	
	    triggerExpandedNoteChange: function(note) {
	        this.vChannel.request('getViewer')
	            ? this.channel.trigger('notes:setExpandedNote', note)
	            : this.expandedNoteChange(note); //todo could be in callback
	    },
	    expandNote: function(view, args) {
	        this.triggerExpandedNoteChange(!args.model.uiModel.get('expanded') ? args.model : null);
	    },
	    activeNoteChangeCB: function(note, opts) { //'editMode' is true when activeNote is not null -- one is open; all others aren't
	
	        this.state.set('activeNote', note); //(need to store for prior)
	
	        var isNew = !opts.isEdit,
	            actions = { //TODO: MAP THE ACTUAL OPTIONS TO COMMANDS (TRIGGER) -- though opts being used in other modules ..... don't break
	                createNew : opts.createNote,  //model.save --> cb
	                enterEditExisting: note !== null && !isNew && !opts.noteSaved, //entering
	                saveNew: isNew && opts.noteSaved,
	                editExisting: !isNew && opts.noteSaved,
	                newCancelled : opts.userCancelled && isNew, //set to null
	                editCancelled : note === null && opts.userCancelled && !isNew,
	                editSavedButNoChanges: note === null && !isNew && opts.savedButNoChange,
	
	                //(active note set when user opens flash note to read) -- this is for open/destroy, others handled like other
	                isReadingFlashNote: opts.isReadingFlashNote,
	                flashNoteDestructed: opts.flashNoteDestructed  // could have flash note cancelled if want to blow up; note: this doesn't apply when the blowup comes after the save of a nee note not create for the current user
	            },
	            actionOptions = _.extend( opts, {
	                isNew: isNew && !opts.isReadingFlashNote, // only applicable if entering/exiting -- though should be new anyhow
	                notes: this.notesCollection,
	                note: note,
	                prNote: this.state.previous('activeNote'),
	                actions: actions,
	                action: _.keys(actions)[ _.indexOf( _.values(actions), true )]
	            });
	
	        this.layout.updatePostActiveNoteChange(actionOptions);
	
	    },
	    expandedNoteChange: function(note) {
	        this.state.set('expandedNote', note);
	        this.layout.expandedNoteChange(note, this.state.previous('expandedNote'));
	    },
	
	
	    /**
	     * Create and return a new note model:  elData - isdoc, noteType
	     * Should clean ... isDocNote, noteType
	     */
	    createNewNote: function( isDocNote, noteType ) {
	
	        var vCh = this.vChannel;
	
	        /**
	         * TODO: this is just a quick fix
	         * - disallow the event to go through when doc no pages
	         * - the actual menu item is disabled via css override
	         * - still needed?
	         */
	        if ( vCh.request('activeDocHasNoPages') && !isDocNote )
	            return false;
	
	
	        var user = fvChannel.request('user'),
	            defaultAccessGroup = user.defaultNoteAccessGroup( noteType === 'FLASH_NOTE' ),
	            //store so can add to collection when created
	            //attach this to avert Backbone making posts into puts  -- the model will have no ID; *** on save must give assign it an id
	            attrs = {
	
	                creationUser: user.getUserID(),
	                creationUserDesc: user.getUserDescription(),
	                accessGroup: defaultAccessGroup.id,
	                accessGroupName: defaultAccessGroup.name,
	                noteType: noteType,
	                noteStatus: 'V'
	            },
	            newNoteOptions = {
	                isNew: true,
	
	                // parse necessary to set groupNoteType, otherwise, will encounter issue encountered in DVBC-1288
	                // where the filter note menu will create a new line for the newly created note;
	                // there's a better way to address -- the filter menu should probably be re-rendered on save
	                // but it's working now and I'm afraid to break the workflow; maybe it was done this way on purpose
	                // re-rendering of the entire notes view should be redone to make more understandable
	                parse: true
	            };
	
	
	        // pg only attrs, options
	        if (!isDocNote) {
	
	            var currentPg = vCh.request('currentPage');
	
	            // need this to create the url on save (don't set above & later delete if doc -- then if no pages & doc note choses --> err.
	            _.extend( attrs, {
	                pageId: currentPg.get('pageId')
	            });
	
	            // Necessary to override creating floating redaction on COLD pages
	            currentPg.isCold() && _.extend( newNoteOptions, {
	               isColdPage: currentPg.isCold()
	            });
	
	            // Send pageModel as options to create on parse to create Shape Models on the Note Model
	            _.extend( newNoteOptions, {
	                pageModel: currentPg
	            });
	
	        }
	
	        var Note = NoteModelFactory.factory( noteType , isDocNote ),
	            newNoteModel = new Note( attrs, newNoteOptions );
	
	        newNoteModel['pageNumber'] = isDocNote
	            ? 0
	            : vCh.request('currentPageNumber');  //if doc note: no page associated with the model (0 for sorting) // TODO : put on model inst. (but is it known?)
	
	        /* flash notes: the change the default accessGroup, accessGroupName to that of the last opened -- should work for flash back to, call when openened*/
	        //TODO: set above in attrs
	
	        var lastOpenedFlashNotePrvGroupId = this.state.get('lastOpenedFlashNotePrvGroupId');
	        if (newNoteModel.isFlashNote() && lastOpenedFlashNotePrvGroupId) {
	            newNoteModel.set({
	                accessGroup: lastOpenedFlashNotePrvGroupId /* on render will select from list */
	                /*note: don't need description -- will get from ui on save (dropdown) */
	                /*  accessGroupName: FV.user.privateGroups.findWhere({groupId: 2000}).get('description') */
	
	            });
	        }
	        return newNoteModel;
	
	    },
	
	    /*
	    * Wait: wait for server before removing from collection -- that handler removes the view -- (if error, don't remove it).
	    * will run success/err after remove event
	    * */
	    _deleteNote: function(note) {
	
	        note.destroy({
	            wait: true,
	            success: _.bind( this._deleteNoteSuccess, this ),
	            error: _.bind (this._deleteNoteError, this )
	        });
	
	    },
	    _deleteNoteSuccess: function(note) {
	
	        this.vChannel.trigger('alert:show', {
	            type: 'info',
	            shortMessage: 'Note Deleted',
	            closeTimeout: 3000
	        });
	
	        this.channel.command('updateFilter', {
	            filterSrc: 'noteDeleted'
	        });
	
	        // TODO: all the above (and below) should be triggered a listener to this event ( and do the same for save )
	        this.channel.trigger('notes:noteDeleted', note);
	
	        this.channel.trigger('notes:updateNoteTypesToDisable'); // (now must do after notes have been added to the page collections )
	
	
	    },
	    _deleteNoteError: function(model, jqXHR) {
	
	        this.vChannel.command('ajaxError', jqXHR, 'Error deleting note');
	
	    },
	
	    /*
	    *  Called on destroy of the last flash note.
	    *  TODO: on open ???
	    * */
	    updateLastFlashNtUser: function(flashNote) {
	        this.state.set('lastOpenedFlashNotePrvGroupId', flashNote.get('creationUserPrivateGroup'));
	    },
	
	    enterSaveNote: function(view) {
	
	        var m = view.model;
	
	        if ( this._disallowSaveOrCancelChanges(m) )
	            return;
	
	        /*
	        * attrsToSave: really the changedNoteAttributes or false if none changed, passed to Backbone.Model.save.
	        * ( contains the attrs we'd like to change ).
	        * Note -- a complete representation of the resource will be sent back from the server
	        * ( and if successful, they're 'set' back on the model, so only attributes that changed will be altered ).
	        * {wait: true}: implemented with DVBC-1628 -- this waits to set the attributes on the model
	        * until after they're returned from the server ( it also prevents an extra validate call from 'set',
	        * and setting model attributes to null if validation fails from 'set' ).
	        * However, Backbone.Model.save still attempts to validate the attributes prior to sending them to the server
	        * ( and it also does so after they are returned ).
	        * */
	        var isNew = m.isNew(),
	            attrsToSave = this.channel.request('notes:changedNoteAttributes', view),
	            saveOptions = {
	                isNew: isNew,
	                success: _.bind( this._noteSaveSuccess, this ),
	                error: _.bind( this._noteSaveFailure, this ),
	                wait: true
	            },
	            isNode = fvChannel.request('settings').isRunningNode;
	
	        /**
	         * DVBC-1762 - if creating shape models on parse of the note model
	         * ( which will be called on saved; now only for full page redactions ),
	         *  model parse requires the pageModel of the note to create the Shape UI Model,
	         *  which now derived from the page collection.
	         *  ( TODO: the reference should be broken from the Shape Model; pageId should be enough ).
	         */
	
	        if ( m.isDrawable() ) {
	
	            _.extend( saveOptions, {
	                pageCollection: this.channel.request('vChannel').request('activeDocPages')
	            });
	
	        }
	
	        if (isNew) {
	
	            /*
	             * Url: force to use this url -- its not a part of the document notes collection.
	             * TODO: stop inheriting the url of the model from the collection or set it's url on create
	             */
	            if ( m.isFlashNote() && m.parentFlashBackNote ) {
	
	                _.extend( saveOptions, {
	                    url: _.result( this.vChannel.request('docNotes'), 'url')
	                });
	
	            }
	
	            if ( m.isGraphicStamp() ) {
	
	                /**
	                 * For Graphic Stamps, never send the src attribute to the Java server to cut down on payload / processing (its not needed).
	                 * The node test server needs this to know the source of the image to read back in (it doesn't have a db).
	                 * This is another hack that should be cleaned up.
	                 * For now detecting if node from the port (above) -- there is no webpack environment variable.
	                 * Alternative is using (PRODUCTION), but that is messier b/c we could run a prod build in node.
	                 * Same logic goes for modify, below.
	                 */
	                !isNode && _.has( attrsToSave, 'src' ) && ( delete attrsToSave.src );
	
	                /**
	                 * Hack: for node server send the graphicStamp header from the selectedStamp -- since its new, like 'src' its not yet on the model
	                 * Not necessary to send Java environment.
	                 * Code here b/c already checking node environment
	                 */
	
	                isNode && ( attrsToSave['graphicStampHeader'] = m.uiModel.getSelectedStampImgHeader() );
	
	            }
	
	            /**
	             * DVBC-1299 - hook in here to change the default autoDisplay for page text notes to NULL
	             * ( they are initially set to 'V' in the default attributes of create new note ).
	             * NULL implies the same meaning as 'V' for Doc Viewer.
	             * Hacky and not the clearest way to accomplish, but definitely the quickest
	             * given existing codebase, especially since we don't give the user the option to change this value,
	             * and it has no meaning for this application, only FDD ( a window opens on document load ).
	             * FDD will interpret NULL the same as 'I'.
	             * Alternatives approaches involve changing the default for the note type (now set in 'createNewNote'),
	             * and handling the it differently when put into and read out from the noteView in the save process (_getRawUserInput).
	             * This is only for new notes -- leave edited ones with the same value.
	             * A change here is definitely something to consider with a refactor / further sub-classing.
	             * Also, nly do if noteStatus is 'V' just in case this ever changes.
	             */
	            if ( m.isPageTextNote() && m.get('noteStatus') ==='V' ) {
	                attrsToSave['noteStatus'] = null;
	            }
	
	
	            m.save( attrsToSave, saveOptions );
	
	        } else {
	
	           if ( attrsToSave !== false ) {
	
	               // DVBC-1299: if page text note and noteStatus is null, set attribute to save back to null.
	               // ( It will have been changed when retrieving the the value printed in the UI ).
	               if ( m.isPageTextNote() && m.get('noteStatus') === null ) {
	                   attrsToSave['noteStatus'] = null;
	               }
	
	
	               // if converting to floating redaction, change the note type before save
	               // ( on success it will be reset from the server and read in as the floating note type )
	               if ( m.isRedactionNoteConvertingToFloatingCodes() ) {
	                    m.set('noteType', 'FLOATING_REDACTION_NOTE');
	               }
	
	               // If modifying a floating redaction note and the system flag is off,
	               // Switch the note type so the server will pick up and save as a regular redaction note.
	               if ( m.isFloatingRedactionAndSystemNotSetForFloatingCodes() ) {
	                   m.set('noteType', 'REDACTION_NOTE');
	               }
	
	               if ( m.isGraphicStamp() && !isNode ) {
	
	                   // Backbone Model save will still send the original attributes, not just the changed ones (by design)
	                   // (src would always exist for existing models)
	                   // hack here taking it off is much simpler the over-writing model.save
	                   m.unset( 'src', {silent:true} );
	
	                   // with the src attr now an obj at all rotations, on modify it will be different than the original model
	                   // we never want to send it to the Java server (and maybe now not the node server ... )
	                   // for simplicity, the src retrieved from that canvas stamp model is just that of the current stamp (a single string, not the entire object)
	                   // so, it will now appear in changed attributes; ensure it's removed (as with newly created stamps)
	                   _.has(attrsToSave, 'src') && ( delete attrsToSave.src );
	
	               }
	
	               m.save( attrsToSave, saveOptions );
	
	           } else {
	
	               // Nothing changed -- reset the ui: same as 'editCancelled';
	               this.channel.trigger('notes:changeActiveNote', null, {
	                   savedButNoChange: true,
	                   isEdit: !isNew
	               });
	           }
	
	        }
	
	    },
	    enterCancelChanges: function(view, args) {
	
	        // Quick hack for signature cancel mediation (model passed instead)
	        if (!(arguments[0] instanceof Backbone.View)) {
	            var model = view.uiModel.parent,
	                view = this.channel.request('getNoteViewFromModel', model);
	        }
	
	        var m = view.model;
	
	        if ( this._disallowSaveOrCancelChanges(m) )
	            return;
	
	        var isNew = m.isNew(),
	            setActiveNoteOpts = {
	                userCancelled: true,
	                isEdit: !isNew
	            },
	            channel = this.channel,
	            exitNoteEditing = function() {
	                m.resetOnCancelChanges();
	                channel.trigger('notes:changeActiveNote', null, setActiveNoteOpts);
	            },
	            opts = {
	                m: m,
	                exitNoteEditing: exitNoteEditing,
	                isDrawable: m.isDrawable(),
	                modalOpts: {
	                    confirmType: 'warning',
	                    title: 'Confirm',
	                    okCB: exitNoteEditing
	                }
	            };
	
	        isNew
	            ? this._cancelCreateNote(opts)
	            : this._cancelModifyNote(opts, view);
	
	    },
	    /*
	    * Disallow save/cancel of note if user is drawing a shape ( DVBC-1497 manifests for polygon redactions ).
	    * First predicate unnecessary but provided for clarity.
	    * DVBC-1498: exception -- proceed when graphic text area view is being edited: the unsaved view will be destroyed on completion.
	    * */
	    _disallowSaveOrCancelChanges: function(note) {
	        return note.isDrawable() && note.uiModel.get('isUserDrawingShape')
	            && this.channel.request('vChannel').request('activeNoteSubType') !== 'text';
	    },
	
	    /*
	    * For drawable notes show a warning dialog.
	    * For new notes there are always 'changes'.
	    * */
	    _cancelCreateNote: function(opts) {
	
	        !opts.isDrawable
	            ? opts.exitNoteEditing()
	            : this.vChannel.trigger('modal:open',
	                _.extend( opts.modalOpts, {
	                    content: 'Cancel New ' + opts.m.desc + ' Note?'
	                })
	        );
	    },
	    /*
	    * If nothing changed, don't ask to save.
	    * Otherwise: change the ui back to the orig values: if drawable-- show a conformation dialog first.
	    * */
	    _cancelModifyNote: function( opts, view ) {
	
	        var attrsToSave = this.channel.request('notes:changedNoteAttributes', view);
	
	        if (attrsToSave === false) {  // ( returns false or that the attrs have changed )
	            opts.exitNoteEditing();
	            /*
	             * Return: don't allow exitNoteEditing again !!!
	             * ( This would set the activeNote twice, causing errors --
	             *  although its null each time, sometimes we need to refer to the previous activeNote
	             *  in the higher level function's logic )
	             */
	            return;
	        }
	
	        !opts.isDrawable
	            ? opts.exitNoteEditing()
	            : opts.modal = this.vChannel.trigger( 'modal:open', _.extend( opts.modalOpts, {
	                content: 'Cancel ' + opts.m.desc + ' Note Modifications?'
	            }));
	
	    },
	    _noteSaveSuccess: function(note, resp, options) {
	
	        this.vChannel.trigger('alert:show', {
	            type: 'success',
	            shortMessage: options.isNew ? 'Note Created' : 'Note Modified',
	            closeTimeout: 3000
	        });
	
	
	        /*
	        * If Flash Back --
	        * Listen for the destroy of the view with the model -- will only be one to one --- it's now the active note.
	        * For note saved here there is no active note ... need to save note.parentFlashBackNote to the collection view
	        * w/out affecting the active note (if access group is the current user ONLY).
	        * */
	        var prtFbNt = note.parentFlashBackNote;
	        if (prtFbNt) {
	
	            var user = fvChannel.request('user');
	
	            // The exit: should remove it from the view and resume destroy countdown.
	            // TODO: facade -- also not going top down.
	            prtFbNt.uiModel.set('replyMode', false);
	
	            // Need to check user id but ensure fetched first (would occur if create new flash note not yet selected
	            user.gettingPrivateGroups().done( _.bind(function(groups) {
	
	                if ( note.get('accessGroup') === user.getPrivateGroup().get('groupId') )
	                    this.notesCollection.add( note, { // will draw
	                        at: 0
	                    });
	
	            }, this));
	            // TODO: fail
	
	        } else {
	
	            // TODO: combo with the below -- they overlap
	            this.channel.trigger('notes:changeActiveNote', null, {
	                noteSaved: true,
	                isEdit: !options.isNew
	            });
	        }
	
	
	        this.channel.command('updateFilter', {
	            filterSrc: 'noteSaved'
	        });
	
	        // If flash note, want added to doc note collection, so it updates
	        this.channel.trigger('notes:noteSaved', note);
	
	        // Note: must now come after the above -- TODO: like delete -- have the above flow from the top level down
	        this.channel.trigger( 'notes:updateNoteTypesToDisable' );
	
	    },
	
	    _noteSaveFailure: function(note, jqXHR, options) {
	
	        note.trigger('notes:noteSaveFailure', note, jqXHR, options );
	
	        // Now showing in a viewer dialog -- not in the note 'error line' ( no longer concerned with a separate notes model )
	        this.vChannel.command( 'ajaxError', jqXHR, 'Error ' + (options.isNew ? 'creating' : 'modifying') + ' note' );
	
	
	    },
	    enterEditNote: function(view, args) {
	        this.channel.trigger( 'notes:changeActiveNote', args.model, {isEdit: true} );
	    },
	    /*
	    * Note: N/A for flash notes.
	    * Locking is handled server side, but to be friendly, don't allow the user to see the modal
	    * if the document is locked by another user.  (I already have the code for it).
	    * */
	    enterDeleteNote: function(view) {
	
	        var note = view.model,
	            showDeleteNoteModal = _.bind( function() {
	
	                this.vChannel.trigger( 'modal:open', {
	                    confirmType: 'warning',
	                    title: 'Confirm',
	                    content: 'Delete Note?',
	                    okCB: _.bind( function() {
	                        this._deleteNote( note );
	                    }, this)
	                });
	
	            }, this );
	
	
	        if ( note.isPageNote() ) {
	            this.vChannel.command( 'checkActiveDocLockStatus', 'Delete Note', showDeleteNoteModal, 0, 0, 1 );
	            return;
	        }
	
	        showDeleteNoteModal();
	
	    },
	
	    consultGroupChange: function( note ) {
	
	        if ( note.supportsColorPicker() ) {
	
	            // Note: was off this.channel, but only want listeners of the current view ( now there is a toolbar or textStamp views )
	            note.trigger( 'colorPicker:toggleEnabled', note );
	        }
	
	        this.vChannel.trigger( 'notes:consultGroupChange', note );
	
	    },
	
	    // convert a redaction note (from the model) to use floating reason codes
	    convertToFloatingCodes: function(view, args) {
	
	        // Set isConvertingToFloatingCodes flag on the note model
	        // Among other things, this will change how the shapeViews and shapeModel will render on the canvas (see canvas.activeNoteChange)
	        var note = args.model;
	        note.isConvertingToFloatingCodes = true;
	
	        /*
	        * Trigger an activeNote change to hook into existing architecture for setting the active note.
	        * Only allowing the call this way (when the note isn't already active, also avoids
	        * Issue of dealing with newly created / modified shapes if 'convert was' clicked in edit mode.
	        * */
	        this.channel.trigger('notes:changeActiveNote', args.model, {
	            isEdit: true
	        });
	    },
	
	    /**
	     * ** Now central point of access ***
	     * See creatableNoteTypesHelper.updateNoteTypesToDisable for notes here.
	     * Update the state of note types that can be created, then update the new notes menus.
	     */
	    updateNoteTypesToDisable: function( options ) {
	
	        var noteTypeToDisable =
	            this.creatableNoteTypesHelper.updateNoteTypesToDisable( this.vChannel, options );
	
	        this.channel.trigger( 'newNoteMenu:setDisabledMenuItems',
	            noteTypeToDisable, this.creatableNoteTypesHelper.disableNewNoteMenus() );
	
	    },
	
	    onBeforeDestroy: function() {
	       this.channel.reset();
	       _.invoke([  this.state, this.layout], 'destroy'); // TODO: the instance variables
	   }
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {__webpack_require__(486);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    NotesHeaderView = __webpack_require__(487),
	    NotesCollectionView = __webpack_require__(518);
	
	
	
	// TODO: extend from 'subPanel content view.... see 'indexes' ... still ... ?
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    template: __webpack_require__(519),
	
	    onRender: Backbone.View.prototype.unwrap,
	
	    regions: {
	        header:                         '.sp-header',
	        noteViews:                      '.sp-body'
	    },
	
	    initialize: function(options) {
	
	        _.extend (this, _.pick(options, 'el', 'notesCollection', 'channel') );
	
	        _.bindAll(this, 'updateOnPgChange', 'updateOnViewModeChange');
	
	    },
	
	
	    serializeData: function() {
	        return {
	            paneId: 'FV-notes'
	        };
	    },
	    /*
	    * ( Must be in DOM )
	    * */
	    onShow: function() {
	
	        this.header.show( new NotesHeaderView({
	            collection: this.notesCollection,
	            channel: this.channel
	        }));
	
	        this.noteViews.show( new NotesCollectionView({
	            collection: this.notesCollection,
	            channel: this.channel
	        }));
	
	
	    },
	
	
	    expandedNoteChange: function(note, priorNote) {
	
	        if (note) {
	            this.$el.addClass('note-expanded');
	            this.header.currentView.enterMode(note, 'note-expanded');
	            note.uiModel.toggle('expanded');
	        } else {
	            this.$el.removeClass('note-expanded');
	            this.header.currentView.exitModeAllModes();
	            priorNote.uiModel.toggle('expanded');
	        }
	
	    },
	    updateOnPgChange: function( options ) {
	
	        // Update pg number OF active note view if editingNote and noteType is pageTextNote and is new --
	        // or if not new text note, disable navigation.
	        this.noteViews.currentView.setNoteViewsNavigability( options.activeNote, options.page );
	
	        this.channel.trigger('notes:updateNoteTypesToDisable'); // ( now not passing options may to pass options.page )
	
	    },
	
	    updateOnViewModeChange: function(viewMode, options) {
	
	        var noteViews = this.noteViews.currentView;
	
	        this.channel.trigger('notes:updateNoteTypesToDisable');
	
	        viewMode === 'pdf'
	            ? noteViews.enterPDFMode()
	            : noteViews.exitPDFMode(options);
	
	    },
	    toggleEditMode: function(on) {
	        this.$el.toggleClass('noteEditing', on); //the entire view -- way tooo linked
	    },
	    updatePostActiveNoteChange: function(actionOptions) {
	
	        var note = actionOptions.note,
	            noteList = this.noteViews.currentView,
	            header = this.header.currentView;
	
	        var isEntering = actionOptions.note !== null;
	        //actions for this layout first
	        if (isEntering) {
	            this.toggleEditMode(1);
	            var createOrEditMode = actionOptions.isNew
	                ? 'create'
	                : !actionOptions.isReadingFlashNote
	                    ? 'edit'
	                    : 'reading'; /* for now only for flash notes that are unopened */
	            header.enterMode(note, createOrEditMode);
	        } else {
	            this.toggleEditMode(0);
	            header.exitModeAllModes();
	        }
	
	        // then main action for note list
	        noteList.updateActiveNoteViewPostNoteChange(actionOptions, isEntering);
	    },
	
	    destroy: function() {
	
	        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
	        this.$el = null;
	        this.el = null;
	    }
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 486 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(488);
	
	var Marionette = __webpack_require__(61),
	    BabySitterView = __webpack_require__(489),
	    Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    NewNoteDropDown = __webpack_require__(490),
	    NoteFilterView = __webpack_require__(492),
	    NoteSortView = __webpack_require__(495),
	    SearchBar = __webpack_require__(497),
	
	    RedactionToolbar = __webpack_require__(500),
	    GraphicNoteToolbar =  __webpack_require__(506),
	
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	__webpack_require__(516);
	
	
	module.exports = BabySitterView.extend({
	
	    template: __webpack_require__(517),
	    className: 'sp-head-wr',
	
	    initialize: function(options) {
	
	        _.extend( this, _.pick( options, 'collection', 'channel') );
	        this.channel.comply(this.commands, this);
	
	    },
	
	    commands: {
	
	        changeSortIndicator: function(dir) {
	            this._setSortDirectionIndicator(dir);
	        },
	
	        updateNoteFilterInHeader: function() {
	
	            var $curBtn = this.ui.filterBtn;
	            var $bClone = $curBtn.clone()
	                .addClass('hide')
	                .removeClass('active filterActive') /* active class is separate from the filter active class */
	                .insertBefore($curBtn);
	
	            var existingView = this.children.findByCustom('noteFilter');
	            existingView.destroy();
	
	            this.ui.filterBtn = $bClone; //or won't be able to re-clone
	
	            this.setFilterIndicatorAndTitle();
	
	            $bClone.toggleClass('filterActive', this.collection.notesAreFiltered() );
	
	            $bClone.removeClass('hide');
	
	            //issue w/destroy is that ui.filterBtn will be null
	
	            var noteFilterView = this._createNoteFilterView({
	                hPos: 'right',
	                container: this.channel.request('vChannel').request('getWrapper')
	            }, this.channel,
	                this.ui.filterBtn
	            ).render();
	
	            this.children.add(noteFilterView, 'noteFilter');
	        }
	    },
	
	    onRender: function() {
	
	        this._setSortDirectionIndicator( this.channel.request('noteSortDirection') );
	        this.unwrap();
	
	    },
	
	    ui: {
	        'searchBarPlaceholder':         '[data-searchWidget]',
	        'addPgNoteBtn':                 '#add-pg-note',
	        'filterBtn':                    '.filter',
	        'sortBtn':                      '.sort',
	        'toggleSortBtn':                '.sort-dir',
	        'modeWr':                       '#modeWr',
	        'noteTypeIcon':                 '.note-type-icn',
	        'toolbarContainer':             '.nonSearch',
	        'previewRedactionToggleBtn':    '#toggle-preview-redactions'
	    },
	    events: {
	
	        'click @ui.toggleSortBtn': function() {
	            this.channel.command('toggleSortDirection');
	        }
	
	    },
	
	    keyboardEvents: {
	
	        // Provide hotkey for the Redaction Preview button.
	        // Don't call channel event; utilize the plugin that will update it's UI.
	        'p': function() {
	            this.ui.previewRedactionToggleBtn.trigger('toggle');
	        }
	
	    },
	
	    onBeforeShow: function() {
	
	        var ch = this.channel,
	            children = this.children,
	            vsWrapper = ch.request('vChannel').request('getWrapper'), //TODO: pass in
	            baseDDopts = {
	                hPos: 'right',
	                container: vsWrapper
	            };
	
	        children.add( new NewNoteDropDown({
	            el: this.ui.addPgNoteBtn,
	            channel: ch,
	            ddOptions: _.extend(baseDDopts, {
	                ddNoSelect: true
	            })
	        }), 'addNoteDD')
	
	        .add( this._createNoteFilterView(baseDDopts, ch, this.ui.filterBtn), 'noteFilter')
	
	        .add( new NoteSortView({
	            el: this.ui.sortBtn,
	            notes: this.collection,
	            channel: ch,
	            ddOptions: _.extend(baseDDopts, {
	                isSelect: true,
	                selectNoOpenerText: true
	            })
	        }), 'sortNotes');
	
	        children.call('render');
	
	        var searchBar = new SearchBar({
	            placeHolder: 'Notes',
	            preCollapse: function() {
	                ch.command('updateFilter', {
	                    filterSrc: 'sat',
	                    satFilterTxt: '',
	                    currentPage: ch.request('currentPageNumber')
	                });
	            },
	            keyUp: function(filterText) {
	                ch.command('updateFilter', {
	                    filterSrc: 'sat',
	                    satFilterTxt: filterText,
	                    currentPage: ch.request('currentPageNumber')
	                });
	            }
	        });
	
	        this.ui.searchBarPlaceholder.replaceWith(searchBar.render().$el);
	        children.add(searchBar, 'searchView');
	
	        this.setFilterIndicatorAndTitle();
	
	        this._createPreviewRedactionToggleButton();
	
	        this.$el.unselectable();
	
	        return this;
	
	    },
	    /* el can change on reset */
	    _createNoteFilterView: function(baseDDopts, ch, el) {
	
	        return new NoteFilterView({
	            el: el,
	            filterModel: ch.request('filterState'),
	            notes: this.collection,
	            channel: ch,
	            ddOptions: _.extend(baseDDopts, {
	                ddMultiSelect: true,
	                selectNoOpenerText: true
	            })
	        });
	
	    },
	
	    // factory for the toolbar -- this belongs in another module (mediate)
	    createToolbar: function(note, isEdit) {
	
	        this.destroyToolbar();
	
	        var options = {
	                note: note,
	                isEdit: isEdit,
	                channel: this.channel
	            },
	            fnRenderToolbar = function(toolbar) {
	                this.children.add( toolbar, 'toolbar' );
	                this.ui.toolbarContainer.append( toolbar.render().el ); //(can't put at end or error will occur for highlight -- TODO: stop b/f gets in)
	            };
	
	
	        if ( note.isNonFullpageRedactionNote() ) {
	
	            this.options.channel.request('currentPageIsCold') && _.extend( options, {
	                pageIsCold: true
	            });
	
	            fnRenderToolbar.call( this, new RedactionToolbar(options) );
	            return;
	        }
	
	        if ( note.isSVGGraphicNote() ) {
	
	            fnRenderToolbar.call(this, new GraphicNoteToolbar( _.extend(
	                options, {
	                    container: this.ui.toolbarContainer
	                })
	            ) );
	        }
	
	    },
	    destroyToolbar: function() {  //use destroy as check, could be empty {}
	        var toolbar =  this.children.findByCustom('toolbar');
	        toolbar && toolbar.destroy(); //(could also trigger)
	    },
	    enterMode: function(note, mode) {  //mode: edit,create,expanded
	
	        this.$el
	            .add(this.ui.modeWr)
	            .addClass( mode + ' ' + note.getNoteClass() );
	
	        this.ui.noteTypeIcon.addClass(note.iconClass);
	
	        this.children.findByCustom('searchView')
	            .triggerMethod('toggleCollapseAbility') //put back ability to toggle it
	            .triggerMethod('forceClose')//(if open, close so can see icons)
	            .triggerMethod('toggleEnabled', 0);
	
	        mode !== 'note-expanded' && this.createToolbar(note, false);
	    },
	    exitModeAllModes: function() {
	
	        this.$el.attr('class', this.className); //remove anything other than selector
	        this.ui.modeWr.removeClass();
	        this.ui.noteTypeIcon.attr('class', this._uiBindings.noteTypeIcon.replace('.', '') ); //remove prior icon class
	
	        var children = this.children,
	            searchView = children.findByCustom('searchView'),
	            toolbar = children.findByCustom('toolbar');
	
	        searchView.triggerMethod('toggleCollapseAbility');
	        searchView.triggerMethod('toggleEnabled', 1);
	        toolbar && toolbar.destroy();
	
	    },
	   /*
	    *  If the active note type can change, was for anon notes.
	    *  No enter/exit on note change
	    * TODO: way too mixed with css from other hacks
	    * */
	    noteModelChanged: function(note, previousNote) {
	
	        var newClass = 'pn-' + note.init,
	            oldInitClass = 'pn-' + previousNote.init,
	            oldIconClass =  previousNote.iconClass,
	            newIconClass = note.iconClass;
	
	        this.$el.removeClass(oldInitClass).addClass(newClass);
	        this.ui.modeWr.removeClass(oldInitClass).addClass(newClass);
	        this.ui.noteTypeIcon.removeClass(oldIconClass).addClass(newIconClass);
	
	    },
	
	    setFilterIndicatorAndTitle: function() {
	
	        var notes = this.collection,
	            notesAreFiltered = notes.notesAreFiltered();
	
	        this.ui.filterBtn.toggleClass( 'filterActive', notesAreFiltered );
	
	        var title = 'Filter';
	
	        if (notesAreFiltered) {
	            title += ':\n' + 'Showing ' + notes.getNumberOfVisibleNotes() + ' of ' + notes.length + ' notes';
	        }
	
	        this.ui.filterBtn.attr('title', title);
	
	    },
	    _setSortDirectionIndicator: function( dir ) {
	
	        var sortedAscending = dir === 'asc';
	
	        var caption =
	            ( sortedAscending ? 'Ascending' : 'Descending' ) + ' order -- ' +
	            'click to sort in ' + ( sortedAscending ? 'descending' : 'ascending' ) + ' order';
	
	        this.ui.toggleSortBtn
	            .removeClass('asc desc')
	            .addClass(dir)
	            .attr( 'title', caption );
	
	    },
	
	    /**
	     * Note: currently this button will be displayed/enabled regardless of whether
	     * redaction notes exist in the document.
	     */
	    _createPreviewRedactionToggleButton: function() {
	
	        var vChannel = this.channel.request('vChannel'),
	            BTN_TITLE = 'Preview Redactions';
	
	        this.ui.previewRedactionToggleBtn.toggleButton({
	
	            isActive: fvChannel.request('localStorage').getPgModeApplyAllRedactions(),
	            toggleAction: function() {
	                vChannel.command('toggleApplyAllRedactionsInPageMode');
	            },
	            activeTitle: BTN_TITLE,
	            inactiveTitle: BTN_TITLE
	
	        });
	
	    },
	
	    onBeforeDestroy: function() {
	
	        BabySitterView.prototype.onBeforeDestroy.apply( this, arguments );
	
	        this.ui.previewRedactionToggleBtn.destroy();
	
	    }
	
	});

/***/ },
/* 488 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var Marionette = __webpack_require__(61);
	__webpack_require__(63);
	
	// TODO: could just MonitorDOMRefresh for onShow ability
	
	module.exports = Marionette.ItemView.extend({
	
	   constructor: function() {
	       this.createChildren();
	       return Marionette.ItemView.prototype.constructor.apply(this, arguments);
	   },
	
	    /* extra to be used as mixin */
	   createChildren: function() {
	        this.children = new Backbone.ChildViewContainer();
	   },
	
	   onBeforeDestroy: function() {
	        var children = this.children;
	            children.each(function(c) {
	            c.destroy();
	            children.remove(c);
	        });
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DropDown = __webpack_require__(432),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = DropDown.extend({
	
	    template: __webpack_require__(491),
	
	    initialize: function (options ) {
	
	        DropDown.prototype.initialize.call(this, options);
	
	        // ( Both share the notes channel )
	        var notesChannel = this.options.channel;
	
	        // Flag to indicate if from notes menu or that created in the header ( whose dropdown menu contents is shared )
	        // Can also prevent some dupe processing, like events in the header
	
	        this.isFromViewerHeader = options.isFromViewerHeader;
	
	        this.creatableNoteTypesHelper = notesChannel.request('creatableNoteTypesHelper');
	
	        this.listenTo( notesChannel, 'newNoteMenu:setDisabledMenuItems', this.setDisabilityOfMenuItems );
	
	    },
	
	    /**
	     * this.creatableNoteTypesHelper.getPrintedNoteTypes: note type by model constructor.
	     * Method transforms the template context to uses the prototypes, appends a note type to them,,
	     * and sorts by actionTitle.
	     * Template utilizes:
	     *  - isDocument
	     *  - actionTitle
	     *  - iconClass
	     *  - noteType
	     *  Note:
	     *  - this is OLD and evolved and really should be re-written.
	     *  - only called for the original created in the notes module.
	     */
	
	    templateOptions: function() {
	
	       var notesHash = this.creatableNoteTypesHelper.getPrintedNoteTypes(),
	           noteTypes = _.keys(notesHash),
	           noteConstrs = _.values(notesHash);
	
	       return {
	           noteTypesToCreate: _.chain(noteConstrs)
	               .map( function( noteConstr, i) {
	                   return _.extend({}, noteConstr.prototype, {
	                       noteType: noteTypes[i]
	                   });
	               }).sortBy(function(n) {
	                   return n.actionTitle;
	               }).value()
	       };
	
	    },
	
	    onRender: function() {
	
	        var notesChannel = this.options.channel;
	
	        if ( !this.isFromViewerHeader ) {
	
	            /* Hook to create the header in the viewer that will share the same DOM as the dropdown content. */
	            notesChannel.trigger('notes:newNoteMenuRendered', this.getDDContent());
	        }
	
	        // Update disability -- we aren't including in template now or re-rendering ...
	        notesChannel.trigger( 'notes:updateNoteTypesToDisable' );
	
	    },
	
	    // TODO: more exact mediation
	    onChange: function(value, elData) {
	
	        var lCh = this.options.channel,
	            vCh = lCh.request('vChannel'),
	            user = fvChannel.request('user'),
	            isDocNote = elData.isdoc,
	            noteType = elData.noteType;
	
	        /**
	         * DVBC-1701 -- trigger an event to set a flag to disable note view mouseenter events prior to changing the active note.
	         * The mouse may be over a note view after selection and close of the dropdown so that when closed,
	         * the event would be picked up by a 'mouseenter'.  This would cause the shapes of that
	         * note view to be made 'active' on the canvas (we only want the shapes of the newly created note to be 'active').
	         * ( This may not always happen; it's a race condition between setting the active note -- something that is set here
	         * and checked prior to triggering the active shapes. But if the menu closes first, the mousenter can be caught in the DOM
	         * before the active note is set ).
	         * The dropdown plugin calls onChange (here) prior to onClose, where the menu content is removed causing a mouseover event.
	         * Ideally we'd utilize the onClose event to re-enable the capture of mouseenter events, but there are 2 new note menus.
	         * When any dropdown is opened, the others are closed and this would re-enable the event capture before a change is made.
	         * So we use a hacky timeout afterwards to resume listening for mouseenter events on the note views.
	         * Since the user is creating a new note, it's reasonable to expect a certain amount of time to expire.
	         * Note: this really only applies to drawable note types.
	         */
	        lCh.trigger('notes:disableNoteViewHoverEvents');
	
	        setTimeout( function() {
	            lCh.trigger('notes:enableNoteViewHoverEvents');
	        }, 1500);
	
	
	        // TODO: this is just a quick fix -- make to disallow the event to go through when doc no pages --
	        // the actual menu item is disabled via css override
	        if ( vCh.request('activeDocHasNoPages') && !isDocNote )
	            return false;
	
	        if ( noteType === 'FLASH_NOTE' && !user.privateGroupsFetched() ) {
	
	            /*
	            * Must first get the private groups if they don't exist.
	            * TODO: this sets the active note, which will trigger events in pageNotes.
	            *  b/f new is actually rendered (eg waiting for flash notes; change this ... why not calling createNewNote ?
	            * */
	
	            user.gettingPrivateGroups().done( function(groups) {
	
	                if (groups === null)
	                    return;  //error: error handler already set in fetch
	
	                lCh.trigger('notes:changeActiveNote', lCh.request('newNoteModel', isDocNote, noteType), {createNote: true} );
	
	            });
	
	            return;
	
	        }
	
	        lCh.trigger( 'notes:changeActiveNote', lCh.request('newNoteModel', isDocNote, noteType), {createNote: true} );
	
	    },
	
	
	    // Update disability of menu items and the menu as a whole
	    setDisabilityOfMenuItems: function( noteTypesToDisable, allTypesDisabled ) {
	
	        if ( !this.isFromViewerHeader ) {
	
	            var $menuItems = this.getDDContent().find('.mi');
	            $menuItems.removeClass('disabled');
	
	            _.each( noteTypesToDisable, function( noteType ) {
	                $menuItems.filter('[data-note-type=' + noteType + ']').addClass('disabled');
	            });
	        }
	
	        // Update for both
	        this.$el.toggleClass( 'disabled', allTypesDisabled );
	
	    },
	
	    /**
	     * Programatically build up key the events hash to avoid use of constants.
	     * While set on both new note menus, key events are only triggered once via Mousetrap
	     * Update 3/8: listeners on the note view anyway.
	     */
	    keyboardEvents: function() {
	
	        if ( this.isFromViewerHeader )
	            return null;
	
	        // Note Type Java Enums by Model Constructors -- same used to populate the template
	        var notesHash = this.creatableNoteTypesHelper.getPrintedNoteTypes();
	
	        var keyEventsHash = {};
	
	        for (var noteType in notesHash ) {
	
	            var hotKeyOfNoteType = notesHash[noteType].prototype.createHotKey;
	
	            // Utilize an old school closure to prevent all generated functions from
	            // using the last note type value in the loop.
	            ( function( noteTypeLocal ){
	
	                keyEventsHash[hotKeyOfNoteType] = function(e) {
	                    this.mimicOnChangeFromHotKey( e, noteTypeLocal );
	                };
	
	            } )(noteType);
	
	        }
	
	        return keyEventsHash;
	
	    },
	
	
	    /*
	     * Hack taking advantage of logic that exists in the DOM.
	     * Some day will need to clean this all up -- we'd want a 'can create' for each note type in all scenarios.
	     */
	    mimicOnChangeFromHotKey: function( e, noteType ) {
	
	        // Prevent any default browser behavior ( eg if went with ctrl keys )
	        e.preventDefault();
	
	        // Prevent if a note is already active.
	        if ( this.options.channel.request('vChannel').request('activeNote') )
	            return false;
	
	
	        var $mi = this.getDDContent().find( '.mi[data-note-type=' + noteType + ']' );
	
	        // This is superfluous since we are creating the keyEvent functions from
	        // the creatable note models type-constructor hash ( as with rendering the template) , but leave in case that ever changes ( they wouldn't be printed ).
	        if ($mi.length < 1)
	            return false;
	
	        // Return if disabled.
	        if ($mi.hasClass('disabled'))
	            return false;
	
	        // Mimic this dropdown's onChange by calling it manually.
	        // $mi.text isn't  used, but need the data.
	        // Triggering a click will not work b/c of the plugin's logic, which looks for the current target of
	        // from a click on the dropdown menu.
	        this.onChange( $mi.text(), $mi.data() );
	
	    },
	
	
	    onBeforeDestroy: function() {
	
	        this.stopListening();
	        this.off();
	        DropDown.prototype.onBeforeDestroy.call(this);
	
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"mi "
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isDocument : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
	    + "\" data-note-type=\""
	    + alias2(alias1((depth0 != null ? depth0.noteType : depth0), depth0))
	    + "\" data-isdoc=\""
	    + alias2(alias1((depth0 != null ? depth0.isDocument : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.actionTitle : depth0), depth0))
	    + "\">\n            <span class=\"dd-icon "
	    + alias2(alias1((depth0 != null ? depth0.iconClass : depth0), depth0))
	    + "\"></span>\n            "
	    + alias2(alias1((depth0 != null ? depth0.actionTitle : depth0), depth0))
	    + "\n        </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "mi-dn";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "mi-pg";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div id=\"dd-new-note\" class=\"add-pg-note-list dropdown-menu hide\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.noteTypesToCreate : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n\n";
	},"useData":true});

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(493);
	
	var DropDown = __webpack_require__(431), //
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(494),
	    initialize: function(options) {
	        DropDown.prototype.initialize.call(this, options);
	        _.extend( this, _.pick(options, 'filterModel', 'notes') );
	    },
	    templateOptions: function() {
	
	        var allNotes = this.notes,
	            allVisibleNotes = allNotes.getVisibleNotes(),  //getVisibleNoteModels(allNotes.models);
	            currentPgNumber = this.options.channel.request('currentPageNumber'),
	            fm = this.filterModel,
	            hideActivityNotes = fm.hideActivityNotes(); // (means the 'filter is applied')
	
	        /* Template data for note types section -- now 'noteTypeGroups' */
	        var uniqueNoteTypesInNotesCollection = allNotes.chain()
	            .uniq( function(m) {
	                return m.noteTypeGroup;
	            })
	            .map( function(m) {
	                var notesOfType = allNotes.getNotesOfGroupType( m.noteTypeGroup ),
	                    visibleNotesOfType = allNotes.getVisibleNotes( notesOfType );
	
	                return _.extend( {}, m , {
	                    nVisible: visibleNotesOfType.length,
	                    nTotal: notesOfType.length,
	                    // don't allow selection of the menu item under certain circumstances -- logic could probably be expanded
	                    disable:
	                    ( m.isDocument && fm.isCurrentPageFilterApplied() ) ||
	                        (hideActivityNotes && m.noteTypeGroup === 'ACTIVITY_NOTE')
	                });
	
	            })
	            .sortBy( function(m) {
	                return m.desc;
	            })
	            .value();
	
	        // Referrals Section
	        var allReferredNotes = allNotes.filter( function(n) {
	                return n.consultGroupsAssigned();
	            }),
	            allUnreferredNotes = allNotes.filter( function(n) {
	                return !n.consultGroupsAssigned();
	            }),
	            visibleReferredNotes = allNotes.getVisibleNotes(allReferredNotes),
	            visibleUnreferredNotes = allNotes.getVisibleNotes(allUnreferredNotes);
	
	        return {
	            pageSection: {
	                all: {
	                    nVisible: allVisibleNotes.length,
	                    nTotal: allNotes.length
	                },
	                currentPage: {
	                    showFilter: this.options.channel.request('viewMode') !== 'pdf',
	                    nVisible:  _.filter(allVisibleNotes, function(n) {
	                        return n.pageNumber === currentPgNumber;
	                    }).length,
	                    nTotal: allNotes.getNotesOfPage( currentPgNumber ).length
	                }
	            },
	            typeSection: {
	                existingNoteTypes: uniqueNoteTypesInNotesCollection
	            },
	            activitySection: {
	                showSection: fm.get('noteTypeFilter') !== 'ACTIVITY_NOTE',
	                showActivityNotes: !hideActivityNotes // active set in template, not via jQ in onRender
	            },
	            referralSection: {
	                showSection: fvChannel.request('supportConsults'),
	                referred: {
	                    nVisible: visibleReferredNotes.length,
	                    nTotal: allReferredNotes.length
	                },
	                notReferred: {
	                    nVisible: visibleUnreferredNotes.length,
	                    nTotal: allUnreferredNotes.length
	                }
	            }
	        };
	
	    },
	    ui: {
	      noteTypeMenuItems:                    '.dd-grp-note-types .mi',
	      pageMenuItems:                        '.dd-grp-page .mi',
	      activityMenuItems:                    '.dd-grp-activity .mi',
	      referralMenuItems:                    '.dd-grp-referrals .mi'
	    },
	    events: {
	        'click @ui.noteTypeMenuItems':      'changeNoteType',
	        'click @ui.pageMenuItems':          'changePageType',
	        'click @ui.activityMenuItems':      'toggleActivityNotes',
	        'click @ui.referralMenuItems':      'changeReferralType'
	    },
	    onAfterSwapEl: function() {
	        this._postRender();
	    },
	    /* (initial render and swap of dd contents */
	    _postRender: function() {
	
	        var fm = this.filterModel;
	
	        this.$('[data-group-note-type="' + fm.get('noteTypeFilter') + '"]').addClass('active');
	        this.$('[data-pg-type="' + fm.get('pageFilter') + '"]').addClass('active');
	        this.$('[data-referral-filter-type="' + fm.get('referralFilter') + '"]').addClass('active');
	
	    },
	    
	    //TODO: need to send all the types from the filter model or the one that just changed?
	    changeNoteType: function(e) {
	        var $target = $(e.currentTarget); //look into taking out of each cb via event delegation
	        if ($target.hasClass('disabled'))
	            return false;
	
	        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
	            noteType:  $target.data('groupNoteType')
	        }));
	    },
	    changePageType: function(e) {
	        var $target = $(e.currentTarget);
	        if ($target.hasClass('disabled')) return false;
	        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
	            page: $target.data('pgType')
	        }));
	
	    },
	    toggleActivityNotes: function(e) {
	        var $target = $(e.currentTarget);
	        if ($target.hasClass('disabled')) return false;
	        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
	            hideActivityNotes: $target.text() === 'Hide'
	        }));
	    },
	    changeReferralType: function(e) {
	        var $target = $(e.currentTarget); //wouldn't apply
	        if ($target.hasClass('disabled')) return false;
	        this.options.channel.command('updateFilter', _.extend( this._getBaseUpdateFilterOptions(), {
	            referralFilter: $target.data('referral-filter-type')
	        }));
	    },
	    _getBaseUpdateFilterOptions: function() {
	        var fm = this.filterModel;
	        return {
	            filterSrc: 'dropdown',
	            page:  fm.get('pageFilter'),
	            noteType:  fm.get('noteTypeFilter'),
	            hideActivityNotes: fm.get('hideActivityNotes'),
	            referralFilter: fm.get('referralFilter'),
	            currentPage: this.options.channel.request('currentPageNumber')
	        };
	    }
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 493 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"list-header\" title=\"Page\">Page:</div>\n        <div class=\"dd-grp dd-grp-page\">\n\n            <div class=\"mi\" data-pg-type=\"all-pages\" title=\"All Pages\">\n                <div class=\"miWr\">\n                    <span class=\"filterItem\">All</span>\n                    <span class=\"filterSum\">("
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.all : depth0)) != null ? stack1.nVisible : stack1), depth0))
	    + "/"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.all : depth0)) != null ? stack1.nTotal : stack1), depth0))
	    + ")</span>\n                </div>\n            </div>\n\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.currentPage : depth0)) != null ? stack1.showFilter : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                <div class=\"mi\" data-pg-type=\"current-page\" title=\"Current Page\">\n                    <div class=\"miWr\">\n                        <span class=\"filterItem\">Current</span>\n                        <span class=\"filterSum\">("
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.currentPage : depth0)) != null ? stack1.nVisible : stack1), depth0))
	    + "/"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.currentPage : depth0)) != null ? stack1.nTotal : stack1), depth0))
	    + ")</span>\n                    </div>\n                </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "        <div class=\"divider\"></div>\n        <div class=\"list-header\" title=\"Note Type\">Type:</div>\n        <div class=\"dd-grp dd-grp-note-types\">\n            <div class=\"mi\" data-group-note-type=\"all\" title=\"All Types\">All</div>\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.existingNoteTypes : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "                <div class=\"mi"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.disable : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-group-note-type=\""
	    + alias2(alias1((depth0 != null ? depth0.noteTypeGroup : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.desc : depth0), depth0))
	    + "\">\n                    <div class=\"miWr\">\n                        <span class=\"filterItem\">"
	    + alias2(alias1((depth0 != null ? depth0.desc : depth0), depth0))
	    + "</span>\n                        <span class=\"filterSum\">("
	    + alias2(alias1((depth0 != null ? depth0.nVisible : depth0), depth0))
	    + "/"
	    + alias2(alias1((depth0 != null ? depth0.nTotal : depth0), depth0))
	    + ")</span>\n                    </div>\n                </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    return " disabled";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showSection : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "            <div class=\"divider\"></div>\n            <div class=\"list-header\" title=\"Activity Log\">Activity Log:</div>\n            <div class=\"dd-grp dd-grp-activity\">\n                <div class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showActivityNotes : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Show\">Show</div>\n                <div class=\"mi "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showActivityNotes : depth0),{"name":"unless","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Hide\">Hide</div>\n            </div>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "active";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showSection : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "            <div class=\"divider\"></div>\n            <div class=\"list-header\" title=\"Consultations\">Consultations:</div>\n            <div class=\"dd-grp dd-grp-referrals\">\n\n                <div class=\"mi\" data-referral-filter-type=\"all\" title=\"All\">All</div>\n\n                <div class=\"mi\" data-referral-filter-type=\"referred\" title=\"Consulted\">\n                    <div class=\"miWr\">\n                        <span class=\"filterItem\">Consulted</span>\n                        <span class=\"filterSum\">("
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.referred : depth0)) != null ? stack1.nVisible : stack1), depth0))
	    + "/"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.referred : depth0)) != null ? stack1.nTotal : stack1), depth0))
	    + ")</span>\n                    </div>\n                </div>\n\n                <div class=\"mi\" data-referral-filter-type=\"not-referred\" title=\"Not Consulted\">\n                    <div class=\"miWr\">\n                        <span class=\"filterItem\">Not Consulted</span>\n                        <span class=\"filterSum\">("
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.notReferred : depth0)) != null ? stack1.nVisible : stack1), depth0))
	    + "/"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.notReferred : depth0)) != null ? stack1.nTotal : stack1), depth0))
	    + ")</span>\n                    </div>\n                </div>\n\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"dd-note-filter\" class=\"filter-by-dd dropdown-menu hide\">\n\n"
	    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.pageSection : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.typeSection : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.activitySection : depth0),{"name":"with","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    \n\n"
	    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.referralSection : depth0),{"name":"with","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>";
	},"useData":true});

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DropDown = __webpack_require__(432);
	
	
	module.exports = DropDown.extend({
	
	    template: __webpack_require__(496),
	
	    templateOptions: function() {
	        return {
	            sortValDesc: _.chain(this.options.notes.comparators)
	                .pairs()
	                .map(function(p) {
	                    var o = {};
	                    o.val = p[0];
	                    o.name = p[1].name;
	                    return o;
	                })
	                .sortBy(function(a) {return a.name;}).value()
	        };
	    },
	
	    onChange: function(value, elData) {
	        this.options.channel.command('changeSortOption', elData.sort);
	    },
	
	    defaultSelector: function() {
	        var sortType = this.options.channel.request('noteSortType');
	        return '[data-sort="' + sortType + '"]';
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"mi\" data-sort=\""
	    + alias2(alias1((depth0 != null ? depth0.val : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "</div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div id=\"dd-note-sort\" class=\"sort-by-dd dropdown-menu hide\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.sortValDesc : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>";
	},"useData":true});

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {//(start and edge of div and expands to fill)
	//TODO: break up into w/hit nav and w/out -- eg one has a hit counter, other no
	
	__webpack_require__(498);
	
	var Marionette = __webpack_require__(61),
	     _ = __webpack_require__(49),
	      Backbone = __webpack_require__(58),
	    util = __webpack_require__(48); /* want for IE8 detection */
	
	__webpack_require__(76); //(for unselectable, selectAll)
	__webpack_require__(175);
	
	
	var defaults = {
	
	    includeNAV: false,
	    includeGrep: false, //(TODO: only allowed if includeNAV)
	
	    startInGrepMode: false,
	
	    keyUp: null, //if not in grep mode, called, otherwise, onAfterKeyUpInGrepMode is called if it is provided
	    onAfterKeyUpInGrepMode: null,
	    onAfterHighlightActiveHit: null, //use instead of keyUp if includeNAV
	
	    preCollapse: null,
	    onAfterFocus: null,
	    onToggleGrep: null,
	
	    allowCollapse: true,
	
	    originalWidth: 0, //really a dummy width, now controlled by min-width in css but need val to toggle back to ('can't co below the min-width)
	    $domToHighlight: null,
	
	    TIMER_DELAY: 500,
	
	    placeHolder: 'Search',
	    initialSearchTxt: null,
	
	    stretchToContainer: false //when true, input take up 100% of parent, essentially turning off the expand/contract functionality; also needs to set originalWidth
	
	};
	
	var keyUpTimer = null;
	
	module.exports = Marionette.ItemView.extend({
	    className: 'searchWidget',
	    template: __webpack_require__(499),
	    initialize: function(options) {
	        _.extend(this, defaults, _.pick( options, _.keys(defaults)) );
	        this.stretchToContainer && (this.originalWidth = '100%');
	        if (this.includeNAV) this._initNAVSection( this.options.$searchContainer );
	    },
	    _initNAVSection: function($searchContainer) {
	        _.extend( this, {
	            $domToHighlight: $searchContainer,
	            searchUI: new SearchHitsUIModel( [], {
	                $domElementsToSearch: $searchContainer
	            })
	        });
	        this.listenTo(this.searchUI, 'changeHit', this.activeHitChangeCB);
	        this.includeGrep && this.listenTo(this.searchUI, 'change:grepMode', this.grepModeToggled);
	    },
	    ui: {
	        searchBar:            '.sb-input',
	        searchCancelBtn:      '.search-cancel',
	        currentHit:           '.currentHit',
	        totalHits:            '.totalHits',
	        nextBtn:              '.sbNext',
	        prevBtn:              '.sbPrev',
	        navWr:                '.sbNAV',
	        grepBtn:              '.sbToggleGrep'
	    },
	    events: {
	        'focus @ui.searchBar':        'searchBarFocused',
	        'blur  @ui.searchBar':        'searchBarBlurred',
	        'click @ui.searchCancelBtn':  'collapseIfAllowed',
	        'mousedown @ui.nextBtn':      'goToNextHit',  //use mousedown to prevent input from losing focus (w/e.prevent default), click is too late
	        'mousedown @ui.prevBtn':      'goToPrevHit',
	        'mousedown @ui.grepBtn':      'onGrepBtnMouseDown'
	    },
	    onRender: function() {
	        this.ui.navWr.unselectable();
	        util.isIE8() && this.ui.searchBar.addClass('ie8');
	        this.initialSearchTxt && this._setSearchTxt(this.initialSearchTxt);
	        this.includeGrep && this.startInGrepMode && this.searchUI.set('grepMode', true, {fromRender: true});
	    },
	    _setSearchTxt: function(txt) {
	        this.ui.searchBar.focus(); // want the event caught (even though won't occur b/c not yet in DOM; OTHERWISE localSearchText not set!!! -- (prob better way to handle) -- can't focus b/c may not yet be in DOM
	        this.searchBarFocused();
	        this.includeNAV && this.onKeyPressed(txt); //trigger the keyup action -- setting the searchText
	    },
	    serializeData: function() {
	        return _.pick(this, 'placeHolder', 'includeNAV', 'includeGrep', 'initialSearchTxt', 'stretchToContainer');
	    },
	    searchBarFocused: function() {
	
	        this.expand();
	
	        var self = this;
	
	        this.ui.searchBar.on( 'keyup', function(e) {
	            
	            e.stopPropagation(); //don't want picked up by doc
	            
	            /* check for escape key press */
	            var key = e.keyCode ? e.keyCode : e.which;
	            if (key === 27)  {
	                self.collapseIfAllowed();    
	                return; 
	            }
	
	            /* only run the action if the value changed -- DVBC-1084) */
	            var searchValue = $(e.target).val();
	                //don't run if the value doesn't change; former necessary to prevent error if not nav (search ui wouldn't exist)
	            if (self.includeNAV && searchValue === self.searchUI.get('searchText')) return;
	           
	            // Delay before search in the case of typing
	            if (keyUpTimer) clearTimeout(keyUpTimer);
	
	            // start new timeout
	            keyUpTimer = setTimeout(function () {
	                self.onKeyPressed(searchValue);
	            }, self.TIMER_DELAY);
	
	        });
	
	        this.onAfterFocus && this.onAfterFocus();
	    },
	    searchBarBlurred: function() {
	        this.ui.searchBar.off('keyup');
	    },
	    onKeyPressed: function(searchText) {
	
	        if (this.includeNAV) {
	
	            var searchTxtExists = searchText.length > 0;
	            this.$el.toggleClass('searchEntered', searchTxtExists);
	
	            if (!this.searchUI.get('grepMode')) {
	                this.$domToHighlight
	                    .unhighlight()
	                    .highlight(searchText);
	                this.searchUI.set({searchText: searchText}); //perf boost w/out bbmodel change?
	                this.keyUp && this.keyUp(searchText); //this will ensure state is up to date; in case there is no activeHitHighlightCallback
	
	            } else {
	                this.searchUI.set({searchText: searchText}, {silent: true});
	                this.onAfterKeyUpInGrepMode && this.onAfterKeyUpInGrepMode(searchText);
	            }
	
	        } else {
	            this.keyUp && this.keyUp(searchText);
	        }
	
	    },
	    expand: function() {
	        this.ui.searchBar.css('width', '100%');
	        this.$el.addClass('open');
	    },
	    collapse: function() {
	
	        if (this.includeNAV) {
	
	            this.searchUI.set('searchText', '', {silent: true}); //ENSURE THE TEXT IS CLEARED! (if not, could be incorrect onContentReset [from ES grep mode])
	            this.includeGrep && this.searchUI.set('grepMode', false);
	
	        } 
	
	        var $searchBar = this.ui.searchBar,
	            self = this;
	
	        this.$el.removeClass('open searchEntered');
	        this.ui.searchBar.off('keyup');
	
	        //clear the value and do b/f selection of active hit; 
	        //val changes the window selection and thus breaks the functionality when this is entered through pressing escape
	        //(unsure why clicking has no impact ... presumably due to timers ... )
	        $searchBar.val('');
	
	        if (this.includeNAV) {
	
	             //place indicator on the active hit to know to select, b/c unhighlight will remove span from DOM 
	              var $activeHit = this.searchUI.getActiveHit(),
	                    activeHitExists = $activeHit.length > 0;
	
	                if (activeHitExists) $activeHit.wrap($('<span class="ftTemp">'));
	
	
	                this.$domToHighlight.unhighlight();
	
	                if (activeHitExists) {
	
	                    var $temp = this.$domToHighlight.find('.ftTemp').selectAll();
	
	                    setTimeout(function() {
	                        //replace temp with just the text(and remove highlight)
	                        //check first in case content was replaced
	                        try {
	                            $temp.length > 0 && ( $temp[0].outerHTML = $temp.text() );
	                        } catch(e) {
	                            $.noop();
	                        }
	
	                    }, 3000);
	                }
	
	          }
	
	        this.preCollapse && this.preCollapse( this.ui.searchBar.val() );
	 
	        $searchBar
	            .css('width', this.originalWidth)
	            .on('focus', _.bind(self.expand, self))
	            .blur();
	    },
	    collapseIfAllowed: function() { //called except for force event
	        this.allowCollapse && this.collapse();
	    },
	    onToggleCollapseAbility: function() {
	        this.allowCollapse = !this.allowCollapse;
	        return this;
	    },
	    onForceClose: function() {
	        this.collapse();
	        return this;
	    },
	
	    onToggleEnabled: function(turnOn) {
	
	        turnOn
	            ? this.ui.searchBar.removeAttr('disabled')
	            : this.ui.searchBar.attr('disabled', 'disabled');
	
	        return this;
	
	    },
	
	    activeHitChangeCB: function($activeHit) {
	       //(only for those tracking hits -- todo: sep out, extended the base
	        if (this.includeNAV) {
	            
	            var searchUI = this.searchUI,
	                $hits = this.$domToHighlight.find('.highlight'), //gets the new highlights
	                activeHitExists = $activeHit.length > 0;
	
	            this.ui.totalHits.text( searchUI.get('numHits') );
	            this.ui.currentHit.text( activeHitExists ? searchUI.get('activeHitIndex') + 1 : 0 );
	
	            if (activeHitExists) {
	                var $prevHit = $hits.eq(searchUI.previous('activeHitIndex'));
	                ($prevHit.length > 0 && $prevHit !== $activeHit) && $prevHit.removeClass('sbActive');
	                $activeHit.addClass('sbActive');
	            }
	            this.onAfterHighlightActiveHit && this.onAfterHighlightActiveHit($activeHit);
	            
	        }
	    },
	    onGrepBtnMouseDown: function(e) {
	        e.preventDefault();   //prevent search bar from losing focus
	        this.searchUI.toggleGrepMode();
	    },
	    goToNextHit: function(e) {
	        e.preventDefault(); //prevent search bar from losing focus
	        this.searchUI.goToNextOrPrevHit('next');
	    },
	    goToPrevHit: function(e) {
	        e.preventDefault();  //prevent search bar from losing focus
	        this.searchUI.goToNextOrPrevHit('previous');
	    },
	    onBeforeGrep: function() {
	        //TODO:
	    },
	    //(will also highlight the active hit (if exists)
	    onContentReset: function($searchContainer, highlightHitIndex) {
	
	        this.$domToHighlight = $searchContainer;
	        this.searchUI.$domElementsToSearch = $searchContainer; //(the state isn't destroyed in between)
	        this.searchUI._wireEvents();
	
	        var txt = this.searchUI.get('searchText');
	
	        this.$domToHighlight.highlight(txt);
	
	        this.searchUI.resetFromContentChange();
	
	        //if from click of highlight (exiting) -- change the active hit to go to the one clicked
	        //DVBC-1284: latter predicate b/c it can be 0 if its the first hit!
	        (highlightHitIndex || highlightHitIndex === 0) && this.searchUI.set('activeHitIndex', highlightHitIndex, {silent: true});
	
	        //(this will go to the active hit)
	        this.searchUI.set('searchText', '', {silent: true});
	        this.searchUI.set('searchText', txt);
	
	        //(if coming back from click of local hit)
	        //DVBC-1284: latter predicate b/c it can be 0 if its the first hit!
	        if (highlightHitIndex || highlightHitIndex === 0) {
	            //(for a trigger to turn off)
	            this.searchUI.set('grepMode', null, {silent: true});
	            this.searchUI.set('grepMode', false, {fromHitHighlight: true});
	            this.ui.searchBar.focus(); //leave focus on the input field
	        }
	    },
	
	    onSetSearchText: function(txt) {
	       //i think this is all needed, event with grep, etc
	        // do nothing if its the same txt that currently exists
	        if (txt === this.searchUI.get('searchText')) return;
	         //reset hit index in case wasn't on the first -- the first hit (if any exist, should be the active)
	        this.searchUI.set({activeHitIndex: 0}, {silent: true}); 
	        this.ui.searchBar.val(txt);
	        this._setSearchTxt(txt);
	    },
	
	    grepModeToggled: function(m, mode, options) {
	        this.ui.grepBtn
	          .toggleClass('active', mode)
	          .attr('title', mode ? 'Show all lines' : 'Only show lines with hits');
	
	        !options.fromHitHighlight && !options.fromRender &&
	            this.onToggleGrep && this.onToggleGrep( mode, this.searchUI.get('searchText') );
	    },
	    onBeforeDestroy: function() {
	        this.ui.searchBar.off();
	        this.searchUI && this.searchUI.destroy(); //todo -- would be part of extended view
	        this.$domToHighlight && this.$domToHighlight.remove();
	    }
	});
	
	
	//TODO: common $fn for hit nav. see search results full text
	var SearchHitsUIModel = Backbone.Model.extend({
	    $domElementsToSearch: null, //all a jquery object -- don't make a prop for mem cleanup (WAS BIGGEST BOTTLENECK IN MEM LEAK DELETED ES PAGE VIEW
	    defaults: {
	        numHits: 0,
	        searchText: '',
	        activeHitIndex: 0, //!don't use -1; start highlighting at the first hit
	        highlightSelector: '.highlight',
	        grepMode: false
	    },
	    initialize: function(attrs, options) {
	        this.$domElementsToSearch = options.$domElementsToSearch;
	        this._wireEvents();
	    },
	    toggleGrepMode: function(force) {
	        this.set('grepMode', !this.get('grepMode'));
	    },
	    resetFromContentChange: function() {
	        this.set({
	            numHits: 0,
	            searchText: ''
	           // DON'T RESET THIS activeHitIndex, if one was activated, reactivate (and scroll to it)
	        }, {silent: true});
	    },
	    _wireEvents: function() {
	        this.listenTo(this, 'change:searchText', this.textSearchChange);
	    },
	    textSearchChange: function(me, text) {
	        
	        var $hits = this.$getHits(),
	            $activeHit = $hits.eq(this.get('activeHitIndex'));
	        
	        this.set({
	            searchText: text,
	            numHits: $hits.length,
	            activeHitIndex: $activeHit.length > 0 ? $hits.index($activeHit) : 0 //use 0, not minus one
	        });
	        this.trigger('changeHit', $activeHit);
	    },
	    $getHits: function() {
	        return this.$domElementsToSearch.find( this.get('highlightSelector') );
	    },
	    getActiveHit: function() {
	      return this.$getHits().eq( this.get('activeHitIndex') );
	
	    },
	    goToNextOrPrevHit: function(nextOrPrevious) {
	        var goNext = nextOrPrevious === 'next';
	        if ( this.get('activeHitIndex') === ( goNext ? this.get('numHits') - 1 : 0 ) )  return;
	        var $hits = this.$getHits(),
	            curIndex = this.get('activeHitIndex'),
	            $goToHit = $hits.eq( curIndex + (goNext ? 1 : -1) );
	        this.set({ activeHitIndex: curIndex + (goNext ? 1 : -1) });
	        this.trigger('changeHit', $goToHit);
	    },
	    destroy: function() {
	        if (this.$domElementsToSearch) {
	            this.$domElementsToSearch.remove();
	            this.$domElementsToSearch = null;
	        }
	        this.stopListening();
	    }
	});
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 498 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "style=\"width:100%;\"";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "    <div class=\"sbNAV hide\">\n        <div class=\"sbHitNumWr\">\n            <span class=\"currentHit\">0</span>\n            <span> of </span>\n            <span class=\"totalHits\">0</span>\n        </div>\n        <div class=\"sbHitBtnWr\">\n            <span class=\"sbPrev icon-up-circled\" title=\"Previous\"></span>\n            <span class=\"sbNext icon-down-circled\" title=\"Next\"></span>\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.includeGrep : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "            <div class=\"sbHitBtnWr\">\n                <span class=\"sbToggleGrep icon-filter\" title=\"Only show lines with hits\"></span>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<span class=\"search-icon\">\n    <i class=\"icon-search\"></i>\n</span>\n<input class=\"sb-input\" type=\"text\" tabindex=\"-1\" placeholder=\""
	    + alias4(((helper = (helper = helpers.placeHolder || (depth0 != null ? depth0.placeHolder : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"placeHolder","hash":{},"data":data}) : helper)))
	    + "\" value=\""
	    + alias4(((helper = (helper = helpers.initialSearchTxt || (depth0 != null ? depth0.initialSearchTxt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"initialSearchTxt","hash":{},"data":data}) : helper)))
	    + "\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.stretchToContainer : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n <span class=\"search-cancel hide\" title=\"Cancel\">\n    <i class=\"icon-cancel-circled-1\"></i>\n</span>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeNAV : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(501);
	
	var ShapeToolbarView = __webpack_require__(502);
	
	module.exports = ShapeToolbarView.extend({
	    template: __webpack_require__(505),
	    id: 'redactTypeTB',
	    ui: _.extend({}, ShapeToolbarView.prototype.ui, {
	        polyRedactBtn: '#polyRedactBtn'
	    }),
	    render: function() {
	        ShapeToolbarView.prototype.render.call(this);
	        this.options.pageIsCold && this.ui.polyRedactBtn.addClass('hide'); //don't allow poly redactions for cold pages
	        return this;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 501 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(503);
	
	var Toolbar = __webpack_require__(504);
	
	
	module.exports = Toolbar.extend({
	
	    initialize: function(options) {
	
	        this.note = options.note;
	
	        var lCh = this.options.channel;
	        lCh.comply(this.commands, this);
	
	        return Toolbar.prototype.initialize.call(this, options);
	    },
	
	    commands: {
	        updateShapeToolbarBtn: function(noteSubType) {
	            this.setActiveButton(noteSubType);
	        }
	    },
	
	    onRender: function() {
	
	        Toolbar.prototype.onRender.call(this);
	        this.setActiveButton( this._getTypeShapeTypeToSetOnRender() );
	
	    },
	
	    /**
	     * Prior to implementation of remembering the last graphic note shape type, the default
	     * for both redactions and graphic notes was the note's defaultSubType.
	     * Leave this as the default with the option to override.
	     */
	    _getTypeShapeTypeToSetOnRender: function() {
	        return this.note.getDefaultShapeSubType();
	    },
	
	    setActiveButton: function(dataAttrVal) {
	        Toolbar.prototype.setActiveButton.call(this, dataAttrVal);
	        this.options.channel.trigger('notes:setNoteSubType', this.activeItem);
	    }
	});

/***/ },
/* 503 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, $) {var Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
	
	    onRender: Backbone.View.prototype.unwrap,
	
	    initialize: function(options) {
	        this.parent = options.parent;
	        this.activeItem = null;
	        this.id = null;
	    },
	
	    ui: {
	        tbBtn: '.tb-btn'
	    },
	
	    events: {
	        'click @ui.tbBtn' : function(e) {
	
	            var $el = $(e.currentTarget),
	                activeItem = $el.data('item');
	
	            if ($el.hasClass('tb-ignore'))
	                return; //ignore but allow to propagate.
	
	            this.setActiveButton(activeItem);
	        }
	    },
	
	    setActiveButton: function(dataAttrVal) {
	
	        this.$('[data-item]').removeClass('active');
	        this.$('[data-item="' + dataAttrVal + '"]').addClass('active');
	        this.activeItem = dataAttrVal;
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(59)))

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"redactTypeTB\" class=\"FV-toolbar FV-noteShapeTB\">\n    <button id=\"rectRedactBtn\" class=\"tb-btn\" data-item=\"rect\" title=\"Rectangle\">\n        <i class=\"icm-frame\"></i>\n    </button>\n    <button id=\"polyRedactBtn\" class=\"tb-btn\" data-item=\"poly\" title=\"Polygon\">\n        <i class=\"icm-polygon\"></i>\n    </button>\n</div>";
	},"useData":true});

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Marionette) {__webpack_require__(507);
	
	var Backbone = __webpack_require__(58),
	    GraphicNoteToolbarState = __webpack_require__(508),
	    ShapeToolbar = __webpack_require__(502),
	    ColorSelector = __webpack_require__(509),
	    StrokeWidthSelector = __webpack_require__(512),
	    BabySitterView = __webpack_require__(489),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	/*
	*
	* TODO: separate out into 2 ways, one with a wrapper for the dropdowns and the toolbar
	*
	* */
	
	module.exports = ShapeToolbar.extend({
	
	    template: __webpack_require__(515),
	
	    id: 'graphicNoteTB',
	
	    ui: _.extend( ShapeToolbar.prototype.ui, {
	        strokeWidthDDBtn: '#strokeWidth',
	        colorPickerDDBtn: '#colorPicker'
	    }),
	
	    initialize: function(options) {
	
	        BabySitterView.prototype.createChildren.call(this);
	        ShapeToolbar.prototype.initialize.call(this, options);
	
	        this.state = new GraphicNoteToolbarState();
	
	        this.channel = options.channel; //listened to by children
	        this.channel.reply(this.requests, this);
	
	        Marionette.bindEntityEvents(this, this.channel, this.channelEvents);
	
	        this.listenTo( this.note, 'colorPicker:toggleEnabled', this.colorPickerToggleEnabled );
	
	    },
	    requests: {
	
	        // Note: this now returns the entire state, which includes the select shape type
	        drawingAttrs: function() {
	            return this.state.toJSON();
	        }
	
	    },
	    channelEvents: {
	        'colorPicker:setColor':         'setColor',
	        'strokeView:setWidth':          'setStrokeWidth'
	    },
	    onRender: function() {
	
	        ShapeToolbar.prototype.onRender.apply(this, arguments); // may need to
	
	        var $ddContainer = this.channel.request('vChannel').request('getWrapper');
	
	        this.children
	            .add( new StrokeWidthSelector({
	                channel: this.channel,
	                el: this.ui.strokeWidthDDBtn,
	                ddOptions: {
	                    hPos: 'right',
	                    isSelect: true,
	                    selectNoOpenerText: true,
	                    defaultWidth: this.state.get('stroke-width'),
	                    container: $ddContainer
	                }
	            }), 'strokeWidthSelector')
	
	            /* TODO: complicated to convert to dd wrapper now: do later when change from Raphael anyway */
	
	            .add( new ColorSelector({
	                parent: this,
	                channel: this.channel,
	                el: this.ui.colorPickerDDBtn,
	                color:  this.state.get('color'),
	                container: $ddContainer
	            }), 'colorSelector')
	
	            .call('render');
	
	            this.colorPickerToggleEnabled( );
	
	    },
	
	    /**
	     * Override to get from the state, not necessarily the default type of the note.
	     */
	    _getTypeShapeTypeToSetOnRender: function() {
	        return this.state.get('shapeType');
	    },
	
	    setActiveButton: function( shapeType ) {
	
	        ShapeToolbar.prototype.setActiveButton.apply( this, arguments );
	        this.state.setShapeType( shapeType );
	
	    },
	
	    setColor: function(color) {
	
	        this.state.setColor( color );
	
	        // TODO: rid and just pass off sandbox instance when get rid of 'outer mediator' (and forward)
	        this.channel.trigger('notes:setDrawColor', color);
	    },
	    setStrokeWidth: function(width) {
	
	        this.state.setStrokeWidth(width);
	
	        //TODO: rid and just pass off sandbox instance when get rid of 'outer mediator'
	        this.channel.trigger('notes:setDrawStrokeWidth', width);
	    },
	
	    colorPickerToggleEnabled: function( ) {
	
	        this.children.findByCustom( 'colorSelector' ).toggleDisabled( this.note.disableColorPickerDueToColorRules( ) );
	
	    },
	
	
	    destroy: function() {
	
	        BabySitterView.prototype.destroy.apply(this, arguments);
	
	    }
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(61)))

/***/ },
/* 507 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    GraphicNoteModel = __webpack_require__(291);
	
	/*
	* Backbone Model housing current the color, strokeWidth, and shapeType used when user is drawing graphic notes.
	* A new one is created each time a graphic note enters 'edit' mode from the graphic note toolbar.
	* Referenced from Canvas Module when applying properties to shapes (color and strokeWidth).
	* Encapsulates all interaction with localStorage for clarity.
	* Default values define the properties used on newly drawn graphic note shapes.
	* GraphicNoteModel referenced here for clarity to show where the default values are defined.
	* ( Alternative would be to pass in from the activeNote instance from the caller -- this could prove
	*   more beneficial if different defaults are ever employed at the subType level or if any other note types
	*   ever require a toolbar selector view. )
	* */
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: function() {
	
	        var localStorage = fvChannel.request('localStorage'),
	            lastColor = localStorage.getLastGraphicNoteShapeColor(),
	            lastStrokeWidth = localStorage.getLastGraphicNoteShapeLineWidth(),
	            lastShapeType = localStorage.getLastGraphicNoteShape();
	
	        return {
	
	            color: lastColor
	                ? lastColor
	                : GraphicNoteModel.prototype.getDefaultShapeColor(),
	
	            'stroke-width': lastStrokeWidth
	                ? lastStrokeWidth
	                :  GraphicNoteModel.prototype.getDefaultStrokeWidth(),
	
	            shapeType: lastShapeType
	                ? lastShapeType
	                : GraphicNoteModel.prototype.getDefaultShapeSubType()
	
	        };
	
	    },
	
	    setColor: function( color ) {
	
	        this.set('color', color);
	        fvChannel.request('localStorage').setLastGraphicNoteShapeColor( color );
	
	    },
	
	    setStrokeWidth: function( width ) {
	
	        this.set('stroke-width', width);
	        fvChannel.request('localStorage').setLastGraphicNoteShapeLineWidth( width );
	
	    },
	
	    setShapeType: function( shapeType ) {
	
	        this.set('shapeType', shapeType );
	        fvChannel.request('localStorage').setLastGraphicNoteShape( shapeType );
	    }
	
	});

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Raphael) {//  This should be on dropdown content view, prob want something simpler anyway
	
	__webpack_require__(510);
	
	var Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    DropDown = __webpack_require__(432),
	    Util = __webpack_require__(48);
	
	
	__webpack_require__(511);
	
	
	module.exports = Backbone.View.extend({
	
	    HEIGHT: 150,
	    WIDTH: 150,
	
	    initialize: function (options) {
	
	        this.isOpen = 0;
	
	        this.colorPicker =  null;
	
	        this.parent = options.parent;
	
	        //TODO: the note controller will not yet exist: (create prior to the toolbar)
	        this.color = options.color;
	
	        this.setElement( options.el );
	
	        this.originalElTitleAttr = this.$el.attr('title');
	        
	        this.icn = this.$('i');
	
	    },
	
	    render: function() {
	
	        var $cpDD = this.parent.$('#cp-dd')
	            .css({
	                width: this.WIDTH + 5,
	                height: this.HEIGHT + 20 //(extra height for bottom slider)
	            });
	
	        this.updateOpenerDisplay( this.color );
	
	        this.dropdown = new DropDown({ //! position (x, y must be set for the plugin to calc angles if put in container)
	            parent: this,
	            el: this.$el,
	            ddOptions: {
	                container: this.options.container,
	                $content: $cpDD,
	                hPos: 'right',
	                onOpen: _.bind(function(hexColor) {
	
	                    this.openCP(hexColor, $cpDD);
	
	                }, this),
	
	                onClose: _.bind( this.closeCP, this )
	            }
	        }).render();
	
	    },
	
	    /**
	     * Now using its on onchange plugin
	     * (starts open -- temp )
	     *  note: <i> is dynamic, use the selector
	     */
	    openCP: function( hexColor, $cpDD ) {
	
	        this.isOpen = 1;
	
	        this.updateOpenerDisplay( this.color );
	        
	        var cpOffset = $cpDD.offset(),
	            cp = this.colorPicker =
	                Raphael.colorpicker( cpOffset.left, cpOffset.top, this.WIDTH, this.color, $cpDD[0] );
	
	        /**
	         * PATCH 712 -- ISSUE W/VERSION 2.1.4 -- prevent from circle disappearing
	         * somewhere inside source set to fill opacity set to 1 on this node, which makes invisible
	         * Note: not an issue with VML
	         */
	
	        $(cp.raphael.canvas)
	            .find('circle').eq(0)
	            .css('fill-opacity', 0);
	
	        cp.onchange = _.bind( function(hexColor) {
	
	            this.color = hexColor;
	
	            this.parent.channel.trigger( 'colorPicker:setColor', hexColor );
	
	            this.updateOpenerDisplay( this.color );
	
	
	        }, this);
	
	    },
	
	
	    // For now must defer so other close triggers don't affect this one
	    closeCP: function() {
	
	        var self = this;
	
	        setTimeout( function () {
	
	            self.isOpen = 0;
	
	            if (self.colorPicker) {  // The active dialog being closed (?)
	                
	                self.colorPicker.remove(); // Cleaning up correctly?
	                self.colorPicker = null;  // there is a small memory leak ... no destroy implemented?
	                
	                self.updateOpenerDisplay();
	
	            }
	
	        }, 10);
	    },
	
	    updateOpenerDisplay: function( color ) {
	
	        var color = color || this.color;
	
	        this.$el.css({ background: color });
	
	        this.icn.removeClass('arrowDown arrowUp'); // don't always need (eg when just change color )
	        this.icn.removeAttr('style'); // border-bottom,  border top
	
	        if ( this.isOpen ) {
	
	            this.icn
	                .addClass('arrowUp')
	                .css('border-bottom-color', Util.getContrastYIQ(color) );
	
	        } else {
	
	            this.icn
	                .addClass('arrowDown')
	                .css( 'border-top-color', Util.getContrastYIQ(color) );
	
	        }
	
	    },
	
	    /**
	     * Toggle disabled and set a tooltip reason for why disabled.
	     * disabledReason: if null, enable,
	     * otherwise its a string containing the reason(s) to for the tooltip
	     * to provide some level of clarity.
	     */
	    toggleDisabled: function( disabledReason ) {
	
	        var disable = disabledReason !== null;
	
	        this.$el.toggleClass( 'disabled', disable );
	
	        var title = this.originalElTitleAttr;
	
	        if ( disable ) {
	            title += ' (disabled):\n' + disabledReason;
	        }
	
	        this.$el.attr( 'title', title );
	
	    }
	    
	    //TODO: destroy
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(182)))

/***/ },
/* 510 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_Raphael) {/*!
	 * Color Picker 0.1.0 - Raphael plugin
	 *
	 * Copyright (c) 2010 Dmitry Baranovskiy (http://raphaeljs.com)
	 * Based on Color Wheel (http://jweir.github.com/colorwheel) by John Weir (http://famedriver.com)
	 * Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php) license.
	 */
	(function (Raphael) {
	    Raphael.colorpicker = function (x, y, size, initcolor, element) {
	        return new ColorPicker(x, y, size, initcolor, element);
	    };
	    Raphael.fn.colorPickerIcon = function (x, y, r) {
	        var segments = pi * r * 2 / Math.min(r / 8, 4);
	        var a = pi / 2 - pi * 2 / segments * 1.5,
	            path = ["M", x, y - r, "A", r, r, 0, 0, 1, r * Math.cos(a) + x, y - r * Math.sin(a), "L", x, y, "z"].join();
	        for (var i = 0; i < segments; i++) {
	            this.path(path).attr({
	                stroke: "none",
	                fill: "hsb(" + (segments - i) * (255 / segments) / 255 + ", 1, 1)",
	                transform: "r" + [90 + (360 / segments) * i, x, y]
	            });
	        }
	        return this.circle(x, y, r).attr({
	            fill: "r#fff-#fff",
	            "fill-opacity": 0,
	            "stroke-width": Math.round(r * .03),
	            stroke: "#fff"
	        });
	    };
	    var pi = Math.PI;
	    function angle(x, y) {
	        return (x < 0) * 180 + Math.atan(-y / -x) * 180 / pi;
	    }
	    var doc = document, win = window,
	        ColorPicker = function (x, y, size, initcolor, element) {
	            size = size || 200;
	            var w3 = 3 * size / 200,
	                w1 = size / 200,
	                fi = 1.6180339887,
	                size20 = size / 20,
	                size2 = size / 2,
	                padding = 2 * size / 200,
	                height = size + size20 * 2 + padding * 3,
	                t = this,
	                H = 1, S = 1, B = 1, s = size - (size20 * 4),
	                r = element ? Raphael(element, size, height) : Raphael(x, y, size, height),
	                xy = s / 6 + size20 * 2 + padding,
	                wh = s * 2 / 3 - padding * 2;
	            w1 < 1 && (w1 = 1);
	            w3 < 1 && (w3 = 1);
	
	
	            r.colorPickerIcon(size2, size2, size2 - padding);
	
	            t.cursor = r.set();
	            t.cursor.push(r.circle(size2, size2, size20 / 2).attr({
	                stroke: "#000",
	                opacity: .5,
	                "stroke-width": w3
	            }));
	            t.cursor.push(t.cursor[0].clone().attr({
	                stroke: "#fff",
	                opacity: 1,
	                "stroke-width": w1
	            }));
	            t.disc = r.circle(size2, size2, size2 - padding).attr({
	                fill: "#000",
	                "fill-opacity": 0,
	                stroke: "none",
	                cursor: "crosshair"
	            });
	            var style = t.disc.node.style;
	            style.unselectable = "on";
	            style.MozUserSelect =  "none";
	            style.WebkitUserSelect= "none";
	
	            // brightness drawing
	            var h = size20 * 2 + 2;
	            t.brect = r.rect(padding + h / fi / 2, size + padding * 2, size - padding * 2 - h / fi, h - padding * 2).attr({
	                stroke: "#fff",
	                fill: "180-#fff-#000"
	            });
	            t.cursorb = r.set();
	            t.cursorb.push(r.rect(size - padding - h / fi, size + padding, ~~(h / fi), h, w3).attr({
	                stroke: "#000",
	                opacity: .5,
	                "stroke-width": w3
	            }));
	            t.cursorb.push(t.cursorb[0].clone().attr({
	                stroke: "#fff",
	                opacity: 1,
	                "stroke-width": w1
	            }));
	            t.btop = t.brect.clone().attr({
	                stroke: "#000",
	                fill: "#000",
	                opacity: 0
	            });
	            style = t.btop.node.style;
	            style.unselectable = "on";
	            style.MozUserSelect =  "none";
	            style.WebkitUserSelect= "none";
	
	            t.bwidth = ~~(h / fi) / 2;
	            t.minx = padding + t.bwidth;
	            t.maxx = size - h / fi - padding + t.bwidth;
	
	            t.H = t.S = t.B = 1;
	            t.padding = padding;
	            t.raphael = r;
	            t.size2 = size2;
	            t.size20 = size20;
	            t.x = x;
	            t.y = y;
	
	            // events
	            t.disc.drag(function (dx, dy, x, y) {
	                t.docOnMove(dx, dy, x, y);
	            }, function (x, y) {
	                t.hsOnTheMove = true;
	                t.setHS(x - t.x, y - t.y);
	            }, function () {
	                t.hsOnTheMove = false;
	            });
	            t.btop.drag(function (dx, dy, x, y) {
	                t.docOnMove(dx, dy, x, y);
	            }, function (x, y) {
	                t.bOnTheMove = true;
	                t.setB(x - t.x);
	            }, function () {
	                t.bOnTheMove = false;
	            });
	
	            t.color(initcolor || "#fff");
	           
	        };
	    ColorPicker.prototype.setB = function (x) {
	        x < this.minx && (x = this.minx);
	        x > this.maxx && (x = this.maxx);
	        this.cursorb.attr({x: x - this.bwidth});
	        this.B = (x - this.minx) / (this.maxx - this.minx);
	        this.onchange && this.onchange(this.color());
	    };
	    ColorPicker.prototype.setHS = function (x, y) {
	        var X = x - this.size2,
	            Y = y - this.size2,
	            R = this.size2 - this.size20 / 2 - this.padding,
	            d = angle(X, Y),
	            rd = d * pi / 180;
	        isNaN(d) && (d = 0);
	        if (X * X + Y * Y > R * R) {
	            x = R * Math.cos(rd) + this.size2;
	            y = R * Math.sin(rd) + this.size2;
	        }
	        this.cursor.attr({cx: x, cy: y});
	        this.H = (1 - d / 360) % 1;
	        this.S = Math.min((X * X + Y * Y) / R / R, 1);
	        this.brect.attr({fill: "180-hsb(" + [this.H, this.S] + ",1)-#000"});
	        this.onchange && this.onchange(this.color());
	    };
	    ColorPicker.prototype.docOnMove = function (dx, dy, x, y) {
	        if (this.hsOnTheMove) {
	            this.setHS(x - this.x, y - this.y);
	        }
	        if (this.bOnTheMove) {
	            this.setB(x - this.x);
	        }
	    };
	    ColorPicker.prototype.remove = function () {
	        this.raphael.remove();
	        this.color = function () {
	            return false;
	        };
	    };
	    ColorPicker.prototype.color = function (color) {
	        if (color) {
	            color = Raphael.getRGB(color);
	            var hex = color.hex;
	            color = Raphael.rgb2hsb(color.r, color.g, color.b);
	            d = color.h * 360;
	            this.H = color.h;
	            this.S = color.s;
	            this.B = color.b;
	
	            this.cursorb.attr({x: this.B * (this.maxx - this.minx) + this.minx - this.bwidth});
	            this.brect.attr({fill: "180-hsb(" + [this.H, this.S] + ",1)-#000"});
	
	            var d = (1 - this.H) * 360,
	                rd = d * pi / 180,
	                R = (this.size2 - this.size20 / 2 - this.padding) * this.S,
	                x = Math.cos(rd) * R + this.size2,
	                y = Math.sin(rd) * R + this.size2;
	            this.cursor.attr({cx: x, cy: y});
	            return this;
	        } else {
	            return Raphael.hsb2rgb(this.H, this.S, this.B).hex;
	        }
	    };
	})(__webpack_provided_window_dot_Raphael);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(182)))

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(513);
	
	var DropDown = __webpack_require__(432);
	
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(514),
	    onChange: function(text, data) { //note: no text
	        this.options.channel.trigger('strokeView:setWidth', data.sw);
	    },
	    defaultSelector: function() {
	        return '[data-sw="' + this.ddOptions.defaultWidth + '"]';
	    }
	});

/***/ },
/* 513 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"sw-dd-wr\">\n    <div class=\"mi sw-bar\" data-sw=\"1\" title=\"1px\">\n        <div class=\"bar-inner\" style=\"height: 1px\"></div>\n\n    </div>\n    <div class=\"mi sw-bar\" data-sw=\"2\" title=\"2px\">\n        <div class=\"bar-inner\" style=\"height: 2px\"></div>\n\n    </div>\n    <div class=\"mi sw-bar\" data-sw=\"3\" title=\"3px\">\n        <div class=\"bar-inner\" style=\"height: 3px\"></div>\n\n    </div>\n    <div class=\"mi sw-bar\" data-sw=\"4\" title=\"4px\">\n        <div class=\"bar-inner\" style=\"height: 4px\"></div>\n\n    </div>\n    <div class=\"mi sw-bar\" data-sw=\"5\" title=\"5px\">\n        <div class=\"bar-inner\" style=\"height: 5px\"></div>\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"graphicNoteTB\" class=\"FV-toolbar FV-noteShapeTB\">\n\n    <!-- TODO: generate from data : this.note.subTypes -->\n    <button class=\"tb-btn\" data-item=\"free\" title=\"Freehand\">\n        <i class=\"icon-pencil\"></i>\n    </button>\n    <button class=\"tb-btn\" data-item=\"rect-fill\" title=\"Rectangle (Fill)\">\n        <i class=\"icon-stop\"></i>\n    </button>\n    <button class=\"tb-btn tb-rect-nofill\" data-item=\"rect-nofill\" title=\"Rectangle (No Fill)\">\n        <i class=\"icm-rectangle\"></i>\n    </button>\n    <button class=\"tb-btn\" data-item=\"line\" title=\"Line\">\n        <i class=\"icm-line\"></i>\n    </button>\n    <button class=\"tb-btn\" data-item=\"line-dashed\" title=\"Dashed Line\">\n        <i class=\"icon-dot-3\"></i>\n    </button>\n    <button class=\"tb-btn\" data-item=\"line-arrow\" title=\"Arrow\">\n        <i class=\"icon-cursor\"></i>\n    </button>\n    <button class=\"tb-btn\" data-item=\"text\" title=\"Text\">\n        <i class=\"icm-type\"></i>\n    </button>\n\n    <div class=\"draw-options\">\n        <button id=\"colorPicker\" class=\"tb-btn tb-ignore dropdown btn-caret\" title=\"Color\" style=\"display: inline-block; background-image: none; width: auto;\">\n            <i class=\"arrowDown\"></i>\n        </button>\n        <button id=\"strokeWidth\" class=\"tb-btn tb-ignore dropdown\" title=\"Line-Width\">\n            <i class=\"icm-align-justify\"></i>\n        </button>\n    </div>\n\n    <div id=\"cp-dd\" class=\"cp-dd dropdown-menu hide\"></div>\n\n\n</div>\n\n \n\n\n   \n    \n\n\n";
	},"useData":true});

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function($) {
	
	    $.fn.toggleButton = function(options) {
	        var el = this,
	            defaults = {
	                activeClass: 'active',
	                toggleAction: $.noop,
	                isActive: false,
	                activeTitle: 'Turn Off',
	                inactiveTitle: 'Turn On'
	            },
	            settings = $.extend(defaults, options);
	
	        settings.isActive &&
	            this.addClass(settings.activeClass);
	
	        this.attr('title', settings.isActive
	            ? settings.activeTitle
	            : settings.inactiveTitle
	        );
	
	        this.on('click', doToggle);
	
	        // Programatic way to trigger the toggle
	        this.on('toggle', doToggle);
	
	        /* untoggles without calling the toggle action */
	        this.on('toggleOff', function() {
	            $(this)
	                .removeClass( settings.activeClass )
	                .attr('title', settings.inactiveTitle);
	        });
	
	        /* toggles on without calling the default action */
	        this.on('toggleOn', function() {
	            $(this)
	                .addClass( settings.activeClass )
	                .attr('title', settings.activeTitle);
	        });
	
	        function doToggle() {
	            el.toggleClass(settings.activeClass);
	            toggleTitle();
	            settings.toggleAction();
	        }
	
	        function toggleTitle() {
	
	            el.attr( 'title', el.attr('title') === settings.activeTitle
	                ? settings.inactiveTitle
	                : settings.activeTitle
	            );
	
	            return el;
	        }
	
	        this.destroy = function() {
	            el.remove();
	        };
	
	        return this;
	
	    };
	
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"sp-head-wr\">\n\n    <div data-searchWidget=\"true\"></div>\n\n    <div class=\"nonSearch\">\n\n        <div id=\"modeWr\">\n\n            <button id=\"add-pg-note\" type=\"button\"  class=\"btn-note-header btn btn-mini btn-hvr dropdown\" title=\"Create\" tabindex=\"-1\">\n                <i class=\"icon-plus-1 dd-btn-icon\"></i>\n            </button>\n\n            <div class=\"createEditWr\">\n                <div id=\"createNoteInd\">\n                    <i class=\"icon-plus-1\"></i>\n                    <div class=\"note-icon-wr\">\n                        <i class=\"note-type-icn\"></i>\n                    </div>\n                </div>\n\n                <div id=\"editNoteInd\" class=\"\">\n                    <i class=\"icon-edit-2\"></i>\n                    <div class=\"note-icon-wr\">\n                         <i class=\"note-type-icn \"></i>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n\n        <div id=\"pgHeadActionBtns\">\n\n            <button type=\"button\" class=\"filter btn-note-header btn btn-mini btn-hvr dropdown \" title=\"Filter\" tabindex=\"-1\">\n                <i class=\"icm-filter dd-btn-icon\"></i>\n                <i id=\"active-filter-indicator\" class=\"icon-ok-circled-1\"></i>\n            </button>\n\n            <button type=\"button\" class=\"sort btn-note-header btn btn-mini btn-hvr dropdown\" title=\"Sort By\" tabindex=\"-1\">\n                <i class=\"icon-sort-alt-down dd-btn-icon\"></i>\n            </button>\n\n            <button type=\"button\" class=\"btn btn-note-header btn-mini btn-hvr sort-dir\" tabindex=\"-1\">\n                <i class=\"icon-sort-up dd-btn-icon\"></i>\n                <i class=\"icon-sort-down dd-btn-icon\"></i>\n            </button>\n\n            <button type=\"button\" id=\"toggle-preview-redactions\"\n                    class=\"btn btn-note-header btn-mini btn-hvr\"\n                    tabindex=\"-1\">\n                <i class=\"icon-doc-text-inv\"></i>\n                <i class=\"icon-eye\"></i>\n            </button>\n\n\n       </div>\n\n    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49);
	
	
	
	module.exports = Marionette.CollectionView.extend({
	    id: 'notesCollection',
	    childViewEventPrefix: 'noteView', // This is for event forward, not catching on 'child events'
	    initialize: function() {
	
	        _.bindAll(this, 'scrollToNote', 'toggleNoteHighlight', 'toggleUserIsDrawing');
	
	        // Flag to capture mouse hover events in the child views:
	        // See DVBC-1701 and comment in new note menu
	        this.captureChildHoverEvents = true;
	
	        /**
	         * Forward events to local notes channel.
	         * Could also use Backbone.fwd
	         */
	        var ch = this.options.channel;
	        this.listenTo(this, 'all', function() {
	            ch.trigger.apply(ch, arguments);
	        });
	
	        ch.reply(this.requests, this);
	        ch.comply(this.commands, this);
	
	        Marionette.bindEntityEvents(this, ch, this.subs);
	
	    },
	    getChildView: function(note) {
	        return note.ViewConstructor;
	    },
	    childViewOptions: function() {
	        return {
	          channel: this.options.channel
	        };
	    },
	    subs: {
	        'notes:hoveredCanvasNoteChange':    'toggleNoteHighlight',
	        'notes:canvasDrawingToggled':       'toggleUserIsDrawing',
	        'noteViews:toggleEventListeners':   'toggleEventsListeners',
	        'notes:disableNoteViewHoverEvents': 'disableNoteViewHoverEvents',
	        'notes:enableNoteViewHoverEvents':  'enableNoteViewHoverEvents'
	    },
	    toggleEventsListeners: function(isOn) {
	        this.children.call((isOn ? 'undelegate' : 'delegate') + 'Events');
	    },
	    commands: {
	        filterNoteViews: function(noteFilterModel) {
	            this.children.call('toggleFiltered', noteFilterModel);
	        }
	    },
	    requests: {
	        getNoteViewFromModel: function(model) {
	            return this.children.findByModel(model);
	        }
	    },
	    onShow: function() {
	        this.scrollTop(0); //must be in dom for IE8
	    },    
	    scrollTop: function(y) {
	        this.$el.scrollTop(y);
	    },
	    scrollToNote: function(note) {
	        var $scroll = this.$el.closest('.sp-body'),//todo: should be this -- but changed class to noteCollection, not what scrolls ... or this.$el.parent ...
	            noteView = this.children.findByModel(note),
	            st = $scroll.scrollTop(),
	            elT = noteView.$el.position().top,
	            nt = st + elT,
	            dt = (nt > st) ?  elT + st : elT - st,
	            self = this;
	        dt -= 1; //for the 'active border'
	        this.isScrolling && $scroll.stop();  /* stop current animations if changed during (shape hover) */
	        $scroll.animate({'scrollTop' : dt}, {
	            duration: 350,
	            easing: 'swing',
	            start: function() {
	                self.isScrolling = true;
	            },
	            complete:function() {
	                delete self.isScrolling;
	            }
	        });
	    },
	    toggleNoteHighlight: function(note, isEntering) { //(comes from canvas highlighted notes, via FV)
	        var view = this.children.findByModel(note);
	        isEntering && this.scrollToNote(note);
	        view.toggleNoteHighlight(isEntering); 
	    },
	    toggleUserIsDrawing: function(isDrawing, note) { //(from canvas drawing toggle)
	        var view = this.children.findByModel(note);
	        view.toggleKeyEvents( isDrawing );
	    },
	
	    disableNoteViewHoverEvents: function() {
	        this.captureChildHoverEvents = false;
	    },
	
	    enableNoteViewHoverEvents: function() {
	        this.captureChildHoverEvents = true;
	    },
	
	    onNoteViewEnterMouseHover: function(view) {
	
	        view.$el.addClass('hovered');
	
	        // See DVBC-1701 and comment in new note menu
	        if (!this.captureChildHoverEvents) {
	            return;
	        }
	
	        if ( view.model.isDrawable() )
	            this.options.channel.trigger('notes:toggleShapeHighlight', view.model, {isEntering: true } );
	
	    },
	
	    onNoteViewExitMouseHover: function(view) {
	
	        view.$el.removeClass('hovered');
	        if ( view.model.isDrawable() )
	            this.options.channel.trigger('notes:toggleShapeHighlight', view.model, {isEntering: false } );
	
	
	    },
	
	
	    /**
	     * Note: called on page change.
	     */
	    setNoteViewsNavigability: function(activeNote, pg) {
	
	        var pgNum = pg.get('number'),
	            activeNoteIsPgTextAndNew =
	                activeNote && activeNote.isPageTextNote() && activeNote.isNew();  //(active note can be null; && exists)
	
	        // Change Page # For New Page Text Note (while creating & on page change)
	
	        if ( activeNoteIsPgTextAndNew ) {
	
	            activeNote.uiModel.set({
	                viewerPgNumber: pgNum, //a) set pg number
	                navigationEnabled: false //b turn of nav ability
	            });
	
	            // DVBC-1764: update the pageId and pageNumber of the actual model so its saved,
	            // the way it's reflected in the UI ... could be done higher up but only would
	            // occur for this notetype so not a big deal.
	            // Could also set these on save from the current page in the viewer.
	            // May want silent update of pageNumber and id function on the model if used elsewhere
	            activeNote.pageNumber = pgNum;
	            activeNote.set( { pageId: pg.get('pageId')}, {silent:true} );
	
	        }
	
	        // Reset navigation ability
	        this.collection.each( function(note) {
	
	            if ( !activeNoteIsPgTextAndNew && note !== activeNote) {
	                // set navigation enabled to val of: currentPgNumber != active notePage number (active note can be false)
	                note.uiModel.set('navigationEnabled', pgNum !== note.pageNumber );
	            }
	        });
	        
	    },
	
	    enterPDFMode: function() {
	
	        this.collection.each(function(note) {
	            note.uiModel.set({
	                navigationEnabled: false, // disallow pg note navigation
	                isEditable: !note.isDrawable() // disallow editing of note
	            });
	        });
	
	    },
	    // TODO: do only if last mode was; not big deal ...
	    exitPDFMode: function( options ) {
	        this.collection.each(function(note) {
	            note.uiModel.set({
	                navigationEnabled: true,
	                isEditable: true //can be set to the page
	            });
	       });
	        options.pagesExist && this.setNoteViewsNavigability( options.activeNote , options.currentPage ); // overwrite ... works but could clean
	    },
	    /**
	     * This has repercussions -- adding and removal aren't silent.
	     * Note: non silent add/removes alter the FV.allNotes collection.
	     * ( From toggle active note )
	     */
	    updateActiveNoteViewPostNoteChange: function(actionOpts, isEntering) {
	
	        var note = actionOpts.note,
	            prNote = actionOpts.prNote;
	
	        switch (actionOpts.action) {
	            case 'createNew':
	                this.collection.add(note, {
	                    sort: true,
	                    at: 0
	                });
	                break;
	            case 'enterEditExisting':
	                break;
	            case 'isReadingFlashNote':
	                this.options.channel.trigger('notes:updateLastFlashPrId', note); /* call on open, not destroy for flashbacks */
	                break;
	            case 'newCancelled':
	            case 'cancelNewFromPageOrViewChange':
	                this.collection.remove(prNote); //allow event
	                break;
	            case 'flashNoteDestructed':
	                this.collection.remove(prNote); //allow event
	                break;
	            case 'saveNew':
	            case 'editExisting': //FIXES THE ISSUE OF MODIFYING -- IN THAT CASE LOGIC CURRENTLY BREAKS IN REMOVE AND ADD TO COLLECTION
	            case 'editCancelled': //NOTE STAYS OPEN AND SHAPES DOUBLE DRAWN ON CANVAS
	            case 'editSavedButNoChanges':
	            case 'cancelEditFromPageOrViewChange':
	            //fixes issues --- but should prob go through the workflow with double setting of the active note -- (which would overlap)
	                view = this.children.findByModel(prNote);
	                view.destroy(); //don't call add event !
	                this.render();
	                break;
	        }
	
	        isEntering && this.turnOnNoteEditMode(note);
	        isEntering && actionOpts.isNew && this.scrollToNote(note);
	        !isEntering && this.turnOffEditModeForAllNotes(actionOpts);
	
	    },
	    turnOnNoteEditMode: function(note, opts) {
	        var nonActiveNotes = new Backbone.Collection(this.collection.without(note));
	        nonActiveNotes.each(function(note) {
	            note.uiModel.setEditMode(false, opts);
	        });
	        note.uiModel.setEditMode(true, opts);
	    },
	    turnOffEditModeForAllNotes: function(opts) {
	        _.invoke( this._getUIModelsOfCollection() , 'setEditMode', false, opts);
	    },
	    _getUIModelsOfCollection: function() {
	        return this.collection.map(function (note) {
	            return note.uiModel;
	        });
	    }
	
	    /**
	     * Old comments:
	     * - can't overrite on add/remove here, the event already raised to FV.allNotes -- don't trigger on it -- b/c first, FV.allNotes is updated
	     * - clone a collection?
	     * - separate events to control workflow
	     * - don't have them removed on canvas if an option in here exists?
	     */
	
	});

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<!--Note: only used in NotesLayout for now-->\n\n<div id=\""
	    + container.escapeExpression(((helper = (helper = helpers.paneId || (depth0 != null ? depth0.paneId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paneId","hash":{},"data":data}) : helper)))
	    + "\" class=\"sub-side-content no-padding\">\n    <div class=\"spWr\">\n        <div class=\"sp-header\"></div>\n        <div class=\"sp-body\"></div>\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    Filter = __webpack_require__(272),
	    Sort = __webpack_require__(521);
	
	var instVars = {
	    filterState: null,
	    sortState: null,
	    channel: null
	};
	
	
	/*
	* For some data storage in the module (for when mode transitions)
	* */
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        activeNote: null,
	        expandedNote: null,
	        viewMode: '', //(now not used)
	        lastOpenedFlashNotePrvGroupId: null
	    },
	    initialize: function(options) {
	
	        _.extend( this, instVars, {
	            filterState: new Filter({
	                hideActivityNotes: options.hideActivityNotes
	            }),
	            sortState: new Sort({
	                comparatorKey: options.sortType,
	                sortDir: options.sortDir
	            }),
	            channel: options.channel
	        });
	
	        this.channel.comply(this.commands, this);
	        this.channel.reply(this.requests, this); // used?
	
	    },
	    inEditMode: function() {
	        return this.get('activeNote') !== null;
	    },
	
	    getSortType: function() {
	        return this.sortState.getSortType();
	    },
	
	    getSortDirection: function() {
	        return this.sortState.getSortDirection();
	    },
	
	    commands: {
	
	        updateFilter: function(options) {
	
	            var src = options.filterSrc;
	
	            if (src === 'pageChange') {
	                this.filterState.updatePgNum(options.currentPage);
	            }
	
	            else if (src === 'modeChange') {
	                options.mode === 'pdf' && this.filterState.setPageFilterToAllPgs(); /* don't allow page level filter in pdf mode */
	            }
	
	            else if ( src === 'dropdown' || src === 'sat' ) {
	                this.filterState[ (src==='dropdown' ? 'dropDown' : 'sat') + 'Filter'](options);
	            }
	
	            // Other src's: noteSaved, noteDeleted
	            this.channel.command( 'filterUpdated', this.filterState );
	
	
	        },
	
	        toggleSortDirection: function() {
	            this.sortState.toggleDirection();
	            this.channel.command('updateSort', this.sortState.get('comparatorKey'), this.sortState.get('sortDir') );
	        },
	
	        changeSortOption: function(comparator) {
	            this.sortState.setComparator(comparator);
	            this.channel.command('updateSort', this.sortState.get('comparatorKey'), this.sortState.get('sortDir') );
	        }
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    NoteSortComparators = __webpack_require__(274);
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        comparatorKey: 'ctime', // valid values are the keys in comparators
	        sortDir: 'desc' // 'asc' or 'desc'
	    },
	
	    /*
	     * If for some reason invalid attributes are passed from local storage
	     * ( maybe they changed between versions )
	     * set the model with it's default to avoid errors.
	     * Basically 'validate' values that aren't undefined/null that would be set by defaults.
	     */
	    constructor: function( attributes , options ) {
	
	        var attrs = attributes || {};
	
	        if ( attrs.hasOwnProperty('comparatorKey') ) {
	
	            var validComparators =  _.keys( NoteSortComparators );
	            if ( ! _.contains( validComparators, attrs.comparatorKey ) )
	                attrs.comparatorKey = this.defaults.comparatorKey;
	
	        }
	
	        if ( attrs.hasOwnProperty('sortDir') ) {
	            if ( ! _.contains( [ 'asc', 'desc' ] , attrs.sortDir ) )
	                attrs.sortDir = this.defaults.sortDir;
	        }
	
	        return Backbone.Model.prototype.constructor.call( this, attrs, options );
	
	    },
	
	    setComparator: function(comparator) {
	        this.set('comparatorKey', comparator);
	    },
	
	    toggleDirection: function() {
	        this.set( 'sortDir', this.get('sortDir')  === 'desc' ? 'asc' : 'desc' );
	    },
	
	    getSortType: function() {
	        return this.get('comparatorKey');
	    },
	
	    getSortDirection: function() {
	        return this.get('sortDir');
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    NoteModelFactory = __webpack_require__(275),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * Purpose is for populating the new note menu ...
	 * Basically a helper class for it.
	 * Now also utilized for creatable note types in Find and Redact as well.
	 */
	
	var CreatableNoteTypes = function() {
	
	    this.printedNoteTypes = []; // note-type:model constructor hash -- what's printed on the menu
	    this.numberAllowedPrintedNoteTypes = 0;
	
	    this.allowedNoteTypes = []; // note types that are always allowed
	    this.disallowedPrintedNoteType = []; // printed by not allowed note types
	    this.drawableNoteTypes = []; // ( creatable drawable note types )
	    this.pageNoteTypes = [];
	
	    // State: this is updated
	    this.currentDissalledPrintedNoteTypes = [];
	
	    /* -- For Find and Redact -- */
	    this.noteTypesToPrintForFindAndRedact = [];
	    this.disallowedFindAndRedactNoteTypes = [];
	
	    return this;
	
	};
	
	
	
	/* Create and cache the instance variables */
	
	CreatableNoteTypes.prototype.initialize = function( vChannel, user ) {
	
	    /* First get all DV note types to print in the menu */
	    /* They can be enabled and disabled */
	    var allDocNoteTypes = NoteModelFactory.creatableNotes('document');
	
	    // Don't include flash notes if the system option is off ( pretend they don't exist )
	    if ( !fvChannel.request('allowFlashNotes') ) {
	        allDocNoteTypes = _.omit( allDocNoteTypes, 'FLASH_NOTE');
	    }
	
	    var allPageNoteTypes = NoteModelFactory.creatableNotes('page');
	
	    this.printedNoteTypes = _.extend( {}, allDocNoteTypes, allPageNoteTypes );
	
	    this.numberAllowedPrintedNoteTypes = _.keys( this.printedNoteTypes ).length;
	
	    /* Now create a list of 'allowed' note types that will always be disabled -- from info known on load */
	    /* Here we only need the keys -- maybe that changes later if we re-render instead of add/remove classes */
	    this.allowedNoteTypes = [];
	
	    var userHasCreateDocNotePerms = vChannel.request('allowCreateDocNote');
	    var userHasCreatePgNotePerms = vChannel.request('allowCreatePgNote');
	    var userHasCreateHighlightPerms = vChannel.request('allowCreateHighlight');
	
	    var excludePageNotes = vChannel.request('settings').excludePageNotes();
	    var docHasPages = !vChannel.request('activeDocHasNoPages');
	    
	    var userCanCreateDocNotes = userHasCreateDocNotePerms;
	
	    var userCanCreatePageNotes = userHasCreatePgNotePerms && !excludePageNotes && docHasPages; // applies to all but highlight
	    var userCanCreateHighlightNotes = userHasCreateHighlightPerms && !excludePageNotes && docHasPages; // this one must be checked separately
	
	    var userHasGraphicStamps = user.hasGraphicStamps();
	    var userHasTextStamps = user.hasTextStamps();
	
	    if ( userCanCreateDocNotes ) {
	
	        this.allowedNoteTypes = this.allowedNoteTypes.concat( _.keys(allDocNoteTypes) );
	    }
	
	    if ( userCanCreatePageNotes ) {
	
	        this.allowedNoteTypes = this.allowedNoteTypes.concat( _.keys(allPageNoteTypes) );
	
	        if ( !userHasGraphicStamps ) {
	
	            this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'GRAPHIC_STAMP' );
	        }
	
	        if ( !userHasTextStamps ) {
	            this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'GRAPHIC_TEXT_STAMP' );
	        }
	
	    }
	
	    // Special case for highlights which now respect their own perm, but not the original
	    if ( userCanCreateHighlightNotes ) {
	
	        if ( this.allowedNoteTypes.indexOf('HIGHLIGHT_NOTE') < 0 ) {
	
	            this.allowedNoteTypes.push( 'HIGHLIGHT_NOTE' );
	        }
	
	    } else {
	
	        this.allowedNoteTypes = _.without( this.allowedNoteTypes, 'HIGHLIGHT_NOTE' );
	
	    }
	
	
	    this.disallowedPrintedNoteType =
	        _.difference( _.keys( this.printedNoteTypes ), this.allowedNoteTypes );
	
	    /* -- Cache some other 'groups' for disabling in updateNoteTypesToDisable fn -- */
	
	    this.drawableNoteTypes = NoteModelFactory.creatableDrawableNoteTypes();
	    this.pageNoteTypes = _.keys( allPageNoteTypes );
	
	    /** ---- Find and Redact Cache ------  **/
	
	    this.noteTypesToPrintForFindAndRedact = NoteModelFactory.getNoteTypesThatSupportFindAndRedact() ;
	    this.disallowedFindAndRedactNoteTypes =
	        _.difference( _.keys( this.noteTypesToPrintForFindAndRedact ) , this.allowedNoteTypes );
	
	    /* -- End Find and Redact Cache ----*/
	
	    return this;
	
	};
	
	
	_.extend( CreatableNoteTypes.prototype, {
	
	    /*
	     * Called to enable/disable menu items depending on the state of the application.
	     * options: only exists if called from pageLoadError -- eg: { fromPageLoadError: 1, page: pageModelSourceOfTheError }.
	     * Sources:
	     * - Directly from onRender of the new note menu ( notes:updateNoteTypesToDisable )
	     * - notes.outerCommands.pageImgLoadError (notes:updateNoteTypesToDisable)
	     * - notesLayout.updateOnPageChange (notes:updateNoteTypesToDisable)
	     * - notesLayout.updateOnViewModeChange (notes:updateNoteTypesToDisable)
	     * - notes: _noteSaveSuccess, _deleteNoteSuccess (notes:updateNoteTypesToDisable); for FULL_PAGE_REDACTION
	     * Now also enables/disabled the entire menu if there are none to choose from ( we used to hide it from the UI )
	     * */
	    updateNoteTypesToDisable: function( vChannel, options ) {
	
	        // Always start with those that aren't ever allowed
	        // ( and clone to not change them by reference )
	        var typesToDisable = _.clone( this.disallowedPrintedNoteType) ;
	
	        /**
	         *  Catch if source stems from an event due to an error loading a page.
	         * ( This would rarely occur in PDF mode, though in this mode drawable notes type
	         *  would already have been disabled ).
	         * Only disable drawable note items if the page that failed is the current page.
	         * Note: page.get('loadError') will inherently be true here but isn't necessary.
	         */
	        if ( options && options.fromPageLoadError &&
	            vChannel.request('currentPageNumber') == options.page.get('number') )
	        {
	            typesToDisable = typesToDisable.concat( this.drawableNoteTypes );
	        }
	
	
	        if ( !vChannel.request('allowCreationOfFullPageRedaction') ) {
	            typesToDisable.push( 'FULL_PAGE_REDACTION' );
	        }
	
	        if ( vChannel.request('viewModeIsPdf') ) {
	            typesToDisable = typesToDisable.concat( this.pageNoteTypes );
	        }
	
	        /**
	         * In other modes, disable drawable notes types if the page doesn't support annotating.
	         * Note: currentPageSupportsAnnotation inherently checks if the document has no pages.
	         * ( But if the document has no pages, these types won't be rendered anyway ).
	         * Note this will capture pages that have already been loaded in error.
	         */
	        if ( !vChannel.request('currentPageSupportsAnnotation') ) {
	            typesToDisable = typesToDisable.concat( this.drawableNoteTypes );
	        }
	
	        // Simply logic so we don't need to worry about order of adding items and preventing dupes
	        typesToDisable = _.unique( typesToDisable );
	
	        this.currentDissalledPrintedNoteTypes = typesToDisable;
	
	        return typesToDisable;
	
	    },
	
	    // Used to populate contents of the dropdown
	    getPrintedNoteTypes: function() {
	
	        return this.printedNoteTypes;
	
	    },
	
	    disableNewNoteMenus: function() {
	
	        return this.numberAllowedPrintedNoteTypes == this.currentDissalledPrintedNoteTypes.length;
	
	    },
	
	    getPrintedNoteTypesForFindAndRedact: function() {
	
	        return this.noteTypesToPrintForFindAndRedact;
	
	    },
	
	    /**
	     * Could cache by cloning constructors used to print the template and then putting a disabled prop on them,
	     * but this is likely not very expensive ( these are also printed );
	     */
	    getDisallowedFindAndRedactNoteTypes: function() {
	
	        return this.disallowedFindAndRedactNoteTypes;
	    },
	
	    allFindAndRedactNoteTypesDisabled: function() {
	
	        return this.disallowedFindAndRedactNoteTypes.length == _.keys( this.noteTypesToPrintForFindAndRedact).length;
	
	    }
	
	
	});
	
	
	
	module.exports = CreatableNoteTypes;
	


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	     $ = __webpack_require__(59),
	    Backbone = __webpack_require__(58),
	    FTLayout = __webpack_require__(524),
	    Radio = __webpack_require__(60),
	    SubApp = __webpack_require__(98),
	    FTState = __webpack_require__(556), //should be need here -- only on main view
	    fvChannel = __webpack_require__(72).channel('FV'),
	    FTModel = __webpack_require__(403),
	    ResetView = __webpack_require__(557);
	
	__webpack_require__(66);
	__webpack_require__(465);
	__webpack_require__(459);
	__webpack_require__(554);
	
	var instanceVars = {
	    region: null,
	    layout: null,
	    fullTextModel: null, //note: (stored on the document model -- the 'activeDocument' )
	    channel: null, //(from subapp)
	    vChannel: null,
	    state: null //note: now storing options, those should prob be moved into own obj with defaults, etc ...
	};
	
	module.exports = SubApp.extend({
	    constructor: function(options, id) {
	        
	        _.extend(this, instanceVars, _.pick(options, 'fullTextModel', 'vChannel'), {
	            id: id,
	            region: new Marionette.Region({
	                el: options.$container
	            }),
	            state: options.state ? 
	                options.state 
	                : new FTState( _.extend( {},
	                    _.pick(options, FTState.prototype.getArrayOfAttributesToPersist() ) //limit any unwanted from moduleWr change options provided
	                 ))
	        });
	
	        SubApp.prototype.constructor.apply(this, arguments);
	
	        /* exported events -- where listener is set -- see viewer channel subscription callbacks */
	        Backbone.fwd.call(this.vChannel, this.channel);
	
	        /* IE8 needs the viewer to be visible in the DOM to calc the correct page offsets */
	        //TODO: for module only -- also need listener for this being rendered
	        if (fvChannel.request('settings').isIE8) {
	            this.listenTo(this.vChannel, 'vChannel:region:viewerVisible', _.bind(function () { //TODO: fwd from subscriptions & above
	                this.channel.command('calcPageBottoms');
	            }, this));
	        }
	    },
	    commands: {
	        render: function(cb) {
	
	            //TODO: ISSUE IF RE-RENDER AND PAGE COLLECTION EXISTS, WANT THE MIN OF THAT IN THE PAGE -- perhaps page text collection s/d be first
	
	            /* don't allow current page (if set by param) to be greater than the number of pages in the document */
	
	            //TODO: if document has no pages (eg if a folder), this.fullTextModel.numberOfPgsInDoc() will be 0, resulting in NaN -- this may not couse a problem
	           this.state.set( 'currentPg', Math.min( this.state.get('currentPg'), this.fullTextModel.numberOfPgsInDoc() ), {
	               silent: true
	           } );
	
	            this.layout = new FTLayout({
	                model: this.fullTextModel, /* flag here is currently preset whether error fetch url or not */
	                lCh: this.channel,
	                state: this.state
	            });
	
	            this.region.show( this.layout, {
	                cb: cb  //(for standalone) ... note, layout has OWN show, this extends it to onAfter (optional)
	            } );
	
	        },
	        showLoadingView: function() {
	            //note: now called only b/f fetch specifically, could hook into model onAfterFetch for this (in viewer nothing shown until loaded entirely)
	            this.region.show( new ResetView() );
	        },
	        changePage: function(options) { /* the only outer -- vChannel (EXPORT)*/
	
	            // Don't allow is an error occurred on model fetch; pgTextCollection will be null
	            if ( this.fullTextModel.errorOccurredOnFetch() )
	                return;
	
	            var goToPgNum = options.pageNum;
	
	            //if in grep mode, (not all pages may be present) -- could also be applicable to upcoming metadata
	            //TODO: pg text collection ... s/b top level
	            if ( !this.layout.pgTextCollection.hasPageNumber(goToPgNum) )
	                return;
	
	            //TODO: note now can be from independent calling app (here will refer to as viewer)
	            this.state.set('currentPg', goToPgNum, {fromViewer: true});
	
	        },
	        //TODO: now export ... but change anyway ... to not be tied to the ft model --- !
	        resetSearch: function(searchTxt, sumbitIfSearchTextIsTheSame) {
	
	            //quick validation (keyup or ok click)
	            if ( !sumbitIfSearchTextIsTheSame && (searchTxt === this.fullTextModel.searchText) ) return false;
	
	            //TODO: rid fetchurl jqXHR
	            var opts = _.pick(this.fullTextModel, 'docId', 'fetchUrl', 'firstQueryRequest');
	
	            var newFtModel = new FTModel([], {
	                searchText: searchTxt,
	                docId: opts.docId,
	                fetchUrl: opts.fetchUrl
	            });
	
	            //TODO: make fn on state returning this
	            var newState = this.state.clone();
	            //don't want every state attribute cloned pre re-entry ...
	            newState.set( _.pick( newState.defaults, 'activeHitNumber', 'currentPg', 'lastScrollTop'), {silent: true} );
	
	            var self = this;
	            this.command('showLoadingView'); //todo: now only here and in independent module ... combo with overall workflow
	
	            newFtModel.fetch().done( function() {
	
	                self.destroy();
	                self.constructor({
	                    fullTextModel: newFtModel,
	                    vChannel: self.vChannel,
	                    $container: self.options.$container,
	                    channel: self.channel, //use the same channel
	                    state: newState
	                }, self.id);
	
	                self.channel.trigger('fullText:updateNoteCountAndCaption', newFtModel.getNumberOfHits(), newFtModel.getSearchTxt() );
	
	                self.channel.command('render');
	                //todo: working except now some minor mem leaks -- destroy on just widget has no leaks now ... appears could be the action 'research' toolbar
	
	
	            }).fail(function(jqXHR) {
	                //TODO: TEST ERR --- should just use build in error view, this not needed
	                self.options.vChannel.command('ajaxError', jqXHR, 'Unable to make full text search request.  Cannot fetch databases.');
	            });
	
	            //fixed overwritten option but now some leaks
	
	        },
	        'vChannel:setScrollPosition': function(scrollRatio) {
	            this.channel.command('setScrollPosition', scrollRatio);
	        }
	
	    },
	    requests: {
	        'vChannel:scrollTopRatio': function() {
	            return this.channel.request('scrollPositionRatio');
	        },
	        getStateAttributesToPersistOnReset: function() {
	            return this.state.getAttributesToPersistOnReset(); //TODO: HERE INCLUDE THE ATTR TO PERSIST
	        }
	    },
	    onBeforeDestroy: function() {
	        this.fullTextModel.abortAjaxRequests(); //(also necessary to prevent fetch dfd from completing, so render not called on module that no longer exists on module switch)
	        this.state.destroy(); //!must do b/f cleaning the view b/c it hold $hits in it
	        this.vChannel.stopListening();
	        this.region.empty(); //onBefore destroy of layout view clears out much
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(525);
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    FTHeader = __webpack_require__(526),
	    FTFooter = __webpack_require__(530),
	    FTPages = __webpack_require__(539),
	    TextPgs = __webpack_require__(550),
	    ESErrorView = __webpack_require__(551);
	
	__webpack_require__(76); //(ajaxErrorMessage)
	__webpack_require__(459);
	__webpack_require__(554);
	
	var ResizeSensor = __webpack_require__(112);
	
	
	var instanceVars = {
	    model: null, //the search model
	    state: null,
	    lCh: null,
	    pgTextCollection: null, //stored here and passed to pages: for hit navigation controlled here
	    pagesView: null,
	    _scrollbarWidth: null, //cache for SAT calcs
	    resizeSensor: null
	};
	
	
	module.exports = Marionette.LayoutView.extend({
	    id: 'esResultsDocLevel',
	    template: __webpack_require__(555),
	    initialize: function (options) {
	        _.extend(this, instanceVars, _.pick(options, 'model', 'lCh', 'state'), {
	            _scrollbarWidth: fvChannel.request('settings').scrollbarWidth //(cache)
	        });
	        this.lCh.comply(this.commands, this);
	        this.lCh.reply(this.requests, this);
	        this.bindEntityEvents(this.state, this.stateCallbacks);
	        _.bindAll(this, 'textScrolled', '_bodyClickUnfocusCB');
	        /* leave name to remove events*/
	        return Marionette.LayoutView.prototype.initialize.apply(this, arguments);
	    },
	    serializeData: function () {
	        return {
	            grepMode: this.state.get('grepMode'),
	            hideHits: !this.state.get('showHits')
	        };
	    },
	    ui: {
	        contentWr:      '.esContentWr',
	        scroller:       '.esContentInnerWr',  //the 'scroller' -- not, now its not
	        overflowCheck:  '.overflowCheck'
	    },
	    regions: {
	        header:         '#esHeader',
	        contentRegion:  '.esContentInnerWr', /* scroller ! */
	        footer:         '#esFooter'
	    },
	    onRender: function () {
	        this.unbindKeyboardEvents(); //for select all
	    },
	    onShow: function ( region, view, options ) {
	
	        this.state.get('fontEmSize') !== 1 && this._updateFontSize(this.state.get('fontEmSize'));
	        this._createResizeSensor();
	
	        if ( !this.model.docOnServerAndNoFetchErr() )
	            return;
	
	        // DVBC-1147, DVBC-1177 - here DON'T use this.model.numberOfPgsInDoc() (condition where no utr notes returned in resp but there are other hits (doc notes), so there are 'pages')
	        if ( this.pgTextCollection.length < 1 )
	            return;
	
	        /* quick fix -- aside from better template struct, must be inside to check overflow */
	        this.ui.scroller.prepend('<div class="overflowCheck"></div>');
	        this.bindUIElements();
	
	        this._postRenderPagesView( _.extend( {}, options, {firstRender: true} ) ); // must pass options, contains
	
	    },
	    onBeforeShow: function (region, view, options) {
	
	        var opts = _.pick(this, 'model', 'lCh'); //todo: pass in docOnServer and noFetch to other views
	
	        this.footer.show(new FTFooter(opts));
	        /*  center is the conditional -- depends on error -- do first? */
	
	        var noError = this.model.docOnServerAndNoFetchErr();
	
	        /* all errors  -- if err, access pages will result in err */
	        if (noError)
	            this._createPagesView();   //(also creates pgTextCollection)
	
	        this.contentRegion.show( noError ? this.pagesView : new ESErrorView(_.pick(this, 'model', 'lCh')) );
	
	        //b/c no yet shown, don't filter elements on visible here ... would need to do onShow
	        this.header.show( new FTHeader( _.extend(opts, {
	            $searchContainer: noError ? this._$getSearchContainer() : $(), /* can't give the individual jq elements from the children (closest) but don't include not pages */
	            pgTextCollection: noError ? this.pgTextCollection : undefined //(if error, pg text collection (created with pages view, not created; conditional left for clarity)
	        })));
	
	        //(run any provided 'onAfterRender' if there was one -- applicable to doc not on server or err fetching model;
	        // (if doc not on server / error occured -- the success runs on highligh of first hit)
	        !noError && options && options.cb && options.cb({
	            jqXHR: this.model.getFetchErr(),
	            docNotOnServer: this.model.docNotOnESServer()
	        });
	    },
	    events: {
	        click:      'onClick',
	        mouseover:  'onMouseover'
	    },
	    keyboardEvents: {
	        'mod+a': 'selectAll' //mod if mac/pc
	    },
	    _destroyAndCreatePagesView: function () {
	        this._destroyPagesView();
	        this._createPagesView();
	        this.contentRegion.show(this.pagesView);
	    },
	    //TODO: consolidate code from the 3 below
	    _postToggleESGrepMode: function () {
	        this._destroyAndCreatePagesView();
	        this._postRenderPagesView({fromGrepToggle: true});
	        this.lCh.trigger('updateGrepToggleBtnState', this.state.get('grepMode'));
	    },
	    _postToggleLocalGrepMode: function (m, mode, options) {
	        this._destroyAndCreatePagesView();
	        this._postRenderPagesView( _.extend( {}, options, {fromGrepToggle: true} )  ); //options could have highlightHitIndex
	    },
	    _postKeyUpInLocalGrepMode: function() {
	        // need to re-render/reset -- and then have search bar activate the hit, THEN,
	        // scroll to it -- having the 2 fns avoids recursions of calling keyup when hit is highlighted
	        // TODO -- overlap with post toggle local grep mode fn
	        this._destroyAndCreatePagesView();
	        this._postRenderPagesView({fromGrepToggle: true}); //calls set hits ...
	    },
	    _postToggleSimpleMode: function() {
	        this._destroyAndCreatePagesView();
	        this._postRenderPagesView({ fromSimpleModeToggle: true });
	    },
	    _postRenderPagesView: function(options) {
	
	        var numberOfPgs = this.pgTextCollection.length;
	        /* must set the top and bottoms before set hits (or do any scrolling to page) */
	        /* note: IE8 wont be correct until the viewer loads */
	
	        this.lCh.command('calcPageBottoms'); //(always do even if 1 page)
	
	        //scroll to the current page position first, knowing that if there is a hit, state.setHits will scroll to the first page with a hit
	        this.silentScrollToPage(this.state.get('currentPg')); //TODO: necessary?
	
	        //(triggers navigation to active hit, and page change)
	        this.state.setHits(this.$el, {
	            initialLoadCallback: options && options.cb, //on show really show happen after scrolling/hit highlighting, etc (eg: to get the active page)
	            fromGrepToggle: options && options.fromGrepToggle,
	            fromSimpleModeToggle: options && options.fromSimpleModeToggle
	        });
	
	        //TODO: for simplicity all below could be put in set hit callback
	
	        //(run in case their was no active hit to fire the other cb */
	        (this.state.getActiveHit().length < 1) && (options && options.cb) && options.cb();
	
	        /* don't allow scroll events to get picked up if only one page --- move up?*/
	        if (numberOfPgs > 1) this.toggleScrollCB(true);
	        /* not on events hash b/c scroll event doesn't bubble*/
	
	        if (options && (options.fromGrepToggle || options.fromSimpleModeToggle || options.firstRender)) { //(first render b/c doc change could come in one of these modes)
	
	            var nHits = this.state.getNumberOfHits();
	
	            /* update number of hits in viewer header */
	
	            this.lCh.trigger('navView:update', this.state.get('activeHitNumber'), nHits);
	            this.lCh.trigger('fullText:updateNoteCountAndCaption', nHits, this.model.getSearchTxt(), this.state.get('localGrepMode') ? this.state.get('localSearchText') : null ); /* vChannel export */
	            this.lCh.trigger('header:updatePageSelector', this.pgTextCollection, this.state.get('currentPg'));
	
	            if (!options.firstRender) {
	
	                this.lCh.trigger('header:updateSearchBarAfterPageViewRender', this._$getSearchContainer(),
	                    options && (options.highlightHitIndex || options.highlightHitIndex === 0) //DVBC-1284: later predicates b/c it can be 0 if its the first hit!
	                        ? options.highlightHitIndex
	                        : null
	                );
	            } else {
	                //if local hit, scroll to it -- if hits, the first hit would have been scrolled to
	                var $localHit = this.$el.find('.sbActive');
	                $localHit.length > 0 && this._scrollToLocalHitIfInView($localHit);
	            }
	
	        }
	    },
	    _createPagesView: function () {
	
	        var simpleMode = this.state.get('simpleMode'),
	            grepMode = this.state.get('grepMode'),
	            localGrepMode = this.state.get('localGrepMode'),
	            localSearchTxt = this.state.get('localSearchText'),
	
	            localGrepSearch = localGrepMode ? localSearchTxt : null,
	
	            // TODO: call this metadata -- this would consist of FC Fields, Doc Props, & RMA that comes
	            // off the source that is non existent (undefined) if not found
	            includeNonFieldHitsOrDocProps = grepMode ? false : !simpleMode; 
	
	        var pgTextObjs = this.model.getPageTextObjs(grepMode, localGrepSearch);
	
	        var fieldHits = this.model.getFCFields(localGrepSearch, includeNonFieldHitsOrDocProps);
	        fieldHits && pgTextObjs.push({
	            pgViewType: 'FC_FIELDS',
	            pgText: fieldHits
	        });
	
	        var securityProperties = this.model.getSecurityOrRMAProperties(localGrepSearch, includeNonFieldHitsOrDocProps, 1);
	        securityProperties && pgTextObjs.push({
	            pgViewType: 'SECURITY_PROPS',
	            pgText: securityProperties
	        });
	
	        var rmaProperties = this.model.getSecurityOrRMAProperties(localGrepSearch, includeNonFieldHitsOrDocProps);
	        rmaProperties && pgTextObjs.push({
	            pgViewType: 'RMA_PROPS',
	            pgText: rmaProperties
	        });
	
	        var docPropHits = this.model.getDocProperties(localGrepSearch, includeNonFieldHitsOrDocProps);
	        docPropHits && pgTextObjs.push({
	            pgViewType: 'DOC_PROPS',
	            pgText: docPropHits
	        });
	
	        var docNoteHits = this.model.getDocNotes(grepMode, localGrepSearch, includeNonFieldHitsOrDocProps);
	        docNoteHits && pgTextObjs.push({
	            pgViewType: 'DOC_NOTES',
	            pgText: docNoteHits
	        });
	
	
	        this.pgTextCollection = new TextPgs(pgTextObjs);
	        
	        this.pagesView = new FTPages({
	            collection: this.pgTextCollection,
	            model: this.model,
	            lCh: this.lCh,
	            state: this.state
	        });
	
	    },
	    //(as well as pg text collection)
	    _destroyPagesView: function () {
	        //MOST FINALLY GONE ... can clean
	        this.lCh.stopComplying('searchBar:localHitActivated'); //prevent mem leak -- $hit callback in context
	
	        this.state.cleanHits();
	
	        var pgsView = this.pagesView,
	            headerView = this.header.currentView,
	            searchBarView = headerView.children.findByCustom('searchBar'); //TODO: mediate
	
	        pgsView.$el.find('*').remove();
	        pgsView.$el.remove();
	
	        searchBarView.searchUI.destroy();
	
	        if (searchBarView.$domToHighlight) {
	            searchBarView.$domToHighlight.remove();
	            searchBarView.$domToHighlight = null;
	        }
	
	        // after first time, this will no longer exist
	        if (searchBarView.options.$searchContainer) {
	            searchBarView.options.$searchContainer.remove();
	            searchBarView.options.$searchContainer = null;
	        }
	
	        if (headerView.options.$searchContainer) {
	            headerView.options.$searchContainer.remove(); //TODO: STILL NECESSARY? -- JUST REMOVE ONE REF (NOW IT'S NOT AN ATTR)?
	            headerView.options.$searchContainer = null;
	        }
	
	        this.contentRegion.empty();
	        Marionette.blindTriggerOn([this.pagesView, this.pgTextCollection], 'destroy');
	
	        pgsView.el = null;
	
	        this.lCh.comply('searchBar:localHitActivated', this);
	    },
	    //TODO: MOVE UP
	    stateCallbacks: {
	        'change:activeHitNumber':   'hitActivated', /* now also implies content changed -- 'hitsSet' */
	        'change:currentPg':         'pageChanged',
	        'change:grepMode':          '_postToggleESGrepMode',
	        'change:localGrepMode':     '_postToggleLocalGrepMode',
	        'change:simpleMode':        '_postToggleSimpleMode',
	        'change:showHits': function (m, show) {
	            this.lCh.trigger('navView:toggleHits', show);
	            this.ui.contentWr.toggleClass('hideHits', !show); //(class on here, not pageViews -- move */
	        },
	        'change:wrapText': function (state) {
	            this._createResizeSensor(); //will existing destroy if not wrapped
	
	            this.pagesView.triggerMethod('wrapTextToggle');
	            //if not in view, scroll to active hit (if there are hits)
	            this.model._hasAnyResults() && this.hitActivated(state, state.get('activeHitNumber'));
	        },
	        'change:fontEmSize': function (m, size) {
	            this._updateFontSize(size);
	            this.lCh.command('calcPageBottoms');
	        },
	        'change:searchInputEnabled': function () {
	            var newSearchView = this.footer.currentView.center.currentView,
	                args = _.toArray(arguments);
	            newSearchView.triggerMethod.apply(newSearchView, ['toggleSearchReset'].concat(args));
	        }
	    },
	    pageChanged: function (m, pgNum, options) {
	
	        var fromViewer = options.fromViewer;
	
	        if (options.fromScroll || options.fromResize || options.fromHitChange || options.fromLocalHitChange || options.fromSimpleModeToggle || fromViewer) { /* already scrolled (not viewer) */
	            this.lCh.trigger('header:setSelectPgNumber', pgNum);
	        }
	
	        if (options.fromSelect || fromViewer) {
	            this.silentScrollToPage(pgNum);
	        }
	
	        if (!options.fromViewer) {
	            this.lCh.trigger('fullText:changePage', pgNum);  /* forwarded (export)*/
	        }
	
	        //(below here is the end of the 'onShow' workflow chain of events ...
	        options && options.initialLoadCallback && options.initialLoadCallback();
	
	    },
	    /* if scrolled, indicate a change in page if it occurs */
	    textScrolled: function () {
	
	        var state = this.state,
	            curScrTop = this.ui.scroller.scrollTop(),
	            dy = curScrTop - state.get('lastScrollTop'),
	            curPgNum = this.lCh.request('currentPgNumber'),  //here, really implies the last page
	            pages = this.pgTextCollection;
	
	        state.set('lastScrollTop', curScrTop);
	
	        if (dy === 0) return;
	
	        if (dy > 0) { //scrolldown
	
	            var currentPgBottom = pages.findWhere({pgNum: curPgNum}).get('bottom');
	            (curScrTop > currentPgBottom) && setCurrentPg();
	
	        } else if (dy < 0) {
	
	            var currentPgTop = pages.findWhere({pgNum: curPgNum}).get('top');
	            (curScrTop < currentPgTop) && setCurrentPg();
	        }
	
	        function setCurrentPg() {
	            var pageOn = pages.getByScrollPosition(curScrTop);
	            pageOn && state.set('currentPg', pageOn.get('pgNum'), {fromScroll: true});
	        }
	
	    },
	    toggleScrollCB: function (on) {
	        /* note: this is working but still need to defer any scroll callbacks */
	        this.ui.scroller.jquery /*only do when rendered -- may not exist on fast reset */
	        && this.ui.scroller[on ? 'on' : 'off']('scroll', this.textScrolled);
	    },
	    /* scrolls, but turn off scroll listener */
	    silentScrollToPage: function (pgNum) {
	
	        this.toggleScrollCB(false);
	
	        var scrollToPage = this.pgTextCollection.findWhere({pgNum: pgNum});
	        scrollToPage && this.ui.scroller.scrollTop(scrollToPage.get('top')).scrollLeft(0);
	        //todo: set last scroll top?
	
	        _.defer(function (cxt) {
	            cxt.toggleScrollCB(true);
	        }, this);
	    },
	    /* used for select all -- will need accessibility high level org TODO: obviously needs reorg */
	    onClick: function (e) {
	
	        e.stopPropagation();
	        var $target = $(e.target);
	
	        //TODO: MAKE DUMMY FOCUS A STATE, W/CB -- also make actual focus like in the key-focus branch
	
	        this.ui.contentWr.addClass('dummyFocus');
	        this.bindKeyboardEvents(); //allow the select all -- todo: to parent
	        $('body').one('click', this._bodyClickUnfocusCB);
	
	        if ($target.hasClass('hit') && this.state.get('grepMode')) {
	            this.state.setActiveHitIndex($target);
	            this.lCh.command('toggleGrepMode');
	        }
	
	        //now handling here, not in plugin -- less listeners & perf boost
	        if ($target.hasClass('highlight') && this.state.get('localGrepMode')) {
	            this.lCh.command('toggleLocalGrepMode', {
	                highlightHitIndex: this.$('.highlight').index($target) //TODO: could now just pass a flag
	            });
	        }
	
	    },
	    /* now just a deleted way to put tooltips on the hover of grepped hits -- not printing the titles on render of the text coming back from es */
	    /* note: not taking away with mouseout */
	    onMouseover: function (e) {
	        e.stopPropagation();
	
	        var $target = $(e.target);
	
	        if (this.state.get('grepMode') && $target.hasClass('hit')) {
	            $target.attr('title', 'View in non-grepped text context');
	            return;
	        }
	
	        if (this.state.get('localGrepMode') && $target.hasClass('highlight')) {
	            $target.attr('title', 'View in non-grepped text context');
	            return;
	        }
	
	    },
	    /* here to avoid leak */
	    _bodyClickUnfocusCB: function () {
	        this.ui.contentWr.removeClass('dummyFocus');
	        this.unbindKeyboardEvents(); //revert to the norm
	    },
	    selectAll: function (e) {
	        !e.preventDefault && (e = $.event.fix(e));
	        e.preventDefault();
	        this.ui.contentWr.selectAll();
	    },
	    hasYOverflow: function () {
	        return this.ui.contentWr.height() > this.ui.overflowCheck.height();
	    },
	    hasXOverflow: function () {
	        return this.ui.contentWr.width() > this.ui.overflowCheck.width();
	    },
	    _updateFontSize: function (size) {
	        this.ui.contentWr.css('font-size', size + 'em');
	    },
	    requests: {
	        showHitsInView: function () {
	            return this.state.get('showHits');
	        },
	        isInGrepMode: function () {
	            return this.state.get('grepMode');
	        },
	        inLocalGrepMode: function() {
	            return this.state.get('localGrepMode');
	        },
	        isInSimpleMode: function() {
	            return this.state.get('simpleMode');
	        },
	        isTextWrapped: function () {
	            return this.state.get('wrapText');
	        },
	        currentPgNumber: function () {
	            return this.state.get('currentPg');
	        },
	        scrollPositionRatio: function () {
	            var $pgsEl = this.pagesView.$el,
	                $scroller = this.contentRegion.$el;
	            return {
	                top: $scroller.scrollTop() / $pgsEl.height(),
	                left: $scroller.scrollLeft() / $pgsEl.width()
	            };
	        },
	        getLocalSearchTxt: function () {
	            return this.state.get('localSearchText');
	        },
	        currentHitNumber: function () {
	            return this.state.get('activeHitNumber');
	        }
	    },
	    commands: {
	        hitButtonClick: function (action) {
	            this.state.navigateHits(action);
	        },
	        showHits: function () {
	            this.state.toggle('showHits');
	        },
	        toggleTextWrapping: function () {
	            this.state.toggle('wrapText');
	        },
	        selectAll: function () {
	            this.selectAll.apply(this, arguments);
	        },
	        changeFontSize: function () {
	            this.state.changeFontSize.apply(this.state, arguments);
	        },
	        toggleSearchBarState: function () {
	            this.state.toggle('searchInputEnabled');
	        },
	        'pageSelect:pageChange': function (pgNum) {
	            this.state.set('currentPg', pgNum, {fromSelect: true});
	        },
	        'searchbar:focused': function() {
	            this._updateCachedViewCalcs();
	        },
	        toggleGrepMode: function () {
	            this.state.toggle('grepMode');
	        },
	        toggleSimpleMode: function() {
	            this.state.toggle('simpleMode');
	        },
	        toggleLocalGrepMode: function (options) {
	            options && options.searchTxt && this.state.set('localSearchText', options.searchTxt, {silent: true});
	            this.state.toggle('localGrepMode', options);
	        },
	        'searchBar:localHitActivated': function ($hit) {
	            this._scrollToLocalHitIfInView($hit);
	        },
	        'searchbar:postKeyupInGrepMode': function (searchTxt) {
	            this.state.set('localSearchText', searchTxt, {silent: true}); //todo: perf issue?
	            this._postKeyUpInLocalGrepMode.apply(this, arguments);
	        },
	        'searchBar:collapsed': function () {
	            this.state.set('localSearchText', '');
	        },
	        'searchBar:postKeyUpNotGrepMode': function(localSearchTxt) {
	            this.state.set('localSearchText', localSearchTxt, {silent: true});
	        },
	        setScrollPosition: function (scrollRatio) {
	            var $pgsEl = this.pagesView.$el;
	            this.contentRegion.$el
	                .scrollTop(scrollRatio.top * $pgsEl.height())
	                .scrollLeft(scrollRatio.left * $pgsEl.width());
	        }
	    },
	    _updateCachedViewCalcs: function() {
	        /* Cache dimension values for SAT perf boost */
	        _.extend(this, {
	            _hasYOverflow: this.hasYOverflow(),
	            _hasXOverflow: this.hasXOverflow(),
	            _scrollerOffsets: this.ui.scroller.getOffsets()
	        });
	    },
	
	    /* really from the set hits now */
	    hitActivated: function (state, hitIdx, options) {
	        this.lCh.trigger('navView:updateHitCount', hitIdx); //todo: also update number?
	        /* scroll to it if exists */
	        var $hit = state.$hits.eq(hitIdx);
	        $hit.length > 0 && this._activateHitIfInView($hit, options);
	    },
	    _activateHitIfInView: function ($hit, options) {
	        /* note: already marked in model */
	        var hitInView = $hit.inView( this.ui.scroller, {
	                yOverflow: this.hasYOverflow(),
	                xOverflow: this.hasXOverflow(),
	                scrollBarWidth: this._scrollbarWidth
	            });
	
	        hitInView
	            ? setPgNumber.call(this)
	            : this.silentCenteredScrollToHit( $hit, _.bind( setPgNumber, this) ) ;
	
	        function setPgNumber() {
	            this.state.attributes && this.state.set('currentPg', this.getPageOfHit($hit), {
	                fromLocalHitChange: true
	            });
	            options && options.initialLoadCallback && options.initialLoadCallback();
	        }
	
	    },
	    //TODO: combo code w/ES hit scroll ...
	    _scrollToLocalHitIfInView: function ($hit) {
	        /* (its already highlighted by the plugin -- also set the page number */
	
	        var hitInView = $hit.inView( null, {
	            yOverflow: this._hasYOverflow,
	            xOverflow: this._hasXOverflow,
	            scrollBarWidth: this._scrollbarWidth,
	            containerOffsets: this._scrollerOffsets
	        });
	
	        hitInView
	            ? setPgNumber.call(this)
	            : this.silentCenteredScrollToHit( $hit, _.bind( setPgNumber, this) ) ;
	
	
	        function setPgNumber() {
	            this.state.attributes && this.state.set('currentPg', this.getPageOfHit($hit), {
	                fromLocalHitChange: true
	            });
	        }
	    },
	    silentCenteredScrollToHit: function ($hit, cb) {
	        var pgNumOfHit = this.getPageOfHit($hit),
	            pg = this.pgTextCollection.findWhere({pgNum: pgNumOfHit}),
	            prevPgTop = pg.get('top');
	
	        this.toggleScrollCB(false);
	        $hit.centeredScroll(this.ui.scroller, prevPgTop, null, _.bind(function () {
	            this.toggleScrollCB(true);
	            cb && cb();
	        }, this));
	    },
	    //(can be find/search )
	    getPageOfHit: function ($hit) {
	        return $hit.closest('.esPage').data('page-num');
	    },
	
	    //note: only done in wrapText and if more than 1 page
	    _createResizeSensor: function () {
	
	        if (this.resizeSensor)
	            this.resizeSensor.detach();
	
	        if (this.model.numberOfPgsInDoc() > 1 && this.state.get('wrapText')) {
	
	            var lCh = this.lCh;
	            var self = this;
	
	            this.resizeSensor = new ResizeSensor(this.el, _.debounce(function () {
	
	                lCh.command('calcPageBottoms');
	                var pageOn = self.pgTextCollection.getByScrollPosition(self.ui.scroller.scrollTop());
	                self.state.set('currentPg', pageOn.get('pgNum'), {fromResize: true});
	
	            }, 20, true));
	        }
	    },
	    _$getSearchContainer: function () {
	        return this.pagesView.$el.find('.esPageText'); //TODO: NO CONTEXT, SPEED UP? ... though the selector should be fast here
	    },
	    onBeforeDestroy: function () {
	
	        this.resizeSensor && this.resizeSensor.detach();
	
	        this.$('*').remove();
	
	        $('body').off('click', this._bodyClickUnfocusCB); //(this fixed the leak on re-search)
	        this.lCh.reset();
	        this.unbindEntityEvents(this.state, this.stateCallbacks);
	        Marionette.blindTriggerOn([this.pgTextCollection, this.state, this.pagesView, this.model], 'destroy');
	        /* not there if err  */
	
	        this.off();
	        this.stopListening();
	        this.$el.remove();
	
	    }
	
	});

/***/ },
/* 525 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(527);
	
	var Marionette = __webpack_require__(61),
	    SearchBarView = __webpack_require__(497),
	    BabySitterView = __webpack_require__(489),
	    PageSelectTemplate = __webpack_require__(528);
	
	__webpack_require__(76);  //unselectable, jqErr
	__webpack_require__(516);
	
	module.exports = BabySitterView.extend({
	    template: __webpack_require__(529),
	    ui: {
	        pageSelect:         '.esPageSelect',
	        toggleWrapTextBtn:  '#wrapTextBtn',
	        fontIncBtn:         '#esLarger',
	        fontDecBtn:         '#esSmaller',
	        selectAllBtn:       '#esSelectAll',
	        searchWidgetPH:     '[data-searchWidget]'
	    },
	    initialize: function () {
	        var lCh = this.options.lCh;
	        this.listenTo(lCh, 'header:setSelectPgNumber',                  this.setSelectPgNumber);
	        this.listenTo(lCh, 'header:updatePageSelector',                 this._updatePageSelect); //(also does the # -- this one called when page content changed)
	        this.listenTo(lCh, 'header:updateSearchBarAfterPageViewRender', this.updateSearchBarAfterPageViewRender);
	        lCh.comply({
	            applyLocalSearchFromESWordClick: this.setSearchBarText
	        }, this);
	    },
	    onRender: function () {
	
	        var lc = this.options.lCh,
	            noErrorOccured = this.model.docOnServerAndNoFetchErr();
	
	        this.$el.unselectable();
	
	        if (noErrorOccured) {
	
	            this._initSearchBar(this.options.$searchContainer);
	
	            this.ui.toggleWrapTextBtn.toggleButton({
	                isActive: lc.request('isTextWrapped'),
	                toggleAction: function () {
	                    lc.command('toggleTextWrapping');
	                },
	                activeTitle: 'Unwrap Text',
	                inactiveTitle: 'Wrap Text'
	            });
	
	            //(pgTextCollection only defined if no error_
	            this._updatePageSelect(this.options.pgTextCollection, lc.request('currentPgNumber'));
	        }
	
	    },
	    serializeData: function () {
	        return {
	            error: !this.model.docOnServerAndNoFetchErr()
	        };
	    },
	    events: function () {
	        var c = this.options.lCh;
	        return {
	            'change @ui.pageSelect': 'pageSelected',
	            'click  @ui.fontIncBtn': function () {
	                c.command('changeFontSize', 'larger');
	            },
	            'click  @ui.fontDecBtn': function () {
	                c.command('changeFontSize', 'smaller');
	            },
	            'click  @ui.selectAllBtn': function (e) {
	                c.command('selectAll', e);
	                /* need to prevent default */
	            }
	
	        };
	
	    },
	    _updatePageSelect: function (pgs, pgNum) {
	
	        this.ui.pageSelect.find('option').remove();
	
	        var nPgs = pgs ? pgs.length : 0,  //(eg none if doc not on es server, error)
	            markup = PageSelectTemplate({
	                pages: !nPgs ? [] : pgs.map(function (p) {
	                    return {
	                        label: p.get('pgLbl'),
	                        number: p.get('pgNum')
	                    };
	                })
	            });
	        this.ui.pageSelect.append(markup);
	        pgNum && this.setSelectPgNumber(pgNum);
	
	        this.ui.pageSelect.toggleClass('invisible', nPgs < 1); //(don't show the page select if there are no pages)
	    },
	    setSelectPgNumber: function (pgNum) {
	        this.ui.pageSelect.val(pgNum);
	    },
	    pageSelected: function (e) {
	        this.options.lCh.command('pageSelect:pageChange', parseInt($(e.currentTarget).val()));
	    },
	    _initSearchBar: function () {
	
	        var lCh = this.options.lCh,
	
	        /* cache for perf boost */
	            _activeHitHighlightCB = lCh._commands['searchBar:localHitActivated'].callback,
	            _searchBarKeyUpGrepMode = lCh._commands['searchbar:postKeyupInGrepMode'].callback,
	            _keyUpNotGrepMode = lCh._commands[ 'searchBar:postKeyUpNotGrepMode'].callback,
	            _cxt = lCh._commands['searchBar:localHitActivated'].context,
	
	            searchView = new SearchBarView({
	                placeHolder: 'Find Here',
	                includeNAV: true,
	                includeGrep: true,
	                startInGrepMode: lCh.request('inLocalGrepMode'),
	                $searchContainer: this.options.$searchContainer,
	                initialSearchTxt: lCh.request('getLocalSearchTxt'),
	                onAfterFocus: function () {
	                    lCh.command('searchbar:focused');
	                },
	                preCollapse: function () {
	                    lCh.command('searchBar:collapsed');
	                },
	                onAfterHighlightActiveHit: function ($activeHit) {
	                    if ($activeHit.length > 0) _activeHitHighlightCB.apply(_cxt, arguments);
	                },
	                keyUp: function() {
	                    _keyUpNotGrepMode.apply(_cxt, arguments); //not using bind for perf
	                },
	                onAfterKeyUpInGrepMode: function () {
	                    _searchBarKeyUpGrepMode.apply(_cxt, arguments);
	                },
	                onToggleGrep: function (mode, searchTxt) {
	                    lCh.command('toggleLocalGrepMode', {
	                        mode: mode,
	                        searchTxt: searchTxt
	                    });
	                }
	            });
	        this.children.add(searchView, 'searchBar');
	        this.ui.searchWidgetPH.replaceWith(searchView.render().$el);
	    },
	    updateSearchBarAfterPageViewRender: function ($searchContainer, highlightHitIndex) {
	        var sb = this.children.findByCustom('searchBar');
	        sb.triggerMethod('content:reset', $searchContainer, highlightHitIndex);
	    },
	    setSearchBarText: function(txt) {
	        var sb = this.children.findByCustom('searchBar');
	        //sb.triggerMethod('content:reset', $searchContainer, txt); --TODO: combo
	        sb.triggerMethod('setSearchText', txt);
	    },
	    onBeforeDestroy: function () {
	        //_.invoke([this.ui.toggleWrapTextBtn, this.children.findByCustom('searchBar')], 'destroy');
	        //if in err view error the above won't exit -- would really want equivalent of 'blind trigger'
	        var $wrapTxtBtn = this.ui.toggleWrapTextBtn,
	            searchBar = this.children.findByCustom('searchBar');
	
	        $wrapTxtBtn.length > 0 && $wrapTxtBtn.destroy();
	        searchBar && searchBar.destroy();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 527 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <option value=\""
	    + alias2(alias1((depth0 != null ? depth0.number : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.label : depth0), depth0))
	    + "</option>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"esButtonWr\">\n\n            <button id=\"wrapTextBtn\" type=\"button\" class=\"btn btn-mini btn-hvr\">\n                <i class=\"icon-text-width\"></i>\n            </button>\n            <button id=\"esSelectAll\" type=\"button\" class=\"btn btn-mini btn-hvr\" title=\"Select All\">\n                <i class=\"icon-doc-text-1\"></i>\n            </button>\n            <div id=\"esFontSizeWr\">\n                <button id=\"esLarger\" type=\"button\" class=\" btn btn-mini btn-hvr\" title=\"Increase Font Size\">\n                    <i class=\"icon-font font-larger\"></i>\n                    <i class=\"fontArrow icon-up-dir\"></i>\n                </button>\n                <button id=\"esSmaller\" type=\"button\" class=\" btn btn-mini btn-hvr\" title=\"Decrease Font Size\">\n                    <i class=\"icon-font font-smaller\"></i>\n                    <i class=\"fontArrow icon-down-dir-1\"></i>\n                </button>\n            </div>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "        <select class=\"esPageSelect\" title=\"Go to page\"></select>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div data-searchWidget=\"true\"></div>\n\n<div id=\"esHeadRight\">\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.error : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.error : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>";
	},"useData":true});

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(531);
	
	var Marionette = __webpack_require__(61);
	var FullTextSearchBar = __webpack_require__(532);
	var NAVHits = __webpack_require__(535);
	
	__webpack_require__(516);
	
	module.exports = Marionette.LayoutView.extend({
	    template: __webpack_require__(538),
	    initialize: function() {
	        this.listenTo(this.options.lCh, 'updateGrepToggleBtnState', this._updateGrepBtnState );
	    },
	    regions: {
	        center:     '#esFootCenter',
	        right:      '#esFootRight'
	    },
	    ui: {
	        toggleHitBtn:       '#esToggleHits',
	        toggleGrepBtn:      '#esToggleGrep',
	        toggleSimpleBtn:    '#esToggleSimple'
	    },
	    serializeData: function() {
	
	        var nHits = this.model.getNumberOfHits(),
	            noHitsExist = nHits < 1;
	
	        return {
	            docOnServerAndNoFetchErr: this.model.docOnServerAndNoFetchErr(),
	            showNoResultsFoundIndicator: noHitsExist && !this.model.isBlankSearch(),
	            showHitNav: this.options.lCh.request('showHitsInView'),
	            showGrepBtn: !noHitsExist //-- disable instead b/c of space?
	        };
	
	    },
	    onBeforeShow: function() {
	
	        var opts = {
	            model: this.model,
	            lCh: this.options.lCh
	        };
	
	        this._createToggleSimpleBtn();
	        this._createToggleGrepBtn(); //always create/show: if switching documents, and grep mode is on, and no hits are found, it looks like no text was returned from the query
	
	        if (this.model.getNumberOfHits() > 0) {
	            this._createToggleHitsBtn();
	        }
	
	        this.center.show(new FullTextSearchBar(opts));
	
	        /* besides errors here, must check if there are hits -- unlike other places -- otherwise the html will be overwritten when no results */
	        this.model.docOnServerAndNoFetchErr() && this.model.getNumberOfHits() > 0 && this.right.show( new NAVHits(opts) ) ;
	    },
	    _createToggleHitsBtn: function() {
	         var lc = this.options.lCh;
	         this.ui.toggleHitBtn.toggleButton({
	            isActive: lc.request('showHitsInView'),
	            toggleAction: function() {
	                lc.command('showHits');
	            },
	            activeTitle: 'Hide',
	            inactiveTitle: 'Show'
	        });
	    },
	    _createToggleGrepBtn: function() {
	        var lc = this.options.lCh;
	        this.ui.toggleGrepBtn.toggleButton({
	            isActive: lc.request('isInGrepMode'),
	            toggleAction: function() {
	                lc.command('toggleGrepMode');
	            },
	            activeTitle: 'Show all lines',
	            inactiveTitle: 'Only show lines with hits'
	        });
	    },
	    _createToggleSimpleBtn: function() {
	        var lc = this.options.lCh;
	        this.ui.toggleSimpleBtn.toggleButton({
	            isActive: lc.request('isInSimpleMode'),
	            toggleAction: function() {
	                lc.command('toggleSimpleMode');
	            },
	            activeTitle: 'Exit Simple Mode',
	            inactiveTitle: 'Enter Simple Mode'
	        });
	    },
	    /* necessary b/c mode can be toggle not just by clicking the btn: eg clicking a hit */
	    _updateGrepBtnState: function(grepMode) {
	        this.ui.toggleGrepBtn.trigger(grepMode ? 'toggleOn': 'toggleOff');
	    },
	    onBeforeDestroy: function() {
	        //_.invoke([this.ui.toggleHitBtn, this.ui.toggleGrepBtn], 'destroy');
	        this.ui.toggleHitBtn.destroy && this.ui.toggleHitBtn.destroy(); //hmmm sometimes, doesn't have the fn
	        this.ui.toggleGrepBtn.length > 0 && this.ui.toggleGrepBtn.destroy(); //(may not exist)
	        this.ui.toggleSimpleBtn.length > 0 && this.ui.toggleSimpleBtn.destroy();
	        this.$('*').remove();
	        this.$el.remove();
	    }
	   
	});

/***/ },
/* 531 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(533);
	
	var Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
	    id: 'esSearchInputWr',
	    template: __webpack_require__(534),
	    initialize: function(options) {
	        _.extend(this, _.pick(options, 'lCh', 'model'));
	    },
	    onRender: function() {
	        this.model.docOnServerAndNoFetchErr()
	            ? this.ui.searchOverlay.append( this.generateSearchMarkup() ) //append to avoid xss
	            : this.ui.searchOverlay.text(this.model.searchText);
	    },
	    serializeData: function () {
	        var m = this.model;
	        return {
	            search: m.searchText, //(the input)
	            showEditButton: (m.docOnServerAndNoFetchErr() )
	        };
	    },
	    ui: {
	        newSearchBtn:       '#newSearch',
	        searchTxtInput:     '#esSearchTerm',
	        newSearchOK:        '.ok',
	        newSearchCancel:    '.cancel',
	        searchOverlay:      '#esSearchOverlay'
	    },
	    events: {
	        'click @ui.searchOverlay': function(e) {
	            e.stopPropagation();
	            var $target = $(e.target);
	            if (!$target.hasClass('esWord'))
	                return;
	            this.lCh.command('applyLocalSearchFromESWordClick', $target.text());
	        },
	        'click @ui.newSearchOK': function () {
	            this.lCh.command('resetSearch', this.ui.searchTxtInput.val());
	        },
	        'click @ui.newSearchBtn': function () {
	            this.lCh.command('toggleSearchBarState', true);
	        },
	        'click @ui.newSearchCancel': function () {
	            this.lCh.command('toggleSearchBarState', false);
	        },
	        'keyup @ui.searchTxtInput': 'keyPressedInNewSearchInput'
	    },
	    keyPressedInNewSearchInput: function(e) {
	        var key = e.keyCode ? e.keyCode : e.which;//norm for IE8 //todo: this would be part of the ok, cancel plugin
	        e.stopPropagation(); //prevent mousetrap bubble
	        (key === 13) && this.lCh.command('resetSearch', this.ui.searchTxtInput.val());
	        (key === 27) && this.lCh.command('toggleSearchBarState', false);
	    },
	    generateSearchMarkup: function() {
	        var searchTxt = this.model.searchText;
	        var words = searchTxt.split(' '); //TODO: STOP WORDS -- AND OR
	        return _.map(words, function(w) {
	            return '<span class="esWord" title="Find ' + w + '">' + w + '</span><span> </span>'; //extra span at end ok
	        });
	
	    },
	    onToggleSearchReset: function(ui, isEnabled) {
	        var $input = this.ui.searchTxtInput;
	        this.$el.toggleClass('active', isEnabled);
	        this.ui.newSearchOK.toggleClass('btn-focus-primary', isEnabled);
	        isEnabled
	            ? $input.select()
	            : $input.val(this.model.searchText);
	    },
	    onBeforeDestroy: function() {
	        this.off();
	        this.$('*').remove();
	        this.$el.remove();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 533 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "\n    <div id=\"esSearchActionBtns\">\n\n        <button id=\"newSearch\" type=\"button\" class=\"btn btn-mini btn-hvr\" title=\"Edit Search...\">\n            <i class=\"icon-edit-2\"></i>\n        </button>\n\n        <div id=\"esSaveCancel\" class=\"inline hide\">\n            <button class=\"btn btn-mini btn-primary ok\" title=\"Save\">  <!-- todo: partial / jq plugin / view -- same as in notes -->\n                <i class=\"icon-ok\"></i>\n            </button>\n            <button class=\"btn btn-mini btn-danger cancel\" title=\"Cancel\">\n                <i class=\"icon-cancel-1\"></i>\n            </button>\n        </div>\n\n    </div>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"esSearchTextWr\">\n    <input id=\"esSearchTerm\" value=\""
	    + container.escapeExpression(((helper = (helper = helpers.search || (depth0 != null ? depth0.search : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"search","hash":{},"data":data}) : helper)))
	    + "\" placeholder=\"Search\" title=\"Full Text Search Query\">\n    <div id=\"esSearchOverlay\"></div>\n</div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showEditButton : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(536);
	
	var Marionette = __webpack_require__(61);
	__webpack_require__(76); //unselectable
	
	module.exports = Marionette.ItemView.extend({
	  id: 'esNAV',
	  template: __webpack_require__(537),
		ui: {
			hitBtns:            '.hitNavbtn',
			activeHitNumber:    '.curESHit',
	        numberHits:         '.nESHits',
	        navBar:             '.esNAVBtns'
		},
	    initialize: function() { //TODO: have as command ...
	        var lCh = this.options.lCh;
	        this.listenTo(lCh, 'navView:toggleHits',        this.hitsToggledCB);
	        this.listenTo(lCh, 'navView:updateHitCount',    this.updateHitCount);
	        this.listenTo(lCh, 'navView:update',            this.update);
	        lCh.reply({
	            navView: function() {
	              return this;
	            }
	        }, this);
	    },
		events: {
	        'click @ui.hitBtns':  'hitButtonClick'
	  },
	    serializeData: function() {
	        var nHits = this.model.getNumberOfHits();
	        return {
	          activeHitNumber: this.options.lCh.request('currentHitNumber'), //note: will be updated anyway, maybe unecessary
	          numHits: nHits
	        };
	    },
	    onRender: function() {
	        this.$el.unselectable();
	    },
	    hitButtonClick: function(e) {
	        this.options.lCh.command('hitButtonClick', $(e.currentTarget).attr('title') );
	    },
	    hitsToggledCB: function(show) {
	        this.$el.toggleClass('noOpacity', !show);
	    },
	    updateHitCount: function(hitPosition) {
	        this.ui.activeHitNumber.text(hitPosition + 1);
	    },
	    /* update the activeHitNumber and the total number of hits */
	    update: function(activeHitPosition, totalHits ) {
	        this.updateHitCount(activeHitPosition);
	        this.ui.numberHits.text(totalHits);
	        //'no results found' replaces this on search w/ no results -- if there are none
	        this.$el.toggleClass('hide', totalHits === 0);
	        //TODO: may also want to toggle the 'grep button'
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 536 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"esHitLbl\">\n    <span class=\"curESHit\">"
	    + alias4(((helper = (helper = helpers.activeHitNumber || (depth0 != null ? depth0.activeHitNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"activeHitNumber","hash":{},"data":data}) : helper)))
	    + "</span>\n    <span>of </span>\n    <span class=\"nESHits\">"
	    + alias4(((helper = (helper = helpers.numHits || (depth0 != null ? depth0.numHits : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numHits","hash":{},"data":data}) : helper)))
	    + "</span>\n</div>\n<div class=\"esNAVBtns\">\n    <button type=\"button\" class=\"esPrev hitNavbtn btn btn-mini btn-hvr\" title=\"Previous\">\n        <i class=\"icon-left-circled\"></i>\n    </button>\n    <button type=\"button\" class=\"esNext hitNavbtn btn btn-mini btn-hvr\" title=\"Next\">\n        <i class=\"icon-right-circled\"></i>\n    </button>\n    <button type=\"button\" class=\"esFirst hitNavbtn btn btn-mini btn-hvr\" title=\"First\">\n        <i class=\"icon-to-start\"></i>\n    </button>\n    <button type=\"button\" class=\"esLast hitNavbtn btn btn-mini btn-hvr\" title=\"Last\">\n        <i class=\"icon-to-end\"></i>\n    </button>\n</div>\n";
	},"useData":true});

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "        <button id=\"esToggleSimple\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">S</button>\n\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showGrepBtn : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "            <button id=\"esToggleGrep\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">\n                <i class=\"icon-filter\"></i>\n            </button>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "        <div id=\"esNoResults\">\n            <i class=\"icon-attention-circled\"></i>\n            No Hits\n        </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showHitNav : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"7":function(container,depth0,helpers,partials,data) {
	    return "            <div class=\"esNAV\"></div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"esFootLeft\">\n\n    <button id=\"esToggleHits\" type=\"button\" class=\"btn btn-mini btn-hvr btn-hvr-border\">HITS</button>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.docOnServerAndNoFetchErr : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>\n\n<div id=\"esFootCenter\"></div>\n\n<div id=\"esFootRight\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showNoResultsFoundIndicator : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
	    + "</div>";
	},"useData":true});

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(540);
	
	var Marionette = __webpack_require__(61),
	    Mousetrap = __webpack_require__(68),
	
	    PageView = __webpack_require__(541),
	    FCFieldView = __webpack_require__(544),
	    DocPropView = __webpack_require__(547),
	    DocNotesView = __webpack_require__(548),
	    RmaPropsView = __webpack_require__(549);
	
	__webpack_require__(76);
	__webpack_require__(114);
	
	/* Note: also contains the jQ $hits -- all interactions with go through here */
	module.exports = Marionette.CollectionView.extend({
	    className: 'ftPages',
	    getChildView: function(pageModel) {
	        switch ( pageModel.get('pgViewType') ) {
	            case 'FC_FIELDS':
	                return FCFieldView;
	            case 'DOC_PROPS':
	                return DocPropView;
	            case 'DOC_NOTES':
	                return DocNotesView;
	            case 'RMA_PROPS':
	            case 'SECURITY_PROPS':
	                return RmaPropsView;
	            default: 
	                return PageView;
	        }
	
	    },
	    childViewOptions: function() {
	        //now only passing what's needed, could pass lCh, state ...
	        return {
	            pageLabelAction: this.options.state.get('pageLabelAction')
	        };
	    },
	    initialize: function(options) {
	        _.extend(this, _.pick(options, 'lCh', 'collection'));
	        this.lCh.comply({
	            calcPageBottoms: this.calcPageBottoms
	        }, this);
	    },
	    onRender: function() {
	        var state = this.options.state;
	        state.get('grepMode') && this.$el.addClass('grepMode');
	        state.get('localGrepMode') && this.$el.addClass('localGrepMode');
	        state.get('wrapText') && this.$el.addClass('wrapText');
	    },
	    onShow: function() {
	        this.children.length > 0 && this.children.last().$el.addClass('lastPage');
	    },
	    // TODO: rename
	    calcPageBottoms: function() {
	        var tHt = 0;
	        this.collection.each(function(p, i) {
	            p.set('top', tHt);
	            tHt += this.children.findByIndex(i).$el.outerHeight();
	            p.set('bottom', tHt);
	        }, this);
	    },
	    onWrapTextToggle: function() {
	        this.$el.toggleClass('wrapText'); //allow overflow/not
	        this._postSizeChangeActions();
	    },
	    _postSizeChangeActions: function() {
	        //TODO: got back to relative scroll position
	        this.calcPageBottoms();
	    },
	    onBeforeDestroy: function() {
	        this.lCh.stopComplying('calcPageBottoms');
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 540 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(542);
	
	var Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
	    className: 'esPage',
	    //Note: ensure no white-space in the template
	    // ... look at better way to accomplish (eg if more content added)?
	    template: __webpack_require__(543),
	    ui: {
	        'pageText':     '.esPageText',
	        'pageNumber':   '.esPgNum'
	    },
	    onRender: function() {
	
	        var m = this.model,
	            pgLabelAction = this.options.pageLabelAction;
	
	        this.$el
	            .attr('data-page-num', m.get('pgNum') ) // still using for closest hit (?)
	            .addClass( m.get('viewCssClass') );
	
	        this.ui.pageNumber.unselectable();
	
	        if ( pgLabelAction && m.get('pgViewType') === 'PAGE' )
	            this._setUpPageAction(pgLabelAction);
	
	    },
	    // Note: only called if setUpPageAction provided as option to widget
	    _setUpPageAction: function(pgLabelAction) {
	
	        var m = this.model;
	
	        if ( pgLabelAction.onClick ) {
	
	            // Note: confirmed no more detached DOM nodes exist on destroy with this event handler
	            // (should be turned off with jq remove on destroy)
	
	            this.ui.pageNumber.on('click', function () {
	
	                pgLabelAction.onClick.call( this, {
	                    number: m.get('pgNum'),
	                    id: m.get('pgId')
	                } );
	
	            });
	        }
	
	        if ( pgLabelAction.appearAsLink )
	            this.ui.pageNumber.addClass('link');
	
	        if ( pgLabelAction.title ) {
	
	            var title = !_.isFunction( pgLabelAction.title )
	                ? pgLabelAction.title
	                : pgLabelAction.title.call( this.ui.pageNumber[0], m.get('pgNum'));
	
	            this.ui.pageNumber.attr('title', title );
	
	        }
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 542 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<div class=\"esPgNum\">"
	    + container.escapeExpression(((helper = (helper = helpers.pgLbl || (depth0 != null ? depth0.pgLbl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgLbl","hash":{},"data":data}) : helper)))
	    + "</div><div class=\"esPageText\">"
	    + ((stack1 = ((helper = (helper = helpers.pgText || (depth0 != null ? depth0.pgText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgText","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</div>";
	},"useData":true});

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(545);
	
	var ESPageView = __webpack_require__(541);
	
	/* note: whitespace must be removed from template */
	var subTemplate = __webpack_require__(546);
	
	module.exports = ESPageView.extend({
	    subTemplate: subTemplate,
	    sectionLabel: 'File Cabinet Fields',
	    serializeData: function() {
	        return {
	            pgLbl: this.model.get('pgLbl'),
	            pgText: this.subTemplate({
	                /* field name X markup from es with hit */
	                fieldHits: this.model.get('pgText')
	            })
	        };
	    }
	
	
	});

/***/ },
/* 545 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper;
	
	  return "<li><span class=\"fcField\">"
	    + container.escapeExpression(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"key","hash":{},"data":data}) : helper)))
	    + ":</span><span class=\"fcFieldValue\">"
	    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
	    + "</span></li>";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<ul>"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.fieldHits : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</ul>";
	},"useData":true});

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	var FCFieldsView = __webpack_require__(544);
	
	//(for now just a field value pair like the fields */
	module.exports = FCFieldsView.extend();

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var FCFieldsView = __webpack_require__(544);
	
	module.exports = FCFieldsView.extend({
	    onRender: function () {
	        FCFieldsView.prototype.onRender.apply(this, arguments);
	        this.$('.fcField').remove();  // TODO: this all from hack, could boost perf with diff template if continue this way
	    }
	});
	


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var FCFieldsView = __webpack_require__(544);
	
	module.exports = FCFieldsView.extend({
	
	    serializeData: function() {
	
	        // field name X markup from es with hit /
	        var modelPgText = this.model.get('pgText');
	
	        // when upgrade underscore, could use mapObject / equivalent ...
	        // may be problematic here if hit returned in html
	        // what this does is takes array and turns to list ... could be done in the model fn itself if that's easier
	
	        var transformedKeysByLists = {};
	        for (key in modelPgText) {
	            transformedKeysByLists[key] = modelPgText[key].join(', ');
	        }
	
	        return {
	            pgLbl: this.model.get('pgLbl'),
	            pgText: this.subTemplate({
	                fieldHits: transformedKeysByLists
	            })
	        };
	
	    }
	});

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58);
	
	/* keys in order of display -- top to bottom b/f pages appear */
	var SECTION_XREF = {
	    FC_FIELDS: {
	        lbl: 'FC Fields',
	        viewClass: 'fcFields'
	    },
	    SECURITY_PROPS: {
	        lbl: 'Security',
	        viewClass: 'rmaProps'
	    },
	    RMA_PROPS: {
	        lbl: 'RMA',
	        viewClass: 'rmaProps'
	    },
	    DOC_PROPS: {
	        lbl: 'Doc Props',
	        viewClass: 'docProps'
	    },
	    DOC_NOTES: {
	        lbl: 'Doc Notes',
	        viewClass: 'docNotes'
	    }
	};
	
	
	var Pg = Backbone.Model.extend({
		defaults: {
	        pgViewType: 'PAGE', //Others: FC_FIELDS, DOC_PROPS, DOC_NOTES; the basis for the child view type
	        pgNum: null,
			pgText: null,
	        pgId: null, //( only applicable for page types ... may want to subclass this in the future )
			top: null,
			bottom: null,
	        pgLbl: null,
	        viewCssClass: ''
		},
	    initialize: function() {
	        var type = this.get('pgViewType');
	        if (type !== 'PAGE') {
	            var sectionKeys = _.keys(SECTION_XREF).reverse();
	            this.set({
	                pgNum: sectionKeys.indexOf(type) * - 1 ,
	                pgLbl: SECTION_XREF[type].lbl,
	                viewCssClass: SECTION_XREF[type].viewClass
	            });
	        } else {
	            this.set({
	                pgLbl: 'Page ' + this.get('pgNum')
	            });
	        }
	    }
	});
	
	
	var Pgs = Backbone.Collection.extend({
		model: Pg,
	    comparator: 'pgNum', //sort by page num
		getByScrollPosition: function(curScrTop) {
			return this.filter(function(p) {
				return curScrTop >= p.get('top') && curScrTop <=  p.get('bottom');
			})[0];
	
		},
	    hasPageNumber: function(pgNum) {
	        return _.contains( this.pluck('pgNum'), pgNum );
	    }
	});
	
	
	module.exports = Pgs;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, $) {__webpack_require__(552);
	__webpack_require__(76);
	
	Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
		className: 'esErrWr',
		template: __webpack_require__(553),
		serializeData: function() {
	
			var m = this.options.model,
				docNotOnServer = m.docNotOnESServer(),
				esFetchFailure = m.getFetchErr(),
				errMsg;
	
			// should put in model facade / clean
			esFetchFailure && (errMsg = $.fn.ajaxErrorMessage( m.getFetchErr() ));
			docNotOnServer && (errMsg = 'Document text currently unavailable');
	
			return {
				errorMsg: errMsg,
				notFoundOnServer: docNotOnServer
			};
		}
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(59)))

/***/ },
/* 552 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "    <div class=\"lighterErrMsg\">\n        "
	    + container.escapeExpression(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"errorMsg","hash":{},"data":data}) : helper)))
	    + "\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <div id=\"esErrMessage\">\n        <div id=\"esErrHead\">\n            <span class=\"icon icon-attention-circled\"></span>\n            <span>Error</span>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.notFoundAgainOnServer : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            </span>\n        </div>\n        <div id=\"esErrContent\" title=\""
	    + alias4(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errorMsg","hash":{},"data":data}) : helper)))
	    + "\">\n            "
	    + alias4(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errorMsg","hash":{},"data":data}) : helper)))
	    + "\n        </div>\n    </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "                    <div>\n                        <span class=\"lbl-again label label-important\">again</span>\n                    </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.notFoundOnServer : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*
	 Scroll an element to the center of a container viewport element (position relative to the container */ 
	
	    // yOffset is addition amount to add to the position of the element (eg if want in relation to diff element)
	(function($) {
	    //todo: could incorporate overlap
	    $.fn.centeredScroll = function($scroller, yOffset, xOffset, cb) { 
	        var $el = this,
	            
	            elOffset = $el.position(),
	            
	                yToScroll = elOffset.top + (yOffset ? yOffset : 0),
	                xToScroll = elOffset.left + (xOffset ? xOffset : 0),
	            
	                elHeight = $el.height(),
	                elWidth = $el.width(),
	           
	            viewPortHeight = $scroller.height(),
	            viewPortWidth =  $scroller.width();
	           
	        yToScroll = elHeight < viewPortHeight
	            ? yToScroll - (viewPortHeight / 2) - (elHeight / 2)
	            : yToScroll;
	
	        xToScroll = (elWidth < viewPortWidth)
	            ? xToScroll - (viewPortWidth / 2) - (elWidth / 2)
	            : xToScroll;
	
	    
	        $scroller.stop().animate({
	            scrollTop: yToScroll,
	            scrollLeft: xToScroll
	        }, {
	            duration: 0,
	            complete: setTimeout(function() { /* allow scroll to complete first */
	                cb && typeof cb === "function" && cb();
	            },0)
	        });
	
	    };
	
	
	}(jQuery));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "grepMode";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "hideHits";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"esHeader\" data-region=\"true\"></div>\n    <div class=\"esContentWr "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.grepMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideHits : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" >\n        <div class=\"esContentInnerWr\" data-region=\"true\" data-scroller=\"true\"></div>\n    </div>\n<div id=\"esFooter\" data-region=\"true\" ></div>\n\n";
	},"useData":true});

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59);
	
	//TODO: break out widget options from the original state when have to time rewrite module
	
	/* defaults for nested option obj pageLabelAction
	 * only come into play if pageLabelAction is provided and these aren't
	 * default use case is to for calling app to launch the viewer from the given page
	 * should now have separate settings object for the plugin ... (do when reorganize)
	 * doesn't include onClick -- default is undefined
	 */
	
	var PG_LBL_ACTION_DEFAULTS = {
	    title: function(pgNumber) {
	        return 'Launch Page ' + pgNumber + ' in Document Viewer';
	    },
	    appearAsLink: true
	};
	
	var State = Backbone.Model.extend({
	    hitSelector: '.hit',
	    initialize: function() {
	        this.$hits = null;
	        //note: attributes already set by this point in BB lifecycle -- quick fix for applying defaults to pageLabelAction (if it exists)
	        var pageLabelAction = this.get('pageLabelAction');
	        if (pageLabelAction) {
	            this.set( 'pageLabelAction',  _.extend({}, PG_LBL_ACTION_DEFAULTS, pageLabelAction) );
	        }
	    },
	    defaults: {
	
	        /* attributes to persist across doc change render requests -- currently, not part of the viewer API/config, only the widget */
	        simpleMode: true, //if true (the default)-- only shows fields, doc properties, and doc that have hits
	        showHits: true,
	        grepMode: false,
	        wrapText: true,
	        fontEmSize: 1,
	        localSearchText: "",
	        localGrepMode: false,
	        pageLabelAction: null, //note: this is a nested obj (with defaults, above)... see documentation
	
	        // original state attributes ... the above should be in a setting object
	        currentPg: 1,
	        activeHitNumber: - 1, // start assuming not in set
	        _lastHitLine: null,
	        _lastHitPage: null,
	        lastScrollTop: 0,
	        searchInputEnabled: false /* attr changed that fires event when user clicks edit search */
	    },
	    getArrayOfAttributesToPersist: function() {
	        //NOTE: the search text, docId, and url are stored on the ES model -- which is fetched prior to creation/rendering of the module
	        return ['showHits', 'grepMode', 'wrapText', 'fontEmSize', 'simpleMode', 'localSearchText', 'localGrepMode', 'pageLabelAction'];
	    },
	    getAttributesToPersistOnReset: function() {
	        return _.pick( this.toJSON(), this.getArrayOfAttributesToPersist() );
	    },
	    /* set the hits and the active hit index, always triggering a change to scroll back to the active hit, called after page view renders */
	    setHits: function($containingEl, options) { /* now not only done once options.initialLoadCallback -- will go to next */
	
	        this.$hits = $containingEl.find(this.hitSelector);
	
	        if (!options.fromGrepToggle && !options.fromSimpleModeToggle) {
	            this.navigateHits('Next', options);
	            return;
	        }
	
	        //hits that did exist may no longer (content swapped)
	        //TODO: OK DECIDE & CLEAN ... EG ALL COULD HAVE LIST PG AND HIT LINE, (AND USE THAT FOR NAVIGATION --
	        // but would need to either print the hit number of the line in question or derive it in here via jquery)
	
	        if (!this.get('localGrepMode')) {
	            //Activate the current -- all hits will be shown in ES GREP/ no GREP at all (if ANY EXIST); force change b/c will be the same hit, so scroll to it
	            this.setActiveHit(this.get('activeHitNumber'), options);
	            return;
	        }
	
	        /* LOCAL GREP MODE */
	
	        //in local grep .... content is always reset
	        if (!this.previous('localGrepMode')) {
	            //if toggling in from first time, go to the first hit -- only printing data attributes on local grep
	            this.setActiveHit( 0, options );
	
	        } else {
	            //content change from typing
	            var lastHitPg = this.get('_lastHitPage');
	            var lastHitLine = this.get('_lastHitLine');
	
	            //TODO: COULD BE MORE THAN 1 (would need to derive the number of the line) -- NOW JUST TAKING THE FIRST as quick fix
	            var $lastHit =  this.$hits.filter( function() {
	                var data = $(this).data();
	                return data.pg === lastHitPg && data.line === lastHitLine;
	            }).eq(0);
	
	            this.setActiveHit( this.$hits.index($lastHit), options);
	
	        }
	
	    },
	    /* also sets active hit numbers */
	    navigateHits: function(action, options) {
	        var max = this.$hits.length - 1,
	            activeHitNumber = this.get('activeHitNumber'),
	            actionHitNum = { 
	                Next: function() {
	                    return activeHitNumber + 1;
	                },
	                Previous: function() {
	                    return activeHitNumber - 1;
	                },
	                First: function() {
	                    return 0;
	                },
	                Last: function() {
	                    return max;
	                }
	            },
	            hitPosition = actionHitNum[action]();
	
	        /* prevent jq wrapping */
	        if (hitPosition === -1 && activeHitNumber === 0) return false;
	        if (hitPosition === max + 1 && activeHitNumber === max) return false;
	
	        this.setActiveHit(hitPosition, _.extend( {}, options, {fromNavigation: true}));
	    },
	    /* mark hit */
	    setActiveHit: function(hitPosition, options) {
	
	        //always force change -- WANT THE CALLBACK -- COULD TRIGGER EVENT INSTEAD
	        this.set('activeHitNumber', null, {silent: true});
	
	        this.$hits.length > 0 && this.$hits.removeClass('active');
	
	        var $hit = this.$hits.eq(hitPosition);
	        $hit && $hit.length > 0 && $hit.addClass('active');
	
	        this.set({
	            activeHitNumber: hitPosition,
	            _lastHitLine: $hit.data('line'), //TODO: REALLY ONLY WAS DOING FOR LOCAL GREP
	            _lastHitPage: $hit.data('pg')
	        }, options) ;
	
	    },
	    //call when clicking out of es grep
	    setActiveHitIndex: function($hit) {
	            this.set({
	                activeHitNumber: this.$hits.index( $hit )
	            },  {silent: true} //todo: always want to scroll to set page?
	        );
	    },
	    changeFontSize: function(how) {
	        var fs =  this.get('fontEmSize');
	        this.set({fontEmSize: fs + ( (fs * 0.10) * (how === 'larger' ? 1: - 1) ) });
	    },
	    getActiveHit: function() {
	        return this.$hits.eq(this.get('activeHitNumber'));
	    },
	    /* currently used pre-toggle grep mode */
	    activeHitIsFirstOrLast: function() {
	        var n = this.get('activeHitNumber');
	        return n === 0 || n === this.$hits.length - 1;
	    },
	    getNumberOfHits: function() {
	        return this.$hits.length;
	    },
	    cleanHits: function() {
	        if (this.$hits) {
	            this.$hits.remove();
	            this.$hits = null;
	        }
	    },
	    destroy: function() {
	        this.cleanHits();
	        Backbone.Model.prototype.destroy.call(this);
	    }
	});
	
	module.exports = State;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(558);
	
	var Marionette = __webpack_require__(61),
		Spinner = __webpack_require__(159);
	
	
	//todo pass doc info (or other info)
	
	module.exports = Marionette.ItemView.extend({
		className: 'FV-reset-wr',
		template: __webpack_require__(559),
		ui: {
			spinHolder: '[data-spin-holder]' //todo: could be behavior
		},
		onRender: function() {
			this.unwrap();
			this.spinner = new Spinner({
				color: '#FFF'
			});
			this.ui.spinHolder.append( this.spinner.render().el );
		},
		onBeforeDestroy: function() {
			this.spinner.destroy();
		}
	});

/***/ },
/* 558 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"FV-reset-wr\">\n	<div class=\"reset-lbl-wr\">\n		<span data-spin-holder=\"true\"></span>\n		<span class=\"reset-loading-label\">Loading ...</span>\n	</div>\n</div>";
	},"useData":true});

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {__webpack_require__(561);
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    DocModeContainer = __webpack_require__(414), //TODO: create mixin for dmc and this
	    ThumbImgWr = __webpack_require__(562),
	    UnRenderableThumb = __webpack_require__(564),
	    UrlThumb = __webpack_require__(567),
	    MultiPartGosPgThumb = __webpack_require__(570);
	
	
	__webpack_require__(458);
	__webpack_require__(60); //(simple enough now for now supapp ....)
	
	
	module.exports = Marionette.CompositeView.extend({
	
	    lazyLoadDelay: 500,   //delay also prevents from loading too many images
	    template: __webpack_require__(571),
	    childViewContainer: '.thumb-scroller',
	
	    constructor: function(options) {
	
	        // Prevent need to pass in option -- greatly optimizes for pages with large documents
	        // Note: not helping perf like the Doc Mode Container
	        this.sort = false;
	
	        Marionette.CompositeView.prototype.constructor.apply( this, arguments );
	
	        // From old initialize:
	        _.bindAll(this, 'checkForPagesInView');
	
	        _.extend(this, Backbone.Radio.Channel.prototype);
	
	        this.reply({
	            childViews: function() {
	                return this.children;
	            }
	        });
	
	        this.comply({
	            checkInView: _.partial(this.checkForPagesInView),
	            listenForThumbsToBeInView: this._listenForThumbsToBeInView,
	            goToThumb: this.goToThumb
	        });
	
	    },
	
	    getChildView: function(model) {
	
	        if ( model.renderUrlViewForThumbnail() )
	            return UrlThumb;
	
	        if ( model.isMultipartGos() )
	            return MultiPartGosPgThumb;
	
	        return model.isRenderable()
	            ? ThumbImgWr
	            : UnRenderableThumb;
	
	    },
	
	    childViewOptions: function() {
	        return {
	            vChannel: this.options.vChannel,
	            parent: this
	        };
	    },
	
	    ui: {
	        thumbScroller:  '.thumb-scroller-wr',
	        thumbContainer: '.thumb-scroller'
	    },
	
	    onRender: function() {
	
	        this.unwrap();
	        this.ui.thumbScroller.scrollTop(0);
	        this.options.vChannel.request('loadImages') && this._listenForThumbsToBeInView();
	        this.ui.thumbScroller.on('scroll', _.bind(this.onScroll, this)); //scroll event does not delegate: can't put in events hash
	
	    },
	
	    onScroll: function(e) {
	        this.options.vChannel.command('forceClosePageActionDropdownMenus');
	    },
	    /* separated from onRender in case loadImages = false; so also called from toggle allow images to load */
	    _listenForThumbsToBeInView: function() {
	        $(this.children.pluck('el')).lazyLoad({
	            container: this.ui.thumbScroller,
	            delay: this.lazyLoadDelay,
	            skipClass: 'invisible'
	        });
	    },
	
	    // Apply to the direct parent container -- fires the event (not the scroll event handler already set)
	    checkForPagesInView: function() {
	
	        this.ui.thumbContainer.trigger('checkInView');
	
	    },
	
	    /**
	     * Link between main scroller and sidescroller.
	     * Basically calc the current top and bottom thresholds of the container and see if the element is in the above or below it)
	     **/
	    goToThumb: function( pgOrThumb ) {
	
	        var vCh = this.options.vChannel,
	            thumbModel = pgOrThumb instanceof this.collection.at(0).constructor  //* always convert to thumbNail */
	                ? pgOrThumb
	                : vCh.request('getThumbFromPageModel', pgOrThumb),
	            thumbView = this.children.findByModel(thumbModel),
	            $thumbEl = $(thumbView.el),
	            thumbPadding = fvChannel.request('cssConstants').V_PADDING,
	            tsScrollTop = this.ui.thumbScroller.scrollTop(), //the outer
	            thumbHeight = thumbModel.getRotatedHeight() + (2 * thumbPadding),
	
	            //calc these from the vThumbOffsets
	            currentThumbBottom = $thumbEl.position().top + thumbHeight + thumbPadding + tsScrollTop,   //can also use the voffset of the prior page + thumbPadding
	            currentThumbTop = currentThumbBottom - thumbHeight,
	            topYThreshold = tsScrollTop,
	            bottomYThreshold = this.ui.thumbScroller.height() +  tsScrollTop,  //(the bottom of the abs div + any scrolltop amt
	            scrollToPosition = 0;
	
	        thumbView.highlight();
	
	        /* scroll */
	        if (currentThumbBottom > bottomYThreshold) {    //if bottom of the current thumb is below the threshold
	
	            scrollToPosition = currentThumbTop  - thumbPadding; //set thumbscrollerTop to the top of the current page position
	            this.ui.thumbScroller.scrollTop(scrollToPosition );               //this one is accurate
	
	        } else if (currentThumbTop < topYThreshold) {
	
	            var prevThumb = this.collection.at( this.collection.indexOf(thumbModel) - 1 ),
	            prevThumbView = prevThumb  ? this.children.findByModel(prevThumb) : null,
	            scrollToPosition = prevThumb ? currentThumbTop - $(prevThumbView.el).position().top - (3 * thumbHeight) - thumbPadding : 0; //(top if the first page)
	
	            // The latter will be negative
	            // This is rather random ... fix ?
	            this.ui.thumbScroller.scrollTop(scrollToPosition );
	
	        }
	    },
	
	    onClearActiveThumb: function() {
	
	        this.children.findByModel( this.options.vChannel.request('currentPage') );
	        this.$('.active').removeClass('active');
	
	    },
	
	    destroy: function() {
	
	        Backbone.Radio.Channel.prototype.reset.call(this);
	        this.ui.thumbScroller.trigger('lazyload.destroy');
	        this.ui.thumbScroller.off('scroll');
	
	        Marionette.CompositeView.prototype.destroy.apply(this, arguments);
	
	        //quick fix for jqCache clear --- the ui elements are detached -- mostly removed
	        this.$('*').remove();
	        this.el = null;
	        this.$el = null;
	
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 561 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(563);
	
	var PageImageWr = __webpack_require__(418),
	    DocModePgImgWr = __webpack_require__(416);
	
	/**
	 * The base is an image ... so inherit from page image wrapper
	 */
	
	var ThumbImgWr = PageImageWr.extend({
	
	    className: 'FV-pgWr FV-pgWr-thumb',
	
	    RENDER_LOADING_LABELS: 0,
	
	    SUPPORTS_PAGE_TEXT_LAYER: 0,
	
	   // TEXT_LAYER_VIEW: DocModePgImgWr.prototype.TEXT_LAYER_VIEW, -- this would work if ever desired
	
	    /**
	     * Add some extra items to the markup while inheriting the BasePg template.
	     */
	    onRender: function() {
	
	        DocModePgImgWr.prototype.onRender.apply( this, arguments );
	
	        var $thumbNum = $('<div class="FV-thumbNum">}</div>').html( this.model.get('number') );
	        this.$el
	            .prepend( $thumbNum )
	            .toggleClass( 'active', this.options.vChannel.request('pageIsActivePage', this.model) );
	
	    },
	
	    // TODO: i think maybe refactor this ... trigger something up top that knows how to handle thumb, page, etc,
	    // then that calls back down ...
	    _postImgLoadOfPageWithUnknownDimensions: function() {
	
	        PageImageWr.prototype._postImgLoadOfPageWithUnknownDimensions.apply( this, arguments );
	
	        // Need to update after new dimensions -- prob want to make a channel call
	        this.model.collection.setVOffsets();
	
	    },
	
	    // Diff: not updating call to images rendering
	    onBeforeImageRequest: function() {
	        this.$el.off('inview');
	    },
	
	    events: {
	
	        'click': function() {
	
	            var vCh = this.options.vChannel;
	            if ( vCh.request('pageIsActivePage', this.model) )
	                return;
	
	            this.highlight();
	            vCh.command('goToPage', vCh.request('getPageFromThumbModel',this.model ));
	        }
	    },
	
	    highlight: function() {
	        this.options.parent.triggerMethod('clearActiveThumb');
	        this.$el.addClass('active');
	    },
	
	    onBeforeDestroy: DocModePgImgWr.prototype.onBeforeDestroy
	
	});
	
	
	
	module.exports = ThumbImgWr;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 563 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(565);
	
	var ThumbView = __webpack_require__(562);
	
	
	module.exports = ThumbView.extend({
	
	    template: __webpack_require__(566),
	
	    NON_LOADING: 1,
	
	    APPLY_TRANSFORM: 0
	
	});
	
	


/***/ },
/* 565 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div class=\"FV-pgWr FV-pgWr-thumb\" title=\"Go to page "
	    + container.escapeExpression(((helper = (helper = helpers.pgNumber || (depth0 != null ? depth0.pgNumber : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"pgNumber","hash":{},"data":data}) : helper)))
	    + "\">\n\n    <div class=\"nonRenderable\">\n        <div class=\"nonRenderableThumbContent\">\n            <span class=\"icon icon-attention-circled\"></span>\n            <span class=\"thumb-unrenderable-text-msg\">Page Not Renderable</span>\n        </div>\n    </div>\n\n    <div data-page-dd-stub=\"true\"></div>\n\n</div>";
	},"useData":true});

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(568);
	
	var ThumbView = __webpack_require__(562);
	
	
	module.exports = ThumbView.extend({
	
	    template: __webpack_require__(569),
	
	    NON_LOADING: 1,
	    APPLY_TRANSFORM: 0,
	
	    ui: _.extend( {}, ThumbView.prototype.ui, {
	        launchBtn:  '.iconWr'
	    }),
	
	    serializeData: function() {
	        return _.extend( ThumbView.prototype.serializeData.call(this), {
	            url: this.model.getPageUrl()
	        });
	    },
	
	    events: _.extend({}, ThumbView.prototype.events, {
	        'click @ui.launchBtn': 'onBtnClick' /* look unintuitive if can't click */
	    }),
	
	    onBtnClick: function(e) {
	        e.preventDefault();
	        window.open(this.model.getPageUrl());
	    }
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 568 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-pgWr FV-pgWr-thumb\" title=\"Go to page "
	    + alias4(((helper = (helper = helpers.pgNumber || (depth0 != null ? depth0.pgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pgNumber","hash":{},"data":data}) : helper)))
	    + "\">\n\n    <div class=\"thumbUrlWr\">\n        <div class=\"iconWr\" title=\"Open In New Window\">\n            <i class=\"icon icon-link-ext-alt\"></i>\n        </div>\n        <div class=\"thumbUrl\">\n            <div class=\"linkWr\">\n                <span class=\"thumbUrlLink\" title=\""
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n        </div>\n    </div>\n\n    <div data-page-dd-stub=\"true\"></div>\n\n</div>";
	},"useData":true});

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var UnrenderableThumb = __webpack_require__(564);
	
	
	/**
	 * For now, just adding an indicator that the thumb is a Multipart Gos Page
	 */
	
	
	module.exports = UnrenderableThumb.extend({
	
	    onRender: function() {
	
	        UnrenderableThumb.prototype.onRender.apply(this, arguments);
	
	        this.$('.thumb-unrenderable-text-msg').html(
	            this.$('.thumb-unrenderable-text-msg').html() + ':\n' + this.model.getFriendlyName()
	        );
	
	    }
	
	});

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"thumbs sub-side-content no-header\">\n    <div class=\"thumb-scroller-wr\">\n        <div class=\"thumb-scroller\"></div>\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    DocIndexesLayout = __webpack_require__(573),
	    SubApp = __webpack_require__(98);
	
	//todo: when add subapp -- add the channel (gl)
	module.exports = SubApp.extend({
	    initialize: function(options) {
	
	        this.vChannel = options.vChannel;
	
	        this.layout = new DocIndexesLayout({
	            el: options.$container,
	            collection: options.indexes
	        }).render();
	
	    },
	    onBeforeDestroy: function() {
	        return this.layout.destroy();
	    }
	
	});
	


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(574);
	
	var Marionette = __webpack_require__(61),
	    IndexesView = __webpack_require__(575);
	
	module.exports = Marionette.LayoutView.extend({ //todo: inherit from subpanel subcontent (notes)
	    className: 'spWr',
	    template: __webpack_require__(579),
	    regions: {
	        header:     '.sp-header', //-- (unused)
	        body:       '.sp-body'
	    },
	    onRender: function () {
	        this.getRegion('body').show(new IndexesView({
	            collection: this.options.collection
	        }));
	    },
	    destroy: function () {
	        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
	        /* remove jq cache references -- still unsure why these are still referenced .... */
	        this.$('*').remove();
	
	    }
	});

/***/ },
/* 574 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette) {var Backbone = __webpack_require__(58),
	    IndexView = __webpack_require__(576);
	
	module.exports = Marionette.CollectionView.extend({
		className: 'indexInfo',
	    childView: IndexView
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(577);
	
	//TODO: this markup should be more semantic / accessible
	
	var Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
	    className: 'fieldWr',
	    template: __webpack_require__(578),
	    serializeData: function() {
	
	        var m = this.model;
	
	        return {
	            fieldName: m.get('name'),
	            fieldValue: m.getMultiLineDisplayValue()
	        };
	
	    }
	
	});

/***/ },
/* 577 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"fieldName\" title=\""
	    + alias4(((helper = (helper = helpers.fieldName || (depth0 != null ? depth0.fieldName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fieldName","hash":{},"data":data}) : helper)))
	    + "\">\n    <span>"
	    + alias4(((helper = (helper = helpers.fieldName || (depth0 != null ? depth0.fieldName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fieldName","hash":{},"data":data}) : helper)))
	    + "</span>\n</div>\n\n<div class=\"fldValWr\">\n    <div class=\"fieldValue\" title=\""
	    + alias4(((helper = (helper = helpers.fieldValue || (depth0 != null ? depth0.fieldValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fieldValue","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.fieldValue || (depth0 != null ? depth0.fieldValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fieldValue","hash":{},"data":data}) : helper)))
	    + "</div>\n</div>";
	},"useData":true});

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"spWr\">\n    <div class=\"sp-header\">\n        <div class=\"FV-subHeader-title ellipsis\" title=\"Document Indexes\">\n            Document Indexes\n        </div>\n    </div>\n    <div class=\"sp-body\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    SubApp = __webpack_require__(98),
	    FindAndRedactState = __webpack_require__(581),
	    Layout = __webpack_require__(586), // Maybe want a region to put inside depending on how render ...
	    FindAndRedactNoteModelConverter = __webpack_require__(584),
	    SearchModelsCollection = __webpack_require__(585),
	    SearchModel = __webpack_require__(582),
	    HiddenCanvasView = __webpack_require__(355),
	    SearchResults = __webpack_require__(657),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    SearchView = __webpack_require__(591),
	    PredefinedSearchesWrapper = __webpack_require__(674);
	
	
	module.exports = SubApp.extend({
	
	    channelName: 'findAndRedact',
	
	    constructor: function( options, id ) {
	
	        SubApp.prototype.constructor.apply( this, arguments );
	
	        this.vChannel = options.vChannel;
	
	        // Store a reference here instead of retrieving from vChannel -- it's used in multiple places in the module
	        this.creatableNoteTypesHelper = options.creatableNoteTypesHelper;
	
	        var predefinedSearchesWrapper = new PredefinedSearchesWrapper();
	
	        if ( options.userProvidedSearches ) {
	
	            predefinedSearchesWrapper.initialize(
	                options.userProvidedSearches,
	                this.creatableNoteTypesHelper.getDisallowedFindAndRedactNoteTypes(),
	                this.channel._requests.getNewNoteModel.callback.bind( this )
	            );
	
	            this.showUserProvidedSearchWarnings( predefinedSearchesWrapper );
	
	
	        }
	
	        this.state = new FindAndRedactState({
	            searches: predefinedSearchesWrapper.getValidSearchesWithPermission().length > 0
	                ? new SearchModelsCollection( predefinedSearchesWrapper.getValidSearchesWithPermission() )
	                : null
	        });
	
	
	        this.region = new Marionette.Region({ el: this.options.el });
	
	        this.layout = null; // created on render -- which is like start
	
	    },
	
	    /* note -- all local */
	    subscriptions: {
	
	        'findAndRedact:search':                 'doSearch',
	        'findAndRedact:showAddSearchModal':     'showAddSearchModal',
	        'findAndRedact:showEditSearchModal':    'showEditSearchModal',
	        'findAndRedact:removeSearch':           'removeSearch',
	        'findAndRedact:toggleCollapseSearch':   'toggleCollapseSearch',
	
	        'findAndRedact:clearSearch':                'clearSearch',
	        'findAndRedact:apply':                      'apply',
	        'findAndRedact:updateShowResultsByTable':   'updateShowResultsByTable',
	
	        'findAndRedact:updatePostCollapseRowClick':         'updatePostCollapseRowClick',
	        'findAndRedact:updatePostResultRowIncludeClick':    'updatePostResultRowIncludeClick',
	
	        // These are forwards:
	        'findAndRedact:userClickedHit':                 'userClickedHit',
	        'findAndRedact:revertShapePosition':            'revertShapePosition',
	        'findAndRedact:hitShapeReasonCodesChange':      'hitShapeReasonCodesChange'
	
	    },
	
	    /* -- note: these are local -- */
	    requests: {
	
	        vChannel: function() {
	            return this.vChannel;
	        },
	        state: function() {
	            return this.state;
	        },
	        creatableNoteTypesHelper: function() {
	            return this.creatableNoteTypesHelper;
	        },
	        getNewSearchModel: function() {
	
	            return new SearchModel({
	                noteModel: this.request( 'getNewNoteModel' )
	            });
	
	        },
	
	        /**
	         *
	         * 'Wrap' the new note model from the notes module
	         * Optional: shapeAttrs -- note attrs may follow when set from API
	         * ( for redactions, calls setSelectedCodeAndFillOnDialogOpen on the shape )
	         */
	        getNewNoteModel: function( noteType, shapeAttrs ) {
	            noteType = noteType || this.defaultNoteType();
	            var note = this.vChannel.request( 'getNewNoteModel', 0, noteType );
	            FindAndRedactNoteModelConverter.convertNewNote( note, shapeAttrs );
	            return note;
	
	        }
	
	    },
	
	    /**
	     * Perhaps this is configurable or remember across searches.
	     * If don't have create_page-note, but can highlight, it has to be highlights ....
	     */
	    defaultNoteType: function() {
	
	        if ( this.request('creatableNoteTypesHelper').getDisallowedFindAndRedactNoteTypes().indexOf( 'REDACTION_NOTE' ) > -1 ) {
	            return 'HIGHLIGHT_NOTE';
	        }
	
	        return 'REDACTION_NOTE';
	
	    },
	
	
	    /* -- 'outer': s/b events but following old commands structure w/BB Radio like the other modules --
	    * don't envision having inner commands here
	    * hooks into existing sub app arch so no need to wire, unwire
	    * */
	    commands: {
	
	        changePage: function (options) {
	
	            if ( !this.state.searchHasResults() )
	                return;
	
	            /* We don't need an expense re-render here */
	            this.state.getSearchResultsTree().updateCurrentPageNumber( options.pageNum );
	
	        }
	
	    },
	
	    /* Initial and re-renders; also like a 'start' */
	    render: function() {
	
	        this.layout = new Layout({ channel: this.channel });
	
	        /**
	         * Perform a search on entry: used if searches are passed in --
	         * kind of a hack: the predefined searches on the state are not yet 'searched'
	         */
	        this.region.once('show', function() {
	
	            if ( !this.state.get('searchPerformed') && this.state.getNumberOfSearches() > 0 && this.state.allSearchesAreValid() ) {
	                this.channel.trigger( 'findAndRedact:search' );
	            }
	
	        }.bind(this) ) ;
	
	        this.region.show( this.layout );
	
	    },
	
	    /* -- Subscriptions -- */
	
	    /**
	     * Sources: 1) search form submit, 2) findAndRedactOnEntry -- either way searches will be set in state
	     * Ultimately puts state into search performed -- we want to lock when user has results.
	     */
	    doSearch: function( search ) {
	
	        if ( search ) {  // ( this would be for regular user search ) -- could do prior; on entry search are already set
	            this.state.addSearch( search );
	        }
	
	        /* extra check -- maybe now we show an error */
	        if ( !this.state.allSearchesAreValid() ) {
	            return;
	        }
	
	        // If from form submit, obtain lock, and only allow if successful.
	        // Lock will be cleared after search is cleared, or immediately search yields no results,
	        // in which case the 'clear' button is not presented.
	        this.request('vChannel').command(
	            'lockActiveDocument', 'FIND_AND_REDACT', 'Find And Redact', this._performSearch.bind(this)
	        );
	
	    },
	
	    // requestAnimationFrame necessary for spinner not to get skipped; cleaner than old timeouts; IE10+=
	    // Note: spinner will be removed when the resultsRegion is shown
	    _performSearch: function() {
	
	        requestAnimationFrame( function() {
	
	            this.channel.trigger('findAndRedact:showSpinner');
	
	            requestAnimationFrame( function() {
	
	                var searches = this.state.get('searches');
	
	                var results = new SearchResults();  // need to clear first?
	                searches.setNoteSubjectsOnSearch();
	                results.buildResultsFromSearches( searches.models, this.channel );
	                this.state.doSearch( results );
	
	                this.channel.trigger('findAndRedact:hideSpinner'); // ( now called again in the layout )
	
	                // No need to re-render the header ( it holds the spinner )
	                this.layout.showBodyRegions();
	
	                this.vChannel.command( 'setFindAndRedactSearchModel', this.state ); // ( the export portion )
	
	                /**
	                 * Persist search attributes only for those manually entered ( vs from the API ).
	                 * ( There can only be one searched at a time manually now  ).
	                 * Leave isAPI logic out of updateLocalStorageForRedactionNotes because searches from the API can be edited.
	                 */
	
	                var firstSearch = searches.at(0);
	                if ( !firstSearch.get('fromAPI') && firstSearch.getNoteModel().isRedactionNote() ) {
	                    searches.at(0).updateLocalStorageForRedactionNotes();
	                }
	
	
	            }.bind(this) );
	
	        }.bind(this) );
	
	
	    },
	
	    /**
	     * For now permissions are done separate from validation issues from frApiModel.
	     * If there are no searches with approp. perms, a view is placed of the model stating 'User lacks permission to create any notes',
	     * and blocking any action.
	     * Alerts here will be displayed and printed in the console as warning regardless.
	     * Those could be made more descriptive.
	     * For now left on model, not the model, for display purposes with DV's alert -- later may want to re-org.
	     * The error reporting can be made better if/when desired.
	     */
	    showUserProvidedSearchWarnings: function( predefinedSearchesWrapper ) {
	
	        var frApiModel = predefinedSearchesWrapper.getApiModel();
	
	        /* None Valid -- not alerting about permissions */
	        if ( !frApiModel.hasValidSearches() ) {
	
	            showWarnings.call( this, {
	                shortMessage: 'Find And Redact API Invalid Input',
	                detailedMsg: 'No valid searches provided.\n' + frApiModel.getValidationErrors().join('\n')
	            });
	            return;
	
	        }
	
	
	        var validSearchesWithoutPermission = predefinedSearchesWrapper.getValidSearchesWithoutPermission();
	        var permissionWarningMessage;
	
	        if ( validSearchesWithoutPermission.length > 0 ) {
	
	            var oValidSearchesWithoutPermCountsPerNoteType = _.countBy( validSearchesWithoutPermission, function( search ) {
	                return search.getNoteModel().desc;
	            });
	
	            var strNoteTypesWithCounts = '';
	            for ( var noteType in oValidSearchesWithoutPermCountsPerNoteType ) {
	                strNoteTypesWithCounts += noteType + ' (' + oValidSearchesWithoutPermCountsPerNoteType[noteType] + '), ';
	            }
	            strNoteTypesWithCounts = strNoteTypesWithCounts.substring( 0 , strNoteTypesWithCounts.length - 2 );
	
	            permissionWarningMessage = 'User Lacks Permission to Create the Following Note Types: ' + strNoteTypesWithCounts;
	
	        }
	
	        /* Some Invalid Searches */
	
	        if ( frApiModel.hasInvalidSearches() ) {
	
	            if ( validSearchesWithoutPermission.length < 0 ) {
	
	                showWarnings.call( this, {
	                    shortMessage: 'Find And Redact API Invalid Input. ' + frApiModel.getInvalidSearches().length + ' Searches Not Included:',
	                    detailedMsg: frApiModel.getValidationErrors().join('\n') // could later print out the provided text ...
	                });
	
	            } else {
	
	                showWarnings.call( this, {
	                    shortMessage: 'Find And Redact: ' + frApiModel.getInvalidSearches().length + ' Invalid Searches and '
	                        + validSearchesWithoutPermission.length + ' Excluded Because of Permissions',
	                    detailedMsg: frApiModel.getValidationErrors().join('\n') + // could later print out the provided text ...
	                         '\n' + permissionWarningMessage
	                });
	
	            }
	
	            return;
	        }
	
	
	        /* All valid -- just permissions */
	        if ( validSearchesWithoutPermission.length > 0 ) {
	
	            showWarnings.call( this, {
	                shortMessage: 'Find and Redact: ' + validSearchesWithoutPermission.length + ' Searches Not Included Because of Permissions',
	                detailedMsg: permissionWarningMessage
	            });
	            return;
	        }
	
	
	        function showWarnings( options ) {
	
	            console.warn( options.shortMessage + '.  ' + options.detailedMsg );
	
	            this.vChannel.trigger('alert:show', {
	                type: 'info',
	                shortMessage: options.shortMessage,
	                detailedMsg: options.detailedMsg,
	                detailedMsgPreserveLineBreaks: 1
	            });
	
	        }
	
	    },
	
	    /**
	     * Now -- can only be called when there are results, one at a time; 'live.'
	     */
	    showAddSearchModal: function( ) {
	
	        var searchFromView = new SearchView({
	            model: this.request( 'getNewSearchModel'),
	            channel: this.channel,
	            submitButtonTitle: 'OK',
	            extraFormClassName: 'fr-search-form-modal',
	            focusInputOnShow: true,
	            onSubmit: function( searchModel ) {
	                this.vChannel.trigger( 'modal:close' );
	                this.addSearch( searchModel );
	
	            }.bind( this )
	
	        });
	
	        this.vChannel.trigger( 'modal:open', {
	            hideFooter: true, // We use this form's button as the submit for now ...
	            title: 'Add Search',
	            content: searchFromView
	        } );
	
	    },
	
	    showEditSearchModal: function( search ) {
	
	        var searchFromView = new SearchView({
	            model: search.getClone(),
	            channel: this.channel,
	            submitButtonTitle: 'OK',
	            extraFormClassName: 'fr-search-form-modal',
	            focusInputOnShow: true,
	            onSubmit: function( clonedSearch ) {
	
	                this.vChannel.trigger( 'modal:close' );
	
	                if ( !search.isTheSameAsOtherSearch( clonedSearch ) ) {
	                    this.editSearch( search, clonedSearch );
	                }
	
	            }.bind( this )
	
	        });
	
	        this.vChannel.trigger( 'modal:open', {
	            hideFooter: true,
	            title: 'Edit Search',
	            content: searchFromView
	        } );
	
	    },
	
	    addSearch: function( searchModel ) {
	
	        this.channel.trigger('findAndRedact:showSpinner'); // now in layout too in case ...
	
	        searchModel.setNoteSubjectOnSearch();
	
	        this.state.addSearch( searchModel );
	
	        this.state.get('searchResults').addSearchesToResults( [searchModel], this.channel );
	
	        // Maybe need spinner, etc from search ... but don't want all same things
	        this.layout.showBodyRegions();
	
	        searchModel.updateLocalStorageForRedactionNotes();
	
	        /* Note: for now it is not live, you can just refresh with the empty new search */
	        this.vChannel.command( 'updateToReflectFindAndRedactSearch' );
	
	    },
	
	    editSearch: function( originalSearchToRemove, newSearchToAdd ) {
	
	        this.state.removeSearch( originalSearchToRemove, 1 ); // yikes: if there are none, it will set the results to none
	        this.addSearch( newSearchToAdd );
	
	    },
	
	    removeSearch: function( searchModel ) {
	
	        this.state.removeSearch( searchModel );
	
	        this.layout.showBodyRegions();
	
	        /* Can't just re-render canvas -- see issue in code with floating redactions */
	        this.vChannel.command( 'updateToReflectFindAndRedactSearch' );
	
	    },
	
	    /* Now really more of a 'reset' */
	    clearSearch: function() {
	
	        this.state.clearSearch();
	        this.layout.showBodyRegions();
	        this.vChannel.command( 'setFindAndRedactSearchModel', this.state );
	
	    },
	
	    updateShowResultsByTable: function( showResultsByPage ) {
	
	        // 'clear' the view prior to re-rendering calc and then the entire layout -- POC
	        // alternative is to show a loading view in it .... see layout comments ...
	        this.layout.getRegion( 'resultsRegion' ).currentView.getRegion( 'hitsTableRegion' ).empty(); // ( only need the bottom ) --
	
	        this.state.set({ showResultsByPage: showResultsByPage });
	        this.state.get('searchResults').updateTreeStateFromHits( showResultsByPage );
	
	        this.layout.showBodyRegions();
	
	    },
	
	    toggleCollapseSearch: function( search ) {
	
	        var resultsTree = this.state.getSearchResultsTree();
	
	        if ( search.get('isSelected') ) {
	
	            search.set( 'isSelected', false );
	            resultsTree.unCollapseAll();
	
	        } else {
	
	            this.state.get('searches').resetSelectedSearch();
	            search.set( 'isSelected', true );
	
	            resultsTree.collapseAllButSearch( search );
	        }
	
	        /* Don't want expensive table re-render */
	        resultsTree.walkDown(function (node) {
	            node.trigger('updateIsCollapsed');
	        });
	
	        this.channel.trigger('findAndRedact:updateSearchPills');
	
	    },
	
	    updatePostCollapseRowClick: function( rowModel ) {
	
	        var resultsTree = this.state.getSearchResultsTree();
	        resultsTree.updateHierarchyCollapsed( rowModel );
	
	        /* Don't do expensive re-render */
	        resultsTree.walkDown( function(node) {
	            node.trigger('updateIsCollapsed');
	        });
	
	        /* -- update selected UI -- */
	        this.state.get('searches').resetSelectedSearch();
	        this.channel.trigger('findAndRedact:updateSearchPills');
	
	    },
	
	    updatePostResultRowIncludeClick: function( rowModel ) {
	
	        var resultsTree = this.state.getSearchResultsTree();
	        resultsTree.updateHierarchyIncludes( rowModel );
	
	        /* Don't do expensive re-render */
	        resultsTree.walkDown( function(node) {
	            node.trigger('updateIsApplied');
	        });
	
	        // Update the 'action row' -- maybe later combo that row in the hierarchy
	        this.channel.trigger('findAndRedact:updateActionRow');
	
	    },
	
	    userClickedHit: function( hitModel ) {
	        this.vChannel.trigger('findAndRedact:goToHit', hitModel ); // may not need to pass the model now
	    },
	
	    revertShapePosition: function( hitModel ) {
	
	        this.vChannel.trigger( 'findAndReact:revertShapePosition', hitModel );
	
	    },
	
	    // Only 1 shape per hit
	    hitShapeReasonCodesChange: function( shape, selectedCodes ) {
	
	        this.vChannel.trigger( 'findAndRedact:hitShapeReasonCodesChange', shape, selectedCodes );
	    },
	
	    /**
	     * May also want 'report' object or object to return options for the alert message ...
	     * but leaving like this since should have one endpoint for saving ... it we decide that's not the case,
	     * clean this up.
	     * This was just a POC to see how saving notes could work
	     * If saving individually, would want to combo logic from the existing note models.
	     */
	    apply: function() {
	
	        var vChannel = this.vChannel;
	
	        var notesToSave = this.state.get('searchResults').getNotesToSaveFromAppliedHits();
	
	        if (notesToSave.length < 0)
	            return;
	
	        /**
	         * Save them ... should consolidate logic from note module, canvas etc ....
	         * First setting the shapes on the note models
	         * TODO: better way ...
	         */
	
	        var regNoteModelsToSave = [],  // we're cloning the notes to save
	            activeDocModel = vChannel.request('activeDocument'), // for url creation
	            scale = vChannel.request('getCurrentScaleValue');
	
	        notesToSave.forEach( function(note) {
	
	            // For now 'clone' the models - then we don't get a link back to those already saved, (unsure?)
	            var regNoteModel = note.clone({
	                parse: true,
	                pageNumber: note.pageNumber // I think only need to set the pageNumber -- TODO: a better clone fn on the note
	            });
	
	            regNoteModel.frNoteId = note.cid; // provide a link back to the original for validation purposes ( not yet in use )
	
	            /**
	             * Update their shapes' properties from the zones prior to a save (from the shapes objects we put on them).
	             * THIS ISN'T DONE LIVE NOW -- PROB SHOULD CHANGE ...
	             * If a floating redaction and haven't been to its page,
	             * //  TODO: now that there could be multiple floating per page, maybe only draw once for all of them ???
	             * will need to draw the canvas to get the coordinates of the boxes, lines, etc.
	             * Note: actually, even if we've have been to it's page, but have gone to another, the floating codes controller is gone
	             * (see this not just for current the same page)
	             * ( or don't destroy the controller, maybe just turn off it's events -- so we remember the positions ) -->
	             * This would also happen if in doc mode and haven't loaded page mode yet -- even if on the same page, it wouldn't
	             * the note wouldn't have a floating codes controller yet.
	             */
	
	            if ( note.isFloatingRedaction() && !note.floatingCodesController ) {
	
	                // don't use vchannel command to avoid reference errors with the test one ...
	                var dummyCanvas = new HiddenCanvasView();
	                dummyCanvas.render( vChannel, note.pageNumber, note.shapes  );
	
	                var canvasShapes = dummyCanvas.canvas.shapes.models; // reference maintained to the shapes here
	
	                regNoteModel.set('shapes', canvasShapes.map( function(shape) {
	
	                    var attrsToPersist = shape.getAttrsToPersist( scale ); // may no longer need scale since storing the points live
	
	                    // if haven't been to the page, box would not have been set
	
	                    // See below -- perhaps unnecessary since if on page, this will be called below with save hidden canvas,
	                    // and also if not on page, it would have been saved on page navigation, but do anyway for now
	                    if ( note.isFloatingRedaction() ) {
	                        shape.set( attrsToPersist );
	                        shape.parse( attrsToPersist ); // sets the box and connection; combo with update attributes to persist
	                    }
	
	                    return attrsToPersist; // area for override -- we don't want it getting points from raphaelEl
	
	                }));
	
	                // Comment this out for visual test;
	                // But doing so may cause issues if multiple pages and then performing actions later. ( eg shapes not there )
	               dummyCanvas.destroy();
	
	            }
	
	            else {
	
	                regNoteModel.set( 'shapes', note.shapes.map( function(shape) {
	
	                    var attrsToPersist = shape.getAttrsToPersist( scale );
	
	                    // Set the code and box; and reset the attributes of the shape so it's remembered on re-render post save --
	                    // Unlike with save, the attributes don't come back from the server prior to re-render remaining find and redact shape
	                    // and go through the 'parse process'
	                    // For now only for floating redaction ... show box is remembered re-render ... actually prob don't even need connection
	                    // other attribute set other than points should be set directly on the shape model ...
	                    // TODO: similar for shapeModel.updateShapeAttributes on floatingCodes shape model
	                    if ( note.isFloatingRedaction() ) {
	
	                        shape.set( attrsToPersist ); // would like a set and parse method perhaps ...
	                        // perhaps this changes if we set box and connection on new shapes ... i don't think we do
	                        // Maybe we only do if it was moved ... which we could check
	                        shape.parse( attrsToPersist ); // may set the other attributes as well -- though they shouldn't change -- need box to reposition after save
	
	                    }
	
	                    return attrsToPersist; // area for override -- we don't want it getting points from raphaelEl
	
	                }));
	
	            }
	
	            regNoteModelsToSave.push( regNoteModel );
	
	        }, this);
	
	
	        /**
	         * Perform a client-side validation check at the note level first before any save is called ( after the shapes are set )
	         * -- this is in case we can ever delete shapes -- THIS IS A REQUIREMENT
	         * Must do after put shapes on them because that's looked at in base note validation ( for now ).
	         * Easier to catch up front than mess with the failure logic on save, where you'd need to incorporate
	         * 'invalid' notes with failed ones ( below ).
	         * For now, this shouldn't really happen -- but it leaves open possibility, especially when implement note level result dropdowns.
	         * For time being: only checking title (and now shapes), which is disabled and can't be changed anyway ---
	         * currently title is blocked live on input so this should be reached.
	         * If any are invalid -- mark as such,  and don't allow to proceed in case the user fixes in whatever
	         * form they would have to if/when we implement note leave dropdowns ...
	         * This way would also lend itself to not clearing the results and instead applying one x one as discussed ...
	         * If left here, should be a separate fn ...
	         * TODO: NOT DOING NOW -- UNECESSARY UNTIL WE CAN DELETE SHAPES, AT WHICH POINT CAN THINK OF BEST WAY TO ACCOMPLISH
	         */
	
	        /*
	         var allNotesPassValidation = true;
	
	         _.each( regNoteModelsToSave, function( note ) {
	
	             note.set( 'title', 'This is a subject longer than 32 characters' ); //-- TO TEST DEBUG
	
	
	
	
	             if ( !note.isValid() ) {
	
	
	                // What to trigger on? could be 2 model? -- search or page
	                // Last one got the model from the pageId of the note ...
	                // noteResultsRowModel.trigger( 'pageRowResultModel:validationError', note.validationError );
	                 allNotesPassValidation = false;
	             }
	
	
	         }, this);
	
	         if ( !allNotesPassValidation ) {
	
	             return;
	         }
	        */
	
	
	        /*
	         * Save process:
	         * For now do the save in a separate loop --> should get from a 'getModelsToSaveFunction'
	         * But leave dirty since will switch to bulk save endpoint
	         */
	        var self = this,
	
	            hitsToApply = self.channel.request('state').get('searchResults').getAppliedHits(),
	
	            numberNotesProcessed = 0,
	            numberOfNotesToSave = regNoteModelsToSave.length,
	            notesSaved = [], // { note, jqXHR }
	            notesFailed = []; // { note, jqXHR }
	
	        regNoteModelsToSave.map( function( note ) {
	
	            /**
	             * TODO -- later it's probably cleaner to have a bulk save endpoint, but that would prob
	             * Send all attributes -- and for now save individually.
	             * be a larger refactor with the current saving workflow in the client
	             * this is something to look into when create notes bulk delete functionality.
	             */
	
	            note.save( [], {
	
	                url: fvChannel.request('apiUrl').pageNote( activeDocModel, note.get('pageId') ), // since not in collection, url will break here ...
	
	                success: function( model, response ) {
	
	                    numberNotesProcessed++;
	
	                    notesSaved.push( {
	                        note: model,
	                        jqXHR: response
	                    } );
	
	                    if ( numberNotesProcessed === numberOfNotesToSave ) {
	                        postNotesSaved.call( self );
	                    }
	
	                },
	
	                // response is jqXHR
	                error: function( model, response, options ) {
	                    // Handle or do with jqXHR
	
	                    numberNotesProcessed++;
	
	                    notesFailed.push( {
	                        note: model,
	                        jqXHR: response
	                    } ); // use the failed model or the find and redact one?
	
	                    if ( numberNotesProcessed === numberOfNotesToSave ) {
	                        postNotesSaved.call( self );
	                    }
	                }
	
	            });
	
	
	        });
	
	
	        function postNotesSaved() {
	
	            // First process any saved note models in the current DV f'ed up workflow
	            // We could sort them page # but this won't make any different
	            // ctime may still be 'off' since called async -- would need bulk save endpoint here to fix this.
	
	            notesSaved.map( function( noteSavedObj ) {
	
	                /**
	                 *  Add to allNotes collection
	                 *  TODO: refactor and move this up
	                 *  this should also create it in the notes view given current setup
	                 *  appears auto-wired by the Marionette collection view
	                 */
	                vChannel.request('allNotes').add( noteSavedObj.note );
	
	                // this adds to the various note collections ... separate that out
	                vChannel.trigger( 'notes:noteSaved', noteSavedObj.note, {
	                    noteSaved: true // this is picked up by something?  -- i think note.toggleEditMode, which would trigger the 'save' indicator on the view
	                } );
	
	                // Hack-work around to show the save indicator on the note view
	                noteSavedObj.note.trigger('showSavedIndicator');
	
	
	            });
	
	
	            if ( notesSaved.length === numberOfNotesToSave ) {
	
	                this.channel.request('vChannel').trigger('alert:show', {
	                    type: 'success',
	                    shortMessage: 'Created ' + notesSaved.length + ' note' + (notesSaved.length > 1 ? 's' : '') +
	                    ' from ' + hitsToApply.length + ' hit' + (hitsToApply.length > 1 ? 's' : ''),
	                    closeTimeout: 5000
	                });
	
	
	            } else if ( notesFailed.length === numberOfNotesToSave ) {
	
	                this.channel.request('vChannel').trigger('alert:show', {
	                    type: 'error',
	                    shortMessage:
	                        'Error creating ' + notesFailed.length + ' note' + (notesFailed.length > 1 ? 's' : '') +
	                        ' from ' + hitsToApply.length + ' hit' + (hitsToApply.length > 1 ? 's' : ''),
	                    detailedMsg: getDetailMsgForNotesThatFailed(),
	                    detailedMsgPreserveLineBreaks: true
	                });
	
	
	            } else { // ( mixed success and failure )
	
	                // TODO: use the new structure
	                // Note: this is more reason to change top level structure of pageNotes and hits being on different objects
	                // that are linked ... also see mess in table results ...
	                var successFullHitsApplied = _.reduce( notesSaved, function( savedHits, savedNoteObj ) {
	
	                   return savedHits.concat( _.filter( hitsToApply, function(hit) {
	                       return hit.get('pageId') ===  savedNoteObj.note.get('pageId');
	                   } ) );
	
	                }, [] );
	
	                var failedHitsApplied = _.reduce( notesFailed, function( failedHits, failedNoteObj ) {
	
	                    return failedHits.concat( _.filter( hitsToApply, function(hit) {
	                        return hit.get('pageId') ===  failedNoteObj.note.get('pageId');
	                    } ) );
	
	                }, [] );
	
	
	                this.channel.request('vChannel').trigger('alert:show', {
	                    type: 'info',
	                    shortMessage:
	
	                        'Created ' + notesSaved.length + ' note' + (notesSaved.length > 1 ? 's' : '') + // (shared)
	                        ' from ' + successFullHitsApplied.length + ' hit' + (successFullHitsApplied.length > 1 ? 's' : ''),
	
	                    detailedMsg:
	
	                        'Error creating ' + notesFailed.length + ' note' + (notesFailed.length > 1 ? 's' : '') + // (shared)
	                        ' from ' + failedHitsApplied.length + ' hit' + (failedHitsApplied.length > 1 ? 's' : '') + ':\n' +
	                        getDetailMsgForNotesThatFailed(),
	
	                    detailedMsgPreserveLineBreaks: true
	
	                });
	
	            }
	
	            // For now we clear the search -- this may change -- AND I think now should
	            this.channel.trigger('findAndRedact:clearSearch');
	
	
	            // Probably should have a class but this is gonna paradigm should change with bulk save endpoint
	            function getDetailMsgForNotesThatFailed() {
	
	                // Get detailed err message for failed notes
	                return _.reduce( notesFailed, function( msg, failedNoteObj, i ) {
	
	                    var noteModel = failedNoteObj.note;
	                    var pgNumber = noteModel.pageNumber;
	                    var hitsToApplyOfPage = hitsToApply.filter( function(hit) {
	                        return hit.get('pageId') === noteModel.get('pageId');
	                    });
	
	                    var nHitsToApplyOfPage = hitsToApplyOfPage.length;
	
	                    msg += '* Page ' + pgNumber
	                        + ' (' + nHitsToApplyOfPage + ' hit' +  (nHitsToApplyOfPage > 1 ? 's' : '') + '): '
	                        + fvChannel.request( 'ajaxErrorMessage', failedNoteObj.jqXHR );
	
	                    if ( i < notesFailed.length )
	                        msg += '\n';
	
	                    return msg;
	
	                }, '' );
	
	            }
	
	        }
	
	    },
	
	    onBeforeDestroy: function() {
	
	        this.region.empty();
	
	        this.state = null;
	        this.layout = null;
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    SearchModel = __webpack_require__(582),
	    SearchModelsCollection = __webpack_require__(585),
	    SearchOptions = __webpack_require__(583),
	    FindAndRedactNoteModelConverter = __webpack_require__(584),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * Note: searches are now assumed to have been 'searched' and will appear in results.
	 * Those in the search forms have not yet been searched/added yet.
	 * Exception: when provided via API, there is a small gap between searches being set
	 * in the module constructor and the search being performed )
	 * ** When provided by the API, more than one search can be provided; but otherwise we can only add one at a time **
	 * Can only add/edit when searchPerformed is true.
	 * When no search performed, there is a view with a model not in the searches.
	 * This allows for providing multiple searches on entry ( but not manually -- which greatly complicated things ).
	 */
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        searches: new SearchModelsCollection(),  // collection facilitates Marionette Collection views
	
	        searchPerformed: false,
	        searchResults: null,
	
	        userClickedHitId: null, // id of user clicked hit whose shapes we want to select on 'render' on the canvas ( note: now only one shape per hit )
	
	        showResultsByPage: true, // if false, show them by search
	
	        // // nWords X searchIndex: the indexes to search ( maybe later we have diff types )
	        subsequentWordIndexCache: {} // Now a map of indexes ( of one kind ), separated by the number of words  // nWords X index: the indexes to search -- TODO: could be diff if have diff search options
	
	    },
	
	    /* now only called through results */
	    addSearch: function( search ) {
	
	        this.get('searches').add( search );
	
	    },
	
	    removeSearch: function( searchModel, fromEditOperaation ) {
	
	        this.get('searches').remove( searchModel );
	
	        /* Live Removal */
	        if ( this.get('searchPerformed') ) {
	
	            this.get('searchResults').removeSearch( searchModel );
	
	            if ( !fromEditOperaation && this.get('searches').length < 1 ) {
	                this.clearSearch();
	            }
	
	        }
	
	    },
	
	    /**
	     *  Note:
	     *  - topLevelSearchModel ( and it's title ) is set prior to the call.
	     */
	    doSearch: function( searchResults ) {
	
	        // TODO: Need to clear existing???
	        this.set({
	            searchPerformed: true,
	            searchResults: searchResults
	        });
	
	    },
	
	    clearSearch: function( ) {
	
	        this.get('searches').erase(); // I don't think need to destroy the individual ones
	
	        if ( this.get('searchPerformed') ) {
	            this.get('searchResults').destroy();
	        }
	
	        this.set({
	            searches: new SearchModelsCollection(), // addSearch should be here
	            searchPerformed: false,
	            searchResults: null
	        });
	
	
	    },
	
	
	    searchHasResults: function() {
	
	        if ( !this.get('searchPerformed') )
	            return false;
	
	        var searchResults = this.get('searchResults');
	
	        return searchResults && searchResults.hasResults();
	
	    },
	
	    /* Shouldn't need anymore if validated one at a time, unless when pass in */
	    allSearchesAreValid: function() {
	
	        return this.get('searches').every( function( sm ) {
	            return sm.isValid();
	        });
	
	    },
	
	    getNumberOfSearches: function() {
	
	        return this.get('searches').length;
	    },
	
	    getSearchResultsTree: function() {
	
	        if ( !this.get('searchPerformed') ) {
	            return null;
	        }
	
	        return this.get('showResultsByPage')
	            ? this.get('searchResults').getPageTree()
	            : this.get('searchResults').getSearchTree();
	
	    }
	
	
	});

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    SearchOptions = __webpack_require__(583),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    FRNoteModelConverter = __webpack_require__(584);
	
	
	
	
	module.exports = Backbone.Model.extend({
	
	   defaults: {
	
	       searchTerm: '',
	       sanitizedSearchTerm: '',
	
	       inResults: false, /* set to true if in the search results -- could just get from those in searchResults .... NOW NOT IN USE*/
	
	       /* Now not exposed as options or in interface, though could be -- set from the Top Level Options */
	       searchOptions: new SearchOptions(),
	       noteModel: null, // not just the note type: may want to expose properties in the UI ( and potentially zone properties to )
	
	       fromAPI: false, // provided on load vs entered manually
	
	       isSelected: false // for now the 'non-collapsed' search ( always start false )
	
	    },
	
	    getNoteModel: function() {
	        return this.get('noteModel');
	    },
	
	    setNoteModel: function( model ) {
	        this.set( 'noteModel',  model );
	    },
	
	    setSearchTerms: function( rawSearchTerm ) {
	
	        var searchOptions = this.get('searchOptions'),
	            sanitizedSearchTerm = !searchOptions.get('ignoreCertainCharacters')
	                ? rawSearchTerm
	                : rawSearchTerm.replace( searchOptions.getCharactersToIgnoreReg(), '' );
	        /**
	         * Trim:
	         *  Remove extraneous spaces at the end of the search
	         *  Also serves to prevent searching for a ' ', which would result in a hit on every word and block the browser.
	         *  Though ' ' is not a character to ignore -- we need spaces to determine the words to search.
	         */
	        sanitizedSearchTerm = sanitizedSearchTerm.trim();
	
	        this.set({
	            searchTerm: rawSearchTerm,
	            sanitizedSearchTerm: sanitizedSearchTerm
	        });
	
	    },
	
	
	    /* If the user entered anything, leave it -- otherwise make the search */
	    setNoteSubjectOnSearch: function() {
	
	        var note = this.getNoteModel(),
	            noteTitle = note.get('title'); // TODO: get subj on note base model is display specific; change that ...
	
	        // TODO: depending on research, the user could change it ... but now after the search it is disabled ...
	
	        if ( !noteTitle || noteTitle.length < 1 ) {
	
	            note.set( 'title', this.get('searchTerm').substring( 0, fvChannel.request('getPageNoteTitleMaxLength') ) );
	        }
	
	    },
	
	    /**
	     * Prevent hitting search on the form and now from findAndRedactOnEntry.
	     *  Allow search if sanitizedSearchTerm has more than 1 character.
	     *  If only 'ignored characters' are entered -- a search would like hang the browser,
	     *  since every word would be a hit.
	     *  Essentially a 'derived' model attribute
	     *  TODO: maybe workflow changes here with reset ... and now this is like a 'validate'
	     * */
	    isValid: function() {
	
	        var sanitizedSearchTerm = this.get('sanitizedSearchTerm');
	
	        return sanitizedSearchTerm.length > 0;
	
	    },
	
	    /* Quick hack to see if changed on edit from prior search -- now not 100% fully accurate, just getting what is needed */
	    isTheSameAsOtherSearch: function( search ) {
	
	        if ( this.get('searchTerm') !== search.get('searchTerm') ) {
	            return false;
	        }
	
	        if ( FRNoteModelConverter.didNoteChange( this.getNoteModel(), search.getNoteModel() ) ) {
	            return false;
	        }
	
	        return true;
	
	    },
	
	    /* Now used for edit -- not overwriting BB clone now */
	    getClone: function() {
	
	        var clonedNote = this.getNoteModel().clone( { parse:true} );
	        var clonedShape = FRNoteModelConverter.cloneShapeModel( clonedNote, this.getNoteModel().shape );
	        clonedNote.shape = clonedShape;
	
	        var clone = this.clone(); // would prob want override at the model level
	        clone.setNoteModel( clonedNote );
	
	        return clone;
	    },
	
	    updateLocalStorageForRedactionNotes: function() {
	
	        if ( this.getNoteModel().isRedactionNote() ) {
	            this.getNoteModel().shape.updateLocalStoragePostDialogClose();
	        }
	
	    }
	
	
	
	
	});

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	/**
	 * If/When add different search types, this will likely need to change and be refined.
	 * Maybe these each need a corresponding TextSearcher ... see if/when have options ...
	 */
	
	
	
	module.exports = Backbone.Model.extend({
	
	   defaults: {
	
	        areaType: 'word', // word, line, or zone -- now only does word
	
	        // only one now -- searches consecutive words, ignoring certain characters
	        // -- maybe we need more fine grained control -- eg google would cover all things below .. would have to break out ..
	
	        type: 'google', // searches Consecutive Words; Firefox: a phrase search
	
	        // TODO: search a search type options -- may be different for different search types
	        ignoreCase: true,
	        ignoreCertainCharacters: true
	
	        // whole words ? -- what else ... (see MS Word -- they have clear options)
	    },
	
	
	    /**
	     * Characters to ignore when searching text in the words.
	     * For now just do selected punctuation: documented here:
	     * http://docs.feith.com/pages/editpage.action?pageId=66521034 for document
	     * Later this may be a property
	     * Maybe we later generate from a list
	     * Do we want to only allow all alphanumeric ?? -- downside is you can't search for them.
	     * Note: if used in a RegExp constructor -- we need to escape the string see code in 'textSearcher'.
	     * - eg var ignoreCharacterPattern = '\\.';
	     *     var ignoreCharacterRegExp = new RegExp( ignoreCharacterPattern , 'g');
	     * Alternative would be creating with double escape's in a string -- which is very hard to understand.
	     * Now coded here as a literal, instead of being built up, which could be the case if we later put more
	     * options on the characters to ignore ( currently hardcoded ).
	     **/
	    getCharactersToIgnoreReg: function() {
	
	        return /[\.\?!,:;\"\'\(\)\[\]\{\}\/\\-]/g;
	
	    }
	
	
	
	});

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * Encapsulate hacked clone functionality for notes and shapes ....
	 */
	
	
	
	module.exports = {
	
	    /**
	     * For now not sub-classing the note models.
	     * This function takes a regular note model and turns it into a 'find and redact' note model.
	     * Note: this assumes a new note model.
	     * For now note it has a flag:
	     *  - isFindAndRedactNote
	     *  - shape
	     *  shapeAttrs: optional -- use for those passed through API ( also implies from API )
	     */
	    convertNewNote: function( note, shapeAttrs ) {
	
	
	        // Set flag first prior to shape parse; if parse comes into play with notes, will need to re-think.
	        note.isFindAndRedactNote = 1; // only place we are now switch-tracking
	        note.isFromAPI = shapeAttrs !== undefined; // set flag to not set last reason codes
	
	
	        // for now augment with the shape properties preset
	        var ShapeConstructorForNote = note.getShapeModel();
	
	
	        // parentNote sets some properties from higher level note model with current arch ... should decouple
	        note.shape = new ShapeConstructorForNote( shapeAttrs ? shapeAttrs : [], {
	            parentNote: note
	        });
	
	        // Don't really need for top-level dummy shape but put in case
	        // TODO: this should handle be subclassing the shape
	        note.shape.isFindAndRedactShape = 1;
	
	        // Need to set this on the model so can see what reason codes were added when we perform a search
	        // TODO: we may want to change this ....
	
	
	        if ( note.isRedactionNote() ) {
	            note.shape.setSelectedCodeAndFillOnDialogOpen();
	        }
	
	        //note.getShape = function() {
	        //    return note.shape;
	        //}
	
	    },
	
	
	
	    /**
	     * TOD0: really need a clone note model function
	     * TEMP: now also used for created the cloned note models on the searches collection
	     *  -- JUST UPDATE THE PAGE NUMBER AND PAGE ID --- ?
	     */
	    getResultPageNoteModel: function( noteModelOfSearch, page, searchId ) {
	
	        var note = noteModelOfSearch.clone({
	            parse: true,
	            pageNumber: page.get('number'), // exists in note model.init -- will set the page number
	            creationUserGroups: noteModelOfSearch.creationUserGroups // TODO: should have a clone for any/all instance variables
	        });
	
	        // TODO: could create a clone of the model that copies the instance variables as well
	        // Set the page id -- note could be different page than the current and not set on clone
	        note.set( 'pageId', page.get('pageId') );
	
	        // TODO: giving an id makes it save as a modify b/c no longer will be new -- use different attribute???
	        //note.set( 'id', 'P' + page.get('pageId') + '_S_'  + searchId );
	
	        // Clone only looks the attribute
	        note.isFindAndRedactNote = 1;
	
	        note.shape = this.cloneShapeModel( note, noteModelOfSearch.shape, page );
	
	        return note;
	
	    },
	
	
	    cloneShapeModel: function( note, shape, page ) {
	
	        // Options uses this sets some properties from the higher level note model w/current arch ... should decouple
	
	        var clonedShape = shape.clone({
	            parentNote: note,
	            pageModel: page
	        });
	
	        // Not in clone -- can rid when subclass -- or override clone
	        clonedShape.isFindAndRedactShape = 1;
	
	        if ( note.isRedactionNote() ) {
	
	            var selectedReasonCodes = shape.getReasonCodeCollection();
	            if ( selectedReasonCodes ) {
	                clonedShape.setReasonCodeCollection( selectedReasonCodes.clone() );
	            }
	
	            // Set these first before views are rendered, rather than incorporating in the view logic
	            // This should really be part of an extended clone functionality
	            clonedShape.setSelectedCodeAndFillOnDialogOpen(
	                shape.getSelectedCodesOnDialogOpen().clone(),
	                shape.getSelectedFillOnDialogOpen()
	            );
	
	        }
	
	        // Could be more in instance variable future -- would need to copy all instance variables
	        return clonedShape;
	
	    },
	
	
	    /**
	     *  Overlap here with getResultPageNoteModel --
	     *  Data model needs a rewrite badly ...
	     *  With multiple searches -- no longer used ... I think we just have getResultPageNoteModel
	     */
	    cloneFrNoteModel: function( note ) {
	
	        var clone = note.clone({
	            parse: true,
	            pageNumber: note.pageNumber, // ( inst var )
	            creationUserGroups: note.creationUserGroups
	        });
	
	        clone.isFindAndRedactNote = 1;
	
	        clone.shape = this.cloneShapeModel( clone, note.shape );
	
	        return clone;
	
	    },
	
	
	    /* TEMP STOPGAP FOR NOTE EDITING -- lot of refactor and overlap ..... */
	    // Attrs are set live in the UI
	    // Overlap with did not change from other create note interface ...
	    didNoteChange: function( a, b ) {
	
	        if ( a.get('noteType') !== b.get('noteType') )
	            return true;
	
	
	        if ( a.get('title') !== b.get('title') ) {
	            return true;
	        }
	
	        if ( a.get('accessGroup') !== b.get('accessGroup') )
	            return true;
	
	
	        if ( a.get('reviewGroups') !== b.get('reviewGroups') )
	            return true;
	
	
	        if ( a.get('noteStatus') !== b.get('noteStatus') ) {
	            return true;
	        }
	
	        if ( a.isRedactionNote() ) {
	
	            if ( a.shape.get('fill') !== b.shape.get('fill') ) {
	                return true;
	            }
	
	            // Reason Codes ...
	            // Could make fn on the reason code collection ... and other ways to handle ... could also be util fn
	
	            var aCodes = a.shape.getReasonCodeCollection().pluck('code'),
	                bCodes = b.shape.getReasonCodeCollection().pluck('code');
	
	            if ( _.difference( aCodes, bCodes).length > 0 || _.difference( bCodes, aCodes).length > 0 ) {
	                return true;
	            }
	
	
	        }
	
	
	        return false;
	
	
	    }
	
	
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    SearchModel = __webpack_require__(582);
	
	
	/* The collection stored on the state model */
	
	module.exports = Backbone.Collection.extend({
	
	    model: SearchModel,
	
	    /* Now unused */
	    allAreSearched: function() {
	
	        return this.every( function(s) {
	            return s.get('inResults');
	        });
	
	    },
	
	    setNoteSubjectsOnSearch: function() {
	
	        this.each( function( search ) {
	            search.setNoteSubjectOnSearch();
	        });
	    },
	
	    resetSelectedSearch: function() {
	
	        this.each( function( search ) {
	            search.set({ isSelected: false });
	
	        });
	    }
	
	});

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(587);
	
	var Marionette = __webpack_require__(61),
	    HeaderView = __webpack_require__(588),
	    SearchView = __webpack_require__(591),
	    ResultsView = __webpack_require__(612),
	    SearchNotAllowedView = __webpack_require__(650),
	    LoadingPredefinedSearchesView = __webpack_require__(653);
	
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	    },
	
	    template: __webpack_require__(656),
	
	    regions: {
	        headerRegion:               '#fr-header',
	        searchRegion:               '#fr-search',
	        resultsRegion:              '#find-and-redact-results'
	    },
	
	    serializeData: function() {
	
	        return {
	            paneId: 'find-and-redact'
	        };
	
	    },
	
	    onBeforeShow: function() {
	
	        var state = this.channel.request('state');
	
	        // Can't have the spinner in the header and show it using on before show
	        this.headerRegion.show( new HeaderView({
	            channel: this.channel
	        }));
	
	
	        /**
	         * If no available note types, disallow any search and show a warning view.
	         * Can put here b/c there will not the ability to search/research.
	         */
	        var creatableNotesHelper = this.channel.request('creatableNoteTypesHelper');
	
	        if ( creatableNotesHelper.allFindAndRedactNoteTypesDisabled() ) {
	            this.searchRegion.show( new SearchNotAllowedView() );
	            return;
	        }
	
	
	        this.showBodyRegions();
	
	
	    },
	
	
	    /**
	     * The searchRegion and bodyResults regions
	     * Always want a header section always in DOM to show spinner ( can't be shown if not in DOM yet ).
	     * Don't need for clear (spinner would be removed but it's a smoother transition )
	     * Assumes there are creatable note types so we can do a search.
	     * TODO: should be it's on region
	     */
	    showBodyRegions: function() {
	
	        var channel = this.channel,
	            state = channel.request('state'),
	            searchPerformed = state.get('searchPerformed');
	
	        // Search:
	
	        if ( !searchPerformed ) {
	
	            // No predefined searches
	            if ( state.get('searches').length < 1 ) {
	
	
	                this.searchRegion.show( new SearchView({
	                    channel: channel,
	
	                    model: channel.request('getNewSearchModel'),
	
	                    onSubmit: function( searchModel ) {
	
	                        this.channel.trigger( 'findAndRedact:search', searchModel );
	                    }.bind( this )
	
	                }));
	
	            } else {
	
	                /**
	                 * Predefined searches: in current WF wouldn't have been searched yet.
	                 * Could later refactor to update search progress one at a time.
	                 */
	
	                this.searchRegion.show( new LoadingPredefinedSearchesView({
	                    channel: this.channel
	                }));
	
	            }
	
	
	        }
	        else {
	
	           this.searchRegion.hasView() && this.searchRegion.reset();
	
	        }
	
	        // Results:
	        if ( !searchPerformed ) {
	
	            // If cancel:
	            this.resultsRegion.hasView() && this.resultsRegion.reset();
	            return;
	        }
	
	
	        /**
	         * for large table rendering, at least always show loading indicator for the hits table view in the results.
	         * in future and depending on feedback, may wanto to make more fine-grained loading -- eg:
	         * show loading view for the results table, which may be large -- but await feedback on current
	         */
	
	        this.resultsRegion.once( 'show', function()  {
	
	            requestAnimationFrame( function() {
	                channel.trigger('findAndRedact:hideSpinner');
	            });
	
	        });
	
	
	        requestAnimationFrame( function() {
	
	            channel.trigger('findAndRedact:showSpinner');
	
	            requestAnimationFrame( function() {
	
	                this.resultsRegion.show( new ResultsView({
	                    channel: this.channel
	                }));
	
	            }.bind( this) );
	
	
	        }.bind(this) );
	
	
	
	    }
	
	
	
	});

/***/ },
/* 587 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(589);
	
	var Marionette = __webpack_require__(61),
	    SpinView = __webpack_require__(159);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	        // Note: hide and show require requestAnimationFrame from callers
	        this.listenTo( this.channel, 'findAndRedact:showSpinner', this.showSpinner );
	        this.listenTo( this.channel, 'findAndRedact:hideSpinner', this.hideSpinner );
	
	    },
	
	    template: __webpack_require__(590),
	
	
	    regions: {
	        spinnerRegion:              '#fr-spinner-region'
	    },
	
	    onBeforeShow: function() {
	
	        this._showHiddenSpinView();
	
	    },
	
	    // With newer browsers, we should move to CSS solution ...
	    // Now starts hidden with param
	    _showHiddenSpinView: function() {
	        this.spinnerRegion.show( new SpinView({
	            length: 3,
	            radius: 3,
	            width: 1
	        }, true) );
	
	    },
	
	    showSpinner: function() {
	
	        this.spinnerRegion.currentView.triggerMethod('start');
	    },
	
	    hideSpinner: function() {
	
	        this.spinnerRegion.currentView.triggerMethod('stop');
	
	    }
	
	
	});

/***/ },
/* 589 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<span class=\"FV-subHeader-title\">Find And Redact</span>\n\n\n\n<div id=\"fr-spinner-region\"></div>";
	},"useData":true});

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(592);
	
	
	var Marionette = __webpack_require__(61),
	    SearchModelView = __webpack_require__(593);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	
	    constructor: function() {
	
	        this.channel = null;
	        this.onSubmit = null;
	        this.dontShowFormButtons = false;
	        this.submitButtonTitle = 'Search';
	        this.disableInputs = false;
	        this.extraFormClassName = null;
	        this.focusInputOnShow = false;
	
	        Marionette.LayoutView.apply( this, arguments );
	
	    },
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	        this.onSubmit = options.onSubmit;
	
	        if ( options.dontShowFormButtons ) {
	            this.dontShowFormButtons = true;
	        }
	
	        if ( options.submitButtonTitle ) {
	            this.submitButtonTitle = options.submitButtonTitle;
	        }
	
	        if ( options.disableInputs ) {
	            this.disableInputs = options.disableInputs;
	        }
	
	        if ( options.extraFormClassName ) {
	            this.extraFormClassName = options.extraFormClassName;
	        }
	
	        if ( options.focusInputOnShow ) {
	            this.focusInputOnShow = true;
	        }
	
	
	    },
	
	    template: __webpack_require__(611),
	
	    regions: {
	        searchInputsRegion:  '.fr-search-model-region'
	    },
	
	    serializeData: function() {
	
	        var state = this.channel.request('state'),
	            searchPerformed = state.get('searchPerformed'),
	            hasExtraFormClassName = this.extraFormClassName && this.extraFormClassName.length > 0;
	
	        return {
	            hasExtraFormClassName: hasExtraFormClassName,
	            extraFormClassName: hasExtraFormClassName ? this.extraFormClassName : '',
	            submitButtonTitle: this.submitButtonTitle,
	            dontShowFormButtons: this.dontShowFormButtons,
	            showSearchButtonAsButtonInfo: searchPerformed, // TODO: ... IN use? maybe add class?
	            disableSearch: !this.model.isValid()
	
	        };
	
	    },
	
	    ui: {
	        form:           '.fr-search-form',
	        submitButton:   '.fr-search-submit'
	    },
	
	    events: {
	        'submit @ui.form':  'searchSubmitted',
	        'click':            'stopPropagationOnClick' // TODO: for when a dropdown -- put in logic or just do better
	    },
	
	    onRender: function() {
	        this.toggleSubmitBtnEnabled();
	    },
	
	
	    stopPropagationOnClick: function(e) {
	        e.stopPropagation();
	    },
	
	    onBeforeShow: function() {
	
	        this.searchInputsRegion.show( new SearchModelView({
	            channel: this.channel,
	            model: this.model,
	            disableInputs: this.disableInputs,
	            parentForm: this,
	            focusInputOnShow: this.focusInputOnShow
	        }));
	    },
	
	    searchSubmitted: function(e) {
	        e.preventDefault();
	        this.onSubmit( this.model );
	    },
	
	    toggleSubmitBtnEnabled: function() {
	
	        if ( !this.dontShowFormButtons ) {
	            this.ui.submitButton[0].disabled = !this.model.isValid();
	        }
	
	    }
	
	
	
	});

/***/ },
/* 592 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(594);
	
	var Marionette = __webpack_require__(61),
	    NoteTypeSelectView = __webpack_require__(595),
	    NoteLevelPropertiesView = __webpack_require__(598);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        this.searchModel = options.model;
	        this.disableInputs = options.disableInputs ? true : false;
	        this.parentForm = options.parentForm;
	        this.focusInputOnShow = options.focusInputOnShow;
	
	    },
	
	    template: __webpack_require__(610),
	
	    ui: {
	        searchInput:        '.fr-search-input'
	    },
	
	    regions: {
	        noteTypeSelectRegion:       '.fr-note-type-select-region',
	        noteLevelPropertiesRegion:  '.fr-search-note-properties-region'
	    },
	
	    serializeData: function() {
	
	        var searchTerm = this.searchModel.get('searchTerm');
	
	        return {
	            searchTerm: searchTerm === null ? '' : searchTerm,
	            disableSearch: this.disableInputs
	        };
	
	    },
	
	    events: {
	        'input @ui.searchInput':    'searchInputChange'
	    },
	
	    onShow: function() {
	
	        if ( this.focusInputOnShow ) {
	
	            setTimeout( function() {
	                this.ui.searchInput.focus();
	            }.bind(this), 0 );
	
	        }
	
	    },
	
	    /**
	     * Create child view onRender, not onBeforeShow due to bug in this version of Marionette
	     */
	    onRender: function() {
	
	        /* perhaps combine? */
	        this._showNoteTypeSelectView();
	        this._showNoteLevelPropertiesView();
	
	    },
	
	    /* Issue -- don't want to re-render when already focused in this input field -- toggle appropriate I think */
	    /* Better way to stop it -- just send an event */
	    searchInputChange: function(e) {
	
	        e.stopPropagation(); // (Mousetrap - hotkeys )
	        this.searchModel.setSearchTerms( $(e.target).val() );
	
	        this.parentForm && this.parentForm.toggleSubmitBtnEnabled();
	
	    },
	
	    _showNoteTypeSelectView: function() {
	
	        this.noteTypeSelectRegion.show( new NoteTypeSelectView({
	            channel: this.channel,
	            noteTypeGroup: this.searchModel.getNoteModel().getNoteTypeGroup(),
	            renderDisabled: this.disableInputs,
	
	            onChange: function( noteType ) {
	
	
	                var newNote = this.channel.request( 'getNewNoteModel', noteType );
	
	                // TODO --  any cleanup here -- if edit likely ...
	                this.searchModel.setNoteModel( newNote );
	
	                this._showNoteLevelPropertiesView();
	
	            }.bind( this )
	
	        }));
	
	    },
	
	    _showNoteLevelPropertiesView: function() {
	
	
	        this.noteLevelPropertiesRegion.show( new NoteLevelPropertiesView({
	            channel: this.channel,
	            model: this.searchModel.getNoteModel(),
	            disableInputs: this.disableInputs
	        }));
	
	    }
	
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 594 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(596);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	
	/**
	 * Maybe we change this to CHOSEN ....
	 */
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'fr-note-type-select-wr',
	    template: __webpack_require__(597),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        this.noteTypeGroup = options.noteTypeGroup; // ( value we use to set is from the group; this can be passed in null ) -- give it the note model instead?
	        this.onChange = options.onChange;
	        this.renderDisabled = options.renderDisabled;
	
	    },
	
	    ui: {
	        'selectBox': '.fr-note-type-select'
	    },
	
	    events: {
	        'change @ui.selectBox':  'onSelectValueChange'
	    },
	
	    serializeData: function() {
	
	        var creatableNotesHelper =
	            this.channel.request('creatableNoteTypesHelper');
	
	        var noteConstructorsToPrint = creatableNotesHelper.getPrintedNoteTypesForFindAndRedact();
	        var noteTypesToDisable = creatableNotesHelper.getDisallowedFindAndRedactNoteTypes();
	
	        var noteTypeCxt = _.map(  noteConstructorsToPrint, function( note, noteType ) {
	
	            return {
	                noteType: noteType,
	                displayName: note.prototype.desc,
	                disable: noteTypesToDisable.indexOf( noteType ) > -1
	            };
	
	        });
	
	        noteTypeCxt =_.sortBy( noteTypeCxt, function( typeCxt ) {
	            return typeCxt.displayName;
	        } );
	
	        return {
	            noteTypes: noteTypeCxt,
	            disableSelectBox: this.renderDisabled || creatableNotesHelper.allFindAndRedactNoteTypesDisabled() // ( could just not render this if there are none, but this is fine )
	        };
	
	    },
	
	    onRender: function() {
	
	        this.ui.selectBox.val( this.noteTypeGroup );
	
	    },
	
	    onSelectValueChange: function( e ) {
	
	        this.onChange( $(e.target).val() );
	
	    }
	
	
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 596 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <option value=\""
	    + alias2(alias1((depth0 != null ? depth0.noteType : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.displayName : depth0), depth0))
	    + "\" "
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.disable : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">"
	    + alias2(alias1((depth0 != null ? depth0.displayName : depth0), depth0))
	    + "</option>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<select class=\"fr-note-type-select\" title=\"Note Type\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSelectBox : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.noteTypes : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</select>\n\n\n\n";
	},"useData":true});

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(599);
	
	var Marionette = __webpack_require__(61),
	    AccessGroupSelector = __webpack_require__(173),
	    ConsultGroupSelector = __webpack_require__(161),
	    ShapePropertiesViewFactory = __webpack_require__(600),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	/**
	 * No Subclass yet by type yet, it's generic enough -- may want a factory.
	 *
	 */
	
	module.exports = Marionette.LayoutView.extend({
	
	    constructor: function() {
	
	        this.channel = null;
	        this.model = null; // ( searchModel )
	
	        this.disableInputs = false;
	        this.includeZonePropertiesView = false;
	
	        this.showConsultGroupSelection = null;
	
	        Marionette.LayoutView.apply( this, arguments );
	
	    },
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        // ( this.model is passed in already )
	
	        if ( options.disableInputs ) {
	            this.disableInputs = true;
	        }
	
	        this.includeZonePropertiesView = this.model.shape.getHasCustomizableProperties();
	
	        this.showConsultGroupSelection = this.model.showConsultGroupSelectorOnNoteViews(); // what is none exist in system?
	
	    },
	
	    template: __webpack_require__(609),
	
	    regions: {
	        consultGroupRegion:     '.fr-consult-group-selector',
	        accessGroupRegion:      '.fr-access-group-selector',
	        shapePropertiesRegion:  '.fr-note-level-shape-properties-region'
	    },
	
	    ui: {
	        subjectInput:           '.fr-note-subject',
	        autoDisplayRadioBtn:    '#fr-autoDisplay', // TODO: form id with for attr ...
	        notePropertiesHeader:   '.fr-note-properties-header', // TODO: use plugin
	        zonePropertiesHeader:   '.fr-note-zone-header', // TODO: use a plugin here ...
	
	        notePropertiesSection:  '.fr-note-properties'
	    },
	
	
	    events: {
	        'input @ui.subjectInput':           'subjectChange', // (input works IE9+)
	        'change @ui.autoDisplayRadioBtn':   'autoDisplayChange',
	
	        'click @ui.zonePropertiesHeader':   'toggleZoneProperties', // TODO: plugin
	        'click @ui.notePropertiesHeader':   'toggleNoteProperties' // TODO: plugin
	    },
	
	    serializeData: function() {
	
	        return  {
	
	            subject: this.model.get('title'),
	            maxSubjectMax: fvChannel.request('getPageNoteTitleMaxLength'), // works IE10+
	            showAutoDisplay: this.model.autoDisplayApplies,
	            autoDisplay: this.model.autoDisplayNote(),
	            includeZonePropertiesView: this.includeZonePropertiesView,
	            showConsultRow: this.showConsultGroupSelection,
	            disableNotePropertyInputs: this.disableInputs,
	
	            // TODO: no longer desired -- and if do, use plugin ...
	            collapseZoneProperties: false,
	            collapseNoteProperties: false
	
	        };
	
	    },
	
	    onBeforeShow: function() {
	
	        var user = fvChannel.request('user');
	
	        /* --- Note Level --- */
	
	        this.accessGroupRegion.show( new AccessGroupSelector({
	
	            groups: user.groups.getArrayOfModelAttrsSortedByName(), // TODO: sort on the view layer
	            onChange: _.bind( function( selectedGroup ) {
	
	                // TODO: api should change so group name properties match -- or it takes a group model ....
	                // What a disaster i was given to work with
	
	                this.model.set({
	                    accessGroup: selectedGroup.groupId,
	                    accessGroupName: selectedGroup.name // TODO: do we ever use this name ???
	                });
	
	
	            }, this),
	
	            selectedGroupId: this.model.get('accessGroup'),
	            renderDisabled: this.disableInputs
	
	        }));
	
	
	        if ( this.showConsultGroupSelection ) {
	
	            this.consultGroupRegion.show( new ConsultGroupSelector({
	
	                userConsultGroups: user.getReferralGroups(),
	                note: this.model,
	                renderDisabled: this.disableInputs,
	
	                /**
	                 * Store selected groups on the model for saving later.
	                 * Should change reviewGroups serverSide in DocViewer API ...
	                 * Regular note process only saves the 'live color'; ...
	                 * TODO: it should be changed to store the selected groups live instead ( if there's a larger need )
	                 */
	                onChange: _.bind( function( selectedGroups ) {
	
	                    this.model.set({
	                        reviewGroups: {
	                            consultation: selectedGroups // ( consultation set to null if none exist )
	                        }
	                    });
	
	
	                }, this)
	
	            }) );
	        }
	
	        /* -- Shape Level --*/
	
	        if ( this.includeZonePropertiesView ) {
	
	            var ShapePropertiesView = ShapePropertiesViewFactory( this.model, 'note' );
	
	            this.shapePropertiesRegion.show( new ShapePropertiesView({
	                shape: this.model.shape,
	                renderDisabled: this.disableInputs,
	                channel: this.channel
	            }) );
	
	        }
	
	    },
	
	    /* The subject of the saved note will be that of the search, unless the user enters something */
	    subjectChange: function( e ) {
	        this.model.set( 'title', $(e.target).val() );
	    },
	
	    autoDisplayChange: function( e ) {
	        this.model.set( 'noteStatus', $(e.target).is(':checked') ? 'V' : 'I' );
	    },
	
	
	
	    // TODO:  plugin
	    toggleNoteProperties: function() {
	
	        this.ui.notePropertiesHeader.find('i').toggleClass('icon-right-dir-1 icon-down-dir-1');
	        this.ui.notePropertiesSection.toggleClass('hide');
	
	    },
	
	    // TODO:  plugin ... this is even too hacky
	    toggleZoneProperties: function() {
	
	        this.ui.zonePropertiesHeader.find('i').toggleClass('icon-right-dir-1 icon-down-dir-1');
	        this.shapePropertiesRegion.$el.toggleClass('hide');
	
	    }
	
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 599 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var HighlightShapeView = __webpack_require__(601),
	    StrikeThroughShapeView = __webpack_require__(603),
	    RedactionNoteLevelView = __webpack_require__(604),
	    RedactionShapeLevelView = __webpack_require__(608);
	
	/**
	 * Utilize factory instead of another reference on the model prototype
	 * ShapeOrNoteLevel: 'shape' or 'note'
	 * - I think intended if meant for top level ( search module ) or zone level
	 * - Could also mean dialog or not -- eg could implement note level dialogs
	 */
	
	
	module.exports = function( noteModel, shapeOrNoteLevel ) {
	
	    // Currently nothing/unused ( and now not broken into different levels )
	    if ( noteModel.isHighlightNote() ) {
	
	        return HighlightShapeView;
	
	    }
	
	    // For now use the same for floating - non floating
	    if (  noteModel.isRedactionNote() ) {
	
	        return shapeOrNoteLevel === 'note'
	            ? RedactionNoteLevelView
	            : RedactionShapeLevelView;
	
	    }
	
	
	};

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var BaseView = __webpack_require__(602);
	
	
	module.exports = BaseView.extend({
	
	});

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61);
	
	
	/**
	 * TODO: now seeThroughFill / color would apply but not in app yet and is done differently depending on the shape type --
	 * original color is already set in a roundabout way
	 * Maybe don't extend these, have a region for non common and show them ...
	 */
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    template: false,
	
	    regions: {}, // even if none, leave to extends
	
	    initialize: function(options) {
	
	        this.shape = options.shape;
	
	        this.channel = options.channel;
	
	        // use as indicator to disable
	        this.renderDisabled = options.renderDisabled;
	
	    }
	
	
	
	});

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var BaseView = __webpack_require__(602);
	
	
	module.exports = BaseView.extend({
	
	});

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var BaseView = __webpack_require__(605);
	
	/**
	 * This is now only for the top level model
	 */
	
	module.exports = BaseView.extend({
	
	});

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(606);
	
	var BaseShapeView = __webpack_require__(602),
	    RedactionZonePropertiesView = __webpack_require__(236);
	
	/**
	 * Now kinda like abstract class.
	 * It's now just a wrapper for the actual redaction zone dialog view.
	 */
	
	
	module.exports = BaseShapeView.extend({
	
	    className: 'fr-redaction-zone-properties',
	
	    template: __webpack_require__(607),
	
	    regions: _.extend( {}, BaseShapeView.prototype.regions, {
	
	        redactionZonePropertiesRegion: '.fr-redaction-zone-properties-region'
	
	    } ),
	
	    onBeforeShow: function() {
	
	        this.redactionZonePropertiesRegion.show( new RedactionZonePropertiesView( this.dialogOptions() ) );
	    },
	
	    dialogOptions: function() {
	
	        return {
	            renderDisabled: this.renderDisabled,
	            shapeModel: this.shape
	        };
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 606 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"fr-redaction-zone-properties-region\"></div>";
	},"useData":true});

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseView = __webpack_require__(605);
	
	
	/**
	 * Here currently implies the shape level view in the results.
	 * Currently no dropdown at the note level, just in the top search model.
	 * Opening and closing via the dropdown plugin vs open/destroy,
	 */
	
	module.exports = BaseView.extend({
	
	    dialogOptions: function() {
	
	        var options = BaseView.prototype.dialogOptions.apply( this, arguments );
	
	        /*  getting around inheritance issues now ... */
	        options.onReasonCodeSubViewChange  = _.bind( this.onReasonCodeSubViewChange, this );
	        options.selectAllReasonCodes = _.bind( this.selectAllReasonCodes, this );
	        options.clearAllReasonCodes = _.bind( this.clearAllReasonCodes, this );
	
	        return options;
	
	    },
	
	    events: _.extend( {}, BaseView.prototype.events, {
	
	        'click': 'stopPropagationOnClick'
	    }),
	
	    stopPropagationOnClick: function(e) {
	
	        e.stopPropagation();
	    },
	
	    onReasonCodeSubViewChange: function( selectedReasonCodes ) {
	        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, selectedReasonCodes );
	
	    },
	
	    selectAllReasonCodes: function() {
	
	        var codes = this.redactionZonePropertiesRegion.currentView._getReasonCodeModelsForSelectAll();
	        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, codes, 1 );
	
	    },
	
	    clearAllReasonCodes: function() {
	        this.channel.trigger( 'findAndRedact:hitShapeReasonCodesChange', this.shape, null, 1 );
	
	    },
	
	    /**
	     *  Proxy from the dialog close when view used as it's content ( hack -- when called as dialog ).
	     *  Unlike the top level search, we do need to tell if the reason codes and fill changed --
	     *  these are all new and the properties are set from local storage.
	     *  Need to update for next dialog open
	     */
	    onDialogClose: function() {
	
	        this.shape.updateLocalStoragePostDialogClose( 1 );
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "icon-right-dir-1";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "icon-down-dir-1";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"disabled\"";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "            <div class=\"fr-note-row\">\n                <label>Consult Group:</label>\n                <div class=\"fr-consult-group-selector fr-note-field-input chosen-consult-grp-wr\" data-region=\"true\"></div>\n            </div>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "            <div class=\"fr-note-row\">\n                <label for=\"fr-autoDisplay\">Auto-Display:</label>\n                <input id=\"fr-autoDisplay\" type=\"checkbox\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.autoDisplay : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableNotePropertyInputs : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " >\n            </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n        <div class=\"fr-note-zone-header fr-section-toggle\" title=\"Zone Properties\">\n            <i class=\"fr-section-collapse icon "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.collapseZoneProperties : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + "\" tabindex=\"0\"></i>\n            Zone Properties\n        </div>\n\n        <div class=\"fr-note-level-shape-properties-region "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.collapseZoneProperties : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-region=\"true\"></div>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"fr-note-level-properties-inner\">\n\n    <div class=\"fr-note-properties-header fr-section-toggle fr-note-row\" title=\"Note Properties\">\n        <i class=\"fr-section-collapse icon "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.collapseNoteProperties : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + "\" tabindex=\"0\"></i>\n        Note Properties\n    </div>\n\n    <div class=\"fr-note-properties "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.collapseNoteProperties : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n\n        <div class=\"fr-note-row\">\n            <label>Subject:</label>\n            <input class=\"fr-note-subject fr-note-field-input\"\n                   type=\"text\" value=\""
	    + alias4(((helper = (helper = helpers.subject || (depth0 != null ? depth0.subject : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"subject","hash":{},"data":data}) : helper)))
	    + "\"\n                   title=\"Subject\" placeholder=\"Enter subject...\"\n                   maxlength=\""
	    + alias4(((helper = (helper = helpers.maxSubjectMax || (depth0 != null ? depth0.maxSubjectMax : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"maxSubjectMax","hash":{},"data":data}) : helper)))
	    + "\"\n                   "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableNotePropertyInputs : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            >\n        </div>\n\n        <div class=\"fr-note-row\">\n            <label>Accessible By:</label>\n            <div class=\"fr-access-group-selector fr-note-field-input\" data-region=\"true\"></div>\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showConsultRow : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showAutoDisplay : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeZonePropertiesView : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n\n</div>\n\n";
	},"useData":true});

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"fr-note-row\">\n    <input class=\"fr-search-input\" type=\"text\" placeholder=\"Search ...\" value=\""
	    + container.escapeExpression(((helper = (helper = helpers.searchTerm || (depth0 != null ? depth0.searchTerm : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"searchTerm","hash":{},"data":data}) : helper)))
	    + "\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSearch : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n</div>\n\n<div class=\"fr-note-row\">\n    <label class=\"\">Note Type:</label>\n    <div class=\"fr-note-type-select-region\" data-region=\"true\"></div>\n</div>\n\n<div class=\"fr-search-note-properties-region fr-note-row\" data-region=\"true\"></div>";
	},"useData":true});

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "        <div class=\"fr-bottom-button-row clearfix\">\n\n            <div class=\"fr-bbr-left pull-left\">\n                <input class=\"fr-search-submit btn btn-small btn-blue "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSearchButtonAsButtonInfo : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "~\" type=\"submit\" value=\""
	    + container.escapeExpression(((helper = (helper = helpers.submitButtonTitle || (depth0 != null ? depth0.submitButtonTitle : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"submitButtonTitle","hash":{},"data":data}) : helper)))
	    + "\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSearch : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n            </div>\n\n        </div>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "btn-info";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<form class=\"fr-search-form "
	    + container.escapeExpression(((helper = (helper = helpers.extraFormClassName || (depth0 != null ? depth0.extraFormClassName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"extraFormClassName","hash":{},"data":data}) : helper)))
	    + "\">\n\n    <div class=\"fr-search-model-region\" data-region=\"true\"></div>\n\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.dontShowFormButtons : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</form>\n\n\n\n\n\n\n\n";
	},"useData":true});

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(613);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    HitsTableView = __webpack_require__(614),
	    HitsActionRowView = __webpack_require__(635),
	    SearchSectionView = __webpack_require__(638),
	    ResultsHeaderView = __webpack_require__(644),
	    NoResultsView = __webpack_require__(646);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    className: '#fr-results-wr',
	
	    template: __webpack_require__(649),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	        this.listenTo( this.channel, 'findAndRedact:updateActionRow', this._showHitsActionRowView );
	
	    },
	
	    regions: {
	        searchSectionRegion:          '#fr-results-searches',
	        resultsHeaderRow:             '#fr-results-header-row',
	        hitsActionRowRegion:          '#fr-action-row',
	        hitsTableRegion:              '#fr-hits-table',
	        noResultsRegion:              '#fr-no-results'
	    },
	
	    onBeforeShow: function() {
	
	        this._showSearchesView();
	
	        if ( this.channel.request('state').searchHasResults() ) {
	
	            this.resultsHeaderRow.show( new ResultsHeaderView({
	                channel: this.channel
	            }));
	            this._showHitsActionRowView();
	            this._showHitsTable();
	
	        } else
	        {
	            this.noResultsRegion.show( new NoResultsView({
	                channel: this.channel,
	                searchTerms: this.channel.request('state').get('searches').pluck('searchTerm')
	            }));
	        }
	
	    },
	
	    _showSearchesView: function() {
	
	        this.searchSectionRegion.show( new SearchSectionView({
	            channel: this.channel
	        }));
	
	    },
	
	    _showHitsActionRowView: function() {
	
	        this.hitsActionRowRegion.show( new HitsActionRowView({
	            channel: this.channel
	        }) );
	
	    },
	
	    // could be diff depending on the note type
	    // actually have the same columns always; but the hit view 2nd row could have a zone properties section
	    _showHitsTable: function() {
	
	        this.hitsTableRegion.show( new HitsTableView({
	            channel: this.channel
	        }) );
	
	
	    }
	
	});

/***/ },
/* 613 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(615);
	
	// Using a composite view instead of Layout so can attach the collection view directly to tbody -- stopped; these will be deprecated on upgrade.
	// - and should upgrade anyway, especially for increased performance
	// Maybe the layout here changes anyone do to need for a fixed header, in which case we go back to Layout with collection view
	// Alt: if can update to V.3 can use replaceElement option
	
	
	/**
	 * No theader -- print the rows views just inside the table now
	 * Could get rid of this and put inside the results view now ...
	 */
	
	var Marionette = __webpack_require__(61),
	    RowHierarchyView = __webpack_require__(616);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    tagName: 'table',
	
	    id: 'fr-results-table',
	
	    template: __webpack_require__(634),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	    },
	
	    regions: {
	        tableBodyRegion:    '#fr-results-table-body'
	    },
	
	    onBeforeShow: function() {
	
	        // Hack: rid 'div' inserted in the region after the tbody.
	        this.tableBodyRegion.once( 'show', _.bind(function() {
	           this.tableBodyRegion.$el.find('tr:first').unwrap();
	        }, this));
	
	
	        this.tableBodyRegion.show( new RowHierarchyView({
	            channel: this.channel
	        }));
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 615 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    HitRowView = __webpack_require__(617),
	    HeaderRowView = __webpack_require__(628),
	    RowViewFactory = __webpack_require__(629);
	
	
	/**
	 * Initially was a collection view, then babysitter view, which had to be flat -- not hierarchical.
	 * Now changed to an array -- should actually become a hierarchy data structure at this point.
	 */
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: false,
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        this.rowViews = []; // remove baby-sitter to check performance improvement
	    },
	
	    onBeforeShow: function() {
	
	        var buffer = document.createDocumentFragment();
	
	        var tree = this.channel.request('state').getSearchResultsTree(),
	            root = tree.getRoot();
	
	        /* First append the root as the 'header' */
	        this.rowViews.push( new HeaderRowView( {
	            model: root,
	            channel: this.channel
	        }) );
	
	        var rootChildren = root.getChildren();
	
	        for ( var level_1_id in rootChildren ) {
	
	            var firstLevelNode = rootChildren[level_1_id],
	                childMap = firstLevelNode.getChildren(),
	                firstLevelNodeHasMultipleChildren = Object.keys( childMap ).length > 1; // This could be stored on the model ...
	
	            var RowConstructor = RowViewFactory( firstLevelNode );
	
	            this.rowViews.push( new RowConstructor( {
	                model: firstLevelNode,
	                channel: this.channel
	            }) );
	
	            for ( var level_2_id in childMap ) {
	
	                var secondLevelNode = childMap[level_2_id];
	
	                /**
	                 * Don't print 'level 2 row if the parent only has one child.
	                 * Maybe we just hide -- put attrs has multiple children on them.
	                 * TODO: maywe we do only if the page tree ...? see complications in searchRowWithPageLink
	                 */
	                if ( firstLevelNodeHasMultipleChildren ) {
	
	                    var RowConstructor = RowViewFactory( secondLevelNode );
	
	                    this.rowViews.push( new RowConstructor( {
	                        model: secondLevelNode,
	                        channel: this.channel
	                    } ) );
	                }
	
	                _.each( secondLevelNode.getChildren(), function( hit ) {
	
	                    this.rowViews.push( new HitRowView( {
	                        model: hit,
	                        channel: this.channel
	                    }) );
	
	                }, this);
	
	            }
	        }
	
	        this.rowViews.forEach( function( view ) {
	            //view.triggerMethod('before:show');
	            buffer.appendChild( view.render().el );
	        });
	
	
	        // may need to separate beforeShow for the other views, etc ...
	        this.attachElContent( buffer );
	
	    },
	
	
	    onBeforeDestroy: function() {
	
	        this.rowViews.forEach( function(v) {
	            v.destroy();
	        });
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(618);
	
	
	var BaseRowView = __webpack_require__(619);
	    HitPreviewView = __webpack_require__(625),
	    ShapePropertiesViewFactory = __webpack_require__(600),
	
	__webpack_require__(434);
	
	
	module.exports = BaseRowView.extend({
	
	    className: 'fr-hit-row-view',
	
	    regions: _.extend( {}, BaseRowView.prototype.regions, { // TODO: we don't want hit hitCountRegion
	        previewCellRegion:  '.fr-td-preview'
	    }),
	    
	    /* init is showing as taking considerable time */
	    initialize: function( options ) {
	
	        BaseRowView.prototype.initialize.apply( this, arguments );
	
	        this.zonePropertiesDropdown = null;
	
	        var m = this.model;
	
	        var hitShape = m.get('shape');
	
	        this.listenTo( m , 'change:isMouseOverCanvasShape', this.toggleCanvasShapeHovered );
	
	        // (for now piggy backing off the existing isSelected functionality of the shape )
	        this.listenTo( hitShape.uiModel, 'change:isSelected', this.toggleShapeIsSelected );
	        this.listenTo( hitShape.uiModel, 'change:isDirty', this.toggleShapeIsDirty );
	
	        // This should be OK so only one can be open at a time; don't need to fire event for all.
	        // We don't allow 2 dialogs of the same shape to be open at once.
	        this.listenTo( hitShape, 'canvas:zoneDialogOpened', this.forceCloseDialog );
	
	        // Cache once; should pass from parent for more perf gains ...
	        // Could dynamically add event to toggleZonePropertiesDialog but this would hurt performance,
	        // And isn't necessary for views without a dialog
	
	        this.showZonePropertiesColumn = hitShape.getHasCustomizableProperties();
	    },
	
	    serializeData: function() {
	
	        var baseCxt = BaseRowView.prototype.serializeData.apply( this, arguments );
	
	        return _.extend( baseCxt, {
	            isHitRow: true,
	            showRevertBtn: this.model.get('shape').uiModel.get('isDirty'),
	            showZonePropertiesColumn: this.showZonePropertiesColumn
	        }) ;
	
	    },
	
	    ui: _.extend( {}, BaseRowView.prototype.ui, {
	        zonePropertiesOpenerBtn:    '.fr-hit-more-btn',
	        revertShapePositionBtn:     '.fr-revert-shape-position'
	    }),
	
	    // would delegation make more efficient at collection level make more efficient ?
	    events:  _.extend( {}, BaseRowView.prototype.events, {
	
	        'click @ui.revertShapePositionBtn':     'onRevertShapePosition',
	        'click @ui.zonePropertiesOpenerBtn':    'toggleZonePropertiesDialog'
	    }),
	
	
	    /**
	     * Create child view onRender, not onBeforeShow due to bug in this version of Marionette
	     * ( see below notes )
	     * this is also taking considerable time when looking at performance in Chrome tools/
	     * ( Base only calls showHitCountView currently )
	     */
	    onRender: function() {
	
	        if ( this.model.get('isApplied') ) {
	            this.$el.addClass( 'isApplied' );
	        }
	
	        if ( this.model.get('isCollapsed') ) {
	            this.$el.addClass( 'hide' );
	        }
	
	        this._createHitPreviewView();
	
	        this.toggleShapeIsSelected();
	
	    },
	
	    /*
	     *  Bug: onBeforeShow not called on children on children of composite/collection view
	     *  https://github.com/marionettejs/backbone.marionette/issues/2428
	     * TODO: -- we should upgrade anyway
	     * onShow would work but in this version but currently unecessary
	     * here: onRender show work for the hitPreview view ( won't yet be in DOM ) and dropdown view is done
	     * on demand for higher performance
	    onBeforeShow: function() {
	        this._createHitPreviewView();
	    },
	    */
	    _createHitPreviewView: function() {
	
	        this.previewCellRegion.show( new HitPreviewView({
	            model: this.model,
	            channel: this.channel
	        }));
	
	    },
	
	    /**
	     * Create zone dialog on the fly for performance.
	     * We could have a lot of hit views, don't create these unless necessary on demand.
	     * Now it's actually a create from the initial button click event -- then the plugin takes over.
	     */
	    toggleZonePropertiesDialog: function(e) {
	
	        // Don't allow to propagate -- there's click event handlers set by the plugin once established.
	        // With current design of the plugin, this will not get called again ('click', stopImmediatePropagation).
	
	        // So never need to call destroy -- also not really necessary to destroy once it's been created.
	        // If there's ever a reason to do so or another use case, we can change the code
	        // ** Update: there now is one: to be more consistent with the redaction properties dialog. **
	        // - do this when combine dialog views
	        // - may want a subview region show each time
	        e.stopPropagation();
	
	        var hitShape = this.model.get('shape');
	
	        if ( !this.zonePropertiesDropdown ) {
	
	            // Hack is now to create the view, append it to the DOM, and then call the dropdown
	            // plugin on the opener with it's content set the the view DOM element
	
	            var ShapePropertiesView = ShapePropertiesViewFactory( hitShape.parentNote, 'shape' );
	
	            var vChannel = this.channel.request('vChannel');
	
	            this.zonePropertiesDropdown = new ShapePropertiesView({
	                shape: hitShape,
	                channel: this.channel
	            });
	
	            // Note: would like to position relatively inside a container and not move on scroll,
	            // but then dropdown would be positioned 'inside' the side container.
	            // Area for optimization -wr::
	            vChannel.request('getWrapper').append(
	                this.zonePropertiesDropdown.render().el
	            );
	
	            // Mimic a show event for it to render as we're calling calling from a region in the view
	            this.zonePropertiesDropdown.triggerMethod('beforeShow');
	
	            // Note: custom open event wasn't working -- just use a click, which is working
	            this.ui.zonePropertiesOpenerBtn.dropDown({
	
	                content: this.zonePropertiesDropdown.$el,
	                //openEvent: 'dd-open',
	                isNotMenu: true, // don't capture click events on the dropdown (here view) -- also requires to prevent default click on inner view
	
	                onBeforeOpen: function() {
	                    vChannel.trigger( 'findAndRedact:openHitShapeDialog', hitShape );
	                },
	                // Proxy the onBeforeClose event from the dropdown plugin to the view -- (hack)
	                onBeforeClose: _.bind(function() {
	
	                    this.zonePropertiesDropdown.triggerMethod('dialogClose');
	
	                    // this.ui.zonePropertiesOpenerBtn.destroy(); -- problem: this removes the opener
	                    // would really want to print the whole thing s...
	                    // when reopened, then most used reason codes would be placed atop
	
	                }, this)
	
	
	            }).trigger('click');
	
	        }
	
	
	    },
	
	    forceCloseDialog: function() {
	
	        if ( this.zonePropertiesDropdown ) {
	            this.ui.zonePropertiesOpenerBtn.getDDEl().trigger('close');
	        }
	
	    },
	
	    mouseEnter: function() {
	        this.model.setIsMouseOverRowView( true );
	    },
	
	    mouseLeave: function() {
	        this.model.setIsMouseOverRowView( false );
	    },
	
	    updateIsApplied: function() {
	
	        var isApplied = this.model.get('isApplied');
	        this.ui.selectHitCb[0].checked = isApplied;
	        this.$el.toggleClass( 'isApplied', isApplied );
	
	    },
	
	
	    updateIsCollapsed: function( ) {
	        this.$el.toggleClass( 'hide', this.model.get('isCollapsed') );
	    },
	
	    onRevertShapePosition: function() {
	        this.channel.trigger( 'findAndRedact:revertShapePosition', this.model );
	    },
	
	    // TODO: scroll but we don't know the scroller yet
	    toggleCanvasShapeHovered: function( hit, isMouseOverCanvasShape ) {
	        this.$el.toggleClass( 'isMouseOverCanvasShape', isMouseOverCanvasShape );
	    },
	
	    toggleShapeIsSelected: function() {
	
	        this.$el.toggleClass( 'isShapeSelected', this.model.get('shape').uiModel.get('isSelected') );
	
	    },
	
	    toggleShapeIsDirty: function( shapeUiModel, isDirty ) {
	        this.ui.revertShapePositionBtn.toggleClass( 'hide', !isDirty );
	    },
	
	    destroy: function() {
	
	        this.stopListening();
	
	        this.zonePropertiesDropdown && this.zonePropertiesDropdown.destroy();
	
	        BaseRowView.prototype.destroy.apply( this, arguments );
	
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 618 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(620);
	
	var Marionette = __webpack_require__(61),
	    HitCountView = __webpack_require__(621); // this may be variable -- not on hit count view
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    tagName: 'tr',
	
	    ROW_TYPE_CLASS_NAME: '',
	
	    template: __webpack_require__(624),
	
	    className: function() {
	
	        return 'fr-hit-row-view fr-hit-row-parent ' + this.ROW_TYPE_CLASS_NAME + ' fr-row-' + this.model.get('rowLevel');
	    },
	
	    initialize: function (options) {
	
	        this.channel = options.channel;
	
	        this.listenTo( this.model, 'updateIsApplied', this.updateIsApplied );
	        this.listenTo( this.model, 'updateIsCollapsed', this.updateIsCollapsed );
	
	    },
	
	    serializeData: function() {
	
	        var m = this.model;
	
	        return {
	            isApplied: m.get('isApplied')
	        };
	
	    },
	
	    onRender: function() {
	
	        this.updateIsCollapsed(); // Not in template now, more logic involved
	        this.showHitCountView();
	
	    },
	
	    regions: {
	        hitCountRegion: '.fr-page-hit-count-region'
	    },
	
	    ui: {
	        collapsibleBtn: '.collapsible-btn',
	        selectHitCb:    '.fr-select-hit-cb'
	    },
	
	    events: {
	        'click @ui.collapsibleBtn': 'collapseBtnClick',
	        'click @ui.selectHitCb':    'appliedInputBoxClicked',
	        'mouseenter': 'mouseEnter',
	        'mouseleave': 'mouseLeave'
	    },
	
	    showHitCountView: function() {
	
	        var hits = this.model.getLowestLevelChildren();
	
	        var nAppliedHits = 0;
	
	        if ( hits.length > 0 ) {
	
	            nAppliedHits = hits.filter( function(hit) {
	                return hit.get('isApplied');
	            }).length;
	        }
	
	        this.hitCountRegion.show( new HitCountView({
	            numberHits: hits.length,
	            numberAppliedHits: nAppliedHits
	        }));
	
	    },
	
	    // will toggle the model but also needs to take the header into account
	    collapseBtnClick: function() {
	        this.channel.trigger('findAndRedact:updatePostCollapseRowClick', this.model );
	    },
	
	
	    appliedInputBoxClicked: function( ) {
	        this.channel.trigger('findAndRedact:updatePostResultRowIncludeClick', this.model );
	    },
	
	
	    updateIsApplied: function() {
	
	        this.ui.selectHitCb[0].checked = this.model.get('isApplied');
	        this.showHitCountView();
	
	    },
	    updateIsCollapsed: function() {
	
	        var m = this.model,
	            collapse = m.get('isCollapsed');
	
	        /* Collapse Button */
	        this.ui.collapsibleBtn.removeClass('icon-right-dir-1 icon-down-dir-1');
	
	        // TODO: plugin
	        if ( collapse ) {
	            this.ui.collapsibleBtn.addClass('icon-right-dir-1');
	        }
	        else {
	            this.ui.collapsibleBtn.addClass('icon-down-dir-1');
	        }
	
	        /* Toggle row visibility */
	
	        // overlap with hit row ...
	        var parent = m.getParent();
	
	        if ( !m.get('isRoot') && parent && !parent.get('isRoot')  ) {
	            this.$el.toggleClass( 'hide', parent.get('isCollapsed') );
	        }
	
	    },
	
	    mouseEnter: function() {
	
	        this.model.getLowestLevelChildren().forEach( function( hit ) {
	            hit.setIsMouseOverRowView( true );
	        });
	
	    },
	
	    mouseLeave: function() {
	
	        this.model.getLowestLevelChildren().forEach( function( hit ) {
	            hit.setIsMouseOverRowView( false );
	        });
	
	    }
	
	
	});
	


/***/ },
/* 620 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(622);
	
	
	var Marionette = __webpack_require__(61);
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(623),
	
	    serializeData: function() {
	
	        return {
	            numberHits: this.options.numberHits,
	            numberAppliedHits: this.options.numberAppliedHits
	        };
	
	    }
	
	});

/***/ },
/* 622 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<div class=\"fr-n-page-hits-selected\">\n    ( "
	    + alias2(alias1((depth0 != null ? depth0.numberAppliedHits : depth0), depth0))
	    + " / "
	    + alias2(alias1((depth0 != null ? depth0.numberHits : depth0), depth0))
	    + " selected )\n</div>";
	},"useData":true});

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "        <i class=\"fr-revert-shape-position icon-undo "
	    + ((stack1 = helpers.unless.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showRevertBtn : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Revert Shape Position\" tabindex=\"0\"></i>\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "        <i title=\"Expand/Collapse\"\n           class=\"icon fr-page-toggle-collapse-icon collapsible-btn\" tabindex=\"0\"></i>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n    <td class=\"fr-td-preview\" data-region=\"true\" "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showZonePropertiesColumn : depth0),{"name":"unless","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "></td>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showZonePropertiesColumn : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "colspan=\"2\"";
	},"11":function(container,depth0,helpers,partials,data) {
	    return "\n        <td class=\"fr-td-more-btn\">\n\n            <button class=\"fr-hit-more-btn btn\" title=\"Zone Properties...\">\n                <i class=\"icon-ellipsis-vert\"></i>\n            </button>\n            <!-- currently not used <div class=\"fr-zone-prop-holder\" data-region=\"true\"></div> -->\n\n        </td>\n\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n    <td class=\"fr-td-content-col\" colspan=\"2\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHeaderRow : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSearchRow : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isPageRow : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        <div class=\"fr-page-hit-count-region\" data-region=\"true\"></div>\n\n    </td>\n\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <span>"
	    + container.escapeExpression(((helper = (helper = helpers.rowHeader || (depth0 != null ? depth0.rowHeader : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"rowHeader","hash":{},"data":data}) : helper)))
	    + "</span>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "            <span>Search \""
	    + container.escapeExpression(container.lambda((depth0 != null ? depth0.search : depth0), depth0))
	    + "\"</span>"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pageNumber : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return ": <a class=\"fr-page-link\" href=\"Page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "\" title=\"Go to page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "\" role=\"button\">Page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "</a>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "            <a class=\"fr-page-link\" href=\"Page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "\" title=\"Go to page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "\" role=\"button\">Page "
	    + alias2(alias1((depth0 != null ? depth0.pageNumber : depth0), depth0))
	    + "</a>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<td class=\"fr-td-page-toggle-collapse\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHitRow : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n</td>\n\n\n<td class=\"fr-td-include\">\n    <input class=\"fr-select-hit-cb\" title=\"Include\" type=\"checkbox\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isApplied : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n</td>\n\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isHitRow : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(13, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n\n\n";
	},"useData":true});

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(626);
	
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(627),
	
	    tagName: 'span',
	
	    // TODO: maybe even cache the template ?
	    serializeData: function() {
	        return this.model.get('textPreviewTemplateContext');
	    },
	
	    ui: {
	        hitLink:    '.fr-preview-hit'
	    },
	
	    events: {
	        'click @ui.hitLink': 'hitLinkClick'
	    },
	
	    // Left an href to keep get keyboard events
	    hitLinkClick: function(e) {
	
	        e.preventDefault();
	        this.options.channel.trigger( 'findAndRedact:userClickedHit', this.model );
	
	    }
	
	});

/***/ },
/* 626 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isHit : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<span class=\"fr-preview-word\">\n             <a class=\"fr-preview-hit\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
	    + "\" role=\"button\" href=\""
	    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.word : depth0), depth0))
	    + "</a>\n        </span>";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "<span class=\"fr-preview-word\">"
	    + container.escapeExpression(container.lambda((depth0 != null ? depth0.word : depth0), depth0))
	    + "</span>";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.words : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseRowView = __webpack_require__(619);
	
	
	module.exports = BaseRowView.extend({
	
	
	    serializeData: function() {
	
	        var cxt = BaseRowView.prototype.serializeData.apply( this, arguments );
	
	        var isPageHierarchy = this.channel.request('state').get('showResultsByPage');
	
	        return _.extend( {}, cxt, {
	
	            isHeaderRow: true,
	            rowHeader: isPageHierarchy ? "Pages / Hits" : "Searches / Hits"
	
	        });
	
	    },
	
	    events: _.omit( BaseRowView.prototype.events, 'mouseenter', 'mouseleave' )
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	var PageRow = __webpack_require__(630),
	    BaseSearchRow = __webpack_require__(632),
	    SearchHierarchyRowWithNoChildren = __webpack_require__(633);
	
	
	
	/* Now not header and hit -- just page or search */
	
	
	module.exports = function( node ) {
	
	    if ( node.isPageNode() ) {
	        return PageRow;
	    }
	
	    if ( node.isSearchNode() ) {
	
	       if ( node.get('rowLevel') === 2 ) {
	
	           return BaseSearchRow;
	
	       } else {
	
	           if ( node.hasMultipleChildren() ) {
	
	               return BaseSearchRow;
	
	           } else {
	
	               return SearchHierarchyRowWithNoChildren;
	
	           }
	
	       }
	
	    }
	
	};

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseRowView = __webpack_require__(619),
	    RowWithPageLinkMixin = __webpack_require__(631);
	
	/* I'm hating the nested hierarchy ... ! */
	
	module.exports = BaseRowView.extend({
	
	    ROW_TYPE_CLASS_NAME: 'fr-hit-row-view-page',
	
	    initialize: function( options ) {
	
	        BaseRowView.prototype.initialize.apply( this, arguments );
	        RowWithPageLinkMixin.setUpCurrentPageChangeListener.apply( this, arguments );
	
	    },
	
	    // TODO: prob best to set on model ... model hier refactor
	    isCurrentPage: function() {
	        return this.model.get('isCurrentPage');
	    },
	
	    // TODO: prob best to set on model
	    getPageId: function() {
	
	        return this.model.get('pageId');
	    },
	
	    serializeData: function() {
	
	        var baseCxt = BaseRowView.prototype.serializeData.apply( this, arguments );
	
	        return _.extend( baseCxt, {
	            isPageRow: true,
	            pageNumber: this.model.get('pageNumber') // could just have this in the base context ....
	        }) ;
	
	    },
	
	    onRender: function() {
	
	        BaseRowView.prototype.onRender.apply( this, arguments );
	
	        this.toggleIsCurrentPage();
	
	    },
	
	
	    ui: _.extend( {}, BaseRowView.prototype.ui, RowWithPageLinkMixin.ui ),
	
	    events:  _.extend( {}, BaseRowView.prototype.events, RowWithPageLinkMixin.events ),
	
	    pageLinkClick: RowWithPageLinkMixin.pageLinkClick,
	
	    toggleIsCurrentPage: RowWithPageLinkMixin.toggleIsCurrentPage
	
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 631 */
/***/ function(module, exports) {

	module.exports = {
	
	    setUpCurrentPageChangeListener: function() {
	
	        this.listenTo( this.model, 'change:isCurrentPage', this.toggleIsCurrentPage );
	    },
	
	    toggleIsCurrentPage: function() {
	
	        var isCurrentPage = this.isCurrentPage();
	
	        // Could combo but this was causing issue inheriting mixins in CSS
	        this.ui.pageLink.toggleClass( 'fr-page-link-current-page', isCurrentPage );
	
	        this.$el.toggleClass( 'fr-hit-row-view-page-current', isCurrentPage );
	
	    },
	
	    ui: {
	        pageLink: '.fr-page-link'
	    },
	
	    events: {
	        'click @ui.pageLink': 'pageLinkClick'
	    },
	
	    // TODO: want a 'setPageNavigability' fn like the note views and probably want to use the same component
	    pageLinkClick: function(e) {
	
	        e.preventDefault();
	        this.channel.request('vChannel').command( 'goToPageId', this.getPageId() );
	
	    }
	
	
	};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseRowView = __webpack_require__(619);
	
	
	module.exports = BaseRowView.extend({
	
	    ROW_TYPE_CLASS_NAME: 'fr-hit-row-view-search',
	
	    serializeData: function() {
	
	        var baseCxt = BaseRowView.prototype.serializeData.call( this );
	
	        return _.extend( baseCxt, {
	            search: this.model.get('search').get('searchTerm'),
	            isSearchRow: true
	        });
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseRow = __webpack_require__(632),
	    RowWithPageLinkMixin = __webpack_require__(631);
	
	
	module.exports = BaseRow.extend({
	
	    initialize: function() {
	
	        BaseRow.prototype.initialize.apply( this, arguments );
	
	        // Need to get the page # from the first hit ... could prob do more efficiently when creating in loop ( or setting model driven )
	        this.firstChildHit = this.model.getFirstChild();
	
	        this.listenTo( this.firstChildHit, 'change:isCurrentPage', this.toggleIsCurrentPage );
	
	    },
	
	    onRender: function() {
	
	        BaseRow.prototype.onRender.apply( this, arguments );
	        this.toggleIsCurrentPage();
	
	    },
	
	    serializeData: function() {
	
	        var baseCxt = BaseRow.prototype.serializeData.call( this );
	
	        return _.extend( baseCxt, {
	            pageNumber: this.firstChildHit.get('pageNumber')
	
	        });
	
	    },
	
	
	    isCurrentPage: function() {
	        return this.firstChildHit.get('isCurrentPage'); // could maybe have a getPageNumbers function ...
	    },
	
	    getPageId: function() {
	        return this.firstChildHit.get('pageId');
	    },
	
	
	    ui: _.extend( {}, BaseRow.prototype.ui, RowWithPageLinkMixin.ui ),
	
	    events:  _.extend( {}, BaseRow.prototype.events, RowWithPageLinkMixin.events ),
	
	    pageLinkClick: RowWithPageLinkMixin.pageLinkClick,
	
	    toggleIsCurrentPage: RowWithPageLinkMixin.toggleIsCurrentPage
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<tbody id=\"fr-results-table-body\" data-region=\"true\"></tbody>";
	},"useData":true});

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(636);
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    id: 'fr-action-row-wr',
	
	    initialize: function(options) {
	
	        this.channel = options.channel;
	
	    },
	
	    template: __webpack_require__(637),
	
	    serializeData: function() {
	
	
	        var state = this.channel.request('state'),
	            searchResults = state.get('searchResults'),
	
	            numberHits = searchResults.getNumberOfHits(),
	            appliedHits = searchResults.getAppliedHits(),
	            numberAppliedHits = appliedHits.length,
	            appliedHitsExist = numberAppliedHits > 0;
	
	        var msg = numberAppliedHits + ' / ' + numberHits + ' hits selected';
	
	
	        if ( appliedHitsExist ) {
	
	            var pagesAndSearchesWithHitsApplied = {
	                pageIds: [],
	                searchIds: []
	            };
	
	            appliedHits.reduce( function( prev, curr ) {
	
	                if (curr.get('isApplied')) {
	
	                    var pageId = curr.get('pageId'),
	                        searchId = curr.get('searchModelId');
	
	                    if ( prev.pageIds.indexOf( pageId ) < 0 ) {
	                        prev.pageIds.push( pageId );
	                    }
	
	                    if ( prev.searchIds.indexOf( searchId) < 0) {
	                        prev.searchIds.push( searchId );
	                    }
	                }
	
	                return prev;
	
	            }, pagesAndSearchesWithHitsApplied );
	
	            msg += ' from ' + pagesAndSearchesWithHitsApplied.pageIds.length + ' page' + ( pagesAndSearchesWithHitsApplied.pageIds.length > 1 ? 's' : '');
	
	            if ( pagesAndSearchesWithHitsApplied.searchIds.length > 1 ) {
	                msg += ' and ' + pagesAndSearchesWithHitsApplied.searchIds.length + ' searches';
	            }
	
	        }
	
	        msg = '(' + msg + ')';
	
	        return {
	            message: msg,
	            appliedHitsExist: appliedHitsExist
	        };
	
	    },
	
	    ui: {
	        applyButton:            '#fr-apply',
	        numberHitsIncludedDiv:  '#fr-n-hits-selected' // for now not a view, no events or anything
	    },
	
	    events: {
	        'click @ui.applyButton': 'onApply'
	    },
	
	    onApply: function() {
	
	        this.channel.trigger( 'findAndRedact:apply' );
	
	    }
	
	});

/***/ },
/* 636 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "btn-primary";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"fr-n-hits-selected\">"
	    + container.escapeExpression(((helper = (helper = helpers.message || (depth0 != null ? depth0.message : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"message","hash":{},"data":data}) : helper)))
	    + "</div>\n\n\n<button id=\"fr-apply\" class=\"btn btn-small "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.appliedHitsExist : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.appliedHitsExist : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">Apply\n</button>\n\n";
	},"useData":true});

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    SearchPillsCollectionView = __webpack_require__(639),
	    NewSearchFormView = __webpack_require__(591);
	
	
	module.exports = Marionette.LayoutView.extend({
	
	    template: __webpack_require__(643),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	        this.listenTo( this.channel, 'findAndRedact:updateSearchPills', this._showPillCollectionView );
	
	    },
	
	    regions: {
	        searchPillsRegion:  '#fr-results-search-collection'
	    },
	
	    serializeData: function() {
	
	        var state = this.channel.request('state'),
	            numberOfSearches = state.getNumberOfSearches();
	
	        return {
	            numberOfSearches: numberOfSearches
	        };
	
	    },
	
	    ui: {
	        addSearchBtn:   '#fr-search-results-add-search',
	        clearBtn:       '#fr-search-results-clear'
	    },
	
	    events: {
	        'click @ui.addSearchBtn':   'addNewSearchButtonClick',
	        'click @ui.clearBtn':       'clearButtonClick'
	    },
	
	
	    onBeforeShow: function() {
	
	       this._showPillCollectionView();
	
	    },
	
	    _showPillCollectionView: function() {
	
	        this.searchPillsRegion.show( new SearchPillsCollectionView({
	            channel: this.channel,
	            collection: this.channel.request('state').get('searches') // maybe have a different collection ....  new Backbone.Collection( // .getSearchModels() -- need to show those that returned none
	        }));
	
	    },
	
	
	    addNewSearchButtonClick: function() {
	
	        this.channel.trigger( 'findAndRedact:showAddSearchModal' );
	
	    },
	
	    clearButtonClick: function() {
	
	        this.channel.trigger('findAndRedact:clearSearch');
	    }
	
	
	});

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(640);
	
	var Marionette = __webpack_require__(61),
	    SearchModelView = __webpack_require__(641);
	
	
	module.exports = Marionette.CollectionView.extend({
	
	    id: 'fr-result-search-list',
	
	    childView: SearchModelView,
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	    },
	
	    childViewOptions: function() {
	
	        return {
	            channel: this.channel
	        };
	
	    }
	
	});

/***/ },
/* 640 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    SearchView = __webpack_require__(591); // may want to wrap in different parent forms ...
	
	
	__webpack_require__(434); // now just using the plugin to show the content of the form view
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        this.detailsView = null; // could maybe render the markup as a region that is toggled ?
	
	    },
	
	    template: __webpack_require__(642),
	
	    attributes: function() {
	
	        var model = this.model;
	
	        return  {
	            class: 'fr-searchPillView' + ( model.get('isSelected') ? ' fr-searchPill-selected' : '' ),
	            title: model.get('searchTerm')
	        };
	
	    },
	
	    ui: {
	        removeBtn:  '.fr-search-pill-remove',
	        moreBtn:    '.fr-search-pill-more',
	        editBtn:    '.fr-search-pill-edit'
	    },
	
	    events: {
	        'click':                'toggleCollapsed',
	        'click @ui.removeBtn':  'removeClicked',
	        'click @ui.moreBtn':    'toggleSearchDialog',
	        'click @ui.editBtn':    'editSearchClicked'
	    },
	
	    serializeData: function() {
	
	        var hitsOfSearch = this.channel.request('state').get('searchResults').getHits().getHitsForSearch( this.model.cid );
	
	        return {
	            searchName: this.model.get('searchTerm'), // TODO: use identifier for display name where-ever needed ...
	            numberOfHits: hitsOfSearch.length
	        };
	
	    },
	
	
	    /* HACK -- copied from hit row -- see comments there */
	    /* prob better to create on fly and append to zone below -- not hover */
	    toggleSearchDialog: function(e) {
	
	        /*
	        this.detailsView = new SearchView({
	            channel: this.channel,
	            model: this.model // I want the search view actually ...
	        });
	
	
	        $('.FV').append( this.detailsView.render().el );
	
	        this.detailsView.triggerMethod('beforeShow');
	
	        this.ui.moreBtn.dropDown({
	            content: this.detailsView.$el,
	            isNotMenu: true
	        });
	        */
	
	
	        e.stopPropagation();  // Don't allow to reach the 'click' event
	
	        if ( !this.detailsView ) {
	
	            var vChannel = this.channel.request('vChannel'); // area for perf gain ...
	
	            this.detailsView = new SearchView({
	                model: this.model,
	                channel: this.channel,
	                dontShowFormButtons: true,
	                disableInputs: true,
	                extraFormClassName: 'fr-search-details-popup'
	            });
	
	
	            // Note: would like to position relatively inside a container and not move on scroll,
	            // but then dropdown would be positioned 'inside' the side container.
	            // Area for optimization -wr::
	            vChannel.request('getWrapper').append( this.detailsView.render().el);
	
	            // Mimic a show event for it to render as we're calling calling from a region in the view
	            this.detailsView.triggerMethod('beforeShow');
	
	            // Note: custom open event wasn't working -- just use a click, which is working
	            this.ui.moreBtn.dropDown({
	                content: this.detailsView.$el,
	                isNotMenu: true // don't capture click events on the dropdown (here view) -- also requires to prevent default click on inner view
	            }).trigger('click');
	
	        }
	
	    },
	
	    removeClicked: function( e ) {
	
	        e.stopPropagation(); // Don't allow to reach the 'click' event which will call toggle collapsed and prevent issues
	        this.channel.trigger( 'findAndRedact:removeSearch', this.model );
	
	    },
	
	    editSearchClicked: function( e ) {
	
	        e.stopPropagation(); // Don't allow to reach the 'click' event
	        this.channel.trigger( 'findAndRedact:showEditSearchModal', this.model );
	
	    },
	
	    toggleCollapsed: function( e ) {
	
	        this.channel.trigger( 'findAndRedact:toggleCollapseSearch', this.model );
	    },
	
	    onBeforeDestroy: function() {
	
	        this.detailsView && this.detailsView.destroy();
	    }
	
	
	});

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return alias4(((helper = (helper = helpers.searchName || (depth0 != null ? depth0.searchName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"searchName","hash":{},"data":data}) : helper)))
	    + "<span class=\"fr-search-count badge\" title=\""
	    + alias4(((helper = (helper = helpers.numberOfHits || (depth0 != null ? depth0.numberOfHits : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberOfHits","hash":{},"data":data}) : helper)))
	    + " hits\">"
	    + alias4(((helper = (helper = helpers.numberOfHits || (depth0 != null ? depth0.numberOfHits : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberOfHits","hash":{},"data":data}) : helper)))
	    + "</span> <!-- could position badge in top right if want room */ -->\n\n<span class=\"btn-fr-search-pill fr-search-pill-remove\" title=\"Remove\" tabindex=\"0\">\n    <i class=\"icon-cancel-1\"></i>\n</span>\n\n<span class=\"btn-fr-search-pill fr-search-pill-edit\" title=\"Edit...\" tabindex=\"0\">\n    <i class=\"icon-pencil-squared\" ></i>\n</span>\n\n<span class=\"btn-fr-search-pill fr-search-pill-more\" title=\"Details...\" tabindex=\"0\">\n    <i class=\"icon-down-dir-1\"></i>\n</span>\n\n\n\n\n";
	},"useData":true});

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div id=\"fr-search-row-header\">\n\n    <div class=\"pull-left\">\n        <span id=\"fr-searches-lbl\">Searches</span>\n        <span id=\"fr-search-count\" class=\"badge\">"
	    + container.escapeExpression(((helper = (helper = helpers.numberOfSearches || (depth0 != null ? depth0.numberOfSearches : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"numberOfSearches","hash":{},"data":data}) : helper)))
	    + "</span>\n    </div>\n\n    <div class=\"pull-right\">\n\n        <button id=\"fr-search-results-add-search\" class=\"btn btn-small\" title=\"Add Search...\">\n            <i class=\"icon-plus-circled\"></i> Add\n        </button>\n\n        <button id=\"fr-search-results-clear\" class=\"btn btn-small\" title=\"Clear\">\n            <i class=\"icon icon-cancel-1\"></i>\n            Clear\n        </button>\n    </div>\n\n\n</div>\n\n\n<div id=\"fr-results-search-collection\" data-region=\"true\"></div>\n\n";
	},"useData":true});

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	   template: __webpack_require__(645),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	    },
	
	    ui: {
	        showByPageOrSearchRadioBtns:    '[name=page_or_search]'
	    },
	
	    events: {
	        'change @ui.showByPageOrSearchRadioBtns': 'pageOrSearchViewByRadioChange',
	
	    },
	
	    serializeData: function() {
	
	        var state = this.channel.request('state'),
	            showResultsByPage = state.get('showResultsByPage'),
	            disableShowResultsBySearch = false, //state.getNumberOfSearches() < 2,
	            showResultsBySearch = disableShowResultsBySearch ? false : !showResultsByPage;
	
	
	        return {
	            showResultsByPage: showResultsByPage,
	            showResultsBySearch: showResultsBySearch,
	            disableShowResultsBySearch: disableShowResultsBySearch
	
	        };
	
	    },
	
	    pageOrSearchViewByRadioChange: function(e) {
	
	        var $target = $(e.target),
	            showByPage = $target.val() === 'PAGE'; // (hard coded now ... could get from reason code collection )
	
	        this.channel.trigger( 'findAndRedact:updateShowResultsByTable', showByPage );
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "checked";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"fr-results-lbl\">Results</div>\n\n<div id=\"fr-result-show-by-rbs\">\n\n    <label>\n        <input id=\"fr-show-by-page\" class=\"fr-show-by-rb\" type=\"radio\" name=\"page_or_search\" value=\"PAGE\" title=\"Show results by page\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showResultsByPage : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n               title=\"View By Page\">\n        Page\n    </label>\n\n    <label>\n        <input id=\"fr-show-by-search\" class=\"fr-show-by-rb\" type=\"radio\" name=\"page_or_search\" value=\"SEARCH\" title=\"Show results by search\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showResultsBySearch : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n               title=\"View By Search\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableShowResultsBySearch : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n        Search\n    </label>\n\n</div>";
	},"useData":true});

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(647);
	
	
	var Marionette = __webpack_require__(61);
	
	
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	        this.searchTerms = options.searchTerms;
	
	    },
	
	    template: __webpack_require__(648),
	
	    serializeData: function() {
	
	        return {
	            multipleSearchTerms: this.searchTerms.length > 1,
	            searchTerms: this.searchTerms
	        };
	
	    }
	
	
	});

/***/ },
/* 647 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n        <!-- TODO: list styling -->\n        <ul id=\"fr-no-results-list\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.searchTerms : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        </ul>\n\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "                <li>\""
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "\"</li>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.searchTerms : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "            \""
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "\"\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "\n\n    <i class=\"icon-attention-circled\"></i>\n\n    No Results Found for:\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.multipleSearchTerms : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n";
	},"useData":true});

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"fr-results-searches\" data-region=\"true\"></div>\n\n<div id=\"fr-results-header-row\" data-region=\"true\"></div>\n\n<div id=\"fr-action-row\" data-region=\"true\"></div>\n\n<div id=\"fr-hits-table\" data-region=\"true\"></div>\n\n<div id=\"fr-no-results\" data-region=\"true\"></div>\n\n\n\n";
	},"useData":true});

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(651);
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(652)
	
	});

/***/ },
/* 651 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"fr-search-disabled-view\">\n    <span class=\"icon icon-attention-circled\"></span>\n    User lacks permission to create any notes.\n</div>";
	},"useData":true});

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(654);
	
	
	var Marionette = __webpack_require__(61);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(655),
	
	    initialize: function( options ) {
	
	        this.channel = options.channel;
	
	    },
	
	    serializeData: function() {
	
	        var searches = this.channel.request('state').get( 'searches' );
	
	        return {
	            searches: searches.pluck('searchTerm')
	        };
	
	
	    }
	
	});

/***/ },
/* 654 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "            <li>"
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "</li>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div id=\"fr-search-loading-view\">\n\n    <div id=\"fr-search-loading-header\">Searching ... </div>\n\n    <ul>\n\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.searches : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </ul>\n\n\n</div>\n\n\n\n\n";
	},"useData":true});

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<!-- copying notes this is a common ui component -- using the 'side panel template -->\n\n<div id=\""
	    + container.escapeExpression(((helper = (helper = helpers.paneId || (depth0 != null ? depth0.paneId : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"paneId","hash":{},"data":data}) : helper)))
	    + "\" class=\"sub-side-content no-padding\">\n\n    <div class=\"spWr\">\n\n        <div id=\"fr-header\" class=\"sp-header\" data-region=\"true\"></div>\n\n        <div class=\"sp-body\">\n\n            <div id=\"fr-body\">\n\n                <div id=\"fr-search\" data-region=\"true\"></div>\n\n                <div id=\"find-and-redact-results\" data-region=\"true\"></div>\n\n            </div>\n\n        </div>\n\n    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {
	var TextSearcher = __webpack_require__(658),
	    Hit = __webpack_require__(660),
	    Hits = __webpack_require__(663),
	    FindAndRedactNoteModelConverter = __webpack_require__(584),
	    TopDownResults = __webpack_require__(664),
	    PageTree = __webpack_require__(666),
	    SearchTree = __webpack_require__(671);
	
	
	var SearchResults = function() {
	
	    this.topDownResults = new TopDownResults(); // Array of { note, searchId, search, pageId } -- TODO: call something more approp? ( notes with info ? ) -- this is crucial for the page notes ( broken by page, by search -- and saving )
	
	    // collection of all hits across notes and searches with references back to searches and pageNotes
	    this.hits = new Hits();
	    this.pageTree = new PageTree();
	    this.searchTree = new SearchTree();
	
	};
	
	
	_.extend( SearchResults.prototype, {
	
	    /**
	     * Note: we don't clear here ... do that from caller if was to refresh.
	     */
	    buildResultsFromSearches: function( searches, frChannel ) {
	
	        var vChannel = frChannel.request('vChannel'),
	            currentPageNumber = vChannel.request('currentPageNumber'),
	            activeDocument = vChannel.request('activeDocument'),
	            state = frChannel.request('state'),
	            indexesCache = state.get('subsequentWordIndexCache'),
	            pageCollection = activeDocument.pageCollection, //--now needed to put page models on notes, shapes -- should break that into ids ...
	            activeDocumentTextModel = activeDocument.getDocumentTextModel(), // getOriginalWordModelById -- maybe want to pass in to see dependencies
	            activeDocumentDerivedWordModels = activeDocumentTextModel.getDerivedWordModels();
	
	        searches.forEach( function( search ) {
	            this._buildResultsFromSearch( search, indexesCache, activeDocumentDerivedWordModels, pageCollection, currentPageNumber );
	        }, this );
	
	        //this.pageTree.getRoot().sortChildren(); // TEMP test ... this breaks more than helps
	
	
	    },
	
	
	    /* Now kind of like the same as search to being with -- now we only do one at a time .... */
	    addSearchesToResults: function( searches, frChannel ) {
	
	        this.buildResultsFromSearches( searches, frChannel );
	        this.updateTreeStateFromHits( frChannel.request('state').get('showResultsByPage') );
	
	    },
	
	    /* Central point to build from search */
	    _buildResultsFromSearch: function( search, indexesCache, activeDocumentDerivedWordModels, pageCollection, currentPageNumber ) {
	
	        /**
	         * Get the index to search -- for now assuming one search type with consecutive words -- may later need factory depending on search type
	         * Alt here for clarity would first be getting all the indexes for each search term and not building on the fly.
	         * -- but prob not great no that we can add searches to existing results
	         */
	
	        var index = this._getIndexForSearch( search, indexesCache, activeDocumentDerivedWordModels );
	
	        /**
	         * Now 'search' index for hits.
	         * Each one could be like a doc if using a search library.
	         * TODO: diff fn -- create hits from found words ... I think this get broken up!
	         */
	
	        var indexHitModels = index.getIndexHits( search.get('sanitizedSearchTerm') );
	
	        /* Add to appropriate models */
	        this._addHitsFromFoundIndexHits( search, indexHitModels, activeDocumentDerivedWordModels, pageCollection, currentPageNumber );
	
	    },
	
	
	    _getIndexForSearch: function( search, stateIndexesCache, activeDocumentDerivedWordModels  ) {
	
	        var index = null,
	            searchTerm = search.get('sanitizedSearchTerm'), // TODO: fn -- get text to search on model: must already validated
	            nSearchTerms = searchTerm.split(' ').length; // Note: this is already validated
	
	        if ( stateIndexesCache[nSearchTerms] ) {
	
	            index = stateIndexesCache[nSearchTerms];
	
	        } else {
	
	            /* Depending on the searchType, may want different Searcher -- and later way to process it */
	            index = new TextSearcher({
	                searchOptions: search.get('searchOptions'),
	                nSearchTerms: nSearchTerms,
	                wordModels: activeDocumentDerivedWordModels
	            });
	
	            stateIndexesCache[nSearchTerms] = index;
	        }
	
	        return index;
	
	    },
	
	
	    /**
	     * Now central entry point for adding object to appropriate data structures.
	     */
	    _addHitsFromFoundIndexHits: function( search, indexHitModels, activeDocumentDerivedWordModels, pageCollection, currentPageNumber ) {
	
	
	        indexHitModels.forEach( function( indexHitModel ) {
	
	            // console.log( JSON.stringify( _.result( PageResult.prototype, 'defaults' ) ) ); // SOMEHOW THIS WAS GETTING CHANGED!
	            /* First create a pageID x word models array of the results from which to create the hits collection -- words must be on the same page. */
	            var pageIdByWordsArray = indexHitModel.getWordsByPage( activeDocumentDerivedWordModels );
	
	            /**
	             * Now loop through the hits words models (separated by pages) to create the hit models
	             * Hits must all be on the same page ( even for derived/dashed words that could cross pages )
	             */
	
	            _.each( pageIdByWordsArray , function(pgWords) {
	
	                var firstWord = pgWords[0],
	                    pageNumber = firstWord.get('pageNumber'),
	                    pageId = firstWord.get('pageId'),
	                    page = pageCollection.findWhere({pageId: pageId});   // Will need the corresponding page model
	
	
	                var topDownResult = this.getTopDownResults().getResultByPageAndSearchId( pageId, search.cid ),
	                    pageNote = null;
	
	
	                if ( topDownResult ) {
	
	                    pageNote = topDownResult.getNote();
	
	                } else
	                {
	                    pageNote = FindAndRedactNoteModelConverter.getResultPageNoteModel( search.get('noteModel'), page, search.cid );
	                    topDownResult = this.getTopDownResults().addNewResult( pageId, search.cid, pageNote, search );
	                }
	
	
	                var pgNoteId = pageNote.cid,
	                    hitId = this.hits.length; // ( TODO: now in order of how added, could create a unique id ) -- search, pageNoteId, hit number of it ) -- BUT MAYBE WE WANT THAT DIFFERENT IF COMBO HITS LATER ON ...
	
	                /**
	                 * Hits needs a separate shape from the parent ...
	                 * this is a model it needs a new cid -- it can't be the shape if we pass it to another collection
	                 * issue is to put in a different collection we need a different model for each
	                 * try this to stop bleeding with fucking bbone ids
	                 * !Now only one shape, could be composed of multiple words -- a hit can only have one shape!
	                 */
	                var shape = FindAndRedactNoteModelConverter.cloneShapeModel( pageNote, pageNote.shape, page );
	
	                var hit = new Hit({
	
	                    id: hitId, // TODO: with adding, i think we use the key
	
	                    //key: 'S' + currentSearchKey + '_' + // an identifier
	
	                    pageNumber: pageNumber,
	                    pageId: pageId,
	                    searchModelId: search.cid, // could use another link pageResults[pageId].getSearchResult( currentSearchKey ).
	                    search: search,
	                    pageNoteId: pgNoteId,
	
	                    words: pgWords,  // derived (not multi-page) or from the original page-level ( if multi-page)
	                    shape: shape
	
	                });
	
	
	                hit.setPreviewTextTemplateContext( activeDocumentDerivedWordModels );
	
	                var derivedPts = hit.getDerivedShapeCoordinates();
	
	
	                /**
	                 * Note: currently no link back to the word models the represent --
	                 * with pgWordModels being either derived or original ( if multi-page) -- there's currently no
	                 * data structure with identifiers for them ( either in the derived or original word arrays ).
	                 * And now with the squashed shapes -- 1 per hit -- there's currently no need.
	                 * Maybe if want to get the area of the hit ???
	                 * Maybe need a third array ( which the text previews could piggy back on) -- of the these models ...
	                 * Could be easier to not squash the shapes and each would 1:1 model ... this is probably the answer
	                 * ! Actually -- can just derive from the hit's words for time being; they are lumped anyway !
	                 */
	
	                shape.set({
	                    uid: pgNoteId + '_' + hitId, // pageNoteId will keep between searches -- will be same format -- used for re-selection on re-render; don't use id
	                    hitId: hitId,
	                    points: derivedPts, // what drives the render from model
	                    originalPointsInTenthsMM: derivedPts // store to reset
	                });
	
	
	                this.hits.add( hit );
	
	                topDownResult.addHit( hit );
	
	                this.pageTree.addHitFromSearch( hit, pageNote, currentPageNumber );
	
	                this.searchTree.addHitFromSearch( hit, pageNote, currentPageNumber );
	
	            }, this );
	
	
	        }, this);
	
	
	
	
	    },
	
	
	    removeSearch: function( search ) {
	
	        // Remove any hit models from the collection -- it's mututable
	        var hitsOfSearch = this.hits.filter( function(m) {
	            return m.get('search').cid === search.cid;
	        });
	
	        this.hits.remove( hitsOfSearch ); // Need to make null or destroy?
	
	        this.getTopDownResults().removeAllResultsOfSearch( search.cid );
	
	        this.pageTree.removeSearch( search.cid );
	        this.searchTree.removeSearch( search.cid );
	
	    },
	
	    getPageTree: function() {
	        return this.pageTree;
	    },
	
	    getSearchTree: function() {
	        return this.searchTree;
	
	    },
	
	    getTopDownResults: function() {
	        return this.topDownResults;
	    },
	
	    getSearchModels: function() {
	
	        return this.getTopDownResults().getUniqueSearches();
	    },
	
	
	    getHits: function() {
	        return this.hits;
	    },
	
	    hasResults: function() {
	        return this.hits && this.hits.length > 0;
	
	    },
	
	    getHitById: function( hitId ) {
	
	        return this.getHits().get( hitId );
	    },
	
	    getNumberOfHits: function() {
	        return this.hits.length;
	    },
	
	    // TODO: data model could change here ...
	    getAllShapesPerPage: function( pageId ) {
	
	        return this.hits.getAllShapesPerPage( pageId );
	
	    },
	
	    getAppliedHits: function() {
	        return this.hits.getAppliedHits();
	    },
	
	    /**
	     * This goes top down.
	     * Would traverse by the node, but this goes by hits.
	     */
	    updateTreeStateFromHits: function( isPageHierarchy ) {
	
	        var tree = isPageHierarchy ? this.getPageTree() : this.getSearchTree();
	        tree.updateStateFromHits();
	
	    },
	
	    _clearResults: function() {
	
	        /* Hits */
	        this.hits.erase(); // deleting the notes models ... cleaning up references -- maybe remove the listeners
	
	        this.topDownResults.clear();
	
	        // Hierarchies --> trying just setting all to null: I don't believe need to destroy in case have listeners on them or anything I just set to null?
	        // with live adding, not setting to null
	        this.pageTree.reset();
	        this.searchTree.reset();
	
	    },
	
	    hasHitsFromFloatingRedactionNotesOnPage: function( pageId ) {
	
	        return this.getTopDownResults().pageHasResultsFromFloatingRedactions( pageId );
	
	    },
	
	    /**
	     * Get an array of pageNotes to save from those that have hits,
	     * also creating the note.shapes array (that we are to save) in the process,
	     * derived from the shapes of the hits to apply.
	     */
	    getNotesToSaveFromAppliedHits: function() {
	
	        var notes = [];
	
	        this.getTopDownResults().getResults().forEach( function( tdr ) {
	
	            var appliedHits = tdr.getAppliedHits();
	
	            if ( appliedHits.length > 0 ) {
	
	                var note = tdr.getNote();
	
	                // Currently the hit only has one shape ( for find and redact )
	                // Create a shapes array from the hits (an array of shape models to save with the note)
	                note.shapes = appliedHits.map( function(h) {
	                    return h.get('shape');
	                });
	
	
	                notes.push( note );
	            }
	
	        });
	
	        return notes;
	
	    },
	
	
	    destroy: function() {
	
	        this._clearResults();
	
	    }
	
	
	});
	
	
	
	
	
	
	
	module.exports = SearchResults;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var Util = __webpack_require__(48),
	    SearchIndexModel = __webpack_require__(659);
	
	
	/**
	 * Now this is really tailored to the default searcher , may need more fine grained control
	 * Maybe it's actually an index wrapper?
	 * Before big changes, wait for feedback on how we want to search.
	 * -- REALLY INDEX CREATOR -- CALL AS SUCH ---  ?
	 *
	 */
	
	var TextSearcher = function( options ) {
	
	    this.searchOptions = options.searchOptions;
	    this.nSearchTerms = options.nSearchTerms;
	    this.wordModels = options.wordModels; // word models to search to create the index
	
	    this.index = this.createIndex(); // what you get when you do the search -- for now contains literals
	
	    return this;
	
	};
	
	
	// Create the index -- maybe be different for different options ... at least somewhat breaking up now ...
	// For efficiency, something like binary search? http://www.position-absolute.com/articles/optimizing-a-search-functionality-with-large-javascript-arrays/
	// Return array of 'index objects' - that contains the text to search; when returned,
	// will then be used to create the hits collection
	
	TextSearcher.prototype.createIndex = function() {
	
	    var nSearchTerms = this.nSearchTerms,
	        allWordModelsInDocument = this.wordModels,
	        nAllWordModelsInDocument = allWordModelsInDocument.length,
	        ignoreCertainCharacters = this.searchOptions.get('ignoreCertainCharacters'),
	        ignoreCharactersRegExp = this.searchOptions.getCharactersToIgnoreReg();
	
	    // Wanted: arrays of word models who text (split with ' ') match the regex:
	    // The # should be the same as the number of words ( now 'derived words' -- which includes dashes )
	    // Maybe use library on the index if get more complicated requirements
	
	    var index = [];
	
	    for ( var wordIndex = 0; wordIndex < nAllWordModelsInDocument; wordIndex++ ) {
	
	        // ( if slice's end is > greater than array length; it uses array length )
	        var aAdjacentWordModels = allWordModelsInDocument.slice( wordIndex, wordIndex + nSearchTerms );
	        var adjacentWordText = '';
	
	        for (var m = 0; m < aAdjacentWordModels.length; m++ ) {
	
	            adjacentWordText += aAdjacentWordModels[m].get('wd');
	
	            // Note: we are no longer including spaces -- they aren't necessary
	            /*
	            if ( m < nWordModels -1 ) {
	                adjacentWordText += ' '; // we assume a space in between; perhaps we look as logic for dashed
	            }
	            */
	        }
	
	        /**
	         * Need to sanitize the the text to search for it ignore characters, in additional to sanitizing the search term.
	         * Replacing on the way in seems performant.
	         * The alternative 'non-elegant regexp' to look for term and exclude characters is more complex.
	         * Side effect: if searching for these characters, hits will not be returned ( perhaps a fix is a different phase and
	         * involving more search options ).
	         */
	        var wordTextToSearch = !ignoreCertainCharacters
	            ? adjacentWordText
	            : adjacentWordText.replace( ignoreCharactersRegExp, '' );
	
	        index.push( new SearchIndexModel({
	            words: aAdjacentWordModels,
	            text: adjacentWordText, // keep in case?
	            textToSearch: wordTextToSearch,
	            numberWords: nSearchTerms
	        }) );
	
	    }
	
	
	
	    return index;
	
	};
	
	
	/**
	 *  This is basically the search
	 *  The searchTerm is currently intertwined in creation of the index.
	 *  Now filtering characters on the way (above): alternative would be something like
	 *  var filter = '[.\-]*'; // testing ...
	 *  (  https://stackoverflow.com/questions/55907086/regex-for-ignoring-special-characters-in-substring-search _
	 *  Could put a fn on search options.
	 *  Note: textToSearch now already has 'ignore characters' removed
	*/
	TextSearcher.prototype.getIndexHits = function( textToSearch ) {
	
	    var userTextToSearch = textToSearch;
	
	    // Get rid of spaces; ( need reg exp to replace all ) -- could use \s but thats all white space
	    userTextToSearch = userTextToSearch.replace(/ /g, '');
	
	    var regexModifier = 'g'; // may want whole words in a different iteration, options
	
	    if ( this.searchOptions.get('ignoreCase') ) {
	        regexModifier += 'i';
	    }
	
	    /* Since using the RegExp constructor with a string literal, we need to RegExp escape it. */
	    var searchRegEx = new RegExp( Util.escapeRegExp( userTextToSearch ) , regexModifier );
	
	    // Search Index W/The RegEx -- if perf an issue could apply could do the test in the initial loop
	    // Consider index model a 'document' if move to 3rd party search library
	    var indexHits = this.index.filter( function( indexModel ) {
	        return searchRegEx.test( indexModel.textToSearch );
	    });
	
	
	    return indexHits;
	
	};
	
	
	
	
	module.exports = TextSearcher;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * The individual model that makes up the Indexes to search.
	 * Was just using object literals but creating this for clarity.
	 */
	
	
	var SearchIndexModel = function( attrs, activeDocumentTextModel ) {
	
	    this.text = attrs.text;
	    this.textToSearch = attrs.textToSearch;
	    this.words = attrs.words; // adjacent word models that we use to search
	    this.numberWords = attrs.numberWords;
	
	};
	
	
	_.extend( SearchIndexModel.prototype, {
	
	    /**
	    * PageId x WordModels array from which to create the hits collection from the word model -- which must be at the page level.
	    * ( with derived words, these may span pages ).
	    * If span's pages, put the original words ( not the derived ones ) -- which which no were mainly used for the search.
	    * **Will only be called for hits -- it's called for all of them **
	    */
	
	    getWordsByPage: function( activeDocumentDerivedWordModels ) {
	
	        var pageIdByWordsArray = {};
	
	        this.words.forEach( function(word) {
	
	            if ( !word.get('isMultiPage') ) {
	
	                var wordPgId = word.get('pageId');
	
	                if ( !pageIdByWordsArray[wordPgId] ) {
	                    pageIdByWordsArray[wordPgId] = [word];
	                }  else {
	                    // ( these could be derived words on the same page )
	                    pageIdByWordsArray[wordPgId].push( word );
	                }
	
	            } else {
	
	                // 'Derived' words that can span > 1 page:
	                // Get the page id from the subwords ( note word.get('pageId') is an array but it doesn't say which words are where )
	
	                word.get('subWordReferences').forEach(function( subWordModelReference ) {
	
	                    // An alternative is storing clones of these models on the derivedWords array
	                    // another alternative is storing the pgIds of the words on the xref at the word level
	                    var subWordModel = activeDocumentDerivedWordModels.getOriginalWordModelById( subWordModelReference.originalId ),
	                        subWordPageId = subWordModel.get('pageId');
	
	                    // Now adding the 'original sub word models' -- can use page_level_key to identify either of them -- true???
	                    // Need to use the sub-words so the hits are not mixed
	                    if ( !pageIdByWordsArray[subWordPageId] ) {
	                        pageIdByWordsArray[subWordPageId] = [subWordModel];
	                    }  else {
	                        // ( these could be derived words on the same page )
	                        pageIdByWordsArray[subWordPageId].push( subWordModel );
	                    }
	
	                });
	
	            }
	
	        });
	
	        return pageIdByWordsArray;
	
	
	    }
	});
	
	
	
	module.exports = SearchIndexModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(661),
	    ShapeUtils = __webpack_require__(197);
	
	
	var NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW = 5; // word is doing 6
	
	
	module.exports = Node.extend({
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( {}, base, {
	
	            nodeType: 'HIT',
	
	            id: null, // s/b unique id of the hit -- 'S_' + search searchModelId + _ + pageNoteId + _ need the number of the hit for that; now just an index
	
	            search: null, // started storing a reference now ....
	            searchModelId: null,
	            words: [], // the word models -- now always one but leave array for later -- there could be > 1 per hit
	
	            // populate from the word model -- actually this could but multi if they span ??? -- how would you handle?
	            pageNumber: null,
	            pageId: null,
	            words: [],
	            /* ---- 'ui/' -----*/
	
	            pageNoteId: null,  // currently a link back to the parent note ... these should always be cid since they aren't saved
	            shape: null, // only one per hit!
	
	            // TODO: with only one shape may want to listen/put on the shape
	            isMouseOverCanvasShape: false, // true if mouse is over any of the shapes of the hit on the canvas; triggers event to highlight hitView
	
	            textPreviewTemplateContext: null // No need to derive each time in the view
	        });
	
	    },
	
	
	    // TODO: move out of model logic but get going ... have a central hit toggled when this is then called at the end ...
	    // Could cause memory leak
	    // Hit to shape
	    // Also could do more top down
	    initialize: function() {
	
	        this.listenTo( this, 'change:isApplied', this.toggleAppliedEventCallback );
	
	    },
	
	    // may not longer need since the hits can have only one shape
	    toggleAppliedEventCallback: function() {
	
	        var shape = this.get('shape');
	
	        // Still necessary?
	        if (!shape)
	            return;
	
	        var isApplied = this.get('isApplied');
	
	        shape.uiModel.set( 'isHitApplied', isApplied );
	
	    },
	
	    /**
	     * Return the coordinates of all the words to use for the shape.
	     * Note: now in 1/10 mm
	     */
	    getDerivedShapeCoordinates: function() {
	
	        var allWordPts = _.reduce( this.get('words'), function( memo, word ) {
	            return memo.concat( word.get('boxFDDZoneUnitsDerived').getBoxCoordinates() );
	        }, [] );
	
	        // Utilize getPtsInRectOrder fn to get the size of a rect that would cover the whole thing
	        return ShapeUtils.getPtsInRectOrder( allWordPts );
	
	    },
	
	    setIsMouseOverRowView: function( isOver ) {
	        this.get('shape').uiModel.set('isMouseOverFindAndRedactHitView', isOver );
	    },
	
	    /**
	     * Note not printing white space but utilizing css pseudo after ' ' --
	     * helps not to have an underline on spaces, just the words.
	     * ( Though then can't search in browser for spaces -- so may want to change ).
	     * We could revisit in an attempt to make more performant / want more control.
	     * Note in the future may be dependant on search type ... (this assumes words are next to each other )
	     * Always print derived words -- expect when they span pages -- only stick to the one page ( shape can't go across) -- if
	     * a derived word spans pages, we need to go back to the originals.
	     * Perhaps could make better using logic with lines ( and derived lines );
	     */
	    setPreviewTextTemplateContext: function( documentDerivedWordModels ) {
	
	        // HitWords are derived unless the were split on different page -- in which case broken into their original wds that compose them
	        var hitWords = this.get('words'),
	            hitPageId = this.get('pageId');
	
	        // In the words to print -- remove any that are 'subwords' and not on the same page, with the parent derived models
	        // ( with which they were originally replaced ).
	        // So we are only printing from the derived array
	        // Appears to work but then we show text than span onto the other page --
	        // Normalize so working with the derived words array ( so all are derived )
	        var derivedWordModelsOfHit = [],
	            originalMultiPageSubWords = {}; // would have to be of this page id -- id X word
	
	        hitWords.forEach( function(word) {
	
	            var derivedParentId = word.get('derivedParentId');
	
	            if ( derivedParentId ) {
	
	                // could also put isParentBrokenByPage on the word model instead of getting here to make more efficient
	                var derivedParentWord = _.find( documentDerivedWordModels, function(m) {
	                    return m.get('id') === derivedParentId;
	                });
	
	                if ( derivedParentWord.get('isMultiPage') ) {
	
	                    derivedWordModelsOfHit.push( derivedParentWord );
	                    originalMultiPageSubWords[word.get('id')] = word; // store for later for replacing in text to print
	
	                } else {
	
	                    derivedWordModelsOfHit.push( word );
	                }
	
	            } else {
	
	                derivedWordModelsOfHit.push( word );
	            }
	
	        });
	
	
	        var firstWordId = derivedWordModelsOfHit[0].id;
	        var lastWordId = derivedWordModelsOfHit[derivedWordModelsOfHit.length -1].id;
	
	        // Currently these should be next to each other ( the only search type we have )
	        // ( Assumes they are in order )
	        // Could make a fn on the derivedWordModels obj
	        var wdsToInclude =
	            documentDerivedWordModels.slice(
	                Math.max( firstWordId - NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW, 0), // don't let it be negative
	                lastWordId + NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW + 1
	            );
	
	        // Purge anything not on the page of the hit ( prob not most efficient )
	        // They are broken up so it's weird having text on one page from another ... (you'll see in next hit)
	        var pageFilteredWdsToInclude = [];
	
	        wdsToInclude.forEach( function( word ) {
	
	            if ( !word.get('isMultiPage') && word.get('pageId') === hitPageId ) {
	                pageFilteredWdsToInclude.push( word );
	
	            } else {
	
	                _.each( word.get('subWordReferences'), function( subwordReference ) {
	                    // Only push the ones already on the page --
	                    // avoids having to pull back in the original models array ...
	                    if ( originalMultiPageSubWords[subwordReference.originalId] ) {
	                        pageFilteredWdsToInclude.push(  originalMultiPageSubWords[subwordReference.originalId] );
	                    }
	
	                });
	            }
	
	        });
	
	
	        // --- Creation of the template context ...
	        var wordsToPrint = pageFilteredWdsToInclude.map( function(m) {
	            return {
	                word: m.get('wd')
	            };
	        });
	
	        // Combo / Squash all of the hit words into one to print as a 'link'
	        // -- maybe better way to do to also keep the word ids associated, but now not needed
	        // With this we lose the association
	        // ( Add spaces here -- they must be from the search )
	        // Use hit words(!) -- not the derived ... so it can be original or derived
	        var squashHitWord = {
	            isHit: true,
	            word: _.reduce( hitWords, function( squashedWordText, wordToPrint, i ) {
	                return squashedWordText + wordToPrint.get('wd') + ( i < hitWords.length - 1 ? ' ' : '' );
	            }, '')
	        };
	
	        // replace the squashed hit word text at the index of the original
	        // ( non derived words -- since they were replaced in the prior the filter )
	        wordsToPrint.splice(
	            pageFilteredWdsToInclude.indexOf( hitWords[0] ), // use original hit words in case any were 'replaced'
	            hitWords.length,
	            squashHitWord
	        );
	
	
	        this.set( 'textPreviewTemplateContext', {
	            words: wordsToPrint  // or just words to print
	        } );
	
	
	    },
	
	
	    destroy: function() {
	
	        this.stopListening();
	
	        Node.prototype.destroy.apply( this, arguments );
	
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(662);
	
	
	module.exports = Node.extend({
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( base, {
	
	            isApplied: false,
	            isCollapsed: false,
	            isMouseOver: false,
	            nodeType: '' // 'PAGE', 'SEARCH', 'HIT' -- could set for root
	
	        });
	
	    },
	
	    resetState: function() {
	
	        this.set({
	            isApplied: false,
	            isCollapsed: false,
	            isMouseOver: false
	        }, { silent: true} );
	
	    },
	
	    isPageNode: function() {
	        return this.get('nodeType') === 'PAGE';
	    },
	
	    isSearchNode: function() {
	        return this.get('nodeType') === 'SEARCH';
	    },
	
	    isHitNode: function() {
	        return this.get('nodeType') === 'HIT';
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58);
	
	
	/* Really a 'key' tree and here is implementation specific -- I can't find a good library --
	    and now using backbone models, TODO: stop THIS */
	
	module.exports = Backbone.Model.extend({
	
	  defaults: function() {
	
	      return {
	
	          rowLevel: null, // TODO: set the row level on add from the parent ...
	          isRoot: false,
	
	          parent: null, // try a ref to the parent ...
	          parentId: null,
	          parentIdAttribute: '',
	
	          children: {} // could be an array ? -- maybe we always make an array instead ?
	
	      };
	
	
	    },
	
	    isRoot: function() {
	        return this.get('isRoot');
	    },
	
	    walkDown: function( cb ) {
	
	        cb( this );
	
	        _.each(  this.getChildren(), function(c) {
	
	           c.walkDown( cb.bind(c) );
	
	        }, this );
	
	    },
	
	    /** -- for FR tree, not using since can hits can have 2 parents */
	    walkUp: function( cb ) {
	
	        cb( this );
	
	        if ( this.isRoot() ) {
	            return;
	        }
	
	        var parent = this.getParent();
	        parent.walkUp( cb.bind(parent) );
	
	    },
	
	    /* predicate fn argument is the node */
	    filter: function( predicate ) {
	
	        var nodes = [];
	
	        this.walkDown( function(node) {
	
	            if ( predicate(node) ) {
	                nodes.push(node);
	            }
	
	        });
	
	        return nodes;
	
	    },
	
	
	    removeAllChildren: function() {
	        this.destroy();
	    },
	
	    getLowestLevelChildren: function( ) {
	
	        var nodes = [];
	
	        this.walkDown( function(node) {
	
	            if ( !node.hasChildren() ) {
	                nodes.push( node );
	            }
	
	        });
	
	        return nodes;
	
	    },
	
	
	    getChildren: function() {
	        return this.get('children');
	    },
	
	
	    getChild: function( childId ) {
	        return this.getChildren()[childId];
	    },
	
	    hasChild: function( childId ) {
	        return this.get('children')[childId];
	    },
	
	    hasChildren: function() {
	        return Object.keys( this.getChildren() ).length > 0;
	
	    },
	
	    getFirstChild: function() {
	
	        var children = this.getChildren();
	        return children[ Object.keys(children )[0] ];
	
	    },
	
	    hasMultipleChildren: function() {
	        return Object.keys( this.getChildren() ).length > 1;
	    },
	
	    addChild: function( childId, child ) {
	        this.get('children')[childId] = child;
	        return child;
	    },
	
	    /**
	     *  oh fuck backbone ... can i just break the link? -- what out for listeners however -- would feel more confident with id's
	     *  need to break the reference first?
	     *  I think just removing the link will break the reference and allow for garbage collection
	     * TODO: any cleanup -- I'm just breaking the link from the caller ... ?
	     */
	    removeChild: function( childId ) {
	
	        return delete this.getChild(childId);
	
	    },
	
	
	    getParent: function() {
	        return this.get('parent');
	    },
	
	    parentHasMultipleChildren: function() {
	        return this.parent.hasMultipleChildren();
	    },
	
	    /* Experiemntal -- and not very generic *-- not using /
	    sortChildren: function() {
	
	        var sortedChildren = _.sortBy(  this.getChildren(), c => c.get('pageNumber') );
	
	        this.removeAllChildren();
	
	        this.set( 'children', sortedChildren );
	
	
	    },
	
	
	
	    /**
	     * TODO: don't make it a BB model anymore
	     * Now just break the references to children
	     */
	    destroy: function() {
	
	        /*
	
	        I don't think this necessary -- just break the link to the children
	        this.walkDown( function(node) {
	
	            node.stopListening();
	            node.off();
	
	            var children = node.getChildren();
	
	            for ( var s in children ) {
	
	                children[s].destroy();
	                delete children[s]; // mostly just breaking the ref
	            }
	
	
	
	        });
	
	        */
	
	        var children = this.getChildren();
	        for ( var s in children ) {
	            delete children[s];
	        }
	
	
	    }
	
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    Hit = __webpack_require__(660);
	
	// Want Collection?  may be easier having JSON object of id x hit
	// Here, the id is the hit id of the model ( really in order of appearance )
	
	module.exports = Backbone.Collection.extend({
	
	    model: Hit,
	
	    getResultsForPage: function( pageNumber ) {
	
	        return this.where({ pageNumber: pageNumber });
	
	    },
	
	    // Note: pageId must be integers
	    getResultsForPageId: function( pageId ) {
	
	        return this.filter( function(hit) {
	            return hit.get('pageId') === pageId;
	        });
	
	    },
	
	    getAllShapesPerPage: function ( pageId ) {
	
	        var hitsOfPage = this.where({
	            pageId: pageId
	        });
	
	        return hitsOfPage.map( function(hit) {
	           return hit.get('shape');
	        });
	
	    },
	
	    getAppliedHits: function() {
	
	       return this.filter( function(hit) {
	          return hit.get('isApplied');
	       });
	
	    },
	
	    getByPageAndSearch: function( pageId, searchId ) {
	
	        return this.filter( function(h) {
	            return h.get('searchModelId') === searchId && h.get('pageId') == pageId;
	        });
	    },
	
	    getHitsForSearch: function( searchId ) {
	
	        return this.filter( function(h) {
	            return h.get('searchModelId' ) === searchId;
	        });
	
	    }
	
	
	});

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    TopDownResult = __webpack_require__(665);
	
	
	
	/**
	 * Could have an OBJ with map of pg_id, search_id, but just doing an array -- or even BB Collection ( actually a good use case for that )
	 * Wrapping and not sub-classing the Array -- this is not possible in ES5 -- Array's are 'exotic' objects ....
	 */
	
	var TopDownResults = function() {
	
	    this.results = [];
	
	};
	
	
	
	_.extend( TopDownResults.prototype, {
	
	    getResults: function() {
	        return this.results;
	    },
	
	    getResultByPageAndSearchId: function( pageId, searchId ) {
	
	        return _.find( this.getResults(), function(r) {
	            return r.searchId === searchId && r.pageId === pageId;
	        });
	
	    },
	
	    hasResult: function( pageId, searchId ) {
	
	        return this.getResultByPageAndSearchId( pageId, searchId ) !== undefined;
	
	    },
	
	    addNewResult: function( pageId, searchId, pageNote, search ) {
	
	        var result = new TopDownResult( pageId, searchId, pageNote, search );
	        this.results.push( result );
	
	        return result;
	
	    },
	
	
	    getUniqueSearchIds: function() {
	
	        return _.uniq( this.results.map( function( r) {
	            return r.searchId;
	        }));
	
	    },
	
	    getUniqueSearches: function() {
	
	        var searchIdBySearchMap = {};
	
	        this.results.forEach( function( r ) {
	
	            var search = r.getSearch();
	            searchIdBySearchMap[search.cid] = search; // TODO: use function to return identifier throughout app as it may chance
	
	        });
	
	        return Object.values( searchIdBySearchMap );
	
	    },
	
	    /* Note: currently mutatable method -- go backwards to keep index as it's re-indexed by splice in the loop */
	    removeAllResultsOfSearch: function( searchId ) {
	
	        var results = this.results;
	        for ( var i= results.length -1 ; i > -1; i-- ) {
	            if ( results[i].searchId === searchId ) {
	                this.results.splice( i, 1 );
	            }
	        }
	
	    },
	
	    getResultsOfPage: function( pageId ) {
	
	        return this.getResults().filter( function(r) {
	            return r.getPageId() === pageId;
	        });
	
	    },
	
	    /* Could argue to use the hierarchy but not that is primarily for the UI */
	    pageHasResultsFromFloatingRedactions: function( pageId ) {
	
	        return this.getResults().filter( function(r) {
	            return r.getPageId() === pageId && r.getNote().isFloatingRedaction();
	        });
	
	
	    },
	
	    getFloatingReasonCodesNotesOfPage: function( pageId ) {
	
	        return this.getResults().reduce( function( prev, current ) {
	
	            if ( current.getPageId() !== pageId )
	                return prev;
	
	            var note = current.getNote();
	
	            if ( note.isFloatingRedaction() && prev.map( function(p) { return p.cid; }).indexOf( note.cid ) < 0 )  {
	                return prev.concat(note);
	            } else {
	                return prev;
	            }
	
	        } , [] );
	
	    },
	
	
	
	    clear: function() {
	        while ( this.results.length > 0) {
	            this.results.pop();
	        }
	    }
	
	
	});
	
	
	
	module.exports = TopDownResults;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49);
	
	/* Hate saying this but a BB collection created with a 'compound key' is prob easier here */
	/* may want to keep sorted by page id x search for saving ? */
	
	var TopDownResult = function( pageId, searchId, note, search ) {
	
	    this.note = note;
	    this.searchId = searchId;
	    this.pageId = pageId;
	    this.search = search; // ( for reference )
	    this.hits = [];
	
	    return this;
	
	};
	
	
	_.extend( TopDownResult.prototype, {
	
	    getNote: function() {
	        return this.note;
	    },
	    addHit: function( hit ) {
	        this.hits.push( hit );
	    },
	
	    getPageId: function( ) {
	        return this.pageId;
	    },
	
	    getHits: function() {
	        return this.hits;
	    },
	
	    getSearch: function() {
	        return this.search;
	    },
	
	    getSearchId: function() {
	        return this.searchId;
	    },
	
	    getAppliedHits: function() {
	
	        return this.getHits().filter( function( h ) {
	            return h.get('isApplied');
	        });
	
	    }
	
	});
	
	
	
	module.exports = TopDownResult;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Tree = __webpack_require__(667),
	    PageResult = __webpack_require__(669),
	    PageSearchResult = __webpack_require__(670);
	
	
	
	var PageTree = function( root ) {
	
	    Tree.apply( this, arguments );
	
	};
	
	
	PageTree.prototype = Object.create( Tree.prototype );
	PageTree.prototype.constructor = PageTree;
	
	
	_.extend( PageTree.prototype, {
	
	    PAGE_NODE_LEVEL: 1,
	
	    /* B/C hits don't have parents ( they would have 2 ) */
	    /* I guess could tell from the view */
	    getParentOfHitModel: function( hit ) {
	
	        return this.getRoot()
	            .getChild( hit.get('pageId') )
	            .getChild( hit.get('searchModelId') );
	
	    },
	
	    addHitFromSearch: function( hit, parentNoteOfHit, currentPageNumber ) {
	
	        var root = this.getRoot();
	        var pgId = hit.get('pageId');
	
	        if ( !root.getChild( pgId ) ) {
	
	            /**
	             * some really odd Backbone shit going on here, when create a new one, it gets the attributes of the previous
	             *  _.result(this, 'defaults') --> this.defaults has that of the other and is called in the contructor
	             */
	            root.addChild( pgId, new PageResult({
	                pageId: pgId,
	                pageNumber: hit.get('pageNumber'),
	                isCurrentPage: currentPageNumber === hit.get('pageNumber'),
	                parent: root
	            }) );
	
	        }
	
	        var pageSearchResult = root.getChild( pgId );
	
	        var searchId = hit.get('search').cid;
	
	        // TODO: instead of cid create a key for the search from title and order
	        // JUST USE CID .. would want searchTerm + searchIndex or search index ... but we don't need to care about
	        if ( !pageSearchResult.hasChild( searchId ) ) {
	
	            pageSearchResult.addChild( searchId , new PageSearchResult({
	                pageId: pgId,
	                note: parentNoteOfHit,
	                search: hit.get('search'),
	                parent: pageSearchResult
	            }));
	
	        }
	
	        pageSearchResult.getChild( searchId ).addChild( hit.id, hit );
	
	
	
	    },
	
	    /* just break the link -- child currently in bbone models, ugh ... */
	    removeSearch: function( searchId ) {
	
	        _.each( this.getRoot().getChildren(), function(pageNode) {
	
	            delete pageNode.getChildren()[searchId];
	
	            if ( !pageNode.hasChildren() ) {
	
	                delete pageNode.getParent().getChildren()[pageNode.get('pageId')]; // Could have a remove page fn which then goes down recursively for the children
	            }
	
	
	        });
	
	
	    },
	
	    // TODO: imple maybe depending on validation on search
	    getRowModelOfPageNote: function( pageNoteId ) {
	
	        debugger;
	
	    }
	
	});
	
	
	module.exports = PageTree;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Tree = __webpack_require__(668),
	    FRResultNode = __webpack_require__(661);
	
	
	
	
	var FRSearchTree = function( root ) {
	
	    this.root = root || new FRResultNode({
	        isRoot: true,
	        rowLevel: 0
	    });
	
	};
	
	
	FRSearchTree.prototype = Object.create( Tree.prototype );
	FRSearchTree.prototype.constructor = FRSearchTree;
	
	
	
	_.extend( FRSearchTree.prototype, {
	
	
	    updateHierarchyPostModelAttributeToggle: function( rowModel, modelAttribute ) {
	
	        var valueToSet = !rowModel.get( modelAttribute );
	
	        /* Go Down -- Toggle All Children */
	        rowModel.walkDown( function( node ) {
	            node.set( modelAttribute, valueToSet );
	        } );
	
	        /* Go back up */
	
	        /* Walk up from the parent -- here avoids issue that hits don't have a parent -- we don't perform anything on this node anyway */
	        /* Except for the root! */
	
	        var parent;
	
	        if ( rowModel.isRoot() ) {
	
	            parent = rowModel;
	
	        } else {
	
	            parent = !rowModel.getParent() ? this.getParentOfHitModel(rowModel) : rowModel.getParent();
	        }
	
	
	        parent.walkUp( function( node ) {
	
	            var allChildrenAreApplied = _.map( node.getChildren(), function(c) {
	                return c.get( modelAttribute );
	            } ).every( function(c) {
	                return c === true; }
	            );
	
	            node.set( modelAttribute, allChildrenAreApplied );
	
	        });
	
	    },
	
	    updateHierarchyIncludes: function( rowModel ) {
	
	        this.updateHierarchyPostModelAttributeToggle( rowModel, 'isApplied' );
	
	    },
	
	    updateHierarchyCollapsed: function( rowModel ) {
	
	        this.updateHierarchyPostModelAttributeToggle( rowModel, 'isCollapsed' );
	
	    },
	
	    getNodesOfLevel: function( level ) {
	
	        var nodes = [];
	
	
	        this.walkDown( function(node) {
	
	            if ( node.get('rowLevel') === level ) {
	                nodes.push( node );
	            }
	
	        });
	
	        return nodes;
	
	
	    },
	
	
	    updateStateFromHits: function() {
	
	        /* First clear all non hit values */
	        /* Stop at the leaf -- could have fn for that in lib ? ... */
	        /* Alt could destroy and create from hits, as in above... */
	        this.walkDown( function( node ) {
	
	            if ( node.hasChildren() ) {
	                node.resetState();
	            }
	
	        });
	
	        // could be combined with tree creation but need to set the 'state' from the hits of the 'rows'
	        // This is not the most efficient ... ( has overlap, 'parents set multiple times' ) -- really want a 'level' walkup when all are done ...
	        var levelTwoNodes = this.getNodesOfLevel( 2 );
	
	        levelTwoNodes.forEach( function(n) {
	
	            n.walkUp( function( node ) {
	
	                var allApplied = _.every( node.getChildren(), function(h) {
	                    return h.get('isApplied');
	                });
	
	                var allCollapsed = _.every( node.getChildren(), function(h) {
	                    return h.get('isCollapsed');
	                });
	
	                node.set({
	                    isApplied: allApplied,
	                    isCollapsed: allCollapsed
	                }, { silent: true} );
	
	
	            });
	
	        });
	
	
	    },
	
	
	
	    reset: function() {
	
	        var root = this.getRoot();
	
	        /* I think could also just set root to null ? */
	        root.resetState();
	
	        root.removeAllChildren();
	
	        return this;
	
	
	    },
	
	    addHitFromSearch: function() {},
	
	
	    updateCurrentPageNumber: function( currentPageNumber ) {
	
	        this.getNodesOfLevel( this.PAGE_NODE_LEVEL ).forEach( function( pageNode ) {
	            pageNode.updateIsCurrentPage( currentPageNumber );
	        });
	
	    },
	
	
	    collapseAllButSearch: function( search ) {
	
	        this.walkDown( function( node ) {
	            node.set('isCollapsed', true );
	        });
	
	        var nodesOfSearch = this.getRoot().filter( function(node) {
	            return node.isSearchNode() && node.get('search') && node.get('search').cid === search.cid;
	        });
	
	        if ( nodesOfSearch.length > 0) {
	
	            nodesOfSearch.forEach( function(node) {
	
	                node.walkDown( function(node) {
	                    node.set('isCollapsed', false);
	                });
	
	            }, this);
	
	        }
	
	        // Walk up -- quick sorta copy paste from reset from hits  ... not most efficient -- 2 for pages .. need 2 or 1?
	
	        this.getNodesOfLevel( 2 ).forEach( function(n) {
	
	            n.walkUp( function( node ) {
	
	                var allCollapsed = _.every( node.getChildren(), function(h) {
	                    return h.get('isCollapsed');
	                });
	
	                node.set({ isCollapsed: allCollapsed } );
	
	            });
	
	        });
	
	    },
	
	    unCollapseAll: function() {
	
	        this.walkDown( function(node) {
	            node.set({ isCollapsed: false } );
	        });
	
	    }
	
	
	});
	
	
	
	module.exports = FRSearchTree;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(662);
	
	/* Now just crude implementation -- could just have nodes ... ? */
	
	function Tree( root ) {
	
	    this.root = root || new Node({
	        isRoot: true,
	        rowLevel: 0
	    });
	
	}
	
	
	_.extend( Tree.prototype, {
	
	    getRoot: function() {
	        return this.root;
	    },
	
	    walkDown: function( callback ) {
	
	        this.getRoot().walkDown( callback );
	
	    }
	
	});
	
	module.exports = Tree;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(661);
	
	/* Make a models we can just add any attributes that we are listening to for a change on it */
	module.exports = Node.extend({
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( base, {
	
	            nodeType: 'PAGE',
	
	            rowLevel: 1,
	            parentIdAttribute: 'pageId',
	
	            pageNumber: 0,
	            isCurrentPage: false
	
	        });
	
	    },
	
	    updateIsCurrentPage: function( pageNumber ) {
	
	        this.set( 'isCurrentPage', pageNumber === this.get('pageNumber') );
	
	    }
	
	
	});
	
	
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(661);
	
	
	
	module.exports = Node.extend({
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( {}, base, {
	
	            nodeType: 'SEARCH',
	            rowLevel: 2,
	            pageId: 0, // ( parent )
	
	            search: null,
	            note: null
	        });
	
	    },
	
	
	    getNote: function() {
	        return this.get('note');
	    }
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Tree = __webpack_require__(667),
	    SearchResult = __webpack_require__(672),
	    SearchPageResult = __webpack_require__(673);
	
	
	var SearchTree = function( root ) {
	
	    Tree.apply( this, arguments );
	
	};
	
	
	SearchTree.prototype = Object.create( Tree.prototype );
	SearchTree.prototype.constructor = SearchTree;
	
	
	
	_.extend( SearchTree.prototype, {
	
	    PAGE_NODE_LEVEL: 2,
	
	    getParentOfHitModel: function( hit ) {
	
	        return this.getRoot()
	            .getChild( hit.get('searchModelId') )
	            .getChild( hit.get('pageId') );
	
	    },
	
	
	    /* just break the link -- child currently in bbone models, ugh ... just break the link */
	    removeSearch: function( searchId ) {
	
	      // this.getRoot().removeChild( searchId ); -- doesn't work
	
	        delete this.getRoot().getChildren()[searchId];
	
	    },
	
	    addHitFromSearch: function( hit, parentNoteOfHit, currentPageNumber ) {
	
	        var root = this.getRoot();
	
	        var search = hit.get('search'),
	            searchId = search.cid;
	
	        if ( !root.getChild(searchId) ) {
	
	            root.addChild( searchId, new SearchResult({
	                search: search,
	                note: parentNoteOfHit,
	                parent: root
	            }));
	
	        }
	
	        var searchPageResult = root.getChild( searchId ),
	            pageId = hit.get('pageId');
	
	        if ( !searchPageResult.hasChild( pageId ) ) {
	
	            searchPageResult.addChild( pageId, new SearchPageResult({
	                pageId: pageId,
	                pageNumber: hit.get('pageNumber'),
	                parentId: searchId,
	                parent: searchPageResult,
	                isCurrentPage: currentPageNumber === hit.get('pageNumber')
	            }));
	
	        }
	
	        searchPageResult.getChild( pageId ).addChild( hit.id, hit );
	
	    }
	
	
	});
	
	
	module.exports = SearchTree;
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(661);
	
	
	module.exports = Node.extend({
	
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( {}, base, {
	
	            nodeType: 'SEARCH',
	            rowLevel: 1,
	
	            parentIdAttribute: 'searchId', // cid ..
	            search: null,
	            note: null
	
	        });
	
	    },
	
	
	    getNote: function() {
	        return this.get('note');
	    },
	
	    getSearch: function() {
	        return this.get('search');
	    }
	
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Node = __webpack_require__(661);
	
	
	module.exports = Node.extend({
	
	
	    defaults: function() {
	
	        var base = _.result( Node.prototype,  'defaults' );
	
	        return _.extend( {}, base, {
	
	            nodeType: 'PAGE',
	
	            rowLevel: 2,
	            pageId: null,
	            pageNumber: null, // want to print in the grid
	            isCurrentPage: false
	
	        });
	
	    },
	
	    // TODO: share with PageTree -- Page Result
	    updateIsCurrentPage: function( pageNumber ) {
	
	        this.set( 'isCurrentPage', pageNumber === this.get('pageNumber') );
	
	    }
	
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(49),
	    FR_ApiModel = __webpack_require__(675);
	
	
	/**
	 * Wrapper around frApiModel -- used to break down into searches with and without permission.
	 * For now we are leaving permission logic out of the apiModel.
	 */
	
	
	var PredefinedSearchesWrapper = function() {
	
	    this.frApiModel = null;
	    this.aValidSearchesWithPermission = [];
	    this.aValidSearchesWithoutPermission = [];
	
	};
	
	
	
	_.extend( PredefinedSearchesWrapper.prototype, {
	
	    /**
	     * userProvidedSearches: those provided to the module.
	     * aDisallowedFindAndRedactNoteTypes: those from the creatableNoteTypesHelper.
	     * fnGetNewModel: fn passed from the module channel -- hack
	     */
	    initialize: function( userProvidedSearches, aDisallowedFindAndRedactNoteTypes, fnGetNewModel ) {
	
	        this.frApiModel = new FR_ApiModel( userProvidedSearches );
	
	        if ( this.frApiModel.hasValidSearches() ) {
	
	            var validPredefinedSearches =
	                this.frApiModel.getSearchesModelsFromApiModels( fnGetNewModel );
	
	            validPredefinedSearches.forEach( function( search ) {
	
	                if ( aDisallowedFindAndRedactNoteTypes.indexOf( search.getNoteModel().getNoteTypeGroup() ) > -1 ) {
	
	                    this.aValidSearchesWithoutPermission.push( search );
	
	                } else  {
	
	                    this.aValidSearchesWithPermission.push( search );
	                }
	
	            }, this);
	
	        }
	
	    },
	
	    getApiModel: function() {
	
	        return this.frApiModel;
	    },
	
	    getValidSearchesWithoutPermission: function() {
	
	        return this.aValidSearchesWithoutPermission;
	
	    },
	
	    getValidSearchesWithPermission: function() {
	
	        return this.aValidSearchesWithPermission;
	
	    }
	
	
	
	} );
	
	
	
	module.exports = PredefinedSearchesWrapper;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {var FrAPISearchModel = __webpack_require__(676),
	    FrAPIGlobalOptionsModel = __webpack_require__(681),
	    FindAndRedactSearchModel =  __webpack_require__(582);
	
	
	/**
	 * Can take either:
	 * - array of search models or single search model
	 * - optional options -- will set everything except for the 'term' in searches -- N/A if only one is provided
	 * eg:
	 *
	 * findAndRedact: {
	
	 	search: [{
	       	term: 'German',
	       	... any other SearchOptionsModel properties ( internally the class will be options )
	
	       }],
	       // Optional SearchOptionsModel
	       	options: {
	       	    noteType: 'redaction',
	            note: {},
	            zone: {},
	            search
	       	},
	
	
	 */
	
	
	/**
	 * Takes the raw input as defined in the API and creates using objects from it
	 * TODO: get out of Backbone methodology and construct the obj's outside the 'models', not within constructions, --
	 * this should be simple but is complex to understand.
	 *
	 */
	
	var FrApiModel = function( userInput ) {
	
	    this._originalInput = JSON.parse( JSON.stringify( userInput ) ); // store in case ( and clone in case )
	
	    this.validSearches = []; // FrApiSearches
	    this.invalidSearches = [];
	
	    this.globalOptions = null; // FrAPISearchModel -- but without the term
	
	    this.validationErrors = [];
	
	    this.init( userInput );
	
	    return this;
	
	
	};
	
	
	
	_.extend( FrApiModel.prototype, {
	
	
	    init: function( userInput ) {
	
	        /* First create and validate the global options if it exists */
	
	        if ( userInput.options ) {
	            /* Could validate though currently nothing to validate */
	            this.globalOptions = new FrAPIGlobalOptionsModel( userInput.options );
	
	        }
	
	        /* Now look at the searches */
	        if ( !userInput.search ) {
	            this.validationErrors.push( 'No Searches Provided ');
	            return;
	        }
	
	        var userSearches = userInput.search instanceof Array ? userInput.search : [userInput.search];
	
	        if ( userSearches.length < 1 ) {
	           this.validationErrors.push( 'No Searches Provided ');
	           return;
	        }
	
	        userSearches.forEach( function( search, i ) {
	
	            /* jQuery provides a deep extend unlike underscore -- for nested properties like zone.fill */
	            /* If we want to merge global reason codes into those of specific searches if those codes don't exist, look for other library/ code fn */
	            var searchAttrs = $.extend( true, {},
	                this._originalInput.options, // currently assumes valid ... ( nested parts can be overwritten )
	                search // takes precedence
	            );
	
	            var model = new FrAPISearchModel( searchAttrs );
	
	            if ( model.isValid() ) {
	
	                this.validSearches.push( model );
	            }
	            else
	            {
	                this.invalidSearches.push( model );
	                // for now not putting a # on the model -- maybe we store the message on the model too
	                this.validationErrors.push( 'Search ' + (i+1) + ': ' + model.validationError );
	            }
	
	        }, this);
	
	
	        //console.log( this );
	
	    },
	
	    getValidSearches: function() {
	        return this.validSearches;
	    },
	
	    getInvalidSearches: function() {
	        return this.invalidSearches;
	    },
	
	    getValidationErrors: function() {
	        return this.validationErrors;
	    },
	
	    hasValidSearches: function() {
	        return this.getValidSearches().length > 0;
	    },
	
	    hasInvalidSearches: function() {
	        return this.getInvalidSearches().length > 0;
	    },
	
	    /* Bridge from searchAPI models to searchModels */
	    getSearchesModelsFromApiModels: function( fnGetNewModel ) {
	
	        var frSearchModels = [];
	
	        this.getValidSearches().forEach( function( searchAPIModel ) {
	
	            /* For time being set the note models from the note type */
	
	            var noteType = searchAPIModel.get('noteType');
	
	            var zone = searchAPIModel.get('zone'); // TODO: redact note or has customizable props .. for now they'd just be ignored ...
	
	            /* Only override what would have been created in new note model if the attrs are specifically provided */
	            var shapeAttrs = zone ? zone.toJSON() : {}; // want these passed in like coming in from DB ..
	
	            // Always pass shape attributes at least as defined, this tell whether to use the last reason codes or not ...
	            var newNoteModel = fnGetNewModel( noteType, shapeAttrs );
	
	            var searchModel = new FindAndRedactSearchModel({
	                fromAPI: true, // flag to differentiate from those manually entered one at a time
	                searchOptions: searchAPIModel.get('search'),
	                noteModel: newNoteModel
	            });
	
	            searchModel.setSearchTerms( searchAPIModel.get('term') );
	
	            frSearchModels.push( searchModel );
	
	        });
	
	        return frSearchModels;
	
	    }
	
	
	
	});
	
	
	
	
	
	module.exports = FrApiModel;
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    FindAndRedactSearchOptions = __webpack_require__( 583),
	    ZoneFactory = __webpack_require__(677);
	
	
	/**
	 *
	 * userProvidedNoteTextXREF:
	 * - quick solution -- could also put a property on note model prototypes -- but this is pretty simple
	 * - user provided name to JAVA enum
	 */
	
	
	var userProvidedNoteTextXREF = {
	    redaction: 'REDACTION_NOTE',
	    highlight: 'HIGHLIGHT_NOTE'
	};
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	
	        term: '', /* Required */
	
	        /* Optional -- one object under frApiGlobal options */
	        noteType: userProvidedNoteTextXREF['redaction'], // converted on creation to the JAVA_ONE on load -- REDACTION_NOTE
	        zone: null, // frAPIZone ( depends on note type )
	        note: null, // not yet implemented
	        search: new FindAndRedactSearchOptions() // actually, when implemented this could be diff API model ... TODO: make null and then create from what is provided
	
	    },
	
	    constructor: function( attributes ) {
	
	        // Clone -- we have issues when comparing the global and merging -- since as of now the attributes can be changed -- we never want to be looked at model -- just what would be passed in raw
	        var attrs = attributes
	            ? JSON.parse( JSON.stringify(attributes)  )
	            : {};
	
	        //console.log( JSON.stringify(attrs) );
	
	        /* Note-type */
	
	        if ( !attrs.noteType || Object.keys( userProvidedNoteTextXREF ).indexOf( attrs.noteType.toLowerCase().trim() ) < 0 ) {
	            attrs.noteType = this.defaults.noteType;
	        }
	        else {
	            attrs.noteType = userProvidedNoteTextXREF[ attrs.noteType.toLowerCase().trim() ];
	        }
	
	        /* Zone */
	        if ( attrs.zone ) {
	            var ZoneApiModel = ZoneFactory( attrs.noteType );
	            attrs.zone = new ZoneApiModel( attrs.zone );
	
	        }
	
	        /* Search */
	        if ( attrs.search ) {
	            attrs.search = new FindAndRedactSearchOptions( attrs.search );
	        }
	
	        Backbone.Model.call( this, attrs );
	
	    },
	
	    /**
	     * Now only doing the term - it is required.
	     * All else currently fails silently -- warnings, errors are printed and displayed.
	     */
	    validate: function( attrs ) {
	
	        if ( !attrs ) {
	            return 'Search not provided';
	        }
	
	        if ( !attrs.term ) {
	            return 'No term provided';
	        }
	
	        // Could validate others and put that in fn .... now not necessary
	
	    }
	
	
	});
	
	


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var HighlightZone = __webpack_require__(678),
	    RedactionZone = __webpack_require__(680);
	
	
	
	module.exports = function( noteType ) {
	
	    if ( noteType === 'REDACTION_NOTE' ) {
	        return RedactionZone;
	    }
	
	    else if ( noteType === 'HIGHLIGHT_NOTE' ) {
	        return HighlightZone;
	    }
	
	
	
	};

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var BaseZone = __webpack_require__(679);
	
	
	module.exports = BaseZone.extend({
	
	
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	
	module.exports = Backbone.Model.extend({
	
	
	});

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var BaseZone = __webpack_require__(679),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	var FILL_XREF = {
	    white_black_border: 'WHITE_BLACK_BORDER',
	    black: 'BLACK',
	    white: 'WHITE'
	};
	
	
	module.exports = BaseZone.extend({
	
	    defaults: _.extend( {}, BaseZone.prototype.defaults, {
	
	        fill: null, // leave empty so new notes are created from history
	        reasonCodes: null // pass in as array but result will be attributes OF valid ones from the models
	
	    } ),
	
	    constructor: function( attributes ) {
	
	        var attrs = attributes || {};
	
	        /* Fill -- only set if provided and it is valid */
	        if ( attrs.fill && Object.keys( FILL_XREF ).indexOf( attrs.fill.toLowerCase().trim() ) > -1 ) {
	            attrs.fill = FILL_XREF[attrs.fill];
	        }
	
	        /* Reason Codes */
	
	        if ( attrs.reasonCodes && attrs.reasonCodes.length > 0 ) {
	
	            var validAndInvalidCodes = fvChannel.request('reasonCodes').getValidAndInvalidCodesFromUserInput( attrs.reasonCodes );
	
	            if ( validAndInvalidCodes.validCodes.length > 0 ) {
	
	                // We must pass the entire model attributes as the would be passed from the DB, to parse correctly in the shape model
	                attrs.reasonCodes = validAndInvalidCodes.validCodes.map( function( vc ) {
	                    return vc.toJSON();
	                });
	
	            } else {
	
	                attrs.reasonCodes = null; // ( set back to null ) .... if setting the attributes from here directly, can't leave an invalid one ...
	
	            }
	
	            if ( validAndInvalidCodes.invalidCodes.length > 0 ) {
	                // TODO: perhaps have a 'warnings' concept in addition to errors --- now just using console.warn
	                // -- MAYBE WE STORE FOR REFERENCE
	                console.warn( 'Reason codes [' + validAndInvalidCodes.invalidCodes.join(', ') + '] are not active codes in the system' );
	
	            }
	
	        }
	
	        BaseZone.call( this, attrs );
	
	    }
	
	
	});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * FrAPISearchModel except the term -- just the options.
	 * Deemed easier for user to provide options -- rather than build the other way via composition
	 * ( and have more nested objects
	 */
	
	
	var FrAPISearchModel = __webpack_require__(676);
	
	
	module.exports = FrAPISearchModel.extend( {
	
	    defaults: _.omit( FrAPISearchModel.prototype.defaults, 'term' ),
	
	    // Currently not checking anything, everything fails silently
	    validate: function( ) { }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Layout View for the Region
	 * TODO: should now make this a SubApp
	 */
	
	
	__webpack_require__(683);
	
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    Util = __webpack_require__(48),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49),
	    ResizeSensor = __webpack_require__(112);
	
	
	var LoginView = __webpack_require__(684),
	    ResetView = __webpack_require__(557),
	    AlertView = __webpack_require__(688),
	    DocNavView = __webpack_require__(691);
	
	__webpack_require__(706);
	
	/* copy anyway on build in case IE through loader */
	var Grab = __webpack_require__(707),
	    Grabbing = __webpack_require__(708),
	    CSS_NAMESPACE = 'FV';
	
	
	module.exports = Marionette.LayoutView.extend({
	    template: __webpack_require__(709),
	    initialize: function(options) {
	
	        var fvSettings = fvChannel.request('settings');
	
	        this.onClickCaptureHandler = null; // store a reference, needing for turning off the listener
	
	        this.resizeSensor = null;
	
	        if (options.el.tagName.toLowerCase() === 'body')
	            $('html, body').addClass(CSS_NAMESPACE + ' fullSize-noSpacing');
	
	        if (fvSettings.isIE) {
	            this.$el.addClass('IE');
	            this._applyGrabbyHandForIE();
	        }
	
	        this.$el.addClass(CSS_NAMESPACE);
	
	        if ( fvSettings.onClick )
	            this._setUpOnClickCaptureHandler( fvSettings.onClick, fvSettings.fromUrlInterface );
	
	
	        this.options.vChannel.comply(this.commands, this); //TODO: mixin for the pattern
	
	
	    },
	    ui: {
	        viewWrapper:    '.FV-view-wr'
	    },
	    regions: {
	        content:    '.FV-viewer-doc', /* main content here: others would be overlay -- eg auth/viewer instance layout view */
	        loading:    '.FV-viewer-loading',
	        docNav:     '.FV-docNav-region',
	        alert:      '.FV-alert-region'
	    },
	
	    // Note: the view this is called onRender the view should be in the DOM
	    onRender: function() {
	        this._createResizeSensor();
	    },
	
	    commands: {
	        showLogin: function( unauthorizedDataModel, loginError ) {
	
	            this.content.show( new LoginView(unauthorizedDataModel, loginError) );
	            this.docNav.reset();
	
	        },
	        showLoading: function() {
	            this.content.show( new ResetView() );
	        },
	        /**
	         * TODO:
	         * - now the layout view and this in there
	         * - pass these in
	         */
	        renderDocNav: function() {
	
	            var vCh = this.options.vChannel;
	            this.docNav.show(
	                new DocNavView({
	                    activeDoc: vCh.request('activeDocument'),
	                    docCollection: vCh.request('documents'),
	                    vChannel: vCh,
	                    vContainer: this.$el    //vCh.request('getWrapper') -- TODO: this is the layout
	                })
	            );
	
	        },
	        /**
	         * TODO:
	         * - can leave -- won't be option to reload unless implement -- would want new view then -- like login WR .. but this faster now
	         * - could do diff view here now ...
	         */
	        showLoadError: function(errMsg) {
	
	            this.$el.addClass('loginError');
	
	            this.content.show( new AlertView( _.extend({
	                    type: 'error',
	                    shortMessage: 'Unable to Load Viewer'
	                }, {
	                    detailedMsg: errMsg
	                })
	            ));
	
	        },
	        'mainView.toggleMultiDocInterfaces': function(show) { /* a fwd ... */
	            var v = this.docNav.currentView;
	            v.toggleDocNavInterfaces.apply(v, arguments);
	        },
	        'mainView.toggleFullScreen': function() {
	
	            this._detachResizeSensor();
	            this.$el.toggleFullScreen( CSS_NAMESPACE );
	            this._createResizeSensor();
	
	            setTimeout( _.bind( function() {
	                this.options.vChannel.command('updateAfterViewerResize');
	            }, this), 1 );
	
	        },
	        'mainView.showAlert': function(viewOptions) {
	            this.alert.show( new AlertView(viewOptions) );
	        },
	        'mainView.hideAlert': function() {
	            this.alert.empty();
	        }
	
	    },
	
	    //TODO: mixin for this pattern
	    resetWiring: function() {
	
	        var vCh = this.options.vChannel;
	            vCh.comply(this.commands, this);
	
	        vCh.reply(this.requests, this);
	
	    },
	    /*
	    * Note: jQuery doesn't support event capturing
	    * Need to capture!  so it's always caught -- all other events are bubbled and propagation could be stopped; these will always be captured first
	    * TODO: if have more events / hooks like these, centralize in FV and forward there ...
	    * */
	    _setUpOnClickCaptureHandler: function( eventNameOrCallbackFn, fromUrlInterface ) {
	
	        if (fromUrlInterface) {
	
	            // send a postMessage with the event name
	            this.onClickCaptureHandler = getDefaultUrlInterfaceClickHandler( eventNameOrCallbackFn );
	
	        } else {
	
	            if ( _.isFunction( eventNameOrCallbackFn ) ) {
	
	                var viewerInstance = this.options.vChannel.request('getViewer');
	
	                this.onClickCaptureHandler = function() {
	                    return eventNameOrCallbackFn.call( FV, viewerInstance );
	                };
	
	            }
	
	            // Could also trigger an event in this case; would be a non-breaking change in the API --
	            // really no need for now; could fire off FV or dispatch a CustomEvent (DOM) probably from this.el for the caller to decide how they want to handle
	        }
	
	        this.el.addEventListener( 'click', this.onClickCaptureHandler, true );
	
	        /*
	         * Perhaps want to debounce, but that would invoke a timer and user's can't click fast anyway.
	         * */
	        function getDefaultUrlInterfaceClickHandler(eventName) {
	
	            var DEFAULT_SESSION_RESET_EVENT_NAME = 'feithSessionReset';
	
	            var message = eventName
	                ? eventName
	                : DEFAULT_SESSION_RESET_EVENT_NAME;
	
	            return function() {
	
	                if( parent != null ){
	                    parent.postMessage( message ,"*" );
	                }
	
	                if( opener != null ){
	                    opener.postMessage( message, "*" );
	                }
	            };
	
	        }
	
	    },
	
	    /* create css for grab and grabbing glass used in IE; cursor urls for IE are relative the html page, not the linked css page -- why this here */
	    _applyGrabbyHandForIE: function() {
	        Util.createClass('.IE .grab', 'cursor: url(' + Grab + '), default');
	        Util.createClass('.IE .grabbing', 'cursor: url(' + Grabbing + '), default');
	    },
	
	    /**
	     * Override Backbone.View.remove to use jQuery's empty() instead of remove() on this.$el.
	     * ( Called from Marionette.ItemView.destroy, which calls this.remove() -- the base of Backbone.View's remove );
	     * DVBC-1550 -- this.el is that set from the user's configuration options.  We don't want to remove the
	     * element they placed the viewer inside, just empty it.
	     */
	    remove: function() {
	        this.emptyRemove();
	    },
	
	    // called from onRender and from refreshResizeSensor below
	    _createResizeSensor: function() {
	
	        var vChannel = this.options.vChannel; // can optimize ...
	
	        this.resizeSensor = new ResizeSensor( this.ui.viewWrapper.get(0),  _.debounce( function() {
	            vChannel.command('updateAfterViewerResize');
	        }, 20, true));
	
	    },
	    // Note: leaving here to show this could be desired, though now not called.
	    // Previously had been called from toggle full screen
	    _refreshResizeSensor: function() {
	
	        this._detachResizeSensor();
	        this._createResizeSensor();
	    },
	    // from destroy of this view
	    _detachResizeSensor: function() {
	        this.resizeSensor && this.resizeSensor.detach();
	    },
	
	    /**
	     * TODO: don't think mousetrap events are removed here (and maybe some more .. trying viewer.destroy)
	     * Should we now destroy resize sensor ... from destroy in viewer it's current'ly called
	     */
	    onBeforeDestroy: function() {
	
	        this.resizeSensor.detach();
	
	        if ( this.resizeSensor ) {
	            this._detachResizeSensor();
	            this.resizeSensor = null;
	        }
	
	        this.el.removeEventListener( 'click', this.onClickCaptureHandler, true );
	        this.options.vChannel.reset(); // HUH?
	
	
	    },
	
	    destroy: function() {
	        Marionette.LayoutView.prototype.destroy.apply( this, arguments );
	    }
	
	});

/***/ },
/* 683 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(685);
	
	var Marionette = __webpack_require__(61),
	    Spinner = __webpack_require__(159),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	__webpack_require__(686);
	
	/*
	 * unauthorizedDataModel: required -- model from FV.unauthorizedData
	 * loginError: null or logInErrorMessage on auth.state if one occurred
	 * */
	
	module.exports = Marionette.ItemView.extend({
	    template: __webpack_require__(687),
	
	    initialize: function( unauthorizedDataModel, loginError ) {
	
	        this.databases = unauthorizedDataModel.getDatabases();
	        this.signupUrl = unauthorizedDataModel.getSignupUrl();
	        this.forgotPasswordUrl = unauthorizedDataModel.getForgotPasswordUrl();
	
	        this.loginError = loginError;
	
	    },
	
	    serializeData: function() {
	
	        var databases = this.databases,
	            nDatabases = databases.length,
	            signupUrl = this.signupUrl,
	            forgotPasswordUrl = this.forgotPasswordUrl,
	            showSignupUrl = signupUrl && signupUrl.length > 0,
	            showForgotPasswordUrl =  forgotPasswordUrl && forgotPasswordUrl.length > 0,
	            loginErr = getErrorMessage.call(this);
	
	
	        return {
	            databases:  databases.sort(),
	            isErr: loginErr && loginErr.length > 0,
	            errMsg: loginErr,
	            hideDatabaseSelect: nDatabases < 2, // if 1, print but hide so it's value is submitted; if none, hide (and submit will be disabled)
	            disableSubmit: nDatabases < 1,
	            signupUrl: signupUrl,
	            forgotPasswordUrl: forgotPasswordUrl,
	            showSignupUrl: showSignupUrl,
	            showForgotPasswordUrl: showForgotPasswordUrl,
	            showSpacerBetweenSignupAndForgotPasswordLinks: showSignupUrl && showForgotPasswordUrl
	        };
	
	        /*
	        * First check if there are no databases,
	        * then check if there is an authentication error sent from the server.
	        * */
	        function getErrorMessage() {
	
	            if (nDatabases < 1)
	                return "Can't log in: no databases available";
	
	            var authErrorMsg = this.loginError;
	
	            if (authErrorMsg && authErrorMsg.length > 0)
	                return authErrorMsg;
	
	            return null;
	        }
	
	    },
	    /* Note: dbs must be set prior to render: fetch doesn't rely on auth */
	    onRender: function() {
	        this.unwrap();
	
	        var dbs = this.databases.sort(),
	            lastStoredDB = fvChannel.request('localStorage').getLastDb(),
	            lastDB =  lastStoredDB && _.contains(dbs, lastStoredDB) ? lastStoredDB : dbs[0];
	
	        this.ui.database.val(lastDB);
	        this.ui.loginBtn
	            .addClass('btn-focus-primary')
	            .loadingButton();
	
	    },
	    onShow: function() {
	        var userField = this.ui.username;
	        _.delay(function() {
	            userField.focus();
	        }, 200);
	    },
	    ui: {
	        username:           '#username',
	        passwd:             '#passwd',
	        database:           '#database',
	        loginBtn:           '#loginBtn',
	        spinHolder:         '.spinWrLogin',
	        form:               '#loginForm',
	        signUpLink:         '#signupLink',
	        forgotPasswordLink: '#forgotPasswordLink'
	    },
	    triggers: {
	        'submit @ui.form':              'submit'
	    },
	
	    //TODO: implement simple validation on client: eg only checking if either or / both empty
	    onSubmit: function() {
	
	        this.$('input').blur();
	        this.spinner = new Spinner();
	        this.ui.spinHolder.append( this.spinner.render().el );
	
	        fvChannel.command('userLoggedIn', { //note; the object was wrapped in array -- for NODE?
	             username: this.ui.username.val(),
	             password: this.ui.passwd.val(),
	             database: this.ui.database.val()
	        });
	
	    },
	    onBeforeDestroy: function() {
	        this.ui.loginBtn.destroy();
	        this.spinner && this.spinner.destroy();
	        this.$('*').remove(); //hacky attempt to fix mem leak -- something going on w/jq caching...
	    },
	    destroy: function() {
	        Marionette.ItemView.prototype.destroy.apply(this, arguments);
	        /* continuation of mem leak hack */
	        this.$el = null;
	        this.el = null;
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 685 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {(function($) {
	
	    $.fn.loadingButton = function(options) {
	
	        var settings = {
	                loadingText: 'loading...',
	                activeClass: 'loading'
	            },
	            isLoading = false,
	            $el = this,
	            txtFn = $el.is('input') ? 'val' : 'html',
	            origText = $el[txtFn]();
	
	        $.extend(settings, options);
	
	        $el.on('click reset load', function() {
	            setTimeout(toggle, 0); /* Defer to ensure form submit (click event) */
	        });
	
	        function toggle() {
	            isLoading = !isLoading;
	            if (isLoading) {
	                $el[txtFn](settings.loadingText).addClass(settings.activeClass).attr('disabled', 'disabled');
	            } else {
	                $el[txtFn](origText).removeClass(settings.activeClass).removeAttr('disabled');
	            }
	        }
	
	        this.destroy = function() {
	            $el.remove();
	        };
	
	        return this;
	    };
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "                            <option>"
	    + container.escapeExpression(container.lambda(depth0, depth0))
	    + "</option>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                    <div class=\"login-error\">\n                        "
	    + container.escapeExpression(((helper = (helper = helpers.errMsg || (depth0 != null ? depth0.errMsg : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"errMsg","hash":{},"data":data}) : helper)))
	    + "\n                    </div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"9":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                        <a id=\"signupLink\" href=\""
	    + container.escapeExpression(((helper = (helper = helpers.signupUrl || (depth0 != null ? depth0.signupUrl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"signupUrl","hash":{},"data":data}) : helper)))
	    + "\" target=\"_blank\" title=\"Sign Up\">Sign Up</a>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    return "                        <span id=\"login-spacer\"> | </span>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                        <a id=\"forgotPasswordLink\" href=\""
	    + container.escapeExpression(((helper = (helper = helpers.forgotPasswordUrl || (depth0 != null ? depth0.forgotPasswordUrl : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"forgotPasswordUrl","hash":{},"data":data}) : helper)))
	    + "\" target=\"_blank\" title=\"Forgot Password\">Forgot Password</a>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"FV-login-wr\">\n\n    <div class=\"FV-login well\">\n\n        <div class=\"login-wr-inner\">\n\n            <h2 class=\"signInHeader\">Log in</h2>\n\n            <form id=\"loginForm\">\n                <label>Username</label>\n                <input id=\"username\" type=\"text\" name=\"username\">\n                <label>Password</label>\n                <input id=\"passwd\" type=\"password\" name=\"passwd\">\n\n                <div class=\"db-row "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideDatabaseSelect : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n                    <label>Database</label>\n                    <select id=\"database\" class=\"\">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.databases : depth0),{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                    </select>\n                </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isErr : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                <div class=\"bottom\">\n                    <input id=\"loginBtn\" class=\"btn btn-primary signIn-btn pull-left\" type=\"submit\" value=\"Sign in\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableSubmit : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ">\n\n                    <div class=\"spinWrLogin pull-right\"></div>\n                </div>\n\n                <div id=\"login-links\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSignupUrl : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSpacerBetweenSignupAndForgotPasswordLinks : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showForgotPasswordUrl : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                </div>\n\n            </form>\n        </div>\n\n    </div>\n\n</div>\n\n\n";
	},"useData":true});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {__webpack_require__(689);
	
	var Backbone = __webpack_require__(58),
	    Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59);
	
	__webpack_require__(115);
	
	
	module.exports = Marionette.ItemView.extend({
	
	    className: 'FV-alert',
	    template: __webpack_require__(690),
	
	    typeShortXRef: {
	        error: { icon: 'icon-attention-circled' },
	        success: { icon: 'icon-ok-circled-1' },
	        info: { icon: '' }
	    },
	
	    // Explicitly define options with defaults for clarity.
	
	    initialize: function( options ) {
	
	        // Here are the default options to pass in
	        var settings = {
	            type: 'error',
	            shortMessage: 'Alert',
	            detailedMsg: '',
	            allowClose: true,
	            closeTimeout: null,
	            detailedMsgPreserveLineBreaks: false // ( if set to true you can break lines with '\n'
	        };
	
	        // Allow to close by default.
	        // If closeTimeout is provided, disallow allowClose, unless it is explicitly provided.
	
	        if (options) {
	
	            $.extend( settings, options );
	
	            if ( options.closeTimeout && !options.allowClose) {
	                settings.allowClose = false;
	            }
	
	        }
	
	        this.settings = settings;
	
	    },
	
	    /*
	    * Note: short message required.
	    * Detail, timeout is optional.
	    * */
	    serializeData: function() {
	
	        return {
	            hideCloseButton: !this.settings.allowClose,
	            shortMsg: this.settings.shortMessage,
	            longMessage: this.settings.detailedMsg,
	            typeClass: this.settings.type === 'info'
	                ? ''
	                : 'alert-' + this.settings.type,
	            iconClass: this.typeShortXRef[this.settings.type].icon,
	            detailedMsgPreserveLineBreaks: this.settings.detailedMsgPreserveLineBreaks
	        };
	
	    },
	    onShow: function() {
	
	        var actualWidth = this.$el.css({ width: 'auto' }).outerWidth(),
	            self = this,
	            closeTimeout = this.settings.closeTimeout;
	
	        this.$el.css({ 'margin-left': -1 * actualWidth / 2 }); // do now on region and make responsive ?
	        this.$el.iframeShim();
	       
	        if (closeTimeout)
	
	            setTimeout( function() {
	                self.destroy();
	                clearTimeout(closeTimeout);
	            }, closeTimeout) ;
	
	    },
	    ui: {
	        closeBtn: '.close'
	    },
	    events: {
	        'click @ui.closeBtn': function(e) {
	            e.stopPropagation();
	            this.destroy();
	        }
	    },
	    onRender: Backbone.View.prototype.unwrap,
	
	    /**
	     * Fade out the view and allow for destroy of shim -- need method, not onBefore for fadeout.
	     */
	    destroy: function() {
	
	        var $el = this.$el,
	            self = this,
	            args = _.toArray(arguments);
	
	        $el.fadeOut(200, function() {
	            $el.iframeShim('destroy');
	            Marionette.ItemView.prototype.destroy.apply(self, args);
	        });
	    }
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 689 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <button type=\"button\" class=\"close\">&times;</button>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "        <div class=\"detailed-err-msg "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.detailedMsgPreserveLineBreaks : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">"
	    + container.escapeExpression(((helper = (helper = helpers.longMessage || (depth0 != null ? depth0.longMessage : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"longMessage","hash":{},"data":data}) : helper)))
	    + "</div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "detailed-err-msg-preserve-line-breaks";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-alert alert "
	    + alias4(((helper = (helper = helpers.typeClass || (depth0 != null ? depth0.typeClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"typeClass","hash":{},"data":data}) : helper)))
	    + "\">\n    <i class=\"alert-icon "
	    + alias4(((helper = (helper = helpers.iconClass || (depth0 != null ? depth0.iconClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"iconClass","hash":{},"data":data}) : helper)))
	    + "\"></i>\n    <span class=\"alert-msg\">\n        "
	    + alias4(((helper = (helper = helpers.shortMsg || (depth0 != null ? depth0.shortMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"shortMsg","hash":{},"data":data}) : helper)))
	    + "\n    </span>\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideCloseButton : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.longMessage : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>";
	},"useData":true});

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(692);
	
	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58);
	
	var NavBar = __webpack_require__(693);
	
	module.exports = Marionette.LayoutView.extend({
	    template: __webpack_require__(705),
	    regions: {
	        navBar: '.FV-region-navBar'
	    },
	    serializeData: function () {
	        var vCh = this.options.vChannel,
	            nDocs = vCh.request('documents').length,
	            activeDocIndex = vCh.request('activeDocIndex');
	        return {
	            showDocNavigation: nDocs > 1,
	            showPrevDocBtn: activeDocIndex !== 0,
	            showNextDocBtn: activeDocIndex !== nDocs - 1
	        };
	    },
	    ui: {
	        docNavBtn: '.FV-docNavBtn'
	
	    },
	    events: {
	        'click @ui.docNavBtn': function (e) {
	            this.options.vChannel.command('changeActiveDoc', $(e.currentTarget).attr('title')); //todo: mediate...
	        }
	    },
	    onRender: function () {
	        // Backbone.View.prototype.unwrap.call(this); //todo: note: unwrap will break the already attached ui -- just leave
	        var vCh = this.options.vChannel;
	        this.navBar.show(
	            new NavBar({
	                activeDoc: vCh.request('activeDocument'),
	                docCollection: vCh.request('documents'),
	                vChannel: vCh,
	                vContainer: this.$el //must be in region / 'layout not yet shown'
	            })
	        );
	    },
	    onAttach: function () {
	        //do on attach for positioning sizing of dd
	        this.ui.docNavBtn.each(function () { //todo: make plugin support multi element ...
	            $(this).iframeShim();
	        });
	        /* must be in DOM to size */
	    },
	    toggleDocNavInterfaces: function (show) {
	        this.navBar.currentView.toggleNavigability(show);
	        this.ui.docNavBtn.toggleClass('hide', !show);
	    },
	    onBeforeDestroy: function () {
	        /*Note: on before destroy would only because after this from layout sub app destroy */
	        this.ui.docNavBtn.each(function () { //todo: make plugin support multi element ...
	            $(this).iframeShim('destroy');
	        });
	        /* must be in DOM to size */
	        this.ui.docNavBtn.remove();
	        /* quick fix for jq cache refs */
	        this.$('*').remove();
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 692 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {__webpack_require__(694);
	
	var BabySitterView = __webpack_require__(489),
	    DocSelectView = __webpack_require__(695),
	    ComboPDFDropDown = __webpack_require__(699);
	
	__webpack_require__(115);
	__webpack_require__(76); //(for unselectable)
	
	module.exports = BabySitterView.extend({
	    id: 'docNav',
	    template: __webpack_require__(704),
	    onRender: function() {
	        this.ui.docBtnWr.unselectable();
	    },
	    ui: {
	        docSelector:    '#docSelect',
	        docPrev:        '.docPrev',
	        docNext:        '.docNext',
	        docFirst:       '.docFirst',
	        docLast:        '.docLast',
	        docNavBtns:     '.docNavBtn',
	        docBtnWr:       '#docArrowNAV',
	        comboPdfBtn:    '#combo-pdf-doc-nav-btn'
	    },
	    events: {
	        'click @ui.docNavBtns'      : 'onClickDocNavBtn' //TODO: dom ref via jqCache -- b/c using multi
	    },
	    serializeData: function() {
	
	        var activeDoc = this.options.activeDoc,
	            docs = this.options.docCollection,
	            docIndex = docs.indexOf(activeDoc),
	            nDocs = docs.length;
	
	      return {
	          docSelectMarkup: DocSelectView.prototype.selectTemplate( activeDoc.documentName() ), //TODO: common code for dd select markup creation ...
	          comboPDFDropDownMarkup: ComboPDFDropDown.prototype.getDropdownButton(),
	          docXOfY: (docIndex + 1) + ' of ' + (nDocs),
	          isFirstDoc: docIndex === 0,
	          isLastDoc: docIndex === nDocs - 1,
	          showComboPdfDropdown: this.options.vChannel.request('allowPDFCombo')
	      };
	
	    },
	    onAttach: function() {
	
	        this.children.add( new DocSelectView(
	            _.extend(  _.pick(this.options, 'activeDoc', 'docCollection', 'vChannel'), {
	                el: this.ui.docSelector,
	                ddOptions: {
	                    isSelect: 1,
	                    container: this.options.vContainer,
	                    dropUp: 1,
	                    isSelectForceChangeOnClick: 1, //quick fix to force change if same doc provided more than once (no change ..)
	                    maxWidth: 250
	                }
	            })
	        ).render(), 'docSelect');
	
	        this.children.add( new ComboPDFDropDown({
	            el: this.ui.comboPdfBtn,
	            vChannel: this.options.vChannel,
	            ddOptions: {
	                container: this.options.vContainer
	            }
	        }).render(), 'comboPDF');
	
	        this.$el.iframeShim();
	    },
	    onClickDocNavBtn: function(e) {
	        e.stopPropagation();
	        var $trg = $(e.currentTarget),
	            dir = $trg.attr('title');
	        if ($trg.hasClass('disabled')) return false;
	        this.options.vChannel.command('changeActiveDoc', dir);
	    },
	    toggleNavigability: function(on) {
	        this.ui.docNavBtns.toggleClass('disabled', !on);
	        this.children.findByCustom('docSelect').dropdown.toggleClass('disabled', !on); //TODO: better enabledOption for the plugin but this will work, if has the class click will disable in the plugin
	    },
	    onBeforeDestroy: BabySitterView.prototype.onBeforeDestroy,
	    destroy: function() {
	        BabySitterView.prototype.destroy.apply(this, arguments);
	
	        this.$('*').remove(); //(a lot b/c 'multi-selector')
	        this.off();
	
	        this.$el.iframeShim('destroy');
	
	        //TODO: still leak from iframe shim
	        this.el = null; //still leak
	        this.$el = null;
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 694 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(696);
	
	var DropDown = __webpack_require__(432);
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(697),
	    defaultSelector: function() {
	        var o = this.options;
	        return '[data-doc="' + o.docCollection.indexOf(o.activeDoc) + '"]';
	    },
	    selectTemplate: function(initialValue) {
	        return __webpack_require__(698)({
	            initialValue: initialValue
	        });
	    },
	    templateOptions: function() {
	       return  {
	           documents: this.options.docCollection.map(function(d, i) {
	               return {
	                   val: i,
	                   name: d.documentName()
	               };
	           })
	       };
	    },
	    onChange: function(value, elData) {
	        this.options.vChannel.command('changeActiveDoc', elData.doc);
	    },
	    onBeforeDestroy: function() {
	        this.$('*').remove();
	        DropDown.prototype.onBeforeDestroy.apply(this, arguments);
	    },
	    destroy: function() {
	        DropDown.prototype.destroy.apply(this, arguments);
	        //todo: onChange still holds the reference in the closure of dd settings
	        this.el = null;
	        this.$el = null;
	    }
	});

/***/ },
/* 696 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"mi\" data-doc=\""
	    + alias2(alias1((depth0 != null ? depth0.val : depth0), depth0))
	    + "\" title=\""
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "\">"
	    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
	    + "</div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div id=\"dd-docSelector\" class=\"dropdown-menu\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.documents : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div id=\"docSelect\" class=\"dropdown\" title=\"Select Document\">\n    <span class=\"ddValue\">"
	    + container.escapeExpression(((helper = (helper = helpers.initialValue || (depth0 != null ? depth0.initialValue : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"initialValue","hash":{},"data":data}) : helper)))
	    + "</span>\n    <span class=\"select-icon icon-arrow-combo\"></span>\n</div>";
	},"useData":true});

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var DropDown = __webpack_require__(431);
	
	
	/**
	 * The template is very similar to that in the header overflow menu dropdown --
	 * should share code but for now this is simple so just go with it.
	 * The same is true for the UI hash and events
	 */
	
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(700),
	    ui: {
	        pdfComboNewWindow:  '#pdfComboLink-nav',
	        pdfComboDL:         '#pdfComboDL-nav'
	    },
	    ddOptions: {
	        dropUp: 1
	    },
	    events: function() {
	        var vCh = this.options.vChannel;
	        return {
	            'click @ui.pdfComboDL':         _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 0), /* put 0 in explicity, otherwise e is passed */
	            'click @ui.pdfComboNewWindow':  _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 1)
	        };
	    },
	    getDropdownButton: function() {
	        return __webpack_require__(701);
	    }
	
	    //destroy: small mem leak in sub-menu bars ...
	    // again, all this complicated by the other plugins and old arch involved --
	    // here looks like ref in the jq cache prev obj to 'sub-menu-items*/
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"dd-doc-nav-merge-pdf\" class=\"dropdown-menu\">\n    <div id=\"pdfComboDL-nav\" class=\"mi\" title=\"Download\">\n        <span class=\"dd-icon icon-download\"></span>\n        Download\n    </div>\n    <div id=\"pdfComboLink-nav\" class=\"mi\" title=\"Open in new window\">\n        <span class=\"dd-icon icon-link-ext\"></span>\n        New Window\n    </div>\n</div>\n";
	},"useData":true});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	//TODO: the icon is the same as the one for pdf mode -- alter it to make it more accessible
	__webpack_require__(702);
	module.exports = __webpack_require__(703);

/***/ },
/* 702 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<span id=\"combo-pdf-doc-nav-btn\" title=\"Combine pages of all renderable documents into single PDF\">\n    <i class=\"icm-file-pdf3\"></i>\n</span>";
	},"useData":true});

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper;
	
	  return "        <div id=\"doc-nav-non-nav-buttons\">\n            "
	    + ((stack1 = ((helper = (helper = helpers.comboPDFDropDownMarkup || (depth0 != null ? depth0.comboPDFDropDownMarkup : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"comboPDFDropDownMarkup","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n        </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<span style=\"display: inline-block;\">Document:</span>\n<span id=\"docNavLbl\" title=\"Document "
	    + alias4(((helper = (helper = helpers.docXOfY || (depth0 != null ? depth0.docXOfY : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docXOfY","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.docXOfY || (depth0 != null ? depth0.docXOfY : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docXOfY","hash":{},"data":data}) : helper)))
	    + "</span>\n\n<div id=\"docNavActions\">\n\n    "
	    + ((stack1 = ((helper = (helper = helpers.docSelectMarkup || (depth0 != null ? depth0.docSelectMarkup : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"docSelectMarkup","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n\n    <div id=\"docArrowNAV\">\n        <span class=\"docNavBtn "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isFirstDoc : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Previous\">\n            <i class=\"icon-left-circled\"></i>\n        </span>\n        <span class=\"docNavBtn "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isLastDoc : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Next\">\n            <i class=\"icon-right-circled\"></i>\n        </span>\n        <span class=\"docNavBtn "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isFirstDoc : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"First\">\n            <i class=\"icon-to-start\"></i>\n        </span>\n        <span class=\"docNavBtn "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isLastDoc : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Last\">\n            <i class=\"icon-to-end\"></i>\n        </span>\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showComboPdfDropdown : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>\n";
	},"useData":true});

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "        \n    <div class=\"FV-region-navBar\"></div>\n        \n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPrevDocBtn : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showNextDocBtn : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"FV-docNavBtn FV-docPrev\" title=\"Previous\">\n            <i class=\"icon-left-big\"></i>\n        </div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"FV-docNavBtn FV-docNext\" title=\"Next\">\n            <i class=\"icon-right-big\"></i>\n        </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showDocNavigation : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/**
	 * Append given el to fullscreen ('overlay') and place it back --
	 * easier than messing unknown 3rd party styling (or place it back)
	 */
	
	
	(function($) {
	
	    $.fn.toggleFullScreen = function( nameSpaceClass ) {
	
	        var $el = this;
	
	        var NO_OVERFLOW_CLASS = 'noOverflow',
	            FULL_SIZE_NO_SPACING_CLASS = 'fullSize-noSpacing';
	
	        if (!$el.data('isOpen')) {
	
	            $('html, body').addClass(
	                nameSpaceClass ? nameSpaceClass + ' ' + NO_OVERFLOW_CLASS : NO_OVERFLOW_CLASS
	            );
	
	            var $replaceDiv = $('<div id="fsReplaceDiv" style="display: none;"></div> ')
	                .insertAfter($el);
	
	            $el.data({
	                    origInlineStyle: $el.attr('style'),
	                    origClass: $el.attr('class'),
	                    isOpen: true,
	                    replaceDiv: $replaceDiv
	                })
	                .removeAttr('style')
	                .removeAttr('class')
	                .addClass( nameSpaceClass + ' ' + FULL_SIZE_NO_SPACING_CLASS )
	                .persistIframeChildrenOnMove()
	                .data('$fsWr',
	                    $('<div id="fs-wr" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 20000;"></div>')
	                        .append($el)
	                        .appendTo('body')  //fixed position rel to doc
	            );
	
	            //if el not static position & top, left, right, bottom > 0 -- this will be off -- make static
	            var origPos =  $el.css('position');
	            if (origPos !== 'static') {
	                $el.css('position', 'static');
	                $el.data('origCSSPosition', origPos); //(flag)
	            }
	
	
	        } else {
	
	            $('html, body').removeClass(
	                nameSpaceClass ? nameSpaceClass + ' ' + NO_OVERFLOW_CLASS : NO_OVERFLOW_CLASS
	            );
	
	            $el.persistIframeChildrenOnMove() //store prior to append
	                .data({ isOpen: false})
	                .attr('style', $el.data('origInlineStyle'))
	                .addClass($el.data('origClass'))
	                .removeClass( FULL_SIZE_NO_SPACING_CLASS )
	                .appendTo($el.data('replaceDiv'))
	                .unwrap()  //get's rid of the replacement div
	                .data('$fsWr')
	                .remove();
	            //remove after iframes appended to orig div
	
	            /* if original position wasn't static, restore it to the value derived from the class*/
	            $el.data('origCSSPosition') && $el.css('position', '');
	
	        }
	
	        return this;
	
	    };
	
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06c243f534d9c5461d16528156cd5a8.cur";

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a8c874b93b3d848f39a71260c57e3863.cur";

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"FV-view-wr\">\n	<div class=\"FV-viewer-doc\"></div>\n	<div class=\"FV-viewer-loading\"></div>\n    <!-- overlays viewer when logged in> -->\n	<div class=\"FV-docNav-region\"></div>\n    <div class=\"FV-alert-region\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, Backbone) {/*
	 * TODO -- really need to clean up this workflow with a model, especially the handling of side panes and widths.
	 * Note: notes panel (right) always created so for time being-put ajax-spinner & more menu in there
	 * */
	
	var $ = __webpack_require__(59),
	    SubApp = __webpack_require__(98),
	    LayoutView = __webpack_require__(711),
	    LeftSideModel = __webpack_require__(755),
	    RightSideModel =  __webpack_require__(757);
	
	__webpack_require__(465);
	
	var instVars = {
	    vChannel: null,
	    leftSideModel: null,
	    rightSideModel: null,
	    layoutView: null
	};
	
	
	module.exports = SubApp.extend({
	
		constructor: function(options, id) {
	        _.extend( this, instVars, options, {id: id} );
	        SubApp.prototype.constructor.apply(this, arguments);
	    },
	
	    initialize: function() {
	
	        var ch = this.channel,
	            rsm = this.rightSideModel = new RightSideModel([], {lChannel: ch}), // all objects could extend from SA interface
	            lsm = this.leftSideModel = new LeftSideModel(),
	            mEvents = this.sideModelEvents;
	           
	        this.layoutView = new LayoutView({ lChannel: ch });
	        this.bindEntityEvents(lsm, mEvents);
	        this.bindEntityEvents(rsm, mEvents);
	
	        /* key: link vChannel to this channel events -- TODO: in subapp ... prefix? */
	
	       Backbone.fwd.call(ch, this.vChannel);  //(apply use if more)
	
	    },
	    /* note: these are inner subscriptions (lChannel) -- (and outer forwarded to it */
	    subscriptions: {
	        'layout:sideHeaderTabClick':        'headerTabButtonClickCB', //(combo with change: currentSubPane of model?
	        'layout:openToSubPane':             'openToSubPane',
	        'layout:closeSidePanel':            'closePane',
	        'layout:toggleSidePanel':           'toggleSidePanel',
	        'layout:setPaneWidth':              'setPanelWidth', /* from drag end */
	        'vChannel:openToSubPane':           'openToSubPane', //if from other change (eg active note -->)
	        'vChannel:resizeSidesIfOverlap':    'resizeSidesIfOverlap', // TODO: fwd
	        'layout:repositionShapeDialog':     'repositionShapeDialog' // ( this one just a fwd )
	    },
	
	    /**
	     * Post change
	     * could forward (or store on model for clarity)
	     */
	    sideModelEvents: {
	        'change:isOpen':                    'paneToggledOpen',  //note: could put hook in here like old paneModel openOrPaneChangeCB
	        'change:currentSubPane':            'subPaneChange',
	        'change:width':                     'paneWidthChanged',
	        'change:isCovering':                'paneCoveringToggled',
	        'panel:postToggleSubPane':          'toggleSubPaneCB' //from within region
	    },
	    commands: {
	        changePage: function(opts) {
	
	            _.invoke( [this.request('navView'), this.request('centerHeaderView'),  this.request('overflowMenu') ], 'updatePostPageChange', opts);
	
	        },
	        toggleHeaderViewMode: function() {
	
	            var centerHeader =  this.request('centerHeaderView'),
	                overflowMenu = this.request('overflowMenu'),
	                leftHeaderView = this.layoutView.getRegion('leftHeader').currentView,
	                toggleFn = 'toggleHeaderViewModeState';
	
	            centerHeader[toggleFn].apply( centerHeader, arguments );
	            overflowMenu[toggleFn].apply( overflowMenu, arguments );
	            leftHeaderView[toggleFn].apply( leftHeaderView, arguments );
	
	        },
	        // Should pass this via channel rather than through direct reference
	        createNewNoteMenu: function() {
	            var rightHeader = this.layoutView.getRegion('rightHeader').currentView;
	            rightHeader.triggerMethod.apply(rightHeader, ['createNewNoteMenu'].concat( _.toArray(arguments) ));
	        },
	        updateFullTextNoteCountAndCaption: function() {
	            this.trigger.apply(this, ['updateFullTextSearchCount'].concat( _.toArray(arguments)) );
	        },
	        changeScale: function() {
	            var header = this.request('centerHeaderView');
	            header.updatePostScale.apply(header, arguments);
	        },
	
	        /*
	        * Open according to settings on viewer load.
	        * Really the state of the panels ...
	        * TODO:
	        * - incorp new api for doc level options ... those would supercede prDocLayout state
	        * - set options of what to open higher level
	        * - document actions
	        * */
	
	        setInitialLayout: function(options) {
	
	            var r = this.rightSideModel,
	                l = this.leftSideModel,
	                vChannel = this.vChannel,
	                prDocLayoutState = options.prDocLayoutState,
	                lastPane;
	
	            if ( options.fullTextQuickView ) { // use prior layout state here?
	
	                this._coverWithPane(r, 'fullText');
	
	            } else {
	
	                /* LEFT*/
	                if (!prDocLayoutState) {
	
	                    if ( vChannel.request('includeFindAndRedactModule') && vChannel.request('settings').findAndRedact() )
	                    {
	                        // Search is now performed on render: canvas shapes are drawn when ready from viewer.state
	                        this.openToSubPane( l, 'findAndRedact' );
	                    }
	                    else
	                    {
	                        ( vChannel.request('includeIndexesModule') && options.autoDisplayIndexes ) &&
	                            this.openToSubPane(l, 'default');
	                    }
	
	
	                } else {
	
	                    var leftPaneSt = prDocLayoutState.leftPane,
	                        lpWasOpen = leftPaneSt.isOpen;
	
	                    lastPane = leftPaneSt.currentSubPane;
	
	                    if (lpWasOpen) {
	
	                        /* --  Open to what it had previously -- if approp to current doc -- viewer would have SAME INSTANCE SETTINGS -- */
	                        if ( lastPane === 'indexInfo' && vChannel.request('includeIndexesModule') ) {
	
	                            this.openToSubPane(l, 'default'); //(indexes)
	
	                        } else if ( lastPane === 'thumbs' && vChannel.request('allowThumbnails') ) {
	
	                            this.openToSubPane(l, 'thumbs');
	
	                        } else if ( lastPane === 'findAndRedact' && vChannel.request('includeFindAndRedactModule') ) {
	
	                            /* -- There are things we could persist with the findAndRedact model, but not doing now -- */
	                            this.openToSubPane(l, 'findAndRedact');
	
	                        }
	
	                    }
	
	                }
	
	                /* RIGHT */
	                var docHasNotes = options.docHasNotes,
	                    docHasVisibleNotes = options.docHasVisibleNotes,
	                    forceOpenNotes = options.forceOpenToNotes;
	
	                /* forceOpenNotes: override others */
	                if (forceOpenNotes && docHasNotes) {
	                    this.openToSubPane(r, 'notes');
	                    return;
	                }
	
	
	                var fullTextQuery = options.fullTextQuery;
	
	                if (!prDocLayoutState) {
	
	                    typeof fullTextQuery === 'string' //(allow empty string search)
	                        ? this.openToSubPane(r, 'fullText') //this.openToSubPane(r, !forceOpenNotes ? 'fullText' : 'default') -- this now handled above
	                        : docHasVisibleNotes && this.openToSubPane(r, 'default');
	
	                } else {
	
	                    var rightPaneSt = prDocLayoutState.rightPane,
	                        rpWasOpen = rightPaneSt.isOpen;
	
	                    lastPane = rightPaneSt.currentSubPane;
	
	                    /* open to what it had previously -- if approp to current doc -- viewer would have SAME INSTANCE SETTINGS */
	                    if (rpWasOpen) {
	
	                        /*force open to notes handle above */
	                        if (lastPane === 'fullText' && fullTextQuery)
	                            this.openToSubPane(r, 'fullText');
	
	                        /* notes panel always printed, force handle above */
	                        if (lastPane === 'notes')
	                            this.openToSubPane(r, 'notes');
	
	                    }
	
	                }
	
	            }
	        },
	        renderZoomView: function(scaleModel) {
	            this.layoutView.getRegion('centerHeader').currentView.triggerMethod('renderZoomView', scaleModel);
	        },
	        showModal: function() {
	            var l = this.layoutView;
	            l.triggerMethod.apply(l, ['showModal'].concat(_.toArray(arguments)));
	        },
	        closeModal: function() {
	            this.layoutView.triggerMethod('closeModal');
	        },
	        toggleFullScreen: function(isFullScreen) {
	            var lsm = this.leftSideModel,
	                rsm = this.rightSideModel;
	            this.layoutView.triggerMethod('toggleFullScreen', isFullScreen);
	           // need to resize the cover (if it is covering -- could also reset ratios of the others .....
	            rsm.isCovering() && this._coverWithPane(rsm, rsm.get('currentSubPane'));
	            lsm.isCovering() && this._coverWithPane(lsm, lsm.get('currentSubPane'));
	        },
	        toggleRotateEnabled: function(disable) {
	            var centerHeader = this.request('centerHeaderView'),
	                overflowMenu = this.request('overflowMenu');
	            _.invoke([centerHeader, overflowMenu], 'toggleRotateEnabled', disable);
	        },
	        //todo: apply higher level, then trickle here
	        togglePaneCover: function(pane, isCovering) { //todo: have in reaction
	            this.vChannel.command('togglePaneIsCoveringLayout', isCovering);
	            this.command('toggleRotateEnabled', isCovering); //todo: best served with load images -- it goes with this, same for zoom
	            _.invoke([this.request('centerHeaderView'), this.request('overflowMenu')], 'toggleScaleEnabled', isCovering);
	        },
	        setPanelIsResizing: function(val) {
	            this.vChannel.command('setPanelIsResizing', val);
	        },
	        updateNoteCount: function(num) {
	            this.trigger('updateNoteCount', num);
	        },
	        /**
	         * Toggle Ability to Rotate If Page Has unknown Dims, Image Load Error.
	         * Old notes: for doc mode -- check if image failure -- not retried every time error like pg mode -- actually now should be?
	         * Note: also hidden via css if no renderable pages.
	         * //TODO: was in render also also -- put into template:
	         *      !vc.request('activeDocHasNoPages') && this.setDisableHandlers.call(this); ... need in headerHeader?
	         */
	        pageImgLoadError: function(page) {
	            this.request('centerHeaderView').toggleRotateEnabled( page.imgLoadFailed() ? 1 : 0 ); // need check -- see above ?
	            this.request('overflowMenu').toggleRotateEnabled(true);
	        },
	        stopLoadingIndicator: function() {
	            var rightHeader =  this.layoutView.getRegion('rightHeader').currentView;  
	            rightHeader && rightHeader.command('stopAjaxSpinner');
	        },
	        activeNoteChange: function(note, options) {
	            this._activeOrExpandedNoteChange.apply(this, arguments);
	        },
	        expandedNoteChange: function() {
	            this._activeOrExpandedNoteChange.apply(this, arguments);
	        }
	    },
	    requests: {
	        vChannel: function() {
	            return this.vChannel;
	        },
	        activeNote: function() {
	            return this.vChannel.request('activeNote');
	        },
			notesEl: function() {
				return this.layoutView.getRegion('rightContent').currentView.ui.notes;
			},
	        fullTextEl: function() {
	            return this.layoutView.getRegion('rightContent').currentView.ui.fullText;
	        },
	        indexesEl: function() {
	            return this.layoutView.getRegion('leftContent').currentView.ui.indexes;
	        },
	        thumbsEl: function() {
	            return this.layoutView.getRegion('leftContent').currentView.ui.thumbNails;
	        },
	        findAndRedactEl: function() {
	            return this.layoutView.getRegion('leftContent').currentView.ui.findAndRedact;
	        },
	        rightSideModel: function() {
	            return this.rightSideModel;
	        },
	        leftSideModel: function() {
	            return this.leftSideModel;
	        },
	        setScaleFn: function() {
	            return this.vChannel._commands.setScale.callback;
	
	        },
	        viewMode: function() {
	            return this.vChannel.request('viewMode');
	        },
	        wrapper: function() {
	            return this.layoutView.$el; //(the $el of the layout) -- todo: implement in places
	        },
	        layoutWidth: function(excludeDragger) { /* exclude dragger from the width calculation, otherwise won't be visible and user won't be able to close covered panel (margin-right of center) */
	            return this.layoutView.$el.width() - (excludeDragger ? 8 : 0); //
	        },
	        modalView: function() {
	            return this.layoutView.getRegion('modal').currentView;
	        },
	        viewerLoaded: function() {
	            return this.vChannel.request('viewerLoaded');
	        },
	        centerHeaderView: function() {
	            return this.layoutView.getRegion('centerHeader').currentView;
	        },
	        navView: function() {
	            return this.layoutView.getRegion('centerHeader').currentView.children.findByCustom('nav');
	        },
	        rotateView: function() {
	            return this.request('centerHeaderView').children.findByCustom('rotate');
	        },
	        overflowMenu: function() {
	            return this.layoutView.getRegion('rightHeader').currentView.request('overflowMenu');
	        },
	
	        /*
	         * Region is a marionette region to show the view inside of -- returns a $dfd.
	         * Do not return the $dfd within a closure!!! this will cause memory leak
	         */
	        renderLayout: function(region, options) {
	
	            var $dfd = $.Deferred(),
	                settings = _.extend(options, {
	                    leftModel: this.leftSideModel,
	                    rightModel: this.rightSideModel,
	                    lChannel: this.channel
	                }),
	                lv = this.layoutView;
	
	            lv.onShow = function(view) {
	                $dfd.resolve(view.centerContent);
	            };
	
	            region.show(lv, settings);
	
	            return $dfd.done(function(centerRegion) {
	                return centerRegion;
	            }).promise();
	
	        },
	        pdfWrapper: function() {
	            return this.vChannel.request('pdfWrapper');
	        },
	        /* note: no state model, so derive from the side models -- currently used to set initial layout on doc reset prior to destroy */
	        state: function() {
	            return {
	                leftPane: this.leftSideModel.toJSON(),
	                rightPane:  this.rightSideModel.toJSON()
	            };
	        }
		},
	
	    // perhaps a pre? where it could exit -- see right
	    toggleSubPaneCB: function( pane ) {
	        pane.get('side') === 'left' &&
	            this.vChannel.command( 'postToggleLeftSubPanel', pane ); //(for the thumbnails
	    },
	
	    //TODO -- put in another ...
	    fullTextPaneWidthChange: function() {
	        this.vChannel.trigger('vChannel:fullTextPaneWidthChange');
	    },
	    resizeSidesIfOverlap: function() {
	        this.layoutView.onResizeSidesIfOverlap(this.leftSideModel, this.rightSideModel); //direct for perf (no triggerMethod)
	    },
	
	    // TODO: pass all open to subpane through here ... is it ?
	    // ...could make much clearer but working
	    // rid direct fn calls and forward through one entry point
	    openToSubPane: function(pane, subPane, options) {
	
	        !options && (options = {});
	
	        (typeof pane === 'string') &&
	            (pane = this[pane + 'SideModel']);
	
	        var lastOpenPane = pane.get('lastOpenSubPane'),
	            oppPane = this._getOppositePane(pane);
	
	        subPane = !subPane && lastOpenPane
	            ? lastOpenPane //closing
	            : subPane; //open to the subPane (can be via entry or hover) -- ... if want default for hover use 'default'
	
	        pane.isCovering() && _.extend(options, { //if the pane is already covering -- example: full screen toggle -- need to include the dragger with for it to show
	            containerWidth: this.request('layoutWidth', true)
	        });
	
	        /* If opposing pane is covering, close it before opening this one */
	        if ( oppPane.isCovering() ) {
	            oppPane.close();
	            oppPane.openToSubPane( oppPane.get('lastOpenSubPane'), options );
	        }
	
	        pane.openToSubPane(subPane, options);
	
	    },
	
	    headerTabButtonClickCB: function(pane, clickedSubPanel) {
	
	        if (pane.get('isOpen')) {
	
	            pane.get('currentSubPane') === clickedSubPanel
	                ? this.closePane(pane)
	                : this.openToSubPane.apply(this, arguments);
	
	        } else {
	
	            this.openToSubPane.apply(this, arguments);
	
	        }
	
	    },
	    paneToggledOpen: function(pane, isOpen, options) {
	
	        var sidePanel = this._getSideView(pane),
	            self = this,
	            args = Array.prototype.slice.call(arguments),
	            vCh = this.vChannel;
	
	        $.when(
	            sidePanel.toggleOpen(pane)
	        ).then(function() {
	
	            var panelCenter = self.layoutView.children.findByCustom('panelCenter');
	
	            panelCenter.updatePostSidePaneOpenChange.apply(panelCenter, args).done( function() {
	
	                vCh.command('setScale'); // could mediate more and only do if fit width/auto in vChannel (and not if in pdf mode)
	                self.resizeSidesIfOverlap();
	                self.channel.trigger( 'layout:repositionShapeDialog' ); // note: could double with set scale but hardly a perf hit
	
	            });
	
	        });
	    },
	    /*
	     * From pane toggle or open of pane --  note: side headers must render first
	     * 'Toggle Header and Side Views
	     */
	    subPaneChange: function(pane, subPane, options) {
	
	        var lastOpenPane = pane.previous('currentSubPane');
	        pane.set({ lastOpenSubPane: !lastOpenPane ? subPane : lastOpenPane});
	
	        this._getSideView(pane).toggleSubPane( pane, subPane, _.extend(options, {vChannel: this.options.vChannel}) );
	
	        this.layoutView[ pane.get('side') === 'left' ? 'leftHeader' : 'rightHeader'].currentView.toggleActivePane(pane, subPane);
	    },
	    setPanelWidth: function(panel, width, options) {  //now used by the enddrag ... should be callback
	        panel.updateWidth(width, options);
	    },
	    paneWidthChanged: function(pane, newWidth, options) {
	
	        var side = this._getSideView(pane);
	        side.updatePosition.apply(side, arguments);
	        options.fromResize && this.layoutView.children.findByCustom('panelCenter').updatePosition(pane); //DOES THE CENTER ...
	        (pane.isCovering() && options.fromDrag) && pane.set('isCovering', false);
	        ////(for recalcing the offsets):
	        //could check options in mediator fn (eg which side)
	        // //todo: subscribe and publish anyway (perf check on mediator)
	        (pane.get('side') === "right" && pane.get('currentSubPane') === 'fullText') &&
	            this.vChannel.trigger('layout:fullTextPaneWidthChange'); //todo: mediate
	    },
	
	    // open pane 100%, closing others; returns false is the pane model doesn't have the subPanel -- (callback for the command)
	    _coverWithPane: function(sidePane, subPane) {
	
	        if (!sidePane.hasSubPane(subPane))
	            return false;
	
	        this.closePane(this._getOppositePane(sidePane)); //(def for reset)
	
	        this.openToSubPane(sidePane, subPane, {
	            cover: true,
	            forceOpen: true,
	            containerWidth: this.request('layoutWidth', true) /* want dragger visible */
	        });
	
	        return true;
	
	    },
	    paneCoveringToggled: function() {  //todo: mediate
	        this.command.apply(this, ['togglePaneCover'].concat(_.toArray(arguments)));
	    },
	    _getOppositePane: function(pane) {
	        return this[(pane.get('side') === 'right' ? 'left' : 'right') + 'SideModel'];
	    },
	    _getSideView: function(pane) {
	        return this.layoutView[ (pane.get('side') === 'left' ? 'left' : 'right') + 'Content'].currentView;
	        //return this.layoutView.children.findByCustom('panel' + (pane.get('side') === 'left' ? 'Left' : 'Right'));
	    },
	
	    /* pane: either the string or model */
	    closePane: function(pane) {
	
	        typeof pane === 'string' &&
	            (pane = this[pane + 'SideModel']);
	
	        pane.close();
	
	    },
	    // Toggle the pane open / closed -- now called from hotkeys
	    // Pane: 'left' or 'right'
	    toggleSidePanel: function( pane ) {
	
	        var sidePanelModel = pane === 'left'
	            ? this.request('leftSideModel')
	            : this.request('rightSideModel');
	
	        sidePanelModel.isOpen()
	            ? this.trigger('layout:closeSidePanel', pane)
	            : this.trigger('layout:openToSubPane', pane);
	
	    },
	
	    _activeOrExpandedNoteChange: function(note, options) {
	
	        // TODO: should have a more centralized enable/disable rotate ...
	        if ( !this.vChannel.request('activeDocHasNoPages') ) {
	            this.command('toggleRotateEnabled', options.disableRotation );
	        }
	
	        this.channel.trigger('rightHeader:toggleNewNoteMenu', note != null);
	
	    },
	    // ( trigger would cause recursion, so just command on vChannel and forward fow now )
	    repositionShapeDialog: function() {
	        this.vChannel.command('repositionShapeDialog');
	    },
	
	    onBeforeDestroy: function() {
	
	        var lsm = this.leftSideModel,
	            rsm = this.rightSideModel,
	            smEvents = this.sideModelEvents;
	
	        this.layoutView.destroy();
	        this.unbindEntityEvents(lsm, smEvents);
	        this.unbindEntityEvents(rsm, smEvents);
	
	        _.invoke([lsm, rsm], 'destroy');
	
	    },
	    destroy: function() {
	        SubApp.prototype.destroy.call(this);
	        this.stopListening();
	
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(58)))

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {/* Layout of Viewer on 'Per Document Basis */
	
	__webpack_require__(712);
	
	var fvChannel = __webpack_require__(72).channel('FV'),
	    Marionette = __webpack_require__(61),
	    BabySitterView = __webpack_require__(489),
	    $ = __webpack_require__(59),
	
	    HeaderCenter = __webpack_require__(713),
	    HeaderLeft = __webpack_require__(730),
	    HeaderRight = __webpack_require__(735),
	
	    PanelCenterView = __webpack_require__(743),
	    PanelLeftView = __webpack_require__(745),
	    PanelRightView = __webpack_require__(749),
	
	    /* TODO -- move to viewer 'view', with  */
	    LoadingModal = __webpack_require__(751),
	    Modal = __webpack_require__(110);
	
	
	__webpack_require__(115);
	
	
	module.exports = Marionette.LayoutView.extend({
	
		template: __webpack_require__(754),
	
	    initialize: function() {
	        BabySitterView.prototype.createChildren.call(this); /* (this.children) views not from regions */
	    },
	
	    onRender:  Backbone.View.prototype.unwrap,  //if get rid of unwrap, rid the leaks
	
	    regions: {
	        leftHeader:     '.FV-header-left',
	        rightHeader:    '.FV-header-right',
	        centerHeader:   '.FV-header-center',
	
	        centerContent:  '.FV-center-content', /*('viewModes view rendered in this region */
	
	        leftContent:    '.FV-side-left',
			rightContent:   '.FV-side-right',
	
	        modal:          '.FV-modal-region'
		},
	
		ui: { /* Note: UI and Events Used in Layout but necessary in this view */
	        header:         '.FV-header',
	        panelCenter:    '.FV-center-wr'
	    },
	
	    onBeforeShow: function(view, region, options) {
	
	        var vCh = options.lChannel.request('vChannel');
	
	        this.centerHeader.show( new HeaderCenter({ vChannel: vCh }) );
	
	        this.leftContent.show( new PanelLeftView() );
	        this.rightContent.show( new PanelRightView() );
	
	        this.leftHeader.show( new HeaderLeft({
	            model: options.leftModel,
	            vChannel: vCh,
	            lChannel: options.lChannel
	         }) );
	
	
	        this.rightHeader.show( new HeaderRight( _.extend({
	                model: options.rightModel,
	                collection: options.notes,
	                vChannel: vCh
	            },
	            _.pick(options, 'fullTextQuery', 'numberFTHits', 'lChannel') 
	        )));
	
	
	        // TODO: out of child?
	        this.children
	            .add( new PanelCenterView( _.extend(options, {
	                el: this.ui.panelCenter,
	                $rightPanel: this.rightContent.$el,
	                $leftPanel: this.leftContent.$el,
	                $layoutViewEl: view.$el
	            })), 'panelCenter');
	
	    },
	
	    keyboardEvents: {
	
	        '[': function() {
	            this.options.lChannel.trigger('layout:toggleSidePanel', 'left');
	        },
	
	        ']': function() {
	            this.options.lChannel.trigger('layout:toggleSidePanel', 'right');
	        }
	
	    },
	
	    // TODO: currently not implemented
	     _setMinWidth: function() {
	         this.originalMinWidth = this.$el.getInlineStyle('min-width'); //store if exists before replacing in order to put it back
	         this.$el.css('min-width', this.options.lChannel.request('vChannel').request('minimumWidth'));
	    },
	    onShowModal: function(options, isLoading) {
	
	        /* the first shows if the view is already made; the latter expects content */
	
	        if ( options && options.modalView && options.modalView instanceof Modal ) {
	            options.modalView.settings.$container = this.$el; //TODO: setter fn
	            this.modal.show( options.modalView );
	            return options;
	        }
	
	        var opts = _.extend( options, {
	                $container: this.$el
	            }),
	            ModalType = !isLoading ? Modal : LoadingModal,
	            view = this.modal.show( new ModalType(opts) );
	
	        return view; //todo: what reliant on return
	
	    },
	    onCloseModal: function() {
	        this.modal.empty();
	    },
	    onToggleFullScreen: function(isFullScreen) {
	        this.centerHeader.currentView.triggerMethod('toggleFullScreen', isFullScreen);
	        this.rightHeader.currentView.command('toggleFullScreen', isFullScreen);
	    },
	    /*
	     * paneToggledOpen, windowResize
	     * TODO: if made smaller on initial the was before and resize -- set size back ... minor -- could keep %'s on a model
	     * whole system would be much better IF model driven
	     */
	    onResizeSidesIfOverlap: function(left, right) {
	
	        var lIsOpen = left.isOpen(),
	            rIsOpen = right.isOpen(),
	            paneIsCovering = left.isCovering() || right.isCovering(),
	            DIST_BUF = 100,//includes draggers (~4px each) //todo: store on center -- minWidth of that panel(?)
	            $l =  this.leftContent.$el,
	            $r =  this.rightContent.$el;
	
	        /* Panel Covering */
	        if (paneIsCovering) { //this applies to entering, now what size if open another
	            var nw = this.options.lChannel.request('layoutWidth', true),
	                paneCovering = lIsOpen ? left : right;
	            paneCovering.updateWidth(nw, {fromResize: true});
	            return; //exit
	        }
	
	        /* No Panel Covering */
	        if (lIsOpen && rIsOpen) {
	
	            /* BOTH OPEN If Both Panels Open, Change Width So they Don't Overlap */
	
	            //i think c with is 0 when l and r width are the same ... (l.width and r.width are the same ... so diff btn is 0)
	            // DVBC-984 --> NOW NOT USING CENTER WIDTH IN CALC, WHICH COULD BE ZERO (I THINK OCCURS WHEN R WIDTH AND L WIDTH ARE THE SAME)
	
	            var lWidth = $l.width();
	            var distBetweenPanelsLessBuffer = ( $r.offset().left - ($l.offset().left + $l.width()) ) - DIST_BUF;
	
	            // No-resize necessary if already wide enough
	            if (distBetweenPanelsLessBuffer >= 0)
	                return;
	
	            var distToMoveEachPanel = Math.abs(distBetweenPanelsLessBuffer) / 2;
	            //assuming equal, could do ratio based off prior ...
	            // todo: should do this ... eg if they were overlapping will be set to same size, really want set to size closest to the actual without overlapping
	
	            //set the width to the current size of the width less the distance to move it,
	            updatePanelWidths( Math.max( lWidth - distToMoveEachPanel, left.minWidth ), Math.max( $r.width() - distToMoveEachPanel, right.minWidth ) );
	
	        } else {
	            /* one side open */
	            var nw = this.$el.width() - DIST_BUF,
	                leftOpen = lIsOpen && !rIsOpen,
	                rightOpen = !lIsOpen && rIsOpen;
	            if (leftOpen && $l.width() > nw || rightOpen && $r.width() > nw ) updatePanelWidths(nw, nw);
	        }
	
	
	        function updatePanelWidths(leftW, rightW) {
	            left.updateWidth(leftW, {fromResize: true}); /* flag WILL also update the center panel in model's update cb IN addition to the panel itself!!! - make clearer */
	            right.updateWidth(rightW, {fromResize: true});
	        }
	
	    },
	    destroy: function() {
	
	        BabySitterView.prototype.onBeforeDestroy.call(this);
	        Marionette.LayoutView.prototype.destroy.apply(this, arguments);
	
	        /* Remove jq cache refs */
	        this.$('*').remove();
	        this.$el = null;
	        this.el = null;
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(49)))

/***/ },
/* 712 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var Marionette = __webpack_require__(61),
	    BabySitterView = __webpack_require__(489),
	     _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    NavView = __webpack_require__(714),
	    ModeView = __webpack_require__(717),
	    ZoomView = __webpack_require__(720),
	    RotateView = __webpack_require__(724),
	    UnrenderablePgsDD = __webpack_require__(726);
	
	//TODO: break out unselectable from extendJQuery
	__webpack_require__(76);
	
	
	var FULL_SCREEN_BTN_CLASS = 'fullScreen',
	    FULL_SCREEN_ICON = 'icon-resize-full-1';
	
	module.exports = BabySitterView.extend({ //item or layout
	    template: __webpack_require__(729),
	    onRender: function() {
	        Backbone.View.prototype.unwrap.call(this);
	        this.$el.unselectable();
	    },
	    FULL_SCREEN_BTN_CLASS: FULL_SCREEN_BTN_CLASS,
	    FULL_SCREEN_ICON: FULL_SCREEN_ICON,
	    ROTATE_DISABLE_CLASS: 'hide',
	    fullScreenTemplateOpts: function(showFullScreen) {
	        return {
	            showToggleFullScreenBtn: showFullScreen,
	            fullScreenBtnClass: FULL_SCREEN_BTN_CLASS,
	            fullScreenIcon: FULL_SCREEN_ICON
	        };
	    },
	    serializeData: function() {
	        var vCh = this.options.vChannel,
	            ad = vCh.request('activeDocument'),
	
	            options = _.extend({
	                viewModeClass: vCh.request('viewMode') + '-mode',
	                containerTitle: ad.containerTitle(),
	                containerType: ad.getContainerType().toLowerCase(),
	                friendlyContainerType: ad.friendlyContainerType(),
	                containerIcon: ad.getContainerIcon(),
	                showUnrenderablePgsDropDown: this._unrenderablePgsExist(),
	                disallowRotate:  vCh.request('disableRotation'),
	                disallowScale: vCh.request('disableScaling'),
	                ROTATE_DISABLE_CLASS: this.ROTATE_DISABLE_CLASS
	            }, this.fullScreenTemplateOpts( !vCh.request('settings').fullScreen() ));
	
	         return options;
	    },
	    ui: {
	        modeBtnView:            '.FV-mode',
	        navView:                '.FV-nav',
	        documentScaleView:      '.zoom-docMode',
	        pageScaleView:          '.zoom-pgMode',
	        unrenderablePgsDD:      '#pdf-md-unrenderable',
	        rotateEl:               '.FV-rotate',
	        fullScreenToggleBtn:    '.' + FULL_SCREEN_BTN_CLASS,
	        fullScreenIcon:         '.' + FULL_SCREEN_ICON,
	        docSelect:              '#docSelect'
	    },
	    events: {
	        'click @ui.fullScreenToggleBtn': 'toggleFullScreenClick'
	    },
	    toggleFullScreenClick: function() {
	        /* note: allow click to propagate to body so dropdown menu's close */
	        this.options.vChannel.command('toggleFullScreenMode'); // should forward ...
	    },
	    onBeforeShow: function() {
	
	        var vCh = this.options.vChannel,
	            ddContainer = {
	                container: vCh.request('getWrapper')  // should get from local channel
	            };
	            this.children
	                .add(
	                    new NavView({
	                        el: this.ui.navView,
	                        vChannel: vCh
	                    }), 'nav')
	                .add(
	                    new ModeView({
	                         el: this.ui.modeBtnView,
	                         vChannel: vCh
	                    }), 'modeBtns');
	
	        vCh.request('docHasRenderablePgs') && this.children.add( new RotateView({ //todo: include url with this?
	            el: this.ui.rotateEl,
	            vChannel: vCh,
	            ddOptions: _.extend({
	                hPos: 'right',
	                ddNoSelect: true,
	                activeClass: 'popupOpen'
	            }, ddContainer)
	        }), 'rotate');
	
	        this._unrenderablePgsExist() && this.children.add( new UnrenderablePgsDD({  //(only if they exist )
	            el: this.ui.unrenderablePgsDD,
	            vChannel: vCh,
	            ddOptions: _.extend({
	                ddNoSelect: true
	            }, ddContainer)
	        }), 'unrenderablePagesDD');
	
	        this.children.call('render');
	
	    },
	    _unrenderablePgsExist: function() {
	       return this.options.vChannel.request('docHasSomeUnrenderablePDFModePgs');
	    },
	    /* note: must be done after scale models is set */
	    onRenderZoomView: function(scale) {
	        var mode = scale.get('mode');
	        this.children.add( new ZoomView({
	            el:  this.ui[mode + 'ScaleView'],
	            model: scale,
	            vChannel: this.options.vChannel
	        }).render(), mode + 'ZoomDD');
	    },
	    updatePostScale: function(mode, scale, prevScale, scaleModel) {
	        this.children.findByCustom(mode + 'ZoomDD').children.findByIndex(0).updatePostScale(scaleModel, scale); //TODO: make event
	    },
	    onToggleFullScreen: function(isFullScreen) {
	        var $icon = this.ui.fullScreenIcon;
	        $icon.removeClass('icon-resize-' + (isFullScreen ? 'full-1': 'small-1'))
	             .addClass('icon-resize-' + (isFullScreen ? 'small-1': 'full-1'))
	             .prop('title', isFullScreen ? 'Resize' : 'Full Screen');
	    },
	    toggleHeaderViewModeState: function(mode, prevMode) {
	
	        this.$el.removeClass(prevMode + '-mode').addClass(mode + '-mode');
	
	        !this.dropdown &&
	            this.children.findByCustom('modeBtns').setActiveMode(mode); //(quick fix: don't do to overflow)
	
	        this.toggleScaleEnabled( this.options.vChannel.request('disableScaling') );
	
	    },
	    updatePostPageChange: function(opts) {
	        this.toggleRotateEnabled(opts.disableRotation);
	        this.toggleScaleEnabled(opts.disableScaling);
	    },
	    toggleRotateEnabled: function(disable) {
	        this.ui.rotateEl.removeClass(this.ROTATE_DISABLE_CLASS); //first remove the non-default
	        disable && this.ui.rotateEl.addClass(this.ROTATE_DISABLE_CLASS);
	    },
	    toggleScaleEnabled: function(disable) {
	        this.ui.documentScaleView.add(this.ui.pageScaleView).toggleClass('hide', disable);
	    },
	    destroy: function() {
	
	        BabySitterView.prototype.destroy.apply(this, arguments);
	
	        /* jq cache / detached nodes */
	        this.$el = null;
	        this.el = null;
	
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Marionette, _) {__webpack_require__(715);
	
	var Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	module.exports = Marionette.ItemView.extend({
	    constructor: function(options) { /* serialize data called b/f init */
	        this.vCh = options.vChannel;
	        Marionette.ItemView.prototype.constructor.call(this, options);
	    },
	    template: __webpack_require__(716),
	    serializeData: function() {
	
	        var activeDocument = this.vCh.request('activeDocument'),
	            pages = activeDocument.pageCollection,
	            docHasNoPages = activeDocument.get('docHasNoPages'); //prob more efficient to handle doc has no pages with css on class
	
	        return {
	            numPages: pages.length,
	            disableNavInput: pages.length < 2,
	            curPgNumber: pages.length > 0 ? this.vCh.request('currentPageNumber') : 0,
	            disableFirstOrPrevPg: this.vCh.request('isFirstPage') || docHasNoPages,
	            disableLastOrNextPg: this.vCh.request('isLastPage') || docHasNoPages
	        };
	
	    },
	    ui: {
	        nextBtn:    '.next-page',
	        prevBtn:    '.prev-page',
	        firstPg:    '.first-page',
	        lastPg:     '.last-page',
	        pageInput:  '#activePage',
	        totalPages: '#totalPages'
	    },
	    events: function() {
	
	        var vCh = this.vCh;
	
	        return {
	            'click @ui.nextBtn':        _.bind(vCh.command, vCh, 'goNextPage'),
	            'click @ui.prevBtn':        _.bind(vCh.command, vCh, 'goPrevPage'),
	            'click @ui.firstPg':        _.bind(vCh.command, vCh, 'goToFirstPage'),
	            'click @ui.lastPg':         _.bind(vCh.command, vCh, 'goToLastPage'),
	            'click @ui.pageInput':      'setPageInputFocus',
	            'change @ui.pageInput':     'validatePgInputAndGoToPage',
	            'keyup @ui.pageInput':      'triggerChangeIE'
	        };
	
	    },
	    updatePostPageChange: function(opts) {
	        this.ui.pageInput.val(opts.page.get('number'));
	        this.ui.prevBtn
	            .add(this.ui.firstPg)
	            .toggleClass('disabled', opts.isFirstPg );
	        this.ui.nextBtn
	            .add(this.ui.lastPg)
	            .toggleClass('disabled', opts.isLastPg);
	    },
	    updateTotalPages: function(numPages) {
	        this.ui.totalPages.text(numPages);
	    },
	    setPageInputFocus: function(e) {
	        $(e.currentTarget).select();
	    },
	    validatePgInputAndGoToPage: function(e) {
	
	        var pg = $(e.currentTarget).val(),
	            pgNum = parseInt(pg);
	
	        if ( isNaN(pgNum) )  {
	            this.undelegateEvents();
	            this.ui.pageInput.val( this.vCh.request('currentPageNumber') );
	
	            this.vCh.trigger('alert:show', {
	                type: 'error',
	                shortMessage: 'Please enter a valid page number.',
	                closeTimeout: 3000
	            });
	
	            this.delegateEvents();
	            this.setPageInputFocus(e);
	            return;   //prevent page change from bubbling with bad number (IE)
	        }
	
	        if (pgNum < 1 || pgNum > this.vCh.request('activeDocPages').length) {
	            this.undelegateEvents();
	            this.ui.pageInput.val( this.vCh.request('currentPageNumber') );
	            this.setPageInputFocus(e);
	            
	            this.vCh.trigger('alert:show', {
	                type: 'error',
	                shortMessage: 'Please enter a page number between 1 and ' + this.vCh.request('activeDocPages').length + '.',
	                closeTimeout: 3000
	            });
	
	            this.setPageInputFocus(e);
	            this.delegateEvents();
	            return false; //don't attempt to move
	        } else {
	
	            this.vCh.command('goToPage', this.vCh.request('activeDocPages').at(pgNum - 1) );
	            if (fvChannel.request('settings').isIE) { $(e.currentTarget).trigger('blur'); } //unfocus the field for IE }
	
	        }
	    },
	    triggerChangeIE: function(e) {
	        if (fvChannel.request('settings').isIE && e.keyCode==13) {
	            $(e.currentTarget).trigger('change'); //force IE to recognize an input change on enter key
	        }
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61), __webpack_require__(49)))

/***/ },
/* 715 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "disabled=\"disabled\"";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<span class=\"iwr first-page  "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableFirstOrPrevPg : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"First Page\">\n    <i class=\"icon-to-start\"></i>\n</span>\n\n<span class=\"iwr prev-page "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableFirstOrPrevPg : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Previous Page\">\n    <i class=\"icon-up-circled\"></i>\n</span>\n\n<span class=\"iwr next-page  "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableLastOrNextPg : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Next Page\">\n    <i class=\"icon-down-circled\"></i>\n</span>\n\n<span class=\"iwr last-page  "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableLastOrNextPg : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Last Page\">\n    <i class=\"icon-to-end\"></i>\n</span>\n\n<div class=\"FV-GoTo\">\n    <input id=\"activePage\" value=\""
	    + alias4(((helper = (helper = helpers.curPgNumber || (depth0 != null ? depth0.curPgNumber : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"curPgNumber","hash":{},"data":data}) : helper)))
	    + "\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableNavInput : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " title=\"Page\">\n    <span> of </span>\n    <span id=\"totalPages\">"
	    + alias4(((helper = (helper = helpers.numPages || (depth0 != null ? depth0.numPages : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numPages","hash":{},"data":data}) : helper)))
	    + "</span>\n</div>";
	},"useData":true});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(718);
	
	var Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	
	
	module.exports = Marionette.ItemView.extend({
	
	    template: __webpack_require__(719),
	
	    serializeData: function () {
	
	        var vCh = this.options.vChannel;
	
	        return {
	            hideDocMode: !vCh.request('includeDocumentMode', 1),
	            hidePgMode: vCh.request('hidePageMode'),
	            hidePdfMode: vCh.request('hidePdfMode')
	        };
	
	    },
	    onRender: function () {
	        this.setActiveMode( this.options.vChannel.request('viewMode') );
	    },
	    ui: {
	        modeBtns: '.view-mode'
	    },
	    events: {
	
	        'click @ui.modeBtns': function(e) {
	
	            e.stopPropagation();
	
	            var selectedMode =  $(e.currentTarget).data('view-mode');
	            if (selectedMode === this.options.vChannel.request('viewMode'))
	                return;
	
	            this.options.vChannel.command('setViewMode', selectedMode);
	        }
	    },
	    setActiveMode: function(mode) {
	        this.ui.modeBtns.removeClass('active');
	        this.$('[data-view-mode="' + mode + '"]').addClass('active');
	    }
	
	});
	
	 
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 718 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<span id=\"doc-mode\" data-view-mode=\"document\" class=\""
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideDocMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " view-mode iwr\" title=\"Full Document Mode\">\n    <i class=\"icon-docs\"></i>\n</span>\n\n<span id=\"pg-mode\" data-view-mode=\"page\" class=\" "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hidePgMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " iwr view-mode\"\n      title=\"Single Page, Actual-Size Mode\">\n    <i class=\"icon-doc\"></i>\n</span>\n\n<span id=\"pdf-mode\" data-view-mode=\"pdf\" class=\""
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hidePdfMode : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " iwr view-mode\" title=\"PDF Mode\">\n    <i class=\"icm-file-pdf3\"></i>\n</span>";
	},"useData":true});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Backbone = __webpack_require__(58),
	    ZoomDropDown = __webpack_require__(721),
	    BabySitterView = __webpack_require__(489);
	
	module.exports = BabySitterView.extend({
	    template: __webpack_require__(723),
	    serializeData: function() {
	        return {
	            initialValue: this.model.getFriendlyScaleValue()
	        };
	    },
	    onRender: function() {
	        var vCh = this.options.vChannel;
	        this.children.add( new ZoomDropDown({
	            el: this.ui.scaleSelect,
	            vChannel: vCh,
	            model: this.model,
	            ddOptions: {
	                isSelect: true,
	                isSelectForceChangeOnClick: 1, // DVBC-1727
	                activeClass: 'active popupOpen', //(want both)
	                container: vCh.request('getWrapper'),
	            }
	        }).render() );
	    },
	    ui: {
	        scaleSelect:    '.scaleSelect',
	        zoomInBtn:      '.zoomin',
	        zoomOutBtn:     '.zoomout'
	    },
	    events: function() {
	        var vCh = this.options.vChannel;
	        return {
	            'click @ui.zoomInBtn':  _.bind(vCh.command, vCh, 'zoomIn'),
	            'click @ui.zoomOutBtn': _.bind(vCh.command, vCh, 'zoomOut')
	        };
	    }
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var DropDown = __webpack_require__(432),
	    DropDownContent = __webpack_require__(431),
	    $ = __webpack_require__(59);
	
	/*
	 a mix of DD content and Base -- content for el to refer to the list, Base Used for ddOptions to capture onSelect Menu Events
	*/
	
	module.exports = DropDownContent.extend({
	    template: __webpack_require__(722),
	    ddDefaults: DropDown.prototype.ddDefaults, /* Allow Menu Selection */
	    templateOptions: function() {
	        var mode = this.model.get('mode');
	        return {
	            mode: mode,
	            scaleValues: this.options.vChannel.request((mode==='page' ? 'page': 'doc') + 'ModeScaleValues')
	        };
	    },
	    onRender: function() {
	        this.model.get('mode') === 'page' && this.$('[data-scale="Fit Height"]').after($('<div>').addClass('divider'));
	    },
	    //todo: ui and clean
	    defaultSelector: function() {
	        return '[data-scale="' + this.model.get('DEFAULT_SCALE') + '"]';
	    },
	    onChange: function(selectedValue, selectedData) {
	        var newScale = selectedData.scale,
	            newScaleType = !newScale
	                ? 'custom'
	                : isNaN(newScale) ? newScale : 'predefined';
	        this.options.vChannel.command('setScale', newScale, newScaleType);
	    },
	    updatePostScale: function(scaleModel, scaleVal) { //should be a model change...
	        var friendlyScaleValue = scaleModel.getFriendlyScaleValue(),//TODO: VARIABLE
	            $ddMenu = this.getDDContent();
	        //remove prior added custom mi if added regardless of type
	        if (this.$customMi) {
	            this.$customMi.remove();
	            delete this.$customMi;
	        }
	        if (scaleModel.get('scaleType') === 'custom') {
	            $ddMenu.find('.mi.active').removeClass('active');
	
	            this.dropdown.find('.ddValue').text(friendlyScaleValue); /* note: this.dropdown refers to the opener */
	
	            //todo:  put in order,  could make from template partial
	            this.$customMi = $('<div class="mi active" data-scale="' + parseFloat(scaleVal) + '">' + friendlyScaleValue + '</div>').appendTo($ddMenu);
	
	        }
	    }
	});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), alias3=helpers.helperMissing, alias4="function";
	
	  return "        <div class=\"mi\" data-scale=\""
	    + alias1(container.lambda(depth0, depth0))
	    + "\" title=\""
	    + alias1(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"key","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias1(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias3),(typeof helper === alias4 ? helper.call(alias2,{"name":"key","hash":{},"data":data}) : helper)))
	    + "</div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div id=\"zoom-dd-"
	    + container.escapeExpression(((helper = (helper = helpers.mode || (depth0 != null ? depth0.mode : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"mode","hash":{},"data":data}) : helper)))
	    + "\" class=\"zoomOptions dropdown-menu\">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.scaleValues : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n";
	},"useData":true});

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<span class=\"iwr zoomin\" title=\"Zoom In\">\n    <i class=\"icon-zoom-in\"></i>\n</span>\n\n<span class=\"iwr zoomout\" title=\"Zoom Out\">\n    <i class=\"icon-zoom-out\"></i>\n</span>\n\n<div class=\"scaleSelect dropdown\" title=\"Zoom\">\n    <span class=\"ddValue\">"
	    + container.escapeExpression(((helper = (helper = helpers.initialValue || (depth0 != null ? depth0.initialValue : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"initialValue","hash":{},"data":data}) : helper)))
	    + "</span>\n    <span class=\"select-icon icon-arrow-combo\"></span>\n</div>";
	},"useData":true});

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	var DropDown = __webpack_require__(432);
	
	module.exports = DropDown.extend({
	    template: __webpack_require__(725),
	    onChange: function(txt, val) {
	        this.options.vChannel.request('rotatePgRequest', val.deg);
	    }
	});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div id=\"dd-rotate\" class=\"dd-rotate dropdown-menu hide\">\n    <div class=\"mi\" data-deg=\"90\" title=\"Right\">\n        <span class=\"dd-icon icon-cw-1\"></span>\n        Right\n    </div>\n    <div class=\"mi\" data-deg=\"180\" title=\"Flip\">\n        <span class=\"dd-icon icon-exchange\"></span>\n        Flip\n    </div>\n    <div class=\"mi\" data-deg=\"-90\" title=\"Left\">\n        <span class=\"dd-icon icon-ccw\"></span>\n        Left\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/*
	* Note: dropdown only shown in pdf mode if a mix of renderable and non-renderable pgs' in viewer.
	* This view is the content of the dropdown button.
	* */
	
	__webpack_require__(727);
	
	var DropDownContentView = __webpack_require__(431),
	    $ = __webpack_require__(59),
	    _ = __webpack_require__(49);
	
	module.exports = DropDownContentView.extend({
	
	    template: __webpack_require__(728),
	
	    // Return array of the page model attributes augmented with a few properties.
	    // (Originally I just provided the model attributes).
	    // Note: unrenderablePDFModePgs are only either GOS or URL page types ...
	    // other 'URL' type pages are renderable so the URL portion wouldn't apply here (though the code should be cleaned up
	    // here and in the regular unrenderable page views to reflect this ) -- see comments in DVBC-1356.
	    templateOptions: function() {
	
	        var vCh = this.options.vChannel,
	
	            aPageModelAttributes =  vCh.request('unrenderablePDFModePgs').map( function(pg) {
	
	                var isGosPageType = pg.hasGosInfo();
	
	                return _.extend( {}, pg.toJSON() , {
	                    isGosPageType: isGosPageType,
	                    showDownloadButton: isGosPageType && vCh.request('allowPageDownload', pg )
	                });
	
	            });
	
	        return {
	            pages: aPageModelAttributes
	        };
	
	    },
	    ui: {
	        downloadGosBtn: '.btn-dl',
	        popUrlBtn:      '.btn-urlPop'
	    },
	    events: {
	        'click @ui.downloadGosBtn': function(e) {
	            var pgNum = $(e.currentTarget).data('pgnum'); // Stored in DOM for now -- really should have item view w/models and loop
	            this.options.vChannel.command('download', 'page', 'raw', pgNum);
	        },
	        'click @ui.popUrlBtn': function(e) {
	            var pgNum = $(e.currentTarget).data('pgnum');
	            window.open( this.options.vChannel.request('unrenderablePDFModePgs').findWhere({number: pgNum}).getPageUrl() );
	        }
	    }
	
	});

/***/ },
/* 727 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["with"].call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"with","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n";
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                    <tr>\n                        <td title=\""
	    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"number","hash":{},"data":data}) : helper)))
	    + "</td>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isGosPageType : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.url : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                        <td>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showDownloadButton : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.url : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n                        </td>\n\n                    </tr>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["with"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.gosInfo : depth0),{"name":"with","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                                <td class=\"tbl-fName\" title=\""
	    + alias4(((helper = (helper = helpers.filename || (depth0 != null ? depth0.filename : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"filename","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.filename || (depth0 != null ? depth0.filename : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"filename","hash":{},"data":data}) : helper)))
	    + "</td>\n                                <td class=\"tbl-fPath\" title=\""
	    + alias4(((helper = (helper = helpers.pathname || (depth0 != null ? depth0.pathname : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pathname","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.pathname || (depth0 != null ? depth0.pathname : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pathname","hash":{},"data":data}) : helper)))
	    + "</td>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                            <td colspan=\"2\" class=\"tbl-url\" title=\""
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.url || (depth0 != null ? depth0.url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"url","hash":{},"data":data}) : helper)))
	    + "</td>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                <button class=\"btn-dl btn btn-mini btn-hvr\" title=\"Download Original\" data-pgNum=\""
	    + container.escapeExpression(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"number","hash":{},"data":data}) : helper)))
	    + "\">\n                                    <i class=\"icon-download\"></i>\n                                </button>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                                <button class=\"btn-urlPop btn btn-mini btn-hvr\" title=\"Open In New Window\" data-pgNum=\""
	    + container.escapeExpression(((helper = (helper = helpers.number || (depth0 != null ? depth0.number : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"number","hash":{},"data":data}) : helper)))
	    + "\">\n                                    <i class=\"icon-link-ext-alt\"></i>\n                                </button>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div id=\"dd-unrenderable-pgs\">\n    <table>\n        <thead>\n            <tr>\n                <th title=\"Page\">Page</th>\n                <th title=\"File or URL\">File/URL</th>\n                <th title=\"Path\">Path<span id=\"pathInfo\"><i class=\"icon-info-circled\" title=\"(Does Not Exist For URLs)\"></i></span></th>\n                <th></th>\n        </thead>\n        <tbody>\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.pages : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        </tbody>\n   </table>\n</div>";
	},"useData":true});

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "            <div id=\"pdf-md-unrenderable\" class=\"hide dropdown iwr\">\n                <span class=\"icon-attention-circled\"></span>\n                Unrenderable Pages\n                <span class=\"icon-down-dir-1\"></span>\n            </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return container.escapeExpression(((helper = (helper = helpers.ROTATE_DISABLE_CLASS || (depth0 != null ? depth0.ROTATE_DISABLE_CLASS : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ROTATE_DISABLE_CLASS","hash":{},"data":data}) : helper)));
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\""
	    + alias4(((helper = (helper = helpers.fullScreenBtnClass || (depth0 != null ? depth0.fullScreenBtnClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullScreenBtnClass","hash":{},"data":data}) : helper)))
	    + " iwr\">\n                <span class=\""
	    + alias4(((helper = (helper = helpers.fullScreenIcon || (depth0 != null ? depth0.fullScreenIcon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullScreenIcon","hash":{},"data":data}) : helper)))
	    + "\" title=\"Full Screen\"></span>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-header-center "
	    + alias4(((helper = (helper = helpers.viewModeClass || (depth0 != null ? depth0.viewModeClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"viewModeClass","hash":{},"data":data}) : helper)))
	    + "\">\n\n    <span class=\"FV-header-doc header-grp\">\n\n        <div class=\"container-info container-"
	    + alias4(((helper = (helper = helpers.containerType || (depth0 != null ? depth0.containerType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"containerType","hash":{},"data":data}) : helper)))
	    + " header-grp\">\n            <span class=\"iwr containerIcon\" title=\""
	    + alias4(((helper = (helper = helpers.friendlyContainerType || (depth0 != null ? depth0.friendlyContainerType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"friendlyContainerType","hash":{},"data":data}) : helper)))
	    + "\">\n                <i class=\""
	    + alias4(((helper = (helper = helpers.containerIcon || (depth0 != null ? depth0.containerIcon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"containerIcon","hash":{},"data":data}) : helper)))
	    + "\"></i>\n            </span>\n            <span class=\"FV-hd-standout containerTitle\" title=\""
	    + alias4(((helper = (helper = helpers.containerTitle || (depth0 != null ? depth0.containerTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"containerTitle","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.containerTitle || (depth0 != null ? depth0.containerTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"containerTitle","hash":{},"data":data}) : helper)))
	    + "</span>\n        </div>\n\n    </span>\n\n    <div class=\"FV-mode header-grp\"></div>\n\n    <div class=\"pdf-mode-container-group\">\n        <span class=\"pdf-mode-lbl label label-important\">PDF</span>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showUnrenderablePgsDropDown : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </div>\n\n    <div class=\"FV-nav header-grp\"></div>\n\n    <div class=\"FV-zoom zoom-docMode header-grp "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disallowScale : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\"></div>\n    <div class=\"FV-zoom zoom-pgMode header-grp "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disallowScale : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\"></div>\n\n    <div class=\"header-grp action-bar\">\n\n        <div class=\"FV-rotate iwr dropdown "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disallowRotate : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n            <span class=\"icon-cw-1\" title=\"Rotate\"></span>\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showToggleFullScreenBtn : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {__webpack_require__(731);
	
	var SideHeader = __webpack_require__(732);
	
	
	
	module.exports = SideHeader.extend({
	
	    template: __webpack_require__(734),
	    onRender: Backbone.View.prototype.unwrap,
	
	    serializeData: function() {
	
	        var vChannel = this.options.vChannel;
	
	        return {
	             showIndexes: vChannel.request('includeIndexesModule'),
	             showThumbnails: this._showThumbnails(),
	             includeFindAndRedactModule: vChannel.request('includeFindAndRedactModule')
	        };
	
	    },
	
	    ui: {
	        thumbsBtn: '#toggleThumbs'
	    },
	
	    /* Thumbnails should never be visible in PDF mode */
	    toggleHeaderViewModeState: function() {
	
	        this.ui.thumbsBtn.toggleClass( 'hide', !this._showThumbnails() );
	
	    },
	
	    _showThumbnails: function() {
	        return this.options.vChannel.request('allowThumbnails');
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 731 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(733);
	
	var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59);
	
	__webpack_require__(76); // ( unselectable )
	
	module.exports = Marionette.ItemView.extend({
	
	    events:  {
	        'click .sidePanelTglBtn': 'togglePanelBtnClicked'
	    },
	
	    toggleHeaderViewModeState: $.noop,
	
	    /* switch panels or close all if click on the open one) */
	    togglePanelBtnClicked: function(e) {
	
	        this.options.lChannel.trigger('layout:sideHeaderTabClick', this.options.model, $(e.currentTarget).data('panel'));
	
	    },
	
	    //TODO: call from controller -- at the region level
	    toggleActivePane: function(sideModel, subPane) {
	
	        var allSubPaneClasses = sideModel.get('subPanes').join(' '),
	            $parentEl= this._parent.$el;
	
	        $parentEl.removeClass(allSubPaneClasses);
	
	       (subPane !== null) && $parentEl.addClass(subPane); //(only if open)
	    },
	
	    onShow: function() {
	        this.$el.unselectable();
	    },
	
	    // TODO: make part of destroy unselectable... need to clear from the jqCache
	    onBeforeDestroy: function() {
	
	        this.$el.find('*').each(function() {
	           $(this).remove();
	        });
	
	    },
	    destroy: function() {
	
	        Marionette.ItemView.prototype.destroy.apply(this, arguments);
	        /* necessary to remove detached node refs from jq cache */
	        this.el = null;
	        this.$el = null;
	
	    }
	});

/***/ },
/* 733 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "        <span id=\"info\" class=\"sidePanelTglBtn iwr\" data-panel=\"indexInfo\" title=\"Document Indexes\">\n             <i class=\"icon-info-circled\"></i>\n        </span>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "\n        <span id=\"find-and-redact-toggle-btn\" class=\"sidePanelTglBtn iwr\" data-panel=\"findAndRedact\" title=\"Find and Redact\">\n            <i class=\"fr-icon-search icon-search-outline\" ></i>\n            <i class=\"fr-icon-edit icon-pencil-alt\"></i>\n        </span>\n\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"FV-sideHeader-inner\">\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showIndexes : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <span id=\"toggleThumbs\" class=\"sidePanelTglBtn iwr "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showThumbnails : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-panel=\"thumbs\" title=\"Thumbnails\">\n         <i class=\"icon-th-list-2\"></i>\n    </span>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.includeFindAndRedactModule : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n</div>";
	},"useData":true});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone, _) {__webpack_require__(736);
	
	var SideHeader = __webpack_require__(732);
	var AjaxSpinner = __webpack_require__(737);
	var OverflowMenu = __webpack_require__(738);
	var BabySitterView = __webpack_require__(489); /* holds the overflow menu and ajax spinner */
	var NewNoteDD = __webpack_require__(490);
	
	/**
	 *
	 * Collection: the allNotes Collection -- could change and make clearer now.
	 */
	
	module.exports = SideHeader.extend({
	
	    template: __webpack_require__(742),
	    className: 'FV-header-right',
	    onRender: Backbone.View.prototype.unwrap,
	    initialize: function(options) {
	
	        this.collection = options.collection;
	
	        BabySitterView.prototype.createChildren.call(this);
	
	        //TODO: -- mediate vChannel / lChannel (see below) : capture on mod subscriptions
	        _.extend(this, Backbone.Radio.Channel.prototype);
	
	        this.comply({
	            toggleFullScreen: function(isFullScreen) {
	                this.children.findByCustom('overflow').triggerMethod('toggleFullScreen', isFullScreen);
	            },
	            stopAjaxSpinner: function() {
	                this.children.findByCustom('ajaxSpinner').triggerMethod('stop');
	            }
	        });
	
	        this.reply({
	           overflowMenu: function() {
	               return this.children.findByCustom('overflow');
	           }
	        });
	
	        var lCh = this.options.lChannel;
	        this.listenTo(lCh, 'updateNoteCount', this.updateNoteCount);
	        this.listenTo(lCh, 'updateFullTextSearchCount', this.updateFullTextSearchCount);
	        this.listenTo(lCh, 'rightHeader:toggleNewNoteMenu', this.toggleNewNoteMenu);
	
	        /* Note: switch from collectionEvents to fix context issue on callback */
	        SideHeader.prototype.initialize.call(this, options);  //fine, the base has init
	
	    },
	    serializeData: function() {
	
	        var fullTextQuery = this.options.fullTextQuery,
	            numberNotes = this.collection.length,
	            showFullTextButton = fullTextQuery !== null,
	            numFTHits = showFullTextButton ? this.options.numberFTHits : 0; //TODO: get nmFThits from the fullTextQuery Mod (now on active doc)
	
	        return {
	            numberNotes: numberNotes,
	            notesTitle: this._getNotesTabTitle(numberNotes),
	            showFullTextButton: showFullTextButton,
	            numFTHits: numFTHits,
	            //note: i think fullTextSearchTitle maybe unnecessary: this will update anyway post search completion -- notes WF doesn't work this way
	            fullTextSearchTitle: showFullTextButton ? this._getFullTextSearchIconTitle(numFTHits, fullTextQuery) : '',
	            hideNoteCount: numberNotes < 1,
	            hideFTCount: numFTHits < 1
	        };
	
	    },
	    ui: {
	        numberNotes:        '.numberNotes',
	        noteTabWr:          '.FV-nav-notes',
	        numberFTSearchHits: '#ftHits',
	        ajaxSpinner:        '.spinner-ajax-wr',
	        overflowMenu:       '#more',
	        newNoteDD:          '.add-pg-note',
	        notesTab:           '#notesTab',
	        fullTextTab:        '#fullTextBtn'
	    },
	    onBeforeShow: function() {
	
	        var vCh = this.options.lChannel.request('vChannel');
	
	        this.children
	            .add(new AjaxSpinner({
	                el: this.ui.ajaxSpinner
	            }).render(), 'ajaxSpinner')
	            .add( new OverflowMenu({
	                el: this.ui.overflowMenu,
	                vChannel: vCh,
	                ddOptions: _.extend({
	                    hPos: 'right',
	                    ddNoSelect: true // allow event but closes the dropdown
	                }, { container: vCh.request('getWrapper') })
	            }).render(), 'overflow');
	
	    },
	    togglePanelBtnClicked: function(e) {
	
	        // Don't allow to switch off note subPane if currently editing the note
	        if ( this.options.lChannel.request('activeNote'))
	            return false;
	
	        SideHeader.prototype.togglePanelBtnClicked.call(this, e);
	
	    },
	    updateNoteCount: function(num) {
	
	        this.ui.notesTab
	            .toggleClass('hide-badge', num < 1)
	            .attr( 'title', this._getNotesTabTitle(num) );
	
	        this.ui.numberNotes.text( num );
	
	    },
	    _getNotesTabTitle: function(numberNotes) {
	
	        var t = 'Notes';
	        (numberNotes > 0) && ( t += ' (' + numberNotes + ')' );
	        return t;
	
	    },
	    // localSearchTxt will exist if es module in 'local grep mode'
	    updateFullTextSearchCount: function(numHits, searchTxt, localSearchTxt) {
	
	        this.ui.fullTextTab
	            .toggleClass('hide-badge', numHits < 1)
	            .attr('title', this._getFullTextSearchIconTitle.apply(this, arguments) );
	
	        this.ui.numberFTSearchHits.text(numHits);
	
	    },
	    /* called on update and initial render -- for now initial would never have localSearchTxt -- not an option */
	    _getFullTextSearchIconTitle: function(numHits, searchTxt, localSearchTxt) {
	
	        if (searchTxt === '')
	            return 'Blank Search';
	
	        var title = 'Search: "' + searchTxt + '" (' + (numHits < 1 ? 'No' : numHits) + ' results)';
	        localSearchTxt && (title += '\n' + 'Filtered by: "' + localSearchTxt + '"');
	
	        return title;
	
	    },
	    onCreateNewNoteMenu: function(ddContent, notesChannel, ddContainer) {
	
	        var noteMenu = new NewNoteDD({
	            el: this.ui.newNoteDD,
	            channel: notesChannel,
	            isFromViewerHeader: true,
	            ddOptions: {
	                container: ddContainer,
	                $content: ddContent,  // utilize the already existing content from the other dropdown
	                hPos: 'right',
	                ddNoSelect: true,
	                activeClass: 'active',
	                onChange: function() {
	                    NewNoteDD.prototype.onChange.apply(noteMenu, arguments);
	                }
	            }
	        }).render();
	
	        this.children.add(noteMenu, 'noteMenu');
	
	    },
	    toggleNewNoteMenu: function(hideIt) {
	        this.ui.newNoteDD.toggleClass( 'hide', hideIt );
	    },
	    onBeforeDestroy: function() {
	
	        this.reset();
	        BabySitterView.prototype.onBeforeDestroy.call(this); //TODO: recursion -- b/c use as constructor
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(49)))

/***/ },
/* 736 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {/**
	 * Really just a wrapper for the plugin (el of the view) -- ajax events captured at the doc level.
	 * As of jQuery 1.8, the .ajaxStart() method should only be attached to document.
	 * Move up (doc level) and mediate  ?
	 */
	
	var SpinView = __webpack_require__(159),
	    $ = __webpack_require__(59);
	
	
	module.exports = SpinView.extend({
	
	    startHidden: true,
	
	    settings: _.extend( {}, SpinView.prototype.settings, {
	        color: '#FFF',
	        length: 3,
	        radius: 3,
	        width: 2
	    }),
	
	    onAfterRender: function() {
	        var $doc = $(document),
	            suppressSpinner = function(url) {
	                return url.indexOf('/rest/v2/api/cre') > -1 || url.indexOf('keepAlive') > -1; //separate loading indicators for the pages (images)
	            },
	            self = this;
	
	        // Use send/complete to filter action based off ajax options url
	        $doc.ajaxSend(function (e, jqXHR, ajaxOptions) {
	
	            if (suppressSpinner(ajaxOptions.url))
	                return;
	
	            self.triggerMethod('start');
	
	        }).ajaxComplete(function (e, jqXHR, ajaxOptions) {
	
	            if (suppressSpinner(ajaxOptions.url))
	                return;
	
	            self.triggerMethod('stop');
	
	        });
	
	    },
	
	    onBeforeDestroy: function () {
	
	        SpinView.prototype.onBeforeDestroy.apply(this, arguments);
	
	        //(jQ source indicates these fn's translate into events -- eg: $.fn.ajaxSend = function ( handler ) { return this.on('ajaxSend', handler); };
	        $(document).off('ajaxSend ajaxComplete');
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(739);
	
	var DropDown = __webpack_require__(431),
	    _ = __webpack_require__(49),
	    $ = __webpack_require__(59),
	    RotateView = __webpack_require__(724),
	    DownLoadTemplate = __webpack_require__(740),
	    RotateMenuTemplate = __webpack_require__(725),
	    HeaderCenterView = __webpack_require__(713);
	
	
	
	/**
	 * Find and Redact -- temporary flag to not show the full text menu items.
	 * In the current design they can be disabled, but at least in Phase 1 we don't want them to appear at all.
	 */
	
	var HIDE_FULL_TEXT_MENU_ITEMS = 1;
	if ( true ) {
	    HIDE_FULL_TEXT_MENU_ITEMS =1;
	}
	
	
	module.exports = DropDown.extend({
	
	    ROTATE_DISABLE_CLASS: 'disabled', /* used b/c hide doesn't work (in header) -- specificity, so use another class) */
	    template: __webpack_require__(741),
	
	    templateOptions: function() {
	
	        var vCh =  this.options.vChannel,
	            documentHasPages = !vCh.request('activeDocHasNoPages'),
	            allowDownloads = vCh.request('allowDownload'),
	            allowDocDownloadPDF = vCh.request('allowDocumentDownload', 1),
	            allowDocDownloadOriginal = vCh.request('allowDocumentDownload'),
	            isMultiDoc = vCh.request('documents').length > 1;
	
	        return _.extend({
	
	            //  Disabling page menu items done in seperate fn
	
	            downloadMenu: DownLoadTemplate({
	                // disable: this is generic -- the underlying items are disabled individually
	                // ( Note: not entirely correct -- eg only 1 URL page document -- DVBC-1704;
	                // would really want if no 'downloadable PDF' or 'original pages' ,
	                // but this isn't going to break anything -- all items will just be disabled )
	                disable: !documentHasPages || !allowDownloads,
	
	                disableDocDownloadPDF: !allowDocDownloadPDF,
	                disableDocDownloadOriginal: !allowDocDownloadOriginal,
	                titleAttribute: 'Download' + ( isMultiDoc ? ' Active Document' : '' )
	            })
	
	            },
	
	            {
	                showPDFComboSubMenu: vCh.request('allowPDFCombo'),
	                documentHasPages: documentHasPages,
	                disableLaunchDocAsPdf: !allowDocDownloadPDF, // utilize same logic as allowing document download as PDF
	                disableNewWindow: !vCh.request('allowNewWindow'),
	                disableDeletePage: !vCh.request('allowDeletePages'),
	                disableAddPages: !vCh.request('allowAddPages'),
	                disableReorderPages: !vCh.request('allowReorderPages'),
	                rotateMenuItems: $(RotateMenuTemplate()).html(), //(html just gives the menu items)
	
	                disbleShowPageText: !vCh.request('allowDocumentLevelShowPageText'),
	                disableTextOnlyMode: !vCh.request('allowDocumentLevelTextOnlyMode'),
	
	
	                hideFullTextMenuItems: HIDE_FULL_TEXT_MENU_ITEMS
	
	            },
	
	            HeaderCenterView.prototype.fullScreenTemplateOpts( !vCh.request('settings').fullScreen() )
	        );
	
	
	    },
	    render: function() {
	
	        DropDown.prototype.render.call(this); //create the dropdown first
	
	        var vc = this.options.vChannel,
	            nPgs = vc.request('activeDocPages').length,
	            pgClass = ( nPgs > 1  ? 'multi' : (nPgs === 0 ? 'no' : 'one')  ) + '-' + 'pages';
	
	        //TODO: in template
	        this.$el.addClass( vc.request('viewMode') + '-mode' ).addClass(pgClass);
	
	        //TODO: should really re-render from template on page change
	        this.updatePostPageChange({
	            isFirstPg:  vc.request('isFirstPage'),
	            isLastPg: vc.request('isLastPage'),
	            disableRotation: vc.request('disableRotation'),
	            disableScaling: vc.request('disableScaling'),
	            page: vc.request('currentPage')
	        });
	
	        return this;
	
	    },
	    ui: _.extend({
	
	            showDocInfo: '.docInfo',
	            showPgInfo: '.pgInfo',
	
	            showPageText: '#mi-show-pg-text',
	            textOnlyMode: '#mi-text-only-mode',
	
	            zoomIn: '#zoom-in',
	            zoomOut: '#zoom-out',
	            popWindow: '.popWindow',
	            nextPg: '.dd-next',
	            prevPg: '.dd-prev',
	            firstPg: '.dd-first',
	            lastPg: '.dd-last',
	            showAbout: '#FV-info',
	
	            /* TODO -- subview, download */
	            dlDocPDF: '#dn-dc-pdf',
	            dlDocRaw: '#dn-dc-raw',
	            dlPgPDF: '#dn-pg-pdf',
	            dlPgRaw: '#dn-pg-raw',
	
	            rotatePg: '.dd-rot-pg',
	            rotateEl: '.mi-rotate', /* same key as header, but diff class */
	            fullScreenLbl: '.mi-fs-lbl',
	            downloadSubMenuItem: '.mi-download',
	
	            pdfComboNewWindow:  '#pdfComboLink',
	            pdfComboDL:         '#pdfComboDL',
	
	            addPg:          '#mi-add-page',
	            deletePg:       '#mi-delete-page',
	            reorderPgs:     '#mi-reorder-pages',
	
	            launchDocAsPdf: '#launchDocAsPdf'
	
	        },
	        _.pick(HeaderCenterView.prototype.ui, 'fullScreenToggleBtn', 'fullScreenIcon')
	    ),
	    events: function() {
	
	        var vCh = this.options.vChannel;
	
	        return {
	            /*
	             * TODO:
	             * - really incorp into main class but here for now -- would need to extend for all
	             * - note -- would need the class, not inherited via css -- derive something from calc'd prop's if make generic
	             * StopImmediatePropagation: prevent other handlers, not just bubbling
	             */
	            'click .mi': function(e) {
	                $(e.target).hasClass('disabled') && e.stopImmediatePropagation();
	            },
	            'click @ui.showDocInfo':            _.bind(vCh.command, vCh, 'showDocInfo'),
	            'click @ui.showPgInfo':             _.bind(vCh.command, vCh, 'showPgInfo'),
	
	            'click @ui.showAbout':              _.bind(vCh.command, vCh, 'showAbout'),
	            'click @ui.popWindow':              _.bind(vCh.command, vCh, 'openInNewWindow'),
	            'click @ui.launchDocAsPdf':         _.bind(vCh.command, vCh, 'openDocAsPdfInNewWindow'),
	
	            'click @ui.fullScreenToggleBtn':    _.bind(vCh.command, vCh, 'toggleFullScreenMode'),
	            'click @ui.nextPg':                 _.bind(vCh.command, vCh, 'goNextPage'),
	            'click @ui.prevPg':                 _.bind(vCh.command, vCh, 'goPrevPage'),
	            'click @ui.firstPg':                _.bind(vCh.command, vCh, 'goToFirstPage'),
	            'click @ui.lastPg':                 _.bind(vCh.command, vCh, 'goToLastPage'),
	
	            /* note: could mixin from zoom view events -- (common dom el names, etc) */
	            'click @ui.zoomIn':                 _.bind(vCh.command, vCh, 'zoomIn'),
	            'click @ui.zoomOut':                _.bind(vCh.command, vCh, 'zoomOut'),
	
	            'click @ui.dlDocPDF':               _.bind(vCh.command, vCh, 'download', 'document', 'PDF'),
	            'click @ui.dlDocRaw':               _.bind(vCh.command, vCh, 'download', 'document', 'raw'),
	
	            'click @ui.pdfComboDL':             _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 0), /* put 0 in explicity, otherwise e is passed */
	            'click @ui.pdfComboNewWindow':      _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 1),
	
	            'click @ui.deletePg': function() {
	                // note: don't use '_.bind(vCh.command, vCh, 'showDeletePageDialog')' shorthand
	                //( avoid passing event argument that's appended by _.bind)
	                vCh.command('showDeletePageDialog');
	            },
	
	            'click @ui.addPg':                  _.bind(vCh.command, vCh, 'showAddPagesDialog'),
	            'click @ui.reorderPgs':             _.bind(vCh.command, vCh, 'showReorderPagesDialog'),
	
	
	            'click @ui.dlPgPDF': function(e) {
	                if ($(e.target).hasClass('disabled'))
	                    return false;
	                vCh.command('download', 'page', 'PDF');
	            },
	            'click @ui.dlPgRaw': function() {
	                vCh.command('download', 'page', 'RAW'); //! -- not BIND form. b/c passes the event param in the arguments object, which isn't wanted by download dispatcher
	            },
	            'click @ui.rotatePg': function(e) {
	                vCh.request('rotatePgRequest', $(e.target).data().deg);
	            },
	            onClickExportPDF: function() {
	                this.options.vChannel.command('exportAllDocumentsAsPDF');
	            },
	
	            'click @ui.showPageText': function(e) {
	
	                var $target =  $(e.currentTarget);
	
	                // TODO: -- do I check this now in lower level plugin?
	                if ( $target.hasClass('disabled') )
	                    return false;
	
	                // TODO: also in use with COLD page action menu -- check for class and make common functionality
	                $target.toggleClass('active');
	
	                vCh.command('toggleShowPageTextMode');
	
	            },
	
	            'click @ui.textOnlyMode': function(e) {
	
	                var $target =  $(e.currentTarget);
	
	                if ( $target.hasClass('disabled') )
	                    return false;
	
	                $target.toggleClass('active');
	
	                vCh.command('toggleTextOnlyMode');
	
	            }
	
	
	        };
	    },
	    onToggleFullScreen: function(isFullScreen) {
	        HeaderCenterView.prototype.onToggleFullScreen.apply(this, arguments);
	        this.ui.fullScreenLbl.text(isFullScreen ? 'Resize' : 'Full Screen');
	    },
	    //TODO: COMBO WITH toggleHeaderViewModeState
	    updatePostPageChange: function(opts) {
	
	        this.setNavFormatting(opts.isFirstPg, opts.isLastPg);
	        this.toggleRotateEnabled(opts.disableRotation);
	        this.toggleScaleEnabled(opts.disableScaling);
	        this._togglePageDownloadEnabled(opts.page);
	
	    },
	    setNavFormatting: function(isFirstPage, isLastPage) {
	
	        var $el = this.$el;
	        $el.removeClass('firstPg lastPg');
	
	        if (isFirstPage)
	            $el.addClass('firstPg');
	
	        if (isLastPage)
	            $el.addClass('lastPg');
	
	    },
	
	    /**
	     *
	     * currentPage predicate required in case doc has no pages
	     * If URL page: OLD disable entire dl submenu ( any doc download request will fail b/c its page request will fail )
	     * New: all for failure and provide error message; this should be fixed in CRE, esp for doc with mixed pages.
	     */
	
	    _togglePageDownloadEnabled: function(currentPage) {
	
	        var vCh = this.options.vChannel;
	
	        this.ui.dlPgRaw.toggleClass('disabled', !currentPage || !vCh.request('allowPageDownload', currentPage) ) ;
	        this.ui.dlPgPDF.toggleClass('disabled', !currentPage || !vCh.request('allowPageDownload', currentPage, 1) ) ;
	
	    },
	    toggleRotateEnabled: function() {
	        HeaderCenterView.prototype.toggleRotateEnabled.apply(this, arguments); //(needs cxt)
	    },
	    toggleScaleEnabled: function(disable) {
	        this.ui.zoomIn.add(this.ui.zoomOut).toggleClass('disabled', disable);
	    },
	    setDisableHandlers: RotateView.prototype.setDisableHandlers,
	    toggleHeaderViewModeState: HeaderCenterView.prototype.toggleHeaderViewModeState
	});
	
	


/***/ },
/* 739 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div class=\"mi mi-download dropdown-submenu "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disable : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\""
	    + container.escapeExpression(((helper = (helper = helpers.titleAttribute || (depth0 != null ? depth0.titleAttribute : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"titleAttribute","hash":{},"data":data}) : helper)))
	    + "\">\n    <span class=\"dd-icon icon-download\"></span>\n    Download\n    <div class=\"dropdown-menu download-dd sm-left\">\n\n        <div class=\"dd-grp dd-doc-d\">\n\n            <div class=\"list-header\" title=\"Document\">Document:</div>\n\n            <div id=\"dn-dc-pdf\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableDocDownloadPDF : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-type=\"PDF\" title=\"PDF\">\n                <span class=\"dd-icon icm-file-pdf3\"></span>\n                PDF\n            </div>\n\n            <div id=\"dn-dc-raw\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableDocDownloadOriginal : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Original\">\n                <span class=\"dd-icon icon-doc\"></span>\n                Original\n            </div>\n\n        </div>\n\n        <div class=\"divider\"></div>\n\n        <div class=\"dd-grp dd-pg-d\">\n            <div class=\"list-header\">Page:</div>\n\n\n            <div id=\"dn-pg-pdf\" class=\"mi\" title=\"PDF\">\n                <span class=\"dd-icon icm-file-pdf3\"></span>\n                PDF\n            </div>\n\n            <div id=\"dn-pg-raw\" class=\"mi\" title=\"Original\">\n                <span class=\"dd-icon icon-doc\"></span>\n                Original\n            </div>\n\n        </div>\n\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "            <div class=\"mi pgInfo\" title=\"Active Page Info...\">\n                <span class=\"dd-icon icon-doc-text-1\"></span>\n               Page Info...\n            </div>\n\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return " <!-- Note: temporary -->\n            <div id=\"mi-show-pg-text\" class=\"mi mi-cb-mixed-with-dd-icon "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disbleShowPageText : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Overlay Page Text Atop FDD Images\">\n                Show Page Text\n            </div>\n\n            <div id=\"mi-text-only-mode\" class=\"mi mi-cb-mixed-with-dd-icon "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableTextOnlyMode : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Text Only Mode\">\n                Text Only Mode\n            </div>\n\n            <div class=\"divider\"></div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    return "disabled";
	},"6":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"mi "
	    + alias4(((helper = (helper = helpers.fullScreenBtnClass || (depth0 != null ? depth0.fullScreenBtnClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullScreenBtnClass","hash":{},"data":data}) : helper)))
	    + "\" title=\"Full Screen\">\n                <span class=\"dd-icon "
	    + alias4(((helper = (helper = helpers.fullScreenIcon || (depth0 != null ? depth0.fullScreenIcon : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullScreenIcon","hash":{},"data":data}) : helper)))
	    + "\"></span>\n                <div class=\"mi-fs-lbl\" style=\"display: inline;\">Full Screen</div>\n            </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    return "            <div class=\"divider\"></div>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"dd-grp dd-grp-nav\">\n            <div id=\"mi\" class=\"mi dd-first\" title=\"First Page\">\n                <span class=\"dd-icon icon-to-start\"></span>\n                First Page\n            </div>\n            <div class=\"mi dd-prev\" title=\"Previous Page\">\n                <span class=\"dd-icon icon-up-circled\"></span>\n                Previous Page\n            </div>\n            <div id=\"mi\" class=\"mi dd-next\" title=\"Next Page\">\n                <span class=\"dd-icon icon-down-circled\"></span>\n                Next Page\n            </div>\n            <div class=\"mi dd-last\" title=\"Last Page\">\n                <span class=\"dd-icon icon-to-end\"></span>\n                Last Page\n            </div>\n        </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"divider\"></div>\n        <div class=\"mi mi-comboPdf dropdown-submenu\" title=\"Combine pages of all renderable documents into single PDF\">\n            <span class=\"dd-icon icm-file-pdf3\"></span>\n            PDF Combo\n            <div class=\"dropdown-menu sm-left\">\n                <div id=\"pdfComboDL\" class=\"mi\" title=\"Download\">\n                    <span class=\"dd-icon icon-download\"></span>\n                    Download\n                </div>\n                <div id=\"pdfComboLink\" class=\"mi\" title=\"Open in new window\">\n                    <span class=\"dd-icon icon-link-ext\"></span>\n                    New Window\n                </div>\n            </div>\n        </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function";
	
	  return "<div id=\"dd-header-overflow\">\n\n    <div class=\"dd-grp grp-docInfo\">\n\n        <div class=\"mi docInfo\" title=\"Doc Info...\">\n            <span class=\"dd-icon icon-doc\"></span>\n            Doc Info...\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.documentHasPages : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        <div class=\"divider\"></div>\n\n        "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideFullTextMenuItems : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n    </div>\n\n    <div class=\"dd-grp grp-pgActions\">\n\n        <!-- TODO: set perms from code for real on these and only show if document has pages, etc -->\n\n        <div id=\"mi-add-page\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableAddPages : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Add Page...\">\n            <span class=\"dd-icon icon-doc-add\"></span>\n            Add Page...\n        </div>\n\n        <div id=\"mi-delete-page\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableDeletePage : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Delete Page...\">\n            <span class=\"dd-icon icon-doc-remove\"></span>\n            Delete Page...\n        </div>\n\n        <div id=\"mi-reorder-pages\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableReorderPages : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Reorder Pages...\">\n            <span class=\"dd-icon icon-arrows-cw\"></span>\n            Reorder Pages...\n        </div>\n\n        <div class=\"divider\"></div>\n\n    </div>\n\n    <div class=\"dd-grp grp-docActions\">\n\n        <div class=\"mi popWindow "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableNewWindow : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Launch Viewer in New Window\">\n            <span class=\"dd-icon icon-popup\"></span>\n            New Window\n        </div>\n\n        <div id=\"launchDocAsPdf\" class=\"mi "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.disableLaunchDocAsPdf : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\"Open Document as PDF in New Window\">\n            <span class=\"dd-icon icon-link-ext\"></span>\n            Launch PDF\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showToggleFullScreenBtn : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.documentHasPages : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.documentHasPages : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <div class=\"dd-grp dd-grp-non-nav\">\n\n        <div class=\"dd-grp dd-grp-zoom\">\n            <div class=\"divider\"></div>\n            <div id=\"zoom-in\" class=\"mi\" title=\"Zoom In\">\n                <span class=\"dd-icon icon-zoom-in\"></span>\n                Zoom In\n            </div>\n            <div id=\"zoom-out\" class=\"mi\" title=\"Zoom Out\">\n                <span class=\"dd-icon icon-zoom-out\"></span>\n                Zoom Out\n            </div>\n        </div>\n\n        <div class=\"mi mi-rotate dropdown-submenu\" title=\"Rotate\">\n            <span class=\"dd-icon icon-cw-1\"></span>\n            Rotate\n            <div class=\"dropdown-menu dd-rot-pg sm-left\">\n                "
	    + ((stack1 = ((helper = (helper = helpers.rotateMenuItems || (depth0 != null ? depth0.rotateMenuItems : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"rotateMenuItems","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n            </div>\n        </div>\n\n        "
	    + ((stack1 = ((helper = (helper = helpers.downloadMenu || (depth0 != null ? depth0.downloadMenu : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"downloadMenu","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\n\n    </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPDFComboSubMenu : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n\n    <div class=\"dd-grp grp-about\">\n\n        <div class=\"divider\"></div>\n\n        <div id=\"FV-info\" class=\"mi about\" title=\"About...\">\n            <span class=\"dd-icon icon-info\"></span>\n            About...\n        </div>\n\n    </div>\n\n\n</div>";
	},"useData":true});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "hide-badge";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <!-- todo: don't need sidePanel toggle panel for event listener -- use data panel -->\n            <div id=\"fullTextBtn\" class=\"iwr sidePanelTglBtn tabWithBadge "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideFTCount : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-panel=\"fullText\" title=\""
	    + alias4(((helper = (helper = helpers.fullTextSearchTitle || (depth0 != null ? depth0.fullTextSearchTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fullTextSearchTitle","hash":{},"data":data}) : helper)))
	    + "\">\n                <span class=\"tabIcon icon-doc-text-1\"></span>\n                <span id=\"ftHits\" class=\"tabBadge\">"
	    + alias4(((helper = (helper = helpers.numFTHits || (depth0 != null ? depth0.numFTHits : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numFTHits","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-sideHeader-inner\">\n\n    <div class=\"rightHeaderNonTabbedContent\">\n\n        <span class=\"spinner-ajax-wr\"></span>\n\n        <div id=\"more\" class=\"iwr\">\n             <span class=\"icon-down-dir-1\" title=\"More...\"></span>\n         </div>\n    </div>\n\n    <div class=\"header-grp right-side\">\n\n        <div class=\"FV-nav-notes\">\n\n            <!-- shown post render of notes -->\n            <button type=\"button\" class=\"add-pg-note btn btn-mini btn-hvr dropdown\" title=\"Create Note\">\n                <i class=\"icon-plus-1\"></i>\n            </button>\n\n            <div id=\"notesTab\" class=\"iwr sidePanelTglBtn tabWithBadge "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.hideNoteCount : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" data-panel=\"notes\" title=\""
	    + alias4(((helper = (helper = helpers.notesTitle || (depth0 != null ? depth0.notesTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"notesTitle","hash":{},"data":data}) : helper)))
	    + "\">\n                <span class=\"tabIcon icm-rawaccesslogs\"></span>\n                <span class=\"tabBadge numberNotes\">"
	    + alias4(((helper = (helper = helpers.numberNotes || (depth0 != null ? depth0.numberNotes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"numberNotes","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n\n        </div>\n\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showFullTextButton : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </div>\n\n</div>";
	},"useData":true});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var Marionette = __webpack_require__(61),
	    $ = __webpack_require__(59),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	__webpack_require__(744);
	
	
	/*
	 * Note: vm ref access through options of currentView -- make back view?
	 * -- other option define region in fn in main view / set vm on before show of region.
	 * Current view is always the CENTER VIEW -- not the main view -- ui layout code overlapping it put in here
	 */
	
	module.exports = Marionette.ItemView.extend({
	
	    initialize: function(options) {
	
	        var o = options;
	        this.lChannel = o.lChannel;
	        this.bindUIElements();
	        this.enableDraggers( o.lChannel, o.$leftPanel, o.$rightPanel, o.$layoutViewEl );
	
	    }, 
	    ui: {
	        draggerLeft:        '.dragger-left',
	        draggerRight:       '.dragger-right',
	        collapseRight:      '.FV-collapse.right',
	        collapseLeft:       '.FV-collapse.left'
	    },
	    triggers: {
	        'click @ui.collapseRight':      'collapseRight',
	        'click @ui.collapseLeft':       'collapseLeft'
	    },
	    onCollapseRight: function() {
	        this.lChannel.trigger('layout:closeSidePanel', 'right');
	    },
	    onCollapseLeft: function() {
	        this.lChannel.trigger('layout:closeSidePanel', 'left');
	    },
	
	    /*
	    * TODO:
	    * - throttle/debounce resize panel
	    * - take width of draggers into account for overflow
	    * Note: layoutView must be in DOM to get $layoutViewEl.
	    * */
	    enableDraggers: function(lChannel, $leftPanel, $rightPanel, $layoutViewEl) {
	
	        var $container = $layoutViewEl,
	
	            fnScale = lChannel.request('setScaleFn'), // ( cache for performance )
	
	            leftSideModel = lChannel.request('leftSideModel'),
	            rightSideModel = lChannel.request('rightSideModel'),
	
	            // TODO: fwd to new lChannel.request('vChannel').request('viewModeIsPdf') and check other places to do so
	            // search for 'isPDF'
	            modeIsPDF = function() {
	                return lChannel.request('viewMode') === 'pdf';
	            },
	            
	
	            modeIsSinglePage = function() {
	                return lChannel.request('viewMode') === 'page';
	            },
	            currentPgRenderedInIframeInDocOrPageMode = function() {
	
	                var curPg =
	                    lChannel.request('vChannel').request('currentPage');  // should mediate ...
	
	                return curPg && curPg.renderUrlViewForDocAndPageMode(); // (Doc could have no pages)
	
	            },
	            currentPgIsGos =function() {
	                var curPg = lChannel.request('vChannel').request('currentPage');
	                return curPg && curPg.isGOS(); // (Doc could have no pages
	            },
	
	            // ( Using functions because current page and mode may have change since init )
	            fnApplyIframeFix = function() {
	               
	                var isPdfMode = modeIsPDF();
	                return isPdfMode ||
	                    ( !isPdfMode && currentPgRenderedInIframeInDocOrPageMode() ) || // cover 'url page views'
	                    ( modeIsSinglePage() && currentPgIsGos() ); // cover GOS pages loaded as PDF's in page mode
	            },
	            
	            fnSetPanelWidth = function(e, side, sideWidth) {
	                lChannel.trigger('layout:setPaneWidth', side === 'left'
	                    ? leftSideModel
	                    : rightSideModel, sideWidth, {fromDrag: true} );
	            },
	            baseOpts = {
	
	                dragStart: function() {
	                    lChannel.command('setPanelIsResizing', true); // could also be forwarded event
	                },
	
	                dragEnd:  function() {
	                    fnScale();
	                    fnSetPanelWidth.apply(this, arguments);
	                    lChannel.command('setPanelIsResizing', false);
	                },
	
	                // Note:
	                // - throttle ~@ 100 can make UI look 'bumpy'
	                // - repositionShapeDialog called twice if scale changes, but hardly a perf. hit
	                //   ( and issue is kinda trivial so don't feel like a large refactor )
	                dragMove: function() {
	                    fnScale();
	                    lChannel.trigger( 'layout:repositionShapeDialog' );
	                },
	
	                draggingClass: 'dragger-active',
	                container: $container,
	                iframeOverlayClass: 'dragger-iframe-overlay',
	
	                /*
	                 * TODO: if more, just provide all visible iframes in the viewerContainer and loop
	                 * (and only request this fn if applyIframeFix is true).
	                 * Note: on init pdfWrapper and docOrPgModeCurrentPgEl don't yet exist.
	                 * Also -- the mode and the current page could change -- why using functions.
	                 */
	                $iframeContainer: function() {
	
	                    if ( modeIsPDF() ) {
	                        return lChannel.request('pdfWrapper');
	                    }
	                    // should mediate better here ...
	                    return lChannel.request('vChannel').request('docOrPgModeCurrentPgEl');
	                },
	
	                fnApplyIframeFix: fnApplyIframeFix // (only if in PDF mode)
	            };
	
	        this.ui.draggerLeft.dragPaneResizer( _.extend({}, baseOpts, {
	            leftPane: $leftPanel,
	            rightPane: this.$el,
	            type: 'left',
	            minLeftEl: $container,
	            maxRightEl: this.ui.draggerRight, //enfore on init draw ...
	            minWidth: leftSideModel.minWidth
	        }));
	
	        this.ui.draggerRight.dragPaneResizer( _.extend({}, baseOpts, {
	            leftPane: this.$el,
	            rightPane: $rightPanel,
	            type: 'right',
	            minLeftEl: this.ui.draggerLeft,
	            maxRightEl: $container,
	            minWidth: rightSideModel.minWidth
	        }));
	
	    },
	    /*
	    * Only from layout (paneToggledOpen)
	    * */
	    updatePostSidePaneOpenChange: function(pane, isOpen) {
	
	        var self = this;
	
	        return $.Deferred(function($dfd) {
	
	            if (isOpen) {
	
	                // _.partial( _.bind(self._toggleCollapsed, self) , isOpen, pane)
	
	                self.updatePosition( pane, function() {
	                    self._toggleCollapsed(isOpen, pane).done( function() {
	                        $dfd.resolve();
	                    });
	                });
	
	            } else {
	
	                self._toggleCollapsed(isOpen, pane).done( function() {
	                    $dfd.resolve();
	                });
	            }
	
	        }).promise();
	
	    },
	    /*
	     * Only from updatePostSidePaneOpenChange
	     * */
	    _toggleCollapsed: function(isOpening, sideModel) { //
	        var side = sideModel.get('side'),
	            dragger = this.ui['dragger' + (side === 'left' ? 'Left' : 'Right')], 
	            $el = this.$el;
	
	        return $.Deferred( function($dfd) {
	            $.when( dragger.toggleClass('hide'), $el.toggleClass('no-margin-' + side)).then( $dfd.resolve );
	        }).promise();
	    },
	    /*
	     * Updates the side margin (using width of the model now just setting css)
	     * TODO:
	     * - have update on model width change ...
	     * - cb: use event instead ?
	    * */
	    updatePosition: function(sideModel, cb) {
	        this.$el.css('margin-' + sideModel.get('side'), parseFloat( sideModel.get('width')) );
	        cb && cb();
	    },
	    onBeforeDestroy: function() {
	        Marionette.blindTriggerOn( [this.ui.draggerLeft, this.ui.draggerRight], 'destroy');
	    }
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery, _) {(function ($) {
	    /*note : this should be specific code for a three column resizer with the layout here */
	    /*for now think of as dragger for and left and right pane*/
	    /* depending on fn.getMouseCoordinates */
	    $.fn.dragPaneResizer = function(options) {  //perhaps just make 3 pane hor resizer ....
	
	        var $dragger = this, //.drag(),
	            $leftPane = options.leftPane,
	            $rightPane = options.rightPane,
	
	            $minLeftEl = options.minLeftEl, //element on left can't go past
	            $maxRightEl = options.maxRightEl, //element on right can't go past
	
	            $container = options.container,
	            type = options.type, //right or left
	           
	            isDragging = false,
	
	            dragStart = options.dragStart,
	            dragEnd = options.dragEnd,
	            dragMove = options.dragMove,
	            draggingClass = options.draggingClass,
	
	
	            draggerW = $dragger.width(),//todo: unknown until in dom
	
	        //todo: a defaults -- CLEAN
	            MIN_WIDTH = options.minWidth || 0, //('pixel') -- must give a min width -- otherwise funky after drag past end and back -- should be larger than the hoverpane
	
	            maxWidth,
	
	            originalH,
	            lastX,
	            leftBoundX,
	            rightBoundX,
	
	            fnApplyIframeFix = options.fnApplyIframeFix,   //here a fn that evaluates
	            iframeOverlayClass = options.iframeOverlayClass, //USE THE OVERLAY IF PASS IN THE CLASS
	            $iframeContainer,
	
	            $iframeOverlay,
	            $doc = $(document),
	            
	            leftPaneLftOffset,
	            leftElLeftOffset,
	            maxRightElLeftOffset,
	            containerLeftOffset,
	            containerWidth,
	            maxRightElIsVisible,
	            maxRightElWidth,
	            minLeftElIsVisible,
	            minLeftElLeftOffset,
	
	            lastLeftPaneMarginRight,
	            lastRightPaneWidth;
	
	        $dragger.on('mousedown', onDraggerMouseDown);
	
	        function onDraggerMouseDown(e) {
	
	            e.preventDefault();
	            e.stopPropagation(); //not allowing to prop a perf issue
	
	            draggerW = $dragger.width(); //slop check in case calc'd when not yet in dom
	
	            /*  don't do if the original target was not el : eg if click on collapser inside*/
	            if (e.target !== $dragger[0]) return;
	
	            dragStart && dragStart();
	
	            isDragging = true;
	            $dragger.addClass(draggingClass);
	            lastX = $.fn.getMouseCoordinate(e).x;
	
	            //if iframeFix create transparent overlay over the center container    -- could do alliframes ...
	            //could repeat for each iframe
	            //append show moves with iframe with out having to resize
	            if (fnApplyIframeFix()) {
	                var iframeContainer = options.$iframeContainer;
	                $iframeContainer = typeof iframeContainer === 'function' ? iframeContainer() : iframeContainer; /* in case not create upon init */
	                $iframeOverlay = $('<div></div>').attr('class', iframeOverlayClass).appendTo( $iframeContainer );
	            }
	
	            leftPaneLftOffset = $leftPane.offset().left;
	            maxRightElLeftOffset = $maxRightEl.offset().left;
	            containerLeftOffset = $container.offset().left;
	            leftElLeftOffset = $minLeftEl.offset().left + MIN_WIDTH;
	            containerWidth = $container.width();
	            maxRightElIsVisible = $maxRightEl.is(':visible');
	            maxRightElWidth = $maxRightEl.width();
	            minLeftElIsVisible = $minLeftEl.is(':visible');
	            minLeftElLeftOffset = $minLeftEl.offset().left;
	
	            originalH = type === 'left' 
	                ? leftPaneLftOffset 
	                : leftPaneLftOffset + $leftPane.width(); 
	
	            //left
	             if (type === 'left') {
	
	              if (!maxWidth) {
	                rightBoundX = maxRightElIsVisible
	                    ? maxRightElLeftOffset - draggerW
	                    : containerLeftOffset + containerWidth - draggerW;
	                } else {
	                     rightBoundX = leftBoundX + maxWidth;
	                }
	            } else {
	                 rightBoundX = !MIN_WIDTH
	                    ? maxRightElLeftOffset + maxRightElWidth - draggerW
	                    : maxRightElLeftOffset + maxRightElWidth - MIN_WIDTH;
	
	                if (!maxWidth) {
	                    leftBoundX = minLeftElIsVisible
	                        ? minLeftElLeftOffset + (draggerW * 2)
	                        : containerLeftOffset + (draggerW * 2);
	                } else {
	                    leftBoundX = rightBoundX - maxWidth;
	                }
	
	                lastLeftPaneMarginRight = parseFloat($leftPane.css('margin-right'));
	                lastRightPaneWidth = parseFloat($rightPane.css('width'));
	            }
	
	             $doc.on('mousemove', onDocMouseMove).on('mouseup', docOnMouseup);
	        }
	
	        function onDocMouseMove(e) {
	            
	            e.preventDefault();
	            e.stopPropagation();
	
	            var x = e.pageX, 
	                dx,
	                resizeLeft = function() {  /* note: dragger moves with center pane */
	                     //if x is within bound, change leftPane width and rightPane margin
	                      if (x >= leftElLeftOffset && x <= rightBoundX) {
	
	                        dx = x - originalH;
	                        $leftPane.width(dx);
	                        $rightPane.css('margin-left', dx);
	                    }
	                };
	
	                //todo: also prevent from mouse going ahead
	
	
	            if (isDragging) {
	
	                if (type === 'left') {
	                    _.debounce(resizeLeft, 100, true)();
	
	                } else {
	                    _.debounce(function() {
	                         if (x >= leftBoundX && x <= rightBoundX) {
	                            dx = lastX - x;
	                            lastLeftPaneMarginRight += dx;
	                            lastRightPaneWidth += dx;
	                            lastX = x;
	                            $leftPane.css('margin-right', lastLeftPaneMarginRight );
	                            $rightPane.width(lastRightPaneWidth);
	                        }
	                    }, 100, true)();
	                }
	
	                dragMove(e);
	            }
	        }
	
	        function docOnMouseup(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            $iframeOverlay && $iframeOverlay.length > 0 && $iframeOverlay.remove();
	            $dragger.removeClass(draggingClass);
	            isDragging = false;
	            $doc.off('mousemove', onDocMouseMove).off('mouseup', docOnMouseup);
	            dragEnd(e, type, (type === 'left' ? $leftPane.width() : $rightPane.width() ));
	        }
	
	
	        $dragger.on('destroy', function() {
	            $dragger.off('mousedown', onDraggerMouseDown).off('destroy');
	            $doc.off('mousemove', onDocMouseMove).off('mouseup', docOnMouseup);
	        });
	
	
	        return this;
	    };
	
	}(jQuery));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(49)))

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
	    Backbone = __webpack_require__(58),
	    BaseSidePanel = __webpack_require__(746);
	
	
	
	module.exports = BaseSidePanel.extend({
	
	    side: 'left',
	
	    panelTemplate: __webpack_require__(748),
	
	    ui: {
	        indexes:        '.FV-indexes-panel',
	        thumbNails:     '.FV-thumbnails-panel',
	        findAndRedact:  '.FV-find-and-redact-panel'
	    }
	
	});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Backbone) {var Marionette = __webpack_require__(61),
		$ = __webpack_require__(59);
	
	module.exports = Marionette.ItemView.extend( {
	    template: __webpack_require__(747),
	    serializeData: function() {
	        return {
	            side: this.side
	        };
	    },
	    onRender: function() {
	        Backbone.View.prototype.unwrap.call(this);
	        /* Put in the sub view */
	        this.$('[data-content]').append( this.panelTemplate() );
	        this.bindUIElements();
	    },
	    onShow: function() {
	        /* Now changing the parent of el -- layout positioning applied to region -- todo: should be mediated atop */
	        this.$parent = this.$el.parent(); /* caching for perf */
	    },
	    toggleOpen: function(pane) { //called from toggleOfMain (change: isOpen): updates position to width, then open/closes
	        this.updatePosition(pane, pane.get('width'));
	        return this.$parent.toggleClass('open').promise();
	    },
	    updatePosition: function(pane, widthValue) { //called from a change in width property of the model
	        this.$parent.css({
	            width: widthValue,
	            right: parseFloat(widthValue)  * -1
	        });
	    },
	    toggleSubPane: function(model) {
	        var currentSubPane = model.get('currentSubPane'),
	            previousSubPane = model.previous('currentSubPane');
	        $.when(this.$parent.removeClass(previousSubPane).addClass(currentSubPane)).then( function() {
	            model.trigger('panel:postToggleSubPane', model);
	        });
	     },
	    onBeforeDestroy: function() {
	       this.$parent.remove();
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-paneContentWr FV-side FV-"
	    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class=\"FV-paneContent FV-"
	    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
	    + "\">\n        <div data-content=\""
	    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
	    + "\" class=\"FV-panel-"
	    + alias4(((helper = (helper = helpers.side || (depth0 != null ? depth0.side : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"side","hash":{},"data":data}) : helper)))
	    + "\"></div>  <!-- This is where to insert -->\n    </div>\n</div>";
	},"useData":true});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"panel-contents\">\n    <div class=\"FV-indexes-panel\"></div>\n    <div class=\"FV-thumbnails-panel\"></div>\n    <div class=\"FV-find-and-redact-panel\"></div>\n</div>";
	},"useData":true});

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var Marionette = __webpack_require__(61),
		Backbone = __webpack_require__(58),
	    BaseSidePanel = __webpack_require__(746);
	
	module.exports = BaseSidePanel.extend({
		side: 'right',
		panelTemplate: __webpack_require__(750),
		ui: {
			notes: 		'.FV-notes-panel',
			fullText: 	'.FV-full-text-panel'
		}
	});

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"panel-contents\">\n    <div data-panel=\"FV-notes\" class=\"FV-notes-panel\"></div>\n    <div data-panel=\"FV-full-text\" class=\"FV-full-text-panel\"></div>\n</div>\n";
	},"useData":true});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	/* Status updates, ability to cancel --- progress indicator instead of spinning gif */
	
	__webpack_require__(752);
	
	var Modal = __webpack_require__(110),
	    Marionette = __webpack_require__(61),
	    _ = __webpack_require__(49);
	
	module.exports = Modal.extend({
	    modalSettings: {    //these don't change -- settings for the modal
	        showDismissBtn: false,
	        overlay: false,
	        hideFooter: true
	    },
	    defaults: { //(the 'content' of key of modal defaults -- set from options passed here
	        heading: 'Loading ...',
	        status: '',
	        startPct: 0,
	        enableCancel: true,
	        cancelTitle: 'Cancel'
	    },
	    initialize: function(options) {
	        var childTemplate = __webpack_require__(753), //loaded inside body of super
	            subMarkup = childTemplate( _.extend( {}, this.defaults, options ) );
	        this.settings = _.extend( {}, {
	            content: subMarkup /* Note: non jquery markup inserted into template body */
	        }, options );
	        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.modalSettings ) );
	        return this;
	    },
	    ui: {
	        cancelBtn:      '#progress-cancel',
	        status:         '.status-msg',
	        progressBar:    '.bar'
	    },
	    events: {
	        'click @ui.cancelBtn': 'cancel'
	    },
	    keyboardEvents: {}, //override: don't allow escape to close
	    onUpdateStatus: function(nComplete, nTotal, statusMessage) { //status message is optional (its the friendly desc from the jq plugin)
	
	        // Prevent err updating ref to ui if destroyed first ... onCancel which destroy the view could run before this is called ...
	        if (this.isDestroyed)
	            return false;
	
	        var pct = String( Math.round( (nComplete / nTotal) * 100 ) ) + '%'; //must be string so jquery keeps %
	
	        if (statusMessage)
	            this._updateStatusMsg(statusMessage);
	
	        this.ui.progressBar.css( 'width', pct );
	    },
	    cancel: function() {
	        this._updateStatusMsg('Cancelling...');
	        this.settings.onCancel && this.settings.onCancel.call(this); //(left of to caller to close on cancel) -- could be
	    },
	    _updateStatusMsg: function(msg) {
	        // If entering here when destroyed already called, there will be an error referencing this.ui.status (it will be a str).
	        if (this.isDestroyed)
	            return false;
	        this.ui.status.text(msg);
	    }
	});


/***/ },
/* 752 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "hide";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"FV-loading-modal\"> <!-- loaded inside modal -->\n    <div class=\"message\">"
	    + alias4(((helper = (helper = helpers.heading || (depth0 != null ? depth0.heading : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"heading","hash":{},"data":data}) : helper)))
	    + "</div>\n\n    <div class=\"progress progress-striped active\">\n        <div class=\"bar\" style=\"width:"
	    + alias4(((helper = (helper = helpers.startPct || (depth0 != null ? depth0.startPct : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"startPct","hash":{},"data":data}) : helper)))
	    + "%;\"></div>\n    </div>\n\n    <div class=\"status-msg ellipsis\">"
	    + alias4(((helper = (helper = helpers.status || (depth0 != null ? depth0.status : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"status","hash":{},"data":data}) : helper)))
	    + "</div>\n\n    <button id=\"progress-cancel\" class=\"btn btn-small pull-right "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.enableCancel : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\" title=\""
	    + alias4(((helper = (helper = helpers.cancelTitle || (depth0 != null ? depth0.cancelTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cancelTitle","hash":{},"data":data}) : helper)))
	    + "\">Abort</button>\n\n</div>\n";
	},"useData":true});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(118);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"FV-layout-wr\"> <!-- note: mode -->\n\n    <div class=\"FV-layout\">\n\n        <div class=\"FV-layout-inner\">\n\n            <div class=\"FV-header\"> <!-- note: mode -->\n                <div class=\"FV-header-inner\">\n                    <div data-content-layout=\"header-left\" class=\"FV-header-left\"></div>\n                    <div data-content-layout=\"header-center\" class=\"FV-header-center\"></div>\n                    <div data-content-layout=\"header-right\" class=\"FV-header-right\"></div> <!-- hybrid: b/c always created (notes), ajax-spinner and more menu in there -->\n                </div>\n\n            </div>\n\n\n            <div class=\"FV-content\">\n\n                <div data-layout=\"left\" class=\"FV-side-left FV-pane FV-left FV-side\"></div>\n\n                <!-- margin applied here on drag, open/close -->\n                <div data-layout=\"center\" class=\"FV-center-wr FV-pane no-margin-left no-margin-right\">\n\n                    <div class=\"FV-dragger dragger-left hide\">\n                        <div class=\"FV-collapse left\" title=\"Collapse\">\n                            <span class=\"arrowLeft\"></span>\n                        </div>\n                    </div>\n\n                    <!--what appears as content of center content: position adjusted slightly to account for border & dragger width -->\n                    <div data-content=\"center\" class=\"FV-center-content FV-pane-center FV-pane\"></div>\n\n                    <div class=\"FV-dragger dragger-right hide\">\n                        <div class=\"FV-collapse right\" title=\"Collapse\">\n                            <span class=\"arrowRight\"></span>\n                        </div>\n                    </div>\n\n                </div>\n\n                <div data-layout=\"right\" class=\"FV-side-right FV-pane FV-side FV-right\"></div>\n\n            </div>\n        </div>\n\n    </div>\n\n    <div class=\"FV-modal-region\"></div>\n\n</div>\n\n";
	},"useData":true});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var fvChannel = __webpack_require__(72).channel('FV'),
		SidePane = __webpack_require__(756);
	   
	module.exports = SidePane.extend({
	
	    // Subpanes: correspond to class of el / data-toggle names (in header)
	    // - perhaps store a ref to their el
	    // - could print to template
	    defaults: _.extend( {}, SidePane.prototype.defaults, {
	
	        subPanes: ['thumbs', 'indexInfo', 'findAndRedact'],
	        side: 'left',
	        defaultSubPane: 'indexInfo'
	
	    }),
	
	    widthStorageKey: function() {
	        return fvChannel.request('localStorage').LEFT_PANE_WIDTH;
	    }
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    _ = __webpack_require__(49),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    Util = __webpack_require__(48);
	
	
	module.exports = Backbone.Model.extend({
	
	    widthStorageKey: null,
	
	    minWidth: 50, // if open -- must be at least this wide (px); assuming not closed
	
	    defaults: {
	        subPanes: [],  //names of: perhaps a hashView the name and the view object?
	        currentSubPane: null, //trigger subpane opening/closing (null indicates the panel is closed)
	        lastOpenSubPane: null,
	        isOpen: false,
	        isCovering: false, //flag -- set to true if open to entire container width
	        width: null, //default 'openToValue' -- of center content and side pane views
	        lastOpenWidth: null, //set on update width
	        defaultSubPane: null //the default subPanel is the one the app will open to by default
	    },
	
	    initialize: function() {
	
	        var loadWidth = this._getWidthOnLoad();
	        this.updateWidth(loadWidth);
	        this._updateStorageWidth(loadWidth); //(lister not set yet -- do it?)
	
	    },
	
	    // Open the panel and set the given subpane as active
	    // Entry point to open to it.
	    openToSubPane: function(subPane, options) {
	
	        var isOpen = this.isOpen(),
	            changingSubPane = subPane !== this.get('currentSubPane'),
	            isCovering = ( options && options.cover ) || ( this.isCovering() ), //(entering into with cover or subpane change when covering)
	            openToSubPane = subPane === 'default' ? this.get('defaultSubPane') : subPane,
	            preCloseAttrs,
	            attrs = {
	                isCovering: isCovering ? true : false,
	                isOpen: true,
	                currentSubPane: openToSubPane,
	                lastOpenSubPane: openToSubPane,
	                lastOpenWidth: this.get('width') ? this.get('width') : this.previous('lastOpenWidth')//this.previous('lastOpenWidth') //don't think need
	            };
	
	        isCovering && (preCloseAttrs = _.extend({}, attrs));
	        (options && options.forceOpen && this.get('isOpen')) && this.close();
	
	        if (isCovering) {
	
	            this.set({width:  options.containerWidth}, {silent: true});
	
	            if (changingSubPane) {
	                preCloseAttrs.lastOpenWidth = this.get('lastOpenWidth'); //could set in above but now overriding here
	            } else {
	                this._updateStorageWidth( this.get('lastOpenWidth') );
	            }
	
	            this.set(preCloseAttrs, options);
	
	        } else {
	
	            var lastOpenWidth = this.get('lastOpenWidth'),
	                w = Math.max(lastOpenWidth, this.minWidth);
	
	            this.set('width', w, {silent: true}); //no trigger
	            this._updateStorageWidth(w);
	            this.set(attrs, options); //last open width incorrect here after the first open cover
	        }
	    },
	    updateWidth: function(width, options)  {
	
	        this.set({
	            width: width,
	            lastOpenWidth: width
	        }, options);
	
	        this._updateStorageWidth(width);
	
	    },
	
	    _updateStorageWidth: function(value) {
	        fvChannel.request('localStorage').setItem(  _.result(this, 'widthStorageKey'), value );
	    },
	
	    /*
	    * If the width isn't stored in local storage or its value is null, get it from the style sheet, otherwise use the stored value.
	    * This may be better performed on init of the localStorage module in a config variable.
	    * */
	
	    _getWidthOnLoad: function() {
	
	        var locallyStoredValue = fvChannel.request('localStorage').getItem( _.result(this, 'widthStorageKey') );
	
	        //null will be string; this happens if closed w/the collapser -- still????
	        return (!locallyStoredValue || locallyStoredValue === 'null' || isNaN(locallyStoredValue))
	            ? getOriginalWidthFromStyleSheet.call(this)
	            : parseInt(locallyStoredValue);
	
	        // TODO: remove the stylesheet dependency -- calc from the JS
	        // Note: needs the FV namespace
	        function getOriginalWidthFromStyleSheet() {
	            return parseInt(
	                Util.getStyleSheetPropertyValue('.FV .FV-side-' + this.get('side'), 'width')
	            );
	        }
	
	    },
	
	    hasSubPane: function(strPane) {
	        return _.contains(this.get('subPanes'), strPane);
	    },
	    isActivePane: function(subPane) { //return if the given subpanel is the active one
	        return (this.get('currentSubPane') === subPane);
	    },
	    isSubPanelOpen: function(subPane) { //is the panel open to the given subPane?
	        return (this.get('isOpen') === true && this.get('currentSubPane') === subPane);
	    },
	    isOpen: function() {
	        return this.get('isOpen');
	    },
	    close: function() {
	        this.doClose();
	    },
	    isCovering: function() {
	      return this.get('isCovering');
	    },
	
	    //(close entire panel)
	    doClose: function() {
	
	        this.set({
	            isCovering: false,
	            isOpen: false, //trigger
	            width: null, //trigger
	            currentSubPane: null,  //trigger
	            lastOpenSubPane: this.previous('currentSubPane')
	        });
	
	    },
	    destroy: function() {
	        this.stopListening();
	    }
	});
	
	
	
	


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var fvChannel = __webpack_require__(72).channel('FV'),
	    SidePane = __webpack_require__(756);
	
	
	module.exports = SidePane.extend({
	
	    initialize: function(attrs, options) {
	
	        this.lChannel = options.lChannel;
	        SidePane.prototype.initialize.apply(this, arguments);
	
	    },
	
	    defaults:  _.extend( {}, SidePane.prototype.defaults, {
	
	        side: 'right',
	        subPanes: ['notes', 'fullText'],
	        defaultSubPane: 'notes' // TODO: from global settings
	
	    }),
	
	    widthStorageKey: function() {
	
	        return fvChannel.request('localStorage').RIGHT_PANE_WIDTH;
	
	    },
	
	    // TODO: MEDIATE -- preclose event (should be via controller or in view or call prior)
	    close: function() {
	
	        if (this.lChannel.request('activeNote'))
	            return;
	
	        this.doClose();
	
	    }
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var ReasonCodeCollection = __webpack_require__(80),
	    fvChannel = __webpack_require__(72).channel('FV');
	    _ = __webpack_require__(49);
	
	
	/**
	 * All reason codes in the system -- active and inactive.
	 * Still need all for cross reference to locally stored last codes.
	 * Inactive is cached on parse for performance boost.
	 */
	
	module.exports = ReasonCodeCollection.extend({
	
	    initialize: function() {
	
	        // Cache the active ones on this object, set on parse
	        this.activeReasonCodes = null;
	
	        /* Cache some other values */
	        this._activeReasonCodeCodes = null;
	        this._sanitizedActiveReasonCodeCodes = null;
	
	
	    },
	
	    // This is for all -- active and inactive
	    url: function() {
	        return fvChannel.request('apiUrl').reasonCodes;
	    },
	
	    parse: function( attrs ) {
	
	        var activeRcs = _.filter( attrs, function(rc) {
	            return rc.active;
	        });
	
	        /* other option is the 'cache' approoach -- then can get out of parse */
	        this.activeReasonCodes = new ReasonCodeCollection( activeRcs );
	
	        return attrs;
	
	    },
	
	
	    getActiveReasonCodes: function() {
	        return this.activeReasonCodes;
	    },
	
	
	    getValidAndInvalidCodesFromUserInput: function( aCodes ) {
	
	        if ( !aCodes || aCodes.length < 1 )
	            return;
	
	
	        this._sanitizedActiveReasonCodeCodes = this._sanitizedActiveReasonCodeCodes || this.getActiveReasonCodes().map( function( rc ) {
	            return rc.get('code').toLowerCase().trim();
	        });
	
	        var retObj = {
	            validCodes: [],
	            invalidCodes: []
	        };
	
	        return aCodes.reduce( function( previous, current ) {
	
	            var indexOfCodeFromActiveSystemCodes = this._sanitizedActiveReasonCodeCodes.indexOf( current.toLowerCase().trim() );
	
	            if (  indexOfCodeFromActiveSystemCodes > -1 ) {
	
	                // Return the 'non-sanitized' -- we want to actual model -- caller can get the attributes from .toJSON()
	
	                previous.validCodes.push( this.getActiveReasonCodes().at( indexOfCodeFromActiveSystemCodes ) );
	
	            } else {
	
	                // Return the raw value for error reporting
	                previous.invalidCodes.push( current );
	
	            }
	
	            return previous;
	
	        }.bind( this ), retObj );
	
	    }
	
	
	
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV'),
	    $ = __webpack_require__(59),
	    AuthState = __webpack_require__(760);
	
	/*
	* This model hold attributes from either an auth or keep alive request 'FeithSessionWeb' object.
	* */
	
	module.exports = Backbone.Model.extend({
	
	    initialize: function() {
	
	        this.state = new AuthState();
	
	    },
	    url: function() {
	        return fvChannel.request('apiUrl').login;
	    },
	
	    /**
	     * Override for specific $ ajax overrides sent to options in Backbone.sync ( DVBC-1775 ).
	     * data: from data from login form -- object of key value pairs.
	     * jqAjax, if provided json object of key value pairs will convert it to form data when processData is true.
	     */
	    fetch: function( options ) {
	
	        var bb_sync_ajax_options = {
	            data: options.data,
	            context: options.context,
	            type: 'POST',
	            contentType: 'application/x-www-form-urlencoded'
	        };
	
	        return Backbone.Model.prototype.fetch.call( this, bb_sync_ajax_options );
	
	    },
	
	    /* API entry point that logs in or out */
	    setUserAuth: function(isAuth, options) {
	        var state = this.state;
	        if (isAuth) {
	            state.login(); //attributes set on fetch
	        } else {
	            this.clear(); //clear previous session login data
	            this.state.logout(options);
	        }
	    },
	    /*
	    *  Call keepAlive and set the attributes of this model to the response.
	    *  Essentially the equivalent of a fetch of this model, as login returns the same 'FeithSessionWeb' object.
	    *  Now only called by FV.addViewer in it's sequence of operations ...
	    *  If first authentication wasn't done, logs in via keep alive -- storing the auth attr's on this model.
	    *  If the auth data model is empty but the user wasn't timed out -- restore the data.
	    *  FV.addViewer occurs on load of FV library which can include a page refresh -- if our session hasn't timed-out,
	    *  this will populate the model and return sucessfully.
	    *  MUST be done prior to rendering so permissions in templates exist.
	    * */
	    loginViaKeepAlive: function(cxt) {
	
	        cxt = cxt || this;
	
	        var self = this;
	
	        return $.Deferred( function($dfd) {
	
	            self._keepAlive().done( function( authAttrs ) {
	                self.set( authAttrs, {set: false} );  //store the attributes on the auth model
	                $dfd.resolveWith(cxt);
	
	            }).fail( function() {
	                $dfd.rejectWith(cxt, [arguments]);
	            });
	
	        }).promise(); 
	        
	    },
	    // Now always returns data : returns either login with session data or 401
	    _keepAlive: function() { 
	        return $.ajax({
	            url: fvChannel.request('apiUrl').keepAlive,
	            type: 'GET'
	        });
	    },
	     /* Note :not yet used in interface */
	    logOut: function() {
	
	        if ( !this.state.firstAuthCompleted() )
	            return;
	
	        $.ajax({
	             url: fvChannel.request('apiUrl').logout,
	             method: 'GET'
	        }).done( function() {
	
	            fvChannel.command('userLoggedOut', {fromLogOut: true});
	
	        }).fail( function(jqXHR){
	
	            fvChannel.command('userLogoutError', jqXHR);
	        });
	
	    },
	    loggedOutFromSessionTimeout: function() {
	        return this.state.didSessionTimeout();
	    },
	    getLogInError: function() {
	        return this.state.loginErr();
	    },
	    didFirstAuthenticationOccur: function() {
	        return this.state.firstAuthCompleted();
	    },
	    isAuthenticated: function() {
	        return this.state.isAuthenticated();
	    },
	    /*
	     * eg: "fdd92_pecan"
	     */
	    getDataService: function() {
	        return this.get('dataService');
	    }
	});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58);
	
	module.exports = Backbone.Model.extend({
	    defaults: {
	        firstAuthComplete: false, // flag used in determining logout reason
	        userAuthenticated: false,
	        logOutReason: null, // 'initialViewerRender' or 'sessionTimeout' or 'validationError' or 'userLoggedOut'
	        logInErrorMessage: null
	    },
	    login: function() {
	        this.set({
	            userAuthenticated: true,
	            firstAuthComplete: !this.get('firstAuthComplete'), //TODO: enum xref
	            logOutReason: null,
	            logInErrorMessage: null
	        });
	    },
	    logout: function(options) {
	
	        var reason = null,
	            logInErrorMsg = null,
	            userLogOut = options && options.fromLogOut,
	            authErr = options && options.authErr,
	            firstAuthCompleted = this.get('firstAuthComplete');
	
	        if (!firstAuthCompleted && !authErr) {
	            reason = 'initialViewerRender';
	        } else if (userLogOut) {
	            reason = 'userLoggedOut';
	        } else if (authErr) {
	            reason = 'validationError';
	        } else if (firstAuthCompleted && !authErr){
	            reason = 'sessionTimeout';
	        }
	
	        if (!userLogOut && firstAuthCompleted && !authErr) {
	            logInErrorMsg = 'Session expired.  Please log back in.';
	        } else if (authErr) {
	            logInErrorMsg = 'Invalid Login Credentials';
	        }
	
	        this.set({
	            firstAuthComplete: firstAuthCompleted,
	            userAuthenticated: false,
	            logOutReason: reason,
	            logInErrorMessage: logInErrorMsg
	        });
	    },
	    didSessionTimeout: function() {
	        return this.get('logOutReason') && this.get('logOutReason') === 'sessionTimeout';
	    },
	    firstAuthCompleted: function() {
	        return this.get('firstAuthComplete');
	    },
	    loginErr: function() {
	        return this.get('logInErrorMessage');
	    },
	    isAuthenticated: function() {
	        return this.get('userAuthenticated');
	    }
	
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	/*
	* Backbone Model representing the unauthorizedData endpoint.
	* Contains data needed for login, prior to user authorization.
	* */
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        databases: [],
	        signupUrl: null,
	        forgotPasswordUrl: null
	    },
	
	    url: function() {
	        return fvChannel.request('apiUrl').unauthorizedData;
	    },
	
	    getDatabases: function() {
	        return this.get('databases');
	    },
	
	    getSignupUrl: function() {
	        return this.get('signupUrl');
	    },
	
	    getForgotPasswordUrl: function() {
	        return this.get('forgotPasswordUrl');
	    }
	
	});

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Note: when using as url defined in model declared prior to viewer load (settings.pathtoapi is not set), ensure the BB url is a function
	 * Note: not including ES search and Feith Libs endpoints -- they have a different path to API, now in settings
	 *
	 */
	
	var _ = __webpack_require__(49);
	
	
	var ApiURL = function(pathToApi) {
	
	    var o = {};
	
	    for (var k in this.prototype) {
	
	        var val = this.prototype[k];
	
	        o[k] = typeof val === 'string'
	            ? pathToApi + val
	            : (function(val) {
	                return function() {
	                    var args = Array.prototype.slice.apply(arguments);
	                    return pathToApi + val.apply(this, args);
	                };
	            })(val);
	        }
	
	    this.constructor.prototype = o;
	
	    return o;
	
	};
	
	
	_.extend( ApiURL.prototype, {
	
	    /* Global */
	
	    login: 'auth/login',
	    logout: 'auth/logout',
	    keepAlive: 'auth/keepAlive', //  //?verbose=' + verbose,  //verbose = true returns with data
	    unauthorizedData: 'auth/unauthorizedData',
	    systemPolicies: 'system/policies',
	    feithLibraryVersionInfo: 'versionInfo',
	
	    user: 'user',
	    userGroups: 'user/groups',
	    allPrivateGroups: 'user/allPrivateGroups',
	    taskPerms:'user/taskPerms',
	    referralGroups: 'user/referralGroups',
	    myStamps: 'myStamps',
	
	    reasonCodes: 'system/reasonCodes',
	
	    /* Instance - some Document Dependent  */
	    docInfo: 'document/info',
	
	    // No Longer Used to Fetch though used as the basis for doc note model operations.
	    docNotes: function( docModel ) {
	        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() +
	            '/' + docModel.getId() + '/notes';
	    },
	
	    pageNotes: 'document/pageNotes', // ( this is the POST; there is also a GET; neither is used )
	
	    // Not used as get, though the base for pageNote Operations
	    pageNote: function(docModel, pgId, seq) {
	
	        var baseGetUrl = 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() +
	            '/' + docModel.getId() + '/' + pgId + '/notes';
	
	        return baseGetUrl + (seq ? '/' + seq : '');
	
	    },
	    // This is the endpoint for the post of the document resource; other is a get
	
	    rotatePage: function(docModel, pgId, deg) {
	        return 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + pgId + '/rotate?rotation=' + deg;
	    },
	    deletePages: function(docModel) {
	        //TODO: common with rotate page -- make fn on model the base uri ...
	        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + 'deletePages';
	    },
	    addPages: function(docModel, insertAtPgNum) {
	
	        //TODO: common with rotate page -- make fn on model the base uri ...
	        var url = 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/' + 'addPages';
	
	        // API really wants page #, but providing sequence here for this application
	        // ( eg pages could be provided individually in doc request ).
	        // If insertAtPgNum isn't provided, page will be appended to the end of the document.
	        // if there are no pages, append to the end, this won't mean anything; (could disabled in UI for page selection)
	
	        if (insertAtPgNum && !docModel.get('docHasNoPages'))
	            url += '?sequence=' + docModel.pageCollection.findWhere({ number: insertAtPgNum }).get('seq');
	
	        return url;
	    },
	    reorderPages: function(docModel) {
	        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/reorderPages';
	    },
	    multiPartGosPageDownload: function( docModel, page ) {
	        return 'page/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() +
	            '/' + page.get('pageId') + '/download/large';
	    },
	    lockStatus: function( docModel ) {
	        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/lock/status';
	    },
	    lockDocument: function( docModel ) {
	        return 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/lock';
	    },
	    unlockDocument: function( docModel, force ) {
	        var url = 'document/' + docModel.getContainerType() + '/' + docModel.getContainerId() + '/' + docModel.getId() + '/unlock';
	        if (force)
	            url += '?force=true';
	        return url;
	    },
	
	    /**
	     * Note: allowDownload and allowPrint now only applicable to test server
	     * ( they are determine at the server level so user can't change via URL )
	     */
	    pdfJsViewer: function( creUrl, allowDownload, allowPrint, isNode ) {
	
	        var src;
	
	        /**
	         * Could just pass in imgUrl from creResponse but may want inline=true in the future.
	         * Inline URL can be a flag for the node server ...
	         * Getting rid of it also makes it easier to apply hash parameters.
	         */
	        creUrl = creUrl.replace('?inline=true', '');
	
	        if (isNode) {
	
	            src = '/api/pdfviewer?file=' + creUrl;
	
	            // Note: current forked pdf-js viewer will also want these params,
	            // but for now not using it
	            if ( !allowDownload )
	                src += '&disableDownload=1';
	
	            if ( !allowPrint )
	                src += '&disablePrint=1';
	
	        } else {
	
	            var PATH_TO_VIEWER_HTML = 'pdfjsViewer/web/viewer.html';
	            src = PATH_TO_VIEWER_HTML;
	            src += '?file=' + creUrl;
	
	        }
	
	        /**
	         * Hash parameters must come after the file query parameter ( and others if sent )
	         * Enforce the first page ( unsure if we want this )
	         * For now leave to make consistent with other PDF viewers.
	         * Should check hash alogorythm used to store PDF files in PDF.js's local history
	         * ( the CRE file names will change so may not be applicable )
	         */
	        src += '#page=1';
	
	        return src;
	
	    }
	
	});
	
	
	module.exports = ApiURL;
	
	
	
	
	


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_) {var S = __webpack_require__(74),
	    moment = __webpack_require__(69),
	    Backbone = __webpack_require__(58),
	    $ = __webpack_require__(59),
	    fvChannel =  __webpack_require__(72).channel('FV');
	
	__webpack_require__(764);
	
	/*
	 * Model is really the model of the client version.json file (in the Backbone sense, with attributes) --
	 * It started this way though now combines a call to versionInfo to get DV Services and CRE version. 
	 * ( Now there's a clearer ways to handle but this works ).
	 * Provides the data necessary to populate the 'about' dialog -- so now really a composite 'about model'.
	 * Client Version - Retrieved From Flat File
	 * Viewer Services and CRE Versions - retrieved from versionInfo webservice
	 */
	
	var VersionModel = Backbone.Model.extend({
	
	    /*
	    * DATE_FORMAT_STR: that defined in pom.xml <maven.build.timestamp.format> for this project.
	    * Note that it's different than the Maven default; this was done so ":"'s don't appear in the file name generated for viewer.js in the webjar
	    * ( See DOCVIEW-212).
	    * Note: we need to define it on parse since it's not a valid ISO 8601 format ( we removed the ":'"s ).
	    * eg: 2019-08-26T17-26-32Z
	    * Update: DVBC-1622 -- the Maven format string was invalid and produced the wrong date -- changed to the current format:
	    * */
	
	    DATE_FORMAT_STR: 'YYYY-MM-DDTHH-mm-ssZ',
	
	    initialize: function() {
	        this.wasFetched = false;
	        this.servicesModel = null;
	        this.creServiceModel = null;
	    },
	
	    // Note: defaults here only refer to the client file and only include the attributes used
	    defaults: {
	        'version': '',  // string - number (eg x.x.x)
	        'build': ''     // datetimestamp
	    },
	    url: function() {
	        return fvChannel.request('settings').pathToVersionFile(); 
	    },
	    // Combo the fetch of version.json file and the webservice call into one action.
	    // Consolidate any potential errors into one message for convenience of caller ( requires both to complete ).
	    fetch: function(cxt) {
	        
	        cxt = cxt ? cxt : this;
	        var self = this;
	        
	        return $.Deferred(function($dfd) {
	            
	            var feithLibs = new FeithLibs(),  
	                q = $.AsyncQueue(),
	                clientErr,
	                servicesErr, // error message trying to access the versionInfo endpoint: Doc Viewer Services / CRE
	                rejectDfd = function() { 
	                    var errMsg = '';
	                    if (clientErr && !servicesErr) {
	                        errMsg = 'Unable to retrieve client version data. '  + clientErr;
	                    } else if (!clientErr && servicesErr) {
	                        errMsg = 'Unable to retrieve server version data. '  + servicesErr;
	                    } else if (clientErr && servicesErr) {
	                        errMsg = 'Unable to retrieve client and server version data.\nClient: ' + clientErr + '\nServer: ' + servicesErr;
	                    }
	                    $dfd.rejectWith(cxt, [errMsg]);
	                };
	
	            q.add({
	                action: 'Client',
	                method: _.bind( Backbone.Model.prototype.fetch, self ), errorCB: function () { 
	                    clientErr = this.error; 
	                } 
	            })
	            .add({ // This will get both Doc Viewer Web Services & CRE Version
	                action: 'Services',
	                method: _.bind( feithLibs.fetch ,feithLibs ), errorCB: function() { 
	                    servicesErr = this.error; 
	                }
	            });
	
	            q.run().done(function() {
	
	                if (!clientErr && !servicesErr) {
	                    
	                    self.wasFetched = true;
	                    self.servicesModel = feithLibs.getDocViewerService();
	                    self.creServiceModel = feithLibs.getCREService();
	
	                    $dfd.resolveWith(cxt);
	
	                } else {
	                    rejectDfd();
	                }
	
	            }).fail(rejectDfd); //(don't think need fail....)
	
	        }).promise();
	
	    },
	    // Return the 'build date'
	    getFormattedDate: function() {
	
	        var build = this.get('build');
	        if (build === '' || build === null ) {
	            return 'Unable to locate version.json';
	        } else {
	            return this.getBuild();
	        }
	
	    },
	    getCopyRightDate: function() {
	        return moment( this.get('build'), this.DATE_FORMAT_STR).year();
	    },
	    getVersion: function() {
	        return this.get('version');
	    },
	    getBuild: function() {
	
	        return moment
	            .utc( this.get('build') , this.DATE_FORMAT_STR )
	            .local()
	            .format(S.DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR);
	
	    }
	});
	
	
	var FeithLibModel = VersionModel.extend({
	
	    /*
	     * DATE_FORMAT_STR: The default for Maven -- 2017-02-03T22:59:43Z' -- for example.
	     * It's a valid ISO 8601 format so we don't technically need to define to read the value,
	     * but providing nonetheless for clarity.
	     * Update DVBC-1619: "yyyy-MM-dd'T'HH:mm:ss'Z'" was incorrect, changed to below:
	     * */
	
	    DATE_FORMAT_STR: "YYYY-MM-DDTHH:mm:ssZ",
	
	    defaults: {
	        title: '',
	        version: '',
	        build: ''
	    }
	});
	
	
	/*
	* Note: this endpoint was moved from FDD rest library v1 into Doc Viewer.
	* With the logic to get the version can be greatly simplified utilizing the endpoint
	* that exists in the Doc Viewer application.
	* */
	var FeithLibs = Backbone.Collection.extend({
	    DOC_VIEWER_SERVICES_TITLE: 'document-viewer-rest-cxf',
	    CRE_SERVICE_TITLE: 'central-rendering-engine-service', 
	    model: FeithLibModel,
	    url: function() {
	        return fvChannel.request('apiUrl').feithLibraryVersionInfo;
	    },
	    getDocViewerService: function() {
	        return this.findWhere({title: this.DOC_VIEWER_SERVICES_TITLE});
	    },
	    getCREService: function() {
	        return this.findWhere({title: this.CRE_SERVICE_TITLE});
	    }
	
	});
	
	
	
	module.exports = VersionModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/**
	 * If continue to use this, may want to think about adding the ability to add new actions to running queue.
	 * This is REALLY OLD -- should be cleaned up.
	 */
	
	
	(function($) {
	
	    $.AsyncQueue = function(options) {
	
	        if ( !(this instanceof $.AsyncQueue) ) {
	            return new $.AsyncQueue(options);
	        }
	
	        this.actions = []; //really an identifier -- need?
	        this.dfds = [];
	        this.failedActions = []; //error callbacks
	
	        return this;  
	    };
	
	
	    /**
	     * Create new action object to add to the queue.
	     */
	    $.AsyncQueue.prototype.Action = function(options) {
	
	        this.action = options.action; // (Note: label, not really needed) -- pass in multiple obj'S
	        this.method = options.method; // (Can be sync or async -- also an array)
	        this.errorCB = options.errorCB;
	        this.successCB = options.successCB;
	        this.cxt = options.cxt; // Could rid need of bind in calls by default
	
	        return this;
	    };
	
	
	    $.AsyncQueue.prototype.add = function(options) {
	
	        var action = new this.Action(options),
	            $dfd = new $.Deferred(),
	            self = this;
	
	        options.successCB && $.extend( action, {successCB: options.successCB}); // Could just as well extend the deferred
	        this.actions.push(action);
	
	        $.when( action.method.call( action.cxt ? action.cxt : this) )
	            .fail( function(jqXHR) {
	
	                // Assuming jqXHR though doesn't have to be ajax; so this not techically correct
	                self.failedActions.push( $.extend( action, {
	                    error: jqXHR.status + ' ' + jqXHR.statusText + ': ' + jqXHR.responseText }
	                ) );
	
	            })
	            .always(function () {
	                $dfd.resolve(); //always resolve all: will call success cb (failures will have $dfd.statusText)
	            });
	
	        this.dfds.push($dfd);
	        return this;
	
	    };
	
	    /**
	     *
	     * Allow all to run so can get errors at end synch'ly -- done is always run b/f always
	     */
	    $.AsyncQueue.prototype.run = function() {
	
	        var self = this,
	            successfulActions = $.grep( this.actions, function(a, i) {
	                return a.successCB && self.failedActions[i] === undefined;
	            });
	
	
	        return $.Deferred( function($dfd) {
	
	             $.when.apply($, self.dfds).done( function() {
	
	                $.each( self.failedActions, function(i, fa) { // Should really just use the deferred itself
	                    fa.errorCB && fa.errorCB(); //TODO: reject - now in the ind's
	                });
	
	                 /**
	                  * Optional Success Callbacks as well to run well all processed
	                  * -- don't need extra callback at end of queue
	                  * Wait for browser.
	                  * Could add cxt and arguments
	                  */
	                 $.each(successfulActions, function(i, a) {
	                     setTimeout.call(window, a.successCB, 0);
	                 });
	
	                $dfd.resolve();
	
	            });
	
	        }).promise();
	    };
	
	
	}(jQuery));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(_, $) {
	/**
	 * Note: context is FV library.
	 * extendJQuery
	 * - for $.fn.ajaxError
	 * - could refactor so this is a module -- though now import not really necessary ( $ namespace will have been loaded )
	 * - can reference directly $.fn for now
	 */
	
	
	var DocumentLockStatus = __webpack_require__(405);
	
	
	__webpack_require__(76);
	
	
	var commands = {
	
	    /** -- Not necessary, only if using EQ master branch; no selectors --
	    initElementQuery: function() { //would only need in wanted to print them
	        this.eq.init();
	    },
	    */
	
	    updateElementQuery: function() {
	        return this.EQ.elementQuery.refresh();
	    },
	    // Redundant on here ... just store these on this .. subapp or mixin ...
	    userLoggedOut: function() {
	        this._enterLoggedOutMode.apply(this, arguments);
	    },
	    unauthorizedLogout: function() {
	        this._enterLoggedOutMode();
	    },
	    userLogoutError: function(jqXHR) {  //todo: would the error here be on all viewers?
	        this.request('firstViewerInstance').command('ajaxError', jqXHR);
	    },
	    userLoggedIn: function(options) {
	        this.triggerMethod('userLogin', options);
	    },
	    viewerDestroyed: function(viewer) { /* cb post deletion of instance */
	        this.viewers = _.omit(this.viewers, String(viewer.id));
	        this.numberViewers--; /* prevent resize if none exist */
	        viewer = null; //its still around ...
	        //todo: any need to update the ids of the others?
	    },
	
	    /**
	     * TODO:
	     * - this is temp: for now send to the first viewer (if multi, don't know which one) ...
	     * -   have one on the window object and use body?
	     * - Diff method to handle errors if the first instance isn't yet created -- if not now will go to console
	     */
	    updatePostRunTimeError: function(msg, url, line) {
	
	        var firstViewer = this.channel.request('firstViewerInstance');
	
	        firstViewer && firstViewer.trigger( 'alert:show', {
	            type: 'error',
	            shortMessage: 'Error',
	            detailedMsg:  msg +  " url: " + url + " line #: " + line
	        });
	
	        _.invoke(this.viewers, 'command', 'updatePostRunTimeError');
	    }
	
	
	
	};
	
	var requests = {
	
	    /**
	     * Wrapper around $.fn.ajaxErrorMessage taking into account document locking
	     * By convention, 409 will be returned as an error in responses that fail
	     * because the document is locked by another user.
	     * Here, the response body will be a documentLockStatus model
	     * (the same returned from document lock webservices -- lock, unlock, status).
	     * Show the same message shown elsewhere for the blocking of transactions due to document locks.
	     * Transactions may be blocked on entry and this is often a double check.
	     * Leave $.fn.ajaxErrorMessage as generic fn, especially b/c could be used by FT Widget.
	     * Can still call $.fn.ajaxErrorMessage if sure not checking for a document lock -- though may want to search
	     * for all reference and refactor to filter them through here.
	     * Could combo logic 'vChannel.command('showDocumentLockedErrorAlert')'
	     */
	    ajaxErrorMessage: function( jqXHR ) {
	
	        var isDocumentLockError = jqXHR.status === 409;
	
	        return isDocumentLockError
	
	            ? new DocumentLockStatus( jqXHR.responseJSON ).getDefaultErrorMessage()
	            : $.fn.ajaxErrorMessage( jqXHR );
	
	    },
	
	    options: function() {
	        return this.options;
	    },
	    settings: function() {
	        return this.settings; //issue -- this not defined yet to return the value?
	    },
	    localStorage: function() {
	        return this.localStorageSettings;
	    },
	    user: function() {
	        return this.user; //can i require from it?
	    },
	    auth: function() {
	        return this.auth;
	    },
	    isAuthenticated: function() {
	      return this.auth.isAuthenticated();
	    },
	    apiUrl: function() {
	        return this.apiURL;
	    },
	    reasonCodes: function() {
	        return this.reasonCodes;
	    },
	    versionModel: function() {
	        return this.version;
	    },
	    cssConstants: function() {
	        return this.cssConstants;
	    },
	    firstViewerInstance: function() {
	        return this.firstViewerInstance();
	    },
	    esURL: function() {
	        return this.settings.absolutePathToES;
	    },
	    allowFlashNotes: function() {
	        var sysPolicies = this.systemPolicies;
	        return sysPolicies && sysPolicies.allowFlashNotes();
	    },
	    supportConsults: function() {
	        var sysPolicies = this.systemPolicies;
	        return sysPolicies && sysPolicies.allowConsults();
	    },
	    applyFloatingReasonCodes: function() {
	        var sysPolicies = this.systemPolicies;
	        return sysPolicies && sysPolicies.applyFloatingReasonCodes();
	    },
	
	    getPageNoteTitleMaxLength: function() {
	
	        return this.systemPolicies.getPageNoteTitleMaxLength();
	
	    },
	    constants: function() {
	        return this.constants;
	    }
	
	
	
	};
	
	
	module.exports = {
	    commands: commands,
	    requests: requests
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49), __webpack_require__(59)))

/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports = {".FV .FV-layout-wr":{"max-width":["880px","780px","700px","580px","510px"]}}

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var Backbone = __webpack_require__(58),
	    fvChannel = __webpack_require__(72).channel('FV');
	
	
	module.exports = Backbone.Model.extend({
	
	    defaults: {
	        allow_flash_notes: 'N',
	        allow_consults: 'N',
	        floating_reason_codes: 'N',
	        page_note_title_max_length: null // length of the field dependant on the schema version ( DVBC-1808 )
	    },
	
	    url: function() {
	        return fvChannel.request('apiUrl').systemPolicies;
	    },
	
	    allowFlashNotes: function() {
	        return this.get('allow_flash_notes') === 'Y';
	    },
	    allowConsults: function() {
	        return this.get('allow_consults') === 'Y';
	    },
	    applyFloatingReasonCodes: function() {
	        return this.get('floating_reason_codes') === 'Y';
	    },
	    getPageNoteTitleMaxLength: function() {
	        return this.get('page_note_title_max_length');
	    }
	
	
	});

/***/ },
/* 768 */
/***/ function(module, exports) {

	/**
	 * Simple hash of constants for use in the application.
	 * Add as needed or when have time to refactor -- eg: Java enums for note types
	 * TODO: put css constants on here, maybe others held elsewhere
	 */
	
	module.exports = {
	
	    NON_RESPONSIVE_REASON_CODE: 'Non-Responsive'
	
	};

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {/*! elementQuery | Author: Tyson Matanich (http://matanich.com), 2013 | License: MIT */
	
	/* ben: note small fork --THIS IS THE PROD VERSION */
	(function (window, document, undefined) {
	    // Enable strict mode
	    "use strict";
	
	    // Use Sizzle standalone or from jQuery
	    var sizzle = window.Sizzle || jQuery.find;
	
	    // Set the number of sizzle selectors to cache (default is 50)
	    //sizzle.selectors.cacheLength = 50;
	
	    var queryData = {};
	
	    var addQueryDataValue = function (selector, type, pair, number, value) {
	
	        selector = trim(selector);
	
	        if (selector != "") {
	            var parts;
	            if (!number && !value) {
	                parts = /^([0-9]*.?[0-9]+)(px|em)$/.exec(pair)
	                if (parts != null) {
	                    number = Number(parts[1]);
	                    if (number + "" != "NaN") {
	                        value = parts[2];
	                    }
	                }
	            }
	
	            if (value) {
	                // Compile the sizzle selector
	                if (sizzle.compile) {
	                    sizzle.compile(selector);
	                }
	
	                // Update the queryData object
	                if (queryData[selector] === undefined) {
	                    queryData[selector] = {};
	                }
	                if (queryData[selector][type] === undefined) {
	                    queryData[selector][type] = {};
	                }
	                queryData[selector][type][pair] = [number, value];
	            }
	        }
	    };
	
	    var updateQueryData = function (data, doUpdate) {
	        var i, j, k;
	        for (i in data) {
	            for (j in data[i]) {
	                if (typeof data[i][j] == "string") {
	                    addQueryDataValue(i, j, data[i][j]);
	                }
	                else if (typeof data[i][j] == "object") {
	                    for (k = 0; k < data[i][j].length; k++) {
	                        addQueryDataValue(i, j, data[i][j][k]);
	                    }
	                }
	            }
	        }
	
	
	        if (doUpdate == true) {
	            refresh();
	        }
	    };
	
	
	    // Refactor from jQuery.trim()
	    var trim = function (text) {
	        if (text == null) {
	            return "";
	        }
	        else {
	            var core_trim = "".trim;
	            if (core_trim && !core_trim.call("\uFEFF\xA0")) {
	                return core_trim.call(text);
	            }
	            else {
	                return (text + "").replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
	            }
	        }
	    };
	
	    // Refactor from jquery().addClass() and jquery().removeClass()
	    var clean = function (element, attr) {
	        // This expression is here for better compressibility
	        var val = element.getAttribute(attr);
	        return val ? (" " + val + " ").replace(/[\t\r\n]/g, " ") : " ";
	    };
	
	    // Refactor from jquery().addClass()
	    var addTo = function (element, attr, value) {
	
	        if (element.nodeType === 1) {
	            var val = trim(value);
	            if (val != "") {
	                var cur = clean(element, attr);
	
	                if (cur.indexOf(" " + val + " ") < 0) {
	                    // Add the value if its not already there
	                    element.setAttribute(attr, trim(cur + val));
	                }
	            }
	        }
	    };
	
	    // Refactor from jquery().removeClass()
	    var removeFrom = function (element, attr, value) {
	
	        if (element.nodeType === 1) {
	            var val = trim(value);
	            if (val != "") {
	                var cur = clean(element, attr);
	                var updated = false;
	                while (cur.indexOf(" " + val + " ") >= 0) {
	                    // Remove the value
	                    cur = cur.replace(" " + val + " ", " ");
	                    updated = true;
	                }
	                if (updated) {
	                    // Update the attribute
	                    element.setAttribute(attr, trim(cur));
	                }
	            }
	        }
	    };
	
	    var refresh = function () {
	
	        var i, ei, j, k, elements, element, val;
	
	        // For each selector
	        for (i in queryData) {
	
	            // Get the items matching the selector
	            elements = sizzle(i);
	
	            if (elements.length > 0) {
	
	                // For each matching element
	                for (ei = 0; ei < elements.length; ei++) {
	                    element = elements[ei];
	
	                    // For each min|max-width|height string
	                    for (j in queryData[i]) {
	
	                        // For each number px|em value pair
	                        for (k in queryData[i][j]) {
	
	                            val = queryData[i][j][k][0];
	
	                            if (queryData[i][j][k][1] == "em") {
	                                // Convert EMs to pixels
	                                val = val * (window.getEmPixels ? getEmPixels(element) : 16); // NOTE: Using getEmPixels() has a small performance impact
	                            }
	
	                            /* NOTE: Using offsetWidth/Height so an element can be adjusted when it reaches a specific size.
	                             /* For Nested queries scrollWidth/Height or clientWidth/Height may sometime be desired but are not supported. */
	
	                            if ((j == "min-width" && element.offsetWidth >= val) ||
	                                (j == "max-width" && element.offsetWidth <= val) ||
	                                (j == "min-height" && element.offsetHeight >= val) ||
	                                (j == "max-height" && element.offsetHeight <= val)) {
	                                // Add matching attr value
	                                addTo(element, j, k);
	                            }
	                            else {
	                                // Remove non-matching attr value
	                                removeFrom(element, j, k);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        if (!window.addEventListener && window.attachEvent) {
	
	            // Force a repaint in IE7 and IE8
	            var className = document.documentElement.className;
	            document.documentElement.className = " " + className;
	            document.documentElement.className = className;
	        }
	    }
	
	    // Expose some public functions
	    window.elementQuery = function (arg1, arg2) {
	        if (arg1 && typeof arg1 == "object" && !(arg1.cssRules || arg1.rules)) {
	            // Add new selector queries
	            updateQueryData(arg1, arg2);
	        }
	        else if (!arg1 && !arg2) {
	            refresh();
	        }
	    };
	
	    //NOTE: For development purposes only! Added stub to prevent errors.
	    window.elementQuery.selectors = function () { };
	
	    //if (window.addEventListener) {
	    //    window.addEventListener("resize", refresh, false);
	    //    window.addEventListener("DOMContentLoaded", refresh, false);
	    //    window.addEventListener("load", refresh, false);
	    //}
	    //else if (window.attachEvent) {
	    //    window.attachEvent("onresize", refresh);
	    //    window.attachEvent("onload", refresh);
	    //}
	
	
	    window.elementQuery.refresh = refresh;
	
	}(this, document, undefined));
	
	/*! getEmPixels  | Author: Tyson Matanich (http://matanich.com), 2013 | License: MIT */
	(function (document, documentElement) {
	    // Enable strict mode
	    "use strict";
	
	    // Form the style on the fly to result in smaller minified file
	    var important = "!important;";
	    var style = "position:absolute" + important + "visibility:hidden" + important + "width:1em" + important + "font-size:1em" + important + "padding:0" + important;
	
	    window.getEmPixels = function (element) {
	
	        var extraBody;
	
	        if (!element) {
	            // Emulate the documentElement to get rem value (documentElement does not work in IE6-7)
	            element = extraBody = document.createElement("body");
	            extraBody.style.cssText = "font-size:1em" + important;
	            documentElement.insertBefore(extraBody, document.body);
	        }
	
	        // Create and style a test element
	        var testElement = document.createElement("i");
	        testElement.style.cssText = style;
	        element.appendChild(testElement);
	
	        // Get the client width of the test element
	        var value = testElement.clientWidth;
	
	        if (extraBody) {
	            // Remove the extra body element
	            documentElement.removeChild(extraBody);
	        }
	        else {
	            // Remove the test element
	            element.removeChild(testElement);
	        }
	
	        // Return the em value in pixels
	        return value;
	    };
	}(document, document.documentElement));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** viewer.js
 **/